window.__version = '12920.0.0.0';

Array.prototype.remove = function (obj) {
    var idx = this.indexOf(obj);
    if (idx > -1)
        this.splice(idx, 1);
    return this;
}

Array.prototype.pushIfNotExists = function (obj) {
    console.log(this);
    var exists = this.indexOf(obj);
    if (exists < 1)
        this.push(obj);
}

Array.prototype.replace = Array.prototype.replace || function (oldObj, newObj) {
    var arr = this;
    var idx = arr.indexOf(oldObj);
    arr.splice(idx, 1, newObj);

    return arr;
}
/*Object.prototype.toQueryString = Object.prototype.toQueryString || function () {
    var obj = this;
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            console.log(key);
            console.log(obj[key]);
        }
    }
}*/
_.mixin({
    'sortKeysBy': function (obj, comparator) {
        var keys = _.sortBy(_.keys(obj), function (key) {
            return comparator ? comparator(obj[key], key) : key;
        });
    
        return _.object(keys, _.map(keys, function (key) {
            return obj[key];
        }));
    }
});
if (!String.prototype.format) {
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
              ? args[number]
              : match
            ;
        });
    };
}
//---------------------------------------------------------------------
//
// QR Code Generator for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//  http://www.opensource.org/licenses/mit-license.php
//
// The word 'QR Code' is registered trademark of
// DENSO WAVE INCORPORATED
//  http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------

var qrcode = function() {

    //---------------------------------------------------------------------
    // qrcode
    //---------------------------------------------------------------------

    /**
     * qrcode
     * @param typeNumber 1 to 40
     * @param errorCorrectionLevel 'L','M','Q','H'
     */
    var qrcode = function(typeNumber, errorCorrectionLevel) {

        var PAD0 = 0xEC;
        var PAD1 = 0x11;

        var _typeNumber = typeNumber;
        var _errorCorrectionLevel = QRErrorCorrectionLevel[errorCorrectionLevel];
        var _modules = null;
        var _moduleCount = 0;
        var _dataCache = null;
        var _dataList = new Array();

        var _this = {};

        var makeImpl = function(test, maskPattern) {

            _moduleCount = _typeNumber * 4 + 17;
            _modules = function(moduleCount) {
                var modules = new Array(moduleCount);
                for (var row = 0; row < moduleCount; row += 1) {
                    modules[row] = new Array(moduleCount);
                    for (var col = 0; col < moduleCount; col += 1) {
                        modules[row][col] = null;
                    }
                }
                return modules;
            }(_moduleCount);

            setupPositionProbePattern(0, 0);
            setupPositionProbePattern(_moduleCount - 7, 0);
            setupPositionProbePattern(0, _moduleCount - 7);
            setupPositionAdjustPattern();
            setupTimingPattern();
            setupTypeInfo(test, maskPattern);

            if (_typeNumber >= 7) {
                setupTypeNumber(test);
            }

            if (_dataCache == null) {
                _dataCache = createData(_typeNumber, _errorCorrectionLevel, _dataList);
            }

            mapData(_dataCache, maskPattern);
        };

        var setupPositionProbePattern = function(row, col) {

            for (var r = -1; r <= 7; r += 1) {

                if (row + r <= -1 || _moduleCount <= row + r) continue;

                for (var c = -1; c <= 7; c += 1) {

                    if (col + c <= -1 || _moduleCount <= col + c) continue;

                    if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
                        || (0 <= c && c <= 6 && (r == 0 || r == 6) )
                        || (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
                        _modules[row + r][col + c] = true;
                    } else {
                        _modules[row + r][col + c] = false;
                    }
                }
            }
        };

        var getBestMaskPattern = function() {

            var minLostPoint = 0;
            var pattern = 0;

            for (var i = 0; i < 8; i += 1) {

                makeImpl(true, i);

                var lostPoint = QRUtil.getLostPoint(_this);

                if (i == 0 || minLostPoint > lostPoint) {
                    minLostPoint = lostPoint;
                    pattern = i;
                }
            }

            return pattern;
        };

        var setupTimingPattern = function() {

            for (var r = 8; r < _moduleCount - 8; r += 1) {
                if (_modules[r][6] != null) {
                    continue;
                }
                _modules[r][6] = (r % 2 == 0);
            }

            for (var c = 8; c < _moduleCount - 8; c += 1) {
                if (_modules[6][c] != null) {
                    continue;
                }
                _modules[6][c] = (c % 2 == 0);
            }
        };

        var setupPositionAdjustPattern = function() {

            var pos = QRUtil.getPatternPosition(_typeNumber);

            for (var i = 0; i < pos.length; i += 1) {

                for (var j = 0; j < pos.length; j += 1) {

                    var row = pos[i];
                    var col = pos[j];

                    if (_modules[row][col] != null) {
                        continue;
                    }

                    for (var r = -2; r <= 2; r += 1) {

                        for (var c = -2; c <= 2; c += 1) {

                            if (r == -2 || r == 2 || c == -2 || c == 2
                                || (r == 0 && c == 0) ) {
                                _modules[row + r][col + c] = true;
                            } else {
                                _modules[row + r][col + c] = false;
                            }
                        }
                    }
                }
            }
        };

        var setupTypeNumber = function(test) {

            var bits = QRUtil.getBCHTypeNumber(_typeNumber);

            for (var i = 0; i < 18; i += 1) {
                var mod = (!test && ( (bits >> i) & 1) == 1);
                _modules[Math.floor(i / 3)][i % 3 + _moduleCount - 8 - 3] = mod;
            }

            for (var i = 0; i < 18; i += 1) {
                var mod = (!test && ( (bits >> i) & 1) == 1);
                _modules[i % 3 + _moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
            }
        };

        var setupTypeInfo = function(test, maskPattern) {

            var data = (_errorCorrectionLevel << 3) | maskPattern;
            var bits = QRUtil.getBCHTypeInfo(data);

            // vertical
            for (var i = 0; i < 15; i += 1) {

                var mod = (!test && ( (bits >> i) & 1) == 1);

                if (i < 6) {
                    _modules[i][8] = mod;
                } else if (i < 8) {
                    _modules[i + 1][8] = mod;
                } else {
                    _modules[_moduleCount - 15 + i][8] = mod;
                }
            }

            // horizontal
            for (var i = 0; i < 15; i += 1) {

                var mod = (!test && ( (bits >> i) & 1) == 1);

                if (i < 8) {
                    _modules[8][_moduleCount - i - 1] = mod;
                } else if (i < 9) {
                    _modules[8][15 - i - 1 + 1] = mod;
                } else {
                    _modules[8][15 - i - 1] = mod;
                }
            }

            // fixed module
            _modules[_moduleCount - 8][8] = (!test);
        };

        var mapData = function(data, maskPattern) {

            var inc = -1;
            var row = _moduleCount - 1;
            var bitIndex = 7;
            var byteIndex = 0;
            var maskFunc = QRUtil.getMaskFunction(maskPattern);

            for (var col = _moduleCount - 1; col > 0; col -= 2) {

                if (col == 6) col -= 1;

                while (true) {

                    for (var c = 0; c < 2; c += 1) {

                        if (_modules[row][col - c] == null) {

                            var dark = false;

                            if (byteIndex < data.length) {
                                dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
                            }

                            var mask = maskFunc(row, col - c);

                            if (mask) {
                                dark = !dark;
                            }

                            _modules[row][col - c] = dark;
                            bitIndex -= 1;

                            if (bitIndex == -1) {
                                byteIndex += 1;
                                bitIndex = 7;
                            }
                        }
                    }

                    row += inc;

                    if (row < 0 || _moduleCount <= row) {
                        row -= inc;
                        inc = -inc;
                        break;
                    }
                }
            }
        };

        var createBytes = function(buffer, rsBlocks) {

            var offset = 0;

            var maxDcCount = 0;
            var maxEcCount = 0;

            var dcdata = new Array(rsBlocks.length);
            var ecdata = new Array(rsBlocks.length);

            for (var r = 0; r < rsBlocks.length; r += 1) {

                var dcCount = rsBlocks[r].dataCount;
                var ecCount = rsBlocks[r].totalCount - dcCount;

                maxDcCount = Math.max(maxDcCount, dcCount);
                maxEcCount = Math.max(maxEcCount, ecCount);

                dcdata[r] = new Array(dcCount);

                for (var i = 0; i < dcdata[r].length; i += 1) {
                    dcdata[r][i] = 0xff & buffer.getBuffer()[i + offset];
                }
                offset += dcCount;

                var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount);
                var rawPoly = qrPolynomial(dcdata[r], rsPoly.getLength() - 1);

                var modPoly = rawPoly.mod(rsPoly);
                ecdata[r] = new Array(rsPoly.getLength() - 1);
                for (var i = 0; i < ecdata[r].length; i += 1) {
                    var modIndex = i + modPoly.getLength() - ecdata[r].length;
                    ecdata[r][i] = (modIndex >= 0)? modPoly.getAt(modIndex) : 0;
                }
            }

            var totalCodeCount = 0;
            for (var i = 0; i < rsBlocks.length; i += 1) {
                totalCodeCount += rsBlocks[i].totalCount;
            }

            var data = new Array(totalCodeCount);
            var index = 0;

            for (var i = 0; i < maxDcCount; i += 1) {
                for (var r = 0; r < rsBlocks.length; r += 1) {
                    if (i < dcdata[r].length) {
                        data[index] = dcdata[r][i];
                        index += 1;
                    }
                }
            }

            for (var i = 0; i < maxEcCount; i += 1) {
                for (var r = 0; r < rsBlocks.length; r += 1) {
                    if (i < ecdata[r].length) {
                        data[index] = ecdata[r][i];
                        index += 1;
                    }
                }
            }

            return data;
        };

        var createData = function(typeNumber, errorCorrectionLevel, dataList) {

            var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectionLevel);

            var buffer = qrBitBuffer();

            for (var i = 0; i < dataList.length; i += 1) {
                var data = dataList[i];
                buffer.put(data.getMode(), 4);
                buffer.put(data.getLength(), QRUtil.getLengthInBits(data.getMode(), typeNumber) );
                data.write(buffer);
            }

            // calc num max data.
            var totalDataCount = 0;
            for (var i = 0; i < rsBlocks.length; i += 1) {
                totalDataCount += rsBlocks[i].dataCount;
            }

            if (buffer.getLengthInBits() > totalDataCount * 8) {
                throw new Error('code length overflow. ('
                    + buffer.getLengthInBits()
                    + '>'
                    + totalDataCount * 8
                    + ')');
            }

            // end code
            if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
                buffer.put(0, 4);
            }

            // padding
            while (buffer.getLengthInBits() % 8 != 0) {
                buffer.putBit(false);
            }

            // padding
            while (true) {

                if (buffer.getLengthInBits() >= totalDataCount * 8) {
                    break;
                }
                buffer.put(PAD0, 8);

                if (buffer.getLengthInBits() >= totalDataCount * 8) {
                    break;
                }
                buffer.put(PAD1, 8);
            }

            return createBytes(buffer, rsBlocks);
        };

        _this.addData = function(data, mode) {

            mode = mode || 'Byte';

            var newData = null;

            switch(mode) {
                case 'Numeric' :
                    newData = qrNumber(data);
                    break;
                case 'Alphanumeric' :
                    newData = qrAlphaNum(data);
                    break;
                case 'Byte' :
                    newData = qr8BitByte(data);
                    break;
                case 'Kanji' :
                    newData = qrKanji(data);
                    break;
                default :
                    throw 'mode:' + mode;
            }

            _dataList.push(newData);
            _dataCache = null;
        };

        _this.isDark = function(row, col) {
            if (row < 0 || _moduleCount <= row || col < 0 || _moduleCount <= col) {
                throw new Error(row + ',' + col);
            }
            return _modules[row][col];
        };

        _this.getModuleCount = function() {
            return _moduleCount;
        };

        _this.make = function() {
            makeImpl(false, getBestMaskPattern() );
        };

        _this.createTableTag = function(cellSize, margin) {

            cellSize = cellSize || 2;
            margin = (typeof margin == 'undefined')? cellSize * 4 : margin;

            var qrHtml = '';

            qrHtml += '<table style="';
            qrHtml += ' border-width: 0px; border-style: none;';
            qrHtml += ' border-collapse: collapse;';
            qrHtml += ' padding: 0px; margin: ' + margin + 'px;';
            qrHtml += '">';
            qrHtml += '<tbody>';

            for (var r = 0; r < _this.getModuleCount(); r += 1) {

                qrHtml += '<tr>';

                for (var c = 0; c < _this.getModuleCount(); c += 1) {
                    qrHtml += '<td style="';
                    qrHtml += ' border-width: 0px; border-style: none;';
                    qrHtml += ' border-collapse: collapse;';
                    qrHtml += ' padding: 0px; margin: 0px;';
                    qrHtml += ' width: ' + cellSize + 'px;';
                    qrHtml += ' height: ' + cellSize + 'px;';
                    qrHtml += ' background-color: ';
                    qrHtml += _this.isDark(r, c)? '#000000' : '#ffffff';
                    qrHtml += ';';
                    qrHtml += '"/>';
                }

                qrHtml += '</tr>';
            }

            qrHtml += '</tbody>';
            qrHtml += '</table>';

            return qrHtml;
        };

        _this.createSvgTag = function(cellSize, margin) {

            cellSize = cellSize || 2;
            margin = (typeof margin == 'undefined')? cellSize * 4 : margin;
            var size = _this.getModuleCount() * cellSize + margin * 2;
            var c, mc, r, mr, qrSvg='', rect;

            rect = 'l' + cellSize + ',0 0,' + cellSize +
                ' -' + cellSize + ',0 0,-' + cellSize + 'z ';

            qrSvg += '<svg';
            qrSvg += ' width="' + size + 'px"';
            qrSvg += ' height="' + size + 'px"';
            qrSvg += ' xmlns="http://www.w3.org/2000/svg"';
            qrSvg += '>';
            qrSvg += '<path d="';

            for (r = 0; r < _this.getModuleCount(); r += 1) {
                mr = r * cellSize + margin;
                for (c = 0; c < _this.getModuleCount(); c += 1) {
                    if (_this.isDark(r, c) ) {
                        mc = c*cellSize+margin;
                        qrSvg += 'M' + mc + ',' + mr + rect;
                    }
                }
            }

            qrSvg += '" stroke="transparent" fill="black"/>';
            qrSvg += '</svg>';

            return qrSvg;
        };

        _this.createImgTag = function(cellSize, margin) {

            cellSize = cellSize || 2;
            margin = (typeof margin == 'undefined')? cellSize * 4 : margin;

            var size = _this.getModuleCount() * cellSize + margin * 2;
            var min = margin;
            var max = size - margin;

            return createImgTag(size, size, function(x, y) {
                if (min <= x && x < max && min <= y && y < max) {
                    var c = Math.floor( (x - min) / cellSize);
                    var r = Math.floor( (y - min) / cellSize);
                    return _this.isDark(r, c)? 0 : 1;
                } else {
                    return 1;
                }
            } );
        };

        return _this;
    };

    //---------------------------------------------------------------------
    // qrcode.stringToBytes
    //---------------------------------------------------------------------

    qrcode.stringToBytes = function(s) {
        var bytes = new Array();
        for (var i = 0; i < s.length; i += 1) {
            var c = s.charCodeAt(i);
            bytes.push(c & 0xff);
        }
        return bytes;
    };

    //---------------------------------------------------------------------
    // qrcode.createStringToBytes
    //---------------------------------------------------------------------

    /**
     * @param unicodeData base64 string of byte array.
     * [16bit Unicode],[16bit Bytes], ...
     * @param numChars
     */
    qrcode.createStringToBytes = function(unicodeData, numChars) {

        // create conversion map.

        var unicodeMap = function() {

            var bin = base64DecodeInputStream(unicodeData);
            var read = function() {
                var b = bin.read();
                if (b == -1) throw new Error();
                return b;
            };

            var count = 0;
            var unicodeMap = {};
            while (true) {
                var b0 = bin.read();
                if (b0 == -1) break;
                var b1 = read();
                var b2 = read();
                var b3 = read();
                var k = String.fromCharCode( (b0 << 8) | b1);
                var v = (b2 << 8) | b3;
                unicodeMap[k] = v;
                count += 1;
            }
            if (count != numChars) {
                throw new Error(count + ' != ' + numChars);
            }

            return unicodeMap;
        }();

        var unknownChar = '?'.charCodeAt(0);

        return function(s) {
            var bytes = new Array();
            for (var i = 0; i < s.length; i += 1) {
                var c = s.charCodeAt(i);
                if (c < 128) {
                    bytes.push(c);
                } else {
                    var b = unicodeMap[s.charAt(i)];
                    if (typeof b == 'number') {
                        if ( (b & 0xff) == b) {
                            // 1byte
                            bytes.push(b);
                        } else {
                            // 2bytes
                            bytes.push(b >>> 8);
                            bytes.push(b & 0xff);
                        }
                    } else {
                        bytes.push(unknownChar);
                    }
                }
            }
            return bytes;
        };
    };

    //---------------------------------------------------------------------
    // QRMode
    //---------------------------------------------------------------------

    var QRMode = {
        MODE_NUMBER :    1 << 0,
        MODE_ALPHA_NUM : 1 << 1,
        MODE_8BIT_BYTE : 1 << 2,
        MODE_KANJI :     1 << 3
    };

    //---------------------------------------------------------------------
    // QRErrorCorrectionLevel
    //---------------------------------------------------------------------

    var QRErrorCorrectionLevel = {
        L : 1,
        M : 0,
        Q : 3,
        H : 2
    };

    //---------------------------------------------------------------------
    // QRMaskPattern
    //---------------------------------------------------------------------

    var QRMaskPattern = {
        PATTERN000 : 0,
        PATTERN001 : 1,
        PATTERN010 : 2,
        PATTERN011 : 3,
        PATTERN100 : 4,
        PATTERN101 : 5,
        PATTERN110 : 6,
        PATTERN111 : 7
    };

    //---------------------------------------------------------------------
    // QRUtil
    //---------------------------------------------------------------------

    var QRUtil = function() {

        var PATTERN_POSITION_TABLE = [
            [],
            [6, 18],
            [6, 22],
            [6, 26],
            [6, 30],
            [6, 34],
            [6, 22, 38],
            [6, 24, 42],
            [6, 26, 46],
            [6, 28, 50],
            [6, 30, 54],
            [6, 32, 58],
            [6, 34, 62],
            [6, 26, 46, 66],
            [6, 26, 48, 70],
            [6, 26, 50, 74],
            [6, 30, 54, 78],
            [6, 30, 56, 82],
            [6, 30, 58, 86],
            [6, 34, 62, 90],
            [6, 28, 50, 72, 94],
            [6, 26, 50, 74, 98],
            [6, 30, 54, 78, 102],
            [6, 28, 54, 80, 106],
            [6, 32, 58, 84, 110],
            [6, 30, 58, 86, 114],
            [6, 34, 62, 90, 118],
            [6, 26, 50, 74, 98, 122],
            [6, 30, 54, 78, 102, 126],
            [6, 26, 52, 78, 104, 130],
            [6, 30, 56, 82, 108, 134],
            [6, 34, 60, 86, 112, 138],
            [6, 30, 58, 86, 114, 142],
            [6, 34, 62, 90, 118, 146],
            [6, 30, 54, 78, 102, 126, 150],
            [6, 24, 50, 76, 102, 128, 154],
            [6, 28, 54, 80, 106, 132, 158],
            [6, 32, 58, 84, 110, 136, 162],
            [6, 26, 54, 82, 110, 138, 166],
            [6, 30, 58, 86, 114, 142, 170]
        ];
        var G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0);
        var G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0);
        var G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1);

        var _this = {};

        var getBCHDigit = function(data) {
            var digit = 0;
            while (data != 0) {
                digit += 1;
                data >>>= 1;
            }
            return digit;
        };

        _this.getBCHTypeInfo = function(data) {
            var d = data << 10;
            while (getBCHDigit(d) - getBCHDigit(G15) >= 0) {
                d ^= (G15 << (getBCHDigit(d) - getBCHDigit(G15) ) );
            }
            return ( (data << 10) | d) ^ G15_MASK;
        };

        _this.getBCHTypeNumber = function(data) {
            var d = data << 12;
            while (getBCHDigit(d) - getBCHDigit(G18) >= 0) {
                d ^= (G18 << (getBCHDigit(d) - getBCHDigit(G18) ) );
            }
            return (data << 12) | d;
        };

        _this.getPatternPosition = function(typeNumber) {
            return PATTERN_POSITION_TABLE[typeNumber - 1];
        };

        _this.getMaskFunction = function(maskPattern) {

            switch (maskPattern) {

                case QRMaskPattern.PATTERN000 :
                    return function(i, j) { return (i + j) % 2 == 0; };
                case QRMaskPattern.PATTERN001 :
                    return function(i, j) { return i % 2 == 0; };
                case QRMaskPattern.PATTERN010 :
                    return function(i, j) { return j % 3 == 0; };
                case QRMaskPattern.PATTERN011 :
                    return function(i, j) { return (i + j) % 3 == 0; };
                case QRMaskPattern.PATTERN100 :
                    return function(i, j) { return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0; };
                case QRMaskPattern.PATTERN101 :
                    return function(i, j) { return (i * j) % 2 + (i * j) % 3 == 0; };
                case QRMaskPattern.PATTERN110 :
                    return function(i, j) { return ( (i * j) % 2 + (i * j) % 3) % 2 == 0; };
                case QRMaskPattern.PATTERN111 :
                    return function(i, j) { return ( (i * j) % 3 + (i + j) % 2) % 2 == 0; };

                default :
                    throw new Error('bad maskPattern:' + maskPattern);
            }
        };

        _this.getErrorCorrectPolynomial = function(errorCorrectLength) {
            var a = qrPolynomial([1], 0);
            for (var i = 0; i < errorCorrectLength; i += 1) {
                a = a.multiply(qrPolynomial([1, QRMath.gexp(i)], 0) );
            }
            return a;
        };

        _this.getLengthInBits = function(mode, type) {

            if (1 <= type && type < 10) {

                // 1 - 9

                switch(mode) {
                    case QRMode.MODE_NUMBER    : return 10;
                    case QRMode.MODE_ALPHA_NUM : return 9;
                    case QRMode.MODE_8BIT_BYTE : return 8;
                    case QRMode.MODE_KANJI     : return 8;
                    default :
                        throw new Error('mode:' + mode);
                }

            } else if (type < 27) {

                // 10 - 26

                switch(mode) {
                    case QRMode.MODE_NUMBER    : return 12;
                    case QRMode.MODE_ALPHA_NUM : return 11;
                    case QRMode.MODE_8BIT_BYTE : return 16;
                    case QRMode.MODE_KANJI     : return 10;
                    default :
                        throw new Error('mode:' + mode);
                }

            } else if (type < 41) {

                // 27 - 40

                switch(mode) {
                    case QRMode.MODE_NUMBER    : return 14;
                    case QRMode.MODE_ALPHA_NUM : return 13;
                    case QRMode.MODE_8BIT_BYTE : return 16;
                    case QRMode.MODE_KANJI     : return 12;
                    default :
                        throw new Error('mode:' + mode);
                }

            } else {
                throw new Error('type:' + type);
            }
        };

        _this.getLostPoint = function(qrcode) {

            var moduleCount = qrcode.getModuleCount();

            var lostPoint = 0;

            // LEVEL1

            for (var row = 0; row < moduleCount; row += 1) {
                for (var col = 0; col < moduleCount; col += 1) {

                    var sameCount = 0;
                    var dark = qrcode.isDark(row, col);

                    for (var r = -1; r <= 1; r += 1) {

                        if (row + r < 0 || moduleCount <= row + r) {
                            continue;
                        }

                        for (var c = -1; c <= 1; c += 1) {

                            if (col + c < 0 || moduleCount <= col + c) {
                                continue;
                            }

                            if (r == 0 && c == 0) {
                                continue;
                            }

                            if (dark == qrcode.isDark(row + r, col + c) ) {
                                sameCount += 1;
                            }
                        }
                    }

                    if (sameCount > 5) {
                        lostPoint += (3 + sameCount - 5);
                    }
                }
            };

            // LEVEL2

            for (var row = 0; row < moduleCount - 1; row += 1) {
                for (var col = 0; col < moduleCount - 1; col += 1) {
                    var count = 0;
                    if (qrcode.isDark(row, col) ) count += 1;
                    if (qrcode.isDark(row + 1, col) ) count += 1;
                    if (qrcode.isDark(row, col + 1) ) count += 1;
                    if (qrcode.isDark(row + 1, col + 1) ) count += 1;
                    if (count == 0 || count == 4) {
                        lostPoint += 3;
                    }
                }
            }

            // LEVEL3

            for (var row = 0; row < moduleCount; row += 1) {
                for (var col = 0; col < moduleCount - 6; col += 1) {
                    if (qrcode.isDark(row, col)
                        && !qrcode.isDark(row, col + 1)
                        &&  qrcode.isDark(row, col + 2)
                        &&  qrcode.isDark(row, col + 3)
                        &&  qrcode.isDark(row, col + 4)
                        && !qrcode.isDark(row, col + 5)
                        &&  qrcode.isDark(row, col + 6) ) {
                        lostPoint += 40;
                    }
                }
            }

            for (var col = 0; col < moduleCount; col += 1) {
                for (var row = 0; row < moduleCount - 6; row += 1) {
                    if (qrcode.isDark(row, col)
                        && !qrcode.isDark(row + 1, col)
                        &&  qrcode.isDark(row + 2, col)
                        &&  qrcode.isDark(row + 3, col)
                        &&  qrcode.isDark(row + 4, col)
                        && !qrcode.isDark(row + 5, col)
                        &&  qrcode.isDark(row + 6, col) ) {
                        lostPoint += 40;
                    }
                }
            }

            // LEVEL4

            var darkCount = 0;

            for (var col = 0; col < moduleCount; col += 1) {
                for (var row = 0; row < moduleCount; row += 1) {
                    if (qrcode.isDark(row, col) ) {
                        darkCount += 1;
                    }
                }
            }

            var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
            lostPoint += ratio * 10;

            return lostPoint;
        };

        return _this;
    }();

    //---------------------------------------------------------------------
    // QRMath
    //---------------------------------------------------------------------

    var QRMath = function() {

        var EXP_TABLE = new Array(256);
        var LOG_TABLE = new Array(256);

        // initialize tables
        for (var i = 0; i < 8; i += 1) {
            EXP_TABLE[i] = 1 << i;
        }
        for (var i = 8; i < 256; i += 1) {
            EXP_TABLE[i] = EXP_TABLE[i - 4]
                ^ EXP_TABLE[i - 5]
                ^ EXP_TABLE[i - 6]
                ^ EXP_TABLE[i - 8];
        }
        for (var i = 0; i < 255; i += 1) {
            LOG_TABLE[EXP_TABLE[i] ] = i;
        }

        var _this = {};

        _this.glog = function(n) {

            if (n < 1) {
                throw new Error('glog(' + n + ')');
            }

            return LOG_TABLE[n];
        };

        _this.gexp = function(n) {

            while (n < 0) {
                n += 255;
            }

            while (n >= 256) {
                n -= 255;
            }

            return EXP_TABLE[n];
        };

        return _this;
    }();

    //---------------------------------------------------------------------
    // qrPolynomial
    //---------------------------------------------------------------------

    function qrPolynomial(num, shift) {

        if (typeof num.length == 'undefined') {
            throw new Error(num.length + '/' + shift);
        }

        var _num = function() {
            var offset = 0;
            while (offset < num.length && num[offset] == 0) {
                offset += 1;
            }
            var _num = new Array(num.length - offset + shift);
            for (var i = 0; i < num.length - offset; i += 1) {
                _num[i] = num[i + offset];
            }
            return _num;
        }();

        var _this = {};

        _this.getAt = function(index) {
            return _num[index];
        };

        _this.getLength = function() {
            return _num.length;
        };

        _this.multiply = function(e) {

            var num = new Array(_this.getLength() + e.getLength() - 1);

            for (var i = 0; i < _this.getLength(); i += 1) {
                for (var j = 0; j < e.getLength(); j += 1) {
                    num[i + j] ^= QRMath.gexp(QRMath.glog(_this.getAt(i) ) + QRMath.glog(e.getAt(j) ) );
                }
            }

            return qrPolynomial(num, 0);
        };

        _this.mod = function(e) {

            if (_this.getLength() - e.getLength() < 0) {
                return _this;
            }

            var ratio = QRMath.glog(_this.getAt(0) ) - QRMath.glog(e.getAt(0) );

            var num = new Array(_this.getLength() );
            for (var i = 0; i < _this.getLength(); i += 1) {
                num[i] = _this.getAt(i);
            }

            for (var i = 0; i < e.getLength(); i += 1) {
                num[i] ^= QRMath.gexp(QRMath.glog(e.getAt(i) ) + ratio);
            }

            // recursive call
            return qrPolynomial(num, 0).mod(e);
        };

        return _this;
    };

    //---------------------------------------------------------------------
    // QRRSBlock
    //---------------------------------------------------------------------

    var QRRSBlock = function() {

        var RS_BLOCK_TABLE = [

            // L
            // M
            // Q
            // H

            // 1
            [1, 26, 19],
            [1, 26, 16],
            [1, 26, 13],
            [1, 26, 9],

            // 2
            [1, 44, 34],
            [1, 44, 28],
            [1, 44, 22],
            [1, 44, 16],

            // 3
            [1, 70, 55],
            [1, 70, 44],
            [2, 35, 17],
            [2, 35, 13],

            // 4
            [1, 100, 80],
            [2, 50, 32],
            [2, 50, 24],
            [4, 25, 9],

            // 5
            [1, 134, 108],
            [2, 67, 43],
            [2, 33, 15, 2, 34, 16],
            [2, 33, 11, 2, 34, 12],

            // 6
            [2, 86, 68],
            [4, 43, 27],
            [4, 43, 19],
            [4, 43, 15],

            // 7
            [2, 98, 78],
            [4, 49, 31],
            [2, 32, 14, 4, 33, 15],
            [4, 39, 13, 1, 40, 14],

            // 8
            [2, 121, 97],
            [2, 60, 38, 2, 61, 39],
            [4, 40, 18, 2, 41, 19],
            [4, 40, 14, 2, 41, 15],

            // 9
            [2, 146, 116],
            [3, 58, 36, 2, 59, 37],
            [4, 36, 16, 4, 37, 17],
            [4, 36, 12, 4, 37, 13],

            // 10
            [2, 86, 68, 2, 87, 69],
            [4, 69, 43, 1, 70, 44],
            [6, 43, 19, 2, 44, 20],
            [6, 43, 15, 2, 44, 16],

            // 11
            [4, 101, 81],
            [1, 80, 50, 4, 81, 51],
            [4, 50, 22, 4, 51, 23],
            [3, 36, 12, 8, 37, 13],

            // 12
            [2, 116, 92, 2, 117, 93],
            [6, 58, 36, 2, 59, 37],
            [4, 46, 20, 6, 47, 21],
            [7, 42, 14, 4, 43, 15],

            // 13
            [4, 133, 107],
            [8, 59, 37, 1, 60, 38],
            [8, 44, 20, 4, 45, 21],
            [12, 33, 11, 4, 34, 12],

            // 14
            [3, 145, 115, 1, 146, 116],
            [4, 64, 40, 5, 65, 41],
            [11, 36, 16, 5, 37, 17],
            [11, 36, 12, 5, 37, 13],

            // 15
            [5, 109, 87, 1, 110, 88],
            [5, 65, 41, 5, 66, 42],
            [5, 54, 24, 7, 55, 25],
            [11, 36, 12, 7, 37, 13],

            // 16
            [5, 122, 98, 1, 123, 99],
            [7, 73, 45, 3, 74, 46],
            [15, 43, 19, 2, 44, 20],
            [3, 45, 15, 13, 46, 16],

            // 17
            [1, 135, 107, 5, 136, 108],
            [10, 74, 46, 1, 75, 47],
            [1, 50, 22, 15, 51, 23],
            [2, 42, 14, 17, 43, 15],

            // 18
            [5, 150, 120, 1, 151, 121],
            [9, 69, 43, 4, 70, 44],
            [17, 50, 22, 1, 51, 23],
            [2, 42, 14, 19, 43, 15],

            // 19
            [3, 141, 113, 4, 142, 114],
            [3, 70, 44, 11, 71, 45],
            [17, 47, 21, 4, 48, 22],
            [9, 39, 13, 16, 40, 14],

            // 20
            [3, 135, 107, 5, 136, 108],
            [3, 67, 41, 13, 68, 42],
            [15, 54, 24, 5, 55, 25],
            [15, 43, 15, 10, 44, 16],

            // 21
            [4, 144, 116, 4, 145, 117],
            [17, 68, 42],
            [17, 50, 22, 6, 51, 23],
            [19, 46, 16, 6, 47, 17],

            // 22
            [2, 139, 111, 7, 140, 112],
            [17, 74, 46],
            [7, 54, 24, 16, 55, 25],
            [34, 37, 13],

            // 23
            [4, 151, 121, 5, 152, 122],
            [4, 75, 47, 14, 76, 48],
            [11, 54, 24, 14, 55, 25],
            [16, 45, 15, 14, 46, 16],

            // 24
            [6, 147, 117, 4, 148, 118],
            [6, 73, 45, 14, 74, 46],
            [11, 54, 24, 16, 55, 25],
            [30, 46, 16, 2, 47, 17],

            // 25
            [8, 132, 106, 4, 133, 107],
            [8, 75, 47, 13, 76, 48],
            [7, 54, 24, 22, 55, 25],
            [22, 45, 15, 13, 46, 16],

            // 26
            [10, 142, 114, 2, 143, 115],
            [19, 74, 46, 4, 75, 47],
            [28, 50, 22, 6, 51, 23],
            [33, 46, 16, 4, 47, 17],

            // 27
            [8, 152, 122, 4, 153, 123],
            [22, 73, 45, 3, 74, 46],
            [8, 53, 23, 26, 54, 24],
            [12, 45, 15, 28, 46, 16],

            // 28
            [3, 147, 117, 10, 148, 118],
            [3, 73, 45, 23, 74, 46],
            [4, 54, 24, 31, 55, 25],
            [11, 45, 15, 31, 46, 16],

            // 29
            [7, 146, 116, 7, 147, 117],
            [21, 73, 45, 7, 74, 46],
            [1, 53, 23, 37, 54, 24],
            [19, 45, 15, 26, 46, 16],

            // 30
            [5, 145, 115, 10, 146, 116],
            [19, 75, 47, 10, 76, 48],
            [15, 54, 24, 25, 55, 25],
            [23, 45, 15, 25, 46, 16],

            // 31
            [13, 145, 115, 3, 146, 116],
            [2, 74, 46, 29, 75, 47],
            [42, 54, 24, 1, 55, 25],
            [23, 45, 15, 28, 46, 16],

            // 32
            [17, 145, 115],
            [10, 74, 46, 23, 75, 47],
            [10, 54, 24, 35, 55, 25],
            [19, 45, 15, 35, 46, 16],

            // 33
            [17, 145, 115, 1, 146, 116],
            [14, 74, 46, 21, 75, 47],
            [29, 54, 24, 19, 55, 25],
            [11, 45, 15, 46, 46, 16],

            // 34
            [13, 145, 115, 6, 146, 116],
            [14, 74, 46, 23, 75, 47],
            [44, 54, 24, 7, 55, 25],
            [59, 46, 16, 1, 47, 17],

            // 35
            [12, 151, 121, 7, 152, 122],
            [12, 75, 47, 26, 76, 48],
            [39, 54, 24, 14, 55, 25],
            [22, 45, 15, 41, 46, 16],

            // 36
            [6, 151, 121, 14, 152, 122],
            [6, 75, 47, 34, 76, 48],
            [46, 54, 24, 10, 55, 25],
            [2, 45, 15, 64, 46, 16],

            // 37
            [17, 152, 122, 4, 153, 123],
            [29, 74, 46, 14, 75, 47],
            [49, 54, 24, 10, 55, 25],
            [24, 45, 15, 46, 46, 16],

            // 38
            [4, 152, 122, 18, 153, 123],
            [13, 74, 46, 32, 75, 47],
            [48, 54, 24, 14, 55, 25],
            [42, 45, 15, 32, 46, 16],

            // 39
            [20, 147, 117, 4, 148, 118],
            [40, 75, 47, 7, 76, 48],
            [43, 54, 24, 22, 55, 25],
            [10, 45, 15, 67, 46, 16],

            // 40
            [19, 148, 118, 6, 149, 119],
            [18, 75, 47, 31, 76, 48],
            [34, 54, 24, 34, 55, 25],
            [20, 45, 15, 61, 46, 16]
        ];

        var qrRSBlock = function(totalCount, dataCount) {
            var _this = {};
            _this.totalCount = totalCount;
            _this.dataCount = dataCount;
            return _this;
        };

        var _this = {};

        var getRsBlockTable = function(typeNumber, errorCorrectionLevel) {

            switch(errorCorrectionLevel) {
                case QRErrorCorrectionLevel.L :
                    return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
                case QRErrorCorrectionLevel.M :
                    return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
                case QRErrorCorrectionLevel.Q :
                    return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
                case QRErrorCorrectionLevel.H :
                    return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
                default :
                    return undefined;
            }
        };

        _this.getRSBlocks = function(typeNumber, errorCorrectionLevel) {

            var rsBlock = getRsBlockTable(typeNumber, errorCorrectionLevel);

            if (typeof rsBlock == 'undefined') {
                throw new Error('bad rs block @ typeNumber:' + typeNumber +
                    '/errorCorrectionLevel:' + errorCorrectionLevel);
            }

            var length = rsBlock.length / 3;

            var list = new Array();

            for (var i = 0; i < length; i += 1) {

                var count = rsBlock[i * 3 + 0];
                var totalCount = rsBlock[i * 3 + 1];
                var dataCount = rsBlock[i * 3 + 2];

                for (var j = 0; j < count; j += 1) {
                    list.push(qrRSBlock(totalCount, dataCount) );
                }
            }

            return list;
        };

        return _this;
    }();

    //---------------------------------------------------------------------
    // qrBitBuffer
    //---------------------------------------------------------------------

    var qrBitBuffer = function() {

        var _buffer = new Array();
        var _length = 0;

        var _this = {};

        _this.getBuffer = function() {
            return _buffer;
        };

        _this.getAt = function(index) {
            var bufIndex = Math.floor(index / 8);
            return ( (_buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
        };

        _this.put = function(num, length) {
            for (var i = 0; i < length; i += 1) {
                _this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
            }
        };

        _this.getLengthInBits = function() {
            return _length;
        };

        _this.putBit = function(bit) {

            var bufIndex = Math.floor(_length / 8);
            if (_buffer.length <= bufIndex) {
                _buffer.push(0);
            }

            if (bit) {
                _buffer[bufIndex] |= (0x80 >>> (_length % 8) );
            }

            _length += 1;
        };

        return _this;
    };

    //---------------------------------------------------------------------
    // qrNumber
    //---------------------------------------------------------------------

    var qrNumber = function(data) {

        var _mode = QRMode.MODE_NUMBER;
        var _data = data;

        var _this = {};

        _this.getMode = function() {
            return _mode;
        };

        _this.getLength = function(buffer) {
            return _data.length;
        };

        _this.write = function(buffer) {

            var data = _data;

            var i = 0;

            while (i + 2 < data.length) {
                buffer.put(strToNum(data.substring(i, i + 3) ), 10);
                i += 3;
            }

            if (i < data.length) {
                if (data.length - i == 1) {
                    buffer.put(strToNum(data.substring(i, i + 1) ), 4);
                } else if (data.length - i == 2) {
                    buffer.put(strToNum(data.substring(i, i + 2) ), 7);
                }
            }
        };

        var strToNum = function(s) {
            var num = 0;
            for (var i = 0; i < s.length; i += 1) {
                num = num * 10 + chatToNum(s.charAt(i) );
            }
            return num;
        };

        var chatToNum = function(c) {
            if ('0' <= c && c <= '9') {
                return c.charCodeAt(0) - '0'.charCodeAt(0);
            }
            throw 'illegal char :' + c;
        };

        return _this;
    };

    //---------------------------------------------------------------------
    // qrAlphaNum
    //---------------------------------------------------------------------

    var qrAlphaNum = function(data) {

        var _mode = QRMode.MODE_ALPHA_NUM;
        var _data = data;

        var _this = {};

        _this.getMode = function() {
            return _mode;
        };

        _this.getLength = function(buffer) {
            return _data.length;
        };

        _this.write = function(buffer) {

            var s = _data;

            var i = 0;

            while (i + 1 < s.length) {
                buffer.put(
                    getCode(s.charAt(i) ) * 45 +
                    getCode(s.charAt(i + 1) ), 11);
                i += 2;
            }

            if (i < s.length) {
                buffer.put(getCode(s.charAt(i) ), 6);
            }
        };

        var getCode = function(c) {

            if ('0' <= c && c <= '9') {
                return c.charCodeAt(0) - '0'.charCodeAt(0);
            } else if ('A' <= c && c <= 'Z') {
                return c.charCodeAt(0) - 'A'.charCodeAt(0) + 10;
            } else {
                switch (c) {
                    case ' ' : return 36;
                    case '$' : return 37;
                    case '%' : return 38;
                    case '*' : return 39;
                    case '+' : return 40;
                    case '-' : return 41;
                    case '.' : return 42;
                    case '/' : return 43;
                    case ':' : return 44;
                    default :
                        throw 'illegal char :' + c;
                }
            }
        };

        return _this;
    };

    //---------------------------------------------------------------------
    // qr8BitByte
    //---------------------------------------------------------------------

    var qr8BitByte = function(data) {

        var _mode = QRMode.MODE_8BIT_BYTE;
        var _data = data;
        var _bytes = qrcode.stringToBytes(data);

        var _this = {};

        _this.getMode = function() {
            return _mode;
        };

        _this.getLength = function(buffer) {
            return _bytes.length;
        };

        _this.write = function(buffer) {
            for (var i = 0; i < _bytes.length; i += 1) {
                buffer.put(_bytes[i], 8);
            }
        };

        return _this;
    };

    //---------------------------------------------------------------------
    // qrKanji
    //---------------------------------------------------------------------

    var qrKanji = function(data) {

        var _mode = QRMode.MODE_KANJI;
        var _data = data;
        var _bytes = qrcode.stringToBytes(data);

        !function(c, code) {
            // self test for sjis support.
            var test = qrcode.stringToBytes(c);
            if (test.length != 2 || ( (test[0] << 8) | test[1]) != code) {
                throw 'sjis not supported.';
            }
        }('\u53cb', 0x9746);

        var _this = {};

        _this.getMode = function() {
            return _mode;
        };

        _this.getLength = function(buffer) {
            return ~~(_bytes.length / 2);
        };

        _this.write = function(buffer) {

            var data = _bytes;

            var i = 0;

            while (i + 1 < data.length) {

                var c = ( (0xff & data[i]) << 8) | (0xff & data[i + 1]);

                if (0x8140 <= c && c <= 0x9FFC) {
                    c -= 0x8140;
                } else if (0xE040 <= c && c <= 0xEBBF) {
                    c -= 0xC140;
                } else {
                    throw 'illegal char at ' + (i + 1) + '/' + c;
                }

                c = ( (c >>> 8) & 0xff) * 0xC0 + (c & 0xff);

                buffer.put(c, 13);

                i += 2;
            }

            if (i < data.length) {
                throw 'illegal char at ' + (i + 1);
            }
        };

        return _this;
    };

    //=====================================================================
    // GIF Support etc.
    //

    //---------------------------------------------------------------------
    // byteArrayOutputStream
    //---------------------------------------------------------------------

    var byteArrayOutputStream = function() {

        var _bytes = new Array();

        var _this = {};

        _this.writeByte = function(b) {
            _bytes.push(b & 0xff);
        };

        _this.writeShort = function(i) {
            _this.writeByte(i);
            _this.writeByte(i >>> 8);
        };

        _this.writeBytes = function(b, off, len) {
            off = off || 0;
            len = len || b.length;
            for (var i = 0; i < len; i += 1) {
                _this.writeByte(b[i + off]);
            }
        };

        _this.writeString = function(s) {
            for (var i = 0; i < s.length; i += 1) {
                _this.writeByte(s.charCodeAt(i) );
            }
        };

        _this.toByteArray = function() {
            return _bytes;
        };

        _this.toString = function() {
            var s = '';
            s += '[';
            for (var i = 0; i < _bytes.length; i += 1) {
                if (i > 0) {
                    s += ',';
                }
                s += _bytes[i];
            }
            s += ']';
            return s;
        };

        return _this;
    };

    //---------------------------------------------------------------------
    // base64EncodeOutputStream
    //---------------------------------------------------------------------

    var base64EncodeOutputStream = function() {

        var _buffer = 0;
        var _buflen = 0;
        var _length = 0;
        var _base64 = '';

        var _this = {};

        var writeEncoded = function(b) {
            _base64 += String.fromCharCode(encode(b & 0x3f) );
        };

        var encode = function(n) {
            if (n < 0) {
                // error.
            } else if (n < 26) {
                return 0x41 + n;
            } else if (n < 52) {
                return 0x61 + (n - 26);
            } else if (n < 62) {
                return 0x30 + (n - 52);
            } else if (n == 62) {
                return 0x2b;
            } else if (n == 63) {
                return 0x2f;
            }
            throw new Error('n:' + n);
        };

        _this.writeByte = function(n) {

            _buffer = (_buffer << 8) | (n & 0xff);
            _buflen += 8;
            _length += 1;

            while (_buflen >= 6) {
                writeEncoded(_buffer >>> (_buflen - 6) );
                _buflen -= 6;
            }
        };

        _this.flush = function() {

            if (_buflen > 0) {
                writeEncoded(_buffer << (6 - _buflen) );
                _buffer = 0;
                _buflen = 0;
            }

            if (_length % 3 != 0) {
                // padding
                var padlen = 3 - _length % 3;
                for (var i = 0; i < padlen; i += 1) {
                    _base64 += '=';
                }
            }
        };

        _this.toString = function() {
            return _base64;
        };

        return _this;
    };

    //---------------------------------------------------------------------
    // base64DecodeInputStream
    //---------------------------------------------------------------------

    var base64DecodeInputStream = function(str) {

        var _str = str;
        var _pos = 0;
        var _buffer = 0;
        var _buflen = 0;

        var _this = {};

        _this.read = function() {

            while (_buflen < 8) {

                if (_pos >= _str.length) {
                    if (_buflen == 0) {
                        return -1;
                    }
                    throw new Error('unexpected end of file./' + _buflen);
                }

                var c = _str.charAt(_pos);
                _pos += 1;

                if (c == '=') {
                    _buflen = 0;
                    return -1;
                } else if (c.match(/^\s$/) ) {
                    // ignore if whitespace.
                    continue;
                }

                _buffer = (_buffer << 6) | decode(c.charCodeAt(0) );
                _buflen += 6;
            }

            var n = (_buffer >>> (_buflen - 8) ) & 0xff;
            _buflen -= 8;
            return n;
        };

        var decode = function(c) {
            if (0x41 <= c && c <= 0x5a) {
                return c - 0x41;
            } else if (0x61 <= c && c <= 0x7a) {
                return c - 0x61 + 26;
            } else if (0x30 <= c && c <= 0x39) {
                return c - 0x30 + 52;
            } else if (c == 0x2b) {
                return 62;
            } else if (c == 0x2f) {
                return 63;
            } else {
                throw new Error('c:' + c);
            }
        };

        return _this;
    };

    //---------------------------------------------------------------------
    // gifImage (B/W)
    //---------------------------------------------------------------------

    var gifImage = function(width, height) {

        var _width = width;
        var _height = height;
        var _data = new Array(width * height);

        var _this = {};

        _this.setPixel = function(x, y, pixel) {
            _data[y * _width + x] = pixel;
        };

        _this.write = function(out) {

            //---------------------------------
            // GIF Signature

            out.writeString('GIF87a');

            //---------------------------------
            // Screen Descriptor

            out.writeShort(_width);
            out.writeShort(_height);

            out.writeByte(0x80); // 2bit
            out.writeByte(0);
            out.writeByte(0);

            //---------------------------------
            // Global Color Map

            // black
            out.writeByte(0x00);
            out.writeByte(0x00);
            out.writeByte(0x00);

            // white
            out.writeByte(0xff);
            out.writeByte(0xff);
            out.writeByte(0xff);

            //---------------------------------
            // Image Descriptor

            out.writeString(',');
            out.writeShort(0);
            out.writeShort(0);
            out.writeShort(_width);
            out.writeShort(_height);
            out.writeByte(0);

            //---------------------------------
            // Local Color Map

            //---------------------------------
            // Raster Data

            var lzwMinCodeSize = 2;
            var raster = getLZWRaster(lzwMinCodeSize);

            out.writeByte(lzwMinCodeSize);

            var offset = 0;

            while (raster.length - offset > 255) {
                out.writeByte(255);
                out.writeBytes(raster, offset, 255);
                offset += 255;
            }

            out.writeByte(raster.length - offset);
            out.writeBytes(raster, offset, raster.length - offset);
            out.writeByte(0x00);

            //---------------------------------
            // GIF Terminator
            out.writeString(';');
        };

        var bitOutputStream = function(out) {

            var _out = out;
            var _bitLength = 0;
            var _bitBuffer = 0;

            var _this = {};

            _this.write = function(data, length) {

                if ( (data >>> length) != 0) {
                    throw new Error('length over');
                }

                while (_bitLength + length >= 8) {
                    _out.writeByte(0xff & ( (data << _bitLength) | _bitBuffer) );
                    length -= (8 - _bitLength);
                    data >>>= (8 - _bitLength);
                    _bitBuffer = 0;
                    _bitLength = 0;
                }

                _bitBuffer = (data << _bitLength) | _bitBuffer;
                _bitLength = _bitLength + length;
            };

            _this.flush = function() {
                if (_bitLength > 0) {
                    _out.writeByte(_bitBuffer);
                }
            };

            return _this;
        };

        var getLZWRaster = function(lzwMinCodeSize) {

            var clearCode = 1 << lzwMinCodeSize;
            var endCode = (1 << lzwMinCodeSize) + 1;
            var bitLength = lzwMinCodeSize + 1;

            // Setup LZWTable
            var table = lzwTable();

            for (var i = 0; i < clearCode; i += 1) {
                table.add(String.fromCharCode(i) );
            }
            table.add(String.fromCharCode(clearCode) );
            table.add(String.fromCharCode(endCode) );

            var byteOut = byteArrayOutputStream();
            var bitOut = bitOutputStream(byteOut);

            // clear code
            bitOut.write(clearCode, bitLength);

            var dataIndex = 0;

            var s = String.fromCharCode(_data[dataIndex]);
            dataIndex += 1;

            while (dataIndex < _data.length) {

                var c = String.fromCharCode(_data[dataIndex]);
                dataIndex += 1;

                if (table.contains(s + c) ) {

                    s = s + c;

                } else {

                    bitOut.write(table.indexOf(s), bitLength);

                    if (table.size() < 0xfff) {

                        if (table.size() == (1 << bitLength) ) {
                            bitLength += 1;
                        }

                        table.add(s + c);
                    }

                    s = c;
                }
            }

            bitOut.write(table.indexOf(s), bitLength);

            // end code
            bitOut.write(endCode, bitLength);

            bitOut.flush();

            return byteOut.toByteArray();
        };

        var lzwTable = function() {

            var _map = {};
            var _size = 0;

            var _this = {};

            _this.add = function(key) {
                if (_this.contains(key) ) {
                    throw new Error('dup key:' + key);
                }
                _map[key] = _size;
                _size += 1;
            };

            _this.size = function() {
                return _size;
            };

            _this.indexOf = function(key) {
                return _map[key];
            };

            _this.contains = function(key) {
                return typeof _map[key] != 'undefined';
            };

            return _this;
        };

        return _this;
    };

    var createImgTag = function(width, height, getPixel, alt) {

        var gif = gifImage(width, height);
        for (var y = 0; y < height; y += 1) {
            for (var x = 0; x < width; x += 1) {
                gif.setPixel(x, y, getPixel(x, y) );
            }
        }

        var b = byteArrayOutputStream();
        gif.write(b);

        var base64 = base64EncodeOutputStream();
        var bytes = b.toByteArray();
        for (var i = 0; i < bytes.length; i += 1) {
            base64.writeByte(bytes[i]);
        }
        base64.flush();

        var img = '';
        img += '<img';
        img += '\u0020src="';
        img += 'data:image/gif;base64,';
        img += base64;
        img += '"';
        img += '\u0020width="';
        img += width;
        img += '"';
        img += '\u0020height="';
        img += height;
        img += '"';
        if (alt) {
            img += '\u0020alt="';
            img += alt;
            img += '"';
        }
        img += '/>';

        return img;
    };

    //---------------------------------------------------------------------
    // returns qrcode function.

    return qrcode;
}();

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define([], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    }
}(function () {
    return qrcode;
}));

var backtop = angular.module('angular.backtop', []);

backtop.directive('backTop', [function() {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    template: '<div id="backtop" class="{{theme}}"><button><div ng-transclude></div></button></div>',
    scope: {
      text: "@buttonText",
      speed: "@scrollSpeed",
      theme: "@buttonTheme",
      useParent: "=?"
    },
    link: function(scope, element,attrs) {

      scope.text = scope.text || 'Scroll top';
      scope.theme = scope.theme || 'light';
      scope.speed = parseInt(scope.speed, 10) || 300;
      scope.parent = attrs.useParent != null ? element.parent() : window;
      var speed = Math.round(scope.speed / 100);
      var onscroll = function () {
        if (scope.parent.pageYOffset > 0) {
          if(!element.showing){
            element.addClass('show');
            element.showing = true;
          }
        } else {
          element.removeClass('show');
          element.showing = false;
        }
      }

      scope.currentYPosition = function() {
        if (document.documentElement && document.documentElement.scrollTop)
          return document.documentElement.scrollTop;
        if (document.body.scrollTop)
          return document.body.scrollTop;
        return 0;
      };

      element.showing = false;
      element.on('click', function() {
        scope.parent.removeEventListener("scroll", onscroll);

        element.removeClass('show');
        element.showing = false;

        var startY = scope.currentYPosition();

        var step = Math.round(startY / 25);
        var leapY = startY < 100 ? 0 : startY - step;

        var scrollInterval = setInterval(function(){
          scope.parent.scrollTo(0, leapY)
          if(!leapY){
            clearInterval(scrollInterval);
            scope.parent.addEventListener("scroll", onscroll)
          }

          leapY -= step;

          if(leapY < 0) leapY = 0;
        }, speed)
      });

      if (attrs.useParent) {
          console.log('I should be using parent', element.parent());
          //scope.parent.onscroll = onscroll;
          scope.parent.bind("scroll", onscroll);
          //  scope.$on("$destroy",
          //      function() {
          //          scope.parent.unbind("scroll");
          //      });
      } else {
        window.addEventListener("scroll", onscroll);
          scope.$on("$destroy",
              function() {
                  window.removeEventListener("scroll", onscroll)
              });
      }
    }
  };

}]);

/*
 * angular-qrcode
 * (c) 2017 Monospaced http://monospaced.com
 * License: MIT
 */

if (typeof module !== 'undefined' &&
    typeof exports !== 'undefined' &&
    module.exports === exports){
    module.exports = 'monospaced.qrcode';
}

angular.module('monospaced.qrcode', [])
    .directive('qrcode', ['$window', function($window) {

        var canvas2D = !!$window.CanvasRenderingContext2D,
            levels = {
                'L': 'Low',
                'M': 'Medium',
                'Q': 'Quartile',
                'H': 'High'
            },
            draw = function(context, qr, modules, tile, color) {
                for (var row = 0; row < modules; row++) {
                    for (var col = 0; col < modules; col++) {
                        var w = (Math.ceil((col + 1) * tile) - Math.floor(col * tile)),
                            h = (Math.ceil((row + 1) * tile) - Math.floor(row * tile));

                        context.fillStyle = qr.isDark(row, col) ? color.foreground : color.background;
                        context.fillRect(Math.round(col * tile),
                            Math.round(row * tile), w, h);
                    }
                }
            };

        return {
            restrict: 'E',
            template: '<canvas class="qrcode"></canvas>',
            link: function(scope, element, attrs) {
                var domElement = element[0],
                    $canvas = element.find('canvas'),
                    canvas = $canvas[0],
                    context = canvas2D ? canvas.getContext('2d') : null,
                    download = 'download' in attrs,
                    href = attrs.href,
                    link = download || href ? document.createElement('a') : '',
                    trim = /^\s+|\s+$/g,
                    error,
                    version,
                    errorCorrectionLevel,
                    data,
                    size,
                    modules,
                    tile,
                    qr,
                    $img,
                    color = {
                        foreground: '#000',
                        background: '#fff'
                    },
                    setColor = function(value) {
                        color.foreground = value || color.foreground;
                    },
                    setBackground = function(value) {
                        color.background = value || color.background;
                    },
                    setVersion = function(value) {
                        version = Math.max(1, Math.min(parseInt(value, 10), 40)) || 5;
                    },
                    setErrorCorrectionLevel = function(value) {
                        errorCorrectionLevel = value in levels ? value : 'M';
                    },
                    setData = function(value) {
                        if (!value) {
                            return;
                        }

                        data = value.replace(trim, '');
                        qr = qrcode(version, errorCorrectionLevel);
                        qr.addData(data);

                        try {
                            qr.make();
                        } catch (e) {
                            var newVersion;
                            if (version >= 40) {
                                throw new Error('Data is too long', e);
                            }
                            newVersion = version + 1;
                            setVersion(newVersion);
                            console.warn('qrcode version is too low and has been incremented to', newVersion)
                            setData(value);
                            return;
                        }

                        error = false;
                        modules = qr.getModuleCount();
                    },
                    setSize = function(value) {
                        size = parseInt(value, 10) || modules * 2;
                        tile = size / modules;
                        canvas.width = canvas.height = size;
                    },
                    render = function() {
                        if (!qr) {
                            return;
                        }

                        if (error) {
                            if (link) {
                                link.removeAttribute('download');
                                link.title = '';
                                link.href = '#_';
                            }
                            if (!canvas2D) {
                                domElement.innerHTML = '<img src width="' + size + '"' +
                                    'height="' + size + '"' +
                                    'class="qrcode">';
                            }
                            scope.$emit('qrcode:error', error);
                            return;
                        }

                        if (download) {
                            domElement.download = 'qrcode.png';
                            domElement.title = 'Download QR code';
                        }

                        if (canvas2D) {
                            draw(context, qr, modules, tile, color);

                            if (download) {
                                domElement.href = canvas.toDataURL('image/png');
                                return;
                            }
                        } else {
                            domElement.innerHTML = qr.createImgTag(tile, 0);
                            $img = element.find('img');
                            $img.addClass('qrcode');

                            if (download) {
                                domElement.href = $img[0].src;
                                return;
                            }
                        }

                        if (href) {
                            domElement.href = href;
                        }
                    };

                if (link) {
                    link.className = 'qrcode-link';
                    $canvas.wrap(link);
                    domElement = domElement.firstChild;
                }

                setColor(attrs.color);
                setBackground(attrs.background);
                setVersion(attrs.version);
                setErrorCorrectionLevel(attrs.errorCorrectionLevel);
                setSize(attrs.size);

                attrs.$observe('version', function(value) {
                    if (!value) {
                        return;
                    }

                    setVersion(value);
                    setData(data);
                    setSize(size);
                    render();
                });

                attrs.$observe('errorCorrectionLevel', function(value) {
                    if (!value) {
                        return;
                    }

                    setErrorCorrectionLevel(value);
                    setData(data);
                    setSize(size);
                    render();
                });

                attrs.$observe('data', function(value) {
                    if (!value) {
                        return;
                    }

                    setData(value);
                    setSize(size);
                    render();
                });

                attrs.$observe('size', function(value) {
                    if (!value) {
                        return;
                    }

                    setSize(value);
                    render();
                });

                attrs.$observe('color', function(value) {
                    if (!value) {
                        return;
                    }

                    setColor(value);
                    render();
                });

                attrs.$observe('background', function(value) {
                    if (!value) {
                        return;
                    }

                    setBackground(value);
                    render();
                });

                attrs.$observe('href', function(value) {
                    if (!value) {
                        return;
                    }

                    href = value;
                    render();
                });
            }
        };
    }]);

/*! angular-google-chart 2017-04-16 */
/*
* @description Google Chart Api Directive Module for AngularJS
* @version 1.0.0-beta.1
* @author GitHub Contributors <https://github.com/angular-google-chart/angular-google-chart/graphs/contributors> 
* @license MIT
* @year 2013
*/
/* global angular */
(function () {
	angular.module('googlechart', [])
		.run(registerResizeEvent);

	registerResizeEvent.$inject = ['$rootScope', '$window'];

	function registerResizeEvent($rootScope, $window) {
		angular.element($window).on('resize', function () {
			$rootScope.$emit('resizeMsg');
		});
	}
})();
/* global angular, google */
(function () {
	angular.module('googlechart')
		.factory('FormatManager', formatManagerFactory);

	function formatManagerFactory() {
		// Handles the processing of Google Charts API Formats
		function FormatManager($google) {
			var self = this;
			var oldFormatTemplates = {};
			self.iFormats = {}; // Holds instances of formats (ie. self.iFormats.date[0] = new $google.visualization.DateFormat(params))
			self.applyFormats = applyFormats;

			// apply formats of type to datatable
			function apply(tFormats, dataTable) {
				var i, formatType;
				for (formatType in tFormats) {
					if (tFormats.hasOwnProperty(formatType)) {
						for (i = 0; i < self.iFormats[formatType].length; i++) {
							if (tFormats[formatType][i].columnNum < dataTable.getNumberOfColumns()) {
								self.iFormats[formatType][i].format(dataTable, tFormats[formatType][i].columnNum);
							}
						}
					}
				}
			}

			function applyFormat(formatType, FormatClass, tFormats) {
				var i;
				if (angular.isArray(tFormats[formatType])) {
					// basic change detection; no need to run if no changes
					if (!angular.equals(tFormats[formatType], oldFormatTemplates[formatType])) {
						oldFormatTemplates[formatType] = tFormats[formatType];
						self.iFormats[formatType] = [];

						if (formatType === 'color') {
							instantiateColorFormatters(tFormats);
						} else {
							for (i = 0; i < tFormats[formatType].length; i++) {
								self.iFormats[formatType].push(new FormatClass(
									tFormats[formatType][i])
								);
							}
						}
					}
				}
			}

			function applyFormats(dataTable, tFormats, customFormatters) {
				var formatType, FormatClass, requiresHtml = false;
				if (!angular.isDefined(tFormats) || !angular.isDefined(dataTable)) {
					return { requiresHtml: false };
				}
				for (formatType in tFormats) {
					if (tFormats.hasOwnProperty(formatType)) {
						FormatClass = getFormatClass(formatType, customFormatters);
						if (!angular.isFunction(FormatClass)) {
							// if no class constructor was returned,
							// there's no point in completing cycle
							continue;
						}
						applyFormat(formatType, FormatClass, tFormats);

						//Many formatters require HTML tags to display special formatting
						if (formatType === 'arrow' || formatType === 'bar' || formatType === 'color') {
							requiresHtml = true;
						}
					}
				}
				apply(tFormats, dataTable);
				return { requiresHtml: requiresHtml };
			}

			function instantiateColorFormatters(tFormats) {
				var t, colorFormat, i, data, formatType = 'color';
				for (t = 0; t < tFormats[formatType].length; t++) {
					colorFormat = new $google.visualization.ColorFormat();

					for (i = 0; i < tFormats[formatType][t].formats.length; i++) {
						data = tFormats[formatType][t].formats[i];

						if (typeof (data.fromBgColor) !== 'undefined' && typeof (data.toBgColor) !== 'undefined') {
							colorFormat.addGradientRange(data.from, data.to, data.color, data.fromBgColor, data.toBgColor);
						} else {
							colorFormat.addRange(data.from, data.to, data.color, data.bgcolor);
						}
					}

					self.iFormats[formatType].push(colorFormat);
				}
			}

			function getFormatClass(formatType, customFormatters) {
				var className = formatType.charAt(0).toUpperCase() + formatType.slice(1).toLowerCase() + "Format";
				if ($google.visualization.hasOwnProperty(className)) {
					return google.visualization[className];
				} else if (angular.isDefined(customFormatters) && customFormatters.hasOwnProperty(formatType)) {
					return customFormatters[formatType];
				}
				return;
			}
		}

		return FormatManager;
	}
})();
/* global angular, google */

(function () {

	angular.module('googlechart')
		.controller('GoogleChartController', GoogleChartController);

	GoogleChartController.$inject = ['$scope', '$element', '$attrs', '$injector', '$timeout', '$window', '$rootScope', 'GoogleChartService'];

	function GoogleChartController($scope, $element, $attrs, $injector, $timeout, $window, $rootScope, GoogleChartService) {
		var self = this;
		var resizeHandler;
		var googleChartService;

		init();

		function cleanup() {
			resizeHandler();
		}

		function draw() {
			if (!draw.triggered && (self.chart !== undefined)) {
				draw.triggered = true;
				$timeout(setupAndDraw, 0, true);
			}
			else if (self.chart !== undefined) {
				$timeout.cancel(draw.recallTimeout);
				draw.recallTimeout = $timeout(draw, 10);
			}
		}

		// Watch function calls this.
		function drawAsync() {
			googleChartService.getReadyPromise()
				.then(draw);
		}

		//setupAndDraw() calls this.
		function drawChartWrapper() {
			googleChartService.draw();
			draw.triggered = false;
		}

		function init() {
			// Instantiate service
			googleChartService = new GoogleChartService();

			self.registerChartListener = googleChartService.registerChartListener;
			self.registerWrapperListener = googleChartService.registerWrapperListener;
			self.registerServiceListener = googleChartService.registerServiceListener;

            /* Watches, to refresh the chart when its data, formatters, options, view,
            or type change. All other values intentionally disregarded to avoid double
            calls to the draw function. Please avoid making changes to these objects
            directly from this directive.*/
			$scope.$watch(watchValue, watchHandler, true); // true is for deep object equality checking

			// Redraw the chart if the window is resized
			resizeHandler = $rootScope.$on('resizeMsg', drawAsync);

			//Cleanup resize handler.
			$scope.$on('$destroy', cleanup);
		}

		function setupAndDraw() {
			googleChartService.setup($element,
				self.chart.type,
				self.chart.data,
				self.chart.view,
				self.chart.options,
				self.chart.formatters,
				self.chart.customFormatters);

			$timeout(drawChartWrapper);
		}

		function watchHandler() {
			self.chart = $scope.$eval($attrs.chart);
			drawAsync();
		}

		function watchValue() {
			var chartObject = $scope.$eval($attrs.chart);
			if (angular.isDefined(chartObject) && angular.isObject(chartObject)) {
				return {
					customFormatters: chartObject.customFormatters,
					data: chartObject.data,
					formatters: chartObject.formatters,
					options: chartObject.options,
					type: chartObject.type,
					view: chartObject.view
				};
			}
		}
	}
})();
/* global angular */
(function () {
	angular.module('googlechart')
		.directive('agcBeforeDraw', beforeDrawDirective);

	function beforeDrawDirective() {
		return {
			restrict: 'A',
			scope: false,
			require: 'googleChart',
			link: function (scope, element, attrs, googleChartController) {
				callback.$inject = ['chartWrapper'];
				function callback(chartWrapper) {
					scope.$apply(function () {
						scope.$eval(attrs.agcBeforeDraw, { chartWrapper: chartWrapper });
					});
				}
				googleChartController.registerServiceListener('beforeDraw', callback, this);
			}
		};
	}
})();

/* global angular */
(function () {
	angular.module('googlechart')
		.provider('agcGstaticLoader', agcGstaticLoaderProvider);

	function agcGstaticLoaderProvider() {
		var useBothLoaders = false;
		var version = "current";
		var options = {
			packages: ["corechart"]
		};

		/** Add Google Visualization API package to loader configuration. */
		this.addPackage = function (packageName) {
			options.packages = options.packages || [];
			options.packages.push(packageName);

			if (needsBothLoaders())
				useBothLoaders = true;
			return this;
		};

		/** Delete key from underlying loader configuration. */
		this.clearOption = function (key) {
			delete this._options[key];
			return this;
		};

		/** Remove Google Visualization API package from loader configuration. */
		this.removePackage = function (packageName) {
			options.packages = this._options.packages || [];
			var index = options.packages.indexOf(packageName);
			if (index > -1)
				options.packages.splice(index, 1);
			return this;
		};

		/** Set option to value. See developers.google.com/chart/ for information about loader options. */
		this.setOption = function (key, value) {
			options[key] = value;
			return this;
		};

		/** Sets underlying loader options object to value provided. Replaces everything, included packages. */
		this.setOptions = function (value) {
			options = value;
			return this;
		};

		/** Set Google Visualization API frozen version to load. Default: 'current' */
		this.setVersion = function (value) {
			version = value;
			if (needsBothLoaders())
				useBothLoaders = true;
			return this;
		};

		/** Override for internal setting to add both loader scripts. Required under certain conditions. */
		this.useBothLoaders = function (value) {
			if (typeof value === 'undefined')
				value = true;

			useBothLoaders = !!value;
			return this;
		};

		/** Check if conditions are correct to need both JSAPI and gstatic loader scripts. */
		function needsBothLoaders() {
			var versionCheck, packageCheck;

			versionCheck = !isNaN(+version) && +version < 45;
			packageCheck = options.packages.indexOf("geochart") > -1 ||
				options.packages.indexOf("map") > -1;

			return versionCheck && packageCheck;
		}

		this.$get = function ($rootScope, $q, agcScriptTagHelper) {

			function scriptLoadCallback() {
				if (!google ||
					!google.charts ||
					typeof google.charts.setOnLoadCallback !== 'function') {
					return $q.reject("Google charts library loader not present.");
				}

				var deferred = $q.defer();

				google.charts.load(version, options);

				google.charts.setOnLoadCallback(function () {
					$rootScope.$apply(function () {
						deferred.resolve(google);
					});
				});

				return deferred.promise;
			}

			var tagPromise = agcScriptTagHelper("https://www.gstatic.com/charts/loader.js");
			if (useBothLoaders)
				tagPromise = tagPromise.then(function () { return agcScriptTagHelper("https://www.google.com/jsapi"); });
			var libraryPromise = tagPromise.then(scriptLoadCallback);

			return libraryPromise;
		};
		this.$get.$inject = ["$rootScope", "$q", "agcScriptTagHelper"];
	}
})();

/* global angular */
(function () {
	angular.module("googlechart")
		.factory("agcJsapiLoader", agcJsapiLoaderFactory);

	agcJsapiLoaderFactory.$inject = ["$log", "$rootScope", "$q", "agcScriptTagHelper", "googleChartApiConfig"];
	function agcJsapiLoaderFactory($log, $rootScope, $q, agcScriptTagHelper, googleChartApiConfig) {
		$log.debug("[AGC] jsapi loader invoked.");
		var apiReady = $q.defer();
		// Massage configuration as needed.
		googleChartApiConfig.optionalSettings = googleChartApiConfig.optionalSettings || {};

		var userDefinedCallback = googleChartApiConfig.optionalSettings.callback;

		var settings = {
			callback: function () {
				if (angular.isFunction(userDefinedCallback))
					userDefinedCallback.call(this);

				$rootScope.$apply(function () {
					apiReady.resolve(google);
				});
			}
		};

		settings = angular.extend({}, googleChartApiConfig.optionalSettings, settings);

		$log.debug("[AGC] Calling tag helper...");
		agcScriptTagHelper("//www.google.com/jsapi")
			.then(function () {
				$log.debug("[AGC] Tag helper returned success.");
				window.google.load('visualization', googleChartApiConfig.version || '1', settings);
			})
			.catch(function () {
				$log.error("[AGC] Tag helper returned error. Script may have failed to load.");
				apiReady.reject();
			});

		return apiReady.promise;
	}
})();

/* global angular */
(function () {
	angular.module("googlechart")
		.provider("agcLibraryLoader", AgcLibraryLoaderProvider);

	AgcLibraryLoaderProvider.$inject = ["$injector"];

	function AgcLibraryLoaderProvider($injector) {

		var DEFAULT_LOADER = "Jsapi";

		this.$get = function (loader) {
			return loader;
		};

		this.setLoader = function (loaderName) {
			if ($injector.has(this.getProviderName(loaderName)))
				this.$get.$inject = [this.getProviderName(loaderName)];
			else {
				console.warn("[Angular-GoogleChart] Loader type \"" + loaderName + "\" doesn't exist. Defaulting to JSAPI loader.");
				this.$get.$inject = [this.getProviderName(DEFAULT_LOADER)];
			}
		};

		this.getProviderName = function (loaderName) {
			loaderName = loaderName.charAt(0).toUpperCase() + loaderName.slice(1);
			return "agc" + loaderName + "Loader";
		};

		this.setLoader(DEFAULT_LOADER);
	}
})();

/* global angular */
(function () {
	angular.module("googlechart")
		.provider("agcNullLoader", AgcNullLoaderProvider);

    /** Fake loader strategy. Use this if you're loading the google charts library
     *  in some non-standard way.
     */

	function AgcNullLoaderProvider() {
		this._hasTrigger = false;
		this._libraryOverride = null;
		this._triggerFunction = (function () {
			// If the trigger function is called before $get,
			// just act as if it was never fetched.
			if (this._deferred)
				this._deferred.resolve(this._libraryOverride || google);
			else
				this._hasTrigger = false;
		}).bind(this);
		this._deferred = null;
	}

	AgcNullLoaderProvider.prototype.$get = function ($q) {
		this._deferred = $q.defer();

		if (!this._hasTrigger)
			this._deferred.resolve(this._libraryOverride || google);

		return this._deferred.promise;
	};
	AgcNullLoaderProvider.prototype.$get.$inject = ["$q"];

	AgcNullLoaderProvider.prototype.getTriggerFunction = function () {
		// Records that the trigger function was fetched.
		// Will wait for it to be called to resolve.
		// This is useful for manual, but deferred, loading of
		// the google charts library.
		this._hasTrigger = true;
		return this._triggerFunction;
	};

    /** Forces angular-google-chart to load this object as the google library.
     *  Makes no checks to ensure that the object passed is compatible. Use
     *  at own risk.
     */
	AgcNullLoaderProvider.prototype.overrideLibrary = function (library) {
		this._libraryOverride = library;
	};
})();

(function () {
	angular.module('googlechart')
		.directive('agcOnClick', onClickDirective);

	function onClickDirective() {
		return {
			restrict: 'A',
			scope: false,
			require: 'googleChart',
			link: function (scope, element, attrs, googleChartController) {
				callback.$inject = ['args', 'chart', 'chartWrapper'];
				function callback(args, chart, chartWrapper) {
					scope.$apply(function () {
						scope.$eval(attrs.agcOnClick, { args: args, chart: chart, chartWrapper: chartWrapper });
					});
				}
				googleChartController.registerChartListener('click', callback, this);
			}
		};
	}
})();

/* global angular */
(function () {
	angular.module('googlechart')
		.directive('agcOnError', onErrorDirective);
	function onErrorDirective() {
		return {
			restrict: 'A',
			scope: false,
			require: 'googleChart',
			link: function (scope, element, attrs, googleChartController) {
				callback.$inject = ['chartWrapper', 'chart', 'args'];
				function callback(chartWrapper, chart, args) {
					var returnValues = {
						chartWrapper: chartWrapper,
						chart: chart,
						args: args,
						error: args[0],
						err: args[0],
						id: args[0].id,
						message: args[0].message
					};
					scope.$apply(function () {
						scope.$eval(attrs.agcOnError, returnValues);
					});
				}
				googleChartController.registerWrapperListener('error', callback, this);
			}
		};
	}
})();
/* global angular */

(function () {
	angular.module('googlechart')
		.directive('agcOnMouseout', agcOnMouseoutDirective);

	function agcOnMouseoutDirective() {
		return {
			restrict: 'A',
			scope: false,
			require: 'googleChart',
			link: function (scope, element, attrs, googleChartController) {
				callback.$inject = ['args', 'chart', 'chartWrapper'];
				function callback(args, chart, chartWrapper) {
					var returnParams = {
						chartWrapper: chartWrapper,
						chart: chart,
						args: args,
						column: args[0].column,
						row: args[0].row
					};
					scope.$apply(function () {
						scope.$eval(attrs.agcOnMouseout, returnParams);
					});
				}
				googleChartController.registerChartListener('onmouseout', callback, this);
			}
		};
	}
})();
/* global angular */

(function () {
	angular.module('googlechart')
		.directive('agcOnMouseover', agcOnMouseoverDirective);

	function agcOnMouseoverDirective() {
		return {
			restrict: 'A',
			scope: false,
			require: 'googleChart',
			link: function (scope, element, attrs, googleChartController) {
				callback.$inject = ['args', 'chart', 'chartWrapper'];
				function callback(args, chart, chartWrapper) {
					var returnParams = {
						chartWrapper: chartWrapper,
						chart: chart,
						args: args,
						column: args[0].column,
						row: args[0].row
					};
					scope.$apply(function () {
						scope.$eval(attrs.agcOnMouseover, returnParams);
					});
				}
				googleChartController.registerChartListener('onmouseover', callback, this);
			}
		};
	}
})();
/* global angular */

(function () {
	angular.module('googlechart')
		.directive('agcOnRangeChange', agcOnRangeChangeDirective);

	function agcOnRangeChangeDirective() {
		return {
			restrict: 'A',
			scope: false,
			require: 'googleChart',
			link: function (scope, element, attrs, googleChartController) {
				callback.$inject = ['args', 'chart', 'chartWrapper'];
				function callback(args, chart, chartWrapper) {
					var returnParams = {
						chartWrapper: chartWrapper,
						chart: chart,
						args: args,
						start: args[0].start,
						end: args[0].end
					};
					scope.$apply(function () {
						scope.$eval(attrs.agcOnRangeChange, returnParams);
					});
				}
				googleChartController.registerChartListener('rangechange', callback, this);
			}
		};
	}
})();

/* global angular */
(function () {
	angular.module('googlechart')
		.directive('agcOnReady', onReadyDirective);

	function onReadyDirective() {
		return {
			restrict: 'A',
			scope: false,
			require: 'googleChart',
			link: function (scope, element, attrs, googleChartController) {
				callback.$inject = ['chartWrapper'];
				function callback(chartWrapper) {
					scope.$apply(function () {
						scope.$eval(attrs.agcOnReady, { chartWrapper: chartWrapper });
					});
				}
				googleChartController.registerWrapperListener('ready', callback, this);
			}
		};
	}
})();
/* global angular */
(function () {
	angular.module('googlechart')
		.directive('agcOnSelect', onSelectDirective);

	function onSelectDirective() {
		return {
			restrict: 'A',
			scope: false,
			require: 'googleChart',
			link: function (scope, element, attrs, googleChartController) {
				callback.$inject = ['chartWrapper', 'chart'];
				function callback(chartWrapper, chart) {
					var selectEventRetParams = { selectedItems: chart.getSelection() };
					// This is for backwards compatibility for people using 'selectedItem' that only wanted the first selection.
					selectEventRetParams.selectedItem = selectEventRetParams.selectedItems[0];
					selectEventRetParams.chartWrapper = chartWrapper;
					selectEventRetParams.chart = chart;
					scope.$apply(function () {
						scope.$eval(attrs.agcOnSelect, selectEventRetParams);
					});
				}
				googleChartController.registerWrapperListener('select', callback, this);
			}
		};
	}
})();
/* global angular */
(function () {
	angular.module("googlechart")
		.factory("agcScriptTagHelper", agcScriptTagHelperFactory);

	agcScriptTagHelperFactory.$inject = ["$q", "$document"];
	function agcScriptTagHelperFactory($q, $document) {
        /** Add a script tag to the document's head section and return an angular
          * promise that resolves when the script has loaded.
          */
		function agcScriptTagHelper(url) {
			var deferred = $q.defer();
			var head = $document.find('head');
			var script = angular.element('<script></script>');

			script.attr('type', 'text/javascript');

			script.on('load', onLoad);
			script.on('error', onError);

			script.attr('src', url);

			// This: head.append(script);
			// Adds the tag, but event handles don't work.
			// Workaround is to add element with native appendChild().
			head[0].appendChild(script[0]);

			function onLoad() {
				deferred.resolve();
			}

			function onError() {
				deferred.reject();
			}

			return deferred.promise;
		}

		return agcScriptTagHelper;
	}
})();

/* global angular, google */
/* jshint -W072 */
(function () {
	angular.module('googlechart')
		.directive('googleChart', googleChartDirective);

	googleChartDirective.$inject = [];

	function googleChartDirective() {

		return {
			restrict: 'A',
			scope: false,
			controller: 'GoogleChartController'
		};
	}
})();

/* global angular */
(function () {
	angular.module('googlechart')
		.value('googleChartApiConfig', {
			version: '1',
			optionalSettings: {
				packages: ['corechart']
			}
		});
})();
/* global angular */
(function () {
	angular.module('googlechart')
		.factory('googleChartApiPromise', googleChartApiPromiseFactory);

	googleChartApiPromiseFactory.$inject = ['agcLibraryLoader'];

	/** Here for backward-compatibility only. */
	function googleChartApiPromiseFactory(agcLibraryLoader) {
		return agcLibraryLoader;
	}
})();

/* global angular */
(function () {
	angular.module('googlechart')
		.factory('GoogleChartService', GoogleChartServiceFactory);

	GoogleChartServiceFactory.$inject = ['agcLibraryLoader', '$injector', '$q', 'FormatManager'];

	function GoogleChartServiceFactory(agcLibraryLoader, $injector, $q, FormatManager) {
		function GoogleChartService() {
			var self = this;
			self.draw = draw;
			self.getChartWrapper = getChartWrapper;
			self.getData = getData;
			self.getElement = getElement;
			self.getOption = getOption;
			self.getOptions = getOptions;
			self.getView = getView;
			self.getReadyPromise = getReadyPromise;
			self.isApiReady = isApiReady;
			self.registerChartListener = registerChartListener;
			self.registerServiceListener = registerServiceListener;
			self.registerWrapperListener = registerWrapperListener;
			self.setData = setData;
			self.setElement = setElement;
			self.setOption = setOption;
			self.setOptions = setOptions;
			self.setup = setup;
			self.setView = setView;

			var $google,
				_libraryPromise,
				_apiReady,
				_chartWrapper,
				_element,
				_chartType,
				_data,
				_view,
				_options,
				_formatters,
				_innerVisualization,
				_formatManager,
				_needsUpdate = true,
				_customFormatters,
				_serviceDeferred,
				serviceListeners = {},
				wrapperListeners = {},
				chartListeners = {};

			_init();

			function _activateServiceEvent(eventName) {
				var i;
				if (angular.isArray(serviceListeners[eventName])) {
					for (i = 0; i < serviceListeners[eventName].length; i++) {
						serviceListeners[eventName][i]();
					}
				}
			}

			function _apiLoadFail(reason) {
				// Not sure what to do if this does happen.
				// Post your suggestions in the issues tracker at
				// https://github.com/angular-google-chart/angular-google-chart/
				return reason;
			}

			function _apiLoadSuccess(g) {
				$google = g;
				_apiReady = true;
				_serviceDeferred.resolve();
				return g;
			}


			function _continueSetup() {
				if (!angular.isDefined(_chartWrapper)) {
					_chartWrapper = new $google.visualization.ChartWrapper({
						chartType: _chartType,
						dataTable: _data,
						view: _view,
						options: _options,
						containerId: _element[0]
					});
					_registerListenersWithGoogle(_chartWrapper, wrapperListeners);
				}
				else {
					_chartWrapper.setChartType(_chartType);
					_chartWrapper.setDataTable(_data);
					_chartWrapper.setView(_view);
					_chartWrapper.setOptions(_options);
				}

				if (!_formatManager) {
					_formatManager = new FormatManager($google);
				}

				if (_formatManager.applyFormats(_chartWrapper.getDataTable(),
					_formatters, _customFormatters).requiresHtml) {
					_chartWrapper.setOption('allowHtml', true);
				}

				_needsUpdate = false;
			}

			// Credit for this solution:
			// http://stackoverflow.com/a/20125572/3771976
			function _getSetDescendantProp(obj, desc, value) {
				var arr = desc ? desc.split(".") : [];

				while (arr.length && obj) {
					var comp = arr.shift();
					var match = new RegExp("(.+)\\[([0-9]*)\\]").exec(comp);

					if (value) {
						if (obj[comp] === undefined) {
							obj[comp] = {};
						}

						if (arr.length === 0) {
							obj[comp] = value;
						}
					}

					obj = obj[comp];
				}

				return obj;
			}

			function _handleReady() {
				// When the chartWrapper is ready, check to see if the inner chart
				// has changed. If it has, re-register listeners onto that chart.
				if (_innerVisualization !== _chartWrapper.getChart()) {
					_innerVisualization = _chartWrapper.getChart();
					_registerListenersWithGoogle(_innerVisualization, chartListeners);
				}
			}

			function _init() {
				_apiReady = false;
				_serviceDeferred = $q.defer();
				//keeps the resulting promise to chain on other actions
				_libraryPromise = agcLibraryLoader
					.then(_apiLoadSuccess)
					.catch(_apiLoadFail);

				registerWrapperListener('ready', _handleReady, self);
			}

			function _registerListener(listenerCollection, eventName, listenerFn, listenerObject) {
				// This is the function that will be invoked by the charts API.
				// Passing the wrapper function allows the use of DI for
				// for the called function.
				var listenerWrapper = function () {
					var locals = {
						chartWrapper: _chartWrapper,
						chart: _chartWrapper.getChart(),
						args: arguments
					};
					$injector.invoke(listenerFn, listenerObject || this, locals);
				};

				if (angular.isDefined(listenerCollection) && angular.isObject(listenerCollection)) {
					if (!angular.isArray(listenerCollection[eventName])) {
						listenerCollection[eventName] = [];
					}
					listenerCollection[eventName].push(listenerWrapper);
					return function () {
						if (angular.isDefined(listenerWrapper.googleListenerHandle)) {
							$google.visualization.events.removeListener(listenerWrapper.googleListenerHandle);
						}
						var fnIndex = listenerCollection[eventName].indexOf(listenerWrapper);
						listenerCollection[eventName].splice(fnIndex, 1);
						if (listenerCollection[eventName].length === 0) {
							listenerCollection[eventName] = undefined;
						}
					};
				}
			}

			function _registerListenersWithGoogle(eventSource, listenerCollection) {
				for (var eventName in listenerCollection) {
					if (listenerCollection.hasOwnProperty(eventName) && angular.isArray(listenerCollection[eventName])) {
						for (var fnIterator = 0; fnIterator < listenerCollection[eventName].length; fnIterator++) {
							if (angular.isFunction(listenerCollection[eventName][fnIterator])) {
								listenerCollection[eventName][fnIterator].googleListenerHandle =
									$google.visualization.events.addListener(eventSource, eventName, listenerCollection[eventName][fnIterator]);
							}
						}
					}
				}
			}

			function _runDrawCycle() {
				_activateServiceEvent('beforeDraw');
				_chartWrapper.draw();
			}

            /*
            This function does this:
                - waits for API to load, if not already loaded
                - sets up ChartWrapper object (create or update)
                - schedules timeout event to draw chart
            */
			function draw() {
				if (_needsUpdate) {
					_libraryPromise = _libraryPromise.then(_continueSetup);
				}
				_libraryPromise = _libraryPromise.then(_runDrawCycle());
			}

			function getChartWrapper() {
				// Most get functions on this interface return copies,
				// this one should return reference so as to expose the 
				//chart api to users
				return _chartWrapper;
			}

			function getData() {
				var data = _data || {};
				return angular.copy(data);
			}

			function getElement() {
				return _element;
			}

			function getOption(name) {
				var options = _options || {};
				return _getSetDescendantProp(options, name);
			}

			function getOptions() {
				var options = _options || {};
				return angular.copy(options);
			}

			function getReadyPromise() {
				return _serviceDeferred.promise;
			}

			function getView() {
				var view = _view || {};
				return angular.copy(view);
			}

			function isApiReady() {
				return _apiReady;
			}

			function registerChartListener(eventName, listenerFn, listenerObject) {
				return _registerListener(chartListeners, eventName, listenerFn, listenerObject);
			}

			function registerServiceListener(eventName, listenerFn, listenerObject) {
				return _registerListener(serviceListeners, eventName, listenerFn, listenerObject);
			}

			function registerWrapperListener(eventName, listenerFn, listenerObject) {
				return _registerListener(wrapperListeners, eventName, listenerFn, listenerObject);
			}

			function setData(data) {
				if (angular.isDefined(data)) {
					_data = angular.copy(data);
					_needsUpdate = true;
				}
			}

			function setElement(element) {
				if (angular.isElement(element) && _element !== element) {
					_element = element;
					// clear out the chartWrapper because we're going to need a new one
					_chartWrapper = null;
					_needsUpdate = true;
				}
			}

			function setOption(name, value) {
				_options = _options || {};
				_getSetDescendantProp(_options, name, angular.copy(value));
				_needsUpdate = true;
			}

			function setOptions(options) {
				if (angular.isDefined(options)) {
					_options = angular.copy(options);
					_needsUpdate = true;
				}
			}

			function setup(element, chartType, data, view, options, formatters, customFormatters) {
				// Keep values if already set,
				// can call setup() with nulls to keep
				// existing values
				_element = element || _element;
				_chartType = chartType || _chartType;
				_data = data || _data;
				_view = view || _view;
				_options = options || _options;
				_formatters = formatters || _formatters;
				_customFormatters = customFormatters || _customFormatters;

				_libraryPromise = _libraryPromise.then(_continueSetup);
			}

			function setView(view) {
				_view = angular.copy(view);
			}
		}
		return GoogleChartService;
	}
})();
/*
 * Toastr
 * Copyright 2012-2015
 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
 * All Rights Reserved.
 * Use, reproduction, distribution, and modification of this code is subject to the terms and
 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
 *
 * ARIA Support: Greta Krafsig
 *
 * Project: https://github.com/CodeSeven/toastr
 */
/* global define */
(function (define) {
    define(['jquery'], function ($) {
        return (function () {
            var $container;
            var listener;
            var toastId = 0;
            var toastType = {
                error: 'error',
                info: 'info',
                success: 'success',
                warning: 'warning'
            };

            var toastr = {
                clear: clear,
                remove: remove,
                error: error,
                getContainer: getContainer,
                info: info,
                options: {},
                subscribe: subscribe,
                success: success,
                version: '2.1.3',
                warning: warning
            };

            var previousToast;

            return toastr;

            ////////////////

            function error(message, title, optionsOverride) {
                return notify({
                    type: toastType.error,
                    iconClass: getOptions().iconClasses.error,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title || getOptions().errorTitle
                });
            }

            function getContainer(options, create) {
                if (!options) { options = getOptions(); }
                $container = $('#' + options.containerId);
                if ($container.length) {
                    return $container;
                }
                if (create) {
                    $container = createContainer(options);
                }
                return $container;
            }

            function info(message, title, optionsOverride) {
                return notify({
                    type: toastType.info,
                    iconClass: getOptions().iconClasses.info,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title || getOptions().infoTitle
                });
            }

            function subscribe(callback) {
                listener = callback;
            }

            function success(message, title, optionsOverride) {
                return notify({
                    type: toastType.success,
                    iconClass: getOptions().iconClasses.success,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title || getOptions().successTitle
                });
            }

            function warning(message, title, optionsOverride) {
                return notify({
                    type: toastType.warning,
                    iconClass: getOptions().iconClasses.warning,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title || getOptions().warningTitle
                });
            }

            function clear($toastElement, clearOptions) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if (!clearToast($toastElement, options, clearOptions)) {
                    clearContainer(options);
                }
            }

            function remove($toastElement) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if ($toastElement && $(':focus', $toastElement).length === 0) {
                    removeToast($toastElement);
                    return;
                }
                if ($container.children().length) {
                    $container.remove();
                }
            }

            // internal functions

            function clearContainer (options) {
                var toastsToClear = $container.children();
                for (var i = toastsToClear.length - 1; i >= 0; i--) {
                    clearToast($(toastsToClear[i]), options);
                }
            }

            function clearToast ($toastElement, options, clearOptions) {
                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
                    $toastElement[options.hideMethod]({
                        duration: options.hideDuration,
                        easing: options.hideEasing,
                        complete: function () { removeToast($toastElement); }
                    });
                    return true;
                }
                return false;
            }

            function createContainer(options) {
                $container = $('<div/>')
                    .attr('id', options.containerId)
                    .addClass(options.positionClass);

                $container.appendTo($(options.target));
                return $container;
            }

            function getDefaults() {
                return {
                    tapToDismiss: true,
                    toastClass: 'toast',
                    containerId: 'toast-container',
                    debug: false,

                    showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
                    showDuration: 300,
                    showEasing: 'swing', //swing and linear are built into jQuery
                    onShown: undefined,
                    hideMethod: 'fadeOut',
                    hideDuration: 1000,
                    hideEasing: 'swing',
                    onHidden: undefined,
                    closeMethod: false,
                    closeDuration: false,
                    closeEasing: false,
                    closeOnHover: true,
                    successTitle: undefined,
                    errorTitle: undefined,
                    warningTitle: undefined,
                    infoTitle: undefined,
                    extendedTimeOut: 1000,
                    iconClasses: {
                        error: 'toast-error',
                        info: 'toast-info',
                        success: 'toast-success',
                        warning: 'toast-warning'
                    },
                    iconClass: 'toast-info',
                    positionClass: 'toast-top-right',
                    timeOut: 5000, // Set timeOut and extendedTimeOut to 0 to make it sticky
                    titleClass: 'toast-title',
                    messageClass: 'toast-message',
                    escapeHtml: false,
                    target: 'body',
                    closeHtml: '<span>&times;</span>',
                    closeClass: 'toast-close-button',
                    newestOnTop: true,
                    preventDuplicates: false,
                    progressBar: false,
                    progressClass: 'toast-progress',
                    rtl: false
                };
            }

            function publish(args) {
                if (!listener) { return; }
                listener(args);
            }

            function notify(map) {
                var options = getOptions();
                var iconClass = map.iconClass || options.iconClass;

                if (typeof (map.optionsOverride) !== 'undefined') {
                    options = $.extend(options, map.optionsOverride);
                    iconClass = map.optionsOverride.iconClass || iconClass;
                }

                if (shouldExit(options, map)) { return; }

                toastId++;

                $container = getContainer(options, true);

                var intervalId = null;
                var $toastElement = $('<div/>');
                var $titleElement = $('<div/>');
                var $messageElement = $('<div/>');
                var $progressElement = $('<div/>');
                var $closeElement = $(options.closeHtml);
                var progressBar = {
                    intervalId: null,
                    hideEta: null,
                    maxHideTime: null
                };
                var response = {
                    toastId: toastId,
                    state: 'visible',
                    startTime: new Date(),
                    options: options,
                    map: map
                };

                personalizeToast();

                displayToast();

                handleEvents();

                publish(response);

                if (options.debug && console) {
                    console.log(response);
                }

                return $toastElement;

                function escapeHtml(source) {
                    if (source == null) {
                        source = '';
                    }

                    return source
                        .replace(/&/g, '&amp;')
                        .replace(/"/g, '&quot;')
                        .replace(/'/g, '&#39;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;');
                }

                function personalizeToast() {
                    setIcon();
                    setTitle();
                    setMessage();
                    setCloseButton();
                    setProgressBar();
                    setRTL();
                    setSequence();
                    setAria();
                }

                function setAria() {
                    var ariaValue = '';
                    switch (map.iconClass) {
                        case 'toast-success':
                        case 'toast-info':
                            ariaValue =  'polite';
                            break;
                        default:
                            ariaValue = 'assertive';
                    }
                    $toastElement.attr('aria-live', ariaValue);
                }

                function handleEvents() {
                    if (options.closeOnHover) {
                        $toastElement.hover(stickAround, delayedHideToast);
                    }

                    if (!options.onclick && options.tapToDismiss) {
                        $toastElement.click(hideToast);
                    }

                    if (options.closeButton && $closeElement) {
                        $closeElement.click(function (event) {
                            if (event.stopPropagation) {
                                event.stopPropagation();
                            } else if (event.cancelBubble !== undefined && event.cancelBubble !== true) {
                                event.cancelBubble = true;
                            }

                            if (options.onCloseClick) {
                                options.onCloseClick(event);
                            }

                            hideToast(true);
                        });
                    }

                    if (options.onclick) {
                        $toastElement.click(function (event) {
                            options.onclick(event);
                            hideToast();
                        });
                    }
                }

                function displayToast() {
                    $toastElement.hide();

                    $toastElement[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing, complete: options.onShown}
                    );

                    if (options.timeOut > 0) {
                        intervalId = setTimeout(hideToast, options.timeOut);
                        progressBar.maxHideTime = parseFloat(options.timeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                        if (options.progressBar) {
                            progressBar.intervalId = setInterval(updateProgress, 10);
                        }
                    }
                }

                function setIcon() {
                    if (map.iconClass) {
                        $toastElement.addClass(options.toastClass).addClass(iconClass);
                    }
                }

                function setSequence() {
                    if (options.newestOnTop) {
                        $container.prepend($toastElement);
                    } else {
                        $container.append($toastElement);
                    }
                }

                function setTitle() {
                    if (map.title) {
                        var suffix = map.title;
                        if (options.escapeHtml) {
                            suffix = escapeHtml(map.title);
                        }
                        $titleElement.append(suffix).addClass(options.titleClass);
                        $toastElement.append($titleElement);
                    }
                }

                function setMessage() {
                    if (map.message) {
                        var suffix = map.message;
                        if (options.escapeHtml) {
                            suffix = escapeHtml(map.message);
                        }
                        $messageElement.append(suffix).addClass(options.messageClass);
                        $toastElement.append($messageElement);
                    }
                }

                function setCloseButton() {
                    if (options.closeButton) {
                        $closeElement.addClass(options.closeClass).attr('role', 'button');
                        $toastElement.prepend($closeElement);
                    }
                }

                function setProgressBar() {
                    if (options.progressBar) {
                        $progressElement.addClass(options.progressClass);
                        $toastElement.prepend($progressElement);
                    }
                }

                function setRTL() {
                    if (options.rtl) {
                        $toastElement.addClass('rtl');
                    }
                }

                function shouldExit(options, map) {
                    if (options.preventDuplicates) {
                        if (map.message === previousToast) {
                            return true;
                        } else {
                            previousToast = map.message;
                        }
                    }
                    return false;
                }

                function hideToast(override) {
                    var method = override && options.closeMethod !== false ? options.closeMethod : options.hideMethod;
                    var duration = override && options.closeDuration !== false ?
                        options.closeDuration : options.hideDuration;
                    var easing = override && options.closeEasing !== false ? options.closeEasing : options.hideEasing;
                    if ($(':focus', $toastElement).length && !override) {
                        return;
                    }
                    clearTimeout(progressBar.intervalId);
                    return $toastElement[method]({
                        duration: duration,
                        easing: easing,
                        complete: function () {
                            removeToast($toastElement);
                            clearTimeout(intervalId);
                            if (options.onHidden && response.state !== 'hidden') {
                                options.onHidden();
                            }
                            response.state = 'hidden';
                            response.endTime = new Date();
                            publish(response);
                        }
                    });
                }

                function delayedHideToast() {
                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                    }
                }

                function stickAround() {
                    clearTimeout(intervalId);
                    progressBar.hideEta = 0;
                    $toastElement.stop(true, true)[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing}
                    );
                }

                function updateProgress() {
                    var percentage = ((progressBar.hideEta - (new Date().getTime())) / progressBar.maxHideTime) * 100;
                    $progressElement.width(percentage + '%');
                }
            }

            function getOptions() {
                return $.extend({}, getDefaults(), toastr.options);
            }

            function removeToast($toastElement) {
                if (!$container) { $container = getContainer(); }
                if ($toastElement.is(':visible')) {
                    return;
                }
                $toastElement.remove();
                $toastElement = null;
                if ($container.children().length === 0) {
                    $container.remove();
                    previousToast = undefined;
                }
            }

        })();
    });
}(typeof define === 'function' && define.amd ? define : function (deps, factory) {
    if (typeof module !== 'undefined' && module.exports && typeof require === 'function') { //Node
        module.exports = factory(require('jquery'));
    } else {
        window.toastr = factory(window.jQuery);
    }
}));

/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 2.1.3 - 2016-08-25
 * License: MIT
 */angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse","ui.bootstrap.tabindex","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.isClass","ui.bootstrap.datepicker","ui.bootstrap.position","ui.bootstrap.datepickerPopup","ui.bootstrap.debounce","ui.bootstrap.dropdown","ui.bootstrap.stackedMap","ui.bootstrap.modal","ui.bootstrap.paging","ui.bootstrap.pager","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);
angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html","uib/template/accordion/accordion.html","uib/template/alert/alert.html","uib/template/carousel/carousel.html","uib/template/carousel/slide.html","uib/template/datepicker/datepicker.html","uib/template/datepicker/day.html","uib/template/datepicker/month.html","uib/template/datepicker/year.html","uib/template/datepickerPopup/popup.html","uib/template/modal/window.html","uib/template/pager/pager.html","uib/template/pagination/pagination.html","uib/template/tooltip/tooltip-html-popup.html","uib/template/tooltip/tooltip-popup.html","uib/template/tooltip/tooltip-template-popup.html","uib/template/popover/popover-html.html","uib/template/popover/popover-template.html","uib/template/popover/popover.html","uib/template/progressbar/bar.html","uib/template/progressbar/progress.html","uib/template/progressbar/progressbar.html","uib/template/rating/rating.html","uib/template/tabs/tab.html","uib/template/tabs/tabset.html","uib/template/timepicker/timepicker.html","uib/template/typeahead/typeahead-match.html","uib/template/typeahead/typeahead-popup.html"]);
angular.module('ui.bootstrap.collapse', [])

  .directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function($animate, $q, $parse, $injector) {
    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
    return {
      link: function(scope, element, attrs) {
        var expandingExpr = $parse(attrs.expanding),
          expandedExpr = $parse(attrs.expanded),
          collapsingExpr = $parse(attrs.collapsing),
          collapsedExpr = $parse(attrs.collapsed),
          horizontal = false,
          css = {},
          cssTo = {};

        init();

        function init() {
          horizontal = !!('horizontal' in attrs);
          if (horizontal) {
            css = {
              width: ''
            };
            cssTo = {width: '0'};
          } else {
            css = {
              height: ''
            };
            cssTo = {height: '0'};
          }
          if (!scope.$eval(attrs.uibCollapse)) {
            element.addClass('in')
              .addClass('collapse')
              .attr('aria-expanded', true)
              .attr('aria-hidden', false)
              .css(css);
          }
        }

        function getScrollFromElement(element) {
          if (horizontal) {
            return {width: element.scrollWidth + 'px'};
          }
          return {height: element.scrollHeight + 'px'};
        }

        function expand() {
          if (element.hasClass('collapse') && element.hasClass('in')) {
            return;
          }

          $q.resolve(expandingExpr(scope))
            .then(function() {
              element.removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', true)
                .attr('aria-hidden', false);

              if ($animateCss) {
                $animateCss(element, {
                  addClass: 'in',
                  easing: 'ease',
                  css: {
                    overflow: 'hidden'
                  },
                  to: getScrollFromElement(element[0])
                }).start()['finally'](expandDone);
              } else {
                $animate.addClass(element, 'in', {
                  css: {
                    overflow: 'hidden'
                  },
                  to: getScrollFromElement(element[0])
                }).then(expandDone);
              }
            });
        }

        function expandDone() {
          element.removeClass('collapsing')
            .addClass('collapse')
            .css(css);
          expandedExpr(scope);
        }

        function collapse() {
          if (!element.hasClass('collapse') && !element.hasClass('in')) {
            return collapseDone();
          }

          $q.resolve(collapsingExpr(scope))
            .then(function() {
              element
              // IMPORTANT: The width must be set before adding "collapsing" class.
              // Otherwise, the browser attempts to animate from width 0 (in
              // collapsing class) to the given width here.
                .css(getScrollFromElement(element[0]))
                // initially all panel collapse have the collapse class, this removal
                // prevents the animation from jumping to collapsed state
                .removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', false)
                .attr('aria-hidden', true);

              if ($animateCss) {
                $animateCss(element, {
                  removeClass: 'in',
                  to: cssTo
                }).start()['finally'](collapseDone);
              } else {
                $animate.removeClass(element, 'in', {
                  to: cssTo
                }).then(collapseDone);
              }
            });
        }

        function collapseDone() {
          element.css(cssTo); // Required so that collapse works when animation is disabled
          element.removeClass('collapsing')
            .addClass('collapse');
          collapsedExpr(scope);
        }

        scope.$watch(attrs.uibCollapse, function(shouldCollapse) {
          if (shouldCollapse) {
            collapse();
          } else {
            expand();
          }
        });
      }
    };
  }]);

angular.module('ui.bootstrap.tabindex', [])

.directive('uibTabindexToggle', function() {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      attrs.$observe('disabled', function(disabled) {
        attrs.$set('tabindex', disabled ? -1 : null);
      });
    }
  };
});

angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex'])

.constant('uibAccordionConfig', {
  closeOthers: true
})

.controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function($scope, $attrs, accordionConfig) {
  // This array keeps track of the accordion groups
  this.groups = [];

  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
  this.closeOthers = function(openGroup) {
    var closeOthers = angular.isDefined($attrs.closeOthers) ?
      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
    if (closeOthers) {
      angular.forEach(this.groups, function(group) {
        if (group !== openGroup) {
          group.isOpen = false;
        }
      });
    }
  };

  // This is called from the accordion-group directive to add itself to the accordion
  this.addGroup = function(groupScope) {
    var that = this;
    this.groups.push(groupScope);

    groupScope.$on('$destroy', function(event) {
      that.removeGroup(groupScope);
    });
  };

  // This is called from the accordion-group directive when to remove itself
  this.removeGroup = function(group) {
    var index = this.groups.indexOf(group);
    if (index !== -1) {
      this.groups.splice(index, 1);
    }
  };
}])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
.directive('uibAccordion', function() {
  return {
    controller: 'UibAccordionController',
    controllerAs: 'accordion',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion.html';
    }
  };
})

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
.directive('uibAccordionGroup', function() {
  return {
    require: '^uibAccordion',         // We need this directive to be inside an accordion
    transclude: true,              // It transcludes the contents of the directive into the template
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
    },
    scope: {
      heading: '@',               // Interpolate the heading attribute onto this scope
      panelClass: '@?',           // Ditto with panelClass
      isOpen: '=?',
      isDisabled: '=?',
      groupSummary: '@?',
      report: '=?',
      summaryArrayName: '@?'
    },
    controller: function() {
      this.setHeading = function(element) {
        this.heading = element;
      };
    },
    link: function(scope, element, attrs, accordionCtrl) {
      element.addClass('panel');
      accordionCtrl.addGroup(scope);
      
      scope.openClass = attrs.openClass || 'panel-open';
      scope.panelClass = attrs.panelClass || 'panel-default';
      scope.$watch('isOpen', function(value) {
        element.toggleClass(scope.openClass, !!value);
        if (value) {
          accordionCtrl.closeOthers(scope);
        }
      });

      scope.toggleOpen = function($event) {
        if (!scope.isDisabled) {
          if (!$event || $event.which === 32) {
            scope.isOpen = !scope.isOpen;
          }
        }
      };

      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
      scope.headingId = id + '-tab';
      scope.panelId = id + '-panel';
    }
  };
})

// Use accordion-heading below an accordion-group to provide a heading containing HTML
.directive('uibAccordionHeading', function() {
  return {
    transclude: true,   // Grab the contents to be used as the heading
    template: '',       // In effect remove this element!
    replace: true,
    require: '^uibAccordionGroup',
    link: function(scope, element, attrs, accordionGroupCtrl, transclude) {
      // Pass the heading to the accordion-group controller
      // so that it can be transcluded into the right place in the template
      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
    }
  };
})

// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
.directive('uibAccordionTransclude', function() {
  return {
    require: '^uibAccordionGroup',
    link: function(scope, element, attrs, controller) {
      scope.$watch(function() { return controller[attrs.uibAccordionTransclude]; }, function(heading) {
        if (heading) {
          var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
          elem.html('');
          elem.append(heading);
        }
      });
    }
  };

  function getHeaderSelectors() {
      return 'uib-accordion-header,' +
          'data-uib-accordion-header,' +
          'x-uib-accordion-header,' +
          'uib\\:accordion-header,' +
          '[uib-accordion-header],' +
          '[data-uib-accordion-header],' +
          '[x-uib-accordion-header]';
  }
});

angular.module('ui.bootstrap.alert', [])

.controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function($scope, $element, $attrs, $interpolate, $timeout) {
  $scope.closeable = !!$attrs.close;
  $element.addClass('alert');
  $attrs.$set('role', 'alert');
  if ($scope.closeable) {
    $element.addClass('alert-dismissible');
  }

  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
    $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;

  if (dismissOnTimeout) {
    $timeout(function() {
      $scope.close();
    }, parseInt(dismissOnTimeout, 10));
  }
}])

.directive('uibAlert', function() {
  return {
    controller: 'UibAlertController',
    controllerAs: 'alert',
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/alert/alert.html';
    },
    transclude: true,
    scope: {
      close: '&'
    }
  };
});

angular.module('ui.bootstrap.buttons', [])

.constant('uibButtonConfig', {
  activeClass: 'active',
  toggleEvent: 'click'
})

.controller('UibButtonsController', ['uibButtonConfig', function(buttonConfig) {
  this.activeClass = buttonConfig.activeClass || 'active';
  this.toggleEvent = buttonConfig.toggleEvent || 'click';
}])

.directive('uibBtnRadio', ['$parse', function($parse) {
  return {
    require: ['uibBtnRadio', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'buttons',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
      var uncheckableExpr = $parse(attrs.uibUncheckable);

      element.find('input').css({display: 'none'});

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        var isActive = element.hasClass(buttonsCtrl.activeClass);

        if (!isActive || angular.isDefined(attrs.uncheckable)) {
          scope.$apply(function() {
            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
            ngModelCtrl.$render();
          });
        }
      });

      if (attrs.uibUncheckable) {
        scope.$watch(uncheckableExpr, function(uncheckable) {
          attrs.$set('uncheckable', uncheckable ? '' : undefined);
        });
      }
    }
  };
}])

.directive('uibBtnCheckbox', function() {
  return {
    require: ['uibBtnCheckbox', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'button',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      element.find('input').css({display: 'none'});

      function getTrueValue() {
        return getCheckboxValue(attrs.btnCheckboxTrue, true);
      }

      function getFalseValue() {
        return getCheckboxValue(attrs.btnCheckboxFalse, false);
      }

      function getCheckboxValue(attribute, defaultValue) {
        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
      }

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        scope.$apply(function() {
          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
          ngModelCtrl.$render();
        });
      });
    }
  };
});

angular.module('ui.bootstrap.carousel', [])

.controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function($scope, $element, $interval, $timeout, $animate) {
  var self = this,
    slides = self.slides = $scope.slides = [],
    SLIDE_DIRECTION = 'uib-slideDirection',
    currentIndex = $scope.active,
    currentInterval, isPlaying, bufferedTransitions = [];

  var destroyed = false;
  $element.addClass('carousel');

  self.addSlide = function(slide, element) {
    slides.push({
      slide: slide,
      element: element
    });
    slides.sort(function(a, b) {
      return +a.slide.index - +b.slide.index;
    });
    //if this is the first slide or the slide is set to active, select it
    if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
      if ($scope.$currentTransition) {
        $scope.$currentTransition = null;
      }

      currentIndex = slide.index;
      $scope.active = slide.index;
      setActive(currentIndex);
      self.select(slides[findSlideIndex(slide)]);
      if (slides.length === 1) {
        $scope.play();
      }
    }
  };

  self.getCurrentIndex = function() {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].slide.index === currentIndex) {
        return i;
      }
    }
  };

  self.next = $scope.next = function() {
    var newIndex = (self.getCurrentIndex() + 1) % slides.length;

    if (newIndex === 0 && $scope.noWrap()) {
      $scope.pause();
      return;
    }

    return self.select(slides[newIndex], 'next');
  };

  self.prev = $scope.prev = function() {
    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;

    if ($scope.noWrap() && newIndex === slides.length - 1) {
      $scope.pause();
      return;
    }

    return self.select(slides[newIndex], 'prev');
  };

  self.removeSlide = function(slide) {
    var index = findSlideIndex(slide);

    var bufferedIndex = bufferedTransitions.indexOf(slides[index]);
    if (bufferedIndex !== -1) {
      bufferedTransitions.splice(bufferedIndex, 1);
    }

    //get the index of the slide inside the carousel
    slides.splice(index, 1);
    if (slides.length > 0 && currentIndex === index) {
      if (index >= slides.length) {
        currentIndex = slides.length - 1;
        $scope.active = currentIndex;
        setActive(currentIndex);
        self.select(slides[slides.length - 1]);
      } else {
        currentIndex = index;
        $scope.active = currentIndex;
        setActive(currentIndex);
        self.select(slides[index]);
      }
    } else if (currentIndex > index) {
      currentIndex--;
      $scope.active = currentIndex;
    }

    //clean the active value when no more slide
    if (slides.length === 0) {
      currentIndex = null;
      $scope.active = null;
      clearBufferedTransitions();
    }
  };

  /* direction: "prev" or "next" */
  self.select = $scope.select = function(nextSlide, direction) {
    var nextIndex = findSlideIndex(nextSlide.slide);
    //Decide direction if it's not given
    if (direction === undefined) {
      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
    }
    //Prevent this user-triggered transition from occurring if there is already one in progress
    if (nextSlide.slide.index !== currentIndex &&
      !$scope.$currentTransition) {
      goNext(nextSlide.slide, nextIndex, direction);
    } else if (nextSlide && nextSlide.slide.index !== currentIndex && $scope.$currentTransition) {
      bufferedTransitions.push(slides[nextIndex]);
    }
  };

  /* Allow outside people to call indexOf on slides array */
  $scope.indexOfSlide = function(slide) {
    return +slide.slide.index;
  };

  $scope.isActive = function(slide) {
    return $scope.active === slide.slide.index;
  };

  $scope.isPrevDisabled = function() {
    return $scope.active === 0 && $scope.noWrap();
  };

  $scope.isNextDisabled = function() {
    return $scope.active === slides.length - 1 && $scope.noWrap();
  };

  $scope.pause = function() {
    if (!$scope.noPause) {
      isPlaying = false;
      resetTimer();
    }
  };

  $scope.play = function() {
    if (!isPlaying) {
      isPlaying = true;
      restartTimer();
    }
  };

  $element.on('mouseenter', $scope.pause);
  $element.on('mouseleave', $scope.play);

  $scope.$on('$destroy', function() {
    destroyed = true;
    resetTimer();
  });

  $scope.$watch('noTransition', function(noTransition) {
    $animate.enabled($element, !noTransition);
  });

  $scope.$watch('interval', restartTimer);

  $scope.$watchCollection('slides', resetTransition);

  $scope.$watch('active', function(index) {
    if (angular.isNumber(index) && currentIndex !== index) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].slide.index === index) {
          index = i;
          break;
        }
      }

      var slide = slides[index];
      if (slide) {
        setActive(index);
        self.select(slides[index]);
        currentIndex = index;
      }
    }
  });

  function clearBufferedTransitions() {
    while (bufferedTransitions.length) {
      bufferedTransitions.shift();
    }
  }

  function getSlideByIndex(index) {
    for (var i = 0, l = slides.length; i < l; ++i) {
      if (slides[i].index === index) {
        return slides[i];
      }
    }
  }

  function setActive(index) {
    for (var i = 0; i < slides.length; i++) {
      slides[i].slide.active = i === index;
    }
  }

  function goNext(slide, index, direction) {
    if (destroyed) {
      return;
    }

    angular.extend(slide, {direction: direction});
    angular.extend(slides[currentIndex].slide || {}, {direction: direction});
    if ($animate.enabled($element) && !$scope.$currentTransition &&
      slides[index].element && self.slides.length > 1) {
      slides[index].element.data(SLIDE_DIRECTION, slide.direction);
      var currentIdx = self.getCurrentIndex();

      if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
        slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
      }

      $scope.$currentTransition = true;
      $animate.on('addClass', slides[index].element, function(element, phase) {
        if (phase === 'close') {
          $scope.$currentTransition = null;
          $animate.off('addClass', element);
          if (bufferedTransitions.length) {
            var nextSlide = bufferedTransitions.pop().slide;
            var nextIndex = nextSlide.index;
            var nextDirection = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
            clearBufferedTransitions();

            goNext(nextSlide, nextIndex, nextDirection);
          }
        }
      });
    }

    $scope.active = slide.index;
    currentIndex = slide.index;
    setActive(index);

    //every time you change slides, reset the timer
    restartTimer();
  }

  function findSlideIndex(slide) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].slide === slide) {
        return i;
      }
    }
  }

  function resetTimer() {
    if (currentInterval) {
      $interval.cancel(currentInterval);
      currentInterval = null;
    }
  }

  function resetTransition(slides) {
    if (!slides.length) {
      $scope.$currentTransition = null;
      clearBufferedTransitions();
    }
  }

  function restartTimer() {
    resetTimer();
    var interval = +$scope.interval;
    if (!isNaN(interval) && interval > 0) {
      currentInterval = $interval(timerFn, interval);
    }
  }

  function timerFn() {
    var interval = +$scope.interval;
    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
      $scope.next();
    } else {
      $scope.pause();
    }
  }
}])

.directive('uibCarousel', function() {
  return {
    transclude: true,
    controller: 'UibCarouselController',
    controllerAs: 'carousel',
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/carousel.html';
    },
    scope: {
      active: '=',
      interval: '=',
      noTransition: '=',
      noPause: '=',
      noWrap: '&'
    }
  };
})

.directive('uibSlide', ['$animate', function($animate) {
  return {
    require: '^uibCarousel',
    restrict: 'A',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/slide.html';
    },
    scope: {
      actual: '=?',
      index: '=?'
    },
    link: function (scope, element, attrs, carouselCtrl) {
      element.addClass('item');
      carouselCtrl.addSlide(scope, element);
      //when the scope is destroyed then remove the slide from the current slides array
      scope.$on('$destroy', function() {
        carouselCtrl.removeSlide(scope);
      });

      scope.$watch('active', function(active) {
        $animate[active ? 'addClass' : 'removeClass'](element, 'active');
      });
    }
  };
}])

.animation('.item', ['$animateCss',
function($animateCss) {
  var SLIDE_DIRECTION = 'uib-slideDirection';

  function removeClass(element, className, callback) {
    element.removeClass(className);
    if (callback) {
      callback();
    }
  }

  return {
    beforeAddClass: function(element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element,
          directionClass + ' ' + direction, done);
        element.addClass(direction);

        $animateCss(element, {addClass: directionClass})
          .start()
          .done(removeClassFn);

        return function() {
          stopped = true;
        };
      }
      done();
    },
    beforeRemoveClass: function (element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element, directionClass, done);

        $animateCss(element, {addClass: directionClass})
          .start()
          .done(removeClassFn);

        return function() {
          stopped = true;
        };
      }
      done();
    }
  };
}]);

angular.module('ui.bootstrap.dateparser', [])

.service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', function($log, $locale, dateFilter, orderByFilter) {
  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

  var localeId;
  var formatCodeToRegex;

  this.init = function() {
    localeId = $locale.id;

    this.parsers = {};
    this.formatters = {};

    formatCodeToRegex = [
      {
        key: 'yyyy',
        regex: '\\d{4}',
        apply: function(value) { this.year = +value; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'yyyy');
        }
      },
      {
        key: 'yy',
        regex: '\\d{2}',
        apply: function(value) { value = +value; this.year = value < 69 ? value + 2000 : value + 1900; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'yy');
        }
      },
      {
        key: 'y',
        regex: '\\d{1,4}',
        apply: function(value) { this.year = +value; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'y');
        }
      },
      {
        key: 'M!',
        regex: '0?[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) {
          var value = date.getMonth();
          if (/^[0-9]$/.test(value)) {
            return dateFilter(date, 'MM');
          }

          return dateFilter(date, 'M');
        }
      },
      {
        key: 'MMMM',
        regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'MMMM'); }
      },
      {
        key: 'MMM',
        regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'MMM'); }
      },
      {
        key: 'MM',
        regex: '0[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) { return dateFilter(date, 'MM'); }
      },
      {
        key: 'M',
        regex: '[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) { return dateFilter(date, 'M'); }
      },
      {
        key: 'd!',
        regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) {
          var value = date.getDate();
          if (/^[1-9]$/.test(value)) {
            return dateFilter(date, 'dd');
          }

          return dateFilter(date, 'd');
        }
      },
      {
        key: 'dd',
        regex: '[0-2][0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) { return dateFilter(date, 'dd'); }
      },
      {
        key: 'd',
        regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) { return dateFilter(date, 'd'); }
      },
      {
        key: 'EEEE',
        regex: $locale.DATETIME_FORMATS.DAY.join('|'),
        formatter: function(date) { return dateFilter(date, 'EEEE'); }
      },
      {
        key: 'EEE',
        regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
        formatter: function(date) { return dateFilter(date, 'EEE'); }
      },
      {
        key: 'HH',
        regex: '(?:0|1)[0-9]|2[0-3]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'HH'); }
      },
      {
        key: 'hh',
        regex: '0[0-9]|1[0-2]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'hh'); }
      },
      {
        key: 'H',
        regex: '1?[0-9]|2[0-3]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'H'); }
      },
      {
        key: 'h',
        regex: '[0-9]|1[0-2]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'h'); }
      },
      {
        key: 'mm',
        regex: '[0-5][0-9]',
        apply: function(value) { this.minutes = +value; },
        formatter: function(date) { return dateFilter(date, 'mm'); }
      },
      {
        key: 'm',
        regex: '[0-9]|[1-5][0-9]',
        apply: function(value) { this.minutes = +value; },
        formatter: function(date) { return dateFilter(date, 'm'); }
      },
      {
        key: 'sss',
        regex: '[0-9][0-9][0-9]',
        apply: function(value) { this.milliseconds = +value; },
        formatter: function(date) { return dateFilter(date, 'sss'); }
      },
      {
        key: 'ss',
        regex: '[0-5][0-9]',
        apply: function(value) { this.seconds = +value; },
        formatter: function(date) { return dateFilter(date, 'ss'); }
      },
      {
        key: 's',
        regex: '[0-9]|[1-5][0-9]',
        apply: function(value) { this.seconds = +value; },
        formatter: function(date) { return dateFilter(date, 's'); }
      },
      {
        key: 'a',
        regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
        apply: function(value) {
          if (this.hours === 12) {
            this.hours = 0;
          }

          if (value === 'PM') {
            this.hours += 12;
          }
        },
        formatter: function(date) { return dateFilter(date, 'a'); }
      },
      {
        key: 'Z',
        regex: '[+-]\\d{4}',
        apply: function(value) {
          var matches = value.match(/([+-])(\d{2})(\d{2})/),
            sign = matches[1],
            hours = matches[2],
            minutes = matches[3];
          this.hours += toInt(sign + hours);
          this.minutes += toInt(sign + minutes);
        },
        formatter: function(date) {
          return dateFilter(date, 'Z');
        }
      },
      {
        key: 'ww',
        regex: '[0-4][0-9]|5[0-3]',
        formatter: function(date) { return dateFilter(date, 'ww'); }
      },
      {
        key: 'w',
        regex: '[0-9]|[1-4][0-9]|5[0-3]',
        formatter: function(date) { return dateFilter(date, 'w'); }
      },
      {
        key: 'GGGG',
        regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
        formatter: function(date) { return dateFilter(date, 'GGGG'); }
      },
      {
        key: 'GGG',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'GGG'); }
      },
      {
        key: 'GG',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'GG'); }
      },
      {
        key: 'G',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'G'); }
      }
    ];
  };

  this.init();

  function createParser(format) {
    var map = [], regex = format.split('');

    // check for literal values
    var quoteIndex = format.indexOf('\'');
    if (quoteIndex > -1) {
      var inLiteral = false;
      format = format.split('');
      for (var i = quoteIndex; i < format.length; i++) {
        if (inLiteral) {
          if (format[i] === '\'') {
            if (i + 1 < format.length && format[i+1] === '\'') { // escaped single quote
              format[i+1] = '$';
              regex[i+1] = '';
            } else { // end of literal
              regex[i] = '';
              inLiteral = false;
            }
          }
          format[i] = '$';
        } else {
          if (format[i] === '\'') { // start of literal
            format[i] = '$';
            regex[i] = '';
            inLiteral = true;
          }
        }
      }

      format = format.join('');
    }

    angular.forEach(formatCodeToRegex, function(data) {
      var index = format.indexOf(data.key);

      if (index > -1) {
        format = format.split('');

        regex[index] = '(' + data.regex + ')';
        format[index] = '$'; // Custom symbol to define consumed part of format
        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
          regex[i] = '';
          format[i] = '$';
        }
        format = format.join('');

        map.push({
          index: index,
          key: data.key,
          apply: data.apply,
          matcher: data.regex
        });
      }
    });

    return {
      regex: new RegExp('^' + regex.join('') + '$'),
      map: orderByFilter(map, 'index')
    };
  }

  function createFormatter(format) {
    var formatters = [];
    var i = 0;
    var formatter, literalIdx;
    while (i < format.length) {
      if (angular.isNumber(literalIdx)) {
        if (format.charAt(i) === '\'') {
          if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
            formatters.push(constructLiteralFormatter(format, literalIdx, i));
            literalIdx = null;
          }
        } else if (i === format.length) {
          while (literalIdx < format.length) {
            formatter = constructFormatterFromIdx(format, literalIdx);
            formatters.push(formatter);
            literalIdx = formatter.endIdx;
          }
        }

        i++;
        continue;
      }

      if (format.charAt(i) === '\'') {
        literalIdx = i;
        i++;
        continue;
      }

      formatter = constructFormatterFromIdx(format, i);

      formatters.push(formatter.parser);
      i = formatter.endIdx;
    }

    return formatters;
  }

  function constructLiteralFormatter(format, literalIdx, endIdx) {
    return function() {
      return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
    };
  }

  function constructFormatterFromIdx(format, i) {
    var currentPosStr = format.substr(i);
    for (var j = 0; j < formatCodeToRegex.length; j++) {
      if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
        var data = formatCodeToRegex[j];
        return {
          endIdx: i + data.key.length,
          parser: data.formatter
        };
      }
    }

    return {
      endIdx: i + 1,
      parser: function() {
        return currentPosStr.charAt(0);
      }
    };
  }

  this.filter = function(date, format) {
    if (!angular.isDate(date) || isNaN(date) || !format) {
      return '';
    }

    format = $locale.DATETIME_FORMATS[format] || format;

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.formatters[format]) {
      this.formatters[format] = createFormatter(format);
    }

    var formatters = this.formatters[format];

    return formatters.reduce(function(str, formatter) {
      return str + formatter(date);
    }, '');
  };

  this.parse = function(input, format, baseDate) {
    if (!angular.isString(input) || !format) {
      return input;
    }

    format = $locale.DATETIME_FORMATS[format] || format;
    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.parsers[format]) {
      this.parsers[format] = createParser(format, 'apply');
    }

    var parser = this.parsers[format],
        regex = parser.regex,
        map = parser.map,
        results = input.match(regex),
        tzOffset = false;
    if (results && results.length) {
      var fields, dt;
      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
        fields = {
          year: baseDate.getFullYear(),
          month: baseDate.getMonth(),
          date: baseDate.getDate(),
          hours: baseDate.getHours(),
          minutes: baseDate.getMinutes(),
          seconds: baseDate.getSeconds(),
          milliseconds: baseDate.getMilliseconds()
        };
      } else {
        if (baseDate) {
          $log.warn('dateparser:', 'baseDate is not a valid date');
        }
        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
      }

      for (var i = 1, n = results.length; i < n; i++) {
        var mapper = map[i - 1];
        if (mapper.matcher === 'Z') {
          tzOffset = true;
        }

        if (mapper.apply) {
          mapper.apply.call(fields, results[i]);
        }
      }

      var datesetter = tzOffset ? Date.prototype.setUTCFullYear :
        Date.prototype.setFullYear;
      var timesetter = tzOffset ? Date.prototype.setUTCHours :
        Date.prototype.setHours;

      if (isValid(fields.year, fields.month, fields.date)) {
        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
          dt = new Date(baseDate);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours, fields.minutes,
            fields.seconds, fields.milliseconds);
        } else {
          dt = new Date(0);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours || 0, fields.minutes || 0,
            fields.seconds || 0, fields.milliseconds || 0);
        }
      }

      return dt;
    }
  };

  // Check if date is valid for specific month (and year for February).
  // Month: 0 = Jan, 1 = Feb, etc
  function isValid(year, month, date) {
    if (date < 1) {
      return false;
    }

    if (month === 1 && date > 28) {
      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
    }

    if (month === 3 || month === 5 || month === 8 || month === 10) {
      return date < 31;
    }

    return true;
  }

  function toInt(str) {
    return parseInt(str, 10);
  }

  this.toTimezone = toTimezone;
  this.fromTimezone = fromTimezone;
  this.timezoneToOffset = timezoneToOffset;
  this.addDateMinutes = addDateMinutes;
  this.convertTimezoneToLocal = convertTimezoneToLocal;

  function toTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
  }

  function fromTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
  }

  //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
  function timezoneToOffset(timezone, fallback) {
    timezone = timezone.replace(/:/g, '');
    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
  }

  function addDateMinutes(date, minutes) {
    date = new Date(date.getTime());
    date.setMinutes(date.getMinutes() + minutes);
    return date;
  }

  function convertTimezoneToLocal(date, timezone, reverse) {
    reverse = reverse ? -1 : 1;
    var dateTimezoneOffset = date.getTimezoneOffset();
    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
  }
}]);

// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
// at most one element.
angular.module('ui.bootstrap.isClass', [])
.directive('uibIsClass', [
         '$animate',
function ($animate) {
  //                    11111111          22222222
  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
  //                    11111111           22222222
  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;

  var dataPerTracked = {};

  return {
    restrict: 'A',
    compile: function(tElement, tAttrs) {
      var linkedScopes = [];
      var instances = [];
      var expToData = {};
      var lastActivated = null;
      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
      var onExp = onExpMatches[2];
      var expsStr = onExpMatches[1];
      var exps = expsStr.split(',');

      return linkFn;

      function linkFn(scope, element, attrs) {
        linkedScopes.push(scope);
        instances.push({
          scope: scope,
          element: element
        });

        exps.forEach(function(exp, k) {
          addForExp(exp, scope);
        });

        scope.$on('$destroy', removeScope);
      }

      function addForExp(exp, scope) {
        var matches = exp.match(IS_REGEXP);
        var clazz = scope.$eval(matches[1]);
        var compareWithExp = matches[2];
        var data = expToData[exp];
        if (!data) {
          var watchFn = function(compareWithVal) {
            var newActivated = null;
            instances.some(function(instance) {
              var thisVal = instance.scope.$eval(onExp);
              if (thisVal === compareWithVal) {
                newActivated = instance;
                return true;
              }
            });
            if (data.lastActivated !== newActivated) {
              if (data.lastActivated) {
                $animate.removeClass(data.lastActivated.element, clazz);
              }
              if (newActivated) {
                $animate.addClass(newActivated.element, clazz);
              }
              data.lastActivated = newActivated;
            }
          };
          expToData[exp] = data = {
            lastActivated: null,
            scope: scope,
            watchFn: watchFn,
            compareWithExp: compareWithExp,
            watcher: scope.$watch(compareWithExp, watchFn)
          };
        }
        data.watchFn(scope.$eval(compareWithExp));
      }

      function removeScope(e) {
        var removedScope = e.targetScope;
        var index = linkedScopes.indexOf(removedScope);
        linkedScopes.splice(index, 1);
        instances.splice(index, 1);
        if (linkedScopes.length) {
          var newWatchScope = linkedScopes[0];
          angular.forEach(expToData, function(data) {
            if (data.scope === removedScope) {
              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
              data.scope = newWatchScope;
            }
          });
        } else {
          expToData = {};
        }
      }
    }
  };
}]);
angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass'])

.value('$datepickerSuppressError', false)

.value('$datepickerLiteralWarning', true)

.constant('uibDatepickerConfig', {
  datepickerMode: 'day',
  formatDay: 'dd',
  formatMonth: 'MMMM',
  formatYear: 'yyyy',
  formatDayHeader: 'EEE',
  formatDayTitle: 'MMMM yyyy',
  formatMonthTitle: 'yyyy',
  maxDate: null,
  maxMode: 'year',
  minDate: null,
  minMode: 'day',
  monthColumns: 3,
  ngModelOptions: {},
  shortcutPropagation: false,
  showWeeks: true,
  yearColumns: 5,
  yearRows: 4
})

.controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser',
  function($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
  var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl;
      ngModelOptions = {},
      watchListeners = [];

  $element.addClass('uib-datepicker');
  $attrs.$set('role', 'application');

  if (!$scope.datepickerOptions) {
    $scope.datepickerOptions = {};
  }

  // Modes chain
  this.modes = ['day', 'month', 'year'];

  [
    'customClass',
    'dateDisabled',
    'datepickerMode',
    'formatDay',
    'formatDayHeader',
    'formatDayTitle',
    'formatMonth',
    'formatMonthTitle',
    'formatYear',
    'maxDate',
    'maxMode',
    'minDate',
    'minMode',
    'monthColumns',
    'showWeeks',
    'shortcutPropagation',
    'startingDay',
    'yearColumns',
    'yearRows'
  ].forEach(function(key) {
    switch (key) {
      case 'customClass':
      case 'dateDisabled':
        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
        break;
      case 'datepickerMode':
        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ?
          $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
        break;
      case 'formatDay':
      case 'formatDayHeader':
      case 'formatDayTitle':
      case 'formatMonth':
      case 'formatMonthTitle':
      case 'formatYear':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
          $interpolate($scope.datepickerOptions[key])($scope.$parent) :
          datepickerConfig[key];
        break;
      case 'monthColumns':
      case 'showWeeks':
      case 'shortcutPropagation':
      case 'yearColumns':
      case 'yearRows':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
          $scope.datepickerOptions[key] : datepickerConfig[key];
        break;
      case 'startingDay':
        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
          self.startingDay = $scope.datepickerOptions.startingDay;
        } else if (angular.isNumber(datepickerConfig.startingDay)) {
          self.startingDay = datepickerConfig.startingDay;
        } else {
          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
        }

        break;
      case 'maxDate':
      case 'minDate':
        $scope.$watch('datepickerOptions.' + key, function(value) {
          if (value) {
            if (angular.isDate(value)) {
              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.timezone);
            } else {
              if ($datepickerLiteralWarning) {
                $log.warn('Literal date support has been deprecated, please switch to date object usage');
              }

              self[key] = new Date(dateFilter(value, 'medium'));
            }
          } else {
            self[key] = datepickerConfig[key] ?
              dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.timezone) :
              null;
          }

          self.refreshView();
        });

        break;
      case 'maxMode':
      case 'minMode':
        if ($scope.datepickerOptions[key]) {
          $scope.$watch(function() { return $scope.datepickerOptions[key]; }, function(value) {
            self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
            if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) ||
              key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
              $scope.datepickerMode = self[key];
              $scope.datepickerOptions.datepickerMode = self[key];
            }
          });
        } else {
          self[key] = $scope[key] = datepickerConfig[key] || null;
        }

        break;
    }
  });

  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if (angular.isDefined($attrs.ngDisabled)) {
    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function(disabled) {
      $scope.disabled = disabled;
      self.refreshView();
    }));
  }

  $scope.isActive = function(dateObject) {
    if (self.compare(dateObject.date, self.activeDate) === 0) {
      $scope.activeDateId = dateObject.uid;
      return true;
    }
    return false;
  };

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelOptions = ngModelCtrl_.$options ||
      $scope.datepickerOptions.ngModelOptions ||
      datepickerConfig.ngModelOptions;
    if ($scope.datepickerOptions.initDate) {
      self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.timezone) || new Date();
      $scope.$watch('datepickerOptions.initDate', function(initDate) {
        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.timezone);
          self.refreshView();
        }
      });
    } else {
      self.activeDate = new Date();
    }

    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
    this.activeDate = !isNaN(date) ?
      dateParser.fromTimezone(date, ngModelOptions.timezone) :
      dateParser.fromTimezone(new Date(), ngModelOptions.timezone);

    ngModelCtrl.$render = function() {
      self.render();
    };
  };

  this.render = function() {
    if (ngModelCtrl.$viewValue) {
      var date = new Date(ngModelCtrl.$viewValue),
          isValid = !isNaN(date);

      if (isValid) {
        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.timezone);
      } else if (!$datepickerSuppressError) {
        $log.error('Datepicker directive: "ng-model" value must be a Date object');
      }
    }
    this.refreshView();
  };

  this.refreshView = function() {
    if (this.element) {
      $scope.selectedDt = null;
      this._refreshView();
      if ($scope.activeDt) {
        $scope.activeDateId = $scope.activeDt.uid;
      }

      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
      date = dateParser.fromTimezone(date, ngModelOptions.timezone);
      ngModelCtrl.$setValidity('dateDisabled', !date ||
        this.element && !this.isDisabled(date));
    }
  };

  this.createDateObject = function(date, format) {
    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
    model = dateParser.fromTimezone(model, ngModelOptions.timezone);
    var today = new Date();
    today = dateParser.fromTimezone(today, ngModelOptions.timezone);
    var time = this.compare(date, today);
    var dt = {
      date: date,
      label: dateParser.filter(date, format),
      selected: model && this.compare(date, model) === 0,
      disabled: this.isDisabled(date),
      past: time < 0,
      current: time === 0,
      future: time > 0,
      customClass: this.customClass(date) || null
    };

    if (model && this.compare(date, model) === 0) {
      $scope.selectedDt = dt;
    }

    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
      $scope.activeDt = dt;
    }

    return dt;
  };

  this.isDisabled = function(date) {
    return $scope.disabled ||
      this.minDate && this.compare(date, this.minDate) < 0 ||
      this.maxDate && this.compare(date, this.maxDate) > 0 ||
      $scope.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode});
  };

  this.customClass = function(date) {
    return $scope.customClass({date: date, mode: $scope.datepickerMode});
  };

  // Split array into smaller arrays
  this.split = function(arr, size) {
    var arrays = [];
    while (arr.length > 0) {
      arrays.push(arr.splice(0, size));
    }
    return arrays;
  };

  $scope.select = function(date) {
    if ($scope.datepickerMode === self.minMode) {
      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.timezone) : new Date(0, 0, 0, 0, 0, 0, 0);
      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
      dt = dateParser.toTimezone(dt, ngModelOptions.timezone);
      ngModelCtrl.$setViewValue(dt);
      ngModelCtrl.$render();
    } else {
      self.activeDate = date;
      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);

      $scope.$emit('uib:datepicker.mode');
    }

    $scope.$broadcast('uib:datepicker.focus');
  };

  $scope.move = function(direction) {
    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
    self.activeDate.setFullYear(year, month, 1);
    self.refreshView();
  };

  $scope.toggleMode = function(direction) {
    direction = direction || 1;

    if ($scope.datepickerMode === self.maxMode && direction === 1 ||
      $scope.datepickerMode === self.minMode && direction === -1) {
      return;
    }

    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);

    $scope.$emit('uib:datepicker.mode');
  };

  // Key event mapper
  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

  var focusElement = function() {
    self.element[0].focus();
  };

  // Listen for focus requests from popup directive
  $scope.$on('uib:datepicker.focus', focusElement);

  $scope.keydown = function(evt) {
    var key = $scope.keys[evt.which];

    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
      return;
    }

    evt.preventDefault();
    if (!self.shortcutPropagation) {
      evt.stopPropagation();
    }

    if (key === 'enter' || key === 'space') {
      if (self.isDisabled(self.activeDate)) {
        return; // do nothing
      }
      $scope.select(self.activeDate);
    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
      $scope.toggleMode(key === 'up' ? 1 : -1);
    } else {
      self.handleKeyDown(key, evt);
      self.refreshView();
    }
  };

  $element.on('keydown', function(evt) {
    $scope.$apply(function() {
      $scope.keydown(evt);
    });
  });

  $scope.$on('$destroy', function() {
    //Clear all watch listeners on destroy
    while (watchListeners.length) {
      watchListeners.shift()();
    }
  });

  function setMode(mode) {
    $scope.datepickerMode = mode;
    $scope.datepickerOptions.datepickerMode = mode;
  }
}])

.controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  this.step = { months: 1 };
  this.element = $element;
  function getDaysInMonth(year, month) {
    return month === 1 && year % 4 === 0 &&
      (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
  }

  this.init = function(ctrl) {
    angular.extend(ctrl, this);
    scope.showWeeks = ctrl.showWeeks;
    ctrl.refreshView();
  };

  this.getDates = function(startDate, n) {
    var dates = new Array(n), current = new Date(startDate), i = 0, date;
    while (i < n) {
      date = new Date(current);
      dates[i++] = date;
      current.setDate(current.getDate() + 1);
    }
    return dates;
  };

  this._refreshView = function() {
    var year = this.activeDate.getFullYear(),
      month = this.activeDate.getMonth(),
      firstDayOfMonth = new Date(this.activeDate);

    firstDayOfMonth.setFullYear(year, month, 1);

    var difference = this.startingDay - firstDayOfMonth.getDay(),
      numDisplayedFromPreviousMonth = difference > 0 ?
        7 - difference : - difference,
      firstDate = new Date(firstDayOfMonth);

    if (numDisplayedFromPreviousMonth > 0) {
      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
    }

    // 42 is the number of days on a six-week calendar
    var days = this.getDates(firstDate, 42);
    for (var i = 0; i < 42; i ++) {
      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
        secondary: days[i].getMonth() !== month,
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.labels = new Array(7);
    for (var j = 0; j < 7; j++) {
      scope.labels[j] = {
        abbr: dateFilter(days[j].date, this.formatDayHeader),
        full: dateFilter(days[j].date, 'EEEE')
      };
    }

    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
    scope.rows = this.split(days, 7);

    if (scope.showWeeks) {
      scope.weekNumbers = [];
      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
          numWeeks = scope.rows.length;
      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
        scope.weekNumbers.push(
          getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
      }
    }
  };

  this.compare = function(date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  function getISO8601WeekNumber(date) {
    var checkDate = new Date(date);
    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
    var time = checkDate.getTime();
    checkDate.setMonth(0); // Compare with Jan 1
    checkDate.setDate(1);
    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
  }

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getDate();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - 7;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + 7;
    } else if (key === 'pageup' || key === 'pagedown') {
      var month = this.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
      this.activeDate.setMonth(month, 1);
      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
    } else if (key === 'home') {
      date = 1;
    } else if (key === 'end') {
      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
    }
    this.activeDate.setDate(date);
  };
}])

.controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  this.step = { years: 1 };
  this.element = $element;

  this.init = function(ctrl) {
    angular.extend(ctrl, this);
    ctrl.refreshView();
  };

  this._refreshView = function() {
    var months = new Array(12),
        year = this.activeDate.getFullYear(),
        date;

    for (var i = 0; i < 12; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(year, i, 1);
      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
    scope.rows = this.split(months, this.monthColumns);
    scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
  };

  this.compare = function(date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getMonth();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - this.monthColumns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + this.monthColumns;
    } else if (key === 'pageup' || key === 'pagedown') {
      var year = this.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
      this.activeDate.setFullYear(year);
    } else if (key === 'home') {
      date = 0;
    } else if (key === 'end') {
      date = 11;
    }
    this.activeDate.setMonth(date);
  };
}])

.controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  var columns, range;
  this.element = $element;

  function getStartingYear(year) {
    return parseInt((year - 1) / range, 10) * range + 1;
  }

  this.yearpickerInit = function() {
    columns = this.yearColumns;
    range = this.yearRows * columns;
    this.step = { years: range };
  };

  this._refreshView = function() {
    var years = new Array(range), date;

    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(start + i, 0, 1);
      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = [years[0].label, years[range - 1].label].join(' - ');
    scope.rows = this.split(years, columns);
    scope.columns = columns;
  };

  this.compare = function(date1, date2) {
    return date1.getFullYear() - date2.getFullYear();
  };

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getFullYear();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - columns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + columns;
    } else if (key === 'pageup' || key === 'pagedown') {
      date += (key === 'pageup' ? - 1 : 1) * range;
    } else if (key === 'home') {
      date = getStartingYear(this.activeDate.getFullYear());
    } else if (key === 'end') {
      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
    }
    this.activeDate.setFullYear(date);
  };
}])

.directive('uibDatepicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
    },
    scope: {
      datepickerOptions: '=?'
    },
    require: ['uibDatepicker', '^ngModel'],
    restrict: 'A',
    controller: 'UibDatepickerController',
    controllerAs: 'datepicker',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      datepickerCtrl.init(ngModelCtrl);
    }
  };
})

.directive('uibDaypicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/day.html';
    },
    require: ['^uibDatepicker', 'uibDaypicker'],
    restrict: 'A',
    controller: 'UibDaypickerController',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        daypickerCtrl = ctrls[1];

      daypickerCtrl.init(datepickerCtrl);
    }
  };
})

.directive('uibMonthpicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/month.html';
    },
    require: ['^uibDatepicker', 'uibMonthpicker'],
    restrict: 'A',
    controller: 'UibMonthpickerController',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        monthpickerCtrl = ctrls[1];

      monthpickerCtrl.init(datepickerCtrl);
    }
  };
})

.directive('uibYearpicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/year.html';
    },
    require: ['^uibDatepicker', 'uibYearpicker'],
    restrict: 'A',
    controller: 'UibYearpickerController',
    link: function(scope, element, attrs, ctrls) {
      var ctrl = ctrls[0];
      angular.extend(ctrl, ctrls[1]);
      ctrl.yearpickerInit();

      ctrl.refreshView();
    }
  };
});

angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods for working with the DOM.
 * It is meant to be used where we need to absolute-position elements in
 * relation to another element (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
    /**
     * Used by scrollbarWidth() function to cache scrollbar's width.
     * Do not access this variable directly, use scrollbarWidth() instead.
     */
    var SCROLLBAR_WIDTH;
    /**
     * scrollbar on body and html element in IE and Edge overlay
     * content and should be considered 0 width.
     */
    var BODY_SCROLLBAR_WIDTH;
    var OVERFLOW_REGEX = {
      normal: /(auto|scroll)/,
      hidden: /(auto|scroll|hidden)/
    };
    var PLACEMENT_REGEX = {
      auto: /\s?auto?\s?/i,
      primary: /^(top|bottom|left|right)$/,
      secondary: /^(top|bottom|left|right|center)$/,
      vertical: /^(top|bottom)$/
    };
    var BODY_REGEX = /(HTML|BODY)/;

    return {

      /**
       * Provides a raw DOM element from a jQuery/jQLite element.
       *
       * @param {element} elem - The element to convert.
       *
       * @returns {element} A HTML element.
       */
      getRawNode: function(elem) {
        return elem.nodeName ? elem : elem[0] || elem;
      },

      /**
       * Provides a parsed number for a style property.  Strips
       * units and casts invalid numbers to 0.
       *
       * @param {string} value - The style value to parse.
       *
       * @returns {number} A valid number.
       */
      parseStyle: function(value) {
        value = parseFloat(value);
        return isFinite(value) ? value : 0;
      },

      /**
       * Provides the closest positioned ancestor.
       *
       * @param {element} element - The element to get the offest parent for.
       *
       * @returns {element} The closest positioned ancestor.
       */
      offsetParent: function(elem) {
        elem = this.getRawNode(elem);

        var offsetParent = elem.offsetParent || $document[0].documentElement;

        function isStaticPositioned(el) {
          return ($window.getComputedStyle(el).position || 'static') === 'static';
        }

        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
          offsetParent = offsetParent.offsetParent;
        }

        return offsetParent || $document[0].documentElement;
      },

      /**
       * Provides the scrollbar width, concept from TWBS measureScrollbar()
       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
       * In IE and Edge, scollbar on body and html element overlay and should
       * return a width of 0.
       *
       * @returns {number} The width of the browser scollbar.
       */
      scrollbarWidth: function(isBody) {
        if (isBody) {
          if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
            var bodyElem = $document.find('body');
            bodyElem.addClass('uib-position-body-scrollbar-measure');
            BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
            BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
            bodyElem.removeClass('uib-position-body-scrollbar-measure');
          }
          return BODY_SCROLLBAR_WIDTH;
        }

        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
          $document.find('body').append(scrollElem);
          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
          scrollElem.remove();
        }

        return SCROLLBAR_WIDTH;
      },

      /**
       * Provides the padding required on an element to replace the scrollbar.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**scrollbarWidth**: the width of the scrollbar</li>
       *     <li>**widthOverflow**: whether the the width is overflowing</li>
       *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
       *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
       *     <li>**heightOverflow**: whether the the height is overflowing</li>
       *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
       *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
       *   </ul>
       */
      scrollbarPadding: function(elem) {
        elem = this.getRawNode(elem);

        var elemStyle = $window.getComputedStyle(elem);
        var paddingRight = this.parseStyle(elemStyle.paddingRight);
        var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
        var scrollParent = this.scrollParent(elem, false, true);
        var scrollbarWidth = this.scrollbarWidth(scrollParent, BODY_REGEX.test(scrollParent.tagName));

        return {
          scrollbarWidth: scrollbarWidth,
          widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
          right: paddingRight + scrollbarWidth,
          originalRight: paddingRight,
          heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
          bottom: paddingBottom + scrollbarWidth,
          originalBottom: paddingBottom
         };
      },

      /**
       * Checks to see if the element is scrollable.
       *
       * @param {element} elem - The element to check.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       *
       * @returns {boolean} Whether the element is scrollable.
       */
      isScrollable: function(elem, includeHidden) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var elemStyle = $window.getComputedStyle(elem);
        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
      },

      /**
       * Provides the closest scrollable ancestor.
       * A port of the jQuery UI scrollParent method:
       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
       *
       * @param {element} elem - The element to find the scroll parent of.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       * @param {boolean=} [includeSelf=false] - Should the element being passed be
       * included in the scrollable llokup.
       *
       * @returns {element} A HTML element.
       */
      scrollParent: function(elem, includeHidden, includeSelf) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var documentEl = $document[0].documentElement;
        var elemStyle = $window.getComputedStyle(elem);
        if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
          return elem;
        }
        var excludeStatic = elemStyle.position === 'absolute';
        var scrollParent = elem.parentElement || documentEl;

        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
          return documentEl;
        }

        while (scrollParent.parentElement && scrollParent !== documentEl) {
          var spStyle = $window.getComputedStyle(scrollParent);
          if (excludeStatic && spStyle.position !== 'static') {
            excludeStatic = false;
          }

          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
            break;
          }
          scrollParent = scrollParent.parentElement;
        }

        return scrollParent;
      },

      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/ - distance to closest positioned
       * ancestor.  Does not account for margins by default like jQuery position.
       *
       * @param {element} elem - The element to caclulate the position on.
       * @param {boolean=} [includeMargins=false] - Should margins be accounted
       * for, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of offset parent</li>
       *     <li>**left**: distance to left edge of offset parent</li>
       *   </ul>
       */
      position: function(elem, includeMagins) {
        elem = this.getRawNode(elem);

        var elemOffset = this.offset(elem);
        if (includeMagins) {
          var elemStyle = $window.getComputedStyle(elem);
          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
        }
        var parent = this.offsetParent(elem);
        var parentOffset = {top: 0, left: 0};

        if (parent !== $document[0].documentElement) {
          parentOffset = this.offset(parent);
          parentOffset.top += parent.clientTop - parent.scrollTop;
          parentOffset.left += parent.clientLeft - parent.scrollLeft;
        }

        return {
          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
          top: Math.round(elemOffset.top - parentOffset.top),
          left: Math.round(elemOffset.left - parentOffset.left)
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/ - distance to viewport.  Does
       * not account for borders, margins, or padding on the body
       * element.
       *
       * @param {element} elem - The element to calculate the offset on.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of viewport</li>
       *     <li>**right**: distance to bottom edge of viewport</li>
       *   </ul>
       */
      offset: function(elem) {
        elem = this.getRawNode(elem);

        var elemBCR = elem.getBoundingClientRect();
        return {
          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
        };
      },

      /**
       * Provides offset distance to the closest scrollable ancestor
       * or viewport.  Accounts for border and scrollbar width.
       *
       * Right and bottom dimensions represent the distance to the
       * respective edge of the viewport element.  If the element
       * edge extends beyond the viewport, a negative value will be
       * reported.
       *
       * @param {element} elem - The element to get the viewport offset for.
       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
       * of the first scrollable element, default is false.
       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
       * be accounted for, default is true.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: distance to the top content edge of viewport element</li>
       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
       *     <li>**left**: distance to the left content edge of viewport element</li>
       *     <li>**right**: distance to the right content edge of viewport element</li>
       *   </ul>
       */
      viewportOffset: function(elem, useDocument, includePadding) {
        elem = this.getRawNode(elem);
        includePadding = includePadding !== false ? true : false;

        var elemBCR = elem.getBoundingClientRect();
        var offsetBCR = {top: 0, left: 0, bottom: 0, right: 0};

        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
        var offsetParentBCR = offsetParent.getBoundingClientRect();

        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
        if (offsetParent === $document[0].documentElement) {
          offsetBCR.top += $window.pageYOffset;
          offsetBCR.left += $window.pageXOffset;
        }
        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;

        if (includePadding) {
          var offsetParentStyle = $window.getComputedStyle(offsetParent);
          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
        }

        return {
          top: Math.round(elemBCR.top - offsetBCR.top),
          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
          left: Math.round(elemBCR.left - offsetBCR.left),
          right: Math.round(offsetBCR.right - elemBCR.right)
        };
      },

      /**
       * Provides an array of placement values parsed from a placement string.
       * Along with the 'auto' indicator, supported placement strings are:
       *   <ul>
       *     <li>top: element on top, horizontally centered on host element.</li>
       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
       *     <li>left: element on left, vertically centered on host element.</li>
       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
       *     <li>right: element on right, vertically centered on host element.</li>
       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
       *   </ul>
       * A placement string with an 'auto' indicator is expected to be
       * space separated from the placement, i.e: 'auto bottom-left'  If
       * the primary and secondary placement values do not match 'top,
       * bottom, left, right' then 'top' will be the primary placement and
       * 'center' will be the secondary placement.  If 'auto' is passed, true
       * will be returned as the 3rd value of the array.
       *
       * @param {string} placement - The placement string to parse.
       *
       * @returns {array} An array with the following values
       * <ul>
       *   <li>**[0]**: The primary placement.</li>
       *   <li>**[1]**: The secondary placement.</li>
       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
       * </ul>
       */
      parsePlacement: function(placement) {
        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
        if (autoPlace) {
          placement = placement.replace(PLACEMENT_REGEX.auto, '');
        }

        placement = placement.split('-');

        placement[0] = placement[0] || 'top';
        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
          placement[0] = 'top';
        }

        placement[1] = placement[1] || 'center';
        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
          placement[1] = 'center';
        }

        if (autoPlace) {
          placement[2] = true;
        } else {
          placement[2] = false;
        }

        return placement;
      },

      /**
       * Provides coordinates for an element to be positioned relative to
       * another element.  Passing 'auto' as part of the placement parameter
       * will enable smart placement - where the element fits. i.e:
       * 'auto left-top' will check to see if there is enough space to the left
       * of the hostElem to fit the targetElem, if not place right (same for secondary
       * top placement).  Available space is calculated using the viewportOffset
       * function.
       *
       * @param {element} hostElem - The element to position against.
       * @param {element} targetElem - The element to position.
       * @param {string=} [placement=top] - The placement for the targetElem,
       *   default is 'top'. 'center' is assumed as secondary placement for
       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
       *   <ul>
       *     <li>top</li>
       *     <li>top-right</li>
       *     <li>top-left</li>
       *     <li>bottom</li>
       *     <li>bottom-left</li>
       *     <li>bottom-right</li>
       *     <li>left</li>
       *     <li>left-top</li>
       *     <li>left-bottom</li>
       *     <li>right</li>
       *     <li>right-top</li>
       *     <li>right-bottom</li>
       *   </ul>
       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
       *   be calculated from the body element, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: Value for targetElem top.</li>
       *     <li>**left**: Value for targetElem left.</li>
       *     <li>**placement**: The resolved placement.</li>
       *   </ul>
       */
      positionElements: function(hostElem, targetElem, placement, appendToBody) {
        hostElem = this.getRawNode(hostElem);
        targetElem = this.getRawNode(targetElem);

        // need to read from prop to support tests.
        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');

        placement = this.parsePlacement(placement);

        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
        var targetElemPos = {top: 0, left: 0, placement: ''};

        if (placement[2]) {
          var viewportOffset = this.viewportOffset(hostElem, appendToBody);

          var targetElemStyle = $window.getComputedStyle(targetElem);
          var adjustedSize = {
            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
          };

          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
                         placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
                         placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
                         placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
                         placement[0];

          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
                         placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
                         placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
                         placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
                         placement[1];

          if (placement[1] === 'center') {
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
                placement[1] = 'left';
              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
                placement[1] = 'right';
              }
            } else {
              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
                placement[1] = 'top';
              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
                placement[1] = 'bottom';
              }
            }
          }
        }

        switch (placement[0]) {
          case 'top':
            targetElemPos.top = hostElemPos.top - targetHeight;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left - targetWidth;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width;
            break;
        }

        switch (placement[1]) {
          case 'top':
            targetElemPos.top = hostElemPos.top;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
            break;
          case 'center':
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
            } else {
              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
            }
            break;
        }

        targetElemPos.top = Math.round(targetElemPos.top);
        targetElemPos.left = Math.round(targetElemPos.left);
        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];

        return targetElemPos;
      },

      /**
       * Provides a way to adjust the top positioning after first
       * render to correctly align element to top after content
       * rendering causes resized element height
       *
       * @param {array} placementClasses - The array of strings of classes
       * element should have.
       * @param {object} containerPosition - The object with container
       * position information
       * @param {number} initialHeight - The initial height for the elem.
       * @param {number} currentHeight - The current height for the elem.
       */
      adjustTop: function(placementClasses, containerPosition, initialHeight, currentHeight) {
        if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
          return {
            top: containerPosition.top - currentHeight + 'px'
          };
        }
      },

      /**
       * Provides a way for positioning tooltip & dropdown
       * arrows when using placement options beyond the standard
       * left, right, top, or bottom.
       *
       * @param {element} elem - The tooltip/dropdown element.
       * @param {string} placement - The placement for the elem.
       */
      positionArrow: function(elem, placement) {
        elem = this.getRawNode(elem);

        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
        if (!innerElem) {
          return;
        }

        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');

        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
        if (!arrowElem) {
          return;
        }

        var arrowCss = {
          top: '',
          bottom: '',
          left: '',
          right: ''
        };

        placement = this.parsePlacement(placement);
        if (placement[1] === 'center') {
          // no adjustment necessary - just reset styles
          angular.element(arrowElem).css(arrowCss);
          return;
        }

        var borderProp = 'border-' + placement[0] + '-width';
        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];

        var borderRadiusProp = 'border-';
        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
          borderRadiusProp += placement[0] + '-' + placement[1];
        } else {
          borderRadiusProp += placement[1] + '-' + placement[0];
        }
        borderRadiusProp += '-radius';
        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];

        switch (placement[0]) {
          case 'top':
            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'bottom':
            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'left':
            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'right':
            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
            break;
        }

        arrowCss[placement[1]] = borderRadius;

        angular.element(arrowElem).css(arrowCss);
      }
    };
  }]);

angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position'])

.value('$datepickerPopupLiteralWarning', true)

.constant('uibDatepickerPopupConfig', {
  altInputFormats: [],
  appendToBody: false,
  clearText: 'Clear',
  closeOnDateSelection: true,
  closeText: 'Done',
  currentText: 'Today',
  datepickerPopup: 'yyyy-MM-dd',
  datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
  html5Types: {
    date: 'yyyy-MM-dd',
    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
    'month': 'yyyy-MM'
  },
  onOpenFocus: true,
  showButtonBar: true,
  placement: 'auto bottom-left'
})

.controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning',
function($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
  var cache = {},
    isHtml5DateInput = false;
  var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
    datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl, scrollParentEl,
    ngModel, ngModelOptions, $popup, altInputFormats, watchListeners = [];

  this.init = function(_ngModel_) {
    ngModel = _ngModel_;
    ngModelOptions = angular.isObject(_ngModel_.$options) ?
      _ngModel_.$options :
      {
        timezone: null
      };
    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ?
      $scope.$parent.$eval($attrs.closeOnDateSelection) :
      datepickerPopupConfig.closeOnDateSelection;
    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ?
      $scope.$parent.$eval($attrs.datepickerAppendToBody) :
      datepickerPopupConfig.appendToBody;
    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ?
      $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ?
      $attrs.datepickerPopupTemplateUrl :
      datepickerPopupConfig.datepickerPopupTemplateUrl;
    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ?
      $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
    altInputFormats = angular.isDefined($attrs.altInputFormats) ?
      $scope.$parent.$eval($attrs.altInputFormats) :
      datepickerPopupConfig.altInputFormats;

    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ?
      $scope.$parent.$eval($attrs.showButtonBar) :
      datepickerPopupConfig.showButtonBar;

    if (datepickerPopupConfig.html5Types[$attrs.type]) {
      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
      isHtml5DateInput = true;
    } else {
      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
      $attrs.$observe('uibDatepickerPopup', function(value, oldValue) {
        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
        // Invalidate the $modelValue to ensure that formatters re-run
        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
        if (newDateFormat !== dateFormat) {
          dateFormat = newDateFormat;
          ngModel.$modelValue = null;

          if (!dateFormat) {
            throw new Error('uibDatepickerPopup must have a date format specified.');
          }
        }
      });
    }

    if (!dateFormat) {
      throw new Error('uibDatepickerPopup must have a date format specified.');
    }

    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
      throw new Error('HTML5 date input types do not support custom formats.');
    }

    // popup element used to display calendar
    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');

    popupEl.attr({
      'ng-model': 'date',
      'ng-change': 'dateSelection(date)',
      'template-url': datepickerPopupTemplateUrl
    });

    // datepicker element
    datepickerEl = angular.element(popupEl.children()[0]);
    datepickerEl.attr('template-url', datepickerTemplateUrl);

    if (!$scope.datepickerOptions) {
      $scope.datepickerOptions = {};
    }

    if (isHtml5DateInput) {
      if ($attrs.type === 'month') {
        $scope.datepickerOptions.datepickerMode = 'month';
        $scope.datepickerOptions.minMode = 'month';
      }
    }

    datepickerEl.attr('datepicker-options', 'datepickerOptions');

    if (!isHtml5DateInput) {
      // Internal API to maintain the correct ng-invalid-[key] class
      ngModel.$$parserName = 'date';
      ngModel.$validators.date = validator;
      ngModel.$parsers.unshift(parseDate);
      ngModel.$formatters.push(function(value) {
        if (ngModel.$isEmpty(value)) {
          $scope.date = value;
          return value;
        }

        if (angular.isNumber(value)) {
          value = new Date(value);
        }

        $scope.date = dateParser.fromTimezone(value, ngModelOptions.timezone);

        return dateParser.filter($scope.date, dateFormat);
      });
    } else {
      ngModel.$formatters.push(function(value) {
        $scope.date = dateParser.fromTimezone(value, ngModelOptions.timezone);
        return value;
      });
    }

    // Detect changes in the view from the text box
    ngModel.$viewChangeListeners.push(function() {
      $scope.date = parseDateString(ngModel.$viewValue);
    });

    $element.on('keydown', inputKeydownBind);

    $popup = $compile(popupEl)($scope);
    // Prevent jQuery cache memory leak (template is now redundant after linking)
    popupEl.remove();

    if (appendToBody) {
      $document.find('body').append($popup);
    } else {
      $element.after($popup);
    }

    $scope.$on('$destroy', function() {
      if ($scope.isOpen === true) {
        if (!$rootScope.$$phase) {
          $scope.$apply(function() {
            $scope.isOpen = false;
          });
        }
      }

      $popup.remove();
      $element.off('keydown', inputKeydownBind);
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);

      //Clear all watch listeners on destroy
      while (watchListeners.length) {
        watchListeners.shift()();
      }
    });
  };

  $scope.getText = function(key) {
    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
  };

  $scope.isDisabled = function(date) {
    if (date === 'today') {
      date = dateParser.fromTimezone(new Date(), ngModelOptions.timezone);
    }

    var dates = {};
    angular.forEach(['minDate', 'maxDate'], function(key) {
      if (!$scope.datepickerOptions[key]) {
        dates[key] = null;
      } else if (angular.isDate($scope.datepickerOptions[key])) {
        dates[key] = new Date($scope.datepickerOptions[key]);
      } else {
        if ($datepickerPopupLiteralWarning) {
          $log.warn('Literal date support has been deprecated, please switch to date object usage');
        }

        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
      }
    });

    return $scope.datepickerOptions &&
      dates.minDate && $scope.compare(date, dates.minDate) < 0 ||
      dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
  };

  $scope.compare = function(date1, date2) {
    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
  };

  // Inner change
  $scope.dateSelection = function(dt) {
    $scope.date = dt;
    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
    $element.val(date);
    ngModel.$setViewValue(date);

    if (closeOnDateSelection) {
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.keydown = function(evt) {
    if (evt.which === 27) {
      evt.stopPropagation();
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.select = function(date, evt) {
    evt.stopPropagation();

    if (date === 'today') {
      var today = new Date();
      if (angular.isDate($scope.date)) {
        date = new Date($scope.date);
        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
      } else {
        date = dateParser.fromTimezone(today, ngModelOptions.timezone);
        date.setHours(0, 0, 0, 0);
      }
    }
    $scope.dateSelection(date);
  };

  $scope.close = function(evt) {
    evt.stopPropagation();

    $scope.isOpen = false;
    $element[0].focus();
  };

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if ($attrs.ngDisabled) {
    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(disabled) {
      $scope.disabled = disabled;
    }));
  }

  $scope.$watch('isOpen', function(value) {
    if (value) {
      if (!$scope.disabled) {
        $timeout(function() {
          positionPopup();

          if (onOpenFocus) {
            $scope.$broadcast('uib:datepicker.focus');
          }

          $document.on('click', documentClickBind);

          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
          if (appendToBody || $position.parsePlacement(placement)[2]) {
            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
            if (scrollParentEl) {
              scrollParentEl.on('scroll', positionPopup);
            }
          } else {
            scrollParentEl = null;
          }

          angular.element($window).on('resize', positionPopup);
        }, 0, false);
      } else {
        $scope.isOpen = false;
      }
    } else {
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);
    }
  });

  function cameltoDash(string) {
    return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
  }

  function parseDateString(viewValue) {
    var date = dateParser.parse(viewValue, dateFormat, $scope.date);
    if (isNaN(date)) {
      for (var i = 0; i < altInputFormats.length; i++) {
        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
        if (!isNaN(date)) {
          return date;
        }
      }
    }
    return date;
  }

  function parseDate(viewValue) {
    if (angular.isNumber(viewValue)) {
      // presumably timestamp to date object
      viewValue = new Date(viewValue);
    }

    if (!viewValue) {
      return null;
    }

    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
      return viewValue;
    }

    if (angular.isString(viewValue)) {
      var date = parseDateString(viewValue);
      if (!isNaN(date)) {
        return dateParser.fromTimezone(date, ngModelOptions.timezone);
      }
    }

    return ngModel.$options && ngModel.$options.allowInvalid ? viewValue : undefined;
  }

  function validator(modelValue, viewValue) {
    var value = modelValue || viewValue;

    if (!$attrs.ngRequired && !value) {
      return true;
    }

    if (angular.isNumber(value)) {
      value = new Date(value);
    }

    if (!value) {
      return true;
    }

    if (angular.isDate(value) && !isNaN(value)) {
      return true;
    }

    if (angular.isString(value)) {
      return !isNaN(parseDateString(value));
    }

    return false;
  }

  function documentClickBind(event) {
    if (!$scope.isOpen && $scope.disabled) {
      return;
    }

    var popup = $popup[0];
    var dpContainsTarget = $element[0].contains(event.target);
    // The popup node may not be an element node
    // In some browsers (IE) only element nodes have the 'contains' function
    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
      $scope.$apply(function() {
        $scope.isOpen = false;
      });
    }
  }

  function inputKeydownBind(evt) {
    if (evt.which === 27 && $scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function() {
        $scope.isOpen = false;
      });
      $element[0].focus();
    } else if (evt.which === 40 && !$scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function() {
        $scope.isOpen = true;
      });
    }
  }

  function positionPopup() {
    if ($scope.isOpen) {
      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
      var position = $position.positionElements($element, dpElement, placement, appendToBody);
      dpElement.css({top: position.top + 'px', left: position.left + 'px'});
      if (dpElement.hasClass('uib-position-measure')) {
        dpElement.removeClass('uib-position-measure');
      }
    }
  }

  $scope.$on('uib:datepicker.mode', function() {
    $timeout(positionPopup, 0, false);
  });
}])

.directive('uibDatepickerPopup', function() {
  return {
    require: ['ngModel', 'uibDatepickerPopup'],
    controller: 'UibDatepickerPopupController',
    scope: {
      datepickerOptions: '=?',
      isOpen: '=?',
      currentText: '@',
      clearText: '@',
      closeText: '@'
    },
    link: function(scope, element, attrs, ctrls) {
      var ngModel = ctrls[0],
        ctrl = ctrls[1];

      ctrl.init(ngModel);
    }
  };
})

.directive('uibDatepickerPopupWrap', function() {
  return {
    restrict: 'A',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
    }
  };
});

angular.module('ui.bootstrap.debounce', [])
/**
 * A helper, internal service that debounces a function
 */
  .factory('$$debounce', ['$timeout', function($timeout) {
    return function(callback, debounceTime) {
      var timeoutPromise;

      return function() {
        var self = this;
        var args = Array.prototype.slice.call(arguments);
        if (timeoutPromise) {
          $timeout.cancel(timeoutPromise);
        }

        timeoutPromise = $timeout(function() {
          callback.apply(self, args);
        }, debounceTime);
      };
    };
  }]);

angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.position'])

.constant('uibDropdownConfig', {
  appendToOpenClass: 'uib-dropdown-open',
  openClass: 'open'
})

.service('uibDropdownService', ['$document', '$rootScope', function($document, $rootScope) {
  var openScope = null;

  this.open = function(dropdownScope, element) {
    if (!openScope) {
      $document.on('click', closeDropdown);
    }

    if (openScope && openScope !== dropdownScope) {
      openScope.isOpen = false;
    }

    openScope = dropdownScope;
  };

  this.close = function(dropdownScope, element) {
    if (openScope === dropdownScope) {
      openScope = null;
      $document.off('click', closeDropdown);
      $document.off('keydown', this.keybindFilter);
    }
  };

  var closeDropdown = function(evt) {
    // This method may still be called during the same mouse event that
    // unbound this event handler. So check openScope before proceeding.
    if (!openScope) { return; }

    if (evt && openScope.getAutoClose() === 'disabled') { return; }

    if (evt && evt.which === 3) { return; }

    var toggleElement = openScope.getToggleElement();
    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    if (evt && openScope.getAutoClose() === 'outsideClick' &&
      dropdownElement && dropdownElement[0].contains(evt.target)) {
      return;
    }

    openScope.isOpen = false;
    openScope.focusToggleElement();

    if (!$rootScope.$$phase) {
      openScope.$apply();
    }
  };

  this.keybindFilter = function(evt) {
    var dropdownElement = openScope.getDropdownElement();
    var toggleElement = openScope.getToggleElement();
    var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
    var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
    if (evt.which === 27) {
      evt.stopPropagation();
      openScope.focusToggleElement();
      closeDropdown();
    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
      evt.preventDefault();
      evt.stopPropagation();
      openScope.focusDropdownEntry(evt.which);
    }
  };
}])

.controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
  var self = this,
    scope = $scope.$new(), // create a child scope so we are not polluting original one
    templateScope,
    appendToOpenClass = dropdownConfig.appendToOpenClass,
    openClass = dropdownConfig.openClass,
    getIsOpen,
    setIsOpen = angular.noop,
    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
    appendToBody = false,
    appendTo = null,
    keynavEnabled = false,
    selectedOption = null,
    body = $document.find('body');

  $element.addClass('dropdown');

  this.init = function() {
    if ($attrs.isOpen) {
      getIsOpen = $parse($attrs.isOpen);
      setIsOpen = getIsOpen.assign;

      $scope.$watch(getIsOpen, function(value) {
        scope.isOpen = !!value;
      });
    }

    if (angular.isDefined($attrs.dropdownAppendTo)) {
      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
      if (appendToEl) {
        appendTo = angular.element(appendToEl);
      }
    }

    appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
    keynavEnabled = angular.isDefined($attrs.keyboardNav);

    if (appendToBody && !appendTo) {
      appendTo = body;
    }

    if (appendTo && self.dropdownMenu) {
      appendTo.append(self.dropdownMenu);
      $element.on('$destroy', function handleDestroyEvent() {
        self.dropdownMenu.remove();
      });
    }
  };

  this.toggle = function(open) {
    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
    if (angular.isFunction(setIsOpen)) {
      setIsOpen(scope, scope.isOpen);
    }

    return scope.isOpen;
  };

  // Allow other directives to watch status
  this.isOpen = function() {
    return scope.isOpen;
  };

  scope.getToggleElement = function() {
    return self.toggleElement;
  };

  scope.getAutoClose = function() {
    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
  };

  scope.getElement = function() {
    return $element;
  };

  scope.isKeynavEnabled = function() {
    return keynavEnabled;
  };

  scope.focusDropdownEntry = function(keyCode) {
    var elems = self.dropdownMenu ? //If append to body is used.
      angular.element(self.dropdownMenu).find('a') :
      $element.find('ul').eq(0).find('a');

    switch (keyCode) {
      case 40: {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = 0;
        } else {
          self.selectedOption = self.selectedOption === elems.length - 1 ?
            self.selectedOption :
            self.selectedOption + 1;
        }
        break;
      }
      case 38: {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = elems.length - 1;
        } else {
          self.selectedOption = self.selectedOption === 0 ?
            0 : self.selectedOption - 1;
        }
        break;
      }
    }
    elems[self.selectedOption].focus();
  };

  scope.getDropdownElement = function() {
    return self.dropdownMenu;
  };

  scope.focusToggleElement = function() {
    if (self.toggleElement) {
      self.toggleElement[0].focus();
    }
  };

  scope.$watch('isOpen', function(isOpen, wasOpen) {
    if (appendTo && self.dropdownMenu) {
      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
        css,
        rightalign,
        scrollbarPadding,
        scrollbarWidth = 0;

      css = {
        top: pos.top + 'px',
        display: isOpen ? 'block' : 'none'
      };

      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
      if (!rightalign) {
        css.left = pos.left + 'px';
        css.right = 'auto';
      } else {
        css.left = 'auto';
        scrollbarPadding = $position.scrollbarPadding(appendTo);

        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
          scrollbarWidth = scrollbarPadding.scrollbarWidth;
        }

        css.right = window.innerWidth - scrollbarWidth -
          (pos.left + $element.prop('offsetWidth')) + 'px';
      }

      // Need to adjust our positioning to be relative to the appendTo container
      // if it's not the body element
      if (!appendToBody) {
        var appendOffset = $position.offset(appendTo);

        css.top = pos.top - appendOffset.top + 'px';

        if (!rightalign) {
          css.left = pos.left - appendOffset.left + 'px';
        } else {
          css.right = window.innerWidth -
            (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
        }
      }

      self.dropdownMenu.css(css);
    }

    var openContainer = appendTo ? appendTo : $element;
    var hasOpenClass = openContainer.hasClass(appendTo ? appendToOpenClass : openClass);

    if (hasOpenClass === !isOpen) {
      $animate[isOpen ? 'addClass' : 'removeClass'](openContainer, appendTo ? appendToOpenClass : openClass).then(function() {
        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
          toggleInvoker($scope, { open: !!isOpen });
        }
      });
    }

    if (isOpen) {
      if (self.dropdownMenuTemplateUrl) {
        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
          templateScope = scope.$new();
          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
            var newEl = dropdownElement;
            self.dropdownMenu.replaceWith(newEl);
            self.dropdownMenu = newEl;
            $document.on('keydown', uibDropdownService.keybindFilter);
          });
        });
      } else {
        $document.on('keydown', uibDropdownService.keybindFilter);
      }

      scope.focusToggleElement();
      uibDropdownService.open(scope, $element);
    } else {
      uibDropdownService.close(scope, $element);
      if (self.dropdownMenuTemplateUrl) {
        if (templateScope) {
          templateScope.$destroy();
        }
        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
        self.dropdownMenu.replaceWith(newEl);
        self.dropdownMenu = newEl;
      }

      self.selectedOption = null;
    }

    if (angular.isFunction(setIsOpen)) {
      setIsOpen($scope, isOpen);
    }
  });
}])

.directive('uibDropdown', function() {
  return {
    controller: 'UibDropdownController',
    link: function(scope, element, attrs, dropdownCtrl) {
      dropdownCtrl.init();
    }
  };
})

.directive('uibDropdownMenu', function() {
  return {
    restrict: 'A',
    require: '?^uibDropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
        return;
      }

      element.addClass('dropdown-menu');

      var tplUrl = attrs.templateUrl;
      if (tplUrl) {
        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
      }

      if (!dropdownCtrl.dropdownMenu) {
        dropdownCtrl.dropdownMenu = element;
      }
    }
  };
})

.directive('uibDropdownToggle', function() {
  return {
    require: '?^uibDropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl) {
        return;
      }

      element.addClass('dropdown-toggle');

      dropdownCtrl.toggleElement = element;

      var toggleDropdown = function(event) {
        event.preventDefault();

        if (!element.hasClass('disabled') && !attrs.disabled) {
          scope.$apply(function() {
            dropdownCtrl.toggle();
          });
        }
      };

      element.bind('click', toggleDropdown);

      // WAI-ARIA
      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
      scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
        element.attr('aria-expanded', !!isOpen);
      });

      scope.$on('$destroy', function() {
        element.unbind('click', toggleDropdown);
      });
    }
  };
});

angular.module('ui.bootstrap.stackedMap', [])
/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
  .factory('$$stackedMap', function() {
    return {
      createNew: function() {
        var stack = [];

        return {
          add: function(key, value) {
            stack.push({
              key: key,
              value: value
            });
          },
          get: function(key) {
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                return stack[i];
              }
            }
          },
          keys: function() {
            var keys = [];
            for (var i = 0; i < stack.length; i++) {
              keys.push(stack[i].key);
            }
            return keys;
          },
          top: function() {
            return stack[stack.length - 1];
          },
          remove: function(key) {
            var idx = -1;
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                idx = i;
                break;
              }
            }
            return stack.splice(idx, 1)[0];
          },
          removeTop: function() {
            return stack.pop();
          },
          length: function() {
            return stack.length;
          }
        };
      }
    };
  });
angular.module('ui.bootstrap.modal', ['ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
/**
 * A helper, internal data structure that stores all references attached to key
 */
  .factory('$$multiMap', function() {
    return {
      createNew: function() {
        var map = {};

        return {
          entries: function() {
            return Object.keys(map).map(function(key) {
              return {
                key: key,
                value: map[key]
              };
            });
          },
          get: function(key) {
            return map[key];
          },
          hasKey: function(key) {
            return !!map[key];
          },
          keys: function() {
            return Object.keys(map);
          },
          put: function(key, value) {
            if (!map[key]) {
              map[key] = [];
            }

            map[key].push(value);
          },
          remove: function(key, value) {
            var values = map[key];

            if (!values) {
              return;
            }

            var idx = values.indexOf(value);

            if (idx !== -1) {
              values.splice(idx, 1);
            }

            if (!values.length) {
              delete map[key];
            }
          }
        };
      }
    };
  })

/**
 * Pluggable resolve mechanism for the modal resolve resolution
 * Supports UI Router's $resolve service
 */
  .provider('$uibResolve', function() {
    var resolve = this;
    this.resolver = null;

    this.setResolver = function(resolver) {
      this.resolver = resolver;
    };

    this.$get = ['$injector', '$q', function($injector, $q) {
      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
      return {
        resolve: function(invocables, locals, parent, self) {
          if (resolver) {
            return resolver.resolve(invocables, locals, parent, self);
          }

          var promises = [];

          angular.forEach(invocables, function(value) {
            if (angular.isFunction(value) || angular.isArray(value)) {
              promises.push($q.resolve($injector.invoke(value)));
            } else if (angular.isString(value)) {
              promises.push($q.resolve($injector.get(value)));
            } else {
              promises.push($q.resolve(value));
            }
          });

          return $q.all(promises).then(function(resolves) {
            var resolveObj = {};
            var resolveIter = 0;
            angular.forEach(invocables, function(value, key) {
              resolveObj[key] = resolves[resolveIter++];
            });

            return resolveObj;
          });
        }
      };
    }];
  })

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
  .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
  function($animate, $injector, $modalStack) {
    return {
      restrict: 'A',
      compile: function(tElement, tAttrs) {
        tElement.addClass(tAttrs.backdropClass);
        return linkFn;
      }
    };

    function linkFn(scope, element, attrs) {
      if (attrs.modalInClass) {
        $animate.addClass(element, attrs.modalInClass);

        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
          var done = setIsAsync();
          if (scope.modalOptions.animation) {
            $animate.removeClass(element, attrs.modalInClass).then(done);
          } else {
            done();
          }
        });
      }
    }
  }])

  .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
  function($modalStack, $q, $animateCss, $document) {
    return {
      scope: {
        index: '@'
      },
      restrict: 'A',
      transclude: true,
      templateUrl: function(tElement, tAttrs) {
        return tAttrs.templateUrl || 'uib/template/modal/window.html';
      },
      link: function(scope, element, attrs) {
        element.addClass(attrs.windowTopClass || '');
        scope.size = attrs.size;

        scope.close = function(evt) {
          var modal = $modalStack.getTop();
          if (modal && modal.value.backdrop &&
            modal.value.backdrop !== 'static' &&
            evt.target === evt.currentTarget) {
            evt.preventDefault();
            evt.stopPropagation();
            $modalStack.dismiss(modal.key, 'backdrop click');
          }
        };

        // moved from template to fix issue #2280
        element.on('click', scope.close);

        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
        // We can detect that by using this property in the template associated with this directive and then use
        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
        scope.$isRendered = true;

        // Deferred object that will be resolved when this modal is render.
        var modalRenderDeferObj = $q.defer();
        // Resolve render promise post-digest
        scope.$$postDigest(function() {
          modalRenderDeferObj.resolve();
        });

        modalRenderDeferObj.promise.then(function() {
          var animationPromise = null;

          if (attrs.modalInClass) {
            animationPromise = $animateCss(element, {
              addClass: attrs.modalInClass
            }).start();

            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
              var done = setIsAsync();
              $animateCss(element, {
                removeClass: attrs.modalInClass
              }).start().then(done);
            });
          }


          $q.when(animationPromise).then(function() {
            // Notify {@link $modalStack} that modal is rendered.
            var modal = $modalStack.getTop();
            if (modal) {
              $modalStack.modalRendered(modal.key);
            }

            /**
             * If something within the freshly-opened modal already has focus (perhaps via a
             * directive that causes focus). then no need to try and focus anything.
             */
            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
              var inputWithAutofocus = element[0].querySelector('[autofocus]');
              /**
               * Auto-focusing of a freshly-opened modal element causes any child elements
               * with the autofocus attribute to lose focus. This is an issue on touch
               * based devices which will show and then hide the onscreen keyboard.
               * Attempts to refocus the autofocus element via JavaScript will not reopen
               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
               * the modal element if the modal does not contain an autofocus element.
               */
              if (inputWithAutofocus) {
                inputWithAutofocus.focus();
              } else {
                element[0].focus();
              }
            }
          });
        });
      }
    };
  }])

  .directive('uibModalAnimationClass', function() {
    return {
      compile: function(tElement, tAttrs) {
        if (tAttrs.modalAnimation) {
          tElement.addClass(tAttrs.uibModalAnimationClass);
        }
      }
    };
  })

  .directive('uibModalTransclude', ['$animate', function($animate) {
    return {
      link: function(scope, element, attrs, controller, transclude) {
        transclude(scope.$parent, function(clone) {
          element.empty();
          $animate.enter(clone, element);
        });
      }
    };
  }])

  .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
    '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
    function($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
      var OPENED_MODAL_CLASS = 'modal-open';

      var backdropDomEl, backdropScope;
      var openedWindows = $$stackedMap.createNew();
      var openedClasses = $$multiMap.createNew();
      var $modalStack = {
        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
      };
      var topModalIndex = 0;
      var previousTopOpenedModal = null;

      //Modal focus behavior
      var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
        'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
        'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
      var scrollbarPadding;
      var SNAKE_CASE_REGEXP = /[A-Z]/g;

      // TODO: extract into common dependency with tooltip
      function snake_case(name) {
        var separator = '-';
        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
          return (pos ? separator : '') + letter.toLowerCase();
        });
      }

      function isVisible(element) {
        return !!(element.offsetWidth ||
          element.offsetHeight ||
          element.getClientRects().length);
      }

      function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
          if (openedWindows.get(opened[i]).value.backdrop) {
            topBackdropIndex = i;
          }
        }

        // If any backdrop exist, ensure that it's index is always
        // right below the top modal
        if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
          topBackdropIndex = topModalIndex;
        }
        return topBackdropIndex;
      }

      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
        if (backdropScope) {
          backdropScope.index = newBackdropIndex;
        }
      });

      function removeModalWindow(modalInstance, elementToReceiveFocus) {
        var modalWindow = openedWindows.get(modalInstance).value;
        var appendToElement = modalWindow.appendTo;

        //clean up the stack
        openedWindows.remove(modalInstance);
        previousTopOpenedModal = openedWindows.top();
        if (previousTopOpenedModal) {
          topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
        }

        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
          openedClasses.remove(modalBodyClass, modalInstance);
          var areAnyOpen = openedClasses.hasKey(modalBodyClass);
          appendToElement.toggleClass(modalBodyClass, areAnyOpen);
          if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
            if (scrollbarPadding.originalRight) {
              appendToElement.css({paddingRight: scrollbarPadding.originalRight + 'px'});
            } else {
              appendToElement.css({paddingRight: ''});
            }
            scrollbarPadding = null;
          }
          toggleTopWindowClass(true);
        }, modalWindow.closedDeferred);
        checkRemoveBackdrop();

        //move focus to specified element if available, or else to body
        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
          elementToReceiveFocus.focus();
        } else if (appendToElement.focus) {
          appendToElement.focus();
        }
      }

      // Add or remove "windowTopClass" from the top window in the stack
      function toggleTopWindowClass(toggleSwitch) {
        var modalWindow;

        if (openedWindows.length() > 0) {
          modalWindow = openedWindows.top().value;
          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
        }
      }

      function checkRemoveBackdrop() {
        //remove backdrop if no longer needed
        if (backdropDomEl && backdropIndex() === -1) {
          var backdropScopeRef = backdropScope;
          removeAfterAnimate(backdropDomEl, backdropScope, function() {
            backdropScopeRef = null;
          });
          backdropDomEl = undefined;
          backdropScope = undefined;
        }
      }

      function removeAfterAnimate(domEl, scope, done, closedDeferred) {
        var asyncDeferred;
        var asyncPromise = null;
        var setIsAsync = function() {
          if (!asyncDeferred) {
            asyncDeferred = $q.defer();
            asyncPromise = asyncDeferred.promise;
          }

          return function asyncDone() {
            asyncDeferred.resolve();
          };
        };
        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

        // Note that it's intentional that asyncPromise might be null.
        // That's when setIsAsync has not been called during the
        // NOW_CLOSING_EVENT broadcast.
        return $q.when(asyncPromise).then(afterAnimating);

        function afterAnimating() {
          if (afterAnimating.done) {
            return;
          }
          afterAnimating.done = true;

          $animate.leave(domEl).then(function() {
            if (done) {
              done();
            }

            domEl.remove();
            if (closedDeferred) {
              closedDeferred.resolve();
            }
          });

          scope.$destroy();
        }
      }

      $document.on('keydown', keydownListener);

      $rootScope.$on('$destroy', function() {
        $document.off('keydown', keydownListener);
      });

      function keydownListener(evt) {
        if (evt.isDefaultPrevented()) {
          return evt;
        }

        var modal = openedWindows.top();
        if (modal) {
          switch (evt.which) {
            case 27: {
              if (modal.value.keyboard) {
                evt.preventDefault();
                $rootScope.$apply(function() {
                  $modalStack.dismiss(modal.key, 'escape key press');
                });
              }
              break;
            }
            case 9: {
              var list = $modalStack.loadFocusElementList(modal);
              var focusChanged = false;
              if (evt.shiftKey) {
                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
                  focusChanged = $modalStack.focusLastFocusableElement(list);
                }
              } else {
                if ($modalStack.isFocusInLastItem(evt, list)) {
                  focusChanged = $modalStack.focusFirstFocusableElement(list);
                }
              }

              if (focusChanged) {
                evt.preventDefault();
                evt.stopPropagation();
              }

              break;
            }
          }
        }
      }

      $modalStack.open = function(modalInstance, modal) {
        var modalOpener = $document[0].activeElement,
          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

        toggleTopWindowClass(false);

        // Store the current top first, to determine what index we ought to use
        // for the current top modal
        previousTopOpenedModal = openedWindows.top();

        openedWindows.add(modalInstance, {
          deferred: modal.deferred,
          renderDeferred: modal.renderDeferred,
          closedDeferred: modal.closedDeferred,
          modalScope: modal.scope,
          backdrop: modal.backdrop,
          keyboard: modal.keyboard,
          openedClass: modal.openedClass,
          windowTopClass: modal.windowTopClass,
          animation: modal.animation,
          appendTo: modal.appendTo
        });

        openedClasses.put(modalBodyClass, modalInstance);

        var appendToElement = modal.appendTo,
            currBackdropIndex = backdropIndex();

        if (!appendToElement.length) {
          throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
        }

        if (currBackdropIndex >= 0 && !backdropDomEl) {
          backdropScope = $rootScope.$new(true);
          backdropScope.modalOptions = modal;
          backdropScope.index = currBackdropIndex;
          backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
          backdropDomEl.attr({
            'class': 'modal-backdrop',
            'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
            'uib-modal-animation-class': 'fade',
            'modal-in-class': 'in'
          });
          if (modal.backdropClass) {
            backdropDomEl.addClass(modal.backdropClass);
          }

          if (modal.animation) {
            backdropDomEl.attr('modal-animation', 'true');
          }
          $compile(backdropDomEl)(backdropScope);
          $animate.enter(backdropDomEl, appendToElement);
          if ($uibPosition.isScrollable(appendToElement)) {
            scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
            if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
              appendToElement.css({paddingRight: scrollbarPadding.right + 'px'});
            }
          }
        }

        var content;
        if (modal.component) {
          content = document.createElement(snake_case(modal.component.name));
          content = angular.element(content);
          content.attr({
            resolve: '$resolve',
            'modal-instance': '$uibModalInstance',
            close: '$close($value)',
            dismiss: '$dismiss($value)'
          });
        } else {
          content = modal.content;
        }

        // Set the top modal index based on the index of the previous top modal
        topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
        angularDomEl.attr({
          'class': 'modal',
          'template-url': modal.windowTemplateUrl,
          'window-top-class': modal.windowTopClass,
          'role': 'dialog',
          'aria-labelledby': modal.ariaLabelledBy,
          'aria-describedby': modal.ariaDescribedBy,
          'size': modal.size,
          'index': topModalIndex,
          'animate': 'animate',
          'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
          'tabindex': -1,
          'uib-modal-animation-class': 'fade',
          'modal-in-class': 'in'
        }).append(content);
        if (modal.windowClass) {
          angularDomEl.addClass(modal.windowClass);
        }

        if (modal.animation) {
          angularDomEl.attr('modal-animation', 'true');
        }

        appendToElement.addClass(modalBodyClass);
        if (modal.scope) {
          // we need to explicitly add the modal index to the modal scope
          // because it is needed by ngStyle to compute the zIndex property.
          modal.scope.$$topModalIndex = topModalIndex;
        }
        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);

        openedWindows.top().value.modalDomEl = angularDomEl;
        openedWindows.top().value.modalOpener = modalOpener;
      };

      function broadcastClosing(modalWindow, resultOrReason, closing) {
        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
      }

      $modalStack.close = function(modalInstance, result) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.resolve(result);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismiss = function(modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.reject(reason);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismissAll = function(reason) {
        var topModal = this.getTop();
        while (topModal && this.dismiss(topModal.key, reason)) {
          topModal = this.getTop();
        }
      };

      $modalStack.getTop = function() {
        return openedWindows.top();
      };

      $modalStack.modalRendered = function(modalInstance) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow) {
          modalWindow.value.renderDeferred.resolve();
        }
      };

      $modalStack.focusFirstFocusableElement = function(list) {
        if (list.length > 0) {
          list[0].focus();
          return true;
        }
        return false;
      };

      $modalStack.focusLastFocusableElement = function(list) {
        if (list.length > 0) {
          list[list.length - 1].focus();
          return true;
        }
        return false;
      };

      $modalStack.isModalFocused = function(evt, modalWindow) {
        if (evt && modalWindow) {
          var modalDomEl = modalWindow.value.modalDomEl;
          if (modalDomEl && modalDomEl.length) {
            return (evt.target || evt.srcElement) === modalDomEl[0];
          }
        }
        return false;
      };

      $modalStack.isFocusInFirstItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[0];
        }
        return false;
      };

      $modalStack.isFocusInLastItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[list.length - 1];
        }
        return false;
      };

      $modalStack.loadFocusElementList = function(modalWindow) {
        if (modalWindow) {
          var modalDomE1 = modalWindow.value.modalDomEl;
          if (modalDomE1 && modalDomE1.length) {
            var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
            return elements ?
              Array.prototype.filter.call(elements, function(element) {
                return isVisible(element);
              }) : elements;
          }
        }
      };

      return $modalStack;
    }])

  .provider('$uibModal', function() {
    var $modalProvider = {
      options: {
        animation: true,
        backdrop: true, //can also be false or 'static'
        keyboard: true
      },
      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
        function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
          var $modal = {};

          function getTemplatePromise(options) {
            return options.template ? $q.when(options.template) :
              $templateRequest(angular.isFunction(options.templateUrl) ?
                options.templateUrl() : options.templateUrl);
          }

          var promiseChain = null;
          $modal.getPromiseChain = function() {
            return promiseChain;
          };

          $modal.open = function(modalOptions) {
            var modalResultDeferred = $q.defer();
            var modalOpenedDeferred = $q.defer();
            var modalClosedDeferred = $q.defer();
            var modalRenderDeferred = $q.defer();

            //prepare an instance of a modal to be injected into controllers and returned to a caller
            var modalInstance = {
              result: modalResultDeferred.promise,
              opened: modalOpenedDeferred.promise,
              closed: modalClosedDeferred.promise,
              rendered: modalRenderDeferred.promise,
              close: function (result) {
                return $modalStack.close(modalInstance, result);
              },
              dismiss: function (reason) {
                return $modalStack.dismiss(modalInstance, reason);
              }
            };

            //merge and clean up options
            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
            modalOptions.resolve = modalOptions.resolve || {};
            modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

            //verify options
            if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
              throw new Error('One of component or template or templateUrl options is required.');
            }

            var templateAndResolvePromise;
            if (modalOptions.component) {
              templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
            } else {
              templateAndResolvePromise =
                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
            }

            function resolveWithTemplate() {
              return templateAndResolvePromise;
            }

            // Wait for the resolution of the existing promise chain.
            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
            // Then add to $modalStack and resolve opened.
            // Finally clean up the chain variable if no subsequent modal has overwritten it.
            var samePromise;
            samePromise = promiseChain = $q.all([promiseChain])
              .then(resolveWithTemplate, resolveWithTemplate)
              .then(function resolveSuccess(tplAndVars) {
                var providedScope = modalOptions.scope || $rootScope;

                var modalScope = providedScope.$new();
                modalScope.$close = modalInstance.close;
                modalScope.$dismiss = modalInstance.dismiss;

                modalScope.$on('$destroy', function() {
                  if (!modalScope.$$uibDestructionScheduled) {
                    modalScope.$dismiss('$uibUnscheduledDestruction');
                  }
                });

                var modal = {
                  scope: modalScope,
                  deferred: modalResultDeferred,
                  renderDeferred: modalRenderDeferred,
                  closedDeferred: modalClosedDeferred,
                  animation: modalOptions.animation,
                  backdrop: modalOptions.backdrop,
                  keyboard: modalOptions.keyboard,
                  backdropClass: modalOptions.backdropClass,
                  windowTopClass: modalOptions.windowTopClass,
                  windowClass: modalOptions.windowClass,
                  windowTemplateUrl: modalOptions.windowTemplateUrl,
                  ariaLabelledBy: modalOptions.ariaLabelledBy,
                  ariaDescribedBy: modalOptions.ariaDescribedBy,
                  size: modalOptions.size,
                  openedClass: modalOptions.openedClass,
                  appendTo: modalOptions.appendTo
                };

                var component = {};
                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};

                if (modalOptions.component) {
                  constructLocals(component, false, true, false);
                  component.name = modalOptions.component;
                  modal.component = component;
                } else if (modalOptions.controller) {
                  constructLocals(ctrlLocals, true, false, true);

                  // the third param will make the controller instantiate later,private api
                  // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
                  ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
                  if (modalOptions.controllerAs && modalOptions.bindToController) {
                    ctrlInstance = ctrlInstantiate.instance;
                    ctrlInstance.$close = modalScope.$close;
                    ctrlInstance.$dismiss = modalScope.$dismiss;
                    angular.extend(ctrlInstance, {
                      $resolve: ctrlLocals.$scope.$resolve
                    }, providedScope);
                  }

                  ctrlInstance = ctrlInstantiate();

                  if (angular.isFunction(ctrlInstance.$onInit)) {
                    ctrlInstance.$onInit();
                  }
                }

                if (!modalOptions.component) {
                  modal.content = tplAndVars[0];
                }

                $modalStack.open(modalInstance, modal);
                modalOpenedDeferred.resolve(true);

                function constructLocals(obj, template, instanceOnScope, injectable) {
                  obj.$scope = modalScope;
                  obj.$scope.$resolve = {};
                  if (instanceOnScope) {
                    obj.$scope.$uibModalInstance = modalInstance;
                  } else {
                    obj.$uibModalInstance = modalInstance;
                  }

                  var resolves = template ? tplAndVars[1] : tplAndVars;
                  angular.forEach(resolves, function(value, key) {
                    if (injectable) {
                      obj[key] = value;
                    }

                    obj.$scope.$resolve[key] = value;
                  });
                }
            }, function resolveError(reason) {
              modalOpenedDeferred.reject(reason);
              modalResultDeferred.reject(reason);
            })['finally'](function() {
              if (promiseChain === samePromise) {
                promiseChain = null;
              }
            });

            return modalInstance;
          };

          return $modal;
        }
      ]
    };

    return $modalProvider;
  });

angular.module('ui.bootstrap.paging', [])
/**
 * Helper internal service for generating common controller code between the
 * pager and pagination components
 */
.factory('uibPaging', ['$parse', function($parse) {
  return {
    create: function(ctrl, $scope, $attrs) {
      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
      ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
      ctrl._watchers = [];

      ctrl.init = function(ngModelCtrl, config) {
        ctrl.ngModelCtrl = ngModelCtrl;
        ctrl.config = config;

        ngModelCtrl.$render = function() {
          ctrl.render();
        };

        if ($attrs.itemsPerPage) {
          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function(value) {
            ctrl.itemsPerPage = parseInt(value, 10);
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }));
        } else {
          ctrl.itemsPerPage = config.itemsPerPage;
        }

        $scope.$watch('totalItems', function(newTotal, oldTotal) {
          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }
        });
      };

      ctrl.calculateTotalPages = function() {
        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
        return Math.max(totalPages || 0, 1);
      };

      ctrl.render = function() {
        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
      };

      $scope.selectPage = function(page, evt) {
        if (evt) {
          evt.preventDefault();
        }

        var clickAllowed = !$scope.ngDisabled || !evt;
        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
          if (evt && evt.target) {
            evt.target.blur();
          }
          ctrl.ngModelCtrl.$setViewValue(page);
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.getText = function(key) {
        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
      };

      $scope.noPrevious = function() {
        return $scope.page === 1;
      };

      $scope.noNext = function() {
        return $scope.page === $scope.totalPages;
      };

      ctrl.updatePage = function() {
        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

        if ($scope.page > $scope.totalPages) {
          $scope.selectPage($scope.totalPages);
        } else {
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.$on('$destroy', function() {
        while (ctrl._watchers.length) {
          ctrl._watchers.shift()();
        }
      });
    }
  };
}]);

angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])

.controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function($scope, $attrs, uibPaging, uibPagerConfig) {
  $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;

  uibPaging.create(this, $scope, $attrs);
}])

.constant('uibPagerConfig', {
  itemsPerPage: 10,
  previousText: '« Previous',
  nextText: 'Next »',
  align: true
})

.directive('uibPager', ['uibPagerConfig', function(uibPagerConfig) {
  return {
    scope: {
      totalItems: '=',
      previousText: '@',
      nextText: '@',
      ngDisabled: '='
    },
    require: ['uibPager', '?ngModel'],
    restrict: 'A',
    controller: 'UibPagerController',
    controllerAs: 'pager',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/pager/pager.html';
    },
    link: function(scope, element, attrs, ctrls) {
      element.addClass('pager');
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
        return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPagerConfig);
    }
  };
}]);

angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
.controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
  var ctrl = this;
  // Setup configuration parameters
  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
    rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
    forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
    boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
    pageLabel = angular.isDefined($attrs.pageLabel) ? function(idx) { return $scope.$parent.$eval($attrs.pageLabel, {$page: idx}); } : angular.identity;
  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;

  uibPaging.create(this, $scope, $attrs);

  if ($attrs.maxSize) {
    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function(value) {
      maxSize = parseInt(value, 10);
      ctrl.render();
    }));
  }

  // Create page object used in template
  function makePage(number, text, isActive) {
    return {
      number: number,
      text: text,
      active: isActive
    };
  }

  function getPages(currentPage, totalPages) {
    var pages = [];

    // Default page limits
    var startPage = 1, endPage = totalPages;
    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

    // recompute if maxSize
    if (isMaxSized) {
      if (rotate) {
        // Current page is displayed in the middle of the visible ones
        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
        endPage = startPage + maxSize - 1;

        // Adjust if limit is exceeded
        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = endPage - maxSize + 1;
        }
      } else {
        // Visible pages are paginated with maxSize
        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

        // Adjust last page if limit is exceeded
        endPage = Math.min(startPage + maxSize - 1, totalPages);
      }
    }

    // Add page number links
    for (var number = startPage; number <= endPage; number++) {
      var page = makePage(number, pageLabel(number), number === currentPage);
      pages.push(page);
    }

    // Add links to move between page sets
    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
      if (startPage > 1) {
        if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
        var previousPageSet = makePage(startPage - 1, '...', false);
        pages.unshift(previousPageSet);
      }
        if (boundaryLinkNumbers) {
          if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
            var secondPageLink = makePage(2, '2', false);
            pages.unshift(secondPageLink);
          }
          //add the first page
          var firstPageLink = makePage(1, '1', false);
          pages.unshift(firstPageLink);
        }
      }

      if (endPage < totalPages) {
        if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
        var nextPageSet = makePage(endPage + 1, '...', false);
        pages.push(nextPageSet);
      }
        if (boundaryLinkNumbers) {
          if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
            pages.push(secondToLastPageLink);
          }
          //add the last page
          var lastPageLink = makePage(totalPages, totalPages, false);
          pages.push(lastPageLink);
        }
      }
    }
    return pages;
  }

  var originalRender = this.render;
  this.render = function() {
    originalRender();
    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
      $scope.pages = getPages($scope.page, $scope.totalPages);
    }
  };
}])

.constant('uibPaginationConfig', {
  itemsPerPage: 10,
  boundaryLinks: false,
  boundaryLinkNumbers: false,
  directionLinks: true,
  firstText: 'First',
  previousText: 'Previous',
  nextText: 'Next',
  lastText: 'Last',
  rotate: true,
  forceEllipses: false
})

.directive('uibPagination', ['$parse', 'uibPaginationConfig', function($parse, uibPaginationConfig) {
  return {
    scope: {
      totalItems: '=',
      firstText: '@',
      previousText: '@',
      nextText: '@',
      lastText: '@',
      ngDisabled:'='
    },
    require: ['uibPagination', '?ngModel'],
    restrict: 'A',
    controller: 'UibPaginationController',
    controllerAs: 'pagination',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/pagination/pagination.html';
    },
    link: function(scope, element, attrs, ctrls) {
      element.addClass('pagination');
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
         return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
    }
  };
}]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])

/**
 * The $tooltip service creates tooltip- and popover-like directives as well as
 * houses global options for them.
 */
.provider('$uibTooltip', function() {
  // The default options tooltip and popover.
  var defaultOptions = {
    placement: 'top',
    placementClassPrefix: '',
    animation: true,
    popupDelay: 0,
    popupCloseDelay: 0,
    useContentExp: false
  };

  // Default hide triggers for each show trigger
  var triggerMap = {
    'mouseenter': 'mouseleave',
    'click': 'click',
    'outsideClick': 'outsideClick',
    'focus': 'blur',
    'none': ''
  };

  // The options specified to the provider globally.
  var globalOptions = {};

  /**
   * `options({})` allows global configuration of all tooltips in the
   * application.
   *
   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
   *     // place tooltips left instead of top by default
   *     $tooltipProvider.options( { placement: 'left' } );
   *   });
   */
	this.options = function(value) {
		angular.extend(globalOptions, value);
	};

  /**
   * This allows you to extend the set of trigger mappings available. E.g.:
   *
   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
   */
  this.setTriggers = function setTriggers(triggers) {
    angular.extend(triggerMap, triggers);
  };

  /**
   * This is a helper function for translating camel-case to snake_case.
   */
  function snake_case(name) {
    var regexp = /[A-Z]/g;
    var separator = '-';
    return name.replace(regexp, function(letter, pos) {
      return (pos ? separator : '') + letter.toLowerCase();
    });
  }

  /**
   * Returns the actual instance of the $tooltip service.
   * TODO support multiple triggers
   */
  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
    var openedTooltips = $$stackedMap.createNew();
    $document.on('keyup', keypressListener);

    $rootScope.$on('$destroy', function() {
      $document.off('keyup', keypressListener);
    });

    function keypressListener(e) {
      if (e.which === 27) {
        var last = openedTooltips.top();
        if (last) {
          last.value.close();
          last = null;
        }
      }
    }

    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
      options = angular.extend({}, defaultOptions, globalOptions, options);

      /**
       * Returns an object of show and hide triggers.
       *
       * If a trigger is supplied,
       * it is used to show the tooltip; otherwise, it will use the `trigger`
       * option passed to the `$tooltipProvider.options` method; else it will
       * default to the trigger supplied to this directive factory.
       *
       * The hide trigger is based on the show trigger. If the `trigger` option
       * was passed to the `$tooltipProvider.options` method, it will use the
       * mapped trigger from `triggerMap` or the passed trigger if the map is
       * undefined; otherwise, it uses the `triggerMap` value of the show
       * trigger; else it will just use the show trigger.
       */
      function getTriggers(trigger) {
        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
        var hide = show.map(function(trigger) {
          return triggerMap[trigger] || trigger;
        });
        return {
          show: show,
          hide: hide
        };
      }

      var directiveName = snake_case(ttType);

      var startSym = $interpolate.startSymbol();
      var endSym = $interpolate.endSymbol();
      var template =
        '<div '+ directiveName + '-popup ' +
          'uib-title="' + startSym + 'title' + endSym + '" ' +
          (options.useContentExp ?
            'content-exp="contentExp()" ' :
            'content="' + startSym + 'content' + endSym + '" ') +
          'origin-scope="origScope" ' +
          'class="uib-position-measure ' + prefix + '" ' +
          'tooltip-animation-class="fade"' +
          'uib-tooltip-classes ' +
          'ng-class="{ in: isOpen }" ' +
          '>' +
        '</div>';

      return {
        compile: function(tElem, tAttrs) {
          var tooltipLinker = $compile(template);

          return function link(scope, element, attrs, tooltipCtrl) {
            var tooltip;
            var tooltipLinkedScope;
            var transitionTimeout;
            var showTimeout;
            var hideTimeout;
            var positionTimeout;
            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
            var triggers = getTriggers(undefined);
            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
            var ttScope = scope.$new(true);
            var repositionScheduled = false;
            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
            var observers = [];
            var lastPlacement;

            var positionTooltip = function() {
              // check if tooltip exists and is not empty
              if (!tooltip || !tooltip.html()) { return; }

              if (!positionTimeout) {
                positionTimeout = $timeout(function() {
                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
                  var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                  var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
                  var placementClasses = ttPosition.placement.split('-');

                  if (!tooltip.hasClass(placementClasses[0])) {
                    tooltip.removeClass(lastPlacement.split('-')[0]);
                    tooltip.addClass(placementClasses[0]);
                  }

                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
                  }

                  $timeout(function() {
                    var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                    var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
                    if (adjustment) {
                      tooltip.css(adjustment);
                    }
                  }, 0, false);

                  // first time through tt element will have the
                  // uib-position-measure class or if the placement
                  // has changed we need to position the arrow.
                  if (tooltip.hasClass('uib-position-measure')) {
                    $position.positionArrow(tooltip, ttPosition.placement);
                    tooltip.removeClass('uib-position-measure');
                  } else if (lastPlacement !== ttPosition.placement) {
                    $position.positionArrow(tooltip, ttPosition.placement);
                  }
                  lastPlacement = ttPosition.placement;

                  positionTimeout = null;
                }, 0, false);
              }
            };

            // Set up the correct scope to allow transclusion later
            ttScope.origScope = scope;

            // By default, the tooltip is not open.
            // TODO add ability to start tooltip opened
            ttScope.isOpen = false;

            function toggleTooltipBind() {
              if (!ttScope.isOpen) {
                showTooltipBind();
              } else {
                hideTooltipBind();
              }
            }

            // Show the tooltip with delay if specified, otherwise show it immediately
            function showTooltipBind() {
              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                return;
              }

              cancelHide();
              prepareTooltip();

              if (ttScope.popupDelay) {
                // Do nothing if the tooltip was already scheduled to pop-up.
                // This happens if show is triggered multiple times before any hide is triggered.
                if (!showTimeout) {
                  showTimeout = $timeout(show, ttScope.popupDelay, false);
                }
              } else {
                show();
              }
            }

            function hideTooltipBind() {
              cancelShow();

              if (ttScope.popupCloseDelay) {
                if (!hideTimeout) {
                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
                }
              } else {
                hide();
              }
            }

            // Show the tooltip popup element.
            function show() {
              cancelShow();
              cancelHide();

              // Don't show empty tooltips.
              if (!ttScope.content) {
                return angular.noop;
              }

              createTooltip();

              // And show the tooltip.
              ttScope.$evalAsync(function() {
                ttScope.isOpen = true;
                assignIsOpen(true);
                positionTooltip();
              });
            }

            function cancelShow() {
              if (showTimeout) {
                $timeout.cancel(showTimeout);
                showTimeout = null;
              }

              if (positionTimeout) {
                $timeout.cancel(positionTimeout);
                positionTimeout = null;
              }
            }

            // Hide the tooltip popup element.
            function hide() {
              if (!ttScope) {
                return;
              }

              // First things first: we don't show it anymore.
              ttScope.$evalAsync(function() {
                if (ttScope) {
                  ttScope.isOpen = false;
                  assignIsOpen(false);
                  // And now we remove it from the DOM. However, if we have animation, we
                  // need to wait for it to expire beforehand.
                  // FIXME: this is a placeholder for a port of the transitions library.
                  // The fade transition in TWBS is 150ms.
                  if (ttScope.animation) {
                    if (!transitionTimeout) {
                      transitionTimeout = $timeout(removeTooltip, 150, false);
                    }
                  } else {
                    removeTooltip();
                  }
                }
              });
            }

            function cancelHide() {
              if (hideTimeout) {
                $timeout.cancel(hideTimeout);
                hideTimeout = null;
              }

              if (transitionTimeout) {
                $timeout.cancel(transitionTimeout);
                transitionTimeout = null;
              }
            }

            function createTooltip() {
              // There can only be one tooltip element per directive shown at once.
              if (tooltip) {
                return;
              }

              tooltipLinkedScope = ttScope.$new();
              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
                if (appendToBody) {
                  $document.find('body').append(tooltip);
                } else {
                  element.after(tooltip);
                }
              });

              openedTooltips.add(ttScope, {
                close: hide
              });

              prepObservers();
            }

            function removeTooltip() {
              cancelShow();
              cancelHide();
              unregisterObservers();

              if (tooltip) {
                tooltip.remove();
                tooltip = null;
              }

              openedTooltips.remove(ttScope);
              
              if (tooltipLinkedScope) {
                tooltipLinkedScope.$destroy();
                tooltipLinkedScope = null;
              }
            }

            /**
             * Set the initial scope values. Once
             * the tooltip is created, the observers
             * will be added to keep things in sync.
             */
            function prepareTooltip() {
              ttScope.title = attrs[prefix + 'Title'];
              if (contentParse) {
                ttScope.content = contentParse(scope);
              } else {
                ttScope.content = attrs[ttType];
              }

              ttScope.popupClass = attrs[prefix + 'Class'];
              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
              var placement = $position.parsePlacement(ttScope.placement);
              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];

              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
            }

            function assignIsOpen(isOpen) {
              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
                isOpenParse.assign(scope, isOpen);
              }
            }

            ttScope.contentExp = function() {
              return ttScope.content;
            };

            /**
             * Observe the relevant attributes.
             */
            attrs.$observe('disabled', function(val) {
              if (val) {
                cancelShow();
              }

              if (val && ttScope.isOpen) {
                hide();
              }
            });

            if (isOpenParse) {
              scope.$watch(isOpenParse, function(val) {
                if (ttScope && !val === ttScope.isOpen) {
                  toggleTooltipBind();
                }
              });
            }

            function prepObservers() {
              observers.length = 0;

              if (contentParse) {
                observers.push(
                  scope.$watch(contentParse, function(val) {
                    ttScope.content = val;
                    if (!val && ttScope.isOpen) {
                      hide();
                    }
                  })
                );

                observers.push(
                  tooltipLinkedScope.$watch(function() {
                    if (!repositionScheduled) {
                      repositionScheduled = true;
                      tooltipLinkedScope.$$postDigest(function() {
                        repositionScheduled = false;
                        if (ttScope && ttScope.isOpen) {
                          positionTooltip();
                        }
                      });
                    }
                  })
                );
              } else {
                observers.push(
                  attrs.$observe(ttType, function(val) {
                    ttScope.content = val;
                    if (!val && ttScope.isOpen) {
                      hide();
                    } else {
                      positionTooltip();
                    }
                  })
                );
              }

              observers.push(
                attrs.$observe(prefix + 'Title', function(val) {
                  ttScope.title = val;
                  if (ttScope.isOpen) {
                    positionTooltip();
                  }
                })
              );

              observers.push(
                attrs.$observe(prefix + 'Placement', function(val) {
                  ttScope.placement = val ? val : options.placement;
                  if (ttScope.isOpen) {
                    positionTooltip();
                  }
                })
              );
            }

            function unregisterObservers() {
              if (observers.length) {
                angular.forEach(observers, function(observer) {
                  observer();
                });
                observers.length = 0;
              }
            }

            // hide tooltips/popovers for outsideClick trigger
            function bodyHideTooltipBind(e) {
              if (!ttScope || !ttScope.isOpen || !tooltip) {
                return;
              }
              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
                hideTooltipBind();
              }
            }

            var unregisterTriggers = function() {
              triggers.show.forEach(function(trigger) {
                if (trigger === 'outsideClick') {
                  element.off('click', toggleTooltipBind);
                } else {
                  element.off(trigger, showTooltipBind);
                  element.off(trigger, toggleTooltipBind);
                }
              });
              triggers.hide.forEach(function(trigger) {
                if (trigger === 'outsideClick') {
                  $document.off('click', bodyHideTooltipBind);
                } else {
                  element.off(trigger, hideTooltipBind);
                }
              });
            };

            function prepTriggers() {
              var showTriggers = [], hideTriggers = [];
              var val = scope.$eval(attrs[prefix + 'Trigger']);
              unregisterTriggers();

              if (angular.isObject(val)) {
                Object.keys(val).forEach(function(key) {
                  showTriggers.push(key);
                  hideTriggers.push(val[key]);
                });
                triggers = {
                  show: showTriggers,
                  hide: hideTriggers
                };
              } else {
                triggers = getTriggers(val);
              }

              if (triggers.show !== 'none') {
                triggers.show.forEach(function(trigger, idx) {
                  if (trigger === 'outsideClick') {
                    element.on('click', toggleTooltipBind);
                    $document.on('click', bodyHideTooltipBind);
                  } else if (trigger === triggers.hide[idx]) {
                    element.on(trigger, toggleTooltipBind);
                  } else if (trigger) {
                    element.on(trigger, showTooltipBind);
                    element.on(triggers.hide[idx], hideTooltipBind);
                  }

                  element.on('keypress', function(e) {
                    if (e.which === 27) {
                      hideTooltipBind();
                    }
                  });
                });
              }
            }

            prepTriggers();

            var animation = scope.$eval(attrs[prefix + 'Animation']);
            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;

            var appendToBodyVal;
            var appendKey = prefix + 'AppendToBody';
            if (appendKey in attrs && attrs[appendKey] === undefined) {
              appendToBodyVal = true;
            } else {
              appendToBodyVal = scope.$eval(attrs[appendKey]);
            }

            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

            // Make sure tooltip is destroyed and removed.
            scope.$on('$destroy', function onDestroyTooltip() {
              unregisterTriggers();
              removeTooltip();
              ttScope = null;
            });
          };
        }
      };
    };
  }];
})

// This is mostly ngInclude code but with a custom scope
.directive('uibTooltipTemplateTransclude', [
         '$animate', '$sce', '$compile', '$templateRequest',
function ($animate, $sce, $compile, $templateRequest) {
  return {
    link: function(scope, elem, attrs) {
      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);

      var changeCounter = 0,
        currentScope,
        previousElement,
        currentElement;

      var cleanupLastIncludeContent = function() {
        if (previousElement) {
          previousElement.remove();
          previousElement = null;
        }

        if (currentScope) {
          currentScope.$destroy();
          currentScope = null;
        }

        if (currentElement) {
          $animate.leave(currentElement).then(function() {
            previousElement = null;
          });
          previousElement = currentElement;
          currentElement = null;
        }
      };

      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function(src) {
        var thisChangeId = ++changeCounter;

        if (src) {
          //set the 2nd param to true to ignore the template request error so that the inner
          //contents and scope can be cleaned up.
          $templateRequest(src, true).then(function(response) {
            if (thisChangeId !== changeCounter) { return; }
            var newScope = origScope.$new();
            var template = response;

            var clone = $compile(template)(newScope, function(clone) {
              cleanupLastIncludeContent();
              $animate.enter(clone, elem);
            });

            currentScope = newScope;
            currentElement = clone;

            currentScope.$emit('$includeContentLoaded', src);
          }, function() {
            if (thisChangeId === changeCounter) {
              cleanupLastIncludeContent();
              scope.$emit('$includeContentError', src);
            }
          });
          scope.$emit('$includeContentRequested', src);
        } else {
          cleanupLastIncludeContent();
        }
      });

      scope.$on('$destroy', cleanupLastIncludeContent);
    }
  };
}])

/**
 * Note that it's intentional that these classes are *not* applied through $animate.
 * They must not be animated as they're expected to be present on the tooltip on
 * initialization.
 */
.directive('uibTooltipClasses', ['$uibPosition', function($uibPosition) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      // need to set the primary position so the
      // arrow has space during position measure.
      // tooltip.positionTooltip()
      if (scope.placement) {
        // // There are no top-left etc... classes
        // // in TWBS, so we need the primary position.
        var position = $uibPosition.parsePlacement(scope.placement);
        element.addClass(position[0]);
      }

      if (scope.popupClass) {
        element.addClass(scope.popupClass);
      }

      if (scope.animation) {
        element.addClass(attrs.tooltipAnimationClass);
      }
    }
  };
}])

.directive('uibTooltipPopup', function() {
  return {
    restrict: 'A',
    scope: { content: '@' },
    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
  };
})

.directive('uibTooltip', [ '$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
}])

.directive('uibTooltipTemplatePopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&', originScope: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
  };
})

.directive('uibTooltipTemplate', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}])

.directive('uibTooltipHtmlPopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
  };
})

.directive('uibTooltipHtml', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, and selector delegatation.
 */
angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])

.directive('uibPopoverTemplatePopup', function() {
  return {
    restrict: 'A',
    scope: { uibTitle: '@', contentExp: '&', originScope: '&' },
    templateUrl: 'uib/template/popover/popover-template.html'
  };
})

.directive('uibPopoverTemplate', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('uibPopoverHtmlPopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&', uibTitle: '@' },
    templateUrl: 'uib/template/popover/popover-html.html'
  };
})

.directive('uibPopoverHtml', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('uibPopoverPopup', function() {
  return {
    restrict: 'A',
    scope: { uibTitle: '@', content: '@' },
    templateUrl: 'uib/template/popover/popover.html'
  };
})

.directive('uibPopover', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopover', 'popover', 'click');
}]);

angular.module('ui.bootstrap.progressbar', [])

.constant('uibProgressConfig', {
  animate: true,
  max: 100
})

.controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function($scope, $attrs, progressConfig) {
  var self = this,
      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;

  this.bars = [];
  $scope.max = getMaxOrDefault();

  this.addBar = function(bar, element, attrs) {
    if (!animate) {
      element.css({'transition': 'none'});
    }

    this.bars.push(bar);

    bar.max = getMaxOrDefault();
    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';

    bar.$watch('value', function(value) {
      bar.recalculatePercentage();
    });

    bar.recalculatePercentage = function() {
      var totalPercentage = self.bars.reduce(function(total, bar) {
        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
        return total + bar.percent;
      }, 0);

      if (totalPercentage > 100) {
        bar.percent -= totalPercentage - 100;
      }
    };

    bar.$on('$destroy', function() {
      element = null;
      self.removeBar(bar);
    });
  };

  this.removeBar = function(bar) {
    this.bars.splice(this.bars.indexOf(bar), 1);
    this.bars.forEach(function (bar) {
      bar.recalculatePercentage();
    });
  };

  //$attrs.$observe('maxParam', function(maxParam) {
  $scope.$watch('maxParam', function(maxParam) {
    self.bars.forEach(function(bar) {
      bar.max = getMaxOrDefault();
      bar.recalculatePercentage();
    });
  });

  function getMaxOrDefault () {
    return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
  }
}])

.directive('uibProgress', function() {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    require: 'uibProgress',
    scope: {
      maxParam: '=?max'
    },
    templateUrl: 'uib/template/progressbar/progress.html'
  };
})

.directive('uibBar', function() {
  return {
    replace: true,
    transclude: true,
    require: '^uibProgress',
    scope: {
      value: '=',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/bar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, element, attrs);
    }
  };
})

.directive('uibProgressbar', function() {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    scope: {
      value: '=',
      maxParam: '=?max',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/progressbar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, angular.element(element.children()[0]), {title: attrs.title});
    }
  };
});

angular.module('ui.bootstrap.rating', [])

.constant('uibRatingConfig', {
  max: 5,
  stateOn: null,
  stateOff: null,
  enableReset: true,
  titles: ['one', 'two', 'three', 'four', 'five']
})

.controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function($scope, $attrs, ratingConfig) {
  var ngModelCtrl = { $setViewValue: angular.noop },
    self = this;

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.push(function(value) {
      if (angular.isNumber(value) && value << 0 !== value) {
        value = Math.round(value);
      }

      return value;
    });

    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
    this.enableReset = angular.isDefined($attrs.enableReset) ?
      $scope.$parent.$eval($attrs.enableReset) : ratingConfig.enableReset;
    var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
      tmpTitles : ratingConfig.titles;

    var ratingStates = angular.isDefined($attrs.ratingStates) ?
      $scope.$parent.$eval($attrs.ratingStates) :
      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
    $scope.range = this.buildTemplateObjects(ratingStates);
  };

  this.buildTemplateObjects = function(states) {
    for (var i = 0, n = states.length; i < n; i++) {
      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
    }
    return states;
  };

  this.getTitle = function(index) {
    if (index >= this.titles.length) {
      return index + 1;
    }

    return this.titles[index];
  };

  $scope.rate = function(value) {
    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
      var newViewValue = self.enableReset && ngModelCtrl.$viewValue === value ? 0 : value;
      ngModelCtrl.$setViewValue(newViewValue);
      ngModelCtrl.$render();
    }
  };

  $scope.enter = function(value) {
    if (!$scope.readonly) {
      $scope.value = value;
    }
    $scope.onHover({value: value});
  };

  $scope.reset = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.onLeave();
  };

  $scope.onKeydown = function(evt) {
    if (/(37|38|39|40)/.test(evt.which)) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
    }
  };

  this.render = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.title = self.getTitle($scope.value - 1);
  };
}])

.directive('uibRating', function() {
  return {
    require: ['uibRating', 'ngModel'],
    restrict: 'A',
    scope: {
      readonly: '=?readOnly',
      onHover: '&',
      onLeave: '&'
    },
    controller: 'UibRatingController',
    templateUrl: 'uib/template/rating/rating.html',
    link: function(scope, element, attrs, ctrls) {
      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
      ratingCtrl.init(ngModelCtrl);
    }
  };
});

angular.module('ui.bootstrap.tabs', [])

.controller('UibTabsetController', ['$scope', function ($scope) {
  var ctrl = this,
    oldIndex;
  ctrl.tabs = [];

  ctrl.select = function(index, evt) {
    if (!destroyed) {
      var previousIndex = findTabIndex(oldIndex);
      var previousSelected = ctrl.tabs[previousIndex];
      if (previousSelected) {
        previousSelected.tab.onDeselect({
          $event: evt,
          $selectedIndex: index
        });
        if (evt && evt.isDefaultPrevented()) {
          return;
        }
        previousSelected.tab.active = false;
      }

      var selected = ctrl.tabs[index];
      if (selected) {
        selected.tab.onSelect({
          $event: evt
        });
        selected.tab.active = true;
        ctrl.active = selected.index;
        oldIndex = selected.index;
      } else if (!selected && angular.isDefined(oldIndex)) {
        ctrl.active = null;
        oldIndex = null;
      }
    }
  };

  ctrl.addTab = function addTab(tab) {
    ctrl.tabs.push({
      tab: tab,
      index: tab.index
    });
    ctrl.tabs.sort(function(t1, t2) {
      if (t1.index > t2.index) {
        return 1;
      }

      if (t1.index < t2.index) {
        return -1;
      }

      return 0;
    });

    if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
      var newActiveIndex = findTabIndex(tab.index);
      ctrl.select(newActiveIndex);
    }
  };

  ctrl.removeTab = function removeTab(tab) {
    var index;
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].tab === tab) {
        index = i;
        break;
      }
    }

    if (ctrl.tabs[index].index === ctrl.active) {
      var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
        index - 1 : index + 1 % ctrl.tabs.length;
      ctrl.select(newActiveTabIndex);
    }

    ctrl.tabs.splice(index, 1);
  };

  $scope.$watch('tabset.active', function(val) {
    if (angular.isDefined(val) && val !== oldIndex) {
      ctrl.select(findTabIndex(val));
    }
  });

  var destroyed;
  $scope.$on('$destroy', function() {
    destroyed = true;
  });

  function findTabIndex(index) {
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].index === index) {
        return i;
      }
    }
  }
}])

.directive('uibTabset', function() {
  return {
    transclude: true,
    replace: true,
    scope: {},
    bindToController: {
      active: '=?',
      type: '@'
    },
    controller: 'UibTabsetController',
    controllerAs: 'tabset',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/tabs/tabset.html';
    },
    link: function(scope, element, attrs) {
      scope.vertical = angular.isDefined(attrs.vertical) ?
        scope.$parent.$eval(attrs.vertical) : false;
      scope.justified = angular.isDefined(attrs.justified) ?
        scope.$parent.$eval(attrs.justified) : false;
    }
  };
})

.directive('uibTab', ['$parse', function($parse) {
  return {
    require: '^uibTabset',
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/tabs/tab.html';
    },
    transclude: true,
    scope: {
      heading: '@',
      index: '=?',
      classes: '@?',
      onSelect: '&select', //This callback is called in contentHeadingTransclude
                          //once it inserts the tab's content into the dom
      onDeselect: '&deselect'
    },
    controller: function() {
      //Empty controller so other directives can require being 'under' a tab
    },
    controllerAs: 'tab',
    link: function(scope, elm, attrs, tabsetCtrl, transclude) {
      scope.disabled = false;
      if (attrs.disable) {
        scope.$parent.$watch($parse(attrs.disable), function(value) {
          scope.disabled = !! value;
        });
      }

      if (angular.isUndefined(attrs.index)) {
        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function(t) { return t.index; })) + 1;
        } else {
          scope.index = 0;
        }
      }

      if (angular.isUndefined(attrs.classes)) {
        scope.classes = '';
      }

      scope.select = function(evt) {
        if (!scope.disabled) {
          var index;
          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
            if (tabsetCtrl.tabs[i].tab === scope) {
              index = i;
              break;
            }
          }

          tabsetCtrl.select(index, evt);
        }
      };

      tabsetCtrl.addTab(scope);
      scope.$on('$destroy', function() {
        tabsetCtrl.removeTab(scope);
      });

      //We need to transclude later, once the content container is ready.
      //when this link happens, we're inside a tab heading.
      scope.$transcludeFn = transclude;
    }
  };
}])

.directive('uibTabHeadingTransclude', function() {
  return {
    restrict: 'A',
    require: '^uibTab',
    link: function(scope, elm) {
      scope.$watch('headingElement', function updateHeadingElement(heading) {
        if (heading) {
          elm.html('');
          elm.append(heading);
        }
      });
    }
  };
})

.directive('uibTabContentTransclude', function() {
  return {
    restrict: 'A',
    require: '^uibTabset',
    link: function(scope, elm, attrs) {
      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;

      //Now our tab is ready to be transcluded: both the tab heading area
      //and the tab content area are loaded.  Transclude 'em both.
      tab.$transcludeFn(tab.$parent, function(contents) {
        angular.forEach(contents, function(node) {
          if (isTabHeading(node)) {
            //Let tabHeadingTransclude know.
            tab.headingElement = node;
          } else {
            elm.append(node);
          }
        });
      });
    }
  };

  function isTabHeading(node) {
    return node.tagName && (
      node.hasAttribute('uib-tab-heading') ||
      node.hasAttribute('data-uib-tab-heading') ||
      node.hasAttribute('x-uib-tab-heading') ||
      node.tagName.toLowerCase() === 'uib-tab-heading' ||
      node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
      node.tagName.toLowerCase() === 'x-uib-tab-heading' ||
      node.tagName.toLowerCase() === 'uib:tab-heading'
    );
  }
});

angular.module('ui.bootstrap.timepicker', [])

.constant('uibTimepickerConfig', {
  hourStep: 1,
  minuteStep: 1,
  secondStep: 1,
  showMeridian: true,
  showSeconds: false,
  meridians: null,
  readonlyInput: false,
  mousewheel: true,
  arrowkeys: true,
  showSpinners: true,
  templateUrl: 'uib/template/timepicker/timepicker.html'
})

.controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
  var selected = new Date(),
    watchers = [],
    ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
    meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
    padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;

  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
  $element.removeAttr('tabindex');

  this.init = function(ngModelCtrl_, inputs) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.unshift(function(modelValue) {
      return modelValue ? new Date(modelValue) : null;
    });

    var hoursInputEl = inputs.eq(0),
        minutesInputEl = inputs.eq(1),
        secondsInputEl = inputs.eq(2);

    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;

    if (mousewheel) {
      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
    if (arrowkeys) {
      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
  };

  var hourStep = timepickerConfig.hourStep;
  if ($attrs.hourStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function(value) {
      hourStep = +value;
    }));
  }

  var minuteStep = timepickerConfig.minuteStep;
  if ($attrs.minuteStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
      minuteStep = +value;
    }));
  }

  var min;
  watchers.push($scope.$parent.$watch($parse($attrs.min), function(value) {
    var dt = new Date(value);
    min = isNaN(dt) ? undefined : dt;
  }));

  var max;
  watchers.push($scope.$parent.$watch($parse($attrs.max), function(value) {
    var dt = new Date(value);
    max = isNaN(dt) ? undefined : dt;
  }));

  var disabled = false;
  if ($attrs.ngDisabled) {
    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(value) {
      disabled = value;
    }));
  }

  $scope.noIncrementHours = function() {
    var incrementedSelected = addMinutes(selected, hourStep * 60);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementHours = function() {
    var decrementedSelected = addMinutes(selected, -hourStep * 60);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementMinutes = function() {
    var incrementedSelected = addMinutes(selected, minuteStep);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementMinutes = function() {
    var decrementedSelected = addMinutes(selected, -minuteStep);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementSeconds = function() {
    var incrementedSelected = addSeconds(selected, secondStep);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementSeconds = function() {
    var decrementedSelected = addSeconds(selected, -secondStep);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noToggleMeridian = function() {
    if (selected.getHours() < 12) {
      return disabled || addMinutes(selected, 12 * 60) > max;
    }

    return disabled || addMinutes(selected, -12 * 60) < min;
  };

  var secondStep = timepickerConfig.secondStep;
  if ($attrs.secondStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function(value) {
      secondStep = +value;
    }));
  }

  $scope.showSeconds = timepickerConfig.showSeconds;
  if ($attrs.showSeconds) {
    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function(value) {
      $scope.showSeconds = !!value;
    }));
  }

  // 12H / 24H mode
  $scope.showMeridian = timepickerConfig.showMeridian;
  if ($attrs.showMeridian) {
    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
      $scope.showMeridian = !!value;

      if (ngModelCtrl.$error.time) {
        // Evaluate from template
        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
          selected.setHours(hours);
          refresh();
        }
      } else {
        updateTemplate();
      }
    }));
  }

  // Get $scope.hours in 24H mode if valid
  function getHoursFromTemplate() {
    var hours = +$scope.hours;
    var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
      hours >= 0 && hours < 24;
    if (!valid || $scope.hours === '') {
      return undefined;
    }

    if ($scope.showMeridian) {
      if (hours === 12) {
        hours = 0;
      }
      if ($scope.meridian === meridians[1]) {
        hours = hours + 12;
      }
    }
    return hours;
  }

  function getMinutesFromTemplate() {
    var minutes = +$scope.minutes;
    var valid = minutes >= 0 && minutes < 60;
    if (!valid || $scope.minutes === '') {
      return undefined;
    }
    return minutes;
  }

  function getSecondsFromTemplate() {
    var seconds = +$scope.seconds;
    return seconds >= 0 && seconds < 60 ? seconds : undefined;
  }

  function pad(value, noPad) {
    if (value === null) {
      return '';
    }

    return angular.isDefined(value) && value.toString().length < 2 && !noPad ?
      '0' + value : value.toString();
  }

  // Respond on mousewheel spin
  this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    var isScrollingUp = function(e) {
      if (e.originalEvent) {
        e = e.originalEvent;
      }
      //pick correct delta variable depending on event
      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
      return e.detail || delta > 0;
    };

    hoursInputEl.bind('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
      }
      e.preventDefault();
    });

    minutesInputEl.bind('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
      }
      e.preventDefault();
    });

     secondsInputEl.bind('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
      }
      e.preventDefault();
    });
  };

  // Respond on up/down arrowkeys
  this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    hoursInputEl.bind('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementHours();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementHours();
          $scope.$apply();
        }
      }
    });

    minutesInputEl.bind('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementMinutes();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementMinutes();
          $scope.$apply();
        }
      }
    });

    secondsInputEl.bind('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementSeconds();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementSeconds();
          $scope.$apply();
        }
      }
    });
  };

  this.setupInputEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    if ($scope.readonlyInput) {
      $scope.updateHours = angular.noop;
      $scope.updateMinutes = angular.noop;
      $scope.updateSeconds = angular.noop;
      return;
    }

    var invalidate = function(invalidHours, invalidMinutes, invalidSeconds) {
      ngModelCtrl.$setViewValue(null);
      ngModelCtrl.$setValidity('time', false);
      if (angular.isDefined(invalidHours)) {
        $scope.invalidHours = invalidHours;
      }

      if (angular.isDefined(invalidMinutes)) {
        $scope.invalidMinutes = invalidMinutes;
      }

      if (angular.isDefined(invalidSeconds)) {
        $scope.invalidSeconds = invalidSeconds;
      }
    };

    $scope.updateHours = function() {
      var hours = getHoursFromTemplate(),
        minutes = getMinutesFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(true);
        } else {
          refresh('h');
        }
      } else {
        invalidate(true);
      }
    };

    hoursInputEl.bind('blur', function(e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.hours === null || $scope.hours === '') {
        invalidate(true);
      } else if (!$scope.invalidHours && $scope.hours < 10) {
        $scope.$apply(function() {
          $scope.hours = pad($scope.hours, !padHours);
        });
      }
    });

    $scope.updateMinutes = function() {
      var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(undefined, true);
        } else {
          refresh('m');
        }
      } else {
        invalidate(undefined, true);
      }
    };

    minutesInputEl.bind('blur', function(e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.minutes === null) {
        invalidate(undefined, true);
      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
        $scope.$apply(function() {
          $scope.minutes = pad($scope.minutes);
        });
      }
    });

    $scope.updateSeconds = function() {
      var seconds = getSecondsFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(seconds)) {
        selected.setSeconds(seconds);
        refresh('s');
      } else {
        invalidate(undefined, undefined, true);
      }
    };

    secondsInputEl.bind('blur', function(e) {
      if (modelIsEmpty()) {
        makeValid();
      } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
        $scope.$apply( function() {
          $scope.seconds = pad($scope.seconds);
        });
      }
    });

  };

  this.render = function() {
    var date = ngModelCtrl.$viewValue;

    if (isNaN(date)) {
      ngModelCtrl.$setValidity('time', false);
      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
    } else {
      if (date) {
        selected = date;
      }

      if (selected < min || selected > max) {
        ngModelCtrl.$setValidity('time', false);
        $scope.invalidHours = true;
        $scope.invalidMinutes = true;
      } else {
        makeValid();
      }
      updateTemplate();
    }
  };

  // Call internally when we know that model is valid.
  function refresh(keyboardChange) {
    makeValid();
    ngModelCtrl.$setViewValue(new Date(selected));
    updateTemplate(keyboardChange);
  }

  function makeValid() {
    ngModelCtrl.$setValidity('time', true);
    $scope.invalidHours = false;
    $scope.invalidMinutes = false;
    $scope.invalidSeconds = false;
  }

  function updateTemplate(keyboardChange) {
    if (!ngModelCtrl.$modelValue) {
      $scope.hours = null;
      $scope.minutes = null;
      $scope.seconds = null;
      $scope.meridian = meridians[0];
    } else {
      var hours = selected.getHours(),
        minutes = selected.getMinutes(),
        seconds = selected.getSeconds();

      if ($scope.showMeridian) {
        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
      }

      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
      if (keyboardChange !== 'm') {
        $scope.minutes = pad(minutes);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];

      if (keyboardChange !== 's') {
        $scope.seconds = pad(seconds);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
    }
  }

  function addSecondsToSelected(seconds) {
    selected = addSeconds(selected, seconds);
    refresh();
  }

  function addMinutes(selected, minutes) {
    return addSeconds(selected, minutes*60);
  }

  function addSeconds(date, seconds) {
    var dt = new Date(date.getTime() + seconds * 1000);
    var newDate = new Date(date);
    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
    return newDate;
  }

  function modelIsEmpty() {
    return ($scope.hours === null || $scope.hours === '') &&
      ($scope.minutes === null || $scope.minutes === '') &&
      (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
  }

  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
    $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;

  $scope.incrementHours = function() {
    if (!$scope.noIncrementHours()) {
      addSecondsToSelected(hourStep * 60 * 60);
    }
  };

  $scope.decrementHours = function() {
    if (!$scope.noDecrementHours()) {
      addSecondsToSelected(-hourStep * 60 * 60);
    }
  };

  $scope.incrementMinutes = function() {
    if (!$scope.noIncrementMinutes()) {
      addSecondsToSelected(minuteStep * 60);
    }
  };

  $scope.decrementMinutes = function() {
    if (!$scope.noDecrementMinutes()) {
      addSecondsToSelected(-minuteStep * 60);
    }
  };

  $scope.incrementSeconds = function() {
    if (!$scope.noIncrementSeconds()) {
      addSecondsToSelected(secondStep);
    }
  };

  $scope.decrementSeconds = function() {
    if (!$scope.noDecrementSeconds()) {
      addSecondsToSelected(-secondStep);
    }
  };

  $scope.toggleMeridian = function() {
    var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

    if (!$scope.noToggleMeridian()) {
      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
      } else {
        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
      }
    }
  };

  $scope.blur = function() {
    ngModelCtrl.$setTouched();
  };

  $scope.$on('$destroy', function() {
    while (watchers.length) {
      watchers.shift()();
    }
  });
}])

.directive('uibTimepicker', ['uibTimepickerConfig', function(uibTimepickerConfig) {
  return {
    require: ['uibTimepicker', '?^ngModel'],
    restrict: 'A',
    controller: 'UibTimepickerController',
    controllerAs: 'timepicker',
    scope: {},
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
    },
    link: function(scope, element, attrs, ctrls) {
      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (ngModelCtrl) {
        timepickerCtrl.init(ngModelCtrl, element.find('input'));
      }
    }
  };
}]);

angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
  .factory('uibTypeaheadParser', ['$parse', function($parse) {
    //                      000001111111100000000000002222222200000000000000003333333333333330000000000044444444000
    var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
    return {
      parse: function(input) {
        var match = input.match(TYPEAHEAD_REGEXP);
        if (!match) {
          throw new Error(
            'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
              ' but got "' + input + '".');
        }

        return {
          itemName: match[3],
          source: $parse(match[4]),
          viewMapper: $parse(match[2] || match[1]),
          modelMapper: $parse(match[1])
        };
      }
    };
  }])

  .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
    function(originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
    var HOT_KEYS = [9, 13, 27, 38, 40];
    var eventDebounceTime = 200;
    var modelCtrl, ngModelOptions;
    //SUPPORTED ATTRIBUTES (OPTIONS)

    //minimal no of characters that needs to be entered before typeahead kicks-in
    var minLength = originalScope.$eval(attrs.typeaheadMinLength);
    if (!minLength && minLength !== 0) {
      minLength = 1;
    }

    originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
        minLength = !newVal && newVal !== 0 ? 1 : newVal;
    });

    //minimal wait time after last character typed before typeahead kicks-in
    var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

    //should it restrict model values to the ones selected from the popup only?
    var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
    originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
      isEditable = newVal !== false;
    });

    //binding to a variable that indicates if matches are being retrieved asynchronously
    var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

    //a function to determine if an event should cause selection
    var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function(scope, vals) {
      var evt = vals.$event;
      return evt.which === 13 || evt.which === 9;
    };

    //a callback executed when a match is selected
    var onSelectCallback = $parse(attrs.typeaheadOnSelect);

    //should it select highlighted popup value when losing focus?
    var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

    //binding to a variable that indicates if there were no results after the query is completed
    var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

    var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

    var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

    var appendTo = attrs.typeaheadAppendTo ?
      originalScope.$eval(attrs.typeaheadAppendTo) : null;

    var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

    //If input matches an item of the list exactly, select it automatically
    var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

    //binding to a variable that indicates if dropdown is open
    var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;

    var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

    //INTERNAL VARIABLES

    //model setter executed upon match selection
    var parsedModel = $parse(attrs.ngModel);
    var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
    var $setModelValue = function(scope, newValue) {
      if (angular.isFunction(parsedModel(originalScope)) &&
        ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {
        return invokeModelSetter(scope, {$$$p: newValue});
      }

      return parsedModel.assign(scope, newValue);
    };

    //expressions used by typeahead
    var parserResult = typeaheadParser.parse(attrs.uibTypeahead);

    var hasFocus;

    //Used to avoid bug in iOS webview where iOS keyboard does not fire
    //mousedown & mouseup events
    //Issue #3699
    var selected;

    //create a child scope for the typeahead directive so we are not polluting original scope
    //with typeahead-specific data (matches, query etc.)
    var scope = originalScope.$new();
    var offDestroy = originalScope.$on('$destroy', function() {
      scope.$destroy();
    });
    scope.$on('$destroy', offDestroy);

    // WAI-ARIA
    var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
    element.attr({
      'aria-autocomplete': 'list',
      'aria-expanded': false,
      'aria-owns': popupId
    });

    var inputsContainer, hintInputElem;
    //add read-only input to show hint
    if (showHint) {
      inputsContainer = angular.element('<div></div>');
      inputsContainer.css('position', 'relative');
      element.after(inputsContainer);
      hintInputElem = element.clone();
      hintInputElem.attr('placeholder', '');
      hintInputElem.attr('tabindex', '-1');
      hintInputElem.val('');
      hintInputElem.css({
        'position': 'absolute',
        'top': '0px',
        'left': '0px',
        'border-color': 'transparent',
        'box-shadow': 'none',
        'opacity': 1,
        'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
        'color': '#999'
      });
      element.css({
        'position': 'relative',
        'vertical-align': 'top',
        'background-color': 'transparent'
      });

      if (hintInputElem.attr('id')) {
        hintInputElem.removeAttr('id'); // remove duplicate id if present.
      }
      inputsContainer.append(hintInputElem);
      hintInputElem.after(element);
    }

    //pop-up element used to display matches
    var popUpEl = angular.element('<div uib-typeahead-popup></div>');
    popUpEl.attr({
      id: popupId,
      matches: 'matches',
      active: 'activeIdx',
      select: 'select(activeIdx, evt)',
      'move-in-progress': 'moveInProgress',
      query: 'query',
      position: 'position',
      'assign-is-open': 'assignIsOpen(isOpen)',
      debounce: 'debounceUpdate'
    });
    //custom item template
    if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
      popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
    }

    if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
      popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
    }

    var resetHint = function() {
      if (showHint) {
        hintInputElem.val('');
      }
    };

    var resetMatches = function() {
      scope.matches = [];
      scope.activeIdx = -1;
      element.attr('aria-expanded', false);
      resetHint();
    };

    var getMatchId = function(index) {
      return popupId + '-option-' + index;
    };

    // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
    // This attribute is added or removed automatically when the `activeIdx` changes.
    scope.$watch('activeIdx', function(index) {
      if (index < 0) {
        element.removeAttr('aria-activedescendant');
      } else {
        element.attr('aria-activedescendant', getMatchId(index));
      }
    });

    var inputIsExactMatch = function(inputValue, index) {
      if (scope.matches.length > index && inputValue) {
        return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
      }

      return false;
    };

    var getMatchesAsync = function(inputValue, evt) {
      var locals = {$viewValue: inputValue};
      isLoadingSetter(originalScope, true);
      isNoResultsSetter(originalScope, false);
      $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
        //it might happen that several async queries were in progress if a user were typing fast
        //but we are interested only in responses that correspond to the current view value
        var onCurrentRequest = inputValue === modelCtrl.$viewValue;
        if (onCurrentRequest && hasFocus) {
          if (matches && matches.length > 0) {
            scope.activeIdx = focusFirst ? 0 : -1;
            isNoResultsSetter(originalScope, false);
            scope.matches.length = 0;

            //transform labels
            for (var i = 0; i < matches.length; i++) {
              locals[parserResult.itemName] = matches[i];
              scope.matches.push({
                id: getMatchId(i),
                label: parserResult.viewMapper(scope, locals),
                model: matches[i]
              });
            }

            scope.query = inputValue;
            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
            //due to other elements being rendered
            recalculatePosition();

            element.attr('aria-expanded', true);

            //Select the single remaining option if user input matches
            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                $$debounce(function() {
                  scope.select(0, evt);
                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
              } else {
                scope.select(0, evt);
              }
            }

            if (showHint) {
              var firstLabel = scope.matches[0].label;
              if (angular.isString(inputValue) &&
                inputValue.length > 0 &&
                firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
                hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
              } else {
                hintInputElem.val('');
              }
            }
          } else {
            resetMatches();
            isNoResultsSetter(originalScope, true);
          }
        }
        if (onCurrentRequest) {
          isLoadingSetter(originalScope, false);
        }
      }, function() {
        resetMatches();
        isLoadingSetter(originalScope, false);
        isNoResultsSetter(originalScope, true);
      });
    };

    // bind events only if appendToBody params exist - performance feature
    if (appendToBody) {
      angular.element($window).on('resize', fireRecalculating);
      $document.find('body').on('scroll', fireRecalculating);
    }

    // Declare the debounced function outside recalculating for
    // proper debouncing
    var debouncedRecalculate = $$debounce(function() {
      // if popup is visible
      if (scope.matches.length) {
        recalculatePosition();
      }

      scope.moveInProgress = false;
    }, eventDebounceTime);

    // Default progress type
    scope.moveInProgress = false;

    function fireRecalculating() {
      if (!scope.moveInProgress) {
        scope.moveInProgress = true;
        scope.$digest();
      }

      debouncedRecalculate();
    }

    // recalculate actual position and set new values to scope
    // after digest loop is popup in right position
    function recalculatePosition() {
      scope.position = appendToBody ? $position.offset(element) : $position.position(element);
      scope.position.top += element.prop('offsetHeight');
    }

    //we need to propagate user's query so we can higlight matches
    scope.query = undefined;

    //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
    var timeoutPromise;

    var scheduleSearchWithTimeout = function(inputValue) {
      timeoutPromise = $timeout(function() {
        getMatchesAsync(inputValue);
      }, waitTime);
    };

    var cancelPreviousTimeout = function() {
      if (timeoutPromise) {
        $timeout.cancel(timeoutPromise);
      }
    };

    resetMatches();

    scope.assignIsOpen = function (isOpen) {
      isOpenSetter(originalScope, isOpen);
    };

    scope.select = function(activeIdx, evt) {
      //called from within the $digest() cycle
      var locals = {};
      var model, item;

      selected = true;
      locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
      model = parserResult.modelMapper(originalScope, locals);
      $setModelValue(originalScope, model);
      modelCtrl.$setValidity('editable', true);
      modelCtrl.$setValidity('parse', true);

      onSelectCallback(originalScope, {
        $item: item,
        $model: model,
        $label: parserResult.viewMapper(originalScope, locals),
        $event: evt
      });

      resetMatches();

      //return focus to the input element if a match was selected via a mouse click event
      // use timeout to avoid $rootScope:inprog error
      if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
        $timeout(function() { element[0].focus(); }, 0, false);
      }
    };

    //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
    element.on('keydown', function(evt) {
      //typeahead is open and an "interesting" key was pressed
      if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
        return;
      }

      var shouldSelect = isSelectEvent(originalScope, {$event: evt});

      /**
       * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
       * or
       * shift + tab is pressed to bring focus to the previous element
       * then clear the results
       */
      if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {
        resetMatches();
        scope.$digest();
        return;
      }

      evt.preventDefault();
      var target;
      switch (evt.which) {
        case 27: // escape
          evt.stopPropagation();

          resetMatches();
          originalScope.$digest();
          break;
        case 38: // up arrow
          scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
          scope.$digest();
          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
          target.parentNode.scrollTop = target.offsetTop;
          break;
        case 40: // down arrow
          scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
          scope.$digest();
          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
          target.parentNode.scrollTop = target.offsetTop;
          break;
        default:
          if (shouldSelect) {
            scope.$apply(function() {
              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                $$debounce(function() {
                  scope.select(scope.activeIdx, evt);
                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
              } else {
                scope.select(scope.activeIdx, evt);
              }
            });
          }
      }
    });

    element.bind('focus', function (evt) {
      hasFocus = true;
      if (minLength === 0 && !modelCtrl.$viewValue) {
        $timeout(function() {
          getMatchesAsync(modelCtrl.$viewValue, evt);
        }, 0);
      }
    });

    element.bind('blur', function(evt) {
      if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
        selected = true;
        scope.$apply(function() {
          if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
            $$debounce(function() {
              scope.select(scope.activeIdx, evt);
            }, scope.debounceUpdate.blur);
          } else {
            scope.select(scope.activeIdx, evt);
          }
        });
      }
      if (!isEditable && modelCtrl.$error.editable) {
        modelCtrl.$setViewValue();
        scope.$apply(function() {
          // Reset validity as we are clearing
          modelCtrl.$setValidity('editable', true);
          modelCtrl.$setValidity('parse', true);
        });
        element.val('');
      }
      hasFocus = false;
      selected = false;
    });

    // Keep reference to click handler to unbind it.
    var dismissClickHandler = function(evt) {
      // Issue #3973
      // Firefox treats right click as a click on document
      if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
        resetMatches();
        if (!$rootScope.$$phase) {
          originalScope.$digest();
        }
      }
    };

    $document.on('click', dismissClickHandler);

    originalScope.$on('$destroy', function() {
      $document.off('click', dismissClickHandler);
      if (appendToBody || appendTo) {
        $popup.remove();
      }

      if (appendToBody) {
        angular.element($window).off('resize', fireRecalculating);
        $document.find('body').off('scroll', fireRecalculating);
      }
      // Prevent jQuery cache memory leak
      popUpEl.remove();

      if (showHint) {
          inputsContainer.remove();
      }
    });

    var $popup = $compile(popUpEl)(scope);

    if (appendToBody) {
      $document.find('body').append($popup);
    } else if (appendTo) {
      angular.element(appendTo).eq(0).append($popup);
    } else {
      element.after($popup);
    }

    this.init = function(_modelCtrl, _ngModelOptions) {
      modelCtrl = _modelCtrl;
      ngModelOptions = _ngModelOptions;

      scope.debounceUpdate = modelCtrl.$options && $parse(modelCtrl.$options.debounce)(originalScope);

      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
      modelCtrl.$parsers.unshift(function(inputValue) {
        hasFocus = true;

        if (minLength === 0 || inputValue && inputValue.length >= minLength) {
          if (waitTime > 0) {
            cancelPreviousTimeout();
            scheduleSearchWithTimeout(inputValue);
          } else {
            getMatchesAsync(inputValue);
          }
        } else {
          isLoadingSetter(originalScope, false);
          cancelPreviousTimeout();
          resetMatches();
        }

        if (isEditable) {
          return inputValue;
        }

        if (!inputValue) {
          // Reset in case user had typed something previously.
          modelCtrl.$setValidity('editable', true);
          return null;
        }

        modelCtrl.$setValidity('editable', false);
        return undefined;
      });

      modelCtrl.$formatters.push(function(modelValue) {
        var candidateViewValue, emptyViewValue;
        var locals = {};

        // The validity may be set to false via $parsers (see above) if
        // the model is restricted to selected values. If the model
        // is set manually it is considered to be valid.
        if (!isEditable) {
          modelCtrl.$setValidity('editable', true);
        }

        if (inputFormatter) {
          locals.$model = modelValue;
          return inputFormatter(originalScope, locals);
        }

        //it might happen that we don't have enough info to properly render input value
        //we need to check for this situation and simply return model value if we can't apply custom formatting
        locals[parserResult.itemName] = modelValue;
        candidateViewValue = parserResult.viewMapper(originalScope, locals);
        locals[parserResult.itemName] = undefined;
        emptyViewValue = parserResult.viewMapper(originalScope, locals);

        return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
      });
    };
  }])

  .directive('uibTypeahead', function() {
    return {
      controller: 'UibTypeaheadController',
      require: ['ngModel', '^?ngModelOptions', 'uibTypeahead'],
      link: function(originalScope, element, attrs, ctrls) {
        ctrls[2].init(ctrls[0], ctrls[1]);
      }
    };
  })

  .directive('uibTypeaheadPopup', ['$$debounce', function($$debounce) {
    return {
      scope: {
        matches: '=',
        query: '=',
        active: '=',
        position: '&',
        moveInProgress: '=',
        select: '&',
        assignIsOpen: '&',
        debounce: '&'
      },
      replace: true,
      templateUrl: function(element, attrs) {
        return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
      },
      link: function(scope, element, attrs) {
        scope.templateUrl = attrs.templateUrl;

        scope.isOpen = function() {
          var isDropdownOpen = scope.matches.length > 0;
          scope.assignIsOpen({ isOpen: isDropdownOpen });
          return isDropdownOpen;
        };

        scope.isActive = function(matchIdx) {
          return scope.active === matchIdx;
        };

        scope.selectActive = function(matchIdx) {
          scope.active = matchIdx;
        };

        scope.selectMatch = function(activeIdx, evt) {
          var debounce = scope.debounce();
          if (angular.isNumber(debounce) || angular.isObject(debounce)) {
            $$debounce(function() {
              scope.select({activeIdx: activeIdx, evt: evt});
            }, angular.isNumber(debounce) ? debounce : debounce['default']);
          } else {
            scope.select({activeIdx: activeIdx, evt: evt});
          }
        };
      }
    };
  }])

  .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
    return {
      scope: {
        index: '=',
        match: '=',
        query: '='
      },
      link: function(scope, element, attrs) {
        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
        $templateRequest(tplUrl).then(function(tplContent) {
          var tplEl = angular.element(tplContent.trim());
          element.replaceWith(tplEl);
          $compile(tplEl)(scope);
        });
      }
    };
  }])

  .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
    var isSanitizePresent;
    isSanitizePresent = $injector.has('$sanitize');

    function escapeRegexp(queryToEscape) {
      // Regex: capture the whole query string and replace it with the string that will be used to match
      // the results, for example if the capture is "a" the result will be \a
      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }

    function containsHtml(matchItem) {
      return /<.*>/g.test(matchItem);
    }

    return function(matchItem, query) {
      if (!isSanitizePresent && containsHtml(matchItem)) {
        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
      }
      matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
      if (!isSanitizePresent) {
        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
      }
      return matchItem;
    };
  }]);

angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/accordion/accordion-group.html",
    "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
    "  <h4 class=\"panel-title\">\n" +
    "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
    "  </h4>\n" +
    "</div>\n" +
    "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
    "  <div class=\"panel-body\" ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/accordion/accordion.html",
    "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
}]);

angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/alert/alert.html",
    "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
    "  <span aria-hidden=\"true\">&times;</span>\n" +
    "  <span class=\"sr-only\">Close</span>\n" +
    "</button>\n" +
    "<div ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/carousel/carousel.html",
    "<div class=\"carousel-inner\" ng-transclude></div>\n" +
    "<a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-class=\"{ disabled: isPrevDisabled() }\" ng-show=\"slides.length > 1\">\n" +
    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
    "  <span class=\"sr-only\">previous</span>\n" +
    "</a>\n" +
    "<a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-class=\"{ disabled: isNextDisabled() }\" ng-show=\"slides.length > 1\">\n" +
    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
    "  <span class=\"sr-only\">next</span>\n" +
    "</a>\n" +
    "<ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
    "  <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
    "    <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
    "  </li>\n" +
    "</ol>\n" +
    "");
}]);

angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/carousel/slide.html",
    "<div class=\"text-center\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/datepicker.html",
    "<div ng-switch=\"datepickerMode\">\n" +
    "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" +
    "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" +
    "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/day.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/month.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/year.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepickerPopup/popup.html",
    "<ul class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
    "  <li ng-transclude></li>\n" +
    "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
    "    <span class=\"btn-group pull-left\">\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
    "    </span>\n" +
    "    <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("uib/template/modal/window.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/modal/window.html",
    "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
    "");
}]);

angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/pager/pager.html",
    "<li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
    "<li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
    "");
}]);

angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/pagination/pagination.html",
    "<li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\n" +
    "<li ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
    "<li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
    "<li ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
    "<li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\"\n" +
    "  uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/popover/popover-html.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/popover/popover-template.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\"\n" +
    "      uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "      tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/popover/popover.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/progressbar/bar.html",
    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/progressbar/progress.html",
    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
}]);

angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/progressbar/progressbar.html",
    "<div class=\"progress\">\n" +
    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/rating/rating.html",
    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" +
    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" +
    "</span>\n" +
    "");
}]);

angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tabs/tab.html",
    "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" +
    "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
    "</li>\n" +
    "");
}]);

angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tabs/tabset.html",
    "<div>\n" +
    "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
    "  <div class=\"tab-content\">\n" +
    "    <div class=\"tab-pane\"\n" +
    "         ng-repeat=\"tab in tabset.tabs\"\n" +
    "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
    "         uib-tab-content-transclude=\"tab\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/timepicker/timepicker.html",
    "<table class=\"uib-timepicker\">\n" +
    "  <tbody>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" +
    "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
    "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" +
    "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
    "    </tr>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-match.html",
    "<a href\n" +
    "   tabindex=\"-1\"\n" +
    "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" +
    "   ng-attr-title=\"{{match.label}}\"></a>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-popup.html",
    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
    "    <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" +
    "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
    "    </li>\n" +
    "</ul>\n" +
    "");
}]);
angular.module('ui.bootstrap.carousel').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>'); angular.$$uibCarouselCss = true; });
angular.module('ui.bootstrap.datepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'); angular.$$uibDatepickerCss = true; });
angular.module('ui.bootstrap.position').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'); angular.$$uibPositionCss = true; });
angular.module('ui.bootstrap.datepickerPopup').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerpopupCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'); angular.$$uibDatepickerpopupCss = true; });
angular.module('ui.bootstrap.tooltip').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>'); angular.$$uibTooltipCss = true; });
angular.module('ui.bootstrap.timepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>'); angular.$$uibTimepickerCss = true; });
angular.module('ui.bootstrap.typeahead').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'); angular.$$uibTypeaheadCss = true; });
!function (e) { if ("object" == typeof exports && "undefined" != typeof module) module.exports = e(); else if ("function" == typeof define && define.amd) define([], e); else { var n; n = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this, n.uuid = e() } }(function () { return function e(n, r, o) { function t(f, u) { if (!r[f]) { if (!n[f]) { var a = "function" == typeof require && require; if (!u && a) return a(f, !0); if (i) return i(f, !0); var d = new Error("Cannot find module '" + f + "'"); throw d.code = "MODULE_NOT_FOUND", d } var s = r[f] = { exports: {} }; n[f][0].call(s.exports, function (e) { var r = n[f][1][e]; return t(r ? r : e) }, s, s.exports, e, n, r, o) } return r[f].exports } for (var i = "function" == typeof require && require, f = 0; f < o.length; f++) t(o[f]); return t }({ 1: [function (e, n, r) { var o = e("./v1"), t = e("./v4"), i = t; i.v1 = o, i.v4 = t, n.exports = i }, { "./v1": 4, "./v4": 5 }], 2: [function (e, n, r) { function o(e, n) { var r = n || 0, o = t; return o[e[r++]] + o[e[r++]] + o[e[r++]] + o[e[r++]] + "-" + o[e[r++]] + o[e[r++]] + "-" + o[e[r++]] + o[e[r++]] + "-" + o[e[r++]] + o[e[r++]] + "-" + o[e[r++]] + o[e[r++]] + o[e[r++]] + o[e[r++]] + o[e[r++]] + o[e[r++]] } for (var t = [], i = 0; i < 256; ++i) t[i] = (i + 256).toString(16).substr(1); n.exports = o }, {}], 3: [function (e, n, r) { (function (e) { var r, o = e.crypto || e.msCrypto; if (o && o.getRandomValues) { var t = new Uint8Array(16); r = function () { return o.getRandomValues(t), t } } if (!r) { var i = new Array(16); r = function () { for (var e, n = 0; n < 16; n++) 0 === (3 & n) && (e = 4294967296 * Math.random()), i[n] = e >>> ((3 & n) << 3) & 255; return i } } n.exports = r }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}) }, {}], 4: [function (e, n, r) { function o(e, n, r) { var o = n && r || 0, t = n || []; e = e || {}; var f = void 0 !== e.clockseq ? e.clockseq : a, l = void 0 !== e.msecs ? e.msecs : (new Date).getTime(), c = void 0 !== e.nsecs ? e.nsecs : s + 1, v = l - d + (c - s) / 1e4; if (v < 0 && void 0 === e.clockseq && (f = f + 1 & 16383), (v < 0 || l > d) && void 0 === e.nsecs && (c = 0), c >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec"); d = l, s = c, a = f, l += 122192928e5; var p = (1e4 * (268435455 & l) + c) % 4294967296; t[o++] = p >>> 24 & 255, t[o++] = p >>> 16 & 255, t[o++] = p >>> 8 & 255, t[o++] = 255 & p; var y = l / 4294967296 * 1e4 & 268435455; t[o++] = y >>> 8 & 255, t[o++] = 255 & y, t[o++] = y >>> 24 & 15 | 16, t[o++] = y >>> 16 & 255, t[o++] = f >>> 8 | 128, t[o++] = 255 & f; for (var b = e.node || u, w = 0; w < 6; ++w) t[o + w] = b[w]; return n ? n : i(t) } var t = e("./lib/rng"), i = e("./lib/bytesToUuid"), f = t(), u = [1 | f[0], f[1], f[2], f[3], f[4], f[5]], a = 16383 & (f[6] << 8 | f[7]), d = 0, s = 0; n.exports = o }, { "./lib/bytesToUuid": 2, "./lib/rng": 3 }], 5: [function (e, n, r) { function o(e, n, r) { var o = n && r || 0; "string" == typeof e && (n = "binary" == e ? new Array(16) : null, e = null), e = e || {}; var f = e.random || (e.rng || t)(); if (f[6] = 15 & f[6] | 64, f[8] = 63 & f[8] | 128, n) for (var u = 0; u < 16; ++u) n[o + u] = f[u]; return n || i(f) } var t = e("./lib/rng"), i = e("./lib/bytesToUuid"); n.exports = o }, { "./lib/bytesToUuid": 2, "./lib/rng": 3 }] }, {}, [1])(1) });
var appName = "beagle";
angular.module(appName,
  [
    "angular.backtop",
    "angular-clipboard",
    "angularMoment",
    "entegra.ngExpandable",
    "monospaced.qrcode",
    "ngResource",
    "ngRoute",
    "ngFileUpload",
    "ngMessages",
    "ngSanitize",
    "ngCookies",
    "gg.editableText.cdbmod",
    "pascalprecht.translate",
    "psl.cdbAreYouSure",
    "psl.cdbMultiSelect",
    "psl.cdbDatepicker",
    "psl.cdbLocalizableDatepicker",
    "psl.cdbLoading",
    "psl.cdbLozenge",
    "psl.cdb-application-access",
    "psl.cdb.fileupload",
    "psl.uuid",
    "psl.cdbMultiSelect",
    "psl.cdbUIGrid",
    "psl.countries",
    "psl.cdbHelp",
    "psl.htmlFragments",
    "psl.lookups",
    "psl.postcode",
    "psl.release",
    "psl.roles",
    "psl.shared",
    "psl.supplierDepots",
    "psl.suppliers",
    "psl.tasks",
    "psl.cdb-tooltip",
    "ui.bootstrap",
    "ui.grid",
    "ui.grid.edit",
    "ui.grid.cellNav",
    "ui.grid.resizeColumns",
    "ui.grid.selection",
    "ui.grid.autoResize",
    "ui.grid.pagination",
    "ui.grid.pinning",
    "ui.select",
    "psl.dashboards",
    "psl.ssrsReportDirective",
    "psl.localStorageService",
    "psl.dashboardButton",
    "psl.permissions",
    "psl.sorton",
    "ngDialog",
    "psl.uiGridWrapper",
    "cdbPercent",
    "psl.needsPermission",
    "psl.cdb.language",
    "psl.cdbPromptDisabled",
    "psl.cdbUrlInputMask",
    'psl.manage-depots',
    'psl.organisation-contacts',
    "ui.tinymce",
    "cdb.tinymce",
    "ngFileUpload",
    "cdb.imageUpload",
    "psl.cdbCollapsableBlock",
    "psl.cdbSticky",
    "cdb.indeterminateCheckbox",
    "psl.organisationContext",
    "psl.jqueryUiSetCultureService",
    "psl.cdb.dialog",
    "cdb.tabs",
    "cdbRemember",
    "googlechart",
    "hc.marked",
    "cdb.psl.toggleButton",
    "psl.clickAndLoad",
    "cdb.psl.servicelevels",
    "psl.cdbAccountingSystemRegion",
  ]);

if (angular.isDefined(window.angularDragula)) {
  angular.module(appName).requires.push(angularDragula(angular));
}

//how much is that doggy in the window?
window.beagle = {
  waggilyTail: {
    wag: function() {
      console("how much is that doggy in the window?");
      console("(The one with the waggily tail.)");
    }
  }
};


angular.module(appName).value("siteUrl",
  function() {
    var url = window.location.protocol + "//" + window.location.host + "/";
    return url;
  });

angular.module(appName).run(function() {
    console.info('INFO: Application Version :: ', window.appVersion)
})

angular.module(appName).value('appName', appName);

//Configure route provider for HTML5 mode
angular.module(appName)
  .config([
    "$locationProvider", "$httpProvider", "$provide", "$sceDelegateProvider", "$compileProvider",
    function($locationProvider, $httpProvider, $provide, $sceDelegateProvider, $compileProvider) {

      $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|javascript):/);
      
      var darwinBaseUrl = window.urls && window.urls.darwin  ? window.urls.darwin.replace(/\/+$/, '')  : '';

      if (window.urls) {
        $sceDelegateProvider.resourceUrlWhitelist([
          "self",
          new RegExp('^' + darwinBaseUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '/.*\\.html(?:\\?.*)?$')
        ]);
      }

      $locationProvider.html5Mode(true);

      $httpProvider.interceptors.push("beagleErrorResponseInterceptor");
      // MB: This needs revising, possibly with a CDN @John. This breaks all libraries using $ngTemplateCache.
      // $httpProvider.interceptors.push("beagleTemplateCacheInterceptor");
    }
  ]);

angular.module(appName).run(
  function ($rootScope, amMoment, enums, organisationContextService, userLanguageService, jqueryUiSetCultureService, localStorageService) {
    $.timepicker.regional['en'] = {
      timeOnlyTitle: 'Time',
      timeText: 'Time',
      hourText: 'Hour',
      minuteText: 'Minute',
      secondText: 'Second',
      millisecText: 'Millisecond',
      timezoneText: 'Timezone',
      currentText: 'Current',
      closeText: 'Close',
      timeFormat: 'HH:mm',
      amNames: ['AM', 'A'],
      pmNames: ['PM', 'P'],
      isRTL: false
    };

    $rootScope.$on("userLanguageService.setCulture",
      function (event, language) {
        jqueryUiSetCultureService.setCulture(language);
      });

    function updateLanguageOnContext(event, data) {

      var context = organisationContextService.getContext();
      if (context.impersonatingUser) {
        context.impersonatingUser.language = data.language;
        console.log("changed language of impersonated user in the context", context.impersonatingUser, data.language);
      } else {
        context.user.language = data.language;
        console.log("changed language of actual user in the context", context.user, data.language);
      }
      localStorageService.setItem(enums.localStorage.organisationContext, context);
    }

    $rootScope.$on("user-language-changed", updateLanguageOnContext);

    function setLanguage() {
      organisationContextService.getCompany();

      var context = organisationContextService.getContext();
      if (context) {

        var languageToUse = context.impersonatingUser
          ? context.impersonatingUser.language
          : context.user.language;
        userLanguageService.setCulture(languageToUse);
      }
    }

    setLanguage();
    $rootScope.$on(enums.broadcasts.updatedContext, setLanguage);
    amMoment.changeLocale("en-gb");
    $rootScope.$enums = enums;
  });

//set the dateTime format of the current logged in user
angular.module(appName).run(["localStorageService", "userService", "$filter", function (localStorageService, userService, $filter) {

  //local storage key for user's timezone
  var timezone = "user-timezone";
  var userTimezone = localStorageService.getItem(timezone);

  //if not in local storage
  if (!userTimezone) {
    userService.getUserTimezone().then(function (response) {
      var data = response.data;
      data.format = data.format.toUpperCase();
      localStorageService.setItem(timezone, data);
    });
  }

}]);

angular.module(appName)
  .factory("_",
    function() {
      return window._;
    });

angular.module(appName)
  .factory("toastr",
    [
      function() {
        // Toastr setup

        window.toastr.options = {

          //successTitle: $translate.instant('success') + "!",
          //errorTitle: $translate.instant('error'),
          //warningTitle: $translate.instant('warning'),
          //infoTitle: $translate.instant('info'),
          showMethod: "slideDown",
          hideMethod: "slideUp",
          closeMethod: "slideUp",
          closeDuration: 100,
          hideDuration: 100,
          showDuration: 100,
          closeButton: true,
          progressBar: true,
          timeOut: 3500,
          positionClass: "toast-top-center"
        };

        return window.toastr;
      }
    ]);

angular.module(appName)
  .factory("autoFocus",
    [
      "$timeout", function($timeout) {
      return {
        implement: function(tag) {
          $timeout(function() {
              angular.element(document.getElementsByTagName(tag)[0]).focus();
            },
            100);
        },
        implementForElementWithId: function(id) {
          $timeout(function() {
            angular.element(document.getElementById(id)).focus();
          });
        }
      };
    }
    ]);


angular.module(appName).factory('translateMessage', [
  'toastr','$translate',
  function(toastr, $translate) {
    var service = {
      success: function(key, isTranslatedOrReplacements) {
        notify('success', isTranslatedOrReplacements, key, 'success');
      },
      warning: function(key, isTranslatedOrReplacements) {
        notify('warning', isTranslatedOrReplacements, key, 'warning');
      },
      error: function (key, isTranslatedOrReplacements) {
        notify('error', isTranslatedOrReplacements, key, 'error');
      },
      info: function (key, isTranslatedOrReplacements) {
        notify('info', isTranslatedOrReplacements, key, 'info');
      }
    };

    function notify(type, isTranslatedOrReplacements, key, defaultText) {
      var needsTranslating =
        (isTranslatedOrReplacements === undefined || typeof isTranslatedOrReplacements === 'object') ? true : !isTranslatedOrReplacements;

      var displayMessage = function (translation) {
        toastr[type](translation);
      };

      var tryAgain = function () {
        if (defaultText) {
          console.error('unable to translate: possible missing key', { type: type, isTranslatedOrReplacements: isTranslatedOrReplacements, key: key });
          return notify(type, false, null, defaultText);
        } else {
          console.error('unable to translate: not key related', { type: type, isTranslatedOrReplacements: isTranslatedOrReplacements, key: key });
        }
      }

      if (needsTranslating) {
        var replacements = (typeof isTranslatedOrReplacements === 'object') ? isTranslatedOrReplacements : null;

        if (replacements) {
          $translate(key, replacements).then(displayMessage, tryAgain);
        } else {
          $translate(key || defaultText).then(displayMessage, tryAgain);
        }
      } else {
        toastr[type](key);
      }
    }

    return service;
  }
])

//Should pull into module?
angular.module(appName)
  .factory("helperService",
    [
      "_",
      function(_) {
        var service = {
          bindReferenceToReal: function(parentDto, childDtoName, childDtoProp, array, arrayProp) {
            if (parentDto && parentDto[childDtoName]) {
              var condition = {};
              condition[arrayProp] = parentDto[childDtoName][childDtoProp];
              var referenceObject = _.findWhere(array, condition);
              if (referenceObject) {
                parentDto[childDtoName] = referenceObject;
              }
            }

          },
          bindReferenceToRealById: function(parentDto, childDtoName, array) {
            this.bindReferenceToReal(parentDto, childDtoName, "id", array, "id");
          },
          isNullOrUndefined: function(obj) {
            if (obj === undefined || obj === null)
              return true;

            return false;
          },

          //checks if there are duplicate account numbers in the nomination aarray
          duplicatesExist: function(array, fieldName) {
            var valueArr = array.map(function(item) { return item[fieldName] });
            var duplicatesExist = valueArr.some(function(item, idx) {
              return valueArr.indexOf(item) !== idx;
            });
            return duplicatesExist;
          },

          getFileExtension: function(filename) {
            return filename.split(".").reverse()[0];
          }
        };

        return service;
      }
    ]);


angular.module(appName)
  .factory("helpDocumentService",
    [
      "helpDocumentFactory",
      function(helpDocumentFactory) {
        var self = this;
        var service = {
          getAll: function() {
            return helpDocumentFactory.getAll();
          },
          getById: function(helpDocument) {
            return helpDocumentFactory.getById({ id: helpDocument.id });
          },
          getHelpDocumentsForUser: function() {
            return helpDocumentFactory.getHelpDocumentsForUser();
          },
          createNewHelpDocument: function(helpDocument) {
            return helpDocumentFactory.createNewHelpDocument(helpDocument);
          },
          update: function(helpDocument) {
            return helpDocumentFactory.update(helpDocument);
          },
          deleteHelpDocument: function(helpDocument) {
            return helpDocumentFactory.deleteHelpDocument({ id: helpDocument.id });
          }
        };

        return service;
      }
    ]);


//Add here as the other document service is attached to Darwin
angular.module(appName)
  .factory("documentService",
    [
      "documentFactory", "fileDownloadService", "$http","$translate","$q",
      function (documentFactory, fileDownloadService, $http, $translate,$q) {
        var service = {
          // GET
          downloadNominationDocument: function(documentId, keepFilename,fileName) {

            var fileExtension = fileName.split('.').pop().trim();
            var url = "/api/Document/DownloadNominationDocument?documentId=" + documentId + "&keepFilename=" + keepFilename;

            var deferred = $q.defer();
            var responseType = 'arraybuffer';
            var accessToken = localStorage.getItem('access_token');
            var headers = {};
            headers.Authorization = 'Bearer ' + accessToken;

            $http.get(
              url,
              {
                responseType: responseType,
                headers: headers
              })
              .then(
                //success
                function (result) {
                  result.data.type = responseType;
                  var blob = new Blob([result.data]);
                  // IE Doesn't support the generic objectUrl method. This uses IE's API for downloading a blob if it exists.
                  if (window.navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(blob, fileName + "." + fileExtension);
                  } else {
                    var objectUrl = window.URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = objectUrl;
                    a.download = fileName + "." + fileExtension;
                    a.click();
                    a.parentNode.removeChild(a);
                    deferred.resolve(result.data);
                  }
                },
                //error
                function (data, status) {
                  console.log("Request failed with status: " + status);
                  deferred.reject(status);
                });

            return deferred.promise;
          },
          getDocument: function(taskUid, documentId, callback) {
            documentFactory.getDocument({ taskKey: taskUid, documentId: documentId }).$promise
              .then(callback);
          },
          downloadDocument: function(documentId) {
            fileDownloadService.downloadFile("/api/Document/DownloadDocument?documentId=" + documentId,
              documentId,
              "pdf");
          },


          downloadDocumentReserveFilename: function(documentId) {
            window.location =
              "/api/Document/DownloadDocument?documentId=" + documentId + "&keepFilename=true";
          },
          downloadHelpDocument: function(documentId, extension) {
            window.location = "/api/Document/DownloadHelpDocument?documentId=" +
              documentId +
              "&extension=" +
              extension;
          },
          downloadHelpDocumentReserveFilename: function(documentId, extension, newTab) {
            var url = "/api/Document/DownloadHelpDocument?documentId=" +
              documentId +
              "&extension=" +
              extension +
              "&keepFilename=true";
            if (newTab) {
              window.open(url, "_blank");
            } else {
              window.location = url;
            }
          },
          getDocumentsByTaskId: function(taskId, callback) {
            documentFactory.getDocumentDtoByTaskId({ taskId: taskId }).$promise.then(function(data) {
              callback(data);
            });
          }

        };

        return service;
      }
    ]);

"use strict";

angular.module(appName)
  .factory("documentFactory",
    [
      "$resource", "siteUrl", function ($resource, siteUrl) {
      var accessToken = localStorage.getItem('access_token');
      return $resource(siteUrl() + "api/Document", {},
        {
          getDocument: {
            method: "GET",
            url: siteUrl() + "api/Document/GetDocument"
          },
          getDocumentDtoByTaskId: {
            method: "GET",
            url: siteUrl() + "api/Document/GetDocumentDtoByTaskId",
            isArray: true,
            data: {
              taskId: "@taskId"
            }
          },
          //I tried this but does not download file the call goes through fine though
          downloadNominationDocument: {
            method: "GET",
            url: siteUrl() + "api/Document/DownloadNominationDocument",
            params: {
              documentId: '@documentId',
              keepFilename: '@keepFilename'
            },
            headers: {
              'Authorization': 'Bearer ' + accessToken
            }
          },
        });
    }
    ]);

angular.module(appName)
  .factory("helpDocumentFactory",
    [
      "$resource", "siteUrl", function($resource, siteUrl) {
      var api = siteUrl() + "api/ApplicationHelpDocument/";
      return $resource(api,
        {},
        {
          getAll: {
            method: "GET",
            url: api + "GetAll",
            isArray: true
          },
          getById: {
            method: "GET",
            url: api + "Get",
            params: {
              id: "@id"
            }
          },
          getHelpDocumentsForUser: {
            method: "GET",
            url: api + "GetForCurrentUser",
            isArray: true
          },
          update: {
            method: "PUT",
            url: api + "Put"
          },
          createNewHelpDocument: {
            method: "POST",
            url: api + "Post"
          },
          deleteHelpDocument: {
            method: "DELETE",
            url: api + "Delete",
            params: {
              id: "@id"
            }
          }
        });
    }
    ]);


//OVERRIDEN SERVICES AND RESOURCES FOR IBELONG TO BELOW:
angular.module(appName)
  .factory("organisationRoleFactory",
    [
      "$resource", "siteUrl", "organisationContextService",
      function($resource, siteUrl, organisationContextService) {
        var baseUrl = "api/OrganisationRole";
        var self = this;
        self.context = organisationContextService.getContext();

        return $resource("api/OrganisationRole",
          {},
          {
            getPermissionsWithAssignedRoles: {
              method: "GET",
              url: siteUrl() + baseUrl + "/GetPermissionsWithAssignedRoles",
              params: {
                id: self.context.id,
                groupOrgId: "@groupOrgId"
              },
              isArray: false
            },
            addPermissionToRole: {
              method: "POST",
              url: siteUrl() + baseUrl + "/AddPermissionToRole",
              params: {
                organisationId: self.context.organisation.id,
                permissionId: "@permissionId",
                organisationRoleId: "@organisationRoleId"
              },
              isArray: false
            },
            removePermissionFromRole: {
              method: "DELETE",
              url: siteUrl() + baseUrl + "/RemovePermissionFromRole",
              params: {
                organisationId: self.context.organisation.id,
                permissionId: "@permissionId",
                organisationRoleId: "@organisationRoleId"
              },
              isArray: false
            },
            createNewOrganisationRole: {
              method: "POST",
              url: siteUrl() + baseUrl + "/CreateNewOrganisationRole",
              isArray: false
            },
            deleteOrganisationRole: {
              method: "DELETE",
              url: siteUrl() + baseUrl + "/DeleteOrganisationRole",
              params: {
                organisationId: self.context.organisation.id,
                organisationRoleId: "@organisationRoleId"
              },
              isArray: false
            },
            saveOrganisationRole: {
              method: "POST",
              url: siteUrl() + baseUrl + "/SaveOrganisationRole",
              isArray: false
            }

          });
      }
    ]);


angular.module(appName)
  .factory("userOrganisationRoleFactory",
    [
      "$resource", "siteUrl", "organisationContextService",
      function($resource, siteUrl, organisationContextService) {
        var baseUrl = "api/UserOrganisationRole";
        var self = this;
        self.context = organisationContextService.getContext();
        return $resource("api/UserOrganisationRole",
          {},
          {
            addUserToRole: {
              method: "POST",
              url: siteUrl() + baseUrl + "/AddUserToRole",
              params: {
                id: self.context.id,
                userId: "@userId",
                organisationRoleId: "@organisationRoleId",
                organisationId: "@organisationId"
              }
            },

            addUserToAllRolesInGroup: {
              method: "POST",
              url: siteUrl() + baseUrl + "/AddUserToAllRolesInGroup",
              params: {
                id: self.context.id,
                userId: "@userId",
                contactId: "@contactId",
                organisationId: "@organisationId",
                application: "@application"
              }
            },
            removeUserFromRole: {
              method: "POST",
              url: siteUrl() + baseUrl + "/RemoveUserFromRole",
              params: {
                id: self.context.id,
                userId: "@userId",
                organisationRoleId: "@organisationRoleId",
                organisationId: "@organisationId"
              }
            },
            removeUserFromRoles: {
              method: "POST",
              url: siteUrl() + baseUrl + "/RemoveUserFromRoles",
              params: {
                id: self.context.id,
                userId: "@userId",
                organisationRoleIds: "@organisationRoleIds",
                organisationIds: "@organisationIds"
              }
            },


          });
      }
    ]);


//Override the resource for supplier depots

angular.module(appName)
  .factory("supplierDepotFactory",
    [
      "$resource", "siteUrl", "organisationContextService",
      function($resource, siteUrl, organisationContextService) {
        var self = this;
        console.log("THIS IS THE OVERRIDEN SUPPLIER DEPOT FACTORY");
        //If you make changes that should go into darwin, update the module as well
        self.context = organisationContextService.getContext();
        return $resource("api/SupplierDepot",
          {},
          {
            getDepotForSupplier: {
              method: "GET",
              url: siteUrl() + "api/SupplierDepot/Get",
              params: {
                supplierId: "@supplierId",
                id: self.context.id,
                isDelivery: "@isDelivery"
              },
              isArray: true
            },
            getAllDepots: {
              method: "GET",
              url: siteUrl() + "api/SupplierDepot/GetAllDepots",
              isArray: true
            },
            getAllTimezones: {
              method: "GET",
              url: siteUrl() + "api/SupplierDepot/GetAllTimezones",
              isArray: true
            },

            deleteDepot: {
              method: "DELETE",
              url: siteUrl() + "api/SupplierDepot/DeleteDepot",
              params: {
                depotId: "@depotId",
                id: self.context.id
              }
            },
            addDepot: {
              method: "POST",
              url: siteUrl() + "api/SupplierDepot/AddDepot"
            },
            editDepot: {
              method: "PUT",
              url: siteUrl() + "api/SupplierDepot/EditDepot"
            },
            downloadImportTemplate: {
              method: "GET",
              url: siteUrl() + "api/SupplierDepot/DownloadImportTemplatePLSWORKDAMNIT",
              params: {
                supplierId: "@supplierId",
                organisationId: "@organisationId"
              }
            },

            getClientCountryAndTimezone: {
              method: "GET",
              url: siteUrl() + "api/SupplierDepot/GetClientCountryAndTimezone",
              params: {
                unitId: "@unitId"
              }
            }
          });
      }
    ]);

angular.module('psl.cdbAccountingSystemRegion', []);
angular.module("psl.cdbAccountingSystemRegion")
  .factory('accountingSystemsRegionService', [
    'accountingSystemsRegionFactory',
    function (accountingSystemsRegionFactory) {
      var service = {
        // GET
        get: function () {
          return accountingSystemsRegionFactory.get().$promise;
        },
      }

      return service;
    }
  ]);
angular.module("psl.cdbAccountingSystemRegion")
  .factory('accountingSystemsRegionFactory', [
    '$resource', 'siteUrl',
    function ($resource, siteUrl) {
      var baseUrl = siteUrl() + 'api/AccountingSystemRegion';
      return $resource(baseUrl, {}, {
        get: {
          method: 'GET',
          url: baseUrl,
          isArray: true
        },
      });
    }
  ]);

angular.module("psl.supplierDepots")
  .factory("supplierDepotService",
    [
      "toastr", "supplierDepotFactory", "organisationContextService",
      function(toastr, supplierDepotFactory, organisationContextService) {
        var self = this;
        console.log("THIS IS THE OVERWRITTEN SUPPLIER DEPOT SERVICE");
        self.context = organisationContextService.getContext();
        console.log("supplierDepotService context", self.context);
        var service = {
          getDownloadImportTemplateUrl: function(supplierId) {
            return "api/SupplierDepot/DownloadImportTemplate?supplierId=" +
              supplierId +
              "&organisationId=" +
              self.context.organisation.id;
          },

          getDepotForSupplier: function (supplierId, callback, isDelivery) {
            return supplierDepotFactory.getDepotForSupplier({ supplierId: supplierId, isDelivery: isDelivery}).$promise.then(
              function(response) {
                return callback(response);
              });
          },

          getAllDepots: function(callback) {
            return supplierDepotFactory.getAllDepots().$promise.then(
              function(response) {
                return callback(response);
              });
          },
          getClientCountryAndTimezone: function(unitId, callback) {
            return supplierDepotFactory.getClientCountryAndTimezone({ unitId: unitId }).$promise.then(
              function(response) {
                return callback(response);
              });
          },
          getAllTimezones: function(callback) {
            return supplierDepotFactory.getAllTimezones().$promise.then(
              function(response) {
                return callback(response);
              });
          },

          deleteDepot: function(depotId, callback) {
            return supplierDepotFactory.deleteDepot({ depotId: depotId }).$promise.then(
              function(response) {
                return callback(response);
              });
          },
          addDepot: function(depot, callback, error) {
            depot.organisationId = self.context.organisation.id;
            return supplierDepotFactory.addDepot(depot).$promise.then(
              function(response) {
                return callback(response);
              },
              function(myError) {
                error();
              });
          },
          editDepot: function(depot, callback, error) {
            depot.organisationId = self.context.organisation.id;
            return supplierDepotFactory.editDepot(depot).$promise.then(
              function(response) {
                return callback(response);
              },
              function(myError) {
                error();
              });
          }
        };

        return service;
      }
    ]);


angular.module("psl.supplierDepots")
  .factory("supplierDepotContactFactory",
    [
      "$resource", "siteUrl", "organisationContextService",
      function($resource, siteUrl, organisationContextService) {
        var self = this;
        self.context = organisationContextService.getContext();
        return $resource("api/SupplierDepotContact",
          {},
          {
            getDepotContactForDepot: {
              method: "GET",
              url: siteUrl() + "api/SupplierDepotContact/Get",
              params: {
                supplierDepotContactId: "@supplierDepotContactId",
                id: self.context.id
              },
              isArray: false
            },
            getAllSupplierDepotContacts: {
              method: "GET",
              url: siteUrl() + "api/SupplierDepotContact/GetAllSupplierDepotContacts",
              isArray: true,
              params: {
                depotId: "@depotId",
                id: self.context.id
              },
            },

            deleteDepotContact: {
              method: "DELETE",
              url: siteUrl() + "api/SupplierDepotContact/DeleteDepotContact",
              params: {
                supplierDepotContactId: "@supplierDepotContactId",
                id: self.context.id
              }
            },
            addDepotContact: {
              method: "POST",
              url: siteUrl() + "api/SupplierDepotContact/AddDepotContact"
            },
            editDepotContact: {
              method: "PUT",
              url: siteUrl() + "api/SupplierDepotContact/EditDepotContact"
            }
          });
      }
    ]);


angular.module("psl.supplierDepots")
  .factory("supplierDepotContactService",
    [
      "$resource", "siteUrl", "supplierDepotContactFactory", "organisationContextService",
      function($resource, siteUrl, supplierDepotContactFactory, organisationContextService) {
        var self = this;
        console.log("THIS IS THE OVERRIDEN SUPPLIER DEPOT FACTORY");
        self.context = organisationContextService.getContext();
        var service = {
          getDepotContactForDepot: function(supplierDepotContactId, callback) {
            return supplierDepotContactFactory
              .getDepotContactForDepot({ supplierDepotContactId: supplierDepotContactId })
              .$promise.then(
                function(response) {
                  return callback(response);
                });
          },

          getAllSupplierDepotContacts: function(depotId, callback) {
            return supplierDepotContactFactory.getAllSupplierDepotContacts({ depotId: depotId }).$promise
              .then(
                function(response) {
                  return callback(response);
                });
          },

          deleteDepotContact: function(supplierDepotContactId, callback) {
            return supplierDepotContactFactory
              .deleteDepotContact({ supplierDepotContactId: supplierDepotContactId }).$promise
              .then(
                function(response) {
                  return callback(response);
                });
          },
          addDepotContact: function(depotContact, callback) {
            depotContact.organisationId = self.context.id;
            return supplierDepotContactFactory.addDepotContact(depotContact).$promise.then(
              function(response) {
                return callback(response);
              });
          },
          editDepotContact: function(depotContact, callback) {
            depotContact.organisationId = self.context.id;
            return supplierDepotContactFactory.editDepotContact(depotContact).$promise.then(
              function(response) {
                return callback(response);
              });
          }
        };
        return service;
      }
    ]);

angular.module("cdb.tinymce").factory("pslTinymceDefaultOptions",
    [
        '$timeout', function($timeout) {
        return {
            plugins: 'link code lists textcolor autoresize',
            toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | bullist | link | fontsizeselect fontselect forecolor',
            fontsize_formats: '6pt 7pt 8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 24pt 36pt',
            menubar: false,
            statusbar: false,
            autoresize_bottom_margin: 0
        };
    }
    ]);

//Cache Buster
angular.module(appName)
  .config(['$provide', function($provide) {
    $provide.decorator('$templateRequest', ['$delegate', function($delegate) {
      return function(url, ignoreRequestError) {
        var whitelist = [
          'ui-grid', // exclude any url that contains 'ui-grid'
          'accordion',
        ];
    
        var isWhitelisted = whitelist.some(function(entry) {
          return url.indexOf(entry) !== -1;
        });

        var shouldVersion = url.includes('Content/js/');
    
        if (!shouldVersion || (shouldVersion && isWhitelisted)) {
          return $delegate(url, ignoreRequestError);
        }
    
        var version = window.__version || 'dev'; 
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        var versionedUrl = url + separator + 'v=' + version;
        return $delegate(versionedUrl, ignoreRequestError);
      };
    }]);
  }]);

//This will change into separate services from the server side
angular.module(appName)
    .factory("paginationFactory", ["enums", "_",
        
		function (enums, _) {
            var paginationFactory = {};
            var pageNumbers;

                paginationFactory.addPaginationVariablesAndFunctionsToScope = function ($scope, numPerPage) {
                var syncStartFromAndEndAt = function()
                {
                    $scope.pagination.startFrom = ($scope.pagination.currentPage - 1) * $scope.pagination.numPerPage;
					$scope.pagination.endAt = $scope.pagination.startFrom + $scope.pagination.numPerPage;
	                $scope.$broadcast(enums.paginationChanged);
                };

                $scope.pagination = $scope.pagination || {};
                $scope.pagination.numPerPage = numPerPage ? numPerPage : 20;
                $scope.pagination.total = 0;
				$scope.pagination.currentPage = $scope.pagination.currentPage || 1;
                $scope.pagination.sortAsc = true;
                $scope.max = 20;

                $scope.pagination.moveTo = function (page) {
                    $scope.pagination.currentPage = page;
                    syncStartFromAndEndAt();
                };

				$scope.numPages = function () {
                    return Math.ceil($scope.pagination.total / $scope.pagination.numPerPage);
                };
                
                $scope.getPageNumbers = function() {
                    return _.range($scope.numPages());
                };
                
                $scope.getLimitCounter = function() {
                    var difference = $scope.max - $scope.pagination.currentPage;
                    if ($scope.pagination.currentPage > ($scope.max / 2)) {
                        return $scope.pagination.currentPage - ($scope.max / 2);
                    } else if (difference) {
                        
                    } else {
                        return 0;
                    }
                }

                $scope.pagination.moveNext = function () {
                    $scope.pagination.currentPage++;
                    syncStartFromAndEndAt();
                };

                $scope.pagination.moveBack = function () {
                    $scope.pagination.currentPage--;
                    syncStartFromAndEndAt();
                };
                syncStartFromAndEndAt();
                $scope.pagination.syncStartFromAndEndAt = syncStartFromAndEndAt;
            };
            
            return paginationFactory;
        }
    ]);
angular.module(appName)
    .controller('appController', [
        'localStorageService',
        function (localStorageService) {
            var app = this;
            var company;
            
            app.company = function () {
                if (!company) {
                    company = localStorageService.getItem('company');
                }
                
                return company;
            };
        }
    ]);
angular.module(appName)
    .value('currentuser', '')
    .value('dragulaAnimationSpeed', 0.5 * 1000)
    .constant('enums',
        {
            //CSH 23052018 - This is a deliberately incomplete list of permission types in the front end. For speed of development I would suggest
            //adding them as we need them, and make sure we put them in the same order they appear on PermissionType2.cs
            'permissionTypes': {
                'BEAGLE_CREATE_WIMD_RECIPES': '1145'
            },
            'currentApplication': {
                'name': 'beagle',
                'id': 5
            },
            'clientExportFormats': {
                '1': 'Adaco',
                '2': 'Acom',
                '3': 'Birchstreet',
                '4': 'Eatec',
                '5': 'FandBShop',
                '6': 'Marketboomer',
                '7': 'Zonal',
                '8': 'Epsl',
                '9': 'Zycus',
                '10': 'GoKart',
                '11': 'GPP',
                '12': 'AgileChain'
            },
            'clientPreferences': {
                'targetMarginPercent': 'TARGETMARGINPERCENT',
                'targetMarginType': 'TARGETMARGINTYPE',
                'customerPortalUrl': 'CUSTOMERPORTALURL',
                'costCalculatorTemplate': 'COSTCALCULATORTEMPLATE',
                'prevailingVatRate': 'PREVAILINGVATRATE',
                'vat': 'VAT'
            },
            'flashReportSections': {
                'spend': 0,
                'credit': 1,
                'revenue': 2
            },
            'orderSheetTypes': {
                'orderGuide': 0,
                'orderSheet': 1,
            },
            'targetMarginTypes': {
                'fcos': 'FCOS',
                'grossProfit': 'GROSSPROFIT'
            },
            'localStorage': {
                'bestPricePurchasingSearch': 'bestPricePurchasingSearch',
                'organisationContext': 'organisationContext',
                'basketSearch': 'basketSearch',
                'shoppingListSearch': 'shoppingListSearch',
                'purchaseOrderSearch': 'purchaseOrderSearch',
                'recipeSearch': 'recipeSearch',
                'isAdminUser': 'isAdminUser',
                'menuFunctionSearch': 'menuFunctionSearch',
                'servicePeriodTypesSearch': 'servicePeriodTypesSearch',
                'manageUrlsSearch': 'manageUrlsSearch',
                'entityTimeoutCache': 'entityTimeoutCache',
                'clientExportsEmail': 'clientExportsEmail'
            },
            'clientExportTransmissionMethodIds': {
                'email': 1
            },
            'broadcasts': {
                'updatedContext': 'updatedContext',
                'fileImported': 'fileImported',
                'nutrientsComponent_forceRefresh': 'nutrientsComponent_forceRefresh'
            },
            'menuCopyTypes': {
                'currentUnit': 1,
                'allUnits': 2
            },
            'shoppingListCopyTypes': {
                'currentUnit': 1,
                'allUnits': 2
            },
            'measureIds': {
                'doz': 162,
                'each': 163,
                'g': 164,
                'gal': 165,
                'kg': 166,
                'lt': 167,
                'ml': 168,
                'cl': 177,
            },
            'productSearchResults': {
                'productId': 0,
                'reference': 1,
                'description': 2,
                'unitOfMeasure': 3,
                'attributes': 4,
                'price': 5,
                'bestPriceSupplierId': 6,
                'bestPriceSkuId': 7,
                'bestPrice': 8,
                'supplier': 9,
                'basketCount': 10,
                'packTypeId': 11,
                'clientSupplierAccountId': 12,
                'skuCode': 13,
                'favouriteId': 15,
                'currencySymbol': 16,
                'measureId': 17,
                'caseQuantity': 18,
                'packQuantity': 19,
                'unit': 20,
                'noOfRecipesUsing': 21,
                'attributeIds': 22,
                '__UNUSED__': 23,
                'rankPrice': 24,
                'sortIndex': 99
            },
            'productSearchTypes': {
                'bestPrice': 0,
                'sku': 1,
                'favourites': 2,
                'subRecipe': 3,
                'usedInRecipe': 4,
                'valVol': 5,
            },
            'productSearchRankType': {
                'bestPrice': 1,
                'bestPortionPrice': 2
            },
            'procurementBasketType': {
                'ProcurementBasket': 'ProcurementBasket',
                'ShoppingList': 'ShoppingList',
                'OrderGuide': 'OrderGuide'
            },
            'procurementBasketTypeInt': {
                'ProcurementBasket': 0,
                'ShoppingList': 1,
                'OrderGuide': 2
            },
            'procurementBasketStatus': {
                'Open': 10,
                'PartSubmitted': 20,
                'Submitted': 30,
                'PartOrdered': 40,
                'Ordered': 50,

            },
            'procurementBasketItemStatus': {
                'Open': 10,
                'Submitted': 20,
                'Ordered': 30
            },
            'packTypes': {
                'caseBox': 1,
                'catchWeight': 2,
                'each': 3,
                'pack': 4
            },
            'invoiceStatus': {
                'Draft': 0,
                'Imported': 1,
                'AwaitingAcceptance': 2,
                'Accepted': 3,
                'Rejected': 4,
                'Exported': 5,
                'PartReconciled': 6,
                'Reconciled': 7,
                'AwaitingCredit': 8
            },
            'creditRequestStatus': {
                'created': 100,
                'submitted': 150,
                'transmitted': 200,
                'partFulfilled': 250,
                'fulfilled': 270,
                'completed': 300,
                'cancelled': 400
            },
            'invoiceTypes': {
                'invoice': 1,
                'creditNote': 2
            },
            'eventNames': {
                'sortOnElementChangedEventName': 'cdb-sort-on-element-changed',
                'uiGridRowSelectionChanged': 'ui-grid-rowSelectionChanged',
                'uiGridCellRowSelectionChangedBatch': 'ui-grid-cell-rowSelectionChangedBatch',
                'purchaseOrderCatalogueSearchRequestToggled': 'purchaseOrderCatalogueSearchRequestToggled',
                'bannerNavigationComplete': 'bannerNavigationComplete',
                'paginationChanged': 'paginationChanged'
            },
            'sortStates': {
                'ascending': 'Ascending',
                'descending': 'Descending'
            },
            'purchaseOrderStatus': {
                'open': 100,
                'pendingApproval': 200,
                'approved': 300,
                'submitted': 400,
                'transmitted': 500,
                'partReceived': 600,
                'received': 700,
                'completed': 800
            },
            'purchaseOrderLineTypes': {
                'basketLine': 1,
                'catalogueLine': 2,
                'manualLine': 3
            },
            'purchaseOrderProjections': {
                'singlePurchaseOrder': 'PurchaseOrders.SinglePurchaseOrderDto',
                'transmittedPurchaseOrder': 'PurchaseOrders.TransmittedPurchaseOrderDto',
                'receivedPurchaseOrder': 'PurchaseOrders.ReceivedPurchaseOrderDto'
            },
            'procurementCreditRequestStatus': {
                'created': 100,
                'submitted': 150,
                'transmitted': 200,
                'partfulfilled': 250,
                'fulfilled': 270,
                'completed': 300,
                'cancelled': 400
            },
            'menuType': {
                'menu': 1,
                'function': 2,
                'all': 3
            },
            'ingredientAllergenStatus': {
                'allergenInformationNotChecked': 0,
                'allergenInformationDefined': 1,
                'allergenInformationNotDefined': 2,
                'allergenInformationUnknown': 3,
                'allergenInformationUnknownDueToNoSupplierSkus': 4
            },
            'systemPreferenceEnum': {
                'vat': 1,
                'naturalWastage': 2,
                'seasonalVariation': 3,
                'staffFeeding': 4,
                'prevailingVatRate': 5,
                'targetMarginPercent': 6,
                'targetMarginType': 7,
                'recipeLite': 8,
                'copyPluWithRecipes': 9,
                'defaultReceivingQuantityFromeDiData': 10,
                'defaultReceivingQuantityFromPurchaseOrder': 11,
                'poPrefix': 12,
                'poStartingNumber': 13,
                'poPadding': 14,
                'crPrefix': 15,
                'crStartingnumber': 16,
                'crPadding': 17,
                'accountingSeparator': 18,
                sopTemplate: 19,
                recipeCardTemplate: 20,
                customerPortalUrl: 21,
                costCalculatorTemplate: 22
            },
            'cookies': {
                'recipeIngredientFavouriteDepartments': 'recipeIngredientFavouriteDepartments'
            },
            procurementAccountTypeEnum: {
                expense: 1,
                revenue: 2
            },
            applicationModules: {
                BEAGLE_FOODFLASHREPORTING: 0,
                BEAGLE_PROCUREMENT: 1,
                BEAGLE_BASIC: 2,
                BEAGLE_WIMD: 3
            },
            flashReportDataSourceTypes: {
                invoiceOnly: 1,
                poOnly: 2,
                reconciledPos: 3
            },
            flashReportIncludeExcludeVat: {
                include: 1,
                exclude: 2
            },
            'savedSearchTypes': {
                'advancedSearchExactSku': 0,
                'advanacedSearchUseRecommended': 1,
                'skuSearchExactSku': 2
            },
            'nutrients': {
                'approvalStatuses': {
                    'approvalRequired': 0,
                    'approved': 1,
                    'rejected': 2,
                    'replaced': 3
                }
            },
            'procurementSkuAttributes':
            {
                'energy_kcal_per_100g': 1,
                'avg_Wt': 2,
                'kCal_per_portion': 3,
                'kCal_per_ingredient': 4
            }
        })

var angular = window.angular
var _organisationContext = JSON.parse(localStorage.getItem('organisationContext'))

angular.module(appName).config([
        '$routeProvider', '$httpProvider', 'enums',
        function ($routeProvider, $httpProvider, enums) {
            window.beagle.routes = [
                {
                    path: '/advanced-search/:entityId/:segmentId?',
                    templateUrl: '/ngxbeagle/dist/content/js/Modules/AdvancedSearch/advancedSearch.html',
                    controller: 'advancedSearchController',
                    resolve: {
                        entityContext$: function (basketContextService, $route) {
                            return basketContextService.get($route.current.params.entityId)
                        }
                    }
                },
                {
                    path: '/advanced-search/create/:entityId/:segmentId?',
                    templateUrl: '/ngxbeagle/dist/content/js/Modules/AdvancedSearch/advancedSearch.html',
                    controller: 'advancedSearchController',
                    resolve: {
                        entityContext$: function (basketContextService, $route) {
                            return basketContextService.get($route.current.params.entityId)
                        }
                    }
                },
                {
                    path: '/advanced-search/:entityId/edit/:basketItemId?/:segmentId?',
                    templateUrl: '/ngxbeagle/dist/content/js/Modules/AdvancedSearch/advancedSearch.html',
                    controller: 'advancedSearchController',
                    resolve: {
                        entityContext$: function (basketContextService, $route) {
                            return basketContextService.get($route.current.params.entityId)
                        }
                    }
                },
                {
                    path: '/',
                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Dashboard/Dashboard.html',
                    controller: 'dashboardController'
                },
                {
                    path: '/SetLogin',
                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Login/setLogin.html',
                    controller: 'setLoginController'
                },
                {
                    path: '/BestPricePurchasingManagement',
                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/BestPricePurchasingMarkedSkus/BestPricePurchasingMarkedSkus.html',
                    controller: 'bestPricePurchasingMarkedSkusController'
                },
                {
                    path: '/logout',
                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Logout/logout.html',
                    controller: 'logoutController'
                },
                {
                    path: '/Dashboard',
                    friendlyNameKey: 'route_dashboard_name',
                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Dashboard/Dashboard.html',
                    controller: 'dashboardController'
                },
                {
                    path: '/Splash',
                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Splash/splash.html'
                },
                {
                    path: '/Unauthorised',
                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Unauthorised/unauthorised.html',
                    controller: 'unauthorisedController',
                    friendlyNameKey: 'Unauthorised',
                    forceHideInMenu: true
                },
                {
                    path: '/MyAccount',
                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/MyAccount/myAccount.html',
                    controller: 'myAccountController',
                    friendlyNameKey: 'Account',
                    forceHideInMenu: true
                },
                {
                    path: '/Eula',
                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Eula/Eula.html',
                    controller: 'eulaController',
                    forceHideInMenu: true
                },
                {
                    path: '#',
                    friendlyNameKey: 'route_invoices_name',
                    children: [
                        {
                            path: '/GroupInvoices',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/Invoices/invoices.html',
                            controller: 'invoicesController',
                            friendlyNameKey: 'route_invoices_groupinvoices_name',
                            permission: 'BEAGLE_GROUPINVOICES_VIEW',
                            resolve: {
                                isGroupClient: function () {
                                    return true
                                },
                            },
                            children: [
                                {
                                    path: '/ViewGroupInvoice/:procurementSubscriptionId/:invoiceHeaderId',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Invoice/invoice.html',
                                    controller: 'invoiceController',
                                    resolve: {
                                        invoiceData: function (invoiceService, $route) {
                                            return invoiceService.getInvoiceById(
                                                $route.current.params.procurementSubscriptionId,
                                                $route.current.params.invoiceHeaderId)
                                        },
                                        isGroupClient: function () {
                                            return true
                                        }
                                    }
                                }
                            ]
                        },
                        {
                            path: '/GroupInvoices/Export',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/InvoiceExport/invoicesExport.html',
                            controller: 'invoicesExportController',
                            friendlyNameKey: 'route_invoices_groupinvoicesexport_name',
                            permission: 'BEAGLE_GROUPINVOICES_EXPORT',
                            resolve: {
                                isGroupClient: function () {
                                    return true
                                },
                                supplierData: function (invoiceService, organisationContextService) {
                                    var ctx = organisationContextService.getContext()
                                    return invoiceService.getUnitSuppliersForGroup(ctx.organisation.id, ctx.id)
                                },
                                transmissionMethods: function (invoiceService, organisationContextService) {
                                    var ctx = organisationContextService.getContext()
                                    return invoiceService.getUnitSuppliersForGroup(ctx.organisation.id, ctx.id)
                                }
                            }
                        },

                        {
                            path: '/UnitInvoices',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/Invoices/invoices.html',
                            controller: 'invoicesController',
                            friendlyNameKey: 'route_invoices_unitinvoices_name',
                            permission: 'BEAGLE_INVOICES_VIEW',
                            resolve: {
                                isGroupClient: function () {
                                    return false
                                },
                            },
                            children: [
                                {
                                    path: '/ViewUnitInvoice/:procurementSubscriptionId/:invoiceHeaderId',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Invoice/invoice.html',
                                    controller: 'invoiceController',
                                    permission: 'BEAGLE_INVOICES_VIEW',
                                    resolve: {
                                        invoiceData: function (invoiceService, organisationContextService, $route) {
                                            var ctx = organisationContextService.getContext()
                                            return invoiceService.getInvoiceById(ctx.currentSubscriptionUnit.id,
                                                $route.current.params.invoiceHeaderId)
                                        },
                                        isGroupClient: function () {
                                            return false
                                        }
                                    }
                                }
                            ]
                        },
                        {
                            path: '/UnitInvoices/Export',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/InvoiceExport/invoicesExport.html',
                            controller: 'invoicesExportController',
                            friendlyNameKey: 'route_invoices_unitinvoicesexport_name',
                            permission: 'BEAGLE_INVOICES_EXPORT',
                            // TODO: Implement when we have real api calls to use
                            resolve: {
                                //supplierData: function (unitSuppliersService, organisationContextService) {
                                //    return false;
                                //},
                                isGroupClient: function () {
                                    return false
                                },
                                supplierData: function (invoiceService, organisationContextService) {
                                    var ctx = organisationContextService.getContext()
                                    return invoiceService.getUnitSuppliers(ctx.currentSubscriptionUnit.organisation.id,
                                        ctx.id)
                                }
                            }
                        },
                        {
                            path: '/CreditRequests',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/CreditRequestsList/creditRequestList.html',
                            friendlyNameKey: 'route_credit_request_list',
                            permission: 'BEAGLE_CREDIT_REQUESTS_VIEW'
                        },
                        {
                            path: '/CreditRequest/:creditRequestId',
                            controller: 'creditRequestView',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/CreditRequestView/creditRequestView.html',
                            hideOnLandingPage: true,
                            resolve: {
                                creditRequestData: function ($route, creditRequestService) {
                                    var id = $route.current.params.creditRequestId
                                    return creditRequestService.get(id)
                                }
                            }
                        },
                        {
                            path: '/CreditNote/Reconcile/:creditRequestId',
                            controller: 'creditReconciliationController',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/CreditReconciliation/creditReconciliation.html',
                            hideOnLandingPage: true,
                            resolve: {
                                creditNoteData: function ($route, creditNoteService) {
                                    var id = $route.current.params.creditRequestId
                                    return creditNoteService.get(id)
                                },
                                unreconciledCreditRequestData: function ($route, creditReconciliationService) {
                                    return creditReconciliationService.getUnreconciledCreditRequests($route.current
                                        .params.creditRequestId)
                                }
                            }
                        },
                        {
                            path: '/Invoices/Reconcile/:invoiceId/:purchaseOrderId?',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/InvoiceReconciliation/invoiceReconciliation.html',
                            controller: 'invoiceReconciliationController',
                            //permission: 'BEAGLE_INVOICES_RECONCILE',
                            resolve: {
                                invoiceData: function ($route, invoiceService, organisationContextService) {
                                    var procurementSubscriptionId = organisationContextService.getContext().id
                                    return invoiceService.getInvoiceById(procurementSubscriptionId,
                                        $route.current.params.invoiceId)
                                },
                                invoiceLineData: function ($route, invoiceReconciliationService) {
                                    return invoiceReconciliationService.getInvoiceLinesForReconciliation($route.current
                                        .params.invoiceId)
                                },
                                creditDueData: function ($route, invoiceReconciliationService) {
                                    return invoiceReconciliationService.getCreditDue($route.current.params.invoiceId)
                                },
                                unreconciledPoData: function ($route, invoiceReconciliationService) {
                                    return invoiceReconciliationService.getUnreconciledReceivingPurchaseOrders(
                                        $route.current.params.invoiceId)
                                }
                            }
                        }
                    ]
                },
                {
                    path: '#',
                    friendlyNameKey: 'route_reports_name',
                    children: [
                        {
                            path: '/GroupReports',
                            friendlyNameKey: 'route_reports_groupreports_name',
                            controller: 'sectionLandingPageController',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/SectionLandingPage/sectionLandingPage.html',
                            //permission: "BEAGLE_REPORTINGGROUPS_VIEW", //Missing from merge may be needed?  JP
                            children: [
                                {
                                    friendlyNameKey: 'route_reports_groupreports_whatsinmydishfuturefunctionsgroupreport_name',
                                    path: _organisationContext == null ? '' :
                                        '/ssrs?BasketCostMatrixReports/FutureFunctionsReportGroup'
                                        + '&ClientId=' + JSON.parse(localStorage.getItem('organisationContext')).currentSubscriptionUnit.client.id
                                        + '&UserId=' + JSON.parse(localStorage.getItem('organisationContext')).user.id
                                        + '&rs:ParameterLanguage=&rc:Parameters=Collapsed&rc:Toolbar=False',
                                    permission: 'GROUP_WIMD_REPORT_FUTUREFUNCTION'
                                },
                                {
                                    path: '/GroupReports/GroupFoodFlashReport',
                                    friendlyNameKey: 'route_reports_groupreports_groupfoodflashreport_name',
                                    templateUrl:
                                        '/ngxbeagle/dist/Content/js/modules/reporting/GroupFoodFlashReport/groupFoodFlashReport.html',
                                    controller: 'groupFoodFlashReportController',
                                    permission: 'BEAGLE_GROUPREPORT_VIEW',
                                },
                                {
                                    path: '/GroupReports/GroupAllowanceReport',
                                    friendlyNameKey: 'route_reports_groupreports_groupallowancereport_name',
                                    templateUrl: '/ngxbeagle/dist/Content/js/modules/AllowanceReport/allowanceReport.html',
                                    controller: 'allowanceReportController',
                                    permission: 'BEAGLE_REPORT_GROUP_ALLOWANCE'
                                },
                                {
                                    friendlyNameKey: 'route_reports_groupreports_purchasing_report',
                                    // We need to null check the orgContext here.
                                    path: _organisationContext == null ? '' :
                                        '/ssrs?BasketCostMatrixReports/PurchasingReportGroup'
                                        + '&ClientId=' + JSON.parse(localStorage.getItem('organisationContext')).currentSubscriptionUnit.client.id
                                        + '&UserId=' + JSON.parse(localStorage.getItem('organisationContext')).user.id
                                        + '&rs:ParameterLanguage=&rc:Parameters=Collapsed&rc:Toolbar=False',
                                    permission: 'BEAGLE_GROUP_PURCHASING_REPORT'
                                },
                                {
                                    friendlyNameKey: 'route_reports_groupreports_user_last_log_in_report',
                                    path: _organisationContext == null ? '' :
                                        '/ssrs?BasketCostMatrixReports/BeagleUserLastLogInWithRoles'
                                        + '&ClientGroupOrgId=' + JSON.parse(localStorage.getItem('organisationContext')).currentSubscriptionUnit.groupOrganisation.id,
                                    permission: 'BEAGLE_GROUP_USER_LAST_LOG_IN_REPORT'
                                },
                                {
                                    friendlyNameKey: 'route_reports_groupreports_late_delivery_report',
                                    // We need to null check the orgContext here.
                                    path: _organisationContext == null ? '' :
                                        '/ssrs?BasketCostMatrixReports/LateDeliveryReportGroup'
                                        + '&UserId=' + JSON.parse(localStorage.getItem('organisationContext')).user.id
                                        + '&rs:ParameterLanguage=&rc:Parameters=Collapsed&rc:Toolbar=False',
                                    permission: 'BEAGLE_GROUP_LATE_DELIVERY_REPORT'
                                },
                                {
                                    friendlyNameKey: 'route_reports_groupreports_order_history_report',
                                    // We need to null check the orgContext here.
                                    path: _organisationContext == null ? '' :
                                        '/ssrs?BasketCostMatrixReports/OrderHistoryReportGroup'
                                        + '&UserId=' + JSON.parse(localStorage.getItem('organisationContext')).user.id
                                        + '&rs:ParameterLanguage=&rc:Parameters=Collapsed&rc:Toolbar=False',
                                    permission: 'BEAGLE_GROUP_ORDER_HISTORY_REPORT'
                                },
                                {
                                    friendlyNameKey: 'route_reports_groupreports_accrual_report',
                                    // We need to null check the orgContext here.
                                    path: _organisationContext == null ? '' :
                                        '/ssrs?BasketCostMatrixReports/AccrualReportGroup'
                                        + '&UserId=' + JSON.parse(localStorage.getItem('organisationContext')).user.id
                                        + '&ClientId=' + JSON.parse(localStorage.getItem('organisationContext')).currentSubscriptionUnit.client.id
                                        + '&rs:ParameterLanguage=&rc:Parameters=Collapsed&rc:Toolbar=False',
                                    permission: 'BEAGLE_GROUP_ACCRUAL_REPORT'
                                },
                                {
                                    friendlyNameKey: 'route_reports_groupreports_delivery_fulfilment_report',
                                    // We need to null check the orgContext here.
                                    path: _organisationContext == null ? '' :
                                        '/ssrs?BasketCostMatrixReports/DeliveryFulfilmentReportGroup'
                                        + '&UserId=' + JSON.parse(localStorage.getItem('organisationContext')).user.id
                                        + '&ClientId=' + JSON.parse(localStorage.getItem('organisationContext')).currentSubscriptionUnit.client.id
                                        + '&rs:ParameterLanguage=&rc:Parameters=Collapsed&rc:Toolbar=False',
                                    permission: 'BEAGLE_GROUP_DELIVERY_FULFILMENT_REPORT'
                                }
                            ]
                        },
                        {
                            path: '/UnitReports',
                            friendlyNameKey: 'route_reports_unitreports_name',
                            controller: 'sectionLandingPageController',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/SectionLandingPage/sectionLandingPage.html',
                            children: [
                                {
                                    friendlyNameKey: 'route_reports_unitreports_whatsinmydishfuturefunctionsunitreport_name',
                                    path: _organisationContext == null ? '' :
                                        '/ssrs?BasketCostMatrixReports/FutureFunctionsReportUnit'
                                        + '&ClientId=' + JSON.parse(localStorage.getItem('organisationContext')).currentSubscriptionUnit.client.id
                                        + '&UserId=' + JSON.parse(localStorage.getItem('organisationContext')).user.id
                                        + '&rs:ParameterLanguage=&rc:Parameters=Collapsed&rc:Toolbar=False',
                                    permission: 'UNIT_WIMD_REPORT_FUTUREFUNCTION'
                                },
                                {
                                    friendlyNameKey: 'route_reports_unitreports_whatsinmydishrecipelistunitreport_name',
                                    path: _organisationContext == null ? '' :
                                        '/ssrs?Whats In My Dish/WIMDRecipeList_Beagle'
                                        + '&ClientId=' + JSON.parse(localStorage.getItem('organisationContext')).currentSubscriptionUnit.client.id
                                        + '&rs:ParameterLanguage=&rc:Parameters=Collapsed&rc:Toolbar=False',
                                    permission: 'UNIT_WIMD_REPORT_LIST'
                                },
                                {
                                    path: '/UnitReports/UnitStockReport',
                                    friendlyNameKey: 'route_reports_unitreports_unitstockreport_name',
                                    templateUrl: '/ngxbeagle/dist/Content/js/modules/reporting/UnitReports/StockReport/unitStockReport.html',
                                    controller: 'unitStockReportController',
                                    hideOnLandingPage: true,
                                    permission: 'BEAGLE_STOCK_REPORT',
                                    resolve: {
                                        unitNameData: function (myUnitsService, organisationContextService) {
                                            var ctx = organisationContextService.getContext()
                                            return myUnitsService.getUnitName(ctx.currentSubscriptionUnit.id)
                                        }
                                    }
                                },
                                {
                                    path: '/UnitReports/UnitFlashReport',
                                    friendlyNameKey: 'route_reports_unitreports_unitflashreport_name',
                                    templateUrl: '/ngxbeagle/dist/Content/js/modules/reporting/UnitReports/unitReport.html',
                                    controller: 'unitReportController',
                                    permission: 'BEAGLE_UNITREPORT_VIEW',
                                    resolve: {
                                        unitNameData: function (myUnitsService, organisationContextService) {
                                            var ctx = organisationContextService.getContext()
                                            return myUnitsService.getUnitName(ctx.currentSubscriptionUnit.id)
                                        }
                                    }
                                },
                                {
                                    path: '/UnitReports/v2/FlashReports',
                                    friendlyNameKey: 'route_reports_unitreports_v2_flashreportlist',
                                    templateUrl: '/ngxbeagle/dist/Content/js/modules/reporting/UnitReports/FlashReporting/flashReportList.html',
                                    controller: 'flashReportListController',
                                    permission: 'BEAGLE_CAN_VIEW_FLASH_REPORT',
                                    hideOnLandingPage: false,
                                    children: [
                                        {
                                            path: '/UnitReports/v2/FlashReports/:flashReportId',
                                            templateUrl: '/ngxbeagle/dist/Content/js/modules/reporting/UnitReports/FlashReporting/flashReportDetail.html',
                                            controller: 'flashReportDetailController',
                                            permission: 'BEAGLE_CAN_VIEW_FLASH_REPORT',
                                            reloadOnSearch: false
                                        }
                                    ]
                                },
                                {
                                    path: '/UnitReports/UnitFlashReport/:procurementSubscriptionUnitId/:procurementSubscriptionAccountingPeriodId/:reportDateTo?',
                                    templateUrl: '/ngxbeagle/dist/Content/js/modules/reporting/unitreports/unitReport.html',
                                    controller: 'unitReportController',
                                    permission: 'BEAGLE_UNITREPORT_VIEW',
                                    hideOnLandingPage: true,
                                    resolve: {
                                        unitNameData: function (myUnitsService, $route, organisationContextService) {
                                            if ($route.current.params.procurementSubscriptionUnitId) {
                                                return myUnitsService.getUnitName($route.current.params
                                                    .procurementSubscriptionUnitId)
                                            } else {
                                                var ctx = organisationContextService.getContext()
                                                console.log(ctx)
                                                return myUnitsService.getUnitName(ctx.currentSubscriptionUnit.id)
                                            }

                                        }
                                    }
                                },
                                {
                                    path: '/UnitAllowanceReport',
                                    friendlyNameKey: 'route_reports_unitreports_unitallowancereport_name',
                                    templateUrl: '/ngxbeagle/dist/Content/js/modules/AllowanceReport/allowanceReport.html',
                                    controller: 'allowanceReportController',
                                    permission: 'BEAGLE_REPORT_UNIT_ALLOWANCE'
                                },
                                {
                                    friendlyNameKey: 'route_reports_unitreports_monthly_purchasing_report',
                                    // We need to null check the orgContext here.
                                    path: _organisationContext == null ? '' :
                                        '/ssrs?BasketCostMatrixReports/MonthlyPurchasingReportUnit'
                                        + '&ClientId=' + JSON.parse(localStorage.getItem('organisationContext')).currentSubscriptionUnit.client.id
                                        + '&UserId=' + JSON.parse(localStorage.getItem('organisationContext')).user.id
                                        + '&rs:ParameterLanguage=&rc:Parameters=Collapsed&rc:Toolbar=False',
                                    permission: 'BEAGLE_UNIT_MONTHLY_PURCHASING_REPORT'
                                },
                                {
                                    friendlyNameKey: 'route_reports_unitreports_purchasing_report',
                                    // We need to null check the orgContext here.
                                    path: _organisationContext == null ? '' :
                                        '/ssrs?BasketCostMatrixReports/PurchasingReportUnit'
                                        + '&ClientId=' + JSON.parse(localStorage.getItem('organisationContext')).currentSubscriptionUnit.client.id
                                        + '&UserId=' + JSON.parse(localStorage.getItem('organisationContext')).user.id
                                        + '&rs:ParameterLanguage=&rc:Parameters=Collapsed&rc:Toolbar=False',
                                    permission: 'BEAGLE_UNIT_PURCHASING_REPORT'
                                },
                                {
                                    friendlyNameKey: 'route_reports_unitreports_late_delivery_report',
                                    // We need to null check the orgContext here.
                                    path: _organisationContext == null ? '' :
                                        '/ssrs?BasketCostMatrixReports/LateDeliveryReportUnit'
                                        + '&UserId=' + JSON.parse(localStorage.getItem('organisationContext')).user.id
                                        + '&rs:ParameterLanguage=&rc:Parameters=Collapsed&rc:Toolbar=False',
                                    permission: 'BEAGLE_UNIT_LATE_DELIVERY_REPORT'
                                },
                                {
                                    friendlyNameKey: 'route_reports_unitreports_order_history_report',
                                    // We need to null check the orgContext here.
                                    path: _organisationContext == null ? '' :
                                        '/ssrs?BasketCostMatrixReports/OrderHistoryReportUnit'
                                        + '&UserId=' + JSON.parse(localStorage.getItem('organisationContext')).user.id
                                        + '&rs:ParameterLanguage=&rc:Parameters=Collapsed&rc:Toolbar=False',
                                    permission: 'BEAGLE_UNIT_ORDER_HISTORY_REPORT'
                                },
                                {
                                    friendlyNameKey: 'route_reports_unitreports_accrual_report',
                                    // We need to null check the orgContext here.
                                    path: _organisationContext == null ? '' :
                                        '/ssrs?BasketCostMatrixReports/AccrualReportUnit'
                                        + '&UserId=' + JSON.parse(localStorage.getItem('organisationContext')).user.id
                                        + '&ClientId=' + JSON.parse(localStorage.getItem('organisationContext')).currentSubscriptionUnit.client.id
                                        + '&rs:ParameterLanguage=&rc:Parameters=Collapsed&rc:Toolbar=False',
                                    permission: 'BEAGLE_UNIT_ACCRUAL_REPORT'
                                },
                                {
                                    friendlyNameKey: 'route_reports_unitreports_delivery_fulfilment_report',
                                    // We need to null check the orgContext here.
                                    path: _organisationContext == null ? '' :
                                        '/ssrs?BasketCostMatrixReports/DeliveryFulfilmentReportUnit'
                                        + '&UserId=' + JSON.parse(localStorage.getItem('organisationContext')).user.id
                                        + '&ClientId=' + JSON.parse(localStorage.getItem('organisationContext')).currentSubscriptionUnit.client.id
                                        + '&rs:ParameterLanguage=&rc:Parameters=Collapsed&rc:Toolbar=False',
                                    permission: 'BEAGLE_UNIT_DELIVERY_FULFILMENT_REPORT'
                                },
                                {
                                    friendlyNameKey: 'route_reports_unitreports_calculatenutrients_name',
                                    path: _organisationContext == null ? '' :
                                        '/ssrs?BasketCostMatrixReports/CalorieCalculationsByMenu'
                                        + '&ClientId=' + JSON.parse(localStorage.getItem('organisationContext')).currentSubscriptionUnit.client.id
                                        + '&rs:ParameterLanguage=&rc:Parameters=Collapsed&rc:Toolbar=False'
                                },
                            ]
                        },

                        {
                            path: '/csm',
                            forceHideInMenu: false,
                            friendlyNameKey: 'route_csm_name',
                            templateUrl: '/ngxbeagle/dist/Content/js/modules/csm/csm.html',
                            controller: 'csmController',
                            permission: 'BEAGLE_ACCESS_CSM',
                            openInNewWindow: true
                        },
                        {
                            path: '/BestPricePurchasingManagement',
                            friendlyNameKey: 'route_best_price_purchasing_management_name',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/BestPricePurchasingMarkedSkus/BestPricePurchasingMarkedSkus.html',
                            controller: 'bestPricePurchasingMarkedSkusController',
                            permission: 'MARK_BEST_PRICE_PURCHASING_SKU'
                        }
                    ]
                },
                {
                    path: '#',
                    friendlyNameKey: 'route_setup_name',
                    children: [
                        {
                            path: '/GroupSetup',
                            friendlyNameKey: 'route_setup_groupsetup_name',
                            controller: 'sectionLandingPageController',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/SectionLandingPage/sectionLandingPage.html',
                            //needsOneOf: [  //From merge may not be needed ~JP
                            //            "BEAGLE_DEPARTMENTS_VIEW",
                            //            "BEAGLE_COSTCENTRES_VIEW",
                            //            "BEAGLE_UNITACCOUNTCODES_VIEW",
                            //            "BEAGLE_ACCOUNTINGYEAR_VIEW",
                            //            "BEAGLE_REPORTINGGROUPS_VIEW",
                            //            "BEAGLE_EXCHANGERATES_VIEW",
                            //            "BEAGLE_RECEIVINGVARIANCEREASONS_VIEW"
                            //],
                            children: [
                                {
                                    path: '/ClientProcurementDepartments',
                                    friendlyNameKey: 'route_setup_groupsetup_departments_name',
                                    controller: 'clientProcurementDepartmentController',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/ClientProcurementDepartments/clientProcurementDepartments.html',
                                    permission: 'BEAGLE_DEPARTMENTS_VIEW',
                                    resolve: {
                                        clientProcurementDepartmentData:
                                            function (localStorageService, clientProcurementDepartmentService, enums) {
                                                var subscriptionId = localStorageService.getItem(enums.localStorage.organisationContext)
                                                    .id
                                                return clientProcurementDepartmentService.get(subscriptionId)
                                            }
                                    },
                                    descriptionKey: 'route_setup_groupsetup_departments_description'
                                },
                                {
                                    path: '/ClientProcurementAccountCodes',
                                    friendlyNameKey: 'route_setup_groupsetup_accountcodes_name',
                                    controller: 'clientProcurementAccountCodeController',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/ClientProcurementAccountCodes/ClientProcurementAccountCode.html',
                                    permission: 'BEAGLE_COSTCENTRES_VIEW',
                                    resolve: {
                                        clientProcurementAccountCodeData:
                                            function (localStorageService, clientProcurementAccountCodeService, enums) {
                                                var subscriptionId = localStorageService.getItem(enums.localStorage.organisationContext)
                                                    .id
                                                return clientProcurementAccountCodeService.get(subscriptionId)
                                            },
                                        accountTypesResolve:
                                            function (clientProcurementAccountCodeService) {
                                                return clientProcurementAccountCodeService.getAccountTypes()
                                            }
                                    },
                                    descriptionKey: 'route_setup_groupsetup_accountcodes_description'
                                },
                                {
                                    path: '/AllowanceTypes',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/AllowanceTypes/allowanceTypes.html',
                                    controller: 'allowanceTypesController',
                                    friendlyNameKey: 'route_setup_groupsetup_allowancetypes_name',
                                    permission: 'BEAGLE_ALLOWANCETYPES_VIEW',
                                    resolve: {
                                        allowanceTypesData: function (localStorageService, allowanceTypesService, enums) {
                                            var subscriptionId = localStorageService.getItem(enums.localStorage.organisationContext).id
                                            return allowanceTypesService.get(subscriptionId)
                                        },
                                        context: function (localStorageService, enums) {
                                            return localStorageService.getItem(enums.localStorage.organisationContext)
                                        }
                                    },
                                    descriptionKey: 'route_setup_groupsetup_allowancetypes_description'
                                },
                                {
                                    path: '/Accounting',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Accounting/accounting.html',
                                    controller: 'accountingController',
                                    friendlyNameKey: 'route_setup_groupsetup_accountingyears_name',
                                    permission: 'BEAGLE_ACCOUNTINGYEAR_VIEW',
                                    resolve: {
                                        procurementSubscription: function (localStorageService, enums) {
                                            var orgContext = localStorageService.getItem(enums.localStorage.organisationContext)
                                            return {
                                                procurementSubscriptionId: orgContext.id
                                            }
                                        }
                                    },
                                    descriptionKey: 'route_setup_groupsetup_accountingyears_description'
                                },
                                {
                                    path: '/ReportingGroups',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/ReportingGroups/reportingGroupsList.html',
                                    controller: 'reportingGroupsListController',
                                    friendlyNameKey: 'route_setup_groupsetup_reportinggroups_name',
                                    permission: 'BEAGLE_REPORTINGGROUPS_VIEW',
                                    resolve: {
                                        reportingGroupListData: function (reportingGroupsService, organisationContextService) {
                                            var ctx = organisationContextService.getContext()
                                            return reportingGroupsService.getReportingGroups(ctx.id)
                                        }
                                    },
                                    descriptionKey: 'route_setup_groupsetup_reportinggroups_description',
                                    children: [
                                        {
                                            path: '/ReportingGroups/View/:reportingGroupId?',
                                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/ReportingGroups/reportingGroupsView.html',
                                            controller: 'reportingGroupsViewController',
                                            resolve: {
                                                reportingGroupData: function (reportingGroupsService, $route) {
                                                    return reportingGroupsService.getReportingGroupData($route.current.params.reportingGroupId)
                                                }
                                            }
                                        }
                                    ]
                                },
                                {
                                    path: '/ExchangeRate',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/ExchangeRates/exchangeRate.html',
                                    controller: 'exchangeRateController',
                                    friendlyNameKey: 'route_setup_groupsetup_exchangerates_name',
                                    resolve: {
                                        exchangeRates: function (localStorageService, exchangeRateService, enums) {
                                            var subscriptionId = localStorageService.getItem(enums.localStorage.organisationContext).id
                                            return exchangeRateService.getExchangeRates(subscriptionId,
                                                function (data) {
                                                    return data
                                                })
                                        },
                                        currencies: function (currencyService) {
                                            return currencyService.get()
                                        }
                                    },
                                    descriptionKey: 'route_setup_groupsetupexchangerates_description',
                                    permission: 'BEAGLE_EXCHANGERATES_VIEW'
                                },
                                {
                                    path: '/ReceivingVarianceReasons',
                                    friendlyNameKey: 'route_setup_groupsetup_variancereasons_name',
                                    controller: 'clientProcurementReceivingVarianceReasonsController',
                                    templateUrl:
                                        '/ngxbeagle/dist/Content/js/Modules/ClientProcurementReceivingVarianceReasons/clientProcurementReceivingVarianceReasons.html',
                                    permission: 'BEAGLE_RECEIVINGVARIANCEREASONS_VIEW',
                                    resolve: {
                                        receivingVarianceReasonData:
                                            function (localStorageService, clientProcurementReceivingVarianceReasonsService, enums) {
                                                var subscriptionId = localStorageService.getItem(enums.localStorage.organisationContext)
                                                    .id
                                                return clientProcurementReceivingVarianceReasonsService.get(subscriptionId)
                                            }
                                    },
                                    descriptionKey: 'route_setup_groupsetup_variancereasons_description'
                                },
                                {
                                    path: '/ServicePeriodTypes',
                                    friendlyNameKey: 'route_setup_groupsetup_wimd_serviceperiodtypes_name',
                                    controller: 'searchServicePeriodTypesController',
                                    templateUrl:
                                        '/ngxbeagle/dist/Content/js/Modules/ServicePeriodTypes/Search/searchServicePeriodTypes.html',
                                    permission: 'BEAGLE_WIMD_SERVICEPERIODTYPES_VIEW',
                                    resolve: {
                                        servicePeriodTypesData:
                                            function (servicePeriodTypesService) {
                                                //var searchParams = servicePeriodTypesService.getSearchParams();
                                                return servicePeriodTypesService.getAll()
                                            }
                                    },
                                    descriptionKey: 'route_setup_groupsetup_wimd_serviceperiodtypes_description'
                                }
                            ]
                        },
                        {
                            path: '/ClientUnitSetup',
                            friendlyNameKey: 'route_setup_unitsetup_name',
                            controller: 'clientUnitSetupController',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/ClientUnitSetup/clientUnitSetup.html',
                            needsOneOf: ['BEAGLE_MANAGECLIENTPREFERENCES', 'BEAGLE_DEPARTMENTS_VIEW', 'BEAGLE_UNITDEPARTMENTS_VIEW', 'BEAGLE_UNITACCOUNTCODES_VIEW', 'BEAGLE_UNITACCOUNTCODES_VIEW', 'BEAGLE_UNITVARIANCEREASONS_VIEW', 'BEAGLE_UNITALLOWANCETYPES_VIEW'],

                        },
                        {
                            path: '/GroupSuppliers',
                            friendlyNameKey: 'route_setup_groupsuppliers_name',
                            controller: 'clientProcurementSuppliersController',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/ClientProcurementSuppliers/clientProcurementSuppliers.html',
                            permission: 'BEAGLE_SUBSCRIPTIONSUPPLIER_VIEW',
                            children: [
                                {
                                    path: '/GroupSuppliers/AddEdit/:id?',
                                    controller: 'addEditClientProcurementSupplierController',
                                    templateUrl: '/ngxbeagle/dist/Content/js/modules/ClientProcurementSuppliers/addEditClientProcurementSupplier/addEditClientProcurementSupplier.html',
                                    forceHideInMenu: true,
                                    resolve: {
                                        groupSupplierData: function ($route, $q, clientProcurementSuppliersResource) {
                                            var subscriptionSupplierId = $route.current.params.id
                                            if (subscriptionSupplierId === undefined) {
                                                var deferred = $q.defer()
                                                deferred.resolve()
                                                deferred.$promise = deferred.promise
                                                return deferred
                                            }

                                            return clientProcurementSuppliersResource.getSupplierData({ subscriptionSupplierId: subscriptionSupplierId })
                                        },

                                        countryData: function (countryResource, localStorageService, enums) {

                                            var orgContext = localStorageService.getItem(enums.localStorage.organisationContext)
                                            //return countryResource.get();
                                            return countryResource.getCountriesWithOrgCountry({ orgId: orgContext.organisation.id })
                                        }
                                    }
                                },
                                {
                                    path: '/ManageSuppliers/Assign/:clientSupplierId?',
                                    controller: 'assignSupplierController',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/ClientUnitSuppliers/AssignSupplier/assignSupplier.html',
                                    permission: 'BEAGLE_UNITSUPPLIERS_VIEW',
                                    resolve: {
                                        unitSupplierData: function (unitSuppliersService, $route) {
                                            var clientSupplierId = $route.current.params.clientSupplierId
                                            if (!clientSupplierId) {
                                                var deferred = $q.defer()
                                                deferred.resolve()
                                                deferred.$promise = deferred.promise
                                                return deferred
                                            }

                                            return unitSuppliersService.getUnitSupplier(orgId, subscriptionId)
                                        }
                                    }
                                },
                                {
                                    path: '/ManagePricing/:supplierId/:agreementId/:supplierName',
                                    friendlyNameKey: 'route_setup_groupsuppliers_managepricing_name',
                                    controller: 'clientProcurementSupplierPricingController',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/ClientProcurementSupplierPricing/clientProcurementSupplierPricing.html'
                                    //forceHideInMenu: true, JP
                                },
                                {
                                    path: '/GroupSuppliers/Edit/:id?',
                                    friendlyNameKey: 'route_setup_groupsuppliers_addedit_name',
                                    controller: 'addEditGroupSupplierController',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/GroupSuppliers/addEditGroupSupplier.html',
                                    forceHideInMenu: true,
                                    resolve: {
                                        groupSupplierData: function ($route, $q, groupSuppliersResource) {
                                            var id = $route.current.params.id
                                            if (id === undefined) {
                                                return $q.when({})
                                            }
                                            return groupSuppliersResource.getGroupSupplierDetail({ id: id })
                                        }
                                    }
                                }
                            ]
                        },
                        {
                            path: '/UnitSuppliers',
                            friendlyNameKey: 'route_setup_unitsuppliers_name',
                            controller: 'unitSuppliersController',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/ClientUnitSuppliers/UnitSuppliers.html',
                            permission: 'BEAGLE_UNITSUPPLIERS_VIEW'
                        },
                        {
                            path: '/UsersAndRoles',
                            friendlyNameKey: 'route_setup_usersandroles_name',
                            controller: 'sectionLandingPageController',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/SectionLandingPage/sectionLandingPage.html',
                            children: [
                                {
                                    path: '/Users',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/ManageUsers/manageUsers.html',
                                    controller: 'manageUsersController',
                                    friendlyNameKey: 'route_setup_usersandroles_users_name',
                                    permission: 'BEAGLE_MANAGEUSERS_VIEW',
                                    resolve: {
                                        procurementSubscription: function (localStorageService, enums) {
                                            var orgContext = localStorageService.getItem(enums.localStorage.organisationContext)
                                            return {
                                                procurementSubscriptionId: orgContext.id,
                                                organisation: orgContext.organisation
                                            }
                                        }
                                    },
                                    descriptionKey: 'route_setup_usersandroles_users_description',
                                    children: [
                                        {
                                            path: '/ManageUser/:userId',
                                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/ManageUser/manageUser.html',
                                            controller: 'manageUserController',
                                            friendlyNameKey: 'Single'
                                        }
                                    ]
                                },
                                {
                                    path: '/Roles',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Roles/roles.html',
                                    controller: 'rolesController',
                                    friendlyNameKey: 'route_setup_usersandroles_roles_name',
                                    permission: 'BEAGLE_MANAGEROLES',
                                    resolve: {
                                        data: function (localStorageService, enums) {
                                            var orgContext = localStorageService.getItem(enums.localStorage.organisationContext)
                                            return {
                                                groupOrganisation: orgContext.organisation
                                            }
                                        }
                                    },
                                    descriptionKey: 'route_setup_usersandroles_roles_description'
                                }
                            ]
                        }
                    ]
                },
                {
                    path: '#',
                    friendlyNameKey: 'route_managedata_name',
                    children: [
                        {
                            path: '/GroupImports',
                            friendlyNameKey: 'route_managedata_groupimports_name',
                            controller: 'sectionLandingPageController',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/SectionLandingPage/sectionLandingPage.html',
                            needsOneOf: ['BEAGLE_INVOICEHEADER_UPLOAD', 'BEAGLE_BUDGET_UPLOAD', 'BEAGLE_ALLOWANCE_UPLOAD', 'BEAGLE_REVENUE_UPLOAD'],
                            children: [
                                {
                                    path: '/GroupRevenueImport',
                                    friendlyNameKey: 'route_managedata_groupimports_grouprevenueimport_name',
                                    controller: 'revenueController',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Revenue/revenue.html',
                                    resolve: {
                                        revenueImportContext: function () {
                                            return 'GROUP'
                                        }
                                    },
                                    permission: 'BEAGLE_REVENUE_UPLOAD',
                                    descriptionKey: 'route_managedata_groupimports_grouprevenueimport_description'
                                },
                                {
                                    path: '/GroupAllowanceImport',
                                    friendlyNameKey: 'route_managedata_groupimports_groupallowanceimport_name',
                                    controller: 'allowanceController',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Allowance/allowance.html',
                                    permission: 'BEAGLE_ALLOWANCE_UPLOAD',
                                    resolve: {
                                        importContext: function () {
                                            return 'GROUP'
                                        }
                                    },
                                    descriptionKey: 'route_managedata_groupimports_groupallowanceimport_description'
                                },
                                {
                                    path: '/GroupBudgetImport',
                                    friendlyNameKey: 'route_managedata_groupimports_groupbudgetimport_name',
                                    controller: 'budgetImportController',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/BudgetImport/budgetImport.html',
                                    permission: 'BEAGLE_BUDGET_UPLOAD',
                                    resolve: {
                                        importContext: function () {
                                            return 'GROUP'
                                        }
                                    },
                                    descriptionKey: 'route_managedata_groupimports_groupbudgetimport_description'
                                },
                                {
                                    path: '/GroupInvoiceHeaderImport',
                                    friendlyNameKey: 'route_managedata_groupimports_groupinvoiceheaderimport_name',
                                    controller: 'invoiceHeaderImportController',
                                    permission: 'BEAGLE_INVOICEHEADER_UPLOAD',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/InvoiceHeaderImport/invoiceHeaderImport.html',
                                    resolve: {
                                        importContext: function () {
                                            return 'GROUP'
                                        }
                                    },
                                    descriptionKey: 'route_managedata_groupimports_groupinvoiceheaderimport_description'
                                }
                            ]
                        },
                        {
                            path: '/UnitImports',
                            friendlyNameKey: 'route_managedata_unitimports_name',
                            controller: 'sectionLandingPageController',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/SectionLandingPage/sectionLandingPage.html',
                            needsOneOf: ['BEAGLE_UNIT_INVOICEHEADER_UPLOAD', 'BEAGLE_UNIT_BUDGET_UPLOAD', 'BEAGLE_UNIT_ALLOWANCE_UPLOAD', 'BEAGLE_UNIT_REVENUE_UPLOAD'],
                            children: [
                                {
                                    path: '/UnitRevenueImport',
                                    friendlyNameKey: 'route_managedata_unitimports_unitrevenueimport_name',
                                    controller: 'revenueController',
                                    permission: 'BEAGLE_UNIT_REVENUE_UPLOAD',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Revenue/revenue.html',
                                    resolve: {
                                        revenueImportContext: function () {
                                            return 'UNIT'
                                        }
                                    },
                                    descriptionKey: 'route_managedata_unitimports_unitrevenueimport_description'
                                },
                                {
                                    path: '/UnitAllowanceImport',
                                    friendlyNameKey: 'route_managedata_unitimports_unitallowanceimport_name',
                                    controller: 'allowanceController',
                                    permission: 'BEAGLE_UNIT_ALLOWANCE_UPLOAD',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Allowance/allowance.html',
                                    resolve: {
                                        importContext: function () {
                                            return 'UNIT'
                                        }
                                    },
                                    descriptionKey: 'route_managedata_unitimports_unitallowanceimport_description'
                                },
                                {
                                    path: '/UnitBudgetImport',
                                    friendlyNameKey: 'route_managedata_unitimports_unitbudgetimport_name',
                                    controller: 'budgetImportController',
                                    permission: 'BEAGLE_UNIT_BUDGET_UPLOAD',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/BudgetImport/budgetImport.html',
                                    resolve: {
                                        importContext: function () {
                                            return 'UNIT'
                                        }
                                    },
                                    descriptionKey: 'route_managedata_unitimports_unitbudgetimport_description'
                                },
                                {
                                    path: '/UnitInvoiceHeaderImport',
                                    friendlyNameKey: 'route_managedata_unitimports_unitinvoiceheaderimport_name',
                                    controller: 'invoiceHeaderImportController',
                                    permission: 'BEAGLE_UNIT_INVOICEHEADER_UPLOAD',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/InvoiceHeaderImport/invoiceHeaderImport.html',
                                    resolve: {
                                        importContext: function () {
                                            return 'UNIT'
                                        }
                                    },
                                    descriptionKey: 'route_managedata_unitimports_unitinvoiceheaderimport_description'
                                }
                            ]
                        },
                        {
                            path: '/DataExports',
                            friendlyNameKey: 'route_managedata_dataexports_name',
                            controller: 'sectionLandingPageController',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/SectionLandingPage/sectionLandingPage.html',
                            permission: 'EPROCUREMENTADMIN',
                            children: [
                                {
                                    path: '/ClientExports',
                                    templateUrl: '/ngxbeagle/dist/Content/js/modules/ClientExports/clientExports.html',
                                    friendlyNameKey: 'route_managedata_dataexports_clientexports_name',
                                    descriptionKey: 'route_managedata_dataexports_clientexports_description',
                                    controller: 'clientExportController',
                                    permission: 'EPROCUREMENTADMIN'
                                }
                            ]
                        }
                    ]
                },
                {
                    path: '/MyUnits',
                    friendlyNameKey: 'route_myunits_name',
                    controller: 'myUnitsController',
                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/MyUnits/myUnits.html',
                    resolve: {
                        units: function (organisationContextService, myUnitsService, localStorageService, enums) {
                            return organisationContextService.isAdminUser(function (data) {
                                var userId = undefined
                                if (data.isAdmin) {
                                    var context = localStorageService.getItem(enums.localStorage.organisationContext)
                                    if (context) {
                                        userId = context.user.id
                                    }
                                }
                                var procurementSubscriptionId = null
                                return myUnitsService.getUnits(procurementSubscriptionId, userId,
                                    function (data2) {
                                        return data2
                                    })

                            })
                        }
                    }
                },
                {
                    path: '/Impersonation',
                    friendlyNameKey: 'route_impersonation_name',
                    controller: 'organisationContextController',
                    templateUrl: window.urls.darwin + '/Content/js/Modules/OrganisationContext/organisationContext.html',
                    permission: 'EPROCUREMENTADMIN',
                    resolve: {
                        isAdminUser: function ($q, organisationContextResource) {
                            return organisationContextResource.isAdminUser().$promise.then(function (data) {
                                return data.isAdmin
                            })
                        }
                    }
                },
                {
                    path: '/login',
                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Login/login.html',
                    controller: 'loginController'
                },
                {
                    path: '/Wimd/Dashboard',
                    controller: 'dashboardController',
                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Dashboard/Dashboard.html',
                    friendlyNameKey: 'route_wimd_name',
                    forceHideInMenu: !window.featureSwitches.recipeServicePeriods,
                    secondaryMenu: true,
                    needsModule: enums.applicationModules.BEAGLE_WIMD,
                    children: [
                        {
                            path: '/Recipes/View/:id?',
                            templateUrl: '/ngxbeagle/dist/Content/js/modules/recipes/ViewEditRecipe/ViewEditRecipeDetails.html',
                            controller: 'viewEditRecipeDetailsController',
                            needsOneOf: ['BEAGLE_VIEW_WIMD_RECIPES', 'BEAGLE_CREATE_WIMD_RECIPES', 'BEAGLE_PUBLISH_UNPUBLISH_WIMD_RECIPES', 'BEAGLE_DELETE_WIMD_RECIPES'],
                            resolve: {
                                recipeData: function ($route, $q, recipeService, organisationContextService) {
                                    var id = $route.current.params.id || null
                                    var clientId = organisationContextService.getContext().currentSubscriptionUnit
                                        .client.id
                                    return recipeService.get(clientId, id)
                                },
                                labelSizeData: function (recipetemplateService) {
                                    return recipetemplateService.listPPDSLabelTemplates()
                                }
                            },
                            children: [
                                {
                                    path: '/Recipes/View/:id?/Ingredients',
                                    templateUrl: '/ngxbeagle/dist/Content/js/modules/recipes/ViewEditRecipe/searchRecipeIngredients.html',
                                    controller: 'searchRecipeIngredientsController',
                                    needsOneOf: ['BEAGLE_VIEW_WIMD_RECIPES', 'BEAGLE_CREATE_WIMD_RECIPES'],
                                    children: [
                                        {
                                            path: '/Recipes/View/:id?/Ingredients/:ingredientId',
                                            controller: 'saveSelectedIngredientController',
                                            templateUrl: '/ngxbeagle/dist/Content/js/modules/recipes/ViewEditRecipe/saveSelectedIngredient.html',
                                            children: [
                                                {
                                                    path: '/Recipes/View/:id?/Ingredients/:ingredientId/search',
                                                    controller: 'searchRecipeIngredientsController',
                                                    templateUrl: '/ngxbeagle/dist/Content/js/modules/recipes/ViewEditRecipe/searchRecipeIngredients.html'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: '/Wimd/Dashboard',
                            friendlyNameKey: 'route_wimd_dashboard_name',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/Dashboard/Dashboard.html',
                            controller: 'dashboardController'
                        },
                        {
                            path: '/Recipes',
                            templateUrl: '/ngxbeagle/dist/Content/js/modules/recipes/unitrecipes/unitrecipes.html',
                            controller: 'unitRecipesController',
                            friendlyNameKey: 'route_unit_recipes_name',
                            needsOneOf: ['BEAGLE_VIEW_WIMD_RECIPES', 'BEAGLE_CREATE_WIMD_RECIPES', 'BEAGLE_PUBLISH_UNPUBLISH_WIMD_RECIPES', 'BEAGLE_DELETE_WIMD_RECIPES'],
                            resolve: {
                                recipeListData: function (organisationContextService, recipeService, localStorageService, enums) {
                                    var clientId = organisationContextService.getContext().currentSubscriptionUnit
                                        .client.id
                                    var searchData = localStorageService.getItem(enums.localStorage.recipeSearch)
                                    if (!searchData) {
                                        searchData = recipeService.getDefaultSearchParams()
                                        // We don't want to be storing the clientId in the local storage.
                                        localStorageService.setItem(enums.localStorage.recipeSearch, searchData)
                                    }
                                    searchData.id = clientId
                                    return recipeService.search(searchData)
                                }
                            }
                        },
                        {
                            path: '/RecipesBelowMargin',
                            templateUrl: '/ngxbeagle/dist/Content/js/modules/recipes/unitrecipes/recipesUnderOverTarget.html',
                            controller: 'recipesUnderOverTargetController',
                            needsOneOf: ['BEAGLE_VIEW_WIMD_RECIPES', 'BEAGLE_CREATE_WIMD_RECIPES']
                        },
                        {
                            path: '/RecipesAboveMargin',
                            templateUrl: '/ngxbeagle/dist/Content/js/modules/recipes/unitrecipes/recipesUnderOverTarget.html',
                            controller: 'recipesUnderOverTargetController',
                            needsOneOf: ['BEAGLE_VIEW_WIMD_RECIPES', 'BEAGLE_CREATE_WIMD_RECIPES']
                        },
                        {
                            path: '/Menus',
                            templateUrl: '/ngxbeagle/dist/Content/js/modules/menus/menus.html',
                            controller: 'menusController',
                            friendlyNameKey: 'route_wimd_menus_functions_name',
                            needsOneOf: ['BEAGLE_VIEW_WIMD_MENUS', 'BEAGLE_ADD_WIMD_MENUS', 'BEAGLE_UPDATE_WIMD_MENUS', 'BEAGLE_DELETE_WIMD_MENUS'],
                            resolve: {
                                menuFunctionListData: function (menusService, localStorageService, enums) {
                                    var searchData = localStorageService.getItem(enums.localStorage.menuFunctionSearch)
                                    var ctx = localStorageService.getItem(enums.localStorage.organisationContext)
                                    if (!searchData) {
                                        searchData = menusService.getDefaultSearchParams()
                                        localStorageService.setItem(enums.localStorage.menuFunctionSearch, searchData)
                                    }
                                    searchData.sortField = menusService.defaultSortField
                                    // MB: We need to make sure we _always_ get the current Client Id to ensure we display the correct entities
                                    searchData.id = ctx.currentSubscriptionUnit.client.id

                                    return menusService.search(searchData)
                                },
                                clientPreferences: function (unitPreferencesService) {
                                    return unitPreferencesService.getSystemPreferencesForCurrentClientUnit()
                                }
                            }
                        },
                        {
                            path: '/ManageUrls',
                            templateUrl: '/ngxbeagle/dist/Content/js/modules/ManageUrls/menuUrlsList.html',
                            controller: 'menuUrlsListController',
                            friendlyNameKey: 'route_wimd_urls_name',
                            needsOneOf: ['BEAGLE_ADD_WIMD_MENUURLMENUS', 'BEAGLE_DELETE_WIMD_MENUURLMENUS'],
                            resolve: {
                                menuUrlData: function (menuUrlsService) {
                                    return menuUrlsService.getMenuUrls()
                                },
                                clientPreferencesData: function (unitPreferencesService) {
                                    return unitPreferencesService.getSystemPreferencesForCurrentClientUnit()
                                }
                            }
                        },
                        {
                            path: '/ManageUrls/View/:id?',
                            templateUrl: '/ngxbeagle/dist/Content/js/modules/ManageUrls/ViewEditUrl/viewEditMenuUrl.html',
                            controller: 'viewEditMenuUrlController',
                            needsOneOf: ['BEAGLE_ADD_WIMD_MENUURLMENUS', 'BEAGLE_DELETE_WIMD_MENUURLMENUS'],
                            resolve: {
                                menuUrlData: function (menuUrlsService, $route, $q) {
                                    if ($route.current.params.id) {
                                        return menuUrlsService.getMenuUrl($route.current.params.id)
                                    } else {
                                        var d = $q.defer()
                                        d.resolve()
                                        return d.promise
                                    }
                                },
                                userLanguageData: function (userLanguageService) {
                                    return userLanguageService.getUserLanguage()
                                },
                                clientPreferences: function (unitPreferencesService) {
                                    return unitPreferencesService.getSystemPreferencesForCurrentClientUnit()
                                }
                            }
                        },
                        {
                            path: '/BulkReplaceIngredients/:ingredientId?',
                            templateUrl: '/ngxbeagle/dist/Content/js/modules/Ingredients/bulkReplaceIngredients.html',
                            controller: 'bulkReplaceIngredientsController',
                            friendlyNameKey: 'bulk_replace_ingredients',
                            permission: 'BEAGLE_BULK_REPLACE_INGREDIENT'
                        },
                        {
                            path: '/UpdateAllergens',
                            templateUrl: '/ngxbeagle/dist/Content/js/modules/UpdateAllergens/updateAllergens.html',
                            controller: 'updateAllergensController',
                            friendlyNameKey: 'update_allergens',
                            permission: 'BEAGLE_WIMD_BULK_UPDATE_ALLERGEN'
                        },
                        {
                            path: '/NutrientApprovals',
                            templateUrl: '/ngxbeagle/dist/Content/js/modules/Nutrients/approvals/nutrientApprovals.html',
                            controller: 'nutrientApprovalsController',
                            friendlyNameKey: 'nutrient_approvals',
                            resolve: {
                                approvalData: function(nutrientApprovalsService) {
                                    return nutrientApprovalsService.get();
                                },
                                rejectionReasonData: function(nutrientApprovalsService) {
                                    return nutrientApprovalsService.getRejectionReasons();
                                },
                                countData: function(wimdTileService) {
                                    return wimdTileService.getProcurementSkuApprovals()
                                },
                            },
                            permission: 'BEAGLE_WIMD_NUTRIENT_APPROVALS'
                        },
                        {
                            path: '/Menu/:menuId?',
                            templateUrl: '/ngxbeagle/dist/Content/js/modules/menus/CreateEdit/createEditMenu.html',
                            controller: 'createEditMenuController',
                            needsOneOf: ['BEAGLE_VIEW_WIMD_MENUS', 'BEAGLE_ADD_WIMD_MENUS', 'BEAGLE_UPDATE_WIMD_MENUS', 'BEAGLE_DELETE_WIMD_MENUS'],
                            resolve: {
                                menuData: function (menusService, $route, $q, enums) {
                                    if ($route.current.params.menuId) {
                                        return menusService.get($route.current.params.menuId)
                                    } else {
                                        var q = $q.defer()
                                        q.resolve(menusService.getNewMenu(enums.menuType.menu))
                                        return q.promise
                                    }
                                },
                                clientPreferences: function (unitPreferencesService) {
                                    return unitPreferencesService.getSystemPreferencesForCurrentClientUnit()
                                },
                                servicePeriodTypeData: function (servicePeriodTypesService) {
                                    return servicePeriodTypesService.getAll()
                                },
                                menuType: function ($rootScope) {
                                    return $rootScope.$enums.menuType.menu
                                },
                                userLanguageData: function (userLanguageService) {
                                    return userLanguageService.getUserLanguage()
                                }
                            }
                        },
                        {
                            path: '/Function/:functionId?',
                            templateUrl: '/ngxbeagle/dist/Content/js/modules/menus/CreateEdit/createEditMenu.html',
                            controller: 'createEditMenuController',
                            needsOneOf: ['BEAGLE_VIEW_WIMD_MENUS', 'BEAGLE_ADD_WIMD_MENUS', 'BEAGLE_UPDATE_WIMD_MENUS', 'BEAGLE_DELETE_WIMD_MENUS'],
                            resolve: {
                                menuData: function (menusService, $route, $q, enums) {
                                    if ($route.current.params.functionId) {
                                        return menusService.get($route.current.params.functionId)
                                    } else {
                                        var q = $q.defer()
                                        q.resolve(menusService.getNewMenu(enums.menuType.function))
                                        return q.promise
                                    }
                                },
                                clientPreferences: function (unitPreferencesService) {
                                    return unitPreferencesService.getSystemPreferencesForCurrentClientUnit()
                                },
                                servicePeriodTypeData: function (servicePeriodTypesService) {
                                    return servicePeriodTypesService.getAll()
                                },
                                menuType: function ($rootScope) {
                                    return $rootScope.$enums.menuType.function
                                },
                                userLanguageData: function (userLanguageService) {
                                    return userLanguageService.getUserLanguage()
                                }
                            }
                        },
                        {
                            path: '/MenuPortal',
                            templateUrl: '/ngxbeagle/dist/Content/js/modules/menus/menuPortal/menuPortal.html',
                            controller: 'menuPortalController'
                        },
                    ]
                },
                {
                    path: '#',
                    friendlyNameKey: 'route_pricing_name',
                    children: [
                        {
                            path: '/PriceLists',
                            templateUrl: '/ngxbeagle/dist/Content/js/modules/priceLists/priceLists.html',
                            controller: 'priceListsController',
                            friendlyNameKey: 'route_price_lists_name',
                            needsOneOf: ['BEAGLE_CAN_CREATE_EDIT_PRICELISTS', 'BEAGLE_CAN_VIEW_PRICELISTS']
                        },
                        {
                            path: '/OrderGuides',
                            templateUrl: '/ngxbeagle/dist/Content/js/modules/OrderGuides/OrderGuidesListPage/orderGuidesListPage.html',
                            controller: 'orderGuidesListController',
                            friendlyNameKey: 'route_order_guides_list_name',
                            needsOneOf: ['BEAGLE_CAN_VIEW_ORDER_GUIDES', 'BEAGLE_CAN_EDIT_ORDER_GUIDES'],
                            resolve: {
                                orderGuideListData: function (localStorageService, orderGuidesService) {
                                    var currentSubscriptionUnit = localStorageService.getItem(enums.localStorage.organisationContext).currentSubscriptionUnit
                                    return orderGuidesService.getAllForUnit(currentSubscriptionUnit.id)
                                }
                            }
                        },
                        {
                            path: '/OrderGuide/:id?',
                            reloadOnSearch: false,
                            templateUrl: '/ngxbeagle/dist/Content/js/modules/OrderGuides/OrderGuidesCreateEditPage/orderGuidesCreateEditPage.html',
                            controller: 'orderGuidesCreateEditController',
                            needsOneOf: ['BEAGLE_CAN_VIEW_ORDER_GUIDES', 'BEAGLE_CAN_EDIT_ORDER_GUIDES'],
                            resolve: {
                                orderGuideData: function ($route, orderGuidesService) {
                                    return orderGuidesService.get($route.current.params.id)
                                },
                                clientSheetTypeData: function (clientUnitService, localStorageService) {
                                    var ctx = localStorageService.getItem(enums.localStorage.organisationContext)
                                    return clientUnitService.getClientOrderSheetType(ctx.currentSubscriptionUnit.client.id)
                                },
                                existingOrderGuideNames: function ($route, orderGuidesService, localStorageService) {
                                    var ctx = localStorageService.getItem(enums.localStorage.organisationContext)
                                    return orderGuidesService.getOrderGuideNamesInUnit(ctx.currentSubscriptionUnit.id)
                                },
                                departmentsData: function (clientUnitDepartmentService, localStorageService, enums) {
                                    var ctx = localStorageService.getItem(enums.localStorage.organisationContext)
                                    return clientUnitDepartmentService.getClientUnitProcurementDepartmentsForUser(ctx.currentSubscriptionUnit.id, ctx.user.id).$promise
                                }
                            }
                        },
                    ]
                },

                {
                    path: '/CreateEditPriceList/:priceListId?',
                    templateUrl: '/ngxbeagle/dist/Content/js/modules/priceLists/createEditPriceList.html',
                    controller: 'createEditPriceListsController',
                    forceHideInMenu: true,
                    permission: 'BEAGLE_CAN_CREATE_EDIT_PRICELISTS',
                    resolve: {
                        priceList: function (localStorageService, priceListsService, $route) {
                            var currentSubscriptionUnit = localStorageService.getItem(enums.localStorage.organisationContext).currentSubscriptionUnit
                            if ($route.current.params.priceListId) {
                                return priceListsService.getBeaglePriceListDetailsById($route.current.params.priceListId, currentSubscriptionUnit.client.id)
                            }
                        }
                    }
                },
                {
                    path: '#',
                    friendlyNameKey: 'route_shopping_name',
                    forceHideInMenu: !window.featureSwitches.baskets,
                    children: [
                        {
                            path: '/Baskets',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/Baskets/basketListPage.html',
                            controller: 'basketListPageController',
                            permission: 'BEAGLE_PROCUREMENT_BASKETS_VIEW',
                            friendlyNameKey: 'route_baskets_name',
                            resolve: {
                                basketListData: function (organisationContextService, basketService) {

                                    var context = organisationContextService.getContext()

                                    return basketService.get(context.currentSubscriptionUnit.id,
                                        context.currentSubscriptionUnit.organisation.id)
                                }
                            }

                        },
                        {
                            path: '/ShoppingLists',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/ShoppingLists/shoppingListListPage.html',
                            controller: 'shoppingListListPageController',
                            friendlyNameKey: 'route_shopping_lists_name',
                            permission: 'BEAGLE_PROCUREMENT_SHOPPING_LISTS_VIEW',
                            resolve: {
                                shoppingListData: function (organisationContextService, shoppingListService) {

                                    var context = organisationContextService.getContext()

                                    return shoppingListService.get(context.currentSubscriptionUnit.id,
                                        context.currentSubscriptionUnit.organisation.id).$promise
                                }
                            }
                        },
                        {
                            path: '/ShoppingLists/Create',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/ShoppingLists/shoppingListCreatePage.html',
                            controller: 'shoppingListCreatePageController',
                            permission: 'BEAGLE_PROCUREMENT_SHOPPING_LISTS_CREATE',
                            forceHideInMenu: true,
                            resolve: {
                                shoppingListViewData: function ($q, shoppingListService, organisationContextService, $route) {
                                    if ($route.current.params.shoppingListId) {
                                        var ctx = organisationContextService.getContext()
                                        var unitId = ctx.currentSubscriptionUnit.id
                                        var orgId = ctx.currentSubscriptionUnit.organisation.id
                                        return shoppingListService.getShoppingListData($route.current.params.shoppingListId, unitId, orgId).$promise
                                    } else {
                                        var deferred = $q.defer()
                                        deferred.resolve()
                                        deferred.$promise = deferred.promise
                                        return deferred
                                    }
                                },
                                userDepartmentData: function (localStorageService, enums, clientUnitDepartmentService) {
                                    var context = localStorageService.getItem(enums.localStorage.organisationContext)
                                    return clientUnitDepartmentService.getClientUnitProcurementDepartmentsForUser(
                                        context.currentSubscriptionUnit.id,
                                        context.user.id).$promise
                                },
                                userAccountCodeData: function (localStorageService, enums, clientUnitAccountCodeService) {
                                    var context = localStorageService.getItem(enums.localStorage.organisationContext)
                                    return clientUnitAccountCodeService.getClientUnitProcurementAccountCodesForUser(
                                        context.currentSubscriptionUnit.id,
                                        context.user.id).$promise
                                }
                            }
                        },
                        {
                            path: '/ShoppingLists/View/:shoppingListId',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/ShoppingLists/shoppingListViewPage.html',
                            controller: 'shoppingListViewPageController',
                            permission: 'BEAGLE_PROCUREMENT_SHOPPING_LISTS_VIEW',
                            forceHideInMenu: true,
                            resolve: {
                                shoppingListViewData: function ($q, shoppingListService, organisationContextService, $route) {
                                    if ($route.current.params.shoppingListId) {
                                        var ctx = organisationContextService.getContext()
                                        var unitId = ctx.currentSubscriptionUnit.id
                                        var orgId = ctx.currentSubscriptionUnit.organisation.id
                                        return shoppingListService.getShoppingListData($route.current.params.shoppingListId, unitId, orgId)
                                    } else {
                                        var deferred = $q.defer()
                                        deferred.resolve()
                                        deferred.$promise = deferred.promise
                                        return deferred
                                    }
                                },
                                userDepartmentData: function (localStorageService, enums, clientUnitDepartmentService) {
                                    var context = localStorageService.getItem(enums.localStorage.organisationContext)
                                    return clientUnitDepartmentService.getClientUnitProcurementDepartmentsForUser(
                                        context.currentSubscriptionUnit.id,
                                        context.user.id).$promise
                                },
                                userAccountCodeData: function (localStorageService, enums, clientUnitAccountCodeService) {
                                    var context = localStorageService.getItem(enums.localStorage.organisationContext)
                                    return clientUnitAccountCodeService.getClientUnitProcurementAccountCodesForUser(
                                        context.currentSubscriptionUnit.id,
                                        context.user.id).$promise
                                }
                            }
                        },
                        {
                            path: '/ProductSearch/:basketId?/:discriminator',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/ProductSearch/productSearch.html',
                            controller: 'productSearchController',
                            friendlyNameKey: 'route_baskets_productsearch_name',
                            forceHideInMenu: true,
                            resolve: {
                                basketData: function (basketService, shoppingListService, organisationContextService, $route, enums) {
                                    if ($route.current.params.discriminator === enums.procurementBasketType.ProcurementBasket) {
                                        return basketService.getBasketDataForProductSearch($route.current.params.basketId)
                                    }
                                }
                            }
                        },
                        {
                            path: '/ProductSearch/:basketId/:discriminator/:segmentId',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/ProductSearch/Segments/productSearchForSegment.html',
                            controller: 'productSearchForSegmentController',
                            forceHideInMenu: true,
                            resolve: {
                                basketData: function (orderGuidesService, shoppingListService, organisationContextService, $route, enums) {
                                    var params = $route.current.params
                                    var orgContext = organisationContextService.getContext()
                                    var orgId = orgContext.currentSubscriptionUnit.organisation.id
                                    var unitId = orgContext.currentSubscriptionUnit.id
                                    if ($route.current.params.discriminator === enums.procurementBasketType.ShoppingList) {
                                        return shoppingListService.getShoppingListDataForProductSearch(params.basketId, unitId, orgId, params.segmentId)
                                    } else if ($route.current.params.discriminator === enums.procurementBasketType.OrderGuide) {
                                        return orderGuidesService.getOrderGuideDataForProductSearch(params.basketId, params.segmentId)
                                    }
                                }
                            }

                        },
                        {
                            path: '/Baskets/View/:basketId?',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/Baskets/basketViewPage.html',
                            controller: 'basketViewPageController',
                            permission: 'BEAGLE_PROCUREMENT_BASKETS_VIEW',
                            forceHideInMenu: true,
                            resolve: {
                                basketViewData: function ($q, basketService, $route) {
                                    if ($route.current.params.basketId)
                                        return basketService.getBasketData($route.current.params.basketId)
                                    else {
                                        var deferred = $q.defer()
                                        deferred.resolve()
                                        deferred.$promise = deferred.promise
                                        return deferred
                                    }
                                },
                                clientSupplierAccountData: function ($route, basketService, $q) {
                                    if ($route.current.params.basketId)
                                        return basketService.getAvailableClientSupplierAccounts($route.current.params.basketId).$promise
                                    else {
                                        var deferred = $q.defer()
                                        deferred.resolve()
                                        deferred.$promise = deferred.promise
                                        return deferred
                                    }
                                }
                            }
                        },
                        {
                            path: '/Baskets/Checkout/:basketId?',
                            permission: 'BEAGLE_PROCUREMENT_BASKETS_ADD',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/BasketCheckout/basketCheckout.html',
                            controller: 'basketCheckoutController',
                            forceHideInMenu: true,
                            resolve: {
                                basketData: function (basketService, $route) {
                                    return basketService.getBasketData($route.current.params.basketId)
                                },
                                basketItemData: function (basketService, $route) {
                                    return basketService.getBasketData($route.current.params.basketId)
                                }
                            }
                        }
                    ]
                },
                {
                    image: '612631894.jpg',
                    path: '/PurchaseOrders',
                    friendlyNameKey: 'route_purchaseorders_name',
                    forceHideInMenu: !window.featureSwitches.purchaseOrders,
                    controller: 'sectionLandingPageController',
                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/SectionLandingPage/sectionLandingPage.html',
                    children: [
                        {
                            path: '/PurchaseOrders/Search',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/PurchaseOrders/ListPurchaseOrders/searchPurchaseOrders.html',
                            controller: 'searchPurchaseOrdersController',
                            friendlyNameKey: 'route_purchaseorders_search_name',
                            descriptionKey: 'route_purchaseorders_search_description',
                            permission: 'BEAGLE_PURCHASEORDERS_VIEW'
                        },
                        {
                            path: '/PurchaseOrders/CreatePurchaseOrders',
                            templateUrl: '/ngxbeagle/dist/Content/js/Modules/PurchaseOrders/CreatePurchaseOrders/createPurchaseOrders.html',
                            controller: 'createPurchaseOrdersController',
                            friendlyNameKey: 'route_purchaseorders_consolidatebaskets_name',
                            descriptionKey: 'route_purchaseorders_consolidatebaskets_description',
                            children: [
                                {
                                    path: '/PurchaseOrders/CreatedPurchaseOrders/:purchaseOrderIds',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/PurchaseOrders/CreatedPurchaseOrders/createdPurchaseOrders.html',
                                    controller: 'createdPurchaseOrdersController'
                                },
                                {
                                    path: '/PurchaseOrder/:purchaseOrderId',
                                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/PurchaseOrders/SinglePurchaseOrder/singlePurchaseOrder.html?v=2',
                                    controller: 'singlePurchaseOrderController',
                                    reloadOnSearch: false
                                }
                            ]
                        },
                        ///CSH 4/12/2017 Hidden as per the ticket: https://www.pivotaltracker.com/n/projects/2068255/stories/153360513
                        /*{
                            path: "/PurchaseOrder/",
                            templateUrl: "/ngxbeagle/dist/Content/js/Modules/PurchaseOrders/SinglePurchaseOrder/singlePurchaseOrder.html",
                            controller: "singlePurchaseOrderController",
                            friendlyNameKey: "route_purchaseorders_createmanualpo_name",
                            descriptionKey: "route_purchaseorders_createmanualpo_description",
                            permission: "BEAGLE_MANUALPURCHASEORDERS_CREATE",
                        }*/
                    ]
                },
                {
                    path: '/PurchaseOrder/Receive/:purchaseOrderId',
                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/ReceivingPurchaseOrder/ReceivePurchaseOrder/receivePurchaseOrder.html',
                    controller: 'receivePurchaseOrderController',
                    permission: 'BEAGLE_MANUALPURCHASEORDERS_CREATE', // TODO: Does this need its own Permission?
                    resolve: {
                        varianceReasonsData: function ($route, clientUnitProcurementReceivingVarianceReasonsService, organisationContextService) {
                            return clientUnitProcurementReceivingVarianceReasonsService.get(organisationContextService.getContext().currentSubscriptionUnit.id)
                        }
                    }
                },
                {
                    path: '/tasks',
                    friendlyNameKey: 'route_tasks_name',
                    templateUrl: '/ngxbeagle/dist/Content/js/modules/Tasks/Tasks.html',
                    permission: 'BEAGLE_ACCESS_TASKS'
                },
                {
                    path: '/Help',
                    friendlyNameKey: 'route_help_name',
                    templateUrl: '/ngxbeagle/dist/Content/js/Modules/Help/help.html',
                    controller: 'helpController'
                    //, forceHideInMenu: false, // JP
                    //permission: null
                },
                {
                    path: '/tasks/submit',
                    templateUrl: window.urls.darwin + '/Content/js/modules/cdbTasks/templates/submit.html',
                    controller: 'submitController'
                },
                {
                    path: '/ssrs',
                    templateUrl: '/ngxbeagle/dist/Content/js/modules/SsrsReportViewer/ssrsReportViewer.html',
                    controller: 'ssrsReportViewer'
                },
                {
                    path: '/ChangePassword',
                    templateUrl: '/ngxbeagle/dist/Content/js/modules/ChangePassword/changePassword.html',
                    controller: 'changePassword'
                }
            ]

            //Recursively add routes to route provider:
            var addRouteToRouteProvider = function (route) {
                angular.forEach(route.children, addRouteToRouteProvider)
                if (route.children) {
                    var childPermissions = _.filter(_.pluck(route.children, 'permission'), function (child) { return child })
                    var childNeedsOneOfs = _.flatten(_.filter(_.pluck(route.children, 'needsOneOf'), function (child) { return child }))
                    var allPermissionsForRoute = _.union(childPermissions, childNeedsOneOfs)
                    if (allPermissionsForRoute.length) {
                        route.needsOneOf = allPermissionsForRoute
                    }
                }

                $routeProvider.when(route.path,
                    {
                        templateUrl: route.templateUrl,
                        controller: route.controller,
                        caseInsensitiveMatch: true,
                        resolve: route.resolve,
                        friendlyNameKey: route.friendlyNameKey,
                        reloadOnSearch: route.reloadOnSearch
                    })
            }
            var routes = window.beagle.routes
            angular.forEach(routes, addRouteToRouteProvider)
            $routeProvider.otherwise({ redirectTo: '/' })

            $httpProvider.interceptors.push('beagleAuthorizationInterceptor')
        }
    ])
    .run([
        '$rootScope', '$location', '$q', 'organisationContextService', '_', 'userService',
        function ($rootScope, $location, $q, organisationContextService, _, userService) {
            var self = this
            self.user = null

            $rootScope.$on('$routeChangeStart',
                function (evt, next, current) {
                    $rootScope.$rootPromise = $q.defer()
                    $rootScope.$loadingRoute = true
                })
            $rootScope.$on('$routeChangeSuccess',
                function (evt, next) {
                    $rootScope.$rootPromise.resolve(next)
                    $rootScope.$loadingRoute = false
                })
            $rootScope.$on('$routeChangeError',
                function (evt, next) {
                    $rootScope.$rootPromise.resolve(next)
                    $rootScope.$loadingRoute = false
                })

            function getLocation (href) {
                var match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/)
                return match && {
                    protocol: match[1],
                    host: match[2],
                    hostname: match[3],
                    port: match[4],
                    pathname: match[5],
                    search: match[6],
                    hash: match[7]
                }
            }

            $rootScope.$on('$locationChangeStart', function (event, from, to) {
                var token = localStorage.getItem('access_token')
                var tokenExpiry = new Date(localStorage.getItem('token_expires'))
                var currentDateTime = new Date()
                var tokenHasExpired = tokenExpiry < currentDateTime
                var organistionContext = localStorage.getItem('organisationContext')
                var parsedContext = JSON.parse(organistionContext)

                //allow setLogin page to run without checks, just logs and redirects
                if (to.indexOf('SetLogin') !== -1) {
                    return
                }

                if (token === null || tokenHasExpired) {
                    //if they don't have a token or it has expired should go to /login
                    $location.path('/login')
                } else if (organistionContext == null || organistionContext == '{}' || !parsedContext.id) {
                    organisationContextService.isAdminUser(function (data) {
                            if (data.passwordExpired) {
                                $location.path('/ChangePassword')
                            } else if (data.isAdmin) {
                                $location.path('/Impersonation')
                            } else {
                                $location.path('/MyUnits')
                            }
                        }
                    )
                }

                //Recursively check routes to see if user has permissions
                var checkRoutes = function (route) {

                    angular.forEach(route.children, checkRoutes)

                    var pathMatch = route.path.toLowerCase() == getLocation(to).pathname.toLowerCase()

                    if (pathMatch) {
                        if (route.permission && !_.contains(user.permissions, route.permission)) {
                            $location.path('/')
                            return
                        } else if (route.needsOneOf && route.needsOneOf.length) {
                            var intersection = _.intersection(user.permissions, route.needsOneOf)
                            if (!intersection.length) {
                                $location.path('/')
                                return
                            }
                        }
                    }
                }

                if (self.user == null) {
                    userService.getCurrentUser().then(function (currentUser) {
                        self.user = currentUser
                        var routes = window.beagle.routes
                        angular.forEach(routes, checkRoutes)
                    })

                } else {
                    var routes = window.beagle.routes
                    angular.forEach(routes, checkRoutes)
                }
            })
        }
    ])

var htmlEscapeValue = function (value) {
	var element = angular.element('<div></div>');
	element.text(value); // not chainable, see #1044
	return element.html();
};

var cdbSanitize = function (value, mode) {
	if (mode === 'text') {
		value = htmlEscapeValue(value);
	}
	return value;
}

/**
 * For debugging issues with $translate (especially timing issues) it's worth using a custom loader.
 *
 * https://gist.github.com/mbrewerton/f12f594e5af235939fc9ed674faa43e8
 */
angular.module(appName)
	.config(['$translateProvider', '$translateSanitizationProvider', function ($translateProvider, $translateSanitizationProvider) {
        $translateSanitizationProvider.addStrategy('cdb', cdbSanitize);
        $translateProvider.useUrlLoader('/api/Translate/Get');
        $translateProvider.preferredLanguage('en');
        $translateProvider.fallbackLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
        $translateProvider.useLoaderCache(true);
		$translateProvider.useLocalStorage();
		$translateProvider.useMessageFormatInterpolation();
	}]);

//CSH 1/5/18 This is a decorator for ng-translate that logs the translations to the console.
//This should not be used in production code!
if (true) {
	angular.module(appName).config([
		'$provide', function($provide) {
			$provide.decorator('$translate',
				[
					'$delegate', '$cookies',
					function $logDecorator($delegate, $cookies) {
						var original = $delegate;
						var translations = {};

						function isEmpty(map) {
							for (var key in map) {
								if (map.hasOwnProperty(key)) {
									return false;
								}
							}
							return true;
						}

						var logTranslationsToConsole = function() {
							if (!isEmpty(translations)) {
								if ($cookies.get('LOG_TRANSLATIONS') == 'TRUE') {
									console.log('Translations:', JSON.parse(JSON.stringify(translations)));
									translations = {};
								}
							}
						}

						var addTranslationToArray = function(key, value) {
							if (!translations[key]) {
								translations[key] = value;
							}
						}

						window.setInterval(logTranslationsToConsole, 5000);

						$delegate = function(a, b, c) {
							var result = original(a, b, c);
							result.then(function(value) {
								addTranslationToArray(a, value);
							});
							return result;
						}
						for (var key in original) {
							if (original.hasOwnProperty(key)) {
								$delegate[key] = original[key];
							}
						}
						$delegate.instant = function(a, b, c, d) {
							var result = original.instant(a, b, c, d);
							addTranslationToArray(a, result);
							return result;
						}

						return $delegate;
					}
				]);
		}
	]);
}


angular.module(appName)
    .directive('addEditMySupplier', function () {
        var controller = [
            '$scope', '$location', '$window', 'localStorageService', 'groupSuppliersResource', 'countryResource', 'enums', 'translateMessage',
        function ($scope, $location, $window, localStorageService, groupSuppliersResource, countryResource, enums, translateMessage) {
                var self = this;

                $scope.cancel = function () {
                    console.log($scope.toggle);
                    $scope.toggle();

                }


                $scope.addUpdateSupplier = function (form) {
                    if (form.$valid) {
                        $scope.
                        $scope.mySupplier.procurementSubScriptionId = localStorageService.getItem(enums.localStorage.organisationContext).id;
                        return groupSuppliersResource.addUpdateMySupplier($scope.mySupplier).$promise.then(function (data) {
                            translateMessage.success("supplier_details_saved");
                            $scope.toggle();
                            $scope.refresh();
                        }, function (error) {
                            console.log('error', error);
                        });
                    }

                    return false;
                };

                $scope.init = function () {

                    //if we can an orgId we are creating new
                    if ($scope.clientSupplierId) {
                        console.log('clientSupplierId', $scope.clientSupplierId)
                        $scope.mySupplier = groupSuppliersResource.getGroupSupplierDetail({ id: $scope.clientSupplierId });
                    }
                    else if($scope.clientOrganisationId) {
                        $scope.mySupplier = null;
                        $scope.mySupplier = {};
                        $scope.mySupplier.clientOrganisationId = $scope.clientOrganisationId;

                        countryResource.query().$promise.then(function (countries) {
                                   $scope.tradingCountries = countries;
                                   $scope.countries = countries;
                                });
                    }



                }();
            }];

        return {
            scope: { clientOrganisationId: '=?', clientSupplierId: '=?', refresh: '&', toggle: '&' },
            restrict: 'E',
            controller: controller,
            templateUrl: '/ngxbeagle/dist/Content/js/directives/addEditMySupplier/addEditGroupSupplier.html'
        }
    })

/**
 * http://stackoverflow.com/a/10364620/3636177 - Mobile detection technique
 *
 */

angular.module(appName)
  .directive('additionalProducts',
    function () {
      var controller = [
        '$scope', '$element', '$attrs', '$timeout', '_', 'validationHelper', 'enums', 'productSearchService',
        function ($scope, $element, $attrs, $timeout, _, validationHelper, enums, productSearchService) {
          var self = this;
          self.elements = {
            self: $element,
            parent: $element.parent(),
            next: $element.next(),
            section: angular.element('section'),
            body: angular.element('body'),
            bodyWrapper: angular.element(document.querySelector('#body-wrapper'))
          };
          $scope.disableAddToBasketButtonIsDefined = angular.isDefined($scope.disableAddToBasketButton);
          $scope.validationHelper = validationHelper;
          $scope.packTypeEnum = enums.packTypes;
          $scope.mobile = validationHelper.isMobile();

          // Add the root class to our parent so that we can style our elements
          $element.addClass('additional-products-root');
          $element.addClass('additional-products-animate');

          self.setElementStyles = function (show) {
            if (show) {
              /* Showing Products */
              if ($scope.mobile) {
                /* Showing Products - Mobile */
                $element.css({
                  top: 0,
                  width: '100%',
                  height: '100%',
                  right: '0%',
                  maxHeight: 'none',
                  maxWidth: 'none',
                  position: 'fixed',
                  backgroundColor: self.elements.section.css('background-color'),
                });
              } else {
                /* Showing Products - Desktop */
                $element.css({
                  padding: '',
                  height: ''
                });
                self.elements.next.css({});
                // self.elements.bodyWrapper.css({ overflow: '' });
              }
            } else {
              /* Hiding Products */
              if ($scope.mobile) {
                /* Hiding Products - Mobile */
                $element.css({
                  right: '-100%',
                  maxWidth: 'none',
                  position: ''
                });
                self.elements.next.css({
                  width: '100%',
                  float: 'none'
                });
              } else {
                /* Hiding Products - desktop */
                $element.css({
                  height: 0,
                });
                self.elements.next.css({
                  width: '100%'
                });
                self.elements.bodyWrapper.css({overflow: ''});
              }
            }
          };

          // Extra function to call parent isBestPrice function from JS as HTML is unreliable
          $scope.callIsBestPrice = function (product) {
            return productSearchService.isBestPrice(product);
          };

          $scope.callDisableAddToBasketButton = function (quantity) {
            var mapped = {
              quantity: quantity
            };
            return $scope.disableAddToBasketButton({product: mapped});
          }

          var resizeTimeout;
          window.addEventListener('resize',
            function () {
              clearTimeout(resizeTimeout);
              resizeTimeout = setTimeout(function () {
                  $scope.mobile = validationHelper.isMobile();
                },
                100);
            });

          $scope.callToggle = function ($event, forceClose) {
            if (forceClose) {
              self.setElementStyles(false);
              // self.elements.bodyWrapper.css({ overflow: '' });
            }
            $scope.toggle($event);
          };

          $scope.$watch('show',
            function (newValue, oldValue) {
              self.setElementStyles(newValue);
              if (newValue && validationHelper.isMobile()) {
                // self.elements.bodyWrapper.css({ overflow: 'hidden', position: 'relative' });
              } else {
                // self.elements.bodyWrapper.css({ overflow: '' });
              }
            });
        }
      ];

      return {
        restrict: 'E',
        scope: {
          data: '=',
          toggle: '&',
          show: '=',
          addToBasket: '&',
          isBestPrice: '&',
          toggleFavourite: '&',
          isOrderableBasket: '=',
          threeDp: '&',
          disableAddToBasketButton: '&?',
          createAdvancedSearchFromSku: '&',
          hideCart: '='
        },
        templateUrl: '/ngxbeagle/dist/Content/js/directives/additionalProducts/additionalProducts.html',
        controller: controller
      };
    });

angular.module(appName).directive('assignSupplier', function () {
    var controller = [
        '$scope', 'localStorageService', 'unitSuppliersService', 'enums', 'translateMessage',
        'clientProcurementSuppliersService', '$translate', 'organisationFactory',
        function ($scope, localStorageService, unitSuppliersService, enums, translateMessage,
            clientProcurementSuppliersService, $translate, organisationFactory
        ) {
                $translate.onReady().then(function () {
                    var self = this;
                    $translate("label_view_accounts").then(function (t) {
                        $scope.viewAccountsText = t;
                    });
                    $scope.cancel = function () {
                        $scope.toggle();
                    }

                    self.addAssignSupplier = function () {

                        $scope.supplier.organisationId = self.organisationId;
                        var supplierDeepCopy = JSON.parse(JSON.stringify($scope.supplier));
                        supplierDeepCopy.accountServiceLevels = self.getAccountServiceLevelSave();
                        return unitSuppliersService.addAssignSupplier(supplierDeepCopy).$promise.then(
                            function (data) {
                                if (data) {
                                    translateMessage.success('supplier_details_saved');
                                    var updatedSupplier = $scope.supplier;
                                    updatedSupplier.updated = true;
                                    updatedSupplier.toggleAccountsLabel = $scope.viewAccountsText;
                                    updatedSupplier.showAccounts = false;
                                    self.unitSuppliersAdded.push(updatedSupplier);
                                    localStorageService.setItem('newUnitSuppliers', self.unitSuppliersAdded);
                                    _.each(self.groupSupplierObjects,
                                        function (supplierObject) {
                                            if (supplierObject.supplier.id == updatedSupplier.supplier.id) {
                                                self.groupSupplierObjects =
                                                    _.without(self.groupSupplierObjects, supplierObject);
                                            }
                                        });
                                    $scope.cancel();
                                }
                            });
                    }


                    self.updateAssignSupplier = function () {
                        var supplierDeepCopy = JSON.parse(JSON.stringify($scope.supplier));
                        supplierDeepCopy.accountServiceLevels = self.getAccountServiceLevelSave();
                        return unitSuppliersService.updateAssignSupplier(supplierDeepCopy).$promise.then(function (data) {
                            if (data) {
                                translateMessage.success('supplier_details_saved');
                            }
                        });
                    }

                    $scope.getDepots = function (supplierId) {
                        if (supplierId > 0) {
                            self.depotObjects = [];
                            $scope.depots = [];
                            unitSuppliersService.getUnitSupplierDepots(supplierId, self.procurementSubScriptionId)
                                .$promise.then(function (data) {
                                    $scope.supplierHasNoDepots = data.length < 1;
                                    self.depotObjects = data;
                                    _.each(data,
                                        function (d) {

                                            var description = "";
                                            description += d.organisationDto.orgName;
                                            if (d.organisationDto.address) {
                                                description += ", ";

                                                description += d.organisationDto.address.addressOne;
                                                description += ", ";
                                                if (d.organisationDto.address.addressTwo) {
                                                    description += d.organisationDto.address.addressTwo;
                                                    description += ", ";
                                                }
                                                description += d.organisationDto.address.town;
                                                description += ", ";
                                                description += d.organisationDto.address.postcode;
                                                description += ", ";
                                                description += d.organisationDto.address.tradingCountry.name;
                                            }

                                            $scope.depots.push({ id: d.id, description: description, orgId: d.organisationId });
                                        });
                                    if ($scope.assignMode == 'new') {
                                        $scope.supplier.headOfficeVendorCode =
                                            _.findWhere(self.groupSupplierObjects, { supplierId: supplierId })
                                                .headOfficeVendorCode;
                                    }
                                });
                        }
                    }

                    $scope.createSupplier = function () {
                        $scope.supplierAdded = false;
                        $scope.supplier = {};
                        self.setupSupplier();
                        $scope.assignMode = 'add';
                    }

                    $scope.addUpdateSupplier = function (form) {
                        if (form.$valid) {
                            //$scope.supplier.depotId = $scope.supplier.depotId
                            //    ? _.findWhere(self.depotObjects, { id: $scope.supplier.depotId }).id
                            //    : 0;
                            if ($scope.assignMode == 'edit') {
                                return self.updateAssignSupplier();
                            } else {
                                return self.addAssignSupplier();
                            }
                        } else {
                            translateMessage.error("something_went_wrong_please_try_again_later");
                        }
                    };

                    $scope.isValidEndDate = function (supplier) {
                        $scope.invalidEndDate = supplier.endDate != null &&
                            supplier.startDate != null &&
                            supplier.endDate < supplier.startDate;
                    }

                    self.setupSupplier = function () {
                        $scope.transmissionTypes =
                            [{ id: 1, description: "Email" }]; // TODO: Get this properly from backend
                        $scope.supplier.transmissionType = _.findWhere($scope.transmissionTypes, { id: 1 });
                        $scope.supplier.client = angular.copy($scope.client);
                        $scope.isLoading = false;
                        if ($scope.assignMode == 'add') {
                            $scope.supplier.accountNumber = "";
                            $scope.supplier.startDate = "";
                            $scope.supplier.supplierDepotId = null;
                        }
                        if ($scope.assignMode == 'edit') {
                            $scope.supplier.startDate = $scope.currentSupplierAccount.startDate;
                            $scope.supplier.endDate = $scope.currentSupplierAccount.endDate;
                            $scope.supplier.oldAccountNumber = $scope.currentSupplierAccount.accountNumber;
                            $scope.supplier.accountNumber = $scope.currentSupplierAccount.accountNumber;
                            $scope.supplier.clientSupplierAccountId = $scope.currentSupplierAccount.clientSupplierAccountId;

                            $scope.supplier.orderPoint = $scope.currentSupplierAccount.orderPoint;
                            $scope.supplier.leadTime = $scope.currentSupplierAccount.leadTime;
                            $scope.supplier.sameDayDelivery = $scope.currentSupplierAccount.sameDayDelivery;
                            $scope.supplier.minimumOrderValue = $scope.set2dp($scope.currentSupplierAccount.minimumOrderValue);
                            $scope.supplier.minimumOrderWeight = $scope.currentSupplierAccount.minimumOrderWeight;
                            $scope.supplier.costOfDelivery = $scope.set2dp($scope.currentSupplierAccount.costOfDelivery);
                            $scope.supplier.costOfDeliveryIfMinimumNotMet = $scope.set2dp($scope.currentSupplierAccount.costOfDeliveryIfMinimumNotMet);
                            $scope.supplier.packagingInfo = $scope.currentSupplierAccount.packagingInfo;
                            $scope.supplier.notes = $scope.currentSupplierAccount.notes;
                            $scope.supplier.cutOffTime = $scope.currentSupplierAccount.cutOffTime;
                            $scope.supplier.cutOffMinutes = $scope.currentSupplierAccount.cutOffMinutes;
                            $scope.supplier.cutOffHours = $scope.currentSupplierAccount.cutOffHours;
                            $scope.supplier.depotContactId = $scope.currentSupplierAccount.depotContactId;
                            $scope.supplier.supplierDepotId = $scope.currentSupplierAccount.supplierDepotId;
                        }
                        if ($scope.assignMode == 'new') {
                            $scope.supplier.supplier = _.findWhere($scope.groupSuppliers, { id: 0 });
                        }
                        $scope.supplier.organisationId = self.organisationId;
                    }

                    $scope.anyServiceLevelErrors = function () {
                        var x = _.some($scope.accountServiceLevelErrors,
                            function (item) {
                                return item == true;
                            });
                        return x;
                    };

                    self.getAccountServiceLevelSave = function () {
                        var days = [];
                        var serviceLevels = [];
                        days.push('monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday');
                        for (var j = 0; j < days.length; j++) {
                            var day = days[j];
                            if (!(typeof $scope.currentSupplierAccount.accountServiceLevels[day] === 'undefined') && $scope.currentSupplierAccount.accountServiceLevels[day].start !== "" && $scope.currentSupplierAccount.accountServiceLevels[day].end) {
                                var dayArray = $scope.currentSupplierAccount.accountServiceLevels[day];
                                var startTimeHour = 0;
                                var startTimeMinute = 0;
                                var endTimeHour = 0;
                                var endTimeMinute = 0;
                                if (!(dayArray.start === undefined)) {
                                    if (dayArray.start.indexOf(':') === -1) {
                                        startTimeHour = parseInt(dayArray.start) * 60;
                                    } else {
                                        startTimeHour = parseInt(dayArray.start.substring(0, dayArray.start.indexOf(':'))) * 60;
                                        startTimeMinute = parseInt(dayArray.start.substring(dayArray.start.indexOf(':') + 1, dayArray.start.length));
                                    }
                                }
                                if (!(dayArray.end === undefined)) {
                                    if (dayArray.end.indexOf(':') === -1) {
                                        endTimeHour = parseInt(dayArray.end) * 60;
                                    } else {
                                        endTimeHour = parseInt(dayArray.end.substring(0, dayArray.end.indexOf(':'))) * 60;
                                        endTimeMinute = parseInt(dayArray.end.substring(dayArray.end.indexOf(':') + 1, dayArray.end.length));
                                    }
                                }
                                serviceLevels.push(
                                    {
                                        accountId: $scope.supplier.clientSupplierAccountId,
                                        day: day,
                                        timeFrom: startTimeHour + startTimeMinute,
                                        timeTo: endTimeHour + endTimeMinute,
                                    });
                            }
                        }

                        return serviceLevels;
                    };


                    self.getAvailableDepotContacts = function () {
                        $scope.currentSupplierAccount.depotContacts = [];
                        var organisationId = $scope.currentSupplierAccount.supplierDepotOrgId;
                        if (organisationId != null) {
                            var dataToSend = { orgId: organisationId, searchTerm: null };

                            return organisationFactory.getOrganisationContactsForOrganisationDto(dataToSend)
                                .$promise.then(function (data) {
                                    $scope.currentSupplierAccount.depotContacts = data.orgContacts;
                                    $scope.loadingList = false;
                                });
                        }

                    };

                    $scope.depotChanged = function () {
                        var depot = _.find($scope.depots, function (depot) {
                            return $scope.supplier.supplierDepotId === depot.id;
                        });

                        if (depot != null) {
                            $scope.currentSupplierAccount.supplierDepotOrgId = depot.orgId;
                        } else {
                            $scope.currentSupplierAccount.supplierDepotOrgId = null;
                        }
                        self.getAvailableDepotContacts();
                    };

                    $scope.set2dp = function (input) {
                        if (input != null && input != '') {
                            if (isNaN(parseFloat(input))) {
                                translateMessage.error('error_please_enter_valid_number');
                                return null;
                            } else {
                                input = parseFloat(input).toFixed(2);
                                return input;
                            }
                        }
                    };

                    $scope.init = function () {
                        $scope.sameDayDeliveryOptions = [{ name: $translate.instant("yes"), value: true }, { name: $translate.instant("no"), value: false }];
                        $scope.accountServiceLevelErrors = {};
                        $scope.hours = [];
                        $scope.minutes = [];
                        for (var i = 0; i < 60; i++) {
                            if (i < 10) {
                                $scope.minutes.push("0" + i);
                                $scope.hours.push("0" + i);
                            } else if (i < 24) {
                                $scope.minutes.push(i.toString());
                                $scope.hours.push(i.toString());
                            } else {
                                $scope.minutes.push(i.toString());
                            }
                        }
                        if ($scope.currentSupplierAccount == null) {
                            $scope.currentSupplierAccount = {};
                        }
                        self.getAvailableDepotContacts();
                        if ($scope.currentSupplierAccount.accountServiceLevels == null) {
                            $scope.currentSupplierAccount.accountServiceLevels = [];
                        }
                        $scope.currentSupplierAccount.accountServiceLevels = _.object(_.map(
                            $scope.currentSupplierAccount.accountServiceLevels,
                            function (item) {
                                return [item.day, item];
                            }));


                        self.procurementSubScriptionId =
                            localStorageService.getItem(enums.localStorage.organisationContext).id;
                        self.organisationId = localStorageService.getItem(enums.localStorage.organisationContext)
                            .currentSubscriptionUnit.organisation.id;
                        self.unitSuppliersAdded = [];
                        $scope.isLoading = true;
                        $scope.supplier = {};
                        if ($scope.currentSupplier) {
                            $scope.supplier = angular.copy($scope.currentSupplier);
                            $scope.getDepots($scope.currentSupplier.supplier.id, self.procurementSubScriptionId);
                            self.setupSupplier();
                        } else {
                            clientProcurementSuppliersService.getClientSpecificSuppliers($scope.subscriptionId).$promise
                                .then(function (data) {
                                    self.groupSupplierObjects = data;
                                    var addedSuppliers = _.where($scope.unitSuppliers, { ispslSupplier: false });
                                    _.each(addedSuppliers,
                                        function (addedSupplier) {
                                            addedSupplier.addedSupplierId = addedSupplier.supplier.id;
                                        });
                                    _.each(self.groupSupplierObjects,
                                        function (supplierObject) {
                                            if (_.findWhere(addedSuppliers,
                                                { addedSupplierId: supplierObject.supplier.id })) {
                                                self.groupSupplierObjects =
                                                    _.without(self.groupSupplierObjects, supplierObject)
                                            }
                                        });
                                    $scope.groupSuppliers = [
                                        { id: 0, name: $translate.instant("no_group_supplier_selected") }
                                    ];
                                    _.each(self.groupSupplierObjects,
                                        function (groupSupplier) {
                                            $scope.groupSuppliers.push(groupSupplier.supplier);
                                        });
                                    self.setupSupplier();
                                });
                        }
                    }();
                });
            }];

        return {
            scope: { client: '=?', currentSupplier: '=?', subscriptionId: '=?', unitSuppliers: '=?', selectedSupplier: '=?', currentSupplierAccount: '=?', assignMode: '=?', refresh: '&', toggle: '&' },
            restrict: 'E',
            controller: controller,
            templateUrl: '/ngxbeagle/dist/Content/js/directives/assignSupplier/assignSupplier.html'
        }
    })

angular.module(appName)
	.directive("banner",
		function() {
			var controller = [
				"oidcManager", "$rootScope", "$scope", "localStorageService", "enums",
				"translateService", "siteUrl", "helpers", "userService", "$window", "accessService", "$q",
				"$translate","$location","$route",
				function(oidcManager,
					$rootScope,
					$scope,
					localStorageService,
					enums,
					translateService,
					siteUrl,
					helpers,
					userService,
					$window,
					accessService,
					$q,
					$translate,
					$location,
					$route) {
					$translate.onReady().then(function() {
						//Private Fields
						var self = this;

						var userManager = oidcManager.UserManager();

						var userAccountMenuItem = {
							friendlyNameKey: "route_welcome_name",
							icon: "fa-user",
							path: "#",
							children: [
								{
									path: "/MyAccount",
									friendlyNameKey: "route_account_name",
									icon: "fa-user"
								},
								{
									path: "",
									ngClick: function() {
										localStorageService.clear();
										userManager.signoutRedirect();
									},
									friendlyNameKey: "route_logout_name",
									icon: "fa-power-off"
								}
							]
						};

						var activeItem;
						self.currentLanguage = localStorage.getItem("NG_TRANSLATE_LANG_KEY");

						//Public Fields
						$scope.permissions = [];
						$scope.debugMode = siteUrl().indexOf("localhost") >= 0;
						$scope.languages = [
							{ code: "zh", description: "中文" }, { code: "de", description: "Deutsche" },
							{ code: "en", description: "English" }, { code: "es", description: "Española" }
						];
						$scope.currentLanguage = _.findWhere($scope.languages, { code: self.currentLanguage });

						$scope.currentContext =
							localStorageService.getItem(enums.localStorage.organisationContext) != null
							? localStorageService.getItem(enums.localStorage.organisationContext)
							.currentSubscriptionUnit
							: null;

						$scope.showSettingsMenu = false;

						var topMenu = [];

						//CSH 29032017 I've added these functions because of a problem using float:unset on the nav items in IE.
						//Instead I've employed float:left and float:right on these items but this then causes the float righted
						//items display order to be reversed. These methods compensate for this:
						//If in the future we drop support for IE we can do this all in CSS
						var adjustScopedMenuItemsArrayBasedOnBrowserWidth = function() {
							var viewportWidth = $(window).width();
							if (viewportWidth > 1130) {
								$scope.topMenu = topMenu.slice(0).reverse();
								$scope.topMenu.unshift(userAccountMenuItem);
							} else {
								$scope.topMenu = topMenu.slice(0);
								$scope.topMenu.unshift(userAccountMenuItem);
							}
						};

						$(window).on("resize.doResize",
							_.debounce(function() {
									adjustScopedMenuItemsArrayBasedOnBrowserWidth();
								},
								100));

						var userModuleEnums;

						var shouldDisplayRouteInMenu = function (route, userPermissions) {
							if (route.needsModule && userModuleEnums.indexOf(route.needsModule) < 0) {
								return false;
							}
							//CSH 7/9/2017 Added this as a hotfix to get unit and group invoices working
							//but not convinced the logic here is correct:
							if (route.path === '/UnitInvoices') {
								if (route.permission && _.contains(userPermissions, route.permission)) {
									return true;
								}
							}
							if (route.path === '/GroupInvoices') {
								if (route.permission && _.contains(userPermissions, route.permission)) {
									return true;
								}
							}
							if (route.permission && !_.contains(userPermissions, route.permission)) {
								return false;
							}

							if (route.children) {
								return _.some(route.children,
									function(child) {
										var shouldDisplayChildInMenu = shouldDisplayRouteInMenu(child, userPermissions);
										return shouldDisplayChildInMenu;
									});
							}

							if (route.forceHideInMenu || !route.friendlyNameKey) {
								return false;
							}

							if (route.needsOneOf && route.needsOneOf.length) {
								var intersection = _
									.intersection(userPermissions, route.needsOneOf);
								if (!intersection.length)
									return false;
							}

							return !route.children;
						}

						var returnRouteIfCurrentRouteIsRelation = function (route) {
							if (route.path.match($route.current.$$route.regexp)) {
								return route;
							}
							if (!route.children || !route.children.length) {
								return false;
							}
							var r = _.find(route.children,
								function (r) {
									return returnRouteIfCurrentRouteIsRelation(r);
								});
							return r;
						};

						var getCurrentTopLevelRoute = function (routes, currentRoute) {
							var currentTopLevelRoute = _.find(routes,
								function(r) {
									return returnRouteIfCurrentRouteIsRelation(r, currentRoute);
								});
							$scope.currentTopLevelRoute = currentTopLevelRoute;
						}

						var removeOptionalParameters = function (routes) {
							_.each(routes, function (r) {
								r.path = r.path.replace(/:(.*)\?/, '');
								if (r.children) {
									removeOptionalParameters(r.children);
								}
							});
						}

						//Private Methods
						var buildMenu = function() {

							if ($scope.currentContext != null) {
								var organisation = $scope.currentContext.organisation;

								$q.all([
									accessService
									.getApplicationModules(enums.currentApplication.id,
										organisation.id),
									userService.getCurrentUser()
								]).then(function(asyncData) {

									userModuleEnums = _.pluck(asyncData[0], 'applicationModuleEnum');

									var currentUser = asyncData[1];

									if (currentUser) {

										// TODO: Refactor to translate
										userAccountMenuItem.isUserMenuItem = true;
										userAccountMenuItem.currentUserName = currentUser.friendlyName;
										$scope.friendlyName = currentUser.friendlyName;

										//filter currentUser.permissions
										$scope.topLevelRoutes = angular.copy(_.filter($window.beagle.routes,
											function(route) {
												return shouldDisplayRouteInMenu(route, currentUser.permissions);
											}));

										removeOptionalParameters($scope.topLevelRoutes);

										topMenu = _.map($scope.topLevelRoutes,
											function(route) {
												return {
													friendlyNameKey: route.friendlyNameKey,
													children: _.filter(route.children,
														function(child) {
															return shouldDisplayRouteInMenu(child,
																currentUser.permissions);
														}),
													permission: route.permission,
													path: route.path,
													openInNewWindow: route.openInNewWindow
												};
											});
										getCurrentTopLevelRoute($scope.topLevelRoutes, $scope.currentPath);
										adjustScopedMenuItemsArrayBasedOnBrowserWidth();
										$rootScope.$broadcast(enums.eventNames.bannerNavigationComplete);
									}
								});
							}

						}; //Public Methods
						$scope.activateMenu = function() {
							$scope.menuActive = !$scope.menuActive;
						};

						$scope.executeMenuFunction = function(child) {
							if (child.ngClick)
								child.ngClick();
						};

						$scope.activate = function (item) {
							var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
							if ($scope.currentTopLevelRoute && $scope.currentTopLevelRoute.secondaryMenu && w && w > 1000 && $scope.currentTopLevelRoute.path === item.route.path) {
								return; //CSH 14122018 This prevents a secondary menu droping down on wide screen sizes
								//if the existing route already has an always-visible horizontal secondary menu
							}

							if (activeItem && activeItem !== item)
								activeItem.active = false;
							activeItem = item;
							item.active = !item.active;
						};

						$scope.$on("$locationChangeSuccess",
							function () {
								$scope.menuActive = false;
								if (activeItem)
									activeItem.active = false;
								$scope.currentPath = $location.$$path.toLowerCase();
							});

						$scope.$on(enums.broadcasts.updatedContext,
							function(event, data) {
								$scope.currentContext = data.context.currenSubscriptionUnit ||
									localStorageService.getItem(enums.localStorage.organisationContext)
									.currentSubscriptionUnit;
								buildMenu();
							});

						$scope.toggleShowSettingsMenu = function() {
							$scope.showSettingsMenu = !$scope.showSettingsMenu;
						};

						$scope.changeLanguage = function(lang) {
							translateService.setLanguage(lang);
							$scope.currentLanguage = _.findWhere($scope.languages, { code: lang });
						};

						//Constructor
						var init = function () {
							$scope.currentPath = $location.$$path.toLowerCase();
							buildMenu();
							if (helpers.isNullOrUndefined(self.currentLanguage)) {
								self.currentLanguage = "en";
							}
						};
						init();
					});
				}
			];

			return {
				restrict: "E",
				scope: true,
				controller: controller,
				templateUrl: "ngxbeagle/dist/Content/js/directives/banner/banner.html"
			};
		});

angular.module(appName)
    .directive('basket', function() {
        var controller = [
            '$scope', 'basketStore', '$location', '$route', 'basketService', 'enums',
            function ($scope, basketStore, $location, $route, basketService, enums) {
                var self = this;
                $scope.basketStore = basketStore;

                $scope.getBasketIcon = function () {
                    if ($route.current.params.discriminator == enums.procurementBasketType.ProcurementBasket)
                        return 'fa-shopping-basket';
                    if ($route.current.params.discriminator == enums.procurementBasketType.ShoppingList)
                        return 'fa-list-alt';
                }

                $scope.goToBasket = function () {
                    console.log($route.current.params);
                    var url;
                    if ($route.current.params.discriminator == enums.procurementBasketType.ProcurementBasket)
                        url = '/baskets/view/' + $route.current.params.basketId;
                    else if ($route.current.params.discriminator == enums.procurementBasketType.ShoppingList)
                        url = '/shoppinglists/view/' + $route.current.params.basketId;

                    console.log(url);
                    $location.path(url);
                }

                $scope.$watch(function() { return $scope.basketStore.show() },
                    function (newValue) {
                        if (newValue == true) {
                            basketService.getBasketCount($route.current.params.basketId).$promise.then(function (c) {
                                $scope.basketStore.setCount(c.count);
                            });
                        }
                    });
            }
        ];

        return {
            restrict: 'E',
            scope: {},
            controller: controller,
            templateUrl: '/ngxbeagle/dist/Content/js/directives/basket/basket.html'
        }
    });

angular.module(appName)
    .factory('basketStore', [
        'basketService', '$route', '$location',
        function (basketService, $route, $location) {
            var self = this;
            self.count = 0;

            return {
                get: function() {
                    return self.count;
                },
                setCount: function(count) {
                    return self.count = count;
                },
                increment: function(amt) {
                    return amt ? self.count += amt : self.count += 1;
                },
                decrement: function(amt) {
                    return amt ? self.count -= amt : self.count -= 1;
                },
                show: function () {
                    var shouldShow = $location.path().toLowerCase().indexOf('productsearch') > 0 &&
                        $route.current.params.basketId != null;
                    return shouldShow;
                },
                basketId: function() {
                    return $route.current.params.basketId;
                }
            }
        }
    ]);
angular.module(appName)
  .directive('cdbBasketItemSearchNameComponent',
    function () {
      var controller = [
        '$scope',
        'enums',
        function($scope,
                 enums) {
          $scope.enums = enums;
        }
      ];

      return {
        controller: controller,
        scope: {
          item: '=',
          parentEntityId: '=',
          segmentId: '=?'
        },
        restrict: 'E',
        templateUrl: '/ngxbeagle/dist/Content/js/directives/basketItemSearchNameComponent/basketItemSearchNameComponent.html'
      }
    }
  );

angular.module('beagle')
    .directive('buttonFix', function() {
        var controller = [
            '$scope', '$element', '$attrs',
            function ($scope, $element, $attrs) {
                $element.css({
                    height: 'auto !important',
                    minHeight: 0
                });
            }
        ];

        return {
            restrict: 'A',
            controller: controller,
        }
    })
angular.module(appName)
    .directive('buttonGroup',
        function () {
            var controller = [
                '$element', '$attrs', '$translate',
                function ($element, $attrs, $translate) {
                    var bg = this;
                    bg.processing = true;
                    bg.buttonClass = $attrs.class || 'blue';

                    if (angular.isDefined($attrs.buttonText)) {
                        $translate($attrs.buttonText).then(function (translateKey1) {
                            bg.buttonText = translateKey1;
                        });
                    } else {
                        $translate('button_group_default_text').then(function (translateKey1) {
                            bg.buttonText = translateKey1;
                        });
                    }
                    bg.open = false;
                    bg.id = uuid.v4();

                    bg.toggleOpen = function () {
                        bg.open = !bg.open;
                    };

                    bg.close = function () {
                        if (bg.open) {
                            bg.open = false;
                        }
                    };
                    bg.processing = false;
                }
            ];

            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                controller: controller,
                controllerAs: 'bg',
                templateUrl: window.urls.beagle + '//ngxbeagle/dist/Content/js/directives/buttonGroup/buttonGroup.html'
            }
        });

angular.module(appName)
    .directive("card", function() {
            return {
                link: function ($scope, $element, $attrs) {
                    $element.addClass('card-' + $attrs.card);
                    $element.removeAttr('card');
                }
            }
        }
    );
//don't use this unless absolutely necessary. In general for routing we should be using hrefs styled as buttons

angular.module(appName)
    .directive('cdbGo', ['$location', function ($location) {

    	function link(scope, element, attrs) {

    		element.on("click", function () {
    			console.log("click", attrs.cdbGo);
    			scope.$apply(function () {
    				$location.path(attrs.cdbGo);
    			});
    		});
    	}

    	return {
    		link: link
    	};
    }]);
angular.module(appName).directive('cdbAutofocus', ['$timeout', function ($timeout) {
	return {
		restrict: 'A',
		link: function ($scope, $element) {
			$timeout(function () {
				$element[0].focus();
			});
		}
	}
}]);
angular.module(appName).directive('cdbFocusOn', ['$timeout', function ($timeout) {
	return {
		scope: {
			cdbFocusOn:"="
		},
		link: function ($scope, $element) {
			$timeout(function () {
				$element[0].focus();
			});
		}
	}
}]);
angular.module(appName)
    .directive('cdbExistsIn', function () {
        return {
            restrict: 'A',
            scope: {
                cdbExistsIn: '=?',
                cdbExistsExclude: '=?'
            },
            require: 'ngModel',
            link: function (scope, elem, attrs, ngModel) {
                function unique(ngModelValue) {
                    if (scope.cdbExistsExclude) {
                        var lowerCaseExclusions = scope.cdbExistsExclude.map(function (val) {
                            return val.toLowerCase();
                        });
                        if (lowerCaseExclusions.indexOf(ngModelValue.toLowerCase()) > -1) {
                            ngModel.$setValidity('existsIn', true);
                            return true;
                        }
                    }
                    if (!ngModelValue ||
                        !scope.cdbExistsIn) {
                        return true;
                    }

                    var lowerCaseArray = scope.cdbExistsIn.map(function (val) {
                        return val.toLowerCase();
                    });
                    var isUnique = lowerCaseArray.indexOf(ngModelValue.toLowerCase()) === -1;
                    ngModel.$setValidity('existsIn', isUnique);

                    return isUnique;
                }

                ngModel.$validators.unique = unique;
            }
        }
    });
angular.module(appName)
	.directive('cdbFloat', function () {

	    return {
	        require: 'ngModel',
	        link: function ($scope, $element, $attrs, $ngModelController) {
	            $ngModelController.$formatters.push(function (value) {
	                return parseFloat(value);
	            });
	            $ngModelController.$parsers = [];
            }
	    };
	});
angular.module(appName)
	.directive('cdbInteger', function () {

	    return {
	        require: 'ngModel',
	        link: function ($scope, $element, $attrs, $ngModelController) {
	            $ngModelController.$formatters.push(function (value) {
	                return parseInt(value);
	            });
	            $ngModelController.$parsers = [];
	        }
	    };
	});
angular.module(appName)
    .directive('cdbMatch', function () {
        return {
            require: 'ngModel',
            link: function (scope, elem, attrs, ngModel) {
                scope.$watch(attrs.cdbMatch, function() {
                    ngModel.$validate();
                });
                
                ngModel.$validators.match = function (modelValue, viewValue) {
                    return viewValue === scope.$eval(attrs.cdbMatch);
                }                
            }
        }
    });
angular.module(appName)
    .directive('cdbMax', function () {
        return {
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {
                function min(ngModelValue) {

                    ctrl.$setValidity('max', isNaN(ngModelValue) || ngModelValue === '' || (parseFloat(ngModelValue) <= parseFloat(attrs.cdbMax)));
                    return ngModelValue;
                }

                ctrl.$parsers.push(min);           
            }
        }
    });
angular.module(appName)
    .directive('cdbMin', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {
                function min(ngModelValue) {
                    
                    ctrl.$setValidity('min', isNaN(ngModelValue) || ngModelValue === '' || (parseFloat(ngModelValue) >= parseFloat(attrs.cdbMin)));
                    return ngModelValue;
                }
                
                ctrl.$parsers.push(min);
            }
        }
    });
angular.module(appName)
    .directive('cdbNumber', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                ngModel: '='
            },
            link: function (scope, element, attrs, ngModel) {
                var dp = attrs['cdbNumber'] || 2;
                var format = function (value) {
                    var parsed;
                    if (value == null || value === 'NaN') {
                        parsed = '';
                    } else {
                        var tryParse = parseFloat(value).toFixed(dp);
                        if (tryParse === 'NaN') {
                            parsed = ngModel.$modelValue || '';
                        } else {
                            parsed = tryParse;
                        }
                    }

                    if (value != null &&
                        parsed != value) {
                        ngModel.$setViewValue(parsed);
                        // ngModel.$modelValue = parsed;
                        ngModel.$render();
                    }

                    return parseFloat(parsed);
                };

                if (element[0].type !== 'number' && !element.hasClass('number')) {
                    element.addClass('number');
                }

                ngModel.$parsers.push(format);
                ngModel.$formatters.push(format);
                
                // this is to make the element be updated in the page load, 
                // because having 'ng-model-options="{ updateOn: 'blur' }"' in the HTML element prevents Angular from writing to the view until the input blurs
                setTimeout(function () {
                    var value = ngModel.$modelValue;
                    if (value != null && !isNaN(value)) {
                        var valueFixed = parseFloat(value).toFixed(dp);
                        element.val(valueFixed);
                    }
                }, 0);
            }
        }
    });
;

angular.module(appName)
    .directive('cdbQrCode', function () {
        var controller = [
            '$scope', '$attrs',
            function ($scope, $attrs) {
                $scope.download = angular.isDefined($attrs.download);
                $scope.showLink = angular.isDefined($attrs.showLink);
            }
        ];

        return {
            restrict: 'E',
            transclude: true,
            scope: {
                data: '=',
                showLink: '=?'
            },
            templateUrl: '/ngxbeagle/dist/Content/js/directives/cdbQrCode/cdbQrCode.html',
            controller: controller
        };
    });

angular.module(appName)
    .directive('cdbResolveBeforeClick', [function () {
        return {
            link: function (scope, element, attr) {
                var resolveBeforeClickAction = attr.cdbResolveBeforeClick;
                var clickAction = attr.cdbClick;
                element.bind('click', function () {
                    var result = scope.$eval(resolveBeforeClickAction);
                    result.then(function () {
                        scope.$eval(clickAction);
                    });
                });
            }
        };
    }]);
angular.module('beagle')
    .directive('clear', function() {
        var controller = [
            '$scope', '$element', '$attrs',
            function ($scope, $element, $attrs) {
                if ($attrs.clear) {
                    $attrs.clear = $attrs.clear.toLowerCase();
                }
                switch($attrs.clear) {
                    case 'left':
                        $scope.class = 'clear-left';
                        break;
                    case 'right':
                        $scope.class = 'clear-right';
                        break;
                    case 'both':
                    default:
                        $scope.class = 'clear';
                        break;
                }

                $element.removeAttr('clear');
            }
        ];

        return {
            restrict: 'A',
            scope: {
                clear: '=clear'
            },
            controller: controller,
            template: '<div class="{{class}}"><ng-transclude></ng-transclude></div>',
            replace: true,
            transclude: true
        }
    })
angular.module(appName)
    .factory('creditRequestResource',
        [
            '$resource', 'siteUrl',
            function ($resource, siteUrl) {
                var self = this;
                self.api = siteUrl() + 'api/ProcurementInvoicing';

                return $resource(self.api,
                    {},
                    {
                        //getTransmissionMethods: {
                        //    method: 'GET',
                        //    url: self.api + '/GetTransmissionMethods',
                        //    params: {
                        //        organisationId: "@organisationId"
                        //    },
                        //    isArray: true
                        //},
                        getProposedRequestCreditNotes: {
                            method: "POST",
                            url: self.api + '/GetProposedRequestCreditNotes'
                        },
                        raiseCreditRequests: {
                            method: 'POST',
                            url: self.api + '/RaiseCreditRequests'
                        },
                        transmitCreditRequest: {
                            method: 'POST',
                            url: self.api + '/TransmitCreditRequest'
                        },
                        getCreditRequests: {
                            method: 'GET',
                            url: self.api + '/GetCreditRequests',
                            params: {
                                id: "@id"
                            },
                            isArray: false
                        },
                        get: {
                            method: 'GET',
                            url: siteUrl() + 'api/ProcurementCreditNote' + '/get',
                            params: {
                                id: "@id",
                                creditRequestId: '@creditRequestId'
                            },
                            isArray: false
                        },
                        cancelCreditRequest: {
                            method: 'POST',
                            url: self.api + '/CancelCreditRequest'
                        },
                        flipCreditRequest: {
                            method: 'POST',
                            url: siteUrl() + 'api/ProcurementCreditNote' + '/flipCreditRequest',
                        }
                    });
            }
        ]);
angular.module(appName)
    .factory('creditRequestService',
        [
            'creditRequestResource', 'organisationContextService', 'fileDownloadService', '$http','siteUrl',
            function (creditRequestResource, organisationContextService, fileDownloadService, $http, siteUrl) {

                var getTransmissionMethods = function (organisationId, cb) {
                    return $http.get(siteUrl() + 'api/ProcurementInvoicing/GetTransmissionMethods?organisationId=' + organisationId);
                    //return creditRequestResource.getTransmissionMethods(organisationId).$promise.then(cb);
                }

                var getProposedRequestCreditNotes = function (procurmentInvoiceHeaderId, cb) {
                    var ctx = organisationContextService.getContext();
                    var dto = {
                        id: ctx.currentSubscriptionUnit.id,
                        procurmentInvoiceHeaderId: procurmentInvoiceHeaderId
                    }
                    return creditRequestResource.getProposedRequestCreditNotes(dto).$promise.then(cb);
                }

                var raiseCreditRequests = function (model) {
                    return creditRequestResource.raiseCreditRequests(model).$promise;
                }
                var transmitCreditRequest = function (model, cb) {
                    return creditRequestResource.transmitCreditRequest(model).$promise.then(cb);
                }

                var getCreditRequests = function (id, cb) {
                    var param = { id: id };
                    return creditRequestResource.getCreditRequests(param).$promise.then(cb);
                };

                var cancelCreditRequest = function (procurementCreditRequestId, message, cb) {
                    var ctx = organisationContextService.getContext();
                    var param = {
                        id: ctx.currentSubscriptionUnit.id,
                        procurementCreditRequestId: procurementCreditRequestId,
                        message: message
                    };
                    return creditRequestResource.cancelCreditRequest(param).$promise.then(cb);               
                }

                var flipCreditRequest = function (procurementCreditRequestId,rollup, cb) {
                    console.log('procurementCreditRequestId', procurementCreditRequestId);
                    var ctx = organisationContextService.getContext();
                    var dto = {
                        id: ctx.currentSubscriptionUnit.id,
                        procurementCreditRequestId: procurementCreditRequestId,
                        rollupLines: rollup
                    }
                    return creditRequestResource.flipCreditRequest(dto).$promise.then(cb);
                };

                var get = function (creditRequestId) {
                    var ctx = organisationContextService.getContext();
                    var param = { id: ctx.currentSubscriptionUnit.id, creditRequestId: creditRequestId };
                    return creditRequestResource.get(param).$promise;
                };

                var downloadCreditRequest = function(creditRequest) {
                    var ctx = organisationContextService.getContext();
                    var url = '/api/ProcurementCreditNote/DownloadCreditRequest?id=' +
                        ctx.currentSubscriptionUnit.id +
                        '&creditRequestId=' +
                        creditRequest.id;
                    return fileDownloadService.downloadFile(url, creditRequest.creditRequestNumber, 'pdf');
                };
                return {
                    getProposedRequestCreditNotes: getProposedRequestCreditNotes,
                    raiseCreditRequests: raiseCreditRequests,
                    transmitCreditRequest: transmitCreditRequest,
                    getCreditRequests: getCreditRequests,
                    get: get,
                    flipCreditRequest: flipCreditRequest,
                    cancelCreditRequest: cancelCreditRequest,
                    downloadCreditRequest: downloadCreditRequest,
                    getTransmissionMethods: getTransmissionMethods
                }
            }
        ]);

angular.module(appName)
    .directive('creditRequestsList', function () {
        var controller = [
			'$scope',
			'$translate',
			'creditRequestService',
			'localStorageService',
			'enums',
			'paginationFactory',
			'$routeParams',
            'translateMessage',
			function ($scope,
				$translate,
				creditRequestService,
				localStorageService,
				enums,
				paginationFactory,
				$routeParams,
                translateMessage) {
                $translate.onReady().then(function() {
                    var syncTotalFiltered = function() {
                        var total = _.filter($scope.creditNotesListDto.list,
                            function(value) {
                                return _.find($scope.statusTypes, function(x) { return x.id == value.status.id })
                                    .checked;
                            }).length;
                        $scope.pagination.total = total;
                        $scope.pagination.syncStartFromAndEndAt();
                    }

                    $scope.setData = function(d) {
                        $scope.creditNotesListDto = d;
                        syncTotalFiltered();
                    }

                    $scope.filter = function(value, index) {
                        return _.find($scope.statusTypes, function(x) { return x.id == value.status.id }).checked;
                    }

                    $scope.filterChanged = function() {
                        $scope.pagination.currentPage = 1;
                        syncTotalFiltered();
                    }

                    $scope.flipCreditRequest = function(creditRequest, rollup) {
                        creditRequest.flipping = true;
                        creditRequestService.flipCreditRequest(creditRequest.id,
                            rollup,
                            function() {
                                translateMessage.success('creditRequests_created_credit_note');
                                creditRequest.flipping = false;
                            });
                    };

                    $scope.cancelRequest = function(creditRequest) {
                        creditRequest.cancelling = true;
                        creditRequestService.cancelCreditRequest(creditRequest.id,
                            creditRequest.cancelMessage,
                            function(data) {
                                translateMessage.success('success');
                                $scope.cancelMessage = data.message;
                                $scope.toggleShowCancelCreditRequest(creditRequest);
                                creditRequest.cancelling = false;
                                creditRequest.status.id = 400;
                                creditRequest.status.name = 'Cancelled';
                            });
                    }

                    $scope.toggleShowCancelCreditRequest = function(creditRequest) {
                        creditRequest.cancelCreditRequest = !creditRequest.cancelCreditRequest;
                    };

                    $scope.toggleCreditRequestActions = function(cr) {
                        cr.showActions = !cr.showActions;
                    }

                    $scope.downloadCreditRequest = function(cr) {
                        cr.downloading = true;

                        return creditRequestService.downloadCreditRequest(cr).then(function() {
                                cr.downloading = false;
                            },
                            function() {
                                cr.downloading = false;
                            });
                    };

                    var setUpFilters = function() {
                        var statusTypes = [];
                        _.each(enums.procurementCreditRequestStatus,
                            function(value, key) {
                                statusTypes.push({ id: value, description: key, checked: true });
                            });
                        $scope.statusTypes = statusTypes;
					}

					var mapQueryStringToFilter = function() {
						_.mapObject($routeParams,
							function (val, key) {
								var lowerKey = key.toLowerCase();
								if (lowerKey == 'search') {
									$scope.search = val;
								} else {
									var statusType = _.find($scope.statusTypes, { description: lowerKey });
									if (statusType) {
										statusType.checked = val;
									}
								}
							});
					}

                    $scope.init = function() {
						var unitId = localStorageService
							.getItem(enums.localStorage.organisationContext)
							.currentSubscriptionUnit.id;
                        creditRequestService.getCreditRequests(unitId, $scope.setData);
						setUpFilters();
	                    mapQueryStringToFilter();
                        paginationFactory.addPaginationVariablesAndFunctionsToScope($scope);
                        $scope.pagination.numPerPage = 10;
                    }();
                });
            }
    ];

        return {
            restrict: 'E',
            scope: {
            },
            templateUrl: '/ngxbeagle/dist/Content/js/directives/creditRequests/list/creditRequestsList.html',
            controller: controller
        }
    });

angular.module(appName).directive('creditRequests', function () {
    var controller = [
        '$scope', '$window', 'creditRequestService','purchaseOrderService',
        'organisationContextService', 'translateMessage',
        function ($scope, $window, creditRequestService, purchaseOrderService,
            organisationContextService, translateMessage
        ) {
                var self = this;
                var context = organisationContextService.getContext();
                $scope.disableRaiseCreditRequest = false;
                $scope.showRaiseButton = true;
                self.success = function () {
                    translateMessage.success('credit_request_raised');
                    $scope.showRaiseButton = false;
                    $window.location.reload();
                }

                $scope.selectAll = false;
                $scope.toggleSelectAll = function() {
                    $scope.selectAll = !$scope.selectAll;
                    for (var i = 0; i < $scope.creditRequestDto.proposedCreditRequestLines.length; i++) {
                        $scope.creditRequestDto.proposedCreditRequestLines[i].raiseRequest = $scope.selectAll;
                    }
                }

                $scope.setData = function (d) {
                    $scope.creditRequestDto = d;
                    purchaseOrderService.getTransmissionMethods(context.organisation.id).then(function (result) {
                        var transmissionMethods = result.data;
                        if (!transmissionMethods.length) {
                            transmissionMethods = [
                                { id: 1, name: 'Email', isDefault: true },
                                { id: 2, name: 'Phone' }
                            ];
                        }
                        $scope.transmissionMethods = transmissionMethods;
                        $scope.creditRequestDto.transmissionMethodId = _.find(transmissionMethods, function (x) { return x.isDefault }).id;
                    });
                }

                $scope.form = {};
                $scope.toggleSelectAll = function () {
                    _.each($scope.creditRequestDto.proposedCreditRequestLines, function (l) {
                        l.raiseRequest = $scope.form.selectedAll;
                    });
                }

                $scope.raiseRequests = function () {
                    $scope.disableRaiseCreditRequest = true;
                    creditRequestService.raiseCreditRequests($scope.creditRequestDto).then(function() {
                            self.success();
                        },
                        function(error) {
                            translateMessage.error("an_unexpected_error_has_occured_credit_request_has_not_been_created");
                        })
                        .finally(function() {
                            $scope.disableRaiseCreditRequest = false;
                        }
                    );
                };

                $scope.init = function () {
                    creditRequestService.getProposedRequestCreditNotes($scope.data, $scope.setData);
                }();
            }
        ];

        return {
            restrict: 'E',
            scope: {
                data: '=',
                cancel: '&',
                showRaiseCreditButton: '='
            },
            templateUrl: '/ngxbeagle/dist/Content/js/directives/creditRequests/request/creditRequests.html',
            controller: controller
        }
    });

angular.module(appName)
    .directive('creditRequest', function () {
        var controller = [
            '$scope', '$translate', '$q', 'creditRequestService', 'genericUiGrid', "$templateRequest", "enums", "$rootScope", "$window", "localStorageService","userService",
            function ($scope, $translate, $q, creditRequestService, genericUiGrid, $templateRequest, enums, $rootScope, $window, localStorageService, userService) {
                var self = this;
                $scope.context = localStorageService.getItem(enums.localStorage.organisationContext);
                self.promises = {
                    lineTypeTemplate: $templateRequest('/ngxbeagle/dist/Content/js/Directives/creditrequests/single/lineTypeTemplate.html'),
                    transmissionMethodsPromise: creditRequestService.getTransmissionMethods($scope.context.organisation.id)
                };

                $scope.creditRequestGrid = null;

                $scope.downloadCreditRequest = function () {
                    $scope.creditRequest.downloading = true;

                    return creditRequestService.downloadCreditRequest($scope.creditRequest).then(function () {
                        $scope.creditRequest.downloading = false;
                    }, function () {
                        $scope.creditRequest.downloading = false;
                    });
                };

                $scope.transmitCreditRequest = function () {
                    $scope.creditRequest.transmitting = true;
                    $scope.creditRequest.invoiceHeaderId = $scope.creditRequest.procurementInvoiceHeaderId;
                    creditRequestService.transmitCreditRequest($scope.creditRequest, function () {
                        $scope.creditRequest.transmitting = false;
                        $translate('success_credit_request_transmitted', { supplierName: $scope.creditRequest.supplier })
                            .then(function (translation) {
                                toastr.success(translation);
                            });
                        $window.location.reload();
                    });
                }

                $scope.init = function () {

                    $q.all(
                        self.promises
                    ).then(function (resultsArray) {
                        userService.hasPermission('BEAGLE_CREDIT_REQUEST_RAISE').then(function () {
                            $scope.canTransmitCreditRequest = true;
                        });
                        var template = resultsArray.lineTypeTemplate;
                        $scope.transmissionMethodsResult = resultsArray.transmissionMethodsPromise;



                        $scope.creditRequest = $scope.data;
                        $scope.creditRequest.creditRequestId = $scope.creditRequest.id;

                        var transmissionMethods = $scope.transmissionMethodsResult.data;
                        if (!transmissionMethods.length) {
                            transmissionMethods = [
                                { id: 1, name: $translate.instant('email'), isDefault: true },
                                { id: 2, name: $translate.instant('phone') }
                            ];
                        }
                        $scope.transmissionMethods = transmissionMethods;
                        var defaultMethod = _.find(transmissionMethods, function (x) { return x.isDefault });
                        //if (!$scope.purchaseOrderIsReadonly()) {
                        $scope.creditRequest.transmissionMethodId = defaultMethod.id;
                        //}

                        var currencyTemplate =
                            $templateRequest("/ngxbeagle/dist/Content/js/Directives/creditRequests/single/currencyDisplay.html");

                        $scope.gridOptions = {
                            enableColumnResizing: true,
                            data: $scope.creditRequest.procurementCreditRequestLines,
                            globalEditableCondition: function () {
                                return false;
                            },
                            columns: [
                                {
                                    field: "lineType.name",
                                    template: template,
                                    width: 150
                                },
                                {
                                    field: 'creditDescription'
                                },
                                {
                                    field: "unitCostPrice",
                                    cellFilter: 'number: 2',
                                    template: currencyTemplate,
                                    cellClass: 'number',
                                    width: 150
                                },
                                {
                                    field: "quantity",
                                    cellFilter: 'number: 3',
                                    cellClass: 'number',
                                    width: 150
                                },
                                {
                                    field: "grossPrice*",
                                    cellFilter: 'number: 2',
                                    template: currencyTemplate,
                                    cellClass: 'number',
                                    width: 150
                                }
                            ]
                        };


                        genericUiGrid.create($scope.gridOptions, $scope.creditRequest.procurementCreditRequestLines).then(
                            function (grid) {
                                $scope.creditRequestGrid = grid;
                            });
                    });


                }();

            }

        ];

        return {
            restrict: 'E',
            scope: {
                data: '=',
                cancel: '&'
            },
            templateUrl: '/ngxbeagle/dist/Content/js/directives/creditRequests/single/creditRequest.html',
            controller: controller
        }
    });

'use strict';

angular.module(appName)
    .directive('editBasketItems',
        function () {
            var controller = [
                '$scope',
                '$anchorScroll',
                '$q',
                'basketService',
                'clientUnitAccountCodeService',
                'toastr',
                '$location',
                'enums',
                'userService',
                'validationHelper',
                '$translate',
                '$rootScope',
                '$timeout',
                'dragulaAnimationSpeed',
                'organisationContextService',
                'productSearchService',
                'shoppingListService',
                'dragulaService',
                function ($scope,
                          $anchorScroll,
                          $q,
                          basketService,
                          clientUnitAccountCodeService,
                          toastr,
                          $location,
                          enums,
                          userService,
                          validationHelper,
                          $translate,
                          $rootScope,
                          $timeout,
                          dragulaAnimationSpeed,
                          organisationContextService,
                          productSearchService,
                          shoppingListService,
                          dragulaService) {
                    $translate.onReady().then(function () {
                        $scope.packTypes = enums.packTypes;
                        $scope.basketTypes = enums.procurementBasketType;
                        var self = this;
                        self.removedItemSuccessMessage = "Item removed from basket.";
                        self.updatedItemSuccessMessage = "Basket item updated.";

                        $scope.removeBasketItem = function (basketItem) {
                            basketService.removeBasketItem(basketItem.id, $scope.basketId).then(
                                function (data) {
                                    self.confirmChanges(data, self.removedItemSuccessMessage);
                                    $scope.basketItems.remove(basketItem);
                                    var x = basketItem.catchWeight;
                                    if (x == null) {
                                        x = 1;
                                    }
                                    $scope.basketTotal =
                                        $scope.basketTotal - (basketItem.quantity * basketItem.itemPrice * x);

                                    $scope.basketWithUnpricedItems = _.some($scope.basketItems,
                                        function (basketItem) {
                                            return basketItem.itemPrice === null || basketItem.itemPrice === undefined;
                                        });
                                    syncSortOrders(true);
                                });
                        };

                        var setIsBestPrice = function (results) {
                            _.each(results,
                                function (alternative) {
                                    alternative.isBestPrice = productSearchService.isBestPrice(alternative, true);
                                });
                        };

                        var setupDragula = function () {
                            var deferred = $q.defer();
                            dragulaService.options($scope,
                                'dragula-bag',
                                {
                                    moves: function (element, container, handle) {
                                        return handle.className.indexOf('dragula-handle') > -1;
                                    },
                                    revertOnSpill: true
                                });
                            deferred.resolve();
                            return deferred.promise;
                        };

                        var dlg;
                        $scope.replaceDialog = {
                            _previousBasketItemId: null,
                            _$index: 0,
                            _itemElementId: '',
                            currentBasketItem: null,
                            show: false,
                            alternativeProducts: [],
                            loading: false,
                            getAlternativeProducts: function () {
                                if (dlg.currentBasketItem.id != dlg._previousBasketItemId) {
                                    dlg.loading = true;
                                    var model = {
                                        basketId: $scope.basket.id,
                                        clientId: self.ctx.currentSubscriptionUnit.client.id,
                                        searchTypeEnum: enums.productSearchTypes.bestPrice,
                                        skuId: dlg.currentBasketItem.skuId,
                                        productId: dlg.currentBasketItem.productId,
                                        organisationId: self.ctx.currentSubscriptionUnit.organisation.id,
                                        term: ''
                                    };
                                    return productSearchService.getAdditionalProducts(model).$promise.then(
                                        function (resp) {
                                            if (resp.length) {
                                                _.each(resp, function (data) {
                                                    setIsBestPrice(data.results);
                                                });
                                            }
                                            ;
                                            dlg.alternativeProducts = resp;
                                            dlg._previousBasketItemId = dlg.currentBasketItem.id;
                                        }).finally(function () {
                                        dlg.loading = false;
                                    });
                                } else {
                                    // OnShow requires a promise on the dialog. Just return a self-resolving promise
                                    var d = $q.defer();
                                    d.resolve();
                                    return d.promise;
                                }
                            },
                            replaceProduct: function (alternative) {
                                $scope.hasDragula = false;
                                $scope.showBasketItems = false;
                                syncSortOrders(true);
                                return shoppingListService.replaceBasketItem(dlg.currentBasketItem, alternative, $scope.availableClientSupplierAccounts).then(
                                    function (replacementProduct) {
                                        replacementProduct.isBestPrice = alternative.isBestPrice;
                                        self.getClientSupplierAccounts().then(function () {
                                            basketService
                                            // We have to set the Account on all items otherwise it will re-save every single basket item!!!!
                                            // Don't ask me why, it just does, and it's very bad
                                                .setClientSupplierDtoOnItemsFromDto($scope.basketItems,
                                                    $scope.availableClientSupplierAccounts,
                                                    function () {
                                                        $scope.showBasketItems = true;
                                                        $timeout(function () {
                                                            var itemElement = document.getElementById('basket-item-' + dlg._$index);
                                                            window.scrollTo(0, dlg._offset);
                                                            itemElement.classList.add('highlight-on');
                                                            $timeout(function () {
                                                                itemElement.classList.remove('highlight-on');
                                                            }, 500);
                                                        });
                                                    });
                                        });

                                        $scope.basketItems.splice(dlg._$index, 1, replacementProduct);
                                        dragulaService.destroy($scope, 'dragula-bag');
                                        dlg.toggle();

                                        $translate('basket_item_replaced_successfully').then(function (t) {
                                            toastr.success(t);
                                        });

                                    }).finally(function () {
                                    $scope.hasDragula = true;
                                    setupDragula();
                                });
                            },
                            showConfirmation: function (alternativeProduct) {
                                alternativeProduct.showConfirmation = !alternativeProduct.showConfirmation;
                            },
                            toggle: function (basketItem, $index, fromTemplate) {
                                dlg = this;
                                console.log('dlg', dlg);
                                dlg.currentBasketItem = basketItem;
                                if (fromTemplate) {
                                    dlg._$index = $index;
                                    dlg._offset = window.scrollY;
                                }
                                dlg.show = !dlg.show;
                            }
                        }

                        $scope.setAccountNumberOnItem = function (basketItem) {
                            basketService.setClientSupplierDtoOnIndividualProduct(basketItem, $scope.availableClientSupplierAccounts);
                        }

                        $scope.isOrderableBasket = function () {
                            return $scope.discriminator == enums.procurementBasketType.ProcurementBasket;
                        }

                        $scope.getNoItemsTranslationKey = function (discriminator) {
                            if (discriminator === enums.procurementBasketType.ProcurementBasket)
                                return 'label_no_basket_items_found';
                        }

                        $scope.calculateQuantityToOrder = function (basketItem) {
                            // Return null because we have a null qty
                            if (!basketItem.quantity) return null;

                            // Our qty exists so calculate C/W if we have one
                            if (basketItem.catchWeight) {
                                return basketItem.calculatedQuantity = basketItem.catchWeight * basketItem.quantity;
                            }
                            // We have no C/W so just return qty
                            return basketItem.quantity;
                        }
                        $scope.updateCatchWeightTotal = function (basketItem) {
                            var oldTotal = 0;
                            var newTotal = 0;
                            if (basketItem.catchWeight) {
                                newTotal = basketItem.quantity * basketItem.catchWeight * basketItem.itemPrice;
                            } else {
                                newTotal = basketItem.quantity * basketItem.itemPrice;
                            }

                            if (basketItem.oldCatchWeight) {
                                oldTotal = basketItem.oldCatchWeight * basketItem.oldQuantity * basketItem.oldItemPrice;
                            } else {
                                oldTotal = basketItem.oldQuantity * basketItem.oldItemPrice;
                            }
                            $scope.basketTotal += (newTotal - oldTotal);
                        }
                        $scope.updateCatchWeightQuantity = function (basketItem) {
                            var oldTotal = 0;
                            var newTotal = 0;
                            var error = false;

                            var newCatchWeight = basketItem.catchWeight == null || basketItem.catchWeight == ''
                                ? 1
                                : basketItem.catchWeight;
                            var oldCatchWeight = basketItem.oldCatchWeight == null || basketItem.catchWeight == ''
                                ? 1
                                : basketItem.oldCatchWeight;


                            if (basketItem.quantity && basketItem.oldQuantity) {
                                newTotal = newCatchWeight * basketItem.quantity * basketItem.itemPrice;
                                oldTotal = oldCatchWeight * basketItem.oldQuantity * basketItem.oldItemPrice;
                            } else if (basketItem.quantity && basketItem.oldQuantity) {
                                newTotal = newCatchWeight * basketItem.quantity * basketItem.itemPrice;
                                oldTotal = oldCatchWeight * basketItem.oldQuantity * basketItem.oldItemPrice;
                                basketItem.oldQuantity = null;

                            } else {
                                basketItem.oldQuantity = basketItem.oldQuantity;
                                error = true;
                            }
                            if (error == false) {
                                $scope.basketTotal += newTotal - oldTotal;
                            }
                        }

                        $scope.updateBasketItem = function (basketItem, isQuantityChange, isCatchWeightChange) {
                            if (basketItem.clientSupplierAccountDto == null) {
                                return;
                            }
                            if (basketItem.catchWeight) {
                                basketItem.catchWeight = parseFloat(basketItem.catchWeight).toFixed(3);
                            }
                            if (validationHelper.isDecimal(basketItem.quantity) == false) {
                                basketItem.quantity = '';
                            } else {
                                basketItem.quantity = parseFloat(basketItem.quantity).toFixed(3);
                            }

                            basketItem.calculatedQuantity = $scope.calculateQuantityToOrder(basketItem);

                            var allowDecimals = false;
                            $scope.errors.decimal = false;
                            $scope.errors.quantity = false;
                            if (basketItem.packTypeId == $scope.packTypes.catchWeight &&
                                (basketItem.catchWeight == null || basketItem.catchWeight == 0)) {
                                allowDecimals = true;
                            }
                            if (!allowDecimals && basketItem.quantity % 1 != 0) {
                                $scope.errors.decimal = true;
                                toastr.error($translate.instant("the_quantity_may_only_be_a_decimal_if"));
                            }

                            if (parseFloat(basketItem.catchWeight) === 0) {
                                toastr.error($translate.instant("catchweight_cannot_be_zero"));
                                $scope.errors.quantity = true;
                            }

                            if (($scope.discriminator === enums.procurementBasketType.ProcurementBasket) &&
                                ((basketItem.quantity < 1 && !allowDecimals) ||
                                    (basketItem.quantity <= 0 && allowDecimals) ||
                                    basketItem.quantity == null ||
                                    basketItem.quantity == undefined)) {
                                toastr.error($translate.instant("quantity_cannot_be_zero"));
                                $scope.errors.quantity = true;
                            }

                            if (!($scope.errors.quantity || $scope.errors.decimal)) {
                                if (!validationHelper.isNullOrWhiteSpace(basketItem.quantity)) {
                                    basketItem.quantity = parseFloat(basketItem.quantity).toFixed(3);
                                }

                                if ($scope.isOrderableBasket() &&
                                    (!basketItem.quantity)) {
                                } else if (
                                    (!$scope.isOrderableBasket() && !isQuantityChange) ||
                                    $scope.isOrderableBasket()) {
                                    basketItem.isSaving = true;
                                    var updateBasketItemRequestDto = {
                                        id: basketItem.id,
                                        quantity: $scope.isOrderableBasket() ? basketItem.quantity : null,
                                        catchWeight: basketItem.catchWeight,
                                        procurementClientUnitAccountCodeId: basketItem
                                            .procurementClientUnitAccountCodeDto
                                            .id,
                                        clientSupplierAccountId:
                                            basketItem.clientSupplierAccountDto
                                                ? basketItem.clientSupplierAccountDto.id
                                                : null,
                                        procurementBasketId: basketItem.procurementBasketId,
                                        discriminator: $scope.discriminator
                                    }


                                    if (isCatchWeightChange) {
                                        $scope.updateCatchWeightTotal(basketItem);
                                    }
                                    if (isQuantityChange) {
                                        $scope.updateCatchWeightQuantity(basketItem);
                                    }

                                    basketService.updateBasketItem(updateBasketItemRequestDto).then(function (data) {
                                            self.confirmChanges(data, self.updatedItemSuccessMessage);
                                            basketItem.oldQuantity = basketItem.quantity;
                                            basketItem.oldCatchWeight = basketItem.catchWeight;
                                            basketItem.itemPrice = data.pricePerItem;
                                            basketItem.supplier = data.supplier;
                                            $scope.basket.hasUnpricedItems = _.some($scope.basket.basketItems,
                                                function (basketItem) {
                                                    return !basketItem.itemPrice;
                                                });
                                        },
                                        function () {
                                            basketItem.quantity = basketItem.oldQuantity;
                                            basketItem.catchWeight = basketItem.oldCatchWeight;
                                            basketItem.calculatedQuantity = $scope.calculateQuantityToOrder(basketItem);
                                        }).finally(function () {
                                        basketItem.isSaving = false;
                                    });
                                }
                            }
                        };

                        self.confirmChanges = function (data, successMessage) {
                            if (data) {
                                toastr.success(successMessage);
                            }
                        };

                        $scope.searchProducts = function (basketId) {
                            $location.path('ProductSearch/' + basketId);
                        };

                        var syncSortOrders = function (ignoreSuccessMessage) {
                            var hasInvalidSortOrder = false;
                            _.each($scope.basketItems,
                                function (item, index) {
                                    var newSortOrder = index + 1;
                                    if (item.sortOrder !== newSortOrder) {
                                        hasInvalidSortOrder = true;
                                    }
                                    item.sortOrder = newSortOrder;
                                });

                            if (hasInvalidSortOrder) {
                                self.setSortOrders(ignoreSuccessMessage);
                            }
                        };

                        self.setSortOrders = function (ignoreSuccessMessage) {
                            var procurementBasketId = $scope.basketId;
                            var procurementBasketItemIds = _.pluck($scope.basketItems, 'id');
                            var request = {
                                procurementBasketId: procurementBasketId,
                                procurementBasketItemIds: procurementBasketItemIds
                            };
                            $scope.updatingSortOrder = true;
                            basketService.updateBasketSortOrder(request).then(function (data) {
                                if (!ignoreSuccessMessage) {
                                    self.confirmChanges(data, self.updatedItemSuccessMessage);
                                }
                            }).finally(function () {
                                $scope.updatingSortOrder = false;
                            });
                        }

                        $rootScope.$on('dragula-bag.drop-model',
                            function () {
                                $timeout(function () {
                                        self.setSortOrders();
                                    },
                                    100);
                            });

                        $scope.setAccountCodesOnItems = function () {

                            _.each($scope.basketItems,
                                function (basketItem) {

                                    if (basketItem.procurementClientUnitAccountCodeDto) {
                                        basketItem.procurementClientUnitAccountCodeDto = _.findWhere(
                                            $scope.accountCodes,
                                            {
                                                clientProcurementAccountCodeId: basketItem
                                                    .procurementClientUnitAccountCodeDto
                                                    .clientProcurementAccountCodeId
                                            });
                                    }

                                });
                        }

                        $scope.init = function () {
                            $scope.showBasketItems = false;
                            self.ctx = organisationContextService.getContext();
                            userService.hasAnyPermission([
                                'BEAGLE_PROCUREMENT_BASKETS_UPDATE_WITHIN_DEPARTMENT',
                                'BEAGLE_PROCUREMENT_BASKETS_UPDATE_WITHIN_ALL_UNITS'
                            ])
                                .then(function () {
                                    $scope.hasEditBasketPermission = true;
                                });
                            userService.hasPermission('BEAGLE_PROCUREMENT_SHOPPING_LISTS_EDIT')
                                .then(function () {
                                    $scope.hasEditShoppingListPermission = true;
                                });
                            angular.forEach($scope.basketItems,
                                function (bi) {
                                    if (bi.catchWeight != null) bi.catchWeight = parseFloat(bi.catchWeight).toFixed(3);
                                    if (bi.quantity != null) bi.quantity = parseFloat(bi.quantity).toFixed(3);

                                    // Sets the current Qty and CW so that we can use it in updateCatchWeightQuantity and updateCatchWeighttotal without needing to render JSON like before
                                    bi.oldQuantity = bi.quantity;
                                    bi.oldCatchWeight = bi.catchWeight;
                                    bi.oldItemPrice = bi.itemPrice;
                                    bi.calculatedQuantity = $scope.calculateQuantityToOrder(bi);
                                });
                            syncSortOrders(true);
                            $scope.basketItems = _.sortBy($scope.basketItems, 'sortOrder');
                            basketService
                                .setClientSupplierDtoOnItemsFromDto($scope.basketItems,
                                    $scope.availableClientSupplierAccounts,
                                    function () {
                                        $scope.showBasketItems = true;
                                    });
                            $scope.hasDragula = true;
                            setupDragula();
                        }();
                    });
                }
            ];

            return {
                scope: {
                    departments: '=?',
                    accountCodes: '=?',
                    basketItems: '=?',
                    basketId: '=?',
                    basketTotal: '=?',
                    basketWithUnpricedItems: '=?',
                    setPrice: '&',
                    discriminator: '=',
                    currency: '=',
                    errors: '=?',
                    basket: '=?',
                    showReplacements: '=',
                    availableClientSupplierAccounts: '='
                },
                restrict: 'E',
                controller: controller,
                templateUrl: '/ngxbeagle/dist/Content/js/directives/editBasketItems/editBasketItems.html'
            }
        }).filter('clientSupplier', ['_', function (_) {
    return function (options, parameters) {
        return _.where(options, {supplierId: parameters.basketItem.supplierId});
    }
}]);

angular.module(appName)
    .directive('editBasketItemsWithSegments', function () {
        var controller = [
            '$scope',
            '$timeout',
            '$translate',
            '$q',
            '$location',
            'enums',
            'basketService',
			'procurementSegmentsService',
			'orderGuideProcurementSegmentsService',
            'procurementSegmentItemService',
            'productSearchService',
            'dragulaService',
            'organisationContextService',
            'toastr',
            'hrefs',
            function ($scope,
                      $timeout,
                      $translate,
                      $q,
                      $location,
                      enums,
                      basketService,
					  procurementSegmentsService,
					  orderGuideProcurementSegmentsService,
                      procurementSegmentItemService,
                      productSearchService,
                      dragulaService,
                      organisationContextService,
                      toastr,
				hrefs) {
				var getDiscriminator = function () {
					return $scope.parentEntity.discriminator;
				}
				//CSH29082019 We're using different permissions, and hence different endpoints, if the entity is an
				//order guide or a basket
				var getSegmentsService = function () {
					return getDiscriminator() == 'OrderGuide' ? orderGuideProcurementSegmentsService : procurementSegmentsService
				}
                var context = organisationContextService.getContext();
                $scope.enums = enums;
                $scope.hrefs = hrefs;
                $scope.existingSegmentNames = _.pluck($scope.parentEntity.procurementSegments, 'name');
                $scope.addSegment = {
                    _defaultActiveSegment: {
                        id: null,
                        name: '',
                        open: true,
                        baseProcurementBasketId: $scope.parentEntity.id
                    },
                    activeSegment: null,
                    show: false,
                    add: function () {
						var me = this;
						return getSegmentsService().create(this.activeSegment).then(function (newSegment) {
                            $translate('success_segment_created', {name: me.activeSegment.name}).then(function (t) {
                                toastr.success(t);
                            });
                            // Default `open` to true for the + / - on the expandable div.
                            newSegment.open = true;
                            newSegment.procurementSegmentItemDtos = []; // By default this is null, initialise an array.
                            $scope.parentEntity.procurementSegments.push(newSegment);
                            $scope.existingSegmentNames.push(newSegment.name);
                            me.toggle();
                        });
                    },
                    toggle: function () {
                        var me = this;
                        if (me.show) {
                            me.show = false;
                        } else {
                            me.activeSegment = angular.copy(me._defaultActiveSegment);
                            _.each($scope.parentEntity.procurementSegments, function (s) {
                                // Force all segments to be editing false to prevent strange behaviour on Enter key
                                s.editing = false;
                            });
                            me.show = true;
                        }
                    }
                };

                $scope.moveTo = {
                    showDialog: false,
                    row: null,
                    selectedSegmentId: null,
                    selectedSegmentItems: [],
                    addSegmentItem: function (segmentItem) {
                        var moveTo = this;
                        var moveToSegmentDto = {
                            procurementSegmentId: segmentItem.procurementSegmentId,
                            procurementSegmentItemId: segmentItem.procurementSegmentItemId,
                            procurementItemDto: segmentItem.procurementItemDto,
                            sortOrder: segmentItem.sortOrder
                        };
                        _.pushIfNotExists(moveTo.selectedSegmentItems, moveToSegmentDto);
                    },
                    removeSegmentItem: function (segmentItem) {
                        var moveTo = this;
                        _.removeById(moveTo.selectedSegmentItems, segmentItem.procurementSegmentItemId, 'procurementSegmentItemId');
                    },
                    availableSegments: [],
                    toggle: function () {
                        var dlg = this;
                        dlg.showDialog = !dlg.showDialog;
                        if (this.showDialog) {
                            // Showing dialog, setup data
                            dlg.availableSegments = _.map($scope.parentEntity.procurementSegments, function (segment) {
                                return {
                                    id: segment.id,
                                    name: segment.name
                                };
                            });
                            dlg.selectedSegmentId = dlg.selectedSegmentId || dlg.availableSegments[0];
                        } else {
                            this.selectedSegmentItems = [];
                        }
                    },
                    moveSegmentItemsToSelectedSegment: function () {
                        var dlg = this;
                        var distinctOldSegmentIds = _.distinct(dlg.selectedSegmentItems, 'procurementSegmentId');
                        var sortedItems = _.sortBy(dlg.selectedSegmentItems, 'sortOrder');
                        var itemIds = _.pluck(sortedItems, 'procurementSegmentItemId');
                        var mappedSegmentItemsForMove = _.map(sortedItems, function(segmentItem) {
                            return {
                                procurementSegmentItemId: segmentItem.procurementSegmentItemId,
                                isBestPrice: segmentItem.procurementItemDto.isBestPrice,
                                isMapped: segmentItem.procurementItemDto.isMapped
                            }
                        });
                        return procurementSegmentItemService.moveSegmentItemsToSelectedSegment(dlg.selectedSegmentId, mappedSegmentItemsForMove, $scope.parentEntity.id, dlg.row).then(function (newSegmentItems) {

                            var segmentsHavingItemsRemoved = _.filter($scope.parentEntity.procurementSegments, function (segment) {
                                return _.contains(distinctOldSegmentIds, segment.id);
                            });
                            _.each(segmentsHavingItemsRemoved, function (segment) {
                                _.removeAllContaining(segment.procurementSegmentItemDtos, itemIds, 'procurementSegmentItemId');
                                setSegmentItemSortOrders(segment);
                            });

                            var segmentItemsMovingTo = _.findById($scope.parentEntity.procurementSegments, dlg.selectedSegmentId);
                            _.each(newSegmentItems, function (newSegmentItem) {
                                if (dlg.row != null && dlg.row >= 0) {
                                    /**
                                     * The user has specified a specific row. Insert our items at this index.
                                     * We do `dlg.row` because users won't be thinking in 0-indexing, they'll be starting at 1.
                                     */
                                    var index = dlg.row - 1;
                                    setAccountcodeDtoOnSegmentItem(newSegmentItem);
                                    segmentItemsMovingTo.procurementSegmentItemDtos.splice(index, 0, newSegmentItem);
                                    index++;
                                } else {
                                    setAccountcodeDtoOnSegmentItem(newSegmentItem);
                                    // dlg.row is NULL or <= 0 to so we should just append all of the items to the end of the new segment
                                    _.pushIfNotExists(segmentItemsMovingTo.procurementSegmentItemDtos, newSegmentItem);
                                }
                            });
                            setSegmentItemSortOrders(segmentItemsMovingTo);
                            dlg.toggle();
                        });
                    }
                };

                $scope.replaceDialog = {
                    _previousSegmentItemId: null,
                    _$index: 0,
                    _itemElementId: '',
                    currentSegmentItem: null,
                    show: false,
                    alternativeProducts: [],
                    loading: false,
                    getAlternativeProducts: function () {
                        var dlg = this;
                        if (dlg.currentSegmentItem.procurementSegmentItemId != dlg._previousSegmentItemId) {
                            dlg.loading = true;
                            var model = {
                                basketId: $scope.parentEntity.id,
                                clientId: context.currentSubscriptionUnit.client.id,
                                searchTypeEnum: enums.productSearchTypes.bestPrice,
                                skuId: dlg.currentSegmentItem.procurementItemDto.skuId,
                                productId: dlg.currentSegmentItem.procurementItemDto.productId,
                                organisationId: context.currentSubscriptionUnit.organisation.id,
                                term: ''
                            };
                            return productSearchService.getAdditionalProducts(model).$promise.then(
                                function (resp) {
                                    if (resp.length) {
                                        _.each(resp, function (data) {
                                            setIsBestPrice(data.results);
                                        });
                                    }

                                    dlg.alternativeProducts = resp;
                                    dlg._previousSegmentItemId = dlg.currentSegmentItem.procurementSegmentItemId;
                                }).finally(function () {
                                dlg.loading = false;
                            });
                        } else {
                            // OnShow requires a promise on the dialog. Just return a self-resolving promise
                            var d = $q.defer();
                            d.resolve();
                            return d.promise;
                        }
                    },
                    updateSegmentItemsAfterReplace: function (dlg, replacementProduct) {
                        var segment = _.findById($scope.parentEntity.procurementSegments, dlg.currentSegmentItem.procurementSegmentId);
                        setAccountcodeDtoOnSegmentItem(replacementProduct);
                        segment.procurementSegmentItemDtos.splice(dlg._$index, 1, replacementProduct);
                        dlg.toggle();

                        $translate('basket_item_replaced_successfully').then(function (t) {
                            toastr.success(t);
                        });
                        $scope.replacingProduct = false;
                    }, replaceProduct: function (alternative) {
                        var dlg = this;
                        // This is used in updateSegmentItem as when we set the CSA on the product, the ng-change will kick in from the template. This lets us exclude this change in the updateSegmentItem method
                        $scope.replacingProduct = true;
                        return $scope.replaceBasketItem({currentBasketItem: dlg.currentSegmentItem, alternativeProduct: alternative, availableClientSupplierAccounts: $scope.availableClientSupplierAccounts}).then(
                            function (replacementProduct) {
                                replacementProduct.procurementItemDto.isMapped = true;

                                if (!replacementProduct.procurementItemDto.clientSupplierAccountDto ||
                                    !_.findWhere($scope.availableClientSupplierAccounts, {id: replacementProduct.procurementItemDto.clientSupplierAccountDto.id})) {
                                    return basketService.getAvailableClientSupplierAccounts($scope.parentEntity.id).$promise.then(function (data) {
                                        $scope.availableClientSupplierAccounts = data;
                                        basketService.setClientSupplierDtoOnIndividualProduct(replacementProduct,
                                            $scope.availableClientSupplierAccounts);
                                        dlg.updateSegmentItemsAfterReplace(dlg, replacementProduct);
                                    });
                                } else {
                                    dlg.updateSegmentItemsAfterReplace(dlg, replacementProduct);
                                }
                            });
                    },
                    showConfirmation: function (alternativeProduct) {
                        alternativeProduct.showConfirmation = !alternativeProduct.showConfirmation;
                    },
                    toggle: function (segmentItem, $index, fromTemplate) {
                        if (segmentItem &&
                            segmentItem.procurementItemDto &&
                            segmentItem.procurementItemDto.savedSearchId !== null &&
                            segmentItem.procurementItemDto.savedSearchType !== enums.savedSearchTypes.skuSearchExactSku) {
                          $location.path('/advanced-search/' + segmentItem.procurementBasketId + '/edit/' + segmentItem.procurementItemDto.id + '/' + segmentItem.procurementSegmentId);
                          return;
                        }
                        var dlg = this;
                        dlg.currentSegmentItem = segmentItem;
                        if (fromTemplate) {
                            dlg._$index = $index;
                            dlg._offset = window.scrollY;
                        }
                        dlg.show = !dlg.show;
                    }
				};

                $scope.selectAllSegmentItemsForMove = function (segment) {
                    _.each(segment.procurementSegmentItemDtos, function (segmentItem) {
                        if (segmentItem.selectedForMove != segment.selectAll) {
                            $scope.selectSegmentItemForMove(segmentItem, segment.selectAll);
                        }
                    });
                };

                $scope.selectSegmentItemForMove = function (segmentItem, forcedValue) {
                    // Sets the selectedForMove on the item to be the forcedValue if it exists, otherwise it will toggle it.
                    segmentItem.selectedForMove = forcedValue ? forcedValue : !segmentItem.selectedForMove;
                    if (segmentItem.selectedForMove) {
                        $scope.moveTo.addSegmentItem(segmentItem);
                    } else {
                        $scope.moveTo.removeSegmentItem(segmentItem);
                    }
                };

                $scope.calculateItemPrice = function (procurementItem) {
                    var qty = $scope.calculateQuantityToOrder(procurementItem);


                    return qty > 0 ?
                        qty * procurementItem.itemPrice :
                        procurementItem.itemPrice;
                };

                $scope.calculateQuantityToOrder = function (procurementItem) {
                    var cw = procurementItem.catchWeight || 0;
                    var qty = procurementItem.quantity || 0;
                    if (qty > 0) {
                        if (cw > 0) {
                            return qty * cw;
                        }

                        return qty;
                    }
                };

                $scope.toggleEditSegment = function (segment) {
                    segment.editing = !segment.editing;
                    segment.oldName = segment.name;
                };

                $scope.cancelEditSegment = function (segment) {
                    segment.name = segment.oldName;
                    $scope.toggleEditSegment(segment);
                };

                $scope.deleteSegment = function (segment) {
					return getSegmentsService().deleteSegment(segment.id).then(function () {
                        _.removeIfExists($scope.parentEntity.procurementSegments, segment);
                        _.removeIfExists($scope.existingSegmentNames, segment.name);
                    });
                };

                $scope.deleteMultipleSegmentItems = function () {
                    //CSH 23072019 Cloning here in case the selected items are changed in between
                    //call to the server and response:
                    var clonedItems = angular.copy($scope.moveTo.selectedSegmentItems);
                    var itemIds = _.pluck($scope.moveTo.selectedSegmentItems, 'procurementSegmentItemId');
                    return procurementSegmentItemService.removeSegmentItemsFromSegment(itemIds).then(function () {
                        _.each(clonedItems, function (x) {
                            var segment = _.find($scope.parentEntity.procurementSegments, {id: x.procurementSegmentId});
                            var segmentItem = _.find(segment.procurementSegmentItemDtos, {procurementSegmentItemId: x.procurementSegmentItemId});
                            _.removeIfExists(segment.procurementSegmentItemDtos, segmentItem);
                            $scope.moveTo.selectedSegmentItems = [];
                        });
                        $scope.parentEntity.basketCount -= clonedItems.length;
                        $translate('success_segment_item_deleted').then(function (t) {
                                toastr.success(t);
                            },
                            //CSH 23072019 added function here to show result even if translation doesn't exist:
                            function (t) {
                                toastr.success(t);
                            });
                    });
                }

                $scope.removeSegmentItemsFromSegment = function (segment, segmentItem) {
                    return procurementSegmentItemService.removeSegmentItemsFromSegment([segmentItem.procurementSegmentItemId]).then(function () {
                        _.removeIfExists(segment.procurementSegmentItemDtos, segmentItem);
                        $scope.parentEntity.basketCount -= 1;
                        setSegmentItemSortOrders(segment);
                        $translate('success_segment_item_deleted').then(function (t) {
                            toastr.success(t);
                        });
                    });
                };

                $scope.saveSegment = function (segment) {
					return getSegmentsService().update(segment).then(function (updatedSegment) {
                        _.removeIfExists($scope.existingSegmentNames, segment.oldName);
                        _.pushIfNotExists($scope.existingSegmentNames, updatedSegment.name);
                        segment.editing = false;
                    });
                };

                $scope.toggleSegment = function (segment) {
                    segment.editing = !segment.editing;
                };

                $scope.getNoSegmentsTranslationKey = function () {
                    switch ($scope.parentEntity.discriminator) {
                        case enums.procurementBasketType.ShoppingList:
                            return 'shopping_list_has_no_segments';
                        case enums.procurementBasketType.OrderGuide:
                            return 'order_guide_has_no_segments';
                    }
                };

                $scope.matchesDiscriminator = function (discriminator) {
                    return $scope.parentEntity.discriminator === discriminator;
                };

                $scope.updateSegmentItem = function (segmentItem, oldAccountNumberId) {
                    // We can't use === due to oldProcurementSegmentItemId being a string.
                    // This is to prevent updating all existing basket items when we replace a product
                    if (segmentItem.procurementItemDto.clientSupplierAccountDto.id != oldAccountNumberId) {
                        segmentItem.saving = true;
                        // Makes the ternary below easier to read
                        var procurementClientUnitAccountCodeDto = segmentItem.procurementItemDto.procurementClientUnitAccountCodeDto;
                        var updateBasketItemRequestDto = {
                            id: segmentItem.procurementItemDto.id,
                            quantity: null,
                            catchWeight: segmentItem.procurementItemDto.catchWeight,
                            clientSupplierAccountId:
                                segmentItem.procurementItemDto.clientSupplierAccountDto
                                    ? segmentItem.procurementItemDto.clientSupplierAccountDto.id
                                    : null,
                            procurementBasketId: segmentItem.procurementItemDto.procurementBasketId,
                            procurementClientUnitAccountCodeId: procurementClientUnitAccountCodeDto ? procurementClientUnitAccountCodeDto.id : null
                        };
                        var promise = getDiscriminator() == 'OrderGuide' ? basketService.updateOrderGuideBasketItem(updateBasketItemRequestDto) : basketService.updateBasketItem(updateBasketItemRequestDto);
                        promise.then(function (data) {
                            $translate('basket_item_updated').then(function (t) {
                                toastr.success(t);
                            });
                            segmentItem.procurementItemDto.itemPrice = data.pricePerItem;
                        }).finally(function () {
                            segmentItem.saving = false;
                        });
                    }
                };

                var setupItemDragula = function () {
                    dragulaService.options($scope,
                        'item-dragula-bag',
                        {
                            moves: function (element, container, handle) {
                                return handle.className.indexOf('item-handle') > -1;
                            },
                            revertOnSpill: true
                        });
                };

                var setupDragula = function () {
                    dragulaService.options($scope,
                        'dragula-bag',
                        {
                            moves: function (element, container, handle) {
                                return handle.className.indexOf('dragula-handle') > -1;
                            },
                            revertOnSpill: true
                        });
                    setupItemDragula();
                };

				var setSegmentSortOrders = function () {
					console.log('$scope.parentEntity', $scope.parentEntity);
                    var segmentIds = _.pluck($scope.parentEntity.procurementSegments, 'id');
                    var request = {
                        baseProcurementBasketId: $scope.parentEntity.id,
                        ProcurementSegmentIds: segmentIds,
                        procurementBasketId: $scope.parentEntity.id
                    };
                    $scope.updatingSortOrder = true;
					getSegmentsService().updateSegmentSortOrders(request).then(function (data) {

                    }).finally(function () {
                        $scope.updatingSortOrder = false;
                    });
                };

                var setSegmentItemSortOrders = function (segment) {
                    $scope.updatingSortOrder = true;
                    var segmentItemIds = _.pluck(segment.procurementSegmentItemDtos, 'procurementSegmentItemId')
                    var dto = {
                        procurementSegmentId: segment.id,
                        procurementSegmentItemIds: segmentItemIds,
                        procurementBasketId: $scope.parentEntity.id
                    };
                    return procurementSegmentItemService.setSegmentItemSortOrders(dto).then(function () {
                    }).finally(function() {
                        $timeout(function () {
                            segment.hasItemDragula = true;
                            $scope.updatingSortOrder = false;
                        });
                    });
                };

                var setIsBestPrice = function (results) {
                    _.each(results,
                        function (alternative) {
                            alternative.isBestPrice = productSearchService.isBestPrice(alternative, true);
                        });
                };

                $scope.$on('dragula-bag.drop-model',
                    function (evt, target, source) {
                        $timeout(function () {
                            setSegmentSortOrders();
                        });
                    });

                var itemDragulaCallback = function (evt, movedItem, targetContainer) {
                    $timeout(function () {
                        $scope.updatingSortOrder = true;
                        var movedItemIdProps = movedItem[0].id.split('-');
                        var targetContainerIdProps = targetContainer[0].id.split('-');

                        // Find the original and new segment(s)
                        var originalSegment = _.find($scope.parentEntity.procurementSegments, function (segment) {
                            return segment.id == movedItemIdProps[1];
                        });

                        var newSegment = _.find($scope.parentEntity.procurementSegments, function (segment) {
                            return segment.id == targetContainerIdProps[2];
                        });

                        // We are not moving between segments, we can just update the sortOrders for the current segment
                        if (newSegment.id === originalSegment.id) {
                            setSegmentItemSortOrders(originalSegment);
                        } else {
                            procurementSegmentItemService.removeSegmentItemsFromSegment([movedItemIdProps[3]]).then(function () {
                                // We are not moving between segments, we can just update the sortOrders for the current segment
                                // We are moving an item to another segment - we must recalculate the sort orders for both segments
                                var movedItemInSegment = _.find(newSegment.procurementSegmentItemDtos, function (item) {
                                    // DO NOT MAKE THIS ===! `movedItemIdProps` is a string array and === will fail on the type comparison between int and string!
                                    if (item.procurementSegmentItemId == movedItemIdProps[3]) {
                                        item.procurementSegmentId = newSegment.id;
                                        return item;
                                    }
                                });
                                movedItemInSegment.procurementBasketTypeEnum = enums.procurementBasketType[$scope.parentEntity.discriminator];
                                var requestDto = procurementSegmentItemService.createSegmentItemRequestDto(movedItemInSegment, $scope.parentEntity.id);
                                // SortOrder is the index in the array + 1 (due to array 0-indexing we need to +1)
                                requestDto.sortOrder = _.indexOf(newSegment.procurementSegmentItemDtos, movedItemInSegment) + 1;
                                procurementSegmentItemService.addProductToSegment(requestDto).then(function (resolved) {
                                    // We moved between two segments, sync the sort orders for both;
                                    _.find(newSegment.procurementSegmentItemDtos, function (item) {
                                        if (item.procurementSegmentItemId == movedItemInSegment.procurementSegmentItemId) {
                                            item.procurementSegmentItemId = resolved.id;
                                        }
                                    });
                                    var segmentOrderPromises = [
                                        setSegmentItemSortOrders(newSegment),
                                        setSegmentItemSortOrders(originalSegment)
                                    ];
                                    $q.all(segmentOrderPromises).then(function () {
                                        $scope.updatingSortOrder = false;
                                    })
                                });
                            });
                        }
                    });
                };
                $scope.$on('item-dragula-bag.drop-model', itemDragulaCallback);

                function setAccountcodeDtoOnSegmentItem(segmentItem) {
                    if ($scope.availableAccountCodes) {
                        segmentItem.procurementItemDto.procurementClientUnitAccountCodeDto = _.findWhere($scope.availableAccountCodes, {id: segmentItem.procurementItemDto.procurementClientUnitAccountCodeDto.id});
                    }
                }

                $scope.init = function () {
                    $scope.loadingClientSupplierAccounts = true;
                    basketService.getAvailableClientSupplierAccounts($scope.parentEntity.id).$promise.then(function (data) {
                        $scope.availableClientSupplierAccounts = data;
                        var segmentItems = _.chain($scope.parentEntity.procurementSegments)
                            .pluck('procurementSegmentItemDtos')
                            .flatten()
                            .value();
                        var procurementItems = [];
                        _.each(segmentItems, function (segmentItem) {
                            procurementItems.push(segmentItem.procurementItemDto);
                        });
                        basketService
                            .setClientSupplierDtoOnItemsFromDto(procurementItems,
                                $scope.availableClientSupplierAccounts, function () {
                                    $scope.loadingClientSupplierAccounts = false;
                                });
                    });
                    $scope.parentEntity.basketCount = 0;
                    // This is a necessary evil to make sure that the `open` property is set on the segments.
                    // It also allows us to count the basketItems at the same time.
                    _.each($scope.parentEntity.procurementSegments, function (segment) {
                        segment.open = true;
                        $scope.parentEntity.basketCount += segment.procurementSegmentItemDtos.length;
                        segment.hasItemDragula = true;

                        if ($scope.availableAccountCodes) {
                            _.each(segment.procurementSegmentItemDtos, function (segmentItem) {
                                if (segmentItem.procurementItemDto.procurementClientUnitAccountCodeDto) {
                                    // This may be null if it's a shopping list created from OrderGuides
                                    setAccountcodeDtoOnSegmentItem(segmentItem);
                                }
                            })
                        }
                    });
                    setupDragula();
                }();
            }
        ];
        return {
            restrict: 'E',
            scope: {
                parentEntity: '=',
                replaceBasketItem: '&',
                availableAccountCodes: '=?',
                searchText: '=?'
            },
            templateUrl: '/ngxbeagle/dist/Content/js/directives/editBasketItemsWithSegments/editBasketItemsWithSegments.html',
            controller: controller
        }
    });

angular.module(appName)
    .directive('cdbIcon', function () {
        var controller = [
            '$scope', '$element', '$timeout', '$attrs',
            function ($scope, $element, $timeout, $attrs) {
                $timeout(function () {
                    var template = '<i class="fa margin-right-5 ' + $attrs.cdbIcon + '"></i> ';

                    var buttonHtml = $element.html();
                    buttonHtml = template + buttonHtml;
                    $element.html(buttonHtml);

                    // Remove the attribute to prevent endless loop cycles
                    $element.removeAttr('cdb-icon');
                });

            }
        ];

        return {
            restrict: 'A',
            controller: controller
        };
    });
angular.module(appName).directive('invoicingNavigationTimeline', function () {
    var controller = [
        '$scope', '$location', '$q', '$element', '$attrs', '$http', 'enums', '_', 'translateMessage',
        'organisationContextService', '$route',
        function ($scope, $location, $q, $element, $attrs, $http, enums, _, translateMessage,
            organisationContextService, $route
        ) {
                var icons = {
                    success: 'fa-check success',
                    inProgress: 'fa-clock-o warning',
                    incomplete: 'fa-close danger',
                    loading: 'fa-spinner'
                };
                var ctx = organisationContextService.getContext();
                $scope.points = {
                    creditNoteView: 'creditNoteView',
                    creditReconciliation: 'creditReconciliation',
                    creditRequest: 'creditRequestView',
                    invoiceReconciliation: 'invoiceReconciliation',
                    invoiceView: 'invoiceView'
                };

                var url = '/api/ProcurementInvoicing/GetNavigation';
                var postNavigationDto = {};
                switch ($scope.current) {
                    case 'creditReconciliation':
                    case 'creditNoteView':
                        postNavigationDto.creditNoteId = $scope.invoiceHeaderId;
                        break;
                    case 'creditRequestView':
                        postNavigationDto.creditRequestId = $scope.invoiceHeaderId;
                        break;
                    case 'invoiceReconciliation':
                    case 'invoiceView':
                        postNavigationDto.invoiceId = $scope.invoiceHeaderId;
                        break;
                    default:
                        break;
                }

                $scope.getNgHref = function(navItem, itemType) {
                    if (itemType == 'creditNote') {
                        return $scope.current == $scope.points.creditReconciliation
                            ? '/ViewUnitInvoice/' + ctx.currentSubscriptionUnit.id + '/' + navItem.id
                            : '/CreditNote/Reconcile/' + navItem.id;
                    } else if (itemType == 'invoice') {
                        return $scope.current == $scope.points.invoiceReconciliation
                            ? '/ViewUnitInvoice/' + ctx.currentSubscriptionUnit.id + '/' + navItem.id
                            : '/Invoices/Reconcile/' + navItem.id;
                    }
                }

                // Using $http for development speed to get a working PoC going
                $http.post(url, postNavigationDto).then(function (navData) {
                    // Set data on the scope
                    $scope.timeline = navData.data;
                });

                $scope.getHeight = function (list, isOpen) {
                    if (list != null) {
                        return { 'max-height': list.length > 0 && isOpen ? list.length * 28 : 0 + 'px' };
                    }
                }

                $scope.isActive = function (point) {
                    if (point == $scope.current) return 'active';
                };

                $scope.toggleInvoices = function (isClickOutside) {
                    // using isClickOutside because we only want to hide the invoices if we click outside as the element is in the dom, it will always fire.
                    if (isClickOutside) $scope.showInvoices = false;
                    // Otherwise toggle it as normal
                    else $scope.showInvoices = !$scope.showInvoices;

                    $scope.showCreditRequests = false;
                    $scope.showCreditNotes = false;
                }

                $scope.toggleCreditRequests = function (isClickOutside) {
                    // using isClickOutside because we only want to hide the invoices if we click outside as the element is in the dom, it will always fire.
                    if (isClickOutside) $scope.showCreditRequests = false;
                    // Otherwise toggle it as normal
                    else $scope.showCreditRequests = !$scope.showCreditRequests;

                    $scope.showCreditNotes = false;
                    $scope.showInvoices = false;
                }

                $scope.toggleCreditNotes = function (isClickOutside) {
                    // using isClickOutside because we only want to hide the invoices if we click outside as the element is in the dom, it will always fire.
                    if (isClickOutside) $scope.showCreditNotes = false;
                    // Otherwise toggle it as normal
                    else $scope.showCreditNotes = !$scope.showCreditNotes;

                    $scope.showCreditRequests = false;
                    $scope.showInvoices = false;
                }

                // MB: Done as UnitInvoice for now - work on groups after
                $scope.navigate = function (point) {
                    switch (point) {
                        case $scope.points.creditNote:
                            $location.path('/ViewUnitInvoice/' + ctx.id + '/' + $scope.timeline.creditNote.id);
                            break;
                        case $scope.points.creditRequest:
                            $location.path('/CreditRequest/' + $scope.timeline.creditRequest.id);
                            break;
                        case $scope.points.invoicing:
                            translateMessage.error('tbi');
                            break;
                        default:
                            if (point.invoiceNumber) {
                                // It's an invoice, go to the invoice page.
                                // TODO: This needs to go to the NEW INVOICING PAGE!!!!!!
                                $location.path('/ViewUnitInvoice/' + ctx.id + '/' + point.id);
                            }
                            break;
                    }
                }

                $scope.getClass = function(entity) {
                    if (entity) {
                        if (entity.status.id == enums.invoiceStatus.AwaitingCredit ||
                            entity.status.id == enums.invoiceStatus.AwaitingAcceptance ||
                            entity.status.id == enums.invoiceStatus.PartReconciled ||
                            entity.status.id == enums.creditRequestStatus.submitted ||
                            entity.status.id == enums.creditRequestStatus.transmitted ||
                            entity.status.id == enums.creditRequestStatus.partFulfilled) {
                            return icons.inProgress;
                        } else if (entity.status.id == enums.invoiceStatus.Reconciled ||
                            entity.status.id == enums.invoiceStatus.Accepted ||
                            entity.status.id == enums.creditRequestStatus.completed ||
                            entity.status.id == enums.invoiceStatus.Exported ||
                            entity.status.id == enums.creditRequestStatus.fulfilled) {
                            return icons.success;
                        } else {
                            return icons.incomplete;
                        }
                    } else {
                        return icons.loading;
                    }
                }

                $scope.getClassForList = function (list) {
                    if (list != null) {
                        if (list.length == 0) {
                            return icons.incomplete;
                        }
                        else if (_.find(list, function (listItem) {
                            return listItem.status.id == enums.invoiceStatus.AwaitingCredit ||
                                listItem.status.id == enums.invoiceStatus.AwaitingAcceptance ||
                                listItem.status.id == enums.invoiceStatus.PartReconciled ||
                                listItem.status.id == enums.creditRequestStatus.submitted ||
                                listItem.status.id == enums.creditRequestStatus.transmitted ||
                                listItem.status.id == enums.creditRequestStatus.partFulfilled })) {
                            return icons.inProgress;
                        } else if (_.every(list,
                            function(listItem) {
                                return listItem.status.id == enums.invoiceStatus.Reconciled ||
                                    listItem.status.id == enums.invoiceStatus.Accepted ||
                                    listItem.status.id == enums.creditRequestStatus.completed ||
                                    listItem.status.id == enums.invoiceStatus.Exported ||
                                    listItem.status.id == enums.creditRequestStatus.fulfilled;
                            })) {
                            return icons.success;
                        } else {
                            return icons.incomplete;
                        }
                    } else {
                        return icons.loading;
                    }
                };

                $scope.isCurrentInvoice = function (invoice) {
                    if ($route.current.params.invoiceHeaderId && $route.current.params.invoiceHeaderId == invoice.id)
                        return 'bold';
                }
            }
        ];

        return {
            restrict: 'AE',
            templateUrl: '/ngxbeagle/dist/Content/js/directives/invoicingNavigationTimeline/invoicingNavigationTimeline.html',
            scope: {
                current: '@',
                invoiceHeaderId: '='
            },
            transclude: true,
            controller: controller
        }

    });

/*

    MB: Leave the commented code in!! It's a work in progress that may improve the look and feel of the UI. Parked for time.

*/
angular.module(appName)
   .directive('load', function () {
       var controller = [
           '$scope', '$q', '$element', '$attrs',
           function ($scope, $q, $element, $attrs) {
               $scope.isLoading = true;
               //var msg = $scope.message ? $scope.message : 'Please wait...';
               //if ($attrs.placeholder)
               //    var placeholderBackup = $attrs.placeholder;
               //debugger;
               //switch($element[0].nodeName) {
               //    case 'SELECT':
               //        var o = document.createElement('option');
               //        o.appendChild(document.createTextNode(msg));
               //        o.id = 'LoadingOption';
               //        o.value = '';
               //        $element[0].appendChild(o);
               //        $element[0].disabled = true;
               //        break;
               //    case 'INPUT':
               //        $element[0].disabled = true;
               //        $element[0].placeholder = msg;
               //}
               if ($scope.waitFor) {
                   $q.all($scope.waitFor)
                       .then(function() {
                           $scope.isLoading = false;

                           //switch($element[0].nodeName) {
                           //    case 'SELECT':
                           //        $('#LoadingOption').remove();
                           //        break;
                           //    case 'INPUT':
                           //        $element[0].placeholder = placeholderBackup ? placeholderBackup : '';
                           //        break;
                           //};

                           //if ($element[0])
                           //    $element[0].disabled = false;
                       });
               } else if ($scope.watch) {
                   var watcher = $scope.$watch('watch',
                       function(oldVal, newVal) {
                           if (newVal == true) {
                               $scope.isLoading = false;
                               watcher();
                           }
                       });
               } else {
                   $scope.isLoading = false;
               }
           }
       ];

       return {
           restrict: 'AE',
           templateUrl: '/ngxbeagle/dist/Content/js/directives/load/load.html',
           scope: {
               watch: '=?',
               waitFor: '=?',
               message: '@?'
           },
           transclude: true,
           controller: controller
       }

   });

angular.module(appName)
	.directive('measureSelect', ['measuresService', function (measuresService) {

		return {
			restrict:'E',
			require: 'ngModel',
			scope: {
				ngModel: "=",
				ngDisabled: "=",
				ngChange: "&"
			},
			template: '<select class="inline-auto" ng-disabled="ngDisabled" ng-change="updateModel()" ng-options="measure.id as measure.description for measure in measures" ng-model="ngModel"></select>',
			link: function ($scope, x, $attr) {
                var useRecipeDescriptions = $attr.hasOwnProperty('recipeDescriptions');
                console.log("useRecipeDescriptions", useRecipeDescriptions);

                if (useRecipeDescriptions) {
                    measuresService.getforWIMD().then(function (result) {
                        $scope.measures = result.data;
                    });
                } else {
                    measuresService.get().then(function (result) {
                        $scope.measures = result.data;
                    });
                }
			
				$scope.updateModel = function () {
					_.defer($scope.ngChange);
				}
			}
		};
	}]);
angular.module(appName).directive('navigationTimeline', function () {
    var controller = [
        '$scope', '$location', '$q', '$element', '$attrs', '$http', 'enums', '_', 'translateMessage',
        'organisationContextService', '$route',
        function ($scope, $location, $q, $element, $attrs, $http, enums, _, translateMessage,
        organisationContextService, $route) {

               var icons = {
                   success: 'fa-check success',
                   inProgress: 'fa-clock-o warning',
                   incomplete: 'fa-close danger',
                   loading: 'fa-spinner fa-spin'
               };
               $scope.points = {
                   purchaseOrder: 'purchaseOrder',
                   receiving: 'receiving',
                   invoicing: 'invoicing'
               };
               // Using $http for development speed to get a working PoC going
               $http.get('/api/purchaseorder/GetNavigationData?purchaseOrderId=' + $scope.purchaseOrderId).then(function (navData) {
                   // Set data on the scope
                   $scope.timeline = navData.data;
               });

               $scope.getHeight = function (list, isOpen) {
                   if (list != null) {
                       return { 'max-height': list.length > 0 && isOpen ? list.length * 28 : 0 + 'px' };
                   }
               }

               $scope.isActive = function(point) {
                   if (point == $scope.current) return 'active';
               };

               $scope.toggleInvoices = function (isClickOutside) {
                   // using isClickOutside because we only want to hide the invoices if we click outside as the element is in the dom, it will always fire.
                   if (isClickOutside) $scope.showInvoices = false;
                       // Otherwise toggle it as normal
                   else $scope.showInvoices = !$scope.showInvoices;
               }

               $scope.navigate = function (point) {
                   switch (point) {
                       case $scope.points.purchaseOrder:
                           $location.path('/PurchaseOrder/' + $scope.timeline.purchaseOrder.id);
                           break;
                       case $scope.points.receiving:
                           $location.path('/PurchaseOrder/Receive/' + $scope.timeline.receivingPurchaseOrder.id);
                           break;
                       case $scope.points.invoicing:
                           translateMessage.error('tbi');
                           break;
                       default:
                           if (point.invoiceNumber) {
                               // It's an invoice, go to the invoice page.
                               // TODO: This needs to go to the NEW INVOICING PAGE!!!!!!
                               var ctx = organisationContextService.getContext();
                               $location.path('/ViewUnitInvoice/' + ctx.id + '/' + point.id);
                           }
                           break;
                   }
               }

               $scope.getClassForPurchaseOrder = function () {
                   if ($scope.timeline) {
                       if ($scope.timeline.purchaseOrder.status.id < enums.purchaseOrderStatus.approved) {
                           return icons.incomplete;
                       } else if ($scope.timeline.purchaseOrder.status.id == enums.purchaseOrderStatus.approved || $scope.timeline.purchaseOrder.status.id == enums.purchaseOrderStatus.submitted) {
                           return icons.inProgress;
                       } else if ($scope.timeline.purchaseOrder.status.id > enums.purchaseOrderStatus.submitted) {
                           return icons.success;
                       }
                   } else {
                       return icons.loading;
                   }
               };

               $scope.getClassForInvoicing = function () {
                   if ($scope.timeline) {
                       if (!$scope.timeline.invoices.length) {
                           return icons.incomplete;
                       } else if (_.find($scope.timeline.invoices, function (inv) { return inv.status.id < enums.invoiceStatus.Accepted })) {
                           return icons.inProgress;
                       } else if (_.every($scope.timeline.invoices, function (inv) { return inv.status.id == enums.invoiceStatus.Accepted || inv.status.id == enums.invoiceStatus.Exported })) {
                           return icons.success;
                       }
                   } else {
                       return icons.loading;
                   }
               };

               $scope.getClassForReceiving = function () {
                   if ($scope.timeline) {
                       if ($scope.timeline.receivingPurchaseOrder.status.id == enums.purchaseOrderStatus.received || $scope.timeline.receivingPurchaseOrder.status.id == enums.purchaseOrderStatus.completed) {
                           return icons.success;
                       } else if ($scope.timeline.receivingPurchaseOrder.status.id ==
                           enums.purchaseOrderStatus.partReceived) {
                           return icons.inProgress;
                       } else {
                           return icons.incomplete;
                       }
                   } else {
                       return icons.loading;
                   }
               };

               $scope.getClassForInvoice = function (invoice) {
                   if (invoice.status.id == enums.invoiceStatus.Accepted ||
                       invoice.status.id == enums.invoiceStatus.Exported) {
                       return icons.success;
                   } else if (invoice.status.id == enums.invoiceStatus.Rejected) {
                       return icons.incomplete;
                   } else if (invoice.status.id < enums.invoiceStatus.Accepted) {
                       return icons.inProgress;
                   }
               }

               $scope.isCurrentInvoice = function (invoice) {
                   if ($route.current.params.invoiceHeaderId && $route.current.params.invoiceHeaderId == invoice.id)
                       return 'bold';
               }
        }
    ];

    return {
        restrict: 'AE',
        templateUrl: '/ngxbeagle/dist/Content/js/directives/navigationTimeline/navigationTimeline.html',
        scope: {
            current: '@',
            purchaseOrderId: '='
        },
        transclude: true,
        controller: controller
    }
});

angular.module('beagle')
    .directive('ngForm', function() {
        var controller = [
            '$scope', '$element', '$attrs',
            function ($scope, $element, $attrs) {
            }
        ];

        return {
            scope: true,
            require: 'ngForm',
            controller: controller
        }
    })
angular.module(appName)
    .directive('nutrientsComponent', function () {
            var controller = [
                '$scope',
                '$rootScope',
                '$q',
                'enums',
                '_',
                'ngDialog',
                'nutrientAttributeHelper',
                'nutrientAttributeService',
                'procurementSkuAttributeService',
                'procurementRecipeAttributeService',
                function (
                    $scope,
                    $rootScope,
                    $q,
                    enums,
                    _,
                    ngDialog,
                    nutrientAttributeHelper,
                    nutrientAttributeService,
                    procurementSkuAttributeService,
                    procurementRecipeAttributeService
                ) {
                    var allowedNutrientAttributes = [];
                    var defaultAttributes = [];

                    function isEachMeasure(measureId) {
                        return measureId === enums.measureIds.each || measureId === enums.measureIds.doz;
                    }

                    function buildAttributeLists() {
                        if ($scope.type === 'sku') {
                            allowedNutrientAttributes = [
                                enums.procurementSkuAttributes.energy_kcal_per_100g
                            ];
                            defaultAttributes = nutrientAttributeService.getDefaultAttributes('sku')

                            if (isEachMeasure($scope.measureId)) {
                                allowedNutrientAttributes.push(enums.procurementSkuAttributes.avg_Wt);
                                defaultAttributes.push(nutrientAttributeService.buildAttributeFormObject(enums.procurementSkuAttributes.avg_Wt, 2));
                            }
                        } else if ($scope.type === 'recipe') {
                            allowedNutrientAttributes = [
                                enums.procurementSkuAttributes.kCal_per_portion
                            ]
                            defaultAttributes = nutrientAttributeService.getDefaultAttributes('recipe')
                        }
                    }

                    function isAllowedAttribute (attributeId) {
                        return _(allowedNutrientAttributes).contains(attributeId)
                    }

                    function mapData (data) {
                        var mappedData = {}
                        _(defaultAttributes).each(function (nutrientAttribute) {
                            var currentId = nutrientAttribute.procurementSkuAttribute.id;
                            if (!isAllowedAttribute(currentId)) return;
                            var mappedAttribute = angular.copy(nutrientAttribute);
                            var attributeWithValue = _(data).find(function (attribute) { return attribute.procurementSkuAttribute.id === currentId }) || {}
                            mappedAttribute.value = attributeWithValue.value;
                            mappedData[currentId] = mappedAttribute;
                        })
                        return mappedData;
                    }

                    function getData () {
                        if ($scope.type === 'sku') return procurementSkuAttributeService.get($scope.entityId)
                        if ($scope.type === 'recipe') return procurementRecipeAttributeService.get($scope.entityId);
                    }

                    function updateOutboundWarning() {
                        if ($scope.type === 'sku' &&
                            isEachMeasure($scope.measureId) &&
                            nutrientAttributeHelper.find($scope.vm.data, enums.procurementSkuAttributes.avg_Wt).value == null
                        ) {
                            $scope.outDataIncomplete = true;
                            $scope.outWarningMessageKey = 'sku_not_factorable_and_avg_weight_null';
                            return;
                        }
                        if ($scope.type === 'recipe' &&
                            nutrientAttributeHelper.find($scope.vm.data, enums.procurementSkuAttributes.kCal_per_portion).value == null
                        ) {
                            $scope.outDataIncomplete = true;
                            $scope.outWarningMessageKey = 'recipe_has_incomplete_calorie_information'
                            return;
                        }

                        $scope.outDataIncomplete = false;
                        $scope.outWarningMessageKey = null;
                    }

                    function refreshComponent() {
                        getData().then(function (response) {
                            buildAttributeLists();
                            $scope.vm = {
                                data: mapData(response.data),
                                entityId: $scope.entityId,
                                getIncompleteTextKey: function () {
                                    return $scope.type === 'sku' ?
                                        'incomplete' :
                                        'ingredients_have_missing_calorie_information'
                                },
                                readOnly: $scope.type === 'recipe',
                                dialog: {
                                    open: function () {
                                        ngDialog.open({
                                            template: 'ngxbeagle/src/angularjs/app/Directives/nutrientsComponent/nutrientsComponentDialog.html',
                                            controller: 'nutrientsComponentDialogController',
                                            disableAnimation: true,
                                            showClose: false,
                                            width: '440px',
                                            data: {
                                                entityId: $scope.entityId,
                                                type: $scope.type,
                                                data: $scope.vm.data
                                            }
                                        }).closePromise.then(function(resp) {
                                            if (resp.value !== 0) {
                                                // Update the vm data
                                                $scope.vm.data = mapData(resp.value)
                                            }
                                            updateOutboundWarning();
                                        })
                                    }
                                }
                            }
                            updateOutboundWarning();
                        })
                    }
                    if ($scope.entityId) refreshComponent();

                    // This is bad, make a better way to force update.
                    $rootScope.$on(enums.broadcasts.nutrientsComponent_forceRefresh, refreshComponent);
                }

            ]

            return {
                restrict: 'E',
                templateUrl: '/ngxbeagle/dist/Content/js/directives/nutrientsComponent/nutrientsComponent.html',
                scope: {
                    entityId: '<',
                    measureId: '<?',
                    type: '@',
                    outDataIncomplete: '=?', // Do not bind into this. Output binding only.
                    outWarningMessageKey: '=?' // Do not bind into this. Output binding only.
                },
                controller: controller
            }
        }
    )

angular.module(appName)
    .controller('nutrientsComponentDialogController',
        [
            '$scope',
            '$translate',
            '_',
            'procurementSkuAttributeService',
            'toastr',
            function (
                $scope,
                $translate,
                _,
                procurementSkuAttributeService,
                toastr
            ) {
                var messages = {}
                $translate([
                    'calories_updated_success',
                    'incomplete',
                    'ingredients_have_missing_calorie_information'

                ]).then(function (translations) {
                    messages = translations
                })
                $scope.vm = angular.copy($scope.ngDialogData)
                $scope.vm.confirm = function () {
                    $scope.vm.saving = true
                    var dto = {
                        skuId: $scope.vm.entityId,
                        procurementSubscriptionAttributes: _($scope.vm.data).map(function (item) {
                            return {
                                value: item.value,
                                procurementSkuAttribute: {
                                    id: item.procurementSkuAttribute.id
                                }
                            }
                        })
                    }
                    procurementSkuAttributeService.post(dto).then(function () {
                            toastr.success(messages.calories_updated_success)
                            $scope.closeThisDialog($scope.vm.data)
                        })
                        .finally(function () {
                            $scope.vm.saving = false
                        })
                }
                console.info('nutrientsComponentDialogController initialised.')
                console.info($scope.vm)
            }
        ]
    )

angular.module(appName)
    .factory('nutrientAttributeHelper', [
        'enums',
        '_',
        function (
            enums,
            _
        ) {
            var objArray = []
            for (var key in enums.procurementSkuAttributes) {
                objArray.push({
                    id: enums.procurementSkuAttributes[key],
                    key: key
                })
            }

            return {
                getByValue: function (enumValue) {
                    var found = _(objArray).findWhere({ id: enumValue });
                    if (!found) console.error('[nutrientAttributeHelper.getByValue] :: Enum value "' + enumValue + '" does not exist in enums.procurementSkuAttributes.', enums.procurementSkuAttributes);
                    return found;
                },
                find: function(array, enumToFind) {
                    var found = _(array).find(function(item) { return item.procurementSkuAttribute.id === enumToFind });
                    if (!found) console.error('[nutrientAttributeHelper.find] :: Enum value "' + enumToFind + '" array.', array);
                    return found;
                }
            }
        }
    ])

angular.module(appName)
    .factory('nutrientAttributeService',
        [
            'enums',
            'nutrientAttributeHelper',
            function (
                enums,
                nutrientAttributeHelper
            ) {
                function buildAttributeFormObject(attributeEnum, precision) {
                    var enumValue = nutrientAttributeHelper.getByValue(attributeEnum);
                    return {
                        procurementSkuAttribute: {
                            id: enumValue.id,
                            key: enumValue.key,
                            translationKey: 'label_' + enumValue.key.toLowerCase(),
                            precision: precision || 0, // TODO Precision on weight
                        },
                        value: null,
                        type: 'number'
                    }
                }
                return {
                    buildAttributeFormObject: buildAttributeFormObject,
                    getDefaultAttributes: function(type) {
                        switch (type) {
                            case 'sku':
                                return [
                                    buildAttributeFormObject(enums.procurementSkuAttributes.energy_kcal_per_100g)
                                ]
                            case 'recipe':
                                return [
                                    buildAttributeFormObject(enums.procurementSkuAttributes.kCal_per_portion)
                                ]
                            default:
                                console.error('[nutrientAttributeService.getDefaultAttributes] :: Unknown type ' + type);
                                return;
                        }
                    }
                }
            }
        ]
    )

angular.module(appName)
    .factory("procurementRecipeAttributeService",
        [
            '$http',
            '_',
            'enums',
            'siteUrl',
            'localStorageService',
            function(
                $http,
                _,
                enums,
                siteUrl,
                localStorageService
            ) {
                var api = siteUrl() + "api/ProcurementRecipeAttributes";
                return {
                    get: function(recipeIds) {
                        return $http.get(api + '/get-recipe-with-attributes', {
                            params:{
                                'recipeIds[]': recipeIds
                            }
                        });
                    }
                }
            }
        ]
    );

angular.module(appName)
    .factory("procurementSkuAttributeService",
        [
            '$http',
            'enums',
            'siteUrl',
            'localStorageService',
            function(
                $http,
                enums,
                siteUrl,
                localStorageService
            ) {
                var api = siteUrl() + "api/ProcurementSubscriptionSkuAttributes";
                var subscriptionId = localStorageService.getItem(enums.localStorage.organisationContext).id
                return {
                    get: function(skuId) {
                        return $http.get(api + '/get-sku-with-attributes/' + skuId + '/' + subscriptionId);
                    },
                    post: function(dto) {
                        dto.procurementSubscriptionId = subscriptionId;
                        return $http.post(api + '/update-sku-attributes/', dto);
                    }
                }
            }
        ]
    );

'use strict';

angular.module(appName)
    .directive('paginate', function () {
        var controller = [
            '$scope', 'paginationService',
        function ($scope, paginationService) {

			var setPage = function(page, arrayWithResults) {
				// get pager object from service
				$scope.pager = paginationService.GetPager(arrayWithResults.length, page, $scope.length || 25);

				// get current page of items
				$scope.items = arrayWithResults.slice($scope.pager.startIndex, $scope.pager.endIndex + 1);
			}

            $scope.setPage = function (page, arrayWithResults) {
            	if (arrayWithResults) {
            		if (page > $scope.pager.totalPages) {
            			return;
            		}

		            setPage(page, arrayWithResults);
	            }
            }

            $scope.init = function () {
                $scope.pager = {};

                $scope.$watch(function () { return $scope.itemArray },
                    function (itemArray, oldArray) {

                        if (itemArray !== undefined) {
                        	setPage(1, $scope.itemArray);
                        }
                    });

            }();
        }];

        return {
            scope: {
				itemArray: '=', //Everything
				items: '=?', //A subset of itemArray
				length: '=?',
				pager: '=?'
            },
            restrict: 'E',
            controller: controller,
            templateUrl: '/ngxbeagle/dist/Content/js/directives/paginate/paginate.html'
        }
    })

angular.module(appName)
    .directive('placeholder',
        function() {
            var controller = [
                '$scope',
                function($scope) {

                }
            ];

            return {
                restrict: 'E',
                controller: controller,
                templateUrl: '/ngxbeagle/dist/Content/js/directives/placeholder/placeholder.html'
            }
        });

var keyList = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    PAUSE: 19,
    CAPS_LOCK: 20,
    ESCAPE: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT_ARROW: 37,
    UP_ARROW: 38,
    RIGHT_ARROW: 39,
    DOWN_ARROW: 40,
    INSERT: 45,
    DELETE: 46,
    KEY_0: 48,
    KEY_1: 49,
    KEY_2: 50,
    KEY_3: 51,
    KEY_4: 52,
    KEY_5: 53,
    KEY_6: 54,
    KEY_7: 55,
    KEY_8: 56,
    KEY_9: 57,
    KEY_A: 65,
    KEY_B: 66,
    KEY_C: 67,
    KEY_D: 68,
    KEY_E: 69,
    KEY_F: 70,
    KEY_G: 71,
    KEY_H: 72,
    KEY_I: 73,
    KEY_J: 74,
    KEY_K: 75,
    KEY_L: 76,
    KEY_M: 77,
    KEY_N: 78,
    KEY_O: 79,
    KEY_P: 80,
    KEY_Q: 81,
    KEY_R: 82,
    KEY_S: 83,
    KEY_T: 84,
    KEY_U: 85,
    KEY_V: 86,
    KEY_W: 87,
    KEY_X: 88,
    KEY_Y: 89,
    KEY_Z: 90,
    LEFT_META: 91,
    RIGHT_META: 92,
    SELECT: 93,
    NUMPAD_0: 96,
    NUMPAD_1: 97,
    NUMPAD_2: 98,
    NUMPAD_3: 99,
    NUMPAD_4: 100,
    NUMPAD_5: 101,
    NUMPAD_6: 102,
    NUMPAD_7: 103,
    NUMPAD_8: 104,
    NUMPAD_9: 105,
    MULTIPLY: 106,
    ADD: 107,
    SUBTRACT: 109,
    DECIMAL: 110,
    DIVIDE: 111,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    NUM_LOCK: 144,
    SCROLL_LOCK: 145,
    SEMICOLON: 186,
    EQUALS: 187,
    COMMA: 188,
    DASH: 189,
    PERIOD: 190,
    FORWARD_SLASH: 191,
    GRAVE_ACCENT: 192,
    OPEN_BRACKET: 219,
    BACK_SLASH: 220,
    CLOSE_BRACKET: 221,
    SINGLE_QUOTE: 222
}

angular.module(appName)
    .directive('cdbPreventKey', [function () {
        return {
            link: function (scope, element, attr) {
                element.bind('keydown keypress', function (event) {
                    if (event.which === keyList[attr.cdbPreventKey]) event.preventDefault();
                })
            }
        }
    }])

angular.module(appName)
  .directive('cdbProductSearchHeader', function () {
      var controller = [
        '$scope',
        'enums',
        function ($scope,
                  enums) {
          $scope.searchRankOptions = [
            {
              id: enums.productSearchRankType.bestPrice,
              key: 'best_price_factored'
            },
            {
              id: enums.productSearchRankType.bestPortionPrice,
              key: 'best_price_portion'
            }
          ]
          $scope.searchData.rankType = $scope.searchRankOptions[0].id
        }
      ];

      return {
        scope: {
          'searchData': '='
        },
        controller: controller,
        templateUrl: '/ngxbeagle/src/angularjs/app/Directives/productSearchHeader/productSearchHeader.html'
      }
    }
  )

angular.module(appName)
    .directive('purchaseOrderInvoiceFlip', function () {
        var controller = [
            '$scope', 'receivingPurchaseOrderService',
            function($scope, receivingPurchaseOrderService) {

                var self = this;

                $scope.evaluateErrors = function(po) {
                    $scope.error = false;

                    if (!po.invoiceNumber) {
                        $scope.invoiceNumberNotExist = true;
                        $scope.error = true;
                    } else {
                        $scope.invoiceNumberNotExist = false;
                    }
                    if (!po.invoiceDate) {
                        $scope.invoiceDateNotExist = true;
                        $scope.error = true;
                    } else {
                        $scope.invoiceDateNotExist = false;
                        $scope.invoiceDateInvalid = !moment(po.invoiceDate, "DD/MM/YYYY", true).isValid();
                        if ($scope.invoiceDateInvalid) {
                            $scope.error = true;
                        }

                    }
                    if (po.deliveryDate != null && po.deliveryDate != '') {
                        $scope.deliveryDateInvalid = !moment(po.deliveryDate, "DD/MM/YYYY", true).isValid();
                        if ($scope.deliveryDateInvalid) {
                            $scope.error = true;
                        }

                    }

                    return $scope.error;
                };

                $scope.flipMyPo = function(po) {
                    var errors = $scope.evaluateErrors(po);

                    if (!errors) {
                        $scope.callbackFunction(po);
                    }
                };

                $scope.getInvoiceDataFromPo = function (purchaseOrder) {
                    $scope.gettingData = true;
                    purchaseOrder.flip.rpo = true;

                    receivingPurchaseOrderService.getInvoiceDataFromPo(purchaseOrder,
                        function(data) {
                            purchaseOrder.invoiceNumber = data.invoiceNumber;
                            purchaseOrder.invoiceDate = data.invoiceDate;

                            $scope.evaluateErrors(purchaseOrder);
                            $scope.gettingData = false;
                        });
                };

                $scope.getInvoiceDataFromPo($scope.purchaseOrder);


            }
        ];


                return {
                    restrict: 'E',
                    scope: {
                        flip: '=', //Everything
                        callbackFunction: '&', //function to be called after entry
                        purchaseOrder: '=', //PurchaseOrder
                        closedTitle: '@',
                        fullScreen: '@',
                        message: '@',
                        showSpinner: '=',
                        disable: '=',
                        closedClass: '@'

                    },
                    controller: controller,
                    templateUrl: '/ngxbeagle/dist/Content/js/directives/purchaseOrderInvoiceFlip/purchaseOrderInvoiceFlip.html'
                }
            });

angular.module(appName)
    .directive('required', function () {
        var controller = [
            '$element', '$timeout', '$translate',
            function ($element, $timeout, $translate) {
                // $timeout is required to ensure that all angular cycles have run at least once. This is required for translations.
                $translate.onReady().then(function() {
                    $timeout(function () {
                        var labels = document.getElementsByTagName('LABEL');
                        for (var i = 0; i < labels.length; i++) {
                            if ($element[0].id &&
                                labels[i].htmlFor &&
                                labels[i].htmlFor == $element[0].id) {
                                console.info('[required.js] :: Detected label ', labels[i])
                                var labelText = labels[i].innerText;
                                if (labelText.indexOf('*') == -1) {
                                    // We don't already have an asterisk. Add one.
                                    labelText += ' *';
                                    labels[i].innerText = labelText;
                                }
                                break;
                            }
                        }
                    }, 0);
                });
            }
        ];
        return {
            restrict: 'A',
            require: 'ngModel',
            controller: controller
        }
    });

/**
 * http://stackoverflow.com/a/10364620/3636177 - Mobile detection technique
 *
 */

angular.module(appName)
    .directive('responsiveFilter', function () {
        var controller = [
            '$scope', '$element', '$attrs', '$timeout', '_', 'validationHelper',
            function ($scope, $element, $attrs, $timeout, _, validationHelper) {
                var self = this;
                self.width = 250;
                self.animateClass = 'responsive-filter-animate';
                self.isDirty = false; // Checks if we've changed any filters
                $scope.selectedItems = [];

                self.setupVariables = function (setElementStyles) {
                    self.elements = {
                        self: $element,
                        next: $element.next(),
                        section: angular.element('section'),
                        body: angular.element('body'),
                        bodyWrapper: angular.element(document.querySelector('#body-wrapper')),
                        active: angular.element('.filter.active'),
                        root: angular.element('.filter-root')
                    }
                    self.sectionWidth = self.elements.section.outerWidth();

                    if (setElementStyles) {
                        self.setElementStyles($scope.show);
                    }

                    $scope.mobile = validationHelper.isMobile();
                }
                self.setupVariables();

                // Add animate class to required elements.
                $element.addClass(self.animateClass);
                self.elements.next.addClass(self.animateClass);
                self.elements.active.addClass(self.animateClass);
                self.elements.root.addClass(self.animateClass);

                $element.css({
                    position: 'fixed',
                    top: 0,
                    left: $scope.mobile ? '100%' : -self.width,
                    width: $scope.mobile ? '100%' : self.width,
                    height: '100%',
                    backgroundColor: self.elements.section.css('background-color'),
                    zIndex: 999,
                    overflowY: 'auto',
                    overflowX: 'hidden'
                });

                // So that we don't have to modify the core css for the <section></section> element.
                // We are only doing so on the first element if we are using the filter directive
                self.elements.section.css({ overflow: 'hidden', minHeight: 550 });

                self.setElementStyles = function (show) {
                    if (show) {
                        /* Showing filters */
                        if ($scope.mobile) {
                            /* Showing filters - Mobile */
                            $element.css({
                                top: 0,
                                width: '100%',
                                left: '0%',
                                maxHeight: 'none',
                                maxWidth: 'none',
                                position: 'fixed'
                            });
                        } else {
                            /* Showing filters - Desktop */
                            $element.css({
                                top: 'auto',
                                left: '10px', // Left dist. Update self.elements.next when updating this
                                maxWidth: self.width,
                                display: 'inline-block',
                                float: 'left',
                                position: 'absolute',
                                width: self.width,
                                maxHeight: 760,
                                overflowY: 'auto'
                            });
                            self.elements.next.css({
                                    // Size of section - width of filters - left dist - gutter
                                width: self.sectionWidth - self.width - 10 - 30,
                                float: 'right'
                            });
                            self.elements.bodyWrapper.css({ overflow: '' });
                        }
                    } else {
                        /* Hiding filters */
                        if ($scope.mobile) {
                            /* Hiding filters - Mobile */
                            $element.css({
                                left: '-100%',
                                maxWidth: 'none'
                            });
                            self.elements.next.css({
                                width: '100%',
                                float: 'none'
                            });
                        } else {
                            /* Hiding filters - desktop */
                            console.log('hit me');
                            $element.css({
                                position: 'absolute',
                                left: -self.width,
                                maxWidth: self.width,
                                overflow: 'hidden',
                                display: 'inline-block',
                                float: 'left'
                            });
                            self.elements.next.css({
                                width: '100%'
                            });
                            self.elements.bodyWrapper.css({ overflow: '' });
                        }
                    }
                }

                $scope.changeActiveFilter = function (filter) {
                    $scope.activeFilter = filter;
                    // if (filter && filter.items.length > 10) {
                    if (filter) {
                        filter.alphabetizedItems = self.alphabetizeFilterItems(filter);
                    }

                    if (filter) {
                        self.elements.active.css({
                            left: '0%'
                        });
                        self.elements.root.css({
                            left: '-100%'
                        });

                        var selectedItem = _.findWhere($scope.selectedItems, { name: filter.name });
                        if (!selectedItem)
                            $scope.selectedItems.push(selectedItem);
                    } else {
                        self.elements.active.css({
                            left: '100%'
                        });
                        self.elements.root.css({
                            left: '0%'
                        });
                    }

                    $element[0].scrollTop = 0;
                }

                $scope.clearActiveFilterItems = function(activeFilter) {
                    for(var i = 0; i < activeFilter.items.length; i++) {
                        activeFilter.items[i].isSelected = false;
                    }

                    if (!self.isDirty) {
                        self.isDirty = true;
                    }
                }

                $scope.clearAllActiveFilterItems = function() {
                    for (var i = 0; i < $scope.filters.length; i++) {
                        var filter = $scope.filters[i];
                        $scope.clearActiveFilterItems(filter);
                    }
                }

                $scope.toggleFilterItem = function (filterItem) {
                    var selected = !filterItem.isSelected;
                    var item = _($scope.activeFilter.items).findWhere({ id: filterItem.id });
                    filterItem.isSelected = selected;
                    item.isSelected = selected;
                    self.isDirty = true;
                }

                $scope.getSelectedFilterItems = function(filter) {
                    var items = _(filter.items).where({ isSelected: true });
                    return {
                        items: items,
                        count: items ? items.length : 0
                    };
                }

                self.alphabetizeFilterItems = function(filter) {
                    if (!filter || !filter.items)
                        return;

                    var items =
                        _.chain(filter.items)
                            .groupBy(function(item) {
                                return item.name[0];
                            })
                            .sortKeysBy()
                            .value()
                    console.log(items);
                    return items;
                }

                var resizeTimeout;
                window.addEventListener('resize', function () {
                    clearTimeout(resizeTimeout);
                    resizeTimeout = setTimeout(self.setupVariables(true), 100);
                });

                $scope.callApply = function (term) {
                    if (self.isDirty) {
                        $scope.apply({ $term: term });
                    }

                    if ($scope.mobile) {
                        if ($scope.activeFilter) {
                            $scope.changeActiveFilter();
                        }
                        $scope.toggle();
                    }
                    self.isDirty = false;
                    $scope.changeActiveFilter(null);
                };

                $scope.$on('updateFilterDirective', function() {
                    if ($scope.activeFilter) {
                        // MB: Someone broke this code. I've disabled it.
                        //$scope.changeActiveFilter(_(newfilters).findWhere(function (filter) {
                        //    return filter.filterType == $scope.activeFilter.filterType;
                        //}));
                        $scope.changeActiveFilter(null);
                    }
                });

                $scope.$watch('show', function (newValue, oldValue) {
                    $scope.mobile = validationHelper.isMobile();
                    if (newValue && $scope.mobile) {
                        self.setElementStyles(newValue);
                        self.elements.bodyWrapper.css({ overflow: 'hidden', position: 'relative' });
                    } else {
                        self.setElementStyles(newValue);
                        self.elements.bodyWrapper.css({ overflow: '' });
                    }
                });
            }
        ];

        return {
            restrict: 'E',
            scope: {
                toggle: '&',
                show: '=',
                filters: '=',
                apply: '&',
                term: '='
            },
            templateUrl: '/ngxbeagle/dist/Content/js/directives/responsiveFilter/responsiveFilter.html',
            controller: controller
        }
    });

/*

    MB: Leave the commented code in!! It's a work in progress that may improve the look and feel of the UI. Parked for time.

*/
angular.module(appName)
   .directive('rootLoad', function () {
       var controller = [
           '$scope', '$q', '$element', '$attrs', '$timeout',
           function ($scope, $q, $element, $attrs, $timeout) {
           }
       ];

       return {
           restrict: 'AE',
           templateUrl: 'ngxbeagle/dist/Content/js/directives/rootLoad/rootLoad.html',
           scope: {
               waitFor: '=?'
           },
           controller: controller
       }

   });

'use strict';

angular.module(appName)
    .directive('searchPagination', function () {
        var controller = [
            '$scope', 'searchService',
        function ($scope, searchService) {

            var self = this;

            //$rootScope.$on('paginationDataUpdated', function () {
                //debugger;
                //$scope.paginationData = searchService.getPaginationData();
            //});

            $scope.getPage = function (pageNumber) {
                if (pageNumber) {
                    _.each($scope.paginationData.pages, function (page) {
                        page.active = false;
                    });
                    pageNumber.active = true;
                    searchService.updatePageNumber(pageNumber);
                    $scope.search();
                }
            }

            $scope.init = function () {
                $scope.paginationData = searchService.getPaginationData();
            }();
        }];

        return {
            scope: { search: '&' },
            restrict: 'E',
            controller: controller,
            templateUrl: '/ngxbeagle/dist/Content/js/directives/searchPagination/searchPagination.html'
        }
    })

'use strict';

angular.module(appName)
    .directive('setupBasket', function () {
        var controller = ['$scope', 'basketService', 'clientUnitAccountCodeService', 'clientUnitDepartmentService', 'translateMessage', '$location', 'helpers', 'localStorageService', 'enums', '$http', '$translate', '_', 'userService',
        function ($scope, basketService, clientUnitAccountCodeService, clientUnitDepartmentService, translateMessage, $location, helpers, localStorageService, enums, $http, $translate, _, userService) {

            var self = this;
            var hasUpdateBasketsWithinAllUnitsPermission;
            var hasUpdateBasketsWithinAllOwnUnitsPermission;
            var hasCreateOrderWithinOwnUnitsPermission;
            var hasCreateOrderWithinAllUnitsPermission;
            $scope.nullPricedItems = false;

            $scope.enums = enums;
            $scope.errors = {
                decimal: false,
                quantity: false
            };

            $scope.searchProducts = function (basket) {
                var id = basket.id || basket.id;
                return 'ProductSearch/' + id + '/' + enums.procurementBasketType.ProcurementBasket;
            }

            $scope.goToCheckout = function (basket) {
                $scope.submittingBasket = true;
                var configureResult = $scope.configureBasket(basket);
                if (configureResult) {
                    configureResult.then(function() {
                        basketService.submitBasket(basket.id,
                            function() {
                                translateMessage.success('message_basket_submitted');
                                $location.path('/baskets');
                            }).finally(function () {
                                $scope.submittingBasket = false;
                        });
                    });
                }
            }

            $scope.submitBasketAndCreatePO = function (basket) {
                $scope.submittingBasket = true;
                var configureResult = $scope.configureBasket(basket);
                if (configureResult) {
                    configureResult.then(function() {
                        $scope.waitingOnServer = true;
                        $scope.creatingPurchaseOrders = true;
                        var dto = {};
                        dto.id = $scope.context.currentSubscriptionUnit.id;
                        dto.basketIds = [];
                        dto.basketIds.push(basket.id);
                        basketService.submitAndConsolidateBasket(dto, function (result) {
                            $scope.purchaseOrderCreated = true;
                            var path = '/PurchaseOrders/CreatedPurchaseOrders/' + _.map(result, function (e) { return e.id }).join(',');
                            $location.path(path);
                        }).finally(function () {
                            $scope.waitingOnServer = false;
                            $scope.creatingPurchaseOrders = false;
                            $scope.submittingBasket = false
                        });
                    });
                }
            };

            $scope.cancel = function () {
                $scope.toggle();
            }

            $scope.basketHasInvalidProducts = function (basket) {
                return _.find(basket.basketItems, function (item) {
                    return item.clientSupplierAccountDto == null ||
                        !item.itemPrice;
                });
            };

            $scope.basketHasItemWithNoAccount = function(basket) {
                return _.find(basket.basketItems, function(item) {
                    return item.clientSupplierAccountDto == null;
                });
            };

            $scope.configureBasket = function (basket) {

                if (self.isDuplicateBasketName(basket)) {
                    translateMessage.error('this_basket_name_is_already_being_used_please_enter_a_unique_name');
                    return null;
                }

                $scope.savingBasket = true;
                basket.procurementSubscriptionId = $scope.subscriptionId;
                basket.procurementSubscriptionUnitId = $scope.context.currentSubscriptionUnit.id;
                if (basket && basket.id) {
                    return self.editBasket(basket);
                }
                else {
                    return self.createBasket(basket);
                }
            };

            $scope.hasInvalidItems = function() {
                var hasInvalidItems = _.find($scope.basket.basketItems, function (basketItem) {
                    var allowDecimals;
                    if (basketItem.packTypeId == enums.packTypes.catchWeight && (basketItem.catchWeight == null || basketItem.catchWeight == 0)) {
                        allowDecimals = true;
                    }

                    return (!allowDecimals && basketItem.quantity % 1 != 0) ||
                        parseFloat(basketItem.catchWeight) === 0 ||
                        ($scope.basket.discriminator === enums.procurementBasketType.ProcurementBasket) &&
                        ((basketItem.quantity < 1 && !allowDecimals) ||
                            (basketItem.quantity <= 0 && allowDecimals) ||
                            basketItem.quantity == null ||
                            basketItem.quantity == undefined);
                });
                return hasInvalidItems;
            }

            $scope.canSubmitBasket = function (basket) {
            	if (!basket.procurementBasketStatus || basket.procurementBasketStatus.id !== enums.procurementBasketStatus.Open) {
		            return false;
            	}

            	if (hasUpdateBasketsWithinAllUnitsPermission) {
		            return true;
            	}
            	if (hasUpdateBasketsWithinAllOwnUnitsPermission) {
		            var basketDepartmentId = $scope.currentBasket.procurementClientUnitDepartment.id;
		            if (_.find($scope.departments, { 'id': basketDepartmentId })) {
						return true;
					}
	            }
		        return false;
            };

            $scope.canCreatePurchaseOrder = function (basket) {
                if (!basket.procurementBasketStatus || basket.procurementBasketStatus.id !== enums.procurementBasketStatus.Open) {
            		return false;
            	}
            	if (hasCreateOrderWithinAllUnitsPermission) {
            		return true;
            	}
            	if (hasCreateOrderWithinOwnUnitsPermission) {
            		var basketDepartmentId = $scope.currentBasket.procurementClientUnitDepartment.id;
            		if (_.find($scope.departments, { 'id': basketDepartmentId })) {
            			return true;
            		}
            	}
            	return false;
            };

            self.createBasket = function (basket) {
                var createBasketPromise = basketService.create(basket);
                createBasketPromise.then(function (data) {
                    translateMessage.success('new_basket_created');
                    $scope.savingBasket = false;
                    $location.path('/ProductSearch/' + data.id + '/' + enums.procurementBasketType.ProcurementBasket);
                }, function (err) {
                    $scope.savingBasket = false;
                });
                return createBasketPromise;
            }

            self.editBasket = function (basket) {
                var editBasketPromise = basketService.update(basket);
                editBasketPromise.then(function (data) {
                    $scope.savingBasket = false;
                    translateMessage.success('basket_updated');
                }, function (err) {
                    $scope.savingBasket = false;
                });
                return editBasketPromise;
            }

            self.isDuplicateBasketName = function (basket) {
                if (!helpers.isNullOrUndefined(basket.procurementBasket) || input == '') {
                    var input = basket.procurementBasket.name;
                    if (!helpers.isNullOrUndefined(input) || input == '') {
                        // Create array of existing basket names, excluding current basket so that editing other fields
                        // on an existing basket doesn't throw a false positive for name duplication
                        var innerBaskets = _.pluck($scope.basketData, 'procurementBasket');
                        innerBaskets = _.without(innerBaskets,
                                _.findWhere(innerBaskets, { id: basket.procurementBasket.id })
                            );
                        var basketNames = _.pluck(innerBaskets, 'name');
                        return _.contains(basketNames, input);
                    }
                }
                return false;
            }

            self.userSetupIsInvalid = function () {
            	if ($scope.accountCodes.length < 1) {
            		return true;
            	}
            	if ($scope.departments.length < 1) {
            		return true;
				}
            	return false;
            }

            $scope.setPrice = function (newPrice) {
                $scope.currentBasket.totalPrice = newPrice;
            }

            $scope.init = function () {
                $scope.loading = true;
                $scope.invalidSetup = false;

                $scope.context = localStorageService.getItem(enums.localStorage.organisationContext);
                var userId = $scope.userId ? $scope.userId : 0;
	            userService.hasPermission('BEAGLE_PROCUREMENT_BASKETS_UPDATE_WITHIN_ALL_UNITS').then(function() {
		            hasUpdateBasketsWithinAllUnitsPermission = true;
	            });
	            userService.hasPermission('BEAGLE_PROCUREMENT_BASKETS_UPDATE_WITHIN_DEPARTMENT').then(function() {
		            hasUpdateBasketsWithinAllOwnUnitsPermission = true;
	            });
	            userService.hasPermission('BEAGLE_PROCUREMENT_BASKET_ORDER_DIRECTLY_WITHIN_DEPARTMENT').then(function () {
	            	hasCreateOrderWithinOwnUnitsPermission = true;
	            });
	            userService.hasPermission('BEAGLE_PROCUREMENT_BASKET_ORDER_DIRECTLY_WITHIN_ALL_UNITS').then(function () {
	            	hasCreateOrderWithinAllUnitsPermission = true;
	            });

                clientUnitDepartmentService.getClientUnitProcurementDepartmentsForUser($scope.context.currentSubscriptionUnit.id, userId).$promise.then(function (data) {
                    $scope.departments = data;
                    self.defaultDepartmentForUser = clientUnitDepartmentService.getDefaultDepartmentForUser($scope.departments);

                clientUnitAccountCodeService.getClientUnitProcurementAccountCodesForUser($scope.context.currentSubscriptionUnit.id, userId).$promise.then(function (data) {
                    $scope.accountCodes = data;
                    self.defaultAccountCodeForUser = clientUnitAccountCodeService.getDefaultAccountCodeForUser($scope.accountCodes);

					if ($scope.currentBasket && $scope.currentBasket.id && !self.userSetupIsInvalid()) {
                        $scope.basket = $scope.currentBasket;

                        //replacement products
                        $scope.replacement = {};
                        $scope.replacement.showReplacements = true;
                        $scope.replacement.showReplacementFilter = _.find($scope.basket.basketItems, function (data) {
                            return data.isReplacement === true;
                        }) != null;
                        //end replacement prod
                        $scope.basket.hasUnpricedItems = _.some($scope.basket.basketItems, function (basketItem) {
                            return basketItem.itemPrice === null || basketItem.itemPrice === undefined;
                        });

						if ($scope.currentBasket.procurementClientUnitDepartment) {
							$scope.basket.procurementClientUnitDepartment = _.findWhere($scope.departments, { clientProcurementDepartmentId: $scope.currentBasket.procurementClientUnitDepartment.clientProcurementDepartmentId });
						}
						if ($scope.currentBasket.procurementClientUnitAccountCode) {
							$scope.basket.procurementClientUnitAccountCode = _.findWhere($scope.accountCodes, {
                                clientProcurementAccountCodeId: $scope.currentBasket.procurementClientUnitAccountCode.clientProcurementAccountCodeId
                            });
						}
                        if (!$scope.basket.procurementClientUnitDepartment || !$scope.basket.procurementClientUnitAccountCode) {
                            $scope.invalidSetup = true;
                        }

                        $scope.showBasketItemsFromSetup = true;
                    } else if (self.userSetupIsInvalid()) {
                        $scope.invalidSetup = true;
                    } else {
                        $scope.basket = {
                            isAsapDelivery: true,
                            procurementClientUnitAccountCode: self.defaultAccountCodeForUser,
                            procurementClientUnitDepartment: self.defaultDepartmentForUser,
                            procurementSubscriptionId: $scope.subscriptionId
                        }
                    }
                    $scope.loading = false;
                    });
                });
            }();
        }];

        return {
            scope: {
                subscriptionId: '=?',
                userId: '=?',
                basketData: '=?',
                currentBasket: '=?',
                toggle: '&',
                basketTotal: '=?',
                basketOriginalTotal: '=?',
                availableClientSupplierAccounts: '='
            },
            restrict: 'E',
            controller: controller,
            templateUrl: '/ngxbeagle/dist/Content/js/directives/setupBasket/setupBasket.html'
        }
    })

angular.module(appName).directive('setupShoppingList', function () {
    var controller = [
        '$scope', '_', 'shoppingListService', 'translateMessage', '$location',
        'organisationContextService', 'enums', 'userService',
        function ($scope, _, shoppingListService, translateMessage, $location,
            organisationContextService, enums, userService
        ) {
            var self = this;
            self.ctx = organisationContextService.getContext();

            $scope.searchProducts = function (shoppingList) {
                window.location = '/ProductSearch/' + $scope.currentShoppingList.id + '/' + enums.procurementBasketType.ShoppingList;
            };

            $scope.enums = enums;
            $scope.searchText = '';
            $scope.errors = {
                decimal: false,
                quantity: false
            };

            $scope.cancel = function () {
                window.location = '/ShoppingLists';
            };

            $scope.replaceBasketItem = function (args) {
                return shoppingListService.replaceBasketItem(args.currentBasketItem, args.alternativeProduct, args.availableClientSupplierAccounts);
            };

            $scope.configureShoppingList = function (shoppingList) {
                shoppingList.procurementSubscriptionId = $scope.subscriptionId;
                shoppingList.procurementSubscriptionUnitId = self.ctx.currentSubscriptionUnit.id;
                shoppingList.isAsapDelivery = true;

                return self[
                    (shoppingList && shoppingList.id) ?
                        'editshoppingList' :
                        'createshoppingList'
                ](shoppingList);
            };

            var generateCreateBasketRequestFromShoppingList = function (shoppingList) {
                var flatItems = _.pluck(_.flatten(_.pluck(shoppingList.procurementSegments, 'procurementSegmentItemDtos')), 'procurementItemDto');
                var itemsWithQuantity = _.filter(flatItems, function (x) { return x.quantity });
                var createBasketItemFromShoppingListItemRequests = _.map(itemsWithQuantity, function (x) {
                    return {
                        procurementItemId: x.id,
                        quantity: x.quantity
                    }
                });
                return {
                    createBasketItemFromShoppingListItemRequests: createBasketItemFromShoppingListItemRequests,
                    newBasketName: shoppingList.newBasketName,
                    shoppingListId: shoppingList.id
                };
            }

            $scope.createBasketFromShoppingList = function () {
                return $scope.configureShoppingList($scope.currentShoppingList).then(function () {
                    $scope.creatingBasketFromShoppingList = true;
                    var request = generateCreateBasketRequestFromShoppingList($scope.currentShoppingList);
                    return shoppingListService.createBasketFromShoppingList(request).then(function (result) {
                        translateMessage.success(
                            'label_created_basket_from_shopping_list',
                            { shoppingListName: $scope.currentShoppingList.name }
                        );
                        window.location = '/baskets/view/' + result.data;
                    }).finally(function () {
                        $scope.creatingBasketFromShoppingList = false;
                    });
                });
            }

            $scope.toggleCreateBasketFromShoppingList = function () {
                $scope.showCreateBasketModal = !$scope.showCreateBasketModal;
            }

            $scope.disableCreateBasketToggle = function () {
                var shouldDisable = _.filter(getFlattenedBasketItems(), function (item) {
                    return item.procurementItemDto.quantity > 0;
                }).length == 0;
                return shouldDisable;
            }

            $scope.hasInvalidItems = function () {
                var itemsWithQuantity = _.filter(getFlattenedBasketItems(),
                    function (segmentItem) {
                        return segmentItem.procurementItemDto.quantity != '' && segmentItem.procurementItemDto.quantity != null && segmentItem.procurementItemDto.quantity >= 0;
                    });
                var hasInvalidItems = _.find(itemsWithQuantity, function (basketItem) {
                    var allowDecimals = false;
                    if (basketItem.procurementItemDto.packTypeId == enums.packTypes.catchWeight && (basketItem.procurementItemDto.catchWeight == null || basketItem.procurementItemDto.catchWeight == 0)) {
                        allowDecimals = true;
                    }

                    return (!allowDecimals && basketItem.procurementItemDto.quantity % 1 != 0) ||
                        parseFloat(basketItem.procurementItemDto.catchWeight) === 0 ||
                        ((basketItem.procurementItemDto.quantity < 1 && !allowDecimals) ||
                            (basketItem.procurementItemDto.quantity <= 0 && allowDecimals) ||
                            basketItem.procurementItemDto.quantity == null ||
                            basketItem.procurementItemDto.quantity == undefined) ||
                        basketItem.procurementItemDto.procurementClientUnitAccountCodeDto == null;
                });
                return hasInvalidItems;
            };

            $scope.disableCreateBasketFromShoppingList = function () {
                return $scope.creatingBasketFromShoppingList ||
                    $scope.errors.decimal ||
                    $scope.errors.quantity ||
                    !$scope.currentShoppingList.procurementClientUnitAccountCode ||
                    $scope.hasInvalidItems();
            };

            $scope.disableSave = function () {
                return !$scope.currentShoppingList.name ||
                    !$scope.currentShoppingList.procurementClientUnitDepartment ||
                    !$scope.currentShoppingList.procurementClientUnitAccountCode
            };

            self.createshoppingList = function (shoppingList) {
                return shoppingListService.create(shoppingList).then(function (data) {
                    var href = shoppingListService.hrefs.view(data.id);
                    window.location = href;
                    translateMessage.success('new_shoppinglist_created');
                }, function (err) {
                    translateMessage.error(err, true);
                });
            }

            self.editshoppingList = function (shoppingList) {
                var updateShoppingListPromise = shoppingListService.update(shoppingList);
                updateShoppingListPromise.then(function (data) {
                    translateMessage.success('shopping_list_updated');
                }, function (err) {
                    translateMessage.error(err, true);
                }).finally(function (d) {
                    $scope.savingShoppingList = false;
                });
                return updateShoppingListPromise;
            }

            function getFlattenedBasketItems() {
                return _.chain($scope.currentShoppingList.procurementSegments)
                    .map(function (segment) {
                        return segment.procurementSegmentItemDtos;
                    })
                    .flatten()
                    .value();
            }

            self.init = function () {
                $scope.currentShoppingList.newBasketName = $scope.currentShoppingList.name;
                $scope.currentShoppingList.procurementClientUnitDepartment = $scope.currentShoppingList.procurementClientUnitDepartment
                    ? _.findWhere($scope.userDepartments, { id: $scope.currentShoppingList.procurementClientUnitDepartment.id })
                    : _.findWhere($scope.userDepartments, { isDefaultForCurrentUser: true });
                /* If it is a new Shopping List, we need to set the accountcode to the default for the user */
                if (!$scope.currentShoppingList.id) {
                    $scope.currentShoppingList.procurementClientUnitAccountCode = _.findWhere($scope.userAccountCodes, { isDefaultForCurrentUser: true });
                } else if ($scope.currentShoppingList.procurementClientUnitAccountCode) {
                    // Our ShoppingList exists already, use whatever ProcurementClientUnitAccountCode we have on the ShoppingList if it exists.
                    // If it doesn't exist, leave it null and force the user to select
                    $scope.currentShoppingList.procurementClientUnitAccountCode = _.findWhere($scope.userAccountCodes, { clientProcurementAccountCodeId: $scope.currentShoppingList.procurementClientUnitAccountCode.clientProcurementAccountCodeId });
                }
                $scope.hasEditPermission = false;
                $scope.hasOrderFromPermission = false;

                userService.hasAnyPermission([
                    'BEAGLE_PROCUREMENT_SHOPPING_LISTS_EDIT',
                    'BEAGLE_PROCUREMENT_SHOPPING_LISTS_ADD'
                ]).then(function () {
                    $scope.hasEditPermission = true;
                });
                userService.hasPermission('BEAGLE_PROCUREMENT_SHOPPING_LISTS_ORDER_FROM').then(function () {
                    $scope.hasOrderFromPermission = true;
                });
            }();
        }
    ];

    return {
        scope: { subscriptionId: '=?', userDepartments: '=', userAccountCodes: '=', userId: '=?', currentShoppingList: '=', shoppingListTotal: '=?', shoppingListOriginalTotal: '=?' },
        restrict: 'E',
        controller: controller,
        templateUrl: '/ngxbeagle/dist/Content/js/directives/setupShoppingList/setupShoppingList.html'
    }
});

angular.module(appName)
.directive('slideable', function () {
    return {
        restrict: 'C',
        compile: function (element, attr) {
            // wrap tag
            var contents = element.html();
            element.html('<div class="slideable_content" style="margin:0 !important; padding:0 !important" >' + contents + '</div>');

            return function postLink(scope, element, attrs) {
                // default properties
                attrs.duration = (!attrs.duration) ? '1s' : attrs.duration;
                attrs.easing = (!attrs.easing) ? 'ease-in-out' : attrs.easing;
                element.css({
                    'overflow': 'hidden',
                    'height': '0px',
                    'transitionProperty': 'height',
                    'transitionDuration': attrs.duration,
                    'transitionTimingFunction': attrs.easing
                });
            };
        }
    };
})
.directive('slideToggle', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var target, content;

            attrs.expanded = false;

            element.bind('click', function () {
                if (!target) target = document.querySelector(attrs.slideToggle);
                if (!content) content = target.querySelector('.slideable_content');

                if (!attrs.expanded) {
                    content.style.border = '1px solid rgba(0,0,0,0)';
                    var y = content.clientHeight;
                    content.style.border = 0;
                    target.style.height = y + 'px';
                } else {
                    target.style.height = '0px';
                }
                attrs.expanded = !attrs.expanded;
            });
        }
    }
});
angular.module(appName).controller('groupSupplierAccountsController', [
    '$scope', '$q', '_', 'organisationContextService', 'groupSupplierAccountsService',
    'localStorageService', 'enums', 'translateMessage', 'helpers', 'defaultOrganisationId',
    'defaultSupplierId', 'transmissionTypes', 'autoFocus',
    function ($scope, $q, _, organisationContextService, groupSupplierAccountsService,
        localStorageService, enums, translateMessage, helpers, defaultOrganisationId,
        defaultSupplierId, transmissionTypes, autoFocus
    ) {
        var self = this;

            $scope.areYouSure = function (supplierAccount) {
                supplierAccount.promptAreYouSure = !supplierAccount.promptAreYouSure;
            }

            $scope.editSupplierAccount = function (supplierAccount) {
                clearUnfinishedEntries();
                $scope.cachedSupplierAccount = angular.copy(supplierAccount);
                $scope.cachedSupplierAccounts = angular.copy($scope.groupSupplierAccounts);
                supplierAccount.isBeingEdited = true;
            }

            $scope.cancelChanges = function (supplierAccount) {
                $scope.groupSupplierAccounts = $scope.cachedSupplierAccounts;
                clearUnfinishedEntries();
            }

            $scope.saveChanges = function (supplierAccount) {
                supplierAccount.isBeingEdited = false;
                translateMessage.success('your_supplier_account_was_saved_successfully');
            }

            $scope.scopeActions = [
                { name: "Edit", function: $scope.editSupplierAccount, color: "green" }
            ]

            $scope.editActions = [
                { name: "Save", function: $scope.saveChanges, color: "green", disabledWhen: "!supplierAccount.vendorCode || supplierAccount.vendorCode == '' || !supplierAccount.accountNumber || supplierAccount.accountNumber == ''" },
                { name: "Cancel", function: $scope.cancelChanges, color: "red" },
            ]

            function clearUnfinishedEntries() {
                $scope.groupSupplierAccounts = helpers.clearUnfinishedTableEntries($scope.groupSupplierAccounts);
            }

            $scope.filterByClient = function (organisationId) {
                getAccounts(organisationId);
            }

            function getAccounts(organisationId, supplierId) {
                groupSupplierAccountsService.get(organisationId).then(function (data) {
                    self.allGroupSupplierAccounts = data;
                    $scope.groupSupplierAccounts = data;

                    _.each(data, function (d) {
                        var duplicate = _.find(self.suppliers, { id: d.supplierId });
                        if (!duplicate) {
                            self.suppliers.push({ id: d.supplierId, name: d.supplierName });
                        }
                    });

                    self.suppliers = _.sortBy(self.suppliers, 'name');
                    self.suppliers.push({ id: 0, name: "View All" })
                    $scope.suppliers = self.suppliers;

                    if (supplierId) {
                        // We got here from Group Suppliers with a Supplier filter set - use it to filter the Suppliers
                        $scope.defaultSupplier = _.findWhere($scope.suppliers, { id: defaultSupplierId });
                        $scope.filterBySupplier(supplierId);
                    }
                    else {
                        // We got here from the menu - just show all the Suppliers for the current Client Unit
                        $scope.defaultSupplier = _.findWhere($scope.suppliers, { id: 0 });
                    }
                    $scope.groupSupplierAccountsData.resolve();
                });
            }

            $scope.filterBySupplier = function (supplierId) {
                $scope.groupSupplierAccounts = supplierId != 0
                    ? _.filter(self.allGroupSupplierAccounts, { supplierId: supplierId })
                    : angular.copy(self.allGroupSupplierAccounts);
            }

            $scope.toggleShowAddEditSupplier = function () {
                $scope.showAddEditSupplier = !$scope.showAddEditSupplier;
            };

            self.init = function () {
                transmissionTypes.$promise.then(function (data) {
                    $scope.transmissionTypes = data;
                });

                $scope.groupSupplierAccountsData = $q.defer();
                self.context = organisationContextService.getContext();
                $scope.organisationContext = {
                    context: self.context,
                    procurementUnits: self.context.procurementSubscriptionUnits,
                };
                self.orgs = [];
                self.suppliers = [];

                _.each(self.context.procurementSubscriptionUnits, function (unit) {
                    self.orgs.push(unit.organisation);
                });

                $scope.clientUnits = self.orgs;

                var organisationId = defaultOrganisationId ?
                    defaultOrganisationId :
                    localStorageService.getItem(enums.localStorage.organisationContext).user.orgId;

                $scope.groupSupplierAccounts = [];
                $scope.currentProcurementSubscriptionId = localStorageService.getItem(enums.localStorage.organisationContext).id;
                $scope.defaultClientUnit = _.findWhere($scope.clientUnits, { id: organisationId });
                getAccounts(organisationId, defaultSupplierId);
            }();
    }
]);
angular.module(appName).directive('systemPreferences', function() {
    var controller = [
        '$scope', '$q', 'enums', 'localStorageService', 'unitPreferencesService', 'validationHelper',
        'organisationContextService', 'recipetemplateService', 'userService', 'translateMessage',
        function ($scope, $q, enums, localStorageService, unitPreferencesService, validationHelper,
            organisationContextService, recipetemplateService, userService, translateMessage
        ) {
                        $scope.moment = moment;
                        $scope.show = false;

                        $scope.toggleShow = function() {
                            $scope.show = !$scope.show;
                        }; //This is to handle preferences in WIMD that are stored as decimals but need to be displayed/edited as percentages
                        $scope.notWIMDPercentagePreference = function(preference) {
                            var key = preference.key;
                            var result =
                                key == 'NATURALWASTAGE' ||
                                key == 'SEASONALVARIATION' ||
                                key == 'STAFFFEEDING' ||
                                key == 'PREVAILINGVATRATE' ||
                                key == 'TARGETMARGINPERCENT' ||
                                key == 'TARGETMARGINTYPE' ||
                                key == 'SOPTEMPLATE' ||
                                key == 'RECIPECARDTEMPLATE' ||
                                key == 'COSTCALCULATORTEMPLATE' ||
                                key == 'CUSTOMERPORTALURL'
                            return !result;

                        };
                        $scope.isWIMDPercentagePreference = function(preference) {
                            var key = preference.key;
                            var result =
                                key == 'NATURALWASTAGE' ||
                                key == 'SEASONALVARIATION' ||
                                key == 'STAFFFEEDING' ||
                                key == 'PREVAILINGVATRATE' ||
                                key == 'TARGETMARGINPERCENT';
                            return result;
                        };
                        $scope.save = function() {
                            var c = organisationContextService.getContext();
                            var unitSubscriptionId = c.currentSubscriptionUnit.id;
                            $scope.dto.id = unitSubscriptionId;
                            var request = angular.copy($scope.dto);
                            var recipeLitePref = _.find(request.systemPreferences,
                                { systemPreferenceTypeId: enums.systemPreferenceEnum.recipeLite });
                            if (recipeLitePref) {
                                recipeLitePref.value = !recipeLitePref.value;
                            }

                            return unitPreferencesService
                                .insertUpdateSystemPreferenceForClient(request)
                                .$promise
                                .then(function() {
                                    translateMessage.success('preferences_updated');
                                });
                        };

                        //Handling this here as back end expects 0/1 for SystemPreferences
                        $scope.togglePreference = function(preference) {
                            preference.value = (preference.value == 0) ? 1 : 0;
                        };

                        $scope.preferenceOptions = [
                            { key: 'FCOS', name: 'fcos' },
                            { key: 'GROSSPROFIT', name: 'grossprofit-in-caps' }
                        ];

                        $scope.sopTemplateOptions = [];
                        $scope.recipecardTemplateOptions = [];

                        $scope.setupTargetMarginType = function(preference) {
                            preference.value = _.findWhere($scope.preferenceOptions, { key: preference.value });
                        };

                        $scope.init = function() {
                            var c = organisationContextService.getContext();
                            var unitSubscriptionId = c.currentSubscriptionUnit.id;
                            var clientId = c.currentSubscriptionUnit.client.id;
                            var model = { id: unitSubscriptionId, clientId: clientId };
                            unitPreferencesService.getSystemPreferencesForClient(model).$promise.then(function(data) {
                                $scope.dto = data;
                                _.each(data.systemPreferences, function(sp) {
                                    if (sp.valueType == 'bool') {
                                        sp.value = sp.value === '0' ? false : sp.value === '1' ? true : !!sp.value;
                                        //CSH 29052018 I've added this next line because the value that we hold for recipe lite
                                        //on the db is the inverse of the question being asked on the UI. I.e. Do you want
                                        //to add pricing to recipes, but that should result in a false value on the database.
                                        if (sp.systemPreferenceTypeId == enums.systemPreferenceEnum.recipeLite) {
                                            sp.value = !sp.value;
                                        }
                                    }
                                });
                            });

                            userService.hasPermission('BEAGLE_WIMD_MANAGE_SOP').then(function() {
                                recipetemplateService.listsoptemplates().then(function(data) {
                                    //CSH 09072018 We're converting the id here to a string to get the dropdowns to work
                                    //the recipe template service is correctly returning the id as a number
                                    //but the actual preference value is a string, hence when ng-options
                                    //tests for equality it returns false and doesn't match the 2 values
                                    _.each(data, function(d) {
                                        d.id = d.id.toString()
                                    });
                                    $scope.sopTemplateOptions = data;
                                });
                            });

                            userService.hasPermission('BEAGLE_WIMD_MANAGE_RECIPE_CARD').then(function() {
                                recipetemplateService.listrecipecardtemplates().then(function(data) {
                                    _.each(data, function(d) {
                                        d.id = d.id.toString()
                                    });

                                    $scope.recipecardTemplateOptions = data;
                                });
                            });

                            userService.hasPermission('BEAGLE_WIMD_MANAGE_SOP').then(function() {
                                recipetemplateService.listCostCalculatorTemplates().then(function(data) {
                                    _.each(data, function(d) {
                                        d.id = d.id.toString()
                                    });
                                    $scope.costCalculatorTemplateOptions = data;
                                });
                            });
                        }();
                }
    ];

    return {
        scope: true,
        restrict: 'E',
        controller: controller,
        templateUrl: '/ngxbeagle/dist/Content/js/directives/systemPreferences/systemPreferences.html?v=2'
    };
});

angular.module(appName)
    .factory('unitPreferencesResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/ClientSystemPreference';
            return $resource(api,
            {},
            {
                getSystemPreferencesForClient: {
                    method: 'POST',
                    url: api + '/GetSystemPreferencesForClient'
                },
                insertUpdateSystemPreferenceForClient: {
                    method: 'POST',
                    url: api + '/InsertUpdateSystemPreferenceForClient'
                },


            });
        }
    ])
angular.module(appName)
    .factory('unitPreferencesService', [
        'unitPreferencesResource', 'organisationContextService',
        function (unitPreferencesResource, organisationContextService) {
            return {
                getSystemPreferencesForCurrentClientUnit: function() {
                    var context = organisationContextService.getContext();
                    if (context) {
                        var dto = {
                            id: context.currentSubscriptionUnit.id, 
                            clientId: context.currentSubscriptionUnit.client.id
                        };
                        return this.getSystemPreferencesForClient(dto).$promise;
                    } 
                },
                getSystemPreferencesForClient: function (model) {
					var promise = unitPreferencesResource.getSystemPreferencesForClient(model);
                    return promise;
                },
                insertUpdateSystemPreferenceForClient: function (model) {
                    return unitPreferencesResource.insertUpdateSystemPreferenceForClient(model);
                }
            };
        }
    ]);


/*

    Adds a div to use inside a table tracking a true/false

*/
angular.module(appName)
   .directive('tableLoad', function () {
       var controller = [
           '$scope',
           function ($scope) {

           }
       ];

       return {
           restrict: 'AE',
           templateUrl: '/ngxbeagle/dist/Content/js/directives/tableLoader/tableLoad.html',
           scope: {
               watch: '='
           },
           transclude: true,
           controller: controller
       }

   });

angular.module(appName)
    .directive('theme', function () {
        var controller = [
            '$rootScope', '$scope', '$element', '$attrs', 'localStorageService', 'enums',
            function ($rootScope, $scope, $element, $attrs, localStorageService, enums) {
                var self = this;
                self.ctx = localStorageService.getItem(enums.localStorage.organisationContext);
                self.siteColour = null;
                self.logoUrl = null;
                self.backgroundDarkenPercentage = $attrs.darkenPercentage || 0;

                self.updateTheme = function (colour) {
                    switch ($element[0].tagName.toLowerCase()) {
                        case 'div':
                        case 'li':
                            $element.css('background-color', self.shadeColour(colour, self.backgroundDarkenPercentage));
                            break;
                        case 'span':
                          $element.css('background-color', self.shadeColour(colour, self.backgroundDarkenPercentage));
                        break;
                        case 'a':
                        case 'p':
                            if ('backgroundColor' in $attrs)
                                $element.css('background-color', self.shadeColour(colour, self.backgroundDarkenPercentage));
                            else
                                $element.css('color', self.shadeColour(colour, self.backgroundDarkenPercentage));
                            break;
                        case 'img':
                            if (self.logoUrl != null) {
                                $element.attr('src', self.logoUrl);
                            }
                            break;
                        default:
                            console.log('You have applied the "theme" directive to an invalid element.');
                            break;
                    }
                    if (self.hasBorder()) {
                        $element.css('border-color', self.shadeColour(colour, -.2));
                    }
                }

                self.hasBorder = function() {
                    return $element.css('border-color') ||
                        $element.css('border-top-color') ||
                        $element.css('border-left-color') ||
                        $element.css('border-bottom-color') ||
                        $element.css('border-right-color');
                }


                self.shadeColour = function (color, percent) {
                    if (color) {
                        var f = parseInt(color.slice(1), 16),
                            t = percent < 0 ? 0 : 255,
                            p = percent < 0 ? percent * -1 : percent,
                            R = f >> 16,
                            G = f >> 8 & 0x00FF,
                            B = f & 0x0000FF;
                        return '#' +
                            (0x1000000 +
                                (Math.round((t - R) * p) + R) * 0x10000 +
                                (Math.round((t - G) * p) + G) * 0x100 +
                                (Math.round((t - B) * p) + B)).toString(16)
                            .slice(1);
                    }
                }

                $rootScope.$on(enums.broadcasts.updatedContext,
                    function (evt, args) {
                        self.ctx = args.context;
                        self.siteColour = self.ctx.siteColour;
                        self.logoUrl = self.ctx.logoUrl;
                        self.updateTheme(self.siteColour);
                    });

                self.init = function () {
                    if (self.ctx != null && self.ctx.siteColour != null) {
                        self.siteColour = self.ctx.siteColour;
                        self.logoUrl = self.ctx.logoUrl;
                        self.updateTheme(self.siteColour);
                    }
                }();
            }
        ];

        return {
            controller: controller,
            restrict: 'A'
        }
    })
angular.module(appName)
    .directive('tranmissionOrganisationcontacts', function ($rootScope) {
        var controller = [
            '$scope', '$element', '$attrs', '$compile', '$translate','$http', function ($scope, $element, $attrs, $compile, $translate,$http) {

                $scope.Updating = false;

                var getContacts = function () {
                    var getOptions = {
                        params: {
                            organisationId: $scope.orgid
                        }
                    }
                    //todo wrap in service
                    $http.get('/api/clientexport/Contacts', getOptions).then(function (response) {

                        $scope.contacts = response.data;
                    });
                }

                $scope.init = function () {
                    getContacts();
                }();



                $scope.sendToChange = function (contact) {
                    $scope.Updating = true;
                    $http.post('api/clientexport/UpdateContact', contact).then(function () {
                  //      getContacts();
                        $translate('success_item_updated').then(function (translation) {
                            $scope.Updating = false;
                            toastr.success(translation);
                        });

                    });
                }


            }
        ];

        return {
            restrict: 'E',
            transclude: true,
            scope: {
                orgid: '@',
                contacts:'='

            },
            templateUrl: '/ngxbeagle/dist/Content/js/directives/transmissionOrganisationContacts/transmissionorganisationcontacts.html',
            controller: controller
        };
    });

angular.module(appName).directive('uiSelectHighlander', ['$rootScope', function ($rootScope) {
    return {
        require: 'uiSelect',
        link: function (scope, element, attrs, $select) {
            var id = uuid.v4();
            $rootScope.$on('uis-highlander:activate', function(obj, params) {
                if (id !== params.id) {
                    $select.close();
                }
            });
            scope.$on('uis:activate', function () {
                $rootScope.$broadcast('uis-highlander:activate', {id:id});
            });
        }
    };
}]);
angular.module('beagle')
    .directive('validate', function() {
        var controller = [
            '$scope', '$element', '$attrs',
            function ($scope, $element, $attrs) {
                
            }
        ];

        return {
            restrict: 'A',
            scope: {
                validate: '&',
                binding: '=ngModel'
            },
            require: 'ngModel',
            controller: controller
        }
    })
/*

 */

angular.module(appName)
   .directive('validSelect', function () {
       return {
           require: 'ngModel',
           link: function (scope, element, attr, mCtrl) {
               mCtrl.$setValidity("Selected", false);
               function validSelect(value) {
                   if (value.id > 0) {
                       mCtrl.$setValidity("Selected", true);
                   } else {
                       mCtrl.$setValidity("Selected", false);
                   }
                   return value;
               }
               mCtrl.$parsers.push(validSelect);
           }
       };
   });
angular.module(appName)
	.factory("factoredMeasuresService",
		[
			"$http", "siteUrl", "$q",
			function($http, siteUrl, $q) {

				var baseUrl = siteUrl();

				var factoredMeasures = null;
				var getPromise = $http.get(baseUrl + "api/factored-measures");
				getPromise.then(function(result) {
					factoredMeasures = result.data;
				});

				var getMeasureFactorFromSourceAndTargetMeasureIdsSync = function(sourceMeasureId, targetMeasureId) {
					for (var i = 0; i < factoredMeasures.length; i++) {
						var fm = factoredMeasures[i];
						if (fm.sourceMeasureId == sourceMeasureId && fm.targetMeasureId == targetMeasureId) {
							return fm;
						}
					}
				};

				var getFactor = function(sourceMeasureId, targetMeasureId) {
					var deferred = $q.defer();
					getPromise.then(function() {
						var result =
							getMeasureFactorFromSourceAndTargetMeasureIdsSync(sourceMeasureId, targetMeasureId);
						deferred.resolve(result);
					});
					return deferred.promise;
				};

				var calculateIngredientFactor = function(
					originalItemMeasureId,
                    ingredientMeasureId,
					originalItemQuantity,
					originalItemPackQuantity,
                    originalItemCaseQuantity,
					ingredientQuantity) {
					var deferred = $q.defer();
					getFactor(originalItemMeasureId, ingredientMeasureId).then(function(factoredMeasure) {
						if (factoredMeasure && ingredientQuantity) {
							originalItemQuantity = originalItemQuantity || 1;
							originalItemPackQuantity = originalItemPackQuantity || 1;
                            originalItemCaseQuantity = originalItemCaseQuantity || 1;
							var factor = (ingredientQuantity * 1) /
								((originalItemQuantity * originalItemPackQuantity * originalItemCaseQuantity) / factoredMeasure.factor);
							deferred.resolve(factor.toFixed(5));

						} else {
							deferred.resolve(null);
						}
					});

					return deferred.promise;
				};

				return {
					calculateIngredientFactor: calculateIngredientFactor,
					getFactor: getFactor
				};
			}
		]);

angular.module(appName).filter('capitalWhiteSpace', function () {
	return function (input) {
	    return input ? input.replace(/([A-Z])/g, ' $1').trim() : null;
	};
});
angular.module(appName)
  .directive('convertToNumber', function () {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel) {
        ngModel.$parsers.push(function (val) {
          return parseInt(val, 10);
        });
        ngModel.$formatters.push(function (val) {
          return '' + val;
        });
      }
    };
  })


angular.module(appName).filter('localTimezoneFormat', ["localStorageService", "userService", "$filter", function (localStorageService, userService, $filter) {
    var timezoneFunction = function (inputDate, dateOnly) {

        if (inputDate == null || inputDate == '') { return ""; }
        //we ALWAYS assume the dates are coming in in format dd/MM/yyyy HH:mm.
        var myInputDate = inputDate.substring(0, 10);

        //We split the date part
        var dateSplit = "";
        var sourceDate = "";
        //This handles .net timezones back for Current date
        if (myInputDate.indexOf("-") > 0) {
            dateSplit = myInputDate.split("-");
            //construct new Date from the date provided. the default is mm dd yyyy which is why we have to do it like this.
            sourceDate = new Date(dateSplit[0], dateSplit[1] - 1, dateSplit[2]);
        }
        else {
            dateSplit = myInputDate.split("/");

            //construct new Date from the date provided. the default is mm dd yyyy which is why we have to do it like this.
            sourceDate = new Date(dateSplit[2], dateSplit[1] - 1, dateSplit[0]);
        }

        //local storage key for user's timezone
        var timezone = "user-timezone";
        var userTimezone = localStorageService.getItem(timezone);

        //the if not in local storage condition has been handled in the app.js (run method)
        userTimezone.format = userTimezone.format.substring(0, userTimezone.format.length - 6).toUpperCase();
        if (dateOnly == null || dateOnly == 'datetime') {
            userTimezone.format += ' HH:mm';
        }

        return moment(sourceDate).format(userTimezone.format);
    };

    timezoneFunction.$stateful = true;
    return timezoneFunction;
}]);

angular.module(appName).filter('makeRange', function () {
    return function (input) {
        var lowBound, highBound;
        switch (input.length) {
            case 1:
                lowBound = 0;
                highBound = parseInt(input[0]) - 1;
                break;
            case 2:
                lowBound = parseInt(input[0]);
                highBound = parseInt(input[1]);
                break;
            default:
                return input;
        }
        var result = [];
        for (var i = lowBound; i <= highBound; i++)
            result.push(i);
        return result;
    };
});
///CSH 7/11/2017 - Exactly the same as angular currency but display result without modification if not a number
angular.module(appName).filter('nanCurrency', ['$filter', function ($filter) {
    return function (input, currency) {
        if (isNaN(input)) {
            return input;
        };
        if (input === 0) {
            return '0.00';
        }
        return $filter('currency')(input, currency);
    }
}]);
///CSH 7/11/2017 - Exactly the same as angular currency but display result without modification if not a number
angular.module(appName).filter('nullableNumber', ['$filter', function ($filter) {
    return function (input, decimalPlaces) {
        if (isNaN(input)) {
            return input;
        };
        if (input === 0 || input == null || input == '') {
            return '';
        }
        return $filter('number')(input, decimalPlaces);
    }
}]);
angular.module(appName)
    .filter('orderObjectBy', function () {
        return function (items, field, reverse) {
            var filtered = [];
            angular.forEach(items, function (item) {
                filtered.push(item);
            });
            filtered.sort(function (a, b) {
                return (a[field] > b[field] ? 1 : -1);
            });
            if (reverse) filtered.reverse();
            return filtered;
        };
    });

angular.module(appName).filter('pslContextCurrency', ['$filter', 'organisationContext', function ($filter, organisationContext) {
	return function (input) {
		var currency = organisationContext.currency.name;
		if (input === 'CURRENCY_SYMBOL') {
			return currency;
		}
        return $filter('currency')(input, currency);
    }
}]);


angular.module(appName).filter('percentage', function () {
    return function (input, max) {
        if (isNaN(input)) {
            return input;
        }
        return Math.floor((input * 100) / max) + '%';
    };
});
angular.module(appName).filter('snakeCase', function () {
    return function (input) {
        if (input != null && input != typeof(undefined)) {
            input = input.replace(/([a-z])([A-Z])/g, '$1_$2');
            input = input.replace(/([A-Z])([A-Z][a-z])/g, '$1_$2');
            return input.toLowerCase();
        }
    };
});
angular.module(appName)
    .service("helpers", ['_', function (_) {
        return {
            isNullOrUndefined: function (obj) {
                return obj === undefined || obj === null;
            },
            clearUnfinishedTableEntries: function (tableEntries) {
                var unfinishedEntries = _.findWhere(tableEntries, {id: 0})
                tableEntries = _.without(tableEntries, unfinishedEntries);
                angular.forEach(tableEntries, function (entry) {
                    entry.isBeingEdited = false;
                    entry.promptAreYouSure = false;
                });
                return tableEntries;
            },
            bindReferenceToReal: function (parentDto, childDtoName, childDtoProp, array, arrayProp) {
                if (parentDto && parentDto[childDtoName]) {
                    var condition = {};
                    condition[arrayProp] = parentDto[childDtoName][childDtoProp];
                    var referenceObject = _.findWhere(array, condition);
                    if (referenceObject) {
                        parentDto[childDtoName] = referenceObject;
                    }
                }

            },
            bindReferenceToRealById: function (parentDto, childDtoName, array) {
                this.bindReferenceToReal(parentDto, childDtoName, 'id', array, 'id');
            },
            sortAscendingCaseInsensitive: function (array, sortBy) {
                return _.sortBy(array, function (i) {
                    return _.propertyOf(i)(sortBy).toLowerCase();
                });
            },
            /*
             * Does a string comparison to check if a value exists within a property.
             *
             * `caseSensitive`: Whether or not the string comparison should be case sensitive (default: false)
             */
            contains: function (property, value, caseSensitive) {
                var propertyString = property.toString();
                return caseSensitive ?
                    propertyString.indexOf(value) > -1 :
                    propertyString.toLowerCase().indexOf(value.toLowerCase()) > -1;
            }
        }
    }
    ]);


var Timer = function (name) {
    this.startTime = null;
    this.endTime = null;
    this.name = name;
};

Timer.prototype = {
    start: function () {
        this.startTime = new Date();
    },

    stop: function () {
        this.endTime = new Date();
        var time = this.endTime.getTime() - this.startTime.getTime();
        console.log(this.name + ' executed in ' + time + 'ms');
    }
}
angular.module(appName)
    .service("validationHelper",
        [
            "moment",
            function (moment) {
                var self = this;
                self.regex = {
                    digit: /^[0-9]+$/,
                    alphanumeric: /^([a-zA-Z0-9\s])+$/,
                    alphabetical: /^([a-zA-Z\s])+$/,
                    decimal: /^\$?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(\.[0-9]+)?$/,
                    decimalStrict: /\d+\.{1}\d+/,
                    ukDate:
                    /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
                password: /^((?=.*\d)(?=.*[a - z])(?=.*[A - Z])(?=.*[\W]).{8, 64 })/
	        };

                /* Private functions to expose */
                self.functions = {
                    isNumber: function (input) {
                        var passRegex = self.regex.digit.test(input);
                        var trimmedNumber = input;

                        if (typeof input == "string")
                            trimmedNumber = parseInt(input.replace(",", ""));

                        return passRegex || parseInt(trimmedNumber);
                    },
                    isDecimal: function (input, strict) {
                        if (strict) {
                            return self.regex.decimalStrict.test(input);
                        } else {
                            return self.regex.decimal.test(input);
                        }
                    },
                    isAlphanumeric: function (input) {
                        return self.regex.alphanumeric.test(input);
                    },
                    isAlphabetical: function (input) {
                        return self.regex.alphabetical.test(input);
                    },
                    isNullOrWhiteSpace: function (input) {
                        return input == null || input == "";
                    },
                    isGreaterThan: function (a, b) {
                        return a > b;
                    },
                    isLessThan: function (a, b) {
                        return a < b;
                    },
                    isMobile: function (customWidth) {
                        if (!customWidth)
                            customWidth = 976;
                        var media = "only screen and (max-width:" + customWidth + "px)";
                        return window.matchMedia(media).matches;
                    },
                    isDuplicate: function (a, b, typeCheck) {
                        return typeCheck == true ? a === b : a == b;
                    },
                    isNegative: function (x) {

                        if (x === null || x === undefined) {
                            return false;
                        }
                        if (typeof (x) === 'string') {
                            //get rid of any currency or percent symbols, leave decimal points and minus operators;
                            var onlyDigitsDecimalsAndMinusOperator = x.replace(/[^0-9.-]/g, '');
                            return parseFloat(onlyDigitsDecimalsAndMinusOperator) < 0;
                        } else if (typeof (x) === 'number') {
                            return x < 0;
                        } else {
                            console.log("typeof(x)", typeof (x));
                        }
                    },

                    startDateLaterThanEndDate: function (startDateInput, endDateInput) {
                        var start = moment(startDateInput, 'DD-MM-YYYY');
                        var end = moment(endDateInput, 'DD-MM-YYYY');
                        return start.isAfter(end);
                    }
                };
                return {
                    regex: self.regex,
                    isNumber: function (input) {
                        return self.regex.digit.test(input);
                    },
                    isAlphanumeric: function (input) {
                        return self.regex.alphanumeric.test(input);
                    },
                    isAlphabetical: function (input) {
                        return self.regex.alphabetical.test(input);
                    },
                    isDecimal: function (input) {
                        return self.functions.isDecimal(input);
                    },
                    isDecimalStrict: function (input) {
                        return self.functions.isDecimal(input, true);
                    },
                    isNullOrWhiteSpace: function (input) {
                        return self.functions.isNullOrWhiteSpace(input);
                    },
                    isDateAfter: function (dateA, dateB, format) {
                        var momentA = moment(dateA);
                        var momentB = moment(dateB);
                        return moment(momentA).isAfter(momentB);
                    },
                    isDateSameOrAfter: function (dateA, dateB, format) {
                        var momentA = moment(dateA);
                        var momentB = moment(dateB);
                        return moment(momentA).isSameOrAfter(momentB);
                    },
                    isGreaterThan: function (a, b) {
                        return a > b;
                    },
                    isLessThan: function (a, b) {
                        return a < b;
                    },
                    isMobile: function () {
                        return window.matchMedia("only screen and (max-width: 976px)").matches;
                    },
                    isDuplicate: function (a, b, typeCheck) {
                        return typeCheck == true ? a === b : a == b;
                    },
                    isNegative: function (x) {
                        return self.functions.isNegative(x);
                    },
                    startDateLaterThanEndDate: function (startDate, endDate) {
                        return self.functions.startDateLaterThanEndDate(startDate, endDate);
                    },
                    isWholeNumber: function (number, allowNulls) {
                        return allowNulls && self.functions.isNullOrWhiteSpace(number) ? true : number % 1 == 0;
                    }
                };
            }
        ]);
angular.module(appName).factory("beagleAuthorizationInterceptor", [
    "$cookies", function($cookies) {

        return {
            request: function(config) {

                var token = localStorage.getItem("access_token");

                if (token !== null) {
                    config.headers["Authorization"] = "Bearer " + token;
                    $cookies.put("Authorization", "Bearer " + token);
                }

                var contextJson = localStorage.getItem("organisationContext");
                if (contextJson) {
                    var contextObject = angular.fromJson(contextJson);
                    if (contextObject) {
                        var currentSubscriptionUnit = contextObject.currentSubscriptionUnit;
                        if (currentSubscriptionUnit) {
                            var organisation = currentSubscriptionUnit.organisation;
                            if (organisation && organisation.id) {
                                config.headers["OrganisationId"] = organisation.id.toString();
                            }
                        }
                    }
                }

                return config;
            }
        };
    }
]);
angular.module(appName).factory("beagleErrorResponseInterceptor", [
    "toastService", "$q", "$location", "localStorageService", "enums",
    function (toastService, $q, $location, localStorageService, enums) {

        return {
            request: function(config) {
                var ctx = localStorageService.getItem(enums.localStorage.organisationContext);
                if (ctx) {
                    config.headers["LanguageCode"] = ctx.impersonatingUser != null ?
                        ctx.impersonatingUser.language :
                        ctx.user.language;
                }
                return config;
            },
            'responseError': function (rejection) {
                // same as above
                var token = localStorage.getItem("access_token");
                var tokenExpiry = new Date(localStorage.getItem("token_expires"));
                var currentDateTime = new Date();
                var tokenHasExpired = tokenExpiry < currentDateTime;
                var status = rejection.status;
                if (status == 400 && rejection.data && rejection.data.exceptionMessage) {
                    toastService.throwBadRequestToast(rejection.data);
                }
                if (token && !tokenHasExpired && (status == 403 || status == 401)) {
                    toastService.throwInsufficientPermissionsToast(rejection.data)
                }
                if (status == 404) {
                    toastService.throwEndpointNotFoundToast();
                }
                if (status == 500) {
                    if (rejection.data &&
                        rejection.data.exceptionMessage) {
                        toastService.error(rejection.data.exceptionMessage);
                    } else if (rejection.data.length) {
                        toastService.error(rejection.data);
                    } else {
                        if (rejection.data.exceptionType == 'System.NotImplementedException') {
                            toastService.throwNotImplementedToast();
                        }
                    }
                }
                if (status == 406) {
                    if ($location.path().toLowerCase().indexOf('/logout') < 0) {
                        $location.path("/Unauthorised");
                    }
                }
                if (status == 408) {
                    toastService.throwUnexpectedErrorToast(status);
                }
                if (status == 409) {
                    toastService.error(rejection.data);
                }


                return $q.reject(rejection);
            }
        };
    }
]);

angular.module(appName)
    .factory('beagleTemplateCacheInterceptor', [
        function () {
            return {
                request: function (config) {
                    if (config.method === 'GET' &&
                        config.url.substring(config.url.length - 5) === '.html') {
                        config.url = config.url + '?v=' + window.appVersion
                    }

                    return config
                }
            }
        }
    ])

angular.module(appName)
	.factory("measuresService",
		[
			"$http", "siteUrl",
			function ($http, siteUrl) {
				var baseUrl = siteUrl();

				var get = function () {
					return $http.get(baseUrl + 'api/measures', { cache: true });
                };
                var getforWIMD = function() {
                    return $http.get(baseUrl + 'api/measures/get-for-wimd');
                };
				return {
                    get: get,
                    getforWIMD: getforWIMD
				};
			}
		]);
'use strict';

angular.module(appName)
    .controller('accountingController', ['$scope', 'localStorageService', 'enums', 'toastr', '$location', 'windowService', 'procurementSubscription', 'accountingService', 'userService','translateMessage',
        function ($scope, localStorageService, enums, toastr, $location, windowService, procurementSubscription, accountingService, userService, translateMessage) {
            var self = this;
            $scope.showAddYear = false;
            $scope.showEditYear = false;
            $scope.accountingPeriods = [];
            $scope.isSavingAccountingYear = false;
            $scope.isSavingAccountingPeriods = false;


            $scope.addYear = function () {
                self.resetAllVariables();
                $scope.showAddYear = true;
                $scope.accountingYear.procurementSubscription = {};
                $scope.accountingYear.procurementSubscription.Id = $scope.procurementSubscriptionId;
            }
            $scope.cancelEdit = function () {
                if ($scope.originalAccountingYear) {
                    $scope.accountingYear.startDate = $scope.originalAccountingYear.startDate;
                    $scope.accountingYear.endDate = $scope.originalAccountingYear.endDate;
                    $scope.accountingYear.description = $scope.originalAccountingYear.description;
                    $scope.accountingYear.divisions = $scope.originalAccountingYear.divisions;
                }
                self.resetAllVariables();
                $scope.showListView = true;
            }
            self.resetAllVariables = function () {
                $scope.showAddYear = false;
                $scope.showEditYear = false;
                $scope.showListView = false;
                $scope.accountingYear = {};
                $scope.accountingPeriods = [];
            }
            self.checkIntesectingDatesInYears = function () {
                var startOrEndDateExistsAlready = false;
                _.each($scope.accountingYears, function (year) {
                    if (!startOrEndDateExistsAlready) {
                        var dateFrom = year.startDate;
                        var dateTo = year.endDate;
                        var dateCheck1 = $scope.accountingYear.startDate;
                        var dateCheck2 = $scope.accountingYear.endDate;

                        var d1 = dateFrom.split("/");
                        var d2 = dateTo.split("/");
                        var c1 = dateCheck1.split("/");
                        var c2 = dateCheck2.split("/");

                        var from = new Date(d1[2], parseInt(d1[1]) - 1, d1[0]);  // -1 because months are from 0 to 11
                        var to = new Date(d2[2], parseInt(d2[1]) - 1, d2[0]);
                        var check1 = new Date(c1[2], parseInt(c1[1]) - 1, c1[0]);
                        var check2 = new Date(c2[2], parseInt(c2[1]) - 1, c2[0]);

                        if (((check1 >= from && check1 <= to) || (check2 >= from && check2 <= to)) && year.id !== $scope.accountingYear.id) {
                            startOrEndDateExistsAlready = true;
                        }
                    }
                });
                return startOrEndDateExistsAlready;
            }
            $scope.addUpdateAccountingYear = function () {
                $scope.processing = true;
                var startOrEndDateExistsAlready = self.checkIntesectingDatesInYears();
                if (startOrEndDateExistsAlready) {
                    translateMessage.error("the_accounting_year_dates_partially_contained");
                    
                } else {
                    $scope.isSavingAccountingYear = true;
                    if ($scope.accountingYear.id) {
                    $scope.accountingYear.organisationId = self.organisationId;
                        accountingService.updateAccountingYear($scope.accountingYear, function (data) {
                            translateMessage.success("the_accounting_year_has_been_updated_successfully");
                            $scope.accountingYear = data;
                            accountingService.getAccountingPeriodsForYear($scope.accountingYear.id, function (data) {
                                if (data.length === 0) {
                                    $scope.accountingPeriods = [];
                                    self.addAccountingPeriodPlaceholders($scope.accountingYear);
                                } else {
                                    $scope.accountingPeriods = data;
                                }
                                $scope.isSavingAccountingYear = false;
                                $scope.processing = false;
                            });
                        });
                    } else {
                    $scope.accountingYear.organisationId = self.organisationId;
                        accountingService.addAccountingYear($scope.accountingYear, function (data) {
                            $scope.processing = false;
                            $scope.originalAccountingYear = angular.copy(data);
                            translateMessage.success("the_accounting_year_has_been_added_successfully");

                            $scope.accountingYear.id = data.id;
                            $scope.accountingYears.push($scope.accountingYear);
                            $scope.accountingPeriods = [];
                            self.addAccountingPeriodPlaceholders(data);
                            $scope.isSavingAccountingYear = false;
                            $scope.processing = false;
                        });
                    }
                }
            }
            self.addAccountingPeriodPlaceholders = function (accountingYear) {
                for (var x = 0; x < accountingYear.divisions; x++) {
                    if (x === 0 && x === accountingYear.divisions - 1) {
                        $scope.accountingPeriods.push({ startDate: $scope.accountingYear.startDate, endDate: $scope.accountingYear.endDate, ProcurementSubscriptionAccountingYear: $scope.accountingYear });
                    }
                    else if (x === 0) {
                        $scope.accountingPeriods.push({
                            startDate: $scope.accountingYear.startDate, ProcurementSubscriptionAccountingYear: $scope.accountingYear
                        });
                    }
                    else if (x === accountingYear.divisions - 1) {
                        $scope.accountingPeriods.push({ endDate: $scope.accountingYear.endDate, ProcurementSubscriptionAccountingYear: $scope.accountingYear });
                    } else {
                        $scope.accountingPeriods.push({ ProcurementSubscriptionAccountingYear: $scope.accountingYear });
                    }

                }
            }

            $scope.addUpdateAccountingPeriods = function () {
                $scope.processing = true;
                $scope.isSavingAccountingPeriods = true;
                var isNewPeriods = _.all($scope.accountingPeriods,
                    function (accountingPeriod) {
                        return accountingPeriod.id === undefined;
                    });
                var isExistingPeriods = _.all($scope.accountingPeriods,
                    function (accountingPeriod) {
                        return accountingPeriod.id !== undefined;
                    });

                if (isNewPeriods === false && isExistingPeriods === false) {
                    translateMessage.error("some_of_the_periods_are_new_and_some_are_old");

                }
                else if (isNewPeriods) {
                    accountingService.addAccountingPeriods($scope.accountingPeriods, function (data) {
                        $scope.processing = false;
                        $scope.isSavingAccountingPeriods = false;
                        translateMessage.success("successfully_added_accounting_periods");
                        self.resetAllVariables();
                    });
                }
                else if (isExistingPeriods) {
                    accountingService.updateAccountingPeriods($scope.accountingPeriods, function (data) {
                        $scope.processing = false;
                        $scope.isSavingAccountingPeriods = false;
                        translateMessage.success("successfully_updated_accounting_periods");
                    });

                }
            }

            $scope.editAccountingYear = function (accYear) {
                self.resetAllVariables();
                $scope.showEditYear = true;
                $scope.accountingYear = accYear;
                $scope.originalAccountingYear = angular.copy(accYear);

                accountingService.getAccountingPeriodsForYear(accYear.id,
                    function (data) {
                        if (data.length === 0) {
                            $scope.accountingPeriods = [];
                            self.addAccountingPeriodPlaceholders(accYear);
                        } else {
                            $scope.accountingPeriods = data;
                        }
                    });
            }

            $scope.checkStartDate = function () {
                if ($scope.accountingYear.startDate && $scope.accountingYear.endDate) {
                    var start = $scope.accountingYear.startDate.split("/");
                    var end = $scope.accountingYear.endDate.split("/");
                    var startDate = new Date(start[2], start[1] - 1, start[0]);
                    var endDate = new Date(end[2], end[1] - 1, end[0]);
                    if (startDate >= endDate) {
                        return true;
                    } else {
                        return false;
                    }
                }
                return false;
            };

            $scope.checkIfDatesSpanAYear = function () {
                if ($scope.accountingYear.startDate && $scope.accountingYear.endDate) {
                    var start = $scope.accountingYear.startDate.split("/");
                    var end = $scope.accountingYear.endDate.split("/");
                    var startDate = new Date(start[2], start[1] - 1, start[0]);
                    var endDate = new Date(end[2], end[1] - 1, end[0]);
                    var timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
                    var diffDays = Math.round(timeDiff / (1000 * 3600 * 24));
                    if (start[2] % 4 === 0) {
                        if (diffDays === 365) {
                            return false;
                        } else {
                            return true;
                        }
                    } else {
                        if (diffDays === 364) {
                            return false;
                        } else {
                            return true;
                        }
                    }
                }
                return false;
            };

            $scope.checkDivisionBetweenLimits = function () {
                if ($scope.accountingYear.divisions) {
                    if ($scope.accountingYear.divisions < 0 || $scope.accountingYear.divisions > 20) {
                        return true;
                    } else {
                        return false;
                    }
                }
                return false;
            };
            $scope.checkDivisionExists = function () {
                if ($scope.accountingYear.divisions) {
                    return false;
                } else {
                    return true;
                }
            };


            $scope.deleteAccountingYear = function (accountingYearId) {
                $scope.processing = true;
                accountingService.deleteAccountingYear(accountingYearId,
                    function (data) {
                        if (data.success) {
                            var item = _.find($scope.accountingYears,
                                function (myItem) {
                                    return myItem.id === accountingYearId;
                                });
                            $scope.accountingYears = _.without($scope.accountingYears, item);
                        }
                        $scope.processing = false;
                    });
            }


            $scope.changeStartDatePeriod = function (index) {
                if (index > 0) {
                    var start = $scope.accountingPeriods[index].startDate.split("/");
                    var startDate = new Date(start[2], start[1] - 1, start[0]);
                    startDate.setDate(startDate.getDate() - 1);
                    var month = startDate.getMonth() + 1;
                    if (month < 10) { month = '0' + month; }
                    var day = startDate.getDate();
                    if (day < 10) { day = '0' + day; }
                    $scope.accountingPeriods[index - 1].endDate = day + '/' + month + '/' + startDate.getFullYear();
                }

            }

            $scope.changeEndDatePeriod = function (index) {
                if (index < $scope.accountingPeriods.length - 1) {
                    var end = $scope.accountingPeriods[index].endDate.split("/");
                    var endDate = new Date(end[2], end[1] - 1, end[0]);
                    endDate.setDate(endDate.getDate() + 1);
                    var month = endDate.getMonth() + 1;
                    if (month < 10) { month = '0' + month; }
                    var day = endDate.getDate();
                    if (day < 10) { day = '0' + day; }
                    $scope.accountingPeriods[index + 1].startDate = day + '/' + month + '/' + endDate.getFullYear();
                }

            }

            $scope.checkOverlappingPeriodDates = function () {
                _.each($scope.accountingPeriods,
                    function (period) {
                        var arrayWithoutCurrentObject = _.without($scope.accountingPeriods, period);
                        _.each(arrayWithoutCurrentObject,
                            function (otherPeriod) {
                                //check if all dates for both periods exist
                                if (period
                                    .startDate &&
                                    period.endDate &&
                                    otherPeriod.startDate &&
                                    otherPeriod.endDate) {
                                    var start1 = period.startDate.split("/");
                                    var end1 = period.endDate.split("/");
                                    var startDate1 = new Date(start1[2], start1[1] - 1, start1[0]);
                                    var endDate1 = new Date(end1[2], end1[1] - 1, end1[0]);

                                    var start2 = otherPeriod.startDate.split("/");
                                    var end2 = otherPeriod.endDate.split("/");
                                    var startDate2 = new Date(start1[2], start1[1] - 1, start1[0]);
                                    var endDate2 = new Date(end1[2], end1[1] - 1, end1[0]);

                                    if (start2 === start1 ||
                                        start2 === end2 ||
                                        end2 === start1 ||
                                        end2 === end1 ||
                                        (start2 > start1 && start2 < end1) ||
                                        (end2 > start1 && end2 < end1) ||
                                        (start1 > start2 && start1 < end2) ||
                                        (end1 > start2 && end1 < end2)) {
                                        return true;
                                    }
                                }
                            });
                    });
            }
            $scope.checkPeriodStartDateLessThanEndDate = function (index) {
                var period = $scope.accountingPeriods[index];
                //if not we are covered by the required attribute
                if (period.startDate && period.endDate) {
                    var start = period.startDate.split("/");
                    var end = period.endDate.split("/");
                    var startDate = new Date(start[2], start[1] - 1, start[0]);
                    var endDate = new Date(end[2], end[1] - 1, end[0]);
                    if (startDate >= endDate) {
                        return true;
                    }
                }
                return false;
            }
            $scope.checkAllPeriodStartDateLessThanEndDate = function () {
                _.each($scope.accountingPeriods,
                    function (periodNotUsed, index) {
                        var period = $scope.accountingPeriods[index];
                        //if not we are covered by the required attribute
                        if (period.startDate && period.endDate) {
                            var start = period.startDate.split("/");
                            var end = period.endDate.split("/");
                            var startDate = new Date(start[2], start[1] - 1, start[0]);
                            var endDate = new Date(end[2], end[1] - 1, end[0]);
                            if (startDate >= endDate) {
                                return true;
                            }
                        }
                    });
                return false;
            }
            $scope.checkDuplicateYearDescriptions = function () {
                var hasDupDesc = false;
                _.each($scope.accountingYears,
                    function (year) {
                        if (year.id !== $scope.accountingYear.id &&
                            year.description === $scope.accountingYear.description)
                            hasDupDesc = true;
                    });
                return hasDupDesc;
            }

            $scope.checkDuplicatePeriodDescriptions = function () {
                var hasDupDesc = false;
                _.each($scope.accountingPeriods,
                    function (period) {
                        var arrayWithoutCurrentObject = _.without($scope.accountingPeriods, period);
                        _.each(arrayWithoutCurrentObject,
                            function (otherPeriod) {
                                if (otherPeriod.description === period.description) {
                                    hasDupDesc = true;
                                }
                            });
                    });
                return hasDupDesc;
            }
            $scope.checkDuplicatePeriodDescription = function (period) {
                var hasDupDesc = false;
                var arrayWithoutCurrentObject = _.without($scope.accountingPeriods, period);
                _.each(arrayWithoutCurrentObject,
                    function (otherPeriod) {
                        if (otherPeriod.description === period.description && period.description) {
                            hasDupDesc = true;
                        }
                    });
                return hasDupDesc;
            }
            $scope.checkYearTimeCoveredByPeriods = function () {
                var yearStart = $scope.accountingYear.startDate.split("/");
                var yearEnd = $scope.accountingYear.endDate.split("/");
                var yearStartDate = new Date(yearStart[2], yearStart[1] - 1, yearStart[0]);
                var yearEndDate = new Date(yearEnd[2], yearEnd[1] - 1, yearEnd[0]);
                var yearTimeDiff = Math.abs(yearEndDate.getTime() - yearStartDate.getTime());
                //this should be 365 or 364
                var yearDiffDays = Math.round(yearTimeDiff / (1000 * 3600 * 24));

                $scope.accountingPeriods.forEach(function (period) {
                    if (period.startDate && period.endDate) {
                        var periodStart = period.startDate.split("/");
                        var periodEnd = period.endDate.split("/");
                        var periodStartDate = new Date(periodStart[2], periodStart[1] - 1, periodStart[0]);
                        var periodEndDate = new Date(periodEnd[2], periodEnd[1] - 1, periodEnd[0]);
                        var periodTimeDiff = Math.abs(periodEndDate.getTime() - periodStartDate.getTime());
                        //this should be 27 -30 -- the dateDiff looses one day because 1/1/12 - 2/1/12 is 1 day difference!
                        var periodDiffDays = Math.round(periodTimeDiff / (1000 * 3600 * 24));
                        yearDiffDays = yearDiffDays - periodDiffDays;
                    } else {
                        return true;
                    }
                });
                //Reason why it is 11 is because 1 day is lost for the year and 12 days "lost" for the month so difference should be 11 between them instead of 12.
                if (yearDiffDays + 1 === $scope.accountingYear.divisions) {
                    return false;
                } else {
                    return true;
                }
            }
            $scope.setDatePickerMonth = function (index, period) {
                if (period.startDate && !period.endDate) {
                    $scope.accountingPeriods[index].endDate = period.startDate;
                }
            }

            $scope.init = function () {
                $scope.loadingResults = true;
                $scope.showListView = true;
                $scope.hasDeletePermission = false;
                $scope.procurementSubscriptionId = procurementSubscription.procurementSubscriptionId;
                accountingService.getAccountingYearsBySubscriptionId($scope.procurementSubscriptionId, function (data) {
                    $scope.accountingYears = data;
                    $scope.loadingResults = false;
                });

                userService.hasPermission('BEAGLE_ACCOUNTINGYEAR_DELETE').then(function() {
                    $scope.hasDeletePermission = true;
                });

                self.organisationId = localStorageService.getItem(enums.localStorage.organisationContext).organisation.id;
            }();

        }]);
'use strict';

angular.module(appName)
    .factory('accountingResource', [
        '$resource', "siteUrl", function ($resource, siteUrl) {
            var api = siteUrl() + "api/ProcurementSubscriptionAccounting";
            return $resource(api, {}, {
                addAccountingYear: {
                    method: "POST",
                    url: api + '/AddAccountingYear',
                    data: {
                        accountingYearDto: "@accountingYearDto"
                    },
                    isArray: false
                },
                addAccountingPeriods: {
                    method: "POST",
                    url: api + '/AddAccountingPeriods',
                    data: {
                        accountingPeriodDtos: "@accountingPeriodDtos"
                    },
                    isArray: true
                },
                getAccountingYearsBySubscriptionId: {
                    method: 'GET',
                    url: api + '/GetAllAccountingYearsForSubscriptionId',
                    params: {
                        id: '@id'
                    },
                    isArray: true
                },
                getAccountingPeriodsForYear: {
                    method: 'GET',
                    url: api + '/GetAccountingPeriodsForYear',
                    params: {
                        accountingYearId: '@accountingYearId'
                    },
                    isArray: true
                },

                deleteAccountingYear: {
                    method: 'DELETE',
                    url: api + '/DeleteAccountingYear',
                    params: {
                        id: '@id'
                    }
                },
                updateAccountingYear: {
                    method: "PUT",
                    url: api + '/UpdateAccountingYear',
                    data: {
                        accountingYearDto: "@accountingYearDto"
					}

                },
                updateAccountingPeriods: {
                    method: "PUT",
                    url: api + '/UpdateAccountingPeriods',
                    data: {
                        accountingPeriodDtos: "@accountingPeriodDtos"
                    },
                    isArray:true
                },
            });
        }
    ]);
angular.module(appName)
    .factory('accountingService', [
        'accountingResource',
        function (accountingResource) {
            return {
                addAccountingYear: function (accountingYearDto, cb) {
                    return accountingResource.addAccountingYear(accountingYearDto)
                        .$promise.then(function(data) {
                            cb(data);
                        });
                },
                addAccountingPeriods:function(accountingPeriodDtos, cb) {
                    return accountingResource.addAccountingPeriods(accountingPeriodDtos)
                        .$promise.then(function(data) {
                            cb(data);
                        });
                },
                getAccountingYearsBySubscriptionId: function(subscriptionId, cb) {
                    return accountingResource.getAccountingYearsBySubscriptionId({ id: subscriptionId })
                    .$promise.then(function(data) {
                        cb(data);
                    });
                },
                getAccountingPeriodsForYear:function(accountingYearId,cb) {
                    return accountingResource.getAccountingPeriodsForYear({accountingYearId:accountingYearId})
                    .$promise.then(function(data) {
                        cb(data);
                    });
                },
                deleteAccountingYear: function (id, cb) {
                    return accountingResource.deleteAccountingYear({ id: id })
                    .$promise.then(function (data) {
                        cb(data);
                    });
                },

                updateAccountingYear: function (accountingYearDto, cb) {
                    return accountingResource.updateAccountingYear(accountingYearDto)
                        .$promise.then(function (data) {
                            cb(data);
                        });
                },
                updateAccountingPeriods: function (accountingPeriodDtos, cb) {
                    return accountingResource.updateAccountingPeriods(accountingPeriodDtos)
                        .$promise.then(function (data) {
                            cb(data);
                        });
                },

            };
        }
    ]);
angular.module(appName)
    .factory('addressResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/Address';
            return $resource(api,
            {},
            {
                get: {
                    method: 'GET',
                    url: '{0}/Get'.format(api),
                    isArray: true,
                    params: {
                        organisationId: "@organisationId"
                    }
                }
            });
        }
    ])
angular.module(appName)
    .factory('addressService', [
        'addressResource',
        function (addressResource) {
            return {
                get: function(orgId) {
                    return addressResource.get({ organisationId: orgId });
                }
            };
        }
    ]);
// eslint-disable-next-line no-undef
angular.module(appName)
  .controller("advancedSearchController",
    [
      "$scope",
      "$routeParams",
      "entityContext$",
      "enums",
      "localStorageService",
      "siteUrl",
      function ($scope,
                $routeParams,
                entityContext$,
                enums,
                localStorageService,
                siteUrl) {
        entityContext$.$promise.then(function (context) {
          var bearerToken = localStorage.getItem('access_token'),
            organisationContext = localStorageService.getItem('organisationContext'),
            clientId = organisationContext.currentSubscriptionUnit.client.id,
            organisationId = organisationContext.currentSubscriptionUnit.organisation.id,
            self = this;

          self.getReturnUrl = function () {
            switch (context.procurementBasketType) {
              case enums.procurementBasketTypeInt.OrderGuide:
                return '/orderguide/' + $routeParams.entityId;
              case enums.procurementBasketTypeInt.ShoppingList:
                return '/shoppinglists/view/' + $routeParams.entityId;
              case enums.procurementBasketTypeInt.ProcurementBasket:
                return '/baskets/view/' + $routeParams.entityId
            }
          }

          $scope.config = {
            endpoints: {
              attributeEndpoint: window.urls.advancedSearchAttributeEndpoint + '&api-key=' + window.urls.advancedSearchAttributeApiKey,
              contextEndpoint: siteUrl() + '/api/ProcurementSegmentItems/AddSearchToSegment',
              saveEndpoints: {},
              replaceEndpoints: {},
              savedSearchEndpoint: siteUrl() + '/api/savedsearch',
              skuSearchEndpoint: window.urls.advancedSearchSkuSearchEndpoint,
              measuresEndpoint: window.urls.advancedSearchMeasuresEndpoint,
              factoredMeasuresEndpoint: window.urls.advancedSearchFactoredMeasuresEndpoint,
              returnUrl: self.getReturnUrl()
            },
            userContext: {
              bearerToken: bearerToken,
              clientId: clientId,
              organisationId: organisationId,
              language: organisationContext.impersonatingUser ? organisationContext.impersonatingUser.language : organisationContext.user.language
            },
            entityContext: {
              entityId: $routeParams.entityId,
              entityType: context.procurementBasketType,
              segmentId: $routeParams.segmentId && $routeParams.segmentId !== 0 ? $routeParams.segmentId : null,
              basketItemId: $routeParams.basketItemId
            },
            dynamicEnums: {
              attributeGroups: {
                supplier: window.appSettings.suppplierAttributeAttributeGroupId
              },
              externalAttributeGroupTypeId: window.appSettings.advancedSearchExternalAttributeGroupTypeId
            }
          };
          $scope.config.endpoints.saveEndpoints[enums.procurementBasketType.OrderGuide] = siteUrl() + '/api/ProcurementSegmentItems/AddSearchToSegment';
          $scope.config.endpoints.saveEndpoints[enums.procurementBasketType.ShoppingList] = siteUrl() + '/api/ProcurementSegmentItems/AddSearchToSegment';
          $scope.config.endpoints.saveEndpoints[enums.procurementBasketType.ProcurementBasket] = siteUrl() + '/api/Basket/AddBasketItem';
          $scope.config.endpoints.replaceEndpoints[enums.procurementBasketType.OrderGuide] = siteUrl() + '/api/OrderGuides/ReplaceBasketItem';
          $scope.config.endpoints.replaceEndpoints[enums.procurementBasketType.ShoppingList] = siteUrl() + '/api/ShoppingList/ReplaceBasketItem';
          $scope.config.endpoints.replaceEndpoints[enums.procurementBasketType.ProcurementBasket] = siteUrl() + '/api/Basket/ReplaceBasketItem';

          if (context.procurementBasketType === enums.procurementBasketTypeInt.OrderGuide) {
            $scope.config.entityContext.additionalData = {
              sheetType: context.sheetType
            }
          }
        })
      }
    ])

angular.module(appName).controller('allowanceController', [
    '$scope', '$rootScope', '$q', 'enums', 'allowanceService', 'translateMessage',
    '_', '$routeParams', 'localStorageService', 'importContext',
    function ($scope, $rootScope, $q, enums, allowanceService, translateMessage,
        _, $routeParams, localStorageService, importContext
    ) {
            $scope.goToUploadMode = function () {
                $scope.uploadMode = true;
                $scope.validationErrorMode = false;
            };

            $scope.goToValidationErrorMode = function () {
                $scope.validationErrorMode = true;
                $scope.uploadMode = false;
            };

            $scope.processAllowanceFile = function(uploadedFile) {
                var dto = {
                    documentId: uploadedFile.id,
                    id: $scope.context.id
                };

                if ($scope.importContext === 'UNIT') {
                    dto.id = $scope.context.currentSubscriptionUnit.id;
                    dto.procurementSubscriptionUnitId = $scope.context.currentSubscriptionUnit.id;
                    dto.procurementSubscriptionId = $scope.context.id;
                    var promise = allowanceService.processUnitAllowanceFile(dto).$promise;
                } else {
                    var promise = allowanceService.processAllowanceFile(dto).$promise;
                }

                promise.then(function(validationData) {
                    if (validationData.validationErrors && validationData.validationErrors.length > 0) {
                        $scope.validationErrors = validationData.validationErrors;
                        $scope.goToValidationErrorMode();
                    } else {
                        $scope.numberOfImportedRows = validationData.numberOfImportedRows;
                        translateMessage.success('file_imported_successfully');
                        $rootScope.$broadcast(enums.broadcasts.fileImported);
                        $scope.goToUploadMode();
                    }
                },function(error) {
                    $scope.goToUploadMode();
                });

                return promise;
            };

            $scope.init = function () {
                $scope.goToUploadMode();
                $scope.context = localStorageService.getItem(enums.localStorage.organisationContext);
                $scope.importContext = importContext;
            }();
    }
]);
angular.module(appName)
    .factory('allowanceResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/Allowance';
            return $resource(api,
            {},
            {
                processAllowanceFile: {
                    method: "POST",
                    url: api + "/ProcessFile"
                },
                processUnitAllowanceFile: {
                method: "POST",
                url: api + "/ProcessUnitAllowanceFile"
        }
                
                
            });
        }
    ])
angular.module(appName)
    .factory('allowanceService', [
        'allowanceResource','$window',
        function (allowanceResource, $window) {
            return {
                processAllowanceFile: function (dto) {
                    return allowanceResource.processAllowanceFile(dto);
                },
                processUnitAllowanceFile: function (dto) {
                    return allowanceResource.processUnitAllowanceFile(dto);
                }
            };
        }
    ]);
angular.module(appName)
	.controller("allowanceReportController", [
		"$scope", "$http", "organisationContext", "$route", "validationHelper", "paginationFactory", "enums", "fileDownloadService",
		function($scope, $http, organisationContext, $route, validationHelper, paginationFactory, enums, fileDownloadService) {

			paginationFactory.addPaginationVariablesAndFunctionsToScope($scope);

			$scope.currencySymbol = organisationContext.currency.name;
			$scope.startDate = "";
			$scope.endDate = "";
			$scope.reportTypes = { group: 0, unit: 1 };
			$scope.tableRows = [];
			$scope.sortOn = {
				column: "allowanceDate",
				sortState: "Descending"
			};
			var procurementSubscriptionId = organisationContext.id;
			var procurementSubscriptionUnitId = organisationContext.currentSubscriptionUnit.id;

			$scope.reportType = $route.current.$$route.originalPath.indexOf("GroupAllowanceReport") > -1 ? $scope.reportTypes.group : $scope.reportTypes.unit;

			var baseUrl = '/api/allowanceReport/';
			var baseSearchUrl = baseUrl + "group/" + procurementSubscriptionId;

			if ($scope.reportType === $scope.reportTypes.unit)
				baseSearchUrl = baseSearchUrl + "/unit/" + procurementSubscriptionUnitId;

			var buildSearchCriteria = function() {
				var sortOn = $scope.sortOn;
				var sortCol = sortOn ? sortOn.column : null;
				var sortDirection = sortOn ? sortOn.sortState : null;
				return {
					params: {
						startDate: $scope.startDate,
						endDate: $scope.endDate,
						resultsPerPage: $scope.pagination.numPerPage,
						startPage: $scope.pagination.currentPage,
						sortCol: sortCol,
						sortDirection: sortDirection
					}
				};
			};

			var buildExportUrl = function () {
			    var url;
			    if ($scope.reportType === $scope.reportTypes.unit)
                    // Passing the subscriptionId for permissions
			        url = baseUrl + 'ExportUnit?id=' + procurementSubscriptionId + '&unitId=' + procurementSubscriptionUnitId;
			    else
			        url = baseUrl + 'ExportGroup?id=' + procurementSubscriptionId;

                // This is to prevent sending "undefined" in the query parameters if you delete a start/end date.
			    if (!$scope.startDate) $scope.startDate = '';
			    if (!$scope.endDate) $scope.endDate = '';
				
			    url += '&startDate=' + $scope.startDate + '&endDate=' + $scope.endDate;
			    console.log(url);
			    return url;
			};
			var search = function() {
				$scope.searching = true;
				$http.get(baseSearchUrl, buildSearchCriteria()).then(function (result) {
					$scope.hasSearched = true;
					$scope.tableRows = result.data.list;
					$scope.pagination.total = result.data.total;
				}).finally(function() {
					$scope.searching = false;
				});
			};

			$scope.exportData = function () {
			    var exportUrl = buildExportUrl;
			    fileDownloadService.downloadFile(buildExportUrl(), "AllowanceReport", "csv");
			};
			$scope.trySearch = function() {
				$scope.invalidEndDate = validationHelper.startDateLaterThanEndDate($scope.startDate, $scope.endDate);
				if (!$scope.invalidEndDate)
					search();
			};

			$scope.$watch("pagination.currentPage", function(newVal, oldVal) {
				if (newVal !== oldVal)
					search();
			});

			$scope.$on(enums.eventNames.sortOnElementChangedEventName, function(event, changingElement) {
				if (event.targetScope === $scope) {
					search();
				};
			});

			search();
		}
	])
'use strict';

angular.module(appName)
    .controller('allowanceTypesController', [
        '$scope',
        'allowanceTypesService',
        'allowanceTypesData',
        'toastr',
        'autoFocus',
        'context',
        'helpers',
        'localStorageService',
        'enums',
        'userService',
        'translateMessage',
        function ($scope, allowanceTypesService, allowanceTypesData, toastr, autoFocus, context, helpers, localStorageService, enums, userService, translateMessage) {

            var self = this;

            $scope.add = function () {
                clearUnfinishedEntries();
                if (window.innerWidth < 768) {
                    window.scrollTo(0, document.body.scrollHeight);
                }
                autoFocus.implement("input");
                $scope.existingAllowanceTypes = angular.copy($scope.allowanceTypes);
                $scope.allowanceTypes.push({ id: 0, description: "", headOfficeAllowanceTypeCode: "", procurementSubscriptionId: context.id });
                $scope.cachedAllowanceType = ({ id: 0, description: "", headOfficeAllowanceTypeCode: "", procurementSubscriptionId: context.id });
            }

            $scope.edit = function (allowanceType) {
                clearUnfinishedEntries();
                $scope.existingAllowanceTypes = angular.copy($scope.allowanceTypes);
                $scope.cachedAllowanceType = angular.copy(allowanceType);
                allowanceType.isBeingEdited = true;
            }

            $scope.delete = function (allowanceType) {
                if (!allowanceType.isInUse) {
                    allowanceType.processing = true;
                    allowanceTypesService.remove(context.id, allowanceType.id).$promise.then(function (data) {
                        allowanceType.processing = false;
                        if (data.success) {
                            $scope.allowanceTypes =
                                helpers.sortAscendingCaseInsensitive(
                                _.without($scope.allowanceTypes, allowanceType),
                                'description');                         

                            translateMessage.success("your_allowance_type_was_sucessfully_removed");
                        }
                        else {

                            translateMessage.error("something_went_wrong_please_try_again_later");
                        }                        
                    });
                }
                else {
                    translateMessage.error("sorry_you_cannot_delete_this_allowance_type");
                }
            }

            $scope.saveChanges = function (allowanceType) {
                var apparentDuplicateDescriptions = _.where($scope.allowanceTypes, { description: allowanceType.description });
                _.each(apparentDuplicateDescriptions, function (description) {
                    description.isDuplicate = description.id != allowanceType.id;
                });
                var isDuplicateDescription = _.findWhere(apparentDuplicateDescriptions, { isDuplicate: true });
                var apparentDuplicateCodes = _.where($scope.allowanceTypes, { headOfficeAllowanceTypeCode: allowanceType.headOfficeAllowanceTypeCode });
                _.each(apparentDuplicateCodes, function (code) {
                    code.isDuplicate = code.id != allowanceType.id;
                });
                var isDuplicateCode = _.findWhere(apparentDuplicateCodes, { isDuplicate: true });
                if (isDuplicateDescription || isDuplicateCode) {
                    translateMessage.error("this_allowance_type_is_already_being_used");

                    if (allowanceType && allowanceType.id == 0) {
                        $scope.add();
                    }
                    else if (allowanceType && $scope.cachedAllowanceType) {
                        allowanceType.description = $scope.cachedAllowanceType.description;
                        allowanceType.headOfficeAllowanceTypeCode = $scope.cachedAllowanceType.headOfficeAllowanceTypeCode;
                        allowanceType.isBeingEdited = true;
                    }
                }
                else {
                    if (allowanceType.id !== 0) {
                        allowanceType.processing = true;
                        var allowanceType = _.findWhere($scope.allowanceTypes, { id: allowanceType.id });
                        allowanceType.organisationId = self.headOfficeOrganisationId;
                        allowanceTypesService.update(allowanceType, allowanceType.isBeingEdited = false).$promise.then(function (data) {
                            allowanceType.processing = false;
                            translateMessage.success("your_allowance_type_was_saved_successfully");
                            clearUnfinishedEntries();
                            $scope.allowanceTypes = helpers.sortAscendingCaseInsensitive($scope.allowanceTypes, 'description');                           
                        });
                    }
                    else {
                        $scope.saveNew(allowanceType);
                    }
                }
            }

            $scope.cancelChanges = function (allowanceType) {
                console.log('cancel', allowanceType);
                if (allowanceType && $scope.cachedAllowanceType) {
                    allowanceType.description = $scope.cachedAllowanceType.description;
                    allowanceType.headOfficeAllowanceTypeCode = $scope.cachedAllowanceType.headOfficeAllowanceTypeCode;
                }
                clearUnfinishedEntries();
            }

            $scope.saveNew = function (allowanceType) {
                allowanceType.processing = true;
                allowanceType.organisationId = self.headOfficeOrganisationId;
                allowanceTypesService.add(allowanceType).$promise.then(function (data) {
                    allowanceType.processing = false;
                    clearUnfinishedEntries();
                    $scope.allowanceTypes.push(data);
                    $scope.allowanceTypes = helpers.sortAscendingCaseInsensitive($scope.allowanceTypes, 'description');

                    translateMessage.success("your_allowance_type_was_saved_successfully");
                          
                });
            }

            $scope.areYouSure = function (allowanceType) {
                allowanceType.promptAreYouSure = !allowanceType.promptAreYouSure;
            }

            $scope.init = function () {
                $scope.hasDeletePermission = false;
                allowanceTypesData.$promise.then(function (data) {
                    $scope.allowanceTypes = data;
                });

                userService.hasPermission('BEAGLE_ALLOWANCETYPES_DELETE').then(function() {
                    $scope.hasDeletePermission = true;
                });

                self.headOfficeOrganisationId = localStorageService.getItem(enums.localStorage.organisationContext).organisation.id;
            }();

            function clearUnfinishedEntries() {
                $scope.allowanceTypes = helpers.clearUnfinishedTableEntries(
                    helpers.sortAscendingCaseInsensitive($scope.allowanceTypes, 'description'));
            }

        }]);
'use strict';

angular.module(appName)
    .factory('allowanceTypesResource', [
        '$resource', "siteUrl", function ($resource, siteUrl) {
            var api = siteUrl() + "api/ProcurementClientAllowanceTypes";
            return $resource(api, {}, {
                get: {
                    method: "GET",
                    url: api + '/Get',
                    params: {
                        id: "@id",
                        organisationId: '@organisationId'
                    },
                    isArray: true
                },
                add: {
                    method: "POST",
                    url: api + "/Add"
                },
                update: {
                    method: "PUT",
                    url: api + "/Update"
                },
                remove: {
                    method: "DELETE",
                    url: api + "/Delete",
                    params: {
                        procurementSubscriptionId: "@procurementSubscriptionId",
                        id: "@id"
                    }
                }
            });
        }
    ]);
angular.module(appName)
    .factory('allowanceTypesService', [
        'allowanceTypesResource', 'organisationContextService',
        function (allowanceTypesResource, organisationContextService) {
            var self = this;
            self.ctx = organisationContextService.getContext();
            return {
				get: function (procurementSubscriptionId, cb) {
					procurementSubscriptionId = procurementSubscriptionId ||
						self.ctx.currentSubscriptionUnit.procurementSubscriptionId;
                    return allowanceTypesResource.get({ id: procurementSubscriptionId, organisationId: self.ctx.currentSubscriptionUnit.organisation.id }).$promise.then(cb);
                },
                add: function (model) {
                    return allowanceTypesResource.add(model);
                },
                update: function (model) {
                    return allowanceTypesResource.update(model);
                },
                remove: function(procurementSubscriptionId, id) {
                    return allowanceTypesResource.remove({ procurementSubscriptionId: procurementSubscriptionId, id: id});
                }
            };
        }
    ]);

angular.module(appName)
    .factory('applicationModuleFactory', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/ApplicationModule';
            return $resource(api,
            {},
            {
                getModulesForOrganisation: {
                    method: 'GET',
                    url: '{0}/GetModulesForOrganisation'.format(api),
                    isArray: true,
                    params: {
                        organisationId: "@organisationId",
                        applicationId: "@applicationId"
					}
                },
                getPermissionsInModules: {
                    method: 'GET',
                    url: '{0}/GetPermissionsInModules'.format(api),
                    isArray: true,
                    params: {
                        applicationId: "@applicationId"
                    }
                }
            });
        }
    ])

'use strict';

angular.module(appName)
    .controller('basketCheckoutController', ['$scope', 'basketService', 'basketData', 'basketItemData', 'toastr', '$location',
        function ($scope, basketService, basketData, basketItemData, toastr, $location) {
            
            $scope.orderBasket = function (basket) {
                if (basket.procurementBasket.procurementBasketStatus.id == 1) {
                    // First order
                }
                else {
                    // Reorder
                }
            }

            $scope.init = function () {
                basketData.$promise.then(function (data) {
                    $scope.basket = data;
                });
            }();

        }]);
'use strict';
angular.module(appName).controller('basketListPageController', [
    '$scope', 'basketService', 'basketListData','localStorageService', 'enums',
    'translateMessage', '$location', 'windowService', 'helpers', '$q', '$translate',
    '$filter', '$timeout',
    function ($scope, basketService, basketListData,localStorageService, enums,
        translateMessage, $location, windowService, helpers, $q, $translate,
        $filter, $timeout
    ) {
        var self = this;
            $scope.basketFilter = {}
            $scope.enums = enums; //for using in html templates

            $scope.unsubmitBasket = function(basket) {
                basket.isUnsubmitting = true;
                basketService.unsubmitBasket(basket.id).then(function() {
                    basket.procurementBasketStatusId = enums.procurementBasketStatus.Open;
                    basket.canBeUnsubmitted = false;
                }).finally(function() {
                    basket.isUnsubmitting = false;
                });
            }

            $scope.getViewBasketUrl = function(basketId) {
                var url = '/baskets/view/' + basketId;
                return url;
            }

            $scope.toggleSetupBasket = function () {
                windowService.viewBasket(null);
            }

            $scope.toggleActions = function (basket) {
                basket.promptAreYouSure = false;
                basket.showActions = !basket.showActions;
            }

            $scope.deleteBasket = function (basket) {
                basket.isDeleting = true;
                basketService.deleteBasket(basket.id).then(function (data) {
                    if (data.success) {
                        translateMessage.success('label_basket_deleted');
                        $scope.filteredSortedBaskets = _.without($scope.filteredSortedBaskets, basket);
                        self.baskets = _.without(self.baskets, basket);
                    } else {
                        translateMessage.error('error_basket_delete_generic');
                    }
                    basket.isDeleting = false;
                    basket.showActions = true;
                });
            }

	        $scope.pagedSortedBaskets = [];

	        $scope.filterSortPaginateBaskets = function (filter) {
	            var statusFilters = [];
	            if (filter.showOpenBaskets) statusFilters.push(enums.procurementBasketStatus.Open);
	            if (filter.showSubmittedBaskets) {
	                statusFilters.push(enums.procurementBasketStatus.Submitted);
	                statusFilters.push(enums.procurementBasketStatus.PartSubmitted);
                }
	            if (filter.showPartOrderedBaskets) {
	                statusFilters.push(enums.procurementBasketStatus.PartOrdered);
	            }
	            if (filter.showOrderedBaskets) {
	                statusFilters.push(enums.procurementBasketStatus.Ordered);
                }
	            var hasTerm = filter.term != '';
	            var filteredBaskets = _.filter(self.baskets,
	                function (basket) {
	                    if (filter.term == '' || !basket.name) {
                            return _(statusFilters).contains(basket.procurementBasketStatusId);
                        } else {
                            return basket.name.toLowerCase().indexOf(filter.term.toLowerCase()) >= 0 &&
	                            _(statusFilters).contains(basket.procurementBasketStatusId);
                        }
	                });
	            if ($scope.sortOn.filterExpr) {
	                if ($scope.sortOn.filterExpr.includes('dateCreated')) {
	                    $scope.sortOn.filterExpr = $scope.sortOn.filterExpr.charAt(0) + 'isoDate';
	                }
                    filteredBaskets = $filter('orderBy')(filteredBaskets, [$scope.sortOn.filterExpr]);
                } else {
	                filteredBaskets = $filter('orderBy')(filteredBaskets, ['-isoDate']);
                }

	            // MB: We had to use a timeout here due to tracking $scope.$emit events.
                //     Things were being fired before expected behaviour had occurred
                $timeout(function() {
                    $scope.filteredSortedBaskets = filteredBaskets;
                    localStorageService.setItem(enums.localStorage.basketSearch, filter);
                });
	        }

            $scope.copyBasket = function (basket) {
                basket.copyingInProgress = true;

                var model = {
                    basketIdToCopy: basket.id,
                    newBasket: {
                        name: basket.name
                    }
                };

                basketService.copyBasket(model).then(function (data) {
                    basket.showActions = false;
                    basket.copyingInProgress = false;
                    basket.promptAreYouSure = false;
                    model.newBasket.showActions = false;
                    if (data) {
                        translateMessage.success('label_basket_copied_success');
                        self.baskets.push(data.newBasket);
                        var index = _.indexOf($scope.filteredSortedBaskets, basket);

                        var newList = angular.copy($scope.filteredSortedBaskets);
                        newList.splice(index + 1, 0, data.newBasket);

                        $timeout(function () {
                            $scope.filteredSortedBaskets = newList;
                        });
                    }
                    else {
                        translateMessage.error('error_basket_copy_generic');
                    }
                });
            };

            $scope.areYouSure = function (basket) {
                basket.promptAreYouSure = !basket.promptAreYouSure;
            }

            $scope.searchProducts = function (basketId) {
                $location.path('/ProductSearch/' + basketId + '/' + enums.procurementBasketType.ProcurementBasket);
            }

            self.userHasAccountCode = function (accountCodeId) {
                return _.findWhere(self.userAccountCodes, { clientProcurementAccountCodeId: accountCodeId });
            }

            self.userHasDepartment = function (departmentId) {
                return _.findWhere(self.userDepartments, { clientProcurementDepartmentId: departmentId });
            }

            $scope.$on(enums.eventNames.sortOnElementChangedEventName, function (event, changingElement) {
                $scope.filterSortPaginateBaskets($scope.basketFilter);
            });

	        $scope.sortColumn = "UU";
	        $scope.init = function () {
            	$scope.loadingBaskets = true;
                $q.all([basketListData.$promise]).then(function(data){
                    self.baskets = _.sortBy(data[0], function (x) {
                        x.isoDate = moment(x.dateCreated,"DD/MM/YYYY");
                        return x.isoDate;
                    });
                    self.userDepartments = data[1];
                    self.userAccountCodes = data[2];

                    var storedFilters = localStorageService.getItem(enums.localStorage.basketSearch);
                    if (storedFilters) {
                        $scope.basketFilter = storedFilters;
                    } else {
                        $scope.basketFilter = {
                            term: '',
                            showOpenBaskets: true,
                            showSubmittedBaskets: false
                        }
                    }

                    self.ctx = localStorageService.getItem(enums.localStorage.organisationContext);
                    $scope.currentProcurementSubscriptionId = self.ctx.currentSubscriptionUnit.id;
                    $scope.userId = self.ctx.user.id;
                    $scope.filteredSortedBaskets = self.baskets;
                    $scope.filterSortPaginateBaskets($scope.basketFilter);
                    _.each($scope.filteredSortedBaskets, function (basket) {
                        basket.isoDate = moment(basket.dateCreated, "DD/MM/YYYY");
                    });
                    $scope.loadingBaskets = false;
                });

            }();
    }
]);
'use strict';

angular.module(appName)
    .factory('basketResource', [
        '$resource', "siteUrl", function ($resource, siteUrl) {
            var api = siteUrl() + "api/Basket";
            return $resource(api, {},
            {
                get: {
                    method: "GET",
                    url: api + '/Get',
                    params: {
                        subscriptionUnitId: "@subscriptionUnitId",
                        organisationId: "@organisationId"
                    },
                    isArray: true
                },
                getBasketCount: {
                    method: 'GET',
                    url: api + '/GetBasketCount',
                    params: {
                        basketId: '@basketId',
                        subscriptionUnitId: '@subscriptionUnitId',
                        organisationId: "@organisationId"
                    }
                },
                getBasketData: {
                    method: 'GET',
                    url: api + '/GetBasketData',
                    params: {
                      basketId: '@basketId',
                      subscriptionUnitId: '@subscriptionUnitId',
                      organisationId: "@organisationId",
                      updatePrices: '@updatePrices'
                    }
                },
                getBasketDataForProductSearch: {
                    method: 'GET',
                    url: api + '/GetBasketDataForProductSearch',
                    params: {
                        basketId: '@basketId',
                        subscriptionUnitId: '@subscriptionUnitId',
                        organisationId: "@organisationId"
                    }
                },
                getBasketWithItems: {
                    method: 'GET',
                    url: api + '/GetBasketData',
                    params: {
                        basketId: '@basketId'
                    }
                },
                getAvailableClientSupplierAccounts: {
                    method: 'GET',
					url: api + '/GetAvailableClientSupplierAccounts',
					isArray: true,
                    params: {
                        basketId: '@basketId',
                        organisationId: '@organisationId'
                    }
                },
                copyBasket: {
                    method: "POST",
                    url: api + "/Copy"
                },
                create: {
                    method: "POST",
                    url: api + "/Create"
                },

                update: {
                    method: "POST",
                    url: api + "/Update"
                },
                deleteBasket: {
                    method: "POST",
                    url: api + "/Delete",
                    params: {
                        basketId: "@basketId"
                    }
                },
                submitBasket: {
                    method: "POST",
                    url: api + "/SubmitBasket",
                },
                unsubmitBasket: {
                    method: "POST",
                    url: api + "/UnsubmitBasket",
                },
                submitAndConsolidateBasket: {
                    method: "POST",
                    url: api + "/SubmitAndConsolidateBasket",
                    isArray:true
                },
                addBasketItem: {
                    method: 'POST',
                    url: api + '/AddBasketItem'
                },
                addBasketItems: {
                    method: 'POST',
                    url: api + '/AddBasketItems',
                    isArray: true
                },
                removeBasketItem: {
                    method: 'POST',
                    url: api + '/RemoveBasketItem',
                    params: {
                        basketItemId: "@basketItemId",
                        organisationId: "@organisationId",
                        procurementBasketId: "@procurementBasketId"
                    }
                },
                updateBasketItem: {
                    method: 'POST',
                    url: api + '/UpdateBasketItem'
				},
				updateOrderGuideBasketItem: {
					method: 'POST',
					url: api + '/UpdateOrderGuideBasketItem'
				},
                getSubmittedBaskets: {
                    method: "GET",
                    url: api + '/GetSubmittedBaskets',
                    isArray: true
                },
                getBasketsWithNullPricedItems: {
                method: "POST",
                url: api + '/GetBasketsWithNullPricedItems',
                isArray: true
        }
            });
        }
    ]);

angular.module(appName)
    .factory("basketService",
    [
      '$q',
		"basketResource",
		'cachedEntityService',
		"enums",
		"organisationContextService",
		"$http",
		"siteUrl",
		function (
		  $q,
			basketResource,
      cachedEntityService,
			enums,
			organisationContextService,
			$http,
			siteUrl) {
            var orgContext = organisationContextService.getContext();
            return {
                addBasketItem: function(basketItem) {
                    basketItem.organisationId = organisationContextService.getOrganisationIdForCurrentProcurementUnit();
                    return basketResource.addBasketItem(basketItem);
                },
                addBasketItems: function(basketItems) {
                    for (index = 0; index < basketItems.length; ++index) {
                        basketItems[index].organisationId =
                            organisationContextService.getOrganisationIdForCurrentProcurementUnit();
                    }

                    return basketResource.addBasketItems(basketItems);
                },
                copyBasket: function(model, cb) {
                    var ctx = organisationContextService.getContext();
                    model.id = ctx.currentSubscriptionUnit.id;
                    model.organisationId = organisationContextService.getOrganisationIdForCurrentProcurementUnit(ctx);
                    return basketResource.copyBasket(model).$promise.then(cb);
                },
                create: function(model, cb) {
                    if (!model.organisationId) {
                        model.organisationId = organisationContextService.getOrganisationIdForCurrentProcurementUnit();
                    }
                    return basketResource.create(model).$promise.then(cb);
                },
                deleteBasket: function(basketId, cb) {
                    return basketResource.deleteBasket({
                        basketId: basketId,
                        organisationId: organisationContextService.getOrganisationIdForCurrentProcurementUnit()
                    }).$promise.then(cb);
                },
                get: function(subscriptionUnitId, organisationId, cb) {
                    return basketResource.get({
                        subscriptionUnitId: subscriptionUnitId,
                        organisationId: organisationId
                    }).$promise.then(cb);
                },
                getBasketData: function(basketId) {
                  var deferred = $q.defer();
                  var ctx = organisationContextService.getContext();
                  var cacheExpired = cachedEntityService.cachedEntityHasExpired(basketId);
                  return basketResource.getBasketData({
                    basketId: basketId,
                    subscriptionUnitId: ctx.currentSubscriptionUnit.id,
                    organisationId: organisationContextService.getOrganisationIdForCurrentProcurementUnit(),
                    updatePrices: cacheExpired
                  }).$promise.then(function (basket) {
                    if (cacheExpired) {
                      cachedEntityService.cacheEntity(basketId);
                    }

                    deferred.resolve(basket);
                    return deferred.promise;
                  });
                },
                getBasketDataForProductSearch: function(basketId) {
                    var ctx = organisationContextService.getContext();
                    return basketResource.getBasketDataForProductSearch({
                        basketId: basketId,
                        subscriptionUnitId: ctx.currentSubscriptionUnit.id,
                        organisationId: organisationContextService.getOrganisationIdForCurrentProcurementUnit()
                    });
                },
                getSubmittedBaskets: function(subscriptionUnitId, cb) {
                    return basketResource.getSubmittedBaskets({
                        id: subscriptionUnitId,
                        organisationId: organisationContextService.getOrganisationIdForCurrentProcurementUnit()
                    }).$promise.then(cb);
                },
                getAvailableClientSupplierAccounts: function(basketId) {
                    var ctx = organisationContextService.getContext();
                    return basketResource
                        .getAvailableClientSupplierAccounts({
                            basketId: basketId,
                            organisationId: ctx.currentSubscriptionUnit.organisation.id
                        });
                },
                getBasketCount: function(basketId) {
                    var ctx = organisationContextService.getContext();
                    return basketResource.getBasketCount({
                        basketId: basketId,
                        subscriptionUnitId: ctx.currentSubscriptionUnit.id,
                        organisationId: ctx.currentSubscriptionUnit.organisation.id
                    });
                },
                getBasketsWithNullPricedItems: function(basketIds, cb) {
                    var dto = {
                        organisationId: organisationContextService.getOrganisationIdForCurrentProcurementUnit(),
                        basketIds: basketIds
                    };
                    return basketResource.getBasketsWithNullPricedItems(dto).$promise.then(cb);
                },
                removeBasketItem: function(basketItemId, procurementBasketId, cb) {
                    console.log("here we go!");
                    return basketResource.removeBasketItem({
                        basketItemId: basketItemId,
                        organisationId: organisationContextService.getOrganisationIdForCurrentProcurementUnit(),
                        procurementBasketId: procurementBasketId
                    }).$promise.then(cb);
                },
                submitAndConsolidateBasket: function(dto, cb) {
                    dto.organisationId = organisationContextService.getOrganisationIdForCurrentProcurementUnit();
                    return basketResource.submitAndConsolidateBasket(dto).$promise.then(function(data) {
                        cb(data);
                    });
                },
                submitBasket: function(basketId, cb) {
                    var ctx = organisationContextService.getContext();
                    var dto = {
                        id: basketId,
                        procurementSubscriptionUnitId: ctx.currentSubscriptionUnit.id,
                        organisationId: organisationContextService.getOrganisationIdForCurrentProcurementUnit(ctx)
                    };
                    return basketResource.submitBasket(dto).$promise.then(cb);
                },
                unsubmitBasket: function(basketId) {
                    return basketResource.unsubmitBasket({
                        id: basketId
                    }).$promise;
                },
                setClientSupplierDtoOnIndividualProduct: function(productItem, availableClientSupplierAccounts) {
                    //make sure the clientSupplierDto is added to the product if an clientSupplierId was returned in the product search
                    var clientSupplierAccountId = productItem[enums.productSearchResults.clientSupplierAccountId] ||
                        (productItem.clientSupplierAccountDto ? productItem.clientSupplierAccountDto.id : null);
                    if (clientSupplierAccountId != null) {
                        productItem.clientSupplierAccountDto = _.findWhere(availableClientSupplierAccounts,
                            { id: clientSupplierAccountId });
                    }
                },
                setClientSupplierDtoOnItemsFromProductSearch: function(items, availableClientSupplierAccounts) {

                    _.each(items,
                        function(item) {
                            var clientSupplierAccountId = item[enums.productSearchResults.clientSupplierAccountId];
                            if (clientSupplierAccountId) {
                                item.clientSupplierAccountDto = _
                                    .findWhere(availableClientSupplierAccounts, { id: clientSupplierAccountId });
                            } else {
                                item.clientSupplierAccountDto = { id: null };
                            }
                        });
                },
                setClientSupplierDtoOnItemsFromDto: function(items, availableClientSupplierAccounts, cb) {

                    _.each(items,
                        function(item) {

                            if (item.clientSupplierAccountDto) {
                                var clientSupplierAccountId = item.clientSupplierAccountDto.id;
                                if (clientSupplierAccountId) {
                                    item.clientSupplierAccountDto = _
                                        .findWhere(availableClientSupplierAccounts, { id: clientSupplierAccountId });
                                }
                            }

                        });
                    cb();
                },
                update: function(model, cb) {
                    var dto = {
                        id: model.id,
                        organisationId: organisationContextService.getOrganisationIdForCurrentProcurementUnit(),
                        name: model.name,
                        isAsapDelivery: model.isAsapDelivery,
                        deliveryDate: model.deliveryDate,
                        clientProcurementDepartmentId: model.procurementClientUnitDepartment.clientProcurementDepartmentId,
                        clientProcurementAccountCodeId: model.procurementClientUnitAccountCode.clientProcurementAccountCodeId,
                        procurementClientUnitDepartmentId: model.procurementClientUnitDepartment.id,
                        procurementSubscriptionUnitId: model.procurementSubscriptionUnitId,
                        procurementBasketStatus: model.procurementBasketStatus.id
                    };
                    return basketResource.update(dto).$promise.then(cb);
                },
                updateBasketItem: function(basketItem, cb) {
                    var dto = basketItem;
                    dto.clientId = orgContext.currentSubscriptionUnit.client.id;
                    dto.organisationId = organisationContextService.getOrganisationIdForCurrentProcurementUnit();
                    return basketResource.updateBasketItem(dto).$promise.then(cb);
				},
				updateOrderGuideBasketItem: function (basketItem, cb) {
					var dto = basketItem;
					dto.clientId = orgContext.currentSubscriptionUnit.client.id;
					dto.organisationId = organisationContextService.getOrganisationIdForCurrentProcurementUnit();
					return basketResource.updateOrderGuideBasketItem(dto).$promise.then(cb);
				},
                updateBasketSortOrder: function (request) {
	                return $http.post(siteUrl() + "api/Basket/UpdateBasketSortOrder", request);
				}
            };
        }
    ]);

'use strict';

angular.module(appName)
    .controller('basketViewPageController', ['$q', '$scope', 'basketViewData', 'clientSupplierAccountData', 'localStorageService', 'windowService', 'enums',
        function ($q, $scope, basketViewData, clientSupplierAccountData, localStorageService, windowService, enums) {
            var resolves = {
                basketViewData: basketViewData,
                clientSupplierAccountData: clientSupplierAccountData
            };
            $scope.showSetupBasket = false;
            basketViewData.$promise.then(function (basket) {
                var ctx = localStorageService.getItem(enums.localStorage.organisationContext);
                $scope.currentProcurementSubscriptionId = ctx.currentSubscriptionUnit.id;
                $scope.userId = ctx.user.id;
            });

            $q.all(resolves).then(function(resolved) {
                $scope.currentBasket = resolved.basketViewData;
                $scope.clientSupplierAccounts = resolved.clientSupplierAccountData;
                $scope.showSetupBasket = true;
            });

            $scope.toggleSetupBasket = function () {
                windowService.baskets();
            }
        }]);
angular.module(appName)
	.factory("procurementItemService",
	[
		"$http","siteUrl",
		function ($http, siteUrl) {

			var url = siteUrl() + "api/procurementItems";

			return {
			    upsertProcurementItems: function (procurementItems) {
			        return $http.put(url, procurementItems);
			    },
			    deleteItems: function (procurementItems) {
			        return $http.post(url, procurementItems);
			    }
			}
		}
	]);

angular.module(appName)
	.controller("bestPricePurchasingMarkedSkusController",
		[
			"$scope",
			"bestPricePurchasingMarkedSkusService",
			"localStorageService",
			"enums",
			"$translate",
			"paginationFactory",
			"organisationContextService",
			"ngDialog",
			
			function($scope,
				bestPricePurchasingMarkedSkusService,
				localStorageService,
				enums,
				$translate,
				paginationFactory,
				organisationContextService,
				ngDialog) {
				$translate.onReady().then(function() {

					var self = this;
					self.context = organisationContextService.getContext();
					paginationFactory.addPaginationVariablesAndFunctionsToScope($scope);
					$scope.enums = enums;
					$scope.markedSkuItem = {};
					$scope.markedSkuRejectionList = {};
					$scope.selectedMarkedSkuRejection = {};
					$scope.selectedMarkedSkuRejection.id = 0;

                    $scope.searchParams = localStorageService.getItem(enums.localStorage.bestPricePurchasingSearch)
                        ? localStorageService.getItem(enums.localStorage.bestPricePurchasingSearch)
						: {
							statusIds: "",
							term: "",
							paginate: true,
							currentPage: 1,
							numPerPage: 20,
							sortField: "skuCode",
							sortAsc: true,
							showOpen: true,
							showSubmitted: true,
							showTransmitted: true,
							showPartReceived: true,
							showReceived: true
						};
					$scope.searchParams.id = self.context.currentSubscriptionUnit.id;

					$scope.sortOn = {
						column: "skuCode",
						sortState: "Ascending"
					};

					$scope.loading = {
						search: false
					};

					$scope.search = function() {
						$scope.loading.search = true;
						$scope.searchParams.id = null;
                        localStorageService.setItem(enums.localStorage.bestPricePurchasingSearch, $scope.searchParams);
						$scope.searchParams.id = self.context.currentSubscriptionUnit.id;
						bestPricePurchasingMarkedSkusService.getBestPricePurchasingMarkedSkus($scope.searchParams).then(
							function (response) {
								///CSH 21012019 Here we are parsing dates to unix timestamps so we can sort on them
								///(Sorting on the date values here doesn't work as we are doing an alphabetical sort
								///so, for example, '17/10/2018' is incorrectly sorted befor '09/10/2018'
								_.each(response.data,
									function(i) {
										i.rejectedDateForSortOn = moment(i.rejectedDate, 'DD/MM/YYYY hh:mm').unix();
										i.expiryDateForSortOn = moment(i.expiryDate, 'DD/MM/YYYY hh:mm').unix();
									});
								$scope.gridData = response.data;
								$scope.loading.search = false;
							},
							function(err) {
								$scope.loading.search = false;
								console.log(err);
							});

					};

					var getmarkedSkuRejectionList = function() {
						bestPricePurchasingMarkedSkusService.markedSkuRejectionList().then(function(result) {
								$scope.markedSkuRejectionList = result.data;
							},
							function(err) {
								console.log(err);
							});
					};

					var dialog;
					var showDialog = function() {
						dialog = ngDialog.open({
							template: 'dialog',
							disableAnimation: true,
							showClose: false,
							closeByDocument: false,
							scope:$scope
						});
					};

					$scope.hideDialog = function () {
						dialog.close();
					};

					$scope.search.showAccepted = true;
					$scope.search.showRejected = true;
					$scope.showAcceptReject = function (item) {
						if (item.isApproved) {
							return $scope.search.showAccepted;
						} else {
							return $scope.search.showRejected;
						}
					}

					$scope.$on(enums.eventNames.sortOnElementChangedEventName,
						function(event) {
							if (event.targetScope === $scope) {
								$scope.search($scope.searchParams.sortField, true);
							};
						});

					self.init = function() {
						$scope.$watchGroup(["pagination.currentPage + pagination.numPerPage"],
							function() {
								if ($scope.pagination &&
									$scope.pagination.currentPage &&
									$scope.pagination.numPerPage) {
									$scope.search(null, false);
								}
							});

						getmarkedSkuRejectionList();
					}();

					// row clicked for edit
					$scope.toggleEditItem = function(markedSkuItem) {
						if (markedSkuItem) {
							$scope.markedSkuItem = markedSkuItem;
							$scope.selectedMarkedSkuRejection.id = markedSkuItem.rejectedReasonId;
						}
						showDialog();
					};

					$scope.delete = function (item) {
						bestPricePurchasingMarkedSkusService.delete(item.id).then(function () {
							_.removeIfExists($scope.gridData, item);
						});
						console.log('item', item);
					}

					$scope.markAccepted = function(item) {
						item.isApproved = true;
					}

					$scope.markRejected = function (item) {
						item.isApproved = false;
					}

					$scope.removeExpiryDate = function(item) {
						item.expiryDate = null;
					}

					// update button clicked
					$scope.updateMarkedSku = function() {

						$scope.markedSkuItem.rejectedReasonId = $scope.selectedMarkedSkuRejection.id;
						var request = angular.copy($scope.markedSkuItem);
						if (request.expiryDate) {
							request.expiryDate = moment(request.expiryDate).format('YYYY-MM-DD');
						}
						bestPricePurchasingMarkedSkusService.update(request).then(function (result) {
								if ($scope.pagination &&
									$scope.pagination.currentPage &&
									$scope.pagination.numPerPage) {
									$scope.search(null, false);
								}
								toastr.success($translate.instant("success_marked_sku_updated"));
								dialog.close();
							},
							function(err) {
								$scope.loading.search = false;
								console.log(err);
							}).finally(function() {
							
						});
					};
				});
			}
		]);
angular.module(appName)
    .factory('bestPricePurchasingMarkedSkusService', [
        'productSearchResource',
        'organisationContextService',
        'siteUrl',
        '$http',
        function (productSearchResource, organisationContextService, siteUrl, $http) {

            var endpointUrl = siteUrl() + 'api/BestPricePurchasing/BestPricePurchasingMarkedSkus';
            var ctx = organisationContextService.getContext();
            var currentSubscriptionUnitClientId = ctx.currentSubscriptionUnit.client.id;
            var orgId = ctx.currentSubscriptionUnit.organisation.id;
            
            var service = {
                getBestPricePurchasingMarkedSkus: function (searchParams) {
                    var url = endpointUrl;

                    var fullUrl = url + "?id=" + currentSubscriptionUnitClientId +
                        "&term=" + searchParams.term +
                        "&paginate=" + searchParams.paginate +
                        "&currentPage=0" + 0 +
                        "&numPerPage=" + 10000 +
                        "&sortField=" + searchParams.sortField +
                        "&sortAsc=" + searchParams.sortAsc;

                    return result = $http.get(fullUrl);
                    
                },
                delete: function (Id) {
                    var url = endpointUrl + '/' + Id;
                    return $http.delete(url);
                },

                update: function (markedSkuItem) {
                    var url = siteUrl() + 'api/BestPricePurchasing/Update';
                    var params = "?Id=" + markedSkuItem.id + "&RejectedReasonId=" + markedSkuItem.rejectedReasonId + "&IsApproved=" + markedSkuItem.isApproved + "&ExpiryDate=" + markedSkuItem.expiryDate;
                    return $http.post(url + params);
                },

                markedSkuRejectionList: function () {
                    var url = siteUrl() + 'Api/BestPricePurchasing/GetBestPricePurchasingRejectReasons';
                    return $http.get(url);
                }
            }

            return service;
        }
    ]);
angular.module(appName).controller('budgetImportController', [
    '$scope', '$rootScope', '$q', 'enums', 'budgetImportService', 'translateMessage',
    '_', '$routeParams', 'localStorageService', 'importContext',
    function ($scope, $rootScope, $q, enums, budgetImportService, translateMessage,
        _, $routeParams, localStorageService, importContext
    ) {
                var self = this;
                $scope.goToUploadMode = function() {
                    $scope.uploadMode = true;
                    $scope.validationErrorMode = false;
                };

                $scope.goToValidationErrorMode = function() {
                    $scope.validationErrorMode = true;
                    $scope.uploadMode = false;
                };

                $scope.processBudgetImportFile = function(uploadedFile) {
                    var dto = {
                        documentId: uploadedFile.id,
                        id: $scope.context.id
                    };

                    var promise;

                    if ($scope.importContext === "UNIT") {
                        dto.id = $scope.context.currentSubscriptionUnit.id;
                        dto.procurementSubscriptionUnitId = $scope.context.currentSubscriptionUnit.id;
                        dto.procurementSubscriptionId = $scope.context.id;
                        promise = budgetImportService.processUnitBudgetImportFile(dto).$promise;
                    } else {
                        promise = budgetImportService.processBudgetImportFile(dto).$promise;
                    }

                    promise.then(function(validationData) {
                        if (validationData.validationErrors && validationData.validationErrors.length > 0) {
                            $scope.validationErrors = validationData.validationErrors;
                            $scope.goToValidationErrorMode();
                        } else {
                            $scope.numberOfImportedRows = validationData.numberOfImportedRows;
                            translateMessage.success('file_imported_successfully');
                            $rootScope.$broadcast(enums.broadcasts.fileImported);
                            $scope.goToUploadMode();
                        }
                    }, function(error) {
                        console.error("There was an error", error);
                        $scope.goToUploadMode();
                    });
                    return promise;
                };

                $scope.init = function() {
                    $scope.goToUploadMode();
                    $scope.context = localStorageService.getItem(enums.localStorage.organisationContext);
                    $scope.importContext = importContext;
                }();
    }
]);

angular.module(appName)
    .factory('budgetImportResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/BudgetImport';
            return $resource(api,
            {},
            {
                processBudgetImportFile: {
                    method: "POST",
                    url: api + "/ProcessFile"
                },
                processUnitBudgetImportFile: {
                    method: "POST",
                    url: api + "/ProcessUnitBudgetFile"
                }
                
                
            });
        }
    ])
angular.module(appName)
    .factory('budgetImportService', [
        'budgetImportResource', '$window',
        function (budgetImportResource, $window) {
            return {
                processBudgetImportFile: function (dto) {
                    return budgetImportResource.processBudgetImportFile(dto);
                },
                processUnitBudgetImportFile: function (dto) {
                    return budgetImportResource.processUnitBudgetImportFile(dto);
                }
            };
        }
    ]);
angular.module('psl.cdbAccountingSystemRegion', []);
angular.module('psl.cdbAccountingSystemRegion')
    .factory('accountingSystemsRegionFactory', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var baseUrl = siteUrl() + 'api/AccountingSystemRegion';
            return $resource(baseUrl, {}, {
                get: {
                    method: 'GET',
                    url: baseUrl,
                    isArray: true
                },
            });
        }
    ]);
angular.module('psl.cdbAccountingSystemRegion')
    .factory('accountingSystemsRegionService', [
        'accountingSystemsRegionFactory',
        function (accountingSystemsRegionFactory) {
            var service = {
                // GET
                get: function () {
                    return accountingSystemsRegionFactory.get().$promise;
                },
            }

            return service;
        }
    ]);

angular.module(appName)
    .directive("manageRoles",
        function() {

            var controller = [
                "$scope", "_", "toastr", "$q", "organisationRoleFactory",
                "organisationContextService", "applicationModuleFactory", "enums",
                "accessService","$translate",
                function($scope, _, toastr, $q, organisationRoleFactory, organisationContextService,
                    applicationModuleFactory, enums, accessService, $translate) {
                    $translate.onReady().then(function() {

                        var self = this;
                        self.context = organisationContextService.getContext();
                        $scope.initialLoading = $q.defer();

                        $scope.changeRoleName = function(previousName, updatedName, role) {

                            var amendOrganisationRoleDto = {
                                organisationId: self.context.organisation.id,
                                organisationRoleDto: {
                                    name: updatedName,
                                    id: role.organisationRoleId
                                }

                            };
                            return organisationRoleFactory.saveOrganisationRole(amendOrganisationRoleDto)
                                .$promise.then(function() {
                                    toastr.success($translate.instant("saved"));

                                    return updatedName;
                                });
                        };

                        self.init = function() {

                            var addedBecauseOfModules = [];
                            var addedAll = [];
                            var excludedFromModel = [];

                            switch ($scope.applicationEnum.toUpperCase()) {
                            case "EPROCUREMENT":
                                var getPermissonsWithAssignedRolesPromise = organisationRoleFactory
                                    .getPermissionsWithAssignedRoles({ groupOrgId: $scope.groupOrganisation.id })
                                    .$promise;
                                var getApplicationModulesPromise = accessService.getApplicationModules(
                                    enums.currentApplication.id,
                                    $scope.groupOrganisation.id);
                                    $q.all([getPermissonsWithAssignedRolesPromise, getApplicationModulesPromise])
                                    .then(function(results) {
                                        var rolesModel = results[0].rolesModel;
                                        var moduleIdsThatTheClientGroupIsSubscribedTo = _
                                            .pluck(results[1], "id");
                                        $scope.permissionsWithRoles = [];
                                        _.each(rolesModel,
                                            function(permission) {
                                                if (!permission.applicationModulePermissions ||
                                                    permission.applicationModulePermissions.length === 0) {
                                                    addedAll.push(permission);
                                                    $scope.permissionsWithRoles.push(permission);
                                                } else {
                                                    var moduleIdsForThisPermission =
                                                        _.pluck(permission.applicationModulePermissions, "id");
                                                    var intersection = _.intersection(moduleIdsForThisPermission,
                                                        moduleIdsThatTheClientGroupIsSubscribedTo);
                                                    if (intersection.length > 0) {
                                                        $scope.permissionsWithRoles.push(permission);
                                                        addedBecauseOfModules.push(permission);
                                                    } else {
                                                        excludedFromModel.push(permission);
                                                    }
                                                }
                                            });
                                    });
                                break;
                            case "DARWIN":
                                organisationRoleFactory
                                    .getPermissionsWithAssignedRoles({ groupOrgId: null })
                                    .$promise.then(function(data) {
                                        $scope.permissionsWithRoles = data.rolesModel;
                                    });
                                break;

                            }

                        }();

                        $scope.toggleRoleCreation = function() {
                            $scope.roleCreationMode = !$scope.roleCreationMode;
                        };


                        $scope.togglePermissionInRole = function(organisationRolePermission) {
                            if (organisationRolePermission.assignedToPermission) {
                                $scope.addPermissionToRole(organisationRolePermission);
                            } else {
                                $scope.removePermissionFromRole(organisationRolePermission);
                            }
                        };

                        $scope.addPermissionToRole = function(organisationRolePermission) {
                            organisationRoleFactory
                                .addPermissionToRole({
                                    organisationRoleId: organisationRolePermission.organisationRoleId,
                                    permissionId: organisationRolePermission.permissionId
                                })
                                .$promise.then(function() {
                                    toastr.success($translate.instant("permission_added_to_role"));
                                });
                        };
                        $scope.removePermissionFromRole = function(organisationRolePermission) {
                            organisationRoleFactory
                                .removePermissionFromRole({
                                    organisationRoleId: organisationRolePermission.organisationRoleId,
                                    permissionId: organisationRolePermission.permissionId
                                })
                                .$promise.then(function() {
                                    toastr.success($translate.instant("permission_removed_from_role"));
                                });
                        };

                        $scope.saveNewOrganisationRole = function(newRole) {

                            newRole.organisationId = $scope.groupOrganisation.id;
                            newRole.isPublic = true;
                            newRole.readonly = false;
                            newRole.applicationEnum = $scope.applicationEnum;

                            var amendOrganisationroleDto = {
                                organisationId: self.context.organisation.id,
                                organisationRoleDto: newRole
                            };
                            organisationRoleFactory.createNewOrganisationRole(amendOrganisationroleDto)
                                .$promise.then(function(data) {

                                    _.each($scope.permissionsWithRoles,
                                        function(permission) {
                                            var organisationRolePermissionDto = {
                                                name: newRole.name,
                                                organisationRoleId: data.updatedRole.id,
                                                permissionId: permission.id,
                                                isPublic: newRole.isPublic,
                                                isReadonly: newRole.readonly,
                                                id: 0,
                                                assignedToPermission: false
                                            };
                                            permission.organisationRolePermissionDtos
                                                .push(organisationRolePermissionDto);
                                        });
                                    toastr.success($translate.instant("saved_new_role"));
                                    $scope.toggleRoleCreation();


                                });

                        };

                        $scope.deleteOrganisationRole = function(organisationRolePermission) {
                            var orgRoleId = organisationRolePermission.organisationRoleId;
                            organisationRoleFactory.deleteOrganisationRole({ organisationRoleId: orgRoleId })
                                .$promise.then(function(data) {

                                    _.each($scope.permissionsWithRoles,
                                        function(permission) {
                                            var orgRolePermissionToRemove = _
                                                .findWhere(permission.organisationRolePermissionDtos,
                                                    { organisationRoleId: orgRoleId });
                                            if (orgRolePermissionToRemove)
                                                permission.organisationRolePermissionDtos.remove(
                                                    orgRolePermissionToRemove);
                                        });
                                    toastr.success($translate.instant("deleted_role"));
                                });
                        };
                    });
                }
            ];

            return {
                restrict: "AE",
                scope: {
                    groupOrganisation: "=",
                    applicationEnum: "@"
                },
                controller: controller,
                templateUrl: "/ngxbeagle/dist/Content/js/Modules/cdbPslRoles/manage-roles.html"
            };
        });

angular.module(appName)
	.controller("changePassword",
	[
        "$scope", "organisationContextService", "manageUserResource", "organisationContextService", "$location",
        function ($scope, organisationContextService, manageUserResource, organisationContextService, $location) {

            $scope.passwordModel = {};



            $scope.changePassword = function () {

                return organisationContextService.isAdminUser(function (data) {
                    $scope.passwordModel.id = data.id;

                    return manageUserResource.forceChangePassword($scope.passwordModel).$promise.then(function () {

                        //Need to update the data in local storage to ensure the password expired is false
                        return organisationContextService.isAdminUser(function (data) {
                            $location.path("/");
                        });
                        
                    });
                }
                );


            };

		    self.init = function () {
       
                
		    }();
		}
		
	]);
'use strict';

angular.module(appName)
    .factory('clientConfigurationResource', [
        '$resource', "siteUrl", function ($resource, siteUrl) {
            var api = siteUrl() + "api/ClientConfiguration";
            
            return $resource(api, {}, {
				getPurchasingModelConfiguration: {
					method: "GET",
					url: api + '/PurchasingModel',
                    params: {
						organisationId: '@organisationId'
					},
                    isArray: false
				}
            });
        }
    ]);
angular.module(appName)
	.factory("clientConfigurationService",
		[
			"clientConfigurationResource",
			function (clientConfigurationResource) {
				return {
					getPurchasingModelConfiguration: function (organisationId, cb) {
                        return clientConfigurationResource.getPurchasingModelConfiguration({ organisationId: organisationId }).$promise;
                    }
				};
			}
		]);

angular.module(appName)
    .controller('clientExportController', [
        '$scope',
        '$rootScope',
        '$routeParams',
        '$http',
        'genericUiGrid',
        'localStorageService',
        'enums',
        '$interval',
        '$templateRequest',
        '$q',
        'paginationFactory',
        '$translate',
        'fileDownloadService',
        'translateMessage',
        'Upload',
        'ngDialog',
        'clientExportGridService',
        '$timeout',
        function ($scope,
            $rootScope,
            $routeParams,
            $http,
            genericUiGrid,
            localStorageService,
            enums,
            $interval,
            $templateRequest,
            $q,
            paginationFactory,
            $translate,
            fileDownloadService,
            translateMessage,
            Upload,
            ngDialog,
            clientExportGridService,
            $timeout
        ) {

            paginationFactory.addPaginationVariablesAndFunctionsToScope($scope)

            var self = this
            var checkboxCellTemplate
            var editRowCellTemplate
            var selectItemCellTemplate
            var selectAllHeaderCellTemplate

            $scope.orgid = 0
            $scope.search = ''
            $scope.startDate = null
            $scope.ClientIsSetup = false

            $scope.disableRefreshDocuments = true
            $scope.exporting = false
            //are we ready to show stuff on the page
            $scope.PageReady = false
            $scope.rowsSelectedForDeletion = []
            $scope.dates = {
                priceEffectiveDate: '',
                priceExpirationDate: ''

            }
            $scope.emailModel = localStorageService.getItem(enums.localStorage.clientExportsEmail) || {
                emailSubject: '',
                emailBody: ''
            }

            $scope.sortOn = {
                column: 'dateExported',
                sortDirection: 'DESC'
            }

            $scope.saveEmailModel = function () {
                localStorageService.setItem(enums.localStorage.clientExportsEmail, $scope.emailModel)
            }

            $scope.IsActiveClicked = function (row, col, field) {
                row.orgId = $scope.orgid
                $http.post('api/clientexport/UpdateClientExportData', row).then(function () {
                    $translate('success_item_updated').then(function (translation) {
                        toastr.success(translation)
                    })

                })
            }

            $scope.EditRowClicked = function (row, col, field) {
                row.orgId = $scope.orgid
                angular.copy(row, $scope.EditRowData) // Create a copy so we don't affect the grid
                $scope.EditingRow = true
            }

            $scope.ImportData = []

            var showDeleteDialog = function () {
                return ngDialog.openConfirm({
                    showClose: false,
                    template: 'ngxbeagle/src/angularjs/app/Modules/ClientExports/deleteRowsDialog.html',
                    data: {
                        count: $scope.rowsSelectedForDeletion.length || 1
                    }
                })
            }

            var deletePriceImport = function (row) {
                showDeleteDialog().then(function () {
                    var priceImportData = row.entity
                    $http
                        .post('api/ClientExport/Delete?priceImportId=' + priceImportData.id + '&id=' + $scope.orgid)
                        .then(function () {
                            _.removeIfExists($scope.ImportData, priceImportData)
                            translateMessage.success('success_item_deleted')
                        })
                })
            }

            // end grid definitions

            $scope.downloadCSV = function () {

            }

            $scope.addDataModal = function () {
                $scope.showModal = true
            }

            $scope.showContactModal = function () {
                $scope.showContacts = true
            }

            $scope.showEmailFields = function () {
                var format = _.findWhere($scope.ExportFormats, { pipelineName: $scope.selectedPipelineName })
                return format && format.transmissionMethodId === enums.clientExportTransmissionMethodIds.email
            }

            $scope.hideContactModal = function () {
                $scope.showContacts = false
            }

            $scope.hideModal = function () {

                $scope.showModal = false
            }

            $scope.addRow = function (event) {
                $scope.showEditForm = true
                $scope.AddingRow = true
            }

            $scope.hideEditForm = function (event) {
                $scope.showEditForm = false
                $scope.AddingRow = false
                $scope.EditingRow = false
                //clear out the form
                $scope.NewRowData = {}
                $scope.EditRowData = {}
            }

            var getSuppliers = function () {
                var getOptions = {
                    params: {
                        id: $scope.orgid,
                        clientId: $scope.clientid
                    }
                }

                $http.get('/api/clientexport/Suppliers', getOptions).then(function (response) {

                        var suppliers = response.data
                        var emptySupplier = {
                            'supplierID': '-1',
                            'supplierName': ''
                        }
                        suppliers.unshift(emptySupplier)

                        $scope.SuppliersData = suppliers
                        //default to 'please select'
                        $scope.SupplierID = '-1'

                    },
                    function (error) {
                        console.log(error.data)
                    }
                )

            }

            var getFormat = function () {
                return $http.get('/api/clientexport/Format?id=' + $scope.orgid).then(function (response) {
                        $scope.format = {
                            id: response.data,
                            name: enums.clientExportFormats[response.data]
                        };
                        $scope.ClientIsSetup = true
                    },
                    function (error) {
                        if (error.data.errorType == 'Setup') {
                            $scope.ClientIsSetup = false
                        }
                    }
                )
            }

            $scope.preference = true
            $scope.preferenceLabel = 'All Suppliers'

            //Handling this here as back end expects 0/1 for SystemPreferences
            $scope.togglePreference = function (preference) {

                $scope.preference = !$scope.preference

                if ($scope.preference == true) {
                    $scope.preferenceLabel = 'All Suppliers'
                    $scope.InvalidSupplier = false
                } else
                    $scope.preferenceLabel = 'Selected Supplier'

            }

            var getExportFormats = function () {
                var getOptions = {
                    params: {
                        organisationId: $scope.orgid
                    }
                }

                $http.get('api/clientexport/GetExportFormats', getOptions).then(function (result) {
                    $scope.ExportFormats = result.data
                    //set selected default
                    var pipeline = _.find($scope.ExportFormats, 'isDefault')
                    if (pipeline != null)
                        $scope.selectedPipelineName = _.find($scope.ExportFormats, 'isDefault').pipelineName
                })

            }

            $scope.$on(enums.eventNames.sortOnElementChangedEventName, function (event, changingElement) {
                //      console.log($scope.sortOn);
            })

            $scope.refreshDocuments = function () {
                disableRefreshDocuments = true;
                getDocuments();
                $timeout(function () {
                    disableRefreshDocuments = false;
                }, 20000);
            }

            var getDocuments = function () {
                var getOptions = {
                    params: {
                        id: $scope.orgid,
                        resultsPerPage: $scope.pagination.numPerPage,
                        startPage: $scope.pagination.currentPage,
                        sortOn: $scope.sortOn.column,
                        sortDirection: $scope.sortOn.sortDirection
                    }
                }

                $http.get('api/clientexport/Documents', getOptions).then(function (result) {
                    $scope.Documents = result.data.list
                    $scope.pagination.total = result.data.total
                })

            }

            $scope.sortDocuments = function (column) {

                if ($scope.sortOn.column !== column) {
                    $scope.sortOn.sortDirection = 'ASC' //default to ascending
                } else {
                    $scope.sortOn.sortDirection = $scope.sortOn.sortDirection === 'DESC' ? 'ASC' : 'DESC'
                }

                $scope.sortOn.column = column
                getDocuments()
            }

            $scope.deleteDocument = function (documentId) {
                var options = {
                    params: {
                        documentId: documentId,
                        id: $scope.orgid
                    }
                }

                $http.delete('api/clientexport/DeleteDocument', options).then(function (result) {

                    var doc = _.find($scope.Documents, { id: documentId })
                    _.removeIfExists($scope.Documents, doc)
                    translateMessage.info('success_item_deleted')
                    getDocuments()
                })
            }

            $scope.downloadDocument = function (documentId) {
                var options = {
                    params: {
                        documentId: documentId,
                        id: $scope.orgid
                    }
                }

                $http.get('api/clientexport/GetFileNameAndExtension', options).then(function (response) {

                    var ext = response.data.extension
                    var fileName = response.data.name

                    var url = 'api/clientexport/DownloadDocuments?documentId=' + documentId + '&Id=' + $scope.orgid
                    fileDownloadService.downloadFile(url, fileName, ext)
                })

            }

            $scope.$watch('pagination.currentPage', function (newVal, oldVal) {
                if (newVal !== oldVal)
                    getDocuments()

            })

            $scope.IsEmailSelected = function () {
                if ($scope.selectedPipelineName != null)
                    return ($scope.selectedPipelineName.toLowerCase().includes('email'))
                return false
            }

            $scope.InvalidDate = false
            $scope.IsValidDateSelected = function () {
                var selectedDate = $scope.startDate
                if (selectedDate == null) {
                    $scope.InvalidDate = true
                    return false
                }
                $scope.InvalidDate = false
                return true
            }

            $scope.InvalidSupplier = false

            $scope.IsValidSupplierSelected = function () {
                if ($scope.SupplierID == '-1' && $scope.preference == 0) {
                    $scope.InvalidSupplier = true
                    return false
                }

                return true
            }

            $scope.getPricingRangeErrorMessage = function () {
                if (($scope.dates.priceEffectiveDate && !$scope.dates.priceExpirationDate) ||
                    (!$scope.dates.priceEffectiveDate && $scope.dates.priceExpirationDate)) return $translate.instant('please_enter_both_fields_when_specifying_range')

                // This doesn't work due to date formatting. Use momentjs
                //if (new Date($scope.priceExpirationDate) < new Date($scope.priceEffectiveDate)) return $translate.instant('price_expiration_must_be_after_price_effective');
            }

            $scope.Export = function () {
                $scope.exporting = true
                $scope.disableRefreshDocuments = false

                //check we have a valid date selected
                if (!$scope.IsValidDateSelected()) return
                // check we have a valid supplier selected
                if (!$scope.IsValidSupplierSelected()) return

                var pipelineId = _.find($scope.ExportFormats, { pipelineName: $scope.selectedPipelineName }).pipelineId
                var supplierId = $scope.preference == true ? null : $scope.SupplierID

                var dto = {
                    OrganisationId: $scope.orgid,
                    SupplierId: supplierId,
                    PipelineName: $scope.selectedPipelineName,
                    PipelineId: pipelineId,
                    Id: $scope.orgid,
                    StartDate: $scope.startDate,
                    ClientPriceStartDate: $scope.dates.clientPriceStartDate,
                    BirchstreetMarketplaceId: null,
                    BirchstreetMarketplaceSupplierId: null,
                    PriceEffectiveDate: $scope.dates.priceEffectiveDate,
                    PriceExpirationDate: $scope.dates.priceExpirationDate,
                    DateFormat: $scope.dates.dateFormat,
                    EmailSubject: $scope.emailModel.emailSubject,
                    EmailBody: $scope.emailModel.emailBody,
                    DepotId: null,
                }

                translateMessage.info('info_exporting_data')
                if (supplierId != null) {
                    dto.BirchstreetMarketplaceId = $scope.supplier.birchstreet_Mktplc_ID
                    dto.BirchstreetMarketplaceSupplierId = $scope.supplier.birchstreet_Supplier_Id
                    dto.DepotId = $scope.supplier.depotId
                }

                $http.post('api/clientexport/Export', dto).then(function (result) {
                    $scope.exporting = false
                    translateMessage.info('info_getting_documents')
                    //refresh the docs
                    getDocuments()
                }, function (error) {
                    $scope.exporting = false
                })
            }

            var setUpGrid = function () {
                clientExportGridService.getGrid($scope.format, $scope.ImportData, deletePriceImport).promise.then(function(gridOptions) {
                    genericUiGrid.create(gridOptions, $scope).then(function (grid) {
                        $scope.clientExportGrid = grid
                    })
                });
            }

            var loadData = function () {
                var getOptions = {
                    params: {
                        id: $scope.orgid,
                        supplierId: $scope.SupplierID,
                        searchFilter: $scope.search,
                        clientId: $scope.clientid,
                        birchstreetMarketplaceId: $scope.supplier.birchstreet_Mktplc_ID,
                        birchstreetMarketplaceSupplierId: $scope.supplier.birchstreet_Supplier_Id,
                        depotId: $scope.supplier.depotId

                    }
                }
                $scope.rowsSelectedForDeletion = []

                $http.get('api/clientexport', getOptions).then(function (response) {
                    $scope.ImportData = response.data
                    setUpGrid()
                })
            }

            $scope.Search = function () {
                //check there is a supplierId selected
                if ($scope.SupplierID)
                    loadData()
            }

            var showValidationDialog = function (errors) {
                return ngDialog.openConfirm({
                    showClose: false,
                    width: '65%',
                    height: '100%',
                    appendClassName: 'ngdialog-overflow-scroll',
                    template: 'ngxbeagle/src/angularjs/app/Modules/ClientExports/uploadValidationTemplate.html',
                    data: {
                        errorData: errors
                    }
                })
            }
            $scope.importEmptyFile = function (files) {
                $scope.loadingEmptyImport = true
                if (files && files.length) {
                    var file = files[0]
                    var supplierId = $scope.SupplierID
                    var clientId = $scope.clientid
                    var url = 'api/ClientExport/ImportData/' + clientId
                    Upload.upload({
                        url: url,
                        file: file
                    }).progress(function (evt) {
                    }).success(function (data, status, headers, config) {
                        $scope.loadingEmptyImport = false
                        translateMessage.success('file_imported_successfully')
                        loadData()
                    }).error(function (errors) {
                        return showValidationDialog(errors)
                    }).finally(function () {
                        $scope.loadingEmptyImport = false
                    })
                }
            }

            $scope.importFile = function (files) {
                $scope.loadingImport = true
                if (files && files.length) {
                    var file = files[0]
                    var supplierId = $scope.SupplierID
                    var clientId = $scope.clientid
                    var url = 'api/ClientExport/ImportData/' + clientId + '/' + supplierId
                    Upload.upload({
                        url: url,
                        file: file
                    }).progress(function (evt) {
                    }).success(function (data, status, headers, config) {
                        translateMessage.success('file_imported_successfully')
                        loadData()
                    }).error(function (errors) {
                        return showValidationDialog(errors)
                    }).finally(function () {
                        $scope.loadingImport = false
                    })
                }
            }

            function getReportFilenameAndExtension (params) {
                var url = 'api/ClientExport/DownloadDataReportFilenameAndExtension/' + params

                return $http.get(url)
            }

            $scope.downloadEmptyTemplate = function () {
                $scope.loadingEmptyDownload = true
                var clientId = $scope.clientid
                getReportFilenameAndExtension(clientId).then(function (response) {
                    var ext = response.data.extension
                    var fileName = response.data.name
                    var url = 'api/ClientExport/DownloadDataReport/' + clientId
                    fileDownloadService.downloadFile(url, fileName, ext).then(function () {
                        $scope.loadingEmptyDownload = false
                    })
                })
            }

            $scope.downloadAllSupplierData = function () {
                $scope.loadingAllSupplierDownload = true
                var clientId = $scope.clientid
                var params = clientId + '/null/false'
                getReportFilenameAndExtension(params).then(function (response) {
                    var ext = response.data.extension
                    var fileName = response.data.name
                    var url = 'api/ClientExport/DownloadDataReport/' + params
                    fileDownloadService.downloadFile(url, fileName, ext).then(function () {
                        $scope.loadingAllSupplierDownload = false
                    })
                })
            }

            $scope.downloadImportFile = function () {
                $scope.loadingDownload = true
                var clientId = $scope.clientid
                var supplierId = $scope.SupplierID
                var params = clientId + '/' + supplierId
                getReportFilenameAndExtension(params).then(function (response) {
                    var ext = response.data.extension
                    var fileName = response.data.name
                    var url = 'api/ClientExport/DownloadDataReport/' + params
                    fileDownloadService.downloadFile(url, fileName, ext).then(function () {
                        $scope.loadingDownload = false
                    })
                })
            }

            $scope.supplierChange = function (supplier) {
                $scope.SupplierID = supplier.supplierID
                $scope.supplier = supplier
                loadData()

                if (supplier.supplierId != '-1')
                    $scope.InvalidSupplier = false
            }

            $scope.NewRowData = {}
            $scope.EditRowData = {}

            $scope.submitEditForm = function () {
                $scope.EditingRow = false

                $http.post('api/clientexport/UpdateClientExportData', $scope.EditRowData).then(function () {
                    $translate('success_item_updated').then(function (translation) {
                        loadData()
                        toastr.success(translation)
                    })
                })
            }

            $scope.submitForm = function () {
                // set the common properties
                // Client_ID, Supplier_OrgID, SupplierID, Orgname
                var firstRow = $scope.ImportData[0]

                $scope.NewRowData.orgId = $scope.orgid
                $scope.NewRowData.client_ID = firstRow.client_ID
                $scope.NewRowData.supplier_OrgID = firstRow.supplier_OrgID
                $scope.NewRowData.supplierID = firstRow.supplierID
                $scope.NewRowData.orgname = firstRow.orgname

                $scope.clientExportGrid.data.push($scope.NewRowData)
                $http.post('api/clientexport/AddClientExportData', $scope.NewRowData).then(function () {
                    translateMessage.success('success_item_updated')
                    // reload the grid
                    $scope.AddingRow = false
                    $scope.NewRowData = {}
                    loadData()
                })

                $scope.showEditForm = false
            }

            $scope.markSelectedForDeletion = function (row, col, model) {
                if (row === undefined) {
                    for (var idx = 0; idx < $scope.clientExportGrid.data.length; idx++) {
                        $scope.clientExportGrid.data[idx].selectedForDeletion = model
                        $scope.rowsSelectedForDeletion.push($scope.clientExportGrid.data[idx])
                    }
                } else {
                    if (model === true) {
                        $scope.rowsSelectedForDeletion.push(row)
                    } else {
                        $scope.rowsSelectedForDeletion.pop(row)
                    }
                }

                console.log($scope.rowsSelectedForDeletion)
            }

            $scope.deleteSelectedRows = function () {
                showDeleteDialog().then(function () {
                    // TODO: Delete rows
                    var body = {
                        orgId: $scope.orgid,
                        deleteLines: _.map($scope.rowsSelectedForDeletion, function (row) {
                            return { priceImportId: row.id }
                        })
                    }
                    $http.post('api/clientexport/DeleteMany', body).then(function () {
                        $translate('lines_deleted_successfully').then(function (translation) {
                            toastr.success(translation)
                            loadData()
                        })
                    })
                })
            }

            var disallowedFields = [
                'supplierid',
                'unit_price',
                'price',
                'quoted_price',
            ]
            $scope.fieldIsEditable = function (prop) {
                return !_.contains(disallowedFields, prop.toLowerCase())
            }

            $scope.init = function () {
                $scope.dateformats = ["DD/MM/YYYY", "MM/DD/YYYY"];
                self.context = localStorageService.getItem(enums.localStorage.organisationContext)
                var organisationId = self.context.user.orgId
                var clientId = self.context.currentSubscriptionUnit.client.id
                $scope.orgid = organisationId
                $scope.clientid = clientId
                $scope.supplier = {}

                // first check that the user is set up for client exports
                getFormat().then(function (results) {
                    $scope.PageReady = true
                    if ($scope.ClientIsSetup) {
                        getSuppliers()
                        getDocuments()
                        getExportFormats()
                    }
                })
            }
            $scope.init()
        }
    ]).directive('editRow', function () {
    return {
        templateUrl: function (elem, attr) {
            return  '/ngxbeagle/dist/Content/js/Modules/ClientExports/templates/ClientExportsEditTemplate.html';
        }
    }
}).directive('addRow', function () {
    return {
        templateUrl: function (elem, attr) {
            return '/ngxbeagle/dist/Content/js/Modules/ClientExports/templates/' + attr.type + 'NewRowTemplate.html'
        }
    }
})

angular.module(appName)
    .service('clientExportGridService', [
        '$http',
        '$templateRequest',
        '$q',
        '_',
        function (
            $http,
            $templateRequest,
            $q,
            _
        ) {
            var templates = {
                checkboxCellTemplate: null,
                editRowCellTemplate: null,
                selectItemCellTemplate: null,
                selectAllHeaderCellTemplate: null
            }
            var defaultGridOptions = {
                enablePinning: true,
                enableRowSelection: true,
                enableSorting: true,
                exporterCsvFilename: 'myFile.csv',
                columns: [],
                globalEditableCondition: function () {
                    return false;
                },
                translate: true,
            }

            $q.all([
                $templateRequest('/ngxbeagle/dist/Content/js/Modules/ClientExports/templates/checkboxCellTemplate.html'),
                $templateRequest('/ngxbeagle/dist/Content/js/Modules/ClientExports/templates/editRowCellTemplate.html'),
                $templateRequest('/ngxbeagle/dist/Content/js/Modules/ClientExports/templates/selectItemCellTemplate.html'),
                $templateRequest('/ngxbeagle/dist/Content/js/Modules/ClientExports/templates/selectAllHeaderCellTemplate.html')
            ]).then(function (results) {
                // Pick off the resolved promises and assign them all to usable variables
                templates.checkboxCellTemplate = results[0]
                templates.editRowCellTemplate = results[1]
                templates.selectItemCellTemplate = results[2]
                templates.selectAllHeaderCellTemplate = results[3]
            })

            /**
             * Ensures that the `translateKey` property does not duplicate the format name in fields that already contain it.
             *
             * For example the field `eatec_Supplier_Name` for translation would become `eatec_eatec_supplier_name` if we don't strip it first.
             * @param field The column field we're modifying.
             * @param format Our current format.
             * @returns {string}
             */
            function stripFormatFromField (field, format) {
                return field.replace(format + '_', '');
            }

            /**
             * Constructs the `translationKey` for translating column headers and edit fields.
             * @param format The column field we're modifying.
             * @param column Our current format.
             * @returns {string}
             */
            function getTranslateKey (format, column) {
                return (format.name + '_' + stripFormatFromField(column.field, format.name)).toLowerCase()
            }

            function getGrid (format, gridData, deletePriceImport) {
                var deferred = $q.defer();

                $http.get('/ngxbeagle/dist/angularjs/app/Modules/ClientExports/gridFormats/' + format.name + '.json').then(function(data) {
                    var columns = _.map(data.data, function(column) {
                        // If visible doesn't exist, assume it's a visible column
                        if (!column.hasOwnProperty('visible') || column.visible !== false) column.translateKey = getTranslateKey(format, column)

                        return column;
                    });
                    columns.unshift({
                            'field': 'selectedForDeletion',
                            'headerCellTemplate': templates.selectAllHeaderCellTemplate,
                            'pinnedLeft': true,
                            'width': 50,
                            'template': templates.selectItemCellTemplate,
                            'hideTitle': true,
                            'editable': false
                        },
                        {
                            'action': deletePriceImport,
                            'visible': true
                        },
                        {
                            'field': 'id',
                            'template': templates.editRowCellTemplate,
                            'editableCellTemplate': templates.editRowCellTemplate,
                            'className': 'number',
                            'pinnedLeft': true,
                            'enableCellEditOnFocus': false,
                            'editable': false,
                            'width': 50,
                            'hideTitle': true
                        });
                    columns.push(
                        {
                            'field': 'isActive',
                            'template': templates.checkboxCellTemplate,
                            'enableCellEditOnFocus': false,
                            'editableCellTemplate': templates.checkboxCellTemplate,
                            'editable': true,
                            'width': 50,
                            'translateKey': 'is_active'
                        })
                    var gridOptions = angular.copy(defaultGridOptions);
                    gridOptions.columns = columns;
                    gridOptions.data = gridData;

                    deferred.resolve(gridOptions);
                });

                return deferred;
            }

            return {
                getGrid: getGrid
            }
        }
    ])

'use strict';

angular.module(appName)
    .controller('clientProcurementAccountCodeController', [
        '$scope', 'clientProcurementAccountCodeService', 'clientProcurementAccountCodeData', 'accountTypesResolve', 'helpers', 'toastr', 'localStorageService', 'enums', 'autoFocus', 'userService', 'translateMessage', '$translate',
        function ($scope, clientProcurementAccountCodeService, clientProcurementAccountCodeData, accountTypesResolve, helpers, toastr, localStorageService, enums, autoFocus, userService, translateMessage,$translate) {
            $translate.onReady().then(function() {
                $scope.addAccountCode = function() {
                    clearUnfinishedEntries();
                    if (window.innerWidth < 768) {
                        window.scrollTo(0, document.body.scrollHeight);
                    }
                    autoFocus.implement("input");
                    $scope.existingAccountCodes = angular.copy($scope.clientProcurementAccountCodes);
                    $scope.cachedAccountCode = {
                        id: 0,
                        headOfficeAccountCode: "",
                        headOfficeExportFieldName: "",
                        description: "",
                        procurementAccountType: _.findWhere($scope.accountTypes, { id: 0 }),
                        clientProcurementSubscriptionId: $scope.currentProcurementSubscriptionId
                    };
                    $scope.clientProcurementAccountCodes.push({
                        id: 0,
                        headOfficeAccountCode: "",
                        headOfficeExportFieldName: "",
                        description: "",
                        procurementAccountType: _.findWhere($scope.accountTypes, { id: 0 }),
                        clientProcurementSubscriptionId: $scope.currentProcurementSubscriptionId
                    });
                };

                $scope.editAccountCode = function(accountCode) {
                    clearUnfinishedEntries();
                    $scope.existingAccountCodes = angular.copy($scope.clientProcurementAccountCodes);
                    $scope.cachedAccountCode = angular.copy(accountCode);
                    accountCode.procurementAccountType =
                        _.findWhere($scope.accountTypes, { id: accountCode.procurementAccountTypeId });
                    var c = _.findWhere($scope.clientProcurementAccountCodes, { id: accountCode.id });
                    c.isBeingEdited = true;
                }

                $scope.deleteAccountCode = function(accountCode) {
                    accountCode.processing = true;
                    if (!accountCode.isInUse) {
                        clientProcurementAccountCodeService.remove(accountCode.clientProcurementSubscriptionId,
                            accountCode.id,
                            accountCode.isInUse).then(function(data) {
                            accountCode.processing = false;
                            if (data.success) {
                                $scope.clientProcurementAccountCodes =
                                    helpers.sortAscendingCaseInsensitive(
                                        _.without($scope.clientProcurementAccountCodes, accountCode),
                                        'description');
                                translateMessage.success("your_account_code_was_successfully_removed");
                            }
                        });
                    } else {
                        translateMessage.error("you_cannot_delete_this_account_code");

                    }
                }

                $scope.saveChanges = function(accountCode) {
                    var duplicateHeadOfficeCode = _.findWhere($scope.existingAccountCodes,
                        { headOfficeAccountCode: accountCode.headOfficeAccountCode });
                    var isDuplicateHeadOfficeCode =
                        duplicateHeadOfficeCode ? duplicateHeadOfficeCode.id != accountCode.id : false;
                    var duplicateDescription = _.findWhere($scope.existingAccountCodes,
                        { description: accountCode.description });
                    var isDuplicateDescription =
                        duplicateDescription ? duplicateDescription.id != accountCode.id : false;
                    accountCode.procurementAccountTypeId = accountCode.procurementAccountType.id;
                    accountCode.organisationId = self.ctx.organisation.id;
                    if (isDuplicateHeadOfficeCode) {
                        translateMessage.error("this_head_offce_code_is_already_in_use");
                        if (accountCode && $scope.cachedAccountCode) {
                            accountCode.headOfficeAccountCode = $scope.cachedAccountCode.headOfficeAccountCode;
                            accountCode.isBeingEdited = true;
                        }
                    } else if (isDuplicateDescription) {
                        translateMessage.error("this_account_code_name_is_already_in_use");
                        if (accountCode && $scope.cachedAccountCode) {
                            accountCode.description = $scope.cachedAccountCode.description;
                            accountCode.isBeingEdited = true;
                        }
                    } else {
                        if (accountCode.id !== 0) {
                            var c = _.findWhere($scope.clientProcurementAccountCodes, { id: accountCode.id });
                            accountCode.processing = true;
                            clientProcurementAccountCodeService.update(accountCode, accountCode.isBeingEdited = false)
                                .then(function(data) {
                                    accountCode.isBeingEdited = false;
                                    accountCode.processing = false;
                                    translateMessage.success("your_account_code_was_saved_successfully");
                                    clearUnfinishedEntries();
                                    $scope.clientProcurementAccountCodes =
                                        helpers.sortAscendingCaseInsensitive($scope.clientProcurementAccountCodes,
                                            'description');
                                    accountCode.procurementAccountTypeDescription =
                                        data.procurementAccountTypeDescription;
                                });
                        } else {
                            $scope.saveNew(accountCode);
                        }
                    }
                }

                $scope.cancelChanges = function(accountCode) {
                    if (accountCode && $scope.cachedAccountCode) {
                        accountCode.description = $scope.cachedAccountCode.description;
                        accountCode.headOfficeAccountCode = $scope.cachedAccountCode.headOfficeAccountCode;
                        accountCode.headOfficeExportFieldName = $scope.cachedAccountCode.headOfficeExportFieldName;
                        accountCode.procurementAccountType = $scope.cachedAccountCode.procurementAccountType;
                    }
                    clearUnfinishedEntries();
                }

                $scope.saveNew = function(accountCode) {
                    accountCode.processing = true;
                    clientProcurementAccountCodeService.add(accountCode).then(function(data) {
                        accountCode.processing = false;
                        clearUnfinishedEntries();
                        data.procurementAccountTypeDescription = data.procurementAccountTypeDescription != null
                            ? data.procurementAccountTypeDescription
                            : accountCode.procurementAccountType.description;
                        $scope.clientProcurementAccountCodes.push(data);
                        $scope.clientProcurementAccountCodes =
                            helpers.sortAscendingCaseInsensitive($scope.clientProcurementAccountCodes, 'description');
                        translateMessage.success("your_account_code_was_saved_successfully");

                    });
                }

                $scope.areYouSure = function(accountCode) {
                    accountCode.promptAreYouSure = !accountCode.promptAreYouSure;
                }

                $scope.editActions = [
                    {
                        name: "Save",
                        function: $scope.saveChanges,
                        color: "green",
                        disabledWhen:
                            "!accountCode.description || !accountCode.headOfficeAccountCode || !accountCode.headOfficeExportFieldName || accountCode.procurementAccountType.id == 0 || accountCode.description == '' || accountCode.headOfficeAccountCode == '' || accountCode.headOfficeExportFieldName == '' || processing"
                    },
                    { name: "Cancel", function: $scope.cancelChanges, color: "red", disabledWhen: null },
                ];

                $scope.init = function() {
                    $scope.hasDeletePermission = false;
                    clientProcurementAccountCodeData.$promise.then(function(data) {
                        $scope.clientProcurementAccountCodes = data;
                    });
                    accountTypesResolve.$promise.then(function(data) {
                        $scope.accountTypes = data;
                        $scope.accountTypes.push({
                            id: 0,
                            description: $translate.instant('no_account_type_selected')
                        });
                    });
                    self.ctx = localStorageService.getItem(enums.localStorage.organisationContext);
                    $scope.currentProcurementSubscriptionId = self.ctx.id;
                    self.headOfficeOrganisationId = localStorageService.getItem(enums.localStorage.organisationContext)
                        .organisation.id;
                    userService.hasPermission('BEAGLE_COSTCENTRES_DELETE').then(function() {
                        $scope.hasDeletePermission = true;
                    });
                }();

                function clearUnfinishedEntries() {
                    $scope.clientProcurementAccountCodes = helpers.clearUnfinishedTableEntries(
                        helpers.sortAscendingCaseInsensitive($scope.clientProcurementAccountCodes, 'description'));
                }
            });
        }]);



'use strict';

angular.module(appName)
    .factory('clientProcurementAccountCodeResource', [
        '$resource', "siteUrl", function ($resource, siteUrl) {
            var api = siteUrl() + "api/ClientProcurementAccountCode";
            return $resource(api, {}, {
                get: {
                    method: "GET",
                    url: api,
                    params: {
                        id: "@id"
                    },
                    isArray: true
                },
                getAccountTypes: {
                    method: "GET",
                    url: api + '/GetListOfAccountTypes',
                    isArray: true
                },
                remove: {
                    method: "POST",
                    url: api + "/Delete",
                    params: {
                        clientProcurementSubscriptionId: "@clientProcurementSubscriptionId",
                        id: "@id",
                        inUse: "@inUse"
                    },
                },
                add: {
                    method: "POST",
                    url: api + "/Add"
                },
                update: {
                    method: "POST",
                    url: api + "/Edit"
                }
            });
        }
    ]);
angular.module(appName)
    .factory('clientProcurementAccountCodeService', [
        'clientProcurementAccountCodeResource',
        function (clientProcurementAccountCodeResource) {
            return {
                get: function (subscriptionId, cb) {
                    return clientProcurementAccountCodeResource.get({ id: subscriptionId }).$promise.then(cb);
                },
                getAccountTypes: function (cb) {
                    return clientProcurementAccountCodeResource.getAccountTypes().$promise.then(cb);
                },
                remove: function (clientProcurementSubscriptionId, id, inUse, cb) {
                    return clientProcurementAccountCodeResource
                        .remove({ clientProcurementSubscriptionId: clientProcurementSubscriptionId, id: id, inUse: inUse })
                        .$promise.then(cb);
                },
                add: function (model, cb) {
                    return clientProcurementAccountCodeResource.add(model).$promise.then(cb);
                },
                update: function(model, cb) {
                    return clientProcurementAccountCodeResource.update(model).$promise.then(cb);
                }
            };
        }
    ]);
'use strict';
angular.module(appName).controller('clientProcurementCostCentreController', [
    '$scope', 'clientProcurementCostCentreService', 'clientProcurementCostCentreData', 'helpers',
    'translateMessage', 'localStorageService', 'enums', 'autoFocus',
    function ($scope, clientProcurementCostCentreService, clientProcurementCostCentreData, helpers,
        translateMessage, localStorageService, enums, autoFocus
    ) {
            $scope.addCostCentre = function () {
                clearUnfinishedEntries();
                if (window.innerWidth < 768) {
                    window.scrollTo(0, document.body.scrollHeight);
                }
                autoFocus.implement('input');
                $scope.existingCostCentres = angular.copy($scope.clientProcurementCostCentres);
                $scope.cachedCostCentre = {
                    clientProcurementSubscriptionId: $scope.currentProcurementSubscriptionId,
                    description: '',
                    headOfficeCostCenterCode: '',
                    headOfficeExportFieldName: '',
                    id: 0
                };
                $scope.clientProcurementCostCentres.push({
                    clientProcurementSubscriptionId: $scope.currentProcurementSubscriptionId,
                    description: '',
                    headOfficeCostCenterCode: '',
                    headOfficeExportFieldName: '',
                    id: 0,
                    organisationId: self.headOfficeOrganisationId
                });
            };

            $scope.editCostCentre = function (centre) {
                clearUnfinishedEntries();
                $scope.existingCostCentres = angular.copy($scope.clientProcurementCostCentres);
                $scope.cachedCostCentre = angular.copy(centre);
                var c = _.findWhere($scope.clientProcurementCostCentres, { id: centre.id });
                c.isBeingEdited = true;
            }

            $scope.deleteCostCentre = function (centre) {
                if (!centre.isInUse) {
                    clientProcurementCostCentreService.remove(centre.clientProcurementSubscriptionId, centre.id, centre.isInUse).then(function (data) {
                        if (data.success) {
                            $scope.clientProcurementCostCentres =
                                helpers.sortAscendingCaseInsensitive(
                                _.without($scope.clientProcurementCostCentres, centre),
                                'description');
                            translateMessage.success('your_cost_centre_was_successfully_removed');
                        }
                    });
                }
                else {
                    translateMessage.error('sorry_you_cannot_delete_this_cost_centre_because_it_is_being_used_by_one_or_more_units');
                }
            }

            $scope.saveChanges = function (centre) {
                var duplicateHeadOfficeCode = _.findWhere($scope.existingCostCentres, { headOfficeCostCenterCode: centre.headOfficeCostCenterCode });
                var isDuplicateHeadOfficeCode = duplicateHeadOfficeCode ? duplicateHeadOfficeCode.id != centre.id : false;
                var duplicateDescription = _.findWhere($scope.existingCostCentres, { description: centre.description });
                var isDuplicateDescription = duplicateDescription ? duplicateDescription.id != centre.id : false;
                if (isDuplicateHeadOfficeCode) {
                    translateMessage.error('this_head_office_code_is_already_being_used_please_enter_a_unique_code');
                    if (centre && $scope.cachedCostCentre) {
                        centre.headOfficeCostCenterCode = $scope.cachedCostCentre.headOfficeCostCenterCode;
                        centre.isBeingEdited = true;
                    }
                }
                else if (isDuplicateDescription) {
                    translateMessage.error('this_cost_centre_name_is_already_being_used_please_enter_a_unique_name');
                    if (centre && $scope.cachedCostCentre) {
                        centre.description = $scope.cachedCostCentre.description;
                        centre.isBeingEdited = true;
                    }
                }
                else {
                    if (centre.id !== 0) {
                        var c = _.findWhere($scope.clientProcurementCostCentres, { id: centre.id });
                        clientProcurementCostCentreService.update(centre, centre.isBeingEdited = false).then(function (data) {
                            translateMessage.success('your_cost_centre_was_saved_successfully');
                            clearUnfinishedEntries();
                            $scope.clientProcurementCostCentres = helpers.sortAscendingCaseInsensitive($scope.clientProcurementCostCentres, 'description');
                        });
                    }
                    else {
                        $scope.saveNew(centre);
                    }
                }
            }

            $scope.cancelChanges = function (centre) {
                if (centre && $scope.cachedCostCentre) {
                    centre.description = $scope.cachedCostCentre.description;
                    centre.headOfficeCostCentreCode = $scope.cachedCostCentre.headOfficeCostCentreCode;
                }
                clearUnfinishedEntries();
            }

            $scope.saveNew = function (centre) {
                clientProcurementCostCentreService.add(centre).then(function (data) {
                    clearUnfinishedEntries();
                    $scope.clientProcurementCostCentres.push(data);
                    $scope.clientProcurementCostCentres = helpers.sortAscendingCaseInsensitive($scope.clientProcurementCostCentres, 'description');
                    translateMessage.success('your_cost_centre_was_saved_successfully');
                });
            }

            $scope.areYouSure = function (centre) {
                centre.promptAreYouSure = !centre.promptAreYouSure;
            }

            $scope.scopeActions = [
                { name: 'Edit', function: $scope.editCostCentre, color: 'blue' }
            ]

            $scope.editActions = [{
                color: 'green',
                disabledWhen: "!costCentre.description || !costCentre.headOfficeCostCenterCode || !costCentre.headOfficeExportFieldName || costCentre.description == '' || costCentre.headOfficeCostCenterCode == '' || costCentre.headOfficeExportFieldName == ''",
                function: $scope.saveChanges,
                name: 'Save'
            }, {
                color: 'red',
                disabledWhen: null,
                function: $scope.cancelChanges,
                name: 'Cancel'
            }]

            $scope.init = function () {
                clientProcurementCostCentreData.$promise.then(function (data) {
                    $scope.clientProcurementCostCentres = data;
                });
                var ctx = localStorageService.getItem(enums.localStorage.organisationContext);
                $scope.currentProcurementSubscriptionId = ctx.id;
                self.headOfficeOrganisationId = localStorageService.getItem(enums.localStorage.organisationContext).organisation.id;
            }();

            function clearUnfinishedEntries() {
                $scope.clientProcurementCostCentres = helpers.clearUnfinishedTableEntries(
                    helpers.sortAscendingCaseInsensitive($scope.clientProcurementCostCentres, 'description'));
            }
    }
]);



angular.module(appName)
    .factory('clientProcurementCostCentreService', [
        'clientProcurementCostCentreResource',
        function (clientProcurementCostCentreResource) {
            return {
                get: function (subscriptionId, cb) {
                    return clientProcurementCostCentreResource.get({ id: subscriptionId }).$promise.then(cb);
                },
                remove: function (clientProcurementSubscriptionId, id, inUse, cb) {
                    return clientProcurementCostCentreResource
                        .remove({ clientProcurementSubscriptionId: clientProcurementSubscriptionId, id: id, inUse: inUse })
                        .$promise.then(cb);
                },
                add: function (model, cb) {
                    return clientProcurementCostCentreResource.add(model).$promise.then(cb);
                },
                update: function(model, cb) {
                    return clientProcurementCostCentreResource.update(model).$promise.then(cb);
                }
            };
        }
    ]);
'use strict';

angular.module(appName).controller('clientProcurementDepartmentController', [
    '$scope', 'clientProcurementDepartmentService', 'clientProcurementDepartmentData',
    'localStorageService', 'helpers', 'enums', 'autoFocus', 'userService', 'translateMessage',
    '$translate',  'clientProcurementAccountCodeService',
    function ( $scope, clientProcurementDepartmentService, clientProcurementDepartmentData,
        localStorageService, helpers, enums, autoFocus, userService, translateMessage, $translate,
        clientProcurementAccountCodeService
    ) {
            $translate.onReady().then(function() {
                var self = this;

                $scope.addDepartment = function() {
                    clearUnfinishedEntries();
                    if (window.innerWidth < 768) {
                        window.scrollTo(0, document.body.scrollHeight);
                    }
                    autoFocus.implement('input');
                    $scope.existingDepartments = angular.copy($scope.clientProcurementDepartments);
                    $scope.cachedDepartment = {
                        id: 0,
                        headOfficeDepartmentCode: '',
                        departmentDescription: '',
                        procurementSubscriptionId: $scope.currentProcurementSubscriptionId,
                        organisationId: self.headOfficeOrganisationId
                    };
                    $scope.clientProcurementDepartments.push({
                        id: 0,
                        headOfficeDepartmentCode: '',
                        departmentDescription: '',
                        procurementSubscriptionId: $scope.currentProcurementSubscriptionId,
                        organisationId: self.headOfficeOrganisationId
                    });
                }

                $scope.editDepartment = function(dept) {
                    clearUnfinishedEntries();
                    $scope.existingDepartments = angular.copy($scope.clientProcurementDepartments);
                    $scope.cachedDepartment = angular.copy(dept);
                    var department = _.findWhere($scope.clientProcurementDepartments, { id: dept.id });
                    department.isBeingEdited = true;
                }

                $scope.deleteDepartment = function(dept) {
                    if (!dept.isInUse) {
                        dept.processing = true;
                        clientProcurementDepartmentService.remove(dept.procurementSubscriptionId, dept.id, dept.isInUse)
                            .then(function(data) {
                                if (data.success) {
                                    $scope.clientProcurementDepartments =
                                        helpers.sortAscendingCaseInsensitive(
                                            _.without($scope.clientProcurementDepartments, dept),
                                            'departmentDescription');
                                    translateMessage.success('your_department_was_successfully_removed');
                                } else {
                                    translateMessage.error('something_went_wrong_please_try_again_later');
                                }
                                dept.processing = false;
                            });
                    } else {
                        translateMessage.error('you_cannot_delete_this_department');
                    }
                }

				$scope.accountTypeDescriptionFor = function (id) {
					if (!id) {
						return null;
					}
					var accountType = _.find($scope.accountTypes, { id: id });
					if (!accountType) {
						return null;
					}
					return accountType.description;
				}

                $scope.saveChanges = function(dept) {
                    var duplicateHeadOfficeCode = _.findWhere($scope.existingDepartments,
                        { headOfficeDepartmentCode: dept.headOfficeDepartmentCode });
                    var duplicateDescription = _.findWhere($scope.existingDepartments,
                        { departmentDescription: dept.departmentDescription });
                    var isDuplicateHeadOfficeCode =
                        duplicateHeadOfficeCode ? duplicateHeadOfficeCode.id != dept.id : false;
                    var isDuplicateDescription = duplicateDescription ? duplicateDescription.id != dept.id : false;
                    if (isDuplicateHeadOfficeCode) {
                        translateMessage.error('this_head_offce_code_is_already_in_use');
                        if (dept && $scope.cachedDepartment) {
                            dept.headOfficeDepartmentCode = $scope.cachedDepartment.headOfficeDepartmentCode;
                            dept.isBeingEdited = true;
                        }
                    } else if (isDuplicateDescription) {
                        translateMessage.error('this_department_name_is_already_in_use');
                        if (dept && $scope.cachedDepartment) {
                            dept.departmentDescription = $scope.cachedDepartment.departmentDescription;
                            dept.isBeingEdited = true;
                        }
                    } else {
                        if (dept.id !== 0) {
                            dept.processing = true;
                            var department = _.findWhere($scope.clientProcurementDepartments, { id: dept.id });
                            clientProcurementDepartmentService.update(dept, department.isBeingEdited = false).then(
                                function(data) {
                                    dept.processing = false;
                                    translateMessage.success('your_department_was_saved_successfully');

                                    clearUnfinishedEntries();
                                    $scope.clientProcurementDepartments =
                                        helpers.sortAscendingCaseInsensitive($scope.clientProcurementDepartments,
                                            'departmentDescription');
                                });
                        } else {
                            $scope.saveNew(dept);
                        }
                    }
                }

                $scope.cancelChanges = function(dept) {
                    if (dept && $scope.cachedDepartment) {
                        dept.departmentDescription = $scope.cachedDepartment.departmentDescription;
                        dept.headOfficeDepartmentCode = $scope.cachedDepartment.headOfficeDepartmentCode;
                    }
                    clearUnfinishedEntries();
                }

                $scope.saveNew = function(dept) {
                    clientProcurementDepartmentService.add(dept).then(function(data) {
                        clearUnfinishedEntries();
                        $scope.clientProcurementDepartments.push(data);
                        $scope.clientProcurementDepartments =
                            helpers.sortAscendingCaseInsensitive($scope.clientProcurementDepartments,
                                'departmentDescription');
                        translateMessage.success('your_department_was_saved_successfully');

                    });
                }

                $scope.areYouSure = function(dept) {
                    dept.promptAreYouSure = !dept.promptAreYouSure;
                }

                $scope.scopeActions = [
                    { name: $translate.instant('button_edit'), function: $scope.editDepartment, color: 'green' }
                ];

                $scope.editActions = [{
                    name: $translate.instant('button_save'),
                    function: $scope.saveChanges,
                    color: 'green',
                    disabledWhen:
                        "!department.departmentDescription || !department.headOfficeDepartmentCode || department.departmentDescription == '' || department.headOfficeDepartmentCode == ''"
                }, {
                    color: 'red',
                    disabledWhen: null,
                    function: $scope.cancelChanges,
                    name: $translate.instant('button_cancel')
                }];

				$scope.init = function () {
					clientProcurementAccountCodeService.getAccountTypes().then(function(result) {
						$scope.accountTypes = result;
					});
                    $scope.hasDeletePermission = false;
                    clientProcurementDepartmentData.$promise.then(function(data) {
                        $scope.clientProcurementDepartments = data;
                        $scope.currentProcurementSubscriptionId =
                            localStorageService.getItem(enums.localStorage.organisationContext).id;
                        self.headOfficeOrganisationId = localStorageService
                            .getItem(enums.localStorage.organisationContext).organisation.id;
                    });

                    userService.hasPermission('BEAGLE_DEPARTMENTS_DELETE').then(function() {
                        $scope.hasDeletePermission = true;
                    });
                }();

                function clearUnfinishedEntries() {
                    $scope.clientProcurementDepartments = helpers.clearUnfinishedTableEntries(
                        helpers.sortAscendingCaseInsensitive($scope.clientProcurementDepartments,
                            'departmentDescription'));
                }
            });
        }]);
'use strict';

angular.module(appName)
    .factory('clientProcurementDepartmentResource', [
        '$resource', "siteUrl", function ($resource, siteUrl) {
            var api = siteUrl() + "api/ClientProcurementDepartment";
            return $resource(api, {}, {
                get: {
                    method: "GET",
                    url: api,
                    params: {
                        id: "@id"
                    },
                    isArray: true
                },
                remove: {
                    method: "POST",
                    url: api + "/Delete",
                    params: {
                        procurementSubscriptionId: "@procurementSubscriptionId",
                        id: "@id",
                        inUse: "@inUse"
                    }
                },
                add: {
                    method: "POST",
                    url: api + "/Add"
                },
                update: {
                    method: "POST",
                    url: api + "/Update"
                }
            });
        }
    ]);
angular.module(appName)
    .factory('clientProcurementDepartmentService', [
        'clientProcurementDepartmentResource', 'organisationContextService',
        function (clientProcurementDepartmentResource, organisationContextService) {
			var ctx = organisationContextService.getContext();
            return {
				get: function (subscriptionId, cb) {
					var subId = subscriptionId || ctx.currentSubscriptionUnit.id;
					return clientProcurementDepartmentResource.get({ id: subId }).$promise.then(cb);
                },
                remove: function (procurementSubscriptionId, id, inUse, cb) {
                    return clientProcurementDepartmentResource
                        .remove({
                            procurementSubscriptionId: procurementSubscriptionId,
                            id: id,
                            inUse: inUse
                         }).$promise.then(cb);
                },
                add: function (model, cb) {
                    return clientProcurementDepartmentResource.add(model).$promise.then(cb);
                },
                update: function (model, cb) {
                    model.organisationId = ctx.organisation.id;
                    return clientProcurementDepartmentResource.update(model).$promise.then(cb);
                }
            };
        }
    ]);
angular.module(appName)
    .controller('clientProcurementReceivingVarianceReasonsController', [
        '$scope',
        '$q',
        '_',
        'organisationContextService',
        'receivingVarianceReasonData',
        'clientProcurementReceivingVarianceReasonsService',
        'localStorageService',
        'enums',
        'toastr',
        'helpers',
        'autoFocus',
        'userService',
        '$translate',
        'translateMessage',
        function ($scope,
                $q,
                _,
                organisationContextService,
                receivingVarianceReasonData,
                clientProcurementReceivingVarianceReasonsService,
                localStorageService,
                enums,
                toastr,
                helpers,
                autoFocus,
                userService,
                $translate,
                translateMessage
        ) {
            $translate.onReady().then(function() {
                var self = this;

                $scope.addVarianceReason = function() {
                    clearUnfinishedEntries();
                    if (window.innerWidth < 768) {
                        window.scrollTo(0, document.body.scrollHeight);
                    }
                    autoFocus.implementForElementWithId("new-reason");
                    $scope.cachedReasons = angular.copy($scope.receivingVarianceReasons);
                    var numberOfReasons = $scope.receivingVarianceReasons.length;
                    $scope.cachedReason = {
                        id: 0,
                        description: "",
                        procurementSubscriptionId: $scope.currentProcurementSubscriptionId,
                        order: numberOfReasons + 1,
                        isDefault: false
                    }
                    var newReason = numberOfReasons < 1
                        ? {
                            id: 0,
                            description: "",
                            procurementSubscriptionId: $scope.currentProcurementSubscriptionId,
                            order: 1,
                            isDefault: true,
                        }
                        : {
                            id: 0,
                            description: "",
                            procurementSubscriptionId: $scope.currentProcurementSubscriptionId,
                            order: numberOfReasons + 1,
                            isDefault: false
                        };

                    newReason.organisationId = self.headOfficeOrganisationId;

                    $scope.receivingVarianceReasons.push(newReason);
                    correctSortOrder();
                }

                $scope.deleteVarianceReason = function(reason) {
                    reason.processing = true;
                    var newDefaultNeeded = reason.isDefault;
                    var orderNumber = reason.order;
                    clientProcurementReceivingVarianceReasonsService
                        .deleteReason(reason.procurementSubscriptionId, reason.id).then(function(data) {
                            $scope.receivingVarianceReasons = data;
                            angular.forEach($scope.receivingVarianceReasons,
                                function(reason) {
                                    if (reason.order > orderNumber) {
                                        reason.order--;
                                    }
                                });
                            if (newDefaultNeeded) {
                                var newDefault = _.findWhere($scope.receivingVarianceReasons, { order: 1 });
                                newDefault.isDefault = true;
                            }
                            clientProcurementReceivingVarianceReasonsService
                                .updateSortOrderAndDefault($scope.receivingVarianceReasons).then(function(data) {
                                    reason.processing = false;
                                    $scope.receivingVarianceReasons = _.sortBy(data, 'order');
                                    translateMessage.success("your_receiving_variance_reason_was_successfully_removed");
                                });
                        });
                }

                $scope.cancelChanges = function(reason) {
                    $scope.receivingVarianceReasons = $scope.cachedReasons;
                    clearUnfinishedEntries();
                }

                $scope.saveChanges = function(reason) {
                    reason.processing = true;
                    var duplicateDescription = _.findWhere($scope.cachedReasons, { description: reason.description });
                    var isDuplicateDescription = duplicateDescription ? duplicateDescription.id != reason.id : false;
                    if (isDuplicateDescription) {
                        translateMessage.error("this_receiving_variance_reason_already_exists");
                        if (reason && $scope.cachedReason) {
                            reason.description = $scope.cachedReason.description;
                            reason.isBeingEdited = true;
                        }
                    } else {
                        if (reason.id !== 0) {
                            clientProcurementReceivingVarianceReasonsService.edit(reason, reason.isBeingEdited = false)
                                .then(function(data) {
                                    clientProcurementReceivingVarianceReasonsService
                                        .updateSortOrderAndDefault($scope.receivingVarianceReasons).then(
                                            function(data) {
                                                reason.processing = false;
                                                $scope.receivingVarianceReasons = _.sortBy(data, 'order');
                                                translateMessage.success(
                                                    "your_receiving_variance_reason_was_saved_successfully");

                                            });
                                });
                        } else {
                            $scope.saveNew(reason);
                        }
                    }
                }

                $scope.saveNew = function(reason) {
                    reason.processing = true;
                    if ($scope.receivingVarianceReasons.length > 1) {
                        var existingRecords = _.without($scope.receivingVarianceReasons, reason);
                        clientProcurementReceivingVarianceReasonsService.updateSortOrderAndDefault(existingRecords)
                            .then(function(data) {
                                clientProcurementReceivingVarianceReasonsService.add(reason).then(function(data) {
                                    reason.processing = false;
                                    $scope.receivingVarianceReasons = _.sortBy(data, 'order');
                                    translateMessage.success("your_receiving_variance_reason_was_saved_successfully");

                                    correctSortOrder();
                                });
                            });
                    } else {
                        clientProcurementReceivingVarianceReasonsService.add(reason).then(function(data) {
                            reason.processing = false;
                            $scope.receivingVarianceReasons = $scope.receivingVarianceReasons =
                                _.sortBy(data, 'order');;
                        });
                    }
                }

                $scope.editReason = function(reason) {
                    clearUnfinishedEntries();
                    $scope.cachedReason = angular.copy(reason);
                    $scope.cachedReasons = angular.copy($scope.receivingVarianceReasons);
                    reason.isBeingEdited = true;
                }

                $scope.areYouSure = function(reason) {
                    reason.promptAreYouSure = !reason.promptAreYouSure;
                }

                $scope.scopeActions = [
                    { name: $translate.instant('button_edit'), function: $scope.editReason, color: "blue" }
                ];

                $scope.editActions = [
                    {
                        name: $translate.instant('button_save'),
                        function: $scope.saveChanges,
                        color: "green",
                        disabledWhen: "!reason.description || reason.description == '' || reason.processing"
                    },
                    {
                        name: $translate.instant('button_cancel'),
                        function: $scope.cancelChanges,
                        color: "red"
                    },
                ];

                $scope.selectDefaultVarianceReason = function(id) {
                    angular.forEach($scope.receivingVarianceReasons,
                        function(reason) {
                            reason.isDefault = reason.id === id;
                        });
                }

                function clearUnfinishedEntries() {
                    $scope.receivingVarianceReasons =
                        helpers.clearUnfinishedTableEntries($scope.receivingVarianceReasons);
                    $scope.receivingVarianceReasons = _.sortBy($scope.receivingVarianceReasons, 'order');
                }

                function correctSortOrder() {
                    $scope.receivingVarianceReasons = _.sortBy($scope.receivingVarianceReasons, 'order');
                }

                $scope.moveDown = function(position) {
                    $scope.receivingVarianceReasons[position].order++;
                    $scope.receivingVarianceReasons[position + 1].order--;
                    correctSortOrder();
                }

                $scope.moveUp = function(position) {
                    $scope.receivingVarianceReasons[position].order--;
                    $scope.receivingVarianceReasons[position - 1].order++;
                    correctSortOrder();
                }

                function findDuplicates(reasons, newReason) {
                    var orders = [];
                    angular.forEach(reasons,
                        function(reason) {
                            orders.push(reason.order);
                        });
                    var positionOfDuplicate = helpers.getIndexOfDuplicate(orders, newReason.order);
                    if (positionOfDuplicate !== -1) {
                        angular.forEach(reasons,
                            function(reason) {

                            })
                    }
                }

                self.init = function() {
                    $scope.mobile = window.innerWidth <= 640;
                    $scope.hasDeletePermission = false;
                    self.context = organisationContextService.getContext();
                    $scope.organisationContext = {
                        context: self.context,
                        procurementUnits: self.context.procurementSubscriptionUnits,
                    };
                    receivingVarianceReasonData.$promise.then(function(data) {
                        $scope.receivingVarianceReasons = $scope.receivingVarianceReasons = _.sortBy(data, 'order');;
                        $scope.currentProcurementSubscriptionId =
                            localStorageService.getItem(enums.localStorage.organisationContext).id;
                    });

                    userService.hasPermission('BEAGLE_RECEIVINGVARIANCEREASONS_DELETE').then(function() {
                        $scope.hasDeletePermission = true;
                    });

                    self.headOfficeOrganisationId = localStorageService.getItem(enums.localStorage.organisationContext)
                        .organisation.id;
                }();
            });
        }]);
'use strict';

angular.module(appName)
    .factory('clientProcurementReceivingVarianceReasonsResource', [
        '$resource', "siteUrl", function ($resource, siteUrl) {
            var api = siteUrl() + "api/ClientProcurementReceivingVarianceReasons";
            return $resource(api, {}, {
                get: {
                    method: "GET",
                    url: api,
                    params: {
                        id: "@id"
                    },
                    isArray: true
                },
                deleteReason: {
                    method: "POST",
                    url: api + "/Delete",
                    params: {
                        procurementSubscriptionId: "@procurementSubscriptionId",
                        id: "@id"
                    },
                    isArray: true
                },
                add: {
                    method: "POST",
                    url: api + "/Add",
                    isArray: true
                },
                edit: {
                    method: "POST",
                    url: api + "/Edit",
                    isArray: true
                },
                updateSortOrderAndDefault: {
                    method: "POST",
                    url: api + "/UpdateSortOrderAndDefault",
                    isArray: true
                }
            });
        }
    ]);
angular.module(appName)
    .factory('clientProcurementReceivingVarianceReasonsService', [
        'clientProcurementReceivingVarianceReasonsResource', 'organisationContextService',
        function (clientProcurementReceivingVarianceReasonsResource, organisationContextService) {
            return {
                get: function (procurementSubscriptionId, cb) {
                    return clientProcurementReceivingVarianceReasonsResource.get({ id: procurementSubscriptionId }).$promise.then(cb);
                },
                deleteReason: function (procurementSubscriptionId, varianceReasonId, cb) {
                    return clientProcurementReceivingVarianceReasonsResource.deleteReason({ procurementSubscriptionId: procurementSubscriptionId, id: varianceReasonId }).$promise.then(cb);
                },
                add: function (model, cb) {
                    return clientProcurementReceivingVarianceReasonsResource.add(model).$promise.then(cb);
                },
                edit: function (model, cb) {
                    return clientProcurementReceivingVarianceReasonsResource.edit(model).$promise.then(cb);
                },
                updateSortOrderAndDefault: function (reasons, cb) {
                    var orgId = organisationContextService.getContext().organisation.id;
                    var model = {
                        procurementClientReceivingVarianceReasons: reasons,
                        organisationId: orgId
                    };
                    return clientProcurementReceivingVarianceReasonsResource.updateSortOrderAndDefault(model).$promise.then(cb);
                }
            };
        }
    ]);
angular.module(appName).controller('clientProcurementSupplierPricingController', [
    '$scope', '$q', 'enums', 'clientProcurementSupplierPricingService', 'localStorageService',
    'translateMessage', 'moment', '_', 'autoFocus', '$routeParams', 'fileDownloadService', '$http',
    'siteUrl', '$timeout','organisationContextService',
    function ($scope, $q, enums, clientProcurementSupplierPricingService, localStorageService,
        translateMessage, moment, _, autoFocus, $routeParams, fileDownloadService, $http,
        siteUrl, $timeout, organisationContextService
    ) {
            var self = this;
            $scope.company = organisationContextService.getCompany();
            $scope.moment = moment;
            $scope.priceList = {};
            $scope.priceList.supplierName = '';

            $scope.toggleActions = function (priceList) {
                priceList.promptAreYouSure = false;
                priceList.showActions = !priceList.showActions;
            }

            $scope.toggleEditingPriceList = function(priceList) {
              priceList.editing = !priceList.editing;
              if (priceList.editing) {
                _.each()
              }
            };

            $scope.goToTaskMode = function () {
                $scope.taskMode = true;
                $scope.listMode = false;
                $scope.uploadMode = false;
                $scope.validationErrorMode = false;
            };

            $scope.goToListMode = function () {
                $scope.taskMode = false;
                $scope.uploadMode = false;
                $scope.validationErrorMode = false;
                $scope.listMode = true;
            };

            $scope.goToUploadMode = function () {
                $scope.uploadMode = true;
                $scope.listMode = false;
                $scope.taskMode = false;
                $scope.validationErrorMode = false;
            };

            $scope.goToValidationErrorMode = function () {
                $scope.validationErrorMode = true;
                $scope.listMode = false;
                $scope.taskMode = false;
                $scope.uploadMode = false;
            };

            $scope.download = function (priceList) {
                var url = 'api/ProcurementSubscriptionSupplier/DownloadPrices?id='
                    + self.context.id
                    + '&quoteSheetId='
                    + priceList.currentQuoteSheetId;

                return fileDownloadService.downloadFile(url, 'QuoteSheet', 'xlsm');
            };

            $scope.downloadTemplate = function () {
                var url = 'api/ProcurementSubscriptionSupplier/DownloadTemplate?supplierId=' + $scope.supplierId;
                return fileDownloadService.downloadFile(url, 'SupplierImportTemplate', 'xlsm');
            };

            $scope.opened = [];
            $scope.open = function (index) {
              $timeout(function () {
                $scope.opened[index] = true;
              });
            };

            $scope.datesValid = function () {
              var start = $scope.priceList.startDate;
              var end = $scope.priceList.endDate;
              if (!start) {
                return false;
              }
              if (!end) {
               return true;
             }

              if (moment(end, 'DD/MM/YYYY') <= moment(start, 'DD/MM/YYYY')) {
               return false;
             }
              return true;
            };

            $scope.processSupplierPriceFile = function (fileDetails) {
                $scope.loading = true;

                var dto = {
                    agreementId: $scope.agreementId,
                    documentId: fileDetails.id,
                    organisationId: self.context.organisation.id,
                    pricesBegin: $scope.priceList.startDate,
                    pricesEnd: $scope.priceList.endDate,
                    supplierId: $scope.supplierId
                };

                var promise = clientProcurementSupplierPricingService
                    .processSupplierPriceFile(dto)
                    .$promise;

                return promise.then(function(returnedData) {
                    if (returnedData.dto.validationErrors.length > 0) {
                        $scope.goToValidationErrorMode();
                        $scope.validationErrors = returnedData.dto.validationErrors;
                    } else {
                        $scope.priceImportSuccessData = returnedData.dto;
                        $scope.goToTaskMode();
                    }
                    $scope.loading = false;
                }, function(error) {
                    $scope.loading = false;
                    $scope.goToUploadMode();
                });
            };

            $scope.submitTask = function () {
                $scope.creatingPrices = true;
                var taskId = $scope.priceImportSuccessData.taskId;
                var url = siteUrl() + 'api/Tasks/SubmitTask?taskId=' + taskId;
                $http.post(url).then(function() {
                    translateMessage.success('prices_created');
                    self.refreshPriceLists();
                    $scope.goToListMode();
                    $scope.creatingPrices = false;
                });
            };


            self.refreshPriceLists = function() {
                $scope.priceListData = $q.defer();
                clientProcurementSupplierPricingService
                    .getPreviouslyUploadedPriceLists(
                        self.context.id,
                        $scope.supplierId,
                        $scope.agreementId
                    ).$promise.then(function (priceListData) {
                        $scope.priceLists = priceListData.priceListDtos;
                        $scope.goToListMode();
                        $scope.priceListData.resolve();
                    });
            };

            $scope.savePriceList = function (priceList) {
                priceList.organisationId = self.context.organisation.id;
                clientProcurementSupplierPricingService
                    .savePriceList(priceList,$scope.supplierId)
                    .$promise
                    .then(function() {
                        translateMessage.success('price_list_saved');
                    });
            };

            $scope.deletePriceList = function (priceList) {
                clientProcurementSupplierPricingService
                    .deletePriceList(self.context.id, priceList.id)
                    .$promise.then(function () {
                        $scope.priceLists.remove(priceList);
                        translateMessage.success('price_list_deleted');
                    });
            };

            $scope.init = function () {
                //TODO get these from URL or the resolve
                $scope.agreementId = $routeParams.agreementId != 'null' ? $routeParams.agreementId : 0;
                $scope.supplierId = $routeParams.supplierId;
				$scope.supplierName = decodeURIComponent($routeParams.supplierName);

                self.context = localStorageService.getItem(enums.localStorage.organisationContext);
                self.refreshPriceLists();
            }();
    }
]);
angular.module(appName)
    .factory('clientProcurementSupplierPricingResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/ProcurementSubscriptionSupplier';
            return $resource(api,
            {},
            {
                get: {
                    method: 'GET',
                    url: api + '/Get',
                    params: {
                        id: "@id"
                    },
                    isArray: true
                },
                post: {
                    method: 'POST',
                    url: api + '/Post'
                },
                put: {
                    method: 'PUT',
                    url: api + '/Put'
                },
                remove: {
                    method: 'POST',
                    url: api + '/Delete',
                    params: {
                        id: '@id'
                    }
                },
                processSupplierPriceFile: {
                    method: "POST",
                    url: api + "/ProcessSupplierPriceFile",
                    params: {
                        organisationId: "@organisationId",
                        supplierId: "@supplierId",
                        agreementId: "@agreementId",
                        documentId: "@documentId",
                        pricesBegin: "@pricesBegin",
                        pricesEnd: "@pricesEnd"
                    }
                },
                
                getPreviouslyUploadedPriceLists: {
                    method: "GET",
                    url: api + "/GetPreviouslyUploadedPriceLists",
                    params: {
                        supplierId: "@supplierId",
                        agreementId: "@agreementId",
                        id: "@id"
                    },
                    isArray: false
                },
                deletePriceList: {
                    method: "DELETE",
                    url: api + "/DeletePriceList",
                    params: {
                        priceListId: "@priceListId",
                        id: "@id"

                    },
                    isArray: false
                },

                download: {
                    method: 'POST',
                    url: api + '/DownloadPrices',
                    data: {
                        quoteSheetId: "@quoteSheetId"
                    },
                    isArray: false
                },
                savePriceList: {
                    method: 'POST',
                    url: api + '/SAVEPRICELIST'
                }
                
            });
        }
    ])
angular.module(appName)
    .factory('clientProcurementSupplierPricingService', [
        'clientProcurementSupplierPricingResource','$window','$location',
        function (clientProcurementSupplierPricingResource,$window,$location) {
            return {
                get: function (subscriptionId) {
                    return clientProcurementSupplierPricingResource.get({ id: id });
                },
                remove: function (model) {
                    return clientProcurementSupplierPricingResource.remove({ id: id });
                },
                add: function (model) {
                    return clientProcurementSupplierPricingResource.post(model);
                },
                edit: function(model) {
                    return clientProcurementSupplierPricingResource.put(model);
                },
                processSupplierPriceFile: function(dto) {
                    return clientProcurementSupplierPricingResource.processSupplierPriceFile(dto);
                },
                getPreviouslyUploadedPriceLists: function(id, supplierId, agreementId) {
                    return clientProcurementSupplierPricingResource
                        .getPreviouslyUploadedPriceLists({ id: id, supplierId: supplierId, agreementId: agreementId });
                },
                deletePriceList: function (id, priceListId) {
                    return clientProcurementSupplierPricingResource.deletePriceList({ id: id, priceListId: priceListId });
                },
                download: function (id, quoteSheetId) {
                    console.log("about to change window.open for quotesheetid sdsd", quoteSheetId);
                        window.open("api/ProcurementSubscriptionSupplier/DownloadPrices?id=" + id + "&quoteSheetId=" + quoteSheetId,
                        "_blank",
                        '');

                },
                savePriceList: function (priceList, supplierId) {
                    priceList.supplierId = supplierId;
                    return clientProcurementSupplierPricingResource.savePriceList(priceList);
                }
            };
        }
    ]);

angular.module(appName).controller('addEditClientProcurementSupplierController', [
    '$scope', '$location', 'localStorageService', 'organisationContextService',
    'clientProcurementSuppliersService', 'countryData', 'groupSupplierData',
  'windowService', '$translate', 'organisationFactory', 'organisationContactFactory','translateMessage',
    function ($scope, $location, localStorageService, organisationContextService,
        clientProcurementSuppliersService, countryData, groupSupplierData,
      windowService, $translate, organisationFactory, organisationContactFactory, translateMessage
    ) {
                $scope.isLoading = true;
                var self = this;
                self.ctx = organisationContextService.getContext();
                $scope.subscriptionId = self.ctx.id;
                $scope.clientOrganisationId = self.ctx.currentSubscriptionUnit.organisation.id;
                $scope.clientGroupOrganisationId = self.ctx.organisation.id;

                $scope.close = function () {
                    windowService.groupSuppliers();
                }

                $scope.createSupplier = function () {
                    $scope.currentSupplierAdded = false;
                    $scope.currentSupplier = {
                        procurementClientSubscriptionId: $scope.subscriptionId,
                        clientOrganisationId: $scope.clientOrganisationId,
                        organisationId: $scope.clientGroupOrganisationId
                    };
                };

                $scope.addUpdateSupplier = function (form) {

                    if ($scope.validateForm(form)) {
                        $scope.savingSupplier = true;
                        var country = $scope.currentSupplier.country;

                        if (country && country.id) {
                            var countryDto = { name: country.name, id: country.id };
                            $scope.currentSupplier.organisationTradingCountryDto = countryDto;
                            $scope.currentSupplier.tradingCountryId = countryDto.id;
                            $scope.currentSupplier.address.tradingCountry = countryDto;
                        } else {
                            translateMessage.error('country_not_found_please_try_again_later');
                        }

                        if ($scope.currentSupplier.id) {
                            $scope.currentSupplier.organisationId = self.ctx.organisation.id;

                            return clientProcurementSuppliersService.update($scope.currentSupplier).$promise.then(function (data) {
                                translateMessage.success('supplier_details_saved');
                                var updatedSupplier = data;
                                updatedSupplier.supplier.name = updatedSupplier.orgName;
                                updatedSupplier.updated = true;
                                self.suppliersAdded.push(updatedSupplier);
                                localStorageService.setItem('newSuppliers', self.suppliersAdded);
                                $scope.currentSupplierId = data.supplierId;
                                $scope.savingSupplier = false;
                            }, function (error) {
                                translateMessage.error(error.data.exceptionMessage, true);
                                $scope.savingSupplier = false;
                            });
                        }
                        else {
                            return clientProcurementSuppliersService.post($scope.currentSupplier).$promise.then(function (data) {
                                translateMessage.success('supplier_details_saved');
                                self.suppliersAdded.push(data);
                                localStorageService.setItem('newSuppliers', self.suppliersAdded);
                                $scope.currentSupplier = data;
                                $scope.currentSupplierId = data.supplierId;
                                $scope.currentSupplierAdded = true;
                                $scope.savingSupplier = false;

                                var currentPath = $location.path();
                                currentPath = currentPath.replace(/\/$/, '');

                                $location.path(currentPath + '/' + data.id);

                            }, function (error) {
                                translateMessage.error(error.data.exceptionMessage, true);
                                $scope.savingSupplier = false;
                            });
                        }
                    }

                    return false;
                };

                $scope.validateForm = function (form) {
                    return form.$valid && ($scope.currentSupplier.country && $scope.currentSupplier.country.id > 0);
                }

                groupSupplierData.$promise.then(function (supplierData) {
                    if (supplierData) {
                        $scope.currentSupplier = supplierData;
                    }

                    countryData.$promise.then(function (countries) {
                        var orgCountry = countries.orgCountry;
                        var countryList = countries.countries;
                        var emptyCountry = { id: 0, name: 'No Country Selected.' };
                        $scope.countries = countryList;
                        $scope.countries.push(emptyCountry);

                        if ($scope.currentSupplier) {
                            $scope.currentSupplierId = $scope.currentSupplier.supplierId;
                            $scope.currentSupplier = angular.copy($scope.currentSupplier);
                            if (countryList != null && $scope.currentSupplier.countryId != null) {
                                $scope.currentSupplier.country = _.findWhere(countryList, { id: $scope.currentSupplier.countryId });
                                $scope.countries.remove(emptyCountry);
                            }
                            $scope.currentSupplier.orgName = $scope.currentSupplier.supplier.name;
                        } else if ($scope.subscriptionId && $scope.clientOrganisationId) {
                            $scope.createSupplier();
                            if (orgCountry) {
                                $scope.currentSupplier.country = _.findWhere($scope.countries, { id: orgCountry.id });
                            }
                        } else {
                            $location.path('/Impersonation');
                        }

                        $scope.closeCreateEditContactView = function () {
                            $scope.createEditContact = false;
                        }

                        $scope.createEditOrgContact = function (orgContact) {
                            if (orgContact) {
                                $scope.activeContact = orgContact;
                            } else {
                                $scope.activeContact = {
                                    id: 0, contactId: 0,
                                    organisationId: $scope.currentSupplier.orgId
                                };
                            }
                            $scope.createEditContact = true;
                        };

                        $scope.getOrgContacts = function () {
                            var dataToSend = { orgId: $scope.currentSupplier.orgId, id: $scope.subscriptionId };
                            return organisationFactory.getOrganisationContactsForOrganisation(dataToSend)
                                .$promise.then(function (data) {
                                    $scope.currentSupplier.organisationContacts = data.orgContacts;
                                    $scope.loadingList = false;
                                });
                        };

                        $scope.refreshActiveContacts = function () {
                            $scope.createEditMode = false;
                            $scope.currentSupplier.organisationContacts = [];
                            if ($scope.currentSupplier.id) {
                                $scope.getOrgContacts();
                            } else {
                                $scope.loadingList = false;
                            }
                        };

                        $scope.$watch('currentSupplier', function () {
                            $scope.loadingList = true;
                            var currentSupplier = $scope.currentSupplier;
                            if (currentSupplier && currentSupplier.id) {
                                $scope.refreshActiveContacts();
                            } else {
                                $scope.loadingList = false;
                            }
                        });

                        self.saveOrgContactToDatabase = function (orgContact, toggleCreateEditMode) {
                            return organisationContactFactory.save(orgContact).$promise.then(function (orgContact) {
                                orgContact.userSaving = false;
                                $scope.savingContact = false;
                                translateMessage.success('organisation_contact_saved');
                                $scope.activeContact = orgContact;
                                var preExistingContact = _.findWhere($scope.currentSupplier.organisationContacts, { id: orgContact.id });
                                if (!preExistingContact) {
                                    if (!$scope.currentSupplier.organisationContacts) {
                                        $scope.currentSupplier.organisationContacts = [];
                                    }
                                    $scope.currentSupplier.organisationContacts.push(orgContact);
                                } else {
                                    preExistingContact.userId = orgContact.userId;
                                    preExistingContact.username = orgContact.username;
                                    preExistingContact.password = orgContact.password;
                                    preExistingContact.jobTitleId = orgContact.jobTitleId;
                                    preExistingContact.userSaving = false;
                                }
                                $scope.refreshActiveContacts();
                                if (toggleCreateEditMode)
                                    $scope.toggleCreateEditMode();
                            },
                                function (error) {
                                    console.error(error);
                                    $scope.savingContact = false;
                                    translateMessage.error(error.data.exceptionMessage, true);
                                });
                        };

                        $scope.saveOrganisationContact = function (orgContact, toggleCreateEditMode, form, formNotRequired) {
                            $scope.savingContact = true;
                            if (formNotRequired || (form && form.$valid)) {
                                self.saveOrgContactToDatabase(orgContact);

                            }
                            if (form && !form.$valid) {
                                $scope.savingContact = false;
                                translateMessage.error('please_correct_the_validation_errors');
                            }
                        };

                        $scope.deleteOrganisationContact = function (orgContact) {
                            organisationContactFactory.delete({ id: orgContact.id }).$promise.then(function () {
                                $scope.currentSupplier.organisationContacts.remove(orgContact);
                                $scope.refreshActiveContacts();
                            });
                        };

                        $scope.init = function () {
                            self.suppliersAdded = [];
                            $scope.isLoading = $scope.createEditContact = false;
                        }();
                    });
                });
    }
]);

angular.module(appName).controller('clientProcurementSuppliersController', [
    '$scope', '$q', 'enums', 'clientProcurementSuppliersService', 'localStorageService',
    'translateMessage', '_', '$location', 'autoFocus', 'helpers', 'windowService', '$translate',
    function($scope, $q, enums, clientProcurementSuppliersService, localStorageService,
        translateMessage, _, $location, autoFocus, helpers, windowService, $translate
    ) {
            var self = this;

            $translate('label_view_accounts').then(function(t) {
                $scope.viewAccountsText = t;
            });

            $scope.mobile = window.innerWidth <= 640;
            $scope.searchText = '';

            $scope.unit = {};

            $scope.updateVendorCode = function(groupSupplier) {
                groupSupplier.orgName = groupSupplier.supplier.name;
                groupSupplier.organisationId = self.context.organisation.id;
                clientProcurementSuppliersService.update(groupSupplier).$promise.then(function(data) {
                    translateMessage.success('head_office_vendor_code_saved');
                    groupSupplier.isBeingEdited = false;

                    var itemOnArray = _.find($scope.groupSupplierData, function(item) {
                        return item.id == groupSupplier.id;
                    });

                    itemOnArray.headOfficeVendorCode.id = data.id;
                });
            };

            $scope.areYouSure = function(groupSupplier) {
                groupSupplier.promptAreYouSure = !groupSupplier.promptAreYouSure;
            };

            $scope.addEditSupplier = function(groupSupplier) {
                if (groupSupplier) {
                    windowService.addEditSupplier(groupSupplier.id);
                } else {
                    windowService.addEditSupplier();
                }
                var newSuppliers = localStorageService.getItem('newSuppliers');
                if (newSuppliers && newSuppliers.length > 0) {
                    _.each(newSuppliers, function(newSupplier) {
                        if (newSupplier.updated) {
                            var supplierToUpdate = _.findWhere($scope.groupSuppliers, { id: newSupplier.id });
                            $scope.groupSuppliers = _.without($scope.groupSuppliers, supplierToUpdate);
                        }

                        var supplierOnArray = _.find($scope.groupSuppliers, function(item) {
                            return item.id === newSupplier.id;
                        });

                        if (!supplierOnArray) {
                            $scope.groupSuppliers.push(newSupplier);
                        }
                    });
                    $scope.groupSuppliers = _.sortBy(
                        _.uniq($scope.groupSuppliers,
                            function(groupSupplier) {
                                return groupSupplier;
                            }),
                        function(groupSupplier) {
                            return groupSupplier.supplier.name.toLowerCase();
                        });
                    $scope.items = $scope.groupSuppliers;
                }
            };

            $scope.toggleAccounts = function(groupSupplier) {
                groupSupplier.showAccounts = !groupSupplier.showAccounts;
                groupSupplier.toggleAccountsLabel = groupSupplier.showAccounts ? 'Hide Accounts' : $scope.viewAccountsText;
                if (groupSupplier.showAccounts) {
                    groupSuppliersService.getSupplierAccounts(self.context.user.orgId, groupSupplier.supplierId)
                        .$promise.then(function(data) {
                            $scope.supplierAccounts = data;
                        });
                }
            };

            $scope.toggleActions = function(groupSupplier) {
                groupSupplier.promptAreYouSure = false;
                groupSupplier.showActions = !groupSupplier.showActions;
                if (groupSupplier.showAccounts) {
                    groupSuppliersService.getSupplierAccounts(self.context.user.orgId, groupSupplier.supplierId)
                        .$promise.then(function(data) {
                            $scope.supplierAccounts = data;
                        });
                }
            };

            $scope.editVendorCode = function(groupSupplier) {
                autoFocus.implementForElementWithId('input-vendor-code');
                groupSupplier.isBeingEdited = true;
                self.cachedCode = angular.copy(groupSupplier.headOfficeVendorCode);
                if (groupSupplier.showAccounts) {
                    $scope.toggleAccounts(groupSupplier);
                }
            };

            $scope.cancelEdit = function(groupSupplier) {
                groupSupplier.isBeingEdited = false;
                groupSupplier.headOfficeVendorCode = self.cachedCode;
            };

            $scope.deleteGroupSupplier = function(supplier) {
                supplier.loading = true;
                clientProcurementSuppliersService.remove(supplier.id).$promise.then(function(data) {
                    if (data) {
                        translateMessage.success('supplier_deleted');

                        $scope.groupSuppliers = _.without(
                            $scope.groupSuppliers,
                            _.findWhere(
                                $scope.groupSuppliers,
                                { id: supplier.id }
                            )
                        );
                    } else {
                        translateMessage.error('something_went_wrong_please_try_again_later');
                    }
                    supplier.loading = false;
                });
            };

            $scope.managePricing = function(groupSupplier) {
                if (groupSupplier.agreementId) {
                    $location.path('ManagePricing/' +
                        groupSupplier.supplierId +
                        '/' +
                        groupSupplier.agreementId +
                        '/' +
						encodeURIComponent(groupSupplier.supplier.name));
                } else {
                    translateMessage.error('you_must_associate_at_least_one_depot_with_your_supplier_before_you_can_upload_pricing');
                }
            };

            var subscriptionId;
            var search = function() {
                clientProcurementSuppliersService.get(subscriptionId, $scope.searchText).$promise.then(function(data) {
                    $scope.groupSuppliers = data;
                    // Technical debt to be investigated if possible - Dtos are inconsistent, hence crude mapping here between City and Town
                    _.each($scope.groupSuppliers, function(groupSupplier) {
                        groupSupplier.city = groupSupplier.town;
                    });
                    $scope.items = data;
                });
            }

            $scope.search = function() {
                search();
            }


      $scope.init = function() {
        localStorageService.setItem('newSuppliers', []);
        self.context = localStorageService.getItem(enums.localStorage.organisationContext);
        subscriptionId = self.context.id;
        $scope.subscriptionId = self.context.currentSubscriptionUnit.procurementSubscriptionId;
        $scope.orgId = self.context.currentSubscriptionUnit.organisation.id;
        search();
      }();
    }
]);
angular.module(appName)
    .factory('clientProcurementSuppliersResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/ProcurementSubscriptionSupplier';
            return $resource(api,
            {},
            {
                get: {
                    method: 'GET',
                    url: api + '/Get',
                    params: {
                        id: "@id"
                    },
                    isArray: true
                },
                getClientSpecificSuppliers: {
                    method: 'GET',
                    url: api + '/GetClientSpecificSuppliers',
                    params: {
                        subscriptionId: "@subscriptionId"
                    },
                    isArray: true
                },
                post: {
                    method: 'POST',
                    url: api + '/Post'
                },
                update: {
                    method: 'PUT',
                    url: api + '/Put'
                },
                remove: {
                    method: 'DELETE',
                    url: api + '/Delete',
                    params: {
                        id: '@id'
                    }
                },
                getSupplierData: {
                    method: 'GET',
                    url: api + '/GetSupplierData',
                    params: {
                        subscriptionSupplierId: '@subscriptionSupplierId'
                    }
                }
                
            });
        }
    ])
angular.module(appName)
    .factory('clientProcurementSuppliersService', [
        'clientProcurementSuppliersResource',
        function (clientProcurementSuppliersResource) {
            return {
                get: function (subscriptionId, searchText) {
                    return clientProcurementSuppliersResource.get({ id: subscriptionId, searchText: searchText });
                },
                getClientSpecificSuppliers: function (subscriptionId, cb) {
                    return clientProcurementSuppliersResource.getClientSpecificSuppliers({ subscriptionId: subscriptionId });
                },
                remove: function (id) {
                    return clientProcurementSuppliersResource.remove({ id: id });
                },
                post: function (model) {
                    return clientProcurementSuppliersResource.post(model);
                },
                update: function (model) {
                    return clientProcurementSuppliersResource.update(model);
                },
                getSupplierData: function(supplierId) {
                    return clientProcurementSuppliersResource.getSupplierData({ supplierId: supplierId });
                }
            };
        }
    ]);
angular.module(appName)
    .factory('clientUnitAccountCodeResource',
    [
        '$resource', 'siteUrl',
        function($resource, siteUrl) {
            var api = siteUrl() + 'api/ClientUnitProcurementAccountCode';
            return $resource(api,
            {},
            {
                get: {
                    method: 'GET',
                    url: api + '/Get',
                    params: { id: '@id' }
                },
                getClientUnitAccountCodes: {
                    method: 'GET',
                    url: api + '/GetClientUnitAccountCodes',
                    params: { id: '@id' },
                    isArray: true
                },
                getClientAccountCodes: {
                    method: 'GET',
                    url: api + '/GetClientProcurementAccountCodes',
                    params: {
                        subscriptionId: '@subscriptionId',
                        id:'@id'
                    },
                    isArray: true
                },
                addAccountCodesToClientUnit: {
                    method: 'POST',
                    url: api + '/AddAccountCodesToClientUnit',
                    isArray: true
                },
                update: {
                    method: 'Put',
                    url: api + '/Put'
                },
                remove: {
                    method: 'Delete',
                    url: api + '/DeleteClientUnitProcurementAccountCode',
                    params: { id: '@id' }
                },
                addUserToClientUnitAccountCode: {
                    method: 'POST',
                    url: api + '/AddUserToClientUnitAccountCode',
                    params: {
                        userId: '@userId',
                        procurementSubscriptionAccountCodeId: '@procurementSubscriptionAccountCodeId',
                        organisationId:'@organisationId'
                    },
                    isArray: false
                },
                removeUserFromClientUnitAccountCode: {
                    method: 'POST',
                    url: api + '/RemoveUserFromClientUnitAccountCode',
                    params: {
                        userId: '@userId',
                        procurementSubscriptionAccountCodeId: '@procurementSubscriptionAccountCodeId',
                        organisationId: '@organisationId'
                    },
                    isArray: false
                },
                setUserAsDefaultClientUnitAccountCodeUser: {
                    method: 'POST',
                    url: api + '/SetUserAsDefaultClientUnitAccountCodeUser',
                    params: {
                        userId: '@userId',
                        procurementSubscriptionAccountCodeId: '@procurementSubscriptionAccountCodeId',
                        organisationId: '@organisationId'
                    },
                    isArray: false
                },
                removeUserAsDefaultClientUnitAccountCodeUser: {
                    method: 'POST',
                    url: api + '/RemoveUserAsDefaultClientUnitAccountCodeUser',
                    params: {
                        userId: '@userId',
                        procurementSubscriptionAccountCodeId: '@procurementSubscriptionAccountCodeId',
                        organisationId: '@organisationId'
                    },
                    isArray: false
                },
                getClientUnitProcurementAccountCodesForUser: {
                    method: 'GET',
                    url: api + '/GetClientUnitProcurementAccountCodesForUser',
                    params: {
                        userId: '@userId',
                        id: '@id',
                    	projection: '@projection'
                    },
                    isArray: true
                }
            });
        }
    ]);
angular.module(appName)
	.factory("clientUnitAccountCodeService", [
		"clientUnitAccountCodeResource",
		"organisationContext",
		function(clientUnitAccountCodeResource, organisationContext) {
			return {
				get: function(id) {
					return clientUnitAccountCodeResource.get({ id: id });
				},
				getClientUnitAccountCodes: function (clientUnitId) {
					if (!clientUnitId) {
						clientUnitId = organisationContext.currentSubscriptionUnit.id;
					};
					return clientUnitAccountCodeResource.getClientUnitAccountCodes({ id: clientUnitId });
				},
				getClientAccountCodes: function(subscriptionId, unitId) {
					return clientUnitAccountCodeResource.getClientAccountCodes({ id: unitId, subscriptionId: subscriptionId });
				},
				addAccountCodesToClientUnit: function(obj) {
					return clientUnitAccountCodeResource.addAccountCodesToClientUnit(obj);
				},
				updateAccountCode: function(accountCode) {
					return clientUnitAccountCodeResource.update(accountCode);
				},
				remove: function(id) {
					return clientUnitAccountCodeResource.remove({ id: id });
				},
				getClientUnitProcurementAccountCodesForUser: function(id, userId, projection) {
					if (!id) {
						id = organisationContext.currentSubscriptionUnit.id;
					};
					if (!userId) {
						userId = organisationContext.user.id;
					}
					if (!projection)
						projection = "eProcurement.ProcurementClientUnitAccountCodeDto";
					return clientUnitAccountCodeResource.getClientUnitProcurementAccountCodesForUser(
						{
							id: id,
							userId: userId,
							projection: projection
						}
					);
				},
				getDefaultAccountCodeForUser: function(accountCodes) {
					return _.findWhere(accountCodes, { isDefaultForCurrentUser: true })
				}
			};
		}
	]);
'use strict';

angular.module(appName)
    .factory('clientUnitProcurementReceivingVarianceReasonsResource', [
        '$resource', "siteUrl", function ($resource, siteUrl) {
            return $resource(siteUrl() + "api/ClientUnitProcurementReceivingVarianceReasons", {}, {
                get: {
                    method: "GET",
                    url: siteUrl() + "api/ClientUnitProcurementReceivingVarianceReasons/Get",
                    params: {
                        id: "@id"
                    },
                    isArray: true
                },
                update: {
                    method: "POST",
                    url: siteUrl() + "api/ClientUnitProcurementReceivingVarianceReasons/Update",
                    isArray: true
                }
            });
        }
    ]);
angular.module(appName)
    .factory('clientUnitProcurementReceivingVarianceReasonsService', [
        'clientUnitProcurementReceivingVarianceReasonsResource',
        function (clientUnitProcurementReceivingVarianceReasonsResource) {
            return {
                get: function (id, subscriptionId, cb) {
                    return clientUnitProcurementReceivingVarianceReasonsResource.get({ id: id });
                },
                update: function (reasons, cb) {
                    return clientUnitProcurementReceivingVarianceReasonsResource.update(reasons).$promise.then(cb);
                }
            };
        }
    ]);
angular.module(appName)
    .factory('clientUnitResource', [
        '$resource', 'siteUrl',
        function($resource, siteUrl) {
            var api = siteUrl() + 'api/ProcurementClientUnit';
            return $resource(api, {}, {
                get: {
                    method: 'GET',
                    url: api + '/get',
                    params: {
                        id: '@id',
                        clientUnitId: '@clientUnitId'
                    }
                },
                getBySubscriptionId: {
                    method: 'GET',
                    url: api + '/getBySubscriptionId',
                    params: {
                        id: '@id'
                    }
                },
                getAllProcurementUnitsForSubscription: {
                    method: 'GET',
                    url: api + '/GetAllProcurementUnitsForSubscription',
                    params: {
                        procurementSubscriptionId: '@procurementSubscriptionId'
                    },
                    isArray: true
                },
                getAllProcurementUnitDtosForSubscription: {
                    method: 'GET',
                    url: api + '/GetAllProcurementUnitDtosForSubscription',
                    params: {
                        id: '@id'
                    },
                    isArray: true
                },
              getClientOrderSheetType: {
                method: 'GET',
                url: api + '/GetClientOrderSheetType',
                params: {
                  clientId: '@clientId'
                }
              },
                save: {
                    method: 'PUT',
                    url: api + '/put'
                },
                setEprocurementEnabled: {
                    method: 'POST',
                    url: api + '/SetEprocurementEnabled',
                    params: {
                        id: '@id',
                        isEnabled: '@isEnabled'
                    }
                },
                removeLogo: {
                    method: 'POST',
                    url: api + '/RemoveLogo',
                    params: {
                        clientId: '@clientId'
                    }
                }
            });
        }
    ])

angular.module(appName)
    .factory('clientUnitService', [
        'clientUnitResource', 'toastr', 'Upload', '$translate',
        function (clientUnitResource, toastr, upload, $translate) {
            return {
                get: function (id, clientUnitId, cb) {
                    return clientUnitResource.get({id: id, clientUnitId: clientUnitId}).$promise.then(cb);
                },
                getBySubscriptionId: function (id, cb) {
                    return clientUnitResource.getBySubscriptionId({id: id}).$promise.then(cb);
                },
                save: function (unit, cb) {
                    return clientUnitResource.save(unit).$promise.then(cb);
                },
                setEprocurementEnabled: function (id, isEnabled, cb) {
                    return clientUnitResource
                        .setEprocurementEnabled({id: id, isEnabled: isEnabled});

                },
                getAllProcurementUnitsForSubscription: function (procurementSubscriptionId) {
                    return clientUnitResource.getAllProcurementUnitsForSubscription({
                        procurementSubscriptionId: procurementSubscriptionId
                    });
                },
                getAllProcurementUnitDtosForSubscription: function (procurementSubscriptionId) {
                    return clientUnitResource.getAllProcurementUnitDtosForSubscription({
                        id: procurementSubscriptionId
                    });
                },
              getClientOrderSheetType: function (clientId) {
                return clientUnitResource.getClientOrderSheetType({
                  clientId: clientId
                })
              },
                validateLogo: function ($file) {
                    var success = true;
                    if ($file) {
                        var logo = $file;
                        console.log('logo', logo);

                        if (logo.type !== 'image/jpeg' && logo.type !== 'image/png') {
                            success = false;
                            $translate('error_must_upload_correct_image_type').then(function (t) {
                                toastr.error(t);
                            });
                        } else {
                            var megaBytes = logo.size / 1000000;
                            if (megaBytes > 10) {
                                success = false;
                                $translate('error_file_size_limit').then(function (t) {
                                    toastr.error(t)
                                });
                            }
                        }
                    } else {
                        success = false;
                    }

                    return success;
                },
                uploadLogo: function (id, orgId, $file, cb) {
                    return upload.upload({
                        url: 'api/ProcurementClientUnit/UploadLogo?id=' + id + '&orgId=' + orgId,
                        id: id,
                        orgId: orgId,
                        file: $file
                    })
                        .progress(function (evt) {
                            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                            console.log('progress: ' + progressPercentage + '% ' + evt.config.file.name);
                        })
                        .success(function (data, status, headers, config) {
                            if (cb)
                                cb(data);
                        })
                        .error(function (err) {
                            console.log(err);
                        });
                },
                removeLogo: function (clientId) {
                    return clientUnitResource.removeLogo({clientId: clientId});
                }
            };
        }
    ]);

angular.module(appName)
    .controller("clientUnitSetupController", [
        "$scope",
        "$q",
        "clientUnitService",
        "localStorageService",
        "currencyService",
        "enums",
        "translateMessage",
		function (
			$scope,
            $q,
            clientUnitService,
            localStorageService,
            currencyService,
            enums,
            translateMessage
        ) {
            var self = this;

            $scope.organisationContext = localStorageService.getItem(enums.localStorage.organisationContext);
            $scope.storage = localStorageService;

            $scope.clientUnitDepartments = [];

            $scope.clientAccountCodes = [];
            $scope.accountCodeUnitArray = [];

            $scope.accountCodePromise = $q.defer();
            $scope.unitDepartmentPromise = $q.defer();

            $scope.uploadLogo = function ($file) {
                var unit = $scope.organisationContext.currentSubscriptionUnit;
                if (clientUnitService.validateLogo($file)) {
                    clientUnitService.uploadLogo($scope.organisationContext.currentSubscriptionUnit.id, unit.organisation.id, $file, function (data) {
                        $scope.organisationContext.currentSubscriptionUnit.logoUrl = data.url;
                        translateMessage.success('logo_was_updated_successfully');
                    });
                }
            };

            $scope.removeLogo = function () {
                var unit = $scope.organisationContext.currentSubscriptionUnit;
                clientUnitService.removeLogo(unit.organisation.id, unit.client.id)
                    .$promise.then(function () {
                        translateMessage.success('your_logo_was_successfully_removed');
                    });
            };

            $scope.setEprocurementEnabled = function (isEnabled) {
                $scope.disableEnableDisableEprocurement = true;
                clientUnitService.setEprocurementEnabled($scope.organisationContext.currentSubscriptionUnit.id, isEnabled).$promise.then(function (data) {
                    $scope.organisationContext.currentSubscriptionUnit.isEprocurementEnabled = isEnabled;
                    console.log(data);
                    $scope.disableEnableDisableEprocurement = false;
                    localStorageService.setItem(enums.localStorage.organisationContext, $scope.organisationContext);
                });
            };

            $scope.isUnitEprocurementEnabled = function () {
                if ($scope.organisationContext && $scope.organisationContext.currentSubscriptionUnit) {
                    return $scope.organisationContext.currentSubscriptionUnit.isEprocurementEnabled;
                }
                return false;
            };

            $scope.setCurrency = function () {
                return currencyService.get().$promise.then(function (currencies) {
                    $scope.currencies = currencies;
                    if (localStorageService.getItem(enums.localStorage.organisationContext)
                        .currentSubscriptionUnit.currency) {
                        var selectedCurrency = _.findWhere($scope.currencies,
                            {
                                id: localStorageService.getItem(enums.localStorage.organisationContext)
                                    .currentSubscriptionUnit.currency.id
                            });
                        $scope.organisationContext.currentSubscriptionUnit.currency = selectedCurrency;
                    } else {
                        $scope.organisationContext.currentSubscriptionUnit.currency = $scope.currencies[0];
                    }
                });
            };
            $scope.saveClientUnit = function ($form) {
                if ($form.$valid) {
                    if ($scope.organisationContext.currentSubscriptionUnit.poPrefix == "") {
                        $scope.organisationContext.currentSubscriptionUnit.poPrefix = null;
                    }
                    return clientUnitService.save($scope.organisationContext.currentSubscriptionUnit,
						function () {
							$scope.organisationContext.currency =
								$scope.organisationContext.currentSubscriptionUnit.currency;
                            localStorageService.setItem(enums.localStorage.organisationContext,
                                $scope.organisationContext);
                            translateMessage.success('your_unit_was_saved_successfully');
                        });

                } else {
                    // Just return false, the form is invalid.
                    return false;
                }
            };

            self.init = function () {
                $scope.mobile = window.innerWidth <= 640;
                $scope.processing = false;
            }();
        }
    ]);
'use strict';

angular.module(appName)
  .controller("accountCodesSectionController", [
    "$scope",
    "clientUnitAccountCodeService",
    "localStorageService",
    "enums",
    "translateMessage",

    function ($scope, clientUnitAccountCodeService, localStorageService, enums, translateMessage) {

      var organisationContext = localStorageService.getItem(enums.localStorage.organisationContext);
      var currentSubscriptionUnitId = organisationContext.currentSubscriptionUnit.id;
      var unitOrganisationId = organisationContext.currentSubscriptionUnit.organisation.id;
      var subscriptionId = organisationContext.id;

      $scope.clientUnitAccountCodes = [];
      var procurementAccountCodeResolve = clientUnitAccountCodeService.getClientAccountCodes(subscriptionId, currentSubscriptionUnitId);
      var clientUnitAccountCodeResolve = clientUnitAccountCodeService.getClientUnitAccountCodes(currentSubscriptionUnitId);
      var filterAccountCodes = function () {
        $scope.clientAccountCodes = _.filter($scope.clientAccountCodes, function (cc) {
          return !_.findWhere($scope.clientUnitAccountCodes, { clientProcurementAccountCodeId: cc.id });
        });
      };
      var procurementAccountCodesBackup = null;
      procurementAccountCodeResolve.$promise.then(function (data) {
        $scope.clientAccountCodes = data;
        procurementAccountCodesBackup = angular.copy(data);

        clientUnitAccountCodeResolve.$promise.then(function (clientUnitAccountCodes) {
          $scope.clientUnitAccountCodes = clientUnitAccountCodes;
          filterAccountCodes();
        });
      });
      var accountCodesToAdd = [];
      $scope.accountCodeCallback = function (accountCode) {
        if (accountCode.isSelected === true) {
          accountCodesToAdd.push(accountCode);
        } else {
          accountCodesToAdd.remove(accountCode);
        }
      };

      $scope.editAccountCode = function (clientUnitAccountCode, resetVariables) {
        clientUnitAccountCode.isEditing = !clientUnitAccountCode.isEditing;
        if (resetVariables) {
          clientUnitAccountCode.newLocalSiteAccountCode = angular.copy(clientUnitAccountCode.localSiteAccountCode);
          clientUnitAccountCode.newLocalSiteExportFieldName = angular.copy(clientUnitAccountCode.localSiteExportFieldName);
        }
      };
      $scope.saveAccountCode = function (clientUnitAccountCode) {
        clientUnitAccountCode.localSiteAccountCode = clientUnitAccountCode.newLocalSiteAccountCode;
        clientUnitAccountCode.localSiteExportFieldName = clientUnitAccountCode.newLocalSiteExportFieldName;
        clientUnitAccountCode.organisationId = unitOrganisationId;
        clientUnitAccountCodeService.updateAccountCode(clientUnitAccountCode).$promise.then(function () {
          translateMessage.success('your_account_code_was_saved_successfully');
          $scope.editAccountCode(clientUnitAccountCode);
        });
      };
      $scope.addAllAccountCodes = function () {
        if (accountCodesToAdd.length > 0) {
          var accountCodeIds = _.pluck(accountCodesToAdd, "id");
          var obj = {
            clientUnitId: $scope.organisationContext.currentSubscriptionUnit.id,
            accountCodeIds: accountCodeIds,
            organisationId: unitOrganisationId
          };
          clientUnitAccountCodeService.addAccountCodesToClientUnit(obj)
            .$promise.then(function (data) {
              for (var i = 0; i < data.length; i++) {
                $scope.clientUnitAccountCodes.push(data[i]);
              }
              filterAccountCodes();
              accountCodesToAdd = [];
            });
        }
      };
      $scope.removeAccountCodeFromClientUnit = function (clientUnitAccountCode) {
        clientUnitAccountCodeService.remove(clientUnitAccountCode.id).$promise.then(function () {
          $scope.clientUnitAccountCodes.remove(clientUnitAccountCode);
          var accountCodeToReaddToList = _.findWhere(procurementAccountCodesBackup, { id: clientUnitAccountCode.clientProcurementAccountCodeId });
          accountCodeToReaddToList.isSelected = false;
          $scope.clientAccountCodes.push(accountCodeToReaddToList);
          translateMessage.success('your_account_code_was_successfully_removed');
  
        });
      };

    }
  ]);
'use strict';

angular.module(appName)
  .controller("allowanceTypesSectionController", [
    "$scope",
    "unitAllowanceTypesService",
    "localStorageService",
    "enums",
    "allowanceTypesService",
    "$q",
     "autoFocus",
     "translateMessage",


     function ($scope, unitAllowanceTypesService, localStorageService, enums, allowanceTypesService, $q, autoFocus, translateMessage) {


      var organisationContext = localStorageService.getItem(enums.localStorage.organisationContext);

      var currentSubscriptionUnitId = organisationContext.currentSubscriptionUnit.id;

      var subscriptionId = $scope.organisationContext.id;

      var allowanceTypesToAdd = [];

      var procurementAllowanceTypesBackup = [];

      var unitAllowanceTypesResolve = $q(function (resolve) {
        return unitAllowanceTypesService.get(currentSubscriptionUnitId, resolve);
      });

      var allowanceTypesResolve = $q(function (resolve) { allowanceTypesService.get(subscriptionId, resolve); });

      var filterAllowanceTypes = function () {
        $scope.allowanceTypes = _.filter($scope.allowanceTypes, function (allowanceType) {
          return !_.findWhere($scope.clientUnitAllowanceTypes, { procurementClientAllowanceTypeId: allowanceType.id });
        });
      };

      allowanceTypesResolve.then(function (allowanceTypes) {
        $scope.allowanceTypes = allowanceTypes;
        procurementAllowanceTypesBackup = angular.copy(allowanceTypes);
        unitAllowanceTypesResolve.then(function (unitAllowanceTypes) {
          $scope.clientUnitAllowanceTypes = unitAllowanceTypes;
          filterAllowanceTypes();
        });
      });

      $scope.saveAllowanceType = function (clientUnitAllowanceType) {
        $scope.processing = true;
        clientUnitAllowanceType.localSiteAllowanceTypeCode = clientUnitAllowanceType.newLocalSiteAllowanceTypeCode;
        clientUnitAllowanceType.organisationId = organisationContext.currentSubscriptionUnit.organisation.id;
        unitAllowanceTypesService.update(clientUnitAllowanceType).$promise.then(function () {
          translateMessage.success('your_allowance_type_was_saved');

          $scope.editAllowanceType(clientUnitAllowanceType);
          $scope.processing = false;
        });
      };
      $scope.removeAllowanceTypeFromClientUnit = function (clientUnitAllowanceType) {
        unitAllowanceTypesService.remove(clientUnitAllowanceType.id).$promise.then(function () {
          $scope.clientUnitAllowanceTypes.remove(clientUnitAllowanceType);
          var allowanceTypeToReaddToList = _.findWhere(procurementAllowanceTypesBackup, { id: clientUnitAllowanceType.procurementClientAllowanceTypeId });
          allowanceTypeToReaddToList.isSelected = false;
          $scope.allowanceTypes.push(allowanceTypeToReaddToList);
            translateMessage.success('your_allowance_type_was_removed');
        });
      };
      $scope.addAllAllowanceTypes = function () {
        if (allowanceTypesToAdd.length > 0) {
          $scope.processing = false;
          var allowanceTypeIds = _.pluck(allowanceTypesToAdd, "id");
          var obj = {
            clientUnitId: $scope.organisationContext.currentSubscriptionUnit.id,
            allowanceTypeIds: allowanceTypeIds,
            organisationId: $scope.organisationContext.currentSubscriptionUnit.organisation.id
          };
          unitAllowanceTypesService.add(obj)
            .$promise.then(function (data) {
              for (var i = 0; i < data.length; i++) {
                $scope.clientUnitAllowanceTypes.push(data[i]);
              }
              filterAllowanceTypes();
              allowanceTypesToAdd = [];
              $scope.processing = false;
               translateMessage('your_allowance_types_were_added');
                  
              });
        }
      };
      $scope.allowanceTypeCallback = function (allowanceType) {
        if (allowanceType.isSelected === true) {
        	allowanceTypesToAdd.push(allowanceType);
        } else {
          allowanceTypesToAdd.remove(allowanceType);
        }
      };
      $scope.editAllowanceType = function (clientUnitAllowanceType, resetVariables) {
        clientUnitAllowanceType.isEditing = !clientUnitAllowanceType.isEditing;
        autoFocus.implementForElementWithId("new-allowance-type-code");
        if (resetVariables) {
          clientUnitAllowanceType.newLocalSiteClientUnitAllowanceTypeCode = angular.copy(clientUnitAllowanceType.localSiteClientUnitAllowanceTypeCode);
        }
      };
    }
  ]);
"use strict";

angular.module(appName)
  .controller("receivingVarianceReasonsSectionController", [
    "$scope",
    "localStorageService",
    "enums",
    "$q",
    "clientUnitProcurementReceivingVarianceReasonsService",
      "_", "translateMessage",
      function ($scope, localStorageService, enums, $q, clientUnitProcurementReceivingVarianceReasonsService, _, translateMessage) {
        var self = this;

        self.organisationContext = localStorageService.getItem(enums.localStorage.organisationContext);
        self.organisationId = self.organisationContext.currentSubscriptionUnit.organisation.id;
        self.currentSubscriptionUnitId = self.organisationContext.currentSubscriptionUnit.id;
        $scope.receivingVarianceReasons = {};

        clientUnitProcurementReceivingVarianceReasonsService.get(self.currentSubscriptionUnitId).$promise
            .then(function(data) {
                $scope.receivingVarianceReasons.reasons = _.sortBy(data, "order");
            });
      //var receivingVarianceReasonResolve =
      //  $q(function(resolve) {
      //    return clientUnitProcurementReceivingVarianceReasonsService.get(currentSubscriptionUnitId, resolve);
      //  });

      $scope.moveDown = function (position) {
        if (position < $scope.receivingVarianceReasons.reasons.length) {
          $scope.receivingVarianceReasons.reasons[position].order++;
          $scope.receivingVarianceReasons.reasons[position + 1].order--;
          $scope.receivingVarianceReasons.organisationId = self.organisationId;
          clientUnitProcurementReceivingVarianceReasonsService.update($scope.receivingVarianceReasons).then(function (data) {
            $scope.receivingVarianceReasons.reasons = _.sortBy(data, "order");
          });
        }
      };
      $scope.moveUp = function (position) {
        if (position > 0) {
          $scope.receivingVarianceReasons.reasons[position].order--;
          $scope.receivingVarianceReasons.reasons[position - 1].order++;
          $scope.receivingVarianceReasons.organisationId = self.organisationId;
          clientUnitProcurementReceivingVarianceReasonsService.update($scope.receivingVarianceReasons).then(function (data) {
            $scope.receivingVarianceReasons.reasons = _.sortBy(data, "order");
          });
        }
      };
      $scope.selectDefaultVarianceReason = function (id) {
        angular.forEach($scope.receivingVarianceReasons.reasons, function (reason) {
          reason.isDefault = reason.id === id;
        });
        $scope.receivingVarianceReasons.organisationId = self.organisationId;
        clientUnitProcurementReceivingVarianceReasonsService.update($scope.receivingVarianceReasons).then(function (data) {
        	$scope.receivingVarianceReasons.reasons = _.sortBy(data, "order");
            translateMessage.success('variance_reason_updated');
        });
      };
    }
  ]);
'use strict';

angular.module(appName)
  .controller("unitDepartmentsSectionController", [
    "$scope",
    "clientProcurementDepartmentService",
    "clientUnitDepartmentService",
    "$q",
    "localStorageService",
    "addressService",
      "enums",
    "translateMessage",
    function ($scope, clientProcurementDepartmentService, clientUnitDepartmentService, $q, localStorageService, addressService, enums, translateMessage) {
      var organisationContext = localStorageService.getItem(enums.localStorage.organisationContext);
      var currentSubscriptionUnitId = organisationContext.currentSubscriptionUnit.id;
      var subscriptionId = organisationContext.id;
      var unitOrganisationId = organisationContext.currentSubscriptionUnit.organisation.id;

      var procurementDepartmentsBackup;
      var departmentsToAdd = [];
      var addressResolve = addressService.get(unitOrganisationId);
      var procurementDepartmentResolve = $q(function (resolve) {
        return clientProcurementDepartmentService.get(subscriptionId, resolve);
      });

      var filterDepartments = function () {
        $scope.subscriptionDepartments = _.filter($scope.subscriptionDepartments, function (dep) {
          return !_.findWhere($scope.organisationContextDepartments, { clientProcurementDepartmentId: dep.id });
        });
      };

      var clientUnitDepartmentsResolveCallback = function (data) {
        $scope.organisationContextDepartments = data;
        procurementDepartmentResolve.then(function (procurementDepartments) {
         
          $scope.subscriptionDepartments = procurementDepartments;
          procurementDepartmentsBackup = angular.copy(procurementDepartments);
          filterDepartments();
        });
      };

      clientUnitDepartmentService.getBySubscriptionClientUnitId(currentSubscriptionUnitId).$promise.then(clientUnitDepartmentsResolveCallback);

      $scope.removeDepartmentFromClientUnit = function (department) {
        clientUnitDepartmentService.remove(department.id, function () {
          $scope.organisationContextDepartments.remove(department);
          var departmentToReaddToList = _.findWhere(procurementDepartmentsBackup, { id: department.clientProcurementDepartmentId });
          departmentToReaddToList.isSelected = false;
          $scope.subscriptionDepartments.push(departmentToReaddToList);
          translateMessage.success('your_department_was_successfully_removed');

        });
      };

      $scope.departmentCallback = function (department) {
        if (department.isSelected === true) {
          departmentsToAdd.push(department);
        } else {
          departmentsToAdd.remove(department);
        }
      };

      $scope.addDepartmentsToClientUnit = function () {
        if (departmentsToAdd.length > 0) {
          var departmentIds = _.pluck(departmentsToAdd, "id");
          var obj = {
            clientId: $scope.organisationContext.currentSubscriptionUnit.client.id,
            clientUnitId: $scope.organisationContext.currentSubscriptionUnit.id,
            departmentIds: departmentIds,
            organisationId: unitOrganisationId
          };
          clientUnitDepartmentService.addDepartmentsToClientUnit(obj)
            .$promise.then(function (data) {
              for (var i = 0; i < data.length; i++) {
                $scope.organisationContextDepartments.push(data[i]);
              }
              filterDepartments();
              departmentsToAdd = [];
            });

        }
      };

      addressResolve.$promise.then(function (addresses) {
        $scope.addresses = addresses;
      });

      $scope.setAddress = function (department) {
        var address = null;
        if (department.organisationAddress != null) {
          address = _.findWhere($scope.addresses, { id: department.organisationAddress.id });
        }
        return address;
      };

      $scope.setIsSavingDepartment = function (isSavingDepartment) {
        var deferred = $q.defer();
        $scope.isSavingDepartment = isSavingDepartment;
        deferred.resolve();
        return deferred.promise;
      };

      $scope.editDepartment = function (department, resetVariables) {
        department.isEditing = !department.isEditing;
        if (resetVariables) {
          department.newOrganisationAddress = angular.copy(department.organisationAddress);
          department.newLocalSiteDepartmentCode = angular.copy(department.localSiteDepartmentCode);
        }
      };
      $scope.saveDepartment = function (department) {
        department.organisationAddress = department.newOrganisationAddress;
        department.localSiteDepartmentCode = department.newLocalSiteDepartmentCode;
        department.organisationId = unitOrganisationId;
	    department.updatingDepartment = true;
        clientUnitDepartmentService.update(department, function () {
          // TODO : Update UI (?) Alert user of completion
          translateMessage.success('your_department_was_saved_successfully');
          $scope.editDepartment(department);
	      delete department.updatingDepartment;
        });
      };
    }
  ]);
angular.module(appName).controller('assignSupplierController', [
    '$scope', '$location', '$window', 'localStorageService', 'unitSuppliersService', 'unitSuppliersResource',
    'countryResource', 'enums', 'clientProcurementSuppliersService', 'organisationContextService',
    'translateMessage',
    function($scope, $location, $window, localStorageService, unitSuppliersService, unitSuppliersResource,
        countryResource, enums, clientProcurementSuppliersService, organisationContextService,
        translateMessage
    ) {
            var self = this;
            self.ctx = organisationContextService.getContext();
            $scope.subscriptionId = self.ctx.id;

            $scope.cancel = function() {
                $scope.toggle();
            }

            self.addAssignSupplier = function() {
                $scope.supplier.organisationId = self.organisationId;
                return unitSuppliersService.addAssignSupplier($scope.supplier).$promise.then(function(data) {
                    if (data) {
                        translateMessage.success('supplier_details_saved');
                        var updatedSupplier = $scope.supplier;
                        updatedSupplier.updated = true;
                        updatedSupplier.toggleAccountsLabel = "View Accounts";
                        updatedSupplier.showAccounts = false;
                        self.unitSuppliersAdded.push(updatedSupplier);
                        localStorageService.setItem('newUnitSuppliers', self.unitSuppliersAdded);
                        _.each(self.groupSupplierObjects, function(supplierObject) {
                            if (supplierObject.supplier.id == updatedSupplier.supplier.id) {
                                self.groupSupplierObjects = _.without(self.groupSupplierObjects, supplierObject);
                            }
                        });
                        $scope.cancel();
                    }
                });
            }

            self.updateAssignSupplier = function() {
                return unitSuppliersService.updateAssignSupplier($scope.supplier).$promise.then(function(data) {
                    if (data) {
                        translateMessage.success('supplier_details_saved');
                    }
                });
            }

            $scope.getDepots = function(supplierId) {
                if (supplierId > 0) {
                    self.depotObjects = [];
                    $scope.depots = [];
                    unitSuppliersService.getUnitSupplierDepots(supplierId).$promise.then(function(data) {
                        $scope.supplierHasNoDepots = data.length < 1;
                        self.depotObjects = data;
                        _.each(data, function(d) {
                            var description = d.depotAddress2 != null
                                ? d.depotName +
                                ", " +
                                d.depotAddress1 +
                                ", " +
                                d.depotAddress2 +
                                ", " +
                                d.depotTown +
                                ", " +
                                d.postcode.name +
                                ", " +
                                d.depotCounty.name
                                : d.depotName +
                                ", " +
                                d.depotAddress1 +
                                ", " +
                                d.depotTown +
                                ", " +
                                d.postcode.name +
                                ", " +
                                d.depotCounty.name;
                            $scope.depots.push({ id: d.id, description: description });
                            $scope.supplier.depot = _.findWhere($scope.depots, function(depot) {
                                return depot.description.split(",")[0] === $scope.currentSupplierAccount.depot;
                            });
                        });
                        if ($scope.assignMode == 'new') {
                            $scope.supplier.headOfficeVendorCode = _.findWhere(
                                self.groupSupplierObjects,
                                { supplierId: supplierId }
                            ).headOfficeVendorCode;
                        }
                    });
                }
            }

            $scope.createSupplier = function() {
                $scope.supplierAdded = false;
                $scope.supplier = {};
                self.setupSupplier();
                $scope.assignMode = 'add';
            }

            $scope.addUpdateSupplier = function(form) {
                if (form.$valid) {
                    $scope.supplier.depotId = $scope.supplier.depot
                        ? _.findWhere(self.depotObjects, { id: $scope.supplier.depot.id }).id
                        : 0;
                    if ($scope.assignMode === 'edit') {
                        self.updateAssignSupplier();
                    } else {
                        self.addAssignSupplier();
                    }
                } else {
                    translateMessage.error("something_went_wrong_please_try_again_later");
                }
            };

            $scope.isValidEndDate = function(supplier) {
                $scope.invalidEndDate = supplier.endDate != null &&
                    supplier.startDate != null &&
                    supplier.endDate < supplier.startDate;
            }

            self.setupSupplier = function() {
                $scope.transmissionTypes = [{ id: 1, description: "Email" }]; // TODO: Get this properly from backend
                $scope.supplier.transmissionType = _.findWhere($scope.transmissionTypes, { id: 1 });
                $scope.supplier.client = angular.copy($scope.client);
                $scope.isLoading = false;
                if ($scope.assignMode === 'add') {
                    $scope.supplier.accountNumber = "";
                    $scope.supplier.startDate = "";
                }
                if ($scope.assignMode === 'edit') {
                    console.log($scope.currentSupplierAccount);
                    $scope.supplier.startDate = $scope.currentSupplierAccount.startDate;
                    $scope.supplier.endDate = $scope.currentSupplierAccount.endDate;
                    $scope.supplier.oldAccountNumber = $scope.currentSupplierAccount.accountNumber;
                    $scope.supplier.accountNumber = $scope.currentSupplierAccount.accountNumber;
                    $scope.supplier.clientSupplierAccountId = $scope.currentSupplierAccount.clientSupplierAccountId;
                }
                if ($scope.assignMode === 'new') {
                    $scope.supplier.supplier = _.findWhere($scope.groupSuppliers, { id: 0 });
                }
            }

            $scope.init = function() {
                self.organisationId = localStorageService.getItem(enums.localStorage.organisationContext)
                    .currentSubscriptionUnit.organisation.id;
                self.unitSuppliersAdded = [];
                $scope.isLoading = true;
                $scope.supplier = {};
                if ($scope.currentSupplier) {
                    $scope.supplier = angular.copy($scope.currentSupplier);
                    $scope.getDepots($scope.currentSupplier.supplier.id);
                    self.setupSupplier();
                } else {
                    clientProcurementSuppliersService.get($scope.subscriptionId).$promise.then(function(data) {
                        self.groupSupplierObjects = data;
                        var addedSuppliers = _.where($scope.unitSuppliers, { ispslSupplier: false });
                        _.each(addedSuppliers,
                            function(addedSupplier) {
                                addedSupplier.addedSupplierId = addedSupplier.supplier.id;
                            });
                        _.each(self.groupSupplierObjects,
                            function(supplierObject) {
                                if (_.findWhere(addedSuppliers, { addedSupplierId: supplierObject.supplier.id })) {
                                    self.groupSupplierObjects = _.without(self.groupSupplierObjects, supplierObject)
                                }
                            });
                        $scope.groupSuppliers = [{ id: 0, name: "No Group Supplier Selected." }];
                        _.each(self.groupSupplierObjects,
                            function(groupSupplier) {
                                $scope.groupSuppliers.push(groupSupplier.supplier);
                            });
                        self.setupSupplier();
                    });
                }
            }();
    }
]);
'use strict';

angular.module(appName)
    .factory('supplierAccountsResource', [
        '$resource', "siteUrl", function ($resource, siteUrl) {
            var api = siteUrl() + 'api/GroupSupplierAccounts'
            return $resource(api, {}, {
                getSupplierAccounts: {
                    method: "GET",
                    url: api + "/GetSupplierAccounts",
                    params: {
                        organisationId: "@organisationId"
                    },
                    isArray: true
                },
                getTransmissionTypes: {
                    method: "GET",
                    url: api + "/GetTransmissionTypes",
                    isArray: true
                },
                deleteSupplierAccount: {
                    method: "POST",
                    url: api + "/Delete"
                },
                add: {
                    method: "POST",
                    url: api + "/Add"
                },
                edit: {
                    method: "POST",
                    url: api + "/Edit"
                }
            });
        }
    ]);
angular.module(appName)
    .factory('supplierAccountsService', [
        'supplierAccountsResource',
        function (groupSupplierAccountsResource) {
            return {
                get: function (organisationId, cb) {
                    return supplierAccountsResource.getSupplierAccounts({ organisationId: organisationId });
                },
                getTransmissionTypes: function (cb) {
                    return supplierAccountsResource.getTransmissionTypes().$promise.then(cb);
                },
                remove: function (model, cb) {
                    return supplierAccountsResource.deleteSupplierAccount(model).$promise.then(cb);
                },
                add: function (model, cb) {
                    return supplierAccountsResource.add(model).$promise.then(cb);
                },
                edit: function (model, cb) {
                    return supplierAccountsResource.edit(model).$promise.then(cb);
                }
            };
        }
    ]);
angular.module(appName)
  .controller("unitSuppliersController", [
    "$scope",
    "$q",
    "enums",
    "unitSuppliersResource",
    "unitSuppliersService",
    "localStorageService",
    "toastr",
    "_",
    "$location",
      "autoFocus",
    '$translate',
    function($scope,
      $q,
      enums,
      unitSuppliersResource,
      unitSuppliersService,
      localStorageService,
      toastr,
      _,
      $location,
      autoFocus,
        $translate) {
        $translate.onReady().then(function () {

            $scope.viewAccountsText = $translate.instant("label_view_accounts");
            
            var self = this;

            $scope.mobile = window.innerWidth <= 640;
            $scope.searchText = "";

            $scope.unit = {};
            $scope.unitSupplierData = [];
            $scope.showAddEditSupplier = false;

            $scope.saveLocalVendorCode = function(unitSupplier) {
                unitSuppliersService
                    .saveLocalVendorCode(unitSupplier.id, unitSupplier.localVendorCode, self.organisationId)
                    .$promise.then(function(data) {
                        toastr.success($translate.instant('local_vendor_code_saved'));
                        unitSupplier.isBeingEdited = false;
                    });
            };
            $scope.areYouSure = function(unitSupplier) {
                unitSupplier.promptAreYouSure = !unitSupplier.promptAreYouSure;
            };
            $scope.toggleShowAddEditSupplier = function(unitSupplier, supplierAccount, assignMode) {
                $scope.assignMode = assignMode;
                $scope.selectedClientSupplier = unitSupplier;
                $scope.currentSupplierAccount = supplierAccount;
                $scope.showAddEditSupplier = !$scope.showAddEditSupplier;
                if (!$scope.showAddEditSupplier) {
                    $scope.selectedClientSupplierId = null;
                    unitSuppliersService.get(self.context.currentSubscriptionUnit.organisation.id, self.context.id)
                        .$promise.then(function(data) {
                            $scope.unitSupplierData = data;
                            _.each($scope.unitSupplierData,
                                function(supplier) {
                                    supplier.showAccounts = false;
                                    supplier.toggleAccountsLabel = $scope.viewAccountsText;
                                    supplier.showActions = false;
                                });
                        });
                }
            };
            $scope.toggleAccounts = function(unitSupplier) {
                unitSupplier.showAccounts = !unitSupplier.showAccounts;
                unitSupplier.toggleAccountsLabel = unitSupplier.showAccounts
                    ? $translate.instant('label_hide_accounts')
                    : $scope.viewAccountsText;

                if (unitSupplier.showAccounts) {
                    unitSuppliersService.getSupplierAccounts(unitSupplier.id)
                        .$promise.then(function(data) {
                            unitSupplier.supplierAccounts = data;
                        });
                }
            };
            $scope.toggleActions = function(unitSupplier) {
                unitSupplier.promptAreYouSure = false;
                unitSupplier.showActions = !unitSupplier.showActions;
                if (!unitSupplier.showActions) {
                    unitSupplier.showAccounts = false;
                    unitSupplier.toggleAccountsLabel = $scope.viewAccountsText;
                }
            };
            $scope.addSupplier = function() {
                $location.path("/Suppliers");
            };
            $scope.editVendorCode = function(unitSupplier) {
                autoFocus.implementForElementWithId("input-vendor-code");
                unitSupplier.isBeingEdited = true;
                self.cachedCode = angular.copy(unitSupplier.headOfficeVendorCode);
                if (unitSupplier.showAccounts) {
                    $scope.toggleAccounts(unitSupplier);
                }
            };
            $scope.cancelEdit = function(unitSupplier) {
                unitSupplier.isBeingEdited = false;
                unitSupplier.headOfficeVendorCode = self.cachedCode;
            };
            $scope.delistUnitSupplier = function(supplierId) {
                unitSuppliersService.delistSupplier(supplierId).$promise.then(function(data) {
                    if (data) {
                        toastr.success($translate.instant('supplier_delisted'));
                        $scope.unitSupplierData = _.without($scope.unitSupplierData,
                            _.findWhere($scope.unitSupplierData, { id: supplierId }));
                    } else {
                        toastr.error($translate.instant('something_went_wrong_please_try_again_later'));
                    }
                });
            };

            var unitSupplierDataCallback = function (data) {

                $scope.viewAccountsText = $translate.instant("label_view_accounts");
                

                angular.forEach(data,
                    function(unitSupplier) {
                        unitSupplier.showActions = false;
                        unitSupplier.showAccounts = false;
                        console.log("here", $scope.viewAccountsText);
                        unitSupplier.toggleAccountsLabel = $scope.viewAccountsText;
                    });
                $scope.unitSupplierData = data;
            };

            var search = function() {
                var subscriptionId = self.context.id;
                return unitSuppliersService.get(self.organisationId, subscriptionId, $scope.searchText).$promise
                    .then(unitSupplierDataCallback);
            };

            $scope.search = function() {
                search();
            }
            $scope.init = function() {
                self.context = localStorageService.getItem(enums.localStorage.organisationContext);
                self.organisationId = self.context.currentSubscriptionUnit.organisation.id;
                self.units = self.context.procurementSubscriptionUnits;
                self.orgs = [];

                _.each(self.units,
                    function(item) {
                        self.orgs.push(item.organisation);
                    });

                $scope.clientUnits = self.orgs;
                $scope.selectedClientUnit = self.context.currentSubscriptionUnit;
            }();
            search();
            //$scope.$watch('searchText', function() {
            //  search();
            //});
        });
    }
  ]);
angular.module(appName)
    .factory('unitSuppliersResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/ProcurementClientUnitSupplier';
            return $resource(api,
            {},
            {
                getUnitSuppliers: {
                    method: 'GET',
                    url: api + '/GetUnitSuppliers',
                    params: { 
                        orgId: "@orgId",
                        id: "@id"
                    },
                    isArray: true
                },
                getUnitSupplier: {
                    method: 'GET',
                    url: api + '/GetUnitSupplier',
                    params: { 
                        clientSupplierId: '@clientSupplierId'
                    }
                },
                getUnitSupplierDepots: {
                    method: 'GET',
                    url: siteUrl() + 'api/SupplierDepot/Get',
                    params: {
                        supplierId: "@supplierId",
                        id:"@id"
                    },
                    isArray: true
                },
                getSupplierAccounts: {
                    method: "GET",
                    url: api + "/GetSupplierAccounts",
                    params: {
                        clientSupplierID: "@clientSupplierID"
                    },
                    isArray: true,
                },
                addAssignSupplier: {
                    method: 'POST',
                    url: api + '/AddAssignSupplier'
                },
                updateAssignSupplier: {
                    method: 'PUT',
                    url: api + '/UpdateAssignSupplier'
                },
                delistSupplier: {
                    method: 'POST',
                    url: api + '/DelistSupplier',
                    params: {
                        id: '@id'
                    }
                },
                saveLocalVendorCode: {
                    method: 'PUT',
                    url: api + '/UpdateLocalVendorCode',
                    params: {
                        clientSupplierId: '@clientSupplierId',
                        newVendorCode: '@newVendorCode',
                        organisationId: '@organisationId'
                    }
                }
            });
        }
    ])
angular.module(appName)
    .factory('unitSuppliersService', [
        'unitSuppliersResource', 'supplierAccountsResource',
        function (unitSuppliersResource, supplierAccountsResource) {
            return {
                get: function (orgId, id, searchText) {
                    return unitSuppliersResource.getUnitSuppliers({ orgId: orgId, id: id, searchText: searchText });
                },
                getUnitSupplier: function(clientSupplierId) {
                    return unitSuppliersResource.getUnitSupplier({ clientSupplierId: clientSupplierId });
                },
                getUnitSupplierDepots: function (supplierId,id,cb) {
                    return unitSuppliersResource.getUnitSupplierDepots({ supplierId: supplierId,id:id });
                },
                addAssignSupplier: function (model, cb) {
                    return unitSuppliersResource
                        .addAssignSupplier(model);
                },
                updateAssignSupplier: function (model, cb) {
                    return unitSuppliersResource
                        .updateAssignSupplier(model);
                },
                getSupplierAccounts: function (clientSupplierId, cb) {
                    return unitSuppliersResource.getSupplierAccounts({ clientSupplierId: clientSupplierId});
                },
                getTransmissionTypes: function (cb) {
                    return supplierAccountsResource.getTransmissionTypes().$promise.then(cb);
                },
                removeSupplierAccount: function (model, cb) {
                    return supplierAccountsResource.deleteSupplierAccount(model).$promise.then(cb);
                },
                addSupplierAccount: function (model, cb) {
                    return supplierAccountsResource.add(model).$promise.then(cb);
                },
                editSupplierAccount: function (model, cb) {
                    return supplierAccountsResource.edit(model).$promise.then(cb);
                },
                delistSupplier: function (id, cb) {
                    return unitSuppliersResource.delistSupplier({ id: id });
                },
                saveLocalVendorCode: function (clientSupplierId, newVendorCode, organisationId) {
                    return unitSuppliersResource.saveLocalVendorCode({ clientSupplierId: clientSupplierId, newVendorCode: newVendorCode, organisationId: organisationId });
                }
            };
        }
    ]);
angular.module(appName)
    .factory('creditNoteResource',
        [
            '$resource', 'siteUrl',
            function ($resource, siteUrl) {
                var self = this;
                self.api = siteUrl() + 'api/ProcurementCreditNote';

                return $resource(self.api,
                    {},
                    {
                        getUnreconciledRequestedCreditNotes: {
                            method: 'GET',
                            url: self.api + '/GetUnreconciledRequestedCreditNotes',
                            isArray: true
                        }
                    });
            }
        ]);
angular.module(appName)
    .factory('creditNoteService',
        [
            'creditNoteResource', 'invoiceResource', 'organisationContextService',
            function (creditNoteResource, invoiceResource, organisationContextService) {
                var ctx = organisationContextService.getContext();

                var get = function(creditNoteId) {
                    return invoiceResource.getInvoiceById({
                        id: ctx.currentSubscriptionUnit.id,
                        invoiceHeaderId: creditNoteId
                    }).$promise;
                };
                return {
                    get: get
                }
            }
        ]);
// PurchaseOrder = Credit Request
//       Invoice = Credit Note

angular.module(appName)
    .controller('creditReconciliationController',
    [
		'$scope',
		'$q',
		'$window',
		'$templateRequest',
		'$translate',
		'creditNoteData',
		'unreconciledCreditRequestData',
		'_',
		'genericUiGrid',
		'toastr',
		'creditNoteService',
		'enums',
		'creditReconciliationService',
	    'validationHelper',
		function (
			$scope,
			$q,
			$window,
			$templateRequest,
			$translate,
			creditNoteData,
			unreconciledCreditRequestData,
			_,
			genericUiGrid,
			toastr,
			creditNoteService,
			enums,
			creditReconciliationService,
            validationHelper) {
		    $translate.onReady().then(function() {
		        var self = this;

		        self.disableMarkAsReconciledButton = {
		            value: true,
		            set: function(force) {
		                if (force) {
		                    self.disableMarkAsReconciledButton.value = force;
		                } else {
		                    var creditNoteLines = _.filter($scope.creditNoteGridOptions.data,
		                        function(row) {
		                            return !row.isItemRow &&
		                                row.amountCredited != row.grossReconciled &&
		                                (row.grossPrice != 0 || row.itemNettPrice != 0 || row.unitCostPrice != 0);
		                        });
		                    self.disableMarkAsReconciledButton.value = creditNoteLines.length > 0;
		                }
		            }
		        };
                self.templateRoot = '/ngxbeagle/dist/Content/js/Modules/CreditReconciliation/GridTemplates/';
		        self.getUiGridTemplate = function(templateName) {
		            return $templateRequest(self.templateRoot + templateName + '.html');
		        }
		        self.resolves = {
		            creditNoteData: creditNoteData.$promise,
		            unreconciledCreditRequestData: unreconciledCreditRequestData.$promise,
		            uiGrid: {
		                creditNoteGrid: {
		                    actionsTemplate: self.getUiGridTemplate('noteGrid/actionsTemplate'),
		                    descriptionTemplate: self.getUiGridTemplate('noteGrid/descriptionTemplate'),
		                    skuCodeTemplate: self.getUiGridTemplate('noteGrid/skuCodeTemplate'),
		                    priceTemplate: self.getUiGridTemplate('noteGrid/priceTemplate')
		                },
		                requestGrid: {
		                    typeTemplate: self.getUiGridTemplate('requestGrid/typeTemplate'),
		                    reconciliationAmountTemplate: self.getUiGridTemplate(
		                        'requestGrid/reconciliationAmountTemplate'),
		                    selectionTemplate: self.getUiGridTemplate('requestGrid/selectionTemplate'),
		                    skuCodeTemplate: self.getUiGridTemplate('requestGrid/skuCodeTemplate'),
		                    crNumberTemplate: self.getUiGridTemplate('requestGrid/crNumberTemplate'),
		                    priceTemplate: self.getUiGridTemplate('requestGrid/priceTemplate'),
		                    priceTemplateNullable: self.getUiGridTemplate('requestGrid/priceTemplateNullable'),
		                }
		            }
		        }
		        self.reconciliationTransaction = {
		            _selectedCreditRequestLines: [],
		            _selectedCreditNoteLine: {},
		            _trackedCreditRequestLines: [],
		            _trackedCreditNoteLines: [],
		            _resetCreditRequestLines: function() {
		                this._selectedCreditRequestLines = [];
		            },
		            xReconciled: 0,
		            yToReconcile: 0,
		            getSelectedCreditRequestLines: function() {
		                return this._selectedCreditRequestLines;
		            },
		            setSelectedCreditRequestLines: function(creditRequests) {
		                var tran = this;
		                tran._resetCreditRequestLines();
		                angular.forEach(creditRequests,
		                    function(creditRequest) {
		                        if (creditRequest.isSelectedForReconciliation) {
		                            angular.forEach(creditRequest.procurementCreditRequestLines,
		                                function(creditRequestLine) {
		                                    creditRequestLine.creditRequestNumber = creditRequest.creditRequestNumber;
		                                    creditRequestLine.currency = creditRequest.currency;
		                                    _.pushIfNotExists(tran._selectedCreditRequestLines, creditRequestLine);
		                                });
		                        }
		                    });
		            },
		            setSelectedCreditNoteLine: function(creditNoteLine) {
		                this.yToReconcile = creditNoteLine.grossPrice;
		                this.xReconciled = creditNoteLine.grossReconciled;
		                this._selectedCreditNoteLine = creditNoteLine;
		            },
		            trackCreditNoteLine: function(creditNoteLine) {
		                var transaction = this;
		                var existingCreditNoteLine = _.findWhere(transaction.getTrackedCreditNoteLines(),
		                    { id: creditNoteLine.id });
		                if (existingCreditNoteLine)
		                    existingCreditNoteLine = creditNoteLine;
		                else
		                    transaction._trackedCreditNoteLines.push(creditNoteLine);
		            },
		            getTrackedCreditNoteLines: function() {
		                return this._trackedCreditNoteLines;
		            },
		            getSelectedCreditNoteLine: function() {
		                return this._selectedCreditNoteLine;
		            },
		            getTrackedCreditRequestLines: function() {
		                return this._trackedCreditRequestLines;
		            },
		            trackCreditRequestReconciliationLineItem: function(creditRequestLine) {
		                _.pushIfNotExists(this._trackedCreditRequestLines, creditRequestLine);
		            },
		            untrackCreditRequestReconciliationLineItem: function(creditRequestLine) {
		                _.removeIfExists(this._trackedCreditRequestLines,
		                    creditRequestLine,
		                    { id: creditRequestLine.id });
		            },
		            commit: function() {
		                var transaction = this;
		                var creditNoteLine = transaction.getSelectedCreditNoteLine();
		                var creditNoteLineInGrid =
		                    _.findWhere($scope.creditNoteGridOptions.data, { id: creditNoteLine.id });
		                var trackedCreditRequestLines = transaction.getTrackedCreditRequestLines();
		                // Initialises the array on the InvoiceLine if it doesn't exist
		                creditNoteLine.creditRequestLinesReconciled = creditNoteLine.creditRequestLinesReconciled || [];

		                angular.forEach(trackedCreditRequestLines,
		                    function(trackedCreditRequestLine) {
		                        //trackedCreditRequestLine.parent.grossReconciled = trackedCreditRequestLine.parent.grossReconciled + trackedCreditRequestLine.grossReconciled;
		                        //trackedCreditRequestLine.skuCode = trackedCreditRequestLine.parent.skuCode;
		                        //trackedCreditRequestLine.purchaseOrderNumber = trackedCreditRequestLine.parent.purchaseOrderNumber;
		                        //trackedCreditRequestLine.isItemRow = true;
		                        self.setupCreditRequestLineForCreditNoteGrid(trackedCreditRequestLine);
		                        // TODO: Sort this for delete
		                        trackedCreditRequestLine.invoiceLineIds = trackedCreditRequestLine.invoiceLineIds || [];
		                        _.pushIfNotExists(trackedCreditRequestLine.invoiceLineIds, trackedCreditRequestLine.id);

		                        // invoiceLine.grossReconciled doesn't exist. Default it to 0 for calculations.
		                        if (!creditNoteLine.grossReconciled) creditNoteLine.grossReconciled = 0;
		                        creditNoteLine.grossReconciled = transaction.xReconciled;
		                        //if (trackedCreditRequestLine.grossReconciled > 0) {
		                        var lineAlreadyExisting = undefined;
		                        var foundCreditNoteLine = false;
		                        _.each($scope.creditNoteGridOptions.data,
		                            function(datum) {
		                                //This protects us if we pass the invoice line that we want
		                                if (datum.creditRequestLinesReconciled) {
		                                    foundCreditNoteLine = false;
		                                }
		                                if (datum.id == creditNoteLine.id) {
		                                    foundCreditNoteLine = true;
		                                }

		                                if (foundCreditNoteLine) {
		                                    if (datum.id == trackedCreditRequestLine.id) {
		                                        lineAlreadyExisting = datum;
		                                    }
		                                }
		                            });

		                        if (lineAlreadyExisting) {
		                            var request =
		                                self.getRequestFromUnreconciledRequestsArray(trackedCreditRequestLine);
		                            if (request) {
		                                if (isNaN(request.grossReconciledToDate)) {
		                                    request.grossReconciledToDate = 0;
		                                }
		                                request.grossReconciledToDate += trackedCreditRequestLine.grossReconciled -
		                                    request.grossReconciledToDate;
		                                request.grossReconciled = trackedCreditRequestLine.grossReconciled;
		                            }
		                            lineAlreadyExisting.grossReconciled = trackedCreditRequestLine.grossReconciled;
		                        } else {
		                            //Updates the entity on the model to return back to server (if entity in there)
		                            var returnedLine = _.find(creditNoteLineInGrid.creditRequestLinesReconciled,
		                                function(requestLine) {
		                                    return requestLine.id == trackedCreditRequestLine.id;
		                                });
		                            //althouugh the grid might not cointain the line, the model could (added deleted and added again).
		                            if (returnedLine) {
		                                returnedLine.grossReconciled = trackedCreditRequestLine.grossReconciled;
		                            } else {
		                                creditNoteLineInGrid.creditRequestLinesReconciled.push(
		                                    angular.copy(trackedCreditRequestLine));
		                            }
		                            //pushes to GRID
		                            self.pushRowToCreditNoteGrid(angular.copy(trackedCreditRequestLine),
		                                creditNoteLine.id);

		                            var request =
		                                self.getRequestFromUnreconciledRequestsArray(trackedCreditRequestLine);
		                            if (request) {
		                                if (isNaN(request.grossReconciledToDate)) {
		                                    request.grossReconciledToDate = 0;
		                                }
		                                request.grossReconciledToDate += trackedCreditRequestLine.grossReconciled;
		                                request.grossReconciled = trackedCreditRequestLine.grossReconciled;
		                            }
		                        }
		                        //}
		                    });
		                transaction.trackCreditNoteLine(creditNoteLine);
		                this.dispose();
		            },
		            dispose: function() {
		                this._selectedCreditNoteLine = {};
		                this._trackedCreditRequestLines = [];
		                this.xReconciled = 0;
		                this.yToReconcile = 0;

		                angular.forEach($scope.creditRequestGridOptions.data,
		                    function(row) {
		                        //row.grossReconciled = 0;
		                        row.selectedForReconciliation = false;
		                    });
		            }
		        }

		        self.updateCreditNoteReconciliationValuesAndSelection = function(entity, colField) {
		            if (colField === true) {
		                // Commented out the check as it caused issues
		                var creditNoteLine = self.reconciliationTransaction.getSelectedCreditNoteLine();
		                // TODO: This requires grossReconciledToDate to be set. I am just using entity.quantity in the calc for now
		                //var lowestValue = Math.min(entity.quantity - entity.grossReconciledToDate, creditNoteLine.amountCredited - creditNoteLine.grossReconciled);
		                var lowestValue = Math.min(entity.grossPrice,
		                    creditNoteLine.amountCredited - creditNoteLine.grossReconciled);
		                entity.grossReconciled = lowestValue;
		                self.reconciliationTransaction.trackCreditRequestReconciliationLineItem(entity);
		                // MB: Cheesy number check
		            } else if (!isNaN(colField)) {
		                self.reconciliationTransaction.trackCreditRequestReconciliationLineItem(entity);
		            } else {
		                self.reconciliationTransaction.untrackCreditRequestReconciliationLineItem(entity);
		            }
		            if (_.isBoolean(colField)) {
		                entity.selectedForReconciliation = colField;
		            }
		        }

		        self.getCurrentlySelectedCreditNoteLine = function() {
		            return _.findWhere($scope.creditNoteLinesForReconciliation, { selectedForReconciliation: true });
		        }

		        self.setupCreditRequestLineForCreditNoteGrid = function(creditRequestLine) {
		            creditRequestLine.productDescription = creditRequestLine.creditDescription;
		            creditRequestLine.isItemRow = true;
		            creditRequestLine.unitCostPrice =
		                creditRequestLine.unitCostPrice || creditRequestLine.creditRequestUnitCostPrice;
		            creditRequestLine.quantityRequested =
		                creditRequestLine.quantityRequested || creditRequestLine.quantity;
		        }

		        $scope.vm = {
		            showReconciliationPage: true,
		            showCreditRequestGrid: false,
		            toggleAllCreditRequests: false,
		            creditRequestFilter: {
		                term: ''
		            },
		            hideAllReconciled: false
		        }

		        $scope.manuallyAutoReconcileCreditNote = function() {
		            var dto = {
		                invoiceHeaderId: $scope.creditNote.id,
		                procurementCreditRequestIds: _.pluck($scope.getSelectedCreditRequests(), 'id')
		            }
		            //this removes existing items if you hit the button multiple times
		            angular.forEach(angular.copy($scope.creditNoteGridOptions.data),
		                function(dataItem) {
		                    if (dataItem.isItemRow == true) {
		                        $scope.creditNoteGridOptions.data.splice(_.indexOf($scope.creditNoteGridOptions.data,
		                                _.findWhere($scope.creditNoteGridOptions.data,
		                                    { id: dataItem.id })),
		                            1);
		                    }
		                });
		            creditReconciliationService.manuallyAutoReconcileReceivingPurchaseOrders(dto).then(
		                function(autoReconciledDto) {
		                    angular.forEach(autoReconciledDto.procurementCreditNoteLine,
		                        function(creditNoteLine) {

		                            var creditNoteLineInGrid = _.findWhere($scope.creditNoteGridOptions.data,
		                                { id: creditNoteLine.id });
		                            creditNoteLineInGrid.grossReconciled = creditNoteLineInGrid.grossReconciled || 0;
		                            creditNoteLineInGrid.grossReconciledToDate =
		                                creditNoteLineInGrid.grossReconciledToDate || 0;
		                            creditNoteLineInGrid.creditRequestLinesReconciled =
		                                creditNoteLine.creditRequestLinesReconciled;

		                            ////get the index of the creditnoteline
		                            //var creditNoteLineIndex = _.indexOf($scope.creditNoteGridOptions.data, creditNoteLineInGrid) + 1;


		                            var invoiceLineIsAlreadyTracked = _.findWhere(
		                                self.reconciliationTransaction.getTrackedCreditNoteLines(),
		                                { id: creditNoteLine.id });
		                            if (!invoiceLineIsAlreadyTracked) {
		                                self.reconciliationTransaction.trackCreditNoteLine(creditNoteLineInGrid);
		                            }

		                            angular.forEach(creditNoteLineInGrid.creditRequestLinesReconciled,
		                                function(creditRequestLine) {
		                                    var itemAlreadyExists = _.findWhere($scope.creditNoteGridOptions.data,
		                                        { id: creditRequestLine.id });
		                                    if (!itemAlreadyExists) {
		                                        if (creditRequestLine.grossReconciled != 0) {
		                                            var lineInCreditRequest =
		                                                self.getItemFromUnreconciledRequestArray(creditRequestLine);
		                                            if (lineInCreditRequest) {
		                                                lineInCreditRequest.grossReconciledToDate =
		                                                    creditRequestLine.grossReconciled;
		                                            }
		                                            creditNoteLineInGrid.grossReconciled =
		                                                creditNoteLine.grossReconciled;
		                                            creditNoteLineInGrid.grossReconciledToDate =
		                                                creditRequestLine.grossReconciled;
		                                            self.setupCreditRequestLineForCreditNoteGrid(creditRequestLine);
		                                            self.pushRowToCreditNoteGrid(creditRequestLine, creditNoteLine.id);
		                                        }
		                                    }
		                                });
		                        });
		                    self.disableMarkAsReconciledButton.set();
		                });
		        }

		        self.getItemFromUnreconciledRequestArray = function(requestLine) {
		            var foundLine = undefined;
		            angular.forEach($scope.unreconciledCreditRequests,
		                function(creditRequest) {
		                    angular.forEach(creditRequest.procurementCreditRequestLines,
		                        function(crLine) {
		                            if (crLine.id == requestLine.id) {
		                                foundLine = crLine;
		                            }
		                        });
		                });
		            return foundLine;
		        }

		        $scope.toggleHideAllReconciled = function() {
		            if ($scope.vm.hideAllReconciled) {
		                var rows = [];
		                angular.forEach($scope.creditNoteLinesForReconciliation,
		                    function(il) {
		                        if (il.amountCredited != il.grossReconciled && !il.isItemRow) {
		                            rows.push(il);
		                            if (il.showingCreditNoteLineReconciliationItems) {
		                                angular.forEach(il.creditRequestLinesReconciled,
		                                    function(receivingLine) {
		                                        if (receivingLine.grossReconciled != 0) {
		                                            receivingLine.invoiceLineId = il.id;
		                                            self.setupCreditRequestLineForCreditNoteGrid(receivingLine);
		                                            rows.push(receivingLine);
		                                        }
		                                    });
		                            }
		                        }
		                    });
		                $scope.creditNoteGridOptions.data = rows;
		                genericUiGrid.create($scope.creditNoteGridOptions, $scope).then(function(grid) {
		                    $scope.creditNoteGrid = grid;
		                });
		            } else {
		                var rows = [];
		                angular.forEach($scope.creditNoteLinesForReconciliation,
		                    function(creditNoteLine) {
		                        if (!creditNoteLine.isItemRow) {
		                            rows.push(creditNoteLine);
		                        }
		                        if (creditNoteLine.showingCreditNoteLineReconciliationItems) {
		                            angular.forEach(creditNoteLine.creditRequestLinesReconciled,
		                                function(receivingLine) {
		                                    if (receivingLine.grossReconciled != 0) {
		                                        rows.push(receivingLine);
		                                    }
		                                });
		                        }
		                    });

		                $scope.creditNoteGridOptions.data = rows;
		                genericUiGrid.create($scope.creditNoteGridOptions, $scope).then(function(grid) {
		                    $scope.creditNoteGrid = grid;
		                });
		            }
		        }

		        $scope.getXofYToReconcile = function(type, useParseFloat) {
		            if (type == 'x') {
		                return useParseFloat
		                    ? parseFloat(self.reconciliationTransaction.xReconciled).toFixed(2)
		                    : self.reconciliationTransaction.xReconciled;
		            } else if (type == 'y') {
		                return useParseFloat
		                    ? parseFloat(self.reconciliationTransaction.yToReconcile).toFixed(2)
		                    : self.reconciliationTransaction.yToReconcile;
		            }
		        }

		        $scope.getXofYClass = function() {
		            var x = $scope.getXofYToReconcile('x'),
		                y = $scope.getXofYToReconcile('y');

		            if (validationHelper.isNegative(x)) {
		                return { 'danger': x < y || x >= 0 }
		            } else {
		                return { 'danger': x < 0 || x > y };
		            }
		        }

		        $scope.disableCommitButton = function() {
		            return $scope.getXofYClass().danger;
		        }

		        $scope.toggleAllCreditRequests = function() {
		            _($scope.unreconciledCreditRequests).each(function(po) {
		                po.isSelectedForReconciliation = $scope.vm.toggleAllCreditRequests;
		                $scope.selectCreditRequestForReconciliation();
		            });

		            //$scope.selectPurchaseOrderForReconciliation($scope.unreconciledPurchaseOrders);
		        }

		        $scope.commitRpoReconciliation = function() {
		            self.reconciliationTransaction.commit();
		            $scope.vm.showCreditRequestGrid = false;
		            self.disableMarkAsReconciledButton.set();
		        }

		        $scope.getReconcilingTitleData = function() {
		            var creditNoteLine = self.reconciliationTransaction.getSelectedCreditNoteLine();
		            return creditNoteLine.productCode + ' - ' + creditNoteLine.productDescription;
		        }

		        $scope.creditNoteGridCallbacks = {
		            selectCreditNoteForReconciliation: function(row) {
		                if (_.isArray(row.entity)) {
		                    row.isSelected = false;
		                    return;
		                }

		                //https://www.pivotaltracker.com/story/show/157422533 - requested to not populate search terms on hitting reocnciliation
		                //$scope.vm.creditRequestFilter.term = row.entity.productCode;


		                $scope.selectCreditNoteLineForReconciliation(row.entity, $scope.vm.creditRequestFilter.term);
		                //THIS got moved inside selectCreditNoteLineForReconciliation as we needed to fix the preselecting bug.
		                //self.setupCreditRequestGridOptions($scope.vm.creditRequestFilter.term);


		                $scope.vm.showCreditRequestGrid = true;
		            },
		            deleteCreditRequestLine: function(row) {
		                // TODO: This needs to be implemented. Had trouble, left for after other fixes
		                self.reconciliationTransaction.untrackCreditRequestReconciliationLineItem(row.entity);

		                var creditNoteLineInGrid = _.findWhere($scope.creditNoteGridOptions.data,
		                    { id: row.entity.invoiceLineId });


		                var creditRequestInGrid = undefined;
		                var foundCreditNoteLine = false;
		                _.each($scope.creditNoteGridOptions.data,
		                    function(datum) {
		                        //This protects us if we pass the invoice line that we want
		                        if (datum.creditRequestLinesReconciled) {
		                            foundCreditNoteLine = false;
		                        }
		                        if (datum.id == row.entity.invoiceLineId) {
		                            foundCreditNoteLine = true;
		                        }

		                        if (foundCreditNoteLine) {
		                            if (datum.id == row.entity.id) {
		                                creditRequestInGrid = datum;
		                            }
		                        }
		                    });

		                var unreconciledRequestEntity = self.getRequestFromUnreconciledRequestsArray(row.entity);
		                unreconciledRequestEntity.grossReconciledToDate -= row.entity.grossReconciled;
		                creditNoteLineInGrid.grossReconciled -= row.entity.grossReconciled;

		                angular.forEach(creditNoteLineInGrid.creditRequestLinesReconciled,
		                    function(invoiceLineReconciliation) {
		                        if (invoiceLineReconciliation.id == row.entity.id) {
		                            invoiceLineReconciliation.grossReconciled = 0;
		                        }
		                    });

		                //we dont want to remove it when deleting, instead you want to set grossReconciled = 0 and then in the commit() to track the same line id
		                //_.each($scope.creditNoteLinesForReconciliation,
		                //    function(creditNoteLine) {
		                //        if (creditNoteLine.id == row.entity.invoiceLineId) {
		                //            creditNoteLine.creditRequestLinesReconciled = _.without(creditNoteLine.creditRequestLinesReconciled,
		                //                _.findWhere(creditNoteLine.creditRequestLinesReconciled,
		                //                    { id: creditRequestInGrid.id }));
		                //        }
		                //    });scope.creditNote.procurementInvoiceStatusId != enums.invoiceStatus.Accepted


		                var index = _.indexOf($scope.creditNoteGridOptions.data, creditRequestInGrid);
		                $scope.creditNoteGridOptions.data.splice(index, 1);

		                self.reconciliationTransaction.trackCreditNoteLine(creditNoteLineInGrid);
		                self.disableMarkAsReconciledButton.set();
		            },
		            showReconcileButton: function() {
		                return $scope.creditRequestGridOptions.data &&
		                    $scope.creditRequestGridOptions.data.length > 0 &&
		                    $scope.creditNote.procurementInvoiceStatusId != enums.invoiceStatus.Reconciled &&
		                    $scope.creditNote.procurementInvoiceStatusId != enums.invoiceStatus.Accepted;
		            },
		            showDeleteButton: function() {
		                return $scope.creditNote.procurementInvoiceStatusId != enums.invoiceStatus.Reconciled &&
		                    $scope.creditNote.procurementInvoiceStatusId != enums.invoiceStatus.Accepted;
		            },
		            showToggleLineItemsButton: function(creditNoteLine) {
		                return _.filter(creditNoteLine.creditRequestLinesReconciled,
		                        function(a) { return a.grossReconciled != 0 }).length >
		                    0;
		            },
		            toggleShowingCreditNoteLineReconciliationItems: function(creditNoteRow) {
		                creditNoteRow.entity.showingCreditNoteLineReconciliationItems =
		                    !creditNoteRow.entity.showingCreditNoteLineReconciliationItems;
		                if (creditNoteRow.entity.showingCreditNoteLineReconciliationItems) {
		                    angular.forEach(creditNoteRow.entity.creditRequestLinesReconciled,
		                        function(receivingLine) {
		                            if (receivingLine.grossReconciled != 0) {
		                                self.pushRowToCreditNoteGrid(receivingLine, creditNoteRow.entity.id);
		                            }
		                        });
		                } else {
		                    angular.forEach(creditNoteRow.entity.creditRequestLinesReconciled,
		                        function(receivingLine) {
		                            var itemInGrid = _.findWhere($scope.creditNoteGridOptions.data,
		                                { id: receivingLine.id, invoiceLineId: creditNoteRow.entity.id });
		                            var index = _.indexOf($scope.creditNoteGridOptions.data, itemInGrid);
		                            $scope.creditNoteGridOptions.data.splice(index, 1);
		                        });
		                }
		            }
		        }
		        $scope.creditRequestGridCallbacks = {
		            afterSelectionCellEdit: function(entity, col, colField) {
		                if (entity.isItemRow) {
		                    self.updateCreditNoteReconciliationValuesAndSelection(entity, colField);
		                    if (colField == true) {
		                        self.reconciliationTransaction.xReconciled += entity.grossReconciled;
		                    } else {
		                        self.reconciliationTransaction.xReconciled -= entity.grossReconciled;
		                    }
		                    // TODO: Do we need to handle grouping?
		                    //var itemsTicked = _.filter(entity.parent.receivingLineItemReconciliations,
		                    //        { selectedForReconciliation: true });
		                    //var hasItemsTicked = itemsTicked.length > 0;
		                    //if (hasItemsTicked == false) {
		                    //    entity.parent.selectedForReconciliation = false;
		                    //} else if (itemsTicked.length == entity.parent.receivingLineItemReconciliations.length) {
		                    //    entity.parent.selectedForReconciliation = true;
		                    //}
		                } else {
		                    // We are a Request LINE! Update the item values
		                    angular.forEach(entity.procurementCreditNoteReconciliations,
		                        function(cnReconciliation) {
		                            if (cnReconciliation.grossReconciled != cnReconciliation.amountReceived)
		                                self.updateCreditNoteReconciliationValuesAndSelection(cnReconciliation,
		                                    colField);
		                            if (colField == true) {
		                                self.reconciliationTransaction.xReconciled += cnReconciliation.grossReconciled;
		                            } else {
		                                self.reconciliationTransaction.xReconciled -= cnReconciliation.grossReconciled;
		                            }
		                        });
		                }
		            },
		            grossReconciledOnChange: function(entity, col, colField) {
		                if (entity.isItemRow) {
		                    self.updateCreditNoteReconciliationValuesAndSelection(entity, true);
		                }
		                //else {
		                //    // We are an RPO LINE! Update the item values
		                //    angular.forEach(entity.receivingLineItemReconciliations,
		                //        function (rpoLineItem) {
		                //            self.updateCreditNoteReconciliationValuesAndSelection(rpoLineItem, colField);
		                //        });
		                //}
		            },
		            hideItemSelect: function(entity, col, colField) {

		                //return entity.grossReconciled == entity.amountReceived;
		            }
		        }

		        self.pushRowToCreditNoteGrid = function(lineToAdd, invoiceLineId) {
		            var grid = $scope.creditNoteGridOptions.data;
		            var creditNoteLine = _.findWhere(grid, { id: invoiceLineId });
		            var index = _.indexOf(grid, creditNoteLine) + 1;
		            if (invoiceLineId) {
		                lineToAdd.invoiceLineId = invoiceLineId;
		            }
		            grid.splice(index, 0, lineToAdd);
		        }

		        self.pushRowToCreditRequestGrid = function(parent, child) {
		            var grid = $scope.creditRequestGridOptions.data;
		            var index = _.indexOf(grid, parent);
		            var childIndex = index + 1;
		            grid.splice(childIndex, 0, child);
		        }

		        $scope.getSelectedCreditRequests = function() {
		            return _.where($scope.unreconciledCreditRequests, { isSelectedForReconciliation: true });
		        }

		        $scope.cancelReconciling = function() {
		            var hasHistory = $window.history.length > 0;
		            if (hasHistory) {
		                $window.history.back();
		            } else {
		                $window.location = '/dashboard';
		            }
		        }

		        $scope.disableMarkAsReconciledButton = function() {
		            return !$scope.creditNote ||
		                $scope.saving ||
		                self.disableMarkAsReconciledButton.value ||
		                $scope.creditNote.procurementInvoiceStatusId == enums.invoiceStatus.Reconciled ||
		                $scope.creditNote.procurementInvoiceStatusId == enums.invoiceStatus.Accepted;
		        }

		        $scope.disableSaveButton = function() {
		            return !$scope.creditNote ||
		                $scope.saving ||
		                $scope.creditNote.procurementInvoiceStatusId == enums.invoiceStatus.Reconciled ||
		                $scope.creditNote.procurementInvoiceStatusId == enums.invoiceStatus.Accepted;
		        }

		        $scope.showAutoReconcileButton = function() {
		            if ($scope.creditNote) {
		                return $scope.creditNote.procurementInvoiceStatusId != enums.invoiceStatus.Reconciled &&
		                    $scope.creditNote.procurementInvoiceStatusId != enums.invoiceStatus.Accepted;
		            } else {
		                return false;
		            }
		        }


		        self.getRequestFromUnreconciledRequestsArray = function(request) {
		            var cr = undefined;
		            angular.forEach($scope.unreconciledCreditRequests,
		                function(req) {
		                    angular.forEach(req.procurementCreditRequestLines,
		                        function(reconciliation) {
		                            if (reconciliation.id == request.id) {
		                                cr = reconciliation;
		                            }
		                        });
		                });
		            return cr;
		        }

		        self.setupCreditRequestGridOptions = function(term) {
		            var creditRequestLines = self.reconciliationTransaction.getSelectedCreditRequestLines();
		            if (term) {
		                term = term.toLowerCase();
		                creditRequestLines = _.filter(creditRequestLines,
		                    function(creditRequestLine) {
		                        return creditRequestLine.productCode.toLowerCase().includes(term) ||
		                            creditRequestLine.creditDescription.toLowerCase().includes(term);
		                    });
		            }
		            var creditRequestLineItemsToAddToGrid = _.sortBy(creditRequestLines, 'skuCode');


		            //var creditNoteLine = self.reconciliationTransaction.getSelectedCreditNoteLine();
		            //angular.forEach(creditRequestLineItemsToAddToGrid,
		            //    function (creditRequestLine) {
		            //        var creditRequestLineItem = _.find(creditNoteLine.creditRequestLinesReconciled,
		            //            function (creditRequestReconciled) {
		            //                return creditRequestReconciled.id == creditRequestLine.id;
		            //            });
		            //        if (creditRequestLineItem) {
		            //            creditRequestLineItem.isItemRow = true;
		            //            creditRequestLineItem.selectedForReconciliation = true;
		            //        }
		            //    });
		            angular.forEach(creditRequestLineItemsToAddToGrid,
		                function(creditRequestLine) {
		                    angular.forEach(creditRequestLine.procurementCreditNoteReconciliations,
		                        function(creditRequestLineItem) {
		                            creditRequestLineItem.isItemRow = true;
		                            creditRequestLineItem.selectedForReconciliation = true;
		                            //self.pushRowToCreditRequestGrid(creditRequestLine, creditRequestLineItem);
		                        });
		                });


		            $scope.creditRequestGridOptions.data = creditRequestLineItemsToAddToGrid;
		            genericUiGrid.create($scope.creditRequestGridOptions, $scope).then(function(grid) {
		                $scope.creditRequestGrid = grid;
		            });
		        }


		        $scope.filterCreditRequestLineData = function(term) {
		            self.setupCreditRequestGridOptions(term);
		        }

		        $scope.selectCreditRequestForReconciliation = function() {
		            var creditRequests = $scope.getSelectedCreditRequests();

		            self.reconciliationTransaction.setSelectedCreditRequestLines(creditRequests);
		            self.setupCreditRequestGridOptions();
		        };

		        $scope.selectCreditNoteLineForReconciliation = function(creditNoteLine, term) {
		            var currentCreditNoteLine = self.getCurrentlySelectedCreditNoteLine();

		            // Set selectedForReconciliation only if the line exists. It won't exist on first load
		            if (currentCreditNoteLine)
		                currentCreditNoteLine.selectedForReconciliation = false;
		            var creditNoteLineReconciliations = [];

		            angular.forEach(creditNoteLine.creditRequestLinesReconciled,
		                function(creditNoteReconcileLine) {
		                    if (creditNoteReconcileLine.grossReconciled != 0) {
		                        creditNoteLineReconciliations.push(creditNoteReconcileLine);
		                    }
		                });

		            //$scope.creditRequestGridOptions.data HAS to have all the data at this point in order to be able to unselect/select lines and AFTER that you filter.
		            self.setupCreditRequestGridOptions();
		            //At this point, the grid is still pointing to the old credit note line. We cannot do this here.
		            angular.forEach($scope.creditRequestGridOptions.data,
		                function(rowInCreditRequestGrid) {
		                    var itemReconciledOnCreditNoteLine = _.findWhere(creditNoteLineReconciliations,
		                        { id: rowInCreditRequestGrid.id });
		                    if (itemReconciledOnCreditNoteLine) {
		                        rowInCreditRequestGrid.selectedForReconciliation = true;
		                        rowInCreditRequestGrid.grossReconciled = itemReconciledOnCreditNoteLine.grossReconciled;
		                    } else {
		                        rowInCreditRequestGrid.selectedForReconciliation = false;
		                        rowInCreditRequestGrid.grossReconciled = 0;
		                    }
		                });
		            self.setupCreditRequestGridOptions(term);
		            creditNoteLine.selectedForReconciliation = true;
		            self.reconciliationTransaction.setSelectedCreditNoteLine(creditNoteLine);
		        }


		        $scope.cancelLineReconciliation = function() {
		            self.reconciliationTransaction.dispose();
		            $scope.vm.showCreditRequestGrid = false;
		            self.disableMarkAsReconciledButton.set();
		        }

		        $scope.saveAndMarkAsReconciled = function() {
		            if (!self.disableMarkAsReconciledButton.value) {
		                $scope.markingAsReconciled = true;
		                self.disableMarkAsReconciledButton.set(true);
		                return $scope.saveReconciliation().then(function() {
		                    return creditReconciliationService.markAsReconciled($scope.creditNote.id).then(
		                        function(successResult) {
		                            $translate('message_credit_note_marked_as_reconciled').then(
		                                function(t) {
		                                    toastr.success(t);
		                                });
		                            $scope.creditNote.procurementInvoiceStatusId = enums.invoiceStatus.Reconciled;
		                            $window.location.reload();
		                        }).finally(function() {
		                        $scope.saving = false;
		                        $scope.markingAsReconciled = false;
		                        self.disableMarkAsReconciledButton.set();
		                    });
		                }).finally(function() {
		                    $scope.saving = false;
		                });
		            }
		        }

		        $scope.saveReconciliation = function() {
		            $scope.saving = true;
		            var creditNoteLines = self.reconciliationTransaction.getTrackedCreditNoteLines();
		            angular.forEach(creditNoteLines,
		                function(cnl) {
		                    angular.forEach(cnl.creditRequestLinesReconciled,
		                        function(creditNoteLineReconciled) {
		                            creditNoteLineReconciled.procurementCreditNoteRequestLineId =
		                                creditNoteLineReconciled.id;
		                        });
		                });

		            // TODO: Left this in in case I need it
		            //angular.forEach(creditNoteLines, function (invoiceLine) {
		            //    angular.forEach(invoiceLine.creditRequestLinesReconciled, function (receivingLineReconciled) {
		            //        angular.forEach(receivingLineReconciled.receivingLineItemReconciliations,
		            //            function (item) {
		            //                item.parent = null;
		            //            });
		            //    });
		            //});

		            return creditReconciliationService.reconcileCreditNoteLines(creditNoteLines, $scope.creditNote.id)
		                .then(
		                    function(reconciledLines) {
		                        // TODO Success
		                        $translate('success_credit_note_reconciled').then(function(t) {
		                            toastr.success(t);
		                        });
		                    }).finally(function() {
		                    $scope.saving = false;
		                });
		        }

		        $scope.init = function() {
		            $q.all(self.resolves).then(function(results) {
		                console.log(results);
		                $scope.creditNote = results.creditNoteData;
		                $scope.unreconciledCreditRequests = results.unreconciledCreditRequestData;
		                $scope.creditNoteLinesForReconciliation =
		                    _.sortBy($scope.creditNote.creditNoteLines, 'productCode');
		                angular.forEach($scope.creditNoteLinesForReconciliation,
		                    function(creditNoteLine) {
		                        creditNoteLine.amountCredited = creditNoteLine.grossPrice;
		                    });
		                $scope.creditNoteGridOptions = {
		                    data: $scope.creditNoteLinesForReconciliation,
		                    columns: [
		                        {
		                            displayName: $translate.instant('product_code'),
		                            field: 'productCode',
		                            minWidth: 100,
		                            template: results.uiGrid.creditNoteGrid.skuCodeTemplate,
		                            placeholder: false
		                        },
		                        {
		                            displayName: $translate.instant('product_description'),
		                            field: 'productDescription',
		                            minWidth: 450,
		                            template: results.uiGrid.creditNoteGrid.descriptionTemplate,
		                            placeholder: false
		                        },
		                        {
		                            displayName: $translate.instant('quantity_requested'),
		                            field: 'quantityRequested',
		                            minWidth: 100,
		                            cellFilter: 'nullableNumber: 3',
		                            cellClass: 'number',
		                            placeholder: false
		                        },
		                        {
		                            displayName: $translate.instant('quantity_credited'),
		                            field: 'quantityInvoiced',
		                            minWidth: 100,
		                            cellFilter: 'nullableNumber: 3',
		                            cellClass: 'number',
		                            placeholder: false
		                        },
		                        {
		                            displayName: $translate.instant('credit_request_number'),
		                            field: 'creditRequestNumber',
		                            minWidth: 110,
		                            placeholder: false
		                        },
		                        {
		                            displayName: $translate.instant('unit_cost_price'),
		                            field: 'unitCostPrice',
		                            minWidth: 130,
		                            cellClass: 'number',
		                            template: results.uiGrid.creditNoteGrid.priceTemplate,
		                            placeholder: false
		                        },
		                        //{ field: 'itemVAT', displayName: results.translations.itemVat, cellFilter: 'pslContextCurrency', cellClass: 'number', template: results.uiGrid.creditNoteGrid.priceTemplate, placeholder: false },
		                        {
		                            displayName: $translate.instant('gross_reconciled'),
		                            field: 'grossReconciled',
		                            minWidth: 130,
		                            cellClass: 'number',
		                            template: results.uiGrid.creditNoteGrid.priceTemplate,
		                            placeholder: false
		                        },
		                        {
		                            displayName: $translate.instant('amount_credited'),
		                            field: 'amountCredited',
		                            minWidth: 130,
		                            cellClass: 'number',
		                            template: results.uiGrid.creditNoteGrid.priceTemplate,
		                            placeholder: false
		                        },
		                        {
		                            displayName: $translate.instant('actions'),
		                            field: 'actions',
		                            minWidth: 130,
		                            template: results.uiGrid.creditNoteGrid.actionsTemplate,
		                            placeholder: false
		                        }
		                    ],
		                    globalEditableCondition: function() {
		                        return false;
		                    },
		                    rowClass: function(row) {
		                        var rowClass = '';
		                        if (row.entity.parent || row.entity.isItemRow) {
		                            rowClass += ' is-item-row ';
		                        } else {
		                            rowClass += ' is-line-row ';
		                        }

		                        if (row.entity.grossReconciled == row.entity.amountCredited) {
		                            rowClass += ' green-text ';
		                        }

		                        return rowClass;
		                    }
		                }

		                angular.forEach(angular.copy($scope.creditNoteLinesForReconciliation),
		                    function(creditNoteLine) {
		                        var creditNoteLineInGrid = _.findWhere($scope.creditNoteGridOptions.data,
		                            { id: creditNoteLine.id });


		                        creditNoteLineInGrid.showingCreditNoteLineReconciliationItems = true;
		                        angular.forEach(creditNoteLine.creditRequestLinesReconciled,
		                            function(reconciledCreditNoteLine) {
		                                if (reconciledCreditNoteLine.grossReconciled != 0) {

		                                    self.setupCreditRequestLineForCreditNoteGrid(reconciledCreditNoteLine);
		                                    self.pushRowToCreditNoteGrid(reconciledCreditNoteLine, creditNoteLine.id);
		                                }
		                            });
		                        creditNoteLineInGrid.creditRequestLinesReconciled =
		                            creditNoteLine.creditRequestLinesReconciled;
		                    });

		                angular.forEach($scope.unreconciledCreditRequests,
		                    function(cr) {
		                        angular.forEach(cr.procurementCreditRequestLines,
		                            function(crLine) {
		                                crLine.isItemRow = true;
		                                if (isNaN(crLine.grossReconciledToDate)) {
		                                    crLine.grossReconciledToDate = 0;
		                                }
		                                angular.forEach(crLine.procurementCreditNoteReconciliations,
		                                    function(crLineReconciliation) {
		                                        crLine.grossReconciledToDate += crLineReconciliation
		                                            .grossReconciledToDate;
		                                    });
		                            });
		                    });

		                $scope.creditRequestGridOptions = {
		                    columns: [
		                        {
		                            displayName: $translate.instant('credit_request_number'),
		                            field: 'creditRequestNumber',
		                            minWidth: 110,
		                            template: results.uiGrid.requestGrid.crNumberTemplate,
		                            placeholder: false
		                        },
		                        {
		                            displayName: $translate.instant('credit_description'),
		                            field: 'creditDescription',
		                            minWidth: 450,
		                            template: results.uiGrid.requestGrid.typeTemplate,
		                            placeholder: false
		                        },
		                        {
		                            displayName: $translate.instant('amount_requested'),
		                            field: 'grossPrice',
		                            minWidth: 130,
		                            template: results.uiGrid.requestGrid.priceTemplate,
		                            cellClass: 'number',
		                            placeholder: false
		                        },
		                        // TODO: I don't think this is needed on the CR grid
		                        //{ field: 'quantityCredited', cellClass: 'number', placeholder: false },
		                        {
		                            displayName: $translate.instant('unit_cost_price'),
		                            field: 'unitCostPrice',
		                            minWidth: 130,
		                            template: results.uiGrid.requestGrid.priceTemplate,
		                            cellClass: 'number',
		                            placeholder: false
		                        },
		                        {
		                            displayName: $translate.instant('quantity_requested'),
		                            field: 'quantity',
		                            minWidth: 130,
		                            cellFilter: 'nullableNumber: 3',
		                            cellClass: 'number',
		                            placeholder: false
		                        },
		                        {
		                            displayName: $translate.instant('gross_reconciled_to_date'),
		                            field: 'grossReconciledToDate',
		                            minWidth: 130,
		                            template: results.uiGrid.requestGrid.priceTemplateNullable,
		                            cellClass: 'number',
		                            placeholder: false
		                        },
		                        {
		                            displayName: $translate.instant('select'),
		                            field: 'selectedForReconciliation',
		                            width: 80,
		                            template: results.uiGrid.requestGrid.selectionTemplate,
		                            placeholder: false
		                        },
		                        {
		                            displayName: $translate.instant('reconciliation_amount'),
		                            field: 'grossReconciled',
		                            minWidth: 130,
		                            cellClass: 'number',
		                            template: results.uiGrid.requestGrid.priceTemplateNullable,
		                            editableTemplate: results.uiGrid.requestGrid.reconciliationAmountTemplate,
		                            placeholder: false,
		                            editable: function(scope) {
		                                return scope.row.entity.isItemRow && scope.row.entity.selectedForReconciliation;
		                            },
		                        }
		                    ],
		                    rowClass: function(row) {
		                        var rowClass = '';
		                        if (row.entity.parent != null || row.entity.isItemRow) {
		                            rowClass += 'is-item-row';
		                        } else {
		                            rowClass += 'is-line-row';
		                        }

		                        return rowClass;
		                    },
		                    globalEditableCondition: function() {
		                        return false;
		                    },
		                    afterCellEdit: function(entity, cell, value, oldValue) {
		                        console.log('New Value: ', value);
		                        console.log('Old Value: ', oldValue);
		                        if (cell.field == 'grossReconciled') {
		                            if (value != oldValue) {
		                                if (value < oldValue) {
		                                    console.log('(less than) Calculated Value: ', oldValue - value);
		                                    console.log('xReconciled Before: ',
		                                        self.reconciliationTransaction.xReconciled);
		                                    self.reconciliationTransaction.xReconciled -= (oldValue - value);
		                                    console.log('xReconciled After: ',
		                                        self.reconciliationTransaction.xReconciled);
		                                } else if (value > oldValue) {
		                                    console.log('(greater than) Calculated Value: ', value - oldValue);
		                                    console.log('xReconciled Before: ',
		                                        self.reconciliationTransaction.xReconciled);
		                                    self.reconciliationTransaction.xReconciled += (value - oldValue);
		                                    console.log('xReconciled After: ',
		                                        self.reconciliationTransaction.xReconciled);
		                                }
		                            }
		                            self.updateCreditNoteReconciliationValuesAndSelection(entity, value);
		                        }
		                    }
		                }

		                angular.forEach($scope.unreconciledCreditRequests,
		                    function(cr) {
		                        if (cr.existingReconciliation) {
		                            cr.isSelectedForReconciliation = true;
		                        }
		                    });
		                $scope.selectCreditRequestForReconciliation();

		                genericUiGrid.create($scope.creditNoteGridOptions, $scope).then(function(grid) {
		                    $scope.creditNoteGrid = grid;
		                });

		                self.disableMarkAsReconciledButton.set();
		            });
		        }();
		    });
		}
    ]);

angular.module(appName)
    .factory('creditReconciliationResource',
        [
            '$resource', 'siteUrl',
            function ($resource, siteUrl) {
                var self = this;
                self.api = siteUrl() + 'api/ProcurementCreditNote';

                return $resource(self.api,
                    {},
                    {
                        getUnreconciledCreditRequests: {
                            method: "GET",
                            url: self.api + '/GetUnreconciledCreditRequests',
                            isArray: true
                        },
                        reconcileCreditLines: {
                            method: 'POST',
                            url: self.api + '/ReconcileCreditLines'
                        },
                        markAsReconciled: {
                            method: 'POST',
                            url: self.api + '/MarkCreditNoteAsReconciled'
                        },
                        manuallyAutoReconcileReceivingPurchaseOrders: {
                            method: 'POST',
                            url: self.api + '/ManuallyAutoReconcileReceivingPurchaseOrders'
                        }
                    });
            }
        ]);
angular.module(appName)
    .factory('creditReconciliationService',
        [
            'creditReconciliationResource', 'organisationContextService',
            function (creditReconciliationResource, organisationContextService) {
                var ctx = organisationContextService.getContext();

                var getUnreconciledCreditRequests = function (creditNoteId) {
                    return creditReconciliationResource.getUnreconciledCreditRequests({
                        id: ctx.currentSubscriptionUnit.id,
                        procurementCreditNoteId: creditNoteId
                    }).$promise;
                }

                var manuallyAutoReconcileReceivingPurchaseOrders = function (dto) {
                    return creditReconciliationResource.manuallyAutoReconcileReceivingPurchaseOrders({
                        id: ctx.currentSubscriptionUnit.id,
                        invoiceHeaderId: dto.invoiceHeaderId,
                        procurementCreditRequestIds: dto.procurementCreditRequestIds
                    }).$promise;
                }

                var reconcileCreditNoteLines = function (creditNoteLines, creditNoteId) {
                    return creditReconciliationResource.reconcileCreditLines({
                        id: ctx.currentSubscriptionUnit.id,
                        procurementCreditNoteId: creditNoteId,
                        procurementCreditNoteLines: creditNoteLines
                    }).$promise;
                };

                var markAsReconciled = function (creditNoteId) {
                    return creditReconciliationResource.markAsReconciled({
                        id: ctx.currentSubscriptionUnit.id,
                        procurementCreditNoteId: creditNoteId
                    }).$promise;
                };

                return {
                    getUnreconciledCreditRequests: getUnreconciledCreditRequests,
                    manuallyAutoReconcileReceivingPurchaseOrders: manuallyAutoReconcileReceivingPurchaseOrders,
                    reconcileCreditNoteLines: reconcileCreditNoteLines,
                    markAsReconciled: markAsReconciled
                }
            }
        ]);
angular.module(appName)
    .controller('creditRequestView', [
        '$scope',
        'creditRequestData',
        function ($scope, creditRequestData) {
            $scope.init = function () {
                creditRequestData.$promise.then(function(creditRequest) {
                    $scope.creditRequest = creditRequest;
                });
            }();
        }]);


angular.module(appName)
	.controller("csmController",
	[
		"$scope", "organisationContextService",
		function ($scope, organisationContextService) {

		    self.init = function () {
		        var context = organisationContextService.getContext();
		        $scope.csmUrl = "/Clients/ClientSupplierManual";
                $scope.ssrsParams = {
                    ClientId: context.currentSubscriptionUnit.client.id,
					CompanyId: context.user.companyId,
					UserId: context.user.id
                }
		    }();
		}

	]);

angular.module(appName)
    .factory('currencyResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/Currency';
            return $resource(api,
            {},
            {
                get: {
                    method: 'GET',
                    url: '{0}/Get'.format(api),
                    isArray: true
                }
            });
        }
    ])
angular.module(appName)
    .factory('currencyService', [
        'currencyResource',
        function (currencyResource) {
            return {
                get: function(cb) {
                    return currencyResource.get();
                }
            };
        }
    ]);
'use strict';

angular.module(appName)
    .controller('dashboardController', ['$scope',"tileService","$httpParamSerializer","$location",
		function ($scope, tileService, $httpParamSerializer, $location) {

			var init = function () {
				var path = $location.$$path.toLowerCase();
				var dashboardUrl = "beaglemain";
				if (path !== "/" && path !== "/dashboard") {
					dashboardUrl = path.substring(1);
				}
				tileService.get(dashboardUrl).then(function (reports) {
            		$scope.reports = reports;
            	});
            }
            init();

	        var setTrustedUrl = function(report, controls) {
	        	if (!report.originalUrl) {
	        		report.originalUrl = report.parsedUrl;
	        	};
				var queryString = $httpParamSerializer(controls);
				report.trustedUrl = '';
		        _.defer(function() {
			        if (report.originalUrl.indexOf("?") > -1) {
				        report.trustedUrl = report.originalUrl + "&" + queryString;
			        } else {
				        report.trustedUrl = report.originalUrl + "?" + queryString;
			        }
		        });
	        };

	        var setExternalLinkUrl = function (report, controls) {
	        	if (!report.originalExternalLinkUrl) {
	        		report.originalExternalLinkUrl = report.externalLinkUrl;
	        	};
	        	var queryString = $httpParamSerializer(controls);
				report.externalLinkUrl = '';
		        _.defer(function() {
			        if (report.originalExternalLinkUrl.indexOf("?") > -1) {
				        report.externalLinkUrl = report.originalExternalLinkUrl + "&" + queryString;
			        } else {
				        report.externalLinkUrl = report.originalExternalLinkUrl + "?" + queryString;
			        }
		        });

	        };

            $scope.reportControlsChanged = function (report, controls) {
            	report.userControlsReady = false;
            	setTrustedUrl(report, controls);
				if (report.externalLinkUrl) {
					setExternalLinkUrl(report, controls);
				}
	            report.userControlsReady = true;
            };
        }]);
'use strict';

angular.module(appName)
	.controller('eulaController', ['$scope','eulaService',
		function ($scope, eulaService) {
			var init = function () {
				eulaService.getEula().then(function (result) {
					$scope.eula = result[0];
				});
			};
			init();
		}
	]);
angular.module(appName)
	.factory('eulaResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/Eula';
            return $resource(api,
            {},
            {
                getEula: {
                    method: 'GET',
					url: api + '/GetEula',
					isArray: true,
					params: {
						currentClientGroupOrgId: '@currentClientGroupOrgId'
					},
                }
            });
        }
    ])
angular.module(appName)
    .factory('eulaService', [
        'eulaResource',
		'organisationContext',
		function (eulaResource, organisationContext) {
            return {
				getEula: function () {
					return eulaResource.getEula({ currentClientGroupOrgId: organisationContext.organisation.id }).$promise;
                }
            };
        }
    ]);
'use strict';

angular.module(appName)
    .controller('exchangeRateController', ['$scope', 'exchangeRates', 'exchangeRateService', 'localStorageService', 'enums', 'toastr', 'currencies', 'autoFocus', 'userService','translateMessage',
        function ($scope, exchangeRates, exchangeRateService, localStorageService, enums, toastr, currencies, autoFocus, userService, translateMessage) {

            var self = this;

            $scope.subscriptionGroupCurrency = localStorageService.getItem(enums.localStorage.organisationContext).currency.name;

            $scope.rateEdit = {};
            $scope.addExchangeRate = function () {
                _.each($scope.exchangeRates,
                    function (thisRate) {
                        thisRate.edit = false;
                        if (!thisRate.id) {
                            $scope.exchangeRates.remove(thisRate);
                        }
                    });


                var rate = {
                    edit: true,
                    procurementSubscription: {
                        id: localStorageService.getItem(enums.localStorage.organisationContext).id
                    }
                };
                $scope.rateEdit = rate;
                $scope.exchangeRates.push(rate);
                if (window.innerWidth < 768) {
                    window.scrollTo(0, document.body.scrollHeight);
                }
                autoFocus.implement("input");
            }

            $scope.deleteExchangeRate = function (rate) {
                if (rate.id) {
                    $scope.processing = true;
                    exchangeRateService.deleteExchangeRate(rate,
                        function () {
                            $scope.exchangeRates = _.without($scope.exchangeRates, rate);
                            translateMessage.success("deleted_exchange_rate");
                            $scope.processing = false;
                        });
                } else {
                    $scope.exchangeRates = _.without($scope.exchangeRates, rate);
                }
            }
            $scope.saveExchangeRate = function (rate) {

                rate.organisationId = self.headOfficeOrganisationId;
                $scope.processing = true;
                if ($scope.rateEdit.id) {
                    
                    exchangeRateService.updateExchangeRate($scope.rateEdit,
                        function (data) {
                            translateMessage.success("updated_exchange_rate");
                            rate.startDate = data.startDate;
                            rate.endDate = data.endDate;
                            rate.currencyFrom = _.find($scope.allCurrencies, function (currency) { return currency.id === data.currencyFrom.id; });
                            rate.currencyTo = _.find($scope.allCurrencies, function (currency) { return currency.id === data.currencyTo.id; });
                            rate.exchangeRate = data.exchangeRate;
                            rate.edit = false;
                            $scope.processing = false;
                        });
                } else {
                    exchangeRateService.addExchangeRate($scope.rateEdit,
                        function (data) {
                            translateMessage.success("added_exchange_rate");
                            rate.startDate = data.startDate;
                            rate.endDate = data.endDate;
                            rate.currencyFrom = _.find($scope.allCurrencies, function (currency) { return currency.id === data.currencyFrom.id; });
                            rate.currencyTo = _.find($scope.allCurrencies, function (currency) { return currency.id === data.currencyTo.id; });
                            rate.exchangeRate = data.exchangeRate;
                            rate.id = data.id;
                            rate.edit = false;
                            $scope.processing = false;
                        });
                }
            }
            $scope.setCurrency = function (exchangeRateCurrency) {
                exchangeRateCurrency = _.find($scope.allCurrencies,
                    function (item) {
                        return item.id === exchangeRateCurrency.id;
                    });
            }
            $scope.editExchangeRate = function (rate) {
                $scope.rateEdit = angular.copy(rate);
                $scope.rateEdit.currencyFrom = rate.currencyFrom;
                $scope.rateEdit.currencyTo = rate.currencyTo;
                _.each($scope.exchangeRates,
                    function (thisRate) {
                        thisRate.edit = false;
                        if (!thisRate.id) {
                            $scope.exchangeRates.remove(thisRate);
                        }
                    });
                rate.edit = true;
            }

            $scope.cancelEdit = function (rate) {
                if (rate.id) {
                    rate.edit = false;
                } else {
                    $scope.exchangeRates = _.without($scope.exchangeRates, rate);
                }

            }

            $scope.checkStartDate = function () {
                if ($scope.rateEdit.startDate && $scope.rateEdit.endDate) {
                    var start = $scope.rateEdit.startDate.split("/");
                    var end = $scope.rateEdit.endDate.split("/");
                    var startDate = new Date(start[2], start[1], start[0]);
                    var endDate = new Date(end[2], end[1], end[0]);
                    if (startDate >= endDate) {
                        return true;
                    } else {
                        return false;
                    }
                }
                return false;
            };

            $scope.checkCoincidedDates = function () {
                //if no currency from or currency To it wont be allowed to save anyway.
                if ($scope.rateEdit.startDate && $scope.rateEdit.currencyTo && $scope.rateEdit.currencyFrom) {
                    var editStart = $scope.rateEdit.startDate.split("/");
                    var editEnd;
                    if ($scope.rateEdit.endDate) {
                        editEnd = $scope.rateEdit.endDate.split("/");
                    } else {
                        //if there is no end date then we get the max endDate.
                        var maxDate = new Date(8640000000000000);
                        editEnd = (maxDate.getDate() + "/" + maxDate.getMonth() + "/" + maxDate.getFullYear()).split("/");
                    }
                    var editStartDate = new Date(editStart[2], editStart[1], editStart[0]);
                    var editEndDate = new Date(editEnd[2], editEnd[1], editEnd[0]);


                    var coincidingDates = false;
                    _.each($scope.exchangeRates, function (exchangeRate) {
                        //If its the same ID that means we dnt have to check it beacuse its the same input we are editing
                        if (exchangeRate.id !== $scope.rateEdit.id) {
                            if (exchangeRate.currencyFrom.id === $scope.rateEdit.currencyFrom.id && $scope.rateEdit.currencyTo.id === exchangeRate.currencyTo.id) {
                                var listStart = exchangeRate.startDate.split("/");
                                var listEnd;
                                if (exchangeRate.endDate) {
                                    listEnd = exchangeRate.endDate.split("/");
                                } else {
                                    var maxDate = new Date(8640000000000000);
                                    listEnd = (maxDate.getDate() + "/" + maxDate.getMonth() + "/" + maxDate.getFullYear()).split("/");
                                }
                                var listStartDate = new Date(listStart[2], listStart[1], listStart[0]);
                                var listEndDate = new Date(listEnd[2], listEnd[1], listEnd[0]);

                                if ((editStartDate >= listStartDate && editStartDate <= listEndDate) ||
                                    (editEndDate >= listStartDate && editEndDate <= listEndDate)) {
                                    coincidingDates = true;
                                }
                            }
                        }

                    });
                    return coincidingDates;
                }
                return false;
            }
            //$scope.checkSourceAndTarget = function() {
            //    if ($scope.rateEdit.currencyTo && $scope.rateEdit.currencyFrom) {
            //        if ($scope.rateEdit.currencyTo.id === $scope.rateEdit.currencyFrom.id) {
            //            return true;
            //        }
            //    }
            //    return false;
            //}

            $scope.init = function () {
                $scope.allCurrencies = currencies;
                $scope.hasDeletePermission = false;

                //needed to bind the data coming back from server into the select box
                $scope.exchangeRates = exchangeRates;
                _.each(exchangeRates, function (rate) {
                    rate.currencyFrom = _.find($scope.allCurrencies,
                        function (currency) {
                            return currency.id === rate.currencyFrom.id;
                        });
                    rate.currencyTo = _.find($scope.allCurrencies,
                        function (currency) {
                            return currency.id === rate.currencyTo.id;
                        });
                    rate.promptAreYouSure = false;
                });

                userService.hasPermission('BEAGLE_EXCHANGERATES_DELETE').then(function() {
                    $scope.hasDeletePermission = true;
                });

                self.headOfficeOrganisationId = localStorageService.getItem(enums.localStorage.organisationContext).organisation.id;


            }();
        }]);
angular.module(appName)
    .factory('exchangeRateResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/ProcurementSubscriptionExchangeRate';
            return $resource(api,
            {},
            {
                getExchangeRates: {
                    method: 'GET',
                    url: api + '/Get',
                    params: {
                        id: "@id"
                    },
                    isArray: true
                },
                addExchangeRate: {
                    method: 'POST',
                    url: api + '/Post'
                },
                updateExchangeRate: {
                    method: 'PUT',
                    url: api + '/Put'
                },
                deleteExchangeRate: {
                    method: 'DELETE',
                    url: api + '/Delete',
                    params: {
                        id: "@id"
                    }
                },
                getAllCurrencies: {
                    method: 'GET',
                    url: api + '/GetAllCurrencies',
                    isArray: true
                }
            });
        }
    ])
angular.module(appName)
    .factory('exchangeRateService', [
        'exchangeRateResource',
        function (exchangeRateResource) {
            return {
                getExchangeRates: function (subscriptionId, cb) {
                    return exchangeRateResource.getExchangeRates({ id: subscriptionId })
                        .$promise.then(function(data) {
                            return cb(data);
                        });
                },
                addExchangeRate: function (obj, cb) {
                    return exchangeRateResource.addExchangeRate(obj)
                        .$promise.then(function(data) {
                            return cb(data);
                        });
                },
                updateExchangeRate: function (obj, cb) {
                    return exchangeRateResource.updateExchangeRate(obj)
                        .$promise.then(function (data) {
                            return cb(data);
                        });
                },
                deleteExchangeRate: function (obj, cb) {
                    return exchangeRateResource.deleteExchangeRate(obj)
                        .$promise.then(function(data) {
                            return cb(data);
                        });
                },
                getAllCurrencies: function(cb) {
                    return exchangeRateResource.getAllCurrencies()
                        .$promise.then(function (data) {
                            return cb(data);
                        });
                }
            };
        }
    ]);
angular.module(appName)
  .controller("groupImportsController", [
    function() {

    }
  ]);
"use strict";

window.angular.module(appName)
  .controller("headerController", [
    "$scope",
    "localStorageService",
    "enums",
    function($scope, localStorageService, enums) {

      var setContext = function() {

        $scope.currentContext =
          localStorageService.getItem(enums.localStorage.organisationContext) != null ?
          localStorageService.getItem(enums.localStorage.organisationContext).currentSubscriptionUnit : null;
      };

      setContext();

      $scope.$on(enums.broadcasts.updatedContext, function(event, data) {
        setContext();
      });
    }
  ]);
angular.module(appName)
    .controller("helpController", [
        '$scope',
    function ($scope) {
        $scope.clear = function () {
            $scope.filterOnSearchText = "";
            $scope.searchText = "";
        }

        $scope.applyFilter = function () {
            $scope.filterOnSearchText = $scope.searchText;
        }
    }
  ]);
angular.module(appName)
	.controller("bulkReplaceIngredientsController",
		[
			"$scope",
			"bulkReplaceIngredientsService",
			"$translate",
			"$routeParams",
            "factoredMeasuresService",
            "wimdPriceService",
			function (
				$scope,
				bulkReplaceIngredientsService,
				$translate,
				$routeParams,
                factoredMeasuresService,
                wimdPriceService
            ) {
                    $scope.wimdPriceService = wimdPriceService;
                    $scope.showRecipes = false;
			        $scope.search = function() {
			            $scope.searching = true;
			            bulkReplaceIngredientsService
			                .searchForCurrentIngredientsToReplace($scope.filter.searchTerm, $scope.filter.searchType)
			                .then(
			                    function(response) {
			                        $scope.searching = false;
			                        $scope.ingredients = response.data;
			                    });
			        };

			        $scope.searchForReplacement = function() {
			            $scope.searchingForReplacement = true;
			            bulkReplaceIngredientsService
			                .searchForReplacementIngredient($scope.replacementFilter.searchTerm,
			                    'S', $scope.ingredientToReplace.subRecipeId).then(
			                    function(response) {
			                        $scope.searchingForReplacement = false;
			                        $scope.ingredientsForReplacement = response.data;
			                    });
			        };


			        $scope.selectIngredientToReplace = function(i) {

			            $scope.ingredientToReplace = i;
			        };

                $scope.updateFactor = function(recipeIngredient) {
                    factoredMeasuresService.calculateIngredientFactor($scope.replacementIngredient.measureId,
                        recipeIngredient.measure.id,
                        $scope.replacementIngredient.originalItemQuantity,
                        $scope.replacementIngredient.originalItemPackQuantity,
                        $scope.replacementIngredient.originalItemCaseQuantity,
                        recipeIngredient.unit).then(
                        function (result) {
                            recipeIngredient.newFactor = result;
                            recipeIngredient.isFactorable = !!result
                            $scope.validateFactors();
                        });
                }

			        $scope.selectedRecipes = function() {
			            return _.filter($scope.recipes, { 'selected': true });
			        };

					$scope.validateFactors = function() {
						$scope.disableReplace = _.find($scope.selectedRecipes(), function (recipe) {
							return !recipe.currentFactor ||
                                !recipe.newFactor ||
                                recipe.newFactor <= 0 ||
                                !recipe.unit ||
                                recipe.unit <= 0;
						});
					};

			        $scope.selectReplacementIngredient = function(i) {
			            $scope.replacementIngredient = i;
			            var request = {
			                backingEntityId: i.backingEntityId,
			                backingEntityType: i.backingEntityType,
			                currentPslPrice: i.currentPslPrice,
			                originalIngredientIds: $scope.ingredientToReplace.ingredientIdList,
                            subRecipeId: i.subRecipeId
			            };
			            bulkReplaceIngredientsService.getIngredientDetailsForReplacement(request).then(
			                function(result) {
                                var recipes = result.data;
                                for (var ri = 0; ri < recipes.length; ri++) {
                                    $scope.updateFactor(recipes[ri])
                                }
			                    $scope.recipes = recipes;
                                $scope.showRecipes = true;
			                });
			        }

			        $scope.replace = function() {
                        var recipes = $scope.selectedRecipes();
                        _(recipes).each(function(recipe) {
                            recipe.quantity = recipe.unit;
                        });
			            var request = {
			                backingEntityId: $scope.replacementIngredient.backingEntityId,
			                backingEntityType: $scope.replacementIngredient.backingEntityType,
			                ingredientReplacementMatrixItems: recipes
			            };
                        return bulkReplaceIngredientsService.replace(request).then(function () {
                            $translate('ingedients_replaced_successfully').then(function(translation) {
                                toastr.success(translation);
                            });

			                $scope.success = true;
			            });
			        };

			        $scope.replaceAnotherIngredient = function() {
			            $scope.success = false;
			            delete $scope.replacementIngredient;
			            delete $scope.ingredientToReplace;
			            delete $scope.ingredientsForReplacement;
			            delete $scope.recipes;
			            delete $scope.ingredients;
			            $scope.ingredientToReplaceIds = [];
			            $scope.filter = {
			                searchType: true,
			                searchTerm: ''
			            };
			            $scope.replacementFilter = {};
			        }

			        var init = function() {
			            $scope.purchasingCriteria = [
			                {
			                    id: 'BESTPRICE',
			                    key: 'best_price'
			                },
			                {
			                    id: 'EXACTSUPPLIER',
			                    key: 'exact_supplier'
			                },
			                {
			                    id: 'EXACTSKU',
			                    key: 'exact_sku'
			                }
			            ];
			            $scope.ingredientToReplaceIds = [];
			            $scope.filter = {
			                searchType: true,
			                searchTerm: ''
			            };
						$scope.replacementFilter = {};
						if ($routeParams && $routeParams.ingredientId) {
							bulkReplaceIngredientsService.getSingleIngredientToReplace($routeParams.ingredientId).then(function (r) {
								$scope.ingredientToReplace = r.data;
								$scope.initComplete = true;
							});
						} else {
							$scope.initComplete = true;
						}
			        };
			        init();

			}
		]);

	angular.module(appName)
	.factory("bulkReplaceIngredientsService",
		[
			"$http", "siteUrl","organisationContextService",
			function ($http, siteUrl, organisationContextService) {

				var baseUrl = siteUrl();

				return {
					searchForCurrentIngredientsToReplace: function (searchTerm, isUnpriced) {
						var clientId = organisationContextService.getContext().currentSubscriptionUnit.client.id;
						var url = baseUrl +
							"api/bulkReplace/searchForCurrentIngredientsToReplace?searchTerm=" +
							searchTerm +
							"&isUnpriced=" +
							isUnpriced +
							"&clientId=" +
							clientId;
						return $http.get(url);
					},

					getSingleIngredientToReplace: function (ingredientId) {
						var clientId = organisationContextService.getContext().currentSubscriptionUnit.client.id;
						var url = baseUrl + "api/bulkReplace/getSingleIngredientToReplace";
						return $http.get(url, {
							params: { clientId: clientId, ingredientId: ingredientId}
						});
					},

					searchForReplacementIngredient: function (searchTerm, searchType, subRecipeId) {
						var clientId = organisationContextService.getContext().currentSubscriptionUnit.client.id;
						var url = baseUrl +
							"api/bulkReplace/searchForReplacementIngredient?searchTerm=" +
							searchTerm +
							"&searchType=" +
							searchType +
							"&clientId=" +
							clientId +
							"&subRecipeId=" +
							subRecipeId;
						return $http.get(url);
					},

					getIngredientDetailsForReplacement: function(request) {
						var url = baseUrl + "api/bulkReplace/getIngredientDetailsForReplacement";
						return $http.post(url, request);
					},

					replace: function (request) {
						var clientId = organisationContextService.getContext().currentSubscriptionUnit.client.id;
						request.clientId = clientId;
						var url = baseUrl + "api/bulkReplace/replace";
						return $http.post(url, request);
					}
				};
			}
		]);

'use strict';
angular.module(appName).controller('invoiceController', [
    '$scope', '$window', 'invoiceData', 'isGroupClient', 'invoiceService', 'translateMessage',
    'genericUiGrid', '$location', 'organisationContext','userService',
    function ($scope, $window, invoiceData, isGroupClient, invoiceService, translateMessage,
        genericUiGrid, $location, organisationContext, userService
    ) {

            $scope.generateBackUrl = function() {
                var url = isGroupClient ? '/GroupInvoices' : '/UnitInvoices';
                return url;
            };

            var executeGrid = function() {
                if ($scope.invoice.invoiceLines && $scope.invoice.invoiceLines.length) {
                    recaculateGrid();
                }
                setupUiGrid();
                setupHistoryGrid();
            }

            var recalculateInvoiceLine = function (il) {
                il.itemNettPrice = il.quantityInvoiced * parseFloat(il.unitCostPrice);
                il.grossPrice = il.itemNettPrice + parseFloat(il.itemVAT);
            }

            var recaculateGrid = function() {
                var invoice = $scope.invoice;
                var invoiceLines = invoice.invoiceLines;
                _.each(invoiceLines, recalculateInvoiceLine);
                var invoiceNettAmount = _.sum(invoiceLines, 'itemNettPrice');
                if (!isNaN(invoiceNettAmount)) {
                    invoice.invoiceNettAmount = invoiceNettAmount;
                }
                var invoiceGrossAmount = _.sum(invoiceLines, 'grossPrice');
                if (!isNaN(invoiceGrossAmount)) {
                    invoice.invoiceGrossAmount = invoiceGrossAmount;
                }
                var invoiceVATAmount = _.sum(invoiceLines, 'itemVAT');
                if (!isNaN(invoiceVATAmount)) {
                    invoice.invoiceVATAmount = invoiceVATAmount;
                }
            }

            var invoiceLineIsInvalid = function (il) {
                if (!il.productCode) {
                    return true;
                }
                if (!il.quantityInvoiced) {
                    return true;
                }
                if (!il.productDescription) {
                    return true;
                }
                if (!il.unitCostPrice) {
                    return true;
                }
                return false;
            }

            var checkIfCanAddInvoiceLine = function () {
                var firstInvalidLine = _.find($scope.invoice.invoiceLines, invoiceLineIsInvalid);
                $scope.cannotAddInvoiceLine = !!firstInvalidLine;
            }
            $scope.deleteDraftInvoice = function (invoice) {
                invoice.deleting = true;
                invoiceService.deleteDraftInvoice(invoice.id, function (data) {
                    if (data != null) {
                        $window.location.href = '/UnitInvoices';
                    }
                });
            }
            $scope.getTableStyle = function () {
                var marginHeight = -3; // optional
                var length = $scope.invoice.procurementInvoiceHistory.length; // this is unique to my cellTemplate
                return {
                    height: (length * $scope.historyGrid.rowHeight + $scope.historyGrid.headerRowHeight + marginHeight) + 'px'
                };
            };

            var invoiceLinesToDelete = [];

            var deleteInvoiceLine = function(row) {
                var invoiceLine = row.entity;
                _.removeIfExists($scope.invoice.invoiceLines, invoiceLine);
                invoiceLinesToDelete.push(invoiceLine.id);
                recaculateGrid();

                checkIfCanAddInvoiceLine();
            }

            var invoiceLineGridApi;
            var setupUiGrid = function () {
                var invoiceLineGridOptions = {
                    data: $scope.invoice.invoiceLines,
                    columns: [
                        {
                            field: 'productCode',
                            translateKey: 'product_code'
                        },
                        {
                            field: 'quantityInvoiced',
                            translateKey: 'quantity_invoiced',
                            cellClass: 'number',
                            cellFilter: 'number: 3'
                        },
                        {
                            field: 'uomDescription',
                            translateKey: 'uom_description'
                        },
                        {
                            field: 'productDescription' ,
                            translateKey: 'product_description'
                        },
                        {
                            field: 'unitCostPrice',
                            translateKey: 'unit_cost_price',
                            cellFilter: 'nanCurrency:"' + $scope.invoice.currency + '"',
                            cellClass: 'number'
                        },
                        {
                            field: 'itemNettPrice',
                            translateKey: 'item_net_price',
                            editable: false,
                            cellFilter: 'nanCurrency:"' + $scope.invoice.currency + '"',
                            cellClass: 'number'
                        },
                        {
                            field: 'itemVAT',
                            translateKey: 'view_invoice__total_vat',
                            cellFilter: 'nanCurrency:"' + $scope.invoice.currency + '"',
                            cellClass: 'number'
                        },
                        {
                            field: 'grossPrice',
                            translateKey: 'gross_price',
                            editable: false,
                            cellFilter: 'nanCurrency:"' + $scope.invoice.currency + '"',
                            cellClass: 'number'
                        },
                        {
                            action: deleteInvoiceLine,
                            translateKey: 'delete',
                            visible: !$scope.readOnly
                        }
                    ],
                    globalEditableCondition:function() {
                        return !$scope.readOnly;
                    },
                    afterCellEdit: function (entity, column, newValue, oldValue) {
                        checkIfCanAddInvoiceLine();
                        var field = column.field;
                        if ((newValue != oldValue) && (field == 'unitCostPrice' || field == 'itemVAT' || field == 'quantityInvoiced')) {
                            recaculateGrid();
                        }
                    },
                    translate: true,
                    onRegisteredApi: function(gridApi) {
                        invoiceLineGridApi = gridApi;
                    }
                };
                genericUiGrid.create(invoiceLineGridOptions, $scope).then(function (grid) {
                    $scope.invoiceLinesGrid = grid;
                });
            };

            var setupHistoryGrid = function() {
                var historyGridOptions = {
                    data: $scope.invoice.procurementInvoiceHistory,
                    columns: [
                        'dateTime',
                        'status',
                        {
                            field: 'notes',
                            width: '50%',
                            placeholder:'-'
                        }
                    ],
                    translate: true
                };
                genericUiGrid.create(historyGridOptions).then(function (grid) {
                    grid.enableHorizontalScrollbar = 0;
                    grid.enableVerticalScrollbar = 0;
                    $scope.historyGrid = grid;
                });
            }

            var createBlankInvoice = function () {
                return {
                    id: '00000000-0000-0000-0000-000000000000',
                    invoiceLines: [],
                    account: {},
                    status: 0,
                    currency: organisationContext.currency.name,
                    procurementInvoiceHistory: []
                }
            }

            $scope.addInvoiceLine = function() {
                $scope.invoice.invoiceLines.push({
                    itemVAT:0
                });
                $scope.invoiceLinesGrid.focusOnCell($scope.invoice.invoiceLines.length - 1, 0);
                checkIfCanAddInvoiceLine();
            };

            var prepareInvoiceForSubmission = function() {
                $scope.invoice.accountId = $scope.invoice.account.id;
                _.each($scope.invoice.invoiceLines, function (il, index) {
                    il.requestId = index;
                });
                $scope.invoice.deletedInvoiceLineIds = invoiceLinesToDelete;

            }

            var invoiceSavedCallback = function (response) {
                delete $scope.invoice.deletedInvoiceLineIds;
                invoiceLinesToDelete = [];
                translateMessage.success('invoice_saved');
                var newId = response.data.newId;
                $scope.invoice.id = newId;
                _.each(response.data.saveInvoiceLineResponses, function (r) {
                    var invoiceLine = _.find($scope.invoice.invoiceLines, function (x) {
                        return x.requestId == r.requestId;
                    });
                    invoiceLine.id = r.newId;
                });
                if ($location.url().endsWith('00000000-0000-0000-0000-000000000000')) {
                    var newUrl = $location.url().replace('00000000-0000-0000-0000-000000000000', newId);
                    $location.url(newUrl).replace();
                }
            }

            $scope.saveAsDraft = function() {
                prepareInvoiceForSubmission();
                invoiceService.saveInvoice($scope.invoice).then(invoiceSavedCallback);
            }

            $scope.submitInvoice = function() {
                prepareInvoiceForSubmission();
                var promise = invoiceService.submitInvoice($scope.invoice);
                promise.then(invoiceSavedCallback);
                promise.then(function() {
                    $window.location.reload();
                });
            }

            var getGroupedClients = function(data) {
                var groupedClients = _.groupBy(data, 'clientId');
                var keys = _.keys(groupedClients);
                var clientsWithSuppliers = _.map(keys, function (k) {
                    return {
                        accounts: groupedClients[k],
                        clientId: k,
                        clientName: groupedClients[k][0].clientName
                    };
                });
                return _.sortBy(clientsWithSuppliers, 'supplierName');
            }

            var addDescriptionToSupplierAccountData = function(data) {
                _.each(data, function (sa) {
                    sa.description = sa.accountNumber + ' - ' + sa.supplierName;
                });
            }

            var defaultInvoiceToCurrentClientUnit = function() {
                var currentClientUnitId = organisationContext.currentSubscriptionUnit.client.id;
                var currentClientUnit = _.find($scope.clients, function(c) {
                    return c.clientId == currentClientUnitId;
                });
                if (currentClientUnit) {
                    $scope.form.client = currentClientUnit;
                }
            }

            var defaultToPreviouslySavedClientUnit = function (result) {
                if (!$scope.invoice.account) {
                    return;
                }
                var selectedClientSupplierAccount = _.find(result.data, function (x) {
                    return x.id == $scope.invoice.account.id;
                });
                if (selectedClientSupplierAccount) {
                    var selectedClient = _.find($scope.clients, function (x) {
                        return x.clientId == selectedClientSupplierAccount.clientId;
                    });
                    $scope.form.client = selectedClient;

                    $scope.invoice.account = selectedClientSupplierAccount;
                    var selectedSupplier = _.find($scope.suppliers, function (x) {
                        return x.supplierId = selectedClientSupplierAccount.supplierId;
                    });
                    $scope.form.supplier = selectedSupplier;
                }
            }

            $scope.clientChanged = function () {
                var account = $scope.invoice.account;
                var client = $scope.form.client;
                if (!account || !client) {
                    return;
                }
                if (account.clientId != client.clientId) {
                    delete $scope.invoice.account;
                }
            }

            $scope.init = function () {
                invoiceData.$promise.then(function (data) {
                    userService.hasPermission('BEAGLE_CAN_DELETE_DRAFT_INVOICES').then(function () {
                        $scope.hasDeleteDraftInvoicePermission = true;
                    });
                    var creatingNewInvoice = false;
                    if (!data.id) {
                        creatingNewInvoice = true;
                        data = createBlankInvoice();
                    }
                    $scope.invoice = data;
                    checkIfCanAddInvoiceLine();
                    $scope.readOnly = data.status != 0;
                    if (!$scope.readOnly) {
                        var accountsPromise = isGroupClient ? invoiceService.getAvailableClientSupplierAccountsForGroup() : invoiceService.getAvailableClientSupplierAccounts();
                        accountsPromise.then(function (result) {
                            addDescriptionToSupplierAccountData(result.data);
                            $scope.availableClientSupplierAccounts = result.data;
                            $scope.clients = getGroupedClients(result.data);
                            if (creatingNewInvoice) {
                                defaultInvoiceToCurrentClientUnit();
                            } else {
                                defaultToPreviouslySavedClientUnit(result);
                            }
                        });

                    }

                    executeGrid();
                });
            }();
        }
    ]);

angular.module(appName)
    .controller('invoicesExportController', [
        '$scope', 'validationHelper', 'invoiceService', 'supplierData', '_', 'organisationContextService', 'fileDownloadService', 'isGroupClient', 'translateMessage',
        function ($scope,
            validationHelper,
            invoiceService,
            supplierData,
            _,
            organisationContextService,
            fileDownloadService,
            isGroupClient,
            translateMessage) {
            var self = this;
            /* Start Variable Init */
            $scope.suppliers = [];
            $scope.exportFormats = [];
            $scope.headers = [];
            $scope.invoices = [];
            $scope.searchModel = {
                organisationId: null,
                allSuppliers: true,
                supplierId: null,
                startDate: "",
                endDate: "",
                exportFormat: null,
                showAccepted: true,
                showRejected: false,
                showExported: false,
                showAwaiting: false,
                paginate: false,

                sortField: "InvoiceDate"
            }
            $scope.exportSettings = {
                exportFormat: null
            };

            supplierData.$promise.then(function (unitSuppliers) {            
                $scope.suppliers = unitSuppliers.sort(function(a, b) {
                    return a.name.localeCompare(b.name);
                });
            });

            /* End Variable Init */

            /* Start Functions */

            self.validateForm = function () {
                var to = moment($scope.searchModel.endDate, 'DD/MM/YYYY');
                var from = moment($scope.searchModel.startDate, 'DD/MM/YYYY');

                var isValid = $scope.searchModel.exportFormat != null &&
                    validationHelper.isDateSameOrAfter(to, from) &&
                    $scope.searchModel.showAccepted == true &&
                    $scope.searchModel.showRejected == false &&
                    $scope.searchModel.showExported == false;
                var isSupplierValid = false;

                if ($scope.searchModel.allSuppliers == true)
                    isSupplierValid = true;
                else if ($scope.searchModel.supplierId != null)
                    isSupplierValid = true;

                return isValid && isSupplierValid;
            }

            $scope.showExportButton = function () {
                return !$scope.exporting;
            }

            $scope.enableButtons = function () {
                return self.validateForm();
            }

            $scope.getInvoices = function () {
                if (self.validateForm()) {
                    invoiceService.search($scope.searchModel, isGroupClient).$promise.then(
                        function (invoices) {
                            $scope.invoices = invoices.list;
                        });
                }
            }

            $scope.exportToSelectedFormat = function () {

                $scope.exporting = true;
                //get the export format so we can pass in the name of the pipeline
                var format = _.find($scope.exportFormats, { id: $scope.searchModel.exportFormat });
                var to = moment($scope.searchModel.endDate, 'DD/MM/YYYY').format("YYYY-MM-DD");;
                var from = moment($scope.searchModel.startDate, 'DD/MM/YYYY').format("YYYY-MM-DD");;

                var supplierId = $scope.searchModel.supplierId;
                invoiceService.export($scope.searchModel.organisationId, format.pipelineName, from, to, supplierId, isGroupClient, format.pipelineId).$promise.then(
                    function (response) {
                        $scope.showMarkAsExportedMessage = true;
                        $scope.exporting = false;
                        var ediTransactionId = response.ediTransactionId;
                        var documentId = response.documentId;
                        $scope.ediTransactionId = ediTransactionId;
                        translateMessage.success('file_exported_successfully');

                        var url = isGroupClient ? '/api/invoice/DownloadDocumentForGroup?organisationId=' + $scope.searchModel.organisationId + '&documentId=' + documentId : '/api/invoice/DownloadDocumentForUnit?id=' + self.context.currentSubscriptionUnit.id + '&documentId=' + documentId;
                        //todo get the extension from the controller
                        switch (format.name) {
                            case 'Sage50cSwinton.xlsx':
                                ext = 'xlsx';
                                break;
                            case 'Hansa':
                                ext = 'txt';
                                break;
                            case 'Legacy':
                                ext = 'xls';
                                break;
                            case 'WoodNortonHotel.XLSX':
                                ext = 'xlsx';
                                break;
                            case 'JPMorgan':
                                ext = 'xlsx';
                                break;
                            default:
                                ext = 'csv';
                        }

                        fileDownloadService.downloadFile(url, 'Exported-Invoice', ext);

                    });

            }

            $scope.export = function () {
                if (self.validateForm()) {
                    $scope.showMarkAsExportedMessage = true;
                    $scope.exporting = true;
                    var structure = [
                        "id", "organisationId", "term", "startDate", "endDate", "exportFormat", "showAccepted",
                        "showRejected", "showAwaiting", "showExported", "allSuppliers", "supplierId"
                    ];
                    var searchString =
                        invoiceService.getSearchStringWithDefinedStructure($scope.searchModel, structure);
                    //invoiceService.exportInvoices(searchString);

                    var url = isGroupClient ? '/api/invoice/exportinvoicesForGroup?' : '/api/invoice/exportinvoices?';
                    fileDownloadService.downloadFile(url + searchString,
                        'Exported-Invoice.csv',
                        'csv');
                }
            }

            $scope.markAsExported = function () {

                $scope.showMarkAsExportedMessage = false;
                $scope.exporting = false;

                invoiceService.markAsExported({ transactionId: $scope.ediTransactionId }, isGroupClient).$promise.then(
                    function () {
                        translateMessage.success('invoices_marked_as_exported');
                        $scope.invoices = [];
                        $scope.markedAsExported = true;
                    });

            }

            $scope.doNotMarkAsExported = function () {
                $scope.exporting = false;
                $scope.showMarkAsExportedMessage = false;
            }

            $scope.optionChanged = function () {
                var format = _.find($scope.exportFormats, { id: $scope.searchModel.exportFormat });
                if (format != null) {
                    if (format.pipelineName.indexOf('APExport.CSV' == 0))
                        $scope.hasCSVPipeline = true;
                    else
                        $scope.hasCSVPipeline = false;
                }
            }

            $scope.getExportFormats = function () {
                invoiceService.getExportFormats($scope.searchModel.organisationId, isGroupClient).$promise.then(
                    function (formats) {
                        $scope.exportFormats = formats;
                        // check that we have actual formats set up  the organisation
                        if (formats.length > 0) $scope.hasFormats = true;
                        // check to see if we enable the 'preview' grid functionality
                        if (_.find(formats, { name: "CSV" })) {
                            $scope.hasCSVPipeline = true;

                        }

                    });


            }

            /* End Functions */

            $scope.init = function () {
                self.context = organisationContextService.getContext();
                //attach Id for IBelongTo
                if (isGroupClient) {
                    $scope.searchModel.id = self.context.id;
                } else {
                    $scope.searchModel.id = self.context.currentSubscriptionUnit.id;
                }
                $scope.searchModel.organisationId = isGroupClient ? self.context.organisation.id : self.context.currentSubscriptionUnit.organisation.id;

                $scope.getExportFormats();


                $scope.headers = [
                    { name: 'Invoice Number' },
                    { name: 'Unit Name' },
                    { name: 'Supplier Name' },
                    { name: 'Invoice Date', type: 'date' },
                    { name: 'Gross Amount', type: 'number' },
                    { name: 'Vat Amount', type: 'number' },
                    { name: 'Net Amount', type: 'number' }
                ];
            }();

        }]);

angular.module(appName)
    .controller('invoiceHeaderImportController', [
        '$scope',
        '$rootScope',
        '$q',
        'enums',
        'invoiceHeaderImportService',
        'toastr',
        '_',
        '$routeParams',
        'localStorageService',
        'importContext',
        'translateMessage',
        function ($scope,
            $rootScope,
                $q,
                enums,
                invoiceHeaderImportService,
                toastr,
                _, $routeParams, localStorageService, importContext, translateMessage) {

            var self = this;
            $scope.goToUploadMode = function () {

                $scope.uploadMode = true;
                $scope.validationErrorMode = false;

            };

            $scope.goToValidationErrorMode = function () {

                $scope.validationErrorMode = true;
                $scope.uploadMode = false;

            };

            $scope.processInvoiceHeaderImportFile = function (uploadedFile) {

                var dto = {
                    documentId: uploadedFile.id,
                    id: $scope.context.id
                };
                if ($scope.importContext === "UNIT") {
                    dto.id = $scope.context.currentSubscriptionUnit.id;
                    dto.procurementSubscriptionUnitId = $scope.context.currentSubscriptionUnit.id;
                    dto.procurementSubscriptionId = $scope.context.id;
                    var promise = invoiceHeaderImportService.processUnitInvoiceHeaderImportFile(dto).$promise;
                } else {
                    var promise = invoiceHeaderImportService.processInvoiceHeaderImportFile(dto).$promise;
                }

                console.log("uploaded file", uploadedFile);
                console.log("promise", promise);
                promise.then(function(validationData) {
                    console.log("ValidationData", validationData);
                    if (validationData.validationErrors && validationData.validationErrors.length > 0) {
                        $scope.validationErrors = validationData.validationErrors;
                        $scope.goToValidationErrorMode();
                    } else {
                        $scope.numberOfImportedRows = validationData.numberOfImportedRows;
                        translateMessage.success('file_imported_successfully');
                        $rootScope.$broadcast(enums.broadcasts.fileImported);
                        $scope.goToUploadMode();
                    }
                },function(error) {
                    console.log("There was an error",error);
                    $scope.goToUploadMode();
                });
                return promise;
            };

            $scope.init = function () {
                $scope.goToUploadMode();
                $scope.context = localStorageService.getItem(enums.localStorage.organisationContext);
                console.log("$scope.context", $scope.context);
                $scope.importContext = importContext;

            }();
        }]);
angular.module(appName)
    .factory('invoiceHeaderImportResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/InvoiceHeaderImport';
            return $resource(api,
            {},
            {
                processInvoiceHeaderImportFile: {
                    method: "POST",
                    url: api + "/ProcessFile"
                },
                processUnitInvoiceHeaderImportFile: {
                    method: "POST",
                    url: api + "/ProcessUnitInvoiceHeaderImportFile"
                }
            });
        }
    ])
angular.module(appName)
    .factory('invoiceHeaderImportService', [
        'invoiceHeaderImportResource', '$window',
        function (invoiceHeaderImportResource, $window) {
            return {
                processInvoiceHeaderImportFile: function (dto) {
                    return invoiceHeaderImportResource.processInvoiceHeaderImportFile(dto);
                },
                processUnitInvoiceHeaderImportFile: function (dto) {
                    return invoiceHeaderImportResource.processUnitInvoiceHeaderImportFile(dto);
                }
            };
        }
    ]);
angular.module(appName)
    .controller('invoiceReconciliationController',
    [
        '$scope', '$q', '$route', '$translate', '$window', 'invoiceData', 'invoiceLineData', 'unreconciledPoData', 'creditDueData',
        'invoiceReconciliationService', 'genericUiGrid', '$templateRequest', 'organisationContextService', 'enums', 'userService',
        function ($scope, $q, $route, $translate, $window, invoiceData, invoiceLineData, unreconciledPoData, creditDueData,
            invoiceReconciliationService, genericUiGrid, $templateRequest, organisationContextService, enums, userService) {
            $translate.onReady().then(function() {
                var self = this;

                $scope.vm = {
                    toggleAllPurchaseOrders: false,
                    showUnreconciledPurchaseOrderLines: false,
                    showInvoiceLines: false,
                    showDebug: true,
                    rpoLineFilter: {
                        term: ''
                    },
                    context: organisationContextService.getContext(),
                    hideAllReconciled: false
                }
                $scope.enums = enums;
                $scope.invoice = {};
                $scope.invoiceLinesForReconciliation = [];
                $scope.purchaseOrder = {};
                $scope.unreconciledPurchaseOrders = [];
                $scope.purchaseOrdersSelectedForReconciliation = [];

                $scope.showReconciliation = true;

                $scope.toggleShowReconciliation = function() {
                    $scope.showReconciliation = !$scope.showReconciliation;
                }

                $scope.acceptInvoiceForPayment = function() {
                    return invoiceReconciliationService.acceptInvoiceForPayment($route.current.params.invoiceId)
                        .$promise
                        .then(function(saved) {
                            $translate('success_accepted_for_payment', { invoiceNumber: $scope.invoice.invoiceNumber })
                                .then(function(t) {
                                    toastr.success(t);
                                });
                        });
                }

                $scope.getSelectedPurchaseOrders = function() {
                    return _.where($scope.unreconciledPurchaseOrders, { isSelectedForReconciliation: true });
                }

                $scope.disableMarkAsReconciledButton = function() {
                    return $scope.isSaving ||
                        self.disableMarkAsReconciledButton.value ||
                        $scope.invoice.procurementInvoiceStatusId == enums.invoiceStatus.Reconciled ||
                        $scope.invoice.procurementInvoiceStatusId == enums.invoiceStatus.Accepted ||
                        $scope.invoice.procurementInvoiceStatusId == enums.invoiceStatus.AwaitingCredit;
                }

                $scope.disableSaveButton = function() {
                    return $scope.isSaving ||
                        $scope.invoice.procurementInvoiceStatusId == enums.invoiceStatus.Reconciled ||
                        $scope.invoice.procurementInvoiceStatusId == enums.invoiceStatus.Accepted ||
                        $scope.invoice.procurementInvoiceStatusId == enums.invoiceStatus.AwaitingCredit;
                }

                $scope.showAutoReconcileButton = function() {
                    if ($scope.hasReconcileInvoicePermission) {
                        return $scope.invoice.procurementInvoiceStatusId != enums.invoiceStatus.Reconciled &&
                            $scope.invoice.procurementInvoiceStatusId != enums.invoiceStatus.Accepted &&
                            $scope.invoice.procurementInvoiceStatusId != enums.invoiceStatus.AwaitingCredit;
                    } else {
                        return false;
                    }
                }

                $scope.saveAndMarkAsReconciled = function() {
                    $scope.markingAsReconciled = true;
                    self.disableMarkAsReconciledButton.set(true);
                    return $scope.saveReconciliation().then(function() {
                        $scope.markInvoiceAsReconciled(false);
                        //At this point we need to see if we have potential credits
                        invoiceReconciliationService.getCreditDue($scope.invoice.id).then(
                            function(potentialCreditsDue) {
                                $scope.creditAmountDue = potentialCreditsDue.grossAmount;
                                if (parseFloat($scope.creditAmountDue) > 0 && $scope.hasCreditRequestRaisePermission) {
                                    $scope.showCreditPrompt = true;
                                }
                            });

                    });
                };
                $scope.cancelPrompt = function() {
                    $scope.showCreditPrompt = false;
                    $scope.markingAsReconciled = false;
                    $scope.toggleShowReconciliation();
                }

                $scope.markInvoiceAsReconciled = function(raiseCreditNotes) {
                    //2nd parameter is raiseCreditNotes.
                    if (raiseCreditNotes) {
                        $scope.raisingCreditNotes = true;
                    }
                    return invoiceReconciliationService.markInvoiceAsReconciled($scope.invoice.id, raiseCreditNotes)
                        .then(
                            function() {
                                $translate('message_invoice_marked_as_reconciled').then(
                                    function(t) {
                                        toastr.success(t);
                                        if (raiseCreditNotes > 0) {
                                            $window.location.reload();
                                        }
                                    });
                                $scope.invoice.procurementInvoiceStatusId = enums.invoiceStatus.Reconciled;
                            }).finally(function() {
                            $scope.saving = false;
                            $scope.markingAsReconciled = false;
                            self.disableMarkAsReconciledButton.set();
                            $scope.raisingCreditNotes = false;
                        });
                }
                $scope.saveReconciliation = function() {
                    $scope.saving = true;
                    var invoiceLines = self.reconciliationTransaction.getTrackedInvoiceLines();

                  angular.forEach(invoiceLines,
                    function (invoiceLine) {
                      angular.forEach(invoiceLine.receivingLinesReconciled,
                        function (receivingLineReconciled) {
                          angular.forEach(receivingLineReconciled.receivingLineItemReconciliations,
                            function (item) {
                              if (item.parent) {
                                var receivingLineItemReconciliationFromParent = _.findWhere(item.parent.receivingLineItemReconciliations, {id: item.id})
                                item.parent = null;
                              }
                            });
                        });
                    });

                    var dto = {
                        invoiceLines: invoiceLines,
                        procurementInvoiceHeaderId: $scope.invoice.id
                    }

                    $scope.gettingPotentialCredits = true;
                    return invoiceReconciliationService.insertReconcilationLines(dto).then(
                        function(reconciledLines) {
                            // TODO Success
                            $translate('success_invoices_reconciled').then(function(t) {
                                toastr.success(t);
                            });
                            $scope.gettingPotentialCredits = true;
                            return invoiceReconciliationService.getCreditDue($scope.invoice.id).then(
                                function(potentialCreditsDue) {
                                    $scope.creditAmountDue = potentialCreditsDue.grossAmount;
                                }).finally(function() {
                                $scope.gettingPotentialCredits = false;
                            });
                        }).finally(function() {
                        $scope.saving = false;
                        $scope.markingAsReconciled = false;
                    });
                }

                $scope.clearReconciliationOnInvoiceLine = function(invoiceLine, poLinesToRemove) {
                    // We have to create a copy so that we don't manipulate the array we are looping over
                    var poLinesToRemoveArray = angular.copy(poLinesToRemove);
                    _.each(poLinesToRemoveArray,
                        function(poLine) {
                            self.unreconcilePoLineWithInvoiceLine(_.findWhere(poLinesToRemove, { id: poLine.id }),
                                invoiceLine);
                        });
                }

                $scope.toggleAllPurchaseOrders = function() {
                    _($scope.unreconciledPurchaseOrders).each(function(po) {
                        po.isSelectedForReconciliation = $scope.vm.toggleAllPurchaseOrders;
                        $scope.selectPurchaseOrderForReconciliation();
                    });
                }

                $scope.selectInvoiceLineForReconciliation = function(invoiceLine) {
                    var currentInvoiceLine = self.getCurrentlySelectedInvoiceLine();
                    // Set selectedForReconciliation only if the line exists. It won't exist on first load
                    if (currentInvoiceLine) currentInvoiceLine.selectedForReconciliation = false;

                    var invoiceLineReconciliations = [];
                    angular.forEach(invoiceLine.receivingLinesReconciled,
                        function(receivingLine) {
                            angular.forEach(receivingLine.receivingLineItemReconciliations,
                                function(item) {
                                    if (item.quantityReconciled > 0) {
                                        invoiceLineReconciliations.push(item);
                                    }
                                });
                        });


                    //I have added this in order to minimize the load when looping
                    var rpoToLoopFrom = _.filter($scope.unreconciledPurchaseOrders,
                        function(rpo) {
                            return rpo.isSelectedForReconciliation;
                        });

                    angular.forEach(rpoToLoopFrom,
                        function(rpo) {
                            angular.forEach(rpo.procurementReceivingPurchaseOrderLines,
                                function(rpoLine) {
                                    rpoLine.quantityReconciled = 0;
                                    angular.forEach(rpoLine.receivingLineItemReconciliations,
                                        function(rpoLineItem) {
                                            var itemReconciledOnInvoiceLine = _.findWhere(invoiceLineReconciliations,
                                                { id: rpoLineItem.id });
                                            if (itemReconciledOnInvoiceLine) {
                                                rpoLineItem.selectedForReconciliation = true;
                                                rpoLineItem.quantityReconciled =
                                                    itemReconciledOnInvoiceLine.quantityReconciled;
                                                rpoLine.quantityReconciled += rpoLineItem.quantityReconciled;
                                            } else {
                                                rpoLineItem.selectedForReconciliation = false;
                                                rpoLineItem.quantityReconciled = 0;
                                            }
                                        });
                                });
                        });
                    invoiceLine.selectedForReconciliation = true;
                    self.reconciliationTransaction.setSelectedInvoiceLine(invoiceLine);
                }

                $scope.commitRpoReconciliation = function() {
                    self.reconciliationTransaction.commit();
                    $scope.vm.showUnreconciledPurchaseOrderLines = false;
                    self.disableMarkAsReconciledButton.set();
                }

                $scope.reconcilePoLineToInvoiceLine = function(poLine) {
                    var invoiceLineToReconcile = self.getCurrentlySelectedInvoiceLine();
                    // Set the quantity to 0 if it's not a number (doesn't exist)
                    if (!_.isNumber(invoiceLineToReconcile.quantityReconciled))
                        invoiceLineToReconcile.quantityReconciled = 0;

                    // Check if we want to be adding the Poline or removing it
                    if (poLine.selectedForReconciliation) {
                        self.reconcilePoLineWithInvoiceLine(poLine, invoiceLineToReconcile);
                    } else {
                        self.unreconcilePoLineWithInvoiceLine(poLine, invoiceLineToReconcile);
                    }
                }

                $scope.selectPurchaseOrderForReconciliation = function() {
                    var purchaseOrders = $scope.getSelectedPurchaseOrders();

                    self.reconciliationTransaction.setSelectedPurchaseOrderLines(purchaseOrders);
                    self.setupRpoGridOptions();

                    $scope.vm.showInvoiceLines = purchaseOrders.length > 0;
                };

                $scope.toggleHideAllReconciled = function() {
                    $scope.invoiceGridOptions.data = [];
                    if ($scope.vm.hideAllReconciled) {
                        var rows = [];
                        angular.forEach($scope.invoiceLinesForReconciliation,
                            function(il) {
                                // This is to prevent a bug where we would get duplicates in the grid. Defaulting all to open for now
                                if (il.quantityInvoiced != il.quantityReconciled && !il.isItemRow) {
                                    rows.push(il);
                                    if (il.showingInvoiceLineReconciliationItems) {
                                        angular.forEach(il.receivingLinesReconciled,
                                            function(receivingLine) {
                                                angular.forEach(receivingLine.receivingLineItemReconciliations,
                                                    function(receivingLineItem) {
                                                        if (receivingLineItem.quantityReconciled > 0) {
                                                            rows.push(receivingLineItem);
                                                        }
                                                    });
                                            });
                                    }
                                }
                            });
                        $scope.invoiceGridOptions.data = rows;
                        genericUiGrid.create($scope.invoiceGridOptions, $scope).then(function(grid) {
                            $scope.invoiceLinesGrid = grid;
                        });
                    } else {
                        var rows = [];
                        angular.forEach($scope.invoiceLinesForReconciliation,
                            function(invoiceLine) {
                                var alreadyPushed = _.findWhere(rows, { id: invoiceLine.id });
                                if (!alreadyPushed) {
                                    rows.push(invoiceLine);
                                }
                                angular.forEach(invoiceLine.receivingLinesReconciled,
                                    function(receivingLine) {
                                        if (invoiceLine.showingInvoiceLineReconciliationItems) {
                                            angular.forEach(receivingLine.receivingLineItemReconciliations,
                                                function(receivingItem) {
                                                    if (receivingItem.quantityReconciled > 0) {
                                                        receivingItem.isItemRow = true;
                                                        receivingItem.skuCode = receivingLine.skuCode;
                                                        receivingItem.purchaseOrderNumber =
                                                            receivingLine.purchaseOrderNumber;
                                                        receivingItem.productDescription = receivingLine.description;
                                                        receivingItem.invoiceLineId = invoiceLine.id;
                                                        rows.push(receivingItem);
                                                    }
                                                });
                                        }
                                    });
                            });
                        $scope.invoiceGridOptions.data = rows;
                        genericUiGrid.create($scope.invoiceGridOptions, $scope).then(function(grid) {
                            $scope.invoiceLinesGrid = grid;
                        });
                    }
                }

                $scope.manuallyAutoReconcileReceivingPurchaseOrders = function() {
                    var dto = {
                        invoiceHeaderId: $scope.invoice.id,
                        receivingPurchaseOrderIds: _.pluck($scope.getSelectedPurchaseOrders(), 'id')
                    }
                    var itemIndexes = [];
                    angular.forEach(angular.copy($scope.invoiceGridOptions.data),
                        function(dataItem) {
                            if (dataItem.isItemRow == true) {
                                $scope.invoiceGridOptions.data.splice(_.indexOf($scope.invoiceGridOptions.data,
                                        _.findWhere($scope.invoiceGridOptions.data,
                                            { id: dataItem.id })),
                                    1);
                            }
                        });
                    invoiceReconciliationService.manuallyAutoReconcileReceivingPurchaseOrders(dto).then(
                        function(autoReconciledDto) {
                            angular.forEach(autoReconciledDto.procurementInvoiceLines,
                                function(invoiceLine) {

                                    var invoiceLineInGrid = _.findWhere($scope.invoiceGridOptions.data,
                                        { id: invoiceLine.id });
                                    invoiceLineInGrid.quantityReconciled = invoiceLine.quantityReconciled || 0;
                                    invoiceLineInGrid.quantityReceived = 0;

                                    var invoiceLineIndex =
                                        _.indexOf($scope.invoiceGridOptions.data, invoiceLineInGrid) + 1;
                                    var currentIndex = invoiceLineIndex;

                                    invoiceLineInGrid.receivingLinesReconciled = invoiceLine.receivingLinesReconciled;

                                    var invoiceLineIsAlreadyTracked = _.findWhere(
                                        self.reconciliationTransaction.getTrackedInvoiceLines(),
                                        { id: invoiceLine.id });
                                    if (!invoiceLineIsAlreadyTracked) {
                                        self.reconciliationTransaction.trackInvoiceLine(invoiceLineInGrid);
                                    }
                                    angular.forEach(invoiceLineInGrid.receivingLinesReconciled,
                                        function(receivingLine) {
                                            invoiceLineInGrid.quantityReceived += receivingLine.quantityReceived;
                                            angular.forEach(receivingLine.receivingLineItemReconciliations,
                                                function(receivingLineItem) {
                                                    var itemAlreadyExists = _.findWhere($scope.invoiceGridOptions.data,
                                                        { id: receivingLineItem.id });
                                                    if (!itemAlreadyExists) {
                                                        if (receivingLineItem.quantityReconciled > 0) {
                                                            var itemInRpo =
                                                                self.getItemFromUnreconciledRpoArray(receivingLineItem);
                                                            if (itemInRpo) {
                                                                itemInRpo.quantityReconciledToDate =
                                                                    receivingLineItem.quantityReconciled;
                                                            }
                                                            receivingLineItem.quantityReconciledToDate =
                                                                receivingLineItem.quantityReconciled;
                                                            receivingLineItem.isItemRow = true;
                                                            receivingLineItem.skuCode = receivingLine.skuCode;
                                                            receivingLineItem.purchaseOrderNumber =
                                                                receivingLine.purchaseOrderNumber;
                                                            receivingLineItem.productDescription =
                                                                receivingLine.description;
                                                            receivingLineItem.invoiceLineId = invoiceLine.id;
                                                            $scope.invoiceGridOptions.data.splice(invoiceLineIndex,
                                                                0,
                                                                receivingLineItem);
                                                        }
                                                    }
                                                });
                                        });
                                });
                            self.disableMarkAsReconciledButton.set();
                            genericUiGrid.create($scope.invoiceGridOptions, $scope).then(function(grid) {
                                $scope.invoiceLinesGrid = grid;
                                $scope.filterInvoiceLineData();
                            });
                        });
                }

                $scope.getReconcilingTitleData = function() {
                    var invoiceLine = self.reconciliationTransaction.getSelectedInvoiceLine();
                    return invoiceLine.productCode + ' - ' + invoiceLine.productDescription;
                }

                $scope.getXofYToReconcile = function(type, useParseFloat) {
                    if (type == 'x') {
                        return useParseFloat
                            ? parseFloat(self.reconciliationTransaction.xReconciled).toFixed(3)
                            : self.reconciliationTransaction.xReconciled;
                    } else if (type == 'y') {
                        return useParseFloat
                            ? parseFloat(self.reconciliationTransaction.yToReconcile).toFixed(3)
                            : self.reconciliationTransaction.yToReconcile;
                    }
                }

                $scope.getReceivingLinesReconciledWithQuantity = function(invoiceLine) {
                    return _.filter(invoiceLine.receivingLinesReconciled,
                            function(receivingLineReconciled) {
                                return _.filter(receivingLineReconciled.receivingLineItemReconciliations,
                                        function(a) { return a.quantityReconciled > 0 }).length >
                                    0;
                            }).length >
                        0;
                }

                $scope.canReconcileRpoSelection = function() {
                    return self.reconciliationTransaction.xReconciled <= self.reconciliationTransaction.yToReconcile;
                }

                self.disableMarkAsReconciledButton = {
                    value: true,
                    set: function(force) {
                        if (force) {
                            self.disableMarkAsReconciledButton.value = force;
                        } else {
                            var invoiceLines = _.filter($scope.invoiceGridOptions.data,
                                function(row) {
                                    return !row.isItemRow &&
                                        row.quantityInvoiced != row.quantityReconciled &&
                                        (row.grossPrice != 0 || row.itemNettPrice != 0 || row.unitCostPrice != 0);
                                });
                            self.disableMarkAsReconciledButton.value = invoiceLines.length > 0;
                        }
                    }
                };
                self.templateRoot = '/ngxbeagle/dist/Content/js/Modules/InvoiceReconciliation/GridTemplates/';
                self.getUiGridTemplate = function(templateName) {
                    return $templateRequest(self.templateRoot + templateName + '.html');
                }
                self.resolves = {
                    invoiceData: invoiceData,
                    invoiceLineData: invoiceLineData,
                    unreconciledPoData: unreconciledPoData,
                    creditDueData: creditDueData,
                    uiGrid: {
                        invoiceGrid: {
                            actionsTemplate: self.getUiGridTemplate('actionsTemplate'),
                            descriptionTemplate: self.getUiGridTemplate('descriptionTemplate'),
                            skuCodeTemplate: self.getUiGridTemplate('skuCodeTemplate'),
                            unitPriceTemplate: self.getUiGridTemplate('unitPriceTemplate'),
                            grossPriceTemplate: self.getUiGridTemplate('grossPriceTemplate'),
                            quantityReceivedTemplate: self.getUiGridTemplate('quantityReceivedTemplate')
                        },
                        rpoGrid: {
                            descriptionTemplate: self.getUiGridTemplate('descriptionTemplate'),
                            reconciliationAmountTemplate:
                                self.getUiGridTemplate('rpoGrid/reconciliationAmountTemplate'),
                            selectionTemplate: self.getUiGridTemplate('rpoGrid/selectionTemplate'),
                            skuCodeTemplate: self.getUiGridTemplate('rpoGrid/skuCodeTemplate'),
                            poNumberTemplate: self.getUiGridTemplate('rpoGrid/poNumberTemplate'),
                            rpoCostPriceTemplate: self.getUiGridTemplate('rpoGrid/rpoCostPriceTemplate')
                        }
                    },
                    translations: {
                        itemVat: $translate('label_item_vat')
                    }
                }

                self.reconciliationTransaction = {
                    _selectedPurchaseOrderLines: [],
                    _selectedInvoiceLine: {},
                    _trackedReconciliationRpoLineItems: [],
                    _trackedInvoiceLines: [],
                    _resetPurchaseOrderLines: function() {
                        this._selectedPurchaseOrderLines = [];
                    },
                    xReconciled: 0,
                    yToReconcile: 0,
                    setSelectedPurchaseOrderLines: function(purchaseOrders) {
                        this._resetPurchaseOrderLines();
                        for (var i = 0; i < purchaseOrders.length; i++) {
                            if (purchaseOrders[i].isSelectedForReconciliation) {
                                _.pushIfNotExists(this._selectedPurchaseOrderLines,
                                    purchaseOrders[i].procurementReceivingPurchaseOrderLines);
                            }
                        }
                    },
                    getSelectedPurchaseOrderLines: function() {
                        return this._selectedPurchaseOrderLines;
                    },
                    setSelectedInvoiceLine: function(invoiceLine) {
                        this.yToReconcile = invoiceLine.quantityInvoiced;
                        this.xReconciled = invoiceLine.quantityReconciled;
                        this._selectedInvoiceLine = invoiceLine;
                    },
                    getSelectedInvoiceLine: function() {
                        return this._selectedInvoiceLine;
                    },
                    trackInvoiceLine: function(invoiceLine) {
                        this._trackedInvoiceLines.push(invoiceLine);
                    },
                    getTrackedInvoiceLines: function() {
                        return this._trackedInvoiceLines;
                    },
                    trackRpoReconciliationLineItem: function(rpoLineItem) {
                        _.pushIfNotExists(this._trackedReconciliationRpoLineItems, rpoLineItem);
                    },
                    untrackRpoReconciliationLineItem: function(rpoLineItem) {
                        _.removeIfExists(this._trackedReconciliationRpoLineItems, rpoLineItem, { id: rpoLineItem.id });
                        // TODO: Remove item from invoice grid
                    },
                    getTrackedRpoReconciliationLines: function() {
                        return this._trackedReconciliationRpoLineItems;
                    },
                    commit: function() {
                        var transaction = this;
                        var invoiceLine = this.getSelectedInvoiceLine();
                        var trackedRpoLineItems = this.getTrackedRpoReconciliationLines();
                        // Initialises the array on the InvoiceLine if it doesn't exist
                        invoiceLine.receivingLinesReconciled = invoiceLine.receivingLinesReconciled || [];
                        var invoiceRow = _.findWhere($scope.invoiceGridOptions.data, { id: invoiceLine.id });
                        if (!_.findWhere(this._trackedInvoiceLines, { id: invoiceLine.id })) {
                            this.trackInvoiceLine(invoiceLine);
                        }
                        var index = _.indexOf($scope.invoiceGridOptions.data, invoiceRow);

                        angular.forEach(trackedRpoLineItems,
                            function(rpoLineItem) {
                                var currentItemOnParent = _.findWhere(
                                    rpoLineItem.parent.receivingLineItemReconciliations,
                                    { id: rpoLineItem.id });

                                rpoLineItem.skuCode = rpoLineItem.parent.skuCode;
                                rpoLineItem.purchaseOrderNumber = rpoLineItem.parent.purchaseOrderNumber;
                                rpoLineItem.productDescription = rpoLineItem.parent.description;
                                rpoLineItem.isItemRow = true;
                                rpoLineItem.invoiceLineId = invoiceLine.id;

                                // invoiceLine.quantityReconciled doesn't exist. Default it to 0 for calculations.
                                if (!invoiceLine.quantityReconciled) {
                                    invoiceLine.quantityReconciled = 0;
                                }
                                invoiceLine.quantityReconciled = transaction.xReconciled;

                                if (rpoLineItem.selectedForReconciliation && rpoLineItem.quantityReconciled > 0) {
                                    var lineAlreadyExisting = _.findWhere(invoiceLine.receivingLinesReconciled,
                                        { id: rpoLineItem.parent.id });
                                    if (lineAlreadyExisting) {

                                        var itemAlreadyOnInvoiceLine =
                                            _.findWhere(lineAlreadyExisting.receivingLineItemReconciliations,
                                                { id: rpoLineItem.id });
                                        itemAlreadyOnInvoiceLine.quantityReconciled = rpoLineItem.quantityReconciled;

                                        //this was previously searching the WHOLE grid.This caused bugs because if you reconcile the same invoice line (after you do the parent in the else,)
                                        //Then the 1st match will be picked up.
                                        //var itemExistsOnGrid = _.findWhere($scope.invoiceGridOptions.data, { id: rpoLineItem.id });


                                        var itemExistsOnGrid = undefined;
                                        var foundInvoiceLine = false;
                                        _.each($scope.invoiceGridOptions.data,
                                            function(datum) {
                                                //This protects us if we pass the invoice line that we want
                                                if (datum.receivingLinesReconciled) {
                                                    foundInvoiceLine = false;
                                                }
                                                if (datum.id == invoiceLine.id) {
                                                    foundInvoiceLine = true;
                                                }

                                                if (foundInvoiceLine) {
                                                    if (datum.id == rpoLineItem.id) {
                                                        itemExistsOnGrid = datum;
                                                    }
                                                }
                                            });


                                        //i could not get it to go through this path while testing
                                        if (!itemExistsOnGrid) {
                                            self.pushRowToGrid(index, rpoLineItem, invoiceLine);
                                            var rpoli = self.getItemFromUnreconciledRpoArray(rpoLineItem);
                                            if (rpoli) {
                                                rpoli.quantityReconciledToDate += rpoLineItem.quantityReconciled;
                                                rpoli.quantityReconciled += rpoLineItem.quantityReconciled;
                                            }
                                        } else {
                                            var rpoli = self.getItemFromUnreconciledRpoArray(rpoLineItem);
                                            //if it exists we need to update the base item on the unreconciled PO
                                            if (rpoli) {
                                                rpoli.quantityReconciledToDate += rpoLineItem.quantityReconciled -
                                                    rpoli.quantityReconciled;
                                                rpoli.quantityReconciled = rpoLineItem.quantityReconciled;
                                            }
                                            itemExistsOnGrid.quantityReconciled = rpoLineItem.quantityReconciled;
                                        }
                                    } else {
                                        var rpoli = self.getItemFromUnreconciledRpoArray(rpoLineItem);
                                        if (rpoli) {
                                            rpoli.quantityReconciledToDate += rpoLineItem.quantityReconciled;
                                            rpoli.quantityReconciled += rpoLineItem.quantityReconciled;
                                        }
                                        invoiceLine.receivingLinesReconciled.push(rpoLineItem.parent);
                                        self.pushRowToGrid(index, rpoLineItem, invoiceLine);
                                    }
                                } else if (rpoLineItem.selectedForReconciliation == false) {
                                    console.log('Im in here (Sku code: {0}) '.format(rpoLineItem.skuCode));
                                    var row = { entity: rpoLineItem };
                                    $scope.invoiceGridCallbacks.deleteRpoItem(row);
                                }
                            });

                        var quantityReceived = 0;
                        var itemsToDelete = [];
                        angular.forEach(invoiceLine.receivingLinesReconciled,
                            function(receivingLine) {
                                angular.forEach(receivingLine.receivingLineItemReconciliations,
                                    function(item) {
                                        if (item.quantityReconciled > 0) {
                                            quantityReceived += item.quantityReceived;
                                        }
                                    });
                            });

                        invoiceLine.quantityReceived = quantityReceived;

                        this.dispose();
                    },
                    dispose: function() {
                        this._selectedInvoiceLine = {};
                        this._trackedReconciliationRpoLineItems = [];
                        this.xReconciled = 0;
                        this.yToReconcile = 0;

                        angular.forEach($scope.receivingPurchaseOrderGridOptions.data,
                            function(row) {
                                row.selectedForReconciliation = false;
                                angular.forEach(row.receivingLineItemReconciliations, function(rpoLine) {
                                  rpoLine.quantityReconciled = rpoLine.quantityReconciledToDate;
                                })
                            });
                    }
                }
                self.getItemFromUnreconciledRpoArray = function(rpoLineItem) {
                    var rpoli = undefined;
                    angular.forEach($scope.unreconciledPurchaseOrders,
                        function(rpo) {
                            angular.forEach(rpo.procurementReceivingPurchaseOrderLines,
                                function(rpoLine) {
                                    angular.forEach(rpoLine.receivingLineItemReconciliations,
                                        function(reconciliationItem) {
                                            if (reconciliationItem.id == rpoLineItem.id) {
                                                rpoli = reconciliationItem;
                                            }
                                        });
                                });
                        });
                    return rpoli;
                }

                self.setupRpoGridOptions = function(term) {
                    var currentlySelectedItems = _.findWhere()
                    var rpoLines = self.reconciliationTransaction.getSelectedPurchaseOrderLines();
                    if (term) {
                        term = term.toLowerCase();
                        rpoLines = _.filter(rpoLines,
                            function(rpoLine) {
                                return rpoLine.skuCode.toLowerCase().includes(term) ||
                                    rpoLine.description.toLowerCase().includes(term);
                            });
                    }
                    var rpoLineItemsToAddToGrid = _.sortBy(rpoLines, 'skuCode');
                    $scope.receivingPurchaseOrderGridOptions.data = _.sortBy(rpoLines, 'skuCode');
                    angular.forEach(rpoLineItemsToAddToGrid,
                        function(rpoLine) {
                            angular.forEach(rpoLine.receivingLineItemReconciliations,
                                function(rpoLineItem) {
                                    rpoLineItem.parent = rpoLine;
                                    rpoLineItem.isItemRow = true;
                                    self.insertRowToGridData(rpoLine, rpoLineItem);
                                });

                            if (_.every(rpoLine.receivingLineItemReconciliations,
                                function(a) {
                                    return a.selectedForReconciliation == true;
                                })) {
                                rpoLine.selectedForReconciliation = true;
                            }
                        });

                    genericUiGrid.create($scope.receivingPurchaseOrderGridOptions, $scope).then(function(grid) {
                        $scope.rpoGrid = grid;
                    });
                }

                $scope.filterRpoLineData = function(term) {
                    self.setupRpoGridOptions(term);
                }

                $scope.filterInvoiceLineData = function(term) {
                    var invoiceLines = $scope.invoiceLinesForReconciliation;
                    if (term) {
                        term = term.toLowerCase();
                        invoiceLines = _.filter(invoiceLines,
                            function(invoiceLine) {
                                return invoiceLine.productCode.toLowerCase().includes(term) ||
                                    invoiceLine.productDescription.toLowerCase().includes(term);
                            });
                    }
                    $scope.invoiceGridOptions.data = _.sortBy(invoiceLines, 'productCode');
                    angular.forEach(invoiceLines,
                        function(invoiceLine) {
                            // This is to prevent a bug where we would get duplicates in the grid. Defaulting all to open for now
                            invoiceLine.showingInvoiceLineReconciliationItems = true;
                            angular.forEach(invoiceLine.receivingLinesReconciled,
                                function(receivingLine) {
                                    if (invoiceLine.showingInvoiceLineReconciliationItems) {
                                        angular.forEach(receivingLine.receivingLineItemReconciliations,
                                            function(receivingItem) {
                                                var invoiceLineRowInInvoiceGrid = _.findWhere(
                                                    $scope.invoiceGridOptions.data,
                                                    { id: invoiceLine.id });
                                                if (invoiceLineRowInInvoiceGrid &&
                                                    receivingItem.quantityReconciled > 0) {
                                                    var index = _.indexOf($scope.invoiceGridOptions.data,
                                                        invoiceLineRowInInvoiceGrid);
                                                    receivingItem.isItemRow = true;
                                                    receivingItem.skuCode = receivingLine.skuCode;
                                                    receivingItem.purchaseOrderNumber =
                                                        receivingLine.purchaseOrderNumber;
                                                    receivingItem.productDescription = receivingLine.description;
                                                    receivingItem.invoiceLineId = invoiceLine.id;
                                                    receivingItem.invoiceLineUnitCostPrice = invoiceLine.unitCostPrice;
                                                    $scope.invoiceGridOptions.data.splice(index + 1, 0, receivingItem);
                                                }
                                            });
                                    }
                                });
                        });

                    genericUiGrid.create($scope.invoiceGridOptions, $scope).then(function(grid) {
                        $scope.invoiceLinesGrid = grid;
                    });
                }

                /**
                 * Entity: The gid row entity.
                 * Col: The column in the grid.
                 * colField: The value of the field.
                 */
                $scope.rpoGridCallbacks = {
                    afterSelectionCellEdit: function(entity, col, colField) {
                        if (entity.isItemRow) {
                            self.updateRpoLineItemValuesAndSelection(entity, colField);
                            if (colField == true) {
                              entity.parent.quantityReconciled += entity.quantityReconciled;
                              self.reconciliationTransaction.xReconciled += entity.quantityReconciled;
                            } else {
                                entity.parent.quantityReconciled -= entity.quantityReconciled;
                                self.reconciliationTransaction.xReconciled -= entity.quantityReconciled;
                                entity.quantityReconciled = 0;
                            }
                            var itemsTicked = _.filter(entity.parent.receivingLineItemReconciliations,
                                { selectedForReconciliation: true });
                            var hasItemsTicked = itemsTicked.length > 0;
                            if (hasItemsTicked == false) {
                                entity.parent.selectedForReconciliation = false;
                            } else if (itemsTicked.length == entity.parent.receivingLineItemReconciliations.length) {
                                entity.parent.selectedForReconciliation = true;
                            }
                        } else {
                            // We are an RPO LINE! Update the item values
                            angular.forEach(entity.receivingLineItemReconciliations,
                                function(rpoLineItem) {
                                    if (rpoLineItem.quantityReconciled != rpoLineItem.quantityReceived) {
                                        self.updateRpoLineItemValuesAndSelection(rpoLineItem, colField);
                                        entity.quantityReconciled += rpoLineItem.quantityReconciled;

                                        if (colField == true) {
                                            self.reconciliationTransaction.xReconciled +=
                                                rpoLineItem.quantityReconciled;
                                        }
                                    }
                                    if (colField == false) {
                                        self.reconciliationTransaction.xReconciled -= rpoLineItem.quantityReconciled;
                                        entity.quantityReconciled = 0;
                                        rpoLineItem.quantityReconciled = 0;
                                        rpoLineItem.selectedForReconciliation = false;
                                    }
                                });

                        }
                    },
                    quantityReconciledOnChange: function(entity, col, colField) {
                        if (entity.isItemRow) {
                            if (entity.selectedForReconciliation) {
                                entity.parent.quantityReconciled += entity.quantityReconciled;
                            }
                        }
                    }
                }

                $scope.invoiceGridCallbacks = {
                    selectInvoiceForReconciliation: function(row) {
                        if (_.isArray(row.entity)) {
                            row.isSelected = false;
                            return;
                        }

                        //https://www.pivotaltracker.com/story/show/157422533 - requested to not populate search terms on hitting reocnciliation
                        //$scope.vm.rpoLineFilter.term = row.entity.productCode;
                        //when clicking reconcile, this allows preselecting the data -- dont switch! -> ME
                        $scope.selectInvoiceLineForReconciliation(row.entity);

                        //https://www.pivotaltracker.com/story/show/157422533 - requested to not populate search terms on hitting reocnciliation
                        $scope.filterRpoLineData();


                        angular.forEach(row.entity.receivingLinesReconciled,
                            function(rlr) {
                                if (rlr.quantityReconciled > 0) {
                                    rlr.quantityReconciled = 0;
                                    var rlrInRpoGrid = _.findWhere($scope.receivingPurchaseOrderGridOptions.data,
                                        { id: rlr.id, invoiceLineId: row.entity.id });
                                    if (rlrInRpoGrid) {
                                        rlrInRpoGrid.quantityReconciled = 0;
                                        angular.forEach(rlrInRpoGrid.receivingLineItemReconciliations,
                                            function(rlir) {
                                                rlrInRpoGrid.quantityReconciled =
                                                    rlrInRpoGrid.quantityReconciled +
                                                    rlir.quantityReconciled;
                                                rlr.quantityReconciled =
                                                    rlr.quantityReconciled +
                                                    rlrInRpoGrid.quantityReconciled;
                                            });
                                    }
                                }
                            });
                        $scope.vm.showUnreconciledPurchaseOrderLines = true;
                    },
                    deleteRpoItem: function(row) {


                        var invoiceLineInGrid =
                            _.findWhere($scope.invoiceLinesGrid.data, { id: row.entity.invoiceLineId });
                        var invoiceLineReconciliations = _.filter(invoiceLineInGrid.receivingLinesReconciled,
                            function(invoiceLineReconciliation) {
                                return invoiceLineReconciliation.receivingLineItemReconciliations.length > 0;
                            });


                        var itemRowInInvoiceGrid = undefined;
                        var foundInvoiceLine = false;
                        _.each($scope.invoiceLinesGrid.data,
                            function(datum) {
                                //This protects us if we pass the invoice line that we want
                                if (datum.receivingLinesReconciled) {
                                    foundInvoiceLine = false;
                                }
                                if (datum.id == row.entity.invoiceLineId) {
                                    foundInvoiceLine = true;
                                }

                                if (foundInvoiceLine) {
                                    if (datum.id == row.entity.id) {
                                        itemRowInInvoiceGrid = datum;
                                    }
                                }
                            });
                        //Same problem here, we could have multiple items with the same id. you need to filter for your specific invoice line.
                        //var itemRowInInvoiceGrid = _.findWhere($scope.invoiceLinesGrid.data, { id: row.entity.id });


                        //This updates the qReconciledtoDate for the grid
                        invoiceLineInGrid.quantityReconciled =
                            invoiceLineInGrid.quantityReconciled - row.entity.quantityReconciled;
                        invoiceLineInGrid.quantityReceived =
                            invoiceLineInGrid.quantityReceived - row.entity.quantityReceived;


                        //This was commented out but after debugging i wanted to add an exactly the same snipper. When you delete items in the grid, this makes sure that your qReconciledToDate is kept
                        //Up to date when you later want to reconcile the SAME items.
                        angular.forEach($scope.unreconciledPurchaseOrders,
                            function(rpo) {
                                angular.forEach(rpo.procurementReceivingPurchaseOrderLines,
                                    function(rpoLine) {
                                        var rpoLineItem = _.find(rpoLine.receivingLineItemReconciliations,
                                            function(rpoLineItem) {
                                                return rpoLineItem.id == row.entity.id;
                                            });
                                        if (rpoLineItem) {
                                            rpoLineItem.quantityReconciledToDate -= row.entity.quantityReconciled;
                                        }
                                    });
                            });

                        angular.forEach(invoiceLineReconciliations,
                            function(invoiceLineReconciliation) {
                                var itemInInvoiceLineReconciliation = _.findWhere(
                                    invoiceLineReconciliation.receivingLineItemReconciliations,
                                    { id: row.entity.id });
                                if (itemInInvoiceLineReconciliation) {
                                    //itemInInvoiceLineReconciliation.quantityReconciledToDate -= itemInInvoiceLineReconciliation.quantityselectInvoiceForReconciliationReconciled;
                                    itemInInvoiceLineReconciliation.quantityReconciled = 0;
                                }

                            });

                        var index = _.indexOf($scope.invoiceLinesGrid.data, itemRowInInvoiceGrid);
                        $scope.invoiceLinesGrid.data.splice(index, 1);
                        $scope.invoiceLineGridApi.core.refresh();

                        self.reconciliationTransaction.trackInvoiceLine(invoiceLineInGrid);
                        self.disableMarkAsReconciledButton.set();
                    },
                    showReconcileButton: function() {
                        return $scope.receivingPurchaseOrderGridOptions.data &&
                            $scope.receivingPurchaseOrderGridOptions.data.length > 0 &&
                            $scope.invoice.procurementInvoiceStatusId != enums.invoiceStatus.Reconciled &&
                            $scope.invoice.procurementInvoiceStatusId != enums.invoiceStatus.Accepted &&
                            $scope.invoice.procurementInvoiceStatusId != enums.invoiceStatus.AwaitingCredit;
                    },
                    showDeleteButton: function() {
                        return $scope.invoice.procurementInvoiceStatusId != enums.invoiceStatus.Reconciled &&
                            $scope.invoice.procurementInvoiceStatusId != enums.invoiceStatus.Accepted &&
                            $scope.invoice.procurementInvoiceStatusId != enums.invoiceStatus.AwaitingCredit;
                    },
                    toggleShowingInvoiceLineReconciliationItems: function(invoiceRow) {
                        invoiceRow.entity.showingInvoiceLineReconciliationItems =
                            !invoiceRow.entity.showingInvoiceLineReconciliationItems;
                        if (invoiceRow.entity.showingInvoiceLineReconciliationItems) {
                            angular.forEach(invoiceRow.entity.receivingLinesReconciled,
                                function(receivingLine) {
                                    angular.forEach(receivingLine.receivingLineItemReconciliations,
                                        function(lineItem) {
                                            if (lineItem.quantityReconciled > 0) {
                                                var invoiceLine = _.findWhere($scope.invoiceLinesGrid.data,
                                                    { id: invoiceRow.entity.id });
                                                var index = _.indexOf($scope.invoiceLinesGrid.data, invoiceLine);
                                                self.pushRowToGrid(index, lineItem);
                                            }
                                        });
                                });
                        } else {
                            angular.forEach(invoiceRow.entity.receivingLinesReconciled,
                                function(receivingLine) {
                                    angular.forEach(receivingLine.receivingLineItemReconciliations,
                                        function(lineItem) {
                                            var itemInGrid = _.findWhere($scope.invoiceLinesGrid.data,
                                                { id: lineItem.id });
                                            if (itemInGrid) {
                                                var index = _.indexOf($scope.invoiceLinesGrid.data, itemInGrid);
                                                $scope.invoiceLinesGrid.data.splice(index, 1);
                                            }
                                        });
                                });
                        }
                    }
                }

                $scope.cancelLineReconciliation = function() {
                    self.reconciliationTransaction.dispose();

                    $scope.vm.showUnreconciledPurchaseOrderLines = false;
                }

                $scope.cancelReconciling = function() {
                    var hasHistory = $window.history.length > 0;
                    if (hasHistory) {
                        $window.history.back();
                    } else {
                        $window.location = '/dashboard';
                    }
                }

                self.updateRpoLineSelectionIfRequired = function(rpoLineItem) {
                }

                self.updateRpoLineItemValuesAndSelection = function(entity, colField) {
                    if (colField === true) {
                        var invoiceLine = self.reconciliationTransaction.getSelectedInvoiceLine();
                        if (entity.quantityReconciledToDate) {
                          entity.quantityReconciled = entity.quantityReconciledToDate;
                        } else {
                          var remainingForReconciliation = entity.quantityReceived - entity.quantityReconciledToDate;
                          if (remainingForReconciliation < 0) {
                              remainingForReconciliation = 0;
                          }
                          //i have added this safety check in order  to prevent negative numbers
                          var lowestValue = Math.min(remainingForReconciliation,
                              invoiceLine.quantityInvoiced - invoiceLine.quantityReconciled);
                          entity.quantityReconciled = lowestValue;
                        }
                        self.reconciliationTransaction.trackRpoReconciliationLineItem(entity);
                    } else if (colField > 0) {
                        entity.quantityReconciled = entity.quantityReconciled;
                        self.reconciliationTransaction.trackRpoReconciliationLineItem(entity);
                    } else {
                        // We still want to add to the tracked entities because we've changed something.
                        self.reconciliationTransaction.trackRpoReconciliationLineItem(entity);
                    }
                    if (_.isBoolean(colField)) {
                        entity.selectedForReconciliation = colField;
                    }
                }

                self.insertRowToGridData = function(parent, child) {
                    var grid = $scope.receivingPurchaseOrderGridOptions.data;
                    var index = _.indexOf(grid, parent);
                    var childIndex = index + 1;
                    grid.splice(childIndex, 0, child);
                }

                self.unreconcilePoLineWithInvoiceLine = function(poLine, invoiceLine) {
                    poLine.quantityReconciled = 0;
                    poLine.selectedForReconciliation = false;
                    var poLineIndexInInvoiceLineReconciliations =
                        invoiceLine.receivingLinesReconciled.indexOf(_.findWhere(invoiceLine.receivingLinesReconciled,
                            { id: poLine.id }));
                    var invoiceLineIndexInGrid = self.findInvoiceLineInGrid(invoiceLine).index + 1;
                    var currentGridIndexForItems = invoiceLineIndexInGrid;

                    self.removeRowFromGrid(invoiceLineIndexInGrid + poLineIndexInInvoiceLineReconciliations);
                    _.removeIfExists(invoiceLine.receivingLinesReconciled, poLine);
                }

                self.reconcilePoLineWithInvoiceLine = function(poLine, invoiceLine) {
                    // Push our PO line to the invoice line reconciled lines array
                    _.pushIfNotExists(invoiceLine.receivingLinesReconciled, poLine);
                    var addedPoLine = _.findWhere(invoiceLine.receivingLinesReconciled, { id: poLine.id });
                    // Find the invoice line in the grid
                    var invoiceLineInGrid = self.findInvoiceLineInGrid(invoiceLine);

                    var currentGridIndexForItems = invoiceLineInGrid.index;
                    // Setup all of the item rows that we need to add to the grid for the PO line
                    _.each(addedPoLine.receivingLineItems,
                        function(lineItem) {
                            self.pushRowToGrid(currentGridIndexForItems, lineItem);
                            currentGridIndexForItems++;
                        });

                    self.pushRowToGrid(invoiceLineInGrid.index, addedPoLine);
                }

                self.pushRowToGrid = function(index, lineToAdd, invoiceLine) {
                    var idx = index + 1;
                    if (invoiceLine) {
                        lineToAdd.invoiceLineId = invoiceLine.id;
                        lineToAdd.invoiceLineUnitCostPrice = invoiceLine.unitCostPrice;
                    }
                    $scope.invoiceLinesGrid.data.splice(idx, 0, lineToAdd);
                }

                self.removeRowFromGrid = function(index) {
                    $scope.invoiceLinesGrid.data.splice(index, 1);
                }

                self.findInvoiceLineInGrid = function(row) {
                    var lineInGrid = _.findWhere($scope.invoiceLinesGrid.data, { id: row.id });
                    var index = $scope.invoiceLinesGrid.data.indexOf(lineInGrid);
                    return { row: lineInGrid, index: index };
                }

                self.getCurrentlySelectedInvoiceLine = function() {
                    return _.findWhere($scope.invoiceLinesForReconciliation, { selectedForReconciliation: true });
                }

                self.init = function() {
                    userService.hasPermission('BEAGLE_CREDIT_REQUESTS_VIEW').then(function() {
                        $scope.hasCreditRequestViewPermission = true;
                    });
                    userService.hasPermission('BEAGLE_CREDIT_REQUEST_RAISE').then(function() {
                        $scope.hasCreditRequestRaisePermission = true;
                    });
                    userService.hasPermission('BEAGLE_CAN_RECONCILE_INVOICES').then(function() {
                        $scope.hasReconcileInvoicePermission = true;
                    });
                    $q.all(self.resolves).then(function(results) {
                        $scope.invoice = results.invoiceData;
                        $scope.creditAmountDue = results.creditDueData.grossAmount;
                        $scope.potentialCreditsWorth = $translate.instant('label_potential_credit_worth', { currencySymbol: $scope.vm.context.currency.name, totalCreditDue: $scope.creditAmountDue });
                        $scope.saveAndMarkAsReconciledMessage = results.translations.saveAndMarkAsReconiledMessage;
                        $scope.showCreditPrompt = false;

                        $scope.invoiceLinesForReconciliation =
                            _.sortBy(results.invoiceLineData.procurementInvoiceLines, 'productCode');
                        $scope.unreconciledPurchaseOrders = results.unreconciledPoData;
                        var rpoGridTemplates = results.uiGrid.rpoGrid;

                        $scope.invoiceGridOptions = {
                            data: $scope.invoiceLinesForReconciliation,
                            enableRowSelection: true,
                            multiSelect: false,
                            columns: [
                                {
                                    displayName: $translate.instant('product_code'),
                                    field: 'productCode',
                                    minWidth: 130,
                                    template: results.uiGrid.invoiceGrid.skuCodeTemplate,
                                    placeholder: false
                                },
                                {
                                    displayName: $translate.instant('product_description'),
                                    field: 'productDescription',
                                    minWidth: 300,
                                    template: results.uiGrid.invoiceGrid.descriptionTemplate,
                                    placeholder: false
                                },
                                {
                                    displayName: $translate.instant('quantity_invoiced'),
                                    field: 'quantityInvoiced',
                                    minWidth: 130,
                                    cellClass: 'number',
                                    cellFilter: 'nullableNumber: 3',
                                    editable: function(cellScope) { return _.isArray(cellScope.row.entity); },
                                    placeholder: false
                                },
                                {
                                    displayName: $translate.instant('quantity_reconciled'),
                                    field: 'quantityReconciled',
                                    minWidth: 130,
                                    placeholder: false,
                                    cellFilter: 'nullableNumber: 3',
                                    cellClass: 'number'
                                },
                                {
                                    displayName: $translate.instant('quantity_received'),
                                    field: 'quantityReceived',
                                    minWidth: 130,
                                    placeholder: false,
                                    template: results.uiGrid.invoiceGrid.quantityReceivedTemplate,
                                    cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex) {
                                        var cellClass = 'number';
                                        if (!row.entity.isItemRow) {
                                            if (row.entity.quantityReceived != row.entity.quantityInvoiced) {
                                                cellClass += ' redText';
                                            }
                                        }


                                        // MB: Commented this out in case PSL ask for it to be re-added
                                        //if (row.entity.isItemRow) {
                                        //    var invoiceLine = _.findWhere($scope.invoiceLinesForReconciliation, { id: row.entity.invoiceLineId });
                                        //    if (row.entity.quantityReceived != invoiceLine.quantityInvoiced) {
                                        //        cellClass += ' redText';
                                        //    }
                                        //}

                                        return cellClass;
                                    }
                                },
                                {
                                    displayName: $translate.instant('purchase_order_number'),
                                    field: 'purchaseOrderNumber',
                                    minWidth: 130,
                                    template: rpoGridTemplates.poNumberTemplate,
                                    placeholder: false
                                },
                                {
                                    displayName: $translate.instant('department'),
                                    field: 'department.name',
                                    minWidth: 130,
                                    placeholder: false
                                },
                                {
                                    displayName: $translate.instant('account_code'),
                                    field: 'accountCode.name',
                                    minWidth: 130,
                                    placeholder: false
                                },
                                {
                                    displayName: $translate.instant('unit_cost_price'),
                                    field: 'unitCostPrice',
                                    minWidth: 130,
                                    template: results.uiGrid.invoiceGrid.unitPriceTemplate,
                                    placeholder: false,
                                    cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex) {
                                        var cellClass = 'number';
                                        if (!row.entity.isItemRow) {
                                            var itemsWithPriceDiscrepency = _.filter(
                                                row.entity.receivingLinesReconciled,
                                                function(receivingLine) {
                                                    return receivingLine.itemPriceOrdered != row.entity.unitCostPrice;
                                                });

                                            if (itemsWithPriceDiscrepency.length > 0) {
                                                cellClass += ' redText';
                                            };
                                        }

                                        // MB: Commented this out in case PSL ask for it to be re-added
                                        //} else {
                                        //if (row.entity.invoiceLineUnitCostPrice !=
                                        //    row.entity.receivingItemUnitCostPrice) {
                                        //    cellClass += ' redText';
                                        //}
                                        //}

                                        return cellClass;
                                    }
                                },
                                //{ field: 'itemVAT', displayName: results.translations.itemVat, cellClass: 'number', template: results.uiGrid.invoiceGrid.priceTemplate, placeholder: false },
                                {
                                    displayName: $translate.instant('gross_price'),
                                    field: 'grossPrice',
                                    minWidth: 130,
                                    cellClass: 'number',
                                    template: results.uiGrid.invoiceGrid.grossPriceTemplate,
                                    placeholder: false
                                },
                                {
                                    displayName: $translate.instant('actions'),
                                    field: 'actions',
                                    minWidth: 130,
                                    template: results.uiGrid.invoiceGrid.actionsTemplate,
                                    placeholder: false
                                }
                            ],
                            globalEditableCondition: function() {
                                return false;
                            },
                            rowClass: function(row) {
                                var rowClass = '';
                                if (row.entity.parent || row.entity.isItemRow) {
                                    rowClass += ' is-item-row ';
                                } else {
                                    rowClass += ' is-line-row ';
                                }

                                if (row.entity.quantityReconciled == row.entity.quantityInvoiced) {
                                    rowClass += ' green-text ';
                                }

                                return rowClass;
                            },
                            onRegisteredApi: function(gridApi) {
                                $scope.invoiceLineGridApi = gridApi;
                            }
                        };
                        genericUiGrid.create($scope.invoiceGridOptions, $scope).then(function(grid) {
                            $scope.invoiceLinesGrid = grid;
                            $scope.filterInvoiceLineData();
                        });

                        $scope.receivingPurchaseOrderGridOptions = {
                            columns: [
                                {
                                    displayName: $translate.instant('purchase_order_number', 'Purchase Order Number'),
                                    field: 'purchaseOrderNumber',
                                    minWidth: 110,
                                    template: rpoGridTemplates.poNumberTemplate,
                                    placeholder: false
                                },
                                {
                                    displayName: $translate.instant('sku_code', 'Sku Code'),
                                    field: 'skuCode',
                                    minWidth: 100,
                                    template: rpoGridTemplates.skuCodeTemplate,
                                    placeholder: false
                                },
                                {
                                    displayName: $translate.instant('description', 'Description'),
                                    field: 'description',
                                    minWidth: 450,
                                    template: rpoGridTemplates.descriptionTemplate,
                                    placeholder: false
                                },
                                {
                                    displayName: $translate.instant('department', 'Department'),
                                    field: 'department.name',
                                    minWidth: 105,
                                    placeholder: false
                                },
                                {
                                    displayName: $translate.instant('account_code', 'Account Code'),
                                    field: 'accountCode.name',
                                    minWidth: 105,
                                    placeholder: false
                                },
                                {
                                    displayName: $translate.instant('quantity_ordered', 'Quantity Ordered'),
                                    field: 'quantityOrdered',
                                    minWidth: 100,
                                    cellFilter: 'nullableNumber: 3',
                                    cellClass: 'number',
                                    placeholder: false
                                },
                                {
                                    displayName: $translate.instant('quantity_received', 'Quantity Received'),
                                    field: 'quantityReceived',
                                    minWidth: 100,
                                    cellFilter: 'number: 3',
                                    cellClass: 'number',
                                    placeholder: false
                                },
                                {
                                    displayName:
                                        $translate.instant('receiving_item_cost_price', 'Item Unit Cost Price'),
                                    field: 'receivingItemUnitCostPrice',
                                    minWidth: 100,
                                    template: rpoGridTemplates.rpoCostPriceTemplate,
                                    cellClass: 'number',
                                    placeholder: false
                                },
                                {
                                    displayName: $translate.instant('quantity_reconciled_to_date',
                                        'Quantity Reconciled to Date'),
                                    field: 'quantityReconciledToDate',
                                    minWidth: 125,
                                    cellFilter: 'nullableNumber: 3',
                                    cellClass: 'number',
                                    placeholder: false
                                },
                                {
                                    displayName: $translate.instant('selected_for_reconciliation', 'Select'),
                                    field: 'selectedForReconciliation',
                                    width: 80,
                                    template: rpoGridTemplates.selectionTemplate,
                                    placeholder: false
                                },
                                {
                                    displayName: $translate.instant('quantity_reconciled', 'Quantity Reconciled'),
                                    field: 'quantityReconciled',
                                    minWidth: 100,
                                    cellClass: 'number',
                                    cellFilter: 'nullableNumber: 3',
                                    placeholder: false,
                                    editable: function(scope) {
                                        return scope.row.entity.isItemRow && scope.row.entity.selectedForReconciliation;
                                    },
                                }
                            ],
                            rowClass: function(row) {
                                var rowClass = '';
                                if (row.entity.parent != null || row.entity.isItemRow) {
                                    rowClass += 'is-item-row show-child-indicator';
                                } else {
                                    rowClass += 'is-line-row';
                                }

                                return rowClass;
                            },
                            globalEditableCondition: function() {
                                return false;
                            },
                            afterCellEdit: function(entity, cell, value, oldValue) {
                                if (cell.field == 'quantityReconciled') {
                                    if (value != oldValue) {
                                        if (value < oldValue) {
                                            var difference = oldValue - value;
                                            self.reconciliationTransaction.xReconciled -= difference;
                                            entity.parent.quantityReconciled -= difference;
                                        } else if (value > oldValue) {
                                            var difference = value - oldValue;
                                            self.reconciliationTransaction.xReconciled += difference;
                                            entity.parent.quantityReconciled += difference;
                                        }
                                    }
                                    self.updateRpoLineItemValuesAndSelection(entity, value);
                                }
                            }
                        }

                        angular.forEach($scope.unreconciledPurchaseOrders,
                            function(rpo) {
                                if (rpo.existingReconciliation) {
                                    rpo.isSelectedForReconciliation = true;
                                    $scope.selectPurchaseOrderForReconciliation(rpo);
                                }
                            });

                        genericUiGrid.create($scope.invoiceGridOptions, $scope).then(function(grid) {
                            $scope.invoiceLinesGrid = grid;
                        });
                        self.disableMarkAsReconciledButton.set();
                    });
                }();
            });
        }
    ]);

angular.module(appName)
    .factory('invoiceReconciliationResource',
        [
            '$resource', 'siteUrl',
            function ($resource, siteUrl) {
                var self = this;
                self.api = siteUrl() + 'api/ProcurementInvoicing';

                return $resource(self.api,
                    {},
                    {
                        getUnreconciledReceivingPurchaseOrders: {
                            method: "GET",
                            url: self.api + '/GetUnreconciledReceivingPurchaseOrders',
                            isArray: true
                        },
                        getInvoiceLinesForReconciliation: {
                            method: "GET",
                            url: self.api + '/GetInvoiceLinesForReconciliation'
                        },
                        insertReconcilationLines: {
                            method: "POST",
                            url: self.api + '/InsertReconcilationLines'
                        },
                        acceptInvoiceForPayment: {
                            method: 'POST',
                            url: self.api + '/AcceptInvoiceForPayment'
                        },
                        getCreditDue: {
                            method: 'GET',
                            url: self.api + '/GetCreditDue'
                        },
                        markInvoiceAsReconciled: {
                            method: 'POST',
                            url: self.api + '/MarkInvoiceAsReconciled'
                        },
                        manuallyAutoReconcileReceivingPurchaseOrders: {
                            method: 'POST',
                            url: self.api + '/ManuallyAutoReconcileReceivingPurchaseOrders'
                        }
                    });
            }
        ]);
angular.module(appName)
    .factory('invoiceReconciliationService',
        [
            'invoiceReconciliationResource', 'organisationContextService',
            function (invoiceReconciliationResource, organisationContextService) {

                var getInvoiceLinesForReconciliation = function(invoiceId) {
                    var ctx = organisationContextService.getContext();
                    return invoiceReconciliationResource.getInvoiceLinesForReconciliation({ id: ctx.currentSubscriptionUnit.id, procurementInvoiceId: invoiceId });
                }

                var getUnreconciledReceivingPurchaseOrders = function(invoiceId) {
                    var ctx = organisationContextService.getContext();
                    return invoiceReconciliationResource.getUnreconciledReceivingPurchaseOrders({
                        id: ctx.currentSubscriptionUnit.id,
                        procurementInvoiceId: invoiceId
                    }).$promise;
                };

                var insertReconcilationLines = function(reconciliationDto) {
                    var ctx = organisationContextService.getContext();
                    var dto = {
                        id: ctx.currentSubscriptionUnit.id,
                        procurementInvoiceLines: reconciliationDto.invoiceLines,
                        procurementInvoiceHeaderId: reconciliationDto.procurementInvoiceHeaderId
                    }
                    return invoiceReconciliationResource.insertReconcilationLines(dto).$promise;
                }

                var acceptInvoiceForPayment = function(invoiceId) {
                    var ctx = organisationContextService.getContext();
                    return invoiceReconciliationResource.acceptInvoiceForPayment({
                        id: ctx.currentSubscriptionUnit.id,
                        procurementInvoiceId: invoiceId
                    });
                }

                var getCreditDue = function(invoiceId) {
                    var ctx = organisationContextService.getContext();
                    return invoiceReconciliationResource.getCreditDue({
                        id: ctx.currentSubscriptionUnit.id,
                        procurementInvoiceHeaderId: invoiceId
                    }).$promise;
                }

                var markInvoiceAsReconciled = function (invoiceId,raiseCreditNote) {
                    var ctx = organisationContextService.getContext();
                    return invoiceReconciliationResource.markInvoiceAsReconciled({
                        id: ctx.currentSubscriptionUnit.id,
                        procurementInvoiceId: invoiceId, 
                        raiseCreditNotes: raiseCreditNote
                    }).$promise;
                }

                var manuallyAutoReconcileReceivingPurchaseOrders = function(dto) {
                    var ctx = organisationContextService.getContext();
                    return invoiceReconciliationResource.manuallyAutoReconcileReceivingPurchaseOrders({
                        id: ctx.currentSubscriptionUnit.id,
                        invoiceHeaderId: dto.invoiceHeaderId,
                        receivingPurchaseOrderIds: dto.receivingPurchaseOrderIds
                    }).$promise;
                }

                return {
                    getInvoiceLinesForReconciliation: getInvoiceLinesForReconciliation,
                    getUnreconciledReceivingPurchaseOrders: getUnreconciledReceivingPurchaseOrders,
                    insertReconcilationLines: insertReconcilationLines,
                    acceptInvoiceForPayment: acceptInvoiceForPayment,
                    getCreditDue: getCreditDue,
                    markInvoiceAsReconciled: markInvoiceAsReconciled,
                    manuallyAutoReconcileReceivingPurchaseOrders: manuallyAutoReconcileReceivingPurchaseOrders
                }
            }
        ]);
'use strict';

angular.module(appName)
    .factory('invoiceResource', [
        '$resource', "siteUrl", function ($resource, siteUrl) {
            var api = siteUrl() + "api/Invoice";
            var self = this;
			return $resource(api, {}, {
				search: {
					method: "GET",
					url: api + '/Search'
				},
				searchForGroup: {
					method: "GET",
					url: api + '/SearchForGroup'
				},
				getInvoices: {
					method: "GET",
					url: api + '/GetInvoices',
					isArray: true
				},
				getInvoiceById: {
					method: "GET",
					url: api + '/GetInvoiceById',
					params: {
						invoiceHeaderId: '@invoiceHeaderId',
						id: '@id'
					}
				},
				getExportFormatsForGroup: {
					method: "GET",
					url: api + '/getExportFormatsForGroup',
					isArray: true,
					params: {
						organisationId: '@organisationId'
					}
				},
				getExportFormatsForUnit: {
					method: "GET",
					url: api + '/getExportFormatsForUnit',
					isArray: true,
					params: {
						id: '@id',
						organisationId: '@organisationId'
					}
				},
				getIsMarriott: {
					method: "GET",
					url: api + '/IsMarriott',
					params: {
						organisationId: '@organisationId'
					}
				},
				updateStatusWithoutDto: {
					method: "POST",
					url: api + '/updateStatusWithoutDto',
					params: {
						procurementInvoiceHeaderId: '@procurementInvoiceHeaderId',
						statusId: '@statusId',
						rejectReason: '@rejectReason',
						creditAmountRequired: '@creditAmountRequired'
					}
				},
                getExportedFile:{
                    method: "GET",
                    url: api + '/DownloadDocument',
                    params: {
                        organisationId: '@organisationId',
                        documentId: '@documentId'
                    }
                },
                exportInvoices: {
                    method: "POST",
                    url: api + '/ExportInvoices'
                },
                exportSearch: {
                    method: "POST",
                    url: api + '/ExportSearch'
                },
                exportForUnit: {
                    method: "POST",
                    url: api + '/exportForUnit'
                },
                exportForGroup: {
                    method: "POST",
                    url: api + '/exportForGroup'
                },
                updateStatus: {
                    method: "POST",
                    url: api + '/UpdateStatus'
                },
                updateStatusForGroup: {
                    method: "POST",
                    url: api + '/UpdateStatusForGroup'
                },
                acceptAllSelected: {
                    method: "POST",
                    url: api + '/AcceptAllSelected',
                    isArray: true
                },
                acceptAllSelectedForGroup: {
                    method: "POST",
                    url: api + '/AcceptAllSelectedForGroup',
                    isArray: true
                },
                markAsExported: {
                    method: "POST",
                    url: api + '/MarkAsExported'
                },
                markAsExportedForGroup: {
                    method: "POST",
                    url: api + '/MarkAsExportedForGroup'
                },
                getUnitSuppliers: {
                    method: "GET",
                    url: api + '/GetUnitSuppliers',
                    params: {
                        id: '@id',
                        organisationId: '@organisationId'
                    },
                    isArray: true
                },
                getUnitSuppliersForGroup: {
                    method: "GET",
                    url: api + '/GetUnitSuppliersForGroup',
                    params: {
                        organisationId: '@organisationId'
                    },
                    isArray: true
                },
                getTransmissionMethodsForUnit: {
                    method: "GET",
                    url: api + '/GetTransmissionMethodsForUnit',
                    params: {
                        id: '@id',
                        organisationId: '@organisationId'
                    },
                    isArray: true
                },
                deleteDraftInvoice: {
                    method: "DELETE",
                    url: api + '/DeleteDraftInvoice',
                    params: {
                        id:'@id'
                    }
                },
                getTransmissionMethodsForGroup: {
                    method: "GET",
                    url: api + '/GetTransmissionMethodsForGroup',
                    params: {
                        id: '@id',
                        organisationId: '@organisationId'
                    },
                    isArray: true
                }
            });
        }
    ]);
'use strict';
angular.module(appName).controller('invoicesController', [
    '$scope', 'invoiceService', 'clientConfigurationService', '$location', 'localStorageService', 'paginationFactory',
    'validationHelper', 'organisationContextService', 'fileDownloadService', '$translate',
    'isGroupClient', 'enums', 'userService', 'translateMessage',
    function ( $scope, invoiceService, clientConfigurationService, $location, localStorageService, paginationFactory,
        validationHelper, organisationContextService, fileDownloadService, $translate,
        isGroupClient, enums, userService, translateMessage
    ) {
        var self = this;
        self.hasInvoiceResetPermission = false;
        self.hasGroupInvoiceResetPermission = false;
        self.hasViewReconciledInvoicesPermission = false;
        self.hasReconcileInvoicesPermission = false;

        paginationFactory.addPaginationVariablesAndFunctionsToScope($scope);
        $scope.pagination.numPerPage = 10;
        $scope.statusData = [
          { statusId: enums.invoiceStatus.Draft, 'class': 'draft', translationKey: 'Draft', text: 'Draft'},
          { statusId: enums.invoiceStatus.Imported, 'class': 'draft', translationKey: 'label_imported', text: 'Imported', checkbox: false },
          { statusId: enums.invoiceStatus.AwaitingAcceptance, 'class': 'draft', translationKey: 'label_awaiting', text: 'AwaitingApproval', model: 'showAwaiting', checkbox: true, order: 3 },
          { statusId: enums.invoiceStatus.Accepted, 'class': 'warning', translationKey: 'label_accepted', text: 'Accepted', model: 'showAccepted', checkbox: true, order: 1 },
          { statusId: enums.invoiceStatus.Rejected, 'class': 'danger', translationKey: 'label_rejected', text: 'Rejected', model: 'showRejected', checkbox: true, order: 2 },
          { statusId: enums.invoiceStatus.Exported, 'class': 'success', translationKey: 'label_exported', text: 'Exported', model: 'showExported', checkbox: true, order: 4 },
          { statusId: enums.invoiceStatus.PartReconciled, 'class': 'info', translationKey: 'label_part_reconciled', text: 'PartReconciled', model: 'showPartReconciled', checkbox: true, order: 5 },
          { statusId: enums.invoiceStatus.Reconciled, 'class': 'info', translationKey: 'label_reconciled', text: 'Reconciled', model: 'showReconciled', checkbox: true, order: 6 },
          { statusId: enums.invoiceStatus.AwaitingCredit, 'class': 'info', translationKey: 'label_awaiting_credit', text: 'AwaitingCredit', model: 'showAwaitingCredit', checkbox: true, order: 7 }
        ];

        $scope.getInvoiceStatusTranslationKey = function (invoice) {
            var status = _.findWhere($scope.statusData, { statusId: invoice.procurementInvoiceStatusId });
            return { translationKey: status.translationKey, 'class': status.class}
        }

        self.validateRejection = function (invoice) {
            var isValid = (typeof(invoice.creditAmountRequired) != 'undefined' || invoice.creditAmountRequired == 0) && typeof(invoice.notes) != 'undefined';
            return isValid;
        };

        $scope._ = _;
        $scope.enums = enums;
        $scope.moment = moment;

        $scope.formatDate = function (date) {
            return moment(date).format('DD/MM/YYYY');
        };


        // Maps fields on the PagedListDto returned by the search to differently named ones
        // on the ProcurementInvoiceDto passed to the Update method
        // Sets the procurement invoice header id, status id, and org id
        self.prepareInvoiceForUpdate = function (invoice, newStatusId) {
            invoice.procurementInvoiceHeaderId = invoice.id;
            invoice.status = newStatusId;
            if (isGroupClient) {
                invoice.organisationId = self.context.organisation.id;
            } else {
                invoice.organisationId = self.context.currentSubscriptionUnit.organisation.id;
            }
        };

        $scope.canResetInvoice = function (invoice) {
            var hasResetPermission =
                (isGroupClient && self.hasGroupInvoiceResetPermission) ||
                    (!isGroupClient && self.hasInvoiceResetPermission);
            return hasResetPermission &&
                (invoice.status === 3 || invoice.status === 4);
        }

        $scope.reset = function (invoice) {
            if ($scope.canResetInvoice(invoice)) {
                var copy = angular.copy(invoice);
                var previousInvoiceStatus = invoice.status;
                self.prepareInvoiceForUpdate(copy, enums.invoiceStatus.AwaitingAcceptance);
                invoice.saving = true;
                invoiceService.updateStatus(copy, isGroupClient).$promise.then(function(data) {
                        invoice.icon = _.find($scope.statusData, { statusId: data.status });
                        invoice.promptAreYouSure = false;
                        invoice.saving = false;
                        invoice.status = data.status;
                        translateMessage.success('invoice_reset_to_awaiting_approval');
                    },
                    function(err) {
                        invoice.status = previousInvoiceStatus;
                        $scope.areYouSure(invoice);
                    });
            }
        };

        $scope.accept = function (invoice) {
            if (invoice.id) {
                var copy = angular.copy(invoice);
                var previousInvoiceStatus = invoice.status;
                self.prepareInvoiceForUpdate(copy, enums.invoiceStatus.Accepted);
                invoice.saving = true;
                invoiceService.updateStatus(copy, isGroupClient).$promise.then(function (data) {
                    invoice.icon = _.find($scope.statusData, { statusId: data.status });
                    invoice.saving = false;
                    invoice.status = data.status;
                    translateMessage.success('invoice_accepted');
                }, function (err) {
                    invoice.saving = false;
                    invoice.status = previousInvoiceStatus;
                    $scope.areYouSure(invoice);
                    console.error(err);
                });
            } else {
                translateMessage.error('invoice_not_found_please_try_again');
            }
        };
        $scope.reject = function (invoice) {
            if (self.validateRejection(invoice)) {
                var previousInvoiceStatus = invoice.status;
                var copy = angular.copy(invoice);
                self.prepareInvoiceForUpdate(copy, enums.invoiceStatus.Rejected);
                invoice.saving = true;
                invoiceService.updateStatus(copy, isGroupClient).$promise.then(function (data) {
                    invoice.icon = _.find($scope.statusData, { statusId: data.status });
                    invoice.saving = false;
                    translateMessage.success('invoice_rejected');
                    invoice.status = data.status;
                    $scope.toggleRejection(invoice);
                }, function (err) {
                    invoice.status = previousInvoiceStatus;
                    invoice.saving = false;
                    $scope.areYouSure(invoice);
                });
            } else {
                translateMessage.error('please_enter_a_credit_amount_and_a_rejection_reason');
            }
        };
        $scope.toggleRejection = function (invoice) {
            invoice.rejecting = !invoice.rejecting;
        };
        $scope.acceptAllSelected = function (selectedInvoices) {
            _.each(selectedInvoices, function (invoice) {
                invoice.status = 3;
                invoice.icon = _.find($scope.statusData, { statusId: invoice.status });
                invoice.procurementInvoiceHeaderId = invoice.id;
            });
            var dto = {};
            dto.procurementInvoiceDto = selectedInvoices;
            if (isGroupClient) {
                dto.organisationId = self.context.organisation.id;
            } else {
                dto.organisationId = self.context.currentSubscriptionUnit.organisation.id;
            }
            invoiceService.acceptAllSelected(dto, isGroupClient).$promise.then(function (data) {
                translateMessage.success('invoices_accepted');
            });
            $scope.selectedInvoices = [];
        };
        $scope.view = function (invoice) {
            var url = '/ViewGroupInvoice/' + invoice.id;
            $location.path(url);
        };

        $scope.isSelectable = function(invoice) {
            return invoice.status == enums.invoiceStatus.Imported ||
                invoice.status == enums.invoiceStatus.AwaitingAcceptance;
        }
        $scope.setSelected = function (invoice) {
            var selectedInvoice = _.find($scope.selectedInvoices, { id: invoice.id });
            if (!selectedInvoice) {
                $scope.selectedInvoices.push(invoice);
            } else {
                $scope.selectedInvoices = _.without($scope.selectedInvoices, selectedInvoice);
            }
        };
        $scope.setAllSelected = function () {
            _.chain($scope.invoices)
                .filter(function(inv) { return $scope.isSelectable(inv); })
                .each(function(invoice) {
                    var selectedInvoice = _.find($scope.selectedInvoices, { id: invoice.id });
                    if (!selectedInvoice) {
                        invoice.selected = true;
                        $scope.selectedInvoices.push(invoice);
                    }
                });

        };
        $scope.setAllDeselected = function () {
            _.each($scope.invoices,
              function (invoice) {
                  var selectedInvoice = _.find($scope.selectedInvoices, { id: invoice.id });
                  if (selectedInvoice) {
                      invoice.selected = false;
                      $scope.selectedInvoices = _.without($scope.selectedInvoices, selectedInvoice);
                  }
              });

        };

        $scope.areYouSure = function (invoice, mode) {
            invoice.promptAreYouSure = !invoice.promptAreYouSure;
            invoice.areYouSureMode = invoice.promptAreYouSure ? mode : null;
        };
        $scope.isValidEndDate = function (searchCriteria) {
            $scope.invalidEndDate = validationHelper.startDateLaterThanEndDate(searchCriteria.startDate, searchCriteria.endDate);
        }; //Pagination variables
        $scope.filter = {};

        self.makeSearchParams = function (paginate) {
            var sortOn = $scope.sortOn;
            var sortCol = sortOn ? sortOn.column : 'InvoiceDate';
            var sortDirection = sortOn ? sortOn.sortState === 'Ascending' ? true : false : true;
            $scope.pagination.currentPage = paginate ? $scope.pagination.currentPage : 1;

            $scope.searchCriteria = {
                organisationId: isGroupClient ? self.context.organisation.id : self.context.currentSubscriptionUnit.organisation.id,
                term: $scope.searchCriteria != null ? $scope.searchCriteria.term : '' || '',
                currentPage: $scope.pagination.currentPage,
                numPerPage: $scope.pagination.numPerPage,
                sortField: sortCol,
                sortAsc: sortDirection,
                paginate: paginate,
                showAccepted: $scope.searchCriteria != null ? $scope.searchCriteria.showAccepted : true,
                showRejected: $scope.searchCriteria != null ? $scope.searchCriteria.showRejected : true,
                showAwaiting: $scope.searchCriteria != null ? $scope.searchCriteria.showAwaiting : true,
                showExported: $scope.searchCriteria != null ? $scope.searchCriteria.showExported : false,
                showPartReconciled: $scope.searchCriteria != null ? $scope.searchCriteria.showPartReconciled : false,
                showReconciled: $scope.searchCriteria != null ? $scope.searchCriteria.showReconciled : false,
                showAwaitingCredit: $scope.searchCriteria != null ? $scope.searchCriteria.showAwaitingCredit : false,
                startDate: $scope.searchCriteria != null ? $scope.searchCriteria.startDate : '' || '',
                endDate: $scope.searchCriteria != null ? $scope.searchCriteria.endDate : '' || ''
            };
            if (!$scope.searchCriteria.startDate) $scope.searchCriteria.startDate = '';
            if (!$scope.searchCriteria.endDate) $scope.searchCriteria.endDate = '';

            return $scope.searchCriteria;
        };

        self.updatePagination = function (data) {
            $scope.pagination.total = data.total;
            $scope.model.supplierServiceLevels = data.list;
            $scope.numPages();
        };
        self.setupFilter = function (query) {
            $scope.filter.term = query.term;
        };
        //pagination variables End

        $scope.export = function () {
            var structure = [
                'id', 'organisationId', 'term', 'startDate', 'endDate', 'sortField', 'sortAsc',
                'showAccepted', 'showRejected', 'showAwaiting', 'showExported', 'showPartReconciled',
                'showReconciled','showAwaitingCredit'
            ];

            //attach Id for IBelongTo
            $scope.searchCriteria.id = isGroupClient ?
                self.context.id :
                self.context.currentSubscriptionUnit.id;

            var searchString = invoiceService.getSearchStringWithDefinedStructure($scope.searchCriteria, structure);
            var url = isGroupClient ?
                '/api/invoice/exportsearchForGroup?' :
                '/api/invoice/exportsearch?';

            fileDownloadService.downloadFile(
                url + searchString,
                'Exported-Invoice-search.csv',
                'csv'
            );
        };


        $scope.search = function (resetPage) {
            if (resetPage) {
                $scope.pagination.currentPage = 1;
                $scope.selectedInvoices = [];
            }
            $scope.searching = true;
            $scope.noResults = false;
            $scope.showSelectAllDeselectAll = false;
            $scope.searchCriteria = self.makeSearchParams(true);

            //attach Id for IBelongTo
            if (isGroupClient) {
                $scope.searchCriteria.id = self.context.id;
            } else
            {
                $scope.searchCriteria.id = self.context.currentSubscriptionUnit.id;
            }

            invoiceService.search($scope.searchCriteria, isGroupClient).$promise.then(function (data) {
                if (!data || data.list.length === 0) {
                    $scope.noResults = true;
                    $scope.invoices = [];
                } else {
                    $scope.pagination.total = data.total;
                    $scope.invoices = data.list;

                    _.each($scope.invoices,
                      function (invoice) {
                          invoice.status = invoice.procurementInvoiceStatusId;
                          var selectedInvoice = _.find($scope.selectedInvoices, { id: invoice.id });
                          if (selectedInvoice) {
                              invoice.selected = true;
                          } else {
                              invoice.selected = false;
                          }
                          invoice.rejecting = false;
                          if (invoice.status === 1 || invoice.status === 2) {
                              $scope.showSelectAllDeselectAll = true;
                          }
                          invoice.icon = _.find($scope.statusData, { statusId: invoice.status });
                      });
                }
                $scope.searching = false;
                localStorageService.setItem('invoiceSearchUnitFilters', $scope.searchCriteria);
            });
        };

        $scope.$on(enums.eventNames.sortOnElementChangedEventName, function (event, changingElement) {
            if (event.targetScope === $scope) {
                $scope.search();
            };
        });

        $scope.generateViewInvoiceUrl = function (invoiceHeader) {
            var url = '/View' + self.groupOrUnit + 'Invoice/' + self.context.id + '/' + invoiceHeader.id;
            return url;
        }

        $scope.canReconcileInvoices = function (invoice) {
            var hasCorrectPermission = invoice.isCreditNote
                ? self.hasReconcileCreditNotePermission
                : self.hasReconcileInvoicesPermission;
            if (hasCorrectPermission) {
                return !invoice.promptAreYouSure && invoice.status == enums.invoiceStatus.Imported ||
                invoice.status == enums.invoiceStatus.AwaitingAcceptance ||
                    invoice.status == enums.invoiceStatus.PartReconciled;
            } else {
                return false;
            }
        }
        $scope.deleteDraftInvoice = function(invoice) {
            invoiceService.deleteDraftInvoice(invoice.id, function(data){
                if (data != null) {
                    $scope.invoices = _.without($scope.invoices,
                        _.find($scope.invoices,
                            function(invoice) {
                                return invoice.id == data.id;
                            }));
                }
            });
        }

        $scope.canViewReconciledInvoices = function (invoice) {
            var hasViewPermission = invoice.isCreditNote
                ? self.hasViewReconciledCreditNotesPermission
                : self.hasViewReconciledInvoicesPermission;

            var hasReconcilePermission = invoice.isCreditNote
                ? self.hasReconcileCreditNotePermission
                : self.hasReconcileInvoicesPermission;
            if (hasViewPermission || hasReconcilePermission) {
                return !invoice.promptAreYouSure && invoice.status == enums.invoiceStatus.Exported ||
                    invoice.status == enums.invoiceStatus.Accepted ||
                    invoice.status == enums.invoiceStatus.Reconciled ||
                    invoice.status == enums.invoiceStatus.AwaitingCredit;
            } else {
                return false;
            }
        }

        $scope.init = function () {
            $scope.selectedInvoices = [];
            self.context = organisationContextService.getContext();
            $scope.procurementSubscriptionUnitId = self.context.id;
            self.groupOrUnit = isGroupClient ? 'Group' : 'Unit';
            $scope.groupOrUnit = self.groupOrUnit;
            $scope.noResults = false;
            $scope.selectAllAreYouSure = false;
            var storedSearchContext = localStorageService.getItem('invoiceSearchUnitFilters');
            if (storedSearchContext) {
                $scope.searchCriteria = storedSearchContext;
                $scope.pagination.currentPage = $scope.searchCriteria.currentPage;
            } else {
                $scope.searchCriteria = self.makeSearchParams(true);
                $scope.noResults = false;
            }

            var organisationId = isGroupClient
                ? self.context.organisation.id
                : self.context.currentSubscriptionUnit.organisation.id;

            clientConfigurationService.getPurchasingModelConfiguration(organisationId).then(function(config) {
                $scope.purchasingModelClientConfig = config.configValue;
            });

            if (!isGroupClient) {
                userService.hasPermission('BEAGLE_INVOICES_RESET', false).then(function() {
                    self.hasInvoiceResetPermission = true;
                });
            }

            if (isGroupClient) {
                userService.hasPermission('BEAGLE_GROUPINVOICES_RESET', false).then(function() {
                    self.hasGroupInvoiceResetPermission = true;
                });
            }

            userService.hasPermission('BEAGLE_CAN_VIEW_RECONCILED_INVOICES').then(function () {
                self.hasViewReconciledInvoicesPermission = true;
            });

            userService.hasPermission('BEAGLE_CAN_RECONCILE_INVOICES').then(function () {
                self.hasReconcileInvoicesPermission = true;
            });

            userService.hasPermission('BEAGLE_CAN_VIEW_RECONCILED_CREDIT_NOTES').then(function () {
                self.hasViewReconciledCreditNotesPermission = true;
            });

            userService.hasPermission('BEAGLE_CAN_DELETE_DRAFT_INVOICES').then(function () {
                $scope.hasDeleteDraftInvoicePermission = true;
            });

            userService.hasPermission('BEAGLE_CAN_RECONCILE_CREDIT_NOTES').then(function () {
                self.hasReconcileCreditNotePermission = true;
            });

            $translate('error_invoice_notes_required').then(function (translation) {
                $scope.error_invoice_notes_required = translation;
            });

            $scope.$watchGroup(['pagination.currentPage + pagination.numPerPage'],
              function () {
                  if ($scope.pagination &&
                    $scope.pagination.currentPage &&
                    $scope.pagination.numPerPage) {
                      $scope.search();
                  }
                });
        }();
    }
  ]);
angular.module(appName)
    .factory('invoiceService', [
		'invoiceResource',
		'$window',
		'organisationContextService',
		'$http',
		'siteUrl',
        function (invoiceResource, $window, organisationContextService, $http, siteUrl) {
            var self = this;
            self.context = organisationContextService.getContext();
            self.getSearchString = function (obj) {
                var searchString = "";
                _.each(_.allKeys(obj), function (prop) {
                    searchString += prop;
                    searchString += '=';
                    searchString += encodeURIComponent(_.propertyOf(obj)(prop));
                    // searchString += _.propertyOf(obj)(prop);
                    if (prop != _.last(_.allKeys(obj))) {
                        searchString += '&';
                    }
                });
                return searchString;
            }

            return {
                getTransmissionMethods: function (organisationId, isGroupClient) {
                    if (isGroupClient) {
                        return invoiceResource.getTransmissionMethodsForUnit({ id: self.context.currentSubscriptionUnit.id, organisationId: organisationId });
                    } else {
                        return invoiceResource.getTransmissionMethodsForGroup({ organisationId: organisationId });
                    }
                },
                getInvoices: function (model, cb) {
                    return invoiceResource.getInvoices(model).$promise.then(cb);
                },
                search: function (model, isGroupClient) {
                    if (isGroupClient) {
                        return invoiceResource.searchForGroup(model);
                    }
                    else {
                        return invoiceResource.search(model);
                    }
                },
                updateStatus: function (model, isGroupClient) {
                    if (isGroupClient) {
                        return invoiceResource.updateStatusForGroup(model);
                    } else {
                        return invoiceResource.updateStatus(model);
                    }
                },
				updateStatusWithoutDto: function (request) {
					return invoiceResource.updateStatusWithoutDto(request).$promise;
				},
                acceptAllSelected: function (invoices, isGroupClient, cb) {
                    if (isGroupClient) {
                        return invoiceResource.acceptAllSelectedForGroup(invoices);
                    } else {
                        return invoiceResource.acceptAllSelected(invoices);
                    }

                },
                deleteDraftInvoice: function (invoiceId, cb) {
                    return invoiceResource.deleteDraftInvoice({ id: invoiceId }).$promise.then(cb);
                },
                getInvoiceById: function (procurementSubscriptionId, invoiceHeaderId, cb) {
                    return invoiceResource.getInvoiceById({ id: procurementSubscriptionId, invoiceHeaderId: invoiceHeaderId }).$promise.then(cb);
                },
                getSearchString: function (obj) {
                    return self.getSearchString(_.allKeys(obj));
                },
                getSearchStringWithDefinedStructure: function (obj, structure) {
                    var obj = _.pick(obj,
                        _.intersection(structure, _.allKeys(obj)));
                    return self.getSearchString(obj);
                },
                exportSearch: function (params) {
                    $window.open('/api/invoice/exportsearch?' + params);
                },
                exportInvoices: function (params) {
                    $window.open('/api/invoice/exportinvoices?' + params);
                },
                exportSearchForGroup: function (params) {
                    $window.open('/api/invoice/exportsearchForGroup?' + params);
                },
                exportInvoicesForGroup: function (params) {
                    $window.open('/api/invoice/exportinvoicesForGroup?' + params);
                },
                getUnitSuppliers: function (organisationId) {
                    var procurementSubscriptionUnitId = self.context.currentSubscriptionUnit.id;
                    return invoiceResource.getUnitSuppliers({ organisationId: organisationId, id: procurementSubscriptionUnitId });
                },
                getUnitSuppliersForGroup: function (organisationId, procurementSubscriptionId) {
                    return invoiceResource.getUnitSuppliersForGroup({ organisationId: organisationId });
                },
                getAvailableClientSupplierAccounts: function () {
                    var clientId = self.context.currentSubscriptionUnit.client.id;
                    return $http.get(siteUrl() + 'api/client/' + clientId + '/client-supplier-accounts');
                },
                getAvailableClientSupplierAccountsForGroup: function () {
                    var clientId = self.context.currentSubscriptionUnit.client.id;
                    return $http.get(siteUrl() + 'api/client/' + clientId + '/parent/client-supplier-accounts');
                },
                getExportFormats: function (organisationId, isGroupClient) {
                    if (isGroupClient) {
                        return invoiceResource.getExportFormatsForGroup({ organisationId: organisationId });
                    } else {

                        return invoiceResource.getExportFormatsForUnit({ id: self.context.currentSubscriptionUnit.id, organisationId: organisationId });
                    }
                },
                getIsMarriott: function (organisationId) {
                    return invoiceResource.getIsMarriott({ organisationId: organisationId });
                },
                getExportedFile: function (organisationId, documentId) {
                    return invoiceResource.getExportedFile({ organisationId: organisationId, documentId: documentId });
                },
                export: function (organisationId, pipeline, from, to, supplierId, isGroupClient,pipelineId) {
                    var dto = {
                        transmissionExportFormatDto: {
                            organisationId: organisationId,
                            pipelinename: pipeline,
                            startDate: from,
                            endDate: to,
                            supplierId: supplierId,
                            isGroupClient: isGroupClient,
                            pipelineId:pipelineId
                        }
                    }

                    if (isGroupClient) {
                        dto.organisationId = organisationId;
                        
                        return invoiceResource.exportForGroup(dto);
                    } else {
                        dto.id = self.context.currentSubscriptionUnit.id;
                        return invoiceResource.exportForUnit(dto);
                    };
                },
                markAsExported: function (invoiceHeader, isGroupClient) {
                    if (isGroupClient) {
                        invoiceHeader.organisationId = self.context.organisation.id;
                        return invoiceResource.markAsExportedForGroup(invoiceHeader);
                    } else {
                        invoiceHeader.id = self.context.currentSubscriptionUnit.id;
                        return invoiceResource.markAsExported(invoiceHeader);
                    }

                },
                saveInvoice: function (invoice) {
                    return $http.post(siteUrl() + 'api/invoice', invoice);
                },
                submitInvoice: function (invoice) {
                    return $http.post(siteUrl() + 'api/invoice/submitted', invoice);
                },
                get: function () {
                    return [{
                        id: "6EE1B011-8A37-44C7-A14F-A475AD942698",
                        invoiceNumber: "28012017ABC",
                        supplierName: "3663 Bidvest Catering Equipment",
                        invoiceDate: "15/01/2017",
                        invoiceGrossAmount: 75.25,
                        invoiceNetAmount: 72.25,
                        status: 3
                    },
                    {
                        id: "8F5E684C-1280-439B-981B-93F7DB0C661C",
                        invoiceNumber: "15012017DEF",
                        supplierName: "Fairfax Meadow",
                        invoiceDate: "23/01/2017",
                        invoiceGrossAmount: 110.00,
                        invoiceNetAmount: 108.79,
                        status: 4
                    },
                    {
                        id: "8DA1F356-394B-4C41-A310-16BF5A3BBF09",
                        invoiceNumber: "23012017GHI",
                        supplierName: "Harvey & Brockless Limited",
                        invoiceDate: "28/01/2017",
                        invoiceGrossAmount: 149.99,
                        invoiceNetAmount: 149.99,
                        status: 5
                    },
                    {
                        id: "ANOTHERID",
                        invoiceNumber: "01022017JKL",
                        supplierName: "Reynolds Catering Ltd",
                        invoiceDate: "01/02/2017",
                        invoiceGrossAmount: 286.56,
                        invoiceNetAmount: 286.56,
                        status: 2
                    },
                    {
                        id: "RITTERINVOICE",
                        invoiceNumber: "01022017MNO",
                        supplierName: "Ritter Courivaud Ltd",
                        invoiceDate: "01/02/2017",
                        invoiceGrossAmount: 212.98,
                        invoiceNetAmount: 211.96,
                        status: 2
                    }]
                }
            }
        }
    ]);
angular.module(appName)
	.directive("rejectInvoice",
		[
			function () {

				return {
					restrict: "E",
					scope: {
						ngModel: "="
					},
					controller: ['$scope',
						'cdbAreYouSureService',
						'$translate',
						'enums',
						'invoiceService',
						function ($scope, cdbAreYouSureService, $translate, enums, invoiceService) {

							var rejectStatus = enums.invoiceStatus.Rejected

							$scope.submitForm = function () {
								cdbAreYouSureService($translate.instant('are_you_sure_you_want_to_reject_this_invoice')).then(function () {
									var request = {
										procurementInvoiceHeaderId: $scope.ngModel,
										statusId: rejectStatus,
										rejectReason: $scope.form.notes,
										creditAmountRequired: $scope.form.creditAmountRequired
									}
									$scope.rejectingInvoice = true;
									invoiceService.updateStatusWithoutDto(request).then(function () {
										toastr.error($translate.instant('invoice_rejected'));
										$scope.$emit('reject-invoice-directive-invoice-rejected', $scope.ngModel);
									}).finally(function () {
										$scope.rejectingInvoice = false;
									});
								});
							}
					}],
					templateUrl: "/ngxbeagle/dist/Content/js/Modules/Invoices/reject-invoice-directive.html",
				};
			}
		]);

angular.module(appName)
    .controller("loginController", [
        "$scope", "$rootScope", "oidcManager", "localStorageService", "enums", "myUnitsService", "languageService",
        function($scope, $rootScope, oidcManager, localStorageService, enums, myUnitsService, languageService) {
            var mgr = oidcManager.UserManager();
            var company = window.isEntegra ? 'entegra' : 'psl';
            var jsLanguage = languageService.getBrowserLanguage();
            var language =  languageService.convertToLanguageEnum(jsLanguage);
            
            $scope.login = function signIn() {
                //clear down any old oidc sessions from previous logins
                for (var i = 0, len = localStorage.length; i < len; ++i) {
                    console.log(localStorage.getItem(localStorage.key(i)));
                    var key = localStorage.key(i);
                    if (key !== null && key.startsWith("oidc")) {
                        console.log("removing item: ", key);
                        localStorage.removeItem(key);
                    }
                }

                mgr.signinRedirect({ scope: null, response_type: null, acr_values: [company, language] }).then(null, function(e) {
                    console.log(e);
                });
            };

            $scope.logout = function() {
                mgr.signoutRedirect();
            };

            $scope.user;
            mgr.events.addUserLoaded(function(u) {
                $scope.user = u;
                console.log("user loaded");
                showUser(user);
            });

            mgr.events.addUserUnloaded(function() {
                $scope.user = null;
                localStorageService.removeItem(enums.localStorage.organisationContext);
                console.log("user unloaded");
                showUser();
            });

            mgr.events.addAccessTokenExpiring(function() {
                console.log("token expiring");
                showUser(user);
            });

            mgr.events.addAccessTokenExpired(function() {
                localStorageService.removeItem(enums.localStorage.organisationContext);
                console.log("token expired");
                showUser(user);
            });

            mgr.events.addSilentRenewError(function(e) {
                console.log("silent renew error", e.message);
            });

            mgr.events.addUserSignedOut(function() {
                console.log("user signed out");
            });

            function signInCallback() {
                mgr.signinRedirectCallback().then(function(user) {
                    $scope.user = user;
                    var hash = window.location.hash.substr(1);
                    var result = hash.split("&").reduce(function(result, item) {
                        var parts = item.split("=");
                        result[parts[0]] = parts[1];
                        return result;
                    }, {});
                    console.log("signin callback", result);
                }).catch(function(error) {
                    console.log(error);
                });
            }

            // clears any old stale requests from storage
            //mgr.clearStaleState().then(function () {
            //    console.log("Finished clearing old state");
            //}).catch(function (e) {
            //    console.error("Error clearing state:", e.message);
            //});

            // checks to see if we already have a logged in user
            mgr.getUser().then(function(user) {
                showUser(user);
            }).catch(function(e) {
                console.log(e);
            });

            //Check to see if we have a token
            //TODO if token has expired
            var token = localStorage.getItem("access_token");
            if (token === null) {
                $scope.login();
            }

            var tokenExpiry = localStorage.getItem("token_expires");
            if (tokenExpiry < new Date().toString()) {
                mgr.events.addAccessTokenExpired();
            }

            var init = function() {
                // checks to see if the page being loaded looks like a login callback
                if (window.location.hash) {
                    signInCallback();
                } else {
                    mgr.getUser().then(function (u) {
                        if (u === null) {
                            $scope.login();
                        } else {
                            myUnitsService.getTheme();
                        }
                    });
                }
            };
            init();

            function showUser() {

            };

            //console.log('getToken', loginService.getToken());
            //alert('calling STS');
            //if (loginService.getToken() === null) {
            //    var url =
            //        "https://localhost:44300/core/connect/authorize?" +
            //        "client_id=" + appName + "&" +
            //        "redirect_uri=" + encodeURI(window.location.protocol + "//" + window.location.host + "/callback.html") + "&" +
            //        "response_type=token&" +
            //        "scope=beagle";

            //    window.location = url;
            //}
        }
    ]);
angular.module(appName)
    .factory("loginService", [
        function () {
            var service = {
                getToken: function () {
                    return localStorage.getItem('access_token');
                },
                setToken: function (token) {
                    localStorage.setItem('access_token', token);
                }
            };

            return service;
        }
    ]);
angular.module(appName)
    .controller("logoutController", [
      "oidcManager", "localStorageService",
        function (oidcManager, localStorageService) {
          var _userManager = oidcManager.UserManager();
          localStorageService.clear();
          _userManager.signoutRedirect();
        }
    ]);
angular.module(appName)
  .controller("manageDataController", [
    function() {

    }
  ]);
angular.module(appName).filter("startFrom",
    function() {
        return function(input, start) {
            if (input) {
                start = +start; //parse to int
                return input.slice(start);
            }
            return [];
        };
    });

angular.module(appName)
    .controller("menuUrlsListController",
        [
            "$scope", "menusService", "$q", "$translate", "menuUrlsService", "$window", "_", "menuUrlData",
            "clientPreferencesData", "localStorageService", "enums", "languages",
            function($scope,
                menusService,
                $q,
                $translate,
                menuUrlsService,
                $window,
                _,
                menuUrlData,
                clientPreferencesData,
                localStorageService,
                enums,
                languages) {
                var self = this;
                self.resolves = {
                    menuUrlData: menuUrlData,
                    clientPreferencesData: clientPreferencesData
                };

                self.getPreference = function(key) {
                    var pref = _.findWhere(self.clientSystemPreferences, { key: key });
                    return pref != null ? pref.value : null;
                };

                self.searchData = localStorageService.getItem(enums.localStorage.manageUrlsSearch);

                $scope.createNewMenuUrlLink = "/ManageUrls/View/";
                $scope.pager = {};
                $scope.filter = {
                    searchTerm: self.searchData ? self.searchData.searchTerm : ""
                };
                $scope.languages = languages;

                $q.all(self.resolves).then(function(resolved) {
                    var rootUrl = $window.urls.menus;
                    $scope.menuUrls = resolved.menuUrlData.data.list;
                    self.clientSystemPreferences = resolved.clientPreferencesData.systemPreferences;
                    self.menuUrls = angular.copy($scope.menuUrls);

                    $scope.getFullLink = function(menuUrl) {
                        return rootUrl +
                            "/" +
                            self.getPreference(enums.clientPreferences.customerPortalUrl) +
                            "/" +
                            menuUrl.url;
                    };

                    $scope.clearSearch = function() {
                        $scope.filter.searchTerm = "";
                        $scope.searchUrls();
                    };

                    $scope.searchUrls = function() {
                        localStorageService.setItem(enums.localStorage.manageUrlsSearch, $scope.filter);
                        $scope.menuUrls = _.filter(self.menuUrls,
                            function(url) {
                                if ($scope.filter.searchTerm != "") {
                                    return url.name.toLowerCase().indexOf($scope.filter.searchTerm.toLowerCase()) > -1;
                                } else {
                                    return true;
                                }
                            });
                    };

                    var deleteMenuMessage;
                    $scope.deleteMenuUrl = function(m) {
                        m.isDeleting = true;
                        menuUrlsService.deleteMenuUrl(m.menuUrlId).then(function() {
                            toastr.success(deleteMenuMessage);
                            m.isDeleting = false;
                            _.removeIfExists($scope.menuUrls, m);
                            _.removeIfExists(self.menuUrls, m);
                        });
                    };

                    var init = function() {

                        $q.all($translate("you_havent_defined_any_menus_yet_please_"),
                            $translate("create_a_menu_or_function"),
                            $translate("before_creating_a_menu_url"),
                            $translate("url_deleted")).then(function(results) {
                            $scope.addUrlDisabledPromptHtml =
                                result[0] +
                                "<a style='text-decoration:underline;' href='/Menu'>" +
                                result[1] +
                                "</a> " +
                                result[2];
                            deleteMenuMessage = result[3];

                        });

                        $scope.searchUrls();
                    }();
                });
            }
        ]);
angular.module(appName)
    .factory('menusUrlsResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/Menu';

            return $resource(api, {},
                {
                    addMenuUrl: {
                        url: api + '/AddMenuUrl',
                        method: 'POST'
                    },
                    deleteMenuUrl: {
                        url: api + '/DeleteMenuUrl',
                        method: 'DELETE'
                    },
                    getMenuUrl: {
                        url: api + '/GetMenuUrl',
                        method: 'GET'
                    },
                    updateMenuUrl: {
                        url: api + '/UpdateMenuUrl',
                        method: 'PUT'
                    }
                });
        }
    ])
angular.module(appName)
	.factory("menuUrlsService",
		[
            "$http", "siteUrl", "organisationContextService", "menusUrlsResource",
            function ($http, siteUrl, organisationContextService, menusUrlsResource) {

                var baseUrl = siteUrl();
				var ctx = organisationContextService.getContext();
                var currentSubscriptionUnitClientId = ctx.currentSubscriptionUnit.client.id;
                var defaultSearchParams = {
                    searchTerm: '',
                    numPerPage: 10,
                    currentPage: 1
                }

                var getDefaultSearchParams = function() {
                    return angular.copy(defaultSearchParams);
                }

				var getMenuUrls = function() {
					var params = {
						term: "",
                        numPerPage: 100000,
						currentPage: 1,
						id: currentSubscriptionUnitClientId
					};
					return $http.get(baseUrl + "api/menu/menuurl/search", {params:params});
				};

				var addUpdateMenuUrl = function(dto) {
					dto.clientId = currentSubscriptionUnitClientId;
					if (dto.menuUrlId) {
                        return menusUrlsResource.updateMenuUrl(dto).$promise;
					}
                    return menusUrlsResource.addMenuUrl(dto).$promise;
				}

				var getMenuUrl = function(id) {
					var params = {
						id: currentSubscriptionUnitClientId,
						menuUrlId: id
					}
                    return menusUrlsResource.getMenuUrl(params).$promise;
				}

				var deleteMenuUrl = function (id) {
					var params = {
						id: currentSubscriptionUnitClientId,
						menuUrlId: id
					}
                    return menusUrlsResource.deleteMenuUrl(params).$promise;
				}

                return {
                    getDefaultSearchParams: getDefaultSearchParams,
					getMenuUrls: getMenuUrls,
					addUpdateMenuUrl: addUpdateMenuUrl,
					getMenuUrl: getMenuUrl,
					deleteMenuUrl: deleteMenuUrl
				};
			}
		]);
angular.module(appName)
    .controller("viewEditMenuUrlController", [
        "$scope",
        "$window",
        "clipboard",
        "$translate",
        "menusService",
        "$rootScope",
        "$timeout",
        "menuUrlsService",
        "$routeParams",
        "$q",
        "$location",
        "menuUrlData",
        "userLanguageData",
        "languages",
        "clientPreferences",
        "enums",
        "cdbAreYouSureService",
        function (
            $scope,
            $window,
            clipboard,
            $translate,
            menusService,
            $rootScope,
            $timeout,
            menuUrlsService,
            $routeParams,
            $q,
            $location,
            menuUrlData,
            userLanguageData,
            languages,
            clientPreferences,
            enums,
            cdbAreYouSureService
        ) {
            var self = this;
            self.resolves = {
                menuUrlData: menuUrlData,
                clientPreferences: clientPreferences
            };

            self.getPreference = function (key) {
                var pref = _.findWhere(self.clientSystemPreferences, { key: key });
                return pref != null ? pref.value : null;
            };

            $q.all(self.resolves).then(function (resolved) {
                self.clientSystemPreferences = resolved.clientPreferences.systemPreferences;
                $scope.menuUrl = resolved.menuUrlData || { url: '' };
                $scope.menuUrl.originalUrl = $scope.menuUrl.url;
                $scope.menuUrl.languageId = $scope.menuUrl.languageId || languages[userLanguageData].id;
                $scope.menuSearch = menusService.getDefaultSearchParams();

                $scope.urlNameChanged = function (n) {
                    if (!$scope.menuUrl.menuUrlId && $scope.mainForm.menuUrlLink.$untouched) {
                        $scope.menuUrl.url = n;
                    }
                    if ($scope.menuUrl.menuUrlId)
                        submit();
                };

                $scope.getFullUrlFromLink = function () {
                    return $scope.rootUrl + $scope.getCustomerPortalUrl() + '/' + $scope.menuUrl.url;
                };
                
                $scope.getCustomerPortalUrl = function() {
                    return self.getPreference(enums.clientPreferences.customerPortalUrl);
                };
                
                $scope.goBack = function() {
                    $location.path('/ManageUrls/');
                };

                $scope.showAddMenuDialog = function () {
					$scope.menus = [];
	                $scope.hasSearched = false;
                    $scope.showSearch = true;
                };
                
                $scope.setLanguage = function(languageId) {
                    $scope.menuUrl.languageId = languageId;
                    if ($scope.menuUrl.menuUrlId)
                        submit();
                };

                $scope.rootUrl = $window.urls.menus;

                var copiedToClipboardSuccessMessage, copiedToClipboardErrorMessage, savedSuccessMessages;
                $scope.copyLinkToClipboard = function () {
                    if (clipboard.supported) {
                        var fullLink = $scope.getFullUrlFromLink();
                        clipboard.copyText(fullLink);
                        toastr.success(copiedToClipboardSuccessMessage + ": " + fullLink);
                    } else {
                        toastr.error(copiedToClipboardErrorMessage);
                        $scope.showFullMenuLink = true;
                    }
                };

                $scope.addMenus = function () {
                    var menusToAdd = $scope.selectedMenus();
                    if (!$scope.menuUrl.menus) {
                        $scope.menuUrl.menus = [];
                    }
                    $scope.menuUrl.menus = $scope.menuUrl.menus.concat(menusToAdd);
					$scope.showSearch = false;
	                return $scope.submit();
                };

				$scope.searchMenus = function () {
					$scope.hasSearched = false;
					$scope.menuSearch.menuType = enums.menuType.all;
					return menusService.search($scope.menuSearch).then(function (data) {
						$scope.hasSearched = true;
                        $scope.menus = _.filter(data.list, function(m) {
                            return !_.findWhere($scope.menuUrl.menus, { menuId: m.menuId });
                        });
                    });
				};

				$scope.$watchCollection('menuUrl.menus',
					function (newVal, oldVal) {
						if (angular.equals(newVal, oldVal) || newVal > oldVal) {
							return;
						}
						submit();
		            });

                var submit = function () {
                    $scope.saving = true;
                    return menuUrlsService.addUpdateMenuUrl($scope.menuUrl).then(function (result) {
                        toastr.success(savedSuccessMessages);
                        if (result.menuUrlId) {
                            $scope.menuUrl.menuUrlId = result.menuUrlId;
                            var path = $location.path();
                            var newUrl;
                            if (path.toLowerCase() == "/manageurls/view/") {
                                newUrl = path.toString() + result.menuUrlId.toString();
                                $location.path(newUrl);
                            } else if (path.toLowerCase() == "/manageurls/view") {
                                newUrl = path.toString() + "/" + result.menuUrlId.toString();
                                $location.path(newUrl);
                            }
                            $scope.menuUrl.originalUrl = $scope.menuUrl.url;
                        }
                    }, function (error) {
                        toastr.error(error.data.data);
                    });
                };

                $scope.submit = function () {
                    return submit();
                };

                $scope.submitAndReturn = function () {
                    submit().then(function () {
                        $window.location.href = '/ManageUrls';
                    });
                };

                $scope.selectedMenus = function () {
                    return _.filter($scope.menus, function (m) {
                        return m.selected;
                    });
                };

                $scope.removeMenu = function (m) {
					_.removeIfExists($scope.menuUrl.menus, m);
                };

                $scope.restoreMenuUrlLink = function(menuUrl) {
                    menuUrl.url = menuUrl.originalUrl;
				};

	            var changedTimeout;
				$scope.menuUrlChanged = function () {
					if (!$scope.menuUrl || !$scope.menuUrl.menuUrlId) {
						return;
					}
					if (changedTimeout) {
						$timeout.cancel(changedTimeout);
					}
					if ($scope.menuUrl.url != $scope.menuUrl.originalUrl) {
                        changedTimeout = $timeout(function () {
                                var t = $translate.instant('are_you_sure_change_url_link');
                                return cdbAreYouSureService(t).then(function () {

                                    submit();
                                }, function () {
                                    $scope.restoreMenuUrlLink($scope.menuUrl);
                                });
                            },
                            600);
                    }
				};

                var getTranslations = function () {
                    var translatePromise =
	                    $translate(["copied_to_clipboard", "error_copying_to_clipboard", "menu_url_saved"]);
                    translatePromise.then(function (results) {
						copiedToClipboardSuccessMessage = results["copied_to_clipboard"];
						copiedToClipboardErrorMessage = results["error_copying_to_clipboard"];
						savedSuccessMessages = results["menu_url_saved"];
                    });
                    return translatePromise;
                };

                var init = function () {
                    var initPromises = [];
                    var translatePromise = getTranslations();
                    initPromises.push(translatePromise);
                };
                init();

            });
        }
    ]);
angular.module(appName)
    .controller("manageUserController",
    [
        "$scope",
        "$routeParams",
        "userSearchResource",
        "manageUserResource",
        "procurementSubscriptionClientUnitDepartmentResource",
        "clientUnitAccountCodeResource",
        "toastr",
        "$q",
        "$location",
        "localStorageService",
        "enums",
        "$translate",
        function ($scope, $routeParams, userSearchResource, manageUserResource,
            procurementSubscriptionClientUnitDepartmentResource, clientUnitAccountCodeResource,
            toastr, $q, $location, localStorageService, enums, $translate) {
            $translate.onReady().then(function() {
                var self = this;

                self.cachedUser = {};

                $scope.cancel = function() {
                    $scope.user = self.cachedUser;
                    $location.path("/Users");
                }

                $scope.toggleActions = function(orgContact) {
                    orgContact.showActions = !orgContact.showActions;
                    if (orgContact.editingRoles == true) {
                        orgContact.editingRoles = false;
                    }
                    if (orgContact.editingDepartments == true) {
                        orgContact.editingDepartments = false;
                    }
                    if (orgContact.editingAccountCodes == true) {
                        orgContact.editingAccountCodes = false;
                    }
                }

                $scope.toggleEditRoles = function(orgContact) {
                    orgContact.editingRoles = !orgContact.editingRoles;
                };

                $scope.toggleEditDepartments = function(orgContact) {
                    orgContact.editingDepartments = !orgContact.editingDepartments;
                    if (orgContact.editingDepartments)
                        self.getDepartmentsForUser(orgContact);

                };
                $scope.toggleEditAccountCodes = function(orgContact) {
                    orgContact.editingAccountCodes = !orgContact.editingAccountCodes;
                    if (orgContact.editingAccountCodes)
                        self.getAccountCodesForUser(orgContact);
                };

                self.getDepartmentsForUser = function(user) {

                    return userSearchResource.getDepartmentsForUser({ userId: user.userId, orgId: user.organisationId })
                        .$promise.then(function(data) {

                            user.procurementClientUnitDepartmentDtos = data.procurementClientUnitDepartmentDtos;
                        });
                };

                $scope.updateDepartmentAssigned = function(department, orgContact) {
                    if (department.isAssigned) {
                        return procurementSubscriptionClientUnitDepartmentResource
                            .addUserToClientUnitDepartment({
                                userId: orgContact.userId,
                                id: department.procurementSubscriptionClientUnitDepartment.id
                            })
                            .$promise.then(function() {
                                    $translate('success_user_assigned_to',
                                        { name: department.procurementSubscriptionClientUnitDepartment.name }).then(
                                            function (t) {
                                                toastr.success(t);
                                            });
                                },
                                function() {
                                    department.isAssigned = false;
                                });
                    } else {
                        department.isDefault = false;
                        return procurementSubscriptionClientUnitDepartmentResource
                            .removeUserFromClientUnitDepartment({
                                userId: orgContact.userId,
                                id: department.procurementSubscriptionClientUnitDepartment.id
                            }).$promise.then(function() {
                                $translate('success_user_removed_from',
                                    { name: department.procurementSubscriptionClientUnitDepartment.name }).then(
                                        function (t) {
                                            toastr.success(t);
                                        });
                            });
                    }

                };

                $scope.updateDepartmentIsDefault = function(department, orgContact) {
                    console.log("update assigned for department, user", department, orgContact);
                    if (department.isDefault) {
                        _.each(orgContact.procurementClientUnitDepartmentDtos,
                            function(item) {
                                item.isDefault = false;
                            });
                        department.isAssigned = true;
                        department.isDefault = true;
                        return procurementSubscriptionClientUnitDepartmentResource
                            .setUserAsDefaultClientUnitDepartmentUser({
                                userId: orgContact.userId,
                                id: department.procurementSubscriptionClientUnitDepartment.id
                            }).$promise.then(function() {
                                $translate('success_user_set_as_default_for',
                                    { name: department.procurementSubscriptionClientUnitDepartment.name }).then(
                                        function (t) {
                                            toastr.success(t);
                                        });

                            });
                    } else {
                        return procurementSubscriptionClientUnitDepartmentResource
                            .removeUserAsDefaultClientUnitDepartmentUser({
                                userId: orgContact.userId,
                                id: department.procurementSubscriptionClientUnitDepartment.id
                            }).$promise.then(function() {
                                $translate('success_user_removed_default_for',
                                    { name: department.procurementSubscriptionClientUnitDepartment.name }).then(
                                        function (t) {
                                            toastr.success(t);
                                        });
                            });
                    }

                };

                ///account codes
                self.getAccountCodesForUser = function(user) {

                    return userSearchResource
                        .getAccountCodesForUser({ userId: user.userId, orgId: user.organisationId }).$promise.then(
                            function(data) {

                                user.procurementClientUnitAccountCodeDtos = data.procurementClientUnitAccountCodeDtos;
                            });
                };

                $scope.updateAccountCodeAssigned = function(accountCode, orgContact) {
                    console.log("update assigned for Account Code, user", accountCode, orgContact);
                    if (accountCode.isAssigned) {
                        return clientUnitAccountCodeResource
                            .addUserToClientUnitAccountCode({
                                userId: orgContact.userId,
                                procurementSubscriptionAccountCodeId: accountCode.procurementSubscriptionAccountCode.id,
                                organisationId: self.unitOrganisationId
                            })
                            .$promise.then(function() {
                                $translate('success_user_assigned_to',
                                    { name: accountCode.procurementSubscriptionAccountCode.name }).then(
                                        function (t) {
                                            toastr.success(t);
                                        });
                            });
                    } else {
                        accountCode.isDefault = false;
                        return clientUnitAccountCodeResource.removeUserFromClientUnitAccountCode({
                            userId: orgContact.userId,
                            procurementSubscriptionAccountCodeId: accountCode.procurementSubscriptionAccountCode.id,
                            organisationId: self.unitOrganisationId
                        }).$promise.then(function() {
                            $translate('success_user_removed_from',
                                { name: accountCode.procurementSubscriptionAccountCode.name }).then(
                                    function (t) {
                                        toastr.success(t);
                                    });
                        });
                    }

                };

                $scope.updateAccountCodeIsDefault = function(accountCode, orgContact) {
                    console.log("update assigned for Account Code, user", accountCode, orgContact);
                    if (accountCode.isDefault) {
                        _.each(orgContact.procurementClientUnitAccountCodeDtos,
                            function(item) {
                                item.isDefault = false;
                            });
                        accountCode.isAssigned = true;
                        accountCode.isDefault = true;
                        return clientUnitAccountCodeResource.setUserAsDefaultClientUnitAccountCodeUser({
                            userId: orgContact.userId,
                            procurementSubscriptionAccountCodeId: accountCode.procurementSubscriptionAccountCode.id,
                            organisationId: self.unitOrganisationId
                        }).$promise.then(function() {
                            $translate('success_user_set_as_default_for',
                                { name: accountCode.procurementSubscriptionAccountCode.name }).then(
                                    function (t) {
                                        toastr.success(t);
                                    });
                        });
                    } else {
                        return clientUnitAccountCodeResource.removeUserAsDefaultClientUnitAccountCodeUser({
                            userId: orgContact.userId,
                            procurementSubscriptionAccountCodeId: accountCode.procurementSubscriptionAccountCode.id,
                            organisationId: self.unitOrganisationId
                        }).$promise.then(function() {
                            $translate('success_user_removed_default_for',
                                { name: accountCode.procurementSubscriptionAccountCode.name }).then(
                                function (t) {
                                    toastr.success(t);
                                    }
                                );
                        });
                    }

                };

                self.init = function() {
                    $scope.errorMode = false;
                    self.context = localStorageService.getItem(enums.localStorage.organisationContext);
                    self.unitOrganisationId = self.context.currentSubscriptionUnit.organisation.id;
                    console.log("route params, context", $routeParams.userId, self.context.user.id);
                    if (parseInt($routeParams.userId) === self.context.user.id) {

                        $translate('error_cannot_manage_self').then(function(translation) {
                            $scope.errorMode = true;
                            $scope.errorMessage = translation;
                        });
                    } else {
                        $scope.loading = $q.defer();
                        $scope.organisationId = self.context.organisation ? self.context.organisation.id : 0;
                        $scope.aPromise = userSearchResource
                            .getUserForEdit({ userId: $routeParams.userId, organisationId: $scope.organisationId })
                            .$promise.then(function(data) {
                                $scope.user = data.userDto;
                                self.cachedUser = data.userDto;
                                $scope.loading.resolve();
                            });
                    }

                }();
            });
        }
    ]);

angular.module(appName)
    .factory('manageUserResource', [
        '$resource', 'siteUrl',
        function($resource, siteUrl) {
            var api = siteUrl() + 'api/ManageUser';
            return $resource(api, {}, {
                updateUser: {
                    method: 'POST',
                    url: api + '/UpdateUser'
                },
                resetPassword: {
                    method: 'POST',
                    url: api + '/ResetPassword',
                    params: {
                        userId: '@userId',
                        id: '@id'
                    }
                },
                resetPasswordForCurrentOrImpersonatedUser: {
                    method: 'POST',
                    url: api + '/ResetPasswordForCurrentOrImpersonatedUser',
                    params: {
                        userId: '@userId'
                    }
                },
                changePassword: {
                    method: 'POST',
                    url: api + '/ChangePassword',
                },
                forceChangePassword: {
                    method: 'POST',
                    url: api + '/ForceChangePassword',
                },
                getCurrentOrImpersonatedUser: {
                    method: "GET",
                    url: api + '/GetCurrentOrImpersonatedUser',
                    isArray: false
                },
                updateCurrentOrImpersonatedUser: {
                    method: 'POST',
                    url: api + '/UpdateCurrentOrImpersonatedUser'
                }
            });
        }
    ])
angular.module(appName)
    .controller("manageUsersController",
    [
        "$scope",
        "userSearchResource",
        "$q",
        "_",
        "procurementSubscription",
        "$location",
        "enums",
        "localStorageService",
        function($scope,
            userSearchResource,
            $q,
            _,
            procurementSubscription,
            $location, enums, localStorageService) {
            var self = this;

            $scope.edit = function(userId) {
                $location.path("/ManageUser/" + userId);
            };
            self.init = function() {
                self.context = localStorageService.getItem(enums.localStorage.organisationContext);
                $scope.loading = $q.defer();
                $scope.procurementSubscriptionId = procurementSubscription.procurementSubscriptionId;
                $scope.procurementSubscriptionName = procurementSubscription.organisation.name;
                $scope.users = [];
                userSearchResource.getUsersForSubscription({ id: $scope.procurementSubscriptionId })
                    .$promise.then(function(data) {

                        var users = data.userDtos;
                        //remove self from the array
                        /*users = _.without(users, _.findWhere(users, {
                            id: self.context.user.id
                        }));*/

                        $scope.users = users;

                        $scope.loading.resolve();
                    });
            }();
        }
    ]);
angular.module(appName)
    .factory('userSearchResource', [
        '$resource', 'siteUrl', 'organisationContextService',
        function ($resource, siteUrl, organisationContextService) {
            var context = organisationContextService.getContext();
           
            var api = siteUrl() + 'api/UserSearch';
            return $resource(api, {}, {
                getUsersForSubscription: {
                    method: 'GET',
                    url: api + '/getUsersForSubscription'
                },
                getUserForEdit: {
                    method: 'GET',
                    url: api + '/getUserForEdit',
                    params: {
                        userId: '@userId',
                        organisationId: '@organisationId',
                        id: context.id
                    }
                },
                getDepartmentsForUser: {
                    method: 'GET',
                    url: api + '/getDepartmentsForUser',
                    params: { userId: '@userId', orgId: '@orgID', id: context.id }
                },
                getAccountCodesForUser: {
                    method: 'GET',
                    url: api + '/getAccountCodesForUser',
                    params: { userId: '@userId', orgId: '@orgID', id: context.id }
                }
            });
        }
    ])
/*
 * This controller is used for the View/Edit and Create scenarios.
 *
 * `!$scope.menu.menuId` means we're in Create.'
 */

angular.module('beagle')
    .controller('createEditMenuController',
        [
			'$scope',
			'$rootScope',
			'$timeout',
			'$location',
			'$window',
			'$translate',
			'$q',
	        'oidcManager',
			'localStorageService',
	        'enums',
			'menusService',
			'menuType',
			'menuData',
			'userLanguageData',
			'servicePeriodTypeData',
	        'organisationContextService',
			'dateService',
			'clipboard',
	        'dragulaService',
			'recipeService',
			'servicePeriodTypesService',
	        'validationHelper',
			'dragulaAnimationSpeed',
			'clientPreferences',
			'cdbAreYouSureService',
			'fileDownloadService',
	        'languages',
            'nutrientAttributeHelper',
            'procurementRecipeAttributeService',
            function (
                $scope,
                $rootScope,
                $timeout,
                $location,
                $window,
                $translate,
                $q,
                oidcManager,
                localStorageService,
                enums,
                menusService,
                menuType,
                menuData,
                userLanguageData,
                servicePeriodTypeData,
                organisationContextService,
                dateService,
                clipboard,
                dragulaService,
                recipeService,
                servicePeriodTypesService,
                validationHelper,
                dragulaAnimationSpeed,
                clientPreferences,
                cdbAreYouSureService,
                fileDownloadService,
                languages,
                nutrientAttributeHelper,
                procurementRecipeAttributeService
            ) {
                // $translate.onReady().then(function() {
                    var self = this;

                    var translations = $translate([
                        'recipes_added_to_service_period',
                        'recipe_deleted_from_service_period_successfully'
                    ]);

                    $scope.showDialogs = {};

                    self.resolves = {
                        menuData: menuData,
                        servicePeriodTypeData: servicePeriodTypeData,
                        menuType: menuType,
                        translations: translations,
                        clientPreferences: clientPreferences,
                        userLanguageData: userLanguageData
                    };

                    self.context = organisationContextService.getContext();

                    self.setRestorationProperties = function(menu) {
                        $scope.menu.originalUrl = menu.link;
                        $scope.menu.originalFunctionDate = menu.functionDate;
                    };

                    self.setServicePeriodRecipeCosts = function(servicePeriodRecipes) {
                        _.each(servicePeriodRecipes,
                            function(spr) {
                                spr.sellingPrice = spr.sellingPrice || spr.recipeCosts.actualSellingPrice;
                            });
                    };

                    self.setDisabledOnServicePeriods = function() {
                    };

                    self.setServicePeriodTypes = function() {
                        _.each($scope.menu.servicePeriods,
                            function(sp) {
                                sp.open = true;
                                // We need to make sure this is initialised to an empty array if none exist.
                                if (!_.isArray(sp.servicePeriodRecipes)) {
                                    sp.servicePeriodRecipes = [];
                                } else {
                                    self.setServicePeriodRecipeCosts(sp.servicePeriodRecipes);
                                }

                                sp.servicePeriodType = _.findWhere($scope.servicePeriodTypes,
                                    { servicePeriodTypeId: sp.servicePeriodTypeId });
                                sp.openInDialog = false;
                            });
                    };

                    self.generateServicePeriod = function() {
                        return {
                            menuId: $scope.menu.menuId,
                            name: ''
                        }
                    };

                    self.getActCovers = function() {
                        var sum = 0;
                        _.each($scope.menu.servicePeriods,
                            function(sp) {
                                sum += _.sum(sp.servicePeriodRecipes, 'coversToProduce');
                            });

                        return sum;
                    };

                    self.isNumber = function(num) {
                        return !isNaN(num) && num != Infinity && num != -Infinity;
                    };

                    self.revenueExVatCalc = function(revenue) {
                        return parseFloat(revenue / (1 + parseFloat($scope.vat))).toFixed(2);
                    };

                    self.syncSortOrders = function(array) {
                        _.each(array,
                            function(item, index) {
                                item.sortOrder = index;
                            });
                    };

                    $scope.getPreference = function(key) {
                        var pref = _.findWhere(self.clientSystemPreferences, { key: key });
                        return pref != null ? pref.value : null;
                    };

                    $scope.currentServicePeriodNames = [];

                    $q.all(self.resolves).then(function(resolved) {
                        // If response is HttpStatusCode.RequestEntityTooLarge then the Menu has > 300 recipes.
                        if (resolved.menuData && resolved.menuData.responseCode === 413) {
                            $scope.company = localStorageService.getItem('company');
                            $scope.tooManyRecipesMessage = {
                                display: true,
                                menuName: resolved.menuData.menuName
                            };
                            return;
                        }
                        self.clientSystemPreferences = resolved.clientPreferences.systemPreferences;
                        var costCalculatorTemplatePreference = _.find(self.clientSystemPreferences,
                            { key: enums.clientPreferences.costCalculatorTemplate });
                        $scope.costCalculatorTemplate =
                            costCalculatorTemplatePreference ? costCalculatorTemplatePreference.value : null;
                        $scope.recipeCardTemplate = _.find(self.clientSystemPreferences,
                            { systemPreferenceTypeId: enums.systemPreferenceEnum.recipeCardTemplate }).value;
                        $scope.sopTemplate = _.find(self.clientSystemPreferences,
                            { systemPreferenceTypeId: enums.systemPreferenceEnum.sopTemplate }).value;
                        $scope.menu = resolved.menuData;
                        $scope.menu.languageId = $scope.menu.languageId || languages[userLanguageData.toLowerCase()].id;
                        $scope.menu.menuTypeId = resolved.menuData.menuTypeId || resolved.menuType;
                        $scope.servicePeriodTypes = resolved.servicePeriodTypeData;
                        $scope.showServiceCostInformation = false;
                        $scope.menuTypeId = resolved.menuType;
                        $scope.menusUrl = $window.urls.menus;
                        $scope.currencySymbol = self.context.currency.name;
                        $scope.targetMarginType = $scope.getPreference(enums.clientPreferences.targetMarginType);
                        $scope.translations = {
                            recipesAdded: resolved.translations["recipes_added_to_service_period"],
                            recipeDeleted: resolved.translations["recipe_deleted_from_service_period_successfully"]
                        };
                        $scope.validationHelper = validationHelper;
                        $scope.sopHeaderOpen = true;
                        $scope.recipeCardHeaderOpen = true;
                        $scope.vatInclusive = $scope.getPreference(enums.clientPreferences.vat) == 1;
                        $scope.vat = $scope.getPreference(enums.clientPreferences.prevailingVatRate);

                        _.each($scope.menu.servicePeriods,
                            function(sp) {
                                $scope.currentServicePeriodNames.push({
                                    id: sp.servicePeriodId,
                                    name: sp.name.toLowerCase(),
                                    type: sp.servicePeriodType.name.toLowerCase()
                                });
                            });

                        $scope.recipeDialog = {
                            _defaultFilter: {
                                id: self.context.currentSubscriptionUnit.client.id,
                                term: '',
                                paginate: false,
                                clientId: self.context.currentSubscriptionUnit.client.id,
                                onlyPublished: true,
                                sortAsc: true,
                                sortField: 'Name'
                            },
                            filter: {},
                            recipes: [],
                            selectedRecipes: [],
                            showRecipeDialog: false,
                            addRecipesToServicePeriod: function() {
                                // This is required so that we can access $scope.recipeDialog inside the _.each function
                                var dialog = this;
                                var realServicePeriod = _.findWhere($scope.menu.servicePeriods,
                                    { servicePeriodId: dialog.servicePeriod.servicePeriodId });
                                if (!realServicePeriod.servicePeriodRecipes) {
                                    realServicePeriod.servicePeriodRecipes = [];
                                }
                                var addRecipesToServicePeriodDto = {
                                    id: realServicePeriod.servicePeriodId,
                                    recipeIds: []
                                };
                                _.each(dialog.selectedRecipes,
                                    function(recipe) {
                                        addRecipesToServicePeriodDto.recipeIds.push(recipe.id);
                                    });

                                return $q.all([
                                    menusService.addRecipesToServicePeriod(addRecipesToServicePeriodDto),
                                    procurementRecipeAttributeService.get(addRecipesToServicePeriodDto.recipeIds)
                                ]).then(
                                    function(response) {
                                        var addedRecipes = response[0];
                                        var recipeAttributes = response[1].data;
                                        _.each(addedRecipes,
                                            function(ar) {
                                                ar.attributes = _(recipeAttributes).filter(function (recipeAttribute) { return recipeAttribute.recipeId === ar.recipeId });
                                                _.pushIfNotExists(realServicePeriod.servicePeriodRecipes, ar);
                                            });
                                        self.setServicePeriodRecipeCosts(addedRecipes);
                                        toastr.success($scope.translations.recipesAdded);
                                        dialog.toggle();
                                    });
                            },
                            getSelectedRecipeCount: function() {
                                return this.selectedRecipes.length;
                            },
                            resetFilter: function() {
                                var dialog = this;
                                dialog.filter = angular.copy(dialog._defaultFilter);
                                dialog.filter.servicePeriodId =
                                    dialog.servicePeriod ?
                                        dialog.servicePeriod.servicePeriodId :
                                        null;
                            },
                            resetRecipes: function() {
                                this.recipes = [];
                                this.selectedRecipes = [];
                            },
                            selectRecipe: function(recipe) {
                                if (recipe.selected) {
                                    this.selectedRecipes.push(recipe);
                                } else {
                                    _.removeIfExists(this.selectedRecipes, recipe, { id: recipe.id });
                                }
                            },
                            toggle: function(servicePeriod) {
                                this.servicePeriod = servicePeriod;
                                this.resetFilter();
                                this.resetRecipes();
                                this.showRecipeDialog = !this.showRecipeDialog;
                            }
                        };

                        dragulaService.options($scope,
                            'servicePeriodRecipes',
                            {
                                moves: function(element, container, handle) {
                                    return handle.className.indexOf('recipe-handle') > -1;
                                },
                                revertOnSpill: true
                            });

                        dragulaService.options($scope,
                            'service-periods',
                            {
                                accepts: function(element, target) {
                                    return element.parentElement.getAttribute('disabled') !== 'disabled';
                                },
                                moves: function(element, container, handle) {
                                    return element.parentElement.getAttribute('disabled') !== 'disabled' &&
                                        handle.className.indexOf('dragula-handle') > -1;
                                },
                                revertOnSpill: true
                            });

                        $scope.shouldEnableMenuEngineeringButton = function() {
                            if (_.every($scope.menu.servicePeriods, function(servicePeriod) {
                                return !servicePeriod.servicePeriodRecipes ||
                                    (servicePeriod.servicePeriodRecipes && !servicePeriod.servicePeriodRecipes.length);
                            })) {
                                return false;
                            }

                            return _.every($scope.menu.servicePeriods, function(servicePeriod) {
                                if (!servicePeriod.servicePeriodRecipes ||
                                    (servicePeriod.servicePeriodRecipes && !servicePeriod.servicePeriodRecipes.length)) {
                                    return true;
                                }
                                return _.every(servicePeriod.servicePeriodRecipes, function(recipe) {
                                    // ServicePeriodRecipes can have their own sellingPrice, but it falls back to the recipe itself if !sellingPrice
                                    return (recipe.sellingPrice && parseFloat(recipe.sellingPrice) > 0 || parseFloat(recipe.recipeCosts.actualSellingPrice)) &&
                                        (recipe.coversSold == null || recipe.coversSold == '' || recipe.coversSold > 0);
                                })
                            })
                        }

                        $scope.cancelEditServicePeriod = function(servicePeriod) {
                            servicePeriod.servicePeriodType = servicePeriod.oldServicePeriodType;
                            $scope.toggleEditServicePeriod(servicePeriod);
                        };

                        $scope.isUnique = function(sp) {
                            if (!sp.servicePeriodType) {
                                return true;
                            }
                            var name = angular.isDefined(sp.newName)
                                ? sp.newName.toLowerCase()
                                : sp.name.toLowerCase();
                            var typeName = sp.servicePeriodType.name.toLowerCase();
                            return _.find($scope.menu.servicePeriods,
                                    function(msp) {
                                        if (msp.servicePeriodId === sp.servicePeriodId) return false;
                                        return msp.name.toLowerCase() === name &&
                                            msp.servicePeriodType.servicePeriodTypeId ===
                                            sp.servicePeriodType.servicePeriodTypeId;
                                    }) ==
                                null;
                        };

                        $scope.currentServicePeriodNamesWithout = function(name, spType) {
                            var item = _.findWhere($scope.currentServicePeriodNames,
                                { name: name.toLowerCase(), type: spType.name.toLowerCase() });
                            return _.without($scope.currentServicePeriodNames, item);
                        };

                        $scope.deleteServicePeriod = function(servicePeriod) {
                            return menusService.deleteServicePeriod($scope.menu.menuId, servicePeriod.servicePeriodId)
                                .then(
                                    function() {
                                        toastr.success($translate.instant('success_service_period_deleted',
                                            { servicePeriodName: servicePeriod.name }));
                                        _.removeIfExists($scope.menu.servicePeriods, servicePeriod);
                                        $scope.toggleDeleteServicePeriodDialog();
                                    });
                        };

                        $scope.deleteServicePeriodRecipe = function(recipe, servicePeriod) {
                            recipe.isDeleting = true;
                            return menusService
                                .deleteServicePeriodRecipe(recipe.servicePeriodRecipeId, recipe.servicePeriodId).then(
                                    function() {
                                        _.removeIfExists(servicePeriod.servicePeriodRecipes, recipe);
                                        toastr.success($scope.translations.recipeDeleted);
                                    }).finally(function() {
                                    recipe.isDeleting = false;
                                });
                        };

                        $scope.format2dp = function(property, number) {
                            if (number === undefined) {
                                return;
                            }
                            $scope.menu[property] = parseFloat(number.toFixed(2));
                        };

                        $scope.formatLink = function(link) {
                            if (link) {
                                link = link.replace(/\s+|\/+|\\+/g, '-')
                                    .replace(
                                        /'+|"+|!+|£+|\$+|%+|\^+|&+|\*+|=+|\++|\[+|]+|{+|}+|;+|:+|@+|#+|~+|,+|<+|\.+|>+|\?+|`+|¬+/g,
                                        '').toLowerCase();
                                return link;
                            }
                        };

                        $scope.nameChanged = function(name, form) {
                            if (!$scope.menu.menuId && form.menuUrl.$untouched) {
                                $scope.menu.link = $scope.formatLink(name);
                            }

                            return true;
                        };

                        $scope.getMenuTypeNameFromEnum = function(menuTypeEnum) {
                            switch (menuTypeEnum) {
                            case enums.menuType.menu:
                                return $translate.instant('menu');
                            case enums.menuType.function:
                                return $translate.instant('function');
                            default:
                                return 'UNKNOWN';
                            }
                        };

                        $scope.getTotalRecipeCost = function(recipe) {
                            return recipe.costPerCover * recipe.coversToProduce;
                        };

                        $scope.isFunctionType = function() {
                            return menuType === $rootScope.$enums.menuType.function;
                        };

                        $scope.getDate = function() {
                            return dateService.getDate();
                        };

                        $scope.copyLinkToClipboard = function(menu) {
                            if (clipboard.supported) {
                                clipboard.copyText($scope.getFullMenuLink(menu));
                                toastr.success($translate.instant('menu_link_copied_to_clipboard',
                                    { menuType: $scope.getMenuTypeNameFromEnum($scope.menuTypeId) }));
                            } else {
                                toastr.error($translate.instant('copy_to_clipboard_not_supported'));
                                $scope.showFullMenuLink = true;
                            }
                        };

                        $scope.costInfo = {
                            preService: {
                                totalCost: function() {
                                    var totalCost = 0;
                                    _.each($scope.menu.servicePeriods,
                                        function(sp) {
                                            _.each(sp.servicePeriodRecipes,
                                                function(spr) {
                                                    // totalCost += parseFloat(parseFloat(spr.recipeCosts.grossCost).toFixed());
                                                    totalCost += spr.recipeCosts.costPerCover * spr.coversToProduce;
                                                });
                                        });

                                    return parseFloat(totalCost).toFixed(2);
                                },
                                revenue: function() {
                                    return parseFloat($scope.menu.numberOfCovers * $scope.menu.costPerHead).toFixed(2);
                                },
                                revenueExVat: function() {
                                    var revenue = this.revenue();
                                    return self.revenueExVatCalc(revenue);
                                },
                                fcos: function() {
                                    var fcos = $scope.vatInclusive ?
                                        this.totalCost() / this.revenueExVat() :
                                        this.totalCost() / this.revenue();
                                    if ($scope.targetMarginType === enums.targetMarginTypes.fcos) {
                                        // Return 0.00 if `costDividedByRevenueExVat` is 0 otherwise we get NaN
                                        return self.isNumber(fcos) ? (fcos * 100).toFixed(2) : '0.00';
                                    } else if ($scope.targetMarginType === enums.targetMarginTypes.grossProfit) {
                                        fcos = 1 - (this.totalCost() / this.revenueExVat());
                                        // Return 0.00 if `costDividedByRevenueExVat` is 0 otherwise we get NaN
                                        return self.isNumber(fcos) ? (fcos * 100).toFixed(2) : '0.00';
                                    }
                                }
                            },
                            postService: {
                                totalCost: function() {
                                    var totalCost = 0;
                                    _.each($scope.menu.servicePeriods,
                                        function(sp) {
                                            _.each(sp.servicePeriodRecipes,
                                                function(spr) {
                                                    // totalCost += parseFloat(parseFloat(spr.recipeCosts.grossCost).toFixed());
                                                    totalCost += spr.recipeCosts.costPerCover * spr.coversSold;
                                                });
                                        });

                                    return parseFloat(totalCost).toFixed(2);
                                },
                                revenue: function() {
                                    return parseFloat($scope.menu.coversCharged * $scope.menu.costPerHead).toFixed(2);
                                },
                                revenueExVat: function() {
                                    var revenue = this.revenue();
                                    return self.revenueExVatCalc(revenue);
                                },
                                fcos: function () {
                                    var fcos = $scope.vatInclusive ?
                                        this.totalCost() / this.revenueExVat() :
                                        this.totalCost() / this.revenue();
                                    // Return 0.00 if `costDividedByRevenueExVat` is 0 otherwise we get NaN
                                    if ($scope.targetMarginType === enums.targetMarginTypes.fcos) {
                                        return self.isNumber(fcos) ? (fcos * 100).toFixed(2) : '0.00';
                                    } else if ($scope.targetMarginType === enums.targetMarginTypes.grossProfit) {
                                        fcos = 1 - (this.totalCost() / this.revenueExVat());
                                        // Return 0.00 if `costDividedByRevenueExVat` is 0 otherwise we get NaN
                                        return self.isNumber(fcos) ? (fcos * 100).toFixed(2) : '0.00';
                                    }
                                }
                            },
                            theoretical: {
                                totalCost: function() {
                                    var totalCost = 0;
                                    _.each($scope.menu.servicePeriods,
                                        function(sp) {
                                            _.each(sp.servicePeriodRecipes,
                                                function(spr) {
                                                    // totalCost += parseFloat(parseFloat(spr.recipeCosts.grossCost).toFixed());
                                                    totalCost += spr.recipeCosts.costPerCover * spr.coversSold;
                                                });
                                        });

                                    return parseFloat(totalCost).toFixed(2);
                                },
                                revenue: function() {
                                    var revenue = 0;

                                    _.each($scope.menu.servicePeriods,
                                        function(sp) {
                                            _.each(sp.servicePeriodRecipes,
                                                function(spr) {
                                                    revenue += spr.sellingPrice * spr.coversSold;
                                                });
                                        });
                                    return revenue.toFixed(2);
                                },
                                revenueExVat: function() {
                                    var revenue = this.revenue();
                                    return self.revenueExVatCalc(revenue);
                                },
                                fcos: function () {
                                    var fcos = $scope.vatInclusive ?
                                        this.totalCost() / this.revenueExVat() :
                                        this.totalCost() / this.revenue();
                                    if ($scope.targetMarginType === enums.targetMarginTypes.fcos) {
                                        // Return 0.00 if `costDividedByRevenueExVat` is 0 otherwise we get NaN
                                        return (!isNaN(fcos) &&
                                                fcos !== Infinity)
                                            ? (fcos * 100).toFixed(2)
                                            : '0.00';
                                    } else if ($scope.targetMarginType === enums.targetMarginTypes.grossProfit) {
                                        fcos = 1 - fcos;
                                        // Return 0.00 if `costDividedByRevenueExVat` is 0 otherwise we get NaN
                                        return self.isNumber(fcos)
                                            ? (fcos * 100).toFixed(2)
                                            : '0.00';
                                    }
                                }
                            }
                        };

                        $scope.recipeCalcs = {
                            suggestedSellingPrice: function(recipe) {
                                var costPerCover = recipe.recipeCosts.costPerCover;
                                var calc;
                                if ($scope.targetMarginType === enums.targetMarginTypes.fcos) {
                                    calc = costPerCover * (100 / $scope.menu.targetMargin);
                                    calc = $scope.vatInclusive ? calc + (calc * ($scope.vat)) : calc;
                                } else if ($scope.targetMarginType === enums.targetMarginTypes.grossProfit) {
                                    calc = (costPerCover / (1 - ($scope.menu.targetMargin / 100)));
                                    calc = $scope.vatInclusive ? calc + (calc * ($scope.vat)) : calc;
                                }

                                return calc
                            },
                            targetMarginValue: function(recipe) {
                                var costPerCover = recipe.recipeCosts.costPerCover || 0;
                                var sellingPrice = recipe.sellingPrice || 0;
                                // If we are not VAT inclusive, then treat VAT as being 1
                                var vat = $scope.vatInclusive ? 1 + parseFloat($scope.vat) : 1;
                                var calc = (costPerCover / (sellingPrice / vat))
                                if ($scope.targetMarginType === enums.targetMarginTypes.fcos) {
                                    calc = calc * 100;
                                } else if ($scope.targetMarginType === enums.targetMarginTypes.grossProfit) {
                                    // Gross Profit is just the reverse of FCOS. do 1 - calc to retrieve the flip of FCOS
                                    calc = (1 - calc) * 100;
                                }

                                // Avoids NULL / Undefined errors by returning 0 if `calc` is not a number
                                return self.isNumber(calc) ? calc : 0;
                            }
                        };

                        $scope.getMenuTypeName = function() {
                            return $scope.getMenuTypeNameFromEnum(menuType);
                        };

                        $scope.refreshServicePeriodTypes = function() {
                            $scope.refreshingServicePeriodTypes = true;
                            return servicePeriodTypesService.getAll().then(function(servicePeriodTypes) {
                                $scope.servicePeriodTypes = servicePeriodTypes;
                                toastr.success($translate.instant('service_period_types_refreshed'));
                            }).finally(function() {
                                $scope.refreshingServicePeriodTypes = false;
                            });
                        };

                        $scope.goBack = function() {
                            $location.path('/Menus/');
                        };

                        $scope.refreshServiceCostInformation = function() {
                            $scope.refreshingServiceCostInformation = true;
                        };

                        $scope.removeImage = function(model, type) {
                            var t;
                            switch (type) {
                            case 'SopHeader':
                                t = $translate.instant('are_you_sure_delete_sop_header_image');
                                return cdbAreYouSureService(t).then(function() {
                                    return menusService.removeSopHeaderImage(model.menuId).then(function() {
                                        model.sopHeaderImage = null;
                                    });
                                });
                            case 'SopServicePeriodHeader':
                                t = $translate.instant('are_you_sure_delete_sop_service_period_header_image',
                                    'Are you sure you want to remove this SOP Service Period header image?');
                                return cdbAreYouSureService(t).then(function() {
                                    return menusService.removeSopServicePeriodHeaderImage(model.servicePeriodId).then(
                                        function() {
                                            model.sopHeaderImage = null;
                                        });
                                });
                            case 'RecipeCardHeader':
                                t = $translate.instant('are_you_sure_delete_recipe_card_header_image',
                                    'Are you sure you want to remove this Recipe Card header image?');
                                return cdbAreYouSureService(t).then(function() {
                                    return menusService.removeRecipeCardHeaderImage(model.menuId).then(function() {
                                        model.recipeCardHeaderImage = null;
                                    });
                                });
                            case 'RecipeCardServicePeriodHeader':
                                t = $translate.instant(
                                    'are_you_sure_delete_recipe_card_service_period_header_image',
                                    'Are you sure you want to remove this Recipe Card Service Period header image?');
                                return cdbAreYouSureService(t).then(function() {
                                    return menusService.removeRecipeCardServicePeriodHeaderImage(model.servicePeriodId)
                                        .then(function() {
                                            model.recipeCardHeaderImage = null;
                                        });
                                });
                            }
                        };

                        $scope.downloadSop = function() {
                            if (!$scope.sopTemplate) {
                                return $translate('to_download_sop_you_need_to').then(function (t) {
                                    return toastr.error(t);
                                });
                            }
                            var url = '/Api/RecipeTemplate/DownloadSOP?clientId=' +
                                self.context.currentSubscriptionUnit.client.id +
                                '&menuId=' +
                                $scope.menu.menuId;
                            $scope.typeDownloading = $translate.instant('sop');
                            $scope.downloadingPack = true;
                            fileDownloadService.downloadFile(url,
                                    $scope.menu.name + '_' + $translate.instant('sop_download'),
                                    'pdf')
                                .then(function() {

                                }).finally(function() {
                                    $scope.downloadingPack = false;
                                });
                        };
                        $scope.downloadCostCalculator = function() {
                            var url = '/Api/RecipeTemplate/DownloadCostCalculator?menuId=' + $scope.menu.menuId;
                            $scope.typeDownloading = $translate.instant('service_review', 'Service Review');
                            $scope.downloadingPack = true;
                            fileDownloadService.downloadFile(url,
                                    $scope.menu.name + '_' + $translate.instant('sop_download'),
                                    'xlsx')
                                .then(function() {

                                }).finally(function() {
                                    $scope.downloadingPack = false;
                                });
                        };

                        $scope.downloadRecipeCard = function() {
                            if (!$scope.recipeCardTemplate) {
                                return $translate('to_download_recipe_card_you_need_to').then(function (t) {
                                    return toastr.error(t);
                                });
                            }
                            var url = '/Api/RecipeTemplate/DownloadRecipeCardMenu?clientId=' +
                                self.context.currentSubscriptionUnit.client.id +
                                '&menuId=' +
                                $scope.menu.menuId;
                            $scope.typeDownloading = $translate.instant('recipe_card');
                            $scope.downloadingPack = true;
                            fileDownloadService
                                .downloadFile(url,
                                    $scope.menu.name + '_' + $translate.instant('recipe_card_download'),
                                    'pdf')
                                .then(function() {

                                }).finally(function() {
                                    $scope.downloadingPack = false;
                                });
                        };

                        $scope.downloadMenuEngineeringReport = function() {
                            var url = '/Api/MenuEngineeringReport/Download?clientId=' +
                                self.context.currentSubscriptionUnit.client.id +
                                '&menuId=' +
                                $scope.menu.menuId;
                            $scope.typeDownloading = $translate.instant('menu_engineering_report');
                            $scope.downloadingPack = true;
                            fileDownloadService
                                .downloadFile(url,
                                    $scope.menu.name + '_' + $translate.instant('menu_engineering_report_download'),
                                    'xlsx')
                                .then(function() {

                                }).finally(function() {
                                    $scope.downloadingPack = false;
                                });
                        };

                        var urlChangedTimeout;
                        $scope.menuLinkChanged = function(menu, form) {
                            if (!$scope.menu.link || !$scope.menu.id || (menu.originalUrl === menu.link)) {
                                return;
                            }
                            if (urlChangedTimeout) {
                                $timeout.cancel(urlChangedTimeout);
                            }
                            urlChangedTimeout = $timeout(function() {
                                var t = $translate.instant('are_you_sure_change_menu_link');
                                return cdbAreYouSureService(t).then(function() {

                                    $scope.formatLink(menu.link);
                                    return $scope.save(menu, form);
                                }, function() {
                                    $scope.restoreMenuUrl(menu);
                                });
                            },
                            600);
                        };

                        $scope.create = function(menu, form) {
                            if ($scope.validateMenu(menu, form)) {
                                return menusService.save(menu).then(function(savedMenu) {
                                        var location = $scope.isFunctionType() ? 'Function' : 'Menu';
                                        $location.url('/' + location + '/' + savedMenu.menuId);
                                        toastr.success($translate.instant('success_menu_created',
                                            { menuType: $scope.getMenuTypeNameFromEnum($scope.menuTypeId) }));
                                    },
                                    function(err) {
                                        if (err.data.errorType === 'FunctionDate') {
                                            toastr.error($translate.instant('error_function_invalid_date'));
                                        } else {
                                            toastr.error(err.data.data);
                                        }
                                    });
                            }
                        };

                        $scope.save = function(menu, form) {
                            if ($scope.validateMenu(menu, form) && menu.menuId) {
                                return menusService.save(menu).then(function(savedMenu) {
                                        toastr.success($translate.instant('success_menu_saved',
                                            { menuType: $scope.getMenuTypeNameFromEnum($scope.menuTypeId) }));
                                    },
                                    function(err) {
                                        if (err.data.errorType === 'FunctionDate') {
                                            toastr.error($translate.instant('error_function_invalid_date'));
                                        }
                                    });
                            }
                        };

                        $scope.saveServicePeriod = function(servicePeriod) {
                            if (servicePeriod.servicePeriodId) {
                                servicePeriod.name = servicePeriod.newName;
                                servicePeriod.servicePeriodTypeId = servicePeriod.servicePeriodType.servicePeriodTypeId;
                            } else {
                                servicePeriod.servicePeriodTypeId = servicePeriod.servicePeriodType.servicePeriodTypeId;
                            }
                            return menusService.saveMenuServicePeriod(servicePeriod).then(function(savedServicePeriod) {
                                    savedServicePeriod.open = true;
                                    savedServicePeriod.openInDialog = true;
                                    _.pushIfNotExists($scope.menu.servicePeriods,
                                        savedServicePeriod,
                                        'servicePeriodId');
                                    if (!servicePeriod.servicePeriodId) {
                                        $scope.currentServicePeriodNames.push({
                                            id: servicePeriod.servicePeriodId,
                                            name: servicePeriod.name.toLowerCase(),
                                            type: servicePeriod.servicePeriodType.name.toLowerCase()
                                        });
                                        $scope.toggleAddServicePeriod();
                                    } else {
                                        _.removeIfExists($scope.currentServicePeriodNames, servicePeriod);
                                        $scope.currentServicePeriodNames.push({
                                            id: servicePeriod.servicePeriodId,
                                            name: servicePeriod.name.toLowerCase(),
                                            type: servicePeriod.servicePeriodType.name.toLowerCase()
                                        });
                                        $scope.toggleEditServicePeriod(servicePeriod);
                                    }
                                },
                                function(error) {
                                    servicePeriod.name = servicePeriod.oldName;
                                });
                        };

                        $scope.setLanguage = function(languageId) {
                            $scope.menu.languageId = languageId;
                            if ($scope.menu.menuId) {
                                $scope.save($scope.menu, null);
                            }
                        };

                        // This can't be moved into the dialog as it's used by click-and-load
                        $scope.searchRecipes = function(filter) {
                            var selectedRecipeIds = _.pluck($scope.recipeDialog.selectedRecipes, 'id');
                            return recipeService.search(filter).then(function(result) {
                                _.each(result.results,
                                    function(recipe) {
                                        if (_.contains(selectedRecipeIds, recipe.id)) {
                                            recipe.selected = true;
                                        }
                                    });
                                $scope.recipeDialog.recipes = result.results;
                            });
                        };

                        $scope.servicePeriodHasUnpricedRecipes = function(servicePeriod) {
                            return _.find(servicePeriod.servicePeriodRecipes,
                                function(spr) {
                                    return spr.isUnpriced;
                                });
                        };

                        $scope.toggleAddServicePeriod = function() {
                            $scope.showAddServicePeriod = !$scope.showAddServicePeriod;
                            if ($scope.showAddServicePeriod) {
                                $scope.newServicePeriod = self.generateServicePeriod();
                            }
                        };

                        $scope.toggleRecipeDialog = function() {
                            $scope.recipeDialog.showRecipeDialog = !$scope.recipeDialog.showRecipeDialog;
                        };

                        $scope.toggleEditServicePeriod = function(servicePeriod) {
                            servicePeriod.editing = !servicePeriod.editing;
                            if (servicePeriod.editing) {
                                var activeServicePeriod = _.findWhere($scope.servicePeriodTypes,
                                    { servicePeriodTypeId: servicePeriod.servicePeriodTypeId });
                                servicePeriod.servicePeriodType = activeServicePeriod;
                                servicePeriod.newName = servicePeriod.name;
                                servicePeriod.oldName = servicePeriod.name;
                                servicePeriod.oldServicePeriodType = activeServicePeriod;
                            }
                        };

                        $scope.toggleServicePeriod = function(servicePeriod) {
                            servicePeriod.open = !servicePeriod.open;
                        };

                        $scope.toggleServicePeriodInDialog = function(servicePeriod) {
                            servicePeriod.openInDialog = !servicePeriod.openInDialog;
                        };

                        $scope.toggleShowManageDownloadPacks = function() {
                            $scope.showDialogs.showManageDownloadPacks = !$scope.showDialogs.showManageDownloadPacks;
                        };

                        $scope.toggleShowManageRecipeCard = function() {
                            $scope.showDialogs.showManageRecipeCard = !$scope.showDialogs.showManageRecipeCard;
                        };

                        $scope.toggleShowServiceCostInformation = function() {
                            $scope.showServiceCostInformation = !$scope.showServiceCostInformation;
                        };

                        $scope.toggleDeleteServicePeriodDialog = function(servicePeriod) {
                            $scope.showDialogs.showDeleteServicePeriodDialog = !$scope.showDialogs.showDeleteServicePeriodDialog;
                            $scope.currentServicePeriod = servicePeriod;
                        };

                        $scope.getMenuLink = function(menu, useOriginalUrl) {
                            if (menu.link && !useOriginalUrl) {
                                return menu.link;
                            } else if (useOriginalUrl) {
                                return menu.originalUrl;
                            } else {
                                return menu.name ? $scope.formatLink(menu.name) : '';
                            }
                        };

                        $scope.getFullMenuLink = function() {
                            return $scope.menusUrl +
                                $scope.getPreference(enums.clientPreferences.customerPortalUrl) +
                                '/' +
                                $scope.getMenuLink($scope.menu);
                        };

                        $scope.getMenuTitle = function(menu) {
                            return menu.menuId
                                ? menu.name
                                : $translate.instant(
                                    'title_create_menu_function',
                                    {
                                        menuType: $scope.getMenuTypeNameFromEnum(menuType)
                                    });
                        };

                        $scope.removeServicePeriod = function(servicePEriod) {

                        };

                        $scope.restoreMenuUrl = function(menu) {
                            $scope.menu.link = $scope.getMenuLink(menu, true);
                        };

                        $scope.restoreFunctionDate = function(menu) {
                            $scope.menu.functionDate = $scope.menu.originalFunctionDate;
                        };

                        $scope.updateServicePeriodRecipe = function(servicePeriodRecipe, property) {
                            
                            // Portions Sold
                            if (property == 'coversSold') {
                                // If not an integer, do not post the update to the backend
                                if (!validationHelper.isWholeNumber(servicePeriodRecipe[property], true))
                                    return;

                                // Force null when input is zero
                                if (servicePeriodRecipe[property] == '0')
                                    servicePeriodRecipe[property] = null;
                            }

                            if (servicePeriodRecipe[property] < 0) {
                                return;
                            }

                            menusService.updateServicePeriodRecipe(servicePeriodRecipe, $scope.menu.menuId).then(
                                function() {
                                    toastr.success($translate.instant('service_period_recipe_updated'));
                                    if (servicePeriodRecipe.sellingPrice == null ||
                                        servicePeriodRecipe.sellingPrice == '') {
                                        servicePeriodRecipe.sellingPrice =
                                            servicePeriodRecipe.recipeCosts.actualSellingPrice;
                                    }
                                });
                        };

                        $scope.validateMenu = function(menu, form) {
                            if (form == null) {
                                // Return true because we don't need to validate anything.
                                // eg. we've set the language which doesn't have a form.
                                return true;
                            }

                            if (!menu.menuId && form.menuUrl.$untouched) {
                                menu.link = $scope.formatLink(menu.name);
                            } else {
                                menu.link = $scope.formatLink(menu.link);
                            }

                            if (!menu.functionDate && $scope.isFunctionType()) {
                                menu.functionDate = dateService.getDate();
                            } else if (!$scope.isFunctionType()) {
                                // Enures a null date for Menu type
                                menu.functionDate = null;
                            }

                            return menu.name && menu.targetMargin && menu.link && (form != null ? form.$valid : true);
                        };

                        $scope.getCaloriesForRecipe = function(recipe) {
                            return nutrientAttributeHelper.find(recipe.attributes, enums.procurementSkuAttributes.kCal_per_portion).value;
                        }

                        $rootScope.$on('service-periods.drop',
                            function(event, el, target, source, sibling) {
                                $scope.disableAllServicePeriods = true;
                                el[0].parentElement.classList.add('disabled');
                                el[0].classList.add('dragula-dropped');
                                $timeout(function() {
                                        self.syncSortOrders($scope.menu.servicePeriods);
                                        menusService.updateServicePeriodSortOrders($scope.menu.servicePeriods).then(
                                            function() {
                                                el[0].parentElement.classList.remove('disabled');
                                                el[0].classList.add('dragula-splash');
                                                el[0].classList.remove('dragula-dropped');
                                                $timeout(function() {
                                                        el[0].classList.remove('dragula-splash');
                                                        $scope.disableAllServicePeriods = false;
                                                    },
                                                    dragulaAnimationSpeed);
                                            });
                                    },
                                    100);
                            });


                        $rootScope.$on('servicePeriodRecipes.drop',
                            function(event, el) {
                                $timeout(function() {
                                        var servicePeriod = _.findWhere($scope.menu.servicePeriods,
                                            { servicePeriodId: parseFloat(el[0].id) });
                                        el[0].classList.add('dragula-splash');
                                        el[0].classList.remove('dragula-dropped');
                                        self.syncSortOrders(servicePeriod.servicePeriodRecipes);
                                        menusService.updateServicePeriodRecipeSortOrders(servicePeriod).then(
                                            function() {
                                                $timeout(function() {
                                                        el[0].classList.remove('dragula-splash');
                                                    },
                                                    dragulaAnimationSpeed);
                                            });
                                    },
                                    100);
                            });

                        $scope.init = function() {
                            self.setRestorationProperties($scope.menu);
                            $scope.menuTypeName = $scope.getMenuTypeNameFromEnum(menuType);
                            self.setServicePeriodTypes();
                        }();
                    });
                // });
            }
        ]);

angular.module(appName)
    .controller("menuPortalController", [
        "$scope", "$rootScope", "oidcManager", "localStorageService", "enums", "myUnitsService",
        function ($scope, $rootScope, oidcManager, localStorageService, enums, myUnitsService) {
            $scope.allergens = [
                { id: 1, name: 'Celery / Celeriac' },
                { id: 2, name: 'Cereals Containing Gluten' },
                { id: 3, name: 'Crustaceans' },
                { id: 4, name: 'Egg' },
                { id: 5, name: 'Fish' },
                { id: 6, name: 'Lupin' },
                { id: 7, name: 'Milk' },
                { id: 8, name: 'Molluscs' },
                { id: 9, name: 'Mustard' },
                { id: 10, name: 'Nuts' },
                { id: 11, name: 'Peanuts' },
                { id: 12, name: 'Sesame' },
                { id: 13, name: 'Soya' },
                {
                    id: 14,
                    name: 'Sulphites (Sulphur Dioxides)'
                }
            ];
        }
    ]);
/*
 * Menus and Functions are the same entity in the DB. I am referring to them in the front end as just "Menus" for this reason.
 */

angular.module(appName)
    .controller('menusController', [
		'$scope',
		'$rootScope',
		'$q',
		'$translate',
		'localStorageService',
		'enums',
		'paginationFactory',
		'menuFunctionListData',
		'menusService',
		'toastr',
		'clientPreferences',
		'languages',
		function ($scope,
			$rootScope,
			$q,
			$translate,
			localStorageService,
			enums,
			paginationFactory,
			menuFunctionListData,
			menusService,
			toastr,
			clientPreferences,
			languages) {
		    $translate.onReady().then(function() {
		        var numPerPage = 25;

		        var self = this;
		        self.resolves = {
		            menuFunctionListData: menuFunctionListData,
		            clientPreferences: clientPreferences
		        };

		        self.setMenus = function(results) {
		            $scope.menus = results.list;
		            $scope.pagination.total = results.total;
		            $scope.pagination.currentPage = results.currentPage;
		        };
		        self.context = localStorageService.getItem('organisationContext');

		        self.getPreference = function(key) {
		            var pref = _.findWhere(self.clientSystemPreferences, { key: key });
		            return pref != null ? pref.value : null;
		        };

		        paginationFactory.addPaginationVariablesAndFunctionsToScope($scope, numPerPage);

		        $scope.cancelCopy = function() {
		            _.each($scope.menus,
		                function(menu) {
		                    menu.selectedForCopy = false;
		                });
		            $scope.showCopy = false;
		            $scope.copyDialog.toggle();
		        };

		        $scope.copyDialog = {
		            _unitPromise: $q.defer(),
					_element: null,
		            availableUnits: null,
		            getAvailableUnits: function() {
		                var dlg = this;
		                if (dlg.availableUnits == null) {
		                    return menusService.getAvailableUnitsToCopyTo().then(function(units) {
		                        dlg.availableUnits = units;
		                    });
		                } else {
		                    dlg._unitPromise.resolve(dlg.availableUnits);
		                    return dlg._unitPromise.promise;
		                }
		            },
		            currentUnit: {
		                id: self.context.currentSubscriptionUnit.client.id,
		                name: self.context.currentSubscriptionUnit.client.name
		            },
					removeUnit: function(unit) {
		            	unit.isSelected = false;
		            	this.selectDeselect(unit);
					},
		            selectedUnits: [],
		            show: false,
		            copyType: enums.menuCopyTypes.currentUnit,
		            toggle: function() {
		            	if (this._element == null) {
                            this._element = angular.element('#copy-dialog-container')[0];
						}
		                this.show = !this.show;
		            },
                    selectDeselect: function ($item) {
		            	var dlg = this;
		            	if ($item.isSelected) {
		            		dlg.selectedUnits.push($item);
						} else {
		            		_.removeIfExists(dlg.selectedUnits, $item);
						}
					},
                    copyToAllUnitsToggled: function() {
		            	this.copyType = enums.menuCopyTypes.allUnits;
					},
		            close: function() {
		                $scope.cancelCopy();
		            },
		            copy: function() {
		                var dlg = this;
		                var menuIds =
		                    _.chain($scope.menus)
		                        .filter(function(menu) {
		                            return menu.selectedForCopy === true;
		                        })
		                        .pluck('menuId')
		                        .value();
		                var clientIds = dlg.copyType === enums.menuCopyTypes.currentUnit ?
                            [dlg.currentUnit.id] : // currentUnit.id is actually the Client.id
							_.pluck(dlg.selectedUnits, 'id');
		                return menusService.copy(menuIds, clientIds).then(function(resp) {
		                    $scope.search().then(function() {
		                    	$translate('menus_copied_successfully').then(function (t) {
                                    toastr.success(t);
                                }).finally(function () {
                                    dlg.close();
                                });
		                    });
		                });
		            }
		        };

		        $scope.disableCopyButton = function() {
		            return _.findWhere($scope.menus, { selectedForCopy: true }) == null;
		        };

		        $scope.getMenuUrl = function(menu) {
		            var url;
		            if (menu.menuTypeId == enums.menuType.menu) {
		                url = '/Menu/';
		            } else {
		                url = '/Function/';
		            }
		            url += menu.menuId;
		            return url;
		        };

		        $scope.search = function(clearSearch, sortField) {
		            $scope.searching = true;
		            if (clearSearch) {
		                $scope.searchData = menusService.getDefaultSearchParams();
		                $scope.pagination.currentPage = 1;
		            }
		            if (sortField) {
		                $scope.searchData.sortField = sortField;
		                $scope.searchData.sortAsc = !$scope.sortOn.sortState || $scope.sortOn.sortState === 'Ascending';
		            }
		            return menusService.search($scope.searchData).then(function(results) {
		                self.setMenus(results);
		                $scope.searchData.id = null;
		                localStorageService.setItem(enums.localStorage.menuFunctionSearch, $scope.searchData);
		                var numberOfPages = $scope.numPages();
		                var currentPage = $scope.pagination.currentPage;
		                console.log('numberOfPages', numberOfPages);
		                console.log('currentPage', currentPage);
		                /*if (currentPage > numberOfPages) {
                            $scope.pagination.currentPage = numberOfPages;
                        }*/
		            }).finally(function() {
		                $scope.searching = false;
		            });
		        };

		        $scope.deleteMenu = function(menu) {
		            menu.deleting = true;
		            return menusService.deleteMenu(menu.menuId).then(function() {
		                var existingMenu = _.findWhere($scope.menus, { menuId: menu.menuId });
		                if (existingMenu) {
		                    _.removeIfExists($scope.menus, existingMenu);
		                }
		                if (menu.menuTypeId == enums.menuType.menu) {
		                    toastr.success($translate.instant('success_menu_deleted'));
		                } else {
		                    toastr.success($translate.instant('success_function_deleted'));
		                }
		            }).finally(function() {
		                menu.deleting = false;
		            });
		        };

		        $scope.init = function() {
		            $q.all(self.resolves).then(function(resolved) {
		                self.clientSystemPreferences = resolved.clientPreferences.systemPreferences;
		                $scope.searchData = localStorageService.getItem(enums.localStorage.menuFunctionSearch);
		                $scope.searchData.sortField = menusService.defaultSortField;
		                $scope.targetMarginType = self.getPreference(enums.clientPreferences.targetMarginType);
		                $scope.languages = languages;
		                self.setMenus(resolved.menuFunctionListData);

		                $scope.$watch('pagination.currentPage',
		                    function(newVal, oldVal) {
		                        if (newVal !== oldVal) {
		                            $scope.searchData.currentPage = newVal;
		                            $scope.search();
		                        }
		                    });
		            });
		        }();
		    });
		}
    ]);
angular.module(appName)
    .factory('menusResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/Menu';

            return $resource(api, {},
                {
                    addRecipesToServicePeriod: {
                        url: api + '/AddRecipesToServicePeriod',
                        method: 'POST',
                        isArray: true
                    },
                    copy: {
                        url: api + '/Copy',
                        method: 'POST'
                    },
                    create: {
                        url: api + '/Add',
                        method: 'POST'
                    },
                    delete: {
                        url: api + '/Delete',
                        method: 'DELETE'
                    },
                    deleteServicePeriod: {
                        url: api + '/DeleteServicePeriod',
                        method: 'DELETE'
                    },
                    deleteServicePeriodRecipe: {
                        url: api + '/DeleteServicePeriodRecipe',
                        method: 'DELETE'
                    },
                    getAvailableUnitsToCopyTo: {
                        url: api + '/GetAvailableUnitsToCopyTo',
                        params: {
                            currentSubscriptionId: '@currentSubscriptionId'
                        },
                        method: 'GET',
                        isArray: true
                    },
                    save: {
                        url: api + '/Update',
                        method: 'PUT'
                    },
                    createServicePeriod: {
                        url: api + '/AddServicePeriod',
                        method: 'POST'
                    },
                    removeRecipeCardHeaderImage: {
                        method: 'DELETE',
                        url: api + '/RemoveRecipeCardHeaderImage'
                    },
                    removeRecipeCardServicePeriodHeaderImage: {
                        method: 'DELETE',
                        url: api + '/RemoveRecipeCardServicePeriodHeaderImage'
                    },
                    removeSopHeaderImage: {
                        method: 'DELETE',
                        url: api + '/RemoveSopHeaderImage'
                    },
                    removeSopServicePeriodHeaderImage: {
                        method: 'DELETE',
                        url: api + '/RemoveSopServicePeriodHeaderImage'
                    },
                    saveMenuServicePeriod: {
                        url: api + '/UpdateServicePeriod',
                        method: 'PUT'
                    },
                    search: {
                        url: api + '/Search',
                        method: 'GET'
                    },
                    updateServicePeriodSortOrders: {
                        method: 'PUT',
                        url: api + '/UpdateServicePeriodSortOrders'
                    },
                    updateServicePeriodRecipe: {
                        method: 'PUT',
                        url: api + '/UpdateServicePeriodRecipe'
                    },
                    updateServicePeriodRecipeSortOrders: {
                        method: 'PUT',
                        url: api + '/UpdateServicePeriodRecipeSortOrders'
                    },

                //  SOP / Recipe Cards
                    uploadSopHeader: {
                        method: 'POST',
                        url: api + '/UploadSopHeader'
                    },
                    uploadSopServicePeriodImage: {
                        method: 'POST',
                        url: api + '/UploadSopHeader'
                    },
                    uploadRecipeCardHeader: {
                        method: 'POST',
                        url: api + '/UploadSopHeader'
                    },
                    uploadRecipeCardServicePeriodImage: {
                        method: 'POST',
                        url: api + '/UploadSopHeader'
                    }
                });
        }
    ])

angular.module(appName)
    .factory('menusService', [
        'menusResource', 'organisationContextService', '_', 'enums', 'validationHelper',
        function (menusResource, organisationContextService, _, enums, validationHelper) {

            var ctx = organisationContextService.getContext();
            var currentSubscriptionUnitClientId = ctx.currentSubscriptionUnit.client.id;
            var orgId = ctx.currentSubscriptionUnit.organisation.id;
            var defaultSearchParams = {
                organisationId: orgId,
                id: currentSubscriptionUnitClientId,
                numPerPage: 25,
                currentPage: 1,
                term: '',
                sortAsc: true,
                sortField: 'Name',
                menuType: enums.menuType.all
            };
            var emptyMenuObject = {
                clientId: currentSubscriptionUnitClientId,
                name: null,
                menuTypeId: 0
            };

            var addRecipesToServicePeriod = function (dto) {
                return menusResource.addRecipesToServicePeriod(dto).$promise;
            };

            var copy = function (menuIds, clientIds) {
                return menusResource.copy({ menuIds: menuIds, clientIds: clientIds }).$promise;
            };

            var get = function (menuId) {
                return menusResource.get({id: currentSubscriptionUnitClientId, menuId: menuId}).$promise;
            };

            var getAvailableUnitsToCopyTo = function () {
                return menusResource.getAvailableUnitsToCopyTo({ currentSubscriptionId: ctx.currentSubscriptionUnit.procurementSubscriptionId }).$promise;
            };

            var getDefaultSearchParams = function (menuType) {
                return angular.copy(defaultSearchParams);
            };

            var getNewMenu = function (menuType) {
                var menu = angular.copy(emptyMenuObject);
                menu.menuTypeId = menuType;
                return menu;
            };

            var removeRecipeCardHeaderImage = function(menuId) {
                return menusResource.removeRecipeCardHeaderImage({ menuId: menuId }).$promise;
            }
            var removeRecipeCardServicePeriodHeaderImage = function (menuServicePeriodId) {
                return menusResource.removeRecipeCardServicePeriodHeaderImage({ menuServicePeriodId: menuServicePeriodId }).$promise;

            }
            var removeSopHeaderImage = function (menuId) {
                return menusResource.removeSopHeaderImage({ menuId: menuId }).$promise;

            }
            var removeSopServicePeriodHeaderImage = function (menuServicePeriodId) {
                return menusResource.removeSopServicePeriodHeaderImage({ menuServicePeriodId: menuServicePeriodId }).$promise;

            }

            var save = function (menu) {
                // Required for Security
                menu.clientId = currentSubscriptionUnitClientId;
                if (menu.menuId) {
                    return menusResource.save(menu).$promise;
                } else {
                    return menusResource.create(menu).$promise;
                }
            };

            var saveMenuServicePeriod = function (servicePeriod) {
                if (servicePeriod.servicePeriodId) {
                    return menusResource.saveMenuServicePeriod(servicePeriod).$promise;
                } else {
                    return menusResource.createServicePeriod(servicePeriod).$promise;
                }
            };

			var search = function (searchData) {
				if (!searchData.id) {
					var clientId = organisationContextService.getContext().currentSubscriptionUnit.client.id;
					searchData.id = clientId;
				}
				searchData.organisationId =
					searchData.organisationId || organisationContextService.getContext().organisation.id;
				searchData.numPerPage = searchData.numPerPage || 10000;
				searchData.currentPage = searchData.currentPage || 1;
				searchData.term = searchData.term || "";
				searchData.recipeIds = searchData.recipeIds || [];
                return menusResource.search(searchData).$promise;
            };

            var deleteMenu = function (menuId) {
                return menusResource.delete({id: currentSubscriptionUnitClientId, menuId: menuId}).$promise;
            };

            var deleteServicePeriod = function (menuId, servicePeriodId) {
                return menusResource
                    .deleteServicePeriod({id: menuId, menuServicePeriodId: servicePeriodId})
                    .$promise;
            };

            var deleteServicePeriodRecipe = function (servicePeriodRecipeId, servicePeriodId) {

                return menusResource.deleteServicePeriodRecipe({
                    id: servicePeriodId,
                    servicePeriodRecipeId: servicePeriodRecipeId
                }).$promise;
            };

            var updateServicePeriodSortOrders = function (servicePeriods) {
                // We need to set Id to be MenuId for IBelongTo, and shuffle the ServicePeriod.Id into ServicePeriod.ServicePeriodId.
                var dto = {
                    id: servicePeriods[0].id,
                    servicePeriods:
                        _.map(servicePeriods,
                            function (sp) {
                                return {
                                    id: sp.menuId,
                                    servicePeriodId: sp.servicePeriodId,
                                    sortOrder: sp.sortOrder
                                };
                            })
                };
                return menusResource.updateServicePeriodSortOrders(dto).$promise;
            };

            var updateServicePeriodRecipe = function(servicePeriodRecipe, menuId) {
                /*if (!validationHelper.isWholeNumber(servicePeriodRecipe.coversSold) || !validationHelper.isLessThan(servicePeriodRecipe.coversSold, 1)) {
                    return; // Return out if we don't match the criteria
                }
*/
                var dto = {
                    id: menuId,
                    servicePeriodRecipe: servicePeriodRecipe
                };

                return menusResource.updateServicePeriodRecipe(dto).$promise;
            };

            var updateServicePeriodRecipeSortOrders = function (servicePeriod) {
                var dto = {
                    id: servicePeriod.menuId,
                    servicePeriodRecipes:
                        _.map(servicePeriod.servicePeriodRecipes,
                            function (spr) {
                                return {
                                    servicePeriodRecipeId: spr.servicePeriodRecipeId,
                                    sortOrder: spr.sortOrder
                                }
                            })
                };

                return menusResource.updateServicePeriodRecipeSortOrders(dto).$promise;
            };

            return {
                addRecipesToServicePeriod: addRecipesToServicePeriod,
                copy: copy,
                defaultSortField: 'Name',
                deleteMenu: deleteMenu,
                deleteServicePeriod: deleteServicePeriod,
                deleteServicePeriodRecipe: deleteServicePeriodRecipe,
                get: get,
                getAvailableUnitsToCopyTo: getAvailableUnitsToCopyTo,
                getDefaultSearchParams: getDefaultSearchParams,
                getNewMenu: getNewMenu,
                removeRecipeCardHeaderImage: removeRecipeCardHeaderImage,
                removeRecipeCardServicePeriodHeaderImage: removeRecipeCardServicePeriodHeaderImage,
                removeSopHeaderImage: removeSopHeaderImage,
                removeSopServicePeriodHeaderImage: removeSopServicePeriodHeaderImage,
                save: save,
                saveMenuServicePeriod: saveMenuServicePeriod,
                search: search,
                updateServicePeriodSortOrders: updateServicePeriodSortOrders,
                updateServicePeriodRecipe: updateServicePeriodRecipe,
                updateServicePeriodRecipeSortOrders: updateServicePeriodRecipeSortOrders
            }
        }
    ]);

'use strict';

angular.module(appName)
    .controller('myAccountController',
    [
        '$scope',       
        function ($scope) {

            var self = this;
            $scope.init = function() {

            }();

        }
    ]);
"use strict";

angular.module(appName).directive("myAccount", function () {
    var controller = [
        "$scope", "localStorageService", "enums", "userSearchResource", "$q",
        "manageUserResource", "$routeParams", "organisationContextService",
        "validationHelper", "$translate", "timezoneResource", 'translateMessage',
        function ($scope, localStorageService, enums, userSearchResource, $q,
            manageUserResource, $routeParams, organisationContextService,
            validationHelper, $translate, timezoneResource, translateMessage
        ) {
                    var self = this;
                    $scope.validationHelper = validationHelper;

                    $scope.changeUserLanguage = function (languageId) {
                        $scope.user.languageId = languageId;
                        $scope.saveUser($scope.user);
                    };

                    $scope.saveUser = function (user) {
                        var model = { id: self.context.id, userSearchDto: user };

                        function callback(model) {
                            translateMessage.success('success_user_updated');
                        }

                        switch ($scope.userContext) {
                            case "self":
                                return manageUserResource
                                    .updateCurrentOrImpersonatedUser(model)
                                    .$promise
                                    .then(callback);

                            case "others":
                                {
                                    return manageUserResource.updateUser(model)
                                        .$promise.then(callback, errorCallback);

                                }

                        }
                        return $q.defer().resolve();
                    };


                    $scope.resetPassword = function (user) {

                        var passwordModel = {};
                        passwordModel.oldPassword = user.currentPassword;
                        passwordModel.newPassword = user.newPassword;
                        passwordModel.Id = user.userId;

                        var successCallback = function (data) {
                            $translate('success_password_changed').then(function (translateKey1) {
                                translateMessage.success(translateKey1);
                            });
                            $scope.password = data.password;
                        };
                        switch ($scope.userContext) {
                            case "self":
                                //organisationId must be called id for the permission to work
                                return manageUserResource
                                    .changePassword(passwordModel)
                                    .$promise
                                    .then( successCallback);
                                break;
                            case "others":
                                return manageUserResource
                                    .changePassword(passwordModel)
                                    .$promise
                                    .then(successCallback);
                                break;
                            default:
                                throw 'Unknown user context';
                        }
                    };

                    $scope.comparePasswords = function (confirmPasswordField) {
                        if ($scope.user.newPassword !== $scope.user.confirmPassword) {
                            $scope.user.passwordsDoNotMatch = true;
                        } else {
                            $scope.user.passwordsDoNotMatch = false;
                        }
                    };


                    $scope.init = function () {

                        $scope.timezones = [];
                        timezoneResource.getAllTimezones().$promise.then(function (data) {
                            $scope.timezones = data;
                        });
                        self.context = localStorageService.getItem(enums.localStorage.organisationContext);

                        if (self.context.impersonatingUser) {
                            $scope.showLanguageChangeWarning = true;
                        }

                        $scope.loading = $q.defer();

                        switch ($scope.userContext) {
                            case "self":
                                {

                                    $scope.userId = self.context.user.id;
                                    $scope.organisationId = self.context.organisation ? self.context.organisation.id : 0;

                                    $scope.aPromise = manageUserResource
                                        .getCurrentOrImpersonatedUser()
                                        .$promise.then(function (data) {
                                            $scope.user = data.userDto;
                                            self.cachedUser = data.userDto;
                                            $scope.user.IsAdmin = localStorageService.getItem("isAdminUser").isAdmin;
                                            $scope.loading.resolve();
                                        });
                                    break;
                                }
                            case "others":
                                {
                                    $scope.userId = $routeParams.userId;
                                    $scope.organisationId = self.context.organisation ? self.context.organisation.id : 0;

                                    $scope.aPromise = userSearchResource
                                        .getUserForEdit({ userId: $scope.userId, organisationId: $scope.organisationId })
                                        .$promise.then(function (data) {
                                            $scope.user = data.userDto;
                                            self.cachedUser = data.userDto;
                                            $scope.loading.resolve();
                                        });
                                    break;
                                }
                        }


                    }();
                }
            ];

            return {
                restrict: "AE",
                scope: {
                    userContext: "@"
                },
                templateUrl: "/ngxbeagle/dist/Content/js/Modules/MyAccount/myAccountDirective.html",
                controller: controller
    };
});

angular.module(appName)
    .factory('accountingService', [
        'accountingResource',
        function (accountingResource) {
            return {
                addAccountingYear: function (accountingYearDto, cb) {
                    return accountingResource.addAccountingYear(accountingYearDto)
                        .$promise.then(function(data) {
                            cb(data);
                        });
                },
                addAccountingPeriods:function(accountingPeriodDtos, cb) {
                    return accountingResource.addAccountingPeriods(accountingPeriodDtos)
                        .$promise.then(function(data) {
                            cb(data);
                        });
                },
                getAccountingYearsBySubscriptionId: function(subscriptionId, cb) {
                    return accountingResource.getAccountingYearsBySubscriptionId({ id: subscriptionId })
                    .$promise.then(function(data) {
                        cb(data);
                    });
                },
                getAccountingPeriodsForYear:function(accountingYearId,cb) {
                    return accountingResource.getAccountingPeriodsForYear({accountingYearId:accountingYearId})
                    .$promise.then(function(data) {
                        cb(data);
                    });
                },
                deleteAccountingYear: function (id, cb) {
                    return accountingResource.deleteAccountingYear({ id: id })
                    .$promise.then(function (data) {
                        cb(data);
                    });
                },

                updateAccountingYear: function (accountingYearDto, cb) {
                    return accountingResource.updateAccountingYear(accountingYearDto)
                        .$promise.then(function (data) {
                            cb(data);
                        });
                },
                updateAccountingPeriods: function (accountingPeriodDtos, cb) {
                    return accountingResource.updateAccountingPeriods(accountingPeriodDtos)
                        .$promise.then(function (data) {
                            cb(data);
                        });
                },

            };
        }
    ]);
'use strict';

angular.module(appName)
    .controller('myUnitsController', [
        '$rootScope', '$scope', '$q', '$location', 'units', 'localStorageService', 'enums', 'myUnitsService','$window',
function ($rootScope, $scope, $q, $location, units, localStorageService, enums, myUnitsService, $window) {
          var self = this;

            $scope.units = [];
            $scope.currentSubscriptionUnit = {};

            $scope.selectUnit = function (unit, redirectToDashboard) {
                $scope.currentSubscriptionUnit = unit;
                var procurementSubscriptionUnits = _.filter(units, function (myUnit) {
                    return myUnit.procurementSubscriptionId === unit.procurementSubscriptionId;
                });

                myUnitsService.getProcurementSubscription($scope.currentSubscriptionUnit.procurementSubscriptionId, function (data) {
                    //set group
                    console.log("login data", data);
                    if ($scope.context === undefined || $scope.context === null) {
                        $scope.context = {};
                    }
                    $scope.context.organisation = data.organisation;
                    $scope.context.currency = data.currency;
                    $scope.context.id = data.id;
                    $scope.context.logoUrl = data.logoUrl;
                    $scope.context.procurementSubscriptionType = data.procurementSubscriptionType;
                    $scope.context.siteColour = data.siteColour;
                    $scope.context.user = data.user;
                    $scope.context.impersonatingUser = data.impersonatingUser;
                    //set other
                    $scope.context.currentSubscriptionUnit = $scope.currentSubscriptionUnit;
                    $scope.context.procurementSubscriptionUnits = procurementSubscriptionUnits;

                    localStorageService.setItem(enums.localStorage.organisationContext, $scope.context);
                    console.log("broadcasting context updated from my units controller");
                    $rootScope.$broadcast(enums.broadcasts.updatedContext, { context: $scope.context });

                    if (redirectToDashboard)
                    {
                        //Changed this to try and force the page loading as sometimes the page wasn't loading data
                        $location.path('/Dashboard');
                    }

                });
            }

            $scope.showSelectButton = function (unit) {
                if ($scope.currentSubscriptionUnit) {
                    if (unit.id === $scope.currentSubscriptionUnit.id) {
                        return false;
                    }
                }
                return true;
            }

            $scope.init = function () {
                $scope.units = units;
                $scope.context = localStorageService.getItem(enums.localStorage.organisationContext);
                if ($scope.context) {
                    $scope.currentSubscriptionUnit = $scope.context.currentSubscriptionUnit;
                }

                if ($scope.units.length == 1) {
                    $scope.selectUnit($scope.units[0], true)
                } 
            }();
        }]);
'use strict';

angular.module(appName)
    .factory('myUnitsResource', [
        '$resource', "siteUrl", function ($resource, siteUrl) {
            return $resource(siteUrl() + "api/MyUnitsController", {},
                {
                    getUnits: {
                        method: "GET",
                        url: siteUrl() + "api/MyUnitsController/GetUnits",
                        params: {
                            id:"@id",
                            userId: "@userId"
                        },
                        isArray: true
                    },
                    getProcurementSubscription: {
                        method: "GET",
                        url: siteUrl() + "api/ProcurementSubscription/GetProcurementSubscriptionFromId",
                        data: {
                            id: "@id"
                        }
                    },
                    getTheme: {
                        method: "GET",
                        url: siteUrl() + "/api/MyUnitsController/GetTheme"
                    },
                    getUnitName: {
                        method: "GET",
                        url: siteUrl() + "/api/MyUnitsController/GetUnitName",
                        params: {
                            id: 'id'
                        }
                    }
                });
        }
    ]);
angular.module(appName)
    .factory('myUnitsService', [
        '$rootScope', 'myUnitsResource', 'localStorageService', 'enums',
        function ($rootScope, myUnitsResource, localStorageService, enums) {

            var service = {
                getUnits: function (id,userId, callback) {
                    return myUnitsResource.getUnits({id:id, userId: userId }).$promise.then(function (data) {
                        return callback(data);
                    });
                },
                getProcurementSubscription: function (id, callback) {
                    return myUnitsResource.getProcurementSubscription({ id: id }).$promise.then(function (data) {
                        return callback(data);
                    });
                },
                getTheme: function(callback) {
                    return myUnitsResource.getTheme().$promise.then(function (theme) {
                        var ctx = localStorageService.getItem(enums.localStorage.organisationContext)

                        if (ctx != null) {
                            ctx.siteColour = theme.siteColour;
                            ctx.logoUrl = theme.logoUrl;
                        } else {
                            ctx = {
                                siteColour: theme.siteColour,
                                logoUrl: theme.logoUrl
                            };
                        }
                        localStorageService.setItem(enums.localStorage.organisationContext, ctx);
                        $rootScope.$broadcast(enums.broadcasts.updatedContext, { context: ctx });
                    });
                },
                getUnitName: function(id) {
                    return myUnitsResource.getUnitName({ id: id });
                }
            };

            return service;
        }
    ]);
angular.module(appName)
    .controller('nutrientApprovalsController', [
        '$scope',
        '$q',
        '$translate',
        '_',
        'approvalData',
        'rejectionReasonData',
        'countData',
        'localStorageService',
        'enums',
        'nutrientApprovalsService',
        'toastr',
        function (
            $scope,
            $q,
            $translate,
            _,
            approvalData,
            rejectionReasonData,
            countData,
            localStorageService,
            enums,
            nutrientApprovalsService,
            toastr
        ) {
            var self = this;
            self.resolves = {
                approvalData: approvalData,
                rejectionReasonData: rejectionReasonData,
                countData: countData
            }

            var mapApprovalRequests = function () {
                return _.chain($scope.vm.approvals)
                    .filter(function (approval) {
                        return isValidApproval(approval)
                    })
                    .map(function (approval) {
                        return {
                            id: approval.id,
                            skuId: approval.sku.id,
                            rejectionReasonId: approval.approvalStatusId === enums.nutrients.approvalStatuses.rejected ? approval.rejectionReasonId : null,
                            approvalStatusId: approval.approvalStatusId
                        }
                    })
            }

            var isValidApproval = function(approval) {
                return approval.approvalStatusId === enums.nutrients.approvalStatuses.approved ||
                    (approval.approvalStatusId === enums.nutrients.approvalStatuses.rejected && approval.rejectionReasonId != null);
            }

            function removeSavedApprovals (approvalRequests) {
                var savedApprovalIds = _(approvalRequests).pluck('id').value();
                $scope.vm.approvals = _($scope.vm.approvals).filter(function(approval) {
                    return !_(savedApprovalIds).contains(approval.id);
                })
                $scope.vm.counts.skuCount =
                    _.chain($scope.vm.approvals)
                        .map(function (approval) {
                            return approval.sku.id
                        })
                        .uniq()
                        .value()
                        .length
            }

            $scope.vm = {
                approvals: null,
                approveOrRejectAll: function(value) {
                    for (var i = 0; i < $scope.vm.approvals.length; i++) {
                        $scope.vm.approvals[i].approvalStatusId = value;
                    }
                },
                counts: null,
                disableSave: function() {
                    var approvalsValid = _($scope.vm.approvals).every(function(approval) {
                        return approval.approvalStatusId !== enums.nutrients.approvalStatuses.rejected ||
                            (approval.approvalStatusId === enums.nutrients.approvalStatuses.rejected && approval.rejectionReasonId != null)
                    })
                    return approvalsValid === false;
                },
                enums: enums,
                filter: '',
                filterApprovals: function() {
                    var vm = this;
                    _(vm.approvals).each(function(approval) {
                        if (!vm.filter) {
                            approval.hide = false;
                            return;
                        }

                        approval.hide =
                            approval.sku.skuCode.indexOf(vm.filter) < 0 ||
                            approval.sku.skuDescription.indexOf(vm.filter) < 0
                    })
                },
                filteredApprovals: null,
                getInvalidApprovalCount: function() {
                    return _($scope.vm.approvals).filter(function(approval) { return !isValidApproval(approval) }).length
                },
                isValidApproval: isValidApproval,
                rejectionReasons: null,
                saving: false,
                submitApprovals: function() {
                    $scope.vm.saving = true;
                    var dto = {
                        approvalRequests: mapApprovalRequests()
                    }
                    return nutrientApprovalsService.post(dto).then(function(resp) {
                        toastr.success($translate.instant('approvals_saved'));
                        removeSavedApprovals(dto.approvalRequests);
                    })
                },
                tryDeselect: function(approval, approvalStatus) {
                    if (approval.approvalStatusId != null &&
                        approvalStatus === approval.lastStatusId) {
                        approval.approvalStatusId = null;
                        approval.lastStatusId = null;
                    } else {
                        approval.lastStatusId = approvalStatus;
                    }
                }
            }

            const init = function () {
                $scope.isAdminUser = localStorageService.getItem(enums.localStorage.isAdminUser)
                $q.all(self.resolves).then(function(resolved) {
                    $scope.vm.approvals = resolved.approvalData.data || [];
                    $scope.vm.filteredApprovals = $scope.vm.approvals;
                    $scope.vm.counts = resolved.countData.data;
                    $scope.vm.rejectionReasons = resolved.rejectionReasonData.data
                })
            }
            init()
        }
    ])

angular.module(appName)
    .factory('nutrientApprovalsService', [
            '$http',
            'siteUrl',
            'localStorageService',
            'enums',
            function (
                $http,
                siteUrl,
                localStorageService,
                enums
            ) {
                var baseUrl = siteUrl() + 'api/ProcurementSubscriptionSkuAttributeApprovals'
                return {
                    get: function () {
                        var subscriptionId = localStorageService.getItem(enums.localStorage.organisationContext).id
                        return $http.get(baseUrl + '/get/' + subscriptionId)
                    },
                    getRejectionReasons: function () {
                        return $http.get(baseUrl + '/get-rejection-reasons')
                    },
                    post: function(dto) {
                        dto.procurementSubscriptionId = localStorageService.getItem(enums.localStorage.organisationContext).id;
                        return $http.post(baseUrl, dto);
                    }
                }
            }
        ]
    )

angular.module(appName)
  .directive('orderGuideDetailsComponent', function () {
    var controller = [
      '$scope',
      '$location',
      '$translate',
      'clientUnitDepartmentService',
      'enums',
      'localStorageService',
      'organisationContextService',
      'orderGuidesService',
      'userService',
      'basketService',
      'moment',
      function ($scope,
                $location,
                $translate,
                clientUnitDepartmentService,
                enums,
                localStorageService,
                organisationContextService,
                orderGuidesService,
                userService,
                basketService,
                moment) {
        var self = this;
        self.ctx = organisationContextService.getContext();
        $scope.enums = enums;
        $scope.originalOrderGuideName = '';
        $scope.deliveryDays = [
          1,
          3,
          6
        ];
        $scope.userHasPermissions = {
          edit: false
        };
        $scope.hrefs = orderGuidesService.hrefs;

        $scope.createOrderGuide = function () {
          return orderGuidesService.create($scope.orderGuide).then(function (data) {
            $translate('success_order_guide_created').then(function (t) {
              toastr.success(t);
              $location.path($scope.hrefs.view(data.id));
              $scope.originalOrderGuideName = $scope.orderGuide.name;
            });
          });
        };

        $scope.download = function () {
          $scope.downloadingOrderGuide = true;
        };

        $scope.saveOrderGuide = function () {
          if (!$scope.orderGuide || !$scope.orderGuide.id) {
            return;
          }
          return orderGuidesService.update($scope.orderGuide).then(function (data) {
            $translate('success_order_guide_saved').then(function (t) {
              toastr.success(t);
            });
            $scope.originalOrderGuideName = $scope.orderGuide.name;
          });
        };

        $scope.restoreOrderGuideName = function () {
          $scope.orderGuide.name = $scope.originalOrderGuideName;
        };

        userService.hasPermission('BEAGLE_CAN_EDIT_ORDER_GUIDES').then(function () {
          $scope.userHasPermissions.edit = true;
        });

        $scope.replaceBasketItem = function (args) {
          return orderGuidesService.replaceBasketItem(args.currentBasketItem, args.alternativeProduct, args.availableClientSupplierAccounts);
        };

        $scope.test = function (form) {
          form.ogName.$error.lol = true;
        };

        $scope.exportToExcel = function () {
          var format = localStorageService.getItem('user-timezone').format;
          var date = moment($scope.orderGuide.exportDate || new Date(), format).format('YYYY-MM-DD');
          var filename = self.ctx.currentSubscriptionUnit.organisation.name + '_' + $scope.orderGuide.name + '_' + date;
          switch ($scope.orderGuide.sheetType) {
            case enums.orderSheetTypes.orderGuide:
              return orderGuidesService.exportOrderGuideToExcel($scope.orderGuide.id, filename);
            case enums.orderSheetTypes.orderSheet:
              return orderGuidesService.exportOrderSheetToExcel($scope.orderGuide.id, filename, date);
          }
        }

        $scope.init = function () {
          if ($scope.orderGuide && $scope.orderGuide.id) {
            // We have managed to pass an OrderGuide into the component. Setup the data using the OrderGuide properties
            $scope.originalOrderGuideName = $scope.orderGuide.name;
            $scope.orderGuide.procurementClientUnitDepartment = _.findWhere($scope.departmentsForUser, {id: $scope.orderGuide.procurementClientUnitDepartment.id});
          } else {
            // We don't have an OrderGuide. We need to setup the appropriate properties using defaults.
            $scope.orderGuide.procurementClientUnitDepartment = clientUnitDepartmentService.getDefaultDepartmentForUser($scope.departmentsForUser);
            $scope.orderGuide.procurementSubscriptionUnitId = self.ctx.currentSubscriptionUnit.id;
            $scope.orderGuide.numberOfDeliveryDays = 3;
            $scope.orderGuide.organisationContactIds = [];
          }
          $scope.$watch("orderGuide.organisationContactIds", function (newOrgContactIds, oldOrgContactIds) {
            if (_.isUndefined(oldOrgContactIds) || angular.equals(newOrgContactIds, oldOrgContactIds)) {
              return;
            }
            orderGuidesService.saveOrgContacts($scope.orderGuide.id, newOrgContactIds).then(function () {
              $translate('success_order_guide_saved').then(function (translation) {
                toastr.success(translation);
              });
            });
          }, true);
        }();
      }
    ];

    return {
      controller: controller,
      scope: {
        orderGuide: '=',
        departmentsForUser: '=',
        existingOrderGuideNames: '='
      },
      templateUrl: '/ngxbeagle/dist/Content/js/Modules/OrderGuides/Directives/orderGuideDetailsComponent.html'
    }
  });

angular.module(appName)
    .directive('orderGuideEmailDropdownControl', ['orderGuidesService', function (orderGuidesService) {
		return {
			link: function (scope) {
                orderGuidesService.getNotificationEmailUserList(scope.subscriptionId).then(function (result) {
					scope.options = result;
				});
				scope.hasChanged = function () {
					if (scope.ngChange) {
						scope.ngChange(scope.ngModel);
					}
				}
			},
			scope: {
				ngModel: "=",
                ngChange: "&",
                subscriptionId:"=?"
			},
            templateUrl: '/ngxbeagle/dist/Content/js/Modules/OrderGuides/Directives/orderGuideEmailDropdownControl.html'
        }
    }]);

angular.module(appName)
    .controller('orderGuidesCreateEditController', [
        '$scope', '$q', '$translate', 'orderGuidesService', 'clientSheetTypeData', 'orderGuideData', 'departmentsData', 'existingOrderGuideNames',
        function ($scope, $q, $translate, orderGuidesService, clientSheetTypeData, orderGuideData, departmentsData, existingOrderGuideNames) {
            var self = this;
            $scope.orderGuide = {};
            self.resolves = {
                orderGuideData: orderGuideData,
                clientSheetTypeData: clientSheetTypeData,
                departmentsData: departmentsData,
                existingOrderGuideNames: existingOrderGuideNames
            };

            $scope.getHeader = function() {
                if ($scope.orderGuide.id) {
                    return $translate.instant('edit_order_guide', { name: $scope.orderGuide.name })
                } else {
                    return $translate.instant('create_order_guide');
                }
            };

            $q.all(self.resolves).then(function (resolved) {
                if (resolved.orderGuideData) {
                    $scope.orderGuide = resolved.orderGuideData;
                } else {
                  $scope.orderGuide.sheetType = resolved.clientSheetTypeData.clientSheetType;
                }
                if (resolved.departmentsData)
                    $scope.departmentsForUser = resolved.departmentsData;
                if (resolved.existingOrderGuideNames) {
                    // If we are loading up an existing OrderGuide then we need to remove the current name from the existing names away otherwise we can't Save.
                    if ($scope.orderGuide.id) {
                        $scope.existingOrderGuideNames = _.without(resolved.existingOrderGuideNames, $scope.orderGuide.name);
                    } else {
                        // We are loading up the create view - do no filtering.
                        $scope.existingOrderGuideNames = resolved.existingOrderGuideNames;
                    }
                }
            });
        }
    ]);

angular.module(appName)
    .controller('orderGuidesListController', [
        '$scope', '$q', '$translate', 'orderGuidesService', 'orderGuideListData', 'helpers', 'enums', 'userService', 'shoppingListService',
        function ($scope, $q, $translate, orderGuidesService, orderGuideListData, helpers, enums, userService, shoppingListService) {
            var self = this;
            $scope.orderGuides = [];
            /*$scope.sortOn = {
                column: 'name',
                sortState: 'Ascending',
                filterExpr: '+name'
            }*/
            $scope.filterModel = {
                term: '',
                newTerm: ''
            };
            $scope.userHasPermissions = {
                edit: false
            };
            $scope.hrefs = orderGuidesService.hrefs;
            $scope.tableColumns = [
                {label: 'name', sortOn: 'name'},
                {label: 'department', sortOn: 'departmentDescription'},
                {label: 'label_number_of_items', sortOn: 'numberOfItems'}
            ];
            self.resolves = {
                orderGuideListData: orderGuideListData
            };

            $scope.actionChevron = function (orderGuide) {
                return orderGuide.showActions ? 'fa-chevron-up' : 'fa-chevron-down';
            };

            $scope.applyFilter = function (newTerm) {
                $scope.filterModel.term = newTerm;
            };

            $scope.convertOrderGuidesToShoppingLists = function() {
                return orderGuidesService.convertOrderGuidesToShoppingLists().then(function() {
                    window.location = shoppingListService.hrefs.root;
                });
            };

            $scope.filterOrderGuides = function (term) {
                return function (og) {
                    return helpers.contains(og.name, term) ||
                        helpers.contains(og.departmentDescription, term) ||
                        helpers.contains(og.numberOfItems, term);
                }
            };

            $scope.deleteOrderGuide = function (orderGuide) {
                orderGuide.deleting = true;
                return orderGuidesService.deleteOrderGuide(orderGuide.id).then(function () {
                    $translate('success_order_guide_deleted', { orderGuideName: orderGuide.name }).then(function (t) {
                        toastr.success(t);
                    });
                    $scope.orderGuides = _.removeIfExists($scope.orderGuides, orderGuide);
                }).finally(function () {
                    orderGuide.deleting = false;
                });
            };

            $scope.toggleActions = function (orderGuide) {
                orderGuide.showActions = !orderGuide.showActions;
            };

            userService.hasPermission('BEAGLE_CAN_EDIT_ORDER_GUIDES').then(function() {
                $scope.userHasPermissions.edit = true;
            });

            userService.hasPermission('EPROCUREMENTADMIN').then(function() {
                $scope.userIsAdmin = true;
            });

            $scope.$on(enums.eventNames.sortOnElementChangedEventName, function (evt, element, sortOn) {
                $scope.sortOn = sortOn;
                $scope.$apply();
            });

            $q.all(self.resolves).then(function (resolved) {
                $scope.orderGuides = resolved.orderGuideListData;
            });
        }
    ]);
angular.module(appName)
    .factory('orderGuidesResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/OrderGuides/';
			return $resource(api, {}, {
				create: {
					method: 'POST',
					url: api + 'Create'
				},
				convertOrderGuidesToShoppingLists: {
					method: 'POST',
					url: api + 'ConvertOrderGuidesToShoppingLists'
				},
				deleteOrderGuide: {
					method: 'DELETE',
					url: api + 'Delete'
				},
				get: {
					method: 'GET',
					url: api + 'Get',
					params: {
						id: '@id',
            updatePrices: '@updatePrices'
					}
				},
				getAllForUnit: {
					method: 'GET',
					url: api + 'GetAllForUnit',
					isArray: true
				},
				getOrderGuideNamesInUnit: {
					method: 'GET',
					url: api + 'GetOrderGuideNamesInUnit',
					isArray: true
				},
				getOrderGuideDataForProductSearch: {
					method: 'GET',
					url: api + '/getOrderGuideDataForProductSearch',
					params: {
						orderGuideId: '@orderGuideId'
					}
				},
				getNotificationEmailUserList: {
					method: 'GET',
					url: api + 'getNotificationEmailUserList',
					isArray: true,
					params: {
						subscriptionUnitId: '@subscriptionUnitId'
					}
				},
                replaceBasketItem: {
                    method: "POST",
                    url: api + '/ReplaceBasketItem'
                },
                update: {
                    method: 'POST',
                    url: api + 'Update'
				},
				saveOrgContacts: {
					method: "POST",
					url: api + "/SaveOrgContacts"
				}
            });
        }
    ]);

angular.module(appName)
  .factory('orderGuidesService', [
    '$q',
    'cachedEntityService',
    'localStorageService',
    'orderGuidesResource',
    'organisationContextService',
    'replaceProductService',
    'procurementSegmentItemService',
    'fileDownloadService',
    'siteUrl',
    '$http',
    'enums',
    function ($q,
              cachedEntityService,
              localStorageService,
              orderGuidesResource,
              organisationContextService,
              replaceProductService,
              procurementSegmentItemService,
              fileDownloadService,
              siteUrl,
              $http,
              enums) {
      var ctx = organisationContextService.getContext();
      /**
       * Creates a new OrderGuide and returns the new Id to the client.
       * @param orderGuide OrderGuideDto to create the new OrderGuide from.
       * @returns {guid} Id of the newly created OrderGuide.
       */
      var create = function (orderGuide) {
        return orderGuidesResource.create(orderGuide).$promise;
      };

      /**
       * Converts all unit Order Guides into Shopping Lists.
       */
      var convertOrderGuidesToShoppingLists = function () {
        return $http.post('/api/OrderGuides/ConvertOrderGuidesToShoppingLists?id=' + ctx.currentSubscriptionUnit.id);
        // return orderGuidesResource.convertOrderGuidesToShoppingLists(ctx.currentSubscriptionUnit.id).$promise;
      };

      /**
       * Deletes an OrderGuide with the given id. Performs IBelongTo checks on the server.
       * @param id Id of the OrderGuide to delete.
       */
      var deleteOrderGuide = function (id) {
        return orderGuidesResource.deleteOrderGuide({id: id}).$promise;
      }

      /**
       * Gets an OrderGuide from the server if an id is passed, otherwise returns an empty promise.
       * @param id Id of the OrderGuide to retrieve from the server.
       * @returns {OrderGuide} The OrderGuide from the server.
       */
      var get = function (id) {
        var deferred = $q.defer();
        if (!id) {
          // The empty resolve allows us to reuse the ViewEdit
          deferred.resolve();
          return deferred.promise;
        }

        var cacheExpired = cachedEntityService.cachedEntityHasExpired(id);
        return orderGuidesResource.get({id: id, updatePrices: cacheExpired}).$promise.then(function(orderGuide) {
          if (cacheExpired) {
            cachedEntityService.cacheEntity(id);
          }

          deferred.resolve(orderGuide);
          return deferred.promise;
        });
      };

      /**
       * Gets an array of OrderGuides for the current SubscriptionUnit by SubscriptionUnitId.
       * @param subscriptionUnitId The id of the current SubscriptionUnit.
       * @returns {OrderGuide[]} Array of OrderGuides for the current SubscriptionUnit.
       */
      var getAllForUnit = function (subscriptionUnitId) {
        return orderGuidesResource.getAllForUnit({id: subscriptionUnitId}).$promise;
      };

      /**
       * Returns an array of all OrderGuide names already existing in the current SubscriptionUnit.
       * @param subscriptionUnitId The id of the current SubscriptionUnit.
       * @returns {string[]} Array of OrderGuide names in the unit.
       */
      var getOrderGuideNamesInUnit = function (subscriptionUnitId) {
        return orderGuidesResource.getOrderGuideNamesInUnit({id: subscriptionUnitId}).$promise;
      };

      var getOrderGuideDataForProductSearch = function (orderGuideId, segmentId) {
        return orderGuidesResource.getOrderGuideDataForProductSearch({
          orderGuideId: orderGuideId,
          segmentId: segmentId
        }).$promise;
      };

      var replaceBasketItem = function (currentSegmentItem, replacementProduct, availableClientSupplierAccounts) {
        replacementProduct.searchDto = {
          searchCriteria: {
            savedSearchType: enums.savedSearchTypes.skuSearchExactSku
          }
        }
        var procurementItemDto = replaceProductService.createReplaceDto(currentSegmentItem.procurementItemDto, replacementProduct, availableClientSupplierAccounts);
        var model = procurementSegmentItemService.createSegmentItemReplaceProductDto(currentSegmentItem, procurementItemDto);

        return orderGuidesResource.replaceBasketItem(model).$promise;
      };

      var update = function (model) {
        var dto = angular.copy.model;
        var dto = {
          id: model.id,
          organisationId: organisationContextService.getOrganisationIdForCurrentProcurementUnit(),
          name: model.name,
          clientProcurementDepartmentId: model.procurementClientUnitDepartment.clientProcurementDepartmentId,
          procurementClientUnitDepartmentId: model.procurementClientUnitDepartment.id,
          procurementSubscriptionUnitId: model.procurementSubscriptionUnitId,
          numberOfDeliveryDays: model.numberOfDeliveryDays,
          notifiedUserIds: model.notifiedUserIds,
          sheetType: model.sheetType
        };
        return orderGuidesResource.update(dto).$promise;
      };

      var exportOrderGuideToExcel = function (procurementBaskedId, orderGuideName) {
        var url = siteUrl() + "api/OrderGuides/ExportOrderGuideToExcel/" + procurementBaskedId;
        return fileDownloadService.downloadFile(url, orderGuideName || 'order-guide', 'xlsx');
      };

      var exportOrderSheetToExcel = function (procurementBaskedId, orderGuideName, exportDate) {
        var url = siteUrl() + "api/OrderGuides/ExportOrderSheetToExcel/" + procurementBaskedId
          + '?exportDate=' + exportDate
          + '&clientName=' + localStorageService.getItem('organisationContext').currentSubscriptionUnit.client.name;
        return fileDownloadService.downloadFile(url, orderGuideName || 'order-sheet', 'xlsx');
      };

      var hrefs = {
        root: '/OrderGuides/',
        create: function () {
          return '/OrderGuide'
        },
        view: function (id) {
          return this.create() + '/' + id
        }
      };

        var getNotificationEmailUserList = function (subscriptionId) {
            //var mySubscriptionId = subscriptionId ?? ctx.currentSubscriptionUnit.id; --> Older environment does not compile nullish coalescing operator
            var mySubscriptionId = subscriptionId || ctx.currentSubscriptionUnit.id;
            return orderGuidesResource.getNotificationEmailUserList({ subscriptionUnitId: mySubscriptionId }).$promise;
      }

      var saveOrgContacts = function (orderGuideId, orgContactIds) {
        return orderGuidesResource.saveOrgContacts({
          orderGuideId: orderGuideId,
          organisationContactIds: orgContactIds
        }).$promise;
      }

      return {
        create: create,
        convertOrderGuidesToShoppingLists: convertOrderGuidesToShoppingLists,
        deleteOrderGuide: deleteOrderGuide,
        get: get,
        getAllForUnit: getAllForUnit,
        getOrderGuideNamesInUnit: getOrderGuideNamesInUnit,
        getOrderGuideDataForProductSearch: getOrderGuideDataForProductSearch,
        update: update,
        hrefs: hrefs,
        replaceBasketItem: replaceBasketItem,
        exportOrderGuideToExcel: exportOrderGuideToExcel,
        exportOrderSheetToExcel: exportOrderSheetToExcel,
        getNotificationEmailUserList: getNotificationEmailUserList,
        saveOrgContacts: saveOrgContacts
      }
    }
  ]);

'use strict';

angular.module(appName)
    .controller('createEditPriceListsController', ['$scope', '$timeout', 'priceList', '$route', 'priceListsService', '$location', 'localStorageService', 'enums', '$translate', 'userService', 'fileDownloadService',
        function ($scope, $timeout, priceList, $route, priceListsService, $location, localStorageService, enums, $translate, userService, fileDownloadService) {
            $scope.filter = {};
            $scope.uniqueClientUnits = "";
            $scope.context = {};
            $scope.selectedUnits = [];
            $scope.accountsToAdd = null;
            $scope.userCanEdit = false;
            $scope.descriptionIsUnique = true;

            $scope.init = function () {
                userService.hasPermission('BEAGLE_CAN_CREATE_EDIT_PRICELISTS').then(function () {
                    $scope.userCanEdit = true;
                });
                $scope.showSearchForAccounts = false;
                if (priceList) {
                    $scope.priceList = priceList
                } else {
                    $scope.priceList = {};
                    $scope.priceList.name = null;
                    $scope.priceList.id = null;
                    $scope.priceList.accounts = [];
                    $scope.priceList.organisationContactIds = [];
                }
                var currentSubscriptionUnit = localStorageService.getItem(enums.localStorage.organisationContext).currentSubscriptionUnit;
                $scope.context.organisationId = currentSubscriptionUnit.organisation.id;
                $scope.context.clientId = currentSubscriptionUnit.client.id;
                $scope.$watch("priceList.organisationContactIds", function (newOrgContactIds, oldOrgContactIds) {
                    if (!$scope.priceList.id || _.isUndefined(oldOrgContactIds)) {
                        return;
                    }
                    priceListsService.saveOrgContacts($scope.priceList.id, newOrgContactIds).then(function () {
                        $translate('saved_price_list').then(function (translation) {
                            toastr.success(translation);
                        });
                    });
                }, true);
            }();


            var savePriceListTimeout;
            $scope.savePriceList = function (priceListForm) {
                $timeout.cancel(savePriceListTimeout);
                if ($scope.priceList.name)
                savePriceListTimeout = $timeout(function() {
                    $scope.checkDescriptionIsUnique(priceListForm).then(function() {
                        return priceListsService.editPriceList({
                            id: $scope.priceList.id,
                            name: $scope.priceList.name,
                            clientId: $scope.context.clientId,
                            organisationContactIds: $scope.priceList.organisationContactIds
                        }).then(function () {
                            $translate('saved_price_list').then(function (translation) {
                                toastr.success(translation);
                            });
                        });
                    });
                }, 600);
            };

            $scope.createPriceList = function () {
                if ($scope.priceList.name) {
                    return priceListsService.addPriceList(
                        {
                            id: $scope.priceList.id,
                            name: $scope.priceList.name,
                            clientId: $scope.context.clientId,
                            organisationContactIds: $scope.priceList.organisationContactIds
                        })
                        .then(function (data) {
                            $scope.priceList.id = data.id;
                            $route.updateParams({priceListId: data.id});
                            $translate('added_price_list').then(function (translation) {
                                toastr.success(translation);
                            });
                        });
                }
            };

            $scope.removeAccountFromPriceList = function (account) {
                priceListsService.removeAccountFromPriceList({
                    accountId: account.clientSupplierAccountId,
                    orderSheetId: $scope.priceList.id,
                    clientId: $scope.context.clientId
                }, $scope.context.clientId).then(function () {
                    updatePriceList().then(function() {
                        $translate('account_removed_from_price_list').then(function (translation) {
                            toastr.success(translation);
                        });
                    });
                });
            };

            $scope.downloadPriceList = function () {
                var formattedDate =
                    moment($scope.pricingDate, "DD-MM-YYYY")
                        .format("MM-DD-YYYY"); //This is needed for downloadPricelist

                var url = 'Api/PriceLists/DownloadPriceList?clientId=' +
                    $scope.context.clientId +
                    '&pricesBegin=' +
                    formattedDate +
                    '&priceListId=' +
                    $scope.priceList.id;
                return fileDownloadService.downloadFile(url, $scope.priceList.name, 'xlsx');
            };

            $scope.searchForAccounts = function () {
                var clientUnitsIdsToFilter = _.chain($scope.uniqueClientUnits)
                    .where({isSelected: true})
                    .map(function (clientUnit) {
                        return clientUnit.id;
                    })
                    .value();

                var clientUnitsIdsToFilterCSV = "";
                if (!(clientUnitsIdsToFilter.length == $scope.uniqueClientUnits.length || $scope.uniqueClientUnits == null)) {
                    if (clientUnitsIdsToFilter.length > 0) {
                        clientUnitsIdsToFilterCSV = clientUnitsIdsToFilter.join(",");
                    } else {
                        clientUnitsIdsToFilterCSV = "empty";
                    }
                }

                if ($scope.filter.accountsSearchText) {
                    $scope.filter.accountsSearchText == $scope.filter.accountsSearchText.toLowerCase();
                }

                return priceListsService.searchForAccounts($scope.priceList.id, $scope.filter.accountsSearchText, clientUnitsIdsToFilterCSV, $scope.context.clientId).then(
                    function (data) {
                        $scope.accountsToAdd = data;
                        for (i = 0; i < $scope.accountsToAdd.length; i++) {
                            $scope.accountsToAdd[i].selected = false;
                        }
                        $scope.showSearchForAccounts = true;

                        if (!$scope.uniqueClientUnits) {
                            $scope.uniqueClientUnits = _.chain($scope.accountsToAdd)
                                .uniq(function (account) {
                                    return account.clientId
                                })
                                .map(function (account) {
                                    return {id: account.clientId, name: account.clientOrgName, isSelected: true};
                                })
                                .value();
                        }
                    });
            };

            $scope.selectedClientUnits = function () {
                return _.where($scope.uniqueClientUnits, {isSelected: true});
            };

            var updatePriceList = function() {
                // MB TODO: This needs to change. We can't update the data every time a change is made - we should be adding/removing accounts from the array etc.
                return priceListsService.getBeaglePriceListDetailsById($scope.priceList.id, $scope.context.clientId).$promise.then(function (data) {
                    $scope.priceList = data;
                });
            };

            $scope.addAccounts = function () {
                var selectedAccountIds = _.pluck(_.where($scope.accountsToAdd, {selected: true}), 'id');
                return priceListsService.addAccounts({
                    selectedAccountIds: selectedAccountIds,
                    priceListId: $scope.priceList.id,
                    clientId: $scope.context.clientId
                }).then(function () {
                    updatePriceList().then(function() {
                        $translate('account_s_added_to_price_list').then(function (translation) {
                            toastr.success(translation);
                        });
                        $scope.showSearchForAccounts = false;
                    });
                })
            };

            $scope.editExisting = function () {
                return !!$scope.priceList.id;
            };

            $scope.selectAll = function () {
                _.each($scope.accountsToAdd,
                    function (account) {
                        account.selected = $scope.selectAllAccounts;
                    });
            };

            $scope.checkDescriptionIsUnique = function (addEditPriceListForm) {
                if ($scope.priceList.name) {
                    return priceListsService.checkDescriptionIsUnique($scope.context.clientId, $scope.priceList.name, $scope.priceList.id == null ? '' : $scope.priceList.id).then(function (val) {
                        addEditPriceListForm.name.$error.uniqueDescription = !val.isUnique;
                    });
                }
            };

            $scope.back = function () {
                $location.url('/PriceLists');
            };
        }]);
'use strict';

angular.module(appName)
    .controller('priceListsController', [
        '$scope',
        '$timeout',
        'localStorageService',
        'enums',
        'paginationFactory',
        'priceListsService',
        '$location',
        '$translate',
        'userService',
        function ($scope,
                  $timeout,
                  localStorageService,
                  enums,
                  paginationFactory,
                  priceListsService,
                  $location,
                  $translate,
                  userService) {
            $scope.userCanEdit = false;

            $scope.get = function (forcePageOne) {
                self.updateSearchParams(forcePageOne);
                localStorageService.setItem(enums.localStorage.priceListSearch, $scope.searchParams);
                return priceListsService.get($scope.searchParams, $scope.clientId).then(function (pagedDto) {
                    $scope.priceLists = pagedDto.list;
                    $scope.pagination.total = pagedDto.total;
                });
            };

            $scope.edit = function (priceList) {
                priceListsService.edit(priceList.id, $scope.clientId).then(function () {
                    console.log("edited");
                });
            };

            $scope.delete = function(priceList) {
                return priceListsService.delete(priceList.id, $scope.clientId).then(function() {
                    $scope.deleting = false;
                    $scope.get(false);
                    $translate('price_list_deleted').then(function (translation) {
                        toastr.success(translation);
                    });                    
                });
            };

            $scope.applyFilter = function () {
                var filterText = $scope.priceListsFilterText || "";
                $scope.priceListsFilterCriteria = filterText.toLowerCase();
                return $scope.get(false);
            };

            $scope.$watchGroup(["pagination.currentPage + pagination.numPerPage"],
                function () {
                    if ($scope.pagination &&
                        $scope.pagination.currentPage &&
                        $scope.pagination.numPerPage) {
                        $scope.get(false);
                    }
                });

            self.updateSearchParams = function(forcePageOne) {
                $scope.searchParams.term = $scope.priceListsFilterCriteria;
                $scope.searchParams.sortField = $scope.sortOn ? $scope.sortOn.column : null;
                if ($scope.sortOn.sortState == enums.sortStates.ascending) {
                    $scope.searchParams.sortAsc = true;
                } else if ($scope.sortOn.sortState == enums.sortStates.descending) {
                    $scope.searchParams.sortAsc = false;
                }

                if ($scope.pagination) {
                    $scope.searchParams.numPerPage = $scope.pagination.numPerPage;

                    if (forcePageOne) {
                        $scope.pagination.currentPage = 1;
                    }
                    $scope.searchParams.currentPage = $scope.pagination.currentPage;
                }
            };   

            $scope.init = function () {

                userService.hasPermission('BEAGLE_CAN_CREATE_EDIT_PRICELISTS').then(function () {
                    $scope.userCanEdit = true;
                });
                $scope.priceListsFilterCriteria = "";
                //Pagination...
                $scope.loading = {
                    search: false
                }

                paginationFactory.addPaginationVariablesAndFunctionsToScope($scope);

                $scope.pagination.numPerPage = 20;

                $scope.sortOn = {
                    sortState: "Ascending"
                };

                $scope.$on(enums.eventNames.sortOnElementChangedEventName, function () {
                    $scope.search($scope.sortOn.sortField, true);
                });
                var currentSubscriptionUnit = localStorageService.getItem(enums.localStorage.organisationContext).currentSubscriptionUnit;
                $scope.organisationId = currentSubscriptionUnit.organisation.id;
                $scope.clientId = currentSubscriptionUnit.client.id
                $scope.searchParams = localStorageService.getItem(enums.localStorage.priceListSearch)
                    || {
                        term: $scope.priceListsFilterCriteria,
                        paginate: true,
                        currentPage: 1,
                        numPerPage: 20,
                        sortField: null,
                        sortAsc: true
                    };
            }();
        }]);
'use strict';

angular.module(appName)
    .factory('priceListsResource', [
        '$resource', "siteUrl", function ($resource, siteUrl) {
            var api = siteUrl() + "Api/PriceLists";
            return $resource(api, {},
                {
                    downloadPriceList: {
                        method: "GET",
                        url: api + "/DownloadPriceList",
                        params: {
                            clientId: '@clientId',
                            organisationId: '@organisationId',
                            priceList: "@priceList"
                        },
                        isArray: false
                    },
                    get: {
                        method: "GET",
                        url: api + "/Get",
                        params: {
                            clientId: '@clientId',
                            term: '@term',
                            paginate: '@paginate',
                            currentPage: '@currentPage',
                            numPerPage: '@numPerPage',
                            sortField: '@sortField',
                            sortAsc: '@sortAsc'
                        },
                        isArray: false
                    },
                    getBeaglePriceListDetailsById: {
                        method: "GET",
                        url: api + "/GetBeaglePriceListDetailsById",
                        params: {
                            clientId: '@clientId',
                            id: "@id"
                        },
                        isArray: false
                    },
                    delete: {
                        method: "GET",
                        url: api + "/Delete",
                        params: {
                            clientId: '@clientId',
                            priceListId: '@priceListId'
                        },
                        isArray: false
                    },
                    addPriceList: {
                        method: "POST",
                        url: api + "/Add",
                        params: {
                            clientId: '@clientId',
                            priceList: "@priceList"
                        },
                        isArray: false
                    },
                    editPriceList: {
                        method: "PUT",
                        url: api + "/Edit",
                        params: {
                            clientId: '@clientId',
                            priceList: "@priceListDto"
                        },
                        isArray: false
                    },
                    removeAccountFromPriceList: {
                        method: "POST",
                        url: api + "/RemoveAccountFromPriceList",
                        params: {
                            orderSheetAccountLiteDto: "@orderSheetAccountLiteDto"
                        },
                        isArray: false
                    },
                    searchForAccounts: {
                        method: "GET",
                        url: api + "/SearchForAccounts",
                        params: {
                            clientId: '@clientId',
                            priceListId: "@priceListId",
                            searchTerm: "@searchTerm",
                            clientUnitsIdsToFilter: "@clientUnitsIdsToFilter"
                        },
                        isArray: true
                    },
                    addAccounts: {
                        method: "POST",
                        url: api + "/AddAccounts",
                        params: {
                            accountsToAddDto: '@accountsToAddDto'
                        },
                        isArray: false
                    },
                    checkDescriptionIsUnique: {
                        method: "GET",
                        url: api + "/CheckDescriptionIsUnique",
                        params: {
                            clientId: '@clientId',
                            description: '@description',
                            priceListId: '@priceListId'
                        },
                        isArray: false
                    },
                    saveOrgContacts: {
                        method: "POST",
                        url: api + "/SaveOrgContacts"
                    }
                });
        }
    ]);
angular.module(appName)
    .factory('priceListsService', [
        'priceListsResource',
        function (priceListsResource) {
            var service = {
                get: function (params, clientId) {
                    return priceListsResource.get(
                        {
                            clientId: clientId,
                            term: params.term,
                            paginate: params.paginate,
                            currentPage: params.currentPage,
                            numPerPage: params.numPerPage,
                            sortField: params.sortField,
                            sortAsc: params.sortAsc   
                        }
                    ).$promise;
                },
                getPriceListSummaryById: function (id, clientId) {
                    return priceListsResource.getPriceListSummaryById({ id: id, clientId: clientId });
                },
                getBeaglePriceListDetailsById: function (id, clientId) {
                    return priceListsResource.getBeaglePriceListDetailsById({ id: id, clientId: clientId});
                },
                delete: function (priceListId, clientId) {
                    return priceListsResource.delete({
                        priceListId: priceListId,
                        clientId: clientId
                    }).$promise;
                },
                addPriceList: function (priceList) {
                    return priceListsResource.addPriceList({
                        id: priceList.id,
                        name: priceList.name,
                        dateCreated: priceList.dateCreated,
                        accounts: priceList.accounts,
                        clientId: priceList.clientId,
                    }).$promise;
                },
                editPriceList: function (priceListDto) {
                    return priceListsResource.editPriceList(priceListDto).$promise;
                },
                checkDescriptionIsUnique: function (clientId, description, priceListId) {
                    return priceListsResource.checkDescriptionIsUnique({
                        clientId: clientId,
                        description: description,
                        priceListId: priceListId
                    }).$promise;
                },
                removeAccountFromPriceList: function (orderSheetAccountLiteDto) {
                    return priceListsResource.removeAccountFromPriceList(orderSheetAccountLiteDto).$promise;
                },
                downloadPriceList: function (priceList, clientId) {
                    return priceListsResource.downloadPriceList({
                        id: priceList.id,
                        name: priceList.name,
                        dateCreated: priceList.dateCreated,
                        accounts: priceList.accounts,
                        clientId: clientId
                    }).$promise;
                },
                searchForAccounts: function (priceListId, searchTerm, clientUnitsIdsToFilter, clientId) {
                    return priceListsResource.searchForAccounts({
                        priceListId: priceListId,
                        searchTerm: searchTerm,
                        clientUnitsIdsToFilter: clientUnitsIdsToFilter,
                        clientId: clientId
                    }).$promise;
                },
                addAccounts: function (accountsToAddDto) {
                    return priceListsResource.addAccounts(accountsToAddDto).$promise;
                },
                saveOrgContacts: function (priceListId, orgContactIds) {
                    return priceListsResource.saveOrgContacts({
                        orderSheetId: priceListId,
                        organisationContactIds: orgContactIds
                    }).$promise;
                }
            };
            return service;
        }
    ]);
angular.module(appName)
    .factory("replaceProductService",
        [
            "organisationContextService", "_",
            function (organisationContextService, _) {
                var createReplaceDto = function(currentBasketItem, replacementProduct, availableClientSupplierAccounts) {
                    var ctx = organisationContextService.getContext();
                    var model = {
                        procurementBasketId: currentBasketItem.procurementBasketId,
                        id: currentBasketItem.id,
                        skuId: replacementProduct.bestPriceSkuId,
                        organisationId: ctx.currentSubscriptionUnit.organisation.id,
                        sortOrder: currentBasketItem.sortOrder,
                        catchWeight: currentBasketItem.catchWeight,
                        isBestPrice: replacementProduct.isBestPrice,
                        itemPrice: replacementProduct.price,
                        rankPrice: replacementProduct.rankPrice,
                        procurementClientUnitAccountCodeDto: currentBasketItem.procurementClientUnitAccountCodeDto,
                        searchDto: replacementProduct.searchDto
                    };
                    /* If we're swapping to the same supplier, we need to:
                     * a) If there's only 1 accountnumber available for the current supplier, use it
                     * b) There's multiple account numbers, honour our current selection
                     */
                    if (currentBasketItem.supplierId === replacementProduct.bestPriceSupplierId) {
                        // Filter our ClientSupplierAccounts for the current supplier
                        var accountsForSupplier = _.filter(availableClientSupplierAccounts,
                            function(csa) {
                                return csa.supplierId === currentBasketItem.supplierId;
                            });

                        if (accountsForSupplier.length === 1) {
                            // We only have one, use it
                            model.clientSupplierAccountDto = accountsForSupplier[0];
                        } else if (accountsForSupplier.length > 1 && currentBasketItem.clientSupplierAccountDto != null) {
                            // We have more than 1, find the one that matches the current selection, unless it's null
                            model.clientSupplierAccountDto = _.findWhere(accountsForSupplier,
                                { id: currentBasketItem.clientSupplierAccountDto.id });
                        }
                    } else {
                        // If swapping to a new supplier, we should always honour the replacementProduct AccountNumber as it already handles singles/multiples
                        model.clientSupplierAccountDto = { id: replacementProduct.clientSupplierAccountId };
                    }

                    return model;
                };

                return {
                    createReplaceDto: createReplaceDto
                }
            }
        ]);

angular.module(appName)
    .service('orderGuideProcurementSegmentsResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/OrderGuideProcurementSegments';
            return $resource(api, {}, {
                create: {
                    method: 'POST',
                    url: api + '/Create'
                },
                update: {
                    method: 'PUT',
                    url: api + '/Update'
                },
                deleteSegment: {
                    method: 'POST',
                    url: api + '/Delete'
                },
                updateSegmentSortOrders: {
                    method: 'PUT',
                    url: api + '/UpdateSegmentSortOrders'
                }
            });
        }
    ]);
angular.module(appName)
    .factory('orderGuideProcurementSegmentsService', [
        'orderGuideProcurementSegmentsResource', 'organisationContextService',
        function (orderGuideProcurementSegmentsResource, organisationContextService) {
            var context = organisationContextService.getContext();
            var addOrgIdToRequest = function(obj) {
                obj.organisationId = context.organisation.id;
            }
            var create = function (procurementSegmentRequestDto) {
                addOrgIdToRequest(procurementSegmentRequestDto);
                return orderGuideProcurementSegmentsResource.create(procurementSegmentRequestDto).$promise;
            };

            var update = function(procurementSegmentRequestDto) {
                addOrgIdToRequest(procurementSegmentRequestDto);
                return orderGuideProcurementSegmentsResource.update(procurementSegmentRequestDto).$promise;
            };

            var deleteSegment = function(procurementSegmentId) {
                var requestDto = {
                    id: procurementSegmentId
                };
                addOrgIdToRequest(requestDto);
                return orderGuideProcurementSegmentsResource.deleteSegment(requestDto).$promise;
            };

            var updateSegmentSortOrders = function(segmentSortOrderRequest) {
                addOrgIdToRequest(segmentSortOrderRequest);
                return orderGuideProcurementSegmentsResource.updateSegmentSortOrders(segmentSortOrderRequest).$promise;
            };

            return {
                create: create,
                update: update,
                deleteSegment: deleteSegment,
                updateSegmentSortOrders: updateSegmentSortOrders
            };
        }
    ]);
angular.module(appName)
    .service('procurementSegmentItemResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/ProcurementSegmentItems';
            return $resource(api, {}, {
                addProductToSegment: {
                    method: 'POST',
                    url: api + '/AddSearchToSegment'
                },
                moveSegmentItemsToSelectedSegment: {
                    method: 'POST',
                    url: api + '/MoveSegmentItemsToSelectedSegment',
                    isArray: true
				},
				/*CSH 23072019 Have removed this from the resource and done as a $http straight on the service as
				 * angular doesn't support sending data in the server, therefore making large numbers of deletes impossible:
				 * https://stackoverflow.com/questions/22186671/angular-resource-delete-wont-send-body-to-express-js-server
				/*
                removeSegmentItemsFromSegment: {
                    method: 'DELETE',
                    url: api + '/RemoveSegmentItemsFromSegment',
                    data: {
                        ids: '@ids'
                    }
                },*/
                setSegmentItemSortOrders: {
                    method: 'POST',
                    url: api + '/SetSegmentItemSortOrders'
                }
            });
        }
    ]);

angular.module(appName)
  .factory('procurementSegmentItemService', [
    'procurementSegmentItemResource',
    'organisationContextService',
    '$http',
    'siteUrl',
    'enums',
    function (procurementSegmentItemResource,
              organisationContextService,
              $http,
              siteUrl,
              enums) {
      var context = organisationContextService.getContext();
      var createSegmentItemRequestDto = function (obj) {
        return {
          procurementBasketId: obj.procurementBasketId,
          procurementBasketTypeEnum: obj.procurementBasketTypeEnum,
          organisationId: obj.organisationId,
          packTypeId: obj.packTypeId,
          segmentId: obj.procurementSegmentId,
          skuId: obj.skuId || obj.procurementItemDto.skuId,
          procurementClientUnitAccountCodeDto: obj.procurementItemDto.procurementClientUnitAccountCodeDto,
          clientSupplierAccountDto: obj.procurementItemDto.clientSupplierAccountDto,
          searchDto: obj.searchDto || {
            searchCriteria: {
              savedSearchType: enums.savedSearchTypes.skuSearchExactSku
            }
          }
        }
      };
      var createSegmentItemReplaceProductDto = function (currentSegmentItem, procurementItemDto) {
        return {
          procurementSegmentItemId: currentSegmentItem.procurementSegmentItemId,
          procurementBasketId: procurementItemDto.procurementBasketId,
          procurementSegmentId: currentSegmentItem.procurementSegmentId,
          sortOrder: currentSegmentItem.sortOrder,
          procurementItemDto: procurementItemDto,
          organisationId: context.currentSubscriptionUnit.organisation.id
        };
      };

      var addProductToSegment = function (obj) {
        obj.organisationId = context.organisation.id;
        obj.subscriptionUnitId = context.currentSubscriptionUnit.Id;
        return procurementSegmentItemResource.addProductToSegment(obj).$promise;
      };

      var moveSegmentItemsToSelectedSegment = function (newSegmentId, mappedSegmentItemsForMove, basketId, rowNumber) {
        var dto = {
          procurementSegmentId: newSegmentId,
          procurementSegmentItems: mappedSegmentItemsForMove,
          organisationId: context.organisation.id,
          rowNumber: rowNumber,
          procurementBasketId: basketId,
          searchDto: {
            searchCriteria: {
              savedSearchType: enums.savedSearchTypes.skuSearchExactSku
            }
          }
        };
        return procurementSegmentItemResource.moveSegmentItemsToSelectedSegment(dto).$promise;
      };

      //CSH 23072019 Implemented outside of the resource pattern to allow for deletion of a large number
      //of items simultaneously, as per:
      //https://stackoverflow.com/questions/38018121/angularjs-http-delete-request-with-body-and-headers
      var removeSegmentItemsFromSegment = function (segmentItemIds) {
        var url = siteUrl() + 'api/ProcurementSegmentItems/RemoveSegmentItemsFromSegment';
        return $http.delete(url, {data: segmentItemIds, headers: {'Content-Type': 'application/json;charset=utf-8'}});
      };

      var setSegmentItemSortOrders = function (segmentItemSortOrderDto) {
        segmentItemSortOrderDto.organisationId = context.organisation.id;
        return procurementSegmentItemResource.setSegmentItemSortOrders(segmentItemSortOrderDto).$promise;
      };

      return {
        addProductToSegment: addProductToSegment,
        createSegmentItemReplaceProductDto: createSegmentItemReplaceProductDto,
        createSegmentItemRequestDto: createSegmentItemRequestDto,
        moveSegmentItemsToSelectedSegment: moveSegmentItemsToSelectedSegment,
        removeSegmentItemsFromSegment: removeSegmentItemsFromSegment,
        setSegmentItemSortOrders: setSegmentItemSortOrders
      };
    }
  ]);

angular.module(appName)
    .service('procurementSegmentsResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/ProcurementSegments';
            return $resource(api, {}, {
                create: {
                    method: 'POST',
                    url: api + '/Create'
                },
                update: {
                    method: 'PUT',
                    url: api + '/Update'
                },
                deleteSegment: {
                    method: 'POST',
                    url: api + '/Delete'
                },
                updateSegmentSortOrders: {
                    method: 'PUT',
                    url: api + '/UpdateSegmentSortOrders'
                }
            });
        }
    ]);
angular.module(appName)
    .factory('procurementSegmentsService', [
        'procurementSegmentsResource', 'organisationContextService',
        function (procurementSegmentsResource, organisationContextService) {
            var context = organisationContextService.getContext();
            var addOrgIdToRequest = function(obj) {
                obj.organisationId = context.organisation.id;
            }
            var create = function (procurementSegmentRequestDto) {
                addOrgIdToRequest(procurementSegmentRequestDto);
                return procurementSegmentsResource.create(procurementSegmentRequestDto).$promise;
            };

            var update = function(procurementSegmentRequestDto) {
                addOrgIdToRequest(procurementSegmentRequestDto);
                return procurementSegmentsResource.update(procurementSegmentRequestDto).$promise;
            };

            var deleteSegment = function(procurementSegmentId) {
                var requestDto = {
                    id: procurementSegmentId
                };
                addOrgIdToRequest(requestDto);
                return procurementSegmentsResource.deleteSegment(requestDto).$promise;
            };

            var updateSegmentSortOrders = function(segmentSortOrderRequest) {
                addOrgIdToRequest(segmentSortOrderRequest);
                return procurementSegmentsResource.updateSegmentSortOrders(segmentSortOrderRequest).$promise;
            };

            return {
                create: create,
                update: update,
                deleteSegment: deleteSegment,
                updateSegmentSortOrders: updateSegmentSortOrders
            };
        }
    ]);
angular.module(appName)
    .factory('clientUnitDepartmentService', [
        'procurementSubscriptionClientUnitDepartmentResource',
		'organisationContext',
        function (procurementSubscriptionClientUnitDepartmentResource, organisationContext) {
            return {
                addDepartmentsToClientUnit: function(obj, cb) {
                    return procurementSubscriptionClientUnitDepartmentResource.addDepartmentsToClientUnit(obj);
                },
                getBySubscriptionClientUnitId: function (id, cb) {
                    return procurementSubscriptionClientUnitDepartmentResource
                        .getBySubscriptionClientUnitId({ id: id });
                },
                remove: function (id, cb) {
                    procurementSubscriptionClientUnitDepartmentResource.remove({ id: id })
                        .$promise.then(function (data) {
                            if (cb)
                                cb(data);
                        });
                },
                update: function (department, cb) {
                    procurementSubscriptionClientUnitDepartmentResource.update(department)
                        .$promise.then(function (data) {
                            if (cb)
                                cb(data);
                        });
				},
				getClientUnitProcurementDepartmentsForUser: function (id, userId, projection, procurementAccountTypeEnum) {
                	if (!id) {
                		id = organisationContext.currentSubscriptionUnit.id;
                	};
                	if (!userId) {
                		userId = organisationContext.user.id;
                	}
					if (!projection) {
						projection = "eProcurement.ProcurementClientUnitDepartmentDto";
					};
                	return procurementSubscriptionClientUnitDepartmentResource.getClientUnitProcurementDepartmentsForUser(
						{
							id: id,
							userId: userId,
							projection: projection,
							procurementAccountType: procurementAccountTypeEnum
						});
                },
                getDefaultDepartmentForUser: function(departments) {
                    return _.findWhere(departments, { isDefaultForCurrentUser: true });
                }
            };
        }
    ]);
angular.module(appName)
    .factory('procurementSubscriptionClientUnitDepartmentResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/ClientUnitProcurementDepartment';
            return $resource(api,
            {},
            {
                addDepartmentsToClientUnit: {
                    method: 'POST',
                    url: api + '/AddDepartmentsToClientUnit',
                    isArray: true
                },
                getBySubscriptionClientUnitId: {
                    method: 'GET',
                    url: api + '/GetBySubscriptionClientUnitId',
                    params: {
                        id: '@id'
                    },
                    isArray: true
                },
                remove: {
                    method: 'DELETE',
                    url: api + '/Delete',
                    params: {
                        id: '@id'
                    }
                },
                update: {
                    method: 'PUT',
                    url: api + '/Update'
                },
                addUserToClientUnitDepartment: {
                    method: 'POST',
                    url: api + '/AddUserToClientUnitDepartment',
                    params: {
                        userId: '@userId',
                        id: '@id'
                    },
                    isArray: false
                },
                removeUserFromClientUnitDepartment: {
                    method: 'POST',
                    url: api + '/RemoveUserFromClientUnitDepartment',
                    params: {
                        userId: '@userId',
                        id: '@id'
                    },
                    isArray: false
                },
                setUserAsDefaultClientUnitDepartmentUser: {
                    method: 'POST',
                    url: api + '/SetUserAsDefaultClientUnitDepartmentUser',
                    params: {
                        userId: '@userId',
                        id: '@id'
                    },
                    isArray: false
                },
                removeUserAsDefaultClientUnitDepartmentUser: {
                    method: 'POST',
                    url: api + '/RemoveUserAsDefaultClientUnitDepartmentUser',
                    params: {
                        userId: '@userId',
                        id: '@id'
                    },
                    isArray: false
                },
                getClientUnitProcurementDepartmentsForUser: {
                    method: 'GET',
                    url: api + '/GetClientUnitProcurementDepartmentsForUser',
                    params: {
                        userId: '@userId',
                        id: '@id',
						projection: '@projection'
                    },
                    isArray: true
                }
            });
        }
    ])
angular.module(appName)
    .factory('productFavouriteService', [
		'$http', 'siteUrl', function ($http, siteUrl) {

			var endpointUrl = siteUrl() + 'api/favourite';

			var service = {
				createFavourite: function (favouriteId, productId, departmentId) {
					var url = endpointUrl + '/' + favouriteId;
					var requestData = {
						id: favouriteId,
						productId: productId,
						departmentId: departmentId
					}
					return $http.put(url, requestData);
				},
				createFavourites: function (favouriteId, productId, departmentIds) {
					var url = endpointUrl + 's';
					var requestData = {
						favouriteId: favouriteId,
						productId: productId,
						skuId: null,
						departmentIds: departmentIds
					}
					return $http.put(url, requestData);
				},
				deleteFavourite:function(favouriteId) {
					var url = endpointUrl + '/' + favouriteId;
					return $http.delete(url);
				}
			}

			return service;
		}
    ]);

angular.module(appName)
  .controller("productSearchController", [
    "$scope", "$filter", "$routeParams", "$location", "basketData", "productSearchService", "basketService", "shoppingListService", "basketStore", "enums", "toastr", "paginationService", "autoFocus", "validationHelper", "$translate", "productFavouriteService", "skuFavouriteService", "organisationContextService", "unitSuppliersService", "_",
    function ($scope, $filter, $routeParams, $location, basketData, productSearchService, basketService, shoppingListService, basketStore, enums, toastr, paginationService, autoFocus, validationHelper, $translate, productFavouriteService, skuFavouriteService, organisationContextService, unitSuppliersService, _) {
      var self = this;
      self.context = organisationContextService.getContext();
      autoFocus.implementForElementWithId("product-search");

      $scope.mobile = validationHelper.isMobile();
      $scope.showFilter = !$scope.mobile; // If mobile is true, we don't want to show by default. This needs to default to the opposite of $scope.mobile.
      $scope.productSearchResultsEnum = enums.productSearchResults;
      $scope.packTypeEnum = enums.packTypes;
      $scope.productData = {
        term: "",
        basketId: $routeParams.basketId
      };
      $scope.enums = enums;

      // The basketStore is our own implementation of storing things like basket counts across areas. Think NGRX but worse.
      $scope.basketStore = basketStore;
      self.oldTerm = "";
      $scope.basket = null;

      var clientProcurementDepartmentId;

      basketData.$promise.then(function (basket) {
        //CSH 05082018: We're getting the departmentId here because favourites are client unit department specific:
        clientProcurementDepartmentId = basket.procurementClientUnitDepartmentId;
        if (basket.name) {
          $scope.basketName = basket.name;
        } else {
          $translate("label_unnamed_basket").then(function (translation) {
            $scope.basketName = translation;
          });
        }
        ;
        // Makes sure the properties are set to null appropriately to avoid the data being wrong due to the setters in the C# code
        _.each(basket.basketItems, function (basketItem) {
          self.setNullPropertiesForEqualityChecks(basketItem);
        });
        $scope.basket = basket;

        // A single variable is used to store the translation for the type of basket entity. This is a bit of a shoddy implementation.
        if ($scope.basket.discriminator == enums.procurementBasketType.ProcurementBasket) {
          $translate("label_item_added_to_basket").then(function (translation) {
            self.translatedLabelForItemAddedToBasket = translation;
          });
        } else if ($scope.basket.discriminator == enums.procurementBasketType.ShoppingList) {
          $translate("label_item_added_to_shopping_list").then(function (translation) {
            self.translatedLabelForItemAddedToBasket = translation;
          });
        }
      });

      /*
        Checks if a product is valid.
        This is used when adding the item to the basket to check if we need to enforce quantity or not.
       */
      self.isProductValid = function (product) {
        if ($scope.isOrderableBasket()) {
          return product.quantity > 0;
        } else {
          // Basket Type is shopping list, allow null Qty
          return true;
        }
      };

      /*
        Sets nullable properties on the basketItem to null. This is because the backend code didn't return null where it should.
        This is a bit of a hacky implementation but it's doing the job.
       */
      self.setNullPropertiesForEqualityChecks = function (basketItem) {
        // If the properties don't exist, set them to 0 so we can do an equality check
        if (!basketItem.catchWeight) basketItem.catchWeight = null;
        if (!basketItem.skuId) basketItem.skuId = null;
      }

      /*
        Checks if two items are unique based on SkuId and CatchWeight.
       */
      self.itemsAreUnique = function (itemOne, itemTwo) {
        self.setNullPropertiesForEqualityChecks(itemOne);
        self.setNullPropertiesForEqualityChecks(itemTwo);
        return itemOne.skuId != itemTwo.skuId && itemOne.catchWeight != itemTwo.catchWeight;
      };

      /*
        Checks if an item already exists in the Basket entity.
       */
      self.itemExistsInBasket = function (basketItem) {
        return _.findWhere($scope.basket.basketItems, {catchWeight: basketItem.catchWeight, skuId: basketItem.skuId});
      };

      /*
        Checks the type of the basket entity. If The type is ProcurementBasket then we are in an "orderable basket" entity.
       */
      $scope.isOrderableBasket = function () {
        // Prevents needless console errors
        if (!$scope.basket) return false;
        return $scope.basket.discriminator == enums.procurementBasketType.ProcurementBasket;
      }

      /*
        Disables the AddToBasket button if we are in a ProcurementBasket entity and the Quantity is null.

        ProcurementBasket's must have a quantity.
       */
      $scope.disableAddToBasketButton = function (product) {
        return product.loading ||
          ($scope.isOrderableBasket() && product.quantity == null); // We only want to check null Qty on basket items
      }

      /*
        Gets additional products from the server.
        Closes any row with `showAdditionalProducts = true` to keep the UI clean.

        TODO: Change this to use a dialog instead of opening rows.
       */
      $scope.getAdditionalProducts = function ($event, product) {
        $scope.additionalProducts = {};
        product.loadingAdditionalProducts = true;

        // Find any rows with additionalProducts expanded
        var additionalProductsToClose = _($scope.productData.results.items).findWhere({showAdditionalProducts: true});
        if (additionalProductsToClose != null && additionalProductsToClose.showAdditionalProducts == true) {
          additionalProductsToClose.showAdditionalProducts = false;
          if (additionalProductsToClose[0] != product[0]) {
            product.showAdditionalProducts = true;
          }
        } else {
          product.showAdditionalProducts = true;
        }

        // If our current product.showAdditionalProducts = true then we need to load the additional products and setup their data
        if (product.showAdditionalProducts) {
          // Create a copy so that we're not referencing the same productData and then set the Id properties
          var searchData = angular.copy($scope.productData);
          searchData.organisationId = self.context.currentSubscriptionUnit.organisation.id;
          searchData.productId = product[enums.productSearchResults.productId];

          searchData.clientId = self.context.currentSubscriptionUnit.client.id;

          // Get the additional products from the server
          productSearchService.getAdditionalProducts(searchData).$promise.then(function (additionalProducts) {
            $scope.additionalProducts = additionalProducts;
            product.loadingAdditionalProducts = false;
          }, function (err) {
            $translate("error_additional_products").then(function (translation) {
              toastr.error(translation);
            });
            product.loadingAdditionalProducts = false;
          });
        } else {
          product.loadingAdditionalProducts = false;
        }
      };

      /*
        Clears the search filters
       */
      $scope.clearFilters = function () {
        $scope.productData.filters = [];
      };

      /*
        Sets the decimal values to 3 decimal places for the UI.
        Throws toastr error if the value is not a number.
       */
      $scope.set3dp = function (input) {
        if (input != null && input != '') {
          if (isNaN(parseFloat(input))) {
            input = null;
            $translate('error_please_enter_valid_number').then(function (t) {
              toastr.error(t);
              return input;
            });
          } else {
            input = parseFloat(input).toFixed(3);
            return input;
          }
        }
      };

      /*
        Performs a search using the search header parameters and filters.
       */
      $scope.search = function (form, performFormValidation) {
        // Checks if the form is valid if `performFormValidation` is true.
        if (performFormValidation) {
          if (form.term.$dirty) {
            $scope.productData.term = form.term.$modelValue;
            $scope.productData.filters = [];
          }
        }

        $scope.loading = true;

        // Get the products from the server using our search params
        productSearchService.search($scope.productData)
          .$promise.then(function (data) {
          // If we need to check if form is valid, check it
          self.oldTerm = data.term;
          $scope.productData.results = data.results;
          //This is to hit the watch in paginate
          if (data.results == null) {
            $scope.productData.results = {};
            $scope.productData.results.items = [];
          }
          if (!$scope.productData.filters.length) {
            $scope.productData.filters = data.filters;
          }

          // Tell the filter directive to update
          $scope.$broadcast('updateFilterDirective');

          if (data.results == null || data.results.length === 0) {
            $scope.items = null;
          }
        }, function (err) {
          $scope.productData.results = null;
        }).finally(function () {
          $scope.loading = false;
          // Reset the term field back to pristine so we can do our dirty checks again
          form.term.$setPristine();
        });
      };

      /*
        Sorts the data using the filter expression from the sortOn directive from the template.
       */
      $scope.sort = function () {
        console.log('$scope.sortOn.filterExpr', $scope.sortOn.filterExpr);
        $scope.productData.results.items = $filter('orderBy')($scope.productData.results.items, $scope.sortOn.filterExpr);
      };

      /*
        Checks if the product is best price.
       */
      $scope.isBestPrice = function (product) {
        return productSearchService.isBestPrice(product);
      };

      /*
        Toggles whether or not the attribute filters are visible.
       */
      $scope.toggleFilter = function () {
        $scope.showFilter = !$scope.showFilter;
      };

      /*
        Removes the favourite flag from the UI if a product has been un-favourited.

        Shows a hollow star instead of a filled star.
       */
      var deleteFavouriteFlagFromUi = function (product) {
        // Delete the props from the product object
        delete product.favouriteId;
        delete product[$scope.productSearchResultsEnum.favouriteId];

        // Look for any SKUs that are mapped to the same product. They will have the same `bestPriceSkuId`. Perform delete action on all SKUs
        var skuId = product.bestPriceSkuId ? product.bestPriceSkuId : product[$scope.productSearchResultsEnum.bestPriceSkuId];

        // Loop over additionalProducts and delete the favouriteId
        if ($scope.additionalProducts && $scope.additionalProducts.length) {
          _.each($scope.additionalProducts[0].results, function (p) {
            if (p.bestPriceSkuId === skuId) {
              delete p.favouriteId;
            }
          });
        }

        // Loop over all items and delete the favouriteId if they have the same `bestPriceSkuId` (mapped to the same product)
        _.each($scope.productData.results.items, function (p) {
          if (p[$scope.productSearchResultsEnum.bestPriceSkuId] === skuId) {
            delete p.favouriteId;
            delete p[$scope.productSearchResultsEnum.favouriteId];
          }
        });
      };

      /*
        Add the favourite flag from the UI if a product has been favourited.

        Shows a hollow star instead of a filled star.
       */
      var addFavouriteFlagToUi = function (product, favouriteId) {
        product.favouriteId = favouriteId;
        product[$scope.productSearchResultsEnum.favouriteId] = favouriteId;

        // Look for any SKUs that are mapped to the same product. They will have the same `bestPriceSkuId`. Perform add action on all SKUs
        var skuId = product.bestPriceSkuId ? product.bestPriceSkuId : product[$scope.productSearchResultsEnum.bestPriceSkuId];

        // Loop over additionalProducts and add the favouriteId
        if ($scope.additionalProducts && $scope.additionalProducts.length) {
          _.each($scope.additionalProducts[0].results, function (p) {
            if (p.bestPriceSkuId === skuId) {
              p.favouriteId = favouriteId;
            }
          });
        }
        // Loop over all items and add the favouriteId if they have the same `bestPriceSkuId` (mapped to the same product)
        _.each($scope.productData.results.items, function (p) {
          if (p[$scope.productSearchResultsEnum.bestPriceSkuId] === skuId) {
            p.favouriteId = favouriteId;
            p[$scope.productSearchResultsEnum.favouriteId] = favouriteId;
          }
        });
      }

      /*
        Toggles the favourite flag(s) on the selected SKU and its alternatives
       */
      $scope.toggleFavourite = function (product) {
        var productId = product.id ? product.id : product[0];
        var skuId = product[7];

        // If we are working with dynamic data, set the `.favouriteId` prop so we can work with it without using array accessors.
        if (product[$scope.productSearchResultsEnum.favouriteId])
          product.favouriteId = product[$scope.productSearchResultsEnum.favouriteId];
        var favouriteId;

        // If the product is currently favourited - delete it and update the UI
        if (product.favouriteId) {
          favouriteId = product.favouriteId;
          // Delete the favourites from the server and then update the UI
          productFavouriteService.deleteFavourite(product.favouriteId).then(null, function () {
            addFavouriteFlagToUi(product, favouriteId);
          });
          deleteFavouriteFlagFromUi(product);
        } else {
          // The product is not currently favourited. Create a new favourite and update the UI
          favouriteId = uuid.v4();
          addFavouriteFlagToUi(product, favouriteId);
          var createFavouritePromise;
          createFavouritePromise = skuFavouriteService.createFavourite(favouriteId, skuId, clientProcurementDepartmentId);

          createFavouritePromise.then(null, function () {
            deleteFavouriteFlagFromUi(product);
          });
        }
      };

      /*
        Checks if the additional products row should be visible for the current product.
       */
      $scope.shouldShowAdditionalProducts = function (product) {
        return ($scope.mobile && product.showAdditionalProducts && !product.loadingAdditionalProducts) ||
          (!$scope.mobile && product.showAdditionalProducts);
      };

      /*
        Adds a SKU to the basket entity based on the discriminator for the Basket entity.
       */
      $scope.addToBasket = function (product) {
        // Set the pack type from the dynamic data, or the product props - whichever is available
        var packTypeId = product[$scope.productSearchResultsEnum.packTypeId];
        if (packTypeId == null) {
          packTypeId = product.packTypeId;
        }

        // Force our qty and C/W to 3 dp
        product.quantity = $scope.set3dp(product.quantity);
        product.catchWeight = $scope.set3dp(product.catchWeight);

        var qty = product.quantity,
          catchWeight = product.catchWeight,
          decimalError = false;

        //This handles skuSearch AND product Search

        //Changed to allow catch weight with null quantity for shopping lists ~ JP
        // Checks if the basket type is a ProcurementBasket. If it is then perfect qty checks to force a Qty on the BasketItem
        // and check if it can be a decimal. If the item is a C/W SKU and has no C/W then Qty can be decimal.
        // If the SKU is not a C/W SKU **OR** It has a C/W then Qty must be an integer.
        if ($scope.basket.discriminator == enums.procurementBasketType.ProcurementBasket) {
          if (packTypeId != 2 && validationHelper.isDecimalStrict(parseFloat(qty)) ||
            packTypeId == 2 && validationHelper.isDecimalStrict(parseFloat(qty)) && !validationHelper.isNullOrWhiteSpace(catchWeight)) {
            $translate('error_quantity_cannot_be_decimal').then(function (t) {
              toastr.error(t);
              return;
            });
            decimalError = true;
          }
        }

        // Our decimal checks are fine, continue
        if (!decimalError) {
          product.loading = true;

          // Sets the CSA on the product from our available CSA's
          basketService
            .setClientSupplierDtoOnIndividualProduct(product,
              $scope.availableClientSupplierAccounts);

          // Check if the product is valid before continuing
          if (self.isProductValid(product)) {
            var basketItem = self.convertProductToBasketItem(product);

            return basketService.addBasketItem(basketItem).$promise.then(function (newBasketItem) {
                // The item is added, perform the after-action
                self.addBasketItemCallback(product, basketItem, newBasketItem);
              },
              function (err) {
                toastr.error(err);
                product.loading = false;
              });
          } else {
            product.loading = false;
          }
        }
      };

      self.addBasketItemCallback = function (product, basketItem, newBasketItem) {
        self.setNullPropertiesForEqualityChecks(newBasketItem);
        toastr.success(self.translatedLabelForItemAddedToBasket);

        // Wtf? If items are unique OR not unique then increment? :facepalm:
        if (self.itemsAreUnique(basketItem, newBasketItem) ||
          !self.itemExistsInBasket(newBasketItem)) {
          basketStore.increment();
        }
        // Check if the `basketCount` prop exists on the product. Increment by ordered qty if it does, otherwise set it
        if (product.hasOwnProperty("basketCount")) {
          product.basketCount += newBasketItem.orderedQuantity;
        } else {
          if (!product[enums.productSearchResults.basketCount]) {
            product[enums.productSearchResults.basketCount] = 0;
          }

          if (self.itemExistsInBasket(newBasketItem)) {
            product[enums.productSearchResults.basketCount] += parseFloat(basketItem.quantity);
          } else {
            product[enums.productSearchResults.basketCount] += newBasketItem.orderedQuantity;
          }

        }
        $scope.basket.basketItems.push(newBasketItem);
        product.loading = false;
        //This is to disable the warning
        $scope.basketCount = 1;
      };

      /*
        Creates a basketItem object from a product used to send to the server as a ProcurementItemDto of X type
       */
      self.convertProductToBasketItem = function (product) {
        return basketItem = {
          procurementBasketId: $routeParams.basketId,
          quantity: product.quantity,
          catchWeight: product.catchWeight,
          skuId: product.bestPriceSkuId || product[enums.productSearchResults.bestPriceSkuId],
          ClientSupplierAccountDto: {id: product[enums.productSearchResults.clientSupplierAccountId]},
          packTypeId: product[enums.productSearchResults.packTypeId],
          searchDto: {
            searchCriteria: {
              priceRank: $scope.productData.rankType,
              savedSearchType: enums.savedSearchTypes.skuSearchExactSku
            }
          },
          itemPrice: product.price || product[enums.productSearchResults.price],
          originalPrice: product.price || product[enums.productSearchResults.price],
          isBestPrice: productSearchService.isBestPrice(product),
          rankPrice: product.rankPrice || product[enums.productSearchResults.rankPrice]
        };
      }

      /*
        Gets all products containing a Qty > 0. This is used by the "Add all Products" button.
       */
      $scope.productsWithQuantity = function () {
        return _.filter($scope.items, function (item) {
          return item.quantity > 0;
        });
      }

      $scope.createAdvancedSearchFromSku = function (sku) {
        if (!sku[enums.productSearchResults.productId]) return;
        var advancedSearchObj = productSearchService.createAdvancedSearchFromSkuObject(sku, $scope.productData.rankType);
        localStorage.setItem('advancedSearchObj', JSON.stringify(advancedSearchObj))
        $location.path('/advanced-search/create/' + $scope.basketId + '/0')
      };

      /*
        Adds many items to the Basket entity when the user clicks on the "Add all Products" button.
       */
      $scope.addItems = function () {
        $scope.savingManyItems = true;

        // Products to be added as items will have a quantity filled in the UI
        var productsToAdd = $scope.productsWithQuantity();
        var itemsToAdd = [];

        // Loop over the products we are adding - force the 3dp values, set the CSA dto and push to the `itemsToAdd` array for iterating
        _.each(productsToAdd, (function (product) {
          product.quantity = $scope.set3dp(product.quantity);
          product.catchWeight = $scope.set3dp(product.catchWeight);

          basketService.setClientSupplierDtoOnIndividualProduct(product, $scope.availableClientSupplierAccounts);

          itemsToAdd.push(self.convertProductToBasketItem(product));
        }));

        // Add all the new items to the ProcurementBasket
        return basketService.addBasketItems(itemsToAdd).$promise.then(function (data) {

            $translate('basket_added_items').then(function (t) {
              toastr.success(t);
            });

            // Loop over every saved item and increment the basket counter
            for (var i = 0; i < data.length; i++) {

              if (!self.itemExistsInBasket(data[i])) {
                basketStore.increment();
              }

              var productFromArray = _.find($scope.items, function (item) {
                return item[enums.productSearchResults.bestPriceSkuId] == data[i].skuId;
              });

              if (productFromArray.hasOwnProperty("basketCount")) {
                productFromArray.basketCount += 1;
              } else if (self.itemsAreUnique(productFromArray, data[i]) || !self.itemExistsInBasket(data[i])) {
                productFromArray[enums.productSearchResults.basketCount] += 1;
              } else {
                productFromArray[enums.productSearchResults.basketCount] = productFromArray[enums.productSearchResults.basketCount] || 1;
              }

              $scope.basket.basketItems.push(data[i]);

              //Wut Matt?
              //This is to disable the warning
              // $scope.basketCount = 1;

            }

            $scope.savingManyItems = false;

          },
          function (err) {
            toastr.error(err);
            $scope.savingManyItems = false;
          });
      };

      /*
       Check if the screen is mobile or not. We do this from screen size.

       This is used by the filtering to determine if it's a pop-out or full screen.
       */
      self.setupVariables = function () {
        $scope.mobile = validationHelper.isMobile();
      };
      var resizeTimeout;
      window.addEventListener("resize", function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(self.setupVariables(), 100);
      });

      $scope.init = function () {
        $scope.basketId = $routeParams.basketId;

        //Items will have to get initialized.
        $scope.items = [];

        //we will disable the message if basketCount > 1
        basketService.getBasketCount($scope.basketId).$promise.then(function (c) {
          $scope.basketCount = c.count;
        });
      }();
    }
  ]);

angular.module(appName)
    .factory('productSearchResource', [
        '$resource', 'siteUrl',
        function($resource, siteUrl) {
            var api = siteUrl() + 'api/ProductSearch';

            return $resource(api, {},
            {
                search: {
                    method: 'POST',
                    url: api + '/Search'
                },
                getAdditionalProducts: {
                    method: 'POST',
                    url: api + '/GetAdditionalProducts',
                    isArray: true
                }
            });
        }
    ])
angular.module(appName)
  .factory('productSearchService', [
    'productSearchResource',
    'organisationContextService',
    'enums',
    function (productSearchResource, organisationContextService, enums) {

      var ctx = organisationContextService.getContext();
      var currentSubscriptionUnitClientId = ctx.currentSubscriptionUnit.client.id;
      var orgId = ctx.currentSubscriptionUnit.organisation.id;

      var service = {
        search: function (searchData) {
          searchData.clientId = currentSubscriptionUnitClientId;
          searchData.organisationId = orgId;
          return productSearchResource.search(searchData);
        },
        getAdditionalProducts: function (searchData) {
          searchData.clientId = currentSubscriptionUnitClientId;
          searchData.organisationId = orgId;
          return productSearchResource.getAdditionalProducts(searchData);
        },
        /*
        Checks if a product is best price. If `ignoreRequiresEnum` is false then check if the product has an id.

        This is because the main search uses dynamic data types, but additional products use a strongly typed data set.
         */
        isBestPrice: function (product, ignoreRequiresEnum) {
          var requiresEnum;
          if (ignoreRequiresEnum) {
            requiresEnum = false;
          } else {
            requiresEnum = !product.id;
          }
          if (requiresEnum) {
            return product[enums.productSearchResults.price] == product[enums.productSearchResults.bestPrice];
          } else {
            return product.price == product.bestEquivalentP2Price;
          }
        },
        createAdvancedSearchFromSkuObject: function(sku, rankType) {
          return {
            attributeIds: sku.attributeIds ? sku.attributeIds : sku[enums.productSearchResults.attributeIds],
            priceRank: rankType,
            uom: {
              unitFrom: sku.unit ? sku.unit : sku[enums.productSearchResults.unit],
              unitTo: sku.unit ? sku.unit : sku[enums.productSearchResults.unit],
              caseFrom: sku.caseQuantity ? sku.caseQuantity : sku[enums.productSearchResults.caseQuantity],
              caseTo: sku.caseQuantity ? sku.caseQuantity : sku[enums.productSearchResults.caseQuantity],
              unitFromMeasure: {
                id: sku.measureId ? sku.measureId : sku[enums.productSearchResults.measureId]
              },
              unitToMeasure: {
                id: sku.measureId ? sku.measureId : sku[enums.productSearchResults.measureId]
              },
              packFrom: sku.packQuantity ? sku.packQuantity : sku[enums.productSearchResults.packQuantity],
              packTo: sku.packQuantity ? sku.packQuantity : sku[enums.productSearchResults.packQuantity]
            },
            returnUrl: window.location.href
          }
        }
      }

      return service;
    }
  ]);

angular.module(appName)
  .controller('productSearchForSegmentController', [
    '$scope',
    '$q',
    '$translate',
    '$filter',
    '$location',
    'basketData',
    'basketStore',
    'validationHelper',
    'organisationContextService',
    'enums',
    'productSearchService',
    'procurementSegmentItemService',
    'skuFavouriteService',
    'productFavouriteService',
    function ($scope,
              $q,
              $translate,
              $filter,
              $location,
              basketData,
              basketStore,
              validationHelper,
              organisationContextService,
              enums,
              productSearchService,
              procurementSegmentItemService,
              skuFavouriteService,
              productFavouriteService) {
      // #region Variable init
      var self = this;
      self.context = organisationContextService.getContext();
      self.resolves = {
        basketData: basketData
      };
      self.productAddedSuccessfullyTranslation = '';
      $scope.basketStore = basketStore;
      $scope.enums = enums;
      $scope.mobile = validationHelper.isMobile();
      $scope.showFilter = !$scope.mobile; // If mobile is true, we don't want to show by default. This needs to default to the opposite of $scope.mobile.
      $scope.productSearchResultsEnum = enums.productSearchResults;
      $scope.packTypeEnum = enums.packTypes;
      $scope.productData = {
        term: ""
      };
      // #endregion

      $scope.search = function (form, performFormValidation) {

        if (performFormValidation) {
          if (form.term.$dirty) {
            $scope.productData.term = form.term.$modelValue;
            $scope.productData.filters = [];
          }
        }

        $scope.loading = true;
        return productSearchService.search($scope.productData)
          .$promise.then(function (data) {
            $scope.productData.results = data.results;
            //This is to hit the watch in paginate
            if (data.results == null) {
              $scope.productData.results = {};
              $scope.productData.results.items = [];
            }

            $scope.productData.results.items = _.map($scope.productData.results.items, function (item, index) {
              item[enums.productSearchResults.sortIndex] = index;
              return item;
            });

            if (!$scope.productData.filters.length) {
              $scope.productData.filters = data.filters;

              $scope.$broadcast('updateFilterDirective');
            }

            if (data.results == null || data.results.length === 0) {
              $scope.items = null;
            }
          }, function (err) {
            $scope.productData.results = null;
          }).finally(function () {
            $scope.loading = false;
            form.term.$setPristine();
          });
      };

      var deleteFavouriteFlagFromUi = function (product) {
        delete product.favouriteId;
        delete product[$scope.productSearchResultsEnum.favouriteId];

        var skuId = product.bestPriceSkuId ? product.bestPriceSkuId : product[$scope.productSearchResultsEnum.bestPriceSkuId];
        if ($scope.additionalProducts && $scope.additionalProducts.length) {
          _.each($scope.additionalProducts[0].results, function (p) {
            if (p.bestPriceSkuId === skuId) {
              delete p.favouriteId;
            }
          });
        }
        _.each($scope.productData.results.items, function (p) {
          if (p[$scope.productSearchResultsEnum.bestPriceSkuId] === skuId) {
            delete p.favouriteId;
            delete p[$scope.productSearchResultsEnum.favouriteId];
          }
        });
      };

      var addFavouriteFlagToUi = function (product, favouriteId) {
        product.favouriteId = favouriteId;
        product[$scope.productSearchResultsEnum.favouriteId] = favouriteId;

        var skuId = product.bestPriceSkuId ? product.bestPriceSkuId : product[$scope.productSearchResultsEnum.bestPriceSkuId];

        if ($scope.additionalProducts && $scope.additionalProducts.length) {
          _.each($scope.additionalProducts[0].results, function (p) {
            if (p.bestPriceSkuId === skuId) {
              p.favouriteId = favouriteId;
            }
          });
        }
        _.each($scope.productData.results.items, function (p) {
          if (p[$scope.productSearchResultsEnum.bestPriceSkuId] === skuId) {
            p.favouriteId = favouriteId;
            p[$scope.productSearchResultsEnum.favouriteId] = favouriteId;
          }
        });
      };

      /*
        Toggles whether or not the attribute filters are visible.
       */
      $scope.toggleFilter = function () {
        $scope.showFilter = !$scope.showFilter;
      };

      $scope.toggleFavourite = function (product) {
        var productId = product.id ? product.id : product[0];
        var skuId = product[7];

        if (product[$scope.productSearchResultsEnum.favouriteId])
          product.favouriteId = product[$scope.productSearchResultsEnum.favouriteId];
        var favouriteId;
        if (product.favouriteId) {
          favouriteId = product.favouriteId;
          productFavouriteService.deleteFavourite(product.favouriteId).then(null, function () {
            addFavouriteFlagToUi(product, favouriteId);
          });
          deleteFavouriteFlagFromUi(product);
        } else {
          favouriteId = uuid.v4();
          addFavouriteFlagToUi(product, favouriteId);
          skuFavouriteService.createFavourite(favouriteId, skuId, procurementCliuentUnitDepartmentId)
            .then(null, function () {
              deleteFavouriteFlagFromUi(product);
            });
        }
      };

      $scope.applyFilters = function (productData) {
        $scope.search();
      };

      $scope.set3dp = function (input) {
        if (input != null && input != '') {
          if (isNaN(parseFloat(input))) {
            input = null;
            $translate('error_please_enter_valid_number').then(function (t) {
              toastr.error(t);
              return input;
            });
          } else {
            input = parseFloat(input).toFixed(3);
            return input;
          }
        }
      };

      $scope.getAttributes = function (skuAttributesCsv) {
        return skuAttributesCsv
          .slice(0, skuAttributesCsv.length)
          .split(',');
      }

      $scope.getAdditionalProducts = function ($event, product) {
        $scope.additionalProducts = {};
        product.loadingAdditionalProducts = true;
        var additionalProductsToClose = _($scope.productData.results.items).findWhere({showAdditionalProducts: true});
        if (additionalProductsToClose != null && additionalProductsToClose.showAdditionalProducts == true) {
          additionalProductsToClose.showAdditionalProducts = false;
          if (additionalProductsToClose[0] != product[0]) {
            product.showAdditionalProducts = true;
          }
        } else {
          product.showAdditionalProducts = true;
        }

        if (product.showAdditionalProducts) {
          var searchData = {
            basketId: $scope.basketEntity.id,
            term: $scope.productData.term,
            filters: $scope.productData.filters,
            productId: product[enums.productSearchResults.productId],
            filterFavourites: $scope.productData.filterFavourites,
            skuId: product[enums.productSearchResults.bestPriceSkuId],
            rankType: $scope.productData.rankType
          };
          searchData.organisationId = self.context.currentSubscriptionUnit.organisation.id;
          searchData.productId = product[enums.productSearchResults.productId];

          searchData.clientId = self.context.currentSubscriptionUnit.client.id;
          productSearchService.getAdditionalProducts(searchData).$promise.then(function (additionalProducts) {
            $scope.additionalProducts = additionalProducts;
            product.loadingAdditionalProducts = false;
          }, function (err) {
            $translate("error_additional_products").then(function (translation) {
              toastr.error(translation);
            });
            product.loadingAdditionalProducts = false;
          });
        } else {
          product.loadingAdditionalProducts = false;
        }
      };


      $scope.shouldShowAdditionalProducts = function (product) {
        return ($scope.mobile && product.showAdditionalProducts && !product.loadingAdditionalProducts) ||
          (!$scope.mobile && product.showAdditionalProducts && !product.loadingAdditionalProducts);
      };

      $scope.isBestPrice = function (product) {
        return productSearchService.isBestPrice(product);
      };

      $scope.disableAddToBasketButton = function (product) {
        return $scope.addingProduct || basketStore.get() === 300;
      };

      $scope.addProduct = function (product) {
        $scope.addingProduct = true;
        var basketItem = {
          procurementBasketId: $scope.basketEntity.id,
          quantity: $scope.set3dp(product.quantity),
          catchWeight: $scope.set3dp(product.catchWeight),
          skuId: product.bestPriceSkuId || product[enums.productSearchResults.bestPriceSkuId],
          clientSupplierAccountDto: {
            id: product.clientSupplierAccountId ||
              product[enums.productSearchResults.clientSupplierAccountId]
          },
          packTypeId: product.packTypeId || product[enums.productSearchResults.packTypeId],
          segmentId: $scope.basketEntity.procurementSegmentDto.id,
          procurementBasketTypeEnum: $scope.basketEntity.discriminator,
          searchDto: {
            searchCriteria: {
              priceRank: $scope.productData.rankType,
              savedSearchType: enums.savedSearchTypes.skuSearchExactSku
            }
          },
          itemPrice: product.price || product[enums.productSearchResults.price],
          originalPrice: product.price || product[enums.productSearchResults.price],
          isBestPrice: productSearchService.isBestPrice(product),
          rankPrice: product.rankPrice || product[enums.productSearchResults.rankPrice]
        };
        return procurementSegmentItemService.addProductToSegment(basketItem).then(function () {
          product[enums.productSearchResults.basketCount] = product[enums.productSearchResults.basketCount] ?
            product[enums.productSearchResults.basketCount] + 1 :
            1;

          var translation;
          switch ($scope.basketEntity.discriminator) {
            case enums.procurementBasketType.ShoppingList:
              translation = $translate.instant('label_item_added_to_shopping_list');
              break;
            case enums.procurementBasketType.OrderGuide:
              translation = $translate.instant('label_item_added_to_order_guide');
              break;
          }
          basketStore.increment(1);
          toastr.success(translation);
        }).finally(function () {
          $scope.addingProduct = false;
        });
      };

      $scope.sort = function () {
        console.log('$scope.sortOn.filterExpr', $scope.sortOn.filterExpr);
        if ($scope.sortOn.filterExpr === undefined) {
          $scope.sortOn.filterExpr = '+' + enums.productSearchResults.sortIndex;
        }
        $scope.productData.results.items = $filter('orderBy')($scope.productData.results.items, $scope.sortOn.filterExpr);
      };

      $scope.createAdvancedSearchFromSku = function (sku) {
        if ((!sku.hasOwnProperty('id') && !sku[enums.productSearchResults.productId]) ||
          (sku.hasOwnProperty('id') && sku.id == null)) return;
        var advancedSearchObj = productSearchService.createAdvancedSearchFromSkuObject(sku, $scope.productData.rankType);
        localStorage.setItem('advancedSearchObj', JSON.stringify(advancedSearchObj))
        $location.path('/advanced-search/create/' + $scope.basketId + '/' + $scope.basketEntity.procurementSegmentDto.id)
      };

      var procurementCliuentUnitDepartmentId;
      $q.all(self.resolves).then(function (resolved) {
        procurementCliuentUnitDepartmentId = resolved.basketData.procurementClientUnitDepartmentId;
        $scope.basketEntity = resolved.basketData;
        $scope.basketId = $scope.basketEntity.id;
      });
    }
  ]);

angular.module(appName)
    .factory('skuFavouriteService', [
		'$http', 'siteUrl', function ($http, siteUrl) {

			var endpointUrl = siteUrl() + 'api/favourite';

			var service = {
				createFavourite: function (favouriteId, skuId, departmentId) {
					var url = endpointUrl + '/' + favouriteId;
					var requestData = {
						id: favouriteId,
						skuId: skuId,
						departmentId: departmentId
					}
					return $http.put(url, requestData);
				},
				createFavourites: function (favouriteId, skuId, departmentIds) {
					var url = endpointUrl + 's';
					var requestData = {
						favouriteId: favouriteId,
						skuId: skuId,
						pruductId: null,
						departmentIds: departmentIds
					}
					return $http.put(url, requestData);
				}
			}

			return service;
		}
    ]);

angular.module(appName)
	.directive("addFromCatalogue",
        function () {
            var controller = function ($scope,
                    $rootScope,
                    $http,
                    genericUiGrid,
                    productSearchService,
                    enums,
                    $translate) {
                $translate.onReady().then(function() {
                    self.setupProperties = function() {
                        console.log('hit');
                        $scope.searchTerm = '';
                        if ($scope.productCatalogueSearchGrid) {
                            $scope.productCatalogueSearchGrid.data = [];
                            $scope.productCatalogueSearchGrid.hasSearched = false;
                        }
                    }

                    $scope.submitSearch = function(searchTerm) {
                        $scope.isSearching = true;
                        $scope.productCatalogueSearchGrid.data = [];
                        var searchOptions = {
                            term: searchTerm,
                            responseType: "BeagleProductSearchPurchaseOrderResponse",
                            searchTypeEnum: 1,
                            filters: [
                                {
                                    filterType: 'Suppliers',
                                    name: 'Suppliers',
                                    items: [
                                        { id: $scope.purchaseOrder.selectedAccount.supplierId, isSelected: true }
                                    ]
                                }
                            ]
                        };
                        productSearchService.search(searchOptions).$promise.then(function(result) {
                            $scope.searchProducts = result.results;
                            $scope.productCatalogueSearchGrid.data = result.results;
                        }).finally(function() {
                            $scope.isSearching = false;
                            $scope.productCatalogueSearchGrid.hasSearched = true;
                        });
                    };

                    $scope.returnToPurchaseOrder = function($form) {
                        $form.$dirty = false;
                        $scope.singlePurchaseOrderScope.addFromSupplierCatalogue();
                    };

                    var init = function() {
                        $rootScope.$on(enums.eventNames.purchaseOrderCatalogueSearchRequestToggled,
                            self.setupProperties);

                        $scope.loadingProductSearch = true;
                        var gridPromise = genericUiGrid.create(
                            {
                                data: [],
                                columns: [
                                    {
                                        displayName: $translate.instant('sku_code'),
                                        field: "skuCode",
                                        width: 150
                                    },
                                    {
                                        displayName: $translate.instant('description'),
                                        field: "description",
                                        minWidth: 450
                                    },
                                    {
                                        displayName: $translate.instant('price'),
                                        field: "price",
                                        width: 100,
                                        cellClass: 'number',
                                        cellFilter: "pslContextCurrency"
                                    }
                                ],
                                rowClick: $scope.singlePurchaseOrderScope.addFromSupplierCatalogue
                            });
                        gridPromise.then(function(grid) {
                            $scope.productCatalogueSearchGrid = grid;
                        }).finally(function() {
                            $scope.loadingProductSearch = false;
                        });
                    };
                    init();
                });
            }

            return {
                controller: controller,
                scope: false,
                templateUrl: '/ngxbeagle/dist/Content/js/modules/purchaseorders/addfromcatalogue/addfromcatalogue.html'
            }

        });

"use strict";

angular.module(appName)
    .controller("createdPurchaseOrdersController", [
        "$scope",
        "$http",
        "$routeParams", "purchaseOrderService", "localStorageService", "enums", "$translate",
        function ($scope, $http, $routeParams, purchaseOrderService, localStorageService, enums, $translate) {

            $scope.deletePurchaseOrder = function(purchaseOrder) {
                console.log("delete this Purchase Order", purchaseOrder);
                purchaseOrderService.deletePurchaseOrder(purchaseOrder, self.context.currentSubscriptionUnit.id).then(function () {
                    $scope.purchaseOrders.remove(purchaseOrder);
                    $translate('purchase_order_deleted').then(function (translation) {
                        toastr.success(translation);
                    });
                });
            };

            var init = function () {
                $scope.loading = true;
                $scope.purchaseOrders = [];
                self.context = localStorageService.getItem(enums.localStorage.organisationContext);
                var getOptions = {
                    params: {
                        purchaseOrderIds: $routeParams.purchaseOrderIds,
                        projection: "PurchaseOrders.CreatedPurchaseOrderDto"
                    }
                };
                $http.get("api/purchaseorder", getOptions).then(function(result) {
                    $scope.purchaseOrders = result.data;
                    $scope.loading = false;
                });
            };
            init();
        }
    ]);
"use strict";


angular.module(appName)
    .controller("createPurchaseOrdersController", [
        "$scope",
        "$http",
        "$timeout",
        "$location",
        "purchaseOrderService",
        "localStorageService",
        "enums",
        "basketService",
        "moment",
        "$window",
        function ($scope, $http, $timeout, $location, purchaseOrderService, localStorageService, enums, basketService, moment, $window) {
            var self = this;
            $scope.purchaseOrderCreated = false;

            $scope.purchaseOrderPreviews = [];

            $scope.selectedBaskets = function () {
                var selectedBaskets = [];
                _.each($scope.baskets, function (basket) {
                    if (basket.include)
                        selectedBaskets.push(basket);
                });
                return selectedBaskets;
            };
            var debounce;
            var getBasketPreviews = function () {
                var deliveryDates = _.map($scope.selectedBaskets(), function (basket) {
                    return basket.deliveryDate;
                });
                $scope.sameDeliveryDates = deliveryDates.allValuesSame();
                if (!$scope.selectedBaskets().length)
                    return;
                $scope.waitingOnServer = true;

                var dto = {};
                dto.id = $scope.context.currentSubscriptionUnit.id;
                dto.basketIds = getBasketIds();

                if (debounce) {
                    $timeout.cancel(debounce);
                }
                debounce = $timeout(function() {
                        self.getBasketsWithNullPricedItems(dto.basketIds,
                            function() {
                                $http.post("/api/purchaseorder/previewPurchaseOrders", dto).then(function(result) {
                                    $scope.purchaseOrderPreviews = result.data;
                                }).finally(function() {
                                    $scope.waitingOnServer = false;
                                });
                            });
                    },
                    800);

            };
            $scope.toggleAll = function () {
                $scope.includeAll = !$scope.includeAll;
                _.each($scope.baskets, function (basket) {
                    basket.include = $scope.includeAll;
                });
                getBasketPreviews();
            };

            $scope.toggle = function () {
                $scope.basketsWithNullItems = false;
                getBasketPreviews();
            };
            $scope.createPurchaseOrders = function () {
                $scope.waitingOnServer = true;
                $scope.creatingPurchaseOrders = true;

                var dto = {};
                dto.id = $scope.context.currentSubscriptionUnit.id;
                dto.basketIds = getBasketIds();
                self.getBasketsWithNullPricedItems(dto.basketIds,
                    function () {
                        purchaseOrderService.createPurchaseOrders(dto, function (result) {
                            if (result.status == 500) {
                                $window.history.back();
                            } else {
                                $scope.purchaseOrderCreated = true;
                                var path = "/PurchaseOrders/CreatedPurchaseOrders/" +
                                    _.map(result, function(e) { return e.id }).join(',');
                                $location.path(path);
                                $scope.waitingOnServer = false;
                                $scope.creatingPurchaseOrders = false;
                            }
                        });
                    });
            };
            //Only shows for ASAP delivery
            $scope.isDateTomorrow = function (deliveryDate) {
                if ($scope.selectedBaskets.count <= 0)
                    return true;
                var anyBasket = $scope.selectedBaskets()[0];
                if (!anyBasket.isAsapDelivery)
                    return true;

                var delDate = moment(deliveryDate, "DD/MM/YYYY");
                return self.tomorrow.getTime() == delDate._d.getTime();
            }

            $scope.previewPurchaseOrders = function () {
                $scope.waitingOnServer = true;
                $scope.creatingPurchaseOrders = true;
                var dto = {};
                dto.id = $scope.context.currentSubscriptionUnit.id;
                dto.basketIds = getBasketIds();
                self.getBasketsWithNullPricedItems(dto.basketIds, function () {
                    purchaseOrderService.previewPurchaseOrders(dto).then(function (result) {
                        $scope.purchaseOrderPreviews = result.data;
                    }).finally(function () {
                        $scope.waitingOnServer = false;
                    });
                });
            };

            self.getBasketsWithNullPricedItems = function (basketIds, cb) {
                basketService.getBasketsWithNullPricedItems(basketIds,
                    function (data) {
                        if (data.length > 0) {
                            $scope.baketsWithNullItemArray = _.map(_.filter($scope.baskets,
                                    function (basket) {
                                        return data.indexOf(basket.id) > -1;
                                    }),
                                function (item) {
                                    return item.name;
                                }).join(",");
                            $scope.basketsWithNullItems = true;
                            $scope.waitingOnServer = false;
                        } else {
                            cb();
                        }
                    });
            }
            Array.prototype.allValuesSame = function () {

                for (var i = 1; i < this.length; i++) {
                    if (this[i] !== this[0])
                        return false;
                }

                return true;
            }
            var getBasketIds = function () {
                var ids = _.pluck($scope.selectedBaskets(), "id");
                return ids;
            };


            var currentDate = new Date();
            currentDate.setDate(currentDate.getDate() + 1);
            currentDate.setHours(0, 0, 0, 0);
            self.tomorrow = currentDate;

            var init = function () {
                //Keep this as true. This is to fix the bug with selectAll setting calling includeall which starts it as true cz x = !x.
                $scope.includeAll = true;
                $scope.toggleAll();
                getBasketPreviews();
                $scope.basketsWithNullItems = false;
                $scope.context = localStorageService.getItem(enums.localStorage.organisationContext);
                $scope.loadingBaskets = true;
                basketService.getSubmittedBaskets($scope.context.currentSubscriptionUnit.id,
                    function (data) {
                        
                       if (data.length == 0) {
                           $scope.baskets = [];
                       }
                        //Check data for error (PO data not setup at unit)
                        else if (data[0].error == true) {
                            $scope.error = true;
                            $scope.baskets = [];
                        } else {
                            //THIS should really be done in the profiler.
                            _.each(data, function (basket) {
                                if (basket.procurementBasketStatus.id == 2) {
                                    basket.procurementBasketStatus.status = "Submitted";
                                };
                            });

                            $scope.baskets = data;
                        }

                        $scope.loadingBaskets = false;
                    });
            };
            init();
        }
    ]);
angular.module(appName)
    .controller('searchPurchaseOrdersController', [
		'$scope',
		'purchaseOrderService',
		'receivingPurchaseOrderService',
		'organisationContextService',
		'paginationFactory',
		'enums',
		'localStorageService',
		'userService',
		'$translate',
		'$location',
		'$routeParams',
		function (
			$scope,
			purchaseOrderService,
			receivingPurchaseOrderService,
			organisationContextService,
			paginationFactory,
			enums,
			localStorageService,
			userService,
			$translate,
			$location,
			$routeParams) {
            $translate.onReady().then(function() {
                var self = this;
                self.context = organisationContextService.getContext();
                paginationFactory.addPaginationVariablesAndFunctionsToScope($scope);

                $scope.enums = enums;

                $scope.searchParams = localStorageService.getItem(enums.localStorage.purchaseOrderSearch)
                    || {
                        statusIds: '',
                        term: '',
                        paginate: true,
                        currentPage: 1,
                        numPerPage: 20,
                        sortField: 'PurchaseOrderNumber',
                        sortAsc: true,
                        showOpen: true,
                        showSubmitted: true,
                        showTransmitted: true,
                        showPartReceived: true,
                        showReceived: true
                    };
                $scope.searchParams.id = self.context.currentSubscriptionUnit.id;

                $scope.sortOn = {
                    column: 'purchaseOrderNumber',
                    sortState: 'Descending'
                };

                $scope.loading = {
                    search: false
                }

                $scope.deletePurchaseOrder = function(purchaseOrder) {
                    console.log("delete this Purchase Order", purchaseOrder);
                    purchaseOrderService.deletePurchaseOrder(purchaseOrder, self.context.currentSubscriptionUnit.id)
                        .then(function() {
                            $scope.purchaseOrders.remove(purchaseOrder);
                            $translate('purchase_order_deleted').then(function(translation) {
                                toastr.success(translation);
                            });
                        });
                };

                $scope.showReceiveButton = function(purchaseOrder) {
                    return purchaseOrder.status.id == enums.purchaseOrderStatus.transmitted ||
                        purchaseOrder.status.id == enums.purchaseOrderStatus.partReceived ||
                        purchaseOrder.status.id == enums.purchaseOrderStatus.awaitingAcceptance ||
                        purchaseOrder.status.id == enums.purchaseOrderStatus.submitted;
                }

                $scope.showViewReceivingButton = function(purchaseOrder) {
                    return purchaseOrder.status.id == enums.purchaseOrderStatus.received ||
                        purchaseOrder.status.id == enums.purchaseOrderStatus.completed;
				}

	            self.updateSearchParams = function (sortField, forcePageOne) {
		            $scope.searchParams.statusIds = '';

		            if (sortField) {
			            $scope.searchParams.sortField = sortField;
		            }

		            $scope.searchParams.sortField = $scope.sortOn ? $scope.sortOn.column : 'PurchaseOrderDate';
		            if ($scope.sortOn.sortState == enums.sortStates.ascending) {
			            $scope.searchParams.sortAsc = true;
		            } else if ($scope.sortOn.sortState == enums.sortStates.descending) {
			            $scope.searchParams.sortAsc = false;
		            }

		            if ($scope.pagination) {
			            $scope.searchParams.numPerPage = $scope.pagination.numPerPage;

			            if (forcePageOne) {
				            $scope.pagination.currentPage = 1;
			            }

			            $scope.searchParams.currentPage = $scope.pagination.currentPage;
		            }
	            }

                $scope.search = function(sortField, forcePageOne) {
                    $scope.loading.search = true;

                    // Set pagination params
                    self.updateSearchParams(sortField, forcePageOne);

                    // Do not store the Id in storage. It causes issues with impersonation and changing units.
                    $scope.searchParams.id = null;
                    localStorageService.setItem(enums.localStorage.purchaseOrderSearch, $scope.searchParams);
                    $scope.searchParams.id = self.context.currentSubscriptionUnit.id;

                    // Create comma separated string of statuses to search
                    purchaseOrderService.createStatusIdString($scope.searchParams);
                    purchaseOrderService.search($scope.searchParams).then(function(pagedDto) {
                            _.each(pagedDto.list,
                                function(item) {
                                    item.departmentNames = item.departmentNamesString.split(',').join([seperator = '\r\n']);
                                    item.flip = {po:false,rpo:false};
                                });
                            $scope.purchaseOrders = pagedDto.list;
                            $scope.pagination.total = pagedDto.total;
                            $scope.loading.search = false;
                        },
                        function(err) {
                            $scope.loading.search = false;
                        });
                }

                $scope.download = function(purchaseOrder) {
                    purchaseOrder.downloading = true;
                    purchaseOrderService.downloadPurchaseOrder(purchaseOrder).then(function(po) {
                            purchaseOrder.downloading = false;
                        },
                        function(err) {
                            purchaseOrder.downloading = false;
                        });
                }

                $scope.flipPurchaseOrder = function(purchaseOrder) {
                    purchaseOrder.flipping = true;
                    purchaseOrderService.flipPurchaseOrder(purchaseOrder.id, purchaseOrder.id).then(
                        function(invoiceDto) {
                            $translate('success_flipping_po').then(function(translation) {
                                toastr.success(translation);
                            });
                            var invoiceId = invoiceDto.id;
                            var subscriptionUnitId = self.context.currentSubscriptionUnit.id;
                            var url = "/ViewUnitInvoice/" + subscriptionUnitId + "/" + invoiceId;
                            window.location.href = url;
                        },
                        function(err) {
                            $translate('error_flipping_po').then(function(translation) {
                                toastr.error(translation);
                            });
                        }).finally(function() {
                        purchaseOrder.flipping = false;
                    });
                };

                $scope.flipRPO = function(purchaseOrder) {
                    purchaseOrder.flipping = true;
                    receivingPurchaseOrderService.flipRPOToInvoice(purchaseOrder).then(function(invoiceDto) {
                        toastr.success($translate.instant('flipped_receiving_purchase_order'));
                        var invoiceId = invoiceDto.id;
                        var subscriptionUnitId = self.context.currentSubscriptionUnit.id;
                        var url = "/ViewUnitInvoice/" + subscriptionUnitId + "/" + invoiceId;
                        window.location.href = url;
                    });
                };

                $scope.toggleShowActions = function(purchaseOrder) {
                    purchaseOrder.showActions = !purchaseOrder.showActions;
                };

                $scope.$on(enums.eventNames.sortOnElementChangedEventName,
                    function(event) {
                        if (event.targetScope === $scope) {
                            $scope.search($scope.searchParams.sortField, true);
                        };
                    });

				var mapQueryStringToRouteParams = function () {
					if (!_.isEmpty($routeParams)) {
						_.mapObject($routeParams,
							function (val, key) {
								$scope.searchParams[key] = val;
							});
						$scope.search();
					}
				}

				self.init = function () {
					mapQueryStringToRouteParams();
                    $scope.$watchGroup(["pagination.currentPage + pagination.numPerPage"],
                        function() {
                            if ($scope.pagination &&
                                $scope.pagination.currentPage &&
                                $scope.pagination.numPerPage) {
                                $scope.search(null, false);
                            }
                        });

                    $scope.canCreateInvoices = false;
                    userService.hasPermission('BEAGLE_CREATE_INVOICE_FROM_PO').then(function() {
                        $scope.canCreateInvoices = true;
					});
                }();
            });
        }
    ]);
angular.module(appName)
	.factory("purchaseOrderLineFactory",
	[
		"$http",
		"siteUrl",
		"$q",
		function ($http, siteUrl, $q) {

			var baseUrl = siteUrl() + "api";

			return {
				createCataloguePurchaseOrderLine: function(createCataloguePurchaseOrderLineRequestDto) {
					var url = baseUrl + '/cataloguePurchaseOrderLine';
					return $http.post(url, createCataloguePurchaseOrderLineRequestDto);
				},
				updatePurchaseOrderLine: function(updatePurchaseOrderLineRequestDto) {
					var dto = updatePurchaseOrderLineRequestDto;
					var url = baseUrl + '/purchaseOrderLine/' + dto.purchaseOrderLineId;
					return $http.put(url, updatePurchaseOrderLineRequestDto);
				},
				upsertManualPurchaseOrderLines: function (updateManualPurchaseOrderLineRequestDtos) {
					if (!updateManualPurchaseOrderLineRequestDtos.length) {
						var deferred = $q.defer();
						deferred.resolve(null);
						return deferred;
					}
					var url = baseUrl + '/manualPurchaseOrderLines/';
					return $http.put(url, updateManualPurchaseOrderLineRequestDtos);
				}
			};
		}
	]);
angular.module(appName)
    .factory('purchaseOrderResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var self = this;
            self.api = siteUrl() + 'api/PurchaseOrder';

            return $resource(self.api, {}, {
                search: {
                    method: 'GET',
                    url: self.api + '/Search',
                    params: {
                        id: '@id',
                        statusIds: '@statusIds',
                        term: '@term',
                        paginate: '@paginate',
                        currentPage: '@currentPage',
                        numPerPage: '@numPerPage',
                        sortField: '@sortField',
                        sortAsc: '@sortAsc'
                    }
                },
                createManualPurchaseOrders: {
                    method: 'POST',
                    url: self.api + '/CreateManualPurchaseOrder',
                    params: {
                        id: '@id'
                    }
                },
                getAccountsForUnit: {
                    method: 'GET',
                    url: self.api + '/GetAccountsForUnit',
                    params: {
                        id: '@id'
                    },
                    isArray: true
                },
                selectAccountForPO: {
                    method: 'POST',
                    url: self.api + '/SelectAccountForPO',
                    params: {
                        id: '@id',
                        accountNo: '@accountNo',
                        purchaseOrderId: '@purchaseOrderId',
                        supplierId: '@supplierId'
                    }
                },
                createPurchaseOrders: {
                    method: 'POST',
                    url: self.api + '/CreatePurchaseOrders',
                    isArray: true
                },
                previewPurchaseOrders: {
                    method: 'POST',
                    url: self.api + '/PreviewPurchaseOrders'
                },
                submitPurchaseOrder: {
                    method: 'POST',
                    url: self.api + '/SubmitPurchaseOrder',
                    params: {
                        id: '@id',
                        purchaseOrderId: '@purchaseOrderId',
                        transmissionType: '@transmissionType'
                    }
                },
                getNextAvailableDeliveryDateForPO: {
                    method: 'GET',
                    url: self.api + '/GetNextAvailableDeliveryDateForPO',
                    params: {
                        id: '@id',
                        accountNumber: '@accountNumber',
                        purchaseOrderId: '@purchaseOrderId'
                    }
                },
                saveNotes: {
                    method: 'POST',
                    url: self.api + '/SaveNotes',
                    params: {
                        id: '@id',
                        purchaseOrderId: '@purchaseOrderId',
                        notes: '@notes'
                    }
                },
                savePoDeliveryDate: {
                    method: 'PUT',
                    url: self.api + '/SavePurchaseOrderDeliveryDate',
                    params: {
                        id: '@id',
                        deliveryDate: '@deliveryDate',
                        purchaseOrderId: '@purchaseOrderId'
                    }
                },
                getVatRatesForPurchaseOrderId: {
                    method: 'GET',
                    url: self.api + '/GetVatRatesForPurchaseOrderId',
                    params: {
                        id: '@id',
                        purchaseOrderId: '@purchaseOrderId'
                    },
                    isArray: true
                },
                flipPurchaseOrder: {
                    method: 'POST',
                    url: self.api + '/FlipPurchaseOrder',
                    params: {
                        id: '@id',
                        purchaseOrderId: '@purchaseOrderId'
                    }
                },
                flipPurchaseOrderWithRandomise: {
                    method: 'POST',
                    url: self.api + '/FlipPurchaseOrderWithRandomise',
                    params: {
                        id: '@id',
                        purchaseOrderId: '@purchaseOrderId'
                    }
                },
                getUnreconciledPurchaseOrders: {
                    method: 'GET',
                    url: self.api + '/GetUnreconciledPurchaseOrders',
                    params: {
                        id: '@id'
                    }
                },
                cancelPurchaseOrder : {
                    method: 'POST',
                    url: self.api + '/CancelPurchaseOrder',
                },
                setReceivedPurchaseOrderToPartReceived: {
                    method: 'POST',
                    url: self.api + '/SetReceivedPurchaseOrderToPartReceived',
                    params: {
                        id: '@id',
                        purchaseOrderId: '@purchaseOrderId'
                    }
                }
            });
        }
    ]);
angular.module(appName)
    .factory('purchaseOrderService', [
        'purchaseOrderResource',
		'enums',
		'$http',
		'siteUrl',
        'fileDownloadService',
        'organisationContextService',
        function (purchaseOrderResource, enums, $http, siteUrl, fileDownloadService, organisationContextService) {
            
            return {
                deletePurchaseOrder: function (purchaseOrder, procurementSubscriptionUnitId) {
                    return $http.delete('api/purchaseorder/deletepurchaseorder',
                        { params : {
                            purchaseOrderId: purchaseOrder.id,
                            id: procurementSubscriptionUnitId
                            }
                        });
                },
            	sendPurchaseOrderToSupplier: function (sendPurchaseOrderToSupplierRequestDto) {
		            var dto = sendPurchaseOrderToSupplierRequestDto;
		            var url = siteUrl() + 'api/PurchaseOrder/' + dto.purchaseOrderId + '/sendtosupplier';
		            return $http.post(url, sendPurchaseOrderToSupplierRequestDto);
	            },

                search: function (searchModel) {
                    return purchaseOrderResource.search({
                        id: searchModel.id,
                        statusIds: searchModel.statusIds,
                        term: searchModel.term,
                        paginate: searchModel.paginate,
                        currentPage: searchModel.currentPage,
                        numPerPage: searchModel.numPerPage,
                        sortField: searchModel.sortField,
                        sortAsc: searchModel.sortAsc
                    }).$promise;
                },
                createManualPurchaseOrders: function (unitId, cb) {
                    var dto = {};
                    dto.id = unitId;
                    return purchaseOrderResource.createManualPurchaseOrders(dto).$promise.then(function (data) {
                        cb(data);
                    }, function(error) {
                        cb(error);
                    });
                },
                selectAccountForPO: function (unitId, accountNo, purchaseOrderId,supplierId, cb) {
                    var dto = {};
                    dto.id = unitId;
                    dto.accountNo = accountNo;
                    dto.purchaseOrderId = purchaseOrderId;
                    dto.supplierId = supplierId;
                    return purchaseOrderResource.selectAccountForPO(dto).$promise.then(function (data) {
                        cb(data);
                    });
                },
                getAccountsForUnit: function (unitId, cb) {
                    var dto = {};
                    dto.id = unitId;
                    return purchaseOrderResource.getAccountsForUnit(dto).$promise.then(function (data) {
                        cb(data);
                    });
                },
                createPurchaseOrders: function (dto, cb) {
                    return purchaseOrderResource.createPurchaseOrders(dto).$promise.then(function (data) {
                        cb(data);
                    }, function (error) {
                        cb(error);
                    });
                },
                previewPurchaseOrders: function (dto) {
                    return purchaseOrderResource.previewPurchaseOrders(dto).$promise;
                },
                createStatusIdString: function(searchParams) {                    
                    var statuses = [];
                    if (searchParams.showOpen) {
                        statuses.push(enums.purchaseOrderStatus.open);
                    }
                    if (searchParams.showSubmitted) {
                        statuses.push(enums.purchaseOrderStatus.submitted);
                    }
                    if (searchParams.showTransmitted) {
                        statuses.push(enums.purchaseOrderStatus.transmitted);
                    }
                    if (searchParams.showPartReceived) {
                        statuses.push(enums.purchaseOrderStatus.partReceived);
                    }
                    if (searchParams.showReceived) {
                        statuses.push(enums.purchaseOrderStatus.received);
                    }
                    if (searchParams.showCompleted) {
                        statuses.push(enums.purchaseOrderStatus.completed);
                    }
                    if (statuses) {
                        searchParams.statusIds = statuses.join(',');
                    }

                    return searchParams;
                },
                downloadPurchaseOrder: function (purchaseOrder) {
                    var context = organisationContextService.getContext();
                    var url = '/api/PurchaseOrder/downloadPurchaseOrder?id=' + context.currentSubscriptionUnit.id + '&purchaseOrderId=' + purchaseOrder.id;
                    return fileDownloadService.downloadFile(url, purchaseOrder.purchaseOrderNumber, 'pdf');
                }
                ,
                submitPurchaseOrder: function (purchaseOrderId, unitId, transmissionMethodId, cb) {
                    var dto = {};
                    dto.id = unitId;
                    dto.purchaseOrderId = purchaseOrderId;
                    dto.transmissionType = transmissionMethodId;
                    return purchaseOrderResource.submitPurchaseOrder(dto).$promise.then(function (data) {
                        cb(data);
                    });
                },

                getNextAvailableDeliveryDateForPO: function (unitId, accountNumber, purchaseOrderId, cb) {
                    var dto = {};
                    dto.id = unitId;
                    dto.accountNumber = accountNumber;
                    dto.purchaseOrderId = purchaseOrderId;
                    return purchaseOrderResource.getNextAvailableDeliveryDateForPO(dto).$promise.then(function (data) {
                        cb(data);
                    });
                },

                savePoDeliveryDate: function (unitId, purchaseOrderId, deliveryDate, cb) {
                    var dto = {};
                    dto.id = unitId;
                    dto.deliveryDate = deliveryDate;
                    dto.purchaseOrderId = purchaseOrderId;
                    return purchaseOrderResource.savePoDeliveryDate(dto).$promise.then(function (data) {
                        cb(data);
                    });
                },

                getVatRatesForPurchaseOrderId: function (unitId, purchaseOrderId, cb) {
                    var dto = {};
                    dto.id = unitId;
                    dto.purchaseOrderId = purchaseOrderId;
                    return purchaseOrderResource.getVatRatesForPurchaseOrderId(dto).$promise.then(function (data) {
                        cb(data);
                    });
                },
                saveNotes: function (unitId, purchaseOrderId,notes, cb) {
                    var dto = {};
                    dto.id = unitId;
                    dto.notes = notes;
                    dto.purchaseOrderId = purchaseOrderId;
                    return purchaseOrderResource.saveNotes(dto).$promise.then(function (data) {
                        cb(data);
                    });
                },
                flipPurchaseOrder: function (unitId, purchaseOrderId, cb) {
                    var dto = {};
                    dto.id = unitId;
                    dto.purchaseOrderId = purchaseOrderId;
                    return purchaseOrderResource.flipPurchaseOrder(dto).$promise;
                },
                getUnreconciledPurchaseOrders: function () {
                    var unitId = organisationContextService.getContext().currentSubscriptionUnit.id;
                    return purchaseOrderResource.getUnreconciledPurchaseOrders(unitId);
                },
                cancelPurchaseOrder: function (purchaseOrderId, message, cb) {
                    var context = organisationContextService.getContext();
                    var dto = {
                        id: context.currentSubscriptionUnit.id,
                        procurementPurchaseOrderId: purchaseOrderId,
                        message: message
                    };
                    return purchaseOrderResource.cancelPurchaseOrder(dto).$promise.then(function (data) {
                        cb(data);
                    });

                },
                setReceivedPurchaseOrderToPartReceived: function(purchaseOrderId) {
                    return purchaseOrderResource.setReceivedPurchaseOrderToPartReceived({
                        id: purchaseOrderId
                    }).$promise;
                },
                getTransmissionMethods: function (organisationId) {
                    return $http.get(siteUrl() + 'api/purchaseorder/transmission-methods/' + organisationId);
                }
            }
        }
    ]);
"use strict";

angular.module(appName)
    .controller("singlePurchaseOrderController",
        [
            "$scope",
            "$http",
            "$routeParams",
            "$templateRequest",
            "$q",
            "$rootScope",
            "enums",
            "$timeout",
            "$location",
            "genericUiGrid",
            "clientUnitAccountCodeService",
            "clientUnitDepartmentService",
            "purchaseOrderLineFactory",
            "purchaseOrderService",
            "basketService",
            "localStorageService",
            "procurementItemService",
            "$window",
            "$translate",
            "validationHelper",
            "userService",
            function ($scope,
                $http,
                $routeParams,
                $templateRequest,
                $q,
                $rootScope,
                enums,
                $timeout,
                $location,
                genericUiGrid,
                clientUnitAccountCodeService,
                clientUnitDepartmentService,
                purchaseOrderLineFactory,
                purchaseOrderService,
                basketService,
                localStorageService,
                procurementItemService,
                $window,
                $translate,
                validationHelper,
                userService) {

                $scope.purchaseOrder = {};
                $scope.vatRates = [];
                $scope.changedDeliveryDate = false;
                $scope.changedNotes = false;
                $scope.sendingPurchaseOrderToSupplier = false;
                var self = this;

                var changedEntities = [];
                var deletedEntities = [];
                $scope.savePoPromise = [];

                var isSingleItemPoLine = function (poLine) {
                    return poLine.basketLines && poLine.basketLines.length === 1;
                };
                var canAddSimilarLine = function (entity) {
                    if (!entity.skuCode || !entity.description || !entity.pricePerUnit)
                        return false;
                    if (!entity.basketLines || !entity.basketLines.length)
                        return false;
                    return true;
                };
                var isManualPoLine = function (poLine) {

                    if (!poLine.skuId && !poLine.relatedBasket && (poLine.basketLines))
                        return true;
                    return false;
                };
                var updatePurchaseOrderLineTotals = function (tableRow) {

                    tableRow.canAddSimilarLine = canAddSimilarLine(tableRow);
                    if (tableRow.catchWeight && tableRow.catchWeight > 0) {
                        tableRow.totalNetPrice = tableRow.quantity * tableRow.pricePerUnit * tableRow.catchWeight;
                        tableRow.orderedQuantity = tableRow.quantity * tableRow.catchWeight;
                    } else {
                        tableRow.totalNetPrice = tableRow.quantity * tableRow.pricePerUnit;
                        tableRow.orderedQuantity = tableRow.quantity;
                    }
                    if (!tableRow.vatRate) {
                        tableRow.vatRate = 0;
                    }
                    tableRow.vatAmount = (tableRow.vatRate / 100) * tableRow.totalNetPrice;
                    tableRow.totalGrossPrice = tableRow.vatAmount + tableRow.totalNetPrice;
                    _.each(tableRow.basketLines,
                        function (basketLine) {
                            updatePurchaseOrderLineTotals(basketLine);
                        });
                    if (isSingleItemPoLine(tableRow)) {
                        var basketLine = tableRow.basketLines[0];
                        basketLine.quantity = tableRow.quantity;
                        basketLine.orderedQuantity = tableRow.orderedQuantity;
                        tableRow.accountCode = (tableRow.accountCode == null || tableRow.accountCode == undefined)
                            ? basketLine.accountCode
                            : tableRow.accountCode;
                        tableRow.department = (tableRow.department == null || tableRow.department == undefined)
                            ? basketLine.department
                            : tableRow.department;
                        basketLine.accountCode = tableRow.accountCode;
                        basketLine.department = tableRow.department;
                        basketLine.skuCode = tableRow.skuCode;
                        basketLine.description = tableRow.description;
                        basketLine.catchWeight = tableRow.catchWeight;
                        basketLine.pricePerUnit = tableRow.pricePerUnit;
                    }
                };


                var calculatePurchaseOrderTotal = function () {
                    var totalGross = 0;
                    var totalVat = 0;
                    var totalNet = 0;
                    _.each($scope.purchaseOrderGrid.data,
                        function (item) {
                            if (!item.isDeleted) {
                                if (item.basketLines) {
                                    var lineTotalNet = 0;
                                    _.each(item.basketLines,
                                        function (basketLine) {
                                            if (!basketLine.isDeleted) {
                                                if (basketLine.quantity &&
                                                    item.pricePerUnit &&
                                                    basketLine.catchWeight) {
                                                    lineTotalNet += basketLine.quantity *
                                                        item.pricePerUnit *
                                                        basketLine.catchWeight;
                                                } else if (basketLine.quantity && item.pricePerUnit) {
                                                    lineTotalNet += basketLine.quantity * item.pricePerUnit;
                                                }
                                            }
                                        });
                                    item.totalNetPrice = lineTotalNet;
                                    totalNet += lineTotalNet;
                                    totalGross += lineTotalNet;
                                    if (item.vatRate && item.vatRate != 0) {
                                        item.vatAmount = lineTotalNet * (item.vatRate / 100);
                                        totalVat += item.vatAmount;
                                        item.totalGrossPrice = item.totalNetPrice + item.vatAmount;
                                    }
                                    //add the VAT amount to the total price of Purchase Order
                                    if (item.vatAmount) {
                                        totalGross += item.vatAmount;
                                    }
                                    item.totalGrossPrice = lineTotalNet + item.vatAmount;
                                }
                            }
                        });
                    $scope.totalGross = totalGross;
                    if (!totalVat) {
                        totalVat = 0;
                    }
                    $scope.totalVat = totalVat;
                    if (!totalNet) {
                        totalNet = 0;
                    }
                    $scope.totalNet = totalNet;
                };

                var calculateOriginalPurchaseOrderTotal = function () {
                    $scope.totalNet = _.reduce(purchaseOrder.singlePurchaseOrderRequestLines,
                        function (m, n) {
                            return m +
                                ((n.catchWeight == null || n.catchWeight === 0)
                                    ? n.quantity * n.pricePerUnit
                                    : n.quantity * n.pricePerUnit * n.catchWeight)
                        },
                        0);

                    $scope.totalVat = _.reduce(purchaseOrder.singlePurchaseOrderRequestLines,
                        function (m, n) {
                            return m +
                                (((n.catchWeight == null || n.catchWeight === 0)
                                    ? n.quantity * n.pricePerUnit
                                    : n.quantity * n.pricePerUnit * n.catchWeight) *
                                    (n.vatRate / 100))
                        },
                        0);

                    $scope.totalGross = $scope.totalNet + $scope.totalVat;


                };

                var editing = false;

                var beginCellEdit = function (entity) {
                    editing = true;
                    entity.editing = true;
                };


                var propagateChangesThroughForManualLines = function (row) {
                    if (row.basketLines && row.basketLines.length > 1) {
                        _.each(row.basketLines,
                            function (line) {
                                if (!line.isDeleted) {
                                    line.description = row.description;
                                    line.skuCode = row.skuCode;
                                    line.pricePerUnit = row.pricePerUnit;
                                    line.catchWeight = row.catchWeight;
                                    line.purchaseOrderLineId = row.id;
                                    line.vatRate = row.vatRate;

                                    if (changedEntities.indexOf(line) === -1)
                                        changedEntities.push(line);
                                }
                            });
                    }
                };
                $scope.goBack = function () {
                    $window.history.back();
                };
                var afterCellEdit = function (tableRow) {
                    if (tableRow.catchWeight == '') tableRow.catchWeight = null;
                    propagateChangesThroughForManualLines(tableRow);
                    updatePurchaseOrderLineTotals(tableRow);
                    calculatePurchaseOrderTotal();

                    var changedItem;
                    if (tableRow.basketLines && tableRow.basketLines.length === 1) {
                        tableRow.basketLines[0].vatRate = tableRow.vatRate;
                        changedItem = tableRow.basketLines[0];
                        changedItem.purchaseOrderLineId = tableRow.id;
                    } else {
                        changedItem = tableRow;
                        if (changedItem.purchaseOrderLineId == null && tableRow.poLine) {
                            changedItem.purchaseOrderLineId = tableRow.poLine.id;
                        }
                    }

                    if (tableRow.editing) {
                        tableRow.editing = false;
                        if (changedEntities.indexOf(changedItem) === -1)
                            if (!changedItem.basketLines) {
                                changedEntities.push(changedItem);
                            }
                    }
                    $scope.getErrorMessage();
                    editing = false;
                };


                //checks if dup per subgroup AND if not populated
                var departmentAndAccountExist = function () {
                    var lineNotPopulated = false;

                    _.each($scope.purchaseOrderGrid.data,
                        function (data) {
                            var listToIterate = _.filter(data.basketLines,
                                function (item) {
                                    return (item.isDeleted === undefined ||
                                        item.isDeleted === null ||
                                        item.isDeleted === false);
                                });
                            if (listToIterate) {
                                var allHaveAccCodeAndDptmt = _.every(listToIterate,
                                    function (basketLine) {
                                        return basketLine.accountCode && basketLine.department;
                                    });
                                if (!allHaveAccCodeAndDptmt) {
                                    lineNotPopulated = true;
                                    return;
                                }
                            };
                        });
                    return lineNotPopulated;
                };

                //checks if dup per subgroup AND if not populated
                var checkDupAccCodeAndDptmtForPoLine = function () {
                    var duplicates = false;

                    _.each($scope.purchaseOrderGrid.data,
                        function (data) {
                            var listToIterate = _.filter(data.basketLines,
                                function (item) {
                                    return (item.isDeleted === undefined ||
                                        item.isDeleted === null ||
                                        item.isDeleted === false);
                                });
                            if (listToIterate) {
                                var groupedList = _.groupBy(listToIterate,
                                    function (basketLine) {
                                        if (basketLine.relatedBasket === undefined) {
                                            basketLine.relatedBasket = null;
                                        }
                                        return basketLine.accountCode.id +
                                            '#' +
                                            basketLine.department.id +
                                            '#' +
                                            basketLine.relatedBasketId;
                                    });
                                if (Object.keys(groupedList).length < listToIterate.length) {
                                    duplicates = true;
                                }
                            };
                        });
                    return duplicates;
                };

                //checks if dup per subgroup AND if not populated
                var checkDupSkuDescriptionCatchWeight = function () {
                    var duplicates = false;
                    var totalCount = 0;
                    var groupedList = _.groupBy($scope.purchaseOrderGrid.data,
                        function (line) {
                            //If its a group element
                            if (line.basketLines) {
                                totalCount++;
                                return line.skuCode + '#' + line.description + '#' + line.catchWeight;
                            }
                        });
                    groupedList = _.omit(groupedList, undefined);
                    if (Object.keys(groupedList).length < totalCount) {
                        duplicates = true;
                    };
                    return duplicates;
                };

                //checks if dup per subgroup AND if not populated
                var checkEmptySkuDescription = function () {
                    var empty = false;

                    _.each($scope.purchaseOrderGrid.data,
                        function (data) {
                            if (!data.description || !data.skuCode) {
                                empty = true;
                                return;
                            }
                        });
                    return empty;
                };

                //checks if dup per subgroup AND if not populated
                var checkNoQuantity = function () {
                    var qtyProblem = false;

                    _.each($scope.purchaseOrderGrid.data,
                        function (data) {
                            if (data.basketLines) {
                                _.each(data.basketLines,
                                    function (basketLine) {
                                        if ((basketLine.quantity === undefined || basketLine.quantity <= 0) &&
                                            basketLine.isDeleted != true) {
                                            qtyProblem = true;
                                            return;
                                        }
                                    });
                            } else if ((data.quantity === undefined || data.quantity <= 0) && data.isDeleted != true) {
                                qtyProblem = true;
                                return;
                            }
                        });
                    return qtyProblem;
                };
                var checkNegativeVatRate = function () {
                    var empty = false;

                    _.each($scope.purchaseOrderGrid.data,
                        function (data) {
                            if (data.vatRate && data.vatRate < 0) {
                                empty = true;
                                return;
                            }
                        });
                    return empty;
                };
                var checkCorrectDecimals = function () {
                    var hasFailingLines = _.find($scope.purchaseOrderGrid.data,
                        function (data) {
                            if (data.basketLines) {
                                if (!data.basketLines[0].relatedBasket) {
                                    return validationHelper.isDecimalStrict(data.basketLines[0].quantity) &&
                                        data.basketLines[0].catchWeight;
                                }
                                return (data.basketLines[0].packTypeId != enums.packTypes.catchWeight &&
                                    validationHelper.isDecimalStrict(data.basketLines[0].quantity)) ||
                                    (data.basketLines[0].packTypeId == enums.packTypes.catchWeight &&
                                        validationHelper.isDecimalStrict(data.basketLines[0].quantity) &&
                                        data.basketLines[0].catchWeight);
                            } else {
                                if (!data.relatedBasket) {
                                    return validationHelper.isDecimalStrict(data.quantity) && data.catchWeight;
                                }
                                return data.packTypeId != enums.packTypes.catchWeight &&
                                    validationHelper.isDecimalStrict(data.quantity) ||
                                    data.packTypeId == enums.packTypes.catchWeight &&
                                    validationHelper.isDecimalStrict(data.quantity) &&
                                    data.catchWeight;
                            }
                        });

                    return hasFailingLines == null;
                };

                var checkNegativeCatchWeight = function () {
                    var empty = false;

                    _.each($scope.purchaseOrderGrid.data,
                        function (data) {
                            if (data.catchWeight && data.catchWeight < 0) {
                                empty = true;
                                return;
                            }
                        });
                    return empty;
                };
                //checks if dup per subgroup AND if not populated
                var checkEmptyPricePerUnit = function () {
                    var empty = false;

                    _.each($scope.purchaseOrderGrid.data,
                        function (data) {
                            if (!data.pricePerUnit || data.pricePerUnit <= 0) {
                                empty = true;
                                return;
                            }
                        });
                    return empty;
                };

                var invalidEntities = [];
                $scope.disableTransmit = function () {
                    if (deletedEntities.length > 0 ||
                        changedEntities.length > 0 ||
                        $scope.changedDeliveryDate ||
                        $scope.changedNotes) {
                        return true;
                    }
                    if ($scope.editing) {
                        return true;
                    }
                    if (invalidEntities.length) {
                        return true;
                    }
                    if (departmentAndAccountExist() ||
                        checkDupAccCodeAndDptmtForPoLine() ||
                        checkEmptySkuDescription() ||
                        checkDupSkuDescriptionCatchWeight() ||
                        checkNoQuantity() ||
                        checkEmptyPricePerUnit() ||
                        checkNegativeCatchWeight() ||
                        checkNegativeVatRate() ||
                        !checkCorrectDecimals()) {
                        return true;
                    }
                    if ($scope.purchaseOrderIsReadonly()) {
                        return true;
                    }
                    if ($scope.savingPurchaseOrder) {
                        return true;

                    }
                    return $scope.sendingPurchaseOrderToSupplier;
                };


                $scope.disableSave = function () {
                    if (!deletedEntities.length &&
                        !changedEntities.length &&
                        !$scope.changedDeliveryDate &&
                        !$scope.changedNotes) {
                        return true;
                    }
                    if (editing) {
                        return true;
                    }
                    if (invalidEntities.length) {
                        return true;
                    }
                    if (departmentAndAccountExist() ||
                        checkDupAccCodeAndDptmtForPoLine() ||
                        checkEmptySkuDescription() ||
                        checkDupSkuDescriptionCatchWeight() ||
                        checkNoQuantity() ||
                        checkEmptyPricePerUnit() ||
                        checkNegativeCatchWeight() ||
                        checkNegativeVatRate() ||
                        !checkCorrectDecimals()) {
                        return true;
                    }
                    if ($scope.purchaseOrderIsReadonly()) {
                        return true;
                    }
                    if ($scope.savingPurchaseOrder) {
                        return true;

                    }
                    return $scope.sendingPurchaseOrderToSupplier;
                };

                $scope.getVatRateFromVatCode = function (vatCodeId) {
                    return _.find($scope.vatRates,
                        function (vatRate) {
                            return vatRate.vatCodeId == vatCodeId;
                        }).amount;
                }

                $scope.getErrorMessage = function () {
                    $scope.departmentAndAccountNotExist = false;
                    $scope.dupDepartmentAndAccountNumber = false;
                    $scope.emptySkuDescription = false;
                    $scope.dupSkuDescriptionCatchWeight = false;
                    $scope.quantityProblem = false;
                    $scope.pricePerUnitError = false;
                    $scope.catchWeightError = false;
                    $scope.negativeVatRate = false;
                    $scope.decimalError = false;

                    if (departmentAndAccountExist()) {
                        $scope.departmentAndAccountNotExist = true;
                    } else if (checkDupAccCodeAndDptmtForPoLine()) {
                        $scope.dupDepartmentAndAccountNumber = true;
                    }
                    if (checkEmptySkuDescription()) {
                        $scope.emptySkuDescription = true;
                    } else if (checkDupSkuDescriptionCatchWeight()) {
                        $scope.dupSkuDescriptionCatchWeight = true;
                    }
                    if (checkNoQuantity()) {
                        $scope.quantityProblem = true;
                    }
                    if (checkEmptyPricePerUnit()) {
                        $scope.pricePerUnitError = true;
                    }
                    if (checkNegativeCatchWeight()) {
                        $scope.catchWeightError = true;
                    }
                    if (checkNegativeVatRate()) {
                        $scope.negativeVatRate = true;
                    }
                    if (!checkCorrectDecimals()) {
                        $scope.decimalError = true;
                    }


                };
                $scope.addLine = function () {
                    // Don't allow add if po is readonly
                    if ($scope.purchaseOrderIsReadonly()) return;
                    var newId = uuid.v4();
                    //After M.E. refactor the uuidv4 is not persisted to the database. Instead, it is used to signify which items have what parents.
                    var newLine = {
                        id: newId,
                        purchaseOrderLineType: enums.purchaseOrderLineTypes.manualLine,
                        basketLines: [
                            {
                                id: uuid.v4(),
                                purchaseOrderLineId: newId,
                                packTypeId: enums.packTypes.catchWeight
                            }
                        ],
                        isNew: true
                    };
                    $scope.purchaseOrderGrid.data.unshift(newLine);
                    $scope.purchaseOrderGrid.focusOnCell(0, 0);
                };

                var createManualLineRequests = function (changedManualLines) {
                    //Group up the items based on a (local) id given by Frontend.
                    var linesGroup = _.groupBy(changedManualLines,
                        function (item) {
                            return item.purchaseOrderLineId;
                        });

                    //Structure the data in the specific shape, keep ids to group things, the backend will save from database
                    var lines = [];

                    _.forEach(linesGroup,
                        function (lineIterate) {
                            var line = null;
                            _.forEach(lineIterate,
                                function (item) {
                                    if (line == null) {
                                        line = {};
                                        line.id = item.poLine == null ? item.purchaseOrderLineId : item.poLine.id;
                                        line.description = item.description;
                                        line.pricePerUnit = item.pricePerUnit;
                                        line.purchaseOrderId = $routeParams.purchaseOrderId,
                                            line.skuCode = item.skuCode;
                                        line.skuId = item.skuId;
                                        line.vatRate = item.vatRate;
                                        line.packSize = item.packSize;
                                        line.catchWeight = item.catchWeight,
                                            line.items = [];
                                    };
                                    var itemDto = {
                                        id: item.id,
                                        quantity: item.quantity,
                                        orderedQuantity: item.orderedQuantity,
                                        accountCodeId: item && item.accountCode ? item.accountCode.id : null,
                                        departmentId: item && item.department ? item.department.id : null,
                                        isNew: item.isNew,
                                        isDeleted: item.isDeleted
                                    };
                                    line.items.push(itemDto);
                                });
                            lines.push(line);
                        });
                    return lines;
                };


                var createManualLineRequestsForDelete = function (changedManualLines) {
                    var requestDtos = _.map(changedManualLines,
                        function (entity) {
                            var requestDto = {
                                id: entity.id,
                                quantity: entity.quantity,
                                orderedQuantity: entity.orderedQuantity,
                                catchWeight: entity.catchWeight,
                                accountCodeId: entity && entity.accountCode ? entity.accountCode.id : null,
                                departmentId: entity && entity.department ? entity.department.id : null,
                                purchaseOrderId: $routeParams.purchaseOrderId,
                                purchaseOrderLineId: entity.purchaseOrderLineId
                                    ? entity.purchaseOrderLineId
                                    : (entity.poLine ? entity.poLine.id : null),
                                description: entity.description,
                                packSize: entity.packSize,
                                pricePerUnit: entity.pricePerUnit,
                                skuCode: entity.skuCode,
                                skuId: entity.skuId,
                                isNew: entity.isNew,
                                isDeleted: entity.isDeleted,
                                vatAmount: entity.vatAmount,
                                vatRate: entity.vatRate
                            };
                            return requestDto;
                        });
                    return requestDtos;
                };


                var evaluateMinimumOrderValue = function () {
                    if ($scope.totalGross < $scope.purchaseOrder.minimumOrderValue) {
                        $scope.minimumOrderValueNotMet = true;
                    } else {
                        $scope.minimumOrderValueNotMet = false;
                    }
                }
                $scope.savePurchaseOrder = function (callback) {
                    changedEntities = changedEntities.filter(function (el) {
                        return deletedEntities.indexOf(el) < 0;
                    });

                    var requests = createManualLineRequests(changedEntities);
                    $scope.savingPurchaseOrder = true;

                    var dto = {};
                    dto.requests = requests;
                    dto.id = $scope.context.currentSubscriptionUnit.id;
                    dto.clientId = $scope.context.currentSubscriptionUnit.client.id;
                    dto.purchaseOrderId = $scope.purchaseOrder.id;

                    //UPDATE ITEMS
                    procurementItemService.upsertProcurementItems(dto).then(function (lines) {

                        //The below piece of code in the if statement, takes the result from the backend and replaces all ids on the frontend to match
                        if (lines.data.length > 0) {
                            _.forEach(lines.data,
                                function (line) {
                                    //Find the line in grid where the ids match
                                    var lineFound = _.findWhere($scope.purchaseOrderGrid.data,
                                        function (gridLine) {
                                            return gridLine.id === line.idFromFrontend;
                                        });
                                    //replace its id (that was added in frontend) with id added from backend.
                                    lineFound.id = line.id;

                                    _.forEach(line.items,
                                        function (item) {
                                            var itemFound = _.filter(_.pluck(_.filter($scope.purchaseOrderGrid.data,
                                                function (data) {
                                                    return data.basketLines != null;
                                                }),
                                                'basketLines')[0],
                                                function (gridLineItem) {
                                                    return gridLineItem.id == item.idFromFrontend;
                                                });
                                            if (itemFound.length == 1) {
                                                itemFound[0].id = item.id;
                                                itemFound[0].purchaseOrderLineId = lineFound.id;
                                            }
                                        });
                                });
                        }

                        changedEntities = [];

                        requests = createManualLineRequestsForDelete(deletedEntities);
                        dto.requests = requests;


                        //DELETE ITEMS
                        procurementItemService.deleteItems(dto).then(function () {
                            deletedEntities = [];


                            if ($scope.changedNotes) {
                                //CHANGE NOTES
                                purchaseOrderService.saveNotes($scope.context.currentSubscriptionUnit.id,
                                    $scope.purchaseOrderId,
                                    $scope.purchaseOrder.supplierNotes,
                                    function (data) {
                                        $scope.changedNotes = false;


                                        if ($scope.changedDeliveryDate) {
                                            //CHANGE DELIVERY DATE
                                            purchaseOrderService.savePoDeliveryDate(
                                                $scope.context.currentSubscriptionUnit.id,
                                                $scope.purchaseOrderId,
                                                $scope.purchaseOrder.requestedDeliveryDate,
                                                function (data) {

                                                    if (data.nextAvailableDelivery !==
                                                        $scope.purchaseOrder.requestedDeliveryDate &&
                                                        !$scope.purchaseOrderIsReadonly()) {
                                                        $scope.invalidDeliveryDate = true;
                                                        $scope.nextAvailableDeliveryDate = data.nextAvailableDelivery;
                                                    } else {
                                                        $scope.invalidDeliveryDate = false;
                                                    }
                                                    $scope.changedDeliveryDate = false;
                                                    $scope.invalidDeliveryDate = $scope.invalidDeliveryDate;


                                                    calculatePurchaseOrderTotal();
                                                    evaluateMinimumOrderValue();

                                                    if (callback !== undefined && !$scope.invalidDeliveryDate) {
                                                        //CALL TRANSMIT PO AFTER ALL ARE DONE
                                                        callback();
                                                    } else {
                                                        $scope.sendingPurchaseOrderToSupplier = false;
                                                    }
                                                });
                                        } else {
                                            calculatePurchaseOrderTotal();
                                            evaluateMinimumOrderValue();

                                            if (callback !== undefined && !$scope.invalidDeliveryDate) {
                                                //CALL TRANSMIT PO AFTER ALL ARE DONE
                                                callback();
                                            }
                                        }

                                    });
                            } else {
                                if ($scope.changedDeliveryDate) {
                                    //CHANGE DELIVERY DATE
                                    purchaseOrderService.savePoDeliveryDate($scope.context.currentSubscriptionUnit.id,
                                        $scope.purchaseOrderId,
                                        $scope.purchaseOrder.requestedDeliveryDate,
                                        function (data) {

                                            if (data.nextAvailableDelivery !==
                                                $scope.purchaseOrder.requestedDeliveryDate &&
                                                !$scope.purchaseOrderIsReadonly()) {
                                                $scope.invalidDeliveryDate = true;
                                                $scope.nextAvailableDeliveryDate = data.nextAvailableDelivery;

                                            } else {
                                                $scope.invalidDeliveryDate = false;
                                            }
                                            $scope.changedDeliveryDate = false;
                                            $scope.invalidDeliveryDate = $scope.invalidDeliveryDate;

                                            calculatePurchaseOrderTotal();
                                            evaluateMinimumOrderValue();


                                            if (callback !== undefined && !$scope.invalidDeliveryDate) {
                                                //CALL TRANSMIT PO AFTER ALL ARE DONE
                                                callback();
                                            } else {
                                                $scope.sendingPurchaseOrderToSupplier = false;
                                            }
                                        });
                                } else {
                                    calculatePurchaseOrderTotal();
                                    evaluateMinimumOrderValue();

                                    if (callback !== undefined && !$scope.invalidDeliveryDate) {
                                        //CALL TRANSMIT PO AFTER ALL ARE DONE
                                        callback();
                                    } else {
                                        $scope.sendingPurchaseOrderToSupplier = false;
                                    }
                                }
                            }

                        });
                    }).finally(function () {
                        $scope.savingPurchaseOrder = false;
                    });
                };

                $scope.setDeliveryDateTrue = function () {
                    $scope.changedDeliveryDate = true;
                }
                $scope.setChangedNotesTrue = function () {
                    $scope.changedNotes = true;
                }
                var purchaseOrderAlreadyContainsSku = function (skuId) {
                    var existingItem = _.find($scope.purchaseOrderGrid.data,
                        function (line) { return line.skuId === skuId });
                    return existingItem;
                };
                $scope.addFromSupplierCatalogue = function (productFromCatalogue) {
                    // Don't allow add if po is readonly
                    if ($scope.purchaseOrderIsReadonly()) return;

                    $rootScope.$broadcast(enums.eventNames.purchaseOrderCatalogueSearchRequestToggled);
                    $scope.showingAddFromCatalogue = !$scope.showingAddFromCatalogue;

                    if (productFromCatalogue) {
                        var selectedProduct = productFromCatalogue.entity;
                        if (purchaseOrderAlreadyContainsSku(selectedProduct.skuId)) {
                            toastr.error($translate.instant("item_already_included_in_po"));
                            return;
                        }

                        //The ids are kept but NOT persisted to the database, they are only used as means to an end in order to be able to tell which altered entites have what parents.
                        //As the structure that was created was flat.
                        var purchaseOrderLineId = uuid.v4();
                        var newLine = {
                            id: purchaseOrderLineId,
                            basketLines: [
                                {
                                    id: uuid.v4(),
                                    purchaseOrderLineId: purchaseOrderLineId,
                                    skuCode: selectedProduct.skuCode,
                                    skuId: selectedProduct.skuId,
                                    pricePerUnit: selectedProduct.price,
                                    packTypeId: selectedProduct.packTypeId
                                }
                            ],
                            skuCode: selectedProduct.skuCode,
                            skuId: selectedProduct.skuId,
                            description: selectedProduct.description,
                            pricePerUnit: selectedProduct.price,
                            isNew: true,
                            vatRate: $scope.getVatRateFromVatCode(selectedProduct.vatCodeId)
                        };
                        $scope.purchaseOrderGrid.data.unshift(newLine);
                        $scope.purchaseOrderGrid.focusOnCell(0, 4);
                    } else {
                        // We aren't passing a product, we want to open up the directive view and scroll to top
                        window.scrollTo(0, 0);
                    }
                };


                $scope.sendPurchaseOrderToSupplier = function () {
                    $scope.sendingPurchaseOrderToSupplier = true;
                    $scope.savePurchaseOrder(function () {
                        $scope.transmitPurchaseOrderToSupplier();
                    });
                };

                $scope.transmitPurchaseOrderToSupplier = function () {
                    $scope.sendingPurchaseOrderToSupplier = true;
                    purchaseOrderService.submitPurchaseOrder($scope.purchaseOrderId,
                        $scope.context.currentSubscriptionUnit.id,
                        $scope.purchaseOrder.transmissionMethodId,
                        function (data) {
                            $scope.purchaseOrder.status.id = 4;
                            $scope.purchaseOrder.status.description = 'Submitted';
                            $scope.sendingPurchaseOrderToSupplier = false;
                            $translate('success_po_transmitted', { supplierName: $scope.purchaseOrder.supplierName })
                                .then(function (translation) {
                                    toastr.success(translation);
                                });
                            $window.location.reload();
                        });
                }

                $scope.toggleShowCancelDialog = function () {
                    $scope.showCancelDialog = !$scope.showCancelDialog;
                }

                $scope.cancelPurchaseOrder = function () {
                    return purchaseOrderService.cancelPurchaseOrder($scope.purchaseOrderId,
                        $scope.purchaseOrder.cancelPurchaseOrderMessage,
                        function (d) {
                            toastr.success(d.message);
                            $scope.cancelledMessage = d.message;
                            $scope.toggleShowCancelDialog();
                            $scope.purchaseOrder.status.id = 900;
                            $scope.purchaseOrder.status.description = $translate.instant('cancelled');
                            //If you reload the window you won't get the cancellation message that's generated server side... ~ JP
                            //$window.location.reload();
                        });

                }

                $scope.selectAccount = function () {
                    if ($scope.purchaseOrder.selectedAccount && $scope.purchaseOrder.selectedAccount.accountNumber) {
                        purchaseOrderService.selectAccountForPO($scope.context.currentSubscriptionUnit.id,
                            $scope.purchaseOrder.selectedAccount.accountNumber,
                            $scope.purchaseOrderId,
                            $scope.purchaseOrder.selectedAccount.supplierId,
                            function (result) {
                                init();
                            });
                    } else {
                        toastr.error($translate.instant("please_select_an_account"));
                    }
                };
                $scope.deleteRow = function (row) {
                    // Don't allow if PO is readonly
                    if ($scope.purchaseOrderIsReadonly()) return;

                    var index = $scope.purchaseOrderGrid.data.indexOf(row.entity);
                    if (index !== -1) {
                        row.entity.isDeleted = true;
                        $scope.purchaseOrderGrid.data.splice(index, 1);

                        if (row.entity.basketLines && row.entity.basketLines.length > 0) {
                            //If any item is showing in grid then that means caret is down and hence we need to delete all of them since the parent was deleted.
                            var count = 0;
                            _.each(row.entity.basketLines,
                                function (basketLine) {
                                    var found = _.find($scope.purchaseOrderGrid.data,
                                        function (item) {
                                            return item == basketLine;
                                        });
                                    if (found) {
                                        count++;
                                    }
                                });
                            $scope.purchaseOrderGrid.data.splice(index, count);

                            _.each(row.entity.basketLines,
                                function (basketLine) {
                                    deletedEntities.push(basketLine);
                                    basketLine.isDeleted = true;
                                });
                        } else {
                            deletedEntities.push(row.entity);
                            row.entity.isDeleted = true;
                        }
                    }

                    $scope.checkNoChildrenAndDelete();
                    calculatePurchaseOrderTotal();
                    $scope.disableSave();
                    $scope.getErrorMessage();
                };

                $scope.checkNoChildrenAndDelete = function () {
                    _.each($scope.purchaseOrderGrid.data,
                        function (item) {
                            var allDeleted = false;
                            if (item && item.basketLines) {
                                allDeleted = _.every(item.basketLines,
                                    function (basketLine) {
                                        return basketLine.isDeleted === true;
                                    });
                            }
                            if (allDeleted) {
                                var index = $scope.purchaseOrderGrid.data.indexOf(item);
                                $scope.purchaseOrderGrid.data.splice(index, 1);
                            }
                        });
                };
                var replaceUnitCostPrice = function () {
                    _.each(purchaseOrder.singlePurchaseOrderRequestLines,
                        function (line) {
                            if (line.basketLines) {
                                _.each(line.basketLines,
                                    function (basketLine) {
                                        basketLine.pricePerUnit = line.pricePerUnit;
                                    });
                            }
                        });
                }
                var linesWithSummaries = function () {
                    replaceUnitCostPrice();
                    var lines = _.sortBy(purchaseOrder.singlePurchaseOrderRequestLines, "skuCode");
                    _.each(lines, updatePurchaseOrderLineTotals);
                    calculateOriginalPurchaseOrderTotal();
                    return lines;
                };


                var validateRow = function (row, colDefs) {
                    if (!row.entity.isDeleted) {
                        var entity = row.entity;
                        var missingFields = [];
                        _.each(colDefs,
                            function (colDef) {
                                if (colDef.required && !entity[colDef.field]) {
                                    missingFields.push(colDef.field);
                                }
                            });
                        row.invalidFields = missingFields;
                        if (row.invalidFields.length) {
                            if (invalidEntities.indexOf(entity) === -1) {
                                invalidEntities.push(entity);
                            }
                        } else {
                            var index = invalidEntities.indexOf(entity);
                            invalidEntities.splice(index, 1);
                        }
                    }
                };
                $scope.purchaseOrderIsReadonly = function () {
                    return $scope.purchaseOrder.status == null ||
                        //at the point of submission, we are initializing the RPO. we cannot allow deleting lines after submission because it would create discrepancy between rpo and po.
                        ($scope.purchaseOrder.status.id != enums.purchaseOrderStatus.open && $scope.purchaseOrder.status.id != enums.purchaseOrderStatus.submitted);
                }

                $scope.findDuplicateSkus = function (row) {
                    var alreadyExists = false;
                    var entity = row.entity;
                    _.each($scope.purchaseOrder.singlePurchaseOrderRequestLines,
                        function (line) {
                            if (line.skuCode === entity.skuCode &&
                                line.id !== row.entity.id &&
                                row.invalidFields.indexOf("skuCode") === -1) {
                                row.invalidFields.push("skuCode");
                                alreadyExists = true;
                            }
                        });
                    return alreadyExists;
                };
                $scope.testBulkUpdate = function () {
                    _.each($scope.purchaseOrderGrid.data,
                        function (poLine) {
                            _.each(poLine.basketLines,
                                function (basketLine) {
                                    basketLine.quantity++;
                                    changedEntities.push(basketLine);
                                });
                            updatePurchaseOrderLineTotals(poLine);
                        });
                };

                $scope.showBasketLinesForItem = function (row) {
                    var data = $scope.purchaseOrderGrid.data;
                    if (row.showingBasketLines) {
                        var children = row.entity.basketLines;
                        _.each(children,
                            function (child) {
                                if (!child.isDeleted) {
                                    var index = data.indexOf(child);
                                    data.splice(index, 1);
                                }
                            });
                        delete row.showingBasketLines;
                        row.entity.canAddSimilarLine = canAddSimilarLine(row.entity);
                    } else {
                        var index = data.indexOf(row.entity) + 1;
                        row.entity.basketLines = _.sortBy(row.entity.basketLines, 'quantity').reverse();
                        _.each(row.entity.basketLines,
                            function (basketLine) {
                                if (!basketLine.isDeleted) {

                                    basketLine.vatRate = row.entity.vatRate;
                                    basketLine.isBasketLine = true;
                                    basketLine.poLine = row.entity;
                                    data.splice(index, 0, basketLine);
                                    index = index++;


                                }
                            });

                        row.showingBasketLines = true;
                    }
                };
                $scope.download = function () {
                    $scope.downloading = true;
                    purchaseOrderService.downloadPurchaseOrder($scope.purchaseOrder).then(function (po) {
                        $scope.downloading = false;
                    },
                        function (err) {
                            $scope.downloading = false;
                        });
                };

                $scope.getSumOfQuantities = function (entity) {
                    var total = 0;
                    entity.basketLines.forEach(function (line) {
                        if (line.quantity && !line.isDeleted) {
                            total += line.quantity;
                        }
                    });
                    return total;
                };
                $scope.getSumOfOrderedQuantities = function (entity) {
                    var total = 0;
                    entity.basketLines.forEach(function (line) {
                        if (line.orderedQuantity && !line.isDeleted) {
                            total += line.orderedQuantity;
                        }
                    });
                    return total;
                };
                $scope.addSimilarLine = function (row) {
                    // Don't allow if PO is readonly
                    if ($scope.purchaseOrderIsReadonly()) return;

                    var data = $scope.purchaseOrderGrid.data;
                    var entity = row.entity;
                    delete entity.relatedBasket;
                    if (!row.showingBasketLines) {
                        $scope.showBasketLinesForItem(row);
                    }
                    var deletedItems = _.filter(entity.basketLines,
                        function (item) {
                            return item.isDeleted === true;
                        });
                    var index = data.indexOf(entity) + entity.basketLines.length + 1 - deletedItems.length;
                    var newEntity = {
                        id: uuid.v4(),
                        skuId: entity.skuId,
                        skuCode: entity.skuCode,
                        description: entity.description,
                        catchWeight: entity.catchWeight,
                        pricePerUnit: entity.pricePerUnit,
                        isNew: true,
                        isBasketLine: true,
                        purchaseOrderLineId: entity.id,
                        vatRate: entity.vatRate,
                        packTypeId: entity.basketLines[0].packTypeId,
                        //This fixes the problem that when you add a similar line, there doesnt exist a basket. the backend send the id like so.
                        relatedBasketId: '00000000-0000-0000-0000-000000000000'

                    };
                    entity.basketLines.push(newEntity);
                    row.entity.canAddSimilarLine = canAddSimilarLine(row.entity);
                    data.splice(index, 0, newEntity);
                    $scope.purchaseOrderGrid.focusOnCell(index, 4);
                    //This deletes the accCode and dptmt on parentd
                    row.entity.accountCode = '';
                    row.entity.department = '';
                };
                self.setupGridApi = function (gridOptions) {
                    $scope.gridOptions.onRegisterApi = function (gridApi) {
                        $scope.gridApi = gridApi;
                        gridApi.selection.on.rowSelectionChanged($scope,
                            function (row) {
                                $scope.activeItem = row.entity;
                            });
                    };
                };

                var init = function () {
                    $scope.enums = enums;
                    userService.hasPermission('BEAGLE_PURCHASEORDERS_SUBMIT').then(function () {
                        $scope.canTransmitPurchaseOrder = true;
                    });
                    $scope.singlePurchaseOrderScope = {
                        addFromSupplierCatalogue: $scope.addFromSupplierCatalogue
                    }
                    $scope.showTopPanel = true;
                    $scope.purchaseOrderId = $routeParams.purchaseOrderId;

                    $scope.context = localStorageService.getItem(enums.localStorage.organisationContext);


                    if ($scope.accounts === undefined) {
                        var subscriptionUnitId = $scope.context.currentSubscriptionUnit.id;
                        $scope.accountsForUnitPromise = purchaseOrderService.getAccountsForUnit(subscriptionUnitId,
                            function (result) {
                                $scope.accounts = result;
                            });
                    }

                    if ($scope.purchaseOrderId) {

                        var tableDataPromise = $http.get("/api/purchaseOrder/" + $routeParams.purchaseOrderId,
                            {
                                params: {
                                    projection: enums.purchaseOrderProjections.singlePurchaseOrder,
                                    dummy: false,
                                    clientUnitId: localStorageService.getItem(enums.localStorage.organisationContext)
                                        .currentSubscriptionUnit.id
                                }
                            });
                        var relatedBasketCellTemplatePromise =
                            $templateRequest(
                                "/ngxbeagle/dist/Content/js/Modules/PurchaseOrders/SinglePurchaseOrder/relatedBasketCellTemplate.html");
                        var quantityTemplate =
                            $templateRequest(
                                "/ngxbeagle/dist/Content/js/Modules/PurchaseOrders/SinglePurchaseOrder/quantityTemplate.html");
                        var quantityOrderedTemplate =
                            $templateRequest(
                                "/ngxbeagle/dist/Content/js/Modules/PurchaseOrders/SinglePurchaseOrder/quantityOrderedTemplate.html");
                        var rightAlignTemplate =
                            $templateRequest(
                                "/ngxbeagle/dist/Content/js/Modules/PurchaseOrders/SinglePurchaseOrder/rightAlignTemplate.html");
                        var rightAlignTemplateWithCurrencySymbol =
                            $templateRequest(
                                "/ngxbeagle/dist/Content/js/Modules/PurchaseOrders/SinglePurchaseOrder/rightAlignTemplateWithCurrencySymbol.html");

                        var clientUnitAccountCodeServicePromise =
                            clientUnitAccountCodeService.getClientUnitProcurementAccountCodesForUser(null,
                                null,
                                "eProcurement.AccountCodeKeyValueResponseDto");
                        var clientUnitDepartmentServicePromise =
                            clientUnitDepartmentService.getClientUnitProcurementDepartmentsForUser(null,
                                null,
                                "eProcurement.DeptKeyValueResponseDto");
                        var transmissionMethodsPromise =
                            purchaseOrderService.getTransmissionMethods($scope.context.organisation.id);


                        $q.all([
                            tableDataPromise,
                            relatedBasketCellTemplatePromise,
                            clientUnitAccountCodeServicePromise,
                            clientUnitDepartmentServicePromise,
                            $scope.accountsForUnitPromise,
                            quantityTemplate,
                            transmissionMethodsPromise
                        ]).then(function (resultsArray) {
                            var relatedBasketCellTemplate = resultsArray[1];
                            var accountCodes = resultsArray[2];
                            var departments = resultsArray[3];
                            var quantityTemplate = resultsArray[5];
                            var transmissionMethodsResult = resultsArray[6];
                            tableDataPromise.then(function (results) {
                                purchaseOrder = results.data;
                                var lines = linesWithSummaries();
                                console.log('lines', lines);
                                // An asterisk in the column name denotes that the field is required. This is the equivalent to: {field:'fieldName', required:true}
                                $scope.gridOptions = {
                                    enableColumnResizing: true,
                                    data: lines,
                                    columns: [
                                        {
                                            displayName: $translate.instant("sku_code"),
                                            field: "skuCode*",
                                            minWidth: 100
                                        },
                                        {
                                            displayName: $translate.instant("description"),
                                            field: "description*",
                                            minWidth: 300
                                        },
                                        {
                                            displayName: $translate.instant("catch_weight"),
                                            field: "catchWeight",
                                            placeholder: "-",
                                            template: rightAlignTemplate,
                                            cellFilter: 'number: 3',
                                            editable: function ($scope) {
                                                if ($scope.grid.appScope.purchaseOrderIsReadonly())
                                                    return false;

                                                // MB: !entity.relatedBasket makes sure any product from manual entry or supplier catalogue enables catch weight at all times
                                                var entity = $scope.row.entity;
                                                if (entity.basketLines && entity.basketLines.length === 1)
                                                    if (entity.basketLines[0].packTypeId ==
                                                        enums.packTypes.catchWeight ||
                                                        !entity.relatedBasket) {
                                                        return true;
                                                    }
                                                if (!entity.basketLines)
                                                    if (entity.packTypeId == enums.packTypes.catchWeight ||
                                                        !entity.relatedBasket) {
                                                        return true;
                                                    }
                                                return false;
                                            },
                                            minWidth: 100
                                        },
                                        {
                                            displayName: $translate.instant("price_per_unit"),
                                            field: "pricePerUnit*",
                                            cellFilter: "number:2",
                                            template: rightAlignTemplateWithCurrencySymbol,
                                            minWidth: 100
                                        },
                                        {
                                            displayName: $translate.instant("quantity"),
                                            field: "quantity",
                                            required: true,
                                            editable: function ($scope) {
                                                if ($scope.grid.appScope.purchaseOrderIsReadonly())
                                                    return false;

                                                var entity = $scope.row.entity;
                                                if (entity.basketLines && entity.basketLines.length === 1)
                                                    return true;
                                                if (!entity.basketLines)
                                                    return true;
                                                return false;
                                            },
                                            template: quantityTemplate,
                                            cellFilter: 'number: 3',
                                            minWidth: 100
                                        },
                                        {
                                            displayName: $translate.instant("ordered_quantity"),
                                            field: "orderedQuantity",
                                            editable: false,
                                            template: quantityOrderedTemplate,
                                            cellFilter: 'number: 3',
                                            minWidth: 100
                                        },
                                        {
                                            displayName: $translate.instant("account_code"),
                                            field: "accountCode",
                                            editDropdownOptionsArray: accountCodes,
                                            editable: function ($scope) {
                                                if ($scope.grid.appScope.purchaseOrderIsReadonly())
                                                    return false;

                                                var entity = $scope.row.entity;
                                                if (entity.basketLines && entity.basketLines.length === 1)
                                                    return true;
                                                if (!entity.basketLines)
                                                    return true;
                                                return false;
                                            },
                                            cellFilter: "cdbDescription",
                                            minWidth: 100
                                        },
                                        {
                                            displayName: $translate.instant("department"),
                                            field: "department",
                                            editDropdownOptionsArray: departments,
                                            editable: function ($scope) {
                                                if ($scope.grid.appScope.purchaseOrderIsReadonly())
                                                    return false;

                                                var entity = $scope.row.entity;
                                                if (entity.basketLines && entity.basketLines.length === 1)
                                                    return true;
                                                if (!entity.basketLines)
                                                    return true;
                                                return false;
                                            },
                                            displayValue: "description",
                                            minWidth: 100
                                        },
                                        {
                                            displayName: $translate.instant("vat_rate"),
                                            field: "vatRate",
                                            template: rightAlignTemplate,
                                            cellFilter: 'percentage:100',
                                            minWidth: 100
                                        },
                                        {
                                            displayName: $translate.instant("total_net_price"),
                                            field: "totalNetPrice",
                                            cellFilter: "number:2",
                                            editable: function () {
                                                return false;
                                            },
                                            template: rightAlignTemplateWithCurrencySymbol,
                                            minWidth: 100
                                        },
                                        {
                                            field: "totalGrossPrice",
                                            displayName: $translate.instant("gross_price"),
                                            cellFilter: "number:2",
                                            editable: function () {
                                                return false;
                                            },
                                            template: rightAlignTemplateWithCurrencySymbol,
                                            minWidth: 100
                                        },
                                        {
                                            displayName: $translate.instant("related_basket"),
                                            field: "relatedBasket",
                                            editable: false,
                                            minWidth: 170
                                        },
                                        {
                                            displayName: $translate.instant("actions"),
                                            field: "actions",
                                            template: relatedBasketCellTemplate,
                                            editable: false,
                                            minWidth: 136
                                        }
                                    ],
                                    beginCellEdit: beginCellEdit,
                                    afterCellEdit: afterCellEdit,
                                    globalEditableCondition: function ($scope) {
                                        if ($scope.grid.appScope.purchaseOrderIsReadonly())
                                            return false;

                                        var entity = $scope.row.entity;
                                        return isManualPoLine(entity);
                                    },
                                    validate: validateRow,
                                    rowClass: function (row) {
                                        if (row.entity.isBasketLine) {
                                            return "is-basket-line";
                                        }
                                        return "";
                                    }
                                };

                                genericUiGrid.create($scope.gridOptions, $scope).then(function (grid) {
                                    $scope.purchaseOrderGrid = grid;
                                });
                                $scope.purchaseOrder = results.data;

                                //this will remove the timepart
                                $scope.purchaseOrder.requestedDeliveryDate =
                                    moment($scope.purchaseOrder.requestedDeliveryDate.split('T')[0], 'YYYY-MM-DD')
                                        .format('DD-MM-YYYY');
                                $scope.purchaseOrder.selectedAccount = _.find($scope.accounts,
                                    function (account) {
                                        return account.id === $scope.purchaseOrder.accountDto.id;
                                    });
                                if ($scope.purchaseOrder.requestedDeliveryDate) {
                                    if (!$scope.purchaseOrderIsReadonly()) {
                                        purchaseOrderService.getNextAvailableDeliveryDateForPO($scope.context
                                            .currentSubscriptionUnit.id,
                                            $scope.purchaseOrder.accountDto.accountNumber,
                                            $scope.purchaseOrder.id,
                                            function (data) {
                                                if (data.deliveryDate !== $scope.purchaseOrder.requestedDeliveryDate) {
                                                    $scope.nextAvailableDeliveryDate = data.deliveryDate;
                                                    $scope.invalidDeliveryDate = true;

                                                    $scope.invalidDeliveryDate = $scope.invalidDeliveryDate;
                                                }
                                            });
                                    } else {
                                        $scope.invalidDeliveryDate = false;
                                    }
                                } else {
                                    $scope.invalidDeliveryDate = true;
                                }
                                evaluateMinimumOrderValue();

                                $scope.invalidDeliveryDate = $scope.invalidDeliveryDate;

                                if ($scope.purchaseOrder.accountDto) {
                                    purchaseOrderService.getVatRatesForPurchaseOrderId(
                                        $scope.context.currentSubscriptionUnit.id,
                                        $scope.purchaseOrder.id,
                                        function (data) {
                                            $scope.vatRates = data;
                                        });
                                }


                                var transmissionMethods = transmissionMethodsResult.data;
                                if (!transmissionMethods.length) {
                                    transmissionMethods = [
                                        { id: 1, name: $translate.instant('email'), isDefault: true },
                                        { id: 2, name: $translate.instant('phone') }
                                    ];
                                }
                                $scope.transmissionMethods = transmissionMethods;
                                var defaultMethod = _.find(transmissionMethods, function (x) { return x.isDefault });
                                if (!$scope.purchaseOrderIsReadonly()) {
                                    $scope.purchaseOrder.transmissionMethodId = defaultMethod.id;
                                }

                                $scope.$watch("purchaseOrder.requestedDeliveryDate",
                                    function (newValue, oldValue) {
                                        if (newValue == null) {
                                            $scope.changedDeliveryDate = true;
                                        }
                                        if (oldValue != null) {
                                            //The format of initial datetime is 01-02-99 , this gets converted to 01/02/19 as the time part removed. we want to enable transmit for that.
                                            if (newValue != oldValue && oldValue.indexOf("-") == -1) {
                                                $scope.changedDeliveryDate = true;
                                            }
                                        }
                                    });


                                $scope.initComplete = true;
                            });
                        });
                    } else {
                        purchaseOrderService.createManualPurchaseOrders(subscriptionUnitId,
                            function (result) {
                                if (result.status == 500) {
                                    $window.history.back();
                                } else {
                                    $location.path('/purchaseOrder/' + result.id);
                                }
                            });
                    }
                };

                init();
            }
        ]);

angular.module(appName)
    .controller('receivePurchaseOrderController',
    [
        '$scope',
        '$q',
        '$location',
        '$window',
        '$route',
        '$templateRequest',
        '$translate',
        'varianceReasonsData',
        'genericUiGrid',
        'clientUnitDepartmentService',
        'receivingPurchaseOrderService',
        'purchaseOrderService',
        'productSearchService',
        'enums',
        'windowService',
        'organisationContextService',
        '$timeout',
        'cdbAreYouSureService',
        'userService',
        function ($scope,
            $q,
            $location,
            $window,
            $route,
            $templateRequest,
            $translate,
            varianceReasonsData,
            genericUiGrid,
            clientUnitDepartmentService,
            receivingPurchaseOrderService,
            purchaseOrderService,
            productSearchService,
            enums,
            windowService,
            organisationContextService,
            $timeout,
            cdbAreYouSureService,
            userService) {
            $translate.onReady().then(function() {
                var self = this;
                $scope.purchaseOrderId = $route.current.params.purchaseOrderId;
                self.receivingPurchaseOrderTransaction = {
                    _getTrackedLine: function(line, expressionObject) {
                        // Our default expression to use. Fallback to SkuCode as it's our default grouping
                        var defaultFindExpression = {
                            skuCode: line.skuCode,
                            replacementPurchaseOrderLine: line.replacementPurchaseOrderLine
                        };
                        // Find inside our _trackedLines using the passed in expression or fallback
                        return _.findWhere(this._trackedLines,
                            expressionObject ? expressionObject : defaultFindExpression);
                    },
                    _trackedLines: [],
                    resetTrackedLines: function() {
                        this._trackedLines = [];
                    },
                    trackEntity: function(line) {
                        // Look for an existing line using a custom expression to be specific. Using replacementPurchaseOrderLine as it will be unique
                        var existingReplacementLine = this._getTrackedLine(line,
                            { id: line.id, replacementPurchaseOrderLine: line.replacementPurchaseOrderLine });
                        if (existingReplacementLine) {
                            // Get the index of the existing line
                            var idx = this._trackedLines.indexOf(existingReplacementLine);
                            // And update it
                            this._trackedLines[idx] = line;
                        } else {
                            // We don't have an existing line, just add a new one
                            this._trackedLines.push(line);
                        }
                    },
                    deleteReplacement: function(replacementLine) {
                        // Get the tracked line by SKU
                        var item = this._getTrackedLine(replacementLine);
                        // Delete the line from the _trackedLines if it exists
                        if (item) this._trackedLines.splice(this._trackedLines.indexOf(item), 1);
                    },
                    createSavableEntity: function(poStatus) {
                        // Creates a new, stripped down object to send to the server. this makes sure we are only sending data that we need
                        var obj = {
                            id: $scope.receivingPurchaseOrder.id,
                            deliveryNoteNumber: $scope.receivingPurchaseOrder.deliveryNoteNumber,
                            invoiceNumber: $scope.receivingPurchaseOrder.invoiceNumber,
                            procurementPurchaseOrder: {
                                id: $scope.receivingPurchaseOrder.procurementPurchaseOrder.id,
                                status: { id: poStatus }
                            },
                            procurementReceivingPurchaseOrderLines: [],
                            dateTimeReceived: $scope.receivingPurchaseOrder.dateTimeReceived
                        };
                        // Need to loop over the lines so that we can trim the data down before POSTing it
                        _.each(this._trackedLines,
                            function(trackedLine) {
                                var trimmedLineData = {
                                    id: trackedLine.id,
                                    receivedThisDelivery: trackedLine.receivedThisDelivery,
                                    skuCode: trackedLine.skuCode,
                                    skuId: trackedLine.skuId,
                                    receivingItems: [],
                                    replacementPurchaseOrderLine: trackedLine.replacementPurchaseOrderLine,
                                    description: trackedLine.description,
                                    pricePerItem: trackedLine.pricePerItem,
                                    vatRate: trackedLine.vatRate
                                }
                                // Likewise with the receivingItems, need to trim data down
                                _.each(trackedLine.receivingItems,
                                    function(receivingItem) {
                                        var trimmedReceivingItem = {
                                            id: receivingItem.id,
                                            receivedThisDelivery: receivingItem.receivedThisDelivery,
                                            department: receivingItem.department,
                                            accountCode: receivingItem.accountCode,
                                            description: receivingItem.description,
                                            varianceReason: receivingItem.varianceReason &&
                                                $scope.canEditVarianceReasons(receivingItem)
                                                ? {
                                                    id: receivingItem.varianceReason.id
                                                }
                                                : null,
                                            varianceAccepted: receivingItem.varianceAccepted || false,

                                            procurementItem: {
                                                id: null,
                                                skuId: receivingItem.procurementItem.skuId,
                                                skuCode: receivingItem.procurementItem.skuCode,
                                                accountCode: receivingItem.procurementItem.accountCode,
                                                department: receivingItem.procurementItem.department,
                                                description: receivingItem.description
                                            }
                                        }
                                        trimmedLineData.receivingItems.push(trimmedReceivingItem);
                                    });
                                // Push our line with trimmed down data to the savable object
                                obj.procurementReceivingPurchaseOrderLines.push(trimmedLineData);
                            });
                        return obj;
                    }
                };

                $scope.headers = [
                    { key: 'label_sku_code' }, // 0
                    { key: 'label_description' }, // 1
                    { key: 'label_quantity_ordered', cssClass: 'number' }, // 2
                    { key: 'label_quantity_invoiced', cssClass: 'number' }, // 3
                    { key: 'label_received_to_date', cssClass: 'number' }, // 4
                    { key: 'label_received_this_delivery', cssClass: 'number' }, // 5
                    { key: 'label_department' }, // 6
                    { key: 'label_variance_accepted' }, // 7
                    { key: 'label_variance_reason' }, // 8
                    { key: 'label_item_price', cssClass: 'number' }, // 9
                    { key: 'label_po_total_price', cssClass: 'number' }, // 10
                    { key: 'label_adjusted_po_price', cssClass: 'number' }, // 11
                    { key: 'label_actions', cssClass: 'number' }, // 12
                    { key: 'label_vat_rate', cssClass: 'number' } // 13
                ];
                $scope.purchaseOrder = {};
                $scope.receivingPurchaseOrder = {
                    invoiceNumber: ''
                };
                $scope.receivingPurchaseOrderReady = false;
                $scope.newManualReplacement = {};
                $scope.loading = true;
                $scope.enums = enums;
                $scope.receivingViewModel = {
                    isReceivingAll: false,
                    isAddingReplacement: false,
                    isSaving: false,
                    isConfirmReceiveZeroQty: false
                };

                self.setReplacementViewModel = function(showReplacementView, productToReplace) {
                    $scope.replacementViewModel = {
                        loading: false,
                        term: productToReplace ? productToReplace.description : '',
                        showReplacementView: showReplacementView || false,
                        productToReplace: productToReplace || {},
                        hasSearched: false,
                        responseType: 'BeagleProductSearchPurchaseOrderResponse',
                        searchTypeEnum: enums.productSearchTypes.sku
                    }

                    if (showReplacementView) {
                        $scope.replacementViewModel.filters = [
                            {
                                filterType: 'Suppliers',
                                name: 'Suppliers',
                                items: [
                                    {
                                        id: $scope.receivingPurchaseOrder.supplier.id,
                                        isSelected: true
                                    }
                                ]
                            }
                        ];
                    }
                };
                self.setReplacementViewModel();

                self.findRealPoLine = function(expressionObject) {
                    // Finds a root-level PO Line using the passed in expression
                    return _.findWhere($scope.receivingPurchaseOrder.procurementReceivingPurchaseOrderLines,
                        expressionObject);
                }

                $scope.isItemLine = function(line) {
                    return line.parentEntity || (line.receivingItems && line.receivingItems.length == 1);
                }

                self.beginCellEdit = function(entity, cell) {
                    entity.editing = true;
                };

                var afterReceivedThisDeliveryCellEdit = function(realParentPoLine, entity) {
                    // If we have a parent, use the skucode from the parent, otherwise use the current entity
                    if (realParentPoLine.receivingItems.length > 1) {
                        // We have a PO line, null check the receivedThisDelivery to prevent errors
                        if (realParentPoLine.receivedThisDelivery == null) {
                            // receivedThisDelivery is null, set it to 0 to prevent NaN errorreplaces
                            realParentPoLine.receivedThisDelivery = 0;
                        }
                        // Init a 0 quantity to use as a base for the received calculations
                        //var totalQuantity = 0;
                        // Loop through the receivingItems and add the receivedThisDelivery to the totalQuantity to create a complete value
                        _(realParentPoLine.receivingItems).each(function(item) {
                            item.receivedThisDelivery = parseFloat(item.receivedThisDelivery).toFixed(3);
                        });
                        var totalQuantity = _.sum(realParentPoLine.receivingItems, 'receivedThisDelivery');
                        // Se the receivedThisDelivery on the root-level PO line to the total quantity of all receivingItems
                        realParentPoLine.receivedThisDelivery = parseFloat(totalQuantity).toFixed(3);
                    } else {
                        entity.receivedThisDelivery = parseFloat(entity.receivedThisDelivery).toFixed(3);
                        // We have one item so we need to do the changes at the line level using the entity, not the items in the entity
                        realParentPoLine.receivedThisDelivery = entity.receivedThisDelivery;
                        realParentPoLine.receivingItems[0].receivedThisDelivery = entity.receivedThisDelivery;
                    }

                    // Track the entity if validation passes
                    if (realParentPoLine.receivedThisDelivery != undefined) {
                        self.receivingPurchaseOrderTransaction.trackEntity(realParentPoLine);
                    }
                }

                $scope.afterCellEdit = function(entity, cell, value) {
                    var id = entity.parentEntity ? entity.parentEntity.id : entity.id;
                    var realParentPoLine = self.findRealPoLine({ id: id });

                    // uigrid passes the cell to the function containing details that we can use, such as field, to do different logic
                    if (cell.field == 'receivedThisDelivery') {
                        afterReceivedThisDeliveryCellEdit(realParentPoLine, entity);
                    } else if (cell.field == 'viewModel.varianceAccepted') {
                        // We have a parent entity. We are already binding to a receivingItem row
                        if (entity.parentEntity) {
                            var realEntity = _.findWhere(realParentPoLine.receivingItems, { id: entity.id });
                            if (realEntity) realEntity.varianceAccepted = value;
                        } else {
                            // We are editing line level, set the variance on the receivingItem. If we have > 1 receivingItems
                            if (realParentPoLine.receivingItems.length == 1) {
                                realParentPoLine.receivingItems[0].varianceAccepted = entity.viewModel.varianceAccepted;
                            }
                        }
                        self.receivingPurchaseOrderTransaction.trackEntity(realParentPoLine);
                    } else if (cell.field == 'viewModel.varianceReason') {
                        if (entity.parentEntity) {
                            var realEntity = _.findWhere(realParentPoLine.receivingItems, { id: entity.id });
                            if (realEntity) {
                                realEntity.varianceReason = value.id != -1 ? value : null;
                                if (value.id == -1) {
                                    entity.viewModel.varianceReason = null;
                                }
                            }
                        } else {
                            // We are editing line level
                            if (realParentPoLine.receivingItems.length == 1) {
                                realParentPoLine.receivingItems[0].varianceReason =
                                    entity.viewModel.varianceReason.id != -1 ? entity.viewModel.varianceReason : null;
                                if (entity.viewModel.varianceReason.id == -1) {
                                    entity.viewModel.varianceReason = null;
                                }
                            }
                        }
                        self.receivingPurchaseOrderTransaction.trackEntity(realParentPoLine);
                    }
                };

                $scope.canEditVarianceReasons = function(entity) {
                    if (entity.receivedThisDelivery == undefined)
                        entity.receivedThisDelivery = 0;
                    if (entity.quantity == undefined)
                        entity.quantity = 0;
                    if (entity.quantityOrdered == undefined)
                        entity.quantityOrdered = 0;
                    return (entity.receivedThisDelivery + entity.quantity) != entity.quantityOrdered;
                }

                $scope.showItemsForPurchaseOrderLine = function(row) {
                    // Assign the grid data to a var for easier reading
                    var data = $scope.purchaseOrderGrid.data;
                    // Check if we are already showing the line items
                    if (row.entity.showingLineItems) {
                        // We are showing line items, get the receivingItems
                        var children = row.entity.receivingItems;
                        // Loop through each receivingItem and remove it from the grid data array
                        _.each(children,
                            function(child) {
                                var idx = data.indexOf(child);
                                data.splice(idx, 1);
                            });
                        // Hide the item rows from the grid
                        row.entity.showingLineItems = false;
                    } else {
                        // We are not showing item rows, we need to get the index of the current row and +1 so we insert into our items /after/ the current row
                        var idx = data.indexOf(row.entity) + 1;
                        // Loop through the receivingItems, set the data as required and add it to the grid
                        _.each(row.entity.receivingItems,
                            function(item) {
                                item.isItemRow = true;
                                // Set the parentEntity to be the root-level PO line entity within the grid
                                item.parentEntity = row.entity;
                                // Insert the new item line into the grid
                                data.splice(idx, 0, item);
                                idx++;
                                return item;
                            });
                        row.entity.showingLineItems = true;
                    }
                };

                $scope.save = function(markAsReceived) {
                    // Safety check to make sure the enable logic passes
                    if (!$scope.disableSave()) {
                        $scope.receivingViewModel.isSaving = true;
                        var entity;
                        // If we pass markAsReceived, we need to set the status to received, otherwise it needs to be partReceived
                        if (markAsReceived) {
                            // Create the trimmed down entity to save and save it
                            entity = self.receivingPurchaseOrderTransaction
                                .createSavableEntity(enums.purchaseOrderStatus.received);
                            receivingPurchaseOrderService.insertUpdateReceivingItems(entity)
                                .then(function() {
                                    toastr.success($translate.instant('purchase_order_marked_as_received'));
                                    $location.path('/PurchaseOrders/Search');
                                }).finally(function() {
                                    $scope.receivingViewModel.isSaving = false;
                                });
                        } else {
                            // Create the trimmed down entity to save and save it
                            entity = self.receivingPurchaseOrderTransaction
                                .createSavableEntity(enums.purchaseOrderStatus.partReceived);
                            receivingPurchaseOrderService.insertUpdateReceivingItems(entity)
                                .then(function() {
                                    toastr.success($translate.instant('purchase_order_marked_as_back_order'));
                                    $location.path('/PurchaseOrders/Search');
                                }).finally(function() {
                                    $scope.receivingViewModel.isSaving = false;
                                });
                        }
                    }
                };

                $scope.associateInvoiceWithRPO = function() {
                    $scope.associatingInvoiceWithRPO = true;
                    var entity = self.receivingPurchaseOrderTransaction
                        .createSavableEntity(enums.purchaseOrderStatus.partReceived);
                    receivingPurchaseOrderService.associateInvoiceWithRPO(entity)
                        .then(function() {
                            $scope.associatingInvoiceWithRPO = false;
                            $scope.getOrCreateReceivingPurchaseOrder(entity.deliveryNoteNumber, entity.invoiceNumber);
                        });

                }


                $scope.cancelReceiving = function() {
                    self.receivingPurchaseOrderTransaction.resetTrackedLines();
                    windowService.searchPurchaseOrders();
                };

                $scope.disableSave = function() {
                    // Disable the saves if we don't even have a receivingPurchaseOrder. This protects against console errors.
                    if (!$scope.receivingPurchaseOrder) return true;

                    var hasDeliveryNoteNumber = $scope.receivingPurchaseOrder.deliveryNoteNumber;
                    var hasInvoiceNumber = $scope.receivingPurchaseOrder.invoiceNumber;

                    // We should disable if either delivery note or invoicenumber is empty
                  return (!hasDeliveryNoteNumber && !hasInvoiceNumber) || $scope.receivingViewModel.isSaving || !$scope.receivingPurchaseOrder.dateTimeReceived || (!$scope.hasQuantityReceivedThisDelivery() && !$scope.receivingViewModel.isConfirmReceiveZeroQty);
                }

                var getJustPoLinesFromTheGrid = function() {
                    var poLines = _.filter($scope.receivingPurchaseOrder.procurementReceivingPurchaseOrderLines,
                        function(l) { return !l.isItemRow });
                    return poLines;
                }

                $scope.receiveAll = function() {
                    var poLines = getJustPoLinesFromTheGrid();
                    _.each(poLines,
                        function(line) {
                            _.each(line.receivingItems,
                                function(receivingItem) {
                                    var qty = receivingItem.procurementItem.catchWeight
                                        ? receivingItem.procurementItem.quantity *
                                        receivingItem.procurementItem.catchWeight
                                        : receivingItem.procurementItem.quantity;
                                    var difference = (qty - receivingItem.receivedToDate);
                                    if (difference > 0) {
                                        receivingItem.receivedThisDelivery = difference;
                                    }
                                });
                            line.receivedThisDelivery = _.sum(line.receivingItems, 'receivedThisDelivery');
                            self.receivingPurchaseOrderTransaction.trackEntity(line);
                        });
                };

                // we need ANY to be non zero. sum is not good because we could receieve 1 and -1
                $scope.hasQuantityReceivedThisDelivery = function () {
                  var poLines = getJustPoLinesFromTheGrid();
                  var anyNonZero = false;
                  _.each(poLines,
                    function (line) {
                      _.each(line.receivingItems,
                          function (receivingItem) {
                            anyNonZero = anyNonZero ||  receivingItem.receivedThisDelivery != 0;
                          });
                    });
                  return anyNonZero;
                }

                $scope.receiveAllFromQuantityInvoiced = function() {
                    var poLines = getJustPoLinesFromTheGrid();
                    _.each(poLines,
                        function(line) {
                            if (line.quantityOrdered == line.ediInvoiced ||
                                (line.receivingItems.length && line.receivingItems.length == 1)) {
                                _.each(line.receivingItems,
                                    function(receivingItem) {
                                        var qty = receivingItem.ediInvoiced;
                                        var difference = (qty - receivingItem.receivedToDate);
                                        if (difference > 0) {
                                            receivingItem.receivedThisDelivery = difference;
                                        }
                                    });
                                line.receivedThisDelivery = _.sum(line.receivingItems, 'receivedThisDelivery');
                                self.receivingPurchaseOrderTransaction.trackEntity(line);
                            } else {
                                line.errorFlash = true;
                                $timeout(function() {
                                        line.errorFlash = false;
                                    },
                                    1000);
                            };
                        });
                };

                $scope.saveTest = function() {
                    alert('Hi');
                }

                var quantityOrderedEqualsQuantityReceivedForAllLines = function() {
                    var poLines = getJustPoLinesFromTheGrid();
                    var firstLineWhereQuantityRecivedNotEqualToQuantityOrdered = _.find(poLines,
                        function(l) {
                            return parseFloat(l.receivedThisDelivery) + parseFloat(l.quantity) !=
                                parseFloat(l.quantityOrdered);
                        });
                    if (firstLineWhereQuantityRecivedNotEqualToQuantityOrdered == null) {
                        return true;
                    }
                    return false;
                }

                var quantityInvoicedEqualsQuantityReceivedForAllLines = function() {
                    var poLines = getJustPoLinesFromTheGrid();
                    var firstLineWhereQuantityRecivedNotEqualToQuantityOrdered = _.find(poLines,
                        function(l) {
                            return parseFloat(l.receivedThisDelivery) + parseFloat(l.quantity) !=
                                parseFloat(l.ediInvoiced);
                        });
                    if (firstLineWhereQuantityRecivedNotEqualToQuantityOrdered == null) {
                        return true;
                    }
                    return false;
                }


                $scope.setReceivedPurchaseOrderToPartReceived = function() {
                    return cdbAreYouSureService($translate.instant('received_po_to_part_received_message')).then(
                        function() {
                            return purchaseOrderService
                                .setReceivedPurchaseOrderToPartReceived($scope.receivingPurchaseOrder
                                    .procurementPurchaseOrder.id).then(function() {
                                    toastr.success($translate.instant('set_received_po_to_part_received'));
                                    $timeout(function() { $window.location.reload(); });
                                });
                        });
                }

                $scope.saveResolveFunction = function() {
                    //functionThatReturnsAPromise
                    var deferred = $q.defer();
                    var areYouSureMessage = $translate.instant("message_mark_as_received");
                    if (!quantityOrderedEqualsQuantityReceivedForAllLines()) {
                        areYouSureMessage =
                            areYouSureMessage +
                            "<br/><br/><strong>" +
                            $translate.instant("message_receiving_po_ordered_not_equal_to_received") +
                            "<strong>";
                        areYouSureMessage = areYouSureMessage.replace("ordered", "<em>ordered</em>");
                    }
                    if (!quantityInvoicedEqualsQuantityReceivedForAllLines()) {
                        areYouSureMessage =
                            areYouSureMessage +
                            "<br/><br/>" +
                            $translate.instant("message_receiving_po_invoiced_not_equal_to_received") +
                            "<strong>";
                        areYouSureMessage = areYouSureMessage.replace("invoiced", "<em>invoiced</em>");
                    }
                    cdbAreYouSureService(areYouSureMessage).then(function() {
                        deferred.resolve();
                    });
                    return deferred.promise;
                }

                $scope.getOrCreateDeliveryToDate = function(procurementItem) {
                    if (procurementItem.receivingItem == null) {
                        procurementItem.receivingItem = {};
                    }
                    if (procurementItem.receivingItem.receivedToDate == null) {
                        var quantityWithoutReceivedToDate =
                            procurementItem.quantity - procurementItem.receivingItem.receivedToDate;
                        if (quantityWithoutReceivedToDate >= 0)
                            procurementItem.receivingItem.receivedThisDelivery = quantityWithoutReceivedToDate;
                    }
                    return procurementItem.receivingItem.receivedThisDelivery;
                }

                $scope.toggleReplacementProductView = function(productLine) {
                    // If we don't pass a line in, it means we a closing the replacement view
                    self.setReplacementViewModel(productLine != null, productLine);
                    $scope.replacementProducts = [];
                };

                $scope.getDepartmentForLine = function(entity) {
                    if (entity.parentEntity) {
                        return entity.department;
                    } else if (entity.receivingItems && entity.receivingItems.length == 1) {
                        return entity.receivingItems[0].department;
                    } else {
                        return null;
                    }
                };

                $scope.disableAddManualLineButton = function() {
                    // Disables if any field is not populated on the manual replacement object
                    return !$scope.newManualReplacement.description ||
                        !$scope.newManualReplacement.skuCode ||
                        !$scope.newManualReplacement.price;
                };

                $scope.addReplacementProduct = function($form, replacementProduct) {
                    // If  we dont have a form, skip form validation
                    if (!$form || $form.$valid) {
                        $scope.receivingViewModel.isAddingReplacement = true;
                        // Get the original PO line
                        var realPoLine = self.findRealPoLine({
                            skuCode: $scope.replacementViewModel.productToReplace.skuCode
                        });
                        // Copy it to create a replacement
                        var replacementLine = angular.copy(realPoLine);
                        receivingPurchaseOrderService.getQuantityOfMatchedInvoiceLinesForSkuCode(
                            replacementProduct.skuCode,
                            $scope.receivingPurchaseOrder.id,
                            $scope.receivingPurchaseOrder.procurementPurchaseOrder.id,
                            $scope.receivingPurchaseOrder.invoiceNumber,
                            $scope.receivingPurchaseOrder.deliveryNoteNumber).then(
                            function(invoiceData) {
                                // Set the data we need to change. This is simpler than creating a brand new object and setting everything we'd need
                                replacementLine.id = null;
                                replacementLine.skuCode = replacementProduct.skuCode;
                                replacementLine.skuId = replacementProduct.skuId;
                                replacementLine.procurementPurchaseOrderLineId = null;
                                replacementLine.replacementPurchaseOrderLine = {
                                    id: realPoLine.id
                                };
                                replacementLine.showingLineItems = realPoLine.receivingItems.length > 1;
                                replacementLine.pricePerItem = replacementProduct.price;
                                replacementLine.description = replacementProduct.description;
                                replacementLine.grossPriceOrdered = 0;
                                replacementLine.isReplacement = true;
                                replacementLine.receivedThisDelivery = parseFloat(0).toFixed(3);
                                replacementLine.receivedToDate = parseFloat(0).toFixed(3);
                                replacementLine.quantity = parseFloat(0).toFixed(3);
                                replacementLine.quantityOrdered = parseFloat(0).toFixed(3);
                                replacementLine.canDelete = true;
                                replacementLine.vatCodeId = replacementProduct.vatCodeId;
                                replacementLine.isReplacement = true;
                                replacementLine.vatRate = replacementProduct.vatCodeId
                                    ? _.findWhere(self.vatRates, { vatCodeId: replacementProduct.vatCodeId }).amount
                                    : 0;
                                replacementLine.ediInvoiced = invoiceData.quantityInvoiced;
                                replacementLine.varianceReason = null;
                                replacementLine.varianceAccepted = false;

                                var grid = $scope.purchaseOrderGrid.data;
                                var index = grid.indexOf(realPoLine) + 1;

                                if (realPoLine.showingLineItems == true) {
                                    index += realPoLine.receivingItems.length;
                                }

                                //realPoLine.replacementPurchaseOrderLine = replacementLine;

                                grid.splice(index, 0, replacementLine);
                                for (var i = 0; i < replacementLine.receivingItems.length; i++) {
                                    index += 1;
                                    replacementLine.receivingItems[i].id = null;
                                    replacementLine.receivingItems[i].procurementItem.skuCode =
                                        replacementProduct.skuCode;
                                    replacementLine.receivingItems[i].procurementItem.skuId = replacementProduct.skuId;
                                    replacementLine.receivingItems[i].procurementItem.pricePerItem =
                                        replacementProduct.price;
                                    replacementLine.receivingItems[i].procurementItem.quantity = 0;
                                    replacementLine.receivingItems[i].receivedThisDelivery = 0;
                                    replacementLine.receivingItems[i].quantity = 0;
                                    replacementLine.receivingItems[i].parentEntity = replacementLine;
                                    replacementLine.receivingItems[i].isItemRow = true;
                                    replacementLine.receivingItems[i].description = replacementLine.description;
                                    replacementLine.receivingItems[i].ediInvoiced = invoiceData.quantityInvoiced;
                                    if (replacementLine.receivingItems.length > 1) {
                                        grid.splice(index, 0, replacementLine.receivingItems[i]);
                                    }
                                }

                                self.receivingPurchaseOrderTransaction.trackEntity(replacementLine);
                                $scope.toggleReplacementProductView();
                            }).finally(function() {
                            $scope.receivingViewModel.isAddingReplacement = false;
                        });
                    }
                };

                $scope.deleteReplacementProduct = function(replacement) {
                    var data = $scope.purchaseOrderGrid.data;
                    var index = data.indexOf(replacement);

                    // If we have more than 1 receivingItem we need to add 1 otherwise it will leave 1 item in the grid. If we have 1 ReceivingItem, we are only one line so delete it.
                    var numberToDelete = replacement.receivingItems.length > 1
                        ? replacement.receivingItems.length + 1
                        : replacement.receivingItems.length;
                    data.splice(index, numberToDelete);

                    self.receivingPurchaseOrderTransaction.deleteReplacement(replacement);
                };


                $scope.searchForReplacementProducts = function() {
                    $scope.replacementViewModel.loading = true;
                    productSearchService.search($scope.replacementViewModel).$promise.then(function(data) {
                        if (data.results) {
                            var mappedResults = _.map(data.results,
                                function(item) {
                                    item.vatRate = _.findWhere(self.vatRates, { vatCodeId: item.vatCodeId });
                                    return item;
                                });
                            $scope.replacementProducts = mappedResults;
                        } else {
                            $scope.replacementProducts = [];
                        }
                    }).finally(function() {
                        $scope.replacementViewModel.loading = false;
                        $scope.replacementViewModel.hasSearched = true;
                    });
                };

                ///______________________________________///
                ///GET OR CREATE RECEIVING PURCHASE ORDER///

                $scope.getOrCreateReceivingPurchaseOrder = function(deliveryNumber, invoiceNumber) {
                    $scope.receivingPurchaseOrder.isLoadingData = true;
                    self.context = organisationContextService.getContext();
                    var unitId = self.context.currentSubscriptionUnit.id;
                    var savedDatetimeReceived = $scope.receivingPurchaseOrder.dateTimeReceived;
                    receivingPurchaseOrderService
                        .getOrCreateReceivingPurchaseOrder(unitId,
                            $route.current.params.purchaseOrderId,
                            deliveryNumber,
                            invoiceNumber)
						.then(function (receivingPurchaseOrder) {
                            $scope.receivingPurchaseOrderReady = true;
                            // Add our PO to the scope for tracking in html
                            $scope.receivingPurchaseOrder = receivingPurchaseOrder;
                            // If we had a DateTimeRecevied before now (eg. if we set it before setting the invoice number) then we want to make sure keep it.
                            $scope.receivingPurchaseOrder.dateTimeReceived = savedDatetimeReceived;
                            // Sort by SkuCode for the grid
							if (!$scope.receivingPurchaseOrder.dateTimeReceived) {
								$scope.receivingPurchaseOrder.dateTimeReceived = moment().format('DD/MM/YYYY HH:mm');
							}
                            // Assigned our lines for easier reading
                            var lines = $scope.receivingPurchaseOrder.procurementReceivingPurchaseOrderLines;
                            // Gets all replacementlines only
                            var replacementLines = _.filter(lines,
                                function(a) { return a.replacementPurchaseOrderLine != null });
                            // Gets all lines that are NOT replacements
                            var linesWithoutReplacement =
                                _.filter(lines, function(a) { return a.replacementPurchaseOrderLine == null });
                            // Sort all of our non-replacement lines by SKU to ensure sorting is done correctly
                            var sortedLines = _.sortBy(linesWithoutReplacement, 'skuCode');

                            // We need to add our replacement lines into the grid directly below the lines they are replacing
                            _.each(replacementLines,
                                function(replacementLine) {
                                    // Get the line that we are replacing
                                    var parent = _.findWhere(sortedLines,
                                        { id: replacementLine.replacementPurchaseOrderLine.id });
                                    // Get the index of the parent line in the sorted array
                                    var indexOfParent = sortedLines.indexOf(parent);
                                    // Add our replacement to the sorted array beneath the parent
                                    sortedLines.splice(indexOfParent + 1, 0, replacementLine);

                                    return replacementLine;
                                });

                            // Reassign the original lines to be our newly sorted and replaced lines
                            $scope.receivingPurchaseOrder.procurementReceivingPurchaseOrderLines = sortedLines;


                            purchaseOrderService
                                .getVatRatesForPurchaseOrderId(self.context.currentSubscriptionUnit.id,
                                    $scope.receivingPurchaseOrder.procurementPurchaseOrder.id,
                                    function(vatRates) {
                                        self.vatRates = vatRates;
                                        // Get our variance reasons
                                        varianceReasonsData.$promise.then(function(varianceReasons) {
                                            $translate('clear_selection').then(function(t) {
                                                varianceReasons.unshift({ id: -1, description: t });
                                            });
                                            // Translate all of our headers in one go passing the `key` property from the objects in the array
                                            var translationPromise = $translate(_.pluck($scope.headers, 'key'));

                                            // Get all of our grid template promises to pass into the grid
                                            var clientUnitDepartmentServicePromise =
                                                clientUnitDepartmentService
                                                    .getClientUnitProcurementDepartmentsForUser(null,
                                                        null,
                                                        "eProcurement.DeptKeyValueResponseDto");
                                            var receivePurchaseOrderLineItemsTemplatePromise =
                                                $templateRequest(
                                                    '/ngxbeagle/dist/Content/js/Modules/ReceivingPurchaseOrder/templates/receivePurchaseOrderLineItemsTemplate.html');
                                            var receivePurchaseOrderLineItemVarianceTemplatePromise =
                                                $templateRequest(
                                                    '/ngxbeagle/dist/Content/js/Modules/ReceivingPurchaseOrder/templates/receivePurchaseOrderLineItemVarianceTemplate.html');
                                            var ediQuantityCellTemplatePromise =
                                                $templateRequest(
                                                    "/ngxbeagle/dist/Content/js/Modules/ReceivingPurchaseOrder/templates/ediQuantityCellTemplate.html");
                                            var checkboxCellTemplatePromise =
                                                $templateRequest(
                                                    "/ngxbeagle/dist/Content/js/Modules/ReceivingPurchaseOrder/templates/checkboxCellTemplate.html");
                                            var receivedToDateTemplatePromise =
                                                $templateRequest(
                                                    "/ngxbeagle/dist/Content/js/Modules/ReceivingPurchaseOrder/templates/receivedToDateTemplate.html");
                                            var receivedThisDeliveryPromise =
                                                $templateRequest(
                                                    "/ngxbeagle/dist/Content/js/Modules/ReceivingPurchaseOrder/templates/receivedThisDeliveryTemplate.html");
                                            var totalItemPriceTemplatePromise =
                                                $templateRequest(
                                                    "/ngxbeagle/dist/Content/js/Modules/ReceivingPurchaseOrder/templates/totalItemPriceTemplate.html");
                                            var adjustedTotalPriceTemplatePromise =
                                                $templateRequest(
                                                    "/ngxbeagle/dist/Content/js/Modules/ReceivingPurchaseOrder/templates/adjustedTotalPriceTemplate.html");
                                            var itemPriceTemplatePromise =
                                                $templateRequest(
                                                    "/ngxbeagle/dist/Content/js/Modules/ReceivingPurchaseOrder/templates/itemPriceTemplate.html");
                                            var quantityOrderedTemplatePromise =
                                                $templateRequest(
                                                    "/ngxbeagle/dist/Content/js/Modules/ReceivingPurchaseOrder/templates/quantityOrderedTemplate.html");
                                            var departmentTemplatePromise =
                                                $templateRequest(
                                                    "/ngxbeagle/dist/Content/js/Modules/ReceivingPurchaseOrder/templates/departmentTemplate.html");
                                            var skuCodeTemplatePromise =
                                                $templateRequest(
                                                    "/ngxbeagle/dist/Content/js/Modules/ReceivingPurchaseOrder/templates/skuCodeTemplate.html");
                                            var descriptionTemplatePromise =
                                                $templateRequest(
                                                    "/ngxbeagle/dist/Content/js/Modules/ReceivingPurchaseOrder/templates/descriptionTemplate.html");
                                            var vatRateTemplatePromise =
                                                $templateRequest(
                                                    "/ngxbeagle/dist/Content/js/Modules/ReceivingPurchaseOrder/templates/vatRateTemplate.html");
                                            var editableReceivedThisDeliveryTemplatePromise =
                                                $templateRequest(
                                                    "/ngxbeagle/dist/Content/js/Modules/ReceivingPurchaseOrder/Templates/editableReceivedThisDeliveryTemplate.html");
                                            userService.hasPermission('BEAGLE_PERFORM_RECEIVING_PURCHASEORDER').then(
                                                function() {
                                                    $scope.hasPerformReceivingPermission = true;
                                                });

                                            // Wait for all promises to resolve before continuing
                                            $q.all([
                                                translationPromise,
                                                clientUnitDepartmentServicePromise,
                                                receivePurchaseOrderLineItemsTemplatePromise,
                                                receivePurchaseOrderLineItemVarianceTemplatePromise,
                                                ediQuantityCellTemplatePromise,
                                                checkboxCellTemplatePromise,
                                                receivedToDateTemplatePromise,
                                                receivedThisDeliveryPromise,
                                                totalItemPriceTemplatePromise,
                                                adjustedTotalPriceTemplatePromise,
                                                itemPriceTemplatePromise,
                                                quantityOrderedTemplatePromise,
                                                departmentTemplatePromise,
                                                skuCodeTemplatePromise,
                                                descriptionTemplatePromise,
                                                vatRateTemplatePromise,
                                                editableReceivedThisDeliveryTemplatePromise
                                            ]).then(function(results) {
                                                // Pick off the resolved promises and assign them all to usable variables
                                                var translatedHeaders = _(results[0]).toArray();
                                                var clientUnitDepartments = results[1];
                                                var receivePurchaseOrderLineItemsTemplate = results[2];
                                                var receivePurchaseOrderLineItemVarianceTemplate = results[3];
                                                var ediQuantityCellTemplate = results[4];
                                                var checkboxCellTemplate = results[5];
                                                var receivedToDateTemplate = results[6];
                                                var receivedThisDeliveryTemplate = results[7];
                                                var totalItemPriceTemplate = results[8];
                                                var adjustedTotalPriceTemplate = results[9];
                                                var itemPriceTemplate = results[10];
                                                var quantityOrderedTemplate = results[11];
                                                var departmentTemplate = results[12];
                                                var skuCodeTemplate = results[13];
                                                var descriptionTemplate = results[14];
                                                var vatRateTemplate = results[15];
                                                var editableReceivedThisDeliveryTemplate = results[16];

                                                self.departments = clientUnitDepartments;

                                                // Setup our gridOptions for creating the grid
                                                var gridOptions = {
                                                    enableColumnResizing: true,
                                                    enableSorting: false,
                                                    data: $scope.receivingPurchaseOrder
                                                        .procurementReceivingPurchaseOrderLines,
                                                    // Setup our columns. We are using the translated headers as the displayName
                                                    columns: [
                                                        {
                                                            field: 'skuCode',
                                                            minWidth: 100,
                                                            displayName: translatedHeaders[0],
                                                            template: skuCodeTemplate
                                                        },
                                                        {
                                                            field: 'description',
                                                            displayName: translatedHeaders[1],
                                                            minWidth: 300,
                                                            template: descriptionTemplate
                                                        },
                                                        {
                                                            field: 'quantityOrdered',
                                                            minWidth: 100,
                                                            displayName: translatedHeaders[2],
                                                            template: quantityOrderedTemplate
                                                        },
                                                        {
                                                            field: 'ediInvoiced',
                                                            minWidth: 100,
                                                            displayName: translatedHeaders[3],
                                                            template: ediQuantityCellTemplate,
                                                            cellClass: 'show-custom-icon',
                                                            placeholder: '0.000'
                                                        },
                                                        {
                                                            field: 'quantity',
                                                            minWidth: 100,
                                                            template: receivedToDateTemplate,
                                                            displayName: translatedHeaders[4]
                                                        },
                                                        {
                                                            field: 'receivedThisDelivery',
                                                            minWidth: 100,
                                                            template: receivedThisDeliveryTemplate,
                                                            editableCellTemplate: editableReceivedThisDeliveryTemplate,
                                                            placeholder: '',
                                                            displayName: translatedHeaders[5],
                                                            editable:
                                                                function(scope) {
                                                                    return $scope.isItemLine(scope.row.entity) &&
                                                                        $scope.hasPerformReceivingPermission;
                                                                }
                                                        },
                                                        {
                                                            field: 'department',
                                                            minWidth: 100,
                                                            displayName: translatedHeaders[6],
                                                            template: departmentTemplate,
                                                            cellFilter: 'cdbDescription'
                                                        },
                                                        {
                                                            field: 'viewModel.varianceAccepted',
                                                            width: 100,
                                                            template: checkboxCellTemplate,
                                                            enableCellEditOnFocus: false,
                                                            displayName: translatedHeaders[7],
                                                            editable: function(scope) {
                                                                return $scope.receivingPurchaseOrder
                                                                    .procurementPurchaseOrder.status.id !=
                                                                    enums.purchaseOrderStatus.received &&
                                                                    $scope.hasPerformReceivingPermission;
                                                            }
                                                        },
                                                        {
                                                            field: 'viewModel.varianceReason',
                                                            minWidth: 130,
                                                            displayName: translatedHeaders[8],
                                                            displayValue: 'description',
                                                            editDropdownOptionsArray: varianceReasons,
                                                            editable: function(scope) {
                                                                return $scope.receivingPurchaseOrder
                                                                    .procurementPurchaseOrder.status.id !=
                                                                    enums.purchaseOrderStatus.received &&
                                                                    $scope.canEditVarianceReasons(scope.row.entity) &&
                                                                    $scope.hasPerformReceivingPermission;
                                                            }
                                                        },
                                                        {
                                                            field: 'pricePerItem',
                                                            minWidth: 100,
                                                            displayName: translatedHeaders[9],
                                                            cellFilter: "pslContextCurrency",
                                                            template: itemPriceTemplate
                                                        },
                                                        {
                                                            field: 'vatRate',
                                                            minWidth: 100,
                                                            displayName: translatedHeaders[13],
                                                            template: vatRateTemplate
                                                        },
                                                        {
                                                            field: 'grossPriceOrdered',
                                                            minWidth: 100,
                                                            displayName: translatedHeaders[10],
                                                            cellFilter: "pslContextCurrency",
                                                            template: totalItemPriceTemplate
                                                        },
                                                        {
                                                            field: 'receivedPurchaseOrderLineItems',
                                                            displayName: translatedHeaders[12],
                                                            template: receivePurchaseOrderLineItemsTemplate,
                                                            minWidth: 150,
                                                            cellClass: 'line-height-2'
                                                        }
                                                    ],
                                                    beginCellEdit: self.beginCellEdit,
                                                    afterCellEdit: $scope.afterCellEdit,
                                                    globalEditableCondition: function() {
                                                        return false;
                                                    },
                                                    rowClass: function(row) {
                                                        // If we have a parentEntity, the current row is an item row
                                                        if (row.entity.parentEntity) {
                                                            return "is-item-row";
                                                            // If we have no PO line Id, it is a replacement item
                                                        } else if (
                                                            row.entity.procurementPurchaseOrderLineId == null ||
                                                                row.entity.replacementPurchaseOrderLine != null) {
                                                            return "is-replacement-row";
                                                        } else {
                                                            // We are a root-level PO line
                                                            return "is-parent-row";
                                                        }
                                                    }
                                                }
                                                genericUiGrid.create(gridOptions, $scope).then(function(grid) {
                                                    $scope.purchaseOrderGrid = grid;
                                                    $scope.loading = false;

                                                });
                                            });
                                        });
                                    });
                        })
                        .finally(function() {
                            $scope.receivingPurchaseOrder.isLoadingData = false;
                        });

                };

                self.init = function() {
                    $scope.associatingInvoiceWithRPO = false;
                    $scope.getOrCreateReceivingPurchaseOrder("");
                }();
            });
        }
    ]);

angular.module(appName)
    .factory('receivingPurchaseOrderResource', [
        '$resource', 'siteUrl', 
        function ($resource, siteUrl) {
            var self = this;
            self.api = siteUrl() + 'api/ReceivingPurchaseOrder/';
                        
            return $resource(self.api, {}, {
                getOrCreateReceivingPurchaseOrder: {
                    method: 'GET',
                    url: self.api + 'GetReceivingPurchaseOrder'
                },
                insertUpdateReceivingItems: {
                    method: 'POST',
                    url: self.api + 'InsertUpdateReceivingItems'
                },
                getQuantityOfMatchedInvoiceLinesForSkuCode: {
                    method: 'GET',
                    url: self.api + 'GetQuantityOfMatchedInvoiceLinesForSkuCode'
                },
                flipRPOToInvoice: {
                    method: 'POST',
                    url: self.api + 'flipRPOToInvoice'
                }, 

                associateInvoiceWithRPO: {
                    method: 'POST',
                    url: self.api + 'AssociateInvoiceWithRPO'
                },
                getInvoiceDataFromPo: {
                    method: 'POST',
                    url: self.api + '/GetInvoiceDataFromPo'
                }
            });
        }
    ]);
angular.module(appName)
    .factory('receivingPurchaseOrderService', [
        'receivingPurchaseOrderResource', 'organisationContextService',
        function (receivingPurchaseOrderResource, organisationContextService) {

            return {
                getOrCreateReceivingPurchaseOrder: function (unitId, procurementPurchaseOrderId, deliveryNumber, invoiceNumber) {
                    return receivingPurchaseOrderResource.getOrCreateReceivingPurchaseOrder({ id: procurementPurchaseOrderId, unitId: unitId, deliveryNoteNumber: deliveryNumber, invoiceNumber: invoiceNumber }).$promise;
                },
                insertUpdateReceivingItems: function (receivingPurchaseOrderDto) {
                    return receivingPurchaseOrderResource.insertUpdateReceivingItems(receivingPurchaseOrderDto).$promise;
                },
                getQuantityOfMatchedInvoiceLinesForSkuCode: function (skuCode, rpoId, procurementPurchaseOrderId, invoiceNumber, deliveryNoteNumber) {
                    return receivingPurchaseOrderResource.getQuantityOfMatchedInvoiceLinesForSkuCode({
                        id: rpoId,
                        procurementPurchaseOrderId: procurementPurchaseOrderId,
                        skuCode: skuCode,
                        invoiceNumber: invoiceNumber,
                        deliveryNoteNumber: deliveryNoteNumber
                    }).$promise;
                },
                flipRPOToInvoice: function (po) {
                    var dto = {
                        id: po.id,
                        procurementPurchaseOrderId: po.id,
                        invoiceNumber: po.invoiceNumber,
                        invoiceDate: po.invoiceDate,
                        deliveryDate: po.deliveryDate
                    };

                    return receivingPurchaseOrderResource.flipRPOToInvoice(dto).$promise;
                },
                associateInvoiceWithRPO: function (receivingPurchaseOrderDto) {
                    return receivingPurchaseOrderResource.associateInvoiceWithRPO(receivingPurchaseOrderDto).$promise;
                },
                getInvoiceDataFromPo: function (purchaseOrder, cb) {
                    var dto = {};
                    dto.Id = purchaseOrder.id;
                    return receivingPurchaseOrderResource.getInvoiceDataFromPo(dto).$promise.then(function (data) {
                        cb(data);
                    });
                },

            }
        }
    ]);
angular.module(appName)
    .factory('ingredientResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/Ingredient';

            return $resource(api, {},
                {
                    search: {
                        url: api + '/Search',
                        method: 'GET',
                        isArray: true
                    },
                    save: {
                        url: api + '/Save',
                        method: 'POST'
                    }
                });
        }
    ])
angular.module(appName)
    .factory('ingredientService', [
        'ingredientResource', 'organisationContextService','$http','siteUrl','$q',
		function (ingredientResource, organisationContextService, $http, siteUrl, $q) {

            var ctx = organisationContextService.getContext();
            var currentSubscriptionUnitClientId = ctx.currentSubscriptionUnit.client.id;

            var search = function (filter) {
                filter.id = currentSubscriptionUnitClientId;
                return ingredientResource.search(filter).$promise;
			}

			var deleteIngredient = function(id) {
				return $http.delete(siteUrl() + "api/ingredient/" + id);
			}

			var get = function (id) {
				var deferred = $q.defer();
				$http.get(siteUrl() + "api/ingredient/" + id).then(function(result) {
					var i = result.data;
					i.entityType = result.data.skuId ? 'Sku' : result.data.subRecipeId ? 'SubRecipe' : 'Product';
					i.price = i.currentIngredientPrice ? i.currentIngredientPrice.basePrice : null;
					deferred.resolve(result);
				});
				return deferred.promise;
			}

            return {
				delete: deleteIngredient,
				get: get,
				search: search
            }
        }
    ]);
angular.module(appName)
	.controller("copyRecipeController",
	[
		"$scope","recipeService","organisationContextService",
		function ($scope, recipeService, organisationContextService) {
			var currentSubscriptionUnit = organisationContextService.getContext().currentSubscriptionUnit.client;
			$scope.currentUnitName = currentSubscriptionUnit.name;
			$scope.model = {
				clientUnitId : currentSubscriptionUnit.id
			}
			$scope.recipe = $scope.ngDialogData.recipe;
			recipeService.getUnitsThatLoggedInUserCanCreateRecipeFor().then(function(result) {
				$scope.availableUnits = result.data;
			});
		}
	]);
angular.module(appName)
	.controller("publishRecipeDialogController",
		[
			"$scope",
			"recipeService",
			"$translate",
			function ($scope, recipeService, $translate) {
				$scope.recipesToPublish = $scope.ngDialogData.recipesToPublish ? angular.copy($scope.ngDialogData.recipesToPublish): [];
				$scope.recipesToUnpublish = $scope.ngDialogData.recipesToUnpublish ? angular.copy($scope.ngDialogData.recipesToUnpublish) : [];
                $scope.showPPDSDisclaimer = angular.copy($scope.ngDialogData.showPPDSDisclaimer);
                $scope.showCalorieDataIncomplete = angular.copy($scope.ngDialogData.showCalorieDataIncomplete);
				$scope.model = {};
				$scope.hasRecipesWithNoAllergens = function() {
					return _.find($scope.recipesToPublish,
							function(recipe) {
								return recipe.hasNoConfirmedAllergens;
							}) != null;
				};

				$scope.hasRecipesWithDifferentAllergensToSuggested = function(){
					return _.find($scope.recipesToPublish,
						function(recipe) {
							return recipe.suggestedAllergensDifferent;
						}) != null
				};

				$scope.disableConfirm = function () {
					var verifyDisclaimer = $scope.hasRecipesWithNoAllergens();
                    return (verifyDisclaimer && !$scope.model.disclaimerTicked) ||
                        ($scope.showPPDSDisclaimer && !$scope.model.ppdsDisclaimerTicked) ||
                        ($scope.showCalorieDataIncomplete && !$scope.model.calorieDataIncompleteTicked);
				};

				var recipeBulkUpdateSuccessMessage = "recipe_bulk_update_success";
				var getTranslations = function() {
					$translate("recipe_bulk_update_success").then(function (t) {
						recipeBulkUpdateSuccessMessage = t;
					});
				};

				$scope.tryCloseDialog = function() {
					if (!$scope.confirmClicked) {
						$scope.closeThisDialog(false);
					}
				};

				$scope.confirmBulkPublishUnpublish = function() {
					var me = this;
					// Disables the Cancel button while we're confirming.
					$scope.confirmClicked = true;
					return recipeService.publishAndUnpublishInBulk(me.recipesToPublish, me.recipesToUnpublish).then(
						function () {
							toastr.success(recipeBulkUpdateSuccessMessage);
							$scope.closeThisDialog(true);
							$scope.disclaimerTicked = false;
							$scope.ppdsDisclaimerTicked = false;
						}).finally(function () {
							$scope.confirmClicked = false;
					});
				};
				var allRecipeIdsToProcess = _.pluck(_.union($scope.recipesToPublish, $scope.recipesToUnpublish), "id");

				var init = function () {
					getTranslations();
					recipeService.checkIfSuggestedAllergensDifferFromConfirmed(allRecipeIdsToProcess).then(
						function (processedRecipes) {
							angular.forEach(processedRecipes.recipeIdsWithNoConfirmedAllergens,
								function (recipeId) {
									var r = _.findWhere($scope.recipesToPublish, { id: recipeId });
									if (r) {
										r.hasNoConfirmedAllergens = true;
									}
								});
							angular.forEach(processedRecipes
								.recipeIdsWithSuggestedAllergensDifferentToConfirmedAllergens,
								function (recipeId) {
									var r = _.findWhere($scope.recipesToPublish, { id: recipeId });
									if (r) {
										r.suggestedAllergensDifferent = true;
									}
								});
							$scope.initComplete = true;
						})
						.finally(function () {
							loadingAllergenConfirmation.resolve();
						});
				}
				init();
			}
		]);

angular.module(appName)
	.factory(
		"publishRecipeService",
	["ngDialog",
		"$q",
		function (ngDialog, $q) {
				return {
					publishRecipes: function (request) {
						var deferred = $q.defer();
						var dialog = ngDialog.open(
							{
								template: "ngxbeagle/dist/Content/js/Modules/Recipes/Shared/publishRecipeDialog.html",
								controller: "publishRecipeDialogController",
								disableAnimation: true,
								showClose: false,
								width: "80%",
								closeByDocument: false,
								data: request
							}
						);
						dialog.closePromise.then(function(data) {
							if (data && data.value && data.value === true) {
								deferred.resolve();
							} else {
								deferred.reject();
							}
						});
						return deferred.promise;
					}
				}
			}
		]);

angular.module(appName)
    .factory('recipeAllergenResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/RecipeAllergens';

            return $resource(api, {},
                {
                    saveMany: {
                        url: api + '/SaveMany',
                        method: 'POST'
                    }
                });
        }
    ])
angular.module(appName)
    .factory('recipeAllergenService', [
        'recipeResource', 'organisationContextService',
        function (recipeResource, organisationContextService) {

            var ctx = organisationContextService.getContext();
            var currentSubscriptionUnitClientId = ctx.currentSubscriptionUnit.client.id;
            var defaultSearchParams = {
                numPerPage: 25,
                currentPage: 1,
                term: '',
                sortAsc: false,
                sortField: 'DateTimeAdded'
            }

            var getDefaultSearchParams = function() {
                return defaultSearchParams;
            }

            var search = function (searchData) {
                return recipeResource.search({
                    id: searchData.id,
                    term: searchData.term,
                    currentPage: searchData.currentPage,
                    numPerPage: searchData.numPerPage,
                    sortAsc: searchData.sortAsc ? searchData.sortAsc : false,
                    sortField: searchData.sortField ? searchData.sortField : 'DateTimeAdded'
                }).$promise;
            }

            var deleteRecipe = function (recipe) {
                return recipeResource.deleteRecipe({ id: recipe.id }).$promise;
            }

            var checkIfSuggestedAllergensDifferFromConfirmed = function (recipeIds) {
                var dto = {
                    recipeIds: recipeIds
                }
                return recipeResource.checkIfSuggestedAllergensDifferFromConfirmed(dto).$promise;
            }

            var publishAndUnpublishInBulk = function (recipesToPublish, recipesToUnpublish) {
                var dto = {
                    recipesToPublish: _.pluck(recipesToPublish, 'id'),
                    recipesToUnpublish: _.pluck(recipesToUnpublish, 'id')
                }
                return recipeResource.publishAndUnpublishInBulk(dto).$promise;
            };

            var get = function(clientId, recipeId) {
                return recipeResource.get({ clientId: clientId, id: recipeId }).$promise;
            }

            var save = function (recipe) {
                recipe.clientId = currentSubscriptionUnitClientId;
                return recipeResource.saveRecipe(recipe).$promise;
            }

            var getRecipeCost = function(recipeId) {
                return recipeResource.getRecipeCost({ id: recipeId });
            }

            return {
                get: get,
                getRecipeCost: getRecipeCost,
                save: save,
                getDefaultSearchParams: getDefaultSearchParams,
                search: search,
                delete: deleteRecipe,
                checkIfSuggestedAllergensDifferFromConfirmed: checkIfSuggestedAllergensDifferFromConfirmed,
                publishAndUnpublishInBulk: publishAndUnpublishInBulk
            }
        }
    ]);
angular.module(appName)
    .factory('recipeResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/Recipe';

            return $resource(api, {},
                {
                    get: {
                        url: api + '/GetRecipe',
                        method: 'GET'
                    },
                    saveRecipe: {
                        url: api + '/SaveRecipe',
                        method: 'POSt'
                    },
                    saveLabelSize: {
                        url: api + '/SaveLabelSize',
                        method: 'POST'
                    },
                    search: {
                        url: api + '/SearchRecipes',
                        method: 'GET'
					},
					getRecipesUnderOrOverFoodCostTarget: {
						url: api + '/GetRecipesUnderOrOverFoodCostTarget',
						method: 'GET'
					},
                    deleteRecipe: {
                        url: api + '/Delete',
                        method: 'DELETE'
                    },
                    checkIfSuggestedAllergensDifferFromConfirmed: {
                        url: api + '/CheckIfSuggestedAllergensDifferFromConfirmed',
                        method: 'POST'
                    },
                    publishAndUnpublishInBulk: {
                        url: api + '/PublishAndUnpublishInBulk',
                        method: 'POST'
                    },
                    getRecipeCost: {
                        url: api + '/GetRecipeCost',
                        method: 'GET'
                    }
                });
        }
    ])

angular.module(appName)
	.factory(
		"recipeService",
		[
			"recipeResource",
			"organisationContextService",
			"$http",
			"siteUrl",
			"enums",
			function(
				recipeResource,
				organisationContextService,
				$http,
				siteUrl,
				enums) {

				var ctx = organisationContextService.getContext();
				var currentSubscriptionUnitClientId = ctx.currentSubscriptionUnit.client.id;
				var defaultSearchParams = {
					numPerPage: 25,
					currentPage: 1,
					term: "",
					sortAsc: false,
					sortField: "DateTimeAdded"
				};

				var getDefaultSearchParams = function() {
					return defaultSearchParams;
				};

				var search = function (searchData) {
					return recipeResource.search({
						id: searchData.id || currentSubscriptionUnitClientId,
						term: searchData.term || "",
						currentPage: searchData.currentPage,
						numPerPage: searchData.numPerPage,
						sortAsc: searchData.sortAsc ? searchData.sortAsc : false,
						sortField: searchData.sortField ? searchData.sortField : "DateTimeAdded",
						paginate: searchData.paginate,
						onlyPublished: searchData.onlyPublished,
						servicePeriodId: searchData.servicePeriodId
					}).$promise;
				};

				var getRecipesUnderOrOverFoodCostTarget = function (searchData) {
					return recipeResource.getRecipesUnderOrOverFoodCostTarget({
						id: searchData.id || currentSubscriptionUnitClientId,
						currentPage: searchData.currentPage,
						numPerPage: searchData.numPerPage,
						sortAsc: searchData.sortAsc ? searchData.sortAsc : false,
						sortField: searchData.sortField ? searchData.sortField : "DateTimeAdded",
						paginate: searchData.paginate,
						belowTargetMargin: searchData.belowTargetMargin,
						aboveTargetMargin: searchData.aboveTargetMargin
					}).$promise;
				};

				var deleteRecipe = function(recipe) {
					return recipeResource.deleteRecipe({ id: recipe.id }).$promise;
				};

				var checkIfSuggestedAllergensDifferFromConfirmed = function(recipeIds) {
					var dto = {
						recipeIds: recipeIds
					};
					return recipeResource.checkIfSuggestedAllergensDifferFromConfirmed(dto).$promise;
				};

				var publishAndUnpublishInBulk = function(recipesToPublish, recipesToUnpublish) {
					var dto = {
						recipesToPublish: _.pluck(recipesToPublish, "id"),
						recipesToUnpublish: _.pluck(recipesToUnpublish, "id")
					};
					return recipeResource.publishAndUnpublishInBulk(dto).$promise;
				};

				var get = function (clientId, recipeId) {
					clientId = clientId || currentSubscriptionUnitClientId;
                    return recipeResource.get({ clientId: clientId, recipeId: recipeId }).$promise;
				};

				var save = function(recipe) {
					recipe.clientId = currentSubscriptionUnitClientId;
					return recipeResource.saveRecipe(recipe).$promise;
				};

                var saveLabelSize = function(saveLabelRequest) {
                    saveLabelRequest.clientId = currentSubscriptionUnitClientId;
                    return recipeResource.saveLabelSize(saveLabelRequest).$promise;
                }

				var getRecipeCost = function(recipeId) {
					return recipeResource.getRecipeCost({ id: recipeId });
				};

				var saveIngredient = function (request) {
					var url = siteUrl() + "api/ingredient";
					return $http.post(url, request);
				}

				var copyRecipe = function(recipeId, clientId) {
					var url = siteUrl() + "api/recipe/" + recipeId + "/copy";
					return $http.post(url,
						{
							clientId: clientId
						});
				}

				var getUnitsThatLoggedInUserCanCreateRecipeFor = function() {
					var url = siteUrl() +
                        "api/client-units?permissionType=" + enums.permissionTypes.BEAGLE_CREATE_WIMD_RECIPES +
                        "&procurementSubscriptionId=" + ctx.currentSubscriptionUnit.procurementSubscriptionId;
					return $http.get(url);
				}

				var getSuitableFors = function() {
					var url = siteUrl() + "api/suitable-fors";
					return $http.get(url);
				}

				var copyRecipes = function(recipeIds, clientId) {
					var url = siteUrl() + "api/recipe/copy-recipes";
					return $http.post(url, { clientId: clientId, recipeIds: recipeIds });
				}

				return {
					copyRecipe: copyRecipe,
					copyRecipes: copyRecipes,
					get: get,
					getRecipeCost: getRecipeCost,
					getRecipesUnderOrOverFoodCostTarget: getRecipesUnderOrOverFoodCostTarget,
					getSuitableFors: getSuitableFors,
					save: save,
                    saveLabelSize: saveLabelSize,
					getDefaultSearchParams: getDefaultSearchParams,
					search: search,
					delete: deleteRecipe,
					checkIfSuggestedAllergensDifferFromConfirmed: checkIfSuggestedAllergensDifferFromConfirmed,
					publishAndUnpublishInBulk: publishAndUnpublishInBulk,
					saveIngredient: saveIngredient,
					getUnitsThatLoggedInUserCanCreateRecipeFor: getUnitsThatLoggedInUserCanCreateRecipeFor
				};
			}
		]);

angular.module(appName)
	.controller("recipesUnderOverTargetController",
		[
			"$scope",
			"$rootScope",
			"$q",
			"$translate",
			"paginationFactory",
			"localStorageService",
			"recipeService",
			"organisationContextService",
			"userService",
			"publishRecipeService",
			"ngDialog",
			"enums",
			"$location",
			function(
				$scope,
				$rootScope,
				$q,
				$translate,
				paginationFactory,
				localStorageService,
				recipeService,
				organisationContextService,
				userService,
				publishRecipeService,
				ngDialog,
				enums,
				$location) {

				var self = this;

				self.updatePagination = function(pagination) {
					var sortOn = $scope.sortOn;
					var sortField = sortOn ? sortOn.column : "DateTimeAdded";
					var sortDirection = sortOn ? sortOn.sortState === "Ascending" ? true : false : true;
					$scope.pagination.belowTargetMargin = $scope.belowOrAbove === "BELOW" ? true : null;
					$scope.pagination.aboveTargetMargin = $scope.belowOrAbove === "ABOVE" ? true : null;
					$scope.pagination.id = $scope.context.currentSubscriptionUnit.client.id;
					$scope.pagination.numPerPage = pagination.numPerPage;
					$scope.pagination.currentPage = pagination.currentPage;
					$scope.pagination.sortAsc = sortDirection;
					$scope.pagination.sortField = sortField;
				};

				$scope.context = organisationContextService.getContext();

				$scope.recipeListContainsAtLeastOneUnpriced = function () {
					if (!$scope.recipes || !$scope.recipes.length) {
						return false;
					}
					for (var i = 0; i < $scope.recipes.length; i++) {
						if ($scope.recipes[i].isUnpriced) {
							return true;
						}
					}
					return false;
				}

				$scope.search = function(forceToFirstPage) {
					if (forceToFirstPage) {
						$scope.pagination.currentPage = 1;
					}
					self.updatePagination($scope.pagination);
					return recipeService.getRecipesUnderOrOverFoodCostTarget($scope.pagination).then(function (model) {
						$scope.pagination.total = model.total;
						$scope.recipes = model.results;
						$scope.pagination.id = null;
						// We don't want to be storing the clientId in the local storage.
						localStorageService.setItem($rootScope.$enums.localStorage.recipeSearch, $scope.pagination);
					});
				};

				$scope.deleteRecipe = function(recipe) {
					return recipeService.delete(recipe).then(function() {
						$scope.recipes.remove(recipe);
						$translate("recipe_deleted").then(function(t) {
							toastr.success(t);
						});
					});
				};

				$scope.generateRecipeUrl = function (recipe) {
					return "/Recipes/view/{0}".format(recipe.id);
				};

				$scope.$on($rootScope.$enums.eventNames.sortOnElementChangedEventName,
					function(event) {
						self.updatePagination($scope.pagination);
						if (event.targetScope === $scope) {
							$scope.search();
						};
					});

				var getBelowOrAbove = function () {
					return $location.$$path == "/RecipesBelowMargin" ? "BELOW" : "ABOVE";
				}

				var init = function () {
					$scope.belowOrAbove = getBelowOrAbove();
					paginationFactory.addPaginationVariablesAndFunctionsToScope($scope, 20);
					$scope.$on(enums.paginationChanged,
						function() {
						});
					$scope.$watchGroup(["pagination.currentPage + pagination.numPerPage"],
						function () {
							if ($scope.pagination &&
								$scope.pagination.currentPage &&
								$scope.pagination.numPerPage) {
								$scope.search();
							}
						});
				}
				init();
			}
		]);
angular.module(appName)
	.controller("unitRecipesController",
		[
			"$scope",
			"$rootScope",
			"$q",
			"$translate",
			"paginationFactory",
			"localStorageService",
			"recipeService",
			"organisationContextService",
			"userService",
			"publishRecipeService",
			"ngDialog",
			"enums",
			function(
				$scope,
				$rootScope,
				$q,
				$translate,
				paginationFactory,
				localStorageService,
				recipeService,
				organisationContextService,
				userService,
				publishRecipeService,
				ngDialog,
				enums) {

				var self = this;

				self.updatePagination = function(pagination) {
					var sortOn = $scope.sortOn;
					var sortField = sortOn ? sortOn.column : "DateTimeAdded";
					var sortDirection = sortOn ? sortOn.sortState === "Ascending" ? true : false : true;

					$scope.pagination.id = $scope.context.currentSubscriptionUnit.client.id;
					$scope.pagination.numPerPage = pagination.numPerPage;
					$scope.pagination.currentPage = pagination.currentPage;
					$scope.pagination.term = pagination.term;
					$scope.pagination.sortAsc = sortDirection;
					$scope.pagination.sortField = sortField;
				};
				self.setPublishPropertiesOnRecipes = function(recipes) {
					angular.forEach(recipes,
						function(recipe) {
							recipe.isOriginallyActive = recipe.activeDish;
						});
				};
				self.resetActiveDishPropertyOnRecipes = function(recipes) {
					angular.forEach(recipes,
						function(recipe) {
							recipe.activeDish = recipe.isOriginallyActive;
						});
				};


				$scope.context = organisationContextService.getContext();
				$scope.isAdminUser = localStorageService.getItem($rootScope.$enums.localStorage.isAdminUser);
				$scope.bulkPublishUnpublish = {
					recipesToPublish: [],
					recipesToUnpublish: [],
					enabled: false,
					showingDialog: false,
					loadingAllergenConfirmation: null,
					disclaimerTicked: false,
					showDialog: function () {
						var dialog = this;
						publishRecipeService.publishRecipes({
							recipesToPublish: $scope.bulkPublishUnpublish.recipesToPublish,
							recipesToUnpublish: $scope.bulkPublishUnpublish.recipesToUnpublish
						}).then(function() {
							self.setPublishPropertiesOnRecipes($scope.recipes);
							dialog.recipesToPublish = [];
							dialog.recipesToUnpublish = [];
							$scope.bulkPublishUnpublish.enabled = false;
							});
						return;
					}
				};

				$scope.recipeListContainsAtLeastOneUnpriced = function () {
					if (!$scope.recipes || !$scope.recipes.length) {
						return false;
					}
					for (var i = 0; i < $scope.recipes.length; i++) {
						if ($scope.recipes[i].isUnpriced) {
							return true;
						}
					}
					return false;
				}

				$scope.addRemoveRecipeForPublishUnpublish = function(recipe) {
					// Publishing recipe
					if (recipe.activeDish) {
						if (!recipe.isOriginallyActive) {
							_.pushIfNotExists($scope.bulkPublishUnpublish.recipesToPublish, recipe);
						}
						// TODO: Add to publish array.

						_.removeIfExists($scope.bulkPublishUnpublish.recipesToUnpublish, recipe);
					} else {
						// Unpublishing recipe
						if (recipe.isOriginallyActive) {
							_.pushIfNotExists($scope.bulkPublishUnpublish.recipesToUnpublish, recipe);

						}
						// TODO: Remove from publish array / Add to unpublish array
						_.removeIfExists($scope.bulkPublishUnpublish.recipesToPublish, recipe);
					}
				};

				var activeStates = null;
				$scope.toggleBulkPublish = function() {
					$scope.bulkPublishUnpublish.enabled = !$scope.bulkPublishUnpublish.enabled;
					if ($scope.bulkPublishUnpublish.enabled) {
						activeStates = _.map($scope.recipes,
							function(r) {
								return {id:r.id, activeDish:r.activeDish}
							});
						activeStates = angular.copy(activeStates);
					}
					// We are cancelling bulk publish - Reset the arrays
					if (!$scope.bulkPublishUnpublish.enabled) {
						$scope.bulkPublishUnpublish.recipesToPublish = [];
						$scope.bulkPublishUnpublish.recipesToUnpublish = [];
						self.resetActiveDishPropertyOnRecipes($scope.recipes);
					}
				};

				var copyingRecipeMessage, copiedRecipeMessage;
				var getTranslations = function () {
					$translate(['copying_recipes', 'recipes_copied']).then(function (result) {
						copyingRecipeMessage = result['copying_recipes'];
						copiedRecipeMessage = result['recipes_copied'];
					});
				}
				$scope.copyRecipes = function() {
					var dialog = ngDialog.open(
						{
							template: "ngxbeagle/dist/Content/js/Modules/Recipes/Shared/copyRecipe.html",
							controller: "copyRecipeController",
							disableAnimation: true,
							showClose: false,
							data: {
								recipe: $scope.recipe
							}
						}
					);
					dialog.closePromise.then(function (response) {
						if (response.value && response.value !== '$document') {
							$scope.copyingRecipes = true;
							toastr.success(copyingRecipeMessage);
							recipeService.copyRecipes(_.pluck($scope.selectedRecipes(), 'id'), response.value).then(function () {
								toastr.success(copiedRecipeMessage);
							}).finally(function () {
								$scope.copyingRecipes = false;
								$scope.search();
							});
						}
					});
				}

				$scope.selectedRecipes = function () {
					if (!$scope.recipes) {
						return[];
					}
					return _.filter($scope.recipes, { isSelected: true });
				}

				$scope.cancelBulkPublish = function () {
					_.each(activeStates,
						function(s) {
							var recipe = _.find($scope.recipes,
								function(r) {
									return r.id === s.id;
								});
							recipe.activeState = s.activeState;
						});
					$scope.toggleBulkPublish();
				}

				$scope.generateRecipeUrl = function(recipe) {
					return "/Recipes/view/{0}".format(recipe.id);
				};

				$scope.clearSearch = function() {
					self.updatePagination(recipeService.getDefaultSearchParams());

					return $scope.search();
				};

				$scope.search = function(forceToFirstPage) {
					if (forceToFirstPage) {
						$scope.pagination.currentPage = 1;
					}
					self.updatePagination($scope.pagination);
					return recipeService.search($scope.pagination).then(function (model) {
						$scope.pagination.total = model.total;
						$scope.recipes = model.results;
						$scope.pagination.id = null;
						// We don't want to be storing the clientId in the local storage.
						localStorageService.setItem($rootScope.$enums.localStorage.recipeSearch, $scope.pagination);
						angular.forEach($scope.recipes,
							function(recipe) {
								recipe.isOriginallyActive = recipe.activeDish;
								// Doing this manually as we also need to compare with our bulk (un)publish
								var recipeIsToPublish = _.find($scope.bulkPublishUnpublish.recipesToPublish,
									function(r) { return r.id == recipe.id });
								if (recipeIsToPublish) {
									recipe.activeDish = true;
								}

								var recipeIsToUnpublish = _.find($scope.bulkPublishUnpublish.recipesToUnpublish,
									function(r) { return r.id == recipe.id });
								if (recipeIsToUnpublish) {
									recipe.activeDish = false;
								}
							});
						self.setPublishPropertiesOnRecipes($scope.recipes);
					});
				};

				$scope.deleteRecipe = function(recipe) {
					return recipeService.delete(recipe).then(function() {
						$scope.recipes.remove(recipe);
						$translate("recipe_deleted").then(function(t) {
							toastr.success(t);
						});
					});
				};

				$scope.$on($rootScope.$enums.eventNames.sortOnElementChangedEventName,
					function(event) {
						self.updatePagination($scope.pagination);
						if (event.targetScope === $scope) {
							$scope.search();
						};
					});

				var init = function () {
					getTranslations();
					$scope.userPermissions = {
						BEAGLE_PUBLISH_UNPUBLISH_WIMD_RECIPES: false
					};

					userService.hasPermission("BEAGLE_PUBLISH_UNPUBLISH_WIMD_RECIPES").then(function () {
						$scope.userPermissions.BEAGLE_PUBLISH_UNPUBLISH_WIMD_RECIPES = true;
					});
					$scope.pagination = localStorageService.getItem($rootScope.$enums.localStorage.recipeSearch);
					paginationFactory.addPaginationVariablesAndFunctionsToScope($scope);
					$scope.$on(enums.paginationChanged,
						function() {
						});
					$scope.$watchGroup(["pagination.currentPage + pagination.numPerPage"],
						function () {
							if ($scope.pagination &&
								$scope.pagination.currentPage &&
								$scope.pagination.numPerPage) {
								$scope.search();
							}
						});
				}
				init();
			}
		]);

angular.module(appName)
	.controller("downloadRecipeCardController",
	[
		"$scope",
		function ($scope) {
			$scope.recipe = $scope.ngDialogData.recipe;
		}
	]);
/**
 * http://stackoverflow.com/a/10364620/3636177 - Mobile detection technique
 *
 */

angular.module(appName)
	.directive("ingredientSearchAdditionalProducts",
		function() {
			var controller = [
				"$scope", "$element", "$attrs", "$timeout", "_", "validationHelper", "enums", "productSearchService",
				function($scope, $element, $attrs, $timeout, _, validationHelper, enums, productSearchService) {
					var self = this;
					self.elements = {
						self: $element,
						parent: $element.parent(),
						next: $element.next(),
						section: angular.element("section"),
						body: angular.element("body"),
						bodyWrapper: angular.element(document.querySelector("#body-wrapper"))
					};
					$scope.validationHelper = validationHelper;
					$scope.packTypeEnum = enums.packTypes;
					$scope.mobile = validationHelper.isMobile();

					// Add the root class to our parent so that we can style our elements
					$element.addClass("additional-products-root");
					$element.addClass("additional-products-animate");

					self.setElementStyles = function(show) {
						if (show) {
							/* Showing Products */
							if ($scope.mobile) {
								/* Showing Products - Mobile */
								$element.css({
									top: 0,
									width: "100%",
									height: "100%",
									right: "0%",
									maxHeight: "none",
									maxWidth: "none",
									position: "fixed",
									backgroundColor: self.elements.section.css("background-color"),
								});
							} else {
								/* Showing Products - Desktop */
								$element.css({
									padding: "",
									height: ""
								});
								self.elements.next.css({
								});
								// self.elements.bodyWrapper.css({ overflow: '' });
							}
						} else {
							/* Hiding Products */
							if ($scope.mobile) {
								/* Hiding Products - Mobile */
								$element.css({
									right: "-100%",
									maxWidth: "none",
									position: ""
								});
								self.elements.next.css({
									width: "100%",
									float: "none"
								});
							} else {
								/* Hiding Products - desktop */
								$element.css({
									height: 0,
								});
								self.elements.next.css({
									width: "100%"
								});
								self.elements.bodyWrapper.css({ overflow: "" });
							}
						}
					};

					// Extra function to call parent isBestPrice function from JS as HTML is unreliable
					$scope.callIsBestPrice = function(product) {
						return productSearchService.isBestPrice(product);
					};

					var resizeTimeout;
					window.addEventListener("resize",
						function() {
							clearTimeout(resizeTimeout);
							resizeTimeout = setTimeout(function() {
									$scope.mobile = validationHelper.isMobile();
								},
								100);
						});

					$scope.callToggle = function($event, forceClose) {
						if (forceClose) {
							self.setElementStyles(false);
							// self.elements.bodyWrapper.css({ overflow: '' });
						}
						$scope.toggle($event);
					};

					$scope.$watch("show",
						function(newValue, oldValue) {
							self.setElementStyles(newValue);
							if (newValue && validationHelper.isMobile()) {
								// self.elements.bodyWrapper.css({ overflow: 'hidden', position: 'relative' });
							} else {
								// self.elements.bodyWrapper.css({ overflow: '' });
							}
						});
				}
			];

			return {
				restrict: "E",
				scope: {
					data: "=",
					toggle: "&",
					show: "=",
					addToBasket: "&",
					isBestPrice: "&",
					toggleFavourite: "&",
					isOrderableBasket: "=",
					threeDp: "&"
				},
				templateUrl: "/ngxbeagle/dist/Content/js/modules/recipes/viewEditRecipe/ingredientSearchAdditionalProducts.html",
				controller: controller
			};
		});

angular.module(appName)
	.controller("recipeFavouriteDepartmentController",
		[
			"$scope",
			function ($scope) {
				$scope.model = {
					selectedDepartments: $scope.ngDialogData.selectedDeptsForFavouriting
				};
				$scope.availableDepartments = $scope.ngDialogData.availableDepartments;
				$scope.confirmSelectedDepartments = function() {
					$scope.closeThisDialog($scope.model.selectedDepartments);
				}
			}
		]);
angular.module(appName)
	.controller("saveSelectedIngredientController",
		[
			"$scope",
			"factoredMeasuresService",
			"allergenService",
			"enums",
			"organisationContextService",
			"recipeService",
			"$q",
			"ingredientService",
			"$routeParams",
			"$window",
			"$translate",
			function(
				$scope,
				factoredMeasuresService,
				allergenService,
				enums,
				organisationContextService,
				recipeService,
				$q,
				ingredientService,
				$routeParams,
				$window,
			    $translate) {
				$scope.measureChanged = function () {
					var i = $scope.ingredient;
					if (!i) {
						return;
					}
					_.defer(function() {
						factoredMeasuresService.calculateIngredientFactor(i.originalItemMeasureId,
							i.measureId,
							i.originalItemQuantity,
                            i.originalItemPackQuantity,
                            i.originalItemCaseQuantity,
							i.quantity).then(
							function (result) {
								i.factor = result;
							});
					});

					return;
				};
                $scope.nutrientWarningMessageKey = 'null';

				$scope.factoredPrice = function() {
					var ingredient = $scope.ingredient;
					if (ingredient && ingredient.quantity && ingredient.yield) {
						var factor = ingredient.factor || ingredient.manualFactor;
						var price = ingredient.price;
						var factoredPrice = price / (ingredient.yield * 0.01) * factor;
						return factoredPrice.toFixed(2);
					}
					return null;
				};

				var ingredientSavedMessage;
				var getTranslations = function() {
				    $translate('ingredient_saved').then(function(t) {
						ingredientSavedMessage = t;
					});
				};

				var saveIngredient = function() {
					var i = $scope.ingredient;
					var saveRequestDto = {
						id: i.id,
						name: i.name,
						recipeId: i.recipeId,
						productId: i.entityType == "Product" ? i.productId : null,
						skuId: i.entityType == "Sku" ? i.skuId : null,
						subRecipeId: i.entityType == "SubRecipe" ? i.subRecipeId : null,
						quantity: i.quantity,
						measureId: i.measureId,
						factor: i.factor || i.manualFactor,
						yield: i.yield,
						price: i.price,
						factoredPrice: $scope.factoredPrice(),
						originalItemPackQuantity: i.originalItemPackQuantity,
						originalItemQuantity: i.originalItemQuantity,
                        isUnpriced: i.isUnpriced
					};
					var promise = recipeService.saveIngredient(saveRequestDto);
					promise.then(function(result) {
						i.id = result.data;
						if ($routeParams.ingredientId) {
							var newUrl = "Recipes/view/" + i.recipeId + "/ingredients/" + i.id;
							$location.path(newUrl).replace();
						}
						toastr.success(ingredientSavedMessage);
					});
					return promise;
				};

				$scope.saveIngredientAndContinue = function() {
					saveIngredient().then(function() {
						$scope.closeThisDialog();
					});
				};

				$scope.saveIngredientAndReturn = function() {
					saveIngredient().then(function() {
						if ($scope.closeThisDialog) {
							$scope.closeThisDialog();
						}
						var newUrl = "/Recipes/view/" + $scope.ingredient.recipeId;
						$window.location.href = newUrl;
					});
				};

				$scope.cancel = function() {
					if ($scope.closeThisDialog) {
						$scope.closeThisDialog();
					}
					if (!$scope.ngDialogData) {
						var newUrl = "/Recipes/view/" + $scope.ingredient.recipeId;
						$window.location.href = newUrl;
					}
				}

				var getIngredient = function() {
					var deferred = $q.defer();
					if ($scope.ngDialogData) {
						var ingredient = $scope.ngDialogData.addIngredientDto;
						deferred.resolve(ingredient);
					} else {
						ingredientService.get($routeParams.ingredientId).then(function(result) {
							var i = result.data;
							if (i.factor) {
								i.manualFactor = i.factor;
							}
							deferred.resolve(i);
						});
					}
					return deferred.promise;
				};

				var getIngredientAllergenStatus = function() {
					var i = $scope.ingredient;
					var promise;
					switch (i.entityType) {
					case "Sku":
						promise = allergenService.getSkuIngredientAllergenStatus(i.skuId);
						break;
					case "Product":
						promise = allergenService.getProductIngredientAllergenStatus(i.productId);
						break;
					case "SubRecipe":
						promise = allergenService.getSubRecipeIngredientAllergenStatus(i.subRecipeId);
						break;
					default:
						throw "Unknown entity type: '" + i.entityType + "'";
					}
					promise.then(function(result) {
						$scope.haveAllergensBeenSpecified = result.data == enums.ingredientAllergenStatus.allergenInformationDefined;
					});
				};

				var getSuggestedAllergensForIngredient = function() {
					var i = $scope.ingredient;
					var entityId = i.entityType == 'Product' ? i.productId : i.entityType == 'Sku' ? i.skuId : i.subRecipeId;
					var context = organisationContextService.getContext();
					var clientUnitId = context.currentSubscriptionUnit.client.id;
					allergenService.getSuggestedAllergensForIngredient(entityId, i.entityType, clientUnitId).then(
						function(result) {
							$scope.suggestedAllergens = result.data;
						});
				};

				var init = function () {
                    getTranslations();
					var recipeId = $routeParams.id;
					var recipePromise = recipeService.get(null, recipeId);
					var ingredientPromise = getIngredient();
					recipePromise.then(function(result) {
						$scope.recipeLite = result.recipe.recipeLite;
					});
					ingredientPromise.then(function (ingredient) {
						$scope.ingredient = ingredient;
						$scope.measureChanged();
						getIngredientAllergenStatus();
						getSuggestedAllergensForIngredient();
					});
					$q.all([recipePromise, ingredientPromise]).then(function() {
						$scope.initComplete = true;
					});
				};
				init();
			}
		]);

angular.module(appName)
	.controller("searchRecipeIngredientsController",
		[
			"$scope",
			"$filter",
			"$routeParams",
			"$q",
			"productSearchService",
			"basketService",
			"basketStore",
			"enums",
			"paginationService",
			"autoFocus",
			"validationHelper",
			"$translate",
			"organisationContextService",
			"ngDialog",
			"recipeService",
			"ingredientService",
			"$location",
			"clientUnitDepartmentService",
			"productFavouriteService",
			"skuFavouriteService",
			"$cookies",
			function(
				$scope,
				$filter,
				$routeParams,
				$q,
				productSearchService,
				basketService,
				basketStore,
				enums,
				paginationService,
				autoFocus,
				validationHelper,
				$translate,
				organisationContextService,
				ngDialog,
				recipeService,
				ingredientService,
				$location,
				clientUnitDepartmentService,
				productFavouriteService,
				skuFavouriteService,
				$cookies
			) {
				var self = this;
				var recipeId = $routeParams.id;
				$scope.recipeId = recipeId;
				self.context = organisationContextService.getContext();
				autoFocus.implementForElementWithId("product-search");
				$scope.mobile = validationHelper.isMobile();
				$scope.showFilter =
					!$scope.mobile; // If mobile is true, we don't want to show by default. This needs to default to the opposite of $scope.mobile.
				$scope.productSearchResultsEnum = enums.productSearchResults;
				$scope.packTypeEnum = enums.packTypes;
				$scope.productData = {
					term: "",
					searchType: enums.productSearchTypes.bestPrice,
					getNoOfRecipesItemIsUsedIn:true,
          recipeId: recipeId
				};
				$scope.searchTypes = [
          {
						key: "label_sku",
						id: "searchsku",
						value: enums.productSearchTypes.sku
          },
          {
            key: "sub_recipe",
            id: "searchsubrecipe",
            value: enums.productSearchTypes.subRecipe
          }
        ];
				$scope.enums = enums;

				$scope.basketStore = basketStore;
				self.oldTerm = "";
				$scope.basket = null;

				self.setNullPropertiesForEqualityChecks = function(basketItem) {
					// If the properties don't exist, set them to 0 so we can do an equality check
					if (!basketItem.catchWeight) basketItem.catchWeight = null;
					if (!basketItem.skuId) basketItem.skuId = null;
				};
				self.itemsAreUnique = function(itemOne, itemTwo) {
					self.setNullPropertiesForEqualityChecks(itemOne);
					self.setNullPropertiesForEqualityChecks(itemTwo);
					return itemOne.skuId != itemTwo.skuId && itemOne.catchWeight != itemTwo.catchWeight;
				};
				self.itemExistsInBasket = function(basketItem) {
					return _.findWhere($scope.basket.basketItems, { catchWeight: basketItem.catchWeight, skuId: basketItem.skuId });
				};

				$scope.setProductSearchType = function (searchType, resetFilters) {
					if (searchType) {
						$scope.productData.searchType = searchType;
					} else {

						$scope.productData.searchType = _.findWhere($scope.searchTypes, { value: $scope.productData.searchTypeEnum });;
					}

					if (resetFilters) {
						$scope.productData.filters = [];
					}
				};
				// Defaults the searchtype to the first searchtype that we have. This may be overwritten later.
				$scope.setProductSearchType($scope.searchTypes[0]);

				$scope.searchTermIsDirty = function(term) {
					return self.oldTerm ? self.oldTerm.toLowerCase() != term.toLowerCase() : false;
				};

				$scope.getAdditionalProducts = function($event, product) {
					$scope.additionalProducts = {};
					product.loadingAdditionalProducts = true;
					var additionalProductsToClose = _($scope.productData.results.items).findWhere({ showAdditionalProducts: true });
					if (additionalProductsToClose != null && additionalProductsToClose.showAdditionalProducts == true) {
						additionalProductsToClose.showAdditionalProducts = false;
						if (additionalProductsToClose[0] != product[0]) {
							product.showAdditionalProducts = true;
						}
					} else {
						product.showAdditionalProducts = true;
					}

					if (product.showAdditionalProducts) {
						var searchData = angular.copy($scope.productData);
						searchData.organisationId = self.context.currentSubscriptionUnit.organisation.id;
						searchData.productId = product[enums.productSearchResults.productId];

						if (searchData.searchTypeEnum == enums.productSearchTypes.bestPrice) {
							searchData.skuId = product[enums.productSearchResults.bestPriceSkuId];
						}

						productSearchService.getAdditionalProducts(searchData).$promise.then(function(additionalProducts) {
								$scope.additionalProducts = additionalProducts;
								product.loadingAdditionalProducts = false;
							},
							function() {
								$translate("error_additional_products").then(function(translation) {
									toastr.error(translation);
								});
								product.loadingAdditionalProducts = false;
							});
					} else {
						product.loadingAdditionalProducts = false;
					}
				};

				$scope.clearFilters = function() {
					$scope.productData.filters = [];
				};

				$scope.set3dp = function(input) {
					if (input != null && input != "") {
						if (isNaN(parseFloat(input))) {
							input = null;
							$translate("error_please_enter_valid_number").then(function(t) {
								toastr.error(t);
								return input;
							});
						} else {
							input = parseFloat(input).toFixed(3);
							return input;
						}
					}
				};


				$scope.search = function(form, performFormValidation) {
					if (performFormValidation) {
						if (form.term.$dirty) {
							$scope.productData.term = form.term.$modelValue;
							$scope.productData.filters = [];
						}
					}

					$scope.productData.searchTypeEnum = $scope.productData.searchType.value;
					$scope.loading = true;
					productSearchService.search($scope.productData).$promise.then(function (data) {
						if (data && data.results && data.results.items) {
							var searchTypeId = $scope.productData.searchType.id;
							var entityType = searchTypeId == 'searchbestprice'
								? 'Product'
								: searchTypeId == 'searchsku'
								? 'Sku'
								: 'SubRecipe';
								_.each(data.results.items,
									function(i) {
										i.yield = 100;
										i.entityType = entityType;
									});
							}
							$scope.productData.results = data.results;
							//This is to hit the watch in paginate
							if (data.results == null) {
								$scope.productData.results = {};
								$scope.productData.results.items = [];
							}
							if (!$scope.productData.filters.length) {
								$scope.productData.filters = data.filters;
							}

							$scope.$broadcast('updateFilterDirective');

						if (data.results == null || data.results.length === 0) {
								$scope.items = null;
							}

							$scope.setProductSearchType();

							$scope.loading = false;
						},
						function () {
							$scope.productData.results = null;
						}).finally(function () {
							$scope.loading = false;
							form.term.$setPristine();
						});
				};
				$scope.sort = function() {
					$scope.productData.results.items = $filter("orderBy")($scope.productData.results.items, $scope.sortOn.filterExpr);
				};

				$scope.isBestPrice = function(product) {
					return productSearchService.isBestPrice(product);
				};
				$scope.toggleFilter = function() {
					$scope.showFilter = !$scope.showFilter;
				};

				var addFavouriteFlagToUi = function (product, favouriteId) {
					product.favouriteId = favouriteId;
					product[$scope.productSearchResultsEnum.favouriteId] = favouriteId;

					var searchType = $scope.productData.searchType.id;
					if (searchType === "searchsku") {
						var skuId = product.bestPriceSkuId ? product.bestPriceSkuId : product[$scope.productSearchResultsEnum.bestPriceSkuId];

						if ($scope.additionalProducts && $scope.additionalProducts.length) {
							_.each($scope.additionalProducts[0].results, function (p) {
								if (p.bestPriceSkuId === skuId) {
									p.favouriteId = favouriteId;
								}
							});
						}
						_.each($scope.productData.results.items, function (p) {
							if (p[$scope.productSearchResultsEnum.bestPriceSkuId] === skuId) {
								p.favouriteId = favouriteId;
								p[$scope.productSearchResultsEnum.favouriteId] = favouriteId;
							}
						});

					} else {
						var productId = product.id ? product.id : product[0];
						if ($scope.additionalProducts && $scope.additionalProducts.length) {
							_.each($scope.additionalProducts[0].results, function (p) {
								if (p.id === productId) {
									p.favouriteId = favouriteId;
								}
							});
						}
						_.each($scope.productData.results.items, function (p) {
							if (p[0] === productId) {
								p.favouriteId = favouriteId;
								p[$scope.productSearchResultsEnum.favouriteId] = favouriteId;
							}
						});
					}
				};

				var deleteFavouriteFlagFromUi = function (product) {
					delete product.favouriteId;
					delete product[$scope.productSearchResultsEnum.favouriteId];

					var searchType = $scope.productData.searchType.id;
					if (searchType === "searchsku") {
						var skuId = product.bestPriceSkuId ? product.bestPriceSkuId : product[$scope.productSearchResultsEnum.bestPriceSkuId];
						if ($scope.additionalProducts && $scope.additionalProducts.length) {
							_.each($scope.additionalProducts[0].results, function (p) {
								if (p.bestPriceSkuId === skuId) {
									delete p.favouriteId;
								}
							});
						}
						_.each($scope.productData.results.items, function (p) {
							if (p[$scope.productSearchResultsEnum.bestPriceSkuId] === skuId) {
								delete p.favouriteId;
								delete p[$scope.productSearchResultsEnum.favouriteId];
							}
						});
					} else {
						var productId = product.id ? product.id : product[0];
						if ($scope.additionalProducts && $scope.additionalProducts.length) {
							_.each($scope.additionalProducts[0].results, function (p) {
								if (p.id === productId) {
									delete p.favouriteId;
								}
							});
						}
						_.each($scope.productData.results.items, function (p) {
							if (p[0] === productId) {
								delete p.favouriteId;
								delete p[$scope.productSearchResultsEnum.favouriteId];
							}
						});
					}
				};

				var selectDepartmentForFavourite = function () {
					var deferred = $q.defer();
					var dialog = ngDialog.open(
						{
							template: "ngxbeagle/dist/Content/js/Modules/Recipes/ViewEditRecipe/recipeFavouriteDepartment.html",
							controller: "recipeFavouriteDepartmentController",
							disableAnimation: true,
							showClose: false,
							width:'40%',
							data: {
								'availableDepartments': $scope.availableDepartments,
								'selectedDeptsForFavouriting': $scope.selectedDepartmentsForFavouriting
							}
						}
					);
					dialog.closePromise.then(function(result) {
						var value = result.value;
						if (!value || value == '$document') {
							deferred.reject();
							return;
						}
						value.favouriteId = uuid.v4();
						$cookies.putObject(enums.cookies.recipeIngredientFavouriteDepartments, value);
						$scope.selectedDepartmentsForFavouriting = value;
						deferred.resolve();
					});
					return deferred.promise;
				}

				var favouriteItem = function (item, departmentIds) {
					var createFavouritePromise;
					if (item.entityType === "Product" || item.bestPriceSupplierId) {
						var productId = item[0] || item.id;
						createFavouritePromise =
							productFavouriteService.createFavourites(item.favouriteId, productId, departmentIds);
					} else if (item.entityType === "Sku" || item.bestPriceSkuId) {
						var skuId = item[7] || item.bestPriceSkuId;
						createFavouritePromise = skuFavouriteService.createFavourites(item.favouriteId, skuId, departmentIds);
					} else {
						return;
					}
					//CSH 30052018 - Note that we're only deleting the flag if the createFavouritePromise fails. The first argument of 'then'
					//here is null
					createFavouritePromise.then(null,
						function () {
							deleteFavouriteFlagFromUi(product);
						});
				}

				$scope.toggleFavourite = function (item) {
					var favouriteId = item[$scope.productSearchResultsEnum.favouriteId] || item.favouriteId;
					if (favouriteId) {
						productFavouriteService.deleteFavourite(favouriteId).then(null, function () {
							addFavouriteFlagToUi(item, favouriteId);
						});
						deleteFavouriteFlagFromUi(item);
					} else {
						if ($scope.availableDepartments.length == 1) {
							item.favouriteId = uuid.v4();
							addFavouriteFlagToUi(item, item.favouriteId);
							var clientProcurementDepartmentId = $scope.availableDepartments[0].id;
							favouriteItem(item, [clientProcurementDepartmentId]);
						} else {
							selectDepartmentForFavourite().then(function () {
								if (!$scope.selectedDepartmentsForFavouriting.length) {
									return;
								}
								item.favouriteId = uuid.v4();
								addFavouriteFlagToUi(item, item.favouriteId);
								favouriteItem(item, $scope.selectedDepartmentsForFavouriting);
							});
						}
					}
				}

				$scope.shouldShowAdditionalProducts = function(product) {
					return ($scope.mobile && product.showAdditionalProducts && !product.loadingAdditionalProducts) ||
						(!$scope.mobile && product.showAdditionalProducts);
				};

				var createIngredientDtoFromProduct = function(product) {

					var productSearchResultsEnum = enums.productSearchResults;
					return {
						name: product[productSearchResultsEnum.description],
						recipeId: recipeId,
						productId: product[productSearchResultsEnum.productId],
						skuId: product[productSearchResultsEnum.bestPriceSkuId],
						subRecipeId: $scope.productData.searchType.id == "searchsubrecipe" ? product[productSearchResultsEnum.productId] : null,
						quantity: product.quantity,
						pslUom: product[productSearchResultsEnum.unitOfMeasure],
						measureId: product[productSearchResultsEnum.measureId],
                        skuMeasureId: product[productSearchResultsEnum.measureId],
						clientProductId: null,
						originalItemMeasureId: product[productSearchResultsEnum.measureId],
						factor: 1,
						yield: product.yield,
						supplierId: null,
                        isBestPrice: $scope.productData.searchType.id == "searchbestprice",
                        originalItemCaseQuantity: product[productSearchResultsEnum.caseQuantity],
						originalItemPackQuantity: product[productSearchResultsEnum.packQuantity],
						originalItemQuantity: product[productSearchResultsEnum.unit],
						isUnpriced: null,
						price: product[productSearchResultsEnum.price],
						bestPrice: product[productSearchResultsEnum.bestPrice],
						entityType: product.entityType
					};
				};

				var createIngredientDtoFromAlternativeProduct = function (product) {
					var i = angular.copy(product);
					i.name = i.description + ' ' + (i.uom || '');
					i.entityType = i.bestPriceSupplierId ? 'Product' : 'Sku';
					i.productId = i.entityType == 'Product' ? i.id : null;
					i.skuId = i.entityType == 'Sku' ? i.bestPriceSkuId : null;
					i.yield = 100;
					i.originalItemMeasureId = i.measureId;
                    i.skuMeasureId = i.measureId;
					i.recipeId = recipeId;
					i.originalItemCaseQuantity = product.caseQuantity;
					i.originalItemPackQuantity = product.packQuantity;
					i.originalItemQuantity = product.unit;
					delete i.id;
					return i;
				};

				$scope.replaceIngredient = function(product) {
					var dto = createIngredientDtoFromProduct(product);
					var i = $scope.ingredientToReplace;
					i.clientProductId = dto.clientProductId;
					i.entityType = dto.entityType;
					i.factor = dto.factor;
					i.isUnpriced = dto.isUnpriced;
					i.measureId = dto.measureId;
					i.name = dto.name;
					i.originalItemMeasureId = dto.originalItemMeasureId;
					i.originalItemPackQuantity = dto.originalItemPackQuantity;
					i.originalItemQuantity = dto.originalItemQuantity;
					i.price = dto.price;
					i.productId = dto.entityType == 'Product' ? dto.productId : null;
					i.skuId = dto.entityType == 'Sku' ? dto.skuId : null;
					i.subRecipeId = dto.entityType == 'SubRecipe' ? dto.subRecipeId : null;
					i.supplierId = dto.entityType == 'SupplierProduct' ? dto.suppliedId : null;
					recipeService.saveIngredient(i).then(function (result) {
						var newUrl = '/Recipes/view/' + i.recipeId + '/ingredients/' + result.data;
						$location.url(newUrl);
					});
				}

				$scope.addToBasket = function (product) {
					var packTypeId = product[$scope.productSearchResultsEnum.packTypeId] || product.packTypeId;
					if (packTypeId == null) {
						packTypeId = product.packTypeId;
					}

					product.quantity = $scope.set3dp(product.quantity);
					product.catchWeight = product.catchWeight ? $scope.sest3dp(product.catchWeight) : null;

					var qty = product.quantity,
						catchWeight = product.catchWeight,
						decimalError = false;

					//This handles skuSearch AND product Search

					//Changed to allow catch weight with null quantity for shopping lists ~ JP
					if (packTypeId != 2 && validationHelper.isDecimalStrict(parseFloat(qty)) ||
						packTypeId == 2 &&
						validationHelper.isDecimalStrict(parseFloat(qty)) &&
						!validationHelper.isNullOrWhiteSpace(catchWeight)) {
						$translate("error_quantity_cannot_be_decimal").then(function(t) {
							toastr.error(t);
							return;
						});
						decimalError = true;
					}
					if (!decimalError) {
						product.loading = true;

						//make sure the clientSupplierDto is added to the product if an clientSupplierId was returned in the product search
						basketService
							.setClientSupplierDtoOnIndividualProduct(product,
								$scope.availableClientSupplierAccounts);

						// MB: When making any changes around the products we need to be very careful to include Alternative Products as well.
						//     25/03/2019 - Fixed #164861301. Previous factor calculation issue was not carried into Alternative Products.
						var addIngredientDto = product.hasOwnProperty('0')
							? createIngredientDtoFromProduct(product)
							: createIngredientDtoFromAlternativeProduct(product);

						ngDialog.open(
							{
								template: "ngxbeagle/dist/Content/js/Modules/Recipes/ViewEditRecipe/saveSelectedIngredient.html",
								controller: "saveSelectedIngredientController",
								disableAnimation: true,
								showClose: false,
								width: '60%',
								data: {
									addIngredientDto: addIngredientDto
								}
							}
						);

						return;
					}
				};

				self.convertProductToBasketItem = function(product) {
					return basketItem = {
						procurementBasketId: $routeParams.basketId,
						quantity: product.quantity,
						catchWeight: product.catchWeight,
						skuId: product.bestPriceSkuId || product[enums.productSearchResults.bestPriceSkuId],
						ClientSupplierAccountDto: { id: product[enums.productSearchResults.clientSupplierAccountId] },
						packTypeId: product[enums.productSearchResults.packTypeId]
					};
				};

				$scope.productsWithQuantity = function() {
					return _.filter($scope.items,
						function(item) {
							return item.quantity > 0;
						});
				};

				self.setupVariables = function() {
					$scope.mobile = validationHelper.isMobile();
				};
				var resizeTimeout;
				window.addEventListener("resize",
					function() {
						clearTimeout(resizeTimeout);
						resizeTimeout = setTimeout(self.setupVariables(), 100);
					});

				$scope.showGuidingMessage = function() {
					//if you have previously added items to the baket dnt show message
					if ($scope.basketCount > 0) {
						return false;
					} else {
						//if you have searched for something
						if ($scope.productData &&
							$scope.productData.results &&
							$scope.productData.results.items &&
							$scope.productData.results.items.length > 0) {
							//If you have at least one basketItem with quantity non zero then
							if ($scope.items && _.every($scope.items, function(item) { return item.quantity == null })) {
								return true;
							} else {
								return false;
							}
						} else {
							return false;
						}
					}
				};

				var setUpFavouriting = function() {
					clientUnitDepartmentService
						.getClientUnitProcurementDepartmentsForUser(null, null, "eProcurement.DeptKeyValueAndDefaultResponseDto").$promise.then(function (data) {
							$scope.availableDepartments = data;
						});
					$scope.selectedDepartmentsForFavouriting =
						$cookies.getObject(enums.cookies.recipeIngredientFavouriteDepartments) || [];
				}

				$scope.init = function () {
					setUpFavouriting();
					$scope.basketId = $routeParams.basketId;
					var context = organisationContextService.getContext();
					var clientUnitId = context.currentSubscriptionUnit.client.id;
					recipeService.get(clientUnitId, recipeId).then(function(result) {
						$scope.recipeName = result.recipe.recipeName;
					});
					$scope.items = [];
					if ($routeParams.ingredientId) {
						ingredientService.get($routeParams.ingredientId).then(function (result) {
							$scope.ingredientToReplace = result.data;
						});
					}

					$translate($scope.searchTypes[0].key).then(function(translation) {
						$scope.searchTypes[0].name = translation;
					});

					$translate($scope.searchTypes[1].key).then(function(translation) {
						$scope.searchTypes[1].name = translation;
					});
        }();
			}
		]);

angular.module(appName)
	.controller("showIngredientsAssociatedWithAllergenController",
	[
		"$scope",
		function ($scope) {
			$scope.allergenContains = $scope.ngDialogData.ingredients.ingredientsContains;
			$scope.allergenMayContain = $scope.ngDialogData.ingredients.ingredientsMayContain;
			$scope.allergenName = $scope.ngDialogData.allergen.name
		}
	]);
angular.module(appName)
    .controller('viewEditRecipeDetailsController',
        [
            '$scope',
            '$location',
            '$rootScope',
            '$q',
            '$translate',
            '$filter',
            '_',
            'recipeData',
            'labelSizeData',
            'helpers',
            'recipeService',
            'ingredientService',
            'validationHelper',
            'organisationContextService',
            'unitPreferencesService',
            'enums',
            'pslTinymceDefaultOptions',
            'ngDialog',
            'publishRecipeService',
            'localStorageService',
            '$timeout',
            'fileDownloadService',
            'nutrientAttributeHelper',
            function (
                $scope,
                $location,
                $rootScope,
                $q,
                $translate,
                $filter,
                _,
                recipeData,
                labelSizeData,
                helpers,
                recipeService,
                ingredientService,
                validationHelper,
                organisationContextService,
                unitPreferencesService,
                enums,
                pslTinymceDefaultOptions,
                ngDialog,
                publishRecipeService,
                localStorageService,
                $timeout,
                fileDownloadService,
                nutrientAttributeHelper
            ) {
                // $translate.onReady().then(function() {
                var self = this
                var getSuitableFors = function () {
                    recipeService.getSuitableFors().then(function (result) {
                        _.each(result.data, function (sf) {
                            var existsOnRecipe = _.findWhere($scope.recipe.recipeSuitableFors, { id: sf.id })
                            if (existsOnRecipe) {
                                sf.isSelected = true
                            }
                        })
                        $scope.suitableFors = result.data
                    })
                }
                self.resolves = {
                    recipeData: recipeData,
                    labelSizeData: labelSizeData
                }
                self.translationStrings = [
                    'recipe_saved'
                ]
                $translate(self.translationStrings).then(function (translations) {
                    self.translations = translations
                })

                $scope.ctx = organisationContextService.getContext()

                $scope.ingredients = {
                    showIngredientDialog: false,
                    toggleShowIngredientDialog: function () {
                        this.showIngredientDialog = !this.showIngredientDialog
                    },
                    filter: {
                        searchTerm: '',
                        searchType: 'S',
                        recipeId: null
                    },
                    selectIngredient: function (ingredient) {
                        if ($scope.recipe.recipeLite) {
                            this.addIngredientToRecipe(ingredient)
                        }
                    },
                    addIngredientToRecipe: function (ingredient) {
                        ingredient.recipeId = $scope.recipe.id
                        //$scope.recipe.
                        // TODO Need to do backend first
                    },
                    ingredienstData: [],
                    search: function () {
                        var me = this
                        // Make sure recipeId is set - if we came from a create scenario, this may not be set.
                        if (this.filter.recipeId != $scope.recipe.id) this.filter.recipeId = $scope.recipe.id
                        return ingredientService.search(this.filter).then(function (ingredients) {
                            return me.ingredientData = ingredients
                        })
                    }
                }

                $scope.suggestedAllergens = []

                $scope.removeSuitableForFromRecipe = function (suitableFor) {

                    // If the suitableFor has a recipeId then it's a recipesuitableFor and needs us to pick off the suitableForId. Otherwise we can safely use the suitableFor.id
                    var suitableForToRemove = _.findWhere($scope.recipe.recipeSuitableFors,
                        { id: suitableFor.id })
                    if (suitableForToRemove) {
                        _.removeIfExists($scope.recipe.recipeSuitableFors, suitableForToRemove)
                    }
                    var suitableForToUnselect =
                        _.findWhere($scope.suitableFors, { id: suitableForToRemove.id })
                    if (suitableForToUnselect) {
                        suitableForToUnselect.isSelected = false
                    }
                    $scope.recipeChanged()
                }

                $scope.downloadRecipeCard = function () {
                    ngDialog.open(
                        {
                            template: 'ngxbeagle/dist/Content/js/Modules/Recipes/ViewEditRecipe/downloadRecipeCard.html',
                            controller: 'downloadRecipeCardController',
                            disableAnimation: true,
                            showClose: false,
                            data: {
                                recipe: $scope.recipe
                            }
                        }
                    )
                }


                self.getAllergenIngredientNames = function(allergenId, contains, mayContain) {
                    return _.filter($scope.recipe.liveIngredients,
                        function (i) {
                            var result = _.find(i.suggestedAllergens, function (sa) {
                                    return sa.allergenId == allergenId
                                        && sa.contains == contains
                                        && sa.mayContain == mayContain;
                                }) != null;

                            return result
                        }).map(function(i) {
                            return i.name;
                        });
                }

                self.getAllergenIngredients = function(allergenId) {
                    var ingredientsContains = self.getAllergenIngredientNames(allergenId, true, false);
                    var ingredientsMayContain = self.getAllergenIngredientNames(allergenId, false, true);

                    return {ingredientsContains: ingredientsContains, ingredientsMayContain: ingredientsMayContain}
                }

                $scope.showIngredientsAssociatedWithAllergen = function (allergenId) {
                    ngDialog.open(
                        {
                            template:
                                'ngxbeagle/dist/Content/js/Modules/Recipes/ViewEditRecipe/showIngredientsAssociatedWithAllergen.html',
                            controller: 'showIngredientsAssociatedWithAllergenController',
                            disableAnimation: true,
                            showClose: false,
                            data: {
                                ingredients: self.getAllergenIngredients(allergenId),
                                allergen: _.findWhere($scope.availableAllergens, { allergenId: allergenId })
                            }
                        }
                    )
                }

                var copyingRecipeMessage, copiedRecipeMessage, ingredientRemovedMessage
                var getTranslations = function () {
                    $translate(['copying_recipe', 'recipe_copied', 'ingredient_removed']).then(function (result) {
                        copyingRecipeMessage = result['copying_recipe']
                        copiedRecipeMessage = result['recipe_copied']
                        ingredientRemovedMessage = result['ingredient_removed']
                    })
                }

                $scope.copyRecipe = function () {
                    var dialog = ngDialog.open(
                        {
                            template: 'ngxbeagle/dist/Content/js/Modules/Recipes/Shared/copyRecipe.html',
                            controller: 'copyRecipeController',
                            disableAnimation: true,
                            showClose: false,
                            data: {
                                recipe: $scope.recipe
                            }
                        }
                    )
                    dialog.closePromise.then(function (response) {
                        if (response.value && response.value !== '$document') {
                            $scope.copyingRecipe = true
                            toastr.success(copyingRecipeMessage)
                            recipeService.copyRecipe($scope.recipe.id, response.value).then(function () {
                                toastr.success(copiedRecipeMessage)
                            }).finally(function () {
                                $scope.copyingRecipe = false
                            })
                        }
                    })
                }

                $scope.canSaveRecipe = function () {
                    if (!$scope.recipe) {
                        return false
                    }
                    return !$scope.recipe.activeDish
                }

                self.downloadPdf = function(url, type, fileName) {
                    $scope.typeDownloading = $translate.instant(type)
                    $scope.downloadingPdf = true
                    fileDownloadService
                        .downloadFile(url,
                            $scope.recipe.recipeName + '_' + $translate.instant(fileName),
                            'pdf')
                        .then(function () {

                        }).finally(function () {
                        $scope.downloadingPdf = false
                    })
                }

                $scope.downloadSop = function () {
                    var url = '/Api/RecipeTemplate/DownloadSOPRecipe?clientId=' +
                        $scope.ctx.currentSubscriptionUnit.client.id +
                        '&recipeId=' +
                        $scope.recipe.id;
                    self.downloadPdf(url, 'sop', 'sop_download');
                }

                $scope.downloadRecipeCard = function () {
                    var url = '/Api/RecipeTemplate/DownloadRecipeCardRecipe?clientId=' +
                        $scope.ctx.currentSubscriptionUnit.client.id +
                        '&recipeId=' +
                        $scope.recipe.id;
                    self.downloadPdf(url, 'recipe_card', 'recipe_card_download');
                }

                self.showPPDSDialog = function (url, type, fileName) {
                    ngDialog.openConfirm({
                        showClose: false,
                        template: 'ngxbeagle/dist/Content/js/Modules/recipes/ViewEditRecipe/PPDSDownloadDialog.html',
                        data: {
                            recipe: $scope.recipe
                        }
                    }).then(function() {
                        self.downloadPdf(url, type, fileName);
                    });
                }

                $scope.tryDownloadPPDSLabel = function() {
                    var url = '/Api/RecipeTemplate/DownloadPPDSLabel?clientId=' + $scope.ctx.currentSubscriptionUnit.client.id +
                        '&recipeId=' + $scope.recipe.id +
                        '&recipeTemplateId=' + $scope.recipe.labelRecipeTemplate.id,
                        type = 'ppds_label',
                        fileName = 'ppds_label_download';
                    if (!$scope.recipe.activeDish) {
                        self.showPPDSDialog(url, type, fileName);
                    } else {
                        self.downloadPdf(url, type, fileName);
                    }
                }

                var buildRecipeSaveRequest = function () {
                    var currentClientId = $scope.ctx.currentSubscriptionUnit.client.id;
                    var allergens = _.map($scope.recipe.recipeAllergens || [], function (a) {
                        return {
                            id: a.id,
                            allergenId: a.allergenId,
                            contains: !!a.contains,
                            mayContain: !!a.mayContain
                        };
                    });

                    return {
                        id: $scope.recipe.id,
                        recipeName: $scope.recipe.recipeName,
                        recipeLite: $scope.recipe.recipeLite,
                        nameOfDishOnMenu: $scope.recipe.nameOfDishOnMenu,
                        methodOfPreparation: $scope.recipe.methodOfPreparation,
                        actualSellingPrice: $scope.recipe.actualSellingPrice,
                        eposSku: $scope.recipe.eposSku,
                        clientSku: $scope.recipe.clientSku,
                        inventorySku: $scope.recipe.inventorySku,
                        clientId: currentClientId,
                        measureId: $scope.recipe.measureId,
                        quantityProduced: $scope.recipe.quantityProduced,
                        allergens: allergens,
                        suitableForIds: _.pluck($scope.recipe.recipeSuitableFors || [], 'id'),
                        haccp: $scope.recipe.haccp,
                        serviceInformation: $scope.recipe.serviceInformation,
                        ppdsLabelText: $scope.recipe.ppdsLabelText,
                        isSubRecipe: $scope.recipe.isSubRecipe,
                        imageUrl: $scope.recipe.imageUrl,
                        labelRecipeTemplateId: $scope.recipe.labelRecipeTemplate ? $scope.recipe.labelRecipeTemplate.id : null
                    };
                };

                $scope.saveRecipe = function (getCosts) {
                    $scope.saving = true
                    if (!$scope.canSaveRecipe || !$scope.recipe.recipeName || !$scope.recipe.nameOfDishOnMenu) {
                        return false
                    }
                    var recipeSaveRequest = buildRecipeSaveRequest()
                    return recipeService.save(recipeSaveRequest).then(function (savedRecipe) {
                        $scope.title = $scope.recipe.recipeName
                        if ($scope.recipe.id === 0) {
                            $location.path('/Recipes/View/{0}'.format(savedRecipe.newRecipeId))
                            toastr.success(self.translations.recipe_saved)
                        } else {
                            if (getCosts) {
                                recipeService.getRecipeCost(savedRecipe.newRecipeId).$promise.then(function (costs) {
                                    $scope.recipe.recipeCost = costs
                                })
                            }
                        }
                        $scope.saving = false
                        $scope.preparingForSave = false
                        $scope.togglingSuitableFors = false
                        $scope.togglingAllergens = false
                        $rootScope.$broadcast(enums.broadcasts.nutrientsComponent_forceRefresh);
                    })
                }

                $scope.saveLabelSize = function() {
                    $scope.saving = true;
                    var request = {
                        recipeId: $scope.recipe.id,
                        labelRecipeTemplateId: $scope.recipe.labelRecipeTemplate ? $scope.recipe.labelRecipeTemplate.id : null
                    }
                    recipeService.saveLabelSize(request).then($scope.saving = false);
                }

                $scope.recipeHasUnpricedIngredients = function () {
                    return _.find($scope.recipe.liveIngredients,
                        function (i) {
                            return i.isUnpriced
                        })
                }

                var recipeChangedTimeout
                $scope.recipeChanged = function (getCosts) {
                    if (!$scope.recipe.id) {
                        return
                    }
                    if (recipeChangedTimeout) {
                        $timeout.cancel(recipeChangedTimeout)
                    }
                    recipeChangedTimeout = $timeout(function () {
                            $scope.saveRecipe(getCosts)
                        },
                        1250)
                    $scope.preparingForSave = true
                }

                $scope.deleteIngredient = function (i) {
                    $scope.saving = true
                    ingredientService.delete(i.id).then(function () {
                        _.removeIfExists($scope.recipe.liveIngredients, i);
                        toastr.success(ingredientRemovedMessage);
                        refreshRecipeFromServer();
                        $scope.saving = false;
                        $rootScope.$broadcast(enums.broadcasts.nutrientsComponent_forceRefresh);
                    })
                }

                $scope.removeImage = function () {
                    delete $scope.recipe.imageUrl
                    $scope.recipeChanged()
                }

                $scope.tinymceOptions = pslTinymceDefaultOptions

                var getUnitPreferencesPromise
                var getUnitPreferences = function () {
                    var c = organisationContextService.getContext()
                    var unitSubscriptionId = c.currentSubscriptionUnit.id
                    var clientId = c.currentSubscriptionUnit.client.id
                    var model = { id: unitSubscriptionId, clientId: clientId }
                    return unitPreferencesService.getSystemPreferencesForClient(model).$promise
                }

                var initCostCalculator = function () {
                    getUnitPreferencesPromise.then(function (result) {
                        var preferences = result.systemPreferences
                        var targetMarginType =
                            _.find(preferences,
                                { systemPreferenceTypeId: enums.systemPreferenceEnum.targetMarginType }).value
                        $scope.targetFcos =
                            _.find(preferences,
                                { systemPreferenceTypeId: enums.systemPreferenceEnum.targetMarginPercent }).value
                        $scope.vatRate = parseFloat(
                            _.find(preferences,
                                { systemPreferenceTypeId: enums.systemPreferenceEnum.prevailingVatRate }).value)
                        var includeVatVal = _.find(preferences,
                            { systemPreferenceTypeId: enums.systemPreferenceEnum.vat }).value
                        $scope.includeVat = includeVatVal === '0' ? false : includeVatVal
                        if (!$scope.includeVat) {
                            $scope.vatRate = 0
                        }
                        $scope.canShowCostCalculator = targetMarginType == 'FCOS'
                        $scope.recipeCardTemplate = _.find(preferences,
                            { systemPreferenceTypeId: enums.systemPreferenceEnum.recipeCardTemplate }).value
                        $scope.sopTemplate = _.find(preferences,
                            { systemPreferenceTypeId: enums.systemPreferenceEnum.sopTemplate }).value
                    })
                }

                var getIngredientsAssociatedWithEachConfirmedAllergen = function (recipe) {
                    var r = recipe
                    var ing = r.liveIngredients
                    var confirmedAllergens = _.where(r.recipeAllergens, function (a) { return a.contains || a.mayContain })
                    _.each(confirmedAllergens,
                        function (a) {
                            var ingredientsWithThisAllergen = _.filter(ing,
                                function (i) {
                                    var result = _.find(i.suggestedAllergens,
                                            function (sa) { return sa.allergenId == a.allergenId }) !=
                                        null
                                    return result
                                })
                            a.associatedIngredients = ingredientsWithThisAllergen
                        })
                }

                var getSuggestedAllergensForRecipe = function () {
                    var suggestedAllergensFromIngredients = _.reduce(
                        _.flatten(_.pluck(_.flatten($scope.recipe.liveIngredients), 'suggestedAllergens')),
                        function (result, item) {
                            var existingItemIndex = result.findIndex(function(allergen) {
                                return allergen.allergenId == item.allergenId
                            })

                            if (existingItemIndex == -1) {
                                result.push(item);
                            } else {
                                // If the existing item is "May contain" and the current item is "Contains"
                                // Replace the existing item since "Contains" takes precedence
                                if (result[existingItemIndex].mayContain && item.contains) {
                                    result[existingItemIndex] = item;
                                }
                            }

                            return result;
                        }, []);
                    var availableAllergenIds = _.pluck($scope.availableAllergens, 'allergenId');
                    var suggestedAllergens = _.filter(suggestedAllergensFromIngredients,
                        function (a) {
                            return availableAllergenIds.indexOf(a.allergenId) > -1
                        })
                    $scope.suggestedAllergens = suggestedAllergens;
                }

                var linkAllergenToIngredients = function (a) {
                    var ingredientsThatContainAllergen = _.filter($scope.recipe.liveIngredients, function (i) {
                        if (!i.suggestedAllergens || i.suggestedAllergens.length === 0)
                            return false

                        return !!_.find(i.suggestedAllergens, function (sa) {
                            return sa.allergenId === a.allergenId
                        })
                    })

                    // The map just prevents ciruclar relations
                    a.associatedIngredients = _.map(ingredientsThatContainAllergen,
                        function (item) {
                            item.suggestedAllergens = null;
                            return item;
                        });
                }

                var setPreviousPpdsLabelText = function() {
                    if (recipeData.previousPpdsLabelText === '') recipeData.previousPpdsLabelText = undefined;
                    if ($scope.recipe.ppdsLabelText === '') $scope.recipe.ppdsLabelText = undefined;
                    self.previousPpdsLabelText = recipeData.previousPpdsLabelText;
                }

                $scope.hasCalorieInformationDefined = function(ingredient) {
                    var calorieAttribute = nutrientAttributeHelper.find(ingredient.attributes, enums.procurementSkuAttributes.kCal_per_ingredient) || {};
                    return calorieAttribute.value != null;
                }

                $scope.copySuggestedAllergens = function () {
                    _.each($scope.suggestedAllergens,
                        function (a) {
                            var indexAllergenAlreadyExistsOnRecipe = $scope.recipe.recipeAllergens.findIndex(function(e) {
                                return e.allergenId == a.allergenId;
                            });

                            // MB: We only want to run this code if the Allergen does not already exist on the recipe.
                            if (indexAllergenAlreadyExistsOnRecipe == -1) {
                                linkAllergenToIngredients(a)
                                $scope.recipe.recipeAllergens.push(_.clone(a));
                            }
                            else {
                                $scope.recipe.recipeAllergens[indexAllergenAlreadyExistsOnRecipe].contains = _.clone(a.contains);
                                $scope.recipe.recipeAllergens[indexAllergenAlreadyExistsOnRecipe].mayContain = _.clone(a.mayContain);
                            }

                        })

                    $scope.saveRecipe()
                }

                $scope.publishRecipe = function () {
                    publishRecipeService.publishRecipes({
                        recipesToPublish: [$scope.recipe],
                        showPPDSDisclaimer: _.unescape(self.previousPpdsLabelText) != _.unescape($scope.recipe.ppdsLabelText),
                        showCalorieDataIncomplete: $scope.recipe.calorieDataIncomplete
                    }).then(function () {
                        $scope.recipe.activeDish = true
                        self.previousPpdsLabelText = $scope.recipe.ppdsLabelText;
                    })
                }

                $scope.unpublishRecipe = function () {
                    publishRecipeService.publishRecipes({
                        recipesToUnpublish: [$scope.recipe]
                    }).then(function () {
                        $scope.recipe.activeDish = false
                    })
                }

                $scope.suggestedAllergensList = function () {
                    return _.pluck($scope.suggestedAllergens, 'allergenName').join(', ')
                }

                $scope.toggleSuitableFor = function (suitableFor) {
                    $scope.togglingSuitableFors = true
                    if (suitableFor.isSelected) {
                        $scope.recipe.recipeSuitableFors.push(suitableFor)
                    } else {
                        var sfOnRecipe = _.findWhere($scope.recipe.recipeSuitableFors, { id: suitableFor.id })
                        if (sfOnRecipe) {
                            _.removeIfExists($scope.recipe.recipeSuitableFors, sfOnRecipe)
                        }
                    }
                }
                $scope.removeSuitableFor = function (s) {
                    _.removeIfExists($scope.recipe.suitableFors, s)
                }

                var setupRecipe = function () {
                    $scope.recipe = recipeData.recipe
                    $scope.title = $scope.recipe.recipeName
                    $scope.availableAllergens = recipeData.recipeClientDto.availableAllergens
                    _.each($scope.availableAllergens,
                        function (allergen) {
                            allergen.allergenId = allergen.id
                        })
                    $scope.recipe.recipeSuitableFors = _.map($scope.recipe.recipeSuitableFors,
                        function (rsf) {
                            return {
                                id: rsf.suitableForId,
                                name: rsf.suitableForName
                            }
                        })
                    $scope.availableLabelSizes = labelSizeData
                    $scope.recipe.labelRecipeTemplate = _.findWhere($scope.availableLabelSizes, { id: $scope.recipe.labelRecipeTemplateId })
                    setPreviousPpdsLabelText();
                    getSuggestedAllergensForRecipe()
                    getIngredientsAssociatedWithEachConfirmedAllergen($scope.recipe)
                }

                var refreshRecipeFromServer = function () {
                    var id = $scope.recipe.id
                    var clientId = organisationContextService.getContext().currentSubscriptionUnit.client.id
                    return recipeService.get(clientId, id).then(function (result) {
                        recipeData = result
                        setupRecipe()
                    })
                }

                $scope.updateContains = function (allergenId) {
                    var allergenOnRecipe = _.findWhere($scope.recipe.recipeAllergens, { allergenId: allergenId })
                    if (allergenOnRecipe) {
                        allergenOnRecipe.contains = !allergenOnRecipe.contains;
                        allergenOnRecipe.mayContain = false;
                    } else {
                        var allergen = _.findWhere($scope.availableAllergens, { allergenId: allergenId })
                        allergen.contains = true;
                        allergen.mayContain = false;
                        $scope.recipe.recipeAllergens.push(allergen);
                    }

                    $scope.saveRecipe()
                }

                $scope.findInRecipeAllergens = function (allergenId) {
                    return _.findWhere($filter('orderBy')($scope.recipe.recipeAllergens, 'dateTimeAdded', true), { allergenId: allergenId })
                }

                $scope.updateMayContain = function (allergenId) {
                    var allergenOnRecipe = _.findWhere($scope.recipe.recipeAllergens, { allergenId: allergenId })
                    if (allergenOnRecipe) {
                        allergenOnRecipe.mayContain = !allergenOnRecipe.mayContain;
                        allergenOnRecipe.contains = false;
                    } else {
                        var allergen = _.findWhere($scope.availableAllergens, { allergenId: allergenId })
                        allergen.contains = false;
                        allergen.mayContain = true;
                        $scope.recipe.recipeAllergens.push(allergen);
                    }

                    $scope.saveRecipe()
                }

                var init = function () {
                    getTranslations()
                    getUnitPreferencesPromise = getUnitPreferences()
                    initCostCalculator()
                    $scope.model = {}
                    $scope.isAdminUser = localStorageService.getItem($rootScope.$enums.localStorage.isAdminUser).isAdmin
                    $q.all(self.resolves).then(function (resolved) {
                        recipeData = resolved.recipeData
                        labelSizeData = resolved.labelSizeData
                        setupRecipe()
                        getSuitableFors()
                    })
                }
                init()
                // });
            }
        ])

angular.module(appName)
  .factory('recipetemplateResource', [
    '$resource', 'siteUrl',
    function ($resource, siteUrl) {
      var api = siteUrl() + 'api/RecipeTemplate'

      return $resource(api, {},
        {
          listsoptemplates: {
            url: api + '/GetSOPTemplates',
            method: 'GET',
            isArray: true
          },
          listrecipecardtemplates: {
            url: api + '/GetRecipeCardTemplates',
            method: 'GET',
            isArray: true
          },
          listCostCalculatorTemplates: {
            url: api + '/GetCostCalculatorTemplates',
            method: 'GET',
            isArray: true
          },
          listPPDSLabelTemplates: {
            url: api + '/GetPPDSLabelTemplates',
            method: 'GET',
            isArray: true
          }
        })
    }
  ])

angular.module(appName)
  .factory('recipetemplateService', [
    'recipetemplateResource',
    function (recipetemplateResource) {

      var listsoptemplates = function () {
        return recipetemplateResource.listsoptemplates().$promise;
      };
      var listrecipecardtemplates = function () {
        return recipetemplateResource.listrecipecardtemplates().$promise;
      };
      var listCostCalculatorTemplates = function () {
        return recipetemplateResource.listCostCalculatorTemplates().$promise;
      }
      var listPPDSLabelTemplates = function () {
        return recipetemplateResource.listPPDSLabelTemplates().$promise;
      }
      return {
        listCostCalculatorTemplates: listCostCalculatorTemplates,
        listsoptemplates: listsoptemplates,
        listrecipecardtemplates: listrecipecardtemplates,
        listPPDSLabelTemplates: listPPDSLabelTemplates
      }
    }
  ]);

angular.module(appName).controller('groupFoodFlashReportController', [
        '$scope', 'moment', 'validationHelper', 'reportingService',
        'reportingGroupsService', 'organisationContextService', 'windowService',
        'localStorageService','$timeout',"_",
        function($scope, moment, validationHelper, reportingService,
            reportingGroupsService, organisationContextService, windowService,
            localStorageService, $timeout, _
        ) {
            var self = this;
            self.context = organisationContextService.getContext();
            $scope.reportingGroups = [];

            var reportingGroupKey = "GROUPREPORT_SAVED_REPORTING_GROUP";
            var reportingPeriodKey = "GROUPREPORT_SAVED_REPORTING_PERIOD";
            var reportDateToKey = "GROUPREPORT_SAVED_REPORT_DATE_TO";

            $scope.saveReportingGroupToLocalStorage = function() {
                localStorageService.setItem(reportingGroupKey, $scope.report.currentReportingGroup);
                if ($scope.report.currentReportingPeriod) {
                    $scope.updateReportData();
                }
            };

            $scope.saveReportingPeriodToLocalStorage = function () {
                localStorageService.setItem(reportingPeriodKey, $scope.report.currentReportingPeriod);
                $scope.updateReportData();
            };

            $scope.saveReportDateToToLocalStorage = function () {
                localStorageService.setItem(reportDateToKey, $scope.report.currentReportDateTo);
            };

            $scope.report = {
                headers: [
                    { displayName: "Unit", field: "unit", type: "text" },
                    { displayName: "Flash Revenue", field: "flashRevenue", type: "currency" },
                    { displayName: "Flash FCOS", field: "flashFcos", type: "currency" },
                    { displayName: "Flash FCOS%", field: "flashFcosPercent", type: "percent" },
                    { displayName: "Target FCOS%", field: "targetFcosPercent", type: "percent" },
                    { displayName: "Saving / (Overspend) v Target", field: "savingOverspendVTarget", type: "currency" },
                    { displayName: "Budget Revenue", field: "budgetRevenue", type: "currency" },
                    { displayName: "Budget Cost", field: "budgetCost", type: "currency" },
                    { displayName: "Budget FCOS%", field: "budgetFcosPercent", type: "percent" },
                    { displayName: "Saving / (Overspend) v Budget", field: "savingOverspendVBudget", type: "currency" },
                    { displayName: "Last Year FCOS%", field: "lastYrFcosPercent", type: "percent" },
                    { displayName: "Saving / (Overspend) v Last Year", field: "savingOverspendVlastYr", type: "currency" }
                ]
            };


            $scope.showReport = function() {
                return $scope.report && $scope.report
                    .currentReportingGroup !=
                    null &&
                    $scope.report.currentReportingPeriod != null;
            }

            $scope.setDirtyWarning = function(element) {
                element.isDirty = true;
            }

            $scope.goToUnitReport = function (procurementSubscriptionUnitId) {
                windowService.unitReport(
                    procurementSubscriptionUnitId,
                    $scope.report.currentReportingPeriod.id,
                    $scope.report.currentReportDateTo
                );
            }

            $scope.updateReportingGroups = function () {
                $scope.loadingReportingGroups = true;
                $scope.loadingReportingPeriods = true;
                return reportingGroupsService.getReportingGroups(self.context.id, true)
                    .$promise.then(function(reportingGroups) {
                        reportingGroups.unshift({ id: null, name: "All" });
                        $scope.reportingGroups = reportingGroups;

                        var savedReportingGroup = localStorageService.getItem(reportingGroupKey);

                        if (savedReportingGroup) {
                            var foundReportingGroup = _
                                .findWhere($scope.reportingGroups, { id: savedReportingGroup.id });

                            $scope.report.currentReportingGroup = foundReportingGroup || $scope.reportingGroups[0];
                        }
                        $scope.loadingReportingGroups = false;

                    });
            };

            $scope.updateReportingPeriods = function () {
                $scope.loadingReportingPeriods = true;
                //will this need to change to become dynamic based on the group chosen?
                return reportingService.getAllReportingPeriodsForSubscription(self.context.id)
                    .$promise.then(function(periods) {
                        $scope.reportingPeriods = periods.data;

                        var savedReportingPeriod = localStorageService.getItem(reportingPeriodKey);
                        if (savedReportingPeriod) {
                            var foundReportingPeriod = _.findWhere($scope.reportingPeriods, { id: savedReportingPeriod.id });
                            if (foundReportingPeriod) {
                                $scope.report.currentReportingPeriod = foundReportingPeriod;
                                var savedReportDateTo = localStorageService.getItem(reportDateToKey);
                                if (savedReportDateTo) {
                                    $scope.report.currentReportDateTo = savedReportDateTo;
                                    $scope.datePickerActive = true;
                                }
                                $scope.updateReportData(false);
                            } else {
                                $scope.loadingData = false;
                            }

                        }
                        $scope.loadingReportingPeriods = false;
                    });
            };

            $scope.nukeDatePicker = function() {
                $scope.report.currentReportDateTo = null;
                $scope.datePickerActive = false;

                $timeout(function() {
                    $scope.datePickerActive = true;
                    $scope.report.currentReportDateTo = $scope.report.currentReportingPeriod.endDate;
                    $scope.saveReportDateToToLocalStorage();
                },1);
            };

            $scope.updateReportData = function (updateLocalStorage) {
                $scope.loadingData = true;
                if (updateLocalStorage) {
                    $scope.saveReportDateToToLocalStorage();
                }

                reportingService.getGroupReportData(self.context.id,
                    $scope.report.currentReportingGroup.id,
                    $scope.report.currentReportingPeriod.id, $scope.report.currentReportDateTo)
                    .$promise.then(function (reportDto) {

                    $scope.report.reportData = _.filter(reportDto.data.reportData, function (item) { return item.unit.toLowerCase() !== "total" });
                    $scope.report.summaryData = _.filter(reportDto.data.reportData, function (item) { return item.unit.toLowerCase() === "total" });
                    $scope.loadingData = false;
                },function(error) {
                    console.error(error);
                    $scope.loadingData = false;
                });
            };

            self.init = function () {
                $scope.updateReportingGroups().then($scope.updateReportingPeriods);
            }();
        }
])
    //this directive is only relevant for the different sections on this report, so I put it in the same file.
    //easy to break out into another file if necessary or can be reused in another report.
    .directive("groupReportingSection", function () {
            var controller = [
                "_", "$scope", "validationHelper",
                function (_, $scope, validationHelper)
            {
                    $scope.validation = validationHelper;
                    $scope.sortHeader = $scope.report.headers[0];
                    $scope.sortAscending = true;

                    //this is the function run when clicking the header;
                    //changing one or more parameters called in the sortReport function passed to orderBy in the template
                    //will trigger angular to perform a resort
                    $scope.sortOnHeaderClick = function (header) {
                        if ($scope.sortHeader === header) {
                            $scope.sortAscending = !$scope.sortAscending;
                        } else {
                            $scope.sortAscending = true;
                            $scope.sortHeader = header;
                        }

                    };

                    //this is the function passed to the orderBy filter in the template.
                    $scope.sortReport = function (item) {

                        var value = item[$scope.sortHeader.field];
                        if (value === null || value === undefined)
                            return 0;
                        if ($scope.sortHeader.type === "text") {
                            return value;
                        } else {
                            var pureNumber = parseFloat(value.replace(/[^0-9-.]/g, ''));
                            return pureNumber;
                        }

                    };
    }];
            return {
                restrict: "AE",
                scope: {
                    report: "=",
                    showHeaderRow: "=",
                    arrayName: "@",
                    title: "@",
                    summaryTable: "=",
                    goToUnitReport: "="
                },
                templateUrl: "/ngxbeagle/dist/Content/js/Modules/Reporting/GroupFoodFlashReport/groupReportingSection.html",
                controller: controller
            };
        });

// angular.module(appName)
//     .directive("contenteditable", function () {
//         return {
//             restrict: "A",
//             require: "ngModel",
//             link: function (scope, element, attrs, ngModel) {
//                 function read() {
//                     ngModel.$setViewValue(element.html());
//                 }

//                 ngModel.$render = function () {
//                     element.html(ngModel.$viewValue || "");
//                 };

//                 element.bind("blur keyup change", function () {
//                     scope.$apply(read);
//                 });
//             }
//         };
//     });
angular.module(appName)
    .controller('reportingController', [
        '$scope', 'moment', 'validationHelper',
        function($scope, moment, validationHelper) {
            var self = this;
            
        }
    ])
angular.module(appName)
    .factory('reportingResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
        	var api = siteUrl() + 'api/Report';

        	return $resource(api, {},
            {
            	getUnitReportData: {
            		method: 'GET',
            		url: api + '/GetUnitReportData',
            		params: {
            			id: '@id', //Guid
            			procurementSubscriptionAccountingPeriodId: '@procurementSubscriptionAccountingPeriodId', //Guid
                        reportDateTo: '@reportDateTo' //dd/MM/yyyy
            		}
            	},
            	getGroupReportData: {
            		method: 'GET',
            		url: api + '/GetGroupReportData',
            		params: {
            			id: '@id', //Guid
            			procurementSubscriptionReportingGroupId: '@procurementSubscriptionReportingGroupId',
            			procurementSubscriptionAccountingPeriodId: '@procurementSubscriptionAccountingPeriodId', //Guid
                        reportDateTo: "@reportDateTo"
            		}
            	},
            	getAllReportingPeriodsForSubscription: {
            		method: 'GET',
            		url: api + '/GetAllReportingPeriodsForSubscription',
            		params: {
            			id: '@id' //Guid
            		}
            	},
            	getCurrentReportingPeriodForSubscription: {
            		method: 'GET',
            		url: api + '/GetCurrentReportingPeriodForSubscription',
            		params: {
            			id: '@id' //Guid
            		}
            	},
            	getAllReportingPeriodsForSubscriptionUnit: {
            		method: 'GET',
            		url: api + '/GetAllReportingPeriodsForSubscriptionUnit',
            		params: {
            			id: '@id' //Guid
            		}
            	},
            	getCurrentReportingPeriodForSubscriptionUnit: {
            		method: 'GET',
            		url: api + '/GetCurrentReportingPeriodForSubscriptionUnit',
            		params: {
            			id: '@id' //Guid
            		}
            	},
            	updateClosingStockData: {
            		method: 'POST',
            		url: api + '/UpdateClosingStockData',
            		params: {
            			id: '@id', //Guid
            			procurementSubscriptionAccountingPeriodId: '@procurementSubscriptionAccountingPeriodId', //Guid
            			closingStock: '@closingStock'
            		}
            	},
            	updateTargetFcosData: {
            		method: 'POST',
            		url: api + '/UpdateTargetFcosData',
            		params: {
            			id: '@id', //Guid
            			procurementSubscriptionAccountingPeriodId: '@procurementSubscriptionAccountingPeriodId', //Guid
						targetFcos: '@targetFcos',
						clientUnitDepartmentId: '@clientUnitDepartmentId'
            		}
            	}
            });
        }
    ]);
angular.module(appName)
	.factory("reportingService",
		[
			"reportingResource", "organisationContextService",
			function(reportingResource, organisationContextService) {
				var context = organisationContextService.getContext();
				var self = this;
				self.reportingPeriods =
				[
					{ id: 1, name: "Jan 2017" },
					{ id: 2, name: "Feb 2017" },
					{ id: 3, name: "Mar 2017" },
					{ id: 4, name: "Apr 2017" },
					{ id: 5, name: "May 2017" },
					{ id: 6, name: "Jun 2017" },
					{ id: 7, name: "Jul 2017" },
					{ id: 8, name: "Aug 2017" },
					{ id: 9, name: "Sep 2017" },
					{ id: 10, name: "Oct 2017" },
					{ id: 11, name: "Nov 2017" },
					{ id: 12, name: "Dec 2017" },
					];
				var reportingPeriodsCache = [];

				var service = {
					getReportingPeriodById: function(id, cb) {
						for (var i = 0; i < self.reportingPeriods.length; i++)
							if (self.reportingPeriods[i].id == id)
								cb(self.reportingPeriods[i]);
					},
					getAllReportingPeriodsForSubscription: function(id) {
						return reportingResource
							.getAllReportingPeriodsForSubscription({ id: id });
					},
					getAllReportingPeriodsForSubscriptionUnit: function(id) {
						id = id || context.currentSubscriptionUnit.id;
						if (reportingPeriodsCache[id]) {
							return reportingPeriodsCache[id];
						}
						var resource = reportingResource
							.getAllReportingPeriodsForSubscriptionUnit({ id: id });
						reportingPeriodsCache[id] = resource;
						return resource;
					},
					getCurrentReportingPeriodForSubscription: function(procurementSubscriptionId) {
						return reportingResource.getCurrentReportingPeriodForSubscription({
							id: procurementSubscriptionId
						});
					},
					getCurrentReportingPeriodForSubscriptionUnit: function(procurementSubscriptionId) {
						return reportingResource.getCurrentReportingPeriodForSubscriptionUnit({
							id: procurementSubscriptionId
						});
					},

					getUnitReportData: function(id, procurementSubscriptionAccountingPeriodId, reportDateTo) {
						return reportingResource.getUnitReportData({
							id: id,
							procurementSubscriptionAccountingPeriodId: procurementSubscriptionAccountingPeriodId,
							reportDateTo: reportDateTo
						});

					},
					getGroupReportData: function(id,
						procurementSubscriptionReportingGroupId,
						procurementSubscriptionAccountingPeriodId,
						reportDateTo) {
						return reportingResource.getGroupReportData(
							{
								id: id,
								procurementSubscriptionReportingGroupId: procurementSubscriptionReportingGroupId,
								procurementSubscriptionAccountingPeriodId: procurementSubscriptionAccountingPeriodId,
								reportDateTo: reportDateTo
							});
					},
					updateClosingStockData: function(id, procurementSubscriptionAccountingPeriodId, closingStock) {
						return reportingResource.updateClosingStockData(
							{
								id: id,
								procurementSubscriptionAccountingPeriodId: procurementSubscriptionAccountingPeriodId,
								closingStock: closingStock
							});
					},
					updateTargetFcosData: function(id,
						procurementSubscriptionAccountingPeriodId,
						targetFcos,
						clientUnitDepartmentId) {
						id = id || context.currentSubscriptionUnit.id;
						return reportingResource.updateTargetFcosData(
							{
								id: id,
								procurementSubscriptionAccountingPeriodId: procurementSubscriptionAccountingPeriodId,
								targetFcos: targetFcos,
								clientUnitDepartmentId: clientUnitDepartmentId
							});
					}
				};

				return service;
			}
		]);
// angular.module(appName)
//     .directive('reportSummary', function () {
//         var control
//         return {
//             restrict
//         }
//     })
angular.module(appName)
	.directive("cdbKeyEvents",
		[
			"$rootScope", function($rootScope) {
				return {
					restrict: "A",
					link: function(scope, elem, attr) {
						var el = elem[0];
						el.addEventListener("keyup",
							function(event) {
								//console.log('keyup', event);
							});
						el.addEventListener("keydown",
							function (event) {
								if (event.code === 'Enter') {
									elem.blur();
								}
								if (event.code === 'Tab') {
									scope.$emit('cdbKeyEventsTab', attr.id);
								}
							});
						el.addEventListener("keypress",
							function (event) {
								//console.log('keypress', event);
							});
					}
				};
			}
		]);
angular.module(appName)
	.directive("cdbNumericOnly",
		[
			function() {

				var allowedKeyValues = [
					"-", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "Backspace", "Enter", "Tab", "ArrowUp",
					"ArrowDown", "ArrowLeft", "ArrowRight"
				];

				

				return {
					restrict: "A",
					priority: 10, //CSH 13112018 This to ensure this directive is executed before ngModel
					link: function (scope, elem, attr) {
						
						var el = elem[0];
						var to2Dp = function () {
							var val = parseFloat(el.value);
							if (val) {
								el.value = val.toFixed(2);
							}
						}
						
						el.addEventListener("keydown",
							function(event) {
								if (allowedKeyValues.indexOf(event.key) < 0) {
									event.preventDefault();
								}
							});
						if (attr.cdbNumericOnly === "2dp") {
							to2Dp();
							scope.$watch(attr.ngModel, to2Dp);
							el.addEventListener("blur", to2Dp);
						}
					}
				};
			}
		]);
angular.module(appName)
	.directive("createFlashReportForm",
		function () {
			return {
				restrict: "E",
				scope: false,
				templateUrl: "/ngxbeagle/dist/Content/js/Modules/Reporting/UnitReports/FlashReporting/Directives/createFlashReportForm.html",
				controller: ['$scope', 'flashReportService', 'enums', '$translate', function ($scope, flashReportService, enums, $translate) {
					$scope.flashReportIncludeExcludeVat = [
						{ id: enums.flashReportIncludeExcludeVat.include, name: $translate.instant('include') },
						{ id: enums.flashReportIncludeExcludeVat.exclude, name: $translate.instant('exclude') },
					];
					flashReportService.getFlashReportTypes().then(function (result) {
						$scope.flashReportTypes = result.data;
						$scope.createReportModel.flashReportTypeId = result.data[0].id;
					});
					flashReportService.getFlashReportDataSources().then(function (result) {
						$scope.flashReportDataSources = result.data;
					});
					flashReportService.getList().then(function (result) {
						existingReportNames = _.pluck(result.data, 'name');
					});
					var existingReportNames;
					$scope.reportNameExists = function () {
						if (!existingReportNames) {
							return false;
						}
						return existingReportNames.indexOf($scope.createReportModel.flashReportName) > -1;
					}
				}]
			};
		});

angular.module(appName)
    .directive("flashReportParameterSelector",
        function () {
            return {
				restrict: "E",
				scope: {
					ngModel: "=",
					selectFrom: "=",
					title: "@",
					edit: "&"
				},
                templateUrl: "/ngxbeagle/dist/Content/js/Modules/Reporting/UnitReports/FlashReporting/Directives/flashReportParameterSelector.html"
            };
	});

angular.module(appName)
	.directive("flashReportSection",
		function() {
			var controller = [
				"$scope", "validationHelper", "$rootScope", "$q", "enums", function($scope, validationHelper, $rootScope, $q, enums) {
					var activeCellFocusedValue;

					$scope.cellClicked = function(date, child, parent, value) {
						$scope.$emit("flashReportSectionCellClicked",
							$scope.$parent.id,
							date,
							child,
							parent,
							value);
						if (!$scope.readonly && child) {
							$scope.activeCell = date + parent.entityId + child.entityId;
						}
					};

					$scope.expandAll = function() {
						_.each($scope.data.children,
							function (i) {
								i.expanded = true;
							});
					}

					$scope.collapseAll = function () {
						_.each($scope.data.children,
							function(i) {
								i.expanded = false;
							});
					}

					$scope.childCellFocused = function(child, parent, date, val) {
						activeCellFocusedValue = val;
					};

					$scope.childCellBlured = function (child, parent, date, newVal) {
						var oldVal = activeCellFocusedValue || 0;
						var diff = newVal - oldVal;
						if (!_.isNaN(diff) && diff !== 0) {
							$scope.data.onChangeChildValue(child, parent, date, diff);
							$rootScope.$broadcast("flashReportSectionChildCellChanged", $scope.$parent.id, date, child, parent, newVal);
						}
						$scope.activeCell = null;
					};
					
					$scope.getWorstCaseChildClass = function(parent, date) {
						var cellClass = '';

                        var childrenHaveDiscrepencies = _.some(parent.children, function (child) {
                            return !!child.discrepeancies && child.discrepeancies[date];
                        });
                        if (childrenHaveDiscrepencies) {
                            cellClass += 'discrepancy';
                        }
                        var childStatuses = _.chain(parent.children)
                            .pluck('dataSources')
                            .pluck(date)
                            .flatten()
                            .uniq()
                            .value();
                        
                        if (_.contains(childStatuses, 'po')) {
                            cellClass += ' po';
                        }
                        else if (_.contains(childStatuses, 'receivedPo')) {
                            cellClass += ' receivedPo';
                        }
                        else if (_.contains(childStatuses, 'invoice')) {
                            cellClass += ' invoice';
                        }
                        else if (_.contains(childStatuses, 'reconciledInvoice')) {
                            cellClass += ' reconciledInvoice';
                        }
						
						return cellClass;
					}
					
					$scope.toggleParentRow = function (datum) {
						if ($scope.parentRowsOnly) {
							return;
						}
						datum.expanded = !datum.expanded;
					};

					$scope.numberOfDatesToShow = 7;
					var populateIndexArray = function() {
						var indexArray = [];
						for (var i = 0; i < $scope.numberOfDatesToShow; i++) {
							indexArray.push(i);
						}
						$scope.indexArray = indexArray;
					};

					var sendPageEvent = function(direction) {
						$rootScope.$broadcast("flashReportSectionPageChange",
							$scope.departmentId,
							$scope.sectionType,
							direction);
					}

					populateIndexArray();
					$scope.validation = validationHelper;
					$scope.paginateDates = function(direction, preventEvents) {
						function calculateStartAndEnd() {
							var startIndex = ($scope.data.datePage - 1) * $scope.numberOfDatesToShow;
							var endIndex = startIndex + $scope.numberOfDatesToShow;

							var obj = { start: startIndex, end: endIndex };
							return obj;
						}

						if (direction === "forwards" && $scope.data.datePage !== $scope.data.numberOfPages) {
							$scope.data.datePage++;
							if (!preventEvents) {
								sendPageEvent("forwards");
							}
						}

						if (direction === "back" && $scope.data.datePage !== 1) {
							$scope.data.datePage--;
							if (!preventEvents) {
								sendPageEvent("back");
							}
						}

						if (direction === "start") {
							$scope.data.datePage = 1;
							if (!preventEvents) {
								sendPageEvent("start");
							}
						}

						var indexes = calculateStartAndEnd();
						var allHeaders = $scope.data.allDateHeaders
							.slice(indexes.start, indexes.end);
						if (allHeaders.length < $scope.numberOfDatesToShow) {
							var diff = $scope.numberOfDatesToShow - allHeaders.length;
							for (var i = 0; i < diff; i++) {
								allHeaders.push(null);
							}
						}
						$scope.data.activeDateHeaders = allHeaders;
					};

					var checkIfWeNeedToPaginate = function(date, nextDate) {
						var activeHeaders = _.filter($scope.data.activeDateHeaders,
							function(i) {
								return i;
							});
						var indexOfNextDateInActiveHeaders = activeHeaders.indexOf(nextDate);
						var indexOfCurrentDateInActiveHeaders = activeHeaders.indexOf(date);
						if (indexOfNextDateInActiveHeaders === -1 && activeHeaders.length < 7) {
							$scope.paginateDates("start");
							return;
						}
						if (indexOfCurrentDateInActiveHeaders >= 0 && indexOfNextDateInActiveHeaders < 0) {
							$scope.paginateDates("forwards");
							return;
						}
					};

					$scope.$on("flashReportSectionPageChange",
						function(event, departmentId, sectionType, direction) {
							if (departmentId === $scope.departmentId && sectionType !== $scope.sectionType) {
								$scope.paginateDates(direction, true);
							}
						});

					$scope.$on("cdbKeyEventsTab",
						function(event, id) {
							var idParts = id.split(":");
							var childEntityId = idParts[2];
							var parentEntityId = idParts[3];
							var date = idParts[4];
							var dates = $scope.data.allDateHeaders;
							var indexOfDate = dates.indexOf(date);
							var nextDate = dates.length > indexOfDate ? dates[indexOfDate + 1] : "";
							if (nextDate) {
								checkIfWeNeedToPaginate(date, nextDate);
								_.defer(function() {
									$scope.activeCell = nextDate + parentEntityId + childEntityId;
								});
							} else {
								var parentRow = _.find($scope.data.children, { entityId: parentEntityId });
								var childRow = _.find(parentRow.children, { entityId: childEntityId });
								var childIndex = parentRow.children.indexOf(childRow);
								var nextChild = parentRow.children[childIndex + 1];
								var newChildEntityId;
								if (nextChild) {
									newChildEntityId = nextChild.entityId;
									nextDate = dates[0];
									checkIfWeNeedToPaginate(date, nextDate);
									_.defer(function() {
										$scope.activeCell = nextDate + parentEntityId + newChildEntityId;
									});
								} else {
									var parents =
										$scope.data
											.children; //CSH 131102018 - This might seem confusing. The parent entities are children of the single main entity.
									var parentIndex = parents.indexOf(parentRow);
									var nextParent = parents[parentIndex + 1];
									if (nextParent) {
										nextParent.expanded = true;
										var newParentEntityId = nextParent.entityId;
										newChildEntityId = nextParent.children[0].entityId;
										nextDate = dates[0];
										checkIfWeNeedToPaginate(date, nextDate);
										_.defer(function() {
											$scope.activeCell = nextDate + newParentEntityId + newChildEntityId;
										});
									}
								}
							}
						});

					///CSH Currently this function fetches the report from an ancestor scope
					///but I have abstracted it out so that in future we can get the report by another
					///method if required.
					var getReport = function () {
						var deferred = $q.defer();
						var report = $scope.$parent.$parent.$parent.$parent.$parent.report;
						deferred.resolve(report);
						return deferred.promise;
					}

					var init = function() {
						var id = $scope.$parent.id;
						var parts = id.split(":");
						$scope.sectionType = parts[0];
						$scope.departmentId = parts[1];
						$scope.topSplit = function (i) {
							return $scope.splitDiscriminator ? $scope.splitDiscriminator(i) : true;
						}
						$scope.bottomSplit = function (i) {
							return !$scope.splitDiscriminator(i);
						}
						var isSpendSection = !!$scope.splitDiscriminator;
						getReport().then(function (report) {
							$scope.report = report;
							$scope.parentRowsOnly = ($scope.report.dataSourceId != enums.flashReportDataSourceTypes.reconciledPos) && isSpendSection;
						});
					};
					init();
				}
			];
			return {
				restrict: "AE",
				scope: {
					data: "=",
					showHeaderRow: "=",
					summaryTable: "=?",
					readonly: "=",
					splitDiscriminator: "="
				},
				templateUrl:
					"/ngxbeagle/dist/Content/js/Modules/Reporting/UnitReports/FlashReporting/Directives/flashReportSection.html",
				controller: controller
			};
		});

angular.module(appName)
	.directive("flashReportSectionWrapper",
		function() {
			return {
				restrict: "AE",
				scope: {
					data: "=",
					title: "@",
					loading: "=",
					missingParametersMessage: "@",
					id: "@",
					splitDiscriminator: "=",
					readonly: '=?'
				},
				transclude: true,
				link: function(scope, el, attr) {
					//CSH 18122018. The logic here is: <div readonly/> = is readonly
					//<div readonly="true"> is readonly
					//<div readonl="false"> is not readonly

					if (_.isUndefined(scope.readonly) && _.has(attr, 'readonly')) {
						scope.readonly = true;
					}
					scope.readonly = !!scope.readonly;
					//scope.readonly = _.has(attr, 'readonly');
				},
				templateUrl:
					"/ngxbeagle/dist/Content/js/Modules/Reporting/UnitReports/FlashReporting/Directives/flashReportSectionWrapper.html"
			};
		});

angular.module(appName)
	.directive("flashReportTabHeader",
		function() {
			return {
				controller: [
					"$scope",
					"flashReportViewControlsService",
					"flashReportService",
					"$timeout",
					"$rootScope",
					function ($scope, flashReportViewControlsService, flashReportService, $timeout, $rootScope) {

						var clientUnitDepartmentId;
						var reportId;
						var fetchReportDataOnNextView = true;

						var getDataRequestDto = function () {
							var dto = {
								reportId: $scope.report.id,
								reportDepartmentId: $scope.departmentId,
								accountingPeriodId: flashReportViewControlsService.accountPeriodId,
								endDate: flashReportViewControlsService.reportDateTo
									? moment(flashReportViewControlsService.reportDateTo, "DD/MM/YYYY")
										.format("MM/DD/YYYY")
									: null
							};
							return dto;
						};

						$scope.headerChanged = function () {
							flashReportService.postAccountingPeriodData({
								procurementSubscriptionAccountingPeriodId: flashReportViewControlsService.accountPeriodId,
								procurementClientUnitDepartmentId: clientUnitDepartmentId,
								closingStock: $scope.header.closingStock,
								targetFcos: $scope.header.targetFcos,
								openingStock: $scope.header.openingStock,
								flashReportId: reportId
							});
							$scope.$emit('flashReportTabHeaderDataUpdated', $scope.header, getDataRequestDto());
						};

						var refreshHeaderData = function () {
							var dataRequestDto = getDataRequestDto();
							if (!dataRequestDto.accountingPeriodId) {
								return;
							}
							$scope.fetchingHeaderData = true;
							flashReportService.getHeaderData(dataRequestDto).then(function (result) {
								$scope.header = result;
								$scope.fetchingHeaderData = false;
							});
							fetchReportDataOnNextView = false;
						}

						var markReportAsRequiringMoreDataOnNextViewAnRefreshIfTabActive = function () {
							fetchReportDataOnNextView = true;
							if ($scope.$parent.$parent.tabIsActive) {
								refreshHeaderData();
							}
						};

						var dataChangedDebouncePromise;
						var init = function() {
							var cdbTabData = $scope.$parent.$parent.cdbTabData;
							$scope.tabId = $scope.$parent.$parent.tabId;
							clientUnitDepartmentId = cdbTabData.reportDepartment
								? cdbTabData.reportDepartment.clientUnitDepartmentId
								: null;
							reportId = cdbTabData.report.id;
							$scope.$on('cdbTabsActivate', function (event, tabId) {
								if ($scope.tabId == tabId && fetchReportDataOnNextView) {
									refreshHeaderData();
								}
							});
							if ($scope.$parent.$parent.tabIsActive) {
								refreshHeaderData();
							}
							$scope.$on("flashReviewViewControlsChanged", markReportAsRequiringMoreDataOnNextViewAnRefreshIfTabActive);
							$scope.$on("flashReportDepartmentUpdated", markReportAsRequiringMoreDataOnNextViewAnRefreshIfTabActive);
							$scope.$on("flashReportSectionChildCellChanged", function () {
								if (dataChangedDebouncePromise) {
									$timeout.cancel(dataChangedDebouncePromise);
								}
								dataChangedDebouncePromise = $timeout(refreshHeaderData, 500);
							});

						};
						init();

					}
				],
				restrict: "E",
				templateUrl:
					"/ngxbeagle/dist/Content/js/Modules/Reporting/UnitReports/FlashReporting/Directives/flashReportTabHeader.html"
			};
		});

angular.module(appName)
    .directive("flashReportTotalsSection",
        function () {
            var controller = [
				"_", "$scope", "validationHelper", "$rootScope", function (_, $scope, validationHelper, $rootScope) {

		            var sendPageEvent = function (direction) {
			            $rootScope.$broadcast("flashReportSectionPageChange",
				            $scope.departmentId,
				            $scope.sectionType,
				            direction);
		            }


                    $scope.numberOfDatesToShow = 7;
                    $scope.validation = validationHelper;
                    $scope.paginateDates = function (direction, preventEvents) {
                        function calculateStartAndEnd() {
                            var startIndex = ($scope.data.datePage - 1) * $scope.numberOfDatesToShow;
                            var endIndex = startIndex + $scope.numberOfDatesToShow;

                            var obj = {start: startIndex, end: endIndex};
                            return obj;
                        }

                        if (direction === "forwards" && $scope.data.datePage !== $scope.data.numberOfPages) {
							$scope.data.datePage++;
	                        if (!preventEvents) {
		                        sendPageEvent("forwards");
	                        }
                        }

                        if (direction === "back" && $scope.data.datePage !== 1) {
							$scope.data.datePage--;
	                        if (!preventEvents) {
		                        sendPageEvent("back");
	                        }
                        }

						var indexes = calculateStartAndEnd();
						var allHeaders = $scope.data.allDateHeaders
							.slice(indexes.start, indexes.end);
						if (allHeaders.length < $scope.numberOfDatesToShow) {
							var diff = $scope.numberOfDatesToShow - allHeaders.length;
							for (var i = 0; i < diff; i++) {
								allHeaders.push(null);
							}
						}

	                    $scope.data.activeDateHeaders = allHeaders;
					};

		            var init = function () {
			            var id = $scope.id;
			            var parts = id.split(":");
			            $scope.sectionType = parts[0];
						$scope.departmentId = parts[1];
			            $scope.$on("flashReportSectionPageChange",
				            function (event, departmentId, sectionType, direction) {
					            if (departmentId === $scope.departmentId && sectionType !== $scope.sectionType) {
						            $scope.paginateDates(direction, true);
					            }
				            });
		            };
		            init();
                }
            ];
            return {
                restrict: "AE",
                scope: {
                    data: "=",
                    showHeaderRow: "=",
                    arrayName: "@",
					summaryTable: "=?",
					id: "@"
                },
                templateUrl: "/ngxbeagle/dist/Content/js/Modules/Reporting/UnitReports/FlashReporting/Directives/flashReportTotalsSection.html",
                controller: controller
            };
        });

angular.module(appName)
	.directive("flashReportViewControls",
		[
			"flashReportViewControlsService", "reportingService", "$timeout",
			function(flashReportViewControlsService, reportingService, $timeout) {
				var controller = [
					"$scope", "$rootScope", function($scope, $rootScope) {

						var accountingPeriodValueSet = false;
						var reportingDateToValueSet = false;
						var accountPeriodsRetrievedFromDb = false;
						var initComplete = false;

						var broadcastChangeEvent = function() {
							if (initComplete) {
								$rootScope.$broadcast('flashReviewViewControlsChanged');
							}
						}

						var checkIfAccountingPeriodIsFirstOne = function() {
							var period = _.find($scope.reportingPeriods, { id: $scope.reportViewOptions.periodId });
							var index = $scope.reportingPeriods.indexOf(period);
							flashReportViewControlsService.accountingPeriodIdFirst =
								index === $scope.reportingPeriods.length - 1;
						}

						var setInitCompleteIfInitcompleteConditionsAreMet = function() {
							if (accountingPeriodValueSet &&
								reportingDateToValueSet &&
								accountPeriodsRetrievedFromDb &&
								!initComplete) {
								initComplete = true;
								if (!$scope.reportViewOptions.periodId) {
									$scope.reportViewOptions.periodId = $scope.reportingPeriods[0].id;
									if (!flashReportViewControlsService.reportDateTo) {
										flashReportViewControlsService.reportDateTo = $scope.reportingPeriods[0].endDate;
										$timeout(function() {
											flashReportViewControlsService.reportDateTo = $scope.reportingPeriods[0].endDate;
										}, 100);
									}
								}
								$scope.controlsInitComplete = true;
								checkIfAccountingPeriodIsFirstOne();
								flashReportViewControlsService.markInitComplete();
								if ($scope.reportViewOptions.periodId) {
									$scope.reportViewOptions.period = _.find($scope.reportingPeriods,
										{ id: $scope.reportViewOptions.periodId });
								}
							}
						}

						$scope.reportViewOptions = {
						};
						$scope.clearReportingDateTo = function() {
							if (flashReportViewControlsService.reportDateTo) {
								flashReportViewControlsService.reportDateTo = '';
								broadcastChangeEvent();
							}
						}
						$scope.reportingDateToChanged = function() {
							broadcastChangeEvent();
						}

						$scope.$watch('reportViewOptions.periodId',
							function(newVal, oldVal) {
								if (newVal && newVal !== oldVal) {
									var period = _.find($scope.reportingPeriods, { id: newVal });
									$scope.reportViewOptions.period = period;
									$scope.reportViewOptions.reportDateTo = null;
									$scope.reportingPeriodSelected = false;
									$timeout(function() {
										$scope.reportingPeriodSelected = true;
										flashReportViewControlsService.accountPeriodId = newVal;
										if (initComplete) {
											checkIfAccountingPeriodIsFirstOne();
										}
										if ($scope.reportingPeriods) {
											if (period && period.endDate) {
												flashReportViewControlsService.reportDateFrom = period.startDate;
												flashReportViewControlsService.reportDateTo = period.endDate;
											} else {
												$scope.clearReportingDateTo();
											}
											broadcastChangeEvent();
										}
									});
								}

							});
						$scope.flashReportViewControlsService = flashReportViewControlsService;
						reportingService.getAllReportingPeriodsForSubscriptionUnit().$promise.then(function (response) {
							var data = _.map(response.data,
								function(i) {
									return {
										id: i.id,
										description: i.description,
										startDate: i.startDate,
										endDate: i.endDate,
										startDateUniv: moment(i.startDate, 'DD/MM/YYYY').format()
									};
								});
							$scope.reportingPeriods = data.reverse();
							accountPeriodsRetrievedFromDb = true;
							setInitCompleteIfInitcompleteConditionsAreMet();
						});
						$scope.$on('cdbRemember_init',
							function(event, id) {
								if (id.indexOf('flashReportViewControlsAccountingPeriod') === 0) {
									if (!accountingPeriodValueSet) {
										accountingPeriodValueSet = true;
									}
								}
								if (id.indexOf('flashReportViewControlsDatepicker') === 0) {
									reportingDateToValueSet = true;
								}
								setInitCompleteIfInitcompleteConditionsAreMet();
							});
					}
				];
				return {
					scope: true,
					restrict: "E",
					templateUrl:
						"/ngxbeagle/dist/Content/js/Modules/Reporting/UnitReports/FlashReporting/Directives/flashReportViewControls.html",
					controller: controller
				};
			}
		]);

angular.module(appName)
	.controller('flashReportAddNewDepartmentTabController', [
		'$scope',
		'cdbSelectFromDialogService',
		'flashReportService',
		'$routeParams',
		'flashReportLookupDataService',
		'$q',
		function ($scope, cdbSelectFromDialogService, flashReportService, $routeParams, flashReportLookupDataService, $q) {

			var report;
			var initDeferred;
			var expenseDepartments;
			var onShow = function () {

				initDeferred.promise.then(function () {

					var existingClientUnitDepartmentIds = _.pluck(report.departments, 'clientUnitDepartmentId');
					var availableExpenseDepartments = _.filter(expenseDepartments,
						function (d) {
							return existingClientUnitDepartmentIds.indexOf(d.id) === -1;
						});

					cdbSelectFromDialogService.selectOne().as('description').in(availableExpenseDepartments).then(
						//User selected a department
						function (selectedDepartment) {
							flashReportService.addDepartmentToFoodFlash($routeParams.flashReportId, selectedDepartment.id).then(
								function (resultFromServer) {
									var flashReportDepartmentId = resultFromServer.data;
									report.addDepartment(flashReportDepartmentId, selectedDepartment.id, selectedDepartment.description);
									var newTabName = 'departmentTab' + flashReportDepartmentId;
									_.defer(function () {
										$scope.$emit('cdbTabsRequestActivate', newTabName);
									});
								});
						},
						//User pressed 'Cancel'
						function () {
							$scope.$emit('cdbTabsRequestActivate', 'summaryTab');
						});
				});
			}

			var init = function () {
				report = $scope.cdbTabData.report;
				initDeferred = $q.defer();

				flashReportLookupDataService.expenseDepartments.then(function (result) {
					expenseDepartments = result;
					initDeferred.resolve();
				});

				$scope.$on('cdbTabsActivate', function (event, tabId) {
					if (tabId === "addNewDepartmentTabid") {
						onShow();
					}
				});
				
			}
			init();
		}
	])

angular.module(appName)
	.factory("flashReportDataSectionFactory",
		[
			function () {

				var noOfActiveHeaders = 7;

				var createActiveDateHeaders = function (allDates) {
					var headers = allDates.slice(0, noOfActiveHeaders);
					var diff = noOfActiveHeaders - headers.length;
					for (var i = 0; i < diff; i++) {
						headers.push("");
					}
					return headers;
				};

				var create = function (response) {
					var allDates = _.keys(response.data);
					var data = response;
					var self = data;
					data.activeDateHeaders = createActiveDateHeaders(allDates);
					data.allDateHeaders = allDates;
					data.datePage = 1;
					data.numberOfPages = Math.ceil(allDates.length / noOfActiveHeaders);
					data.onChangeChildValue = function (child, parent, date, diff) {
						///CSH 13112018 This function updates only the cells that need to change based 
						///on the most granular cell
						///
						//Update parent entity figure for date
						parent.data[date] = parent.data[date] + diff;
						//Update grandparent entity figure for date
						self.data[date] = self.data[date] + diff;
						//Update total to date figures:
						var dateIndex = data.allDateHeaders.indexOf(date);
						for (var i = dateIndex; i <= data.allDateHeaders.length; i++) {
							var d = data.allDateHeaders[i];
							self.toDateData[d] = self.toDateData[d] + diff;
						}
						//Update child row total
						child.total = child.total + diff;
						//Update parent row total
						parent.total = parent.total + diff;
						//Update overall total
						self.total = self.total + diff;
						//Update mix figures
						_.each(self.children,
							function (c) {
								_.each(c.children,
									function (g) {
										g.mix = g.total / self.total;
									});
								c.mix = c.total / self.total;
							});
					};
					return data;
				}

				var getStockMovementRow = function (section) {
					return _.find(section.children, { entityId: '-1' });
				};

				var createSpend = function (response) {
					var section = create(response);
					section.updateStockMovement = function (stockMovementValue) {
						var perDay = stockMovementValue.perDay;
						var stockMovementRow = getStockMovementRow(section);
						stockMovementRow.data = _.object(_.map(stockMovementRow.data, function (value, key) {
							return [key, perDay];
						}));
						section.data = _.object(_.map(section.data, function (value, key) {
							var newVal = value + perDay;
							return [key, newVal];
						}));
						section.toDateData = _.object(_.map(section.toDateData, function (value, key) {
							return [key, perDay];
						}));
						stockMovementRow.total = stockMovementValue.total;
					};
					return section;
				}

				return {
					create: create,
					createSpend: createSpend
				};
			}
		]);
angular.module(appName).controller('flashReportDepartmentTabController', [
    '$scope',
    'flashReportService',
    'cdbSelectFromDialogService',
    'enums',
    '$translate',
    '$q',
    'flashReportDataSectionFactory',
    'flashReportLookupDataService',
    'flashReportViewControlsService',
    'flashReportViewSpendDetailService',
    '$rootScope',
	'userService',
    function(
        $scope,
        flashReportService,
        cdbSelectFromDialogService,
        enums,
        $translate,
        $q,
        flashReportDataSectionFactory,
        flashReportLookupDataService,
        flashReportViewControlsService,
        flashReportViewSpendDetailService,
        $rootScope,
		userService
    ) {
        $scope.flashReportViewControlsService = flashReportViewControlsService
        $scope.removeDepartmentFromReport = function() {
            flashReportService
                .removeDepartmentFromReport($scope.departmentId)
                .then(function() {
                    $scope.report.removeDepartment($scope.departmentId)
                    $scope.$emit(
                        'cdbTabRequestTabRemove',
                        'departmentTab' + $scope.departmentId
                    )
                    $scope.$emit('cdbTabsRequestActivate', 'summaryTab')
                    $rootScope.$broadcast('flashReportDepartmentUpdated')
                })
        }
		var fetchReportDataOnNextView = true;
        var select_expense_account_codes = 'select_expense_account_codes'
        var select_client_supplier_accounts = 'select_client_supplier_accounts'
        var select_allowance_types = 'select_allowance_types'
        var select_revenue_account_codes = 'select_revenue_account_codes'
        var select_revenue_departments = 'select_revenue_departments'
        var select_non_psl_client_supplier_accounts =
            'select_non_psl_client_supplier_accounts'
        var getTranslations = function() {
            $translate([
                select_expense_account_codes,
                select_client_supplier_accounts,
                select_allowance_types,
                select_revenue_account_codes,
                select_revenue_departments,
                select_non_psl_client_supplier_accounts,
            ]).then(function(r) {
                select_expense_account_codes = r.select_expense_account_codes
                select_client_supplier_accounts =
                    r.select_client_supplier_accounts
                select_allowance_types = r.select_allowance_types
                select_revenue_account_codes = r.select_revenue_account_codes
                select_revenue_departments = r.select_revenue_departments
                select_non_psl_client_supplier_accounts =
                    r.select_non_psl_client_supplier_accounts
            })
        }

        var getDataRequestDto = function(flashReportSection) {
            var dto = {
                flashReportSection: flashReportSection,
                reportId: $scope.report.id,
                reportDepartmentId: $scope.departmentId,
                accountingPeriodId:
                    flashReportViewControlsService.accountPeriodId,
                endDate: flashReportViewControlsService.reportDateTo
                    ? moment(
                          flashReportViewControlsService.reportDateTo,
                          'DD/MM/YYYY'
                      ).format('MM/DD/YYYY')
                    : null,
            }
            return dto
        }

        ///CSH 05032020 This updates the 'Totals' section at the bottom of the screen
        var calculateOverallTabTotals = function() {
            if (($scope.spendData || $scope.creditData) && $scope.revenueData) {
                var anyDataSet =
                    $scope.spendData || $scope.creditData || $scope.revenueData
                if (!anyDataSet) {
                    return
                }
                var totalsData = {
                    data: {},
                    toDateData: {}
                }
                var keys = _.keys(angular.copy(anyDataSet.data))
                _.each(keys, function(date) {
                    var spendTotal =
                        $scope.spendData && $scope.spendData.data
                            ? $scope.spendData.data[date]
                            : 0;
                    var creditTotal =
                        $scope.creditData && $scope.creditData.data
                            ? $scope.creditData.data[date]
                            : 0;
                    var revenueData =
                        $scope.revenueData &&
                        $scope.revenueData.data &&
                        $scope.revenueData.data[date]
                            ? $scope.revenueData.data[date]
                            : 0;
                    var fcos = revenueData != 0 ?
                        (spendTotal - creditTotal) / revenueData :
                        0;
                    totalsData.data[date] = fcos;
                    var spendTotalToDate =
                        $scope.spendData &&
                        $scope.spendData.data &&
							($scope.spendData.toDateData &&
							$scope.spendData.toDateData[date])
                            ? $scope.spendData.toDateData[date]
                            : 0
                    var creditTotalToDate =
                        $scope.creditData &&
                            $scope.creditData.data &&
                            $scope.creditData.toDateData[date]
                            ? $scope.creditData.toDateData[date]
                            : 0;
                    var revenueDataToDate =
                        $scope.revenueData &&
                        $scope.revenueData.data &&
                        $scope.revenueData.toDateData[date]
                            ? $scope.revenueData.toDateData[date]
                            : 0;
                    var fcosToDate = revenueDataToDate != 0 ?
                        (spendTotalToDate - creditTotalToDate) / revenueDataToDate :
                        0;
                    totalsData.toDateData[date] = fcosToDate
                });
                console.log('totalsData', totalsData);
                $scope.totalsData = flashReportDataSectionFactory.create(totalsData)
            } else {
                delete $scope.totalsData
            }
        }

        var loadSpendData = function() {
            var request = getDataRequestDto(enums.flashReportSections.spend)
            $scope.loadingSpendData = true
            flashReportService
                .getSpend(request)
                .then(function(response) {
                    $scope.spendData = flashReportDataSectionFactory.createSpend(response)
                    $scope.loadingSpendData = false
                    $scope.$broadcast(
                        'flashReportingSpendDataLoaded',
                        $scope.spendData
                    )
                    calculateOverallTabTotals()
                })
        }

        var loadCreditsData = function() {
            $scope.loadingCreditData = true
            var request = getDataRequestDto(enums.flashReportSections.credit)
            flashReportService
                .getCredits(request)
                .then(function(response) {
                    $scope.loadingCreditData = false
                    $scope.creditData = flashReportDataSectionFactory.create(
                        response
                    )
                    calculateOverallTabTotals()
                })
        }

        var loadRevenueData = function() {
            $scope.loadingRevenueData = true
            var request = getDataRequestDto(enums.flashReportSections.revenue)
            flashReportService
                .getRevenue(request)
                .then(function(response) {
                    $scope.loadingRevenueData = false
                    $scope.revenueData = flashReportDataSectionFactory.create(
                        response
                    )
                    calculateOverallTabTotals()
                })
        }

		var updateReportData = function () {
            if (!flashReportViewControlsService.accountPeriodId) {
                return
			}
            var m = $scope.model
            if (
                m.clientSupplierAccountIds.length
            ) {
                $scope.canLoadSpendData = true
                loadSpendData()
            } else {
                $scope.canLoadSpendData = false
            }
            if (m.allowanceTypeIds.length) {
                $scope.canLoadCreditData = true
                loadCreditsData()
            } else {
                $scope.canLoadCreditData = false
            }
            if (
                m.revenueAccountCodeIds.length &&
                m.revenueDepartmentIds.length
            ) {
                $scope.canLoadRevenueData = true
                loadRevenueData()
            } else {
                $scope.canLoadRevenueData = false
			}
			fetchReportDataOnNextView = false;
        }

        $scope.selectExpenseAccountCodes = function() {
            cdbSelectFromDialogService
                .select('id')
                .as('description')
                .withLabel(select_expense_account_codes)
                .in($scope.expenseAccountCodes)
                .forModel($scope.model.expenseAccountCodeIds)
				.then(function (r) {
                    $scope.model.expenseAccountCodeIds = r
                })
        }

        $scope.selectClientSupplierAccounts = function() {
            cdbSelectFromDialogService
                .select('id')
                .as('description')
                .withLabel(select_client_supplier_accounts)
                .in($scope.clientSupplierAccounts)
                .forModel($scope.model.clientSupplierAccountIds)
                .then(function(r) {
                    $scope.model.clientSupplierAccountIds = r
                })
        }

        $scope.selectNonPslClientSupplierAccounts = function() {
            cdbSelectFromDialogService
                .select('id')
                .as('description')
                .withLabel(select_non_psl_client_supplier_accounts)
                .in($scope.nonPslClientSupplierAccounts)
                .forModel($scope.model.nonPslClientSupplierAccountIds)
                .then(function(r) {
                    $scope.model.nonPslClientSupplierAccountIds = r
                })
        }

        $scope.selectAllowanceTypes = function() {
            cdbSelectFromDialogService
                .select('id')
                .as('description')
                .withLabel(select_expense_account_codes)
                .in($scope.allowanceTypes)
                .forModel($scope.model.allowanceTypeIds)
                .then(function(r) {
                    $scope.model.allowanceTypeIds = r
                })
        }

		///CSH 20052019 Have commented out call to getRevenueAccountCodesForEachDept as part of ticket 166055494
		///Am keeping the code in for now in case the client changes their mind but will remove completely in 2 months
		///if client still happy.
        $scope.selectRevenueAccountCodes = function() {
            //flashReportService
                //.getRevenueAccountCodesForEachDept($scope.report.id)
				//.then(function (data) {
                    //data = JSON.parse(angular.toJson(data))
                    //delete data[$scope.departmentId]
                    var accountCodeIdsInUseInOtherTables = []
                    /*_.each(data, function(d) {
                        accountCodeIdsInUseInOtherTables = accountCodeIdsInUseInOtherTables.concat(
                            d
                        )
					})*/
                    var filteredList = _.filter(
                        $scope.revenueAccountCodes,
                        function(i) {
                            return (
                                accountCodeIdsInUseInOtherTables.indexOf(
                                    i.clientProcurementAccountCodeId
                                ) === -1
                            )
                        }
					)
                    cdbSelectFromDialogService
                        .select('id')
                        .as('description')
                        .withLabel(select_revenue_account_codes)
                        .in(filteredList)
                        .forModel($scope.model.revenueAccountCodeIds)
						.then(function (r) {
                            $scope.model.revenueAccountCodeIds = r
                        })
                //})
        }

        $scope.selectRevenueDepartments = function() {
            cdbSelectFromDialogService
                .select('id')
                .as('description')
                .withLabel(select_revenue_departments)
                .in($scope.revenueDepartments)
                .forModel($scope.model.revenueDepartmentIds)
                .then(function(r) {
                    $scope.model.revenueDepartmentIds = r
                })
        }

        $scope.spendSplitDiscriminator = function(i) {
            return !i.nonPslSupplier
        }

        var setupModelWatcher = function() {
            $scope.$watch(
                'model',
				function (newModelValue, oldModelValue) {
					if (angular.equals(oldModelValue, newModelValue)) {
						return;
					};
                    flashReportService
                        .updateFlashReportDepartmentTab($scope.model)
                        .then(function() {
                            $rootScope.$broadcast(
                                'flashReportDepartmentUpdated'
							)
                            if (!angular.equals(newModelValue, oldModelValue)) {
								var m = $scope.model;
                                var modelDiff = _.diff(
                                    newModelValue,
                                    oldModelValue
								)
                                if (
                                    _.noOfProperties(
                                        modelDiff.expenseAccountCodeIds
                                    ) ||
                                    _.noOfProperties(
                                        modelDiff.clientSupplierAccountIds
                                    ) ||
                                    _.noOfProperties(
                                        modelDiff.nonPslClientSupplierAccountIds
                                    )
                                ) {
									loadSpendData()
									$scope.canLoadSpendData = true
                                }
                                if (
                                    _.noOfProperties(
                                        modelDiff.expenseAccountCodeIds
                                    ) ||
                                    _.noOfProperties(modelDiff.allowanceTypeIds)
                                ) {
									$scope.canLoadCreditData = true
									loadCreditsData();
                                }
                                if (
                                    _.noOfProperties(
                                        modelDiff.expenseAccountCodeIds
                                    ) ||
                                    _.noOfProperties(
                                        modelDiff.revenueAccountCodeIds
                                    ) ||
                                    _.noOfProperties(
                                        modelDiff.revenueDepartmentIds
                                    )
                                ) {
									$scope.canLoadRevenueData = true
									loadRevenueData();
                                }
                            }
                        })
                },
                true
            )
		}

		var calculateStockMovementValue = function (header, request) {
			var openingStock = header.openingStock;
			var closingStock = header.closingStock;
			//CSH 28/5/19 - The logic below means that both the opening stock and closing stock should have values greater than zero
			//or zero itself, but not any other falsy value like null, undefined, etc.
			if ((!openingStock && openingStock !== 0) || (!closingStock && closingStock !== 0)) {
				return;
			}
			var currentReportingPeriod = _.find($scope.reportingPeriods.data, { id: request.accountingPeriodId });
			var startDate = moment(currentReportingPeriod.startDate, 'DD/MM/YYYY');
			var endDate = request.endDate ? moment(request.endDate, 'MM/DD/YYYY') : moment(currentReportingPeriod.endDate, 'DD/MM/YYYY'); //CSH 28/5/19 - Note inconsistent date format.
            var days = moment.duration(endDate.diff(startDate)).days() + 1;
            var prevStockMovement = $scope.stockMovement ? $scope.stockMovement.perDay : null;
            console.log('prevStockMovement', prevStockMovement);
			$scope.stockMovement = {
				perDay: (closingStock - openingStock) / -days,
			}
			//CSH Adding a deliberate rounding error here to simulate existing report, as requested by Stuart Allam:
			$scope.stockMovement.total = (Math.round($scope.stockMovement.perDay * 100) / 100) * days;
			if ($scope.spendData) {
				$scope.spendData.updateStockMovement($scope.stockMovement);
			}
		}

        var init = function() {
			getTranslations();
			$scope.departmentId = $scope.cdbTabData.reportDepartmentId;
			$scope.department = $scope.cdbTabData.reportDepartment;
			$scope.report = $scope.cdbTabData.report;
			$scope.$on('flashReportDetailControllerShowRebatesInSpendChanged', updateReportData);
            $scope.$on('flashReportTabHeaderDataUpdated', function (event, header, request) {
                loadSpendData();
			});
            var getFlashReportTabPromise = flashReportService.getFlashReportDepartmentTab(
                $scope.departmentId
            )
            getFlashReportTabPromise.then(function(r) {
                $scope.model = r.data
            })
            flashReportLookupDataService.expenseAccountCodes.then(function(r) {
                $scope.expenseAccountCodes = r
            })
            flashReportLookupDataService.revenueAccountCodes.then(function(r) {
                $scope.revenueAccountCodes = r
			})
			flashReportLookupDataService.reportingPeriods.then(function(r) {
				$scope.reportingPeriods = r;
			})
			flashReportLookupDataService.clientSupplierAccounts.then(function (r) {
				$scope.clientSupplierAccounts = _.sortBy(_.filter(r, function (i) {
					return !i.nonPslSupplier
				}), 'name');
				$scope.nonPslClientSupplierAccounts = _.sortBy(_.filter(r, function (i) {
					return i.nonPslSupplier
				}), 'name');
            })
            flashReportLookupDataService.allowanceTypes.then(function(r) {
                $scope.allowanceTypes = r
            })
            flashReportLookupDataService.revenueDepartments.then(function(r) {
                $scope.revenueDepartments = r
            })

            userService.hasPermission('BEAGLE_UNIT_REVENUE_UPLOAD').then(
                function() {
                    $scope.canEditRevenue = true
                },
                function() {
                    $scope.canEditRevenue = false
                }
            )
            userService.hasPermission('BEAGLE_UNIT_ALLOWANCE_UPLOAD').then(
                function() {
                    $scope.canEditCredits = true
                },
                function() {
                    $scope.canEditCredits = false
                }
            )
			$q
				.all([
					flashReportLookupDataService.all,
					getFlashReportTabPromise,
					flashReportViewControlsService.initPromise,
				])
				.then(function () {
					//CSH 25072019: This event handler calls the backend to get the data only when the tab is first displayed,
					//rather than when the page is loaded:
					$scope.$on('cdbTabsActivate', function (event, tabId) {
						if ($scope.tabId == tabId && fetchReportDataOnNextView) {
							updateReportData();
						}
					});
					if ($scope.tabIsActive) {
						updateReportData();
					}
					$scope.initComplete = true
					setupModelWatcher()
					$scope.$on(
						'flashReviewViewControlsChanged',
						function () {
							fetchReportDataOnNextView = true;
							if ($scope.tabIsActive) {
								updateReportData();
							}
						}
					);
					$scope.$on('flashReportingSpendDataLoaded', function () {
						if ($scope.stockMovement || $scope.stockMovement === 0) {
							$scope.spendData.updateStockMovement($scope.stockMovement);
						}
					});
                    $scope.$on('flashReportSectionChildCellChanged', function(
                        event,
                        sectionId,
                        date,
                        childEntity,
                        parentEntity,
                        value
                    ) {
                        var callingDepartmentId = sectionId.split(':')[1];
                        //CSH 06032020 If the cell has been changed on a different tab to this one
                        //we want to ignore the cell changed event:
                        if (callingDepartmentId != $scope.departmentId) {
                            return;
                        }
                        var requestDate = moment(date, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss');
                        if (sectionId.indexOf('creditsData') === 0) {
                            var request = {
                                allowanceDate: requestDate,
                                procurementClientUnitDepartmentId:
                                    $scope.department.clientUnitDepartmentId,
                                procurementClientUnitAllowanceTypeId:
                                    parentEntity.entityId,
                                allowanceAmount: value,
                                procurementClientUnitAccountCodeId:
                                    childEntity.entityId,
                            }
                            flashReportService.updateProcurementAllowanceImportedLine(
                                request
                            ).then(function () {
                                calculateOverallTabTotals();
                            });
                        }
                        if (sectionId.indexOf('revenueData') === 0) {
                            var revenueRequest = {
                                revenueDate: requestDate,
                                procurementClientUnitDepartmentId:
                                    parentEntity.entityId,
                                revenue: value,
                                procurementClientUnitAccountCodeId:
                                    childEntity.entityId,
                            }
                            flashReportService.updateProcurementRevenueImportedLine(
                                revenueRequest
                            ).then(function () {
                                calculateOverallTabTotals();
                            });
                        }
                    })
                    $scope.$on('flashReportSectionCellClicked', function(
                        event,
                        sectionId,
                        date,
                        childEntity,
                        parentEntity,
                        value
                    ) {
						if (sectionId.indexOf('spendData') === 0) {
							if (!flashReportViewSpendDetailService.showingSpendDetail) {
								//CSH 29/05/2019 an EntityId of -1 denotes the StockMovement line, and therefore
								//should not open a spend detail dialog:
								if (parentEntity.entityId === "-1") {
									return;
								}
								flashReportViewSpendDetailService.showSpendDetail({
                                    reportId: $scope.report.id,
                                    includeExcludeVat: $scope.report.includeExcludeVat,
									departmentName: $scope.department.name,
									departmentId: $scope.departmentId,
									supplierName: parentEntity.supplierName,
									clientSupplierAccountNumber:
									parentEntity.clientSupplierAccountNumber,
									clientSupplierAccountId: parentEntity.entityId,
									expenseAccountCode: childEntity ? childEntity.entityName : null,
									expenseAccountCodeId: childEntity ? childEntity.entityId : null,
									date: date,
								})
							}
						}
                    })
                    $rootScope.$broadcast(
                        'flashReportDepartmentTabInitComplete',
                        'departmentTab' + $scope.departmentId
                    )
                })
        }
        init()
    },
])

angular.module(appName)
	.controller('flashReportDetailController',
		[
			'$scope',
			'flashReportService',
			'$routeParams',
			"$location",
			'flashReportFactory',
			'flashReportViewControlsService',
			'fileDownloadService',
			'siteUrl',
			'$translate', 
			'$rootScope',
			'copyFlashReportService',
			function($scope,
				flashReportService,
				$routeParams,
				$location,
				flashReportFactory,
				flashReportViewControlsService,
				fileDownloadService,
				siteUrl,
				$translate,
				$rootScope,
				copyFlashReportService) {
				
				$scope.reportViewOptions = {
				};
				var setPageModeToCreate = function() {
					$scope.creating = true;
					$scope.creating = true;
					$scope.editing = false;
				}

				var setPageModeToEdit = function() {
					var tabName = Object.keys($location.$$search)[0];
					_.defer(function() {
						$scope.creating = false;
						$scope.editing = true;
						$scope.activeTab = tabName || 'summaryTab';
					});
				}

				$scope.submitCreateReportForm = function() {
					$scope.submittingCreateReportForm = true;
					var request = angular.copy($scope.createReportModel);
					flashReportService.createFlashReport(request).then(function(result) {
						setPageModeToEdit();
						$location.url('/UnitReports/v2/FlashReports/' + result.data).replace();
					}).finally(function() {
						$scope.submittingCreateReportForm = false;
					});
				}

				var existingReports;

				$scope.reportNameChanged = function() {
					var existingReportWithThatName = _.find(existingReports, { name: $scope.report.name });
					if (existingReportWithThatName && existingReportWithThatName.id != $scope.report.id) {
						$scope.existingReportWithThatName = true;
					} else {
						$scope.existingReportWithThatName = false;
						flashReportService.renameFlashReport($scope.report.id, $scope.report.name);
					}
				}

				$scope.reportDataSourceChanged = function () {
					flashReportService.changeReportDataSource($scope.report.id, $scope.report.dataSourceId).then(function () {
						$rootScope.$broadcast('flashReviewViewControlsChanged');
					});
				}

				$scope.showRebatesInSpendChanged = function () {
					flashReportService.setRebatesInSpendFlag($scope.report.id, $scope.report.showRebatesInSpend).then(function () {
						$scope.$broadcast('flashReportDetailControllerShowRebatesInSpendChanged', $scope.report.showRebatesInSpend);
					});
				}

				$scope.copyThisReport = function(id) {
					copyFlashReportService.copyFlashReport(id).then(function (result) {
						var url = '/UnitReports/v2/FlashReports/' + result.id + '?summaryTab';
                        $location.url(url);
					});
				}

				$scope.exportToExcel = function() {
					var r = {
						flashReportId: $scope.flashReportId,
						accountingPeriodId: flashReportViewControlsService.accountPeriodId,
						reportDateTo: flashReportViewControlsService.reportDateTo
							? moment(flashReportViewControlsService.reportDateTo, "DD/MM/YYYY").format("MM/DD/YYYY")
							: null
					};
					return fileDownloadService
						.downloadFile(siteUrl() +
							"api/FlashReportData/exportToExcel?flashReportId=" +
							r.flashReportId +
							"&accountingPeriodId=" +
							r.accountingPeriodId +
							"&reportDateTo=" +
							r.reportDateTo,
							"FlashReport", "xlsx").then(function () {
								toastr.success($translate.instant('success'));
							},
							function() {
								toastr.error($translate.instant('unexpected_error'));
							});
				}

				var init = function() {
					$scope.createReportModel = {};
					$scope.$on('cdbTabsActivate',
						function(event, tabId) {
							$location.url('/UnitReports/v2/FlashReports/' + $routeParams.flashReportId + "?" + tabId)
								.replace();
						});
					flashReportService.getList().then(function(result) {
						existingReports = result.data;
					});
					flashReportService.getSubscriptionUnitFlashReportAllowRebateLineStatus().then(function (result) {
						$scope.showRebateOption = result.data;
					});
					if ($routeParams.flashReportId.toLowerCase() === 'create') {
						$scope.report = {
							departments: []
						}
						setPageModeToCreate();
						$scope.initComplete = true;
					} else {
						$scope.flashReportId = $routeParams.flashReportId;
						flashReportService.getReport($routeParams.flashReportId).then(function(result) {
							$scope.report = flashReportFactory.create(result.data);
							setPageModeToEdit();
							$scope.initComplete = true;
						});
					}
				}
				init();
			}
		])

angular.module(appName)
	.factory('flashReportFactory',
		[
			function () {
				return {
					create: function (dto) {
						var report = angular.copy(dto);
						report.removeDepartment = function (departmentId) {
							var departmentToRemove = _.find(report.departments, { id: departmentId });
							_.removeIfExists(report.departments, departmentToRemove);
						}
						report.addDepartment = function (departmentId, clientUnitDepartmentId, departmentName) {
							report.departments.push({ id: departmentId, clientUnitDepartmentId: clientUnitDepartmentId,  name: departmentName });
						}
						return report;
					}
				}
			}
		]);
angular.module(appName)
	.controller('flashReportListController', [
		'$scope',
		'flashReportService',
		'organisationContext',
		'copyFlashReportService',
		function ($scope, flashReportService, organisationContext, copyFlashReportService) {

			$scope.deleteReport = function(report) {
				report.deleting = true;
				flashReportService.deleteReport(report.id).then(function() {
					_.removeIfExists($scope.flashReports, report);
				}).finally(function() {
					report.deleting = false;
				});
			}

			$scope.copyReport = function (report) {
				copyFlashReportService.copyFlashReport(report.id).then(function (result) {
					$scope.flashReports.push(result);
				});
			}

			var init = function () {
				$scope.unitName = organisationContext.currentSubscriptionUnit.organisation.name;
				flashReportService.getList().then(function (result) {
					$scope.initComplete = true;
					$scope.flashReports = result.data;
				});
			}
			init();
		}
	])
angular.module(appName)
	.controller('flashReportSummaryTabController', [
		'$scope', 'flashReportViewControlsService', 'enums', 'flashReportService', 'flashReportDataSectionFactory', '$q', 'flashReportLookupDataService',
		function ($scope, flashReportViewControlsService, enums, flashReportService, flashReportDataSectionFactory, $q, flashReportLookupDataService) {

			var updatingReportData = false;
			var fetchReportDataOnNextView = true;
			var calculateOverallTabTotals = function () {
				if (($scope.spendData || $scope.creditData) && $scope.revenueData) {
					var anyDataSet = $scope.spendData || $scope.creditData || $scope.revenueData;
					if (!anyDataSet) {
						return;
					}
					var totalsData = {
						data: {},
						toDateData: {
						}
					};
					var keys = _.keys(angular.copy(anyDataSet.data));
					_.each(keys,
						function (date) {
							var spendTotal = $scope.spendData && $scope.spendData.data
								? $scope.spendData.data[date]
								: 0;
							var creditTotal = $scope.creditData && $scope.creditData.data
								? $scope.creditData.data[date]
								: 0;
							var revenueData = $scope.revenueData && $scope.revenueData.data && $scope.revenueData.data[date]
								? $scope.revenueData.data[date]
								: 0;
						    var fcos = revenueData != 0 ? (spendTotal - creditTotal) / revenueData
                                            : 0;
							totalsData.data[date] = fcos;
							var spendTotalToDate = $scope.spendData && $scope.spendData.data && ($scope.spendData.toDateData ? $scope.spendData.toDateData[date] : 0)
								? $scope.spendData.toDateData[date]
								: 0;
							var creditTotalToDate = $scope.creditData && $scope.creditData.data && $scope.creditData.toDateData[date]
								? $scope.creditData.toDateData[date]
								: 0;
							var revenueDataToDate = $scope.revenueData && $scope.revenueData.data && $scope.revenueData.toDateData[date]
								? $scope.revenueData.toDateData[date]
								: 0;
						    var fcosToDate = revenueDataToDate != 0? (spendTotalToDate - creditTotalToDate) / revenueDataToDate : 0;
							totalsData.toDateData[date] = fcosToDate;
						});
					$scope.totalsData = flashReportDataSectionFactory.create(totalsData);
				} else {
					delete $scope.totalsData;
				}
			}

			var getDataRequestDto = function (flashReportSection) {
				var dto = {
					flashReportSection: flashReportSection,
					reportId: $scope.report.id,
					reportDepartmentId: $scope.departmentId,
					accountingPeriodId: flashReportViewControlsService.accountPeriodId,
					endDate: flashReportViewControlsService.reportDateTo
						? moment(flashReportViewControlsService.reportDateTo, "DD/MM/YYYY").format("MM/DD/YYYY")
						: null
				};
				return dto;
			};

			$scope.spendSplitDiscriminator = function (i) {
				return !i.nonPslSupplier
			}

			var loadSpendData = function () {
				var request = getDataRequestDto(enums.flashReportSections.spend);
				$scope.loadingSpendData = true;
				var loadSpendDataPromise = flashReportService.getSpend(request);
				loadSpendDataPromise.then(function (response) {
					$scope.spendData = flashReportDataSectionFactory.createSpend(response);
					$scope.loadingSpendData = false;
					$scope.$broadcast("flashReportingSpendDataLoaded", $scope.spendData);
					calculateOverallTabTotals();
				});
				return loadSpendDataPromise;
			};

			var loadCreditsData = function () {
				$scope.loadingCreditData = true;
				var request = getDataRequestDto(enums.flashReportSections.credit);
				var loadCreditsDataPromise = flashReportService.getCredits(request);
				loadCreditsDataPromise.then(function (response) {
					$scope.loadingCreditData = false;
					$scope.creditData = flashReportDataSectionFactory.create(response);
					calculateOverallTabTotals();
				});
				return loadCreditsDataPromise;
			};

			var loadRevenueData = function () {
				$scope.loadingRevenueData = true;
				var request = getDataRequestDto(enums.flashReportSections.revenue);
				var loadRevenueDataPromise = flashReportService.getRevenue(request);
				loadRevenueDataPromise.then(function (response) {
					$scope.loadingRevenueData = false;
					$scope.revenueData = flashReportDataSectionFactory.create(response);
					calculateOverallTabTotals();
				});
				return loadRevenueDataPromise;
			};

			//CSH 29/05/2019 This is copied from flashReportDepartmentTabController.js, 
			//please update both functions if changing, or better, abstract out if you have the time
			var calculateStockMovementValue = function (header, request) {
				var openingStock = header.openingStock;
				var closingStock = header.closingStock;
				//CSH 28/5/19 - The logic below means that both the opening stock and closing stock should have values greater than zero
				//or zero itself, but not any other falsy value like null, undefined, etc.
				if ((!openingStock && openingStock !== 0) || (!closingStock && closingStock !== 0)) {
					return;
				}
				var currentReportingPeriod = _.find($scope.reportingPeriods.data, { id: request.accountingPeriodId });
				var startDate = moment(currentReportingPeriod.startDate, 'DD/MM/YYYY');
				var endDate = request.endDate ? moment(request.endDate, 'MM/DD/YYYY') : moment(currentReportingPeriod.endDate, 'DD/MM/YYYY'); //CSH 28/5/19 - Note inconsistent date format.
				var days = moment.duration(endDate.diff(startDate)).days() + 1;
				$scope.stockMovement = {
					perDay: (closingStock - openingStock) / -days,
				}
				//CSH Adding a deliberate rounding error here to simulate existing report, as requested by Stuart Allam:
				$scope.stockMovement.total = (Math.round($scope.stockMovement.perDay * 100) / 100) * days;
				if ($scope.spendData) {
					$scope.spendData.updateStockMovement($scope.stockMovement);
				}
			}

			var updateReportData = function () {
				if (updatingReportData) {
					return;
				}
				if (!flashReportViewControlsService.accountPeriodId) {
					return;
				};
				updatingReportData = true;
				$q.all([loadSpendData(), loadCreditsData(), loadRevenueData()]).then(function() {
					updatingReportData = false;
				});
				fetchReportDataOnNextView = false;
			};

			var markReportAsRequiringMoreDataOnNextViewAnRefreshIfTabActive = function () {
				fetchReportDataOnNextView = true;
				if ($scope.tabIsActive) {
					updateReportData();
				}
			};

			var init = function () {
				//CSH 25072019: This event handler calls the backend to get the data only when the tab is first displayed,
				//rather than when the page is loaded:
				$scope.$on('cdbTabsActivate', function (event, tabId) {
					if ($scope.tabId == tabId && fetchReportDataOnNextView) {
						updateReportData();
					}
				});
				if ($scope.tabIsActive) {
					updateReportData();
				}
				flashReportLookupDataService.reportingPeriods.then(function (r) {
					$scope.reportingPeriods = r;
				})
				$scope.report = $scope.cdbTabData.report;
				$scope.$on('flashReportDetailControllerShowRebatesInSpendChanged', function () {
					markReportAsRequiringMoreDataOnNextViewAnRefreshIfTabActive();
				});
				$scope.$on("flashReviewViewControlsChanged", function () {
					markReportAsRequiringMoreDataOnNextViewAnRefreshIfTabActive();
				});
				$scope.$on("flashReportDepartmentUpdated", function () {
					markReportAsRequiringMoreDataOnNextViewAnRefreshIfTabActive();
				});
				$scope.$on('flashReportingSpendDataLoaded', function () {
					if ($scope.stockMovement || $scope.stockMovement === 0) {
						$scope.spendData.updateStockMovement($scope.stockMovement);
					}
				});
				$scope.$on('flashReportTabHeaderDataUpdated', function (event, header, request) {
					loadSpendData();
				});
				$scope.$on('flashReportSectionChildCellChanged', function (event, id) {
					markReportAsRequiringMoreDataOnNextViewAnRefreshIfTabActive();
				});
			}
			init();
		}
	])
angular.module(appName)
    .factory('flashReportResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/FlashReportData/';
	        return $resource(api,
		        {},
				{
					getSpend: {
						method: 'GET',
						url: api + 'getSpend',
						params: {
							unitId: '@unitId',
							flashReportSection: '@flashReportSection',
							reportId: '@reportId',
							reportDepartmentId: '@reportDepartmentId',
							accountingPeriodId: '@accountingPeriodId',
							endDate: '@endDate'
						}
					}, getCredits: {
						method: 'GET',
						url: api + 'getCredits',
						params: {
							unitId: '@unitId',
							flashReportSection: '@flashReportSection',
							reportId: '@reportId',
							reportDepartmentId: '@reportDepartmentId',
							accountingPeriodId: '@accountingPeriodId',
							endDate: '@endDate'
						}
					}, getRevenue: {
						method: 'GET',
						url: api + 'getRevenue',
						params: {
							unitId: '@unitId',
							flashReportSection: '@flashReportSection',
							reportId: '@reportId',
							reportDepartmentId: '@reportDepartmentId',
							accountingPeriodId: '@accountingPeriodId',
							endDate: '@endDate'
						}
					},
					getSpendDetail: {
						method: 'GET',
						url: api + 'getSpendDetail',
						isArray: true,
						params: {
							flashReportId: '@flashReportId',
							departmentId: '@departmentId',
							accountingPeriodId: '@accountingPeriodId',
							accountingPeriodEndDate: '@accountingPeriodEndDate',
							asAtDate: '@asAtDate',
							clientSupplierAccountId: '@clientSupplierAccountId',
							procurementClientUnitAccountCodeId: '@procurementClientUnitAccountCodeId'
						}
					},
					getHeaderData: {
						method: 'GET',
						url: api + 'getHeaderData',
						params: {
							unitId: '@unitId',
							reportId: '@reportId',
							reportDepartmentId: '@reportDepartmentId',
							accountingPeriodId: '@accountingPeriodId',
							endDate: '@endDate'
						}
					},
					postAccountingPeriodData: {
						method: 'POST',
						url: api + 'postAccountingPeriodData',
						params: {
							procurementSubscriptionAccountingPeriodId: '@procurementSubscriptionAccountingPeriodId',
							procurementClientUnitDepartmentId: '@procurementClientUnitDepartmentId',
							closingStock: '@closingStock',
							targetFcos: '@targetFcos'
						}
					},
					renameFlashReport: {
						method: 'POST',
						url: siteUrl() + 'api/flashReports/renameFlashReport',
						params: {
							flashReportId: '@flashReportId',
							flashReportName: '@flashReportName'
						}
					},
					exportToExcel: {
						method: 'GET',
						url: api + 'exportToExcel',
						params: {
							flashReportId: '@flashReportId',
							accountingPeriodId: '@accountingPeriodId',
							reportDateTo: '@reportDateTo'
						}
					},
					getRevenueAccountCodesForEachDept: {
						method: 'GET',
						url: api + 'getRevenueAccountCodesForEachDept',
						params: {
							flashReportId: '@flashReportId'
						}
					},
					setRebatesInSpendFlag: {
						method: 'POST',
						url: siteUrl() + 'api/flashReports/setRebatesInSpendFlag',
						params: {
							flashReportId: '@flashReportId',
							setRebatesInSpendFlag: '@setRebatesInSpendFlag'
						}
					},
					changeReportDataSource: {
						method: 'POST',
						url: siteUrl() + 'api/flashReports/changeReportDataSource',
						params: {
							flashReportId: '@flashReportId',
							flashReportDataSourceId: '@flashReportDataSourceId'
						}
					},
		        });
        }]);
angular.module(appName)
    .factory('procurementAllowanceImportedLineResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
			var api = siteUrl() + 'api/ProcurementAllowanceImportedLines/';
	        return $resource(api,
		        {},
		        {
			        update: {
				        method: 'POST',
						url: api + 'update',
				        params: {
							allowanceDate: '@allowanceDate',
							procurementSubscriptionUnitId: '@procurementSubscriptionUnitId',
							procurementClientUnitDepartmentId: '@procurementClientUnitDepartmentId',
							procurementClientUnitAllowanceTypeId: '@procurementClientUnitAllowanceTypeId',
							allowanceAmount: '@allowanceAmount',
							procurementClientUnitAccountCodeId: '@procurementClientUnitAccountCodeId'
				        }
			        },
		        });
        }]);
angular.module(appName)
    .factory('procurementRevenueImportedLineResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
			var api = siteUrl() + 'api/ProcurementRevenueImportedLines/';
	        return $resource(api,
		        {},
		        {
			        update: {
				        method: 'POST',
						url: api + 'update',
				        params: {
							allowanceDate: '@revenueDate',
							procurementSubscriptionUnitId: '@procurementSubscriptionUnitId',
							procurementClientUnitDepartmentId: '@procurementClientUnitDepartmentId',
							allowanceAmount: '@revenue',
							procurementClientUnitAccountCodeId: '@procurementClientUnitAccountCodeId'
				        }
			        },
		        });
        }]);
angular.module(appName).factory('copyFlashReportService', [
    '$q',
    'ngDialog',
    'flashReportService',
    '$translate',
    '$location',
    function (
        $q,
        ngDialog,
        flashReportService,
        $translate,
        $location
    ) {
        var service = {
            showingSpendDetail: false,
            copyFlashReport: function (flashReportId) {
                var deferred = $q.defer();
                var promises = [];
                promises.push(flashReportService.getFlashReportTypes());
                promises.push(flashReportService.getFlashReportDataSources());
                promises.push(flashReportService.getReport(flashReportId));
                $q.all(promises).then(function (results) {
                    dialog = ngDialog.open({
                        template: 'Content/js/Modules/Reporting/UnitReports/FlashReporting/Services/copyFlashReportService.html',
                        disableAnimation: true,
                        showClose: false,
                        controller: [
                            '$scope',
                            function ($scope) {
                                $scope.flashReportTypes = results[0].data;
                                $scope.flashReportDataSources = results[1].data;
                                var report = results[2].data;
                                $scope.createReportModel = {
                                    flashReportName: report.name + ' ' + $translate.instant('copy'),
                                    flashReportDataSourceId: report.dataSourceId,
                                    includeExcludeVat: report.includeExcludeVat
                                };
                                $scope.submitCopyReportForm = function () {
                                    $scope.createReportModel.flashReportId = flashReportId;
                                    flashReportService.copyReport($scope.createReportModel).then(function (result) {
                                        toastr.success($translate.instant('success'));
                                        $scope.closeThisDialog({ id: result.data, name: $scope.createReportModel.flashReportName });
                                    });
                                }
                            },
                        ],
                        width: 750
                    })
                    dialogId = dialog.id
                    dialog.closePromise.then(function (closeResult) {
                        if (!closeResult.value || closeResult.value == '$document') {
                            deferred.reject();
                        } else {
                            deferred.resolve(closeResult.value);
                        }
                    })
                });
                return deferred.promise;
            },
        }
        return service
    },
])

//CSH 07012018 This is a service that just brings in the lookup data from all the services and returns it to the various 
//Flash related controllers and directives that need it. Purpose is:
//1 - Make sure we're not calling the server multiple times when we don't need to. Here each controller is pulling from the same
//promise
//2 Clarity - all the code for look up is in one place and not cluttering up the init functions of the controllers
//3 Consistency - all the lookup data is returned in a consistanct format
angular.module(appName)
	.factory("flashReportLookupDataService",
		[
			"clientUnitAccountCodeService",
			"flashReportService",
			"enums",
			"unitAllowanceTypesService",
			"clientUnitDepartmentService",
			"$q",
			"reportingService",
			function(clientUnitAccountCodeService,
				flashReportService,
				enums,
				unitAllowanceTypesService,
				clientUnitDepartmentService,
				$q,
				reportingService) {

				var accountTypeEnums = enums.procurementAccountTypeEnum;

				var expenseAccountCodesDeferred = $q.defer();
				var revenueAccountCodesDeferred = $q.defer();
				clientUnitAccountCodeService.getClientUnitAccountCodes().$promise.then(
					function (r) {
						expenseAccountCodesDeferred.resolve(_.filter(r, { procurementAccountTypeId: accountTypeEnums.expense }));
						revenueAccountCodesDeferred.resolve(_.filter(r, { procurementAccountTypeId: accountTypeEnums.revenue }));
					});

				var clientSupplierAccountsDeferred = $q.defer();
				flashReportService.getClientSupplierAccounts().then(function (r) {
					_.each(r.data,
						function(x) {
							x.description = x.name;
						});
					clientSupplierAccountsDeferred.resolve(r.data);
				});

				var allowanceTypesDeferred = $q.defer();
				unitAllowanceTypesService.get().then(function (r) {
					allowanceTypesDeferred.resolve(_.map(r,
						function(x) {
							return {
								id: x.id,
								description: x.description
							};
						}));
				});

				var revenueDepartmentsDeferred = $q.defer();
				clientUnitDepartmentService
					.getClientUnitProcurementDepartmentsForUser(null,
						null,
						"eProcurement.DeptKeyValueResponseDto",
						accountTypeEnums.revenue).$promise.then(
					function (result) {
						revenueDepartmentsDeferred.resolve(result);
					});

				var expenseDepartmentsDeferred = $q.defer();
				clientUnitDepartmentService
					.getClientUnitProcurementDepartmentsForUser(null,
						null,
						"eProcurement.DeptKeyValueResponseDto",
						accountTypeEnums.expense).$promise.then(
						function (result) {
							expenseDepartmentsDeferred.resolve(result);
							});

				var reportingPeriodsDeferred = $q.defer();
				reportingService.getAllReportingPeriodsForSubscriptionUnit().$promise.then(
					function (result) {
						reportingPeriodsDeferred.resolve(result);
					});

				var allPromise = $q.all([
					expenseDepartmentsDeferred.promise,
					expenseAccountCodesDeferred.promise,
					revenueAccountCodesDeferred.promise,
					clientSupplierAccountsDeferred.promise,
					allowanceTypesDeferred.promise,
					revenueDepartmentsDeferred.promise,
					reportingPeriodsDeferred.promise
				]);
				return {
					expenseDepartments: expenseDepartmentsDeferred.promise,
					expenseAccountCodes: expenseAccountCodesDeferred.promise,
					revenueAccountCodes: revenueAccountCodesDeferred.promise,
					clientSupplierAccounts: clientSupplierAccountsDeferred.promise,
					allowanceTypes: allowanceTypesDeferred.promise,
					revenueDepartments: revenueDepartmentsDeferred.promise,
					reportingPeriods: reportingPeriodsDeferred.promise,
					all:allPromise
				};
			}
		]);
angular.module(appName)
	.factory('flashReportService',
		[
			'siteUrl', '$http', 'organisationContext', 'flashReportResource', 'procurementAllowanceImportedLineResource','procurementRevenueImportedLineResource',
			function (siteUrl, $http, organisationContext, flashReportResource, procurementAllowanceImportedLineResource, procurementRevenueImportedLineResource) {

				var subscriptionUnitId = organisationContext.currentSubscriptionUnit.id;
				var procurementSubscriptionId = _organisationContext.currentSubscriptionUnit.procurementSubscriptionId;

				return {
					getFlashReportTypes: function () {
						return $http.get(siteUrl() + "api/flashReports/getFlashReportTypes");
					},
					getFlashReportDataSources: function () {
						return $http.get(siteUrl() + "api/flashReports/getFlashReportDataSources");
					},
					createFlashReport: function (request) {
						request.procurementSubscriptionUnitId =
							request.procurementSubscriptionUnitId || subscriptionUnitId;
						return $http.put(siteUrl() + "api/flashReports/createFlashReport", request);
					},
					getList: function () {
						return $http.get(siteUrl() + "api/flashReports/getFlashReportList/" + subscriptionUnitId);
					},
					deleteReport: function (reportId) {
						return $http.delete(siteUrl() + "api/flashReports/deleteReport/" + reportId);
					},
					addDepartmentToFoodFlash: function (flashReportId, departmentId) {
						return $http.put(siteUrl() +
							"api/flashReports/" +
							flashReportId +
							"/addDepartmentToFoodFlash/" +
							departmentId);
					},
					getReport: function (flashReportId) {
						return $http.get(siteUrl() + "api/flashReports/getReport/" + flashReportId);
					},
					removeDepartmentFromReport: function (flashReportDepartmentId) {
						return $http.delete(siteUrl() +
							"api/flashReports/deleteFlashReportDepartment/" +
							flashReportDepartmentId);
					},
					updateFlashReportDepartmentTab: function (model) {
						return $http.post(siteUrl() + "api/flashReports/updateFlashReportDepartmentTab", model);
					},
					getFlashReportDepartmentTab: function (id) {
						return $http.get(siteUrl() + "api/flashReportDepartments/" + id);
					},
					getClientSupplierAccounts: function (clientId) {
						if (!clientId) {
							clientId = organisationContext.currentSubscriptionUnit.client.id;
						}
						return $http.get(siteUrl() + "api/clientSupplierAccounts/GetForSubscriptionUnit/" + clientId);
					},
					getSpend: function (getDataObject) {
						return flashReportResource.getSpend(getDataObject).$promise;
					},
					getCredits: function (getDataObject) {
						return flashReportResource.getCredits(getDataObject).$promise;
					},
					getRevenue: function (getDataObject) {
						return flashReportResource.getRevenue(getDataObject).$promise;
					},
					getHeaderData: function (getDataRequest) {
						return flashReportResource.getHeaderData(getDataRequest).$promise;
					},
					postAccountingPeriodData: function (postAccountingPeriodDataRequest) {
						return flashReportResource.postAccountingPeriodData(postAccountingPeriodDataRequest).$promise;
					},
					renameFlashReport: function (flashReportId, flashReportName) {
						return flashReportResource.renameFlashReport({
							flashReportId: flashReportId,
							flashReportName: flashReportName
						});
					},
					updateProcurementAllowanceImportedLine: function (updateRequest) {
						updateRequest.procurementSubscriptionUnitId = subscriptionUnitId;
						return procurementAllowanceImportedLineResource.update(updateRequest).$promise;
					},
					updateProcurementRevenueImportedLine: function (updateRequest) {
						updateRequest.procurementSubscriptionUnitId = subscriptionUnitId;
						return procurementRevenueImportedLineResource.update(updateRequest).$promise;
					},
					exportToExcel: function (request) {
						return flashReportResource.exportToExcel(request).$promise;
					},
					getRevenueAccountCodesForEachDept: function (flashReportId) {
						return flashReportResource.getRevenueAccountCodesForEachDept({ flashReportId: flashReportId }).$promise;
					},
					getSubscriptionUnitFlashReportAllowRebateLineStatus: function () {
						return $http.get(siteUrl() + "api/ProcurementSubscription/GetFlashReportAllowRebateLineStatus/" + procurementSubscriptionId);
					},
					setRebatesInSpendFlag: function (flashReportId, rebatesInSpendFlag) {
						return flashReportResource.setRebatesInSpendFlag({
							flashReportId: flashReportId,
							rebatesInSpendFlag: rebatesInSpendFlag
						}).$promise;
					},
					copyReport: function (request) {
						return $http.post(siteUrl() + "api/flashReports/copyReport", request);
					},
					changeReportDataSource: function (flashReportId, flashReportDataSourceId) {
						return flashReportResource.changeReportDataSource({
							flashReportId: flashReportId,
							flashReportDataSourceId: flashReportDataSourceId
						}).$promise;
					},
				}
			}
	]);
//CSH 091102018 This is just a way of communicating the state of the flash report controls to the department
//department detail controller
angular.module(appName)
	.factory("flashReportViewControlsService",
		["$q",
			function ($q) {
				var initDeferred = $q.defer();
				var accountPeriodId = null;
				var reportDateTo = null;
				var reportDateFrom = null;
				return {
					markInitComplete: function() {
						initDeferred.resolve();
					},
					reportDateFrom: reportDateFrom,
					reportDateTo: reportDateTo,
					accountPeriodId: accountPeriodId,
					initPromise: initDeferred.promise
				};
			}
		]);
angular.module(appName).factory('flashReportViewSpendDetailService', [
    'ngDialog',
    '$filter',
    'flashReportViewControlsService',
    'flashReportResource',
    'invoiceService',
    'enums',
    'organisationContext',
    '$translate',
    'enums',
    function(
        ngDialog,
        $filter,
        flashReportViewControlsService,
        flashReportResource,
        invoiceService,
        enums,
        organisationContext,
        $translate,
        enums
    ) {
		var dialog, dialogId;

        var service = {
            showingSpendDetail: false,
            showSpendDetail: function (showSpendArgs) {
                console.log('showSpendArgs', showSpendArgs);
				var self = this;
				self.showingSpendDetail = true
                showSpendArgs.labelData = {
                    supplierName: showSpendArgs.supplierName,
                    departmentName: showSpendArgs.departmentName,
                    cellDate: $filter('date')(showSpendArgs.date, 'd MMM yyyy'),
                }
                var asAtDate = moment(showSpendArgs.date, 'DD/MM/YYYY').format()
                var getSpendDetailRequest = {
                    flashReportId: showSpendArgs.reportId,
                    departmentId: showSpendArgs.departmentId,
                    accountingPeriodId:
                        flashReportViewControlsService.accountPeriodId,
                    accountingPeriodEndDate:
                        flashReportViewControlsService.reportDateTo,
                    asAtDate: asAtDate,
                    clientSupplierAccountId:
                        showSpendArgs.clientSupplierAccountId,
                    procurementClientUnitAccountCodeId:
                        showSpendArgs.expenseAccountCodeId,
                    includeExcludeVat: showSpendArgs.includeExcludeVat
                }
                if (dialogId) {
                    return
                }
                flashReportResource.getSpendDetail(getSpendDetailRequest)
                    .$promise.then(function(result) {
                        dialog = ngDialog.open({
                            template:
                                'Content/js/Modules/Reporting/UnitReports/FlashReporting/Services/flashReportViewSpendDetail.html',
                            disableAnimation: true,
                            showClose: false,
                            controller: [
                                '$scope',
                                function($scope) {
                                    $scope.clientUnitId = organisationContext.id;
                                    $scope.showVatFields = getSpendDetailRequest.includeExcludeVat == enums.flashReportIncludeExcludeVat.include;
									var acceptStatus = enums.invoiceStatus.Accepted;
									var rejectedStatus = enums.invoiceStatus.Rejected;
                                    $scope.acceptInvoice = function(i) {
                                        $scope.acceptingInvoice = true
                                        invoiceService
											.updateStatusWithoutDto(
												{
													procurementInvoiceHeaderId: i.itemId,
													statusId: acceptStatus,
												}
                                            )
                                            .then(function(r) {
                                                i.itemStatusId = acceptStatus
                                                $translate(
                                                    'invoice_accepted'
                                                ).then(function(translation) {
                                                    toastr.success(translation)
                                                })
                                            })
                                            .finally(function() {
                                                $scope.acceptingInvoice = false
                                            })
                                    }
                                    $scope.shouldDisableButtons = function() {
                                        return (
                                            $scope.rejectingInvoice ||
                                            $scope.acceptingInvoice
                                        )
									}
									$scope.getRejectReason = function (i) {
										i.showingRejectReason = true;
									}
									$scope.cancelInvoiceReject = function (i) {
										i.showingRejectReason = false;
									}
                                    $scope.canAcceptOrRejectWithItemStatus = function(
                                        itemStatusId
                                    ) {
                                        return (
                                            itemStatusId ==
                                                enums.invoiceStatus.Imported ||
                                            itemStatusId ===
                                                enums.invoiceStatus
                                                    .AwaitingAcceptance ||
                                            itemStatusId ==
                                                enums.invoiceStatus.Reconciled
                                        )
									}
									var init = function () {
										$scope.$on('reject-invoice-directive-invoice-rejected', function (event, procurementInvoiceId) {
											var rejectedInvoice = _.find($scope.ngDialogData.detail, function (i) {
												return i.itemId == procurementInvoiceId;
											});
											rejectedInvoice.itemStatusId = rejectedStatus;
											rejectedInvoice.showingRejectReason = false;
										});
									}
									init();
                                },
                            ],
                            width: 750,
                            data: {
                                args: showSpendArgs,
                                detail: result,
                            },
                        })
                        dialogId = dialog.id
                        dialog.closePromise.then(function() {
                            self.showingSpendDetail = false
                            dialogId = null
                        })
                    })
            },
        }
        return service
    },
])

angular.module(appName)
	.controller("unitStockReportController", [
		"$scope", "$http", "organisationContext", "$route", "validationHelper", "paginationFactory", "enums", "fileDownloadService",
		function($scope, $http, organisationContext, $route, validationHelper, paginationFactory, enums, fileDownloadService) {

			paginationFactory.addPaginationVariablesAndFunctionsToScope($scope);
			$scope.currencySymbol = organisationContext.currency.name;
			$scope.startDate = "";
			$scope.endDate = "";
			$scope.reportTypes = { group: 0, unit: 1 };
			var procurementSubscriptionId = organisationContext.id;
			var procurementSubscriptionUnitId = organisationContext.currentSubscriptionUnit.id;

			$scope.reportType = $route.current.$$route.originalPath.indexOf("GroupStockReport") > -1 ? $scope.reportTypes.group : $scope.reportTypes.unit;



			var baseUrl = '/api/stockReport/';



			var buildExportUrl = function () {
			    var url;
			    if ($scope.reportType === $scope.reportTypes.unit)
                    // Passing the subscriptionId for permissions
                    url = baseUrl + 'DownloadUnitStockReport?id=' + procurementSubscriptionId + '&unitId=' + procurementSubscriptionUnitId;
			    //else
       //             url = baseUrl + 'DownloadUnitStockReport?id=' + procurementSubscriptionId;
                
			    if (!$scope.startDate) $scope.startDate = '';
			    if (!$scope.endDate) $scope.endDate = '';
				
			    url += '&startDate=' + $scope.startDate + '&endDate=' + $scope.endDate;
			    return url;
			};


            $scope.downloadData = function () {
			    var exportUrl = buildExportUrl();
                fileDownloadService.downloadFile(exportUrl, "StockReport", "csv");
			};
		}
	])
angular.module(appName).controller('unitReportController', [
    '$scope', '$route', 'moment', '_', 'validationHelper', 'reportingService',
    'reportingGroupsService', 'organisationContextService', '$routeParams', 'unitNameData',
    '$filter', '$timeout', 'translateMessage',
    function($scope, $route, moment, _, validationHelper, reportingService,
        reportingGroupsService, organisationContextService, $routeParams, unitNameData,
        $filter, $timeout, translateMessage
    ) {
            var self = this;

            $scope.summaryEnum = {
                'unit': 0,
                'unit_number': 1,
                'period': 2,
                'budget_FCOS': 3,
                'target_FCOS': 4,
                'psl_supply': 5,
                'non_psl_supply': 6,
                'compliance': 7,
                'opening_stock': 8,
                'purchases': 9,
                'total_credits': 10,
                'closing_stock': 11,
                'consumption': 12,
                'revenue': 13,
                'fcos': 14,
                'over_underspend_to_budget': 15,
                'over_underspend_to_forecast': 16
            };

            $scope.moment = moment;
            $scope.reportingPeriods = [];
            $scope.report = {};

            unitNameData.$promise.then(function(unitName) {
                $scope.unitName = unitName.orgName;
            });

            $scope.hasValidDate = function() {
                // var date = angular.copy($scope.report.period);
                // return !validationHelper.isNullOrWhiteSpace(date) && moment(date, 'DD/MM/YYYY').isValid();
                return !validationHelper.isNullOrWhiteSpace($scope.report.period);
            };
            $scope.setDirtyWarning = function(element) {
                element.isDirty = true;
            };

            $scope.updateClosingStock = function(val) {
                if (!val || validationHelper.isDecimal(val))
                    return reportingService.updateClosingStockData($scope.procurementSubscriptionUnitId,
                        $scope.report.period.id,
                        val).$promise.then(function() {
                            translateMessage.success('closing_stock_has_been_updated');

                        return val;
                    });
            };

            $scope.formatCurrency = function (formatter) {
                if (formatter.value) {
                    return $filter(formatter.formatType)(formatter.value, 2);
                } else {
                    return formatter.value;
                }
            };

            $scope.updateTargetFcos = function(val) {
                if (!val || validationHelper.isDecimal(val))
                    return reportingService.updateTargetFcosData(
                        $scope.procurementSubscriptionUnitId,
                        $scope.report.period.id,
                        val
                    ).$promise.then(function() {
                            translateMessage.success('target_fcos_has_been_updated');
                            return val;
                        });
            };

            self.getTodayFormatted = function () {
                var now = moment();
                var month = now.format('M');
                var day = now.format('D');
                var year = now.format('YYYY');
                day = day.length === 1 ? '0' + day : day;
                month = month.length === 1 ? '0' + month : month;
                return day + '/' + month + '/' + year;
            };

            $scope.changeReportingPeriod = function () {
                $scope.report.reportDateTo = $scope.report.period.endDate;
                $scope.updateReportData();
            };

            function calculateActiveDateHeaders(data, dateToShow, activeGroup) {
                var indexOfDateWeWantToShow = _.indexOf(data.reportDateHeaders, dateToShow);
                var checker = -1;
                activeGroup.number = 0;
                while (checker <= indexOfDateWeWantToShow) {
                    activeGroup.number++;
                    checker = $scope.numberOfDatesToShow * activeGroup.number;
                }
                return data.reportDateHeaders.slice(checker - $scope.numberOfDatesToShow, checker);
            };

            self.setupSections = function (data) {
                //we need to make sure the final group is exactly divisible by (7)
                while (data.reportDateHeaders.length % $scope.numberOfDatesToShow !== 0) {
                    data.reportDateHeaders.push('');
                }

                var numberOfPages = Math.ceil(data.reportDateHeaders.length / $scope.numberOfDatesToShow);

                //we want a specific section to appear in the report when loaded.
                //Either the date from the url, or today's date depending
                $scope.todayFormatted = self.getTodayFormatted();

                var todayIsInTheReportingPeriod = _.contains(data.reportDateHeaders, $scope.todayFormatted);
                var activeGroup = {};
                var activeDateHeaders = calculateActiveDateHeaders(data, todayIsInTheReportingPeriod ? $scope.todayFormatted: $scope.report.reportDateTo, activeGroup);

                var sectionData = {
                    activeDateHeaders: activeDateHeaders,
                    activeGroupNumber: activeGroup.number,
                    numberOfPages: numberOfPages
                };
                return sectionData;
            }

            $scope.updateReportData = function() {
                if ($scope.report.period) {
                    $scope.loadingData = true;

                    reportingService
                        .getUnitReportData($scope.procurementSubscriptionUnitId,
                        $scope.report.period.id, $scope.report.reportDateTo)
                        .$promise.then(function (reportDto) {

                            var data = reportDto.data;
                            var summaryData = data.summaryData;
                            var reportData = data.reportData;
                            var rowTypeGroups = _.groupBy(reportData, 'rowType');

                            var activeSectionData = self.setupSections(data);

                            $scope.report =
                            {
                                allDateHeaders: data.reportDateHeaders,
                                activeDateHeaders: activeSectionData.activeDateHeaders,
                                datePage: activeSectionData.activeGroupNumber,
                                numberOfPages: activeSectionData.numberOfPages,
                                period: _.findWhere($scope.reportingPeriods,
                                    { id: $scope.report.period.id.toLowerCase() }),
                                credits: rowTypeGroups.Credit || [],
                                nonPslSuppliers: rowTypeGroups.NonPSL || [],
                                pslSuppliers: rowTypeGroups.PSL || [],
                                revenue: rowTypeGroups.Revenue || [],
                                reportDateTo: data.reportDateTo,
                                totalsRevenueAndFoodCost: rowTypeGroups.TotalsRevenueAndFoodCost || [],
                                supplierTotals: rowTypeGroups.TotalsSpend || [],
                                totalsCreditsAndNetCost: rowTypeGroups.TotalsCreditsAndNetCost || [],
                                summary: summaryData,
                                todayFormatted: $scope.todayFormatted,
                                totals: rowTypeGroups.Totals || []
                            };


                            if (rowTypeGroups.Rebates)
                                $scope.report.pslSuppliers.push(rowTypeGroups.Rebates[0]);

                            if (rowTypeGroups.StockMovement) {
                                $scope.report.pslSuppliers.push(rowTypeGroups.StockMovement[0]);
                            }

                            $scope.datePickerActive = true;
                            $scope.loadingData = false;
                        });
                }
            };

            $scope.nukeDatePicker = function () {
                $scope.report.reportDateTo = null;
                $scope.datePickerActive = false;

                $timeout(function () {
                    $scope.datePickerActive = true;
                    $scope.report.reportDateTo = $scope.report.period.endDate;
                }, 1);
            };

            self.init = function() {
                $scope.numberOfDatesToShow = 7;
                self.context = organisationContextService.getContext();
                $scope.loadingAccountingPeriods = true;
                $scope.procurementSubscriptionUnitId = $routeParams.procurementSubscriptionUnitId != null ?
                    $routeParams.procurementSubscriptionUnitId :
                    self.context.currentSubscriptionUnit.id;

                    reportingService.getAllReportingPeriodsForSubscriptionUnit(self.context.currentSubscriptionUnit.id).$promise
                        .then(function(periods) {
                            $scope.reportingPeriods = periods.data.reverse();
                            if ($routeParams.procurementSubscriptionAccountingPeriodId) {
                                $scope.report.period = _
                                    .findWhere($scope.reportingPeriods,
                                        { id: $routeParams.procurementSubscriptionAccountingPeriodId.toLowerCase() });
                            }
                            $scope.loadingAccountingPeriods = false;
                        })
                        .then(function () {
                            if ($routeParams.reportDateTo) {
                                $scope.reportDateFromUrl = $routeParams.reportDateTo.replace(/_/g, '/');
                                $scope.report.reportDateTo = $scope.reportDateFromUrl;
                                $scope.updateReportData();
                            } else {
                                $scope.report.reportDateTo = $scope.report.period ? $scope.report.period.endDate : null;
                                $scope.updateReportData();
                            }
                        });
            }();
    }
])
    //this directive is only relevant for the different sections on this report, so I put it in the same file.
    .directive('unitReportingSection', function() {
        var controller = [
            '_', '$scope', 'validationHelper',
            function(_, $scope, validationHelper) {
                    $scope.numberOfDatesToShow = 7;
                    $scope.validation = validationHelper;
                    $scope.paginateDates = function(direction) {

                        function calculateStartAndEnd() {
                            var startIndex = ($scope.report.datePage - 1) * $scope.numberOfDatesToShow;
                            var endIndex = startIndex + $scope.numberOfDatesToShow;

                            var obj = { start: startIndex, end: endIndex };
                            return obj;
                        }

                        if (direction === 'forwards' && $scope.report.datePage !== $scope.report.numberOfPages) {
                            $scope.report.datePage++;
                        };

                        if (direction === 'back' && $scope.report.datePage !== 1) {
                            $scope.report.datePage--;
                        };

                        var indexes = calculateStartAndEnd();
                        $scope.report.activeDateHeaders = $scope.report.allDateHeaders
                            .slice(indexes.start, indexes.end);
                    };



                }
        ];
        return {
            restrict: 'AE',
            scope: {
                report: '=',
                showHeaderRow: '=',
                arrayName: '@',
                title: '@',
                summaryTable: '='
            },
            templateUrl: '/ngxbeagle/dist/Content/js/Modules/Reporting/UnitReports/unitReportingSection.html',
            controller: controller
        };
    });

angular.module(appName)
    .controller('reportingGroupsListController', [
        '$scope', 'reportingGroupListData', 'reportingGroupsService', '$translate', 'userService',
        function ($scope, reportingGroupListData, reportingGroupsService, $translate, userService) {
            var self = this;
            $scope.hasDeletePermission = false;

            $scope.deleteReportingGroup = function(reportingGroup) {
                reportingGroupsService.remove(reportingGroup)
                    .$promise.then(function() {
                        $translate('label_reporting_groups_removed_success', { reportingGroupName: reportingGroup.name })
                            .then(function(translation) {
                                toastr.success(translation);
                                $scope.reportingGroups.remove(reportingGroup);
                            });
                    });
            }

            reportingGroupListData.$promise.then(function(data) {
                console.log('Loaded: ', data);
                $scope.reportingGroups = data;
            });

            userService.hasPermission('BEAGLE_REPORTINGGROUPS_DELETE').then(function() {
                $scope.hasDeletePermission = true;
            });
        }
    ]);




angular.module(appName)
    .factory('reportingGroupsResource', [
        '$resource', 'siteUrl',
        function($resource, siteUrl) {
            var api = siteUrl() + 'api/ReportingGroup';

            return $resource(api, {},
            {
                getReportingGroups: {
                    method: 'GET',
                    url: api + '/GetReportingGroups',
                    params: {
                        id: '@id',
                        includeUnits: '@includeUnits'
                    },
                    isArray: true
                },
                getReportingGroupData: {
                    method: 'GET',
                    url: api + '/GetReportingGroupData',
                    params: {
                        id: '@id'
                    }
                },
                add: {
                    method: 'POST',
                    url: api + '/Add'
                },
                update: {
                    method: 'POST',
                    url: api + '/Update'
                },
                remove: {
                    method: 'DELETE',
                    url: api + '/Delete',
                    params: { reportingGroupId: '@reportingGroupId' }
                },
                addUnitsToReportingGroup: {
                    method: 'POST',
                    url: api + '/AddUnitsToReportingGroup',
                    isArray: true
                },
                removeUnitFromReportingGroup: {
                    method: 'POST',
                    url: api + '/RemoveUnitFromReportingGroup'
                }
            });
        }
    ])
angular.module(appName)
    .factory('reportingGroupsService', [
        'reportingGroupsResource', 'localStorageService', 'enums',
        function (reportingGroupsResource, localStorageService, enums) {
            var self = this;
            self.headOfficeOrganisationId = localStorageService.getItem(enums.localStorage.organisationContext).organisation.id;


            var service = {
                add: function (reportingGroup) {
                    reportingGroup.organisationId = self.headOfficeOrganisationId;
                    return reportingGroupsResource.add(reportingGroup);
                },
                update: function (reportingGroup) {
                    reportingGroup.organisationId = self.headOfficeOrganisationId;
                    return reportingGroupsResource.update(reportingGroup);
                },
                remove: function(reportingGroup) {
                    return reportingGroupsResource.remove({ id: reportingGroup.id });
                },
                addUnitsToReportingGroup: function (obj) {
                    obj.organisationId = self.headOfficeOrganisationId;
                    return reportingGroupsResource.addUnitsToReportingGroup(obj);
                },
                removeUnitFromReportingGroup: function (reportingGroupId, unitId) {
                    var obj = {
                        reportingGroupId: reportingGroupId,
                        unitId: unitId,
                        organisationId: self.headOfficeOrganisationId
                    }
                    return reportingGroupsResource.removeUnitFromReportingGroup(obj);
                },
                getReportingGroups: function (subscriptionId, includeUnits) {
                    return reportingGroupsResource.getReportingGroups({ id: subscriptionId, includeUnits: includeUnits });
                },
                getReportingGroupData: function(reportingGroupId) {
                    return reportingGroupsResource.getReportingGroupData({ id: reportingGroupId });
                }
            }

            return service;
        }
    ]);
angular.module(appName)
    .controller('reportingGroupsViewController', [
        '$scope', 'reportingGroupData', '$route', '$translate', 'windowService', 'toastr', 'reportingGroupsService', 'validationHelper', 'organisationContextService', 'clientUnitService',
        function ($scope, reportingGroupData, $route, $translate, windowService, toastr, reportingGroupsService, validationHelper, organisationContextService, clientUnitService) {
            $translate.onReady().then(function() {
                var self = this;
                $scope.reportingGroup = $scope.reportingGroup || {};
                self.ctx = organisationContextService.getContext();
                self.unitsToAdd = self.unitsToAdd || [];
                self.setupGroupProperties = function(group) {
                    $scope.reportingGroup.id = group.id;
                    $scope.reportingGroup.name = group.name;
                    $scope.reportingGroup.newName = group.name;
                    $scope.reportingGroup.reportingGroupUnits =
                        $scope.reportingGroup.reportingGroupUnits || group.reportingGroupUnits || [];
                }

                self.showSaveSuccessToast = function() {
                    $translate('message_saved', { item: 'Reporting Group' }).then(function(translation) {
                        toastr.success(translation);
                    });
                }

                self.filterUnits = function() {
                    $scope.subscriptionUnits = _.filter($scope.subscriptionUnits,
                        function(unit) {
                            return !_.findWhere($scope.reportingGroup.reportingGroupUnits,
                                { procurementSubscriptionUnitId: unit.id });
                        });
                }

                $scope.subscriptionUnitCallback = function(unit) {
                    if (unit.isSelected) {
                        self.unitsToAdd.push(unit);
                    } else {
                        self.unitsToAdd.remove(unit);
                    }
                }

                $scope.isEditing = function() {
                    return $route.current.params.reportingGroupId != null ||
                        !validationHelper.isNullOrWhiteSpace($scope.reportingGroup.id);
                }

                $scope.cancel = function() {
                    windowService.reportingGroups();
                    return false;
                }

                $scope.disableSave = function() {
                    var isInvalid =
                        $scope.saving ||
                            validationHelper.isNullOrWhiteSpace($scope.reportingGroup.newName);
                    return isInvalid;
                }

                $scope.addUnitsToReportingGroup = function() {
                    if (self.unitsToAdd.length > 0) {
                        var unitIds = _(self.unitsToAdd).pluck('id');
                        var obj = {
                            reportingGroupId: $scope.reportingGroup.id,
                            unitIds: unitIds
                        }

                        reportingGroupsService.addUnitsToReportingGroup(obj)
                            .$promise.then(function(units) {
                                toastr.success($translate.instant('label_reporting_groups_add_unit_success',
                                    { reportingGroupName: $scope.reportingGroup.name }));

                                for (var i = 0; i < units.length; i++) {
                                    $scope.reportingGroup.reportingGroupUnits.push(units[i]);
                                }
                                self.unitsToAdd = [];
                                self.filterUnits();
                            });
                    }
                }

                $scope.removeUnitFromReportingGroup = function(unit) {
                    reportingGroupsService.removeUnitFromReportingGroup($scope.reportingGroup.id, unit.id)
                        .$promise.then(function() {
                            self.filterUnits();
                            $translate('label_reporting_groups_removed_success',
                                    {
                                        unitName: unit.procurementSubscriptionUnit.organisation.name,
                                        reportingGroupName: $scope.reportingGroup.name
                                    })
                                .then(function(translation) {
                                    toastr.success(translation);
                                    $scope.reportingGroup.reportingGroupUnits.remove(unit);

                                    var unitToReaddToList = _.findWhere(self.subscriptionUnitsBackup,
                                        { id: unit.procurementSubscriptionUnitId });
                                    unitToReaddToList.isSelected = false;
                                    $scope.subscriptionUnits.push(unitToReaddToList);
                                    self.filterUnits();
                                });
                        });
                }

                // Save the reporting group name
                $scope.save = function() {
                    var reportingGroupToSave = angular.copy($scope.reportingGroup);
                    $scope.saving = true;
                    if (validationHelper.isNullOrWhiteSpace($scope.reportingGroup.newName))
                        return;

                    reportingGroupToSave.name = reportingGroupToSave.newName;

                    if (validationHelper.isNullOrWhiteSpace(reportingGroupToSave.id)) {
                        // new reporting group
                        reportingGroupsService.add(reportingGroupToSave)
                            .$promise.then(function(savedGroup) {
                                    // We don't want to just set the whole object because we will overwrite the units if we do
                                    self.setupGroupProperties(savedGroup);
                                    self.showSaveSuccessToast();
                                    windowService.viewReportingGroups(savedGroup.id);
                                    $scope.saving = false;
                                },
                                function(err) {
                                    console.log('Error: ', err);
                                    $scope.saving = false;
                                });
                    } else {
                        // saving existing reporting group
                        reportingGroupsService.update(reportingGroupToSave)
                            .$promise.then(function(savedGroup) {
                                    // We don't want to just set the whole object because we will overwrite the units if we do
                                    self.setupGroupProperties(savedGroup);
                                    self.showSaveSuccessToast();
                                    $scope.saving = false;
                                },
                                function(err) {
                                    console.log('Error: ', err);
                                    $scope.saving = false;
                                });
                    }
                }

                reportingGroupData.$promise.then(function(data) {
                    $scope.reportingGroup = data;
                    $scope.reportingGroup.newName = data.name;
                    debugger;
                    $scope.reportingGroup
                        .procurementSubscriptionId = $scope.reportingGroup.procurementSubscriptionId || self.ctx.id;

                    clientUnitService.getAllProcurementUnitDtosForSubscription(self.ctx.id).$promise.then(
                        function(units) {
                            self.subscriptionUnitsBackup = angular.copy(units);
                            $scope.subscriptionUnits = units;
                            self.filterUnits();
                        });
                });
            });
        }
    ]);




angular.module(appName)
    .controller('revenueController', [
        '$scope',
        '$rootScope',
        '$q',
        'enums',
        'revenueService',
        'toastr',
        '_',
        '$routeParams',
        'localStorageService',
        'revenueImportContext',
        '$translate',
        function (
                $scope,
                $rootScope,
                $q,
                enums,
                revenueService,
                toastr,
                _,
                $routeParams,
                localStorageService,
                revenueImportContext,
                $translate
            ) {

            var self = this;
            self.contextTypes = {
                unit: 'UNIT',
            }

            $scope.goToUploadMode = function () {
                $scope.uploadMode = true;
                $scope.validationErrorMode = false;
            };

            $scope.goToValidationErrorMode = function () {
                $scope.validationErrorMode = true;
                $scope.uploadMode = false;
            };

            function translateSuccessToast(key) {
                return $translate(key).then(function (translation) {
                    return toastr.success(translation);
                });
            };

            $scope.processRevenueFile = function (uploadedFile) {

                var dto = {
                    documentId: uploadedFile.id,
                    id: $scope.context.id
                };

                if ($scope.revenueImportContext === self.contextTypes.unit) {
                    dto.id = $scope.context.currentSubscriptionUnit.id;
                    dto.procurementSubscriptionUnitId = $scope.context.currentSubscriptionUnit.id;
                    dto.procurementSubscriptionId = $scope.context.id;
                    var promise = revenueService.processUnitRevenueFile(dto).$promise;
                } else {
                    var promise = revenueService.processRevenueFile(dto).$promise;
                }
                var deferred = $q.defer();

                promise.then(function(validationData) {
                    if (validationData.validationErrors && validationData.validationErrors.length > 0) {
                        $scope.validationErrors = validationData.validationErrors;
                        $scope.goToValidationErrorMode();
                    } else {
                        translateSuccessToast('file_import_success');
                        $scope.numberOfImportedRows = validationData.numberOfImportedRows;
                        $rootScope.$broadcast(enums.broadcasts.fileImported);
                        $scope.goToUploadMode();
                    }

                    deferred.resolve();
                },function(error) {
                    $scope.goToUploadMode();

                    deferred.resolve();
                });
                return deferred.promise;
            };

            $scope.init = function () {
                $scope.goToUploadMode();
                $scope.context = localStorageService.getItem(enums.localStorage.organisationContext);
                $scope.revenueImportContext = revenueImportContext;
                $scope.idParam = revenueImportContext === self.contextTypes.unit ? $scope.context.currentSubscriptionUnit.id : $scope.context.currentSubscriptionUnit.procurementSubscriptionId;
            }();
        }]);

angular.module(appName)
    .factory('revenueResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/Revenue';
            return $resource(api,
            {},
            {
                processRevenueFile: {
                    method: "POST",
                    url: api + "/ProcessFile"
                },
                processUnitRevenueFile: {
                    method: "POST",
                    url: api + "/ProcessUnitRevenueFile"
                }
                
                
            });
        }
    ])
angular.module(appName)
    .factory('revenueService', [
        'revenueResource','$window',
        function (revenueResource, $window) {
            return {
                processRevenueFile: function (dto) {
                    return revenueResource.processRevenueFile(dto);
                },
                processUnitRevenueFile: function (dto) {
                    return revenueResource.processUnitRevenueFile(dto);
                }
            };
        }
    ]);
'use strict';

angular.module(appName)
    .controller('rolesController', ['$scope',"data",
        function ($scope,data) {

            $scope.data = data;
            $scope.init = function () {

            }();
        }]);
angular.module(appName)
    .controller("sectionLandingPageController", [
        "$location", "$scope",
        function ($location, $scope) {
            var path = $location.path();
            $scope.section = null;
            $scope.image = null;
            _.each(window.beagle.routes, function (route) {
               
                if (route.path == path) {
                    console.log(route);
                    $scope.section = route;
                    $scope.section.image = route.image;
                } else {
                    $scope.image = route.image;
                    _.each(route.children, function (childRoute) {
                        if (childRoute.path === path) {
                            $scope.section = childRoute;
                        };
                    });
                }
                return route.path === path;
            });
        }
    ]);
angular.module(appName)
    .controller('searchServicePeriodTypesController', [
        '$scope', '$q', '$filter', '$timeout', '$translate', 'servicePeriodTypesData', 'servicePeriodTypesService', '_', 'localStorageService', 'enums',
        function ($scope, $q, $filter, $timeout, $translate, servicePeriodTypesData, servicePeriodTypesService, _, localStorageService, enums) {
            $translate.onReady().then(function() {
                var self = this;
                self.resolves = {
                    servicePeriodTypes: servicePeriodTypesData
                };

                self.resetServicePeriodType = function(servicePeriodType) {
                    if (servicePeriodType.isEditing) {
                        servicePeriodType.originalName = servicePeriodType.name;
                    } else {
                        servicePeriodType.name = servicePeriodType.originalName;
                    }
                };

                $q.all(self.resolves).then(function(resolved) {
                    $scope.servicePeriodTypes = _.sortBy(resolved.servicePeriodTypes, 'name');
                    $scope.filterObject = servicePeriodTypesService.getSearchParams();

                    $scope.showBack = function() {
                        return window.history.length > 1;
                    };

                    $scope.clearFilter = function() {
                        localStorageService.removeItem(enums.localStorage.servicePeriodTypesSearch);
                        $scope.filterObject = servicePeriodTypesService.getSearchParams();
                        $scope.filter($scope.filterObject);
                    };

                    $scope.filter = function(filter) {
                        var filteredServicePeriodTypes = _.filter(self.servicePeriodTypes,
                            function(spt) {
                                // spt = servicePeriodType
                                if (!filter.term) {
                                    return true;
                                } else {
                                    return spt.name.toLowerCase().indexOf(filter.term.toLowerCase()) > -1;
                                }
                            });

                        $timeout(function() {
                                $scope.servicePeriodTypes = filteredServicePeriodTypes;
                                localStorageService.setItem(enums.localStorage.servicePeriodTypesSearch,
                                    $scope.filterObject);
                            },
                            0);
                    };

                    $scope.addEmptyServicePeriodType = function() {
                        if (!_.findWhere($scope.servicePeriodTypes, { servicePeriodTypeId: 0 })) {
                            var newServicePeriodType = {
                                servicePeriodTypeId: 0,
                                name: ''
                            };
                            $scope.servicePeriodTypes.unshift(newServicePeriodType);
                            $scope.toggleEditOnServicePeriodType(newServicePeriodType, true);
                        }
                    };

                    $scope.deleteServicePeriodType = function(servicePeriodType) {
                        servicePeriodTypesService.deleteServicePeriodType(servicePeriodType).then(function() {
                            toastr.success($translate.instant('service_period_type_deleted'));
                            _.removeIfExists($scope.servicePeriodTypes, servicePeriodType);
                            _.removeIfExists(self.servicePeriodTypes,
                                servicePeriodType,
                                { servicePeriodTypeId: servicePeriodType.servicePeriodTypeId });
                        });
                    };

                    $scope.isUnique = function(servicePeriodType) {
                        return _.find($scope.servicePeriodTypes,
                                function(spt) {
                                    return servicePeriodType.servicePeriodTypeId !== spt.servicePeriodTypeId &&
                                        servicePeriodType.name.toLowerCase() === spt.name.toLowerCase();
                                }) ==
                            null;
                    };

                    $scope.saveServicePeriodType = function(servicePeriodType) {
                        return servicePeriodTypesService.save(servicePeriodType).then(function(savedServicePeriodType) {
                            _.removeIfExists($scope.servicePeriodTypes, servicePeriodType);
                            savedServicePeriodType.originalName = savedServicePeriodType.name;
                            servicePeriodType = savedServicePeriodType;
                            toastr.success($translate.instant('success_saved_service_period_type'));
                            _.pushIfNotExists($scope.servicePeriodTypes, savedServicePeriodType, 'servicePeriodTypeId');
                            _.pushIfNotExists(self.servicePeriodTypes, savedServicePeriodType, 'servicePeriodTypeId');
                        }).finally(function() {
                            servicePeriodType.isEditing = false;
                        });
                    };

                    $scope.toggleEditOnServicePeriodType = function(servicePeriodType, isEditing) {
                        var openServicePeriodType = _.findWhere($scope.servicePeriodTypes,
                            { isEditing: true });
                        if (openServicePeriodType) {
                            if (openServicePeriodType.servicePeriodTypeId === 0) {
                                _.removeIfExists($scope.servicePeriodTypes,
                                    openServicePeriodType);
                            }
                            openServicePeriodType.isEditing = false;
                            self.resetServicePeriodType(openServicePeriodType);
                        }
                        servicePeriodType.isEditing = isEditing;
                        self.resetServicePeriodType(servicePeriodType);
                    };

                    $scope.init = function() {
                        self.servicePeriodTypes = angular.copy($scope.servicePeriodTypes);

                        $scope.filter($scope.filterObject);
                    }();
                });
            });
        }]);
angular.module(appName)
    .factory('servicePeriodTypesResource', [
        '$resource', 'siteUrl',
        function ($resource, siteUrl) {
            var api = siteUrl() + 'api/ServicePeriodTypes';

            return $resource(api, {},
                {
                    create: {
                        method: 'POST',
                        url: api + '/CreateServicePeriodType'
                    },
                    delete: {
                        method: 'DELETE',
                        url: api + '/Delete'
                    },
                    getAll: {
                        method: 'GET',
                        url: api + '/GetAll',
                        isArray: true
                    },
                    save: {
                        method: 'PUT',
                        url: api + '/UpdateServicePeriodType'
                    }
                });
        }
    ])
angular.module(appName)
    .factory('servicePeriodTypesService', [
        'servicePeriodTypesResource', 'organisationContextService', 'localStorageService', '_', 'enums',
        function (servicePeriodTypesResource, organisationContextService, localStorageService, _, enums) {

            var ctx = organisationContextService.getContext();
            var currentSubscriptionUnitClientId = ctx.currentSubscriptionUnit.client.id;
            var orgId = ctx.currentSubscriptionUnit.organisation.id;
            var defaultSearchParams = {
                term: '',
            }

            var deleteServicePeriodType = function (servicePeriodType) {
                var obj = {
                    id: currentSubscriptionUnitClientId,
                    servicePeriodTypeId: servicePeriodType.servicePeriodTypeId
                };
                return servicePeriodTypesResource.delete(obj).$promise;
            }

            var getSearchParams = function () {
                var searchParams = localStorageService.getItem(enums.localStorage.servicePeriodTypesSearch) || angular.copy(defaultSearchParams);
                return searchParams;
            }

            var getAll = function (searchParams) {
                // Id Used for IBelongTo on Client
                return servicePeriodTypesResource.getAll({
                    id: currentSubscriptionUnitClientId
                }).$promise;
            }

            var save = function (servicePeriodType) {
                // Used for IBelongTo on Client
                servicePeriodType.id = currentSubscriptionUnitClientId;
                if (servicePeriodType.servicePeriodTypeId) {
                    return servicePeriodTypesResource.save(servicePeriodType).$promise;
                } else {
                    return servicePeriodTypesResource.create(servicePeriodType).$promise;
                }
            }

            return {
                deleteServicePeriodType: deleteServicePeriodType,
                getSearchParams: getSearchParams,
                getAll: getAll,
                save: save
            }
        }
    ]);
angular.module(appName)
    .controller("setLoginController", [
      "$rootScope", "$http", "$timeout", "localStorageService", "userLanguageService",
        function ($rootScope, $http, $timeout, localStorageService, userLanguageService) {
            var addLogin = function () {
                $http.post("/api/User/AddLoginHistory", {})
                    .then(function (response) {
                        var language = response.data.language.code;
                        userLanguageService.setCulture(language);
                        localStorageService.setItem('company', response.data.company.name);
                        $timeout(function () {
                            window.location = '/MyUnits';    
                        }, 1000);                        
                    });
            };
            addLogin();
        }
    ]);
angular.module(appName)
    .controller('shoppingListCreatePageController', [
        '$scope', '$location', '$q', 'shoppingListService', 'shoppingListViewData', 'userDepartmentData', 'userAccountCodeData' , 'localStorageService', 'windowService', 'enums',
        function ($scope, $location, $q, shoppingListService, shoppingListViewData, userDepartmentData, userAccountCodeData, localStorageService, windowService, enums) {
            $scope.showSetupshoppingList = false;
            self.resolves = {
                shoppingListViewData: shoppingListViewData,
                userDepartmentData: userDepartmentData,
                userAccountCodeData: userAccountCodeData
            }
            self.ctx = localStorageService.getItem(enums.localStorage.organisationContext);
            $scope.currentProcurementSubscriptionId = ctx.currentSubscriptionUnit.id;
                $scope.userId = ctx.user.id;

            self.setupShoppingList = function (shoppingList) {
                $scope.currentShoppingList = shoppingList;
                $scope.showSetupshoppingList = true;
            }

            $scope.init = function () {
                $q.all(self.resolves).then(function(results) {
                    self.setupShoppingList(results.shoppingListViewData);
                    $scope.userDepartments = results.userDepartmentData;
                    $scope.userAccountCodes = results.userAccountCodeData;
                });
            }();
        }]);
angular.module(appName)
    .controller('shoppingListListPageController',
        [
            '$scope', '$q', '$timeout', '$location', '$filter', 'shoppingListData', 'enums', 'localStorageService', 'basketService', '$translate', 'toastr',
            'organisationContextService', 'shoppingListService', 'userService',
            function ($scope, $q, $timeout, $location, $filter, shoppingListData, enums, localStorageService, basketService, $translate, toastr,
                organisationContextService, shoppingListService, userService) {
                var self = this;
                self.resolves = {
                    shoppingListData: shoppingListData,
                    //userDepartmentData: userDepartmentData,
                    //userAccountCodeData: userAccountCodeData
                }
                self.ctx = organisationContextService.getContext();
                $scope.shoppingListFilter = {};
                $scope.hrefs = shoppingListService.hrefs;
                
                $scope.copyDialog = {
                    shoppingList: {},
                    availableUnits: null,
                    copyType: enums.shoppingListCopyTypes.currentUnit,
                    currentUnit: {
                        id: self.ctx.currentSubscriptionUnit.id,
                        name: self.ctx.currentSubscriptionUnit.client.name
                    },
                    selectedUnits: [],
                    unitsNeedingAttention: [],
                    show: false,
                    copy: function() {
                        var dlg = this;
                        if (dlg.copyType == enums.shoppingListCopyTypes.currentUnit) {
                            dlg.selectedUnits = [dlg.currentUnit];
                        }
                        return shoppingListService.copy(dlg.shoppingList, dlg.selectedUnits).then(function(resp) {
                            if (resp.length) {
                                $translate('label_shopping_list_copied_success').then(function(t) {
                                    toastr.success(t);
                                    var containsCurrentUnit = dlg.copyType == enums.shoppingListCopyTypes.currentUnit ||
                                        _.findWhere(dlg.selectedUnits, { id: dlg.currentUnit.id });
                                    if (containsCurrentUnit) {
                                        shoppingListService.get(self.ctx.currentSubscriptionUnit.id,
                                                self.ctx.currentSubscriptionUnit.organisation.id).$promise
                                            .then(function(results) {
                                                self.setupShoppingListDateTimes(results);
                                                $scope.filteredSortedShoppingLists = self.shoppingLists;
                                                $scope.filterSortPaginateShoppingLists($scope.shoppingListFilter);
                                            });
                                    }
                                    dlg.unitsNeedingAttention = _.filter(dlg.selectedUnits,
                                        function(u) {
                                            return _.contains(resp, u.id);
                                        });
                                });
                            } else {
                                $translate('label_shopping_list_copied_success').then(function(t) {
                                    shoppingListService.get(self.ctx.currentSubscriptionUnit.id,
                                        self.ctx.currentSubscriptionUnit.organisation.id).$promise
                                        .then(function(results) {
                                            self.setupShoppingListDateTimes(results);
                                            $scope.filteredSortedShoppingLists = self.shoppingLists;
                                            $scope.filterSortPaginateShoppingLists($scope.shoppingListFilter);
                                            toastr.success(t);
                                            dlg.toggle();
                                        });
                                });
                            }
                            // Handle response
                        });
                    },
                    selectDeselect: function (unit) {
                        var dlg = this;
                        // TODO: select/deselect unit
                        if (unit.isSelected) {
                            dlg.selectedUnits.push(unit);
                        } else {
                            dlg.removeUnit(unit);
                        }
                    },
                    removeUnit: function (unit) {
                        var dlg = this;
                        unit.isSelected = false;
                        var selectedUnit = _.findWhere(dlg.selectedUnits,
                            function(u) {
                                return u.id == unit.id;
                            });
                        dlg.selectedUnits.remove(selectedUnit);
                    },
                    toggle: function(shoppingList) {
                        var dlg = this;
                        if (shoppingList) {
                            dlg.loadingUnits = true;
                            shoppingListService.getUnitsForShoppingListCopy(shoppingList.id).then(function(units) {
                                    dlg.availableUnits = units;

                                    _.each(dlg.selectedUnits,
                                        function(selectedUnit) {
                                            var unitSelected = _.find(dlg.availableUnits, { id: selectedUnit.id });
                                            if (unitSelected) {
                                                unitSelected.isSelected = true;
                                            } else {
                                                dlg.selectedUnits.remove(selectedUnit);
                                            };
                                        });
                                })
                                .finally(function() {
                                    dlg.loadingUnits = false;
                                });
                            dlg.shoppingList = shoppingList;
                        }
                        dlg.unitsNeedingAttention = [];
                        dlg.show = !dlg.show;
                    }
                };

                $scope.filterSortPaginateShoppingLists = function (filter) {
                    var hasTerm = filter.term != '';
                    var filteredShoppingLists = _.filter(self.shoppingLists,
                        function (shoppingList) {
                            if (filter.term == '' || !shoppingList.name) {
                                return true;
                            } else {
                                return shoppingList.name.toLowerCase().indexOf(filter.term.toLowerCase()) >= 0
                            }
                        });
                    if ($scope.sortOn.filterExpr) {
                        filteredShoppingLists = $filter('orderBy')(filteredShoppingLists, [$scope.sortOn.filterExpr, '-isoDate']);
                    } else {
                        filteredShoppingLists = $filter('orderBy')(filteredShoppingLists, ['+name', '-isoDate']);
                    }

                    // MB: We had to use a timeout here due to tracking $scope.$emit events.
                    //     Things were being fired before expected behaviour had occurred
                    $timeout(function () {
                        $scope.filteredSortedShoppingLists = filteredShoppingLists;
                        localStorageService.setItem(enums.localStorage.shoppingListSearch, filter);
                    });
                }

                $scope.deleteshoppingList = function (shoppingList) {
                    shoppingList.isDeleting = true;
                    shoppingListService.deleteShoppingList(shoppingList.id).then(function (data) {
                        if (data.success) {
                            $translate('label_shopping_list_deleted').then(function (translation) {
                                toastr.success(translation);
                            });
                            $scope.filteredSortedShoppingLists = _.without($scope.filteredSortedShoppingLists, shoppingList);
                            self.shoppingLists = _.without(self.shoppingLists, shoppingList);
                            //$scope.filteredSortedShoppingLists = self.applyFilters(self.showOpenshoppingLists, self.showSubmittedshoppingLists);
                        } else {
                            $translate('error_shoppingList_delete_generic').then(function (translation) {
                                toastr.error(translation);
                            });
                        }

                        shoppingList.isDeleting = false;
                    });
                }

                $scope.searchProducts = function (shoppingListId) {
                    window.location = '/ProductSearch/' + shoppingListId + '/' + enums.procurementBasketType.ShoppingList;
                }

                $scope.getViewshoppingListUrl = function (shoppingListId) {
                    var url = '/ShoppingLists/view/' + shoppingListId;
                    return url;
                }

				$scope.toggleSetupShoppingList = function () {
					createBasketFromShoppingList
                    $location.path('/ShoppingLists/Create');
                }

                $scope.download = function (basket) {
                    basket.downloading = true;
                    shoppingListService.downloadShoppingList(basket).then(function (shoppingList) {
                        basket.downloading = false;
                    }, function (err) {
                        basket.downloading = false;
                    });
                }

                $scope.copy = function (shoppingList) {
                    $scope.copyDialog.toggle(shoppingList);
                }

                self.initTestData = function () {

                    $scope.filteredSortedShoppingLists = [
                        {
                            id: 'E6F7D767-E53C-44E5-B1FF-76788A905BFD',
                            name: 'My first shopping list',
                            departmentDescription: $scope.userDepartments[0].departmentDescription,
                            accountCodeDescription: $scope.userAccountCodes[0].description,
                            totalPrice: 50.70,
                            numberOfItems: 0
                        }
                    ];
                }

                $scope.toggleActions = function (shoppingList) {
                    shoppingList.promptAreYouSure = false;
                    shoppingList.showActions = !shoppingList.showActions;
                }

                self.setupShoppingListDateTimes = function(shoppingLists) {
                    self.shoppingLists = _.sortBy(shoppingLists, function (x) {
                        x.isoDate = moment(x.dateCreated);
                        if (x.name == null) {
                            return x.name;
                        } else {
                            return x.name.toLowerCase();
                        }
                    });
                }

                $scope.$on(enums.eventNames.sortOnElementChangedEventName, function (event, changingElement) {
                    $scope.filterSortPaginateShoppingLists($scope.shoppingListFilter);
                });

                self.init = function () {
                    $q.all(self.resolves).then(function (results) {
                        //$scope.userDepartments = results.userDepartmentData;
                        //$scope.userAccountCodes = results.userAccountCodeData;
                        //$scope.filteredSortedShoppingLists = results.shoppingListData;
                        self.setupShoppingListDateTimes(results.shoppingListData);
                        var storedFilters = localStorageService.getItem(enums.localStorage.shoppingListSearch);
                        if (storedFilters) {
                            $scope.shoppingListFilter = storedFilters;
                        } else {
                            $scope.shoppingListFilter = {
                                term: ''
                            }
                        }

                        userService.hasPermission('BEAGLE_PROCUREMENT_SHOPPING_LISTS_VIEW').then(
                            function() {
                                $scope.hasViewPermission = true;
                            });

                        userService.hasPermission('BEAGLE_PROCUREMENT_SHOPPING_LISTS_ADD').then(
                            function () {
                                $scope.hasAddPermission = true;
                            });
                        userService.hasPermission('BEAGLE_PROCUREMENT_SHOPPING_LISTS_EDIT').then(
                            function () {
                                $scope.hasEditPermission = true;
                            });

                        userService.hasPermission('BEAGLE_PROCUREMENT_SHOPPING_LISTS_DELETE').then(
                            function() {
                                $scope.hasDeletePermission = true;
                            });

                        $scope.filteredSortedShoppingLists = self.shoppingLists;
                        $scope.filterSortPaginateShoppingLists($scope.shoppingListFilter);
                    });
                }();
            }
        ]);
'use strict';

angular.module(appName)
    .factory('shoppingListResource', [
        '$resource', "siteUrl", function ($resource, siteUrl) {
            var api = siteUrl() + "api/shoppingList";
            return $resource(api, {},
            {
                addBasketItem: {
                    method: 'POST',
                    url: api + '/AddBasketItem'
                },
                get: {
                    method: "GET",
                    url: api + '/Get',
                    params: {
                        subscriptionUnitId: "@subscriptionUnitId",
                        organisationId: "@organisationId"
                    },
                    isArray: true
                },
                getSingleShoppingList: {
                    method: 'GET',
                    url: api + '/GetSingleShoppingList',
                    params: {
                      shoppingListId: '@shoppingListId',
                      subscriptionUnitId: '@subscriptionUnitId',
                      organisationId: "@organisationId",
                      updatePrices: '@updatePrices'
                    }
                },
                getShoppingListDataForProductSearch: {
                    method: 'GET',
                    url: api + '/getShoppingListDataForProductSearch',
                    params: {
                        shoppingListId: '@shoppingListId',
                        subscriptionUnitId: '@subscriptionUnitId',
                        organisationId: "@organisationId",
                        segmentId: "@segmentId"
                    }
                },
                getUnitsForShoppingListCopy: {
                    method: 'GET',
                    url: api + '/getUnitsForShoppingListCopy',
                    params: {
                        shoppingListId: '@shoppingListId',
                        organisationId: '@organisationId'
                    },
                    isArray: true
                },
                copyShoppingList: {
                    method: "POST",
                    url: api + "/Copy",
                    isArray: true
                },
                create: {
                    method: "POST",
                    url: api + "/Create"
                },
                update: {
                    method: "POST",
                    url: api + "/Update"
                },
                deleteShoppingList: {
                    method: "POST",
                    url: api + "/Delete"
                },
                replaceBasketItem: {
                    method: "POST",
                    url: api + '/ReplaceBasketItem'
                }
            });
        }
    ]);

angular.module(appName)
  .factory("shoppingListService",
    [
      '$q',
      'cachedEntityService',
      "shoppingListResource",
      "$http",
      "organisationContextService",
      "fileDownloadService",
      'replaceProductService',
      'procurementSegmentItemService',
      'siteUrl',
      'enums',
      function ($q,
                cachedEntityService,
                shoppingListResource,
                $http,
                organisationContextService,
                fileDownloadService,
                replaceProductService,
                procurementSegmentItemService,
                siteUrl,
                enums) {
        var ctx = organisationContextService.getContext();

        var addBasketItem = function (basketItem) {
          basketItem.organisationId = organisationContextService.getOrganisationIdForCurrentProcurementUnit();
          return shoppingListResource.addBasketItem(basketItem);
        };

        var get = function (subscriptionUnitId, organisationId) {
          return shoppingListResource.get({
            subscriptionUnitId: subscriptionUnitId,
            organisationId: organisationId
          });
        };

        var downloadShoppingList = function (shoppingList) {
          var context = organisationContextService.getContext();
          var url = '/api/ShoppingList/downloadShoppingList?organisationId=' + context.currentSubscriptionUnit.organisation.id + '&shoppingListId=' + shoppingList.id;
          return fileDownloadService.downloadFile(url, shoppingList.name, 'pdf');
        }

        var getShoppingListData = function (shoppingListId, subscriptionUnitId, organisationId) {
          var deferred = $q.defer();
          var cacheExpired = cachedEntityService.cachedEntityHasExpired(shoppingListId);
          return shoppingListResource.getSingleShoppingList({
            subscriptionUnitId: subscriptionUnitId,
            organisationId: organisationId,
            shoppingListId: shoppingListId,
            updatePrices: cacheExpired
          }).$promise.then(function(shopppingList) {
            if (cacheExpired) {
              cachedEntityService.cacheEntity(shoppingListId);
            }

            deferred.resolve(shopppingList);
            return deferred.promise;
          });
        };

        var getShoppingListDataForProductSearch = function (shoppingListId, subscriptionUnitId, organisationId, segmentId) {
          return shoppingListResource.getShoppingListDataForProductSearch({
            subscriptionUnitId: subscriptionUnitId,
            organisationId: organisationId,
            shoppingListId: shoppingListId,
            segmentId: segmentId
          }).$promise;
        };

        var getUnitsForShoppingListCopy = function (shoppingListId) {
          return shoppingListResource.getUnitsForShoppingListCopy({organisationId: ctx.currentSubscriptionUnit.organisation.id, shoppingListId: shoppingListId}).$promise;
        }

        var create = function (model) {
          if (!model.organisationId) {
            model.organisationId = organisationContextService.getOrganisationIdForCurrentProcurementUnit();
          }
          return shoppingListResource.create(model).$promise;
        };

        var update = function (model, cb) {
          var dto = {
            id: model.id,
            organisationId: organisationContextService.getOrganisationIdForCurrentProcurementUnit(),
            name: model.name,
            clientProcurementDepartmentId: model.procurementClientUnitDepartment.clientProcurementDepartmentId,
            clientProcurementAccountCodeId: model.procurementClientUnitAccountCode.clientProcurementAccountCodeId,
            procurementClientUnitDepartmentId: model.procurementClientUnitDepartment.id,
            procurementSubscriptionUnitId: model.procurementSubscriptionUnitId,
            procurementBasketStatus: model.procurementBasketStatus.id
          };
          return shoppingListResource.update(dto).$promise.then(cb);
        };

        //CSH 15082019 Doing this directly rather than via resource as returning a GUID rather than an object:
        var createBasketFromShoppingList = function (request) {
          return $http.post(siteUrl() + "api/shoppingList/createBasketFromShoppingList", request);
        }

        var copy = function (shoppingList, units) {
          var model = {
            organisationId: organisationContextService.getOrganisationIdForCurrentProcurementUnit(),
            shoppingListId: shoppingList.id,
            unitIds: _.pluck(units, 'id'),
            departmentId: shoppingList.clientProcurementDepartmentId,
            accountCodeId: shoppingList.clientProcurementAccountCodeId
          };
          return shoppingListResource.copyShoppingList(model).$promise;
        };

        var deleteShoppingList = function (shoppingListId, cb) {
          return shoppingListResource.deleteShoppingList({
            id: shoppingListId,
            organisationId: organisationContextService.getOrganisationIdForCurrentProcurementUnit()
          }).$promise.then(cb);
        };

        var replaceBasketItem = function (currentSegmentItem, replacementProduct, availableClientSupplierAccounts) {
          replacementProduct.searchDto = {
            searchCriteria: {
              savedSearchType: enums.savedSearchTypes.skuSearchExactSku
            }
          }
          var procurementItemDto = replaceProductService.createReplaceDto(currentSegmentItem.procurementItemDto, replacementProduct, availableClientSupplierAccounts);
          var model = procurementSegmentItemService.createSegmentItemReplaceProductDto(currentSegmentItem, procurementItemDto);

          return shoppingListResource.replaceBasketItem(model).$promise;
        };

        var hrefs = {
          root: '/ShoppingLists',
          create: function () {
            return this.root + '/Create'
          },
          view: function (id) {
            return this.root + '/view/' + id
          }
        };

        return {
          addBasketItem: addBasketItem,
          downloadShoppingList: downloadShoppingList,
          create: create,
          get: get,
          getShoppingListData: getShoppingListData,
          getUnitsForShoppingListCopy: getUnitsForShoppingListCopy,
          getShoppingListDataForProductSearch: getShoppingListDataForProductSearch,
          update: update,
          createBasketFromShoppingList: createBasketFromShoppingList,
          copy: copy,
          deleteShoppingList: deleteShoppingList,
          replaceBasketItem: replaceBasketItem,
          hrefs: hrefs
        };
      }
    ]);

angular.module(appName)
    .controller('shoppingListViewPageController', [
        '$scope', '$location', '$q', 'shoppingListService', 'shoppingListViewData', 'userDepartmentData', 'userAccountCodeData' , 'localStorageService', 'windowService', 'enums',
        function ($scope, $location, $q, shoppingListService, shoppingListViewData, userDepartmentData, userAccountCodeData, localStorageService, windowService, enums) {
            $scope.showSetupshoppingList = false;
            self.resolves = {
                shoppingListViewData: shoppingListViewData,
                userDepartmentData: userDepartmentData,
                userAccountCodeData: userAccountCodeData
            }
            self.ctx = localStorageService.getItem(enums.localStorage.organisationContext);
            $scope.currentProcurementSubscriptionId = ctx.currentSubscriptionUnit.id;
                $scope.userId = ctx.user.id;

            self.setupShoppingList = function (shoppingList) {
                $scope.currentShoppingList = shoppingList;
                $scope.showSetupshoppingList = true;
            };

            $scope.init = function () {
                $q.all(self.resolves).then(function(results) {
                    self.setupShoppingList(results.shoppingListViewData);
                    $scope.userDepartments = results.userDepartmentData;
                    $scope.userAccountCodes = results.userAccountCodeData;
                });
            }();
        }]);
angular.module(appName)
  .controller("sitemapController", [
    "$scope", "moment", "validationHelper",
    function($scope, moment, validationHelper) {
      $scope.routes = window.beagle.routes;
    }
  ]);
angular.module(appName)
	.controller("ssrsReportViewer", [
		"$routeParams","$scope","organisationContextService",
		function ($routeParams, $scope, organisationContextService) {

		    var normaliseQueryString = function(qs) {
                if (qs && qs.indexOf('?') === 0) {
                    qs = qs.substr(1);
                }
		        return qs;
		    };

            var splitKvp = function(kvp) {
                var parts = kvp.split('=');
                return {
                    key:parts[0],
                    value:parts.length > 1 ? parts[1] : null
                }
            }

            var getParameters = function(kvps) {
                if (!kvps.length || kvps.length < 2) {
                    return null;
                }
                var remainingParameters = kvps.slice(1, kvps.length);
                var parameters = {};
                _.each(remainingParameters, function(kvp) {
                    var split = splitKvp(kvp);
                    parameters[split.key] = split.value;
                });
                return parameters;
            }

		    var getReportName = function (kvps) {
                if (!kvps.length) {
                    throw "Was expecting a query string with at least one parameter";
                }
                var firstParam = kvps[0];
                var split = splitKvp(firstParam);
                if (split.value) {
                    throw "Was expecting the first element of the query string to be the ssrs report name with null value";
                }
		        return split.key;
		    }

		    var context = organisationContextService.getContext();
		    $scope.clientId = context.currentSubscriptionUnit.client.id;

		    var queryString = decodeURIComponent(window.location.search);
		    queryString = normaliseQueryString(queryString);

            if (!queryString) {
                throw "Was expecting a query string to pass to the ssrs directive";
            }

            var kvps = queryString.split('&');
            var reportName = getReportName(kvps);
            var parameters = getParameters(kvps);
            $scope.reportName = reportName;
		    $scope.parameters = parameters;
		}
	]);
//angular.module(appName)
//    .factory('taskResource', [
//        '$resource', 'siteUrl',
//        function ($resource, siteUrl) {
//            var api = siteUrl() + 'api/Task';
//            return $resource(api,
//            {},
//            {
//                submitTask: {
//                    method: 'POST',
//                    url:  api + '/SubmitTask',
//                    params: {
//                        taskId: '@taskId'
//                    },
//                    isArray: false
//                }
//            },
//             {
//                 getTaskActions: {
//                     method: 'GET',
//                     url: api + '/getTaskActions',
//                     params: {
//                         taskTypeId: '@taskTypeId',
//                         taskId: '@taskId'
//                     }
//                 }
//             });
//        }
//    ])
angular.module(appName)
    .factory('templateService',
    [
        function () {
            var self = this;
                self.baseUrl = null;

            function getTemplate(relativeName) {
                
            }

            function setBaseUrl(baseUrl) {
                self.baseUrl = baseUrl;
            }

            return {
                getTemplate: getTemplate,
                setBaseUrl: setBaseUrl
            }
        }
    ]);

'use strict';

angular.module(appName)
    .controller('unauthorisedController', ['$scope',
        function ($scope) {

            $scope.init = function () {

            }();
        }]);
'use strict';

angular.module(appName)
    .factory('unitAllowanceTypesResource', [
        '$resource', "siteUrl", function ($resource, siteUrl) {
            var api = siteUrl() + "api/ProcurementClientUnitAllowanceType";
            return $resource(api, {}, {
                get: {
                    method: "GET",
                    url: api + '/Get',
                    params: {
                        id: "@id"
                    },
                    isArray: true
                },
                add: {
                    method: "POST",
                    url: api + "/AddAllowanceTypesToClientUnit",
                    isArray: true
                },
                update: {
                    method: "PUT",
                    url: api + "/Update"
                },
                remove: {
                    method: "DELETE",
                    url: api + "/Delete",
                    params: {
                        id: "@id"
                    }
                }
            });
        }
    ]);
angular.module(appName)
    .factory('unitAllowanceTypesService', [
		'unitAllowanceTypesResource',
		'organisationContextService',
		function (unitAllowanceTypesResource, organisationContextService) {
			var self = this;
			self.ctx = organisationContextService.getContext();
            return {
				get: function (id, cb) {
					if (!id) {
						id = self.ctx.currentSubscriptionUnit.id;
					}
                    return unitAllowanceTypesResource.get({ id: id }).$promise.then(cb);
                },
                add: function (model) {
                    return unitAllowanceTypesResource.add(model);
                },
                update: function (model) {
                    return unitAllowanceTypesResource.update(model);
                },
                remove: function (id) {
                    return unitAllowanceTypesResource.remove({ id: id });
                }
            };
        }
    ]);
angular.module(appName)
  .controller("unitImportsController", [
    function() {

    }
  ]);
angular.module(appName)
	.controller("updateAllergensController",
		[
			"$scope",
			"updateAllergensService",
			"allergenService",
			"$translate",
            "menusService",
            "$rootScope",
            "localStorageService",
			function (
				$scope,
				updateAllergensService,
				allergenService,
				$translate,
                menusService,
                $rootScope,
                localStorageService
			) {
				var init = function () {
                    $scope.isAdminUser = localStorageService.getItem($rootScope.$enums.localStorage.isAdminUser);
                    $scope.savingChanges = false;
					$scope.changes = function() {
						return _.filter($scope.recipes,
							function(a) {
								return a.updateRequest;
							});
					}

					var getAssociatedMenus = function () {
						var recipeIds = _.pluck($scope.recipes, 'recipeId');
						menusService.search(
							{
								recipeIds: recipeIds,
								viewTypeName: 'eProcurement.Menus.MenuWithRecipesDto'
							}
						).then(function (result) {
							$scope.menus = result.list;
							_.each($scope.recipes,
								function(r) {
									var associatedMenus = _.filter($scope.menus,
										function(m) {
											return m.recipeIds.indexOf(r.recipeId) > -1;
										});
									r.associatedMenuIds = _.pluck(associatedMenus, 'id');
								});
						});
					}

					var successMessage;

					$scope.save = function () {
						$scope.savingChanges = true;
						var changes = $scope.changes();
						_.each(changes,
							function(c) {
								c.updateAllergens = c.updateRequest === 'change';
								c.UpdateAllergensDecision = c.updateRequest;
							});
						
						updateAllergensService.submitChanges(changes).then(function () {
							$scope.savingChanges = false;
							toastr.success(successMessage);
							_.each(changes,
								function(c) {
									_.removeIfExists($scope.recipes, c);
									
									delete c.updateRequest;
									getAssociatedMenus();
								});
						});
					}

					var init = function () {
					    $translate('changes_confirmed').then(function(r) {
							successMessage = r;
						});
						updateAllergensService.getRecipesWhereSuggestedAllergensHaveChanged().then(function(result) {
							_.each(result.data,
								function(r) {
                                    r.containsIdsAdded = _.map(r.containsIdsAdded.split(','),
										function(i) { return parseInt(i) });
                                    r.containsIdsRemoved = _.map(r.containsIdsRemoved.split(','),
                                        function (i) { return parseInt(i) });
                                    r.mayContainIdsAdded = _.map(r.mayContainIdsAdded.split(','),
                                        function (i) { return parseInt(i) });
                                    r.mayContainIdsRemoved = _.map(r.mayContainIdsRemoved.split(','),
                                        function (i) { return parseInt(i) });
								});
							$scope.recipes = result.data;
							getAssociatedMenus();
						});
						allergenService.getAll().then(function(result) {
							$scope.allergens = result.data;
						});
					}
					init();
				};
				init();
			}
		]);
angular.module(appName)
	.factory("updateAllergensService",
		[
			"$http", "siteUrl","organisationContextService",
			function ($http, siteUrl, organisationContextService) {

				var baseUrl = siteUrl();

				return {
					getRecipesWhereSuggestedAllergensHaveChanged: function() {
						var clientId = organisationContextService.getContext().currentSubscriptionUnit.client.id;
						var url = baseUrl + "api/allergen-update/getRecipesWhereSuggestedAllergensHaveChanged?clientId=" + clientId;
						return $http.get(url);
					},
					submitChanges: function (changes) {
						var url = baseUrl + "api/allergen-update/submitChanges";
						return $http.post(url, changes);
					}
				};
			}
		]);
var Oidc=function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={exports:{},id:r,loaded:!1};return t[r].call(i.exports,i,i.exports,e),i.loaded=!0,i.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){n(1),t.exports=n(299)},function(t,e,n){(function(t){"use strict";function e(t,e,n){t[e]||Object[r](t,e,{writable:!0,configurable:!0,value:n})}if(n(2),n(294),n(296),t._babelPolyfill)throw new Error("only one instance of babel-polyfill is allowed");t._babelPolyfill=!0;var r="defineProperty";e(String.prototype,"padLeft","".padStart),e(String.prototype,"padRight","".padEnd),"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function(t){[][t]&&e(Array,t,Function.call.bind([][t]))})}).call(e,function(){return this}())},function(t,e,n){n(3),n(52),n(53),n(54),n(55),n(57),n(60),n(61),n(62),n(63),n(64),n(65),n(66),n(67),n(68),n(70),n(72),n(74),n(76),n(79),n(80),n(81),n(85),n(87),n(89),n(93),n(94),n(95),n(96),n(98),n(99),n(100),n(101),n(102),n(103),n(104),n(106),n(107),n(108),n(110),n(111),n(112),n(114),n(115),n(116),n(117),n(118),n(119),n(120),n(121),n(122),n(123),n(124),n(125),n(126),n(127),n(132),n(133),n(137),n(138),n(139),n(140),n(142),n(143),n(144),n(145),n(146),n(147),n(148),n(149),n(150),n(151),n(152),n(153),n(154),n(155),n(156),n(157),n(158),n(160),n(161),n(167),n(168),n(170),n(171),n(172),n(176),n(177),n(178),n(179),n(180),n(182),n(183),n(184),n(185),n(188),n(190),n(191),n(192),n(194),n(196),n(198),n(199),n(200),n(202),n(203),n(204),n(205),n(211),n(214),n(215),n(217),n(218),n(221),n(222),n(225),n(226),n(227),n(228),n(229),n(230),n(231),n(232),n(233),n(234),n(235),n(236),n(237),n(238),n(239),n(240),n(241),n(242),n(243),n(245),n(246),n(247),n(248),n(249),n(250),n(252),n(253),n(254),n(255),n(256),n(257),n(258),n(259),n(261),n(262),n(264),n(265),n(266),n(267),n(270),n(271),n(272),n(273),n(274),n(275),n(276),n(277),n(279),n(280),n(281),n(282),n(283),n(284),n(285),n(286),n(287),n(288),n(289),n(292),n(293),t.exports=n(9)},function(t,e,n){"use strict";var r=n(4),i=n(5),s=n(6),o=n(8),a=n(18),u=n(22).KEY,c=n(7),f=n(23),h=n(24),l=n(19),d=n(25),p=n(26),g=n(27),y=n(29),v=n(42),m=n(45),S=n(12),b=n(32),w=n(16),E=n(17),x=n(46),_=n(49),R=n(51),A=n(11),F=n(30),K=R.f,P=A.f,U=_.f,O=r.Symbol,C=r.JSON,I=C&&C.stringify,j="prototype",T=d("_hidden"),D=d("toPrimitive"),J={}.propertyIsEnumerable,H=f("symbol-registry"),B=f("symbols"),k=f("op-symbols"),N=Object[j],M="function"==typeof O,V=r.QObject,L=!V||!V[j]||!V[j].findChild,q=s&&c(function(){return 7!=x(P({},"a",{get:function(){return P(this,"a",{value:7}).a}})).a})?function(t,e,n){var r=K(N,e);r&&delete N[e],P(t,e,n),r&&t!==N&&P(N,e,r)}:P,W=function(t){var e=B[t]=x(O[j]);return e._k=t,e},z=M&&"symbol"==typeof O.iterator?function(t){return"symbol"==typeof t}:function(t){return t instanceof O},Y=function(t,e,n){return t===N&&Y(k,e,n),S(t),e=w(e,!0),S(n),i(B,e)?(n.enumerable?(i(t,T)&&t[T][e]&&(t[T][e]=!1),n=x(n,{enumerable:E(0,!1)})):(i(t,T)||P(t,T,E(1,{})),t[T][e]=!0),q(t,e,n)):P(t,e,n)},G=function(t,e){S(t);for(var n,r=v(e=b(e)),i=0,s=r.length;s>i;)Y(t,n=r[i++],e[n]);return t},X=function(t,e){return void 0===e?x(t):G(x(t),e)},$=function(t){var e=J.call(this,t=w(t,!0));return this===N&&i(B,t)&&!i(k,t)?!1:e||!i(this,t)||!i(B,t)||i(this,T)&&this[T][t]?e:!0},Z=function(t,e){if(t=b(t),e=w(e,!0),t!==N||!i(B,e)||i(k,e)){var n=K(t,e);return!n||!i(B,e)||i(t,T)&&t[T][e]||(n.enumerable=!0),n}},Q=function(t){for(var e,n=U(b(t)),r=[],s=0;n.length>s;)i(B,e=n[s++])||e==T||e==u||r.push(e);return r},tt=function(t){for(var e,n=t===N,r=U(n?k:b(t)),s=[],o=0;r.length>o;)i(B,e=r[o++])&&(n?i(N,e):!0)&&s.push(B[e]);return s};M||(O=function(){if(this instanceof O)throw TypeError("Symbol is not a constructor!");var t=l(arguments.length>0?arguments[0]:void 0),e=function(n){this===N&&e.call(k,n),i(this,T)&&i(this[T],t)&&(this[T][t]=!1),q(this,t,E(1,n))};return s&&L&&q(N,t,{configurable:!0,set:e}),W(t)},a(O[j],"toString",function(){return this._k}),R.f=Z,A.f=Y,n(50).f=_.f=Q,n(44).f=$,n(43).f=tt,s&&!n(28)&&a(N,"propertyIsEnumerable",$,!0),p.f=function(t){return W(d(t))}),o(o.G+o.W+o.F*!M,{Symbol:O});for(var et="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),nt=0;et.length>nt;)d(et[nt++]);for(var et=F(d.store),nt=0;et.length>nt;)g(et[nt++]);o(o.S+o.F*!M,"Symbol",{"for":function(t){return i(H,t+="")?H[t]:H[t]=O(t)},keyFor:function(t){if(z(t))return y(H,t);throw TypeError(t+" is not a symbol!")},useSetter:function(){L=!0},useSimple:function(){L=!1}}),o(o.S+o.F*!M,"Object",{create:X,defineProperty:Y,defineProperties:G,getOwnPropertyDescriptor:Z,getOwnPropertyNames:Q,getOwnPropertySymbols:tt}),C&&o(o.S+o.F*(!M||c(function(){var t=O();return"[null]"!=I([t])||"{}"!=I({a:t})||"{}"!=I(Object(t))})),"JSON",{stringify:function(t){if(void 0!==t&&!z(t)){for(var e,n,r=[t],i=1;arguments.length>i;)r.push(arguments[i++]);return e=r[1],"function"==typeof e&&(n=e),!n&&m(e)||(e=function(t,e){return n&&(e=n.call(this,t,e)),z(e)?void 0:e}),r[1]=e,I.apply(C,r)}}}),O[j][D]||n(10)(O[j],D,O[j].valueOf),h(O,"Symbol"),h(Math,"Math",!0),h(r.JSON,"JSON",!0)},function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){t.exports=!n(7)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){t.exports=function(t){try{return!!t()}catch(e){return!0}}},function(t,e,n){var r=n(4),i=n(9),s=n(10),o=n(18),a=n(20),u="prototype",c=function(t,e,n){var f,h,l,d,p=t&c.F,g=t&c.G,y=t&c.S,v=t&c.P,m=t&c.B,S=g?r:y?r[e]||(r[e]={}):(r[e]||{})[u],b=g?i:i[e]||(i[e]={}),w=b[u]||(b[u]={});g&&(n=e);for(f in n)h=!p&&S&&void 0!==S[f],l=(h?S:n)[f],d=m&&h?a(l,r):v&&"function"==typeof l?a(Function.call,l):l,S&&o(S,f,l,t&c.U),b[f]!=l&&s(b,f,d),v&&w[f]!=l&&(w[f]=l)};r.core=i,c.F=1,c.G=2,c.S=4,c.P=8,c.B=16,c.W=32,c.U=64,c.R=128,t.exports=c},function(t,e){var n=t.exports={version:"2.4.0"};"number"==typeof __e&&(__e=n)},function(t,e,n){var r=n(11),i=n(17);t.exports=n(6)?function(t,e,n){return r.f(t,e,i(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var r=n(12),i=n(14),s=n(16),o=Object.defineProperty;e.f=n(6)?Object.defineProperty:function(t,e,n){if(r(t),e=s(e,!0),r(n),i)try{return o(t,e,n)}catch(a){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e,n){var r=n(13);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){t.exports=!n(6)&&!n(7)(function(){return 7!=Object.defineProperty(n(15)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var r=n(13),i=n(4).document,s=r(i)&&r(i.createElement);t.exports=function(t){return s?i.createElement(t):{}}},function(t,e,n){var r=n(13);t.exports=function(t,e){if(!r(t))return t;var n,i;if(e&&"function"==typeof(n=t.toString)&&!r(i=n.call(t)))return i;if("function"==typeof(n=t.valueOf)&&!r(i=n.call(t)))return i;if(!e&&"function"==typeof(n=t.toString)&&!r(i=n.call(t)))return i;throw TypeError("Can't convert object to primitive value")}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){var r=n(4),i=n(10),s=n(5),o=n(19)("src"),a="toString",u=Function[a],c=(""+u).split(a);n(9).inspectSource=function(t){return u.call(t)},(t.exports=function(t,e,n,a){var u="function"==typeof n;u&&(s(n,"name")||i(n,"name",e)),t[e]!==n&&(u&&(s(n,o)||i(n,o,t[e]?""+t[e]:c.join(String(e)))),t===r?t[e]=n:a?t[e]?t[e]=n:i(t,e,n):(delete t[e],i(t,e,n)))})(Function.prototype,a,function(){return"function"==typeof this&&this[o]||u.call(this)})},function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+r).toString(36))}},function(t,e,n){var r=n(21);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,i){return t.call(e,n,r,i)}}return function(){return t.apply(e,arguments)}}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e,n){var r=n(19)("meta"),i=n(13),s=n(5),o=n(11).f,a=0,u=Object.isExtensible||function(){return!0},c=!n(7)(function(){return u(Object.preventExtensions({}))}),f=function(t){o(t,r,{value:{i:"O"+ ++a,w:{}}})},h=function(t,e){if(!i(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!s(t,r)){if(!u(t))return"F";if(!e)return"E";f(t)}return t[r].i},l=function(t,e){if(!s(t,r)){if(!u(t))return!0;if(!e)return!1;f(t)}return t[r].w},d=function(t){return c&&p.NEED&&u(t)&&!s(t,r)&&f(t),t},p=t.exports={KEY:r,NEED:!1,fastKey:h,getWeak:l,onFreeze:d}},function(t,e,n){var r=n(4),i="__core-js_shared__",s=r[i]||(r[i]={});t.exports=function(t){return s[t]||(s[t]={})}},function(t,e,n){var r=n(11).f,i=n(5),s=n(25)("toStringTag");t.exports=function(t,e,n){t&&!i(t=n?t:t.prototype,s)&&r(t,s,{configurable:!0,value:e})}},function(t,e,n){var r=n(23)("wks"),i=n(19),s=n(4).Symbol,o="function"==typeof s,a=t.exports=function(t){return r[t]||(r[t]=o&&s[t]||(o?s:i)("Symbol."+t))};a.store=r},function(t,e,n){e.f=n(25)},function(t,e,n){var r=n(4),i=n(9),s=n(28),o=n(26),a=n(11).f;t.exports=function(t){var e=i.Symbol||(i.Symbol=s?{}:r.Symbol||{});"_"==t.charAt(0)||t in e||a(e,t,{value:o.f(t)})}},function(t,e){t.exports=!1},function(t,e,n){var r=n(30),i=n(32);t.exports=function(t,e){for(var n,s=i(t),o=r(s),a=o.length,u=0;a>u;)if(s[n=o[u++]]===e)return n}},function(t,e,n){var r=n(31),i=n(41);t.exports=Object.keys||function(t){return r(t,i)}},function(t,e,n){var r=n(5),i=n(32),s=n(36)(!1),o=n(40)("IE_PROTO");t.exports=function(t,e){var n,a=i(t),u=0,c=[];for(n in a)n!=o&&r(a,n)&&c.push(n);for(;e.length>u;)r(a,n=e[u++])&&(~s(c,n)||c.push(n));return c}},function(t,e,n){var r=n(33),i=n(35);t.exports=function(t){return r(i(t))}},function(t,e,n){var r=n(34);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){var r=n(32),i=n(37),s=n(39);t.exports=function(t){return function(e,n,o){var a,u=r(e),c=i(u.length),f=s(o,c);if(t&&n!=n){for(;c>f;)if(a=u[f++],a!=a)return!0}else for(;c>f;f++)if((t||f in u)&&u[f]===n)return t||f||0;return!t&&-1}}},function(t,e,n){var r=n(38),i=Math.min;t.exports=function(t){return t>0?i(r(t),9007199254740991):0}},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e,n){var r=n(38),i=Math.max,s=Math.min;t.exports=function(t,e){return t=r(t),0>t?i(t+e,0):s(t,e)}},function(t,e,n){var r=n(23)("keys"),i=n(19);t.exports=function(t){return r[t]||(r[t]=i(t))}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){var r=n(30),i=n(43),s=n(44);t.exports=function(t){var e=r(t),n=i.f;if(n)for(var o,a=n(t),u=s.f,c=0;a.length>c;)u.call(t,o=a[c++])&&e.push(o);return e}},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e){e.f={}.propertyIsEnumerable},function(t,e,n){var r=n(34);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,e,n){var r=n(12),i=n(47),s=n(41),o=n(40)("IE_PROTO"),a=function(){},u="prototype",c=function(){var t,e=n(15)("iframe"),r=s.length,i=">";for(e.style.display="none",n(48).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write("<script>document.F=Object</script"+i),t.close(),c=t.F;r--;)delete c[u][s[r]];return c()};t.exports=Object.create||function(t,e){var n;return null!==t?(a[u]=r(t),n=new a,a[u]=null,n[o]=t):n=c(),void 0===e?n:i(n,e)}},function(t,e,n){var r=n(11),i=n(12),s=n(30);t.exports=n(6)?Object.defineProperties:function(t,e){i(t);for(var n,o=s(e),a=o.length,u=0;a>u;)r.f(t,n=o[u++],e[n]);return t}},function(t,e,n){t.exports=n(4).document&&document.documentElement},function(t,e,n){var r=n(32),i=n(50).f,s={}.toString,o="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],a=function(t){try{return i(t)}catch(e){return o.slice()}};t.exports.f=function(t){return o&&"[object Window]"==s.call(t)?a(t):i(r(t))}},function(t,e,n){var r=n(31),i=n(41).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return r(t,i)}},function(t,e,n){var r=n(44),i=n(17),s=n(32),o=n(16),a=n(5),u=n(14),c=Object.getOwnPropertyDescriptor;e.f=n(6)?c:function(t,e){if(t=s(t),e=o(e,!0),u)try{return c(t,e)}catch(n){}return a(t,e)?i(!r.f.call(t,e),t[e]):void 0}},function(t,e,n){var r=n(8);r(r.S,"Object",{create:n(46)})},function(t,e,n){var r=n(8);r(r.S+r.F*!n(6),"Object",{defineProperty:n(11).f})},function(t,e,n){var r=n(8);r(r.S+r.F*!n(6),"Object",{defineProperties:n(47)})},function(t,e,n){var r=n(32),i=n(51).f;n(56)("getOwnPropertyDescriptor",function(){return function(t,e){return i(r(t),e)}})},function(t,e,n){var r=n(8),i=n(9),s=n(7);t.exports=function(t,e){var n=(i.Object||{})[t]||Object[t],o={};o[t]=e(n),r(r.S+r.F*s(function(){n(1)}),"Object",o)}},function(t,e,n){var r=n(58),i=n(59);n(56)("getPrototypeOf",function(){return function(t){return i(r(t))}})},function(t,e,n){var r=n(35);t.exports=function(t){return Object(r(t))}},function(t,e,n){var r=n(5),i=n(58),s=n(40)("IE_PROTO"),o=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=i(t),r(t,s)?t[s]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?o:null}},function(t,e,n){var r=n(58),i=n(30);n(56)("keys",function(){return function(t){return i(r(t))}})},function(t,e,n){n(56)("getOwnPropertyNames",function(){return n(49).f})},function(t,e,n){var r=n(13),i=n(22).onFreeze;n(56)("freeze",function(t){return function(e){return t&&r(e)?t(i(e)):e}})},function(t,e,n){var r=n(13),i=n(22).onFreeze;n(56)("seal",function(t){return function(e){return t&&r(e)?t(i(e)):e}})},function(t,e,n){var r=n(13),i=n(22).onFreeze;n(56)("preventExtensions",function(t){return function(e){return t&&r(e)?t(i(e)):e}})},function(t,e,n){var r=n(13);n(56)("isFrozen",function(t){return function(e){return r(e)?t?t(e):!1:!0}})},function(t,e,n){var r=n(13);n(56)("isSealed",function(t){return function(e){return r(e)?t?t(e):!1:!0}})},function(t,e,n){var r=n(13);n(56)("isExtensible",function(t){return function(e){return r(e)?t?t(e):!0:!1}})},function(t,e,n){var r=n(8);r(r.S+r.F,"Object",{assign:n(69)})},function(t,e,n){"use strict";var r=n(30),i=n(43),s=n(44),o=n(58),a=n(33),u=Object.assign;t.exports=!u||n(7)(function(){var t={},e={},n=Symbol(),r="abcdefghijklmnopqrst";return t[n]=7,r.split("").forEach(function(t){e[t]=t}),7!=u({},t)[n]||Object.keys(u({},e)).join("")!=r})?function(t,e){for(var n=o(t),u=arguments.length,c=1,f=i.f,h=s.f;u>c;)for(var l,d=a(arguments[c++]),p=f?r(d).concat(f(d)):r(d),g=p.length,y=0;g>y;)h.call(d,l=p[y++])&&(n[l]=d[l]);return n}:u},function(t,e,n){var r=n(8);r(r.S,"Object",{is:n(71)})},function(t,e){t.exports=Object.is||function(t,e){return t===e?0!==t||1/t===1/e:t!=t&&e!=e}},function(t,e,n){var r=n(8);r(r.S,"Object",{setPrototypeOf:n(73).set})},function(t,e,n){var r=n(13),i=n(12),s=function(t,e){if(i(t),!r(e)&&null!==e)throw TypeError(e+": can't set as prototype!")};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,e,r){try{r=n(20)(Function.call,n(51).f(Object.prototype,"__proto__").set,2),r(t,[]),e=!(t instanceof Array)}catch(i){e=!0}return function(t,n){return s(t,n),e?t.__proto__=n:r(t,n),t}}({},!1):void 0),check:s}},function(t,e,n){"use strict";var r=n(75),i={};i[n(25)("toStringTag")]="z",i+""!="[object z]"&&n(18)(Object.prototype,"toString",function(){return"[object "+r(this)+"]"},!0)},function(t,e,n){var r=n(34),i=n(25)("toStringTag"),s="Arguments"==r(function(){return arguments}()),o=function(t,e){try{return t[e]}catch(n){}};t.exports=function(t){var e,n,a;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=o(e=Object(t),i))?n:s?r(e):"Object"==(a=r(e))&&"function"==typeof e.callee?"Arguments":a}},function(t,e,n){var r=n(8);r(r.P,"Function",{bind:n(77)})},function(t,e,n){"use strict";var r=n(21),i=n(13),s=n(78),o=[].slice,a={},u=function(t,e,n){if(!(e in a)){for(var r=[],i=0;e>i;i++)r[i]="a["+i+"]";a[e]=Function("F,a","return new F("+r.join(",")+")")}return a[e](t,n)};t.exports=Function.bind||function(t){var e=r(this),n=o.call(arguments,1),a=function(){var r=n.concat(o.call(arguments));return this instanceof a?u(e,r.length,r):s(e,r,t)};return i(e.prototype)&&(a.prototype=e.prototype),a}},function(t,e){t.exports=function(t,e,n){var r=void 0===n;switch(e.length){case 0:return r?t():t.call(n);case 1:return r?t(e[0]):t.call(n,e[0]);case 2:return r?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return r?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return r?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var r=n(11).f,i=n(17),s=n(5),o=Function.prototype,a=/^\s*function ([^ (]*)/,u="name",c=Object.isExtensible||function(){return!0};u in o||n(6)&&r(o,u,{configurable:!0,get:function(){try{var t=this,e=(""+t).match(a)[1];return s(t,u)||!c(t)||r(t,u,i(5,e)),e}catch(n){return""}}})},function(t,e,n){"use strict";var r=n(13),i=n(59),s=n(25)("hasInstance"),o=Function.prototype;s in o||n(11).f(o,s,{value:function(t){if("function"!=typeof this||!r(t))return!1;if(!r(this.prototype))return t instanceof this;for(;t=i(t);)if(this.prototype===t)return!0;return!1}})},function(t,e,n){var r=n(8),i=n(82);r(r.G+r.F*(parseInt!=i),{parseInt:i})},function(t,e,n){var r=n(4).parseInt,i=n(83).trim,s=n(84),o=/^[\-+]?0[xX]/;t.exports=8!==r(s+"08")||22!==r(s+"0x16")?function(t,e){var n=i(String(t),3);return r(n,e>>>0||(o.test(n)?16:10))}:r},function(t,e,n){var r=n(8),i=n(35),s=n(7),o=n(84),a="["+o+"]",u="​",c=RegExp("^"+a+a+"*"),f=RegExp(a+a+"*$"),h=function(t,e,n){var i={},a=s(function(){return!!o[t]()||u[t]()!=u}),c=i[t]=a?e(l):o[t];n&&(i[n]=c),r(r.P+r.F*a,"String",i)},l=h.trim=function(t,e){return t=String(i(t)),1&e&&(t=t.replace(c,"")),2&e&&(t=t.replace(f,"")),t};t.exports=h},function(t,e){t.exports="	\n\x0B\f\r   ᠎             　\u2028\u2029\ufeff"},function(t,e,n){var r=n(8),i=n(86);r(r.G+r.F*(parseFloat!=i),{parseFloat:i})},function(t,e,n){var r=n(4).parseFloat,i=n(83).trim;t.exports=1/r(n(84)+"-0")!==-(1/0)?function(t){var e=i(String(t),3),n=r(e);return 0===n&&"-"==e.charAt(0)?-0:n}:r},function(t,e,n){"use strict";var r=n(4),i=n(5),s=n(34),o=n(88),a=n(16),u=n(7),c=n(50).f,f=n(51).f,h=n(11).f,l=n(83).trim,d="Number",p=r[d],g=p,y=p.prototype,v=s(n(46)(y))==d,m="trim"in String.prototype,S=function(t){var e=a(t,!1);if("string"==typeof e&&e.length>2){e=m?e.trim():l(e,3);var n,r,i,s=e.charCodeAt(0);if(43===s||45===s){if(n=e.charCodeAt(2),88===n||120===n)return NaN}else if(48===s){switch(e.charCodeAt(1)){case 66:case 98:r=2,i=49;break;case 79:case 111:r=8,i=55;break;default:return+e}for(var o,u=e.slice(2),c=0,f=u.length;f>c;c++)if(o=u.charCodeAt(c),48>o||o>i)return NaN;return parseInt(u,r)}}return+e};if(!p(" 0o1")||!p("0b1")||p("+0x1")){p=function(t){var e=arguments.length<1?0:t,n=this;return n instanceof p&&(v?u(function(){y.valueOf.call(n)}):s(n)!=d)?o(new g(S(e)),n,p):S(e)};for(var b,w=n(6)?c(g):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),E=0;w.length>E;E++)i(g,b=w[E])&&!i(p,b)&&h(p,b,f(g,b));p.prototype=y,y.constructor=p,n(18)(r,d,p)}},function(t,e,n){var r=n(13),i=n(73).set;t.exports=function(t,e,n){var s,o=e.constructor;return o!==n&&"function"==typeof o&&(s=o.prototype)!==n.prototype&&r(s)&&i&&i(t,s),t}},function(t,e,n){"use strict";var r=n(8),i=(n(90),n(38)),s=n(91),o=n(92),a=1..toFixed,u=Math.floor,c=[0,0,0,0,0,0],f="Number.toFixed: incorrect invocation!",h="0",l=function(t,e){for(var n=-1,r=e;++n<6;)r+=t*c[n],c[n]=r%1e7,r=u(r/1e7)},d=function(t){for(var e=6,n=0;--e>=0;)n+=c[e],c[e]=u(n/t),n=n%t*1e7},p=function(){for(var t=6,e="";--t>=0;)if(""!==e||0===t||0!==c[t]){var n=String(c[t]);e=""===e?n:e+o.call(h,7-n.length)+n}return e},g=function(t,e,n){return 0===e?n:e%2===1?g(t,e-1,n*t):g(t*t,e/2,n)},y=function(t){for(var e=0,n=t;n>=4096;)e+=12,n/=4096;for(;n>=2;)e+=1,n/=2;return e};r(r.P+r.F*(!!a&&("0.000"!==8e-5.toFixed(3)||"1"!==.9.toFixed(0)||"1.25"!==1.255.toFixed(2)||"1000000000000000128"!==0xde0b6b3a7640080.toFixed(0))||!n(7)(function(){a.call({})})),"Number",{toFixed:function(t){var e,n,r,a,u=s(this,f),c=i(t),v="",m=h;if(0>c||c>20)throw RangeError(f);if(u!=u)return"NaN";if(-1e21>=u||u>=1e21)return String(u);if(0>u&&(v="-",u=-u),u>1e-21)if(e=y(u*g(2,69,1))-69,n=0>e?u*g(2,-e,1):u/g(2,e,1),n*=4503599627370496,e=52-e,e>0){for(l(0,n),r=c;r>=7;)l(1e7,0),r-=7;for(l(g(10,r,1),0),r=e-1;r>=23;)d(1<<23),r-=23;d(1<<r),l(1,1),d(2),m=p()}else l(0,n),l(1<<-e,0),m=p()+o.call(h,c);return c>0?(a=m.length,m=v+(c>=a?"0."+o.call(h,c-a)+m:m.slice(0,a-c)+"."+m.slice(a-c))):m=v+m,m}})},function(t,e){t.exports=function(t,e,n,r){if(!(t instanceof e)||void 0!==r&&r in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){var r=n(34);t.exports=function(t,e){if("number"!=typeof t&&"Number"!=r(t))throw TypeError(e);return+t}},function(t,e,n){"use strict";var r=n(38),i=n(35);t.exports=function(t){var e=String(i(this)),n="",s=r(t);if(0>s||s==1/0)throw RangeError("Count can't be negative");for(;s>0;(s>>>=1)&&(e+=e))1&s&&(n+=e);return n}},function(t,e,n){"use strict";var r=n(8),i=n(7),s=n(91),o=1..toPrecision;r(r.P+r.F*(i(function(){return"1"!==o.call(1,void 0)})||!i(function(){o.call({})})),"Number",{toPrecision:function(t){var e=s(this,"Number#toPrecision: incorrect invocation!");return void 0===t?o.call(e):o.call(e,t)}})},function(t,e,n){var r=n(8);r(r.S,"Number",{EPSILON:Math.pow(2,-52)})},function(t,e,n){var r=n(8),i=n(4).isFinite;r(r.S,"Number",{isFinite:function(t){return"number"==typeof t&&i(t)}})},function(t,e,n){var r=n(8);r(r.S,"Number",{isInteger:n(97)})},function(t,e,n){var r=n(13),i=Math.floor;t.exports=function(t){return!r(t)&&isFinite(t)&&i(t)===t}},function(t,e,n){var r=n(8);r(r.S,"Number",{isNaN:function(t){return t!=t}})},function(t,e,n){var r=n(8),i=n(97),s=Math.abs;r(r.S,"Number",{isSafeInteger:function(t){return i(t)&&s(t)<=9007199254740991}})},function(t,e,n){var r=n(8);r(r.S,"Number",{MAX_SAFE_INTEGER:9007199254740991})},function(t,e,n){var r=n(8);r(r.S,"Number",{MIN_SAFE_INTEGER:-9007199254740991})},function(t,e,n){var r=n(8),i=n(86);r(r.S+r.F*(Number.parseFloat!=i),"Number",{parseFloat:i})},function(t,e,n){var r=n(8),i=n(82);r(r.S+r.F*(Number.parseInt!=i),"Number",{parseInt:i})},function(t,e,n){var r=n(8),i=n(105),s=Math.sqrt,o=Math.acosh;r(r.S+r.F*!(o&&710==Math.floor(o(Number.MAX_VALUE))&&o(1/0)==1/0),"Math",{acosh:function(t){return(t=+t)<1?NaN:t>94906265.62425156?Math.log(t)+Math.LN2:i(t-1+s(t-1)*s(t+1))}})},function(t,e){t.exports=Math.log1p||function(t){return(t=+t)>-1e-8&&1e-8>t?t-t*t/2:Math.log(1+t)}},function(t,e,n){function r(t){return isFinite(t=+t)&&0!=t?0>t?-r(-t):Math.log(t+Math.sqrt(t*t+1)):t}var i=n(8),s=Math.asinh;i(i.S+i.F*!(s&&1/s(0)>0),"Math",{asinh:r})},function(t,e,n){var r=n(8),i=Math.atanh;r(r.S+r.F*!(i&&1/i(-0)<0),"Math",{atanh:function(t){return 0==(t=+t)?t:Math.log((1+t)/(1-t))/2}})},function(t,e,n){var r=n(8),i=n(109);r(r.S,"Math",{cbrt:function(t){return i(t=+t)*Math.pow(Math.abs(t),1/3)}})},function(t,e){t.exports=Math.sign||function(t){return 0==(t=+t)||t!=t?t:0>t?-1:1}},function(t,e,n){var r=n(8);r(r.S,"Math",{clz32:function(t){return(t>>>=0)?31-Math.floor(Math.log(t+.5)*Math.LOG2E):32}})},function(t,e,n){var r=n(8),i=Math.exp;r(r.S,"Math",{cosh:function(t){return(i(t=+t)+i(-t))/2}})},function(t,e,n){var r=n(8),i=n(113);r(r.S+r.F*(i!=Math.expm1),"Math",{expm1:i})},function(t,e){var n=Math.expm1;t.exports=!n||n(10)>22025.465794806718||n(10)<22025.465794806718||-2e-17!=n(-2e-17)?function(t){return 0==(t=+t)?t:t>-1e-6&&1e-6>t?t+t*t/2:Math.exp(t)-1}:n},function(t,e,n){var r=n(8),i=n(109),s=Math.pow,o=s(2,-52),a=s(2,-23),u=s(2,127)*(2-a),c=s(2,-126),f=function(t){return t+1/o-1/o};r(r.S,"Math",{fround:function(t){var e,n,r=Math.abs(t),s=i(t);return c>r?s*f(r/c/a)*c*a:(e=(1+a/o)*r,n=e-(e-r),n>u||n!=n?s*(1/0):s*n)}})},function(t,e,n){var r=n(8),i=Math.abs;r(r.S,"Math",{hypot:function(t,e){for(var n,r,s=0,o=0,a=arguments.length,u=0;a>o;)n=i(arguments[o++]),n>u?(r=u/n,s=s*r*r+1,u=n):n>0?(r=n/u,s+=r*r):s+=n;return u===1/0?1/0:u*Math.sqrt(s)}})},function(t,e,n){var r=n(8),i=Math.imul;r(r.S+r.F*n(7)(function(){return-5!=i(4294967295,5)||2!=i.length}),"Math",{imul:function(t,e){var n=65535,r=+t,i=+e,s=n&r,o=n&i;return 0|s*o+((n&r>>>16)*o+s*(n&i>>>16)<<16>>>0)}})},function(t,e,n){var r=n(8);r(r.S,"Math",{log10:function(t){return Math.log(t)/Math.LN10}})},function(t,e,n){var r=n(8);r(r.S,"Math",{log1p:n(105)})},function(t,e,n){var r=n(8);r(r.S,"Math",{log2:function(t){return Math.log(t)/Math.LN2}})},function(t,e,n){var r=n(8);r(r.S,"Math",{sign:n(109)})},function(t,e,n){var r=n(8),i=n(113),s=Math.exp;r(r.S+r.F*n(7)(function(){return-2e-17!=!Math.sinh(-2e-17)}),"Math",{sinh:function(t){return Math.abs(t=+t)<1?(i(t)-i(-t))/2:(s(t-1)-s(-t-1))*(Math.E/2)}})},function(t,e,n){var r=n(8),i=n(113),s=Math.exp;r(r.S,"Math",{tanh:function(t){var e=i(t=+t),n=i(-t);return e==1/0?1:n==1/0?-1:(e-n)/(s(t)+s(-t))}})},function(t,e,n){var r=n(8);r(r.S,"Math",{trunc:function(t){return(t>0?Math.floor:Math.ceil)(t)}})},function(t,e,n){var r=n(8),i=n(39),s=String.fromCharCode,o=String.fromCodePoint;r(r.S+r.F*(!!o&&1!=o.length),"String",{fromCodePoint:function(t){for(var e,n=[],r=arguments.length,o=0;r>o;){if(e=+arguments[o++],i(e,1114111)!==e)throw RangeError(e+" is not a valid code point");n.push(65536>e?s(e):s(((e-=65536)>>10)+55296,e%1024+56320))}return n.join("")}})},function(t,e,n){var r=n(8),i=n(32),s=n(37);r(r.S,"String",{raw:function(t){for(var e=i(t.raw),n=s(e.length),r=arguments.length,o=[],a=0;n>a;)o.push(String(e[a++])),r>a&&o.push(String(arguments[a]));return o.join("")}})},function(t,e,n){"use strict";n(83)("trim",function(t){return function(){return t(this,3)}})},function(t,e,n){"use strict";var r=n(128)(!0);n(129)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=r(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e,n){var r=n(38),i=n(35);t.exports=function(t){return function(e,n){var s,o,a=String(i(e)),u=r(n),c=a.length;return 0>u||u>=c?t?"":void 0:(s=a.charCodeAt(u),55296>s||s>56319||u+1===c||(o=a.charCodeAt(u+1))<56320||o>57343?t?a.charAt(u):s:t?a.slice(u,u+2):(s-55296<<10)+(o-56320)+65536)}}},function(t,e,n){"use strict";var r=n(28),i=n(8),s=n(18),o=n(10),a=n(5),u=n(130),c=n(131),f=n(24),h=n(59),l=n(25)("iterator"),d=!([].keys&&"next"in[].keys()),p="@@iterator",g="keys",y="values",v=function(){return this};t.exports=function(t,e,n,m,S,b,w){c(n,e,m);var E,x,_,R=function(t){if(!d&&t in P)return P[t];switch(t){case g:return function(){return new n(this,t)};case y:return function(){return new n(this,t)}}return function(){return new n(this,t)}},A=e+" Iterator",F=S==y,K=!1,P=t.prototype,U=P[l]||P[p]||S&&P[S],O=U||R(S),C=S?F?R("entries"):O:void 0,I="Array"==e?P.entries||U:U;if(I&&(_=h(I.call(new t)),_!==Object.prototype&&(f(_,A,!0),r||a(_,l)||o(_,l,v))),F&&U&&U.name!==y&&(K=!0,O=function(){return U.call(this)}),r&&!w||!d&&!K&&P[l]||o(P,l,O),u[e]=O,u[A]=v,S)if(E={values:F?O:R(y),keys:b?O:R(g),entries:C},w)for(x in E)x in P||s(P,x,E[x]);else i(i.P+i.F*(d||K),e,E);return E}},function(t,e){t.exports={}},function(t,e,n){"use strict";var r=n(46),i=n(17),s=n(24),o={};n(10)(o,n(25)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=r(o,{next:i(1,n)}),s(t,e+" Iterator")}},function(t,e,n){"use strict";var r=n(8),i=n(128)(!1);r(r.P,"String",{codePointAt:function(t){return i(this,t)}})},function(t,e,n){"use strict";var r=n(8),i=n(37),s=n(134),o="endsWith",a=""[o];r(r.P+r.F*n(136)(o),"String",{endsWith:function(t){var e=s(this,t,o),n=arguments.length>1?arguments[1]:void 0,r=i(e.length),u=void 0===n?r:Math.min(i(n),r),c=String(t);return a?a.call(e,c,u):e.slice(u-c.length,u)===c}})},function(t,e,n){var r=n(135),i=n(35);t.exports=function(t,e,n){if(r(e))throw TypeError("String#"+n+" doesn't accept regex!");return String(i(t))}},function(t,e,n){var r=n(13),i=n(34),s=n(25)("match");t.exports=function(t){var e;return r(t)&&(void 0!==(e=t[s])?!!e:"RegExp"==i(t))}},function(t,e,n){var r=n(25)("match");t.exports=function(t){var e=/./;try{"/./"[t](e)}catch(n){try{return e[r]=!1,!"/./"[t](e)}catch(i){}}return!0}},function(t,e,n){"use strict";var r=n(8),i=n(134),s="includes";r(r.P+r.F*n(136)(s),"String",{includes:function(t){return!!~i(this,t,s).indexOf(t,arguments.length>1?arguments[1]:void 0)}})},function(t,e,n){var r=n(8);r(r.P,"String",{repeat:n(92)})},function(t,e,n){"use strict";var r=n(8),i=n(37),s=n(134),o="startsWith",a=""[o];r(r.P+r.F*n(136)(o),"String",{startsWith:function(t){var e=s(this,t,o),n=i(Math.min(arguments.length>1?arguments[1]:void 0,e.length)),r=String(t);return a?a.call(e,r,n):e.slice(n,n+r.length)===r}})},function(t,e,n){"use strict";n(141)("anchor",function(t){return function(e){return t(this,"a","name",e)}})},function(t,e,n){var r=n(8),i=n(7),s=n(35),o=/"/g,a=function(t,e,n,r){var i=String(s(t)),a="<"+e;return""!==n&&(a+=" "+n+'="'+String(r).replace(o,"&quot;")+'"'),a+">"+i+"</"+e+">"};t.exports=function(t,e){var n={};n[t]=e(a),r(r.P+r.F*i(function(){var e=""[t]('"');return e!==e.toLowerCase()||e.split('"').length>3}),"String",n)}},function(t,e,n){"use strict";n(141)("big",function(t){return function(){return t(this,"big","","")}})},function(t,e,n){"use strict";n(141)("blink",function(t){return function(){return t(this,"blink","","")}})},function(t,e,n){"use strict";n(141)("bold",function(t){return function(){return t(this,"b","","")}})},function(t,e,n){"use strict";n(141)("fixed",function(t){return function(){return t(this,"tt","","")}})},function(t,e,n){"use strict";n(141)("fontcolor",function(t){return function(e){return t(this,"font","color",e)}})},function(t,e,n){"use strict";n(141)("fontsize",function(t){return function(e){return t(this,"font","size",e)}})},function(t,e,n){"use strict";n(141)("italics",function(t){return function(){return t(this,"i","","")}})},function(t,e,n){"use strict";n(141)("link",function(t){return function(e){return t(this,"a","href",e)}})},function(t,e,n){"use strict";n(141)("small",function(t){return function(){return t(this,"small","","")}})},function(t,e,n){"use strict";n(141)("strike",function(t){return function(){return t(this,"strike","","")}})},function(t,e,n){"use strict";n(141)("sub",function(t){return function(){return t(this,"sub","","")}})},function(t,e,n){"use strict";n(141)("sup",function(t){return function(){return t(this,"sup","","")}})},function(t,e,n){var r=n(8);r(r.S,"Date",{now:function(){return(new Date).getTime()}})},function(t,e,n){"use strict";var r=n(8),i=n(58),s=n(16);r(r.P+r.F*n(7)(function(){return null!==new Date(NaN).toJSON()||1!==Date.prototype.toJSON.call({toISOString:function(){return 1}})}),"Date",{toJSON:function(t){var e=i(this),n=s(e);return"number"!=typeof n||isFinite(n)?e.toISOString():null}})},function(t,e,n){"use strict";var r=n(8),i=n(7),s=Date.prototype.getTime,o=function(t){return t>9?t:"0"+t};r(r.P+r.F*(i(function(){return"0385-07-25T07:06:39.999Z"!=new Date(-5e13-1).toISOString()})||!i(function(){new Date(NaN).toISOString()})),"Date",{toISOString:function(){if(!isFinite(s.call(this)))throw RangeError("Invalid time value");
var t=this,e=t.getUTCFullYear(),n=t.getUTCMilliseconds(),r=0>e?"-":e>9999?"+":"";return r+("00000"+Math.abs(e)).slice(r?-6:-4)+"-"+o(t.getUTCMonth()+1)+"-"+o(t.getUTCDate())+"T"+o(t.getUTCHours())+":"+o(t.getUTCMinutes())+":"+o(t.getUTCSeconds())+"."+(n>99?n:"0"+o(n))+"Z"}})},function(t,e,n){var r=Date.prototype,i="Invalid Date",s="toString",o=r[s],a=r.getTime;new Date(NaN)+""!=i&&n(18)(r,s,function(){var t=a.call(this);return t===t?o.call(this):i})},function(t,e,n){var r=n(25)("toPrimitive"),i=Date.prototype;r in i||n(10)(i,r,n(159))},function(t,e,n){"use strict";var r=n(12),i=n(16),s="number";t.exports=function(t){if("string"!==t&&t!==s&&"default"!==t)throw TypeError("Incorrect hint");return i(r(this),t!=s)}},function(t,e,n){var r=n(8);r(r.S,"Array",{isArray:n(45)})},function(t,e,n){"use strict";var r=n(20),i=n(8),s=n(58),o=n(162),a=n(163),u=n(37),c=n(164),f=n(165);i(i.S+i.F*!n(166)(function(t){Array.from(t)}),"Array",{from:function(t){var e,n,i,h,l=s(t),d="function"==typeof this?this:Array,p=arguments.length,g=p>1?arguments[1]:void 0,y=void 0!==g,v=0,m=f(l);if(y&&(g=r(g,p>2?arguments[2]:void 0,2)),void 0==m||d==Array&&a(m))for(e=u(l.length),n=new d(e);e>v;v++)c(n,v,y?g(l[v],v):l[v]);else for(h=m.call(l),n=new d;!(i=h.next()).done;v++)c(n,v,y?o(h,g,[i.value,v],!0):i.value);return n.length=v,n}})},function(t,e,n){var r=n(12);t.exports=function(t,e,n,i){try{return i?e(r(n)[0],n[1]):e(n)}catch(s){var o=t.return;throw void 0!==o&&r(o.call(t)),s}}},function(t,e,n){var r=n(130),i=n(25)("iterator"),s=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||s[i]===t)}},function(t,e,n){"use strict";var r=n(11),i=n(17);t.exports=function(t,e,n){e in t?r.f(t,e,i(0,n)):t[e]=n}},function(t,e,n){var r=n(75),i=n(25)("iterator"),s=n(130);t.exports=n(9).getIteratorMethod=function(t){return void 0!=t?t[i]||t["@@iterator"]||s[r(t)]:void 0}},function(t,e,n){var r=n(25)("iterator"),i=!1;try{var s=[7][r]();s.return=function(){i=!0},Array.from(s,function(){throw 2})}catch(o){}t.exports=function(t,e){if(!e&&!i)return!1;var n=!1;try{var s=[7],o=s[r]();o.next=function(){return{done:n=!0}},s[r]=function(){return o},t(s)}catch(a){}return n}},function(t,e,n){"use strict";var r=n(8),i=n(164);r(r.S+r.F*n(7)(function(){function t(){}return!(Array.of.call(t)instanceof t)}),"Array",{of:function(){for(var t=0,e=arguments.length,n=new("function"==typeof this?this:Array)(e);e>t;)i(n,t,arguments[t++]);return n.length=e,n}})},function(t,e,n){"use strict";var r=n(8),i=n(32),s=[].join;r(r.P+r.F*(n(33)!=Object||!n(169)(s)),"Array",{join:function(t){return s.call(i(this),void 0===t?",":t)}})},function(t,e,n){var r=n(7);t.exports=function(t,e){return!!t&&r(function(){e?t.call(null,function(){},1):t.call(null)})}},function(t,e,n){"use strict";var r=n(8),i=n(48),s=n(34),o=n(39),a=n(37),u=[].slice;r(r.P+r.F*n(7)(function(){i&&u.call(i)}),"Array",{slice:function(t,e){var n=a(this.length),r=s(this);if(e=void 0===e?n:e,"Array"==r)return u.call(this,t,e);for(var i=o(t,n),c=o(e,n),f=a(c-i),h=Array(f),l=0;f>l;l++)h[l]="String"==r?this.charAt(i+l):this[i+l];return h}})},function(t,e,n){"use strict";var r=n(8),i=n(21),s=n(58),o=n(7),a=[].sort,u=[1,2,3];r(r.P+r.F*(o(function(){u.sort(void 0)})||!o(function(){u.sort(null)})||!n(169)(a)),"Array",{sort:function(t){return void 0===t?a.call(s(this)):a.call(s(this),i(t))}})},function(t,e,n){"use strict";var r=n(8),i=n(173)(0),s=n(169)([].forEach,!0);r(r.P+r.F*!s,"Array",{forEach:function(t){return i(this,t,arguments[1])}})},function(t,e,n){var r=n(20),i=n(33),s=n(58),o=n(37),a=n(174);t.exports=function(t,e){var n=1==t,u=2==t,c=3==t,f=4==t,h=6==t,l=5==t||h,d=e||a;return function(e,a,p){for(var g,y,v=s(e),m=i(v),S=r(a,p,3),b=o(m.length),w=0,E=n?d(e,b):u?d(e,0):void 0;b>w;w++)if((l||w in m)&&(g=m[w],y=S(g,w,v),t))if(n)E[w]=y;else if(y)switch(t){case 3:return!0;case 5:return g;case 6:return w;case 2:E.push(g)}else if(f)return!1;return h?-1:c||f?f:E}}},function(t,e,n){var r=n(175);t.exports=function(t,e){return new(r(t))(e)}},function(t,e,n){var r=n(13),i=n(45),s=n(25)("species");t.exports=function(t){var e;return i(t)&&(e=t.constructor,"function"!=typeof e||e!==Array&&!i(e.prototype)||(e=void 0),r(e)&&(e=e[s],null===e&&(e=void 0))),void 0===e?Array:e}},function(t,e,n){"use strict";var r=n(8),i=n(173)(1);r(r.P+r.F*!n(169)([].map,!0),"Array",{map:function(t){return i(this,t,arguments[1])}})},function(t,e,n){"use strict";var r=n(8),i=n(173)(2);r(r.P+r.F*!n(169)([].filter,!0),"Array",{filter:function(t){return i(this,t,arguments[1])}})},function(t,e,n){"use strict";var r=n(8),i=n(173)(3);r(r.P+r.F*!n(169)([].some,!0),"Array",{some:function(t){return i(this,t,arguments[1])}})},function(t,e,n){"use strict";var r=n(8),i=n(173)(4);r(r.P+r.F*!n(169)([].every,!0),"Array",{every:function(t){return i(this,t,arguments[1])}})},function(t,e,n){"use strict";var r=n(8),i=n(181);r(r.P+r.F*!n(169)([].reduce,!0),"Array",{reduce:function(t){return i(this,t,arguments.length,arguments[1],!1)}})},function(t,e,n){var r=n(21),i=n(58),s=n(33),o=n(37);t.exports=function(t,e,n,a,u){r(e);var c=i(t),f=s(c),h=o(c.length),l=u?h-1:0,d=u?-1:1;if(2>n)for(;;){if(l in f){a=f[l],l+=d;break}if(l+=d,u?0>l:l>=h)throw TypeError("Reduce of empty array with no initial value")}for(;u?l>=0:h>l;l+=d)l in f&&(a=e(a,f[l],l,c));return a}},function(t,e,n){"use strict";var r=n(8),i=n(181);r(r.P+r.F*!n(169)([].reduceRight,!0),"Array",{reduceRight:function(t){return i(this,t,arguments.length,arguments[1],!0)}})},function(t,e,n){"use strict";var r=n(8),i=n(36)(!1),s=[].indexOf,o=!!s&&1/[1].indexOf(1,-0)<0;r(r.P+r.F*(o||!n(169)(s)),"Array",{indexOf:function(t){return o?s.apply(this,arguments)||0:i(this,t,arguments[1])}})},function(t,e,n){"use strict";var r=n(8),i=n(32),s=n(38),o=n(37),a=[].lastIndexOf,u=!!a&&1/[1].lastIndexOf(1,-0)<0;r(r.P+r.F*(u||!n(169)(a)),"Array",{lastIndexOf:function(t){if(u)return a.apply(this,arguments)||0;var e=i(this),n=o(e.length),r=n-1;for(arguments.length>1&&(r=Math.min(r,s(arguments[1]))),0>r&&(r=n+r);r>=0;r--)if(r in e&&e[r]===t)return r||0;return-1}})},function(t,e,n){var r=n(8);r(r.P,"Array",{copyWithin:n(186)}),n(187)("copyWithin")},function(t,e,n){"use strict";var r=n(58),i=n(39),s=n(37);t.exports=[].copyWithin||function(t,e){var n=r(this),o=s(n.length),a=i(t,o),u=i(e,o),c=arguments.length>2?arguments[2]:void 0,f=Math.min((void 0===c?o:i(c,o))-u,o-a),h=1;for(a>u&&u+f>a&&(h=-1,u+=f-1,a+=f-1);f-- >0;)u in n?n[a]=n[u]:delete n[a],a+=h,u+=h;return n}},function(t,e,n){var r=n(25)("unscopables"),i=Array.prototype;void 0==i[r]&&n(10)(i,r,{}),t.exports=function(t){i[r][t]=!0}},function(t,e,n){var r=n(8);r(r.P,"Array",{fill:n(189)}),n(187)("fill")},function(t,e,n){"use strict";var r=n(58),i=n(39),s=n(37);t.exports=function(t){for(var e=r(this),n=s(e.length),o=arguments.length,a=i(o>1?arguments[1]:void 0,n),u=o>2?arguments[2]:void 0,c=void 0===u?n:i(u,n);c>a;)e[a++]=t;return e}},function(t,e,n){"use strict";var r=n(8),i=n(173)(5),s="find",o=!0;s in[]&&Array(1)[s](function(){o=!1}),r(r.P+r.F*o,"Array",{find:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),n(187)(s)},function(t,e,n){"use strict";var r=n(8),i=n(173)(6),s="findIndex",o=!0;s in[]&&Array(1)[s](function(){o=!1}),r(r.P+r.F*o,"Array",{findIndex:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),n(187)(s)},function(t,e,n){n(193)("Array")},function(t,e,n){"use strict";var r=n(4),i=n(11),s=n(6),o=n(25)("species");t.exports=function(t){var e=r[t];s&&e&&!e[o]&&i.f(e,o,{configurable:!0,get:function(){return this}})}},function(t,e,n){"use strict";var r=n(187),i=n(195),s=n(130),o=n(32);t.exports=n(129)(Array,"Array",function(t,e){this._t=o(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,i(1)):"keys"==e?i(0,n):"values"==e?i(0,t[n]):i(0,[n,t[n]])},"values"),s.Arguments=s.Array,r("keys"),r("values"),r("entries")},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){var r=n(4),i=n(88),s=n(11).f,o=n(50).f,a=n(135),u=n(197),c=r.RegExp,f=c,h=c.prototype,l=/a/g,d=/a/g,p=new c(l)!==l;if(n(6)&&(!p||n(7)(function(){return d[n(25)("match")]=!1,c(l)!=l||c(d)==d||"/a/i"!=c(l,"i")}))){c=function(t,e){var n=this instanceof c,r=a(t),s=void 0===e;return!n&&r&&t.constructor===c&&s?t:i(p?new f(r&&!s?t.source:t,e):f((r=t instanceof c)?t.source:t,r&&s?u.call(t):e),n?this:h,c)};for(var g=(function(t){t in c||s(c,t,{configurable:!0,get:function(){return f[t]},set:function(e){f[t]=e}})}),y=o(f),v=0;y.length>v;)g(y[v++]);h.constructor=c,c.prototype=h,n(18)(r,"RegExp",c)}n(193)("RegExp")},function(t,e,n){"use strict";var r=n(12);t.exports=function(){var t=r(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}},function(t,e,n){"use strict";n(199);var r=n(12),i=n(197),s=n(6),o="toString",a=/./[o],u=function(t){n(18)(RegExp.prototype,o,t,!0)};n(7)(function(){return"/a/b"!=a.call({source:"a",flags:"b"})})?u(function(){var t=r(this);return"/".concat(t.source,"/","flags"in t?t.flags:!s&&t instanceof RegExp?i.call(t):void 0)}):a.name!=o&&u(function(){return a.call(this)})},function(t,e,n){n(6)&&"g"!=/./g.flags&&n(11).f(RegExp.prototype,"flags",{configurable:!0,get:n(197)})},function(t,e,n){n(201)("match",1,function(t,e,n){return[function(n){"use strict";var r=t(this),i=void 0==n?void 0:n[e];return void 0!==i?i.call(n,r):new RegExp(n)[e](String(r))},n]})},function(t,e,n){"use strict";var r=n(10),i=n(18),s=n(7),o=n(35),a=n(25);t.exports=function(t,e,n){var u=a(t),c=n(o,u,""[t]),f=c[0],h=c[1];s(function(){var e={};return e[u]=function(){return 7},7!=""[t](e)})&&(i(String.prototype,t,f),r(RegExp.prototype,u,2==e?function(t,e){return h.call(t,this,e)}:function(t){return h.call(t,this)}))}},function(t,e,n){n(201)("replace",2,function(t,e,n){return[function(r,i){"use strict";var s=t(this),o=void 0==r?void 0:r[e];return void 0!==o?o.call(r,s,i):n.call(String(s),r,i)},n]})},function(t,e,n){n(201)("search",1,function(t,e,n){return[function(n){"use strict";var r=t(this),i=void 0==n?void 0:n[e];return void 0!==i?i.call(n,r):new RegExp(n)[e](String(r))},n]})},function(t,e,n){n(201)("split",2,function(t,e,r){"use strict";var i=n(135),s=r,o=[].push,a="split",u="length",c="lastIndex";if("c"=="abbc"[a](/(b)*/)[1]||4!="test"[a](/(?:)/,-1)[u]||2!="ab"[a](/(?:ab)*/)[u]||4!="."[a](/(.?)(.?)/)[u]||"."[a](/()()/)[u]>1||""[a](/.?/)[u]){var f=void 0===/()??/.exec("")[1];r=function(t,e){var n=String(this);if(void 0===t&&0===e)return[];if(!i(t))return s.call(n,t,e);var r,a,h,l,d,p=[],g=(t.ignoreCase?"i":"")+(t.multiline?"m":"")+(t.unicode?"u":"")+(t.sticky?"y":""),y=0,v=void 0===e?4294967295:e>>>0,m=new RegExp(t.source,g+"g");for(f||(r=new RegExp("^"+m.source+"$(?!\\s)",g));(a=m.exec(n))&&(h=a.index+a[0][u],!(h>y&&(p.push(n.slice(y,a.index)),!f&&a[u]>1&&a[0].replace(r,function(){for(d=1;d<arguments[u]-2;d++)void 0===arguments[d]&&(a[d]=void 0)}),a[u]>1&&a.index<n[u]&&o.apply(p,a.slice(1)),l=a[0][u],y=h,p[u]>=v)));)m[c]===a.index&&m[c]++;return y===n[u]?!l&&m.test("")||p.push(""):p.push(n.slice(y)),p[u]>v?p.slice(0,v):p}}else"0"[a](void 0,0)[u]&&(r=function(t,e){return void 0===t&&0===e?[]:s.call(this,t,e)});return[function(n,i){var s=t(this),o=void 0==n?void 0:n[e];return void 0!==o?o.call(n,s,i):r.call(String(s),n,i)},r]})},function(t,e,n){"use strict";var r,i,s,o=n(28),a=n(4),u=n(20),c=n(75),f=n(8),h=n(13),l=(n(12),n(21)),d=n(90),p=n(206),g=(n(73).set,n(207)),y=n(208).set,v=n(209)(),m="Promise",S=a.TypeError,b=a.process,w=a[m],b=a.process,E="process"==c(b),x=function(){},_=!!function(){try{var t=w.resolve(1),e=(t.constructor={})[n(25)("species")]=function(t){t(x,x)};return(E||"function"==typeof PromiseRejectionEvent)&&t.then(x)instanceof e}catch(r){}}(),R=function(t,e){return t===e||t===w&&e===s},A=function(t){var e;return h(t)&&"function"==typeof(e=t.then)?e:!1},F=function(t){return R(w,t)?new K(t):new i(t)},K=i=function(t){var e,n;this.promise=new t(function(t,r){if(void 0!==e||void 0!==n)throw S("Bad Promise constructor");e=t,n=r}),this.resolve=l(e),this.reject=l(n)},P=function(t){try{t()}catch(e){return{error:e}}},U=function(t,e){if(!t._n){t._n=!0;var n=t._c;v(function(){for(var r=t._v,i=1==t._s,s=0,o=function(e){var n,s,o=i?e.ok:e.fail,a=e.resolve,u=e.reject,c=e.domain;try{o?(i||(2==t._h&&I(t),t._h=1),o===!0?n=r:(c&&c.enter(),n=o(r),c&&c.exit()),n===e.promise?u(S("Promise-chain cycle")):(s=A(n))?s.call(n,a,u):a(n)):u(r)}catch(f){u(f)}};n.length>s;)o(n[s++]);t._c=[],t._n=!1,e&&!t._h&&O(t)})}},O=function(t){y.call(a,function(){var e,n,r,i=t._v;if(C(t)&&(e=P(function(){E?b.emit("unhandledRejection",i,t):(n=a.onunhandledrejection)?n({promise:t,reason:i}):(r=a.console)&&r.error&&r.error("Unhandled promise rejection",i)}),t._h=E||C(t)?2:1),t._a=void 0,e)throw e.error})},C=function(t){if(1==t._h)return!1;for(var e,n=t._a||t._c,r=0;n.length>r;)if(e=n[r++],e.fail||!C(e.promise))return!1;return!0},I=function(t){y.call(a,function(){var e;E?b.emit("rejectionHandled",t):(e=a.onrejectionhandled)&&e({promise:t,reason:t._v})})},j=function(t){var e=this;e._d||(e._d=!0,e=e._w||e,e._v=t,e._s=2,e._a||(e._a=e._c.slice()),U(e,!0))},T=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw S("Promise can't be resolved itself");(e=A(t))?v(function(){var r={_w:n,_d:!1};try{e.call(t,u(T,r,1),u(j,r,1))}catch(i){j.call(r,i)}}):(n._v=t,n._s=1,U(n,!1))}catch(r){j.call({_w:n,_d:!1},r)}}};_||(w=function(t){d(this,w,m,"_h"),l(t),r.call(this);try{t(u(T,this,1),u(j,this,1))}catch(e){j.call(this,e)}},r=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},r.prototype=n(210)(w.prototype,{then:function(t,e){var n=F(g(this,w));return n.ok="function"==typeof t?t:!0,n.fail="function"==typeof e&&e,n.domain=E?b.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&U(this,!1),n.promise},"catch":function(t){return this.then(void 0,t)}}),K=function(){var t=new r;this.promise=t,this.resolve=u(T,t,1),this.reject=u(j,t,1)}),f(f.G+f.W+f.F*!_,{Promise:w}),n(24)(w,m),n(193)(m),s=n(9)[m],f(f.S+f.F*!_,m,{reject:function(t){var e=F(this),n=e.reject;return n(t),e.promise}}),f(f.S+f.F*(o||!_),m,{resolve:function(t){if(t instanceof w&&R(t.constructor,this))return t;var e=F(this),n=e.resolve;return n(t),e.promise}}),f(f.S+f.F*!(_&&n(166)(function(t){w.all(t).catch(x)})),m,{all:function(t){var e=this,n=F(e),r=n.resolve,i=n.reject,s=P(function(){var n=[],s=0,o=1;p(t,!1,function(t){var a=s++,u=!1;n.push(void 0),o++,e.resolve(t).then(function(t){u||(u=!0,n[a]=t,--o||r(n))},i)}),--o||r(n)});return s&&i(s.error),n.promise},race:function(t){var e=this,n=F(e),r=n.reject,i=P(function(){p(t,!1,function(t){e.resolve(t).then(n.resolve,r)})});return i&&r(i.error),n.promise}})},function(t,e,n){var r=n(20),i=n(162),s=n(163),o=n(12),a=n(37),u=n(165),c={},f={},e=t.exports=function(t,e,n,h,l){var d,p,g,y,v=l?function(){return t}:u(t),m=r(n,h,e?2:1),S=0;if("function"!=typeof v)throw TypeError(t+" is not iterable!");if(s(v)){for(d=a(t.length);d>S;S++)if(y=e?m(o(p=t[S])[0],p[1]):m(t[S]),y===c||y===f)return y}else for(g=v.call(t);!(p=g.next()).done;)if(y=i(g,m,p.value,e),y===c||y===f)return y};e.BREAK=c,e.RETURN=f},function(t,e,n){var r=n(12),i=n(21),s=n(25)("species");t.exports=function(t,e){var n,o=r(t).constructor;return void 0===o||void 0==(n=r(o)[s])?e:i(n)}},function(t,e,n){var r,i,s,o=n(20),a=n(78),u=n(48),c=n(15),f=n(4),h=f.process,l=f.setImmediate,d=f.clearImmediate,p=f.MessageChannel,g=0,y={},v="onreadystatechange",m=function(){var t=+this;if(y.hasOwnProperty(t)){var e=y[t];delete y[t],e()}},S=function(t){m.call(t.data)};l&&d||(l=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return y[++g]=function(){a("function"==typeof t?t:Function(t),e)},r(g),g},d=function(t){delete y[t]},"process"==n(34)(h)?r=function(t){h.nextTick(o(m,t,1))}:p?(i=new p,s=i.port2,i.port1.onmessage=S,r=o(s.postMessage,s,1)):f.addEventListener&&"function"==typeof postMessage&&!f.importScripts?(r=function(t){f.postMessage(t+"","*")},f.addEventListener("message",S,!1)):r=v in c("script")?function(t){u.appendChild(c("script"))[v]=function(){u.removeChild(this),m.call(t)}}:function(t){setTimeout(o(m,t,1),0)}),t.exports={set:l,clear:d}},function(t,e,n){var r=n(4),i=n(208).set,s=r.MutationObserver||r.WebKitMutationObserver,o=r.process,a=r.Promise,u="process"==n(34)(o);t.exports=function(){var t,e,n,c=function(){var r,i;for(u&&(r=o.domain)&&r.exit();t;){i=t.fn,t=t.next;try{i()}catch(s){throw t?n():e=void 0,s}}e=void 0,r&&r.enter()};if(u)n=function(){o.nextTick(c)};else if(s){var f=!0,h=document.createTextNode("");new s(c).observe(h,{characterData:!0}),n=function(){h.data=f=!f}}else if(a&&a.resolve){var l=a.resolve();n=function(){l.then(c)}}else n=function(){i.call(r,c)};return function(r){var i={fn:r,next:void 0};e&&(e.next=i),t||(t=i,n()),e=i}}},function(t,e,n){var r=n(18);t.exports=function(t,e,n){for(var i in e)r(t,i,e[i],n);return t}},function(t,e,n){"use strict";var r=n(212);t.exports=n(213)("Map",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},{get:function(t){var e=r.getEntry(this,t);return e&&e.v},set:function(t,e){return r.def(this,0===t?0:t,e)}},r,!0)},function(t,e,n){"use strict";var r=n(11).f,i=n(46),s=(n(10),n(210)),o=n(20),a=n(90),u=n(35),c=n(206),f=n(129),h=n(195),l=n(193),d=n(6),p=n(22).fastKey,g=d?"_s":"size",y=function(t,e){var n,r=p(e);if("F"!==r)return t._i[r];for(n=t._f;n;n=n.n)if(n.k==e)return n};t.exports={getConstructor:function(t,e,n,f){var h=t(function(t,r){a(t,h,e,"_i"),t._i=i(null),t._f=void 0,t._l=void 0,t[g]=0,void 0!=r&&c(r,n,t[f],t)});return s(h.prototype,{clear:function(){for(var t=this,e=t._i,n=t._f;n;n=n.n)n.r=!0,n.p&&(n.p=n.p.n=void 0),delete e[n.i];t._f=t._l=void 0,t[g]=0},"delete":function(t){var e=this,n=y(e,t);if(n){var r=n.n,i=n.p;delete e._i[n.i],n.r=!0,i&&(i.n=r),r&&(r.p=i),e._f==n&&(e._f=r),e._l==n&&(e._l=i),e[g]--}return!!n},forEach:function(t){a(this,h,"forEach");for(var e,n=o(t,arguments.length>1?arguments[1]:void 0,3);e=e?e.n:this._f;)for(n(e.v,e.k,this);e&&e.r;)e=e.p},has:function(t){return!!y(this,t)}}),d&&r(h.prototype,"size",{get:function(){return u(this[g])}}),h},def:function(t,e,n){var r,i,s=y(t,e);return s?s.v=n:(t._l=s={i:i=p(e,!0),k:e,v:n,p:r=t._l,n:void 0,r:!1},t._f||(t._f=s),r&&(r.n=s),t[g]++,"F"!==i&&(t._i[i]=s)),t},getEntry:y,setStrong:function(t,e,n){f(t,e,function(t,e){this._t=t,this._k=e,this._l=void 0},function(){for(var t=this,e=t._k,n=t._l;n&&n.r;)n=n.p;return t._t&&(t._l=n=n?n.n:t._t._f)?"keys"==e?h(0,n.k):"values"==e?h(0,n.v):h(0,[n.k,n.v]):(t._t=void 0,h(1))},n?"entries":"values",!n,!0),l(e)}}},function(t,e,n){"use strict";var r=n(4),i=n(8),s=n(18),o=n(210),a=n(22),u=n(206),c=n(90),f=n(13),h=n(7),l=n(166),d=n(24),p=n(88);t.exports=function(t,e,n,g,y,v){var m=r[t],S=m,b=y?"set":"add",w=S&&S.prototype,E={},x=function(t){var e=w[t];s(w,t,"delete"==t?function(t){return v&&!f(t)?!1:e.call(this,0===t?0:t)}:"has"==t?function(t){return v&&!f(t)?!1:e.call(this,0===t?0:t)}:"get"==t?function(t){return v&&!f(t)?void 0:e.call(this,0===t?0:t)}:"add"==t?function(t){return e.call(this,0===t?0:t),this}:function(t,n){return e.call(this,0===t?0:t,n),this})};if("function"==typeof S&&(v||w.forEach&&!h(function(){(new S).entries().next()}))){var _=new S,R=_[b](v?{}:-0,1)!=_,A=h(function(){_.has(1)}),F=l(function(t){new S(t)}),K=!v&&h(function(){for(var t=new S,e=5;e--;)t[b](e,e);return!t.has(-0)});F||(S=e(function(e,n){c(e,S,t);var r=p(new m,e,S);return void 0!=n&&u(n,y,r[b],r),r}),S.prototype=w,w.constructor=S),(A||K)&&(x("delete"),x("has"),y&&x("get")),(K||R)&&x(b),v&&w.clear&&delete w.clear}else S=g.getConstructor(e,t,y,b),o(S.prototype,n),a.NEED=!0;return d(S,t),E[t]=S,i(i.G+i.W+i.F*(S!=m),E),v||g.setStrong(S,t,y),S}},function(t,e,n){"use strict";var r=n(212);t.exports=n(213)("Set",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},{add:function(t){return r.def(this,t=0===t?0:t,t)}},r)},function(t,e,n){"use strict";var r,i=n(173)(0),s=n(18),o=n(22),a=n(69),u=n(216),c=n(13),f=(n(5),o.getWeak),h=Object.isExtensible,l=u.ufstore,d={},p=function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},g={get:function(t){if(c(t)){var e=f(t);return e===!0?l(this).get(t):e?e[this._i]:void 0}},set:function(t,e){return u.def(this,t,e)}},y=t.exports=n(213)("WeakMap",p,g,u,!0,!0);7!=(new y).set((Object.freeze||Object)(d),7).get(d)&&(r=u.getConstructor(p),a(r.prototype,g),o.NEED=!0,i(["delete","has","get","set"],function(t){var e=y.prototype,n=e[t];s(e,t,function(e,i){if(c(e)&&!h(e)){this._f||(this._f=new r);var s=this._f[t](e,i);return"set"==t?this:s}return n.call(this,e,i)})}))},function(t,e,n){"use strict";var r=n(210),i=n(22).getWeak,s=n(12),o=n(13),a=n(90),u=n(206),c=n(173),f=n(5),h=c(5),l=c(6),d=0,p=function(t){return t._l||(t._l=new g)},g=function(){this.a=[]},y=function(t,e){return h(t.a,function(t){return t[0]===e})};g.prototype={get:function(t){var e=y(this,t);return e?e[1]:void 0},has:function(t){return!!y(this,t)},set:function(t,e){var n=y(this,t);n?n[1]=e:this.a.push([t,e])},"delete":function(t){var e=l(this.a,function(e){return e[0]===t});return~e&&this.a.splice(e,1),!!~e}},t.exports={getConstructor:function(t,e,n,s){var c=t(function(t,r){a(t,c,e,"_i"),t._i=d++,t._l=void 0,void 0!=r&&u(r,n,t[s],t)});return r(c.prototype,{"delete":function(t){if(!o(t))return!1;var e=i(t);return e===!0?p(this).delete(t):e&&f(e,this._i)&&delete e[this._i]},has:function(t){if(!o(t))return!1;var e=i(t);return e===!0?p(this).has(t):e&&f(e,this._i)}}),c},def:function(t,e,n){var r=i(s(e),!0);return r===!0?p(t).set(e,n):r[t._i]=n,t},ufstore:p}},function(t,e,n){"use strict";var r=n(216);n(213)("WeakSet",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},{add:function(t){return r.def(this,t,!0)}},r,!1,!0)},function(t,e,n){"use strict";var r=n(8),i=n(219),s=n(220),o=n(12),a=n(39),u=n(37),c=n(13),f=(n(25)("typed_array"),n(4).ArrayBuffer),h=n(207),l=s.ArrayBuffer,d=s.DataView,p=i.ABV&&f.isView,g=l.prototype.slice,y=i.VIEW,v="ArrayBuffer";r(r.G+r.W+r.F*(f!==l),{ArrayBuffer:l}),r(r.S+r.F*!i.CONSTR,v,{isView:function(t){return p&&p(t)||c(t)&&y in t}}),r(r.P+r.U+r.F*n(7)(function(){return!new l(2).slice(1,void 0).byteLength}),v,{slice:function(t,e){if(void 0!==g&&void 0===e)return g.call(o(this),t);for(var n=o(this).byteLength,r=a(t,n),i=a(void 0===e?n:e,n),s=new(h(this,l))(u(i-r)),c=new d(this),f=new d(s),p=0;i>r;)f.setUint8(p++,c.getUint8(r++));return s}}),n(193)(v)},function(t,e,n){for(var r,i=n(4),s=n(10),o=n(19),a=o("typed_array"),u=o("view"),c=!(!i.ArrayBuffer||!i.DataView),f=c,h=0,l=9,d="Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(",");l>h;)(r=i[d[h++]])?(s(r.prototype,a,!0),s(r.prototype,u,!0)):f=!1;t.exports={ABV:c,CONSTR:f,TYPED:a,VIEW:u}},function(t,e,n){"use strict";var r=n(4),i=n(6),s=n(28),o=n(219),a=n(10),u=n(210),c=n(7),f=n(90),h=n(38),l=n(37),d=n(50).f,p=n(11).f,g=n(189),y=n(24),v="ArrayBuffer",m="DataView",S="prototype",b="Wrong length!",w="Wrong index!",E=r[v],x=r[m],_=r.Math,R=(r.parseInt,r.RangeError),A=r.Infinity,F=E,K=_.abs,P=_.pow,U=(_.min,_.floor),O=_.log,C=_.LN2,I="buffer",j="byteLength",T="byteOffset",D=i?"_b":I,J=i?"_l":j,H=i?"_o":T,B=function(t,e,n){var r,i,s,o=Array(n),a=8*n-e-1,u=(1<<a)-1,c=u>>1,f=23===e?P(2,-24)-P(2,-77):0,h=0,l=0>t||0===t&&0>1/t?1:0;for(t=K(t),t!=t||t===A?(i=t!=t?1:0,r=u):(r=U(O(t)/C),t*(s=P(2,-r))<1&&(r--,s*=2),t+=r+c>=1?f/s:f*P(2,1-c),t*s>=2&&(r++,s/=2),r+c>=u?(i=0,r=u):r+c>=1?(i=(t*s-1)*P(2,e),r+=c):(i=t*P(2,c-1)*P(2,e),r=0));e>=8;o[h++]=255&i,i/=256,e-=8);for(r=r<<e|i,a+=e;a>0;o[h++]=255&r,r/=256,a-=8);return o[--h]|=128*l,o},k=function(t,e,n){var r,i=8*n-e-1,s=(1<<i)-1,o=s>>1,a=i-7,u=n-1,c=t[u--],f=127&c;for(c>>=7;a>0;f=256*f+t[u],u--,a-=8);for(r=f&(1<<-a)-1,f>>=-a,a+=e;a>0;r=256*r+t[u],u--,a-=8);if(0===f)f=1-o;else{if(f===s)return r?NaN:c?-A:A;r+=P(2,e),f-=o}return(c?-1:1)*r*P(2,f-e)},N=function(t){return t[3]<<24|t[2]<<16|t[1]<<8|t[0]},M=function(t){return[255&t]},V=function(t){return[255&t,t>>8&255]},L=function(t){return[255&t,t>>8&255,t>>16&255,t>>24&255]},q=function(t){return B(t,52,8)},W=function(t){return B(t,23,4)},z=function(t,e,n){p(t[S],e,{get:function(){return this[n]}})},Y=function(t,e,n,r){var i=+n,s=h(i);if(i!=s||0>s||s+e>t[J])throw R(w);var o=t[D]._b,a=s+t[H],u=o.slice(a,a+e);return r?u:u.reverse()},G=function(t,e,n,r,i,s){var o=+n,a=h(o);if(o!=a||0>a||a+e>t[J])throw R(w);for(var u=t[D]._b,c=a+t[H],f=r(+i),l=0;e>l;l++)u[c+l]=f[s?l:e-l-1]},X=function(t,e){f(t,E,v);var n=+e,r=l(n);if(n!=r)throw R(b);return r};if(o.ABV){if(!c(function(){new E})||!c(function(){new E(.5)})){E=function(t){return new F(X(this,t))};for(var $,Z=E[S]=F[S],Q=d(F),tt=0;Q.length>tt;)($=Q[tt++])in E||a(E,$,F[$]);s||(Z.constructor=E)}var et=new x(new E(2)),nt=x[S].setInt8;et.setInt8(0,2147483648),et.setInt8(1,2147483649),!et.getInt8(0)&&et.getInt8(1)||u(x[S],{setInt8:function(t,e){nt.call(this,t,e<<24>>24)},setUint8:function(t,e){nt.call(this,t,e<<24>>24)}},!0)}else E=function(t){var e=X(this,t);this._b=g.call(Array(e),0),this[J]=e},x=function(t,e,n){f(this,x,m),f(t,E,m);var r=t[J],i=h(e);if(0>i||i>r)throw R("Wrong offset!");if(n=void 0===n?r-i:l(n),i+n>r)throw R(b);this[D]=t,this[H]=i,this[J]=n},i&&(z(E,j,"_l"),z(x,I,"_b"),z(x,j,"_l"),z(x,T,"_o")),u(x[S],{getInt8:function(t){return Y(this,1,t)[0]<<24>>24},getUint8:function(t){return Y(this,1,t)[0]},getInt16:function(t){var e=Y(this,2,t,arguments[1]);return(e[1]<<8|e[0])<<16>>16},getUint16:function(t){var e=Y(this,2,t,arguments[1]);return e[1]<<8|e[0]},getInt32:function(t){return N(Y(this,4,t,arguments[1]))},getUint32:function(t){return N(Y(this,4,t,arguments[1]))>>>0},getFloat32:function(t){return k(Y(this,4,t,arguments[1]),23,4)},getFloat64:function(t){return k(Y(this,8,t,arguments[1]),52,8)},setInt8:function(t,e){G(this,1,t,M,e)},setUint8:function(t,e){G(this,1,t,M,e)},setInt16:function(t,e){G(this,2,t,V,e,arguments[2])},setUint16:function(t,e){G(this,2,t,V,e,arguments[2])},setInt32:function(t,e){G(this,4,t,L,e,arguments[2])},setUint32:function(t,e){G(this,4,t,L,e,arguments[2])},setFloat32:function(t,e){G(this,4,t,W,e,arguments[2])},setFloat64:function(t,e){G(this,8,t,q,e,arguments[2])}});y(E,v),y(x,m),a(x[S],o.VIEW,!0),e[v]=E,e[m]=x},function(t,e,n){var r=n(8);r(r.G+r.W+r.F*!n(219).ABV,{DataView:n(220).DataView})},function(t,e,n){n(223)("Int8",1,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){"use strict";if(n(6)){var r=n(28),i=n(4),s=n(7),o=n(8),a=n(219),u=n(220),c=n(20),f=n(90),h=n(17),l=n(10),d=n(210),p=(n(97),n(38)),g=n(37),y=n(39),v=n(16),m=n(5),S=n(71),b=n(75),w=n(13),E=n(58),x=n(163),_=n(46),R=n(59),A=n(50).f,F=(n(224),n(165)),K=n(19),P=n(25),U=n(173),O=n(36),C=n(207),I=n(194),j=n(130),T=n(166),D=n(193),J=n(189),H=n(186),B=n(11),k=n(51),N=B.f,M=k.f,V=i.RangeError,L=i.TypeError,q=i.Uint8Array,W="ArrayBuffer",z="Shared"+W,Y="BYTES_PER_ELEMENT",G="prototype",X=Array[G],$=u.ArrayBuffer,Z=u.DataView,Q=U(0),tt=U(2),et=U(3),nt=U(4),rt=U(5),it=U(6),st=O(!0),ot=O(!1),at=I.values,ut=I.keys,ct=I.entries,ft=X.lastIndexOf,ht=X.reduce,lt=X.reduceRight,dt=X.join,pt=X.sort,gt=X.slice,yt=X.toString,vt=X.toLocaleString,mt=P("iterator"),St=P("toStringTag"),bt=K("typed_constructor"),wt=K("def_constructor"),Et=a.CONSTR,xt=a.TYPED,_t=a.VIEW,Rt="Wrong length!",At=U(1,function(t,e){return Ct(C(t,t[wt]),e)}),Ft=s(function(){return 1===new q(new Uint16Array([1]).buffer)[0]}),Kt=!!q&&!!q[G].set&&s(function(){new q(1).set({})}),Pt=function(t,e){if(void 0===t)throw L(Rt);var n=+t,r=g(t);if(e&&!S(n,r))throw V(Rt);return r},Ut=function(t,e){var n=p(t);if(0>n||n%e)throw V("Wrong offset!");return n},Ot=function(t){if(w(t)&&xt in t)return t;throw L(t+" is not a typed array!")},Ct=function(t,e){if(!(w(t)&&bt in t))throw L("It is not a typed array constructor!");return new t(e)},It=function(t,e){return jt(C(t,t[wt]),e)},jt=function(t,e){for(var n=0,r=e.length,i=Ct(t,r);r>n;)i[n]=e[n++];return i},Tt=function(t,e,n){N(t,e,{get:function(){return this._d[n]}})},Dt=function(t){var e,n,r,i,s,o,a=E(t),u=arguments.length,f=u>1?arguments[1]:void 0,h=void 0!==f,l=F(a);if(void 0!=l&&!x(l)){for(o=l.call(a),r=[],e=0;!(s=o.next()).done;e++)r.push(s.value);a=r}for(h&&u>2&&(f=c(f,arguments[2],2)),e=0,n=g(a.length),i=Ct(this,n);n>e;e++)i[e]=h?f(a[e],e):a[e];return i},Jt=function(){for(var t=0,e=arguments.length,n=Ct(this,e);e>t;)n[t]=arguments[t++];return n},Ht=!!q&&s(function(){vt.call(new q(1))}),Bt=function(){return vt.apply(Ht?gt.call(Ot(this)):Ot(this),arguments)},kt={copyWithin:function(t,e){return H.call(Ot(this),t,e,arguments.length>2?arguments[2]:void 0)},every:function(t){return nt(Ot(this),t,arguments.length>1?arguments[1]:void 0)},fill:function(t){return J.apply(Ot(this),arguments)},filter:function(t){return It(this,tt(Ot(this),t,arguments.length>1?arguments[1]:void 0))},find:function(t){return rt(Ot(this),t,arguments.length>1?arguments[1]:void 0)},findIndex:function(t){return it(Ot(this),t,arguments.length>1?arguments[1]:void 0)},forEach:function(t){Q(Ot(this),t,arguments.length>1?arguments[1]:void 0)},indexOf:function(t){return ot(Ot(this),t,arguments.length>1?arguments[1]:void 0)},includes:function(t){return st(Ot(this),t,arguments.length>1?arguments[1]:void 0)},join:function(t){return dt.apply(Ot(this),arguments)},lastIndexOf:function(t){return ft.apply(Ot(this),arguments)},map:function(t){return At(Ot(this),t,arguments.length>1?arguments[1]:void 0)},reduce:function(t){return ht.apply(Ot(this),arguments)},reduceRight:function(t){return lt.apply(Ot(this),arguments)},reverse:function(){for(var t,e=this,n=Ot(e).length,r=Math.floor(n/2),i=0;r>i;)t=e[i],e[i++]=e[--n],e[n]=t;return e},some:function(t){return et(Ot(this),t,arguments.length>1?arguments[1]:void 0)},sort:function(t){return pt.call(Ot(this),t)},subarray:function(t,e){var n=Ot(this),r=n.length,i=y(t,r);return new(C(n,n[wt]))(n.buffer,n.byteOffset+i*n.BYTES_PER_ELEMENT,g((void 0===e?r:y(e,r))-i))}},Nt=function(t,e){return It(this,gt.call(Ot(this),t,e))},Mt=function(t){Ot(this);var e=Ut(arguments[1],1),n=this.length,r=E(t),i=g(r.length),s=0;if(i+e>n)throw V(Rt);for(;i>s;)this[e+s]=r[s++]},Vt={entries:function(){return ct.call(Ot(this))},keys:function(){return ut.call(Ot(this))},values:function(){return at.call(Ot(this))}},Lt=function(t,e){return w(t)&&t[xt]&&"symbol"!=typeof e&&e in t&&String(+e)==String(e)},qt=function(t,e){return Lt(t,e=v(e,!0))?h(2,t[e]):M(t,e)},Wt=function(t,e,n){return!(Lt(t,e=v(e,!0))&&w(n)&&m(n,"value"))||m(n,"get")||m(n,"set")||n.configurable||m(n,"writable")&&!n.writable||m(n,"enumerable")&&!n.enumerable?N(t,e,n):(t[e]=n.value,t)};Et||(k.f=qt,B.f=Wt),o(o.S+o.F*!Et,"Object",{getOwnPropertyDescriptor:qt,defineProperty:Wt}),s(function(){yt.call({})})&&(yt=vt=function(){return dt.call(this)});var zt=d({},kt);d(zt,Vt),l(zt,mt,Vt.values),d(zt,{slice:Nt,set:Mt,constructor:function(){},toString:yt,toLocaleString:Bt}),Tt(zt,"buffer","b"),Tt(zt,"byteOffset","o"),Tt(zt,"byteLength","l"),Tt(zt,"length","e"),N(zt,St,{get:function(){return this[xt]}}),t.exports=function(t,e,n,u){u=!!u;var c=t+(u?"Clamped":"")+"Array",h="Uint8Array"!=c,d="get"+t,p="set"+t,y=i[c],v=y||{},m=y&&R(y),S=!y||!a.ABV,E={},x=y&&y[G],F=function(t,n){var r=t._d;return r.v[d](n*e+r.o,Ft)},K=function(t,n,r){var i=t._d;u&&(r=(r=Math.round(r))<0?0:r>255?255:255&r),i.v[p](n*e+i.o,r,Ft)},P=function(t,e){N(t,e,{get:function(){return F(this,e)},set:function(t){return K(this,e,t)},enumerable:!0})};S?(y=n(function(t,n,r,i){f(t,y,c,"_d");var s,o,a,u,h=0,d=0;if(w(n)){if(!(n instanceof $||(u=b(n))==W||u==z))return xt in n?jt(y,n):Dt.call(y,n);s=n,d=Ut(r,e);var p=n.byteLength;if(void 0===i){if(p%e)throw V(Rt);if(o=p-d,0>o)throw V(Rt)}else if(o=g(i)*e,o+d>p)throw V(Rt);a=o/e}else a=Pt(n,!0),o=a*e,s=new $(o);for(l(t,"_d",{b:s,o:d,l:o,e:a,v:new Z(s)});a>h;)P(t,h++)}),x=y[G]=_(zt),l(x,"constructor",y)):T(function(t){new y(null),new y(t)},!0)||(y=n(function(t,n,r,i){f(t,y,c);var s;return w(n)?n instanceof $||(s=b(n))==W||s==z?void 0!==i?new v(n,Ut(r,e),i):void 0!==r?new v(n,Ut(r,e)):new v(n):xt in n?jt(y,n):Dt.call(y,n):new v(Pt(n,h));
}),Q(m!==Function.prototype?A(v).concat(A(m)):A(v),function(t){t in y||l(y,t,v[t])}),y[G]=x,r||(x.constructor=y));var U=x[mt],O=!!U&&("values"==U.name||void 0==U.name),C=Vt.values;l(y,bt,!0),l(x,xt,c),l(x,_t,!0),l(x,wt,y),(u?new y(1)[St]==c:St in x)||N(x,St,{get:function(){return c}}),E[c]=y,o(o.G+o.W+o.F*(y!=v),E),o(o.S,c,{BYTES_PER_ELEMENT:e,from:Dt,of:Jt}),Y in x||l(x,Y,e),o(o.P,c,kt),D(c),o(o.P+o.F*Kt,c,{set:Mt}),o(o.P+o.F*!O,c,Vt),o(o.P+o.F*(x.toString!=yt),c,{toString:yt}),o(o.P+o.F*s(function(){new y(1).slice()}),c,{slice:Nt}),o(o.P+o.F*(s(function(){return[1,2].toLocaleString()!=new y([1,2]).toLocaleString()})||!s(function(){x.toLocaleString.call([1,2])})),c,{toLocaleString:Bt}),j[c]=O?U:C,r||O||l(x,mt,C)}}else t.exports=function(){}},function(t,e,n){var r=n(75),i=n(25)("iterator"),s=n(130);t.exports=n(9).isIterable=function(t){var e=Object(t);return void 0!==e[i]||"@@iterator"in e||s.hasOwnProperty(r(e))}},function(t,e,n){n(223)("Uint8",1,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(223)("Uint8",1,function(t){return function(e,n,r){return t(this,e,n,r)}},!0)},function(t,e,n){n(223)("Int16",2,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(223)("Uint16",2,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(223)("Int32",4,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(223)("Uint32",4,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(223)("Float32",4,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(223)("Float64",8,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){var r=n(8),i=n(21),s=n(12),o=Function.apply;r(r.S,"Reflect",{apply:function(t,e,n){return o.call(i(t),e,s(n))}})},function(t,e,n){var r=n(8),i=n(46),s=n(21),o=n(12),a=n(13),u=n(77);r(r.S+r.F*n(7)(function(){function t(){}return!(Reflect.construct(function(){},[],t)instanceof t)}),"Reflect",{construct:function(t,e){s(t),o(e);var n=arguments.length<3?t:s(arguments[2]);if(t==n){switch(e.length){case 0:return new t;case 1:return new t(e[0]);case 2:return new t(e[0],e[1]);case 3:return new t(e[0],e[1],e[2]);case 4:return new t(e[0],e[1],e[2],e[3])}var r=[null];return r.push.apply(r,e),new(u.apply(t,r))}var c=n.prototype,f=i(a(c)?c:Object.prototype),h=Function.apply.call(t,f,e);return a(h)?h:f}})},function(t,e,n){var r=n(11),i=n(8),s=n(12),o=n(16);i(i.S+i.F*n(7)(function(){Reflect.defineProperty(r.f({},1,{value:1}),1,{value:2})}),"Reflect",{defineProperty:function(t,e,n){s(t),e=o(e,!0),s(n);try{return r.f(t,e,n),!0}catch(i){return!1}}})},function(t,e,n){var r=n(8),i=n(51).f,s=n(12);r(r.S,"Reflect",{deleteProperty:function(t,e){var n=i(s(t),e);return n&&!n.configurable?!1:delete t[e]}})},function(t,e,n){"use strict";var r=n(8),i=n(12),s=function(t){this._t=i(t),this._i=0;var e,n=this._k=[];for(e in t)n.push(e)};n(131)(s,"Object",function(){var t,e=this,n=e._k;do if(e._i>=n.length)return{value:void 0,done:!0};while(!((t=n[e._i++])in e._t));return{value:t,done:!1}}),r(r.S,"Reflect",{enumerate:function(t){return new s(t)}})},function(t,e,n){function r(t,e){var n,a,f=arguments.length<3?t:arguments[2];return c(t)===f?t[e]:(n=i.f(t,e))?o(n,"value")?n.value:void 0!==n.get?n.get.call(f):void 0:u(a=s(t))?r(a,e,f):void 0}var i=n(51),s=n(59),o=n(5),a=n(8),u=n(13),c=n(12);a(a.S,"Reflect",{get:r})},function(t,e,n){var r=n(51),i=n(8),s=n(12);i(i.S,"Reflect",{getOwnPropertyDescriptor:function(t,e){return r.f(s(t),e)}})},function(t,e,n){var r=n(8),i=n(59),s=n(12);r(r.S,"Reflect",{getPrototypeOf:function(t){return i(s(t))}})},function(t,e,n){var r=n(8);r(r.S,"Reflect",{has:function(t,e){return e in t}})},function(t,e,n){var r=n(8),i=n(12),s=Object.isExtensible;r(r.S,"Reflect",{isExtensible:function(t){return i(t),s?s(t):!0}})},function(t,e,n){var r=n(8);r(r.S,"Reflect",{ownKeys:n(244)})},function(t,e,n){var r=n(50),i=n(43),s=n(12),o=n(4).Reflect;t.exports=o&&o.ownKeys||function(t){var e=r.f(s(t)),n=i.f;return n?e.concat(n(t)):e}},function(t,e,n){var r=n(8),i=n(12),s=Object.preventExtensions;r(r.S,"Reflect",{preventExtensions:function(t){i(t);try{return s&&s(t),!0}catch(e){return!1}}})},function(t,e,n){function r(t,e,n){var u,l,d=arguments.length<4?t:arguments[3],p=s.f(f(t),e);if(!p){if(h(l=o(t)))return r(l,e,n,d);p=c(0)}return a(p,"value")?p.writable!==!1&&h(d)?(u=s.f(d,e)||c(0),u.value=n,i.f(d,e,u),!0):!1:void 0===p.set?!1:(p.set.call(d,n),!0)}var i=n(11),s=n(51),o=n(59),a=n(5),u=n(8),c=n(17),f=n(12),h=n(13);u(u.S,"Reflect",{set:r})},function(t,e,n){var r=n(8),i=n(73);i&&r(r.S,"Reflect",{setPrototypeOf:function(t,e){i.check(t,e);try{return i.set(t,e),!0}catch(n){return!1}}})},function(t,e,n){"use strict";var r=n(8),i=n(36)(!0);r(r.P,"Array",{includes:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),n(187)("includes")},function(t,e,n){"use strict";var r=n(8),i=n(128)(!0);r(r.P,"String",{at:function(t){return i(this,t)}})},function(t,e,n){"use strict";var r=n(8),i=n(251);r(r.P,"String",{padStart:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0,!0)}})},function(t,e,n){var r=n(37),i=n(92),s=n(35);t.exports=function(t,e,n,o){var a=String(s(t)),u=a.length,c=void 0===n?" ":String(n),f=r(e);if(u>=f||""==c)return a;var h=f-u,l=i.call(c,Math.ceil(h/c.length));return l.length>h&&(l=l.slice(0,h)),o?l+a:a+l}},function(t,e,n){"use strict";var r=n(8),i=n(251);r(r.P,"String",{padEnd:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0,!1)}})},function(t,e,n){"use strict";n(83)("trimLeft",function(t){return function(){return t(this,1)}},"trimStart")},function(t,e,n){"use strict";n(83)("trimRight",function(t){return function(){return t(this,2)}},"trimEnd")},function(t,e,n){"use strict";var r=n(8),i=n(35),s=n(37),o=n(135),a=n(197),u=RegExp.prototype,c=function(t,e){this._r=t,this._s=e};n(131)(c,"RegExp String",function(){var t=this._r.exec(this._s);return{value:t,done:null===t}}),r(r.P,"String",{matchAll:function(t){if(i(this),!o(t))throw TypeError(t+" is not a regexp!");var e=String(this),n="flags"in u?String(t.flags):a.call(t),r=new RegExp(t.source,~n.indexOf("g")?n:"g"+n);return r.lastIndex=s(t.lastIndex),new c(r,e)}})},function(t,e,n){n(27)("asyncIterator")},function(t,e,n){n(27)("observable")},function(t,e,n){var r=n(8),i=n(244),s=n(32),o=n(51),a=n(164);r(r.S,"Object",{getOwnPropertyDescriptors:function(t){for(var e,n=s(t),r=o.f,u=i(n),c={},f=0;u.length>f;)a(c,e=u[f++],r(n,e));return c}})},function(t,e,n){var r=n(8),i=n(260)(!1);r(r.S,"Object",{values:function(t){return i(t)}})},function(t,e,n){var r=n(30),i=n(32),s=n(44).f;t.exports=function(t){return function(e){for(var n,o=i(e),a=r(o),u=a.length,c=0,f=[];u>c;)s.call(o,n=a[c++])&&f.push(t?[n,o[n]]:o[n]);return f}}},function(t,e,n){var r=n(8),i=n(260)(!0);r(r.S,"Object",{entries:function(t){return i(t)}})},function(t,e,n){"use strict";var r=n(8),i=n(58),s=n(21),o=n(11);n(6)&&r(r.P+n(263),"Object",{__defineGetter__:function(t,e){o.f(i(this),t,{get:s(e),enumerable:!0,configurable:!0})}})},function(t,e,n){t.exports=n(28)||!n(7)(function(){var t=Math.random();__defineSetter__.call(null,t,function(){}),delete n(4)[t]})},function(t,e,n){"use strict";var r=n(8),i=n(58),s=n(21),o=n(11);n(6)&&r(r.P+n(263),"Object",{__defineSetter__:function(t,e){o.f(i(this),t,{set:s(e),enumerable:!0,configurable:!0})}})},function(t,e,n){"use strict";var r=n(8),i=n(58),s=n(16),o=n(59),a=n(51).f;n(6)&&r(r.P+n(263),"Object",{__lookupGetter__:function(t){var e,n=i(this),r=s(t,!0);do if(e=a(n,r))return e.get;while(n=o(n))}})},function(t,e,n){"use strict";var r=n(8),i=n(58),s=n(16),o=n(59),a=n(51).f;n(6)&&r(r.P+n(263),"Object",{__lookupSetter__:function(t){var e,n=i(this),r=s(t,!0);do if(e=a(n,r))return e.set;while(n=o(n))}})},function(t,e,n){var r=n(8);r(r.P+r.R,"Map",{toJSON:n(268)("Map")})},function(t,e,n){var r=n(75),i=n(269);t.exports=function(t){return function(){if(r(this)!=t)throw TypeError(t+"#toJSON isn't generic");return i(this)}}},function(t,e,n){var r=n(206);t.exports=function(t,e){var n=[];return r(t,!1,n.push,n,e),n}},function(t,e,n){var r=n(8);r(r.P+r.R,"Set",{toJSON:n(268)("Set")})},function(t,e,n){var r=n(8);r(r.S,"System",{global:n(4)})},function(t,e,n){var r=n(8),i=n(34);r(r.S,"Error",{isError:function(t){return"Error"===i(t)}})},function(t,e,n){var r=n(8);r(r.S,"Math",{iaddh:function(t,e,n,r){var i=t>>>0,s=e>>>0,o=n>>>0;return s+(r>>>0)+((i&o|(i|o)&~(i+o>>>0))>>>31)|0}})},function(t,e,n){var r=n(8);r(r.S,"Math",{isubh:function(t,e,n,r){var i=t>>>0,s=e>>>0,o=n>>>0;return s-(r>>>0)-((~i&o|~(i^o)&i-o>>>0)>>>31)|0}})},function(t,e,n){var r=n(8);r(r.S,"Math",{imulh:function(t,e){var n=65535,r=+t,i=+e,s=r&n,o=i&n,a=r>>16,u=i>>16,c=(a*o>>>0)+(s*o>>>16);return a*u+(c>>16)+((s*u>>>0)+(c&n)>>16)}})},function(t,e,n){var r=n(8);r(r.S,"Math",{umulh:function(t,e){var n=65535,r=+t,i=+e,s=r&n,o=i&n,a=r>>>16,u=i>>>16,c=(a*o>>>0)+(s*o>>>16);return a*u+(c>>>16)+((s*u>>>0)+(c&n)>>>16)}})},function(t,e,n){var r=n(278),i=n(12),s=r.key,o=r.set;r.exp({defineMetadata:function(t,e,n,r){o(t,e,i(n),s(r))}})},function(t,e,n){var r=n(211),i=n(8),s=n(23)("metadata"),o=s.store||(s.store=new(n(215))),a=function(t,e,n){var i=o.get(t);if(!i){if(!n)return;o.set(t,i=new r)}var s=i.get(e);if(!s){if(!n)return;i.set(e,s=new r)}return s},u=function(t,e,n){var r=a(e,n,!1);return void 0===r?!1:r.has(t)},c=function(t,e,n){var r=a(e,n,!1);return void 0===r?void 0:r.get(t)},f=function(t,e,n,r){a(n,r,!0).set(t,e)},h=function(t,e){var n=a(t,e,!1),r=[];return n&&n.forEach(function(t,e){r.push(e)}),r},l=function(t){return void 0===t||"symbol"==typeof t?t:String(t)},d=function(t){i(i.S,"Reflect",t)};t.exports={store:o,map:a,has:u,get:c,set:f,keys:h,key:l,exp:d}},function(t,e,n){var r=n(278),i=n(12),s=r.key,o=r.map,a=r.store;r.exp({deleteMetadata:function(t,e){var n=arguments.length<3?void 0:s(arguments[2]),r=o(i(e),n,!1);if(void 0===r||!r.delete(t))return!1;if(r.size)return!0;var u=a.get(e);return u.delete(n),!!u.size||a.delete(e)}})},function(t,e,n){var r=n(278),i=n(12),s=n(59),o=r.has,a=r.get,u=r.key,c=function(t,e,n){var r=o(t,e,n);if(r)return a(t,e,n);var i=s(e);return null!==i?c(t,i,n):void 0};r.exp({getMetadata:function(t,e){return c(t,i(e),arguments.length<3?void 0:u(arguments[2]))}})},function(t,e,n){var r=n(214),i=n(269),s=n(278),o=n(12),a=n(59),u=s.keys,c=s.key,f=function(t,e){var n=u(t,e),s=a(t);if(null===s)return n;var o=f(s,e);return o.length?n.length?i(new r(n.concat(o))):o:n};s.exp({getMetadataKeys:function(t){return f(o(t),arguments.length<2?void 0:c(arguments[1]))}})},function(t,e,n){var r=n(278),i=n(12),s=r.get,o=r.key;r.exp({getOwnMetadata:function(t,e){return s(t,i(e),arguments.length<3?void 0:o(arguments[2]))}})},function(t,e,n){var r=n(278),i=n(12),s=r.keys,o=r.key;r.exp({getOwnMetadataKeys:function(t){return s(i(t),arguments.length<2?void 0:o(arguments[1]))}})},function(t,e,n){var r=n(278),i=n(12),s=n(59),o=r.has,a=r.key,u=function(t,e,n){var r=o(t,e,n);if(r)return!0;var i=s(e);return null!==i?u(t,i,n):!1};r.exp({hasMetadata:function(t,e){return u(t,i(e),arguments.length<3?void 0:a(arguments[2]))}})},function(t,e,n){var r=n(278),i=n(12),s=r.has,o=r.key;r.exp({hasOwnMetadata:function(t,e){return s(t,i(e),arguments.length<3?void 0:o(arguments[2]))}})},function(t,e,n){var r=n(278),i=n(12),s=n(21),o=r.key,a=r.set;r.exp({metadata:function(t,e){return function(n,r){a(t,e,(void 0!==r?i:s)(n),o(r))}}})},function(t,e,n){var r=n(8),i=n(209)(),s=n(4).process,o="process"==n(34)(s);r(r.G,{asap:function(t){var e=o&&s.domain;i(e?e.bind(t):t)}})},function(t,e,n){"use strict";var r=n(8),i=n(4),s=n(9),o=n(209)(),a=n(25)("observable"),u=n(21),c=n(12),f=n(90),h=n(210),l=n(10),d=n(206),p=d.RETURN,g=function(t){return null==t?void 0:u(t)},y=function(t){var e=t._c;e&&(t._c=void 0,e())},v=function(t){return void 0===t._o},m=function(t){v(t)||(t._o=void 0,y(t))},S=function(t,e){c(t),this._c=void 0,this._o=t,t=new b(this);try{var n=e(t),r=n;null!=n&&("function"==typeof n.unsubscribe?n=function(){r.unsubscribe()}:u(n),this._c=n)}catch(i){return void t.error(i)}v(this)&&y(this)};S.prototype=h({},{unsubscribe:function(){m(this)}});var b=function(t){this._s=t};b.prototype=h({},{next:function(t){var e=this._s;if(!v(e)){var n=e._o;try{var r=g(n.next);if(r)return r.call(n,t)}catch(i){try{m(e)}finally{throw i}}}},error:function(t){var e=this._s;if(v(e))throw t;var n=e._o;e._o=void 0;try{var r=g(n.error);if(!r)throw t;t=r.call(n,t)}catch(i){try{y(e)}finally{throw i}}return y(e),t},complete:function(t){var e=this._s;if(!v(e)){var n=e._o;e._o=void 0;try{var r=g(n.complete);t=r?r.call(n,t):void 0}catch(i){try{y(e)}finally{throw i}}return y(e),t}}});var w=function(t){f(this,w,"Observable","_f")._f=u(t)};h(w.prototype,{subscribe:function(t){return new S(t,this._f)},forEach:function(t){var e=this;return new(s.Promise||i.Promise)(function(n,r){u(t);var i=e.subscribe({next:function(e){try{return t(e)}catch(n){r(n),i.unsubscribe()}},error:r,complete:n})})}}),h(w,{from:function(t){var e="function"==typeof this?this:w,n=g(c(t)[a]);if(n){var r=c(n.call(t));return r.constructor===e?r:new e(function(t){return r.subscribe(t)})}return new e(function(e){var n=!1;return o(function(){if(!n){try{if(d(t,!1,function(t){return e.next(t),n?p:void 0})===p)return}catch(r){if(n)throw r;return void e.error(r)}e.complete()}}),function(){n=!0}})},of:function(){for(var t=0,e=arguments.length,n=Array(e);e>t;)n[t]=arguments[t++];return new("function"==typeof this?this:w)(function(t){var e=!1;return o(function(){if(!e){for(var r=0;r<n.length;++r)if(t.next(n[r]),e)return;t.complete()}}),function(){e=!0}})}}),l(w.prototype,a,function(){return this}),r(r.G,{Observable:w}),n(193)("Observable")},function(t,e,n){var r=n(4),i=n(8),s=n(78),o=n(290),a=r.navigator,u=!!a&&/MSIE .\./.test(a.userAgent),c=function(t){return u?function(e,n){return t(s(o,[].slice.call(arguments,2),"function"==typeof e?e:Function(e)),n)}:t};i(i.G+i.B+i.F*u,{setTimeout:c(r.setTimeout),setInterval:c(r.setInterval)})},function(t,e,n){"use strict";var r=n(291),i=n(78),s=n(21);t.exports=function(){for(var t=s(this),e=arguments.length,n=Array(e),o=0,a=r._,u=!1;e>o;)(n[o]=arguments[o++])===a&&(u=!0);return function(){var r,s=this,o=arguments.length,c=0,f=0;if(!u&&!o)return i(t,n,s);if(r=n.slice(),u)for(;e>c;c++)r[c]===a&&(r[c]=arguments[f++]);for(;o>f;)r.push(arguments[f++]);return i(t,r,s)}}},function(t,e,n){t.exports=n(4)},function(t,e,n){var r=n(8),i=n(208);r(r.G+r.B,{setImmediate:i.set,clearImmediate:i.clear})},function(t,e,n){for(var r=n(194),i=n(18),s=n(4),o=n(10),a=n(130),u=n(25),c=u("iterator"),f=u("toStringTag"),h=a.Array,l=["NodeList","DOMTokenList","MediaList","StyleSheetList","CSSRuleList"],d=0;5>d;d++){var p,g=l[d],y=s[g],v=y&&y.prototype;if(v){v[c]||o(v,c,h),v[f]||o(v,f,g),a[g]=h;for(p in r)v[p]||i(v,p,r[p],!0)}}},function(t,e,n){(function(e,n){!function(e){"use strict";function r(t,e,n,r){var i=Object.create((e||s).prototype),o=new p(r||[]);return i._invoke=h(t,n,o),i}function i(t,e,n){try{return{type:"normal",arg:t.call(e,n)}}catch(r){return{type:"throw",arg:r}}}function s(){}function o(){}function a(){}function u(t){["next","throw","return"].forEach(function(e){t[e]=function(t){return this._invoke(e,t)}})}function c(t){this.arg=t}function f(t){function e(e,n){var r=t[e](n),i=r.value;return i instanceof c?Promise.resolve(i.arg).then(s,o):Promise.resolve(i).then(function(t){return r.value=t,r})}function r(t,n){function r(){return e(t,n)}return i=i?i.then(r,r):new Promise(function(t){t(r())})}"object"==typeof n&&n.domain&&(e=n.domain.bind(e));var i,s=e.bind(t,"next"),o=e.bind(t,"throw");e.bind(t,"return");this._invoke=r}function h(t,e,n){var r=E;return function(s,o){if(r===_)throw new Error("Generator is already running");if(r===R){if("throw"===s)throw o;return y()}for(;;){var a=n.delegate;if(a){if("return"===s||"throw"===s&&a.iterator[s]===v){n.delegate=null;var u=a.iterator.return;if(u){var c=i(u,a.iterator,o);if("throw"===c.type){s="throw",o=c.arg;continue}}if("return"===s)continue}var c=i(a.iterator[s],a.iterator,o);if("throw"===c.type){n.delegate=null,s="throw",o=c.arg;continue}s="next",o=v;var f=c.arg;if(!f.done)return r=x,f;n[a.resultName]=f.value,n.next=a.nextLoc,n.delegate=null}if("next"===s)n._sent=o,r===x?n.sent=o:n.sent=v;else if("throw"===s){if(r===E)throw r=R,o;n.dispatchException(o)&&(s="next",o=v)}else"return"===s&&n.abrupt("return",o);r=_;var c=i(t,e,n);if("normal"===c.type){r=n.done?R:x;var f={value:c.arg,done:n.done};if(c.arg!==A)return f;n.delegate&&"next"===s&&(o=v)}else"throw"===c.type&&(r=R,s="throw",o=c.arg)}}}function l(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function d(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function p(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(l,this),this.reset(!0)}function g(t){if(t){var e=t[S];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var n=-1,r=function i(){for(;++n<t.length;)if(m.call(t,n))return i.value=t[n],i.done=!1,i;return i.value=v,i.done=!0,i};return r.next=r}}return{next:y}}function y(){return{value:v,done:!0}}var v,m=Object.prototype.hasOwnProperty,S="function"==typeof Symbol&&Symbol.iterator||"@@iterator",b="object"==typeof t,w=e.regeneratorRuntime;if(w)return void(b&&(t.exports=w));w=e.regeneratorRuntime=b?t.exports:{},w.wrap=r;var E="suspendedStart",x="suspendedYield",_="executing",R="completed",A={},F=a.prototype=s.prototype;o.prototype=F.constructor=a,a.constructor=o,o.displayName="GeneratorFunction",w.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return e?e===o||"GeneratorFunction"===(e.displayName||e.name):!1},w.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,a):t.__proto__=a,t.prototype=Object.create(F),t},w.awrap=function(t){return new c(t)},u(f.prototype),w.async=function(t,e,n,i){var s=new f(r(t,e,n,i));return w.isGeneratorFunction(e)?s:s.next().then(function(t){return t.done?t.value:s.next()})},u(F),F[S]=function(){return this},F.toString=function(){return"[object Generator]"},w.keys=function(t){var e=[];for(var n in t)e.push(n);return e.reverse(),function r(){for(;e.length;){var n=e.pop();if(n in t)return r.value=n,r.done=!1,r}return r.done=!0,r}},w.values=g,p.prototype={constructor:p,reset:function(t){if(this.prev=0,this.next=0,this.sent=v,this.done=!1,this.delegate=null,this.tryEntries.forEach(d),!t)for(var e in this)"t"===e.charAt(0)&&m.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=v)},stop:function(){this.done=!0;var t=this.tryEntries[0],e=t.completion;if("throw"===e.type)throw e.arg;return this.rval},dispatchException:function(t){function e(e,r){return s.type="throw",s.arg=t,n.next=e,!!r}if(this.done)throw t;for(var n=this,r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r],s=i.completion;if("root"===i.tryLoc)return e("end");if(i.tryLoc<=this.prev){var o=m.call(i,"catchLoc"),a=m.call(i,"finallyLoc");if(o&&a){if(this.prev<i.catchLoc)return e(i.catchLoc,!0);if(this.prev<i.finallyLoc)return e(i.finallyLoc)}else if(o){if(this.prev<i.catchLoc)return e(i.catchLoc,!0)}else{if(!a)throw new Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return e(i.finallyLoc)}}}},abrupt:function(t,e){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&m.call(r,"finallyLoc")&&this.prev<r.finallyLoc){var i=r;break}}i&&("break"===t||"continue"===t)&&i.tryLoc<=e&&e<=i.finallyLoc&&(i=null);var s=i?i.completion:{};return s.type=t,s.arg=e,i?this.next=i.finallyLoc:this.complete(s),A},complete:function(t,e){if("throw"===t.type)throw t.arg;"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=t.arg,this.next="end"):"normal"===t.type&&e&&(this.next=e)},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.finallyLoc===t)return this.complete(n.completion,n.afterLoc),d(n),A}},"catch":function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.tryLoc===t){var r=n.completion;if("throw"===r.type){var i=r.arg;d(n)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,n){return this.delegate={iterator:g(t),resultName:e,nextLoc:n},A}}}("object"==typeof e?e:"object"==typeof window?window:"object"==typeof self?self:this)}).call(e,function(){return this}(),n(295))},function(t,e){function n(){c&&o&&(c=!1,o.length?u=o.concat(u):f=-1,u.length&&r())}function r(){if(!c){var t=setTimeout(n);c=!0;for(var e=u.length;e;){for(o=u,u=[];++f<e;)o&&o[f].run();f=-1,e=u.length}o=null,c=!1,clearTimeout(t)}}function i(t,e){this.fun=t,this.array=e}function s(){}var o,a=t.exports={},u=[],c=!1,f=-1;a.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];u.push(new i(t,e)),1!==u.length||c||setTimeout(r,0)},i.prototype.run=function(){this.fun.apply(null,this.array)},a.title="browser",a.browser=!0,a.env={},a.argv=[],a.version="",a.versions={},a.on=s,a.addListener=s,a.once=s,a.off=s,a.removeListener=s,a.removeAllListeners=s,a.emit=s,a.binding=function(t){throw new Error("process.binding is not supported")},a.cwd=function(){return"/"},a.chdir=function(t){throw new Error("process.chdir is not supported")},a.umask=function(){return 0}},function(t,e,n){n(297),t.exports=n(9).RegExp.escape},function(t,e,n){var r=n(8),i=n(298)(/[\\^$*+?.()|[\]{}]/g,"\\$&");r(r.S,"RegExp",{escape:function(t){return i(t)}})},function(t,e){t.exports=function(t,e){var n=e===Object(e)?function(t){return e[t]}:e;return function(e){return String(e).replace(t,n)}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=e.Log=n(300),i=e.OidcClient=n(301),s=e.WebStorageStateStore=n(303),o=e.InMemoryWebStorage=n(325),a=e.UserManager=n(326),u=e.AccessTokenEvents=n(335),c=e.MetadataService=n(306),f=e.CordovaPopupNavigator=n(341),h=e.CordovaIFrameNavigator=n(343),l=e.CheckSessionIFrame=n(340);e.default={Log:r,OidcClient:i,WebStorageStateStore:s,InMemoryWebStorage:o,UserManager:a,AccessTokenEvents:u,MetadataService:c,CordovaPopupNavigator:f,CordovaIFrameNavigator:h,CheckSessionIFrame:l}},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i={info:function(){},warn:function(){},error:function(){}},s=0,o=1,a=2,u=3,c=void 0,f=void 0,h=function(){function t(){n(this,t)}return t.reset=function(){f=u,c=i},t.info=function(){if(f>=u){for(var t=arguments.length,e=Array(t),n=0;t>n;n++)e[n]=arguments[n];c.info.apply(c,Array.from(e))}},t.warn=function(){if(f>=a){for(var t=arguments.length,e=Array(t),n=0;t>n;n++)e[n]=arguments[n];c.warn.apply(c,Array.from(e))}},t.error=function(){if(f>=o){for(var t=arguments.length,e=Array(t),n=0;t>n;n++)e[n]=arguments[n];c.error.apply(c,Array.from(e))}},r(t,null,[{key:"NONE",get:function(){return s}},{key:"ERROR",get:function(){return o}},{key:"WARN",get:function(){return a}},{key:"INFO",get:function(){return u}},{key:"level",get:function(){return f},set:function(t){if(!(t>=s&&u>=t))throw new Error("Invalid log level");f=t}},{key:"logger",get:function(){return c},set:function(t){if(!(t.info&&t.warn&&t.error))throw new Error("Invalid logger");c=t}}]),t}();e.default=h,h.reset(),t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(300),a=r(o),u=n(302),c=r(u),f=n(309),h=r(f),l=n(317),d=r(l),p=n(322),g=r(p),y=n(323),v=r(y),m=n(324),S=r(m),b=n(319),w=r(b),E=n(320),x=r(E),_=function(){function t(){var e=arguments.length<=0||void 0===arguments[0]?{}:arguments[0];i(this,t),e instanceof c.default?this._settings=e:this._settings=new c.default(e)}return t.prototype.createSigninRequest=function(){var t=this,e=arguments.length<=0||void 0===arguments[0]?{}:arguments[0],n=e.response_type,r=e.scope,i=e.redirect_uri,s=e.data,o=e.prompt,u=e.display,c=e.max_age,f=e.ui_locales,h=e.id_token_hint,l=e.login_hint,p=e.acr_values,g=arguments[1];a.default.info("OidcClient.createSigninRequest");var y=this._settings.client_id;n=n||this._settings.response_type,r=r||this._settings.scope,i=i||this._settings.redirect_uri,o=o||this._settings.prompt,u=u||this._settings.display,c=c||this._settings.max_age,f=f||this._settings.ui_locales,p=p||this._settings.acr_values;var v=this._settings.authority;return this._metadataService.getAuthorizationEndpoint().then(function(e){a.default.info("Received authorization endpoint",e);var m=new d.default({url:e,client_id:y,redirect_uri:i,response_type:n,scope:r,data:s,authority:v,prompt:o,display:u,max_age:c,ui_locales:f,id_token_hint:h,login_hint:l,acr_values:p}),S=m.state;return g=g||t._stateStore,g.set(S.id,S.toStorageString()).then(function(){return m})})},t.prototype.processSigninResponse=function(t,e){var n=this;a.default.info("OidcClient.processSigninResponse");var r=new g.default(t);return r.state?(e=e||this._stateStore,e.remove(r.state).then(function(t){if(!t)throw a.default.error("No matching state found in storage"),new Error("No matching state found in storage");var e=w.default.fromStorageString(t);return a.default.info("Received state from storage; validating response"),n._validator.validateSigninResponse(e,r)})):(a.default.error("No state in response"),Promise.reject(new Error("No state in response")))},t.prototype.createSignoutRequest=function(){var t=this,e=arguments.length<=0||void 0===arguments[0]?{}:arguments[0],n=e.id_token_hint,r=e.data,i=e.post_logout_redirect_uri,s=arguments[1];return a.default.info("OidcClient.createSignoutRequest"),i=i||this._settings.post_logout_redirect_uri,this._metadataService.getEndSessionEndpoint().then(function(e){if(!e)throw a.default.error("No end session endpoint url returned"),new Error("no end session endpoint");a.default.info("Received end session endpoint",e);var o=new v.default({url:e,id_token_hint:n,post_logout_redirect_uri:i,data:r}),u=o.state;return u&&(a.default.info("Signout request has state to persist"),s=s||t._stateStore,s.set(u.id,u.toStorageString())),o})},t.prototype.processSignoutResponse=function(t,e){var n=this;a.default.info("OidcClient.processSignoutResponse");var r=new S.default(t);if(!r.state)return a.default.info("No state in response"),r.error?(a.default.warn("Response was error",r.error),Promise.reject(new h.default(r))):Promise.resolve(r);var i=r.state;return e=e||this._stateStore,e.remove(i).then(function(t){if(!t)throw a.default.error("No matching state found in storage"),new Error("No matching state found in storage");var e=x.default.fromStorageString(t);return a.default.info("Received state from storage; validating response"),n._validator.validateSignoutResponse(e,r)})},t.prototype.clearStaleState=function(t){return a.default.info("OidcClient.clearStaleState"),t=t||this._stateStore,x.default.clearStaleState(t,this.settings.staleStateAge)},s(t,[{key:"_stateStore",get:function(){return this.settings.stateStore}},{key:"_validator",get:function(){return this.settings.validator}},{key:"_metadataService",get:function(){return this.settings.metadataService}},{key:"settings",get:function(){return this._settings}},{key:"metadataService",get:function(){return this._metadataService}}]),t}();e.default=_,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(300),a=r(o),u=n(303),c=r(u),f=n(305),h=r(f),l=n(306),d=r(l),p=".well-known/openid-configuration",g="id_token",y="openid",v=60,m=300,S=function(){function t(){var e=arguments.length<=0||void 0===arguments[0]?{}:arguments[0],n=e.authority,r=e.metadataUrl,s=e.metadata,o=e.signingKeys,a=e.client_id,u=e.response_type,f=void 0===u?g:u,l=e.scope,p=void 0===l?y:l,S=e.redirect_uri,b=e.post_logout_redirect_uri,w=e.prompt,E=e.display,x=e.max_age,_=e.ui_locales,R=e.acr_values,A=e.filterProtocolClaims,F=void 0===A?!0:A,K=e.loadUserInfo,P=void 0===K?!0:K,U=e.staleStateAge,O=void 0===U?v:U,C=e.clockSkew,I=void 0===C?m:C,j=e.stateStore,T=void 0===j?new c.default:j,D=e.ResponseValidatorCtor,J=void 0===D?h.default:D,H=e.MetadataServiceCtor,B=void 0===H?d.default:H;i(this,t),this._authority=n,this._metadataUrl=r,this._metadata=s,this._signingKeys=o,this._client_id=a,this._response_type=f,this._scope=p,this._redirect_uri=S,this._post_logout_redirect_uri=b,this._prompt=w,this._display=E,this._max_age=x,this._ui_locales=_,this._acr_values=R,this._filterProtocolClaims=!!F,this._loadUserInfo=!!P,this._staleStateAge=O,this._clockSkew=I,this._stateStore=T,this._validator=new J(this),this._metadataService=new B(this)}return s(t,[{key:"client_id",get:function(){return this._client_id},set:function(t){if(this._client_id)throw a.default.error("client_id has already been assigned."),new Error("client_id has already been assigned.");this._client_id=t}},{key:"response_type",get:function(){return this._response_type}},{key:"scope",get:function(){return this._scope}},{key:"redirect_uri",get:function(){return this._redirect_uri}},{key:"post_logout_redirect_uri",get:function(){return this._post_logout_redirect_uri}},{key:"prompt",get:function(){return this._prompt}},{key:"display",get:function(){return this._display}},{key:"max_age",get:function(){return this._max_age}},{key:"ui_locales",get:function(){return this._ui_locales}},{key:"acr_values",get:function(){return this._acr_values}},{key:"authority",get:function(){return this._authority},set:function(t){if(this._authority)throw a.default.error("authority has already been assigned."),new Error("authority has already been assigned.");this._authority=t}},{key:"metadataUrl",get:function(){return this._metadataUrl||(this._metadataUrl=this.authority,this._metadataUrl&&this._metadataUrl.indexOf(p)<0&&("/"!==this._metadataUrl[this._metadataUrl.length-1]&&(this._metadataUrl+="/"),this._metadataUrl+=p)),this._metadataUrl}},{key:"metadata",get:function(){return this._metadata},set:function(t){this._metadata=t}},{key:"signingKeys",get:function(){return this._signingKeys},set:function(t){this._signingKeys=t}},{key:"filterProtocolClaims",get:function(){return this._filterProtocolClaims}},{key:"loadUserInfo",get:function(){return this._loadUserInfo}},{key:"staleStateAge",get:function(){return this._staleStateAge}},{key:"clockSkew",get:function(){return this._clockSkew}},{key:"stateStore",get:function(){return this._stateStore}},{key:"validator",get:function(){return this._validator}},{key:"metadataService",get:function(){return this._metadataService}}]),t}();e.default=S,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(300),o=r(s),a=n(304),u=r(a),c=function(){function t(){var e=arguments.length<=0||void 0===arguments[0]?{}:arguments[0],n=e.prefix,r=void 0===n?"oidc.":n,s=e.store,o=void 0===s?u.default.localStorage:s;i(this,t),this._store=o,
this._prefix=r}return t.prototype.set=function(t,e){return o.default.info("WebStorageStateStore.set",t),t=this._prefix+t,this._store.setItem(t,e),Promise.resolve()},t.prototype.get=function(t){o.default.info("WebStorageStateStore.get",t),t=this._prefix+t;var e=this._store.getItem(t);return Promise.resolve(e)},t.prototype.remove=function(t){o.default.info("WebStorageStateStore.remove",t),t=this._prefix+t;var e=this._store.getItem(t);return this._store.removeItem(t),Promise.resolve(e)},t.prototype.getAllKeys=function(){o.default.info("WebStorageStateStore.getAllKeys");for(var t=[],e=0;e<this._store.length;e++){var n=this._store.key(e);0===n.indexOf(this._prefix)&&t.push(n.substr(this._prefix.length))}return Promise.resolve(t)},t}();e.default=c,t.exports=e.default},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i={setTimeout:function(t){function e(e,n){return t.apply(this,arguments)}return e.toString=function(){return t.toString()},e}(function(t,e){return setTimeout(t,e)}),clearTimeout:function(t){function e(e){return t.apply(this,arguments)}return e.toString=function(){return t.toString()},e}(function(t){return clearTimeout(t)})},s=!1,o=function(){function t(){n(this,t)}return t._testing=function(){s=!0},r(t,null,[{key:"location",get:function(){return s?void 0:location}},{key:"localStorage",get:function(){return s?void 0:localStorage}},{key:"sessionStorage",get:function(){return s?void 0:sessionStorage}},{key:"XMLHttpRequest",get:function(){return s?void 0:XMLHttpRequest}},{key:"timer",get:function(){return s?void 0:i}}]),t}();e.default=o,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(300),o=r(s),a=n(306),u=r(a),c=n(308),f=r(c),h=n(309),l=r(h),d=n(310),p=r(d),g=["nonce","at_hash","iat","nbf","exp","aud","iss","c_hash"],y=function(){function t(e){var n=arguments.length<=1||void 0===arguments[1]?u.default:arguments[1],r=arguments.length<=2||void 0===arguments[2]?f.default:arguments[2],s=arguments.length<=3||void 0===arguments[3]?p.default:arguments[3];if(i(this,t),!e)throw o.default.error("No settings passed to ResponseValidator"),new Error("settings");this._settings=e,this._metadataService=new n(this._settings),this._userInfoService=new r(this._settings),this._joseUtil=s}return t.prototype.validateSigninResponse=function(t,e){var n=this;return o.default.info("ResponseValidator.validateSigninResponse"),this._processSigninParams(t,e).then(function(e){return o.default.info("state processed"),n._validateTokens(t,e).then(function(t){return o.default.info("tokens validated"),n._processClaims(t).then(function(t){return o.default.info("claims processed"),t})})})},t.prototype.validateSignoutResponse=function(t,e){return o.default.info("ResponseValidator.validateSignoutResponse"),t.id!==e.state?(o.default.error("State does not match"),Promise.reject(new Error("State does not match"))):(o.default.info("state validated"),e.state=t.data,e.error?(o.default.warn("Response was error",e.error),Promise.reject(new l.default(e))):Promise.resolve(e))},t.prototype._processSigninParams=function(t,e){if(o.default.info("ResponseValidator._processSigninParams"),t.id!==e.state)return o.default.error("State does not match"),Promise.reject(new Error("State does not match"));if(!t.client_id)return o.default.error("No client_id on state"),Promise.reject(new Error("No client_id on state"));if(!t.authority)return o.default.error("No authority on state"),Promise.reject(new Error("No authority on state"));if(this._settings.authority){if(this._settings.authority&&this._settings.authority!==t.authority)return o.default.error("authority mismatch on settings vs. signin state"),Promise.reject(new Error("authority mismatch on settings vs. signin state"))}else this._settings.authority=t.authority;if(this._settings.client_id){if(this._settings.client_id&&this._settings.client_id!==t.client_id)return o.default.error("client_id mismatch on settings vs. signin state"),Promise.reject(new Error("client_id mismatch on settings vs. signin state"))}else this._settings.client_id=t.client_id;return o.default.info("state validated"),e.state=t.data,e.error?(o.default.warn("Response was error",e.error),Promise.reject(new l.default(e))):t.nonce&&!e.id_token?(o.default.error("Expecting id_token in response"),Promise.reject(new Error("No id_token in response"))):!t.nonce&&e.id_token?(o.default.error("Not expecting id_token in response"),Promise.reject(new Error("Unexpected id_token in response"))):Promise.resolve(e)},t.prototype._processClaims=function(t){var e=this;if(o.default.info("ResponseValidator._processClaims"),t.isOpenIdConnect){if(o.default.info("response is OIDC, processing claims"),t.profile=this._filterProtocolClaims(t.profile),this._settings.loadUserInfo&&t.access_token)return o.default.info("loading user info"),this._userInfoService.getClaims(t.access_token).then(function(n){return t.profile=e._mergeClaims(t.profile,n),o.default.info("user info claims received, updated profile:",t.profile),t});o.default.info("not loading user info")}else o.default.info("response is not OIDC, not processing claims");return Promise.resolve(t)},t.prototype._mergeClaims=function(t,e){var n=Object.assign({},t);for(var r in e){var i=e[r];Array.isArray(i)||(i=[i]);var s=!0,o=!1,a=void 0;try{for(var u,c=i[Symbol.iterator]();!(s=(u=c.next()).done);s=!0){var f=u.value;n[r]?Array.isArray(n[r])?n[r].indexOf(f)<0&&n[r].push(f):n[r]!==f&&(n[r]=[n[r],f]):n[r]=f}}catch(h){o=!0,a=h}finally{try{!s&&c.return&&c.return()}finally{if(o)throw a}}}return n},t.prototype._filterProtocolClaims=function(t){o.default.info("ResponseValidator._filterProtocolClaims, incoming claims:",t);var e=Object.assign({},t);return this._settings._filterProtocolClaims?(g.forEach(function(t){delete e[t]}),o.default.info("protocol claims filtered",e)):o.default.info("protocol claims not filtered"),e},t.prototype._validateTokens=function(t,e){return o.default.info("ResponseValidator._validateTokens"),e.id_token?e.access_token?(o.default.info("Validating id_token and access_token"),this._validateIdTokenAndAccessToken(t,e)):(o.default.info("Validating id_token"),this._validateIdToken(t,e)):(o.default.info("No id_token to validate"),Promise.resolve(e))},t.prototype._validateIdTokenAndAccessToken=function(t,e){var n=this;return o.default.info("ResponseValidator._validateIdTokenAndAccessToken"),this._validateIdToken(t,e).then(function(t){return n._validateAccessToken(t)})},t.prototype._validateIdToken=function(t,e){var n=this;if(o.default.info("ResponseValidator._validateIdToken"),!t.nonce)return o.default.error("No nonce on state"),Promise.reject(new Error("No nonce on state"));var r=this._joseUtil.parseJwt(e.id_token);if(!r||!r.header||!r.payload)return o.default.error("Failed to parse id_token",r),Promise.reject(new Error("Failed to parse id_token"));if(t.nonce!==r.payload.nonce)return o.default.error("Invalid nonce in id_token"),Promise.reject(new Error("Invalid nonce in id_token"));var i=r.header.kid;return i?this._metadataService.getIssuer().then(function(s){return o.default.info("Received issuer"),n._metadataService.getSigningKeys().then(function(a){if(!a)return o.default.error("No signing keys from metadata"),Promise.reject(new Error("No signing keys from metadata"));o.default.info("Received signing keys");var u=a.filter(function(t){return t.kid===i})[0];if(!u)return o.default.error("No key matching kid found in signing keys"),Promise.reject(new Error("No key matching kid found in signing keys"));var c=t.client_id,f=n._settings.clockSkew;return o.default.info("Validaing JWT; using clock skew (in seconds) of: ",f),n._joseUtil.validateJwt(e.id_token,u,s,c,f).then(function(){return o.default.info("JWT validation successful"),e.profile=r.payload,e})})}):(o.default.error("No kid found in id_token"),Promise.reject(new Error("No kid found in id_token")))},t.prototype._validateAccessToken=function(t){if(o.default.info("ResponseValidator._validateAccessToken"),!t.profile)return o.default.error("No profile loaded from id_token"),Promise.reject(new Error("No profile loaded from id_token"));if(!t.profile.at_hash)return o.default.error("No at_hash in id_token"),Promise.reject(new Error("No at_hash in id_token"));if(!t.id_token)return o.default.error("No id_token"),Promise.reject(new Error("No id_token"));var e=this._joseUtil.parseJwt(t.id_token);if(!e||!e.header)return o.default.error("Failed to parse id_token",e),Promise.reject(new Error("Failed to parse id_token"));var n=e.header.alg;if(!n||5!==n.length)return o.default.error("Unsupported alg:",n),Promise.reject(new Error("Unsupported alg: "+n));var r=n.substr(2,3);if(!r)return o.default.error("Unsupported alg:",n,r),Promise.reject(new Error("Unsupported alg: "+n));if(r=parseInt(r),256!==r&&384!==r&&512!==r)return o.default.error("Unsupported alg:",n,r),Promise.reject(new Error("Unsupported alg: "+n));var i="sha"+r,s=this._joseUtil.hashString(t.access_token,i);if(!s)return o.default.error("access_token hash failed:",i),Promise.reject(new Error("Failed to validate at_hash"));var a=s.substr(0,s.length/2),u=this._joseUtil.hexToBase64Url(a);return u!==t.profile.at_hash?(o.default.error("Failed to validate at_hash",u,t.profile.at_hash),Promise.reject(new Error("Failed to validate at_hash"))):Promise.resolve(t)},t}();e.default=y,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(300),o=r(s),a=n(307),u=r(a),c=function(){function t(e){var n=arguments.length<=1||void 0===arguments[1]?u.default:arguments[1];if(i(this,t),!e)throw o.default.error("No settings passed to MetadataService"),new Error("settings");this._settings=e,this._jsonService=new n}return t.prototype.getMetadata=function(){var t=this;return o.default.info("MetadataService.getMetadata"),this._settings.metadata?(o.default.info("Returning metadata from settings"),Promise.resolve(this._settings.metadata)):this._settings.metadataUrl?(o.default.info("getting metadata from",this._settings.metadataUrl),this._jsonService.getJson(this._settings.metadataUrl).then(function(e){return o.default.info("json received"),t._settings.metadata=e,e})):(o.default.error("No metadataUrl configured on settings"),Promise.reject(new Error("No metadataUrl configured on settings")))},t.prototype.getIssuer=function(){return o.default.info("MetadataService.getIssuer"),this._getMetadataProperty("issuer")},t.prototype.getAuthorizationEndpoint=function(){return o.default.info("MetadataService.getAuthorizationEndpoint"),this._getMetadataProperty("authorization_endpoint")},t.prototype.getUserInfoEndpoint=function(){return o.default.info("MetadataService.getUserInfoEndpoint"),this._getMetadataProperty("userinfo_endpoint")},t.prototype.getCheckSessionIframe=function(){return o.default.info("MetadataService.getCheckSessionIframe"),this._getMetadataProperty("check_session_iframe",!0)},t.prototype.getEndSessionEndpoint=function(){return o.default.info("MetadataService.getEndSessionEndpoint"),this._getMetadataProperty("end_session_endpoint",!0)},t.prototype._getMetadataProperty=function(t){var e=arguments.length<=1||void 0===arguments[1]?!1:arguments[1];return o.default.info("MetadataService._getMetadataProperty",t),this.getMetadata().then(function(n){if(o.default.info("metadata recieved"),void 0===n[t]){if(e===!0)return void o.default.warn("Metadata does not contain optional property "+t);throw o.default.error("Metadata does not contain property "+t),new Error("Metadata does not contain property "+t)}return n[t]})},t.prototype.getSigningKeys=function(){var t=this;return o.default.info("MetadataService.getSigningKeys"),this._settings.signingKeys?(o.default.info("Returning signingKeys from settings"),Promise.resolve(this._settings.signingKeys)):this._getMetadataProperty("jwks_uri").then(function(e){return o.default.info("jwks_uri received",e),t._jsonService.getJson(e).then(function(e){if(o.default.info("key set received",e),!e.keys)throw o.default.error("Missing keys on keyset"),new Error("Missing keys on keyset");var n=t._filterSigningKeys(e.keys);return o.default.info("filtered keys",n),t._settings.signingKeys=n,t._settings.signingKeys})})},t.prototype._filterSigningKeys=function(t){return o.default.info("MetadataService._filterSigningKeys",t),t.filter(function(t){return"sig"===t.use})},t}();e.default=c,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(300),o=r(s),a=n(304),u=r(a),c=function(){function t(){var e=arguments.length<=0||void 0===arguments[0]?u.default.XMLHttpRequest:arguments[0];i(this,t),this._XMLHttpRequest=e}return t.prototype.getJson=function(t,e){var n=this;if(o.default.info("JsonService.getJson",t),!t)throw o.default.error("No url passed"),new Error("url");return new Promise(function(r,i){var s=new n._XMLHttpRequest;s.open("GET",t),s.onload=function(){o.default.info("HTTP response received, status",s.status),200===s.status?r(JSON.parse(s.responseText)):i(Error(s.statusText+" ("+s.status+")"))},s.onerror=function(){o.default.error("network error"),i(Error("Network Error"))},e&&(o.default.info("token passed, setting Authorization header"),s.setRequestHeader("Authorization","Bearer "+e)),s.send()})},t}();e.default=c,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(307),o=r(s),a=n(306),u=r(a),c=n(300),f=r(c),h=function(){function t(e){var n=arguments.length<=1||void 0===arguments[1]?o.default:arguments[1],r=arguments.length<=2||void 0===arguments[2]?u.default:arguments[2];if(i(this,t),!e)throw f.default.error("No settings passed to UserInfoService"),new Error("settings");this._settings=e,this._jsonService=new n,this._metadataService=new r(this._settings)}return t.prototype.getClaims=function(t){var e=this;return f.default.info("UserInfoService.getClaims"),t?this._metadataService.getUserInfoEndpoint().then(function(n){return f.default.info("received userinfo url",n),e._jsonService.getJson(n,t).then(function(t){return f.default.info("claims received",t),t})}):(f.default.error("No token passed"),Promise.reject(new Error("A token is required")))},t}();e.default=h,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=n(300),u=r(a),c=function(t){function e(){var n=arguments.length<=0||void 0===arguments[0]?{}:arguments[0],r=n.error,o=n.error_description,a=n.error_uri,c=n.state;if(i(this,e),!r)throw u.default.error("No error passed to ErrorResponse"),new Error("error");var f=s(this,t.call(this,o||r));return f.name="ErrorResponse",f.error=r,f.error_description=o,f.error_uri=a,f.state=c,f}return o(e,t),e}(Error);e.default=c,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(311),o=n(300),a=r(o),u=["RS256","RS384","RS512","PS256","PS384","PS512","ES256","ES384","ES512"],c=function(){function t(){i(this,t)}return t.parseJwt=function(t){a.default.info("JoseUtil.parseJwt");try{var e=s.jws.JWS.parse(t);return{header:e.headerObj,payload:e.payloadObj}}catch(n){a.default.error(n)}},t.validateJwt=function(e,n,r,i,o,u){a.default.info("JoseUtil.validateJwt");try{if("RSA"===n.kty)if(n.e&&n.n)n=s.KEYUTIL.getKey(n);else{if(!n.x5c||!n.x5c.length)return a.default.error("RSA key missing key material",n),Promise.reject(new Error("RSA key missing key material"));n=s.KEYUTIL.getKey(s.X509.getPublicKeyFromCertPEM(n.x5c[0]))}else{if("EC"!==n.kty)return a.default.error("Unsupported key type",n&&n.kty),Promise.reject(new Error("Unsupported key type: "+n&&n.kty));if(!(n.crv&&n.x&&n.y))return a.default.error("EC key missing key material",n),Promise.reject(new Error("EC key missing key material"));n=s.KEYUTIL.getKey(n)}return t._validateJwt(e,n,r,i,o,u)}catch(c){return a.default.error(c&&c.message||c),Promise.reject("JWT validation failed")}},t._validateJwt=function(e,n,r,i,o,c){a.default.info("JoseUtil._validateJwt"),o||(o=0),c||(c=parseInt(Date.now()/1e3));var f=t.parseJwt(e).payload;if(f.iss!==r)return a.default.error("Invalid issuer in token",f.iss),Promise.reject(new Error("Invalid issuer in token: "+f.iss));if(f.aud!==i)return a.default.error("Invalid audience in token",f.aud),Promise.reject(new Error("Invalid audience in token: "+f.aud));var h=c+o,l=c-o;if(h<f.iat)return a.default.error("iat is in the future",f.iat),Promise.reject(new Error("iat is in the future: "+f.iat));if(h<f.nbf)return a.default.error("nbf is in the future",f.nbf),Promise.reject(new Error("nbf is in the future: "+f.nbf));if(f.exp<l)return a.default.error("exp is in the past",f.exp),Promise.reject(new Error("exp is in the past:"+f.exp));try{if(!s.jws.JWS.verify(e,n,u))return a.default.error("signature validation failed"),Promise.reject(new Error("signature validation failed"))}catch(d){return a.default.error(d&&d.message||d),Promise.reject(new Error("signature validation failed"))}return Promise.resolve()},t.hashString=function(t,e){a.default.info("JoseUtil.hashString",t,e);try{return s.crypto.Util.hashString(t,e)}catch(n){a.default.error(n)}},t.hexToBase64Url=function(t){a.default.info("JoseUtil.hexToBase64Url",t);try{return(0,s.hextob64u)(t)}catch(e){a.default.error(e)}},t}();e.default=c,t.exports=e.default},function(t,e,n){(function(t){function r(t){var e,n,r="";for(e=0;e+3<=t.length;e+=3)n=parseInt(t.substring(e,e+3),16),r+=ar.charAt(n>>6)+ar.charAt(63&n);if(e+1==t.length?(n=parseInt(t.substring(e,e+1),16),r+=ar.charAt(n<<2)):e+2==t.length&&(n=parseInt(t.substring(e,e+2),16),r+=ar.charAt(n>>2)+ar.charAt((3&n)<<4)),ur)for(;(3&r.length)>0;)r+=ur;return r}function i(t){var e,n,r,i="",s=0;for(e=0;e<t.length&&t.charAt(e)!=ur;++e)r=ar.indexOf(t.charAt(e)),0>r||(0==s?(i+=h(r>>2),n=3&r,s=1):1==s?(i+=h(n<<2|r>>4),n=15&r,s=2):2==s?(i+=h(n),i+=h(r>>2),n=3&r,s=3):(i+=h(n<<2|r>>4),i+=h(15&r),s=0));return 1==s&&(i+=h(n<<2)),i}function s(t){var e,n=i(t),r=new Array;for(e=0;2*e<n.length;++e)r[e]=parseInt(n.substring(2*e,2*e+2),16);return r}function o(t,e,n){null!=t&&("number"==typeof t?this.fromNumber(t,e,n):null==e&&"string"!=typeof t?this.fromString(t,256):this.fromString(t,e))}function a(){return new o(null)}function u(t,e,n,r,i,s){for(;--s>=0;){var o=e*this[t++]+n[r]+i;i=Math.floor(o/67108864),n[r++]=67108863&o}return i}function c(t,e,n,r,i,s){for(var o=32767&e,a=e>>15;--s>=0;){var u=32767&this[t],c=this[t++]>>15,f=a*u+c*o;u=o*u+((32767&f)<<15)+n[r]+(1073741823&i),i=(u>>>30)+(f>>>15)+a*c+(i>>>30),n[r++]=1073741823&u}return i}function f(t,e,n,r,i,s){for(var o=16383&e,a=e>>14;--s>=0;){var u=16383&this[t],c=this[t++]>>14,f=a*u+c*o;u=o*u+((16383&f)<<14)+n[r]+i,i=(u>>28)+(f>>14)+a*c,n[r++]=268435455&u}return i}function h(t){return pr.charAt(t)}function l(t,e){var n=gr[t.charCodeAt(e)];return null==n?-1:n}function d(t){for(var e=this.t-1;e>=0;--e)t[e]=this[e];t.t=this.t,t.s=this.s}function p(t){this.t=1,this.s=0>t?-1:0,t>0?this[0]=t:-1>t?this[0]=t+this.DV:this.t=0}function g(t){var e=a();return e.fromInt(t),e}function y(t,e){var n;if(16==e)n=4;else if(8==e)n=3;else if(256==e)n=8;else if(2==e)n=1;else if(32==e)n=5;else{if(4!=e)return void this.fromRadix(t,e);n=2}this.t=0,this.s=0;for(var r=t.length,i=!1,s=0;--r>=0;){var a=8==n?255&t[r]:l(t,r);0>a?"-"==t.charAt(r)&&(i=!0):(i=!1,0==s?this[this.t++]=a:s+n>this.DB?(this[this.t-1]|=(a&(1<<this.DB-s)-1)<<s,this[this.t++]=a>>this.DB-s):this[this.t-1]|=a<<s,s+=n,s>=this.DB&&(s-=this.DB))}8==n&&0!=(128&t[0])&&(this.s=-1,s>0&&(this[this.t-1]|=(1<<this.DB-s)-1<<s)),this.clamp(),i&&o.ZERO.subTo(this,this)}function v(){for(var t=this.s&this.DM;this.t>0&&this[this.t-1]==t;)--this.t}function m(t){if(this.s<0)return"-"+this.negate().toString(t);var e;if(16==t)e=4;else if(8==t)e=3;else if(2==t)e=1;else if(32==t)e=5;else{if(4!=t)return this.toRadix(t);e=2}var n,r=(1<<e)-1,i=!1,s="",o=this.t,a=this.DB-o*this.DB%e;if(o-- >0)for(a<this.DB&&(n=this[o]>>a)>0&&(i=!0,s=h(n));o>=0;)e>a?(n=(this[o]&(1<<a)-1)<<e-a,n|=this[--o]>>(a+=this.DB-e)):(n=this[o]>>(a-=e)&r,0>=a&&(a+=this.DB,--o)),n>0&&(i=!0),i&&(s+=h(n));return i?s:"0"}function S(){var t=a();return o.ZERO.subTo(this,t),t}function b(){return this.s<0?this.negate():this}function w(t){var e=this.s-t.s;if(0!=e)return e;var n=this.t;if(e=n-t.t,0!=e)return this.s<0?-e:e;for(;--n>=0;)if(0!=(e=this[n]-t[n]))return e;return 0}function E(t){var e,n=1;return 0!=(e=t>>>16)&&(t=e,n+=16),0!=(e=t>>8)&&(t=e,n+=8),0!=(e=t>>4)&&(t=e,n+=4),0!=(e=t>>2)&&(t=e,n+=2),0!=(e=t>>1)&&(t=e,n+=1),n}function x(){return this.t<=0?0:this.DB*(this.t-1)+E(this[this.t-1]^this.s&this.DM)}function _(t,e){var n;for(n=this.t-1;n>=0;--n)e[n+t]=this[n];for(n=t-1;n>=0;--n)e[n]=0;e.t=this.t+t,e.s=this.s}function R(t,e){for(var n=t;n<this.t;++n)e[n-t]=this[n];e.t=Math.max(this.t-t,0),e.s=this.s}function A(t,e){var n,r=t%this.DB,i=this.DB-r,s=(1<<i)-1,o=Math.floor(t/this.DB),a=this.s<<r&this.DM;for(n=this.t-1;n>=0;--n)e[n+o+1]=this[n]>>i|a,a=(this[n]&s)<<r;for(n=o-1;n>=0;--n)e[n]=0;e[o]=a,e.t=this.t+o+1,e.s=this.s,e.clamp()}function F(t,e){e.s=this.s;var n=Math.floor(t/this.DB);if(n>=this.t)return void(e.t=0);var r=t%this.DB,i=this.DB-r,s=(1<<r)-1;e[0]=this[n]>>r;for(var o=n+1;o<this.t;++o)e[o-n-1]|=(this[o]&s)<<i,e[o-n]=this[o]>>r;r>0&&(e[this.t-n-1]|=(this.s&s)<<i),e.t=this.t-n,e.clamp()}function K(t,e){for(var n=0,r=0,i=Math.min(t.t,this.t);i>n;)r+=this[n]-t[n],e[n++]=r&this.DM,r>>=this.DB;if(t.t<this.t){for(r-=t.s;n<this.t;)r+=this[n],e[n++]=r&this.DM,r>>=this.DB;r+=this.s}else{for(r+=this.s;n<t.t;)r-=t[n],e[n++]=r&this.DM,r>>=this.DB;r-=t.s}e.s=0>r?-1:0,-1>r?e[n++]=this.DV+r:r>0&&(e[n++]=r),e.t=n,e.clamp()}function P(t,e){var n=this.abs(),r=t.abs(),i=n.t;for(e.t=i+r.t;--i>=0;)e[i]=0;for(i=0;i<r.t;++i)e[i+n.t]=n.am(0,r[i],e,i,0,n.t);e.s=0,e.clamp(),this.s!=t.s&&o.ZERO.subTo(e,e)}function U(t){for(var e=this.abs(),n=t.t=2*e.t;--n>=0;)t[n]=0;for(n=0;n<e.t-1;++n){var r=e.am(n,e[n],t,2*n,0,1);(t[n+e.t]+=e.am(n+1,2*e[n],t,2*n+1,r,e.t-n-1))>=e.DV&&(t[n+e.t]-=e.DV,t[n+e.t+1]=1)}t.t>0&&(t[t.t-1]+=e.am(n,e[n],t,2*n,0,1)),t.s=0,t.clamp()}function O(t,e,n){var r=t.abs();if(!(r.t<=0)){var i=this.abs();if(i.t<r.t)return null!=e&&e.fromInt(0),void(null!=n&&this.copyTo(n));null==n&&(n=a());var s=a(),u=this.s,c=t.s,f=this.DB-E(r[r.t-1]);f>0?(r.lShiftTo(f,s),i.lShiftTo(f,n)):(r.copyTo(s),i.copyTo(n));var h=s.t,l=s[h-1];if(0!=l){var d=l*(1<<this.F1)+(h>1?s[h-2]>>this.F2:0),p=this.FV/d,g=(1<<this.F1)/d,y=1<<this.F2,v=n.t,m=v-h,S=null==e?a():e;for(s.dlShiftTo(m,S),n.compareTo(S)>=0&&(n[n.t++]=1,n.subTo(S,n)),o.ONE.dlShiftTo(h,S),S.subTo(s,s);s.t<h;)s[s.t++]=0;for(;--m>=0;){var b=n[--v]==l?this.DM:Math.floor(n[v]*p+(n[v-1]+y)*g);if((n[v]+=s.am(0,b,n,m,0,h))<b)for(s.dlShiftTo(m,S),n.subTo(S,n);n[v]<--b;)n.subTo(S,n)}null!=e&&(n.drShiftTo(h,e),u!=c&&o.ZERO.subTo(e,e)),n.t=h,n.clamp(),f>0&&n.rShiftTo(f,n),0>u&&o.ZERO.subTo(n,n)}}}function C(t){var e=a();return this.abs().divRemTo(t,null,e),this.s<0&&e.compareTo(o.ZERO)>0&&t.subTo(e,e),e}function I(t){this.m=t}function j(t){return t.s<0||t.compareTo(this.m)>=0?t.mod(this.m):t}function T(t){return t}function D(t){t.divRemTo(this.m,null,t)}function J(t,e,n){t.multiplyTo(e,n),this.reduce(n)}function H(t,e){t.squareTo(e),this.reduce(e)}function B(){if(this.t<1)return 0;var t=this[0];if(0==(1&t))return 0;var e=3&t;return e=e*(2-(15&t)*e)&15,e=e*(2-(255&t)*e)&255,e=e*(2-((65535&t)*e&65535))&65535,e=e*(2-t*e%this.DV)%this.DV,e>0?this.DV-e:-e}function k(t){this.m=t,this.mp=t.invDigit(),this.mpl=32767&this.mp,this.mph=this.mp>>15,this.um=(1<<t.DB-15)-1,this.mt2=2*t.t}function N(t){var e=a();return t.abs().dlShiftTo(this.m.t,e),e.divRemTo(this.m,null,e),t.s<0&&e.compareTo(o.ZERO)>0&&this.m.subTo(e,e),e}function M(t){var e=a();return t.copyTo(e),this.reduce(e),e}function V(t){for(;t.t<=this.mt2;)t[t.t++]=0;for(var e=0;e<this.m.t;++e){var n=32767&t[e],r=n*this.mpl+((n*this.mph+(t[e]>>15)*this.mpl&this.um)<<15)&t.DM;for(n=e+this.m.t,t[n]+=this.m.am(0,r,t,e,0,this.m.t);t[n]>=t.DV;)t[n]-=t.DV,t[++n]++}t.clamp(),t.drShiftTo(this.m.t,t),t.compareTo(this.m)>=0&&t.subTo(this.m,t)}function L(t,e){t.squareTo(e),this.reduce(e)}function q(t,e,n){t.multiplyTo(e,n),this.reduce(n)}function W(){return 0==(this.t>0?1&this[0]:this.s)}function z(t,e){if(t>4294967295||1>t)return o.ONE;var n=a(),r=a(),i=e.convert(this),s=E(t)-1;for(i.copyTo(n);--s>=0;)if(e.sqrTo(n,r),(t&1<<s)>0)e.mulTo(r,i,n);else{var u=n;n=r,r=u}return e.revert(n)}function Y(t,e){var n;return n=256>t||e.isEven()?new I(e):new k(e),this.exp(t,n)}/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
	 */
function G(){var t=a();return this.copyTo(t),t}function X(){if(this.s<0){if(1==this.t)return this[0]-this.DV;if(0==this.t)return-1}else{if(1==this.t)return this[0];if(0==this.t)return 0}return(this[1]&(1<<32-this.DB)-1)<<this.DB|this[0]}function $(){return 0==this.t?this.s:this[0]<<24>>24}function Z(){return 0==this.t?this.s:this[0]<<16>>16}function Q(t){return Math.floor(Math.LN2*this.DB/Math.log(t))}function tt(){return this.s<0?-1:this.t<=0||1==this.t&&this[0]<=0?0:1}function et(t){if(null==t&&(t=10),0==this.signum()||2>t||t>36)return"0";var e=this.chunkSize(t),n=Math.pow(t,e),r=g(n),i=a(),s=a(),o="";for(this.divRemTo(r,i,s);i.signum()>0;)o=(n+s.intValue()).toString(t).substr(1)+o,i.divRemTo(r,i,s);return s.intValue().toString(t)+o}function nt(t,e){this.fromInt(0),null==e&&(e=10);for(var n=this.chunkSize(e),r=Math.pow(e,n),i=!1,s=0,a=0,u=0;u<t.length;++u){var c=l(t,u);0>c?"-"==t.charAt(u)&&0==this.signum()&&(i=!0):(a=e*a+c,++s>=n&&(this.dMultiply(r),this.dAddOffset(a,0),s=0,a=0))}s>0&&(this.dMultiply(Math.pow(e,s)),this.dAddOffset(a,0)),i&&o.ZERO.subTo(this,this)}function rt(t,e,n){if("number"==typeof e)if(2>t)this.fromInt(1);else for(this.fromNumber(t,n),this.testBit(t-1)||this.bitwiseTo(o.ONE.shiftLeft(t-1),ht,this),this.isEven()&&this.dAddOffset(1,0);!this.isProbablePrime(e);)this.dAddOffset(2,0),this.bitLength()>t&&this.subTo(o.ONE.shiftLeft(t-1),this);else{var r=new Array,i=7&t;r.length=(t>>3)+1,e.nextBytes(r),i>0?r[0]&=(1<<i)-1:r[0]=0,this.fromString(r,256)}}function it(){var t=this.t,e=new Array;e[0]=this.s;var n,r=this.DB-t*this.DB%8,i=0;if(t-- >0)for(r<this.DB&&(n=this[t]>>r)!=(this.s&this.DM)>>r&&(e[i++]=n|this.s<<this.DB-r);t>=0;)8>r?(n=(this[t]&(1<<r)-1)<<8-r,n|=this[--t]>>(r+=this.DB-8)):(n=this[t]>>(r-=8)&255,0>=r&&(r+=this.DB,--t)),0!=(128&n)&&(n|=-256),0==i&&(128&this.s)!=(128&n)&&++i,(i>0||n!=this.s)&&(e[i++]=n);return e}function st(t){return 0==this.compareTo(t)}function ot(t){return this.compareTo(t)<0?this:t}function at(t){return this.compareTo(t)>0?this:t}function ut(t,e,n){var r,i,s=Math.min(t.t,this.t);for(r=0;s>r;++r)n[r]=e(this[r],t[r]);if(t.t<this.t){for(i=t.s&this.DM,r=s;r<this.t;++r)n[r]=e(this[r],i);n.t=this.t}else{for(i=this.s&this.DM,r=s;r<t.t;++r)n[r]=e(i,t[r]);n.t=t.t}n.s=e(this.s,t.s),n.clamp()}function ct(t,e){return t&e}function ft(t){var e=a();return this.bitwiseTo(t,ct,e),e}function ht(t,e){return t|e}function lt(t){var e=a();return this.bitwiseTo(t,ht,e),e}function dt(t,e){return t^e}function pt(t){var e=a();return this.bitwiseTo(t,dt,e),e}function gt(t,e){return t&~e}function yt(t){var e=a();return this.bitwiseTo(t,gt,e),e}function vt(){for(var t=a(),e=0;e<this.t;++e)t[e]=this.DM&~this[e];return t.t=this.t,t.s=~this.s,t}function mt(t){var e=a();return 0>t?this.rShiftTo(-t,e):this.lShiftTo(t,e),e}function St(t){var e=a();return 0>t?this.lShiftTo(-t,e):this.rShiftTo(t,e),e}function bt(t){if(0==t)return-1;var e=0;return 0==(65535&t)&&(t>>=16,e+=16),0==(255&t)&&(t>>=8,e+=8),0==(15&t)&&(t>>=4,e+=4),0==(3&t)&&(t>>=2,e+=2),0==(1&t)&&++e,e}function wt(){for(var t=0;t<this.t;++t)if(0!=this[t])return t*this.DB+bt(this[t]);return this.s<0?this.t*this.DB:-1}function Et(t){for(var e=0;0!=t;)t&=t-1,++e;return e}function xt(){for(var t=0,e=this.s&this.DM,n=0;n<this.t;++n)t+=Et(this[n]^e);return t}function _t(t){var e=Math.floor(t/this.DB);return e>=this.t?0!=this.s:0!=(this[e]&1<<t%this.DB)}function Rt(t,e){var n=o.ONE.shiftLeft(t);return this.bitwiseTo(n,e,n),n}function At(t){return this.changeBit(t,ht)}function Ft(t){return this.changeBit(t,gt)}function Kt(t){return this.changeBit(t,dt)}function Pt(t,e){for(var n=0,r=0,i=Math.min(t.t,this.t);i>n;)r+=this[n]+t[n],e[n++]=r&this.DM,r>>=this.DB;if(t.t<this.t){for(r+=t.s;n<this.t;)r+=this[n],e[n++]=r&this.DM,r>>=this.DB;r+=this.s}else{for(r+=this.s;n<t.t;)r+=t[n],e[n++]=r&this.DM,r>>=this.DB;r+=t.s}e.s=0>r?-1:0,r>0?e[n++]=r:-1>r&&(e[n++]=this.DV+r),e.t=n,e.clamp()}function Ut(t){var e=a();return this.addTo(t,e),e}function Ot(t){var e=a();return this.subTo(t,e),e}function Ct(t){var e=a();return this.multiplyTo(t,e),e}function It(){var t=a();return this.squareTo(t),t}function jt(t){var e=a();return this.divRemTo(t,e,null),e}function Tt(t){var e=a();return this.divRemTo(t,null,e),e}function Dt(t){var e=a(),n=a();return this.divRemTo(t,e,n),new Array(e,n)}function Jt(t){this[this.t]=this.am(0,t-1,this,0,0,this.t),++this.t,this.clamp()}function Ht(t,e){if(0!=t){for(;this.t<=e;)this[this.t++]=0;for(this[e]+=t;this[e]>=this.DV;)this[e]-=this.DV,++e>=this.t&&(this[this.t++]=0),++this[e]}}function Bt(){}function kt(t){return t}function Nt(t,e,n){t.multiplyTo(e,n)}function Mt(t,e){t.squareTo(e)}function Vt(t){return this.exp(t,new Bt)}function Lt(t,e,n){var r=Math.min(this.t+t.t,e);for(n.s=0,n.t=r;r>0;)n[--r]=0;var i;for(i=n.t-this.t;i>r;++r)n[r+this.t]=this.am(0,t[r],n,r,0,this.t);for(i=Math.min(t.t,e);i>r;++r)this.am(0,t[r],n,r,0,e-r);n.clamp()}function qt(t,e,n){--e;var r=n.t=this.t+t.t-e;for(n.s=0;--r>=0;)n[r]=0;for(r=Math.max(e-this.t,0);r<t.t;++r)n[this.t+r-e]=this.am(e-r,t[r],n,0,0,this.t+r-e);n.clamp(),n.drShiftTo(1,n)}function Wt(t){this.r2=a(),this.q3=a(),o.ONE.dlShiftTo(2*t.t,this.r2),this.mu=this.r2.divide(t),this.m=t}function zt(t){if(t.s<0||t.t>2*this.m.t)return t.mod(this.m);if(t.compareTo(this.m)<0)return t;var e=a();return t.copyTo(e),this.reduce(e),e}function Yt(t){return t}function Gt(t){for(t.drShiftTo(this.m.t-1,this.r2),t.t>this.m.t+1&&(t.t=this.m.t+1,t.clamp()),this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3),this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);t.compareTo(this.r2)<0;)t.dAddOffset(1,this.m.t+1);for(t.subTo(this.r2,t);t.compareTo(this.m)>=0;)t.subTo(this.m,t)}function Xt(t,e){t.squareTo(e),this.reduce(e)}function $t(t,e,n){t.multiplyTo(e,n),this.reduce(n)}function Zt(t,e){var n,r,i=t.bitLength(),s=g(1);if(0>=i)return s;n=18>i?1:48>i?3:144>i?4:768>i?5:6,r=8>i?new I(e):e.isEven()?new Wt(e):new k(e);var o=new Array,u=3,c=n-1,f=(1<<n)-1;if(o[1]=r.convert(this),n>1){var h=a();for(r.sqrTo(o[1],h);f>=u;)o[u]=a(),r.mulTo(h,o[u-2],o[u]),u+=2}var l,d,p=t.t-1,y=!0,v=a();for(i=E(t[p])-1;p>=0;){for(i>=c?l=t[p]>>i-c&f:(l=(t[p]&(1<<i+1)-1)<<c-i,p>0&&(l|=t[p-1]>>this.DB+i-c)),u=n;0==(1&l);)l>>=1,--u;if((i-=u)<0&&(i+=this.DB,--p),y)o[l].copyTo(s),y=!1;else{for(;u>1;)r.sqrTo(s,v),r.sqrTo(v,s),u-=2;u>0?r.sqrTo(s,v):(d=s,s=v,v=d),r.mulTo(v,o[l],s)}for(;p>=0&&0==(t[p]&1<<i);)r.sqrTo(s,v),d=s,s=v,v=d,--i<0&&(i=this.DB-1,--p)}return r.revert(s)}function Qt(t){var e=this.s<0?this.negate():this.clone(),n=t.s<0?t.negate():t.clone();if(e.compareTo(n)<0){var r=e;e=n,n=r}var i=e.getLowestSetBit(),s=n.getLowestSetBit();if(0>s)return e;for(s>i&&(s=i),s>0&&(e.rShiftTo(s,e),n.rShiftTo(s,n));e.signum()>0;)(i=e.getLowestSetBit())>0&&e.rShiftTo(i,e),(i=n.getLowestSetBit())>0&&n.rShiftTo(i,n),e.compareTo(n)>=0?(e.subTo(n,e),e.rShiftTo(1,e)):(n.subTo(e,n),n.rShiftTo(1,n));return s>0&&n.lShiftTo(s,n),n}function te(t){if(0>=t)return 0;var e=this.DV%t,n=this.s<0?t-1:0;if(this.t>0)if(0==e)n=this[0]%t;else for(var r=this.t-1;r>=0;--r)n=(e*n+this[r])%t;return n}function ee(t){var e=t.isEven();if(this.isEven()&&e||0==t.signum())return o.ZERO;for(var n=t.clone(),r=this.clone(),i=g(1),s=g(0),a=g(0),u=g(1);0!=n.signum();){for(;n.isEven();)n.rShiftTo(1,n),e?(i.isEven()&&s.isEven()||(i.addTo(this,i),s.subTo(t,s)),i.rShiftTo(1,i)):s.isEven()||s.subTo(t,s),s.rShiftTo(1,s);for(;r.isEven();)r.rShiftTo(1,r),e?(a.isEven()&&u.isEven()||(a.addTo(this,a),u.subTo(t,u)),a.rShiftTo(1,a)):u.isEven()||u.subTo(t,u),u.rShiftTo(1,u);n.compareTo(r)>=0?(n.subTo(r,n),e&&i.subTo(a,i),s.subTo(u,s)):(r.subTo(n,r),e&&a.subTo(i,a),u.subTo(s,u))}return 0!=r.compareTo(o.ONE)?o.ZERO:u.compareTo(t)>=0?u.subtract(t):u.signum()<0?(u.addTo(t,u),u.signum()<0?u.add(t):u):u}function ne(t){var e,n=this.abs();if(1==n.t&&n[0]<=yr[yr.length-1]){for(e=0;e<yr.length;++e)if(n[0]==yr[e])return!0;return!1}if(n.isEven())return!1;for(e=1;e<yr.length;){for(var r=yr[e],i=e+1;i<yr.length&&vr>r;)r*=yr[i++];for(r=n.modInt(r);i>e;)if(r%yr[e++]==0)return!1}return n.millerRabin(t)}function re(t){var e=this.subtract(o.ONE),n=e.getLowestSetBit();if(0>=n)return!1;var r=e.shiftRight(n);t=t+1>>1,t>yr.length&&(t=yr.length);for(var i=a(),s=0;t>s;++s){i.fromInt(yr[Math.floor(Math.random()*yr.length)]);var u=i.modPow(r,this);if(0!=u.compareTo(o.ONE)&&0!=u.compareTo(e)){for(var c=1;c++<n&&0!=u.compareTo(e);)if(u=u.modPowInt(2,this),0==u.compareTo(o.ONE))return!1;if(0!=u.compareTo(e))return!1}}return!0}/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
	 */
function ie(){this.i=0,this.j=0,this.S=new Array}function se(t){var e,n,r;for(e=0;256>e;++e)this.S[e]=e;for(n=0,e=0;256>e;++e)n=n+this.S[e]+t[e%t.length]&255,r=this.S[e],this.S[e]=this.S[n],this.S[n]=r;this.i=0,this.j=0}function oe(){var t;return this.i=this.i+1&255,this.j=this.j+this.S[this.i]&255,t=this.S[this.i],this.S[this.i]=this.S[this.j],this.S[this.j]=t,this.S[t+this.S[this.i]&255]}function ae(){return new ie}function ue(t){Sr[br++]^=255&t,Sr[br++]^=t>>8&255,Sr[br++]^=t>>16&255,Sr[br++]^=t>>24&255,br>=wr&&(br-=wr)}function ce(){ue((new Date).getTime())}function fe(){if(null==mr){for(ce(),mr=ae(),mr.init(Sr),br=0;br<Sr.length;++br)Sr[br]=0;br=0}return mr.next()}function he(t){var e;for(e=0;e<t.length;++e)t[e]=fe()}function le(){}/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
	 */
function de(t,e){return new o(t,e)}function pe(t,e){if(e<t.length+11)return alert("Message too long for RSA"),null;for(var n=new Array,r=t.length-1;r>=0&&e>0;){var i=t.charCodeAt(r--);128>i?n[--e]=i:i>127&&2048>i?(n[--e]=63&i|128,n[--e]=i>>6|192):(n[--e]=63&i|128,n[--e]=i>>6&63|128,n[--e]=i>>12|224)}n[--e]=0;for(var s=new le,a=new Array;e>2;){for(a[0]=0;0==a[0];)s.nextBytes(a);n[--e]=a[0]}return n[--e]=2,n[--e]=0,new o(n)}function ge(t,e,n){for(var r="",i=0;r.length<e;)r+=n(String.fromCharCode.apply(String,t.concat([(4278190080&i)>>24,(16711680&i)>>16,(65280&i)>>8,255&i]))),i+=1;return r}function ye(t,e,n){if(t.length+2*Rr+2>e)throw"Message too long for RSA";var r,i="";for(r=0;r<e-t.length-2*Rr-2;r+=1)i+="\x00";var s=rstr_sha1("")+i+""+t,a=new Array(Rr);(new le).nextBytes(a);var u=ge(a,s.length,n||rstr_sha1),c=[];for(r=0;r<s.length;r+=1)c[r]=s.charCodeAt(r)^u.charCodeAt(r);var f=ge(c,a.length,rstr_sha1),h=[0];for(r=0;r<a.length;r+=1)h[r+1]=a[r]^f.charCodeAt(r);return new o(h.concat(c))}function ve(){this.n=null,this.e=0,this.d=null,this.p=null,this.q=null,this.dmp1=null,this.dmq1=null,this.coeff=null}function me(t,e){this.isPublic=!0,"string"!=typeof t?(this.n=t,this.e=e):null!=t&&null!=e&&t.length>0&&e.length>0?(this.n=de(t,16),this.e=parseInt(e,16)):alert("Invalid RSA public key")}function Se(t){return t.modPowInt(this.e,this.n)}function be(t){var e=pe(t,this.n.bitLength()+7>>3);if(null==e)return null;var n=this.doPublic(e);if(null==n)return null;var r=n.toString(16);return 0==(1&r.length)?r:"0"+r}function we(t,e){var n=ye(t,this.n.bitLength()+7>>3,e);if(null==n)return null;var r=this.doPublic(n);if(null==r)return null;var i=r.toString(16);return 0==(1&i.length)?i:"0"+i}/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
	 */
function Ee(t,e){for(var n=t.toByteArray(),r=0;r<n.length&&0==n[r];)++r;if(n.length-r!=e-1||2!=n[r])return null;for(++r;0!=n[r];)if(++r>=n.length)return null;for(var i="";++r<n.length;){var s=255&n[r];128>s?i+=String.fromCharCode(s):s>191&&224>s?(i+=String.fromCharCode((31&s)<<6|63&n[r+1]),++r):(i+=String.fromCharCode((15&s)<<12|(63&n[r+1])<<6|63&n[r+2]),r+=2)}return i}function xe(t,e,n){for(var r="",i=0;r.length<e;)r+=n(t+String.fromCharCode.apply(String,[(4278190080&i)>>24,(16711680&i)>>16,(65280&i)>>8,255&i])),i+=1;return r}function _e(t,e,n){t=t.toByteArray();var r;for(r=0;r<t.length;r+=1)t[r]&=255;for(;t.length<e;)t.unshift(0);if(t=String.fromCharCode.apply(String,t),t.length<2*Rr+2)throw"Cipher too short";var r,i=t.substr(1,Rr),s=t.substr(Rr+1),o=xe(s,Rr,n||rstr_sha1),a=[];for(r=0;r<i.length;r+=1)a[r]=i.charCodeAt(r)^o.charCodeAt(r);var u=xe(String.fromCharCode.apply(String,a),t.length-Rr,rstr_sha1),c=[];for(r=0;r<s.length;r+=1)c[r]=s.charCodeAt(r)^u.charCodeAt(r);if(c=String.fromCharCode.apply(String,c),c.substr(0,Rr)!==rstr_sha1(""))throw"Hash mismatch";c=c.substr(Rr);var f=c.indexOf(""),h=-1!=f?c.substr(0,f).lastIndexOf("\x00"):-1;if(h+1!=f)throw"Malformed data";return c.substr(f+1)}function Re(t,e,n){this.isPrivate=!0,"string"!=typeof t?(this.n=t,this.e=e,this.d=n):null!=t&&null!=e&&t.length>0&&e.length>0?(this.n=de(t,16),this.e=parseInt(e,16),this.d=de(n,16)):alert("Invalid RSA private key")}function Ae(t,e,n,r,i,s,o,a){if(this.isPrivate=!0,null==t)throw"RSASetPrivateEx N == null";if(null==e)throw"RSASetPrivateEx E == null";if(0==t.length)throw"RSASetPrivateEx N.length == 0";if(0==e.length)throw"RSASetPrivateEx E.length == 0";null!=t&&null!=e&&t.length>0&&e.length>0?(this.n=de(t,16),this.e=parseInt(e,16),this.d=de(n,16),this.p=de(r,16),this.q=de(i,16),this.dmp1=de(s,16),this.dmq1=de(o,16),this.coeff=de(a,16)):alert("Invalid RSA private key in RSASetPrivateEx")}function Fe(t,e){var n=new le,r=t>>1;this.e=parseInt(e,16);for(var i=new o(e,16);;){for(;this.p=new o(t-r,1,n),0!=this.p.subtract(o.ONE).gcd(i).compareTo(o.ONE)||!this.p.isProbablePrime(10););for(;this.q=new o(r,1,n),0!=this.q.subtract(o.ONE).gcd(i).compareTo(o.ONE)||!this.q.isProbablePrime(10););if(this.p.compareTo(this.q)<=0){var s=this.p;this.p=this.q,this.q=s}var a=this.p.subtract(o.ONE),u=this.q.subtract(o.ONE),c=a.multiply(u);if(0==c.gcd(i).compareTo(o.ONE)){this.n=this.p.multiply(this.q),this.d=i.modInverse(c),this.dmp1=this.d.mod(a),this.dmq1=this.d.mod(u),this.coeff=this.q.modInverse(this.p);break}}}function Ke(t){if(null==this.p||null==this.q)return t.modPow(this.d,this.n);for(var e=t.mod(this.p).modPow(this.dmp1,this.p),n=t.mod(this.q).modPow(this.dmq1,this.q);e.compareTo(n)<0;)e=e.add(this.p);return e.subtract(n).multiply(this.coeff).mod(this.p).multiply(this.q).add(n)}function Pe(t){var e=de(t,16),n=this.doPrivate(e);return null==n?null:Ee(n,this.n.bitLength()+7>>3)}function Ue(t,e){var n=de(t,16),r=this.doPrivate(n);return null==r?null:_e(r,this.n.bitLength()+7>>3,e)}/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
	 */
function Oe(t,e){this.x=e,this.q=t}function Ce(t){return t==this?!0:this.q.equals(t.q)&&this.x.equals(t.x)}function Ie(){return this.x}function je(){return new Oe(this.q,this.x.negate().mod(this.q))}function Te(t){return new Oe(this.q,this.x.add(t.toBigInteger()).mod(this.q))}function De(t){return new Oe(this.q,this.x.subtract(t.toBigInteger()).mod(this.q))}function Je(t){return new Oe(this.q,this.x.multiply(t.toBigInteger()).mod(this.q))}function He(){return new Oe(this.q,this.x.square().mod(this.q))}function Be(t){return new Oe(this.q,this.x.multiply(t.toBigInteger().modInverse(this.q)).mod(this.q))}function ke(t,e,n,r){this.curve=t,this.x=e,this.y=n,null==r?this.z=o.ONE:this.z=r,this.zinv=null}function Ne(){return null==this.zinv&&(this.zinv=this.z.modInverse(this.curve.q)),this.curve.fromBigInteger(this.x.toBigInteger().multiply(this.zinv).mod(this.curve.q))}function Me(){return null==this.zinv&&(this.zinv=this.z.modInverse(this.curve.q)),this.curve.fromBigInteger(this.y.toBigInteger().multiply(this.zinv).mod(this.curve.q))}function Ve(t){if(t==this)return!0;if(this.isInfinity())return t.isInfinity();if(t.isInfinity())return this.isInfinity();var e,n;return e=t.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t.z)).mod(this.curve.q),e.equals(o.ZERO)?(n=t.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t.z)).mod(this.curve.q),n.equals(o.ZERO)):!1}function Le(){return null==this.x&&null==this.y?!0:this.z.equals(o.ZERO)&&!this.y.toBigInteger().equals(o.ZERO)}function qe(){return new ke(this.curve,this.x,this.y.negate(),this.z)}function We(t){if(this.isInfinity())return t;if(t.isInfinity())return this;var e=t.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t.z)).mod(this.curve.q),n=t.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t.z)).mod(this.curve.q);if(o.ZERO.equals(n))return o.ZERO.equals(e)?this.twice():this.curve.getInfinity();var r=new o("3"),i=this.x.toBigInteger(),s=this.y.toBigInteger(),a=(t.x.toBigInteger(),t.y.toBigInteger(),n.square()),u=a.multiply(n),c=i.multiply(a),f=e.square().multiply(this.z),h=f.subtract(c.shiftLeft(1)).multiply(t.z).subtract(u).multiply(n).mod(this.curve.q),l=c.multiply(r).multiply(e).subtract(s.multiply(u)).subtract(f.multiply(e)).multiply(t.z).add(e.multiply(u)).mod(this.curve.q),d=u.multiply(this.z).multiply(t.z).mod(this.curve.q);return new ke(this.curve,this.curve.fromBigInteger(h),this.curve.fromBigInteger(l),d)}function ze(){if(this.isInfinity())return this;if(0==this.y.toBigInteger().signum())return this.curve.getInfinity();var t=new o("3"),e=this.x.toBigInteger(),n=this.y.toBigInteger(),r=n.multiply(this.z),i=r.multiply(n).mod(this.curve.q),s=this.curve.a.toBigInteger(),a=e.square().multiply(t);o.ZERO.equals(s)||(a=a.add(this.z.square().multiply(s))),a=a.mod(this.curve.q);var u=a.square().subtract(e.shiftLeft(3).multiply(i)).shiftLeft(1).multiply(r).mod(this.curve.q),c=a.multiply(t).multiply(e).subtract(i.shiftLeft(1)).shiftLeft(2).multiply(i).subtract(a.square().multiply(a)).mod(this.curve.q),f=r.square().multiply(r).shiftLeft(3).mod(this.curve.q);return new ke(this.curve,this.curve.fromBigInteger(u),this.curve.fromBigInteger(c),f)}function Ye(t){if(this.isInfinity())return this;if(0==t.signum())return this.curve.getInfinity();var e,n=t,r=n.multiply(new o("3")),i=this.negate(),s=this;for(e=r.bitLength()-2;e>0;--e){s=s.twice();var a=r.testBit(e),u=n.testBit(e);a!=u&&(s=s.add(a?this:i))}return s}function Ge(t,e,n){var r;r=t.bitLength()>n.bitLength()?t.bitLength()-1:n.bitLength()-1;for(var i=this.curve.getInfinity(),s=this.add(e);r>=0;)i=i.twice(),t.testBit(r)?i=n.testBit(r)?i.add(s):i.add(this):n.testBit(r)&&(i=i.add(e)),--r;return i}function Xe(t,e,n){this.q=t,this.a=this.fromBigInteger(e),this.b=this.fromBigInteger(n),this.infinity=new ke(this,null,null)}function $e(){return this.q}function Ze(){return this.a}function Qe(){return this.b}function tn(t){return t==this?!0:this.q.equals(t.q)&&this.a.equals(t.a)&&this.b.equals(t.b)}function en(){return this.infinity}function nn(t){return new Oe(this.q,t)}function rn(t){switch(parseInt(t.substr(0,2),16)){case 0:return this.infinity;case 2:case 3:return null;case 4:case 6:case 7:var e=(t.length-2)/2,n=t.substr(2,e),r=t.substr(e+2,e);return new ke(this,this.fromBigInteger(new o(n,16)),this.fromBigInteger(new o(r,16)));default:return null}}function sn(t){for(var e=new Array,n=0;n<t.length;n++)e[n]=t.charCodeAt(n);return e}function on(t){for(var e="",n=0;n<t.length;n++)e+=String.fromCharCode(t[n]);return e}function an(t){for(var e="",n=0;n<t.length;n++){var r=t[n].toString(16);1==r.length&&(r="0"+r),e+=r}return e}function un(t){return an(sn(t))}function cn(t){return r(un(t))}function fn(t){return ln(r(un(t)))}function hn(t){return on(s(dn(t)))}function ln(t){return t=t.replace(/\=/g,""),t=t.replace(/\+/g,"-"),t=t.replace(/\//g,"_")}function dn(t){return t.length%4==2?t+="==":t.length%4==3&&(t+="="),t=t.replace(/-/g,"+"),t=t.replace(/_/g,"/")}function pn(t){return t.length%2==1&&(t="0"+t),ln(r(t))}function gn(t){return i(dn(t))}function yn(t){return r(En(_n(t)))}function vn(t){return decodeURIComponent(xn(i(t)))}function mn(t){return En(_n(t))}function Sn(t){return decodeURIComponent(xn(t))}function bn(t){for(var e="",n=0;n<t.length-1;n+=2)e+=String.fromCharCode(parseInt(t.substr(n,2),16));return e}function wn(t){for(var e="",n=0;n<t.length;n++)e+=("0"+t.charCodeAt(n).toString(16)).slice(-2);return e}function En(t){return t.replace(/%/g,"")}function xn(t){return t.replace(/(..)/g,"%$1")}function _n(t){for(var e=encodeURIComponent(t),n="",r=0;r<e.length;r++)"%"==e[r]?(n+=e.substr(r,3),r+=2):n=n+"%"+un(e[r]);return n}function Rn(t){return t=t.replace(/\r\n/gm,"\n")}function An(t){return t=t.replace(/\r\n/gm,"\n"),t=t.replace(/\n/gm,"\r\n")}function Fn(t){t=t.replace(/^\s*\[\s*/,""),t=t.replace(/\s*\]\s*$/,""),t=t.replace(/\s*/g,"");try{var e=t.split(/,/).map(function(t,e,n){var r=parseInt(t);if(0>r||r>255)throw"integer not in range 0-255";var i=("00"+r.toString(16)).slice(-2);return i}).join("");return e}catch(n){throw"malformed integer array string: "+n}}/*! rsapem-1.1.js (c) 2012 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
function Kn(t){var e=t;return e=e.replace("-----BEGIN RSA PRIVATE KEY-----",""),e=e.replace("-----END RSA PRIVATE KEY-----",""),e=e.replace(/[ \n]+/g,"")}function Pn(t){var e=new Array,n=Fr.getStartPosOfV_AtObj(t,0),r=Fr.getPosOfNextSibling_AtObj(t,n),i=Fr.getPosOfNextSibling_AtObj(t,r),s=Fr.getPosOfNextSibling_AtObj(t,i),o=Fr.getPosOfNextSibling_AtObj(t,s),a=Fr.getPosOfNextSibling_AtObj(t,o),u=Fr.getPosOfNextSibling_AtObj(t,a),c=Fr.getPosOfNextSibling_AtObj(t,u),f=Fr.getPosOfNextSibling_AtObj(t,c);return e.push(n,r,i,s,o,a,u,c,f),e}function Un(t){var e=Pn(t),n=Fr.getHexOfV_AtObj(t,e[0]),r=Fr.getHexOfV_AtObj(t,e[1]),i=Fr.getHexOfV_AtObj(t,e[2]),s=Fr.getHexOfV_AtObj(t,e[3]),o=Fr.getHexOfV_AtObj(t,e[4]),a=Fr.getHexOfV_AtObj(t,e[5]),u=Fr.getHexOfV_AtObj(t,e[6]),c=Fr.getHexOfV_AtObj(t,e[7]),f=Fr.getHexOfV_AtObj(t,e[8]),h=new Array;return h.push(n,r,i,s,o,a,u,c,f),h}function On(t){var e=Un(t);this.setPrivateEx(e[1],e[2],e[3],e[4],e[5],e[6],e[7],e[8])}function Cn(t){var e=Kn(t),n=i(e),r=Un(n);this.setPrivateEx(r[1],r[2],r[3],r[4],r[5],r[6],r[7],r[8])}function In(t,e){for(var n="",r=e/4-t.length,i=0;r>i;i++)n+="0";return n+t}function jn(t,e){var n=function(t){return KJUR.crypto.Util.hashString(t,e)},r=n(t);return this.signWithMessageHash(r,e)}function Tn(t,e){var n=KJUR.crypto.Util.getPaddedDigestInfoHex(t,e,this.n.bitLength()),r=de(n,16),i=this.doPrivate(r),s=i.toString(16);return In(s,this.n.bitLength())}function Dn(t){return jn.call(this,t,"sha1")}function Jn(t){return jn.call(this,t,"sha256")}function Hn(t,e,n){for(var r="",i=0;r.length<e;)r+=bn(n(wn(t+String.fromCharCode.apply(String,[(4278190080&i)>>24,(16711680&i)>>16,(65280&i)>>8,255&i])))),i+=1;return r}function Bn(t,e,n){var r=function(t){return KJUR.crypto.Util.hashHex(t,e)},i=r(wn(t));return void 0===n&&(n=-1),this.signWithMessageHashPSS(i,e,n)}function kn(t,e,n){var r,i=bn(t),s=i.length,a=this.n.bitLength()-1,u=Math.ceil(a/8),c=function(t){return KJUR.crypto.Util.hashHex(t,e)};if(-1===n||void 0===n)n=s;else if(-2===n)n=u-s-2;else if(-2>n)throw"invalid salt length";if(s+n+2>u)throw"data too long";var f="";n>0&&(f=new Array(n),(new le).nextBytes(f),f=String.fromCharCode.apply(String,f));var h=bn(c(wn("\x00\x00\x00\x00\x00\x00\x00\x00"+i+f))),l=[];for(r=0;u-n-s-2>r;r+=1)l[r]=0;var d=String.fromCharCode.apply(String,l)+""+f,p=Hn(h,d.length,c),g=[];for(r=0;r<d.length;r+=1)g[r]=d.charCodeAt(r)^p.charCodeAt(r);var y=65280>>8*u-a&255;for(g[0]&=~y,r=0;s>r;r++)g.push(h.charCodeAt(r));return g.push(188),In(this.doPrivate(new o(g)).toString(16),this.n.bitLength())}function Nn(t,e,n){var r=new ve;r.setPublic(e,n);var i=r.doPublic(t);return i}function Mn(t,e,n){var r=Nn(t,e,n),i=r.toString(16).replace(/^1f+00/,"");return i}function Vn(t){for(var e in KJUR.crypto.Util.DIGESTINFOHEAD){var n=KJUR.crypto.Util.DIGESTINFOHEAD[e],r=n.length;if(t.substring(0,r)==n){var i=[e,t.substring(r)];return i}}return[]}function Ln(t,e,n,r){var i=Mn(e,n,r),s=Vn(i);if(0==s.length)return!1;var o=s[0],a=s[1],u=function(t){return KJUR.crypto.Util.hashString(t,o)},c=u(t);return a==c}function qn(t,e){var n=de(t,16),r=Ln(e,n,this.n.toString(16),this.e.toString(16));return r}function Wn(t,e){e=e.replace(Ir,""),e=e.replace(/[ \n]+/g,"");var n=de(e,16);if(n.bitLength()>this.n.bitLength())return 0;var r=this.doPublic(n),i=r.toString(16).replace(/^1f+00/,""),s=Vn(i);if(0==s.length)return!1;var o=s[0],a=s[1],u=function(t){return KJUR.crypto.Util.hashString(t,o)},c=u(t);return a==c}function zn(t,e){e=e.replace(Ir,""),e=e.replace(/[ \n]+/g,"");var n=de(e,16);if(n.bitLength()>this.n.bitLength())return 0;var r=this.doPublic(n),i=r.toString(16).replace(/^1f+00/,""),s=Vn(i);if(0==s.length)return!1;var o=(s[0],s[1]);return o==t}function Yn(t,e,n,r){var i=function(t){return KJUR.crypto.Util.hashHex(t,n)},s=i(wn(t));return void 0===r&&(r=-1),this.verifyWithMessageHashPSS(s,e,n,r)}function Gn(t,e,n,r){var i=new o(e,16);if(i.bitLength()>this.n.bitLength())return!1;var s,a=function(t){return KJUR.crypto.Util.hashHex(t,n)},u=bn(t),c=u.length,f=this.n.bitLength()-1,h=Math.ceil(f/8);if(-1===r||void 0===r)r=c;else if(-2===r)r=h-c-2;else if(-2>r)throw"invalid salt length";if(c+r+2>h)throw"data too long";var l=this.doPublic(i).toByteArray();for(s=0;s<l.length;s+=1)l[s]&=255;for(;l.length<h;)l.unshift(0);if(188!==l[h-1])throw"encoded message does not end in 0xbc";l=String.fromCharCode.apply(String,l);var d=l.substr(0,h-c-1),p=l.substr(d.length,c),g=65280>>8*h-f&255;if(0!==(d.charCodeAt(0)&g))throw"bits beyond keysize not zero";var y=Hn(p,d.length,a),v=[];for(s=0;s<d.length;s+=1)v[s]=d.charCodeAt(s)^y.charCodeAt(s);v[0]&=~g;var m=h-c-r-2;for(s=0;m>s;s+=1)if(0!==v[s])throw"leftmost octets not zero";if(1!==v[m])throw"0x01 marker not found";return p===bn(a(wn("\x00\x00\x00\x00\x00\x00\x00\x00"+u+String.fromCharCode.apply(String,v.slice(-r)))))}/*! x509-1.1.9.js (c) 2012-2016 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
function Xn(){this.subjectPublicKeyRSA=null,this.subjectPublicKeyRSA_hN=null,this.subjectPublicKeyRSA_hE=null,this.hex=null,this.getSerialNumberHex=function(){return Fr.getDecendantHexVByNthList(this.hex,0,[0,1])},this.getSignatureAlgorithmField=function(){var t=Fr.getDecendantHexVByNthList(this.hex,0,[0,2,0]),e=KJUR.asn1.ASN1Util.oidHexToInt(t),n=KJUR.asn1.x509.OID.oid2name(e);return n},this.getIssuerHex=function(){return Fr.getDecendantHexTLVByNthList(this.hex,0,[0,3])},this.getIssuerString=function(){return Xn.hex2dn(Fr.getDecendantHexTLVByNthList(this.hex,0,[0,3]))},this.getSubjectHex=function(){return Fr.getDecendantHexTLVByNthList(this.hex,0,[0,5])},this.getSubjectString=function(){return Xn.hex2dn(Fr.getDecendantHexTLVByNthList(this.hex,0,[0,5]))},this.getNotBefore=function(){var t=Fr.getDecendantHexVByNthList(this.hex,0,[0,4,0]);return t=t.replace(/(..)/g,"%$1"),t=decodeURIComponent(t)},this.getNotAfter=function(){var t=Fr.getDecendantHexVByNthList(this.hex,0,[0,4,1]);return t=t.replace(/(..)/g,"%$1"),t=decodeURIComponent(t)},this.readCertPEM=function(t){var e=Xn.pemToHex(t),n=Xn.getPublicKeyHexArrayFromCertHex(e),r=new ve;r.setPublic(n[0],n[1]),this.subjectPublicKeyRSA=r,this.subjectPublicKeyRSA_hN=n[0],this.subjectPublicKeyRSA_hE=n[1],this.hex=e},this.readCertPEMWithoutRSAInit=function(t){var e=Xn.pemToHex(t),n=Xn.getPublicKeyHexArrayFromCertHex(e);this.subjectPublicKeyRSA.setPublic(n[0],n[1]),this.subjectPublicKeyRSA_hN=n[0],this.subjectPublicKeyRSA_hE=n[1],this.hex=e},this.getInfo=function(){var t="Basic Fields\n";t+="  serial number: "+this.getSerialNumberHex()+"\n",t+="  signature algorithm: "+this.getSignatureAlgorithmField()+"\n",t+="  issuer: "+this.getIssuerString()+"\n",t+="  notBefore: "+this.getNotBefore()+"\n",t+="  notAfter: "+this.getNotAfter()+"\n",t+="  subject: "+this.getSubjectString()+"\n",t+="  subject public key info: \n";var e=Xn.getSubjectPublicKeyInfoPosFromCertHex(this.hex),n=Fr.getHexOfTLV_AtObj(this.hex,e),r=Cr.getKey(n,null,"pkcs8pub");r instanceof ve&&(t+="    key algorithm: RSA\n",t+="    n="+r.n.toString(16).substr(0,16)+"...\n",t+="    e="+r.e.toString(16)+"\n"),t+="X509v3 Extensions:\n";for(var i=Xn.getV3ExtInfoListOfCertHex(this.hex),s=0;s<i.length;s++){var o=i[s],a=KJUR.asn1.x509.OID.oid2name(o.oid);""===a&&(a=o.oid);var u="";if(o.critical===!0&&(u="CRITICAL"),t+="  "+a+" "+u+":\n","basicConstraints"===a){var c=Xn.getExtBasicConstraints(this.hex);void 0===c.cA?t+="    {}\n":(t+="    cA=true",void 0!==c.pathLen&&(t+=", pathLen="+c.pathLen),t+="\n")}else if("keyUsage"===a)t+="    "+Xn.getExtKeyUsageString(this.hex)+"\n";else if("subjectKeyIdentifier"===a)t+="    "+Xn.getExtSubjectKeyIdentifier(this.hex)+"\n";else if("authorityKeyIdentifier"===a){var f=Xn.getExtAuthorityKeyIdentifier(this.hex);void 0!==f.kid&&(t+="    kid="+f.kid+"\n")}else if("extKeyUsage"===a){var h=Xn.getExtExtKeyUsageName(this.hex);t+="    "+h.join(", ")+"\n"}else if("subjectAltName"===a){var l=Xn.getExtSubjectAltName(this.hex);t+="    "+l.join(", ")+"\n"}else if("cRLDistributionPoints"===a){var d=Xn.getExtCRLDistributionPointsURI(this.hex);t+="    "+d+"\n"}else if("authorityInfoAccess"===a){var p=Xn.getExtAIAInfo(this.hex);void 0!==p.ocsp&&(t+="    ocsp: "+p.ocsp.join(",")+"\n"),void 0!==p.caissuer&&(t+="    caissuer: "+p.caissuer.join(",")+"\n")}}return t+="signature algorithm: "+Xn.getSignatureAlgorithmName(this.hex)+"\n",t+="signature: "+Xn.getSignatureValueHex(this.hex).substr(0,16)+"...\n"}}/*! nodeutil-1.0.0 (c) 2015 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
function $n(t){return n(316).readFileSync(t,"utf8")}function Zn(t){var e=n(311),r=n(316);return e.rstrtohex(r.readFileSync(t,"binary"))}function Qn(t){var e=n(316);return e.readFileSync(t,"binary")}function tr(t,e){var r=n(316);r.writeFileSync(t,e,"binary")}function er(t,e){var r=n(316),i=n(311),s=i.hextorstr(e);r.writeFileSync(t,s,"binary")}var nr={};nr.userAgent=!1;var rr={};if("undefined"==typeof ir||!ir)var ir={};ir.namespace=function(){var t,e,n,r=arguments,i=null;for(t=0;t<r.length;t+=1)for(n=(""+r[t]).split("."),i=ir,e="YAHOO"==n[0]?1:0;e<n.length;e+=1)i[n[e]]=i[n[e]]||{},i=i[n[e]];return i},ir.log=function(t,e,n){var r=ir.widget.Logger;return r&&r.log?r.log(t,e,n):!1},ir.register=function(t,e,n){var r,i,s,o,a,u=ir.env.modules;for(u[t]||(u[t]={versions:[],builds:[]}),r=u[t],i=n.version,s=n.build,o=ir.env.listeners,r.name=t,r.version=i,r.build=s,r.versions.push(i),r.builds.push(s),r.mainClass=e,a=0;a<o.length;a+=1)o[a](r);e?(e.VERSION=i,e.BUILD=s):ir.log("mainClass is undefined for module "+t,"warn")},ir.env=ir.env||{modules:[],listeners:[]},ir.env.getVersion=function(t){return ir.env.modules[t]||null},ir.env.parseUA=function(t){var e,n=function(t){var e=0;return parseFloat(t.replace(/\./g,function(){return 1==e++?"":"."}))},r=nr,i={ie:0,opera:0,gecko:0,webkit:0,chrome:0,mobile:null,air:0,ipad:0,iphone:0,ipod:0,ios:null,android:0,webos:0,caja:r&&r.cajaVersion,secure:!1,os:null},s=t||nr&&nr.userAgent,o=rr&&rr.location,a=o&&o.href;return i.secure=a&&0===a.toLowerCase().indexOf("https"),s&&(/windows|win32/i.test(s)?i.os="windows":/macintosh/i.test(s)?i.os="macintosh":/rhino/i.test(s)&&(i.os="rhino"),/KHTML/.test(s)&&(i.webkit=1),e=s.match(/AppleWebKit\/([^\s]*)/),e&&e[1]&&(i.webkit=n(e[1]),/ Mobile\//.test(s)?(i.mobile="Apple",e=s.match(/OS ([^\s]*)/),e&&e[1]&&(e=n(e[1].replace("_","."))),i.ios=e,i.ipad=i.ipod=i.iphone=0,e=s.match(/iPad|iPod|iPhone/),e&&e[0]&&(i[e[0].toLowerCase()]=i.ios)):(e=s.match(/NokiaN[^\/]*|Android \d\.\d|webOS\/\d\.\d/),e&&(i.mobile=e[0]),/webOS/.test(s)&&(i.mobile="WebOS",e=s.match(/webOS\/([^\s]*);/),e&&e[1]&&(i.webos=n(e[1]))),/ Android/.test(s)&&(i.mobile="Android",e=s.match(/Android ([^\s]*);/),e&&e[1]&&(i.android=n(e[1])))),e=s.match(/Chrome\/([^\s]*)/),e&&e[1]?i.chrome=n(e[1]):(e=s.match(/AdobeAIR\/([^\s]*)/),e&&(i.air=e[0]))),i.webkit||(e=s.match(/Opera[\s\/]([^\s]*)/),e&&e[1]?(i.opera=n(e[1]),e=s.match(/Version\/([^\s]*)/),e&&e[1]&&(i.opera=n(e[1])),e=s.match(/Opera Mini[^;]*/),e&&(i.mobile=e[0])):(e=s.match(/MSIE\s([^;]*)/),e&&e[1]?i.ie=n(e[1]):(e=s.match(/Gecko\/([^\s]*)/),e&&(i.gecko=1,e=s.match(/rv:([^\s\)]*)/),e&&e[1]&&(i.gecko=n(e[1]))))))),i},ir.env.ua=ir.env.parseUA(),function(){if(ir.namespace("util","widget","example"),"undefined"!=typeof YAHOO_config){var t,e=YAHOO_config.listener,n=ir.env.listeners,r=!0;if(e){for(t=0;t<n.length;t++)if(n[t]==e){r=!1;break}r&&n.push(e)}}}(),ir.lang=ir.lang||{},function(){var t=ir.lang,e=Object.prototype,n="[object Array]",r="[object Function]",i="[object Object]",s=[],o={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","/":"&#x2F;","`":"&#x60;"},a=["toString","valueOf"],u={isArray:function(t){return e.toString.apply(t)===n},isBoolean:function(t){return"boolean"==typeof t},isFunction:function(t){return"function"==typeof t||e.toString.apply(t)===r},isNull:function(t){return null===t},isNumber:function(t){return"number"==typeof t&&isFinite(t)},isObject:function(e){return e&&("object"==typeof e||t.isFunction(e))||!1},isString:function(t){return"string"==typeof t},isUndefined:function(t){return"undefined"==typeof t},_IEEnumFix:ir.env.ua.ie?function(n,r){var i,s,o;for(i=0;i<a.length;i+=1)s=a[i],o=r[s],t.isFunction(o)&&o!=e[s]&&(n[s]=o)}:function(){},escapeHTML:function(t){return t.replace(/[&<>"'\/`]/g,function(t){return o[t]})},extend:function(n,r,i){if(!r||!n)throw new Error("extend failed, please check that all dependencies are included.");var s,o=function(){};if(o.prototype=r.prototype,n.prototype=new o,n.prototype.constructor=n,n.superclass=r.prototype,r.prototype.constructor==e.constructor&&(r.prototype.constructor=r),i){for(s in i)t.hasOwnProperty(i,s)&&(n.prototype[s]=i[s]);t._IEEnumFix(n.prototype,i)}},augmentObject:function(e,n){if(!n||!e)throw new Error("Absorb failed, verify dependencies.");var r,i,s=arguments,o=s[2];if(o&&o!==!0)for(r=2;r<s.length;r+=1)e[s[r]]=n[s[r]];else{for(i in n)!o&&i in e||(e[i]=n[i]);t._IEEnumFix(e,n)}return e},augmentProto:function(e,n){if(!n||!e)throw new Error("Augment failed, verify dependencies.");var r,i=[e.prototype,n.prototype];for(r=2;r<arguments.length;r+=1)i.push(arguments[r]);return t.augmentObject.apply(this,i),e},dump:function(e,n){var r,i,s=[],o="{...}",a="f(){...}",u=", ",c=" => ";if(!t.isObject(e))return e+"";if(e instanceof Date||"nodeType"in e&&"tagName"in e)return e;if(t.isFunction(e))return a;if(n=t.isNumber(n)?n:3,t.isArray(e)){for(s.push("["),r=0,i=e.length;i>r;r+=1)t.isObject(e[r])?s.push(n>0?t.dump(e[r],n-1):o):s.push(e[r]),s.push(u);s.length>1&&s.pop(),s.push("]")}else{s.push("{");for(r in e)t.hasOwnProperty(e,r)&&(s.push(r+c),t.isObject(e[r])?s.push(n>0?t.dump(e[r],n-1):o):s.push(e[r]),s.push(u));s.length>1&&s.pop(),s.push("}")}return s.join("")},substitute:function(e,n,r,s){for(var o,a,u,c,f,h,l,d,p,g=[],y=e.length,v="dump",m=" ",S="{",b="}";(o=e.lastIndexOf(S,y),!(0>o))&&(a=e.indexOf(b,o),!(o+1>a));)l=e.substring(o+1,a),c=l,h=null,u=c.indexOf(m),u>-1&&(h=c.substring(u+1),c=c.substring(0,u)),f=n[c],r&&(f=r(c,f,h)),t.isObject(f)?t.isArray(f)?f=t.dump(f,parseInt(h,10)):(h=h||"",d=h.indexOf(v),d>-1&&(h=h.substring(4)),p=f.toString(),f=p===i||d>-1?t.dump(f,parseInt(h,10)):p):t.isString(f)||t.isNumber(f)||(f="~-"+g.length+"-~",g[g.length]=l),e=e.substring(0,o)+f+e.substring(a+1),s===!1&&(y=o-1);for(o=g.length-1;o>=0;o-=1)e=e.replace(new RegExp("~-"+o+"-~"),"{"+g[o]+"}","g");return e},trim:function(t){try{return t.replace(/^\s+|\s+$/g,"")}catch(e){return t}},merge:function(){var e,n={},r=arguments,i=r.length;for(e=0;i>e;e+=1)t.augmentObject(n,r[e],!0);return n},later:function(e,n,r,i,o){e=e||0,n=n||{};var a,u,c=r,f=i;if(t.isString(r)&&(c=n[r]),!c)throw new TypeError("method undefined");return t.isUndefined(i)||t.isArray(f)||(f=[i]),a=function(){c.apply(n,f||s)},u=o?setInterval(a,e):setTimeout(a,e),{interval:o,cancel:function(){this.interval?clearInterval(u):clearTimeout(u)}}},isValue:function(e){return t.isObject(e)||t.isString(e)||t.isNumber(e)||t.isBoolean(e)}};t.hasOwnProperty=e.hasOwnProperty?function(t,e){return t&&t.hasOwnProperty&&t.hasOwnProperty(e)}:function(e,n){return!t.isUndefined(e[n])&&e.constructor.prototype[n]!==e[n]},u.augmentObject(t,u,!0),ir.util.Lang=t,t.augment=t.augmentProto,ir.augment=t.augmentProto,ir.extend=t.extend}(),ir.register("yahoo",ir,{version:"2.9.0",build:"2800"});/*! CryptoJS v3.1.2 core-fix.js
	 * code.google.com/p/crypto-js
	 * (c) 2009-2013 by Jeff Mott. All rights reserved.
	 * code.google.com/p/crypto-js/wiki/License
	 * THIS IS FIX of 'core.js' to fix Hmac issue.
	 * https://code.google.com/p/crypto-js/issues/detail?id=84
	 * https://crypto-js.googlecode.com/svn-history/r667/branches/3.x/src/core.js
	 */
var sr=sr||function(t,e){var n={},r=n.lib={},i=r.Base=function(){function t(){}return{extend:function(e){t.prototype=this;var n=new t;return e&&n.mixIn(e),n.hasOwnProperty("init")||(n.init=function(){n.$super.init.apply(this,arguments)}),n.init.prototype=n,n.$super=this,n},create:function(){var t=this.extend();return t.init.apply(t,arguments),t},init:function(){},mixIn:function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e]);t.hasOwnProperty("toString")&&(this.toString=t.toString)},clone:function(){return this.init.prototype.extend(this)}}}(),s=r.WordArray=i.extend({init:function(t,n){t=this.words=t||[],n!=e?this.sigBytes=n:this.sigBytes=4*t.length},toString:function(t){return(t||a).stringify(this)},concat:function(t){var e=this.words,n=t.words,r=this.sigBytes,i=t.sigBytes;if(this.clamp(),r%4)for(var s=0;i>s;s++){var o=n[s>>>2]>>>24-s%4*8&255;e[r+s>>>2]|=o<<24-(r+s)%4*8}else for(var s=0;i>s;s+=4)e[r+s>>>2]=n[s>>>2];return this.sigBytes+=i,this},clamp:function(){var e=this.words,n=this.sigBytes;e[n>>>2]&=4294967295<<32-n%4*8,e.length=t.ceil(n/4)},clone:function(){var t=i.clone.call(this);return t.words=this.words.slice(0),t},random:function(e){for(var n=[],r=0;e>r;r+=4)n.push(4294967296*t.random()|0);return new s.init(n,e)}}),o=n.enc={},a=o.Hex={stringify:function(t){for(var e=t.words,n=t.sigBytes,r=[],i=0;n>i;i++){var s=e[i>>>2]>>>24-i%4*8&255;r.push((s>>>4).toString(16)),r.push((15&s).toString(16))}return r.join("")},parse:function(t){for(var e=t.length,n=[],r=0;e>r;r+=2)n[r>>>3]|=parseInt(t.substr(r,2),16)<<24-r%8*4;return new s.init(n,e/2)}},u=o.Latin1={stringify:function(t){for(var e=t.words,n=t.sigBytes,r=[],i=0;n>i;i++){var s=e[i>>>2]>>>24-i%4*8&255;r.push(String.fromCharCode(s))}return r.join("")},parse:function(t){for(var e=t.length,n=[],r=0;e>r;r++)n[r>>>2]|=(255&t.charCodeAt(r))<<24-r%4*8;return new s.init(n,e)}},c=o.Utf8={stringify:function(t){try{return decodeURIComponent(escape(u.stringify(t)))}catch(e){throw new Error("Malformed UTF-8 data")}},parse:function(t){return u.parse(unescape(encodeURIComponent(t)))}},f=r.BufferedBlockAlgorithm=i.extend({reset:function(){this._data=new s.init,this._nDataBytes=0},_append:function(t){"string"==typeof t&&(t=c.parse(t)),this._data.concat(t),this._nDataBytes+=t.sigBytes},_process:function(e){var n=this._data,r=n.words,i=n.sigBytes,o=this.blockSize,a=4*o,u=i/a;u=e?t.ceil(u):t.max((0|u)-this._minBufferSize,0);var c=u*o,f=t.min(4*c,i);if(c){for(var h=0;c>h;h+=o)this._doProcessBlock(r,h);var l=r.splice(0,c);n.sigBytes-=f}return new s.init(l,f)},clone:function(){var t=i.clone.call(this);return t._data=this._data.clone(),t},_minBufferSize:0}),h=(r.Hasher=f.extend({cfg:i.extend(),init:function(t){this.cfg=this.cfg.extend(t),this.reset()},reset:function(){f.reset.call(this),this._doReset()},update:function(t){return this._append(t),this._process(),this},finalize:function(t){t&&this._append(t);var e=this._doFinalize();return e},blockSize:16,_createHelper:function(t){return function(e,n){return new t.init(n).finalize(e)}},_createHmacHelper:function(t){return function(e,n){return new h.HMAC.init(t,n).finalize(e)}}}),n.algo={});return n}(Math);!function(t){var e=sr,n=e.lib,r=n.Base,i=n.WordArray,e=e.x64={};e.Word=r.extend({init:function(t,e){this.high=t,this.low=e}}),e.WordArray=r.extend({init:function(e,n){e=this.words=e||[],this.sigBytes=n!=t?n:8*e.length},toX32:function(){for(var t=this.words,e=t.length,n=[],r=0;e>r;r++){var s=t[r];n.push(s.high),n.push(s.low)}return i.create(n,this.sigBytes)},clone:function(){for(var t=r.clone.call(this),e=t.words=this.words.slice(0),n=e.length,i=0;n>i;i++)e[i]=e[i].clone();return t}})}(),sr.lib.Cipher||function(t){var e=sr,n=e.lib,r=n.Base,i=n.WordArray,s=n.BufferedBlockAlgorithm,o=e.enc.Base64,a=e.algo.EvpKDF,u=n.Cipher=s.extend({cfg:r.extend(),createEncryptor:function(t,e){return this.create(this._ENC_XFORM_MODE,t,e)},createDecryptor:function(t,e){return this.create(this._DEC_XFORM_MODE,t,e)},init:function(t,e,n){this.cfg=this.cfg.extend(n),this._xformMode=t,this._key=e,this.reset()},reset:function(){s.reset.call(this),this._doReset()},process:function(t){return this._append(t),this._process()},finalize:function(t){return t&&this._append(t),this._doFinalize()},keySize:4,ivSize:4,_ENC_XFORM_MODE:1,_DEC_XFORM_MODE:2,_createHelper:function(t){return{encrypt:function(e,n,r){return("string"==typeof n?p:d).encrypt(t,e,n,r)},decrypt:function(e,n,r){return("string"==typeof n?p:d).decrypt(t,e,n,r)}}}});n.StreamCipher=u.extend({_doFinalize:function(){return this._process(!0)},blockSize:1});var c=e.mode={},f=function(e,n,r){var i=this._iv;i?this._iv=t:i=this._prevBlock;for(var s=0;r>s;s++)e[n+s]^=i[s]},h=(n.BlockCipherMode=r.extend({createEncryptor:function(t,e){return this.Encryptor.create(t,e)},createDecryptor:function(t,e){return this.Decryptor.create(t,e)},init:function(t,e){this._cipher=t,this._iv=e}})).extend();h.Encryptor=h.extend({processBlock:function(t,e){var n=this._cipher,r=n.blockSize;f.call(this,t,e,r),n.encryptBlock(t,e),this._prevBlock=t.slice(e,e+r)}}),h.Decryptor=h.extend({processBlock:function(t,e){var n=this._cipher,r=n.blockSize,i=t.slice(e,e+r);n.decryptBlock(t,e),f.call(this,t,e,r),this._prevBlock=i}}),c=c.CBC=h,h=(e.pad={}).Pkcs7={pad:function(t,e){for(var n=4*e,n=n-t.sigBytes%n,r=n<<24|n<<16|n<<8|n,s=[],o=0;n>o;o+=4)s.push(r);n=i.create(s,n),t.concat(n)},unpad:function(t){t.sigBytes-=255&t.words[t.sigBytes-1>>>2]}},n.BlockCipher=u.extend({cfg:u.cfg.extend({mode:c,padding:h}),reset:function(){u.reset.call(this);var t=this.cfg,e=t.iv,t=t.mode;if(this._xformMode==this._ENC_XFORM_MODE)var n=t.createEncryptor;else n=t.createDecryptor,this._minBufferSize=1;this._mode=n.call(t,this,e&&e.words)},_doProcessBlock:function(t,e){this._mode.processBlock(t,e)},_doFinalize:function(){var t=this.cfg.padding;if(this._xformMode==this._ENC_XFORM_MODE){t.pad(this._data,this.blockSize);var e=this._process(!0)}else e=this._process(!0),t.unpad(e);return e},blockSize:4});var l=n.CipherParams=r.extend({init:function(t){this.mixIn(t)},toString:function(t){return(t||this.formatter).stringify(this)}}),c=(e.format={}).OpenSSL={stringify:function(t){var e=t.ciphertext;return t=t.salt,(t?i.create([1398893684,1701076831]).concat(t).concat(e):e).toString(o)},parse:function(t){t=o.parse(t);var e=t.words;if(1398893684==e[0]&&1701076831==e[1]){var n=i.create(e.slice(2,4));e.splice(0,4),t.sigBytes-=16}return l.create({ciphertext:t,salt:n})}},d=n.SerializableCipher=r.extend({cfg:r.extend({format:c}),encrypt:function(t,e,n,r){r=this.cfg.extend(r);var i=t.createEncryptor(n,r);return e=i.finalize(e),i=i.cfg,l.create({ciphertext:e,key:n,iv:i.iv,algorithm:t,mode:i.mode,padding:i.padding,blockSize:t.blockSize,formatter:r.format})},decrypt:function(t,e,n,r){return r=this.cfg.extend(r),e=this._parse(e,r.format),t.createDecryptor(n,r).finalize(e.ciphertext)},_parse:function(t,e){return"string"==typeof t?e.parse(t,this):t}}),e=(e.kdf={}).OpenSSL={execute:function(t,e,n,r){return r||(r=i.random(8)),t=a.create({keySize:e+n}).compute(t,r),n=i.create(t.words.slice(e),4*n),t.sigBytes=4*e,l.create({key:t,iv:n,salt:r})}},p=n.PasswordBasedCipher=d.extend({cfg:d.cfg.extend({kdf:e}),encrypt:function(t,e,n,r){return r=this.cfg.extend(r),n=r.kdf.execute(n,t.keySize,t.ivSize),r.iv=n.iv,t=d.encrypt.call(this,t,e,n.key,r),t.mixIn(n),t},decrypt:function(t,e,n,r){return r=this.cfg.extend(r),e=this._parse(e,r.format),n=r.kdf.execute(n,t.keySize,t.ivSize,e.salt),r.iv=n.iv,d.decrypt.call(this,t,e,n.key,r)}})}(),function(){for(var t=sr,e=t.lib.BlockCipher,n=t.algo,r=[],i=[],s=[],o=[],a=[],u=[],c=[],f=[],h=[],l=[],d=[],p=0;256>p;p++)d[p]=128>p?p<<1:p<<1^283;for(var g=0,y=0,p=0;256>p;p++){var v=y^y<<1^y<<2^y<<3^y<<4,v=v>>>8^255&v^99;r[g]=v,i[v]=g;var m=d[g],S=d[m],b=d[S],w=257*d[v]^16843008*v;s[g]=w<<24|w>>>8,o[g]=w<<16|w>>>16,a[g]=w<<8|w>>>24,u[g]=w,w=16843009*b^65537*S^257*m^16843008*g,c[v]=w<<24|w>>>8,f[v]=w<<16|w>>>16,h[v]=w<<8|w>>>24,l[v]=w,g?(g=m^d[d[d[b^m]]],y^=d[d[y]]):g=y=1}var E=[0,1,2,4,8,16,32,64,128,27,54],n=n.AES=e.extend({_doReset:function(){for(var t=this._key,e=t.words,n=t.sigBytes/4,t=4*((this._nRounds=n+6)+1),i=this._keySchedule=[],s=0;t>s;s++)if(n>s)i[s]=e[s];else{var o=i[s-1];s%n?n>6&&4==s%n&&(o=r[o>>>24]<<24|r[o>>>16&255]<<16|r[o>>>8&255]<<8|r[255&o]):(o=o<<8|o>>>24,o=r[o>>>24]<<24|r[o>>>16&255]<<16|r[o>>>8&255]<<8|r[255&o],o^=E[s/n|0]<<24),i[s]=i[s-n]^o}for(e=this._invKeySchedule=[],n=0;t>n;n++)s=t-n,o=n%4?i[s]:i[s-4],e[n]=4>n||4>=s?o:c[r[o>>>24]]^f[r[o>>>16&255]]^h[r[o>>>8&255]]^l[r[255&o]]},encryptBlock:function(t,e){this._doCryptBlock(t,e,this._keySchedule,s,o,a,u,r)},decryptBlock:function(t,e){var n=t[e+1];t[e+1]=t[e+3],t[e+3]=n,this._doCryptBlock(t,e,this._invKeySchedule,c,f,h,l,i),n=t[e+1],t[e+1]=t[e+3],t[e+3]=n},_doCryptBlock:function(t,e,n,r,i,s,o,a){for(var u=this._nRounds,c=t[e]^n[0],f=t[e+1]^n[1],h=t[e+2]^n[2],l=t[e+3]^n[3],d=4,p=1;u>p;p++)var g=r[c>>>24]^i[f>>>16&255]^s[h>>>8&255]^o[255&l]^n[d++],y=r[f>>>24]^i[h>>>16&255]^s[l>>>8&255]^o[255&c]^n[d++],v=r[h>>>24]^i[l>>>16&255]^s[c>>>8&255]^o[255&f]^n[d++],l=r[l>>>24]^i[c>>>16&255]^s[f>>>8&255]^o[255&h]^n[d++],c=g,f=y,h=v;g=(a[c>>>24]<<24|a[f>>>16&255]<<16|a[h>>>8&255]<<8|a[255&l])^n[d++],y=(a[f>>>24]<<24|a[h>>>16&255]<<16|a[l>>>8&255]<<8|a[255&c])^n[d++],v=(a[h>>>24]<<24|a[l>>>16&255]<<16|a[c>>>8&255]<<8|a[255&f])^n[d++],l=(a[l>>>24]<<24|a[c>>>16&255]<<16|a[f>>>8&255]<<8|a[255&h])^n[d++],t[e]=g,t[e+1]=y,t[e+2]=v,t[e+3]=l},keySize:8});t.AES=e._createHelper(n)}(),function(){function t(t,e){var n=(this._lBlock>>>t^this._rBlock)&e;this._rBlock^=n,this._lBlock^=n<<t}function e(t,e){var n=(this._rBlock>>>t^this._lBlock)&e;this._lBlock^=n,this._rBlock^=n<<t}var n=sr,r=n.lib,i=r.WordArray,r=r.BlockCipher,s=n.algo,o=[57,49,41,33,25,17,9,1,58,50,42,34,26,18,10,2,59,51,43,35,27,19,11,3,60,52,44,36,63,55,47,39,31,23,15,7,62,54,46,38,30,22,14,6,61,53,45,37,29,21,13,5,28,20,12,4],a=[14,17,11,24,1,5,3,28,15,6,21,10,23,19,12,4,26,8,16,7,27,20,13,2,41,52,31,37,47,55,30,40,51,45,33,48,44,49,39,56,34,53,46,42,50,36,29,32],u=[1,2,4,6,8,10,12,14,15,17,19,21,23,25,27,28],c=[{0:8421888,268435456:32768,536870912:8421378,805306368:2,1073741824:512,1342177280:8421890,1610612736:8389122,1879048192:8388608,2147483648:514,2415919104:8389120,2684354560:33280,2952790016:8421376,3221225472:32770,3489660928:8388610,3758096384:0,4026531840:33282,134217728:0,402653184:8421890,671088640:33282,939524096:32768,1207959552:8421888,1476395008:512,1744830464:8421378,2013265920:2,2281701376:8389120,2550136832:33280,2818572288:8421376,3087007744:8389122,3355443200:8388610,3623878656:32770,3892314112:514,4160749568:8388608,1:32768,268435457:2,536870913:8421888,805306369:8388608,1073741825:8421378,1342177281:33280,1610612737:512,1879048193:8389122,2147483649:8421890,2415919105:8421376,2684354561:8388610,2952790017:33282,3221225473:514,3489660929:8389120,3758096385:32770,4026531841:0,134217729:8421890,402653185:8421376,671088641:8388608,939524097:512,1207959553:32768,1476395009:8388610,1744830465:2,2013265921:33282,2281701377:32770,2550136833:8389122,2818572289:514,3087007745:8421888,3355443201:8389120,3623878657:0,3892314113:33280,4160749569:8421378},{0:1074282512,16777216:16384,33554432:524288,50331648:1074266128,67108864:1073741840,83886080:1074282496,100663296:1073758208,117440512:16,134217728:540672,150994944:1073758224,167772160:1073741824,184549376:540688,201326592:524304,218103808:0,234881024:16400,251658240:1074266112,8388608:1073758208,25165824:540688,41943040:16,58720256:1073758224,75497472:1074282512,92274688:1073741824,109051904:524288,125829120:1074266128,142606336:524304,159383552:0,176160768:16384,192937984:1074266112,209715200:1073741840,226492416:540672,243269632:1074282496,260046848:16400,268435456:0,285212672:1074266128,301989888:1073758224,318767104:1074282496,335544320:1074266112,352321536:16,369098752:540688,385875968:16384,402653184:16400,419430400:524288,436207616:524304,452984832:1073741840,469762048:540672,486539264:1073758208,503316480:1073741824,520093696:1074282512,276824064:540688,293601280:524288,310378496:1074266112,327155712:16384,343932928:1073758208,360710144:1074282512,377487360:16,394264576:1073741824,411041792:1074282496,427819008:1073741840,444596224:1073758224,461373440:524304,478150656:0,494927872:16400,511705088:1074266128,528482304:540672},{0:260,1048576:0,2097152:67109120,3145728:65796,4194304:65540,5242880:67108868,6291456:67174660,7340032:67174400,8388608:67108864,9437184:67174656,10485760:65792,11534336:67174404,12582912:67109124,13631488:65536,14680064:4,15728640:256,524288:67174656,1572864:67174404,2621440:0,3670016:67109120,4718592:67108868,5767168:65536,6815744:65540,7864320:260,8912896:4,9961472:256,11010048:67174400,12058624:65796,13107200:65792,14155776:67109124,15204352:67174660,16252928:67108864,16777216:67174656,17825792:65540,18874368:65536,19922944:67109120,20971520:256,22020096:67174660,23068672:67108868,24117248:0,25165824:67109124,26214400:67108864,27262976:4,28311552:65792,29360128:67174400,30408704:260,31457280:65796,32505856:67174404,17301504:67108864,18350080:260,19398656:67174656,20447232:0,21495808:65540,22544384:67109120,23592960:256,24641536:67174404,25690112:65536,26738688:67174660,27787264:65796,28835840:67108868,29884416:67109124,30932992:67174400,31981568:4,33030144:65792},{0:2151682048,65536:2147487808,131072:4198464,196608:2151677952,262144:0,327680:4198400,393216:2147483712,458752:4194368,524288:2147483648,589824:4194304,655360:64,720896:2147487744,786432:2151678016,851968:4160,917504:4096,983040:2151682112,32768:2147487808,98304:64,163840:2151678016,229376:2147487744,294912:4198400,360448:2151682112,425984:0,491520:2151677952,557056:4096,622592:2151682048,688128:4194304,753664:4160,819200:2147483648,884736:4194368,950272:4198464,1015808:2147483712,1048576:4194368,1114112:4198400,1179648:2147483712,1245184:0,1310720:4160,1376256:2151678016,1441792:2151682048,1507328:2147487808,1572864:2151682112,1638400:2147483648,1703936:2151677952,1769472:4198464,1835008:2147487744,1900544:4194304,1966080:64,2031616:4096,1081344:2151677952,1146880:2151682112,1212416:0,1277952:4198400,1343488:4194368,1409024:2147483648,1474560:2147487808,1540096:64,1605632:2147483712,1671168:4096,1736704:2147487744,1802240:2151678016,1867776:4160,1933312:2151682048,1998848:4194304,2064384:4198464},{0:128,4096:17039360,8192:262144,12288:536870912,16384:537133184,20480:16777344,24576:553648256,28672:262272,32768:16777216,36864:537133056,40960:536871040,45056:553910400,49152:553910272,53248:0,57344:17039488,61440:553648128,2048:17039488,6144:553648256,10240:128,14336:17039360,18432:262144,22528:537133184,26624:553910272,30720:536870912,34816:537133056,38912:0,43008:553910400,47104:16777344,51200:536871040,55296:553648128,59392:16777216,63488:262272,65536:262144,69632:128,73728:536870912,77824:553648256,81920:16777344,86016:553910272,90112:537133184,94208:16777216,98304:553910400,102400:553648128,106496:17039360,110592:537133056,114688:262272,118784:536871040,122880:0,126976:17039488,67584:553648256,71680:16777216,75776:17039360,79872:537133184,83968:536870912,88064:17039488,92160:128,96256:553910272,100352:262272,104448:553910400,108544:0,112640:553648128,116736:16777344,120832:262144,124928:537133056,129024:536871040},{0:268435464,256:8192,512:270532608,768:270540808,1024:268443648,1280:2097152,1536:2097160,1792:268435456,2048:0,2304:268443656,2560:2105344,2816:8,3072:270532616,3328:2105352,3584:8200,3840:270540800,128:270532608,384:270540808,640:8,896:2097152,1152:2105352,1408:268435464,1664:268443648,1920:8200,2176:2097160,2432:8192,2688:268443656,2944:270532616,3200:0,3456:270540800,3712:2105344,3968:268435456,4096:268443648,4352:270532616,4608:270540808,4864:8200,5120:2097152,5376:268435456,5632:268435464,5888:2105344,6144:2105352,6400:0,6656:8,6912:270532608,7168:8192,7424:268443656,7680:270540800,7936:2097160,4224:8,4480:2105344,4736:2097152,4992:268435464,5248:268443648,5504:8200,5760:270540808,6016:270532608,6272:270540800,6528:270532616,6784:8192,7040:2105352,7296:2097160,7552:0,7808:268435456,8064:268443656},{0:1048576,16:33555457,32:1024,48:1049601,64:34604033,80:0,96:1,112:34603009,128:33555456,144:1048577,160:33554433,176:34604032,192:34603008,208:1025,224:1049600,240:33554432,8:34603009,24:0,40:33555457,56:34604032,72:1048576,88:33554433,104:33554432,120:1025,136:1049601,152:33555456,168:34603008,184:1048577,200:1024,216:34604033,232:1,248:1049600,256:33554432,272:1048576,288:33555457,304:34603009,320:1048577,336:33555456,352:34604032,368:1049601,384:1025,400:34604033,416:1049600,432:1,448:0,464:34603008,480:33554433,496:1024,264:1049600,280:33555457,296:34603009,312:1,328:33554432,344:1048576,360:1025,376:34604032,392:33554433,408:34603008,424:0,440:34604033,456:1049601,472:1024,488:33555456,504:1048577},{0:134219808,1:131072,2:134217728,3:32,4:131104,5:134350880,6:134350848,7:2048,8:134348800,9:134219776,10:133120,11:134348832,12:2080,13:0,14:134217760,15:133152,2147483648:2048,2147483649:134350880,2147483650:134219808,2147483651:134217728,2147483652:134348800,2147483653:133120,2147483654:133152,2147483655:32,2147483656:134217760,2147483657:2080,2147483658:131104,2147483659:134350848,2147483660:0,2147483661:134348832,2147483662:134219776,2147483663:131072,16:133152,17:134350848,18:32,19:2048,20:134219776,21:134217760,22:134348832,23:131072,24:0,25:131104,26:134348800,27:134219808,28:134350880,29:133120,30:2080,31:134217728,2147483664:131072,2147483665:2048,2147483666:134348832,2147483667:133152,2147483668:32,2147483669:134348800,2147483670:134217728,2147483671:134219808,2147483672:134350880,2147483673:134217760,2147483674:134219776,2147483675:0,2147483676:133120,2147483677:2080,2147483678:131104,2147483679:134350848}],f=[4160749569,528482304,33030144,2064384,129024,8064,504,2147483679],h=s.DES=r.extend({_doReset:function(){for(var t=this._key.words,e=[],n=0;56>n;n++){var r=o[n]-1;e[n]=t[r>>>5]>>>31-r%32&1}for(t=this._subKeys=[],r=0;16>r;r++){for(var i=t[r]=[],s=u[r],n=0;24>n;n++)i[n/6|0]|=e[(a[n]-1+s)%28]<<31-n%6,i[4+(n/6|0)]|=e[28+(a[n+24]-1+s)%28]<<31-n%6;for(i[0]=i[0]<<1|i[0]>>>31,n=1;7>n;n++)i[n]>>>=4*(n-1)+3;i[7]=i[7]<<5|i[7]>>>27}for(e=this._invSubKeys=[],n=0;16>n;n++)e[n]=t[15-n]},encryptBlock:function(t,e){this._doCryptBlock(t,e,this._subKeys)},decryptBlock:function(t,e){this._doCryptBlock(t,e,this._invSubKeys)},_doCryptBlock:function(n,r,i){this._lBlock=n[r],this._rBlock=n[r+1],t.call(this,4,252645135),t.call(this,16,65535),e.call(this,2,858993459),e.call(this,8,16711935),t.call(this,1,1431655765);for(var s=0;16>s;s++){for(var o=i[s],a=this._lBlock,u=this._rBlock,h=0,l=0;8>l;l++)h|=c[l][((u^o[l])&f[l])>>>0];this._lBlock=u,this._rBlock=a^h}i=this._lBlock,this._lBlock=this._rBlock,this._rBlock=i,t.call(this,1,1431655765),e.call(this,8,16711935),e.call(this,2,858993459),t.call(this,16,65535),t.call(this,4,252645135),n[r]=this._lBlock,n[r+1]=this._rBlock},keySize:2,ivSize:2,blockSize:2});n.DES=r._createHelper(h),s=s.TripleDES=r.extend({_doReset:function(){var t=this._key.words;this._des1=h.createEncryptor(i.create(t.slice(0,2))),this._des2=h.createEncryptor(i.create(t.slice(2,4))),this._des3=h.createEncryptor(i.create(t.slice(4,6)))},encryptBlock:function(t,e){this._des1.encryptBlock(t,e),this._des2.decryptBlock(t,e),this._des3.encryptBlock(t,e)},decryptBlock:function(t,e){this._des3.decryptBlock(t,e),this._des2.encryptBlock(t,e),this._des1.decryptBlock(t,e)},keySize:6,ivSize:2,blockSize:2}),n.TripleDES=r._createHelper(s)}(),function(){var t=sr,e=t.lib.WordArray;t.enc.Base64={stringify:function(t){var e=t.words,n=t.sigBytes,r=this._map;t.clamp(),t=[];for(var i=0;n>i;i+=3)for(var s=(e[i>>>2]>>>24-8*(i%4)&255)<<16|(e[i+1>>>2]>>>24-8*((i+1)%4)&255)<<8|e[i+2>>>2]>>>24-8*((i+2)%4)&255,o=0;4>o&&n>i+.75*o;o++)t.push(r.charAt(s>>>6*(3-o)&63));if(e=r.charAt(64))for(;t.length%4;)t.push(e);return t.join("")},parse:function(t){var n=t.length,r=this._map,i=r.charAt(64);i&&(i=t.indexOf(i),-1!=i&&(n=i));for(var i=[],s=0,o=0;n>o;o++)if(o%4){var a=r.indexOf(t.charAt(o-1))<<2*(o%4),u=r.indexOf(t.charAt(o))>>>6-2*(o%4);i[s>>>2]|=(a|u)<<24-8*(s%4),s++}return e.create(i,s)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="}}(),function(t){function e(t,e,n,r,i,s,o){return t=t+(e&n|~e&r)+i+o,(t<<s|t>>>32-s)+e}function n(t,e,n,r,i,s,o){return t=t+(e&r|n&~r)+i+o,(t<<s|t>>>32-s)+e}function r(t,e,n,r,i,s,o){return t=t+(e^n^r)+i+o,(t<<s|t>>>32-s)+e}function i(t,e,n,r,i,s,o){return t=t+(n^(e|~r))+i+o,(t<<s|t>>>32-s)+e}for(var s=sr,o=s.lib,a=o.WordArray,u=o.Hasher,o=s.algo,c=[],f=0;64>f;f++)c[f]=4294967296*t.abs(t.sin(f+1))|0;o=o.MD5=u.extend({_doReset:function(){this._hash=new a.init([1732584193,4023233417,2562383102,271733878])},_doProcessBlock:function(t,s){for(var o=0;16>o;o++){var a=s+o,u=t[a];t[a]=16711935&(u<<8|u>>>24)|4278255360&(u<<24|u>>>8)}var o=this._hash.words,a=t[s+0],u=t[s+1],f=t[s+2],h=t[s+3],l=t[s+4],d=t[s+5],p=t[s+6],g=t[s+7],y=t[s+8],v=t[s+9],m=t[s+10],S=t[s+11],b=t[s+12],w=t[s+13],E=t[s+14],x=t[s+15],_=o[0],R=o[1],A=o[2],F=o[3],_=e(_,R,A,F,a,7,c[0]),F=e(F,_,R,A,u,12,c[1]),A=e(A,F,_,R,f,17,c[2]),R=e(R,A,F,_,h,22,c[3]),_=e(_,R,A,F,l,7,c[4]),F=e(F,_,R,A,d,12,c[5]),A=e(A,F,_,R,p,17,c[6]),R=e(R,A,F,_,g,22,c[7]),_=e(_,R,A,F,y,7,c[8]),F=e(F,_,R,A,v,12,c[9]),A=e(A,F,_,R,m,17,c[10]),R=e(R,A,F,_,S,22,c[11]),_=e(_,R,A,F,b,7,c[12]),F=e(F,_,R,A,w,12,c[13]),A=e(A,F,_,R,E,17,c[14]),R=e(R,A,F,_,x,22,c[15]),_=n(_,R,A,F,u,5,c[16]),F=n(F,_,R,A,p,9,c[17]),A=n(A,F,_,R,S,14,c[18]),R=n(R,A,F,_,a,20,c[19]),_=n(_,R,A,F,d,5,c[20]),F=n(F,_,R,A,m,9,c[21]),A=n(A,F,_,R,x,14,c[22]),R=n(R,A,F,_,l,20,c[23]),_=n(_,R,A,F,v,5,c[24]),F=n(F,_,R,A,E,9,c[25]),A=n(A,F,_,R,h,14,c[26]),R=n(R,A,F,_,y,20,c[27]),_=n(_,R,A,F,w,5,c[28]),F=n(F,_,R,A,f,9,c[29]),A=n(A,F,_,R,g,14,c[30]),R=n(R,A,F,_,b,20,c[31]),_=r(_,R,A,F,d,4,c[32]),F=r(F,_,R,A,y,11,c[33]),A=r(A,F,_,R,S,16,c[34]),R=r(R,A,F,_,E,23,c[35]),_=r(_,R,A,F,u,4,c[36]),F=r(F,_,R,A,l,11,c[37]),A=r(A,F,_,R,g,16,c[38]),R=r(R,A,F,_,m,23,c[39]),_=r(_,R,A,F,w,4,c[40]),F=r(F,_,R,A,a,11,c[41]),A=r(A,F,_,R,h,16,c[42]),R=r(R,A,F,_,p,23,c[43]),_=r(_,R,A,F,v,4,c[44]),F=r(F,_,R,A,b,11,c[45]),A=r(A,F,_,R,x,16,c[46]),R=r(R,A,F,_,f,23,c[47]),_=i(_,R,A,F,a,6,c[48]),F=i(F,_,R,A,g,10,c[49]),A=i(A,F,_,R,E,15,c[50]),R=i(R,A,F,_,d,21,c[51]),_=i(_,R,A,F,b,6,c[52]),F=i(F,_,R,A,h,10,c[53]),A=i(A,F,_,R,m,15,c[54]),R=i(R,A,F,_,u,21,c[55]),_=i(_,R,A,F,y,6,c[56]),F=i(F,_,R,A,x,10,c[57]),A=i(A,F,_,R,p,15,c[58]),R=i(R,A,F,_,w,21,c[59]),_=i(_,R,A,F,l,6,c[60]),F=i(F,_,R,A,S,10,c[61]),A=i(A,F,_,R,f,15,c[62]),R=i(R,A,F,_,v,21,c[63]);o[0]=o[0]+_|0,o[1]=o[1]+R|0,o[2]=o[2]+A|0,o[3]=o[3]+F|0},_doFinalize:function(){var e=this._data,n=e.words,r=8*this._nDataBytes,i=8*e.sigBytes;n[i>>>5]|=128<<24-i%32;var s=t.floor(r/4294967296);for(n[(i+64>>>9<<4)+15]=16711935&(s<<8|s>>>24)|4278255360&(s<<24|s>>>8),n[(i+64>>>9<<4)+14]=16711935&(r<<8|r>>>24)|4278255360&(r<<24|r>>>8),e.sigBytes=4*(n.length+1),this._process(),e=this._hash,n=e.words,r=0;4>r;r++)i=n[r],n[r]=16711935&(i<<8|i>>>24)|4278255360&(i<<24|i>>>8);return e},clone:function(){var t=u.clone.call(this);return t._hash=this._hash.clone(),t}}),s.MD5=u._createHelper(o),s.HmacMD5=u._createHmacHelper(o)}(Math),function(){var t=sr,e=t.lib,n=e.WordArray,r=e.Hasher,i=[],e=t.algo.SHA1=r.extend({_doReset:function(){this._hash=new n.init([1732584193,4023233417,2562383102,271733878,3285377520])},_doProcessBlock:function(t,e){for(var n=this._hash.words,r=n[0],s=n[1],o=n[2],a=n[3],u=n[4],c=0;80>c;c++){if(16>c)i[c]=0|t[e+c];else{var f=i[c-3]^i[c-8]^i[c-14]^i[c-16];i[c]=f<<1|f>>>31}f=(r<<5|r>>>27)+u+i[c],f=20>c?f+((s&o|~s&a)+1518500249):40>c?f+((s^o^a)+1859775393):60>c?f+((s&o|s&a|o&a)-1894007588):f+((s^o^a)-899497514),u=a,a=o,o=s<<30|s>>>2,s=r,r=f}n[0]=n[0]+r|0,n[1]=n[1]+s|0,n[2]=n[2]+o|0,n[3]=n[3]+a|0,n[4]=n[4]+u|0},_doFinalize:function(){var t=this._data,e=t.words,n=8*this._nDataBytes,r=8*t.sigBytes;return e[r>>>5]|=128<<24-r%32,e[(r+64>>>9<<4)+14]=Math.floor(n/4294967296),e[(r+64>>>9<<4)+15]=n,t.sigBytes=4*e.length,this._process(),this._hash},clone:function(){var t=r.clone.call(this);return t._hash=this._hash.clone(),t}});t.SHA1=r._createHelper(e),t.HmacSHA1=r._createHmacHelper(e)}(),function(t){for(var e=sr,n=e.lib,r=n.WordArray,i=n.Hasher,n=e.algo,s=[],o=[],a=function(t){return 4294967296*(t-(0|t))|0},u=2,c=0;64>c;){var f;t:{f=u;for(var h=t.sqrt(f),l=2;h>=l;l++)if(!(f%l)){f=!1;break t}f=!0}f&&(8>c&&(s[c]=a(t.pow(u,.5))),o[c]=a(t.pow(u,1/3)),c++),u++}var d=[],n=n.SHA256=i.extend({_doReset:function(){this._hash=new r.init(s.slice(0))},_doProcessBlock:function(t,e){for(var n=this._hash.words,r=n[0],i=n[1],s=n[2],a=n[3],u=n[4],c=n[5],f=n[6],h=n[7],l=0;64>l;l++){if(16>l)d[l]=0|t[e+l];else{var p=d[l-15],g=d[l-2];d[l]=((p<<25|p>>>7)^(p<<14|p>>>18)^p>>>3)+d[l-7]+((g<<15|g>>>17)^(g<<13|g>>>19)^g>>>10)+d[l-16]}p=h+((u<<26|u>>>6)^(u<<21|u>>>11)^(u<<7|u>>>25))+(u&c^~u&f)+o[l]+d[l],g=((r<<30|r>>>2)^(r<<19|r>>>13)^(r<<10|r>>>22))+(r&i^r&s^i&s),h=f,f=c,c=u,u=a+p|0,a=s,s=i,i=r,r=p+g|0}n[0]=n[0]+r|0,n[1]=n[1]+i|0,n[2]=n[2]+s|0,n[3]=n[3]+a|0,n[4]=n[4]+u|0,n[5]=n[5]+c|0,n[6]=n[6]+f|0,n[7]=n[7]+h|0},_doFinalize:function(){var e=this._data,n=e.words,r=8*this._nDataBytes,i=8*e.sigBytes;return n[i>>>5]|=128<<24-i%32,n[(i+64>>>9<<4)+14]=t.floor(r/4294967296),n[(i+64>>>9<<4)+15]=r,e.sigBytes=4*n.length,this._process(),this._hash},clone:function(){var t=i.clone.call(this);return t._hash=this._hash.clone(),t}});e.SHA256=i._createHelper(n),e.HmacSHA256=i._createHmacHelper(n)}(Math),function(){var t=sr,e=t.lib.WordArray,n=t.algo,r=n.SHA256,n=n.SHA224=r.extend({_doReset:function(){this._hash=new e.init([3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428])},_doFinalize:function(){var t=r._doFinalize.call(this);return t.sigBytes-=4,t}});t.SHA224=r._createHelper(n),t.HmacSHA224=r._createHmacHelper(n)}(),function(){function t(){return i.create.apply(i,arguments)}for(var e=sr,n=e.lib.Hasher,r=e.x64,i=r.Word,s=r.WordArray,r=e.algo,o=[t(1116352408,3609767458),t(1899447441,602891725),t(3049323471,3964484399),t(3921009573,2173295548),t(961987163,4081628472),t(1508970993,3053834265),t(2453635748,2937671579),t(2870763221,3664609560),t(3624381080,2734883394),t(310598401,1164996542),t(607225278,1323610764),t(1426881987,3590304994),t(1925078388,4068182383),t(2162078206,991336113),t(2614888103,633803317),t(3248222580,3479774868),t(3835390401,2666613458),t(4022224774,944711139),t(264347078,2341262773),t(604807628,2007800933),t(770255983,1495990901),t(1249150122,1856431235),t(1555081692,3175218132),t(1996064986,2198950837),t(2554220882,3999719339),t(2821834349,766784016),t(2952996808,2566594879),t(3210313671,3203337956),t(3336571891,1034457026),t(3584528711,2466948901),t(113926993,3758326383),t(338241895,168717936),t(666307205,1188179964),t(773529912,1546045734),t(1294757372,1522805485),t(1396182291,2643833823),t(1695183700,2343527390),t(1986661051,1014477480),t(2177026350,1206759142),t(2456956037,344077627),t(2730485921,1290863460),t(2820302411,3158454273),t(3259730800,3505952657),t(3345764771,106217008),t(3516065817,3606008344),t(3600352804,1432725776),t(4094571909,1467031594),t(275423344,851169720),t(430227734,3100823752),t(506948616,1363258195),t(659060556,3750685593),t(883997877,3785050280),t(958139571,3318307427),t(1322822218,3812723403),t(1537002063,2003034995),t(1747873779,3602036899),t(1955562222,1575990012),t(2024104815,1125592928),t(2227730452,2716904306),t(2361852424,442776044),t(2428436474,593698344),t(2756734187,3733110249),t(3204031479,2999351573),t(3329325298,3815920427),t(3391569614,3928383900),t(3515267271,566280711),t(3940187606,3454069534),t(4118630271,4000239992),t(116418474,1914138554),t(174292421,2731055270),t(289380356,3203993006),t(460393269,320620315),t(685471733,587496836),t(852142971,1086792851),t(1017036298,365543100),t(1126000580,2618297676),t(1288033470,3409855158),t(1501505948,4234509866),t(1607167915,987167468),t(1816402316,1246189591)],a=[],u=0;80>u;u++)a[u]=t();r=r.SHA512=n.extend({_doReset:function(){this._hash=new s.init([new i.init(1779033703,4089235720),new i.init(3144134277,2227873595),new i.init(1013904242,4271175723),new i.init(2773480762,1595750129),new i.init(1359893119,2917565137),new i.init(2600822924,725511199),new i.init(528734635,4215389547),new i.init(1541459225,327033209)])},_doProcessBlock:function(t,e){for(var n=this._hash.words,r=n[0],i=n[1],s=n[2],u=n[3],c=n[4],f=n[5],h=n[6],n=n[7],l=r.high,d=r.low,p=i.high,g=i.low,y=s.high,v=s.low,m=u.high,S=u.low,b=c.high,w=c.low,E=f.high,x=f.low,_=h.high,R=h.low,A=n.high,F=n.low,K=l,P=d,U=p,O=g,C=y,I=v,j=m,T=S,D=b,J=w,H=E,B=x,k=_,N=R,M=A,V=F,L=0;80>L;L++){var q=a[L];if(16>L)var W=q.high=0|t[e+2*L],z=q.low=0|t[e+2*L+1];else{var W=a[L-15],z=W.high,Y=W.low,W=(z>>>1|Y<<31)^(z>>>8|Y<<24)^z>>>7,Y=(Y>>>1|z<<31)^(Y>>>8|z<<24)^(Y>>>7|z<<25),G=a[L-2],z=G.high,X=G.low,G=(z>>>19|X<<13)^(z<<3|X>>>29)^z>>>6,X=(X>>>19|z<<13)^(X<<3|z>>>29)^(X>>>6|z<<26),z=a[L-7],$=z.high,Z=a[L-16],Q=Z.high,Z=Z.low,z=Y+z.low,W=W+$+(Y>>>0>z>>>0?1:0),z=z+X,W=W+G+(X>>>0>z>>>0?1:0),z=z+Z,W=W+Q+(Z>>>0>z>>>0?1:0);q.high=W,q.low=z}var $=D&H^~D&k,Z=J&B^~J&N,q=K&U^K&C^U&C,tt=P&O^P&I^O&I,Y=(K>>>28|P<<4)^(K<<30|P>>>2)^(K<<25|P>>>7),G=(P>>>28|K<<4)^(P<<30|K>>>2)^(P<<25|K>>>7),X=o[L],et=X.high,nt=X.low,X=V+((J>>>14|D<<18)^(J>>>18|D<<14)^(J<<23|D>>>9)),Q=M+((D>>>14|J<<18)^(D>>>18|J<<14)^(D<<23|J>>>9))+(V>>>0>X>>>0?1:0),X=X+Z,Q=Q+$+(Z>>>0>X>>>0?1:0),X=X+nt,Q=Q+et+(nt>>>0>X>>>0?1:0),X=X+z,Q=Q+W+(z>>>0>X>>>0?1:0),z=G+tt,q=Y+q+(G>>>0>z>>>0?1:0),M=k,V=N,k=H,N=B,H=D,B=J,J=T+X|0,D=j+Q+(T>>>0>J>>>0?1:0)|0,j=C,T=I,C=U,I=O,U=K,O=P,P=X+z|0,K=Q+q+(X>>>0>P>>>0?1:0)|0}d=r.low=d+P,r.high=l+K+(P>>>0>d>>>0?1:0),g=i.low=g+O,i.high=p+U+(O>>>0>g>>>0?1:0),v=s.low=v+I,s.high=y+C+(I>>>0>v>>>0?1:0),S=u.low=S+T,u.high=m+j+(T>>>0>S>>>0?1:0),w=c.low=w+J,c.high=b+D+(J>>>0>w>>>0?1:0),x=f.low=x+B,f.high=E+H+(B>>>0>x>>>0?1:0),R=h.low=R+N,h.high=_+k+(N>>>0>R>>>0?1:0),F=n.low=F+V,n.high=A+M+(V>>>0>F>>>0?1:0)},_doFinalize:function(){var t=this._data,e=t.words,n=8*this._nDataBytes,r=8*t.sigBytes;return e[r>>>5]|=128<<24-r%32,e[(r+128>>>10<<5)+30]=Math.floor(n/4294967296),e[(r+128>>>10<<5)+31]=n,t.sigBytes=4*e.length,this._process(),this._hash.toX32()},clone:function(){var t=n.clone.call(this);return t._hash=this._hash.clone(),t},blockSize:32}),e.SHA512=n._createHelper(r),e.HmacSHA512=n._createHmacHelper(r)}(),function(){var t=sr,e=t.x64,n=e.Word,r=e.WordArray,e=t.algo,i=e.SHA512,e=e.SHA384=i.extend({_doReset:function(){this._hash=new r.init([new n.init(3418070365,3238371032),new n.init(1654270250,914150663),new n.init(2438529370,812702999),new n.init(355462360,4144912697),new n.init(1731405415,4290775857),new n.init(2394180231,1750603025),new n.init(3675008525,1694076839),new n.init(1203062813,3204075428)])},_doFinalize:function(){var t=i._doFinalize.call(this);return t.sigBytes-=16,t}});t.SHA384=i._createHelper(e),t.HmacSHA384=i._createHmacHelper(e)}(),function(){var t=sr,e=t.lib,n=e.WordArray,r=e.Hasher,e=t.algo,i=n.create([0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13]),s=n.create([5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11]),o=n.create([11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6]),a=n.create([8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11]),u=n.create([0,1518500249,1859775393,2400959708,2840853838]),c=n.create([1352829926,1548603684,1836072691,2053994217,0]),e=e.RIPEMD160=r.extend({_doReset:function(){this._hash=n.create([1732584193,4023233417,2562383102,271733878,3285377520])},_doProcessBlock:function(t,e){for(var n=0;16>n;n++){var r=e+n,f=t[r];
t[r]=16711935&(f<<8|f>>>24)|4278255360&(f<<24|f>>>8)}var h,l,d,p,g,y,v,m,S,b,r=this._hash.words,f=u.words,w=c.words,E=i.words,x=s.words,_=o.words,R=a.words;y=h=r[0],v=l=r[1],m=d=r[2],S=p=r[3],b=g=r[4];for(var A,n=0;80>n;n+=1)A=h+t[e+E[n]]|0,A=16>n?A+((l^d^p)+f[0]):32>n?A+((l&d|~l&p)+f[1]):48>n?A+(((l|~d)^p)+f[2]):64>n?A+((l&p|d&~p)+f[3]):A+((l^(d|~p))+f[4]),A|=0,A=A<<_[n]|A>>>32-_[n],A=A+g|0,h=g,g=p,p=d<<10|d>>>22,d=l,l=A,A=y+t[e+x[n]]|0,A=16>n?A+((v^(m|~S))+w[0]):32>n?A+((v&S|m&~S)+w[1]):48>n?A+(((v|~m)^S)+w[2]):64>n?A+((v&m|~v&S)+w[3]):A+((v^m^S)+w[4]),A|=0,A=A<<R[n]|A>>>32-R[n],A=A+b|0,y=b,b=S,S=m<<10|m>>>22,m=v,v=A;A=r[1]+d+S|0,r[1]=r[2]+p+b|0,r[2]=r[3]+g+y|0,r[3]=r[4]+h+v|0,r[4]=r[0]+l+m|0,r[0]=A},_doFinalize:function(){var t=this._data,e=t.words,n=8*this._nDataBytes,r=8*t.sigBytes;for(e[r>>>5]|=128<<24-r%32,e[(r+64>>>9<<4)+14]=16711935&(n<<8|n>>>24)|4278255360&(n<<24|n>>>8),t.sigBytes=4*(e.length+1),this._process(),t=this._hash,e=t.words,n=0;5>n;n++)r=e[n],e[n]=16711935&(r<<8|r>>>24)|4278255360&(r<<24|r>>>8);return t},clone:function(){var t=r.clone.call(this);return t._hash=this._hash.clone(),t}});t.RIPEMD160=r._createHelper(e),t.HmacRIPEMD160=r._createHmacHelper(e)}(Math),function(){var t=sr,e=t.enc.Utf8;t.algo.HMAC=t.lib.Base.extend({init:function(t,n){t=this._hasher=new t.init,"string"==typeof n&&(n=e.parse(n));var r=t.blockSize,i=4*r;n.sigBytes>i&&(n=t.finalize(n)),n.clamp();for(var s=this._oKey=n.clone(),o=this._iKey=n.clone(),a=s.words,u=o.words,c=0;r>c;c++)a[c]^=1549556828,u[c]^=909522486;s.sigBytes=o.sigBytes=i,this.reset()},reset:function(){var t=this._hasher;t.reset(),t.update(this._iKey)},update:function(t){return this._hasher.update(t),this},finalize:function(t){var e=this._hasher;return t=e.finalize(t),e.reset(),e.finalize(this._oKey.clone().concat(t))}})}(),function(){var t=sr,e=t.lib,n=e.Base,r=e.WordArray,e=t.algo,i=e.HMAC,s=e.PBKDF2=n.extend({cfg:n.extend({keySize:4,hasher:e.SHA1,iterations:1}),init:function(t){this.cfg=this.cfg.extend(t)},compute:function(t,e){for(var n=this.cfg,s=i.create(n.hasher,t),o=r.create(),a=r.create([1]),u=o.words,c=a.words,f=n.keySize,n=n.iterations;u.length<f;){var h=s.update(e).finalize(a);s.reset();for(var l=h.words,d=l.length,p=h,g=1;n>g;g++){p=s.finalize(p),s.reset();for(var y=p.words,v=0;d>v;v++)l[v]^=y[v]}o.concat(h),c[0]++}return o.sigBytes=4*f,o}});t.PBKDF2=function(t,e,n){return s.create(n).compute(t,e)}}();/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
	 */
var or,ar="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",ur="=",cr=0xdeadbeefcafe,fr=15715070==(16777215&cr);fr&&"Microsoft Internet Explorer"==nr.appName?(o.prototype.am=c,or=30):fr&&"Netscape"!=nr.appName?(o.prototype.am=u,or=26):(o.prototype.am=f,or=28),o.prototype.DB=or,o.prototype.DM=(1<<or)-1,o.prototype.DV=1<<or;var hr=52;o.prototype.FV=Math.pow(2,hr),o.prototype.F1=hr-or,o.prototype.F2=2*or-hr;var lr,dr,pr="0123456789abcdefghijklmnopqrstuvwxyz",gr=new Array;for(lr="0".charCodeAt(0),dr=0;9>=dr;++dr)gr[lr++]=dr;for(lr="a".charCodeAt(0),dr=10;36>dr;++dr)gr[lr++]=dr;for(lr="A".charCodeAt(0),dr=10;36>dr;++dr)gr[lr++]=dr;I.prototype.convert=j,I.prototype.revert=T,I.prototype.reduce=D,I.prototype.mulTo=J,I.prototype.sqrTo=H,k.prototype.convert=N,k.prototype.revert=M,k.prototype.reduce=V,k.prototype.mulTo=q,k.prototype.sqrTo=L,o.prototype.copyTo=d,o.prototype.fromInt=p,o.prototype.fromString=y,o.prototype.clamp=v,o.prototype.dlShiftTo=_,o.prototype.drShiftTo=R,o.prototype.lShiftTo=A,o.prototype.rShiftTo=F,o.prototype.subTo=K,o.prototype.multiplyTo=P,o.prototype.squareTo=U,o.prototype.divRemTo=O,o.prototype.invDigit=B,o.prototype.isEven=W,o.prototype.exp=z,o.prototype.toString=m,o.prototype.negate=S,o.prototype.abs=b,o.prototype.compareTo=w,o.prototype.bitLength=x,o.prototype.mod=C,o.prototype.modPowInt=Y,o.ZERO=g(0),o.ONE=g(1),Bt.prototype.convert=kt,Bt.prototype.revert=kt,Bt.prototype.mulTo=Nt,Bt.prototype.sqrTo=Mt,Wt.prototype.convert=zt,Wt.prototype.revert=Yt,Wt.prototype.reduce=Gt,Wt.prototype.mulTo=$t,Wt.prototype.sqrTo=Xt;var yr=[2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997],vr=(1<<26)/yr[yr.length-1];o.prototype.chunkSize=Q,o.prototype.toRadix=et,o.prototype.fromRadix=nt,o.prototype.fromNumber=rt,o.prototype.bitwiseTo=ut,o.prototype.changeBit=Rt,o.prototype.addTo=Pt,o.prototype.dMultiply=Jt,o.prototype.dAddOffset=Ht,o.prototype.multiplyLowerTo=Lt,o.prototype.multiplyUpperTo=qt,o.prototype.modInt=te,o.prototype.millerRabin=re,o.prototype.clone=G,o.prototype.intValue=X,o.prototype.byteValue=$,o.prototype.shortValue=Z,o.prototype.signum=tt,o.prototype.toByteArray=it,o.prototype.equals=st,o.prototype.min=ot,o.prototype.max=at,o.prototype.and=ft,o.prototype.or=lt,o.prototype.xor=pt,o.prototype.andNot=yt,o.prototype.not=vt,o.prototype.shiftLeft=mt,o.prototype.shiftRight=St,o.prototype.getLowestSetBit=wt,o.prototype.bitCount=xt,o.prototype.testBit=_t,o.prototype.setBit=At,o.prototype.clearBit=Ft,o.prototype.flipBit=Kt,o.prototype.add=Ut,o.prototype.subtract=Ot,o.prototype.multiply=Ct,o.prototype.divide=jt,o.prototype.remainder=Tt,o.prototype.divideAndRemainder=Dt,o.prototype.modPow=Zt,o.prototype.modInverse=ee,o.prototype.pow=Vt,o.prototype.gcd=Qt,o.prototype.isProbablePrime=ne,o.prototype.square=It,ie.prototype.init=se,ie.prototype.next=oe;var mr,Sr,br,wr=256;if(null==Sr){Sr=new Array,br=0;var Er;if(rr.crypto&&rr.crypto.getRandomValues){var xr=new Uint8Array(32);for(rr.crypto.getRandomValues(xr),Er=0;32>Er;++Er)Sr[br++]=xr[Er]}if("Netscape"==nr.appName&&nr.appVersion<"5"&&rr.crypto){var _r=rr.crypto.random(32);for(Er=0;Er<_r.length;++Er)Sr[br++]=255&_r.charCodeAt(Er)}for(;wr>br;)Er=Math.floor(65536*Math.random()),Sr[br++]=Er>>>8,Sr[br++]=255&Er;br=0,ce()}le.prototype.nextBytes=he;var Rr=20;ve.prototype.doPublic=Se,ve.prototype.setPublic=me,ve.prototype.encrypt=be,ve.prototype.encryptOAEP=we,ve.prototype.type="RSA";var Rr=20;ve.prototype.doPrivate=Ke,ve.prototype.setPrivate=Re,ve.prototype.setPrivateEx=Ae,ve.prototype.generate=Fe,ve.prototype.decrypt=Pe,ve.prototype.decryptOAEP=Ue,Oe.prototype.equals=Ce,Oe.prototype.toBigInteger=Ie,Oe.prototype.negate=je,Oe.prototype.add=Te,Oe.prototype.subtract=De,Oe.prototype.multiply=Je,Oe.prototype.square=He,Oe.prototype.divide=Be,ke.prototype.getX=Ne,ke.prototype.getY=Me,ke.prototype.equals=Ve,ke.prototype.isInfinity=Le,ke.prototype.negate=qe,ke.prototype.add=We,ke.prototype.twice=ze,ke.prototype.multiply=Ye,ke.prototype.multiplyTwo=Ge,Xe.prototype.getQ=$e,Xe.prototype.getA=Ze,Xe.prototype.getB=Qe,Xe.prototype.equals=tn,Xe.prototype.getInfinity=en,Xe.prototype.fromBigInteger=nn,Xe.prototype.decodePointHex=rn,/*! (c) Stefan Thomas | https://github.com/bitcoinjs/bitcoinjs-lib
	 */
Oe.prototype.getByteLength=function(){return Math.floor((this.toBigInteger().bitLength()+7)/8)},ke.prototype.getEncoded=function(t){var e=function(t,e){var n=t.toByteArrayUnsigned();if(e<n.length)n=n.slice(n.length-e);else for(;e>n.length;)n.unshift(0);return n},n=this.getX().toBigInteger(),r=this.getY().toBigInteger(),i=e(n,32);return t?r.isEven()?i.unshift(2):i.unshift(3):(i.unshift(4),i=i.concat(e(r,32))),i},ke.decodeFrom=function(t,e){var n=(e[0],e.length-1),r=e.slice(1,1+n/2),i=e.slice(1+n/2,1+n);r.unshift(0),i.unshift(0);var s=new o(r),a=new o(i);return new ke(t,t.fromBigInteger(s),t.fromBigInteger(a))},ke.decodeFromHex=function(t,e){var n=(e.substr(0,2),e.length-2),r=e.substr(2,n/2),i=e.substr(2+n/2,n/2),s=new o(r,16),a=new o(i,16);return new ke(t,t.fromBigInteger(s),t.fromBigInteger(a))},ke.prototype.add2D=function(t){if(this.isInfinity())return t;if(t.isInfinity())return this;if(this.x.equals(t.x))return this.y.equals(t.y)?this.twice():this.curve.getInfinity();var e=t.x.subtract(this.x),n=t.y.subtract(this.y),r=n.divide(e),i=r.square().subtract(this.x).subtract(t.x),s=r.multiply(this.x.subtract(i)).subtract(this.y);return new ke(this.curve,i,s)},ke.prototype.twice2D=function(){if(this.isInfinity())return this;if(0==this.y.toBigInteger().signum())return this.curve.getInfinity();var t=this.curve.fromBigInteger(o.valueOf(2)),e=this.curve.fromBigInteger(o.valueOf(3)),n=this.x.square().multiply(e).add(this.curve.a).divide(this.y.multiply(t)),r=n.square().subtract(this.x.multiply(t)),i=n.multiply(this.x.subtract(r)).subtract(this.y);return new ke(this.curve,r,i)},ke.prototype.multiply2D=function(t){if(this.isInfinity())return this;if(0==t.signum())return this.curve.getInfinity();var e,n=t,r=n.multiply(new o("3")),i=this.negate(),s=this;for(e=r.bitLength()-2;e>0;--e){s=s.twice();var a=r.testBit(e),u=n.testBit(e);a!=u&&(s=s.add2D(a?this:i))}return s},ke.prototype.isOnCurve=function(){var t=this.getX().toBigInteger(),e=this.getY().toBigInteger(),n=this.curve.getA().toBigInteger(),r=this.curve.getB().toBigInteger(),i=this.curve.getQ(),s=e.multiply(e).mod(i),o=t.multiply(t).multiply(t).add(n.multiply(t)).add(r).mod(i);return s.equals(o)},ke.prototype.toString=function(){return"("+this.getX().toBigInteger().toString()+","+this.getY().toBigInteger().toString()+")"},ke.prototype.validate=function(){var t=this.curve.getQ();if(this.isInfinity())throw new Error("Point is at infinity.");var e=this.getX().toBigInteger(),n=this.getY().toBigInteger();if(e.compareTo(o.ONE)<0||e.compareTo(t.subtract(o.ONE))>0)throw new Error("x coordinate out of bounds");if(n.compareTo(o.ONE)<0||n.compareTo(t.subtract(o.ONE))>0)throw new Error("y coordinate out of bounds");if(!this.isOnCurve())throw new Error("Point is not on the curve.");if(this.multiply(t).isInfinity())throw new Error("Point is not a scalar multiple of G.");return!0};/*! Mike Samuel (c) 2009 | code.google.com/p/json-sans-eval
	 */
var Ar=function(){function t(t,e,n){return e?o[e]:String.fromCharCode(parseInt(n,16))}var e="(?:-?\\b(?:0|[1-9][0-9]*)(?:\\.[0-9]+)?(?:[eE][+-]?[0-9]+)?\\b)",n='(?:[^\\0-\\x08\\x0a-\\x1f"\\\\]|\\\\(?:["/\\\\bfnrt]|u[0-9A-Fa-f]{4}))',r='(?:"'+n+'*")',i=new RegExp("(?:false|true|null|[\\{\\}\\[\\]]|"+e+"|"+r+")","g"),s=new RegExp("\\\\(?:([^u])|u(.{4}))","g"),o={'"':'"',"/":"/","\\":"\\",b:"\b",f:"\f",n:"\n",r:"\r",t:"	"},a=new String(""),u="\\",c=({"{":Object,"[":Array},Object.hasOwnProperty);return function(e,n){var r,o=e.match(i),f=o[0],h=!1;"{"===f?r={}:"["===f?r=[]:(r=[],h=!0);for(var l,d=[r],p=1-h,g=o.length;g>p;++p){f=o[p];var y;switch(f.charCodeAt(0)){default:y=d[0],y[l||y.length]=+f,l=void 0;break;case 34:if(f=f.substring(1,f.length-1),-1!==f.indexOf(u)&&(f=f.replace(s,t)),y=d[0],!l){if(!(y instanceof Array)){l=f||a;break}l=y.length}y[l]=f,l=void 0;break;case 91:y=d[0],d.unshift(y[l||y.length]=[]),l=void 0;break;case 93:d.shift();break;case 102:y=d[0],y[l||y.length]=!1,l=void 0;break;case 110:y=d[0],y[l||y.length]=null,l=void 0;break;case 116:y=d[0],y[l||y.length]=!0,l=void 0;break;case 123:y=d[0],d.unshift(y[l||y.length]={}),l=void 0;break;case 125:d.shift()}}if(h){if(1!==d.length)throw new Error;r=r[0]}else if(d.length)throw new Error;if(n){var v=function(t,e){var r=t[e];if(r&&"object"==typeof r){var i=null;for(var s in r)if(c.call(r,s)&&r!==t){var o=v(r,s);void 0!==o?r[s]=o:(i||(i=[]),i.push(s))}if(i)for(var a=i.length;--a>=0;)delete r[i[a]]}return n.call(t,e,r)};r=v({"":r},"")}return r}}();/*! asn1-1.0.9.js (c) 2013-2015 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
"undefined"!=typeof KJUR&&KJUR||(KJUR={}),"undefined"!=typeof KJUR.asn1&&KJUR.asn1||(KJUR.asn1={}),KJUR.asn1.ASN1Util=new function(){this.integerToByteHex=function(t){var e=t.toString(16);return e.length%2==1&&(e="0"+e),e},this.bigIntToMinTwosComplementsHex=function(t){var e=t.toString(16);if("-"!=e.substr(0,1))e.length%2==1?e="0"+e:e.match(/^[0-7]/)||(e="00"+e);else{var n=e.substr(1),r=n.length;r%2==1?r+=1:e.match(/^[0-7]/)||(r+=2);for(var i="",s=0;r>s;s++)i+="f";var a=new o(i,16),u=a.xor(t).add(o.ONE);e=u.toString(16).replace(/^-/,"")}return e},this.getPEMStringFromHex=function(t,e){var n=(KJUR.asn1,sr.enc.Hex.parse(t)),r=sr.enc.Base64.stringify(n),i=r.replace(/(.{64})/g,"$1\r\n");return i=i.replace(/\r\n$/,""),"-----BEGIN "+e+"-----\r\n"+i+"\r\n-----END "+e+"-----\r\n"},this.newObject=function(t){var e=KJUR.asn1,n=Object.keys(t);if(1!=n.length)throw"key of param shall be only one.";var r=n[0];if(-1==":bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:seq:set:tag:".indexOf(":"+r+":"))throw"undefined key: "+r;if("bool"==r)return new e.DERBoolean(t[r]);if("int"==r)return new e.DERInteger(t[r]);if("bitstr"==r)return new e.DERBitString(t[r]);if("octstr"==r)return new e.DEROctetString(t[r]);if("null"==r)return new e.DERNull(t[r]);if("oid"==r)return new e.DERObjectIdentifier(t[r]);if("enum"==r)return new e.DEREnumerated(t[r]);if("utf8str"==r)return new e.DERUTF8String(t[r]);if("numstr"==r)return new e.DERNumericString(t[r]);if("prnstr"==r)return new e.DERPrintableString(t[r]);if("telstr"==r)return new e.DERTeletexString(t[r]);if("ia5str"==r)return new e.DERIA5String(t[r]);if("utctime"==r)return new e.DERUTCTime(t[r]);if("gentime"==r)return new e.DERGeneralizedTime(t[r]);if("seq"==r){for(var i=t[r],s=[],o=0;o<i.length;o++){var a=e.ASN1Util.newObject(i[o]);s.push(a)}return new e.DERSequence({array:s})}if("set"==r){for(var i=t[r],s=[],o=0;o<i.length;o++){var a=e.ASN1Util.newObject(i[o]);s.push(a)}return new e.DERSet({array:s})}if("tag"==r){var u=t[r];if("[object Array]"===Object.prototype.toString.call(u)&&3==u.length){var c=e.ASN1Util.newObject(u[2]);return new e.DERTaggedObject({tag:u[0],explicit:u[1],obj:c})}var f={};if(void 0!==u.explicit&&(f.explicit=u.explicit),void 0!==u.tag&&(f.tag=u.tag),void 0===u.obj)throw"obj shall be specified for 'tag'.";return f.obj=e.ASN1Util.newObject(u.obj),new e.DERTaggedObject(f)}},this.jsonToASN1HEX=function(t){var e=this.newObject(t);return e.getEncodedHex()}},KJUR.asn1.ASN1Util.oidHexToInt=function(t){for(var e="",n=parseInt(t.substr(0,2),16),r=Math.floor(n/40),i=n%40,e=r+"."+i,s="",a=2;a<t.length;a+=2){var u=parseInt(t.substr(a,2),16),c=("00000000"+u.toString(2)).slice(-8);if(s+=c.substr(1,7),"0"==c.substr(0,1)){var f=new o(s,2);e=e+"."+f.toString(10),s=""}}return e},KJUR.asn1.ASN1Util.oidIntToHex=function(t){var e=function(t){var e=t.toString(16);return 1==e.length&&(e="0"+e),e},n=function(t){var n="",r=new o(t,10),i=r.toString(2),s=7-i.length%7;7==s&&(s=0);for(var a="",u=0;s>u;u++)a+="0";i=a+i;for(var u=0;u<i.length-1;u+=7){var c=i.substr(u,7);u!=i.length-7&&(c="1"+c),n+=e(parseInt(c,2))}return n};if(!t.match(/^[0-9.]+$/))throw"malformed oid string: "+t;var r="",i=t.split("."),s=40*parseInt(i[0])+parseInt(i[1]);r+=e(s),i.splice(0,2);for(var a=0;a<i.length;a++)r+=n(i[a]);return r},KJUR.asn1.ASN1Object=function(){var t="";this.getLengthHexFromValue=function(){if("undefined"==typeof this.hV||null==this.hV)throw"this.hV is null or undefined.";if(this.hV.length%2==1)throw"value hex must be even length: n="+t.length+",v="+this.hV;var e=this.hV.length/2,n=e.toString(16);if(n.length%2==1&&(n="0"+n),128>e)return n;var r=n.length/2;if(r>15)throw"ASN.1 length too long to represent by 8x: n = "+e.toString(16);var i=128+r;return i.toString(16)+n},this.getEncodedHex=function(){return(null==this.hTLV||this.isModified)&&(this.hV=this.getFreshValueHex(),this.hL=this.getLengthHexFromValue(),this.hTLV=this.hT+this.hL+this.hV,this.isModified=!1),this.hTLV},this.getValueHex=function(){return this.getEncodedHex(),this.hV},this.getFreshValueHex=function(){return""}},KJUR.asn1.DERAbstractString=function(t){KJUR.asn1.DERAbstractString.superclass.constructor.call(this);this.getString=function(){return this.s},this.setString=function(t){this.hTLV=null,this.isModified=!0,this.s=t,this.hV=un(this.s)},this.setStringHex=function(t){this.hTLV=null,this.isModified=!0,this.s=null,this.hV=t},this.getFreshValueHex=function(){return this.hV},"undefined"!=typeof t&&("string"==typeof t?this.setString(t):"undefined"!=typeof t.str?this.setString(t.str):"undefined"!=typeof t.hex&&this.setStringHex(t.hex))},ir.lang.extend(KJUR.asn1.DERAbstractString,KJUR.asn1.ASN1Object),KJUR.asn1.DERAbstractTime=function(t){KJUR.asn1.DERAbstractTime.superclass.constructor.call(this);this.localDateToUTC=function(t){utc=t.getTime()+6e4*t.getTimezoneOffset();var e=new Date(utc);return e},this.formatDate=function(t,e,n){var r=this.zeroPadding,i=this.localDateToUTC(t),s=String(i.getFullYear());"utc"==e&&(s=s.substr(2,2));var o=r(String(i.getMonth()+1),2),a=r(String(i.getDate()),2),u=r(String(i.getHours()),2),c=r(String(i.getMinutes()),2),f=r(String(i.getSeconds()),2),h=s+o+a+u+c+f;if(n===!0){var l=i.getMilliseconds();if(0!=l){var d=r(String(l),3);d=d.replace(/[0]+$/,""),h=h+"."+d}}return h+"Z"},this.zeroPadding=function(t,e){return t.length>=e?t:new Array(e-t.length+1).join("0")+t},this.getString=function(){return this.s},this.setString=function(t){this.hTLV=null,this.isModified=!0,this.s=t,this.hV=un(t)},this.setByDateValue=function(t,e,n,r,i,s){var o=new Date(Date.UTC(t,e-1,n,r,i,s,0));this.setByDate(o)},this.getFreshValueHex=function(){return this.hV}},ir.lang.extend(KJUR.asn1.DERAbstractTime,KJUR.asn1.ASN1Object),KJUR.asn1.DERAbstractStructured=function(t){KJUR.asn1.DERAbstractString.superclass.constructor.call(this);this.setByASN1ObjectArray=function(t){this.hTLV=null,this.isModified=!0,this.asn1Array=t},this.appendASN1Object=function(t){this.hTLV=null,this.isModified=!0,this.asn1Array.push(t)},this.asn1Array=new Array,"undefined"!=typeof t&&"undefined"!=typeof t.array&&(this.asn1Array=t.array)},ir.lang.extend(KJUR.asn1.DERAbstractStructured,KJUR.asn1.ASN1Object),KJUR.asn1.DERBoolean=function(){KJUR.asn1.DERBoolean.superclass.constructor.call(this),this.hT="01",this.hTLV="0101ff"},ir.lang.extend(KJUR.asn1.DERBoolean,KJUR.asn1.ASN1Object),KJUR.asn1.DERInteger=function(t){KJUR.asn1.DERInteger.superclass.constructor.call(this),this.hT="02",this.setByBigInteger=function(t){this.hTLV=null,this.isModified=!0,this.hV=KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t)},this.setByInteger=function(t){var e=new o(String(t),10);this.setByBigInteger(e)},this.setValueHex=function(t){this.hV=t},this.getFreshValueHex=function(){return this.hV},"undefined"!=typeof t&&("undefined"!=typeof t.bigint?this.setByBigInteger(t.bigint):"undefined"!=typeof t.int?this.setByInteger(t.int):"number"==typeof t?this.setByInteger(t):"undefined"!=typeof t.hex&&this.setValueHex(t.hex))},ir.lang.extend(KJUR.asn1.DERInteger,KJUR.asn1.ASN1Object),KJUR.asn1.DERBitString=function(t){KJUR.asn1.DERBitString.superclass.constructor.call(this),this.hT="03",this.setHexValueIncludingUnusedBits=function(t){this.hTLV=null,this.isModified=!0,this.hV=t},this.setUnusedBitsAndHexValue=function(t,e){if(0>t||t>7)throw"unused bits shall be from 0 to 7: u = "+t;var n="0"+t;this.hTLV=null,this.isModified=!0,this.hV=n+e},this.setByBinaryString=function(t){t=t.replace(/0+$/,"");var e=8-t.length%8;8==e&&(e=0);for(var n=0;e>=n;n++)t+="0";for(var r="",n=0;n<t.length-1;n+=8){var i=t.substr(n,8),s=parseInt(i,2).toString(16);1==s.length&&(s="0"+s),r+=s}this.hTLV=null,this.isModified=!0,this.hV="0"+e+r},this.setByBooleanArray=function(t){for(var e="",n=0;n<t.length;n++)e+=1==t[n]?"1":"0";this.setByBinaryString(e)},this.newFalseArray=function(t){for(var e=new Array(t),n=0;t>n;n++)e[n]=!1;return e},this.getFreshValueHex=function(){return this.hV},"undefined"!=typeof t&&("string"==typeof t&&t.toLowerCase().match(/^[0-9a-f]+$/)?this.setHexValueIncludingUnusedBits(t):"undefined"!=typeof t.hex?this.setHexValueIncludingUnusedBits(t.hex):"undefined"!=typeof t.bin?this.setByBinaryString(t.bin):"undefined"!=typeof t.array&&this.setByBooleanArray(t.array))},ir.lang.extend(KJUR.asn1.DERBitString,KJUR.asn1.ASN1Object),KJUR.asn1.DEROctetString=function(t){KJUR.asn1.DEROctetString.superclass.constructor.call(this,t),this.hT="04"},ir.lang.extend(KJUR.asn1.DEROctetString,KJUR.asn1.DERAbstractString),KJUR.asn1.DERNull=function(){KJUR.asn1.DERNull.superclass.constructor.call(this),this.hT="05",this.hTLV="0500"},ir.lang.extend(KJUR.asn1.DERNull,KJUR.asn1.ASN1Object),KJUR.asn1.DERObjectIdentifier=function(t){var e=function(t){var e=t.toString(16);return 1==e.length&&(e="0"+e),e},n=function(t){var n="",r=new o(t,10),i=r.toString(2),s=7-i.length%7;7==s&&(s=0);for(var a="",u=0;s>u;u++)a+="0";i=a+i;for(var u=0;u<i.length-1;u+=7){var c=i.substr(u,7);u!=i.length-7&&(c="1"+c),n+=e(parseInt(c,2))}return n};KJUR.asn1.DERObjectIdentifier.superclass.constructor.call(this),this.hT="06",this.setValueHex=function(t){this.hTLV=null,this.isModified=!0,this.s=null,this.hV=t},this.setValueOidString=function(t){if(!t.match(/^[0-9.]+$/))throw"malformed oid string: "+t;var r="",i=t.split("."),s=40*parseInt(i[0])+parseInt(i[1]);r+=e(s),i.splice(0,2);for(var o=0;o<i.length;o++)r+=n(i[o]);this.hTLV=null,this.isModified=!0,this.s=null,this.hV=r},this.setValueName=function(t){if("undefined"==typeof KJUR.asn1.x509.OID.name2oidList[t])throw"DERObjectIdentifier oidName undefined: "+t;var e=KJUR.asn1.x509.OID.name2oidList[t];this.setValueOidString(e)},this.getFreshValueHex=function(){return this.hV},"undefined"!=typeof t&&("string"==typeof t&&t.match(/^[0-2].[0-9.]+$/)?this.setValueOidString(t):void 0!==KJUR.asn1.x509.OID.name2oidList[t]?this.setValueOidString(KJUR.asn1.x509.OID.name2oidList[t]):"undefined"!=typeof t.oid?this.setValueOidString(t.oid):"undefined"!=typeof t.hex?this.setValueHex(t.hex):"undefined"!=typeof t.name&&this.setValueName(t.name))},ir.lang.extend(KJUR.asn1.DERObjectIdentifier,KJUR.asn1.ASN1Object),KJUR.asn1.DEREnumerated=function(t){KJUR.asn1.DEREnumerated.superclass.constructor.call(this),this.hT="0a",this.setByBigInteger=function(t){this.hTLV=null,this.isModified=!0,this.hV=KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t)},this.setByInteger=function(t){var e=new o(String(t),10);this.setByBigInteger(e)},this.setValueHex=function(t){this.hV=t},this.getFreshValueHex=function(){return this.hV},"undefined"!=typeof t&&("undefined"!=typeof t.int?this.setByInteger(t.int):"number"==typeof t?this.setByInteger(t):"undefined"!=typeof t.hex&&this.setValueHex(t.hex))},ir.lang.extend(KJUR.asn1.DEREnumerated,KJUR.asn1.ASN1Object),KJUR.asn1.DERUTF8String=function(t){KJUR.asn1.DERUTF8String.superclass.constructor.call(this,t),this.hT="0c"},ir.lang.extend(KJUR.asn1.DERUTF8String,KJUR.asn1.DERAbstractString),KJUR.asn1.DERNumericString=function(t){KJUR.asn1.DERNumericString.superclass.constructor.call(this,t),this.hT="12"},ir.lang.extend(KJUR.asn1.DERNumericString,KJUR.asn1.DERAbstractString),KJUR.asn1.DERPrintableString=function(t){KJUR.asn1.DERPrintableString.superclass.constructor.call(this,t),this.hT="13"},ir.lang.extend(KJUR.asn1.DERPrintableString,KJUR.asn1.DERAbstractString),KJUR.asn1.DERTeletexString=function(t){KJUR.asn1.DERTeletexString.superclass.constructor.call(this,t),this.hT="14"},ir.lang.extend(KJUR.asn1.DERTeletexString,KJUR.asn1.DERAbstractString),KJUR.asn1.DERIA5String=function(t){KJUR.asn1.DERIA5String.superclass.constructor.call(this,t),this.hT="16"},ir.lang.extend(KJUR.asn1.DERIA5String,KJUR.asn1.DERAbstractString),KJUR.asn1.DERUTCTime=function(t){KJUR.asn1.DERUTCTime.superclass.constructor.call(this,t),this.hT="17",this.setByDate=function(t){this.hTLV=null,this.isModified=!0,this.date=t,this.s=this.formatDate(this.date,"utc"),this.hV=un(this.s)},this.getFreshValueHex=function(){return"undefined"==typeof this.date&&"undefined"==typeof this.s&&(this.date=new Date,this.s=this.formatDate(this.date,"utc"),this.hV=un(this.s)),this.hV},void 0!==t&&(void 0!==t.str?this.setString(t.str):"string"==typeof t&&t.match(/^[0-9]{12}Z$/)?this.setString(t):void 0!==t.hex?this.setStringHex(t.hex):void 0!==t.date&&this.setByDate(t.date))},ir.lang.extend(KJUR.asn1.DERUTCTime,KJUR.asn1.DERAbstractTime),KJUR.asn1.DERGeneralizedTime=function(t){KJUR.asn1.DERGeneralizedTime.superclass.constructor.call(this,t),this.hT="18",this.withMillis=!1,this.setByDate=function(t){this.hTLV=null,this.isModified=!0,this.date=t,this.s=this.formatDate(this.date,"gen",this.withMillis),this.hV=un(this.s)},this.getFreshValueHex=function(){return void 0===this.date&&void 0===this.s&&(this.date=new Date,this.s=this.formatDate(this.date,"gen",this.withMillis),this.hV=un(this.s)),this.hV},void 0!==t&&(void 0!==t.str?this.setString(t.str):"string"==typeof t&&t.match(/^[0-9]{14}Z$/)?this.setString(t):void 0!==t.hex?this.setStringHex(t.hex):void 0!==t.date&&this.setByDate(t.date),t.millis===!0&&(this.withMillis=!0))},ir.lang.extend(KJUR.asn1.DERGeneralizedTime,KJUR.asn1.DERAbstractTime),KJUR.asn1.DERSequence=function(t){KJUR.asn1.DERSequence.superclass.constructor.call(this,t),this.hT="30",this.getFreshValueHex=function(){for(var t="",e=0;e<this.asn1Array.length;e++){var n=this.asn1Array[e];t+=n.getEncodedHex()}return this.hV=t,this.hV}},ir.lang.extend(KJUR.asn1.DERSequence,KJUR.asn1.DERAbstractStructured),KJUR.asn1.DERSet=function(t){KJUR.asn1.DERSet.superclass.constructor.call(this,t),this.hT="31",this.sortFlag=!0,this.getFreshValueHex=function(){for(var t=new Array,e=0;e<this.asn1Array.length;e++){var n=this.asn1Array[e];t.push(n.getEncodedHex())}return 1==this.sortFlag&&t.sort(),this.hV=t.join(""),this.hV},"undefined"!=typeof t&&"undefined"!=typeof t.sortflag&&0==t.sortflag&&(this.sortFlag=!1)},ir.lang.extend(KJUR.asn1.DERSet,KJUR.asn1.DERAbstractStructured),KJUR.asn1.DERTaggedObject=function(t){KJUR.asn1.DERTaggedObject.superclass.constructor.call(this),this.hT="a0",this.hV="",this.isExplicit=!0,this.asn1Object=null,this.setASN1Object=function(t,e,n){this.hT=e,this.isExplicit=t,this.asn1Object=n,this.isExplicit?(this.hV=this.asn1Object.getEncodedHex(),this.hTLV=null,this.isModified=!0):(this.hV=null,this.hTLV=n.getEncodedHex(),this.hTLV=this.hTLV.replace(/^../,e),this.isModified=!1)},this.getFreshValueHex=function(){return this.hV},"undefined"!=typeof t&&("undefined"!=typeof t.tag&&(this.hT=t.tag),"undefined"!=typeof t.explicit&&(this.isExplicit=t.explicit),"undefined"!=typeof t.obj&&(this.asn1Object=t.obj,this.setASN1Object(this.isExplicit,this.hT,this.asn1Object)))},ir.lang.extend(KJUR.asn1.DERTaggedObject,KJUR.asn1.ASN1Object);/*! asn1hex-1.1.6.js (c) 2012-2015 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
var Fr=new function(){this.getByteLengthOfL_AtObj=function(t,e){if("8"!=t.substring(e+2,e+3))return 1;var n=parseInt(t.substring(e+3,e+4));return 0==n?-1:n>0&&10>n?n+1:-2},this.getHexOfL_AtObj=function(t,e){var n=this.getByteLengthOfL_AtObj(t,e);return 1>n?"":t.substring(e+2,e+2+2*n)},this.getIntOfL_AtObj=function(t,e){var n=this.getHexOfL_AtObj(t,e);if(""==n)return-1;var r;return r=parseInt(n.substring(0,1))<8?new o(n,16):new o(n.substring(2),16),r.intValue()},this.getStartPosOfV_AtObj=function(t,e){var n=this.getByteLengthOfL_AtObj(t,e);return 0>n?n:e+2*(n+1)},this.getHexOfV_AtObj=function(t,e){var n=this.getStartPosOfV_AtObj(t,e),r=this.getIntOfL_AtObj(t,e);return t.substring(n,n+2*r)},this.getHexOfTLV_AtObj=function(t,e){var n=t.substr(e,2),r=this.getHexOfL_AtObj(t,e),i=this.getHexOfV_AtObj(t,e);return n+r+i},this.getPosOfNextSibling_AtObj=function(t,e){var n=this.getStartPosOfV_AtObj(t,e),r=this.getIntOfL_AtObj(t,e);return n+2*r},this.getPosArrayOfChildren_AtObj=function(t,e){var n=new Array,r=this.getStartPosOfV_AtObj(t,e);n.push(r);for(var i=this.getIntOfL_AtObj(t,e),s=r,o=0;;){var a=this.getPosOfNextSibling_AtObj(t,s);if(null==a||a-r>=2*i)break;if(o>=200)break;n.push(a),s=a,o++}return n},this.getNthChildIndex_AtObj=function(t,e,n){var r=this.getPosArrayOfChildren_AtObj(t,e);return r[n]},this.getDecendantIndexByNthList=function(t,e,n){if(0==n.length)return e;var r=n.shift(),i=this.getPosArrayOfChildren_AtObj(t,e);return this.getDecendantIndexByNthList(t,i[r],n)},this.getDecendantHexTLVByNthList=function(t,e,n){var r=this.getDecendantIndexByNthList(t,e,n);return this.getHexOfTLV_AtObj(t,r)},this.getDecendantHexVByNthList=function(t,e,n){var r=this.getDecendantIndexByNthList(t,e,n);return this.getHexOfV_AtObj(t,r)}};Fr.getVbyList=function(t,e,n,r){var i=this.getDecendantIndexByNthList(t,e,n);if(void 0===i)throw"can't find nthList object";if(void 0!==r&&t.substr(i,2)!=r)throw"checking tag doesn't match: "+t.substr(i,2)+"!="+r;return this.getHexOfV_AtObj(t,i)},Fr.hextooidstr=function(t){var e=function(t,e){return t.length>=e?t:new Array(e-t.length+1).join("0")+t},n=[],r=t.substr(0,2),i=parseInt(r,16);n[0]=new String(Math.floor(i/40)),n[1]=new String(i%40);for(var s=t.substr(2),o=[],a=0;a<s.length/2;a++)o.push(parseInt(s.substr(2*a,2),16));for(var u=[],c="",a=0;a<o.length;a++)128&o[a]?c+=e((127&o[a]).toString(2),7):(c+=e((127&o[a]).toString(2),7),u.push(new String(parseInt(c,2))),c="");var f=n.join(".");return u.length>0&&(f=f+"."+u.join(".")),f},Fr.dump=function(t,e,n,r){var i=function(t,e){if(t.length<=2*e)return t;var n=t.substr(0,e)+"..(total "+t.length/2+"bytes).."+t.substr(t.length-e,e);return n};void 0===e&&(e={ommit_long_octet:32}),void 0===n&&(n=0),void 0===r&&(r="");var s=e.ommit_long_octet;if("01"==t.substr(n,2)){var o=Fr.getHexOfV_AtObj(t,n);return"00"==o?r+"BOOLEAN FALSE\n":r+"BOOLEAN TRUE\n"}if("02"==t.substr(n,2)){var o=Fr.getHexOfV_AtObj(t,n);return r+"INTEGER "+i(o,s)+"\n"}if("03"==t.substr(n,2)){var o=Fr.getHexOfV_AtObj(t,n);return r+"BITSTRING "+i(o,s)+"\n"}if("04"==t.substr(n,2)){var o=Fr.getHexOfV_AtObj(t,n);if(Fr.isASN1HEX(o)){var a=r+"OCTETSTRING, encapsulates\n";return a+=Fr.dump(o,e,0,r+"  ")}return r+"OCTETSTRING "+i(o,s)+"\n"}if("05"==t.substr(n,2))return r+"NULL\n";if("06"==t.substr(n,2)){var u=Fr.getHexOfV_AtObj(t,n),c=KJUR.asn1.ASN1Util.oidHexToInt(u),f=KJUR.asn1.x509.OID.oid2name(c),h=c.replace(/\./g," ");return""!=f?r+"ObjectIdentifier "+f+" ("+h+")\n":r+"ObjectIdentifier ("+h+")\n"}if("0c"==t.substr(n,2))return r+"UTF8String '"+Sn(Fr.getHexOfV_AtObj(t,n))+"'\n";if("13"==t.substr(n,2))return r+"PrintableString '"+Sn(Fr.getHexOfV_AtObj(t,n))+"'\n";if("14"==t.substr(n,2))return r+"TeletexString '"+Sn(Fr.getHexOfV_AtObj(t,n))+"'\n";if("16"==t.substr(n,2))return r+"IA5String '"+Sn(Fr.getHexOfV_AtObj(t,n))+"'\n";if("17"==t.substr(n,2))return r+"UTCTime "+Sn(Fr.getHexOfV_AtObj(t,n))+"\n";if("18"==t.substr(n,2))return r+"GeneralizedTime "+Sn(Fr.getHexOfV_AtObj(t,n))+"\n";if("30"==t.substr(n,2)){if("3000"==t.substr(n,4))return r+"SEQUENCE {}\n";var a=r+"SEQUENCE\n",l=Fr.getPosArrayOfChildren_AtObj(t,n),d=e;if((2==l.length||3==l.length)&&"06"==t.substr(l[0],2)&&"04"==t.substr(l[l.length-1],2)){var p=Fr.getHexOfV_AtObj(t,l[0]),c=KJUR.asn1.ASN1Util.oidHexToInt(p),f=KJUR.asn1.x509.OID.oid2name(c),g=JSON.parse(JSON.stringify(e));g.x509ExtName=f,d=g}for(var y=0;y<l.length;y++)a+=Fr.dump(t,d,l[y],r+"  ");return a}if("31"==t.substr(n,2)){for(var a=r+"SET\n",l=Fr.getPosArrayOfChildren_AtObj(t,n),y=0;y<l.length;y++)a+=Fr.dump(t,e,l[y],r+"  ");return a}var v=parseInt(t.substr(n,2),16);if(0!=(128&v)){var m=31&v;if(0!=(32&v)){for(var a=r+"["+m+"]\n",l=Fr.getPosArrayOfChildren_AtObj(t,n),y=0;y<l.length;y++)a+=Fr.dump(t,e,l[y],r+"  ");return a}var o=Fr.getHexOfV_AtObj(t,n);"68747470"==o.substr(0,8)&&(o=Sn(o)),"subjectAltName"===e.x509ExtName&&2==m&&(o=Sn(o));var a=r+"["+m+"] "+o+"\n";return a}return r+"UNKNOWN("+t.substr(n,2)+") "+Fr.getHexOfV_AtObj(t,n)+"\n"},Fr.isASN1HEX=function(t){if(t.length%2==1)return!1;var e=Fr.getIntOfL_AtObj(t,0),n=t.substr(0,2),r=Fr.getHexOfL_AtObj(t,0),i=t.length-n.length-r.length;return i==2*e},/*! asn1x509-1.0.14.js (c) 2013-2015 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
"undefined"!=typeof KJUR&&KJUR||(KJUR={}),"undefined"!=typeof KJUR.asn1&&KJUR.asn1||(KJUR.asn1={}),"undefined"!=typeof KJUR.asn1.x509&&KJUR.asn1.x509||(KJUR.asn1.x509={}),KJUR.asn1.x509.Certificate=function(t){KJUR.asn1.x509.Certificate.superclass.constructor.call(this);this.setRsaPrvKeyByPEMandPass=function(t,e){var n=Or.getDecryptedKeyHex(t,e),r=new ve;r.readPrivateKeyFromASN1HexString(n),this.prvKey=r},this.sign=function(){this.asn1SignatureAlg=this.asn1TBSCert.asn1SignatureAlg,sig=new KJUR.crypto.Signature({alg:"SHA1withRSA"}),sig.init(this.prvKey),sig.updateHex(this.asn1TBSCert.getEncodedHex()),this.hexSig=sig.sign(),this.asn1Sig=new KJUR.asn1.DERBitString({hex:"00"+this.hexSig});var t=new KJUR.asn1.DERSequence({array:[this.asn1TBSCert,this.asn1SignatureAlg,this.asn1Sig]});this.hTLV=t.getEncodedHex(),this.isModified=!1},this.setSignatureHex=function(t){this.asn1SignatureAlg=this.asn1TBSCert.asn1SignatureAlg,this.hexSig=t,this.asn1Sig=new KJUR.asn1.DERBitString({hex:"00"+this.hexSig});var e=new KJUR.asn1.DERSequence({array:[this.asn1TBSCert,this.asn1SignatureAlg,this.asn1Sig]});this.hTLV=e.getEncodedHex(),this.isModified=!1},this.getEncodedHex=function(){if(0==this.isModified&&null!=this.hTLV)return this.hTLV;throw"not signed yet"},this.getPEMString=function(){var t=this.getEncodedHex(),e=sr.enc.Hex.parse(t),n=sr.enc.Base64.stringify(e),r=n.replace(/(.{64})/g,"$1\r\n");return"-----BEGIN CERTIFICATE-----\r\n"+r+"\r\n-----END CERTIFICATE-----\r\n"},"undefined"!=typeof t&&("undefined"!=typeof t.tbscertobj&&(this.asn1TBSCert=t.tbscertobj),"undefined"!=typeof t.prvkeyobj?this.prvKey=t.prvkeyobj:"undefined"!=typeof t.rsaprvkey?this.prvKey=t.rsaprvkey:"undefined"!=typeof t.rsaprvpem&&"undefined"!=typeof t.rsaprvpas&&this.setRsaPrvKeyByPEMandPass(t.rsaprvpem,t.rsaprvpas))},ir.lang.extend(KJUR.asn1.x509.Certificate,KJUR.asn1.ASN1Object),KJUR.asn1.x509.TBSCertificate=function(t){KJUR.asn1.x509.TBSCertificate.superclass.constructor.call(this),this._initialize=function(){this.asn1Array=new Array,this.asn1Version=new KJUR.asn1.DERTaggedObject({obj:new KJUR.asn1.DERInteger({"int":2})}),this.asn1SerialNumber=null,this.asn1SignatureAlg=null,this.asn1Issuer=null,this.asn1NotBefore=null,this.asn1NotAfter=null,this.asn1Subject=null,this.asn1SubjPKey=null,this.extensionsArray=new Array},this.setSerialNumberByParam=function(t){this.asn1SerialNumber=new KJUR.asn1.DERInteger(t)},this.setSignatureAlgByParam=function(t){this.asn1SignatureAlg=new KJUR.asn1.x509.AlgorithmIdentifier(t)},this.setIssuerByParam=function(t){this.asn1Issuer=new KJUR.asn1.x509.X500Name(t)},this.setNotBeforeByParam=function(t){this.asn1NotBefore=new KJUR.asn1.x509.Time(t)},this.setNotAfterByParam=function(t){this.asn1NotAfter=new KJUR.asn1.x509.Time(t)},this.setSubjectByParam=function(t){this.asn1Subject=new KJUR.asn1.x509.X500Name(t)},this.setSubjectPublicKeyByParam=function(t){this.asn1SubjPKey=new KJUR.asn1.x509.SubjectPublicKeyInfo(t)},this.setSubjectPublicKeyByGetKey=function(t){var e=Cr.getKey(t);this.asn1SubjPKey=new KJUR.asn1.x509.SubjectPublicKeyInfo(e)},this.appendExtension=function(t){this.extensionsArray.push(t)},this.appendExtensionByName=function(t,e){if("basicconstraints"==t.toLowerCase()){var n=new KJUR.asn1.x509.BasicConstraints(e);this.appendExtension(n)}else if("keyusage"==t.toLowerCase()){var n=new KJUR.asn1.x509.KeyUsage(e);this.appendExtension(n)}else if("crldistributionpoints"==t.toLowerCase()){var n=new KJUR.asn1.x509.CRLDistributionPoints(e);this.appendExtension(n)}else if("extkeyusage"==t.toLowerCase()){var n=new KJUR.asn1.x509.ExtKeyUsage(e);this.appendExtension(n)}else{if("authoritykeyidentifier"!=t.toLowerCase())throw"unsupported extension name: "+t;var n=new KJUR.asn1.x509.AuthorityKeyIdentifier(e);this.appendExtension(n)}},this.getEncodedHex=function(){if(null==this.asn1NotBefore||null==this.asn1NotAfter)throw"notBefore and/or notAfter not set";var t=new KJUR.asn1.DERSequence({array:[this.asn1NotBefore,this.asn1NotAfter]});if(this.asn1Array=new Array,this.asn1Array.push(this.asn1Version),this.asn1Array.push(this.asn1SerialNumber),this.asn1Array.push(this.asn1SignatureAlg),this.asn1Array.push(this.asn1Issuer),this.asn1Array.push(t),this.asn1Array.push(this.asn1Subject),this.asn1Array.push(this.asn1SubjPKey),this.extensionsArray.length>0){var e=new KJUR.asn1.DERSequence({array:this.extensionsArray}),n=new KJUR.asn1.DERTaggedObject({explicit:!0,tag:"a3",obj:e});this.asn1Array.push(n)}var r=new KJUR.asn1.DERSequence({array:this.asn1Array});return this.hTLV=r.getEncodedHex(),this.isModified=!1,this.hTLV},this._initialize()},ir.lang.extend(KJUR.asn1.x509.TBSCertificate,KJUR.asn1.ASN1Object),KJUR.asn1.x509.Extension=function(t){KJUR.asn1.x509.Extension.superclass.constructor.call(this);this.getEncodedHex=function(){var t=new KJUR.asn1.DERObjectIdentifier({oid:this.oid}),e=new KJUR.asn1.DEROctetString({hex:this.getExtnValueHex()}),n=new Array;n.push(t),this.critical&&n.push(new KJUR.asn1.DERBoolean),n.push(e);var r=new KJUR.asn1.DERSequence({array:n});return r.getEncodedHex()},this.critical=!1,"undefined"!=typeof t&&"undefined"!=typeof t.critical&&(this.critical=t.critical)},ir.lang.extend(KJUR.asn1.x509.Extension,KJUR.asn1.ASN1Object),KJUR.asn1.x509.KeyUsage=function(t){KJUR.asn1.x509.KeyUsage.superclass.constructor.call(this,t),this.getExtnValueHex=function(){return this.asn1ExtnValue.getEncodedHex()},this.oid="2.5.29.15","undefined"!=typeof t&&"undefined"!=typeof t.bin&&(this.asn1ExtnValue=new KJUR.asn1.DERBitString(t))},ir.lang.extend(KJUR.asn1.x509.KeyUsage,KJUR.asn1.x509.Extension),KJUR.asn1.x509.BasicConstraints=function(t){KJUR.asn1.x509.BasicConstraints.superclass.constructor.call(this,t);this.getExtnValueHex=function(){var t=new Array;this.cA&&t.push(new KJUR.asn1.DERBoolean),this.pathLen>-1&&t.push(new KJUR.asn1.DERInteger({"int":this.pathLen}));var e=new KJUR.asn1.DERSequence({array:t});return this.asn1ExtnValue=e,this.asn1ExtnValue.getEncodedHex()},this.oid="2.5.29.19",this.cA=!1,this.pathLen=-1,"undefined"!=typeof t&&("undefined"!=typeof t.cA&&(this.cA=t.cA),"undefined"!=typeof t.pathLen&&(this.pathLen=t.pathLen))},ir.lang.extend(KJUR.asn1.x509.BasicConstraints,KJUR.asn1.x509.Extension),KJUR.asn1.x509.CRLDistributionPoints=function(t){KJUR.asn1.x509.CRLDistributionPoints.superclass.constructor.call(this,t),this.getExtnValueHex=function(){return this.asn1ExtnValue.getEncodedHex()},this.setByDPArray=function(t){this.asn1ExtnValue=new KJUR.asn1.DERSequence({array:t})},this.setByOneURI=function(t){var e=new KJUR.asn1.x509.GeneralNames([{uri:t}]),n=new KJUR.asn1.x509.DistributionPointName(e),r=new KJUR.asn1.x509.DistributionPoint({dpobj:n});this.setByDPArray([r])},this.oid="2.5.29.31","undefined"!=typeof t&&("undefined"!=typeof t.array?this.setByDPArray(t.array):"undefined"!=typeof t.uri&&this.setByOneURI(t.uri))},ir.lang.extend(KJUR.asn1.x509.CRLDistributionPoints,KJUR.asn1.x509.Extension),KJUR.asn1.x509.ExtKeyUsage=function(t){KJUR.asn1.x509.ExtKeyUsage.superclass.constructor.call(this,t),this.setPurposeArray=function(t){this.asn1ExtnValue=new KJUR.asn1.DERSequence;for(var e=0;e<t.length;e++){var n=new KJUR.asn1.DERObjectIdentifier(t[e]);this.asn1ExtnValue.appendASN1Object(n)}},this.getExtnValueHex=function(){return this.asn1ExtnValue.getEncodedHex()},this.oid="2.5.29.37","undefined"!=typeof t&&"undefined"!=typeof t.array&&this.setPurposeArray(t.array)},ir.lang.extend(KJUR.asn1.x509.ExtKeyUsage,KJUR.asn1.x509.Extension),KJUR.asn1.x509.AuthorityKeyIdentifier=function(t){KJUR.asn1.x509.AuthorityKeyIdentifier.superclass.constructor.call(this,t),this.asn1KID=null,this.asn1CertIssuer=null,this.asn1CertSN=null,this.getExtnValueHex=function(){var t=new Array;this.asn1KID&&t.push(new KJUR.asn1.DERTaggedObject({explicit:!1,tag:"80",obj:this.asn1KID})),this.asn1CertIssuer&&t.push(new KJUR.asn1.DERTaggedObject({explicit:!1,tag:"a1",obj:this.asn1CertIssuer})),this.asn1CertSN&&t.push(new KJUR.asn1.DERTaggedObject({explicit:!1,tag:"82",obj:this.asn1CertSN}));var e=new KJUR.asn1.DERSequence({array:t});return this.asn1ExtnValue=e,this.asn1ExtnValue.getEncodedHex()},this.setKIDByParam=function(t){this.asn1KID=new KJUR.asn1.DEROctetString(t)},this.setCertIssuerByParam=function(t){this.asn1CertIssuer=new KJUR.asn1.x509.X500Name(t)},this.setCertSNByParam=function(t){this.asn1CertSN=new KJUR.asn1.DERInteger(t)},this.oid="2.5.29.35","undefined"!=typeof t&&("undefined"!=typeof t.kid&&this.setKIDByParam(t.kid),"undefined"!=typeof t.issuer&&this.setCertIssuerByParam(t.issuer),"undefined"!=typeof t.sn&&this.setCertSNByParam(t.sn))},ir.lang.extend(KJUR.asn1.x509.AuthorityKeyIdentifier,KJUR.asn1.x509.Extension),KJUR.asn1.x509.CRL=function(t){KJUR.asn1.x509.CRL.superclass.constructor.call(this);this.setRsaPrvKeyByPEMandPass=function(t,e){var n=Or.getDecryptedKeyHex(t,e),r=new ve;r.readPrivateKeyFromASN1HexString(n),this.rsaPrvKey=r},this.sign=function(){this.asn1SignatureAlg=this.asn1TBSCertList.asn1SignatureAlg,sig=new KJUR.crypto.Signature({alg:"SHA1withRSA",prov:"cryptojs/jsrsa"}),sig.initSign(this.rsaPrvKey),sig.updateHex(this.asn1TBSCertList.getEncodedHex()),this.hexSig=sig.sign(),this.asn1Sig=new KJUR.asn1.DERBitString({hex:"00"+this.hexSig});var t=new KJUR.asn1.DERSequence({array:[this.asn1TBSCertList,this.asn1SignatureAlg,this.asn1Sig]});this.hTLV=t.getEncodedHex(),this.isModified=!1},this.getEncodedHex=function(){if(0==this.isModified&&null!=this.hTLV)return this.hTLV;throw"not signed yet"},this.getPEMString=function(){var t=this.getEncodedHex(),e=sr.enc.Hex.parse(t),n=sr.enc.Base64.stringify(e),r=n.replace(/(.{64})/g,"$1\r\n");return"-----BEGIN X509 CRL-----\r\n"+r+"\r\n-----END X509 CRL-----\r\n"},"undefined"!=typeof t&&("undefined"!=typeof t.tbsobj&&(this.asn1TBSCertList=t.tbsobj),"undefined"!=typeof t.rsaprvkey&&(this.rsaPrvKey=t.rsaprvkey),"undefined"!=typeof t.rsaprvpem&&"undefined"!=typeof t.rsaprvpas&&this.setRsaPrvKeyByPEMandPass(t.rsaprvpem,t.rsaprvpas))},ir.lang.extend(KJUR.asn1.x509.CRL,KJUR.asn1.ASN1Object),KJUR.asn1.x509.TBSCertList=function(t){KJUR.asn1.x509.TBSCertList.superclass.constructor.call(this);this.setSignatureAlgByParam=function(t){this.asn1SignatureAlg=new KJUR.asn1.x509.AlgorithmIdentifier(t)},this.setIssuerByParam=function(t){this.asn1Issuer=new KJUR.asn1.x509.X500Name(t)},this.setThisUpdateByParam=function(t){this.asn1ThisUpdate=new KJUR.asn1.x509.Time(t)},this.setNextUpdateByParam=function(t){this.asn1NextUpdate=new KJUR.asn1.x509.Time(t)},this.addRevokedCert=function(t,e){var n={};void 0!=t&&null!=t&&(n.sn=t),void 0!=e&&null!=e&&(n.time=e);var r=new KJUR.asn1.x509.CRLEntry(n);this.aRevokedCert.push(r)},this.getEncodedHex=function(){if(this.asn1Array=new Array,null!=this.asn1Version&&this.asn1Array.push(this.asn1Version),this.asn1Array.push(this.asn1SignatureAlg),this.asn1Array.push(this.asn1Issuer),this.asn1Array.push(this.asn1ThisUpdate),null!=this.asn1NextUpdate&&this.asn1Array.push(this.asn1NextUpdate),this.aRevokedCert.length>0){var t=new KJUR.asn1.DERSequence({array:this.aRevokedCert});this.asn1Array.push(t)}var e=new KJUR.asn1.DERSequence({array:this.asn1Array});return this.hTLV=e.getEncodedHex(),this.isModified=!1,this.hTLV},this._initialize=function(){this.asn1Version=null,this.asn1SignatureAlg=null,this.asn1Issuer=null,this.asn1ThisUpdate=null,this.asn1NextUpdate=null,this.aRevokedCert=new Array},this._initialize()},ir.lang.extend(KJUR.asn1.x509.TBSCertList,KJUR.asn1.ASN1Object),KJUR.asn1.x509.CRLEntry=function(t){KJUR.asn1.x509.CRLEntry.superclass.constructor.call(this);this.setCertSerial=function(t){this.sn=new KJUR.asn1.DERInteger(t)},this.setRevocationDate=function(t){this.time=new KJUR.asn1.x509.Time(t)},this.getEncodedHex=function(){var t=new KJUR.asn1.DERSequence({array:[this.sn,this.time]});return this.TLV=t.getEncodedHex(),this.TLV},"undefined"!=typeof t&&("undefined"!=typeof t.time&&this.setRevocationDate(t.time),"undefined"!=typeof t.sn&&this.setCertSerial(t.sn))},ir.lang.extend(KJUR.asn1.x509.CRLEntry,KJUR.asn1.ASN1Object),KJUR.asn1.x509.X500Name=function(t){if(KJUR.asn1.x509.X500Name.superclass.constructor.call(this),this.asn1Array=new Array,this.setByString=function(t){var e=t.split("/");e.shift();for(var n=0;n<e.length;n++)this.asn1Array.push(new KJUR.asn1.x509.RDN({str:e[n]}))},this.setByObject=function(t){for(var e in t)if(t.hasOwnProperty(e)){var n=new KJUR.asn1.x509.RDN({str:e+"="+t[e]});this.asn1Array?this.asn1Array.push(n):this.asn1Array=[n]}},this.getEncodedHex=function(){if("string"==typeof this.hTLV)return this.hTLV;var t=new KJUR.asn1.DERSequence({array:this.asn1Array});return this.hTLV=t.getEncodedHex(),this.hTLV},"undefined"!=typeof t){if("undefined"!=typeof t.str?this.setByString(t.str):"object"==typeof t&&this.setByObject(t),"undefined"!=typeof t.certissuer){var e=new Xn;e.hex=Xn.pemToHex(t.certissuer),this.hTLV=e.getIssuerHex()}if("undefined"!=typeof t.certsubject){var e=new Xn;e.hex=Xn.pemToHex(t.certsubject),this.hTLV=e.getSubjectHex()}}},ir.lang.extend(KJUR.asn1.x509.X500Name,KJUR.asn1.ASN1Object),KJUR.asn1.x509.RDN=function(t){KJUR.asn1.x509.RDN.superclass.constructor.call(this),this.asn1Array=new Array,this.addByString=function(t){this.asn1Array.push(new KJUR.asn1.x509.AttributeTypeAndValue({str:t}))},this.getEncodedHex=function(){var t=new KJUR.asn1.DERSet({array:this.asn1Array});return this.TLV=t.getEncodedHex(),this.TLV},"undefined"!=typeof t&&"undefined"!=typeof t.str&&this.addByString(t.str)},ir.lang.extend(KJUR.asn1.x509.RDN,KJUR.asn1.ASN1Object),KJUR.asn1.x509.AttributeTypeAndValue=function(t){KJUR.asn1.x509.AttributeTypeAndValue.superclass.constructor.call(this);var e="utf8";this.setByString=function(t){if(!t.match(/^([^=]+)=(.+)$/))throw"malformed attrTypeAndValueStr: "+t;this.setByAttrTypeAndValueStr(RegExp.$1,RegExp.$2)},this.setByAttrTypeAndValueStr=function(t,n){this.typeObj=KJUR.asn1.x509.OID.atype2obj(t);var r=e;"C"==t&&(r="prn"),this.valueObj=this.getValueObj(r,n)},this.getValueObj=function(t,e){if("utf8"==t)return new KJUR.asn1.DERUTF8String({str:e});if("prn"==t)return new KJUR.asn1.DERPrintableString({str:e});if("tel"==t)return new KJUR.asn1.DERTeletexString({str:e});if("ia5"==t)return new KJUR.asn1.DERIA5String({str:e});throw"unsupported directory string type: type="+t+" value="+e},this.getEncodedHex=function(){var t=new KJUR.asn1.DERSequence({array:[this.typeObj,this.valueObj]});return this.TLV=t.getEncodedHex(),this.TLV},"undefined"!=typeof t&&"undefined"!=typeof t.str&&this.setByString(t.str)},ir.lang.extend(KJUR.asn1.x509.AttributeTypeAndValue,KJUR.asn1.ASN1Object),KJUR.asn1.x509.SubjectPublicKeyInfo=function(t){KJUR.asn1.x509.SubjectPublicKeyInfo.superclass.constructor.call(this);this.setRSAKey=function(t){if(!ve.prototype.isPrototypeOf(t))throw"argument is not RSAKey instance";this.rsaKey=t;var e=new KJUR.asn1.DERInteger({bigint:t.n}),n=new KJUR.asn1.DERInteger({"int":t.e}),r=new KJUR.asn1.DERSequence({array:[e,n]}),i=r.getEncodedHex();this.asn1AlgId=new KJUR.asn1.x509.AlgorithmIdentifier({name:"rsaEncryption"}),this.asn1SubjPKey=new KJUR.asn1.DERBitString({hex:"00"+i})},this.setRSAPEM=function(t){if(!t.match(/-----BEGIN PUBLIC KEY-----/))throw"key not supported";var e=t;e=e.replace(/^-----[^-]+-----/,""),e=e.replace(/-----[^-]+-----\s*$/,"");var n=e.replace(/\s+/g,""),r=sr.enc.Base64.parse(n),i=sr.enc.Hex.stringify(r),s=Un(i),o=s[1],a=o.substr(2),u=Un(a),c=new ve;c.setPublic(u[0],u[1]),this.setRSAKey(c)},this.getASN1Object=function(){if(null==this.asn1AlgId||null==this.asn1SubjPKey)throw"algId and/or subjPubKey not set";var t=new KJUR.asn1.DERSequence({array:[this.asn1AlgId,this.asn1SubjPKey]});return t},this.getEncodedHex=function(){var t=this.getASN1Object();return this.hTLV=t.getEncodedHex(),this.hTLV},this._setRSAKey=function(t){var e=KJUR.asn1.ASN1Util.newObject({seq:[{"int":{bigint:t.n}},{"int":{"int":t.e}}]}),n=e.getEncodedHex();this.asn1AlgId=new KJUR.asn1.x509.AlgorithmIdentifier({name:"rsaEncryption"}),this.asn1SubjPKey=new KJUR.asn1.DERBitString({hex:"00"+n})},this._setEC=function(t){var e=new KJUR.asn1.DERObjectIdentifier({name:t.curveName});this.asn1AlgId=new KJUR.asn1.x509.AlgorithmIdentifier({name:"ecPublicKey",asn1params:e}),this.asn1SubjPKey=new KJUR.asn1.DERBitString({hex:"00"+t.pubKeyHex})},this._setDSA=function(t){var e=new KJUR.asn1.ASN1Util.newObject({seq:[{"int":{bigint:t.p}},{"int":{bigint:t.q}},{"int":{bigint:t.g}}]});this.asn1AlgId=new KJUR.asn1.x509.AlgorithmIdentifier({name:"dsa",asn1params:e});var n=new KJUR.asn1.DERInteger({bigint:t.y});this.asn1SubjPKey=new KJUR.asn1.DERBitString({hex:"00"+n.getEncodedHex()})},"undefined"!=typeof t&&("undefined"!=typeof ve&&t instanceof ve?this._setRSAKey(t):"undefined"!=typeof KJUR.crypto.ECDSA&&t instanceof KJUR.crypto.ECDSA?this._setEC(t):"undefined"!=typeof KJUR.crypto.DSA&&t instanceof KJUR.crypto.DSA?this._setDSA(t):"undefined"!=typeof t.rsakey?this.setRSAKey(t.rsakey):"undefined"!=typeof t.rsapem&&this.setRSAPEM(t.rsapem))},ir.lang.extend(KJUR.asn1.x509.SubjectPublicKeyInfo,KJUR.asn1.ASN1Object),KJUR.asn1.x509.Time=function(t){KJUR.asn1.x509.Time.superclass.constructor.call(this);this.setTimeParams=function(t){this.timeParams=t},this.getEncodedHex=function(){var t=null;return t=null!=this.timeParams?"utc"==this.type?new KJUR.asn1.DERUTCTime(this.timeParams):new KJUR.asn1.DERGeneralizedTime(this.timeParams):"utc"==this.type?new KJUR.asn1.DERUTCTime:new KJUR.asn1.DERGeneralizedTime,this.TLV=t.getEncodedHex(),this.TLV},this.type="utc","undefined"!=typeof t&&("undefined"!=typeof t.type?this.type=t.type:"undefined"!=typeof t.str&&(t.str.match(/^[0-9]{12}Z$/)&&(this.type="utc"),t.str.match(/^[0-9]{14}Z$/)&&(this.type="gen")),this.timeParams=t)},ir.lang.extend(KJUR.asn1.x509.Time,KJUR.asn1.ASN1Object),KJUR.asn1.x509.AlgorithmIdentifier=function(t){KJUR.asn1.x509.AlgorithmIdentifier.superclass.constructor.call(this);this.getEncodedHex=function(){if(null==this.nameAlg&&null==this.asn1Alg)throw"algorithm not specified";null!=this.nameAlg&&null==this.asn1Alg&&(this.asn1Alg=KJUR.asn1.x509.OID.name2obj(this.nameAlg));var t=[this.asn1Alg];this.paramEmpty||t.push(this.asn1Params);var e=new KJUR.asn1.DERSequence({array:t});return this.hTLV=e.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&("undefined"!=typeof t.name&&(this.nameAlg=t.name),"undefined"!=typeof t.asn1params&&(this.asn1Params=t.asn1params),"undefined"!=typeof t.paramempty&&(this.paramEmpty=t.paramempty)),null==this.asn1Params&&(this.asn1Params=new KJUR.asn1.DERNull)},ir.lang.extend(KJUR.asn1.x509.AlgorithmIdentifier,KJUR.asn1.ASN1Object),KJUR.asn1.x509.GeneralName=function(t){KJUR.asn1.x509.GeneralName.superclass.constructor.call(this);var e={rfc822:"81",dns:"82",dn:"a4",uri:"86"};this.explicit=!1,this.setByParam=function(t){var n=null;if("undefined"!=typeof t){if("undefined"!=typeof t.rfc822&&(this.type="rfc822",n=new KJUR.asn1.DERIA5String({str:t[this.type]})),"undefined"!=typeof t.dns&&(this.type="dns",n=new KJUR.asn1.DERIA5String({str:t[this.type]})),"undefined"!=typeof t.uri&&(this.type="uri",n=new KJUR.asn1.DERIA5String({str:t[this.type]})),"undefined"!=typeof t.certissuer){this.type="dn",this.explicit=!0;var r=t.certissuer,i=null;if(r.match(/^[0-9A-Fa-f]+$/),-1!=r.indexOf("-----BEGIN ")&&(i=Xn.pemToHex(r)),null==i)throw"certissuer param not cert";var s=new Xn;s.hex=i;var o=s.getIssuerHex();n=new KJUR.asn1.ASN1Object,n.hTLV=o}if("undefined"!=typeof t.certsubj){this.type="dn",this.explicit=!0;var r=t.certsubj,i=null;if(r.match(/^[0-9A-Fa-f]+$/),-1!=r.indexOf("-----BEGIN ")&&(i=Xn.pemToHex(r)),null==i)throw"certsubj param not cert";var s=new Xn;s.hex=i;var o=s.getSubjectHex();n=new KJUR.asn1.ASN1Object,n.hTLV=o}if(null==this.type)throw"unsupported type in params="+t;this.asn1Obj=new KJUR.asn1.DERTaggedObject({explicit:this.explicit,tag:e[this.type],obj:n})}},this.getEncodedHex=function(){return this.asn1Obj.getEncodedHex()},"undefined"!=typeof t&&this.setByParam(t)},ir.lang.extend(KJUR.asn1.x509.GeneralName,KJUR.asn1.ASN1Object),KJUR.asn1.x509.GeneralNames=function(t){KJUR.asn1.x509.GeneralNames.superclass.constructor.call(this);this.setByParamArray=function(t){for(var e=0;e<t.length;e++){var n=new KJUR.asn1.x509.GeneralName(t[e]);this.asn1Array.push(n)}},this.getEncodedHex=function(){var t=new KJUR.asn1.DERSequence({array:this.asn1Array});return t.getEncodedHex()},this.asn1Array=new Array,"undefined"!=typeof t&&this.setByParamArray(t)},ir.lang.extend(KJUR.asn1.x509.GeneralNames,KJUR.asn1.ASN1Object),KJUR.asn1.x509.DistributionPointName=function(t){KJUR.asn1.x509.DistributionPointName.superclass.constructor.call(this);if(this.getEncodedHex=function(){if("full"!=this.type)throw"currently type shall be 'full': "+this.type;return this.asn1Obj=new KJUR.asn1.DERTaggedObject({explicit:!1,tag:this.tag,obj:this.asn1V}),this.hTLV=this.asn1Obj.getEncodedHex(),this.hTLV},"undefined"!=typeof t){if(!KJUR.asn1.x509.GeneralNames.prototype.isPrototypeOf(t))throw"This class supports GeneralNames only as argument";this.type="full",this.tag="a0",this.asn1V=t}},ir.lang.extend(KJUR.asn1.x509.DistributionPointName,KJUR.asn1.ASN1Object),KJUR.asn1.x509.DistributionPoint=function(t){KJUR.asn1.x509.DistributionPoint.superclass.constructor.call(this);this.getEncodedHex=function(){var t=new KJUR.asn1.DERSequence;if(null!=this.asn1DP){var e=new KJUR.asn1.DERTaggedObject({explicit:!0,tag:"a0",obj:this.asn1DP});t.appendASN1Object(e)}return this.hTLV=t.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&"undefined"!=typeof t.dpobj&&(this.asn1DP=t.dpobj)},ir.lang.extend(KJUR.asn1.x509.DistributionPoint,KJUR.asn1.ASN1Object),KJUR.asn1.x509.OID=new function(t){this.atype2oidList={C:"2.5.4.6",O:"2.5.4.10",OU:"2.5.4.11",ST:"2.5.4.8",L:"2.5.4.7",CN:"2.5.4.3",SN:"2.5.4.4",DN:"2.5.4.49",DC:"0.9.2342.19200300.100.1.25"},this.name2oidList={sha1:"1.3.14.3.2.26",sha256:"2.16.840.1.101.3.4.2.1",sha384:"2.16.840.1.101.3.4.2.2",sha512:"2.16.840.1.101.3.4.2.3",sha224:"2.16.840.1.101.3.4.2.4",md5:"1.2.840.113549.2.5",md2:"1.3.14.7.2.2.1",ripemd160:"1.3.36.3.2.1",MD2withRSA:"1.2.840.113549.1.1.2",MD4withRSA:"1.2.840.113549.1.1.3",MD5withRSA:"1.2.840.113549.1.1.4",SHA1withRSA:"1.2.840.113549.1.1.5",SHA224withRSA:"1.2.840.113549.1.1.14",SHA256withRSA:"1.2.840.113549.1.1.11",SHA384withRSA:"1.2.840.113549.1.1.12",SHA512withRSA:"1.2.840.113549.1.1.13",SHA1withECDSA:"1.2.840.10045.4.1",SHA224withECDSA:"1.2.840.10045.4.3.1",SHA256withECDSA:"1.2.840.10045.4.3.2",SHA384withECDSA:"1.2.840.10045.4.3.3",SHA512withECDSA:"1.2.840.10045.4.3.4",dsa:"1.2.840.10040.4.1",SHA1withDSA:"1.2.840.10040.4.3",SHA224withDSA:"2.16.840.1.101.3.4.3.1",SHA256withDSA:"2.16.840.1.101.3.4.3.2",rsaEncryption:"1.2.840.113549.1.1.1",countryName:"2.5.4.6",organization:"2.5.4.10",organizationalUnit:"2.5.4.11",stateOrProvinceName:"2.5.4.8",locality:"2.5.4.7",commonName:"2.5.4.3",subjectKeyIdentifier:"2.5.29.14",keyUsage:"2.5.29.15",subjectAltName:"2.5.29.17",basicConstraints:"2.5.29.19",nameConstraints:"2.5.29.30",cRLDistributionPoints:"2.5.29.31",certificatePolicies:"2.5.29.32",authorityKeyIdentifier:"2.5.29.35",policyConstraints:"2.5.29.36",extKeyUsage:"2.5.29.37",authorityInfoAccess:"1.3.6.1.5.5.7.1.1",anyExtendedKeyUsage:"2.5.29.37.0",serverAuth:"1.3.6.1.5.5.7.3.1",clientAuth:"1.3.6.1.5.5.7.3.2",codeSigning:"1.3.6.1.5.5.7.3.3",emailProtection:"1.3.6.1.5.5.7.3.4",timeStamping:"1.3.6.1.5.5.7.3.8",ocspSigning:"1.3.6.1.5.5.7.3.9",ecPublicKey:"1.2.840.10045.2.1",secp256r1:"1.2.840.10045.3.1.7",secp256k1:"1.3.132.0.10",secp384r1:"1.3.132.0.34",pkcs5PBES2:"1.2.840.113549.1.5.13",pkcs5PBKDF2:"1.2.840.113549.1.5.12","des-EDE3-CBC":"1.2.840.113549.3.7",data:"1.2.840.113549.1.7.1","signed-data":"1.2.840.113549.1.7.2","enveloped-data":"1.2.840.113549.1.7.3","digested-data":"1.2.840.113549.1.7.5","encrypted-data":"1.2.840.113549.1.7.6","authenticated-data":"1.2.840.113549.1.9.16.1.2",tstinfo:"1.2.840.113549.1.9.16.1.4"},this.objCache={},this.name2obj=function(t){if("undefined"!=typeof this.objCache[t])return this.objCache[t];if("undefined"==typeof this.name2oidList[t])throw"Name of ObjectIdentifier not defined: "+t;var e=this.name2oidList[t],n=new KJUR.asn1.DERObjectIdentifier({oid:e});return this.objCache[t]=n,n},this.atype2obj=function(t){if("undefined"!=typeof this.objCache[t])return this.objCache[t];if("undefined"==typeof this.atype2oidList[t])throw"AttributeType name undefined: "+t;var e=this.atype2oidList[t],n=new KJUR.asn1.DERObjectIdentifier({oid:e});return this.objCache[t]=n,n}},KJUR.asn1.x509.OID.oid2name=function(t){var e=KJUR.asn1.x509.OID.name2oidList;for(var n in e)if(e[n]==t)return n;return""},KJUR.asn1.x509.OID.name2oid=function(t){var e=KJUR.asn1.x509.OID.name2oidList;return void 0===e[t]?"":e[t]},KJUR.asn1.x509.X509Util=new function(){this.getPKCS8PubKeyPEMfromRSAKey=function(t){var e=null,n=KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t.n),r=KJUR.asn1.ASN1Util.integerToByteHex(t.e),i=new KJUR.asn1.DERInteger({hex:n}),s=new KJUR.asn1.DERInteger({hex:r}),o=new KJUR.asn1.DERSequence({array:[i,s]}),a=o.getEncodedHex(),u=new KJUR.asn1.x509.AlgorithmIdentifier({name:"rsaEncryption"}),c=new KJUR.asn1.DERBitString({hex:"00"+a}),f=new KJUR.asn1.DERSequence({array:[u,c]}),h=f.getEncodedHex(),e=KJUR.asn1.ASN1Util.getPEMStringFromHex(h,"PUBLIC KEY");return e}},KJUR.asn1.x509.X509Util.newCertPEM=function(t){var e=KJUR.asn1.x509,n=new e.TBSCertificate;if(void 0===t.serial)throw"serial number undefined.";if(n.setSerialNumberByParam(t.serial),"string"!=typeof t.sigalg.name)throw"unproper signature algorithm name";if(n.setSignatureAlgByParam(t.sigalg),void 0===t.issuer)throw"issuer name undefined.";if(n.setIssuerByParam(t.issuer),void 0===t.notbefore)throw"notbefore undefined.";if(n.setNotBeforeByParam(t.notbefore),void 0===t.notafter)throw"notafter undefined.";if(n.setNotAfterByParam(t.notafter),void 0===t.subject)throw"subject name undefined.";if(n.setSubjectByParam(t.subject),void 0===t.sbjpubkey)throw"subject public key undefined.";if(n.setSubjectPublicKeyByGetKey(t.sbjpubkey),void 0!==t.ext&&void 0!==t.ext.length)for(var r=0;r<t.ext.length;r++)for(key in t.ext[r])n.appendExtensionByName(key,t.ext[r][key]);if(void 0===t.cakey&&void 0===t.sighex)throw"param cakey and sighex undefined.";var i=null,s=null;return t.cakey&&(i=Cr.getKey.apply(null,t.cakey),s=new e.Certificate({tbscertobj:n,prvkeyobj:i}),s.sign()),t.sighex&&(s=new e.Certificate({tbscertobj:n}),s.setSignatureHex(t.sighex)),s.getPEMString()},/*! asn1cms-1.0.2.js (c) 2013-2014 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
"undefined"!=typeof KJUR&&KJUR||(KJUR={}),"undefined"!=typeof KJUR.asn1&&KJUR.asn1||(KJUR.asn1={}),"undefined"!=typeof KJUR.asn1.cms&&KJUR.asn1.cms||(KJUR.asn1.cms={}),KJUR.asn1.cms.Attribute=function(t){KJUR.asn1.cms.Attribute.superclass.constructor.call(this);this.getEncodedHex=function(){var t,e,n;t=new KJUR.asn1.DERObjectIdentifier({oid:this.attrTypeOid}),e=new KJUR.asn1.DERSet({array:this.valueList});try{e.getEncodedHex()}catch(r){throw"fail valueSet.getEncodedHex in Attribute(1)/"+r}n=new KJUR.asn1.DERSequence({array:[t,e]});try{this.hTLV=n.getEncodedHex()}catch(r){throw"failed seq.getEncodedHex in Attribute(2)/"+r}return this.hTLV}},ir.lang.extend(KJUR.asn1.cms.Attribute,KJUR.asn1.ASN1Object),KJUR.asn1.cms.ContentType=function(t){KJUR.asn1.cms.ContentType.superclass.constructor.call(this),this.attrTypeOid="1.2.840.113549.1.9.3";var e=null;if("undefined"!=typeof t){var e=new KJUR.asn1.DERObjectIdentifier(t);this.valueList=[e]}},ir.lang.extend(KJUR.asn1.cms.ContentType,KJUR.asn1.cms.Attribute),KJUR.asn1.cms.MessageDigest=function(t){if(KJUR.asn1.cms.MessageDigest.superclass.constructor.call(this),this.attrTypeOid="1.2.840.113549.1.9.4","undefined"!=typeof t)if(t.eciObj instanceof KJUR.asn1.cms.EncapsulatedContentInfo&&"string"==typeof t.hashAlg){var e=t.eciObj.eContentValueHex,n=t.hashAlg,r=KJUR.crypto.Util.hashHex(e,n),i=new KJUR.asn1.DEROctetString({hex:r});i.getEncodedHex(),this.valueList=[i]}else{var i=new KJUR.asn1.DEROctetString(t);i.getEncodedHex(),this.valueList=[i]}},ir.lang.extend(KJUR.asn1.cms.MessageDigest,KJUR.asn1.cms.Attribute),KJUR.asn1.cms.SigningTime=function(t){if(KJUR.asn1.cms.SigningTime.superclass.constructor.call(this),this.attrTypeOid="1.2.840.113549.1.9.5","undefined"!=typeof t){var e=new KJUR.asn1.x509.Time(t);try{e.getEncodedHex()}catch(n){throw"SigningTime.getEncodedHex() failed/"+n}this.valueList=[e]}},ir.lang.extend(KJUR.asn1.cms.SigningTime,KJUR.asn1.cms.Attribute),KJUR.asn1.cms.SigningCertificate=function(t){KJUR.asn1.cms.SigningCertificate.superclass.constructor.call(this),this.attrTypeOid="1.2.840.113549.1.9.16.2.12";var e=KJUR.asn1,n=KJUR.asn1.cms,r=KJUR.crypto;this.setCerts=function(t){for(var i=[],s=0;s<t.length;s++){var o=Cr.getHexFromPEM(t[s]),a=r.Util.hashHex(o,"sha1"),u=new e.DEROctetString({hex:a});u.getEncodedHex();var c=new n.IssuerAndSerialNumber({cert:t[s]});c.getEncodedHex();var f=new e.DERSequence({array:[u,c]});f.getEncodedHex(),i.push(f)}var h=new e.DERSequence({array:i});h.getEncodedHex(),this.valueList=[h]},"undefined"!=typeof t&&"object"==typeof t.array&&this.setCerts(t.array)},ir.lang.extend(KJUR.asn1.cms.SigningCertificate,KJUR.asn1.cms.Attribute),KJUR.asn1.cms.SigningCertificateV2=function(t){KJUR.asn1.cms.SigningCertificateV2.superclass.constructor.call(this),this.attrTypeOid="1.2.840.113549.1.9.16.2.47";var e=KJUR.asn1,n=KJUR.asn1.x509,r=KJUR.asn1.cms,i=KJUR.crypto;if(this.setCerts=function(t,s){for(var o=[],a=0;a<t.length;a++){var u=Cr.getHexFromPEM(t[a]),c=[];"sha256"!=s&&c.push(new n.AlgorithmIdentifier({name:s}));var f=i.Util.hashHex(u,s),h=new e.DEROctetString({hex:f});h.getEncodedHex(),c.push(h);var l=new r.IssuerAndSerialNumber({cert:t[a]});l.getEncodedHex(),c.push(l);var d=new e.DERSequence({array:c});d.getEncodedHex(),o.push(d)}var p=new e.DERSequence({array:o});p.getEncodedHex(),this.valueList=[p]},"undefined"!=typeof t&&"object"==typeof t.array){var s="sha256";"string"==typeof t.hashAlg&&(s=t.hashAlg),this.setCerts(t.array,s)}},ir.lang.extend(KJUR.asn1.cms.SigningCertificateV2,KJUR.asn1.cms.Attribute),KJUR.asn1.cms.IssuerAndSerialNumber=function(t){KJUR.asn1.cms.IssuerAndSerialNumber.superclass.constructor.call(this);var e=KJUR.asn1,n=e.x509;this.setByCertPEM=function(t){var r=Cr.getHexFromPEM(t),i=new Xn;i.hex=r;var s=i.getIssuerHex();this.dIssuer=new n.X500Name,this.dIssuer.hTLV=s;var o=i.getSerialNumberHex();this.dSerial=new e.DERInteger({hex:o})},this.getEncodedHex=function(){var t=new KJUR.asn1.DERSequence({array:[this.dIssuer,this.dSerial]});return this.hTLV=t.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&("string"==typeof t&&-1!=t.indexOf("-----BEGIN ")&&this.setByCertPEM(t),t.issuer&&t.serial&&(t.issuer instanceof KJUR.asn1.x509.X500Name?this.dIssuer=t.issuer:this.dIssuer=new KJUR.asn1.x509.X500Name(t.issuer),t.serial instanceof KJUR.asn1.DERInteger?this.dSerial=t.serial:this.dSerial=new KJUR.asn1.DERInteger(t.serial)),"string"==typeof t.cert&&this.setByCertPEM(t.cert))},ir.lang.extend(KJUR.asn1.cms.IssuerAndSerialNumber,KJUR.asn1.ASN1Object),KJUR.asn1.cms.AttributeList=function(t){KJUR.asn1.cms.AttributeList.superclass.constructor.call(this),this.list=new Array,this.sortFlag=!0,this.add=function(t){t instanceof KJUR.asn1.cms.Attribute&&this.list.push(t)},this.length=function(){return this.list.length},this.clear=function(){this.list=new Array,this.hTLV=null,this.hV=null},this.getEncodedHex=function(){if("string"==typeof this.hTLV)return this.hTLV;var t=new KJUR.asn1.DERSet({array:this.list,sortflag:this.sortFlag});return this.hTLV=t.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&"undefined"!=typeof t.sortflag&&0==t.sortflag&&(this.sortFlag=!1)},ir.lang.extend(KJUR.asn1.cms.AttributeList,KJUR.asn1.ASN1Object),KJUR.asn1.cms.SignerInfo=function(t){KJUR.asn1.cms.SignerInfo.superclass.constructor.call(this);var e=KJUR.asn1,n=KJUR.asn1.cms,r=KJUR.asn1.x509;this.dCMSVersion=new e.DERInteger({"int":1}),this.dSignerIdentifier=null,this.dDigestAlgorithm=null,this.dSignedAttrs=new n.AttributeList,this.dSigAlg=null,this.dSig=null,this.dUnsignedAttrs=new n.AttributeList,this.setSignerIdentifier=function(t){if("string"==typeof t&&-1!=t.indexOf("CERTIFICATE")&&-1!=t.indexOf("BEGIN")&&-1!=t.indexOf("END")){this.dSignerIdentifier=new n.IssuerAndSerialNumber({cert:t})}},this.setForContentAndHash=function(t){"undefined"!=typeof t&&(t.eciObj instanceof KJUR.asn1.cms.EncapsulatedContentInfo&&(this.dSignedAttrs.add(new n.ContentType({oid:"1.2.840.113549.1.7.1"})),this.dSignedAttrs.add(new n.MessageDigest({eciObj:t.eciObj,hashAlg:t.hashAlg}))),"undefined"!=typeof t.sdObj&&t.sdObj instanceof KJUR.asn1.cms.SignedData&&-1==t.sdObj.digestAlgNameList.join(":").indexOf(t.hashAlg)&&t.sdObj.digestAlgNameList.push(t.hashAlg),"string"==typeof t.hashAlg&&(this.dDigestAlgorithm=new r.AlgorithmIdentifier({name:t.hashAlg})))},this.sign=function(t,n){this.dSigAlg=new r.AlgorithmIdentifier({name:n});var i=this.dSignedAttrs.getEncodedHex(),s=Cr.getKey(t),o=new KJUR.crypto.Signature({alg:n});o.init(s),o.updateHex(i);var a=o.sign();this.dSig=new e.DEROctetString({hex:a})},this.addUnsigned=function(t){this.hTLV=null,this.dUnsignedAttrs.hTLV=null,this.dUnsignedAttrs.add(t)},this.getEncodedHex=function(){if(this.dSignedAttrs instanceof KJUR.asn1.cms.AttributeList&&0==this.dSignedAttrs.length())throw"SignedAttrs length = 0 (empty)";var t=new e.DERTaggedObject({obj:this.dSignedAttrs,tag:"a0",explicit:!1}),n=null;this.dUnsignedAttrs.length()>0&&(n=new e.DERTaggedObject({obj:this.dUnsignedAttrs,tag:"a1",explicit:!1}));var r=[this.dCMSVersion,this.dSignerIdentifier,this.dDigestAlgorithm,t,this.dSigAlg,this.dSig];null!=n&&r.push(n);var i=new e.DERSequence({array:r});return this.hTLV=i.getEncodedHex(),this.hTLV}},ir.lang.extend(KJUR.asn1.cms.SignerInfo,KJUR.asn1.ASN1Object),KJUR.asn1.cms.EncapsulatedContentInfo=function(t){KJUR.asn1.cms.EncapsulatedContentInfo.superclass.constructor.call(this);var e=KJUR.asn1;KJUR.asn1.cms,KJUR.asn1.x509;this.dEContentType=new e.DERObjectIdentifier({name:"data"}),this.dEContent=null,this.isDetached=!1,this.eContentValueHex=null,this.setContentType=function(t){t.match(/^[0-2][.][0-9.]+$/)?this.dEContentType=new e.DERObjectIdentifier({oid:t}):this.dEContentType=new e.DERObjectIdentifier({name:t})},this.setContentValue=function(t){"undefined"!=typeof t&&("string"==typeof t.hex?this.eContentValueHex=t.hex:"string"==typeof t.str&&(this.eContentValueHex=mn(t.str)))},this.setContentValueHex=function(t){this.eContentValueHex=t},this.setContentValueStr=function(t){this.eContentValueHex=mn(t)},this.getEncodedHex=function(){if("string"!=typeof this.eContentValueHex)throw"eContentValue not yet set";var t=new e.DEROctetString({hex:this.eContentValueHex});this.dEContent=new e.DERTaggedObject({obj:t,tag:"a0",explicit:!0});var n=[this.dEContentType];this.isDetached||n.push(this.dEContent);var r=new e.DERSequence({array:n});return this.hTLV=r.getEncodedHex(),this.hTLV}},ir.lang.extend(KJUR.asn1.cms.EncapsulatedContentInfo,KJUR.asn1.ASN1Object),KJUR.asn1.cms.ContentInfo=function(t){KJUR.asn1.cms.ContentInfo.superclass.constructor.call(this);var e=KJUR.asn1,n=(KJUR.asn1.cms,KJUR.asn1.x509);this.dContentType=null,this.dContent=null,this.setContentType=function(t){"string"==typeof t&&(this.dContentType=n.OID.name2obj(t))},this.getEncodedHex=function(){var t=new e.DERTaggedObject({obj:this.dContent,tag:"a0",explicit:!0}),n=new e.DERSequence({array:[this.dContentType,t]});return this.hTLV=n.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&(t.type&&this.setContentType(t.type),t.obj&&t.obj instanceof e.ASN1Object&&(this.dContent=t.obj))},ir.lang.extend(KJUR.asn1.cms.ContentInfo,KJUR.asn1.ASN1Object),KJUR.asn1.cms.SignedData=function(t){KJUR.asn1.cms.SignedData.superclass.constructor.call(this);var e=KJUR.asn1,n=KJUR.asn1.cms,r=KJUR.asn1.x509;this.dCMSVersion=new e.DERInteger({"int":1}),this.dDigestAlgs=null,this.digestAlgNameList=[],this.dEncapContentInfo=new n.EncapsulatedContentInfo,this.dCerts=null,this.certificateList=[],this.crlList=[],this.signerInfoList=[new n.SignerInfo],this.addCertificatesByPEM=function(t){var n=Cr.getHexFromPEM(t),r=new e.ASN1Object;r.hTLV=n,this.certificateList.push(r)},this.getEncodedHex=function(){if("string"==typeof this.hTLV)return this.hTLV;if(null==this.dDigestAlgs){for(var t=[],n=0;n<this.digestAlgNameList.length;n++){var i=this.digestAlgNameList[n],s=new r.AlgorithmIdentifier({name:i});t.push(s)}this.dDigestAlgs=new e.DERSet({array:t})}var o=[this.dCMSVersion,this.dDigestAlgs,this.dEncapContentInfo];if(null==this.dCerts&&this.certificateList.length>0){var a=new e.DERSet({array:this.certificateList});this.dCerts=new e.DERTaggedObject({obj:a,tag:"a0",explicit:!1})}null!=this.dCerts&&o.push(this.dCerts);var u=new e.DERSet({array:this.signerInfoList});o.push(u);var c=new e.DERSequence({array:o});return this.hTLV=c.getEncodedHex(),this.hTLV},this.getContentInfo=function(){this.getEncodedHex();var t=new n.ContentInfo({type:"signed-data",obj:this});return t},this.getContentInfoEncodedHex=function(){var t=this.getContentInfo(),e=t.getEncodedHex();return e},this.getPEM=function(){var t=this.getContentInfoEncodedHex(),n=e.ASN1Util.getPEMStringFromHex(t,"CMS");return n}},ir.lang.extend(KJUR.asn1.cms.SignedData,KJUR.asn1.ASN1Object),KJUR.asn1.cms.CMSUtil=new function(){},KJUR.asn1.cms.CMSUtil.newSignedData=function(t){var e=KJUR.asn1.cms,n=KJUR.asn1.cades,r=new e.SignedData;if(r.dEncapContentInfo.setContentValue(t.content),"object"==typeof t.certs)for(var i=0;i<t.certs.length;i++)r.addCertificatesByPEM(t.certs[i]);r.signerInfoList=[];for(var i=0;i<t.signerInfos.length;i++){var s=t.signerInfos[i],o=new e.SignerInfo;o.setSignerIdentifier(s.signerCert),o.setForContentAndHash({sdObj:r,eciObj:r.dEncapContentInfo,hashAlg:s.hashAlg});for(attrName in s.sAttr){var a=s.sAttr[attrName];if("SigningTime"==attrName){var u=new e.SigningTime(a);o.dSignedAttrs.add(u)}if("SigningCertificate"==attrName){var u=new e.SigningCertificate(a);o.dSignedAttrs.add(u)}if("SigningCertificateV2"==attrName){var u=new e.SigningCertificateV2(a);o.dSignedAttrs.add(u)}if("SignaturePolicyIdentifier"==attrName){var u=new n.SignaturePolicyIdentifier(a);o.dSignedAttrs.add(u)}}o.sign(s.signerPrvKey,s.sigAlg),r.signerInfoList.push(o)}return r},/*! asn1tsp-1.0.1.js (c) 2014 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
"undefined"!=typeof KJUR&&KJUR||(KJUR={}),"undefined"!=typeof KJUR.asn1&&KJUR.asn1||(KJUR.asn1={}),"undefined"!=typeof KJUR.asn1.tsp&&KJUR.asn1.tsp||(KJUR.asn1.tsp={}),KJUR.asn1.tsp.Accuracy=function(t){KJUR.asn1.tsp.Accuracy.superclass.constructor.call(this);var e=KJUR.asn1;this.seconds=null,this.millis=null,this.micros=null,this.getEncodedHex=function(){var t=null,n=null,r=null,i=[];if(null!=this.seconds&&(t=new e.DERInteger({"int":this.seconds}),i.push(t)),null!=this.millis){var s=new e.DERInteger({"int":this.millis});n=new e.DERTaggedObject({obj:s,tag:"80",explicit:!1}),i.push(n)}if(null!=this.micros){var o=new e.DERInteger({"int":this.micros});r=new e.DERTaggedObject({obj:o,tag:"81",explicit:!1}),i.push(r)}var a=new e.DERSequence({array:i});return this.hTLV=a.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&("number"==typeof t.seconds&&(this.seconds=t.seconds),"number"==typeof t.millis&&(this.millis=t.millis),"number"==typeof t.micros&&(this.micros=t.micros))},ir.lang.extend(KJUR.asn1.tsp.Accuracy,KJUR.asn1.ASN1Object),KJUR.asn1.tsp.MessageImprint=function(t){KJUR.asn1.tsp.MessageImprint.superclass.constructor.call(this);var e=KJUR.asn1,n=KJUR.asn1.x509;this.dHashAlg=null,this.dHashValue=null,this.getEncodedHex=function(){if("string"==typeof this.hTLV)return this.hTLV;var t=new e.DERSequence({array:[this.dHashAlg,this.dHashValue]});return t.getEncodedHex()},"undefined"!=typeof t&&("string"==typeof t.hashAlg&&(this.dHashAlg=new n.AlgorithmIdentifier({name:t.hashAlg})),"string"==typeof t.hashValue&&(this.dHashValue=new e.DEROctetString({hex:t.hashValue})))},ir.lang.extend(KJUR.asn1.tsp.MessageImprint,KJUR.asn1.ASN1Object),KJUR.asn1.tsp.TimeStampReq=function(t){KJUR.asn1.tsp.TimeStampReq.superclass.constructor.call(this);var e=KJUR.asn1,n=KJUR.asn1.tsp;this.dVersion=new e.DERInteger({"int":1}),this.dMessageImprint=null,this.dPolicy=null,this.dNonce=null,this.certReq=!0,this.setMessageImprint=function(t){return t instanceof KJUR.asn1.tsp.MessageImprint?void(this.dMessageImprint=t):void("object"==typeof t&&(this.dMessageImprint=new n.MessageImprint(t)))},this.getEncodedHex=function(){if(null==this.dMessageImprint)throw"messageImprint shall be specified";var t=[this.dVersion,this.dMessageImprint];null!=this.dPolicy&&t.push(this.dPolicy),null!=this.dNonce&&t.push(this.dNonce),this.certReq&&t.push(new e.DERBoolean);var n=new e.DERSequence({array:t});return this.hTLV=n.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&("object"==typeof t.mi&&this.setMessageImprint(t.mi),"object"==typeof t.policy&&(this.dPolicy=new e.DERObjectIdentifier(t.policy)),"object"==typeof t.nonce&&(this.dNonce=new e.DERInteger(t.nonce)),"boolean"==typeof t.certreq&&(this.certReq=t.certreq))},ir.lang.extend(KJUR.asn1.tsp.TimeStampReq,KJUR.asn1.ASN1Object),KJUR.asn1.tsp.TSTInfo=function(t){KJUR.asn1.tsp.TSTInfo.superclass.constructor.call(this);var e=KJUR.asn1,n=KJUR.asn1.x509,r=KJUR.asn1.tsp;if(this.dVersion=new e.DERInteger({"int":1}),this.dPolicy=null,this.dMessageImprint=null,this.dSerialNumber=null,this.dGenTime=null,this.dAccuracy=null,this.dOrdering=null,this.dNonce=null,this.dTsa=null,this.getEncodedHex=function(){var t=[this.dVersion];if(null==this.dPolicy)throw"policy shall be specified.";if(t.push(this.dPolicy),null==this.dMessageImprint)throw"messageImprint shall be specified.";if(t.push(this.dMessageImprint),null==this.dSerialNumber)throw"serialNumber shall be specified.";if(t.push(this.dSerialNumber),null==this.dGenTime)throw"genTime shall be specified.";t.push(this.dGenTime),null!=this.dAccuracy&&t.push(this.dAccuracy),null!=this.dOrdering&&t.push(this.dOrdering),null!=this.dNonce&&t.push(this.dNonce),null!=this.dTsa&&t.push(this.dTsa);var n=new e.DERSequence({array:t});return this.hTLV=n.getEncodedHex(),this.hTLV},"undefined"!=typeof t){if("string"==typeof t.policy){if(!t.policy.match(/^[0-9.]+$/))throw"policy shall be oid like 0.1.4.134";this.dPolicy=new e.DERObjectIdentifier({oid:t.policy})}"undefined"!=typeof t.messageImprint&&(this.dMessageImprint=new r.MessageImprint(t.messageImprint)),"undefined"!=typeof t.serialNumber&&(this.dSerialNumber=new e.DERInteger(t.serialNumber)),"undefined"!=typeof t.genTime&&(this.dGenTime=new e.DERGeneralizedTime(t.genTime)),"undefind"!=typeof t.accuracy&&(this.dAccuracy=new r.Accuracy(t.accuracy)),"undefined"!=typeof t.ordering&&1==t.ordering&&(this.dOrdering=new e.DERBoolean),"undefined"!=typeof t.nonce&&(this.dNonce=new e.DERInteger(t.nonce)),"undefined"!=typeof t.tsa&&(this.dTsa=new n.X500Name(t.tsa))}},ir.lang.extend(KJUR.asn1.tsp.TSTInfo,KJUR.asn1.ASN1Object),KJUR.asn1.tsp.TimeStampResp=function(t){KJUR.asn1.tsp.TimeStampResp.superclass.constructor.call(this);var e=KJUR.asn1,n=KJUR.asn1.tsp;this.dStatus=null,this.dTST=null,this.getEncodedHex=function(){if(null==this.dStatus)throw"status shall be specified";var t=[this.dStatus];null!=this.dTST&&t.push(this.dTST);var n=new e.DERSequence({array:t});return this.hTLV=n.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&("object"==typeof t.status&&(this.dStatus=new n.PKIStatusInfo(t.status)),"undefined"!=typeof t.tst&&t.tst instanceof KJUR.asn1.ASN1Object&&(this.dTST=t.tst.getContentInfo()))},ir.lang.extend(KJUR.asn1.tsp.TimeStampResp,KJUR.asn1.ASN1Object),KJUR.asn1.tsp.PKIStatusInfo=function(t){KJUR.asn1.tsp.PKIStatusInfo.superclass.constructor.call(this);var e=KJUR.asn1,n=KJUR.asn1.tsp;this.dStatus=null,this.dStatusString=null,this.dFailureInfo=null,this.getEncodedHex=function(){if(null==this.dStatus)throw"status shall be specified";var t=[this.dStatus];null!=this.dStatusString&&t.push(this.dStatusString),null!=this.dFailureInfo&&t.push(this.dFailureInfo);var n=new e.DERSequence({array:t});return this.hTLV=n.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&("object"==typeof t.status&&(this.dStatus=new n.PKIStatus(t.status)),"object"==typeof t.statstr&&(this.dStatusString=new n.PKIFreeText({array:t.statstr})),"object"==typeof t.failinfo&&(this.dFailureInfo=new n.PKIFailureInfo(t.failinfo)))},ir.lang.extend(KJUR.asn1.tsp.PKIStatusInfo,KJUR.asn1.ASN1Object),KJUR.asn1.tsp.PKIStatus=function(t){KJUR.asn1.tsp.PKIStatus.superclass.constructor.call(this);var e=KJUR.asn1,n=KJUR.asn1.tsp;if(this.getEncodedHex=function(){return this.hTLV=this.dStatus.getEncodedHex(),this.hTLV},"undefined"!=typeof t)if("undefined"!=typeof t.name){var r=n.PKIStatus.valueList;if("undefined"==typeof r[t.name])throw"name undefined: "+t.name;this.dStatus=new e.DERInteger({"int":r[t.name]})}else this.dStatus=new e.DERInteger(t)},ir.lang.extend(KJUR.asn1.tsp.PKIStatus,KJUR.asn1.ASN1Object),KJUR.asn1.tsp.PKIStatus.valueList={granted:0,grantedWithMods:1,rejection:2,waiting:3,revocationWarning:4,revocationNotification:5},KJUR.asn1.tsp.PKIFreeText=function(t){KJUR.asn1.tsp.PKIFreeText.superclass.constructor.call(this);var e=KJUR.asn1;this.textList=[],this.getEncodedHex=function(){for(var t=[],n=0;n<this.textList.length;n++)t.push(new e.DERUTF8String({str:this.textList[n]}));var r=new e.DERSequence({array:t});return this.hTLV=r.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&"object"==typeof t.array&&(this.textList=t.array)},ir.lang.extend(KJUR.asn1.tsp.PKIFreeText,KJUR.asn1.ASN1Object),KJUR.asn1.tsp.PKIFailureInfo=function(t){KJUR.asn1.tsp.PKIFailureInfo.superclass.constructor.call(this);var e=KJUR.asn1,n=KJUR.asn1.tsp;if(this.value=null,this.getEncodedHex=function(){if(null==this.value)throw"value shall be specified";var t=new Number(this.value).toString(2),n=new e.DERBitString;return n.setByBinaryString(t),this.hTLV=n.getEncodedHex(),this.hTLV},"undefined"!=typeof t)if("string"==typeof t.name){var r=n.PKIFailureInfo.valueList;if("undefined"==typeof r[t.name])throw"name undefined: "+t.name;this.value=r[t.name]}else"number"==typeof t.int&&(this.value=t.int)},ir.lang.extend(KJUR.asn1.tsp.PKIFailureInfo,KJUR.asn1.ASN1Object),KJUR.asn1.tsp.PKIFailureInfo.valueList={badAlg:0,badRequest:2,badDataFormat:5,timeNotAvailable:14,unacceptedPolicy:15,unacceptedExtension:16,addInfoNotAvailable:17,systemFailure:25},KJUR.asn1.tsp.AbstractTSAAdapter=function(t){this.getTSTHex=function(t,e){throw"not implemented yet"}},KJUR.asn1.tsp.SimpleTSAAdapter=function(t){KJUR.asn1.tsp.SimpleTSAAdapter.superclass.constructor.call(this),this.params=null,this.serial=0,this.getTSTHex=function(t,e){var n=KJUR.crypto.Util.hashHex(t,e);this.params.tstInfo.messageImprint={hashAlg:e,hashValue:n},this.params.tstInfo.serialNumber={"int":this.serial++};var r=Math.floor(1e9*Math.random());this.params.tstInfo.nonce={"int":r};var i=KJUR.asn1.tsp.TSPUtil.newTimeStampToken(this.params);return i.getContentInfoEncodedHex()},"undefined"!=typeof t&&(this.params=t)},ir.lang.extend(KJUR.asn1.tsp.SimpleTSAAdapter,KJUR.asn1.tsp.AbstractTSAAdapter),KJUR.asn1.tsp.FixedTSAAdapter=function(t){KJUR.asn1.tsp.FixedTSAAdapter.superclass.constructor.call(this),this.params=null,this.getTSTHex=function(t,e){var n=KJUR.crypto.Util.hashHex(t,e);this.params.tstInfo.messageImprint={hashAlg:e,hashValue:n};var r=KJUR.asn1.tsp.TSPUtil.newTimeStampToken(this.params);return r.getContentInfoEncodedHex()},"undefined"!=typeof t&&(this.params=t)},ir.lang.extend(KJUR.asn1.tsp.FixedTSAAdapter,KJUR.asn1.tsp.AbstractTSAAdapter),KJUR.asn1.tsp.TSPUtil=new function(){},KJUR.asn1.tsp.TSPUtil.newTimeStampToken=function(t){var e=KJUR.asn1.cms,n=KJUR.asn1.tsp,r=new e.SignedData,i=new n.TSTInfo(t.tstInfo),s=i.getEncodedHex();if(r.dEncapContentInfo.setContentValue({hex:s}),r.dEncapContentInfo.setContentType("tstinfo"),"object"==typeof t.certs)for(var o=0;o<t.certs.length;o++)r.addCertificatesByPEM(t.certs[o]);var a=r.signerInfoList[0];a.setSignerIdentifier(t.signerCert),a.setForContentAndHash({sdObj:r,eciObj:r.dEncapContentInfo,hashAlg:t.hashAlg});var u=new e.SigningCertificate({array:[t.signerCert]});return a.dSignedAttrs.add(u),a.sign(t.signerPrvKey,t.sigAlg),r},KJUR.asn1.tsp.TSPUtil.parseTimeStampReq=function(t){var e={};e.certreq=!1;var n=Fr.getPosArrayOfChildren_AtObj(t,0);if(n.length<2)throw"TimeStampReq must have at least 2 items";var r=Fr.getHexOfTLV_AtObj(t,n[1]);e.mi=KJUR.asn1.tsp.TSPUtil.parseMessageImprint(r);for(var i=2;i<n.length;i++){var s=n[i],o=t.substr(s,2);if("06"==o){var a=Fr.getHexOfV_AtObj(t,s);e.policy=Fr.hextooidstr(a)}"02"==o&&(e.nonce=Fr.getHexOfV_AtObj(t,s)),"01"==o&&(e.certreq=!0)}return e},KJUR.asn1.tsp.TSPUtil.parseMessageImprint=function(t){var e={};if("30"!=t.substr(0,2))throw"head of messageImprint hex shall be '30'";var n=(Fr.getPosArrayOfChildren_AtObj(t,0),Fr.getDecendantIndexByNthList(t,0,[0,0])),r=Fr.getHexOfV_AtObj(t,n),i=Fr.hextooidstr(r),s=KJUR.asn1.x509.OID.oid2name(i);if(""==s)throw"hashAlg name undefined: "+i;var o=s,a=Fr.getDecendantIndexByNthList(t,0,[1]);return e.hashAlg=o,e.hashValue=Fr.getHexOfV_AtObj(t,a),e},/*! asn1cades-1.0.0.js (c) 2013-2014 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
"undefined"!=typeof KJUR&&KJUR||(KJUR={}),"undefined"!=typeof KJUR.asn1&&KJUR.asn1||(KJUR.asn1={}),"undefined"!=typeof KJUR.asn1.cades&&KJUR.asn1.cades||(KJUR.asn1.cades={}),KJUR.asn1.cades.SignaturePolicyIdentifier=function(t){KJUR.asn1.cades.SignaturePolicyIdentifier.superclass.constructor.call(this),this.attrTypeOid="1.2.840.113549.1.9.16.2.15";var e=KJUR.asn1,n=KJUR.asn1.cades;if("undefined"!=typeof t&&"string"==typeof t.oid&&"object"==typeof t.hash){var r=new e.DERObjectIdentifier({oid:t.oid}),i=new n.OtherHashAlgAndValue(t.hash),s=new e.DERSequence({array:[r,i]});this.valueList=[s]}},ir.lang.extend(KJUR.asn1.cades.SignaturePolicyIdentifier,KJUR.asn1.cms.Attribute),KJUR.asn1.cades.OtherHashAlgAndValue=function(t){KJUR.asn1.cades.OtherHashAlgAndValue.superclass.constructor.call(this);var e=KJUR.asn1,n=KJUR.asn1.x509;this.dAlg=null,this.dHash=null,this.getEncodedHex=function(){var t=new e.DERSequence({array:[this.dAlg,this.dHash]});return this.hTLV=t.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&"string"==typeof t.alg&&"string"==typeof t.hash&&(this.dAlg=new n.AlgorithmIdentifier({name:t.alg}),this.dHash=new e.DEROctetString({hex:t.hash}))},ir.lang.extend(KJUR.asn1.cades.OtherHashAlgAndValue,KJUR.asn1.ASN1Object),KJUR.asn1.cades.SignatureTimeStamp=function(t){KJUR.asn1.cades.SignatureTimeStamp.superclass.constructor.call(this),this.attrTypeOid="1.2.840.113549.1.9.16.2.14",this.tstHex=null;var e=KJUR.asn1;if("undefined"!=typeof t){if("undefined"!=typeof t.res)if("string"==typeof t.res&&t.res.match(/^[0-9A-Fa-f]+$/));else if(!(t.res instanceof KJUR.asn1.ASN1Object))throw"res param shall be ASN1Object or hex string";if("undefined"!=typeof t.tst)if("string"==typeof t.tst&&t.tst.match(/^[0-9A-Fa-f]+$/)){var n=new e.ASN1Object;this.tstHex=t.tst,n.hTLV=this.tstHex,n.getEncodedHex(),this.valueList=[n]}else if(!(t.tst instanceof KJUR.asn1.ASN1Object))throw"tst param shall be ASN1Object or hex string"}},ir.lang.extend(KJUR.asn1.cades.SignatureTimeStamp,KJUR.asn1.cms.Attribute),KJUR.asn1.cades.CompleteCertificateRefs=function(t){KJUR.asn1.cades.CompleteCertificateRefs.superclass.constructor.call(this),this.attrTypeOid="1.2.840.113549.1.9.16.2.21";var e=(KJUR.asn1,KJUR.asn1.cades);this.setByArray=function(t){this.valueList=[];for(var n=0;n<t.length;n++){var r=new e.OtherCertID(t[n]);this.valueList.push(r)}},"undefined"!=typeof t&&"object"==typeof t&&"number"==typeof t.length&&this.setByArray(t)},ir.lang.extend(KJUR.asn1.cades.CompleteCertificateRefs,KJUR.asn1.cms.Attribute),KJUR.asn1.cades.OtherCertID=function(t){KJUR.asn1.cades.OtherCertID.superclass.constructor.call(this);var e=KJUR.asn1,n=KJUR.asn1.cms,r=KJUR.asn1.cades;this.hasIssuerSerial=!0,this.dOtherCertHash=null,this.dIssuerSerial=null,this.setByCertPEM=function(t){this.dOtherCertHash=new r.OtherHash(t),this.hasIssuerSerial&&(this.dIssuerSerial=new n.IssuerAndSerialNumber(t))},this.getEncodedHex=function(){if(null!=this.hTLV)return this.hTLV;if(null==this.dOtherCertHash)throw"otherCertHash not set";var t=[this.dOtherCertHash];null!=this.dIssuerSerial&&t.push(this.dIssuerSerial);var n=new e.DERSequence({array:t});return this.hTLV=n.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&("string"==typeof t&&-1!=t.indexOf("-----BEGIN ")&&this.setByCertPEM(t),"object"==typeof t&&(t.hasis===!1&&(this.hasIssuerSerial=!1),"string"==typeof t.cert&&this.setByCertPEM(t.cert)))},ir.lang.extend(KJUR.asn1.cades.OtherCertID,KJUR.asn1.ASN1Object),KJUR.asn1.cades.OtherHash=function(t){KJUR.asn1.cades.OtherHash.superclass.constructor.call(this);var e=KJUR.asn1,n=KJUR.asn1.cades;if(this.alg="sha256",this.dOtherHash=null,this.setByCertPEM=function(t){if(-1==t.indexOf("-----BEGIN "))throw"certPEM not to seem PEM format";var e=Xn.pemToHex(t),r=KJUR.crypto.Util.hashHex(e,this.alg);this.dOtherHash=new n.OtherHashAlgAndValue({alg:this.alg,hash:r})},this.getEncodedHex=function(){if(null==this.dOtherHash)throw"OtherHash not set";return this.dOtherHash.getEncodedHex()},"undefined"!=typeof t)if("string"==typeof t)if(-1!=t.indexOf("-----BEGIN "))this.setByCertPEM(t);else{if(!t.match(/^[0-9A-Fa-f]+$/))throw"unsupported string value for params";this.dOtherHash=new e.DEROctetString({hex:t})}else"object"==typeof t&&("string"==typeof t.cert?("string"==typeof t.alg&&(this.alg=t.alg),this.setByCertPEM(t.cert)):this.dOtherHash=new n.OtherHashAlgAndValue(t))},ir.lang.extend(KJUR.asn1.cades.OtherHash,KJUR.asn1.ASN1Object),KJUR.asn1.cades.CAdESUtil=new function(){},KJUR.asn1.cades.CAdESUtil.addSigTS=function(t,e,n){},KJUR.asn1.cades.CAdESUtil.parseSignedDataForAddingUnsigned=function(t){var e=KJUR.asn1,n=KJUR.asn1.cms,r=KJUR.asn1.cades.CAdESUtil,i={};if("06092a864886f70d010702"!=Fr.getDecendantHexTLVByNthList(t,0,[0]))throw"hex is not CMS SignedData";var s=Fr.getDecendantIndexByNthList(t,0,[1,0]),o=Fr.getPosArrayOfChildren_AtObj(t,s);if(o.length<4)throw"num of SignedData elem shall be 4 at least";var a=o.shift();i.version=Fr.getHexOfTLV_AtObj(t,a);var u=o.shift();i.algs=Fr.getHexOfTLV_AtObj(t,u);var c=o.shift();i.encapcontent=Fr.getHexOfTLV_AtObj(t,c),i.certs=null,i.revs=null,i.si=[];var f=o.shift();"a0"==t.substr(f,2)&&(i.certs=Fr.getHexOfTLV_AtObj(t,f),f=o.shift()),"a1"==t.substr(f,2)&&(i.revs=Fr.getHexOfTLV_AtObj(t,f),f=o.shift());var h=f;if("31"!=t.substr(h,2))throw"Can't find signerInfos";for(var l=Fr.getPosArrayOfChildren_AtObj(t,h),d=0;d<l.length;d++){var p=l[d],g=r.parseSignerInfoForAddingUnsigned(t,p,d);i.si[d]=g}var y=null;i.obj=new n.SignedData,y=new e.ASN1Object,y.hTLV=i.version,i.obj.dCMSVersion=y,y=new e.ASN1Object,y.hTLV=i.algs,i.obj.dDigestAlgs=y,y=new e.ASN1Object,y.hTLV=i.encapcontent,i.obj.dEncapContentInfo=y,y=new e.ASN1Object,y.hTLV=i.certs,i.obj.dCerts=y,i.obj.signerInfoList=[];for(var d=0;d<i.si.length;d++)i.obj.signerInfoList.push(i.si[d].obj);return i},KJUR.asn1.cades.CAdESUtil.parseSignerInfoForAddingUnsigned=function(t,e,n){var r=KJUR.asn1,i=KJUR.asn1.cms,s={},o=Fr.getPosArrayOfChildren_AtObj(t,e);if(6!=o.length)throw"not supported items for SignerInfo (!=6)";var a=o.shift();s.version=Fr.getHexOfTLV_AtObj(t,a);var u=o.shift();s.si=Fr.getHexOfTLV_AtObj(t,u);var c=o.shift();s.digalg=Fr.getHexOfTLV_AtObj(t,c);var f=o.shift();s.sattrs=Fr.getHexOfTLV_AtObj(t,f);var h=o.shift();s.sigalg=Fr.getHexOfTLV_AtObj(t,h);var l=o.shift();s.sig=Fr.getHexOfTLV_AtObj(t,l),s.sigval=Fr.getHexOfV_AtObj(t,l);var d=null;return s.obj=new i.SignerInfo,d=new r.ASN1Object,d.hTLV=s.version,s.obj.dCMSVersion=d,d=new r.ASN1Object,d.hTLV=s.si,s.obj.dSignerIdentifier=d,d=new r.ASN1Object,d.hTLV=s.digalg,s.obj.dDigestAlgorithm=d,d=new r.ASN1Object,d.hTLV=s.sattrs,s.obj.dSignedAttrs=d,d=new r.ASN1Object,d.hTLV=s.sigalg,s.obj.dSigAlg=d,d=new r.ASN1Object,d.hTLV=s.sig,s.obj.dSig=d,s.obj.dUnsignedAttrs=new i.AttributeList,s},/*! asn1csr-1.0.0.js (c) 2015 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
"undefined"!=typeof KJUR.asn1.csr&&KJUR.asn1.csr||(KJUR.asn1.csr={}),KJUR.asn1.csr.CertificationRequest=function(t){KJUR.asn1.csr.CertificationRequest.superclass.constructor.call(this);this.sign=function(t,e){null==this.prvKey&&(this.prvKey=e),this.asn1SignatureAlg=new KJUR.asn1.x509.AlgorithmIdentifier({name:t}),sig=new KJUR.crypto.Signature({alg:t}),sig.initSign(this.prvKey),sig.updateHex(this.asn1CSRInfo.getEncodedHex()),this.hexSig=sig.sign(),this.asn1Sig=new KJUR.asn1.DERBitString({hex:"00"+this.hexSig});var n=new KJUR.asn1.DERSequence({array:[this.asn1CSRInfo,this.asn1SignatureAlg,this.asn1Sig]});this.hTLV=n.getEncodedHex(),this.isModified=!1},this.getPEMString=function(){var t=KJUR.asn1.ASN1Util.getPEMStringFromHex(this.getEncodedHex(),"CERTIFICATE REQUEST");return t},this.getEncodedHex=function(){if(0==this.isModified&&null!=this.hTLV)return this.hTLV;throw"not signed yet"},"undefined"!=typeof t&&"undefined"!=typeof t.csrinfo&&(this.asn1CSRInfo=t.csrinfo)},ir.lang.extend(KJUR.asn1.csr.CertificationRequest,KJUR.asn1.ASN1Object),KJUR.asn1.csr.CertificationRequestInfo=function(t){KJUR.asn1.csr.CertificationRequestInfo.superclass.constructor.call(this),this._initialize=function(){this.asn1Array=new Array,this.asn1Version=new KJUR.asn1.DERInteger({"int":0}),this.asn1Subject=null,this.asn1SubjPKey=null,this.extensionsArray=new Array},this.setSubjectByParam=function(t){this.asn1Subject=new KJUR.asn1.x509.X500Name(t)},this.setSubjectPublicKeyByGetKey=function(t){var e=Cr.getKey(t);this.asn1SubjPKey=new KJUR.asn1.x509.SubjectPublicKeyInfo(e)},this.getEncodedHex=function(){this.asn1Array=new Array,this.asn1Array.push(this.asn1Version),this.asn1Array.push(this.asn1Subject),this.asn1Array.push(this.asn1SubjPKey);var t=new KJUR.asn1.DERSequence({array:this.extensionsArray}),e=new KJUR.asn1.DERTaggedObject({explicit:!1,tag:"a0",obj:t});this.asn1Array.push(e);var n=new KJUR.asn1.DERSequence({array:this.asn1Array});return this.hTLV=n.getEncodedHex(),this.isModified=!1,this.hTLV},this._initialize()},ir.lang.extend(KJUR.asn1.csr.CertificationRequestInfo,KJUR.asn1.ASN1Object),KJUR.asn1.csr.CSRUtil=new function(){},KJUR.asn1.csr.CSRUtil.newCSRPEM=function(t){var e=KJUR.asn1.csr;if(void 0===t.subject)throw"parameter subject undefined";if(void 0===t.sbjpubkey)throw"parameter sbjpubkey undefined";if(void 0===t.sigalg)throw"parameter sigalg undefined";if(void 0===t.sbjprvkey)throw"parameter sbjpubkey undefined";var n=new e.CertificationRequestInfo;n.setSubjectByParam(t.subject),n.setSubjectPublicKeyByGetKey(t.sbjpubkey);var r=new e.CertificationRequest({csrinfo:n}),i=Cr.getKey(t.sbjprvkey);r.sign(t.sigalg,i);var s=r.getPEMString();return s};var Kr,Pr;"function"==typeof t?(Kr=function(e){return ln(new t(e,"utf8").toString("base64"))},Pr=function(e){return new t(dn(e),"base64").toString("utf8")}):(Kr=function(t){return pn(En(_n(t)))},Pr=function(t){return decodeURIComponent(xn(gn(t)))});var Ur=function(t,e){var n=t.length;t.length>e.length&&(n=e.length);for(var r=0;n>r;r++)if(t.charCodeAt(r)!=e.charCodeAt(r))return r;return t.length!=e.length?n:-1};/*! crypto-1.1.8.js (c) 2013-2016 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
"undefined"!=typeof KJUR&&KJUR||(KJUR={}),"undefined"!=typeof KJUR.crypto&&KJUR.crypto||(KJUR.crypto={}),KJUR.crypto.Util=new function(){this.DIGESTINFOHEAD={sha1:"3021300906052b0e03021a05000414",sha224:"302d300d06096086480165030402040500041c",sha256:"3031300d060960864801650304020105000420",sha384:"3041300d060960864801650304020205000430",sha512:"3051300d060960864801650304020305000440",md2:"3020300c06082a864886f70d020205000410",md5:"3020300c06082a864886f70d020505000410",ripemd160:"3021300906052b2403020105000414"},this.DEFAULTPROVIDER={md5:"cryptojs",sha1:"cryptojs",sha224:"cryptojs",sha256:"cryptojs",sha384:"cryptojs",sha512:"cryptojs",ripemd160:"cryptojs",hmacmd5:"cryptojs",hmacsha1:"cryptojs",hmacsha224:"cryptojs",hmacsha256:"cryptojs",hmacsha384:"cryptojs",hmacsha512:"cryptojs",hmacripemd160:"cryptojs",MD5withRSA:"cryptojs/jsrsa",SHA1withRSA:"cryptojs/jsrsa",SHA224withRSA:"cryptojs/jsrsa",SHA256withRSA:"cryptojs/jsrsa",SHA384withRSA:"cryptojs/jsrsa",SHA512withRSA:"cryptojs/jsrsa",RIPEMD160withRSA:"cryptojs/jsrsa",MD5withECDSA:"cryptojs/jsrsa",SHA1withECDSA:"cryptojs/jsrsa",SHA224withECDSA:"cryptojs/jsrsa",SHA256withECDSA:"cryptojs/jsrsa",SHA384withECDSA:"cryptojs/jsrsa",SHA512withECDSA:"cryptojs/jsrsa",RIPEMD160withECDSA:"cryptojs/jsrsa",SHA1withDSA:"cryptojs/jsrsa",SHA224withDSA:"cryptojs/jsrsa",SHA256withDSA:"cryptojs/jsrsa",MD5withRSAandMGF1:"cryptojs/jsrsa",SHA1withRSAandMGF1:"cryptojs/jsrsa",SHA224withRSAandMGF1:"cryptojs/jsrsa",SHA256withRSAandMGF1:"cryptojs/jsrsa",SHA384withRSAandMGF1:"cryptojs/jsrsa",SHA512withRSAandMGF1:"cryptojs/jsrsa",RIPEMD160withRSAandMGF1:"cryptojs/jsrsa"},this.CRYPTOJSMESSAGEDIGESTNAME={md5:sr.algo.MD5,sha1:sr.algo.SHA1,sha224:sr.algo.SHA224,sha256:sr.algo.SHA256,sha384:sr.algo.SHA384,sha512:sr.algo.SHA512,ripemd160:sr.algo.RIPEMD160},this.getDigestInfoHex=function(t,e){if("undefined"==typeof this.DIGESTINFOHEAD[e])throw"alg not supported in Util.DIGESTINFOHEAD: "+e;return this.DIGESTINFOHEAD[e]+t},this.getPaddedDigestInfoHex=function(t,e,n){var r=this.getDigestInfoHex(t,e),i=n/4;if(r.length+22>i)throw"key is too short for SigAlg: keylen="+n+","+e;for(var s="0001",o="00"+r,a="",u=i-s.length-o.length,c=0;u>c;c+=2)a+="ff";var f=s+a+o;return f},this.hashString=function(t,e){var n=new KJUR.crypto.MessageDigest({alg:e});return n.digestString(t)},this.hashHex=function(t,e){var n=new KJUR.crypto.MessageDigest({alg:e});return n.digestHex(t)},this.sha1=function(t){var e=new KJUR.crypto.MessageDigest({alg:"sha1",prov:"cryptojs"});return e.digestString(t)},this.sha256=function(t){var e=new KJUR.crypto.MessageDigest({alg:"sha256",prov:"cryptojs"});return e.digestString(t)},this.sha256Hex=function(t){var e=new KJUR.crypto.MessageDigest({alg:"sha256",prov:"cryptojs"});return e.digestHex(t)},this.sha512=function(t){var e=new KJUR.crypto.MessageDigest({alg:"sha512",prov:"cryptojs"});return e.digestString(t)},this.sha512Hex=function(t){var e=new KJUR.crypto.MessageDigest({alg:"sha512",prov:"cryptojs"});return e.digestHex(t)},this.md5=function(t){var e=new KJUR.crypto.MessageDigest({alg:"md5",prov:"cryptojs"});return e.digestString(t)},this.ripemd160=function(t){var e=new KJUR.crypto.MessageDigest({alg:"ripemd160",prov:"cryptojs"});return e.digestString(t)},this.getCryptoJSMDByName=function(t){}},KJUR.crypto.MessageDigest=function(t){this.setAlgAndProvider=function(t,e){if(null!=t&&void 0===e&&(e=KJUR.crypto.Util.DEFAULTPROVIDER[t]),-1!=":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(t)&&"cryptojs"==e){try{this.md=KJUR.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[t].create()}catch(n){throw"setAlgAndProvider hash alg set fail alg="+t+"/"+n}this.updateString=function(t){this.md.update(t)},this.updateHex=function(t){var e=sr.enc.Hex.parse(t);this.md.update(e)},this.digest=function(){var t=this.md.finalize();return t.toString(sr.enc.Hex)},this.digestString=function(t){return this.updateString(t),this.digest()},this.digestHex=function(t){return this.updateHex(t),this.digest()}}if(-1!=":sha256:".indexOf(t)&&"sjcl"==e){try{this.md=new sjcl.hash.sha256}catch(n){throw"setAlgAndProvider hash alg set fail alg="+t+"/"+n}this.updateString=function(t){this.md.update(t)},this.updateHex=function(t){var e=sjcl.codec.hex.toBits(t);this.md.update(e)},this.digest=function(){var t=this.md.finalize();return sjcl.codec.hex.fromBits(t)},this.digestString=function(t){return this.updateString(t),this.digest()},this.digestHex=function(t){return this.updateHex(t),this.digest()}}},this.updateString=function(t){throw"updateString(str) not supported for this alg/prov: "+this.algName+"/"+this.provName},this.updateHex=function(t){throw"updateHex(hex) not supported for this alg/prov: "+this.algName+"/"+this.provName},this.digest=function(){throw"digest() not supported for this alg/prov: "+this.algName+"/"+this.provName},this.digestString=function(t){throw"digestString(str) not supported for this alg/prov: "+this.algName+"/"+this.provName},this.digestHex=function(t){throw"digestHex(hex) not supported for this alg/prov: "+this.algName+"/"+this.provName},void 0!==t&&void 0!==t.alg&&(this.algName=t.alg,void 0===t.prov&&(this.provName=KJUR.crypto.Util.DEFAULTPROVIDER[this.algName]),this.setAlgAndProvider(this.algName,this.provName))},KJUR.crypto.Mac=function(t){this.setAlgAndProvider=function(t,e){if(t=t.toLowerCase(),null==t&&(t="hmacsha1"),t=t.toLowerCase(),"hmac"!=t.substr(0,4))throw"setAlgAndProvider unsupported HMAC alg: "+t;void 0===e&&(e=KJUR.crypto.Util.DEFAULTPROVIDER[t]),this.algProv=t+"/"+e;var n=t.substr(4);if(-1!=":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(n)&&"cryptojs"==e){try{var r=KJUR.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[n];this.mac=sr.algo.HMAC.create(r,this.pass)}catch(i){throw"setAlgAndProvider hash alg set fail hashAlg="+n+"/"+i}this.updateString=function(t){this.mac.update(t)},this.updateHex=function(t){var e=sr.enc.Hex.parse(t);this.mac.update(e)},this.doFinal=function(){var t=this.mac.finalize();return t.toString(sr.enc.Hex)},this.doFinalString=function(t){return this.updateString(t),this.doFinal()},this.doFinalHex=function(t){return this.updateHex(t),this.doFinal()}}},this.updateString=function(t){throw"updateString(str) not supported for this alg/prov: "+this.algProv},this.updateHex=function(t){throw"updateHex(hex) not supported for this alg/prov: "+this.algProv},this.doFinal=function(){throw"digest() not supported for this alg/prov: "+this.algProv},this.doFinalString=function(t){throw"digestString(str) not supported for this alg/prov: "+this.algProv},this.doFinalHex=function(t){throw"digestHex(hex) not supported for this alg/prov: "+this.algProv},this.setPassword=function(t){if("string"==typeof t){var e=t;return t.length%2!=1&&t.match(/^[0-9A-Fa-f]+$/)||(e=wn(t)),void(this.pass=sr.enc.Hex.parse(e))}if("object"!=typeof t)throw"KJUR.crypto.Mac unsupported password type: "+t;var e=null;if(void 0!==t.hex){if(t.hex.length%2!=0||!t.hex.match(/^[0-9A-Fa-f]+$/))throw"Mac: wrong hex password: "+t.hex;e=t.hex}if(void 0!==t.utf8&&(e=mn(t.utf8)),void 0!==t.rstr&&(e=wn(t.rstr)),void 0!==t.b64&&(e=i(t.b64)),void 0!==t.b64u&&(e=gn(t.b64u)),null==e)throw"KJUR.crypto.Mac unsupported password type: "+t;this.pass=sr.enc.Hex.parse(e)},void 0!==t&&(void 0!==t.pass&&this.setPassword(t.pass),void 0!==t.alg&&(this.algName=t.alg,void 0===t.prov&&(this.provName=KJUR.crypto.Util.DEFAULTPROVIDER[this.algName]),this.setAlgAndProvider(this.algName,this.provName)))},KJUR.crypto.Signature=function(t){var e=null;if(this._setAlgNames=function(){this.algName.match(/^(.+)with(.+)$/)&&(this.mdAlgName=RegExp.$1.toLowerCase(),this.pubkeyAlgName=RegExp.$2.toLowerCase())},this._zeroPaddingOfSignature=function(t,e){for(var n="",r=e/4-t.length,i=0;r>i;i++)n+="0";return n+t},this.setAlgAndProvider=function(t,e){if(this._setAlgNames(),"cryptojs/jsrsa"!=e)throw"provider not supported: "+e;if(-1!=":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(this.mdAlgName)){try{this.md=new KJUR.crypto.MessageDigest({alg:this.mdAlgName})}catch(n){throw"setAlgAndProvider hash alg set fail alg="+this.mdAlgName+"/"+n}this.init=function(t,e){var n=null;try{n=void 0===e?Cr.getKey(t):Cr.getKey(t,e)}catch(r){throw"init failed:"+r}if(n.isPrivate===!0)this.prvKey=n,this.state="SIGN";else{if(n.isPublic!==!0)throw"init failed.:"+n;this.pubKey=n,this.state="VERIFY"}},this.initSign=function(t){"string"==typeof t.ecprvhex&&"string"==typeof t.eccurvename?(this.ecprvhex=t.ecprvhex,this.eccurvename=t.eccurvename):this.prvKey=t,this.state="SIGN"},this.initVerifyByPublicKey=function(t){"string"==typeof t.ecpubhex&&"string"==typeof t.eccurvename?(this.ecpubhex=t.ecpubhex,this.eccurvename=t.eccurvename):t instanceof KJUR.crypto.ECDSA?this.pubKey=t:t instanceof ve&&(this.pubKey=t),this.state="VERIFY"},this.initVerifyByCertificatePEM=function(t){var e=new Xn;e.readCertPEM(t),this.pubKey=e.subjectPublicKeyRSA,this.state="VERIFY"},this.updateString=function(t){this.md.updateString(t)},this.updateHex=function(t){this.md.updateHex(t)},this.sign=function(){if(this.sHashHex=this.md.digest(),"undefined"!=typeof this.ecprvhex&&"undefined"!=typeof this.eccurvename){var t=new KJUR.crypto.ECDSA({curve:this.eccurvename});this.hSign=t.signHex(this.sHashHex,this.ecprvhex)}else if(this.prvKey instanceof ve&&"rsaandmgf1"==this.pubkeyAlgName)this.hSign=this.prvKey.signWithMessageHashPSS(this.sHashHex,this.mdAlgName,this.pssSaltLen);else if(this.prvKey instanceof ve&&"rsa"==this.pubkeyAlgName)this.hSign=this.prvKey.signWithMessageHash(this.sHashHex,this.mdAlgName);else if(this.prvKey instanceof KJUR.crypto.ECDSA)this.hSign=this.prvKey.signWithMessageHash(this.sHashHex);else{if(!(this.prvKey instanceof KJUR.crypto.DSA))throw"Signature: unsupported public key alg: "+this.pubkeyAlgName;this.hSign=this.prvKey.signWithMessageHash(this.sHashHex)}return this.hSign},this.signString=function(t){return this.updateString(t),this.sign()},this.signHex=function(t){return this.updateHex(t),this.sign()},this.verify=function(t){if(this.sHashHex=this.md.digest(),"undefined"!=typeof this.ecpubhex&&"undefined"!=typeof this.eccurvename){var e=new KJUR.crypto.ECDSA({curve:this.eccurvename});return e.verifyHex(this.sHashHex,t,this.ecpubhex)}if(this.pubKey instanceof ve&&"rsaandmgf1"==this.pubkeyAlgName)return this.pubKey.verifyWithMessageHashPSS(this.sHashHex,t,this.mdAlgName,this.pssSaltLen);if(this.pubKey instanceof ve&&"rsa"==this.pubkeyAlgName)return this.pubKey.verifyWithMessageHash(this.sHashHex,t);if(this.pubKey instanceof KJUR.crypto.ECDSA)return this.pubKey.verifyWithMessageHash(this.sHashHex,t);if(this.pubKey instanceof KJUR.crypto.DSA)return this.pubKey.verifyWithMessageHash(this.sHashHex,t);throw"Signature: unsupported public key alg: "+this.pubkeyAlgName}}},this.init=function(t,e){throw"init(key, pass) not supported for this alg:prov="+this.algProvName},this.initVerifyByPublicKey=function(t){throw"initVerifyByPublicKey(rsaPubKeyy) not supported for this alg:prov="+this.algProvName},this.initVerifyByCertificatePEM=function(t){throw"initVerifyByCertificatePEM(certPEM) not supported for this alg:prov="+this.algProvName},this.initSign=function(t){throw"initSign(prvKey) not supported for this alg:prov="+this.algProvName},this.updateString=function(t){throw"updateString(str) not supported for this alg:prov="+this.algProvName},this.updateHex=function(t){throw"updateHex(hex) not supported for this alg:prov="+this.algProvName},this.sign=function(){throw"sign() not supported for this alg:prov="+this.algProvName},this.signString=function(t){throw"digestString(str) not supported for this alg:prov="+this.algProvName},this.signHex=function(t){throw"digestHex(hex) not supported for this alg:prov="+this.algProvName},this.verify=function(t){throw"verify(hSigVal) not supported for this alg:prov="+this.algProvName},this.initParams=t,void 0!==t&&(void 0!==t.alg&&(this.algName=t.alg,void 0===t.prov?this.provName=KJUR.crypto.Util.DEFAULTPROVIDER[this.algName]:this.provName=t.prov,this.algProvName=this.algName+":"+this.provName,this.setAlgAndProvider(this.algName,this.provName),this._setAlgNames()),void 0!==t.psssaltlen&&(this.pssSaltLen=t.psssaltlen),void 0!==t.prvkeypem)){if(void 0!==t.prvkeypas)throw"both prvkeypem and prvkeypas parameters not supported";try{var e=new ve;e.readPrivateKeyFromPEMString(t.prvkeypem),this.initSign(e)}catch(n){throw"fatal error to load pem private key: "+n}}},KJUR.crypto.OID=new function(){this.oidhex2name={"2a864886f70d010101":"rsaEncryption","2a8648ce3d0201":"ecPublicKey","2a8648ce380401":"dsa","2a8648ce3d030107":"secp256r1","2b8104001f":"secp192k1","2b81040021":"secp224r1","2b8104000a":"secp256k1","2b81040023":"secp521r1","2b81040022":"secp384r1","2a8648ce380403":"SHA1withDSA","608648016503040301":"SHA224withDSA","608648016503040302":"SHA256withDSA"}},/*! ecdsa-modified-1.0.4.js (c) Stephan Thomas, Kenji Urushima | github.com/bitcoinjs/bitcoinjs-lib/blob/master/LICENSE
	 */
"undefined"!=typeof KJUR&&KJUR||(KJUR={}),"undefined"!=typeof KJUR.crypto&&KJUR.crypto||(KJUR.crypto={}),KJUR.crypto.ECDSA=function(t){var e="secp256r1",n=new le;this.type="EC",this.getBigRandom=function(t){return new o(t.bitLength(),n).mod(t.subtract(o.ONE)).add(o.ONE)},this.setNamedCurve=function(t){this.ecparams=KJUR.crypto.ECParameterDB.getByName(t),this.prvKeyHex=null,this.pubKeyHex=null,this.curveName=t},this.setPrivateKeyHex=function(t){this.isPrivate=!0,this.prvKeyHex=t},this.setPublicKeyHex=function(t){this.isPublic=!0,this.pubKeyHex=t},this.generateKeyPairHex=function(){var t=this.ecparams.n,e=this.getBigRandom(t),n=this.ecparams.G.multiply(e),r=n.getX().toBigInteger(),i=n.getY().toBigInteger(),s=this.ecparams.keylen/4,o=("0000000000"+e.toString(16)).slice(-s),a=("0000000000"+r.toString(16)).slice(-s),u=("0000000000"+i.toString(16)).slice(-s),c="04"+a+u;return this.setPrivateKeyHex(o),this.setPublicKeyHex(c),{ecprvhex:o,ecpubhex:c}},this.signWithMessageHash=function(t){return this.signHex(t,this.prvKeyHex)},this.signHex=function(t,e){var n=new o(e,16),r=this.ecparams.n,i=new o(t,16);do var s=this.getBigRandom(r),a=this.ecparams.G,u=a.multiply(s),c=u.getX().toBigInteger().mod(r);while(c.compareTo(o.ZERO)<=0);var f=s.modInverse(r).multiply(i.add(n.multiply(c))).mod(r);return KJUR.crypto.ECDSA.biRSSigToASN1Sig(c,f)},this.sign=function(t,e){var n=e,r=this.ecparams.n,i=o.fromByteArrayUnsigned(t);do var s=this.getBigRandom(r),a=this.ecparams.G,u=a.multiply(s),c=u.getX().toBigInteger().mod(r);while(c.compareTo(o.ZERO)<=0);var f=s.modInverse(r).multiply(i.add(n.multiply(c))).mod(r);return this.serializeSig(c,f)},this.verifyWithMessageHash=function(t,e){return this.verifyHex(t,e,this.pubKeyHex)},this.verifyHex=function(t,e,n){var r,i,s=KJUR.crypto.ECDSA.parseSigHex(e);r=s.r,i=s.s;var a;a=ke.decodeFromHex(this.ecparams.curve,n);var u=new o(t,16);return this.verifyRaw(u,r,i,a)},this.verify=function(t,e,n){var r,i;if(Bitcoin.Util.isArray(e)){var s=this.parseSig(e);r=s.r,i=s.s}else{if("object"!=typeof e||!e.r||!e.s)throw"Invalid value for signature";r=e.r,i=e.s}var a;if(n instanceof ke)a=n;else{if(!Bitcoin.Util.isArray(n))throw"Invalid format for pubkey value, must be byte array or ECPointFp";a=ke.decodeFrom(this.ecparams.curve,n)}var u=o.fromByteArrayUnsigned(t);return this.verifyRaw(u,r,i,a)},this.verifyRaw=function(t,e,n,r){var i=this.ecparams.n,s=this.ecparams.G;if(e.compareTo(o.ONE)<0||e.compareTo(i)>=0)return!1;if(n.compareTo(o.ONE)<0||n.compareTo(i)>=0)return!1;var a=n.modInverse(i),u=t.multiply(a).mod(i),c=e.multiply(a).mod(i),f=s.multiply(u).add(r.multiply(c)),h=f.getX().toBigInteger().mod(i);return h.equals(e)},this.serializeSig=function(t,e){var n=t.toByteArraySigned(),r=e.toByteArraySigned(),i=[];return i.push(2),i.push(n.length),i=i.concat(n),i.push(2),i.push(r.length),i=i.concat(r),i.unshift(i.length),i.unshift(48),i},this.parseSig=function(t){var e;if(48!=t[0])throw new Error("Signature not a valid DERSequence");if(e=2,2!=t[e])throw new Error("First element in signature must be a DERInteger");var n=t.slice(e+2,e+2+t[e+1]);if(e+=2+t[e+1],2!=t[e])throw new Error("Second element in signature must be a DERInteger");var r=t.slice(e+2,e+2+t[e+1]);e+=2+t[e+1];var i=o.fromByteArrayUnsigned(n),s=o.fromByteArrayUnsigned(r);return{r:i,s:s}},this.parseSigCompact=function(t){if(65!==t.length)throw"Signature has the wrong length";var e=t[0]-27;if(0>e||e>7)throw"Invalid signature type";var n=this.ecparams.n,r=o.fromByteArrayUnsigned(t.slice(1,33)).mod(n),i=o.fromByteArrayUnsigned(t.slice(33,65)).mod(n);return{r:r,s:i,i:e}},void 0!==t&&void 0!==t.curve&&(this.curveName=t.curve),void 0===this.curveName&&(this.curveName=e),this.setNamedCurve(this.curveName),void 0!==t&&(void 0!==t.prv&&this.setPrivateKeyHex(t.prv),void 0!==t.pub&&this.setPublicKeyHex(t.pub))},KJUR.crypto.ECDSA.parseSigHex=function(t){var e=KJUR.crypto.ECDSA.parseSigHexInHexRS(t),n=new o(e.r,16),r=new o(e.s,16);return{r:n,s:r}},KJUR.crypto.ECDSA.parseSigHexInHexRS=function(t){if("30"!=t.substr(0,2))throw"signature is not a ASN.1 sequence";var e=Fr.getPosArrayOfChildren_AtObj(t,0);if(2!=e.length)throw"number of signature ASN.1 sequence elements seem wrong";var n=e[0],r=e[1];if("02"!=t.substr(n,2))throw"1st item of sequene of signature is not ASN.1 integer";if("02"!=t.substr(r,2))throw"2nd item of sequene of signature is not ASN.1 integer";var i=Fr.getHexOfV_AtObj(t,n),s=Fr.getHexOfV_AtObj(t,r);return{r:i,s:s}},KJUR.crypto.ECDSA.asn1SigToConcatSig=function(t){var e=KJUR.crypto.ECDSA.parseSigHexInHexRS(t),n=e.r,r=e.s;if("00"==n.substr(0,2)&&n.length/2*8%128==8&&(n=n.substr(2)),"00"==r.substr(0,2)&&r.length/2*8%128==8&&(r=r.substr(2)),n.length/2*8%128!=0)throw"unknown ECDSA sig r length error";if(r.length/2*8%128!=0)throw"unknown ECDSA sig s length error";return n+r},KJUR.crypto.ECDSA.concatSigToASN1Sig=function(t){if(t.length/2*8%128!=0)throw"unknown ECDSA concatinated r-s sig  length error";var e=t.substr(0,t.length/2),n=t.substr(t.length/2);return KJUR.crypto.ECDSA.hexRSSigToASN1Sig(e,n)},KJUR.crypto.ECDSA.hexRSSigToASN1Sig=function(t,e){var n=new o(t,16),r=new o(e,16);return KJUR.crypto.ECDSA.biRSSigToASN1Sig(n,r)},KJUR.crypto.ECDSA.biRSSigToASN1Sig=function(t,e){var n=new KJUR.asn1.DERInteger({bigint:t}),r=new KJUR.asn1.DERInteger({bigint:e}),i=new KJUR.asn1.DERSequence({array:[n,r]});return i.getEncodedHex()},/*! ecparam-1.0.0.js (c) 2013 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
"undefined"!=typeof KJUR&&KJUR||(KJUR={}),"undefined"!=typeof KJUR.crypto&&KJUR.crypto||(KJUR.crypto={}),KJUR.crypto.ECParameterDB=new function(){function t(t){return new o(t,16)}var e={},n={};this.getByName=function(t){var r=t;if("undefined"!=typeof n[r]&&(r=n[t]),"undefined"!=typeof e[r])return e[r];throw"unregistered EC curve name: "+r},this.regist=function(r,i,s,o,a,u,c,f,h,l,d,p){e[r]={};var g=t(s),y=t(o),v=t(a),m=t(u),S=t(c),b=new Xe(g,y,v),w=b.decodePointHex("04"+f+h);e[r].name=r,e[r].keylen=i,e[r].curve=b,e[r].G=w,e[r].n=m,e[r].h=S,e[r].oid=d,e[r].info=p;for(var E=0;E<l.length;E++)n[l[E]]=r}},KJUR.crypto.ECParameterDB.regist("secp128r1",128,"FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFF","FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFC","E87579C11079F43DD824993C2CEE5ED3","FFFFFFFE0000000075A30D1B9038A115","1","161FF7528B899B2D0C28607CA52C5B86","CF5AC8395BAFEB13C02DA292DDED7A83",[],"","secp128r1 : SECG curve over a 128 bit prime field"),KJUR.crypto.ECParameterDB.regist("secp160k1",160,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFAC73","0","7","0100000000000000000001B8FA16DFAB9ACA16B6B3","1","3B4C382CE37AA192A4019E763036F4F5DD4D7EBB","938CF935318FDCED6BC28286531733C3F03C4FEE",[],"","secp160k1 : SECG curve over a 160 bit prime field"),KJUR.crypto.ECParameterDB.regist("secp160r1",160,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFC","1C97BEFC54BD7A8B65ACF89F81D4D4ADC565FA45","0100000000000000000001F4C8F927AED3CA752257","1","4A96B5688EF573284664698968C38BB913CBFC82","23A628553168947D59DCC912042351377AC5FB32",[],"","secp160r1 : SECG curve over a 160 bit prime field"),KJUR.crypto.ECParameterDB.regist("secp192k1",192,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFEE37","0","3","FFFFFFFFFFFFFFFFFFFFFFFE26F2FC170F69466A74DEFD8D","1","DB4FF10EC057E9AE26B07D0280B7F4341DA5D1B1EAE06C7D","9B2F2F6D9C5628A7844163D015BE86344082AA88D95E2F9D",[]),KJUR.crypto.ECParameterDB.regist("secp192r1",192,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFC","64210519E59C80E70FA7E9AB72243049FEB8DEECC146B9B1","FFFFFFFFFFFFFFFFFFFFFFFF99DEF836146BC9B1B4D22831","1","188DA80EB03090F67CBF20EB43A18800F4FF0AFD82FF1012","07192B95FFC8DA78631011ED6B24CDD573F977A11E794811",[]),KJUR.crypto.ECParameterDB.regist("secp224r1",224,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000000000000000001","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFE","B4050A850C04B3ABF54132565044B0B7D7BFD8BA270B39432355FFB4","FFFFFFFFFFFFFFFFFFFFFFFFFFFF16A2E0B8F03E13DD29455C5C2A3D","1","B70E0CBD6BB4BF7F321390B94A03C1D356C21122343280D6115C1D21","BD376388B5F723FB4C22DFE6CD4375A05A07476444D5819985007E34",[]),KJUR.crypto.ECParameterDB.regist("secp256k1",256,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFC2F","0","7","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141","1","79BE667EF9DCBBAC55A06295CE870B07029BFCDB2DCE28D959F2815B16F81798","483ADA7726A3C4655DA4FBFC0E1108A8FD17B448A68554199C47D08FFB10D4B8",[]),KJUR.crypto.ECParameterDB.regist("secp256r1",256,"FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF","FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC","5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B","FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551","1","6B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C296","4FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5",["NIST P-256","P-256","prime256v1"]),KJUR.crypto.ECParameterDB.regist("secp384r1",384,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC","B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973","1","AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB7","3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f",["NIST P-384","P-384"]),KJUR.crypto.ECParameterDB.regist("secp521r1",521,"1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF","1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC","051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00","1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409","1","C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66","011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650",["NIST P-521","P-521"]),/*! dsa-modified-1.0.1.js (c) Recurity Labs GmbH, Kenji Urushimma | github.com/openpgpjs/openpgpjs/blob/master/LICENSE
	 */
"undefined"!=typeof KJUR&&KJUR||(KJUR={}),"undefined"!=typeof KJUR.crypto&&KJUR.crypto||(KJUR.crypto={}),KJUR.crypto.DSA=function(){function t(t,e,n,i,s,a){var u=KJUR.crypto.Util.hashString(e,t.toLowerCase()),u=u.substr(0,s.bitLength()/4),c=new o(u,16),f=r(o.ONE.add(o.ONE),s.subtract(o.ONE)),h=n.modPow(f,i).mod(s),l=f.modInverse(s).multiply(c.add(a.multiply(h))).mod(s),d=new Array;return d[0]=h,d[1]=l,d}function e(t){var e=openpgp.config.config.prefer_hash_algorithm;switch(Math.round(t.bitLength()/8)){case 20:return 2!=e&&e>11&&10!=e&&8>e?2:e;case 28:return e>11&&8>e?11:e;case 32:return e>10&&8>e?8:e;default:return util.print_debug("DSA select hash algorithm: returning null for an unknown length of q"),null}}function n(t,e,n,r,i,s,a,u){var c=KJUR.crypto.Util.hashString(r,t.toLowerCase()),c=c.substr(0,s.bitLength()/4),f=new o(c,16);if(o.ZERO.compareTo(e)>0||e.compareTo(s)>0||o.ZERO.compareTo(n)>0||n.compareTo(s)>0)return util.print_error("invalid DSA Signature"),null;var h=n.modInverse(s),l=f.multiply(h).mod(s),d=e.multiply(h).mod(s),p=a.modPow(l,i).multiply(u.modPow(d,i)).mod(i).mod(s);return 0==p.compareTo(e)}function r(t,e){if(!(e.compareTo(t)<=0)){for(var n=e.subtract(t),r=i(n.bitLength());r>n;)r=i(n.bitLength());return t.add(r)}}function i(t){if(0>t)return null;var e=Math.floor((t+7)/8),n=s(e);return t%8>0&&(n=String.fromCharCode(Math.pow(2,t%8)-1&n.charCodeAt(0))+n.substring(1)),new o(u(n),16)}function s(t){for(var e="",n=0;t>n;n++)e+=String.fromCharCode(a());return e}function a(){var t=new Uint32Array(1);return rr.crypto.getRandomValues(t),255&t[0]}function u(t){if(null==t)return"";for(var e,n=[],r=t.length,i=0;r>i;){for(e=t[i++].charCodeAt().toString(16);e.length<2;)e="0"+e;n.push(""+e)}return n.join("")}this.p=null,this.q=null,this.g=null,this.y=null,this.x=null,this.type="DSA",this.setPrivate=function(t,e,n,r,i){this.isPrivate=!0,this.p=t,this.q=e,this.g=n,this.y=r,this.x=i},this.setPublic=function(t,e,n,r){this.isPublic=!0,this.p=t,this.q=e,this.g=n,this.y=r,this.x=null},this.signWithMessageHash=function(t){var e=this.p,n=this.q,i=this.g,s=(this.y,this.x),a=(t.substr(0,n.bitLength()/4),new o(t,16)),u=r(o.ONE.add(o.ONE),n.subtract(o.ONE)),c=i.modPow(u,e).mod(n),f=u.modInverse(n).multiply(a.add(s.multiply(c))).mod(n),h=KJUR.asn1.ASN1Util.jsonToASN1HEX({seq:[{"int":{bigint:c}},{"int":{bigint:f}}]});return h},this.verifyWithMessageHash=function(t,e){var n=this.p,r=this.q,i=this.g,s=this.y,a=this.parseASN1Signature(e),u=a[0],c=a[1],t=t.substr(0,r.bitLength()/4),f=new o(t,16);if(o.ZERO.compareTo(u)>0||u.compareTo(r)>0||o.ZERO.compareTo(c)>0||c.compareTo(r)>0)throw"invalid DSA signature";var h=c.modInverse(r),l=f.multiply(h).mod(r),d=u.multiply(h).mod(r),p=i.modPow(l,n).multiply(s.modPow(d,n)).mod(n).mod(r);return 0==p.compareTo(u)},this.parseASN1Signature=function(t){try{var e=new o(Fr.getVbyList(t,0,[0],"02"),16),n=new o(Fr.getVbyList(t,0,[1],"02"),16);return[e,n]}catch(r){throw"malformed DSA signature"}},this.select_hash_algorithm=e,this.sign=t,this.verify=n,this.getRandomBigIntegerInRange=r,this.getRandomBigInteger=i,this.getRandomBytes=s};/*! pkcs5pkey-1.0.6.js (c) 2013-2014 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
var Or=function(){var t=function(t,e,r){return n(sr.AES,t,e,r)},e=function(t,e,r){return n(sr.TripleDES,t,e,r)},n=function(t,e,n,r){var i=sr.enc.Hex.parse(e),s=sr.enc.Hex.parse(n),o=sr.enc.Hex.parse(r),a={};a.key=s,a.iv=o,a.ciphertext=i;var u=t.decrypt(a,s,{iv:o});return sr.enc.Hex.stringify(u)},r=function(t,e,n){return o(sr.AES,t,e,n)},s=function(t,e,n){return o(sr.TripleDES,t,e,n)},o=function(t,e,n,r){var i=sr.enc.Hex.parse(e),s=sr.enc.Hex.parse(n),o=sr.enc.Hex.parse(r),a=t.encrypt(i,s,{iv:o}),u=sr.enc.Hex.parse(a.toString()),c=sr.enc.Base64.stringify(u);return c},a={"AES-256-CBC":{proc:t,eproc:r,keylen:32,ivlen:16},"AES-192-CBC":{proc:t,eproc:r,keylen:24,ivlen:16},"AES-128-CBC":{proc:t,eproc:r,keylen:16,ivlen:16},"DES-EDE3-CBC":{proc:e,eproc:s,keylen:24,ivlen:8}},u=function(t){return a[t].proc},c=function(t){var e=sr.lib.WordArray.random(t),n=sr.enc.Hex.stringify(e);return n},f=function(t){var e={};t.match(new RegExp("DEK-Info: ([^,]+),([0-9A-Fa-f]+)","m"))&&(e.cipher=RegExp.$1,e.ivsalt=RegExp.$2),t.match(new RegExp("-----BEGIN ([A-Z]+) PRIVATE KEY-----"))&&(e.type=RegExp.$1);var n=-1,r=0;-1!=t.indexOf("\r\n\r\n")&&(n=t.indexOf("\r\n\r\n"),r=2),-1!=t.indexOf("\n\n")&&(n=t.indexOf("\n\n"),r=1);var i=t.indexOf("-----END");if(-1!=n&&-1!=i){var s=t.substring(n+2*r,i-r);s=s.replace(/\s+/g,""),e.data=s}return e},h=function(t,e,n){for(var r=n.substring(0,16),i=sr.enc.Hex.parse(r),s=sr.enc.Utf8.parse(e),o=a[t].keylen+a[t].ivlen,u="",c=null;;){var f=sr.algo.MD5.create();if(null!=c&&f.update(c),f.update(s),f.update(i),c=f.finalize(),u+=sr.enc.Hex.stringify(c),u.length>=2*o)break}var h={};return h.keyhex=u.substr(0,2*a[t].keylen),h.ivhex=u.substr(2*a[t].keylen,2*a[t].ivlen),h},l=function(t,e,n,r){var i=sr.enc.Base64.parse(t),s=sr.enc.Hex.stringify(i),o=a[e].proc,u=o(s,n,r);return u},d=function(t,e,n,r){var i=a[e].eproc,s=i(t,n,r);return s};return{version:"1.0.5",getHexFromPEM:function(t,e){var n=t;if(-1==n.indexOf("BEGIN "+e))throw"can't find PEM header: "+e;n=n.replace("-----BEGIN "+e+"-----",""),n=n.replace("-----END "+e+"-----","");var r=n.replace(/\s+/g,""),s=i(r);return s},getDecryptedKeyHexByKeyIV:function(t,e,n,r){var i=u(e);return i(t,n,r)},parsePKCS5PEM:function(t){return f(t)},getKeyAndUnusedIvByPasscodeAndIvsalt:function(t,e,n){return h(t,e,n)},decryptKeyB64:function(t,e,n,r){return l(t,e,n,r)},getDecryptedKeyHex:function(t,e){var n=f(t),r=(n.type,n.cipher),i=n.ivsalt,s=n.data,o=h(r,e,i),a=o.keyhex,u=l(s,r,a,i);return u},getRSAKeyFromEncryptedPKCS5PEM:function(t,e){var n=this.getDecryptedKeyHex(t,e),r=new ve;return r.readPrivateKeyFromASN1HexString(n),r},getEryptedPKCS5PEMFromPrvKeyHex:function(t,e,n,r){var i="";if("undefined"!=typeof n&&null!=n||(n="AES-256-CBC"),"undefined"==typeof a[n])throw"PKCS5PKEY unsupported algorithm: "+n;if("undefined"==typeof r||null==r){var s=a[n].ivlen,o=c(s);r=o.toUpperCase()}var u=h(n,e,r),f=u.keyhex,l=d(t,n,f,r),p=l.replace(/(.{64})/g,"$1\r\n"),i="-----BEGIN RSA PRIVATE KEY-----\r\n";return i+="Proc-Type: 4,ENCRYPTED\r\n",i+="DEK-Info: "+n+","+r+"\r\n",i+="\r\n",i+=p,i+="\r\n-----END RSA PRIVATE KEY-----\r\n"},getEryptedPKCS5PEMFromRSAKey:function(t,e,n,r){var i=new KJUR.asn1.DERInteger({"int":0}),s=new KJUR.asn1.DERInteger({bigint:t.n}),o=new KJUR.asn1.DERInteger({"int":t.e}),a=new KJUR.asn1.DERInteger({bigint:t.d}),u=new KJUR.asn1.DERInteger({bigint:t.p}),c=new KJUR.asn1.DERInteger({bigint:t.q}),f=new KJUR.asn1.DERInteger({bigint:t.dmp1}),h=new KJUR.asn1.DERInteger({bigint:t.dmq1}),l=new KJUR.asn1.DERInteger({bigint:t.coeff}),d=new KJUR.asn1.DERSequence({array:[i,s,o,a,u,c,f,h,l]}),p=d.getEncodedHex();return this.getEryptedPKCS5PEMFromPrvKeyHex(p,e,n,r)},newEncryptedPKCS5PEM:function(t,e,n,r){"undefined"!=typeof e&&null!=e||(e=1024),"undefined"!=typeof n&&null!=n||(n="10001");var i=new ve;i.generate(e,n);var s=null;return s="undefined"==typeof r||null==r?this.getEncryptedPKCS5PEMFromRSAKey(pkey,t):this.getEncryptedPKCS5PEMFromRSAKey(pkey,t,r)},getRSAKeyFromPlainPKCS8PEM:function(t){if(t.match(/ENCRYPTED/))throw"pem shall be not ENCRYPTED";var e=this.getHexFromPEM(t,"PRIVATE KEY"),n=this.getRSAKeyFromPlainPKCS8Hex(e);return n},getRSAKeyFromPlainPKCS8Hex:function(t){var e=Fr.getPosArrayOfChildren_AtObj(t,0);if(3!=e.length)throw"outer DERSequence shall have 3 elements: "+e.length;var n=Fr.getHexOfTLV_AtObj(t,e[1]);if("300d06092a864886f70d0101010500"!=n)throw"PKCS8 AlgorithmIdentifier is not rsaEnc: "+n;var n=Fr.getHexOfTLV_AtObj(t,e[1]),r=Fr.getHexOfTLV_AtObj(t,e[2]),i=Fr.getHexOfV_AtObj(r,0),s=new ve;return s.readPrivateKeyFromASN1HexString(i),s},parseHexOfEncryptedPKCS8:function(t){var e={},n=Fr.getPosArrayOfChildren_AtObj(t,0);if(2!=n.length)throw"malformed format: SEQUENCE(0).items != 2: "+n.length;e.ciphertext=Fr.getHexOfV_AtObj(t,n[1]);var r=Fr.getPosArrayOfChildren_AtObj(t,n[0]);if(2!=r.length)throw"malformed format: SEQUENCE(0.0).items != 2: "+r.length;if("2a864886f70d01050d"!=Fr.getHexOfV_AtObj(t,r[0]))throw"this only supports pkcs5PBES2";var i=Fr.getPosArrayOfChildren_AtObj(t,r[1]);if(2!=r.length)throw"malformed format: SEQUENCE(0.0.1).items != 2: "+i.length;var s=Fr.getPosArrayOfChildren_AtObj(t,i[1]);if(2!=s.length)throw"malformed format: SEQUENCE(0.0.1.1).items != 2: "+s.length;if("2a864886f70d0307"!=Fr.getHexOfV_AtObj(t,s[0]))throw"this only supports TripleDES";e.encryptionSchemeAlg="TripleDES",e.encryptionSchemeIV=Fr.getHexOfV_AtObj(t,s[1]);var o=Fr.getPosArrayOfChildren_AtObj(t,i[0]);if(2!=o.length)throw"malformed format: SEQUENCE(0.0.1.0).items != 2: "+o.length;if("2a864886f70d01050c"!=Fr.getHexOfV_AtObj(t,o[0]))throw"this only supports pkcs5PBKDF2";var a=Fr.getPosArrayOfChildren_AtObj(t,o[1]);if(a.length<2)throw"malformed format: SEQUENCE(0.0.1.0.1).items < 2: "+a.length;e.pbkdf2Salt=Fr.getHexOfV_AtObj(t,a[0]);var u=Fr.getHexOfV_AtObj(t,a[1]);try{e.pbkdf2Iter=parseInt(u,16)}catch(c){throw"malformed format pbkdf2Iter: "+u}return e},getPBKDF2KeyHexFromParam:function(t,e){var n=sr.enc.Hex.parse(t.pbkdf2Salt),r=t.pbkdf2Iter,i=sr.PBKDF2(e,n,{keySize:6,iterations:r}),s=sr.enc.Hex.stringify(i);return s},getPlainPKCS8HexFromEncryptedPKCS8PEM:function(t,e){var n=this.getHexFromPEM(t,"ENCRYPTED PRIVATE KEY"),r=this.parseHexOfEncryptedPKCS8(n),i=Or.getPBKDF2KeyHexFromParam(r,e),s={};s.ciphertext=sr.enc.Hex.parse(r.ciphertext);var o=sr.enc.Hex.parse(i),a=sr.enc.Hex.parse(r.encryptionSchemeIV),u=sr.TripleDES.decrypt(s,o,{iv:a}),c=sr.enc.Hex.stringify(u);return c},getRSAKeyFromEncryptedPKCS8PEM:function(t,e){var n=this.getPlainPKCS8HexFromEncryptedPKCS8PEM(t,e),r=this.getRSAKeyFromPlainPKCS8Hex(n);return r},getKeyFromEncryptedPKCS8PEM:function(t,e){var n=this.getPlainPKCS8HexFromEncryptedPKCS8PEM(t,e),r=this.getKeyFromPlainPrivatePKCS8Hex(n);return r},parsePlainPrivatePKCS8Hex:function(t){var e={};if(e.algparam=null,"30"!=t.substr(0,2))throw"malformed plain PKCS8 private key(code:001)";var n=Fr.getPosArrayOfChildren_AtObj(t,0);if(3!=n.length)throw"malformed plain PKCS8 private key(code:002)";if("30"!=t.substr(n[1],2))throw"malformed PKCS8 private key(code:003)";var r=Fr.getPosArrayOfChildren_AtObj(t,n[1]);if(2!=r.length)throw"malformed PKCS8 private key(code:004)";if("06"!=t.substr(r[0],2))throw"malformed PKCS8 private key(code:005)";if(e.algoid=Fr.getHexOfV_AtObj(t,r[0]),"06"==t.substr(r[1],2)&&(e.algparam=Fr.getHexOfV_AtObj(t,r[1])),"04"!=t.substr(n[2],2))throw"malformed PKCS8 private key(code:006)";return e.keyidx=Fr.getStartPosOfV_AtObj(t,n[2]),e},getKeyFromPlainPrivatePKCS8PEM:function(t){var e=this.getHexFromPEM(t,"PRIVATE KEY"),n=this.getKeyFromPlainPrivatePKCS8Hex(e);return n},getKeyFromPlainPrivatePKCS8Hex:function(t){var e=this.parsePlainPrivatePKCS8Hex(t);if("2a864886f70d010101"==e.algoid){this.parsePrivateRawRSAKeyHexAtObj(t,e);var n=e.key,r=new ve;return r.setPrivateEx(n.n,n.e,n.d,n.p,n.q,n.dp,n.dq,n.co),r}if("2a8648ce3d0201"==e.algoid){if(this.parsePrivateRawECKeyHexAtObj(t,e),void 0===KJUR.crypto.OID.oidhex2name[e.algparam])throw"KJUR.crypto.OID.oidhex2name undefined: "+e.algparam;var i=KJUR.crypto.OID.oidhex2name[e.algparam],r=new KJUR.crypto.ECDSA({curve:i,prv:e.key});return r}throw"unsupported private key algorithm"},getRSAKeyFromPublicPKCS8PEM:function(t){var e=this.getHexFromPEM(t,"PUBLIC KEY"),n=this.getRSAKeyFromPublicPKCS8Hex(e);return n},getKeyFromPublicPKCS8PEM:function(t){var e=this.getHexFromPEM(t,"PUBLIC KEY"),n=this.getKeyFromPublicPKCS8Hex(e);return n},getKeyFromPublicPKCS8Hex:function(t){var e=this.parsePublicPKCS8Hex(t);if("2a864886f70d010101"==e.algoid){var n=this.parsePublicRawRSAKeyHex(e.key),r=new ve;return r.setPublic(n.n,n.e),r}if("2a8648ce3d0201"==e.algoid){if(void 0===KJUR.crypto.OID.oidhex2name[e.algparam])throw"KJUR.crypto.OID.oidhex2name undefined: "+e.algparam;var i=KJUR.crypto.OID.oidhex2name[e.algparam],r=new KJUR.crypto.ECDSA({curve:i,pub:e.key});return r}throw"unsupported public key algorithm"},parsePublicRawRSAKeyHex:function(t){var e={};if("30"!=t.substr(0,2))throw"malformed RSA key(code:001)";var n=Fr.getPosArrayOfChildren_AtObj(t,0);if(2!=n.length)throw"malformed RSA key(code:002)";if("02"!=t.substr(n[0],2))throw"malformed RSA key(code:003)";if(e.n=Fr.getHexOfV_AtObj(t,n[0]),"02"!=t.substr(n[1],2))throw"malformed RSA key(code:004)";return e.e=Fr.getHexOfV_AtObj(t,n[1]),e},parsePrivateRawRSAKeyHexAtObj:function(t,e){var n=e.keyidx;if("30"!=t.substr(n,2))throw"malformed RSA private key(code:001)";var r=Fr.getPosArrayOfChildren_AtObj(t,n);if(9!=r.length)throw"malformed RSA private key(code:002)";e.key={},e.key.n=Fr.getHexOfV_AtObj(t,r[1]),e.key.e=Fr.getHexOfV_AtObj(t,r[2]),e.key.d=Fr.getHexOfV_AtObj(t,r[3]),e.key.p=Fr.getHexOfV_AtObj(t,r[4]),e.key.q=Fr.getHexOfV_AtObj(t,r[5]),e.key.dp=Fr.getHexOfV_AtObj(t,r[6]),e.key.dq=Fr.getHexOfV_AtObj(t,r[7]),e.key.co=Fr.getHexOfV_AtObj(t,r[8])},parsePrivateRawECKeyHexAtObj:function(t,e){var n=e.keyidx;if("30"!=t.substr(n,2))throw"malformed ECC private key(code:001)";var r=Fr.getPosArrayOfChildren_AtObj(t,n);if(3!=r.length)throw"malformed ECC private key(code:002)";if("04"!=t.substr(r[1],2))throw"malformed ECC private key(code:003)";e.key=Fr.getHexOfV_AtObj(t,r[1])},parsePublicPKCS8Hex:function(t){var e={};e.algparam=null;var n=Fr.getPosArrayOfChildren_AtObj(t,0);if(2!=n.length)throw"outer DERSequence shall have 2 elements: "+n.length;var r=n[0];if("30"!=t.substr(r,2))throw"malformed PKCS8 public key(code:001)";var i=Fr.getPosArrayOfChildren_AtObj(t,r);if(2!=i.length)throw"malformed PKCS8 public key(code:002)";if("06"!=t.substr(i[0],2))throw"malformed PKCS8 public key(code:003)";if(e.algoid=Fr.getHexOfV_AtObj(t,i[0]),"06"==t.substr(i[1],2)&&(e.algparam=Fr.getHexOfV_AtObj(t,i[1])),"03"!=t.substr(n[1],2))throw"malformed PKCS8 public key(code:004)";return e.key=Fr.getHexOfV_AtObj(t,n[1]).substr(2),e},getRSAKeyFromPublicPKCS8Hex:function(t){var e=Fr.getPosArrayOfChildren_AtObj(t,0);if(2!=e.length)throw"outer DERSequence shall have 2 elements: "+e.length;var n=Fr.getHexOfTLV_AtObj(t,e[0]);if("300d06092a864886f70d0101010500"!=n)throw"PKCS8 AlgorithmId is not rsaEncryption";if("03"!=t.substr(e[1],2))throw"PKCS8 Public Key is not BITSTRING encapslated.";var r=Fr.getStartPosOfV_AtObj(t,e[1])+2;if("30"!=t.substr(r,2))throw"PKCS8 Public Key is not SEQUENCE.";var i=Fr.getPosArrayOfChildren_AtObj(t,r);if(2!=i.length)throw"inner DERSequence shall have 2 elements: "+i.length;if("02"!=t.substr(i[0],2))throw"N is not ASN.1 INTEGER";if("02"!=t.substr(i[1],2))throw"E is not ASN.1 INTEGER";var s=Fr.getHexOfV_AtObj(t,i[0]),o=Fr.getHexOfV_AtObj(t,i[1]),a=new ve;return a.setPublic(s,o),a}}}(),Cr=function(){var t=function(t,e,n){return r(sr.AES,t,e,n)},e=function(t,e,n){return r(sr.TripleDES,t,e,n)},n=function(t,e,n){return r(sr.DES,t,e,n)},r=function(t,e,n,r){var i=sr.enc.Hex.parse(e),s=sr.enc.Hex.parse(n),o=sr.enc.Hex.parse(r),a={};a.key=s,a.iv=o,a.ciphertext=i;var u=t.decrypt(a,s,{iv:o});return sr.enc.Hex.stringify(u)},s=function(t,e,n){return c(sr.AES,t,e,n)},a=function(t,e,n){return c(sr.TripleDES,t,e,n)},u=function(t,e,n){return c(sr.DES,t,e,n)},c=function(t,e,n,r){var i=sr.enc.Hex.parse(e),s=sr.enc.Hex.parse(n),o=sr.enc.Hex.parse(r),a=t.encrypt(i,s,{iv:o}),u=sr.enc.Hex.parse(a.toString()),c=sr.enc.Base64.stringify(u);return c},f={"AES-256-CBC":{proc:t,eproc:s,keylen:32,ivlen:16},"AES-192-CBC":{proc:t,eproc:s,keylen:24,ivlen:16},"AES-128-CBC":{proc:t,eproc:s,keylen:16,ivlen:16},"DES-EDE3-CBC":{proc:e,eproc:a,keylen:24,ivlen:8},"DES-CBC":{proc:n,eproc:u,keylen:8,ivlen:8}},h=function(t){return f[t].proc},l=function(t){var e=sr.lib.WordArray.random(t),n=sr.enc.Hex.stringify(e);return n},d=function(t){var e={};t.match(new RegExp("DEK-Info: ([^,]+),([0-9A-Fa-f]+)","m"))&&(e.cipher=RegExp.$1,e.ivsalt=RegExp.$2),t.match(new RegExp("-----BEGIN ([A-Z]+) PRIVATE KEY-----"))&&(e.type=RegExp.$1);var n=-1,r=0;-1!=t.indexOf("\r\n\r\n")&&(n=t.indexOf("\r\n\r\n"),r=2),-1!=t.indexOf("\n\n")&&(n=t.indexOf("\n\n"),r=1);var i=t.indexOf("-----END");if(-1!=n&&-1!=i){var s=t.substring(n+2*r,i-r);s=s.replace(/\s+/g,""),e.data=s}return e},p=function(t,e,n){for(var r=n.substring(0,16),i=sr.enc.Hex.parse(r),s=sr.enc.Utf8.parse(e),o=f[t].keylen+f[t].ivlen,a="",u=null;;){var c=sr.algo.MD5.create();if(null!=u&&c.update(u),c.update(s),c.update(i),u=c.finalize(),a+=sr.enc.Hex.stringify(u),a.length>=2*o)break}var h={};return h.keyhex=a.substr(0,2*f[t].keylen),h.ivhex=a.substr(2*f[t].keylen,2*f[t].ivlen),h},g=function(t,e,n,r){var i=sr.enc.Base64.parse(t),s=sr.enc.Hex.stringify(i),o=f[e].proc,a=o(s,n,r);return a},y=function(t,e,n,r){var i=f[e].eproc,s=i(t,n,r);return s};return{version:"1.0.0",getHexFromPEM:function(t,e){var n=t;if(-1==n.indexOf("-----BEGIN "))throw"can't find PEM header: "+e;"string"==typeof e&&""!=e?(n=n.replace("-----BEGIN "+e+"-----",""),n=n.replace("-----END "+e+"-----","")):(n=n.replace(/-----BEGIN [^-]+-----/,""),n=n.replace(/-----END [^-]+-----/,""));var r=n.replace(/\s+/g,""),s=i(r);return s},getDecryptedKeyHexByKeyIV:function(t,e,n,r){var i=h(e);return i(t,n,r)},parsePKCS5PEM:function(t){return d(t)},getKeyAndUnusedIvByPasscodeAndIvsalt:function(t,e,n){return p(t,e,n)},decryptKeyB64:function(t,e,n,r){return g(t,e,n,r)},getDecryptedKeyHex:function(t,e){var n=d(t),r=(n.type,n.cipher),i=n.ivsalt,s=n.data,o=p(r,e,i),a=o.keyhex,u=g(s,r,a,i);return u},getRSAKeyFromEncryptedPKCS5PEM:function(t,e){var n=this.getDecryptedKeyHex(t,e),r=new ve;return r.readPrivateKeyFromASN1HexString(n),r},getEncryptedPKCS5PEMFromPrvKeyHex:function(t,e,n,r,i){var s="";if("undefined"!=typeof r&&null!=r||(r="AES-256-CBC"),"undefined"==typeof f[r])throw"KEYUTIL unsupported algorithm: "+r;if("undefined"==typeof i||null==i){var o=f[r].ivlen,a=l(o);i=a.toUpperCase()}var u=p(r,n,i),c=u.keyhex,h=y(e,r,c,i),d=h.replace(/(.{64})/g,"$1\r\n"),s="-----BEGIN "+t+" PRIVATE KEY-----\r\n";return s+="Proc-Type: 4,ENCRYPTED\r\n",s+="DEK-Info: "+r+","+i+"\r\n",s+="\r\n",s+=d,s+="\r\n-----END "+t+" PRIVATE KEY-----\r\n"},getEncryptedPKCS5PEMFromRSAKey:function(t,e,n,r){var i=new KJUR.asn1.DERInteger({"int":0}),s=new KJUR.asn1.DERInteger({bigint:t.n}),o=new KJUR.asn1.DERInteger({"int":t.e}),a=new KJUR.asn1.DERInteger({bigint:t.d}),u=new KJUR.asn1.DERInteger({bigint:t.p}),c=new KJUR.asn1.DERInteger({bigint:t.q}),f=new KJUR.asn1.DERInteger({bigint:t.dmp1}),h=new KJUR.asn1.DERInteger({bigint:t.dmq1}),l=new KJUR.asn1.DERInteger({bigint:t.coeff}),d=new KJUR.asn1.DERSequence({array:[i,s,o,a,u,c,f,h,l]}),p=d.getEncodedHex();return this.getEncryptedPKCS5PEMFromPrvKeyHex("RSA",p,e,n,r)},newEncryptedPKCS5PEM:function(t,e,n,r){"undefined"!=typeof e&&null!=e||(e=1024),"undefined"!=typeof n&&null!=n||(n="10001");var i=new ve;i.generate(e,n);var s=null;return s="undefined"==typeof r||null==r?this.getEncryptedPKCS5PEMFromRSAKey(i,t):this.getEncryptedPKCS5PEMFromRSAKey(i,t,r)},getRSAKeyFromPlainPKCS8PEM:function(t){if(t.match(/ENCRYPTED/))throw"pem shall be not ENCRYPTED";var e=this.getHexFromPEM(t,"PRIVATE KEY"),n=this.getRSAKeyFromPlainPKCS8Hex(e);return n},getRSAKeyFromPlainPKCS8Hex:function(t){var e=Fr.getPosArrayOfChildren_AtObj(t,0);if(3!=e.length)throw"outer DERSequence shall have 3 elements: "+e.length;var n=Fr.getHexOfTLV_AtObj(t,e[1]);if("300d06092a864886f70d0101010500"!=n)throw"PKCS8 AlgorithmIdentifier is not rsaEnc: "+n;var n=Fr.getHexOfTLV_AtObj(t,e[1]),r=Fr.getHexOfTLV_AtObj(t,e[2]),i=Fr.getHexOfV_AtObj(r,0),s=new ve;return s.readPrivateKeyFromASN1HexString(i),s},parseHexOfEncryptedPKCS8:function(t){var e={},n=Fr.getPosArrayOfChildren_AtObj(t,0);if(2!=n.length)throw"malformed format: SEQUENCE(0).items != 2: "+n.length;e.ciphertext=Fr.getHexOfV_AtObj(t,n[1]);var r=Fr.getPosArrayOfChildren_AtObj(t,n[0]);if(2!=r.length)throw"malformed format: SEQUENCE(0.0).items != 2: "+r.length;if("2a864886f70d01050d"!=Fr.getHexOfV_AtObj(t,r[0]))throw"this only supports pkcs5PBES2";var i=Fr.getPosArrayOfChildren_AtObj(t,r[1]);if(2!=r.length)throw"malformed format: SEQUENCE(0.0.1).items != 2: "+i.length;var s=Fr.getPosArrayOfChildren_AtObj(t,i[1]);if(2!=s.length)throw"malformed format: SEQUENCE(0.0.1.1).items != 2: "+s.length;if("2a864886f70d0307"!=Fr.getHexOfV_AtObj(t,s[0]))throw"this only supports TripleDES";e.encryptionSchemeAlg="TripleDES",e.encryptionSchemeIV=Fr.getHexOfV_AtObj(t,s[1]);var o=Fr.getPosArrayOfChildren_AtObj(t,i[0]);if(2!=o.length)throw"malformed format: SEQUENCE(0.0.1.0).items != 2: "+o.length;if("2a864886f70d01050c"!=Fr.getHexOfV_AtObj(t,o[0]))throw"this only supports pkcs5PBKDF2";var a=Fr.getPosArrayOfChildren_AtObj(t,o[1]);if(a.length<2)throw"malformed format: SEQUENCE(0.0.1.0.1).items < 2: "+a.length;e.pbkdf2Salt=Fr.getHexOfV_AtObj(t,a[0]);var u=Fr.getHexOfV_AtObj(t,a[1]);try{e.pbkdf2Iter=parseInt(u,16)}catch(c){throw"malformed format pbkdf2Iter: "+u}return e},getPBKDF2KeyHexFromParam:function(t,e){var n=sr.enc.Hex.parse(t.pbkdf2Salt),r=t.pbkdf2Iter,i=sr.PBKDF2(e,n,{keySize:6,iterations:r}),s=sr.enc.Hex.stringify(i);return s},getPlainPKCS8HexFromEncryptedPKCS8PEM:function(t,e){var n=this.getHexFromPEM(t,"ENCRYPTED PRIVATE KEY"),r=this.parseHexOfEncryptedPKCS8(n),i=Cr.getPBKDF2KeyHexFromParam(r,e),s={};s.ciphertext=sr.enc.Hex.parse(r.ciphertext);var o=sr.enc.Hex.parse(i),a=sr.enc.Hex.parse(r.encryptionSchemeIV),u=sr.TripleDES.decrypt(s,o,{iv:a}),c=sr.enc.Hex.stringify(u);return c},getRSAKeyFromEncryptedPKCS8PEM:function(t,e){var n=this.getPlainPKCS8HexFromEncryptedPKCS8PEM(t,e),r=this.getRSAKeyFromPlainPKCS8Hex(n);return r},getKeyFromEncryptedPKCS8PEM:function(t,e){var n=this.getPlainPKCS8HexFromEncryptedPKCS8PEM(t,e),r=this.getKeyFromPlainPrivatePKCS8Hex(n);return r},parsePlainPrivatePKCS8Hex:function(t){var e={};if(e.algparam=null,"30"!=t.substr(0,2))throw"malformed plain PKCS8 private key(code:001)";var n=Fr.getPosArrayOfChildren_AtObj(t,0);if(3!=n.length)throw"malformed plain PKCS8 private key(code:002)";if("30"!=t.substr(n[1],2))throw"malformed PKCS8 private key(code:003)";var r=Fr.getPosArrayOfChildren_AtObj(t,n[1]);if(2!=r.length)throw"malformed PKCS8 private key(code:004)";if("06"!=t.substr(r[0],2))throw"malformed PKCS8 private key(code:005)";if(e.algoid=Fr.getHexOfV_AtObj(t,r[0]),"06"==t.substr(r[1],2)&&(e.algparam=Fr.getHexOfV_AtObj(t,r[1])),"04"!=t.substr(n[2],2))throw"malformed PKCS8 private key(code:006)";return e.keyidx=Fr.getStartPosOfV_AtObj(t,n[2]),e},getKeyFromPlainPrivatePKCS8PEM:function(t){var e=this.getHexFromPEM(t,"PRIVATE KEY"),n=this.getKeyFromPlainPrivatePKCS8Hex(e);return n},getKeyFromPlainPrivatePKCS8Hex:function(t){var e=this.parsePlainPrivatePKCS8Hex(t);if("2a864886f70d010101"==e.algoid){this.parsePrivateRawRSAKeyHexAtObj(t,e);var n=e.key,r=new ve;return r.setPrivateEx(n.n,n.e,n.d,n.p,n.q,n.dp,n.dq,n.co),r}if("2a8648ce3d0201"==e.algoid){if(this.parsePrivateRawECKeyHexAtObj(t,e),void 0===KJUR.crypto.OID.oidhex2name[e.algparam])throw"KJUR.crypto.OID.oidhex2name undefined: "+e.algparam;var i=KJUR.crypto.OID.oidhex2name[e.algparam],r=new KJUR.crypto.ECDSA({curve:i});return r.setPublicKeyHex(e.pubkey),r.setPrivateKeyHex(e.key),r.isPublic=!1,r}if("2a8648ce380401"==e.algoid){var s=Fr.getVbyList(t,0,[1,1,0],"02"),a=Fr.getVbyList(t,0,[1,1,1],"02"),u=Fr.getVbyList(t,0,[1,1,2],"02"),c=Fr.getVbyList(t,0,[2,0],"02"),f=new o(s,16),h=new o(a,16),l=new o(u,16),d=new o(c,16),r=new KJUR.crypto.DSA;return r.setPrivate(f,h,l,null,d),r}throw"unsupported private key algorithm"},getRSAKeyFromPublicPKCS8PEM:function(t){var e=this.getHexFromPEM(t,"PUBLIC KEY"),n=this.getRSAKeyFromPublicPKCS8Hex(e);return n},getKeyFromPublicPKCS8PEM:function(t){var e=this.getHexFromPEM(t,"PUBLIC KEY"),n=this.getKeyFromPublicPKCS8Hex(e);return n},getKeyFromPublicPKCS8Hex:function(t){var e=this.parsePublicPKCS8Hex(t);if("2a864886f70d010101"==e.algoid){var n=this.parsePublicRawRSAKeyHex(e.key),r=new ve;return r.setPublic(n.n,n.e),r}if("2a8648ce3d0201"==e.algoid){if(void 0===KJUR.crypto.OID.oidhex2name[e.algparam])throw"KJUR.crypto.OID.oidhex2name undefined: "+e.algparam;var i=KJUR.crypto.OID.oidhex2name[e.algparam],r=new KJUR.crypto.ECDSA({curve:i,pub:e.key});return r}if("2a8648ce380401"==e.algoid){var s=e.algparam,a=Fr.getHexOfV_AtObj(e.key,0),r=new KJUR.crypto.DSA;return r.setPublic(new o(s.p,16),new o(s.q,16),new o(s.g,16),new o(a,16)),r}throw"unsupported public key algorithm"},parsePublicRawRSAKeyHex:function(t){var e={};if("30"!=t.substr(0,2))throw"malformed RSA key(code:001)";var n=Fr.getPosArrayOfChildren_AtObj(t,0);if(2!=n.length)throw"malformed RSA key(code:002)";if("02"!=t.substr(n[0],2))throw"malformed RSA key(code:003)";if(e.n=Fr.getHexOfV_AtObj(t,n[0]),"02"!=t.substr(n[1],2))throw"malformed RSA key(code:004)";return e.e=Fr.getHexOfV_AtObj(t,n[1]),e},parsePrivateRawRSAKeyHexAtObj:function(t,e){var n=e.keyidx;if("30"!=t.substr(n,2))throw"malformed RSA private key(code:001)";var r=Fr.getPosArrayOfChildren_AtObj(t,n);if(9!=r.length)throw"malformed RSA private key(code:002)";e.key={},e.key.n=Fr.getHexOfV_AtObj(t,r[1]),e.key.e=Fr.getHexOfV_AtObj(t,r[2]),e.key.d=Fr.getHexOfV_AtObj(t,r[3]),e.key.p=Fr.getHexOfV_AtObj(t,r[4]),e.key.q=Fr.getHexOfV_AtObj(t,r[5]),e.key.dp=Fr.getHexOfV_AtObj(t,r[6]),e.key.dq=Fr.getHexOfV_AtObj(t,r[7]),e.key.co=Fr.getHexOfV_AtObj(t,r[8])},parsePrivateRawECKeyHexAtObj:function(t,e){var n=e.keyidx,r=Fr.getVbyList(t,n,[1],"04"),i=Fr.getVbyList(t,n,[2,0],"03").substr(2);e.key=r,e.pubkey=i},parsePublicPKCS8Hex:function(t){var e={};e.algparam=null;var n=Fr.getPosArrayOfChildren_AtObj(t,0);if(2!=n.length)throw"outer DERSequence shall have 2 elements: "+n.length;var r=n[0];if("30"!=t.substr(r,2))throw"malformed PKCS8 public key(code:001)";var i=Fr.getPosArrayOfChildren_AtObj(t,r);if(2!=i.length)throw"malformed PKCS8 public key(code:002)";if("06"!=t.substr(i[0],2))throw"malformed PKCS8 public key(code:003)";if(e.algoid=Fr.getHexOfV_AtObj(t,i[0]),"06"==t.substr(i[1],2)?e.algparam=Fr.getHexOfV_AtObj(t,i[1]):"30"==t.substr(i[1],2)&&(e.algparam={},e.algparam.p=Fr.getVbyList(t,i[1],[0],"02"),e.algparam.q=Fr.getVbyList(t,i[1],[1],"02"),e.algparam.g=Fr.getVbyList(t,i[1],[2],"02")),"03"!=t.substr(n[1],2))throw"malformed PKCS8 public key(code:004)";return e.key=Fr.getHexOfV_AtObj(t,n[1]).substr(2),e},getRSAKeyFromPublicPKCS8Hex:function(t){var e=Fr.getPosArrayOfChildren_AtObj(t,0);if(2!=e.length)throw"outer DERSequence shall have 2 elements: "+e.length;var n=Fr.getHexOfTLV_AtObj(t,e[0]);if("300d06092a864886f70d0101010500"!=n)throw"PKCS8 AlgorithmId is not rsaEncryption";if("03"!=t.substr(e[1],2))throw"PKCS8 Public Key is not BITSTRING encapslated.";var r=Fr.getStartPosOfV_AtObj(t,e[1])+2;if("30"!=t.substr(r,2))throw"PKCS8 Public Key is not SEQUENCE.";var i=Fr.getPosArrayOfChildren_AtObj(t,r);if(2!=i.length)throw"inner DERSequence shall have 2 elements: "+i.length;if("02"!=t.substr(i[0],2))throw"N is not ASN.1 INTEGER";if("02"!=t.substr(i[1],2))throw"E is not ASN.1 INTEGER";var s=Fr.getHexOfV_AtObj(t,i[0]),o=Fr.getHexOfV_AtObj(t,i[1]),a=new ve;return a.setPublic(s,o),a}}}();Cr.getKey=function(t,e,n){if("undefined"!=typeof ve&&t instanceof ve)return t;if("undefined"!=typeof KJUR.crypto.ECDSA&&t instanceof KJUR.crypto.ECDSA)return t;if("undefined"!=typeof KJUR.crypto.DSA&&t instanceof KJUR.crypto.DSA)return t;if(void 0!==t.curve&&void 0!==t.xy&&void 0===t.d)return new KJUR.crypto.ECDSA({pub:t.xy,curve:t.curve});if(void 0!==t.curve&&void 0!==t.d)return new KJUR.crypto.ECDSA({prv:t.d,curve:t.curve});if(void 0===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0===t.d){var r=new ve;return r.setPublic(t.n,t.e),r}if(void 0===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0!==t.d&&void 0!==t.p&&void 0!==t.q&&void 0!==t.dp&&void 0!==t.dq&&void 0!==t.co&&void 0===t.qi){var r=new ve;return r.setPrivateEx(t.n,t.e,t.d,t.p,t.q,t.dp,t.dq,t.co),r}if(void 0===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0!==t.d&&void 0===t.p){var r=new ve;return r.setPrivate(t.n,t.e,t.d),r}if(void 0!==t.p&&void 0!==t.q&&void 0!==t.g&&void 0!==t.y&&void 0===t.x){var r=new KJUR.crypto.DSA;return r.setPublic(t.p,t.q,t.g,t.y),r}if(void 0!==t.p&&void 0!==t.q&&void 0!==t.g&&void 0!==t.y&&void 0!==t.x){var r=new KJUR.crypto.DSA;return r.setPrivate(t.p,t.q,t.g,t.y,t.x),r}if("RSA"===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0===t.d){var r=new ve;return r.setPublic(gn(t.n),gn(t.e)),r}if("RSA"===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0!==t.d&&void 0!==t.p&&void 0!==t.q&&void 0!==t.dp&&void 0!==t.dq&&void 0!==t.qi){var r=new ve;return r.setPrivateEx(gn(t.n),gn(t.e),gn(t.d),gn(t.p),gn(t.q),gn(t.dp),gn(t.dq),gn(t.qi)),r}if("RSA"===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0!==t.d){var r=new ve;return r.setPrivate(gn(t.n),gn(t.e),gn(t.d)),r}if("EC"===t.kty&&void 0!==t.crv&&void 0!==t.x&&void 0!==t.y&&void 0===t.d){var i=new KJUR.crypto.ECDSA({curve:t.crv}),s=i.ecparams.keylen/4,a=("0000000000"+gn(t.x)).slice(-s),u=("0000000000"+gn(t.y)).slice(-s),c="04"+a+u;return i.setPublicKeyHex(c),i}if("EC"===t.kty&&void 0!==t.crv&&void 0!==t.x&&void 0!==t.y&&void 0!==t.d){var i=new KJUR.crypto.ECDSA({curve:t.crv}),s=i.ecparams.keylen/4,f=("0000000000"+gn(t.d)).slice(-s);return i.setPrivateKeyHex(f),i}if(-1!=t.indexOf("-END CERTIFICATE-",0)||-1!=t.indexOf("-END X509 CERTIFICATE-",0)||-1!=t.indexOf("-END TRUSTED CERTIFICATE-",0))return Xn.getPublicKeyFromCertPEM(t);if("pkcs8pub"===n)return Cr.getKeyFromPublicPKCS8Hex(t);if(-1!=t.indexOf("-END PUBLIC KEY-"))return Cr.getKeyFromPublicPKCS8PEM(t);if("pkcs5prv"===n){var r=new ve;return r.readPrivateKeyFromASN1HexString(t),r}if("pkcs5prv"===n){var r=new ve;return r.readPrivateKeyFromASN1HexString(t),r}if(-1!=t.indexOf("-END RSA PRIVATE KEY-")&&-1==t.indexOf("4,ENCRYPTED")){var h=Cr.getHexFromPEM(t,"RSA PRIVATE KEY");return Cr.getKey(h,null,"pkcs5prv")}if(-1!=t.indexOf("-END DSA PRIVATE KEY-")&&-1==t.indexOf("4,ENCRYPTED")){var l=this.getHexFromPEM(t,"DSA PRIVATE KEY"),d=Fr.getVbyList(l,0,[1],"02"),p=Fr.getVbyList(l,0,[2],"02"),g=Fr.getVbyList(l,0,[3],"02"),y=Fr.getVbyList(l,0,[4],"02"),v=Fr.getVbyList(l,0,[5],"02"),r=new KJUR.crypto.DSA;return r.setPrivate(new o(d,16),new o(p,16),new o(g,16),new o(y,16),new o(v,16)),r}if(-1!=t.indexOf("-END PRIVATE KEY-"))return Cr.getKeyFromPlainPrivatePKCS8PEM(t);if(-1!=t.indexOf("-END RSA PRIVATE KEY-")&&-1!=t.indexOf("4,ENCRYPTED"))return Cr.getRSAKeyFromEncryptedPKCS5PEM(t,e);if(-1!=t.indexOf("-END EC PRIVATE KEY-")&&-1!=t.indexOf("4,ENCRYPTED")){var l=Cr.getDecryptedKeyHex(t,e),r=Fr.getVbyList(l,0,[1],"04"),m=Fr.getVbyList(l,0,[2,0],"06"),S=Fr.getVbyList(l,0,[3,0],"03").substr(2),b="";if(void 0===KJUR.crypto.OID.oidhex2name[m])throw"undefined OID(hex) in KJUR.crypto.OID: "+m;b=KJUR.crypto.OID.oidhex2name[m];var i=new KJUR.crypto.ECDSA({name:b});return i.setPublicKeyHex(S),i.setPrivateKeyHex(r),i.isPublic=!1,i}if(-1!=t.indexOf("-END DSA PRIVATE KEY-")&&-1!=t.indexOf("4,ENCRYPTED")){var l=Cr.getDecryptedKeyHex(t,e),d=Fr.getVbyList(l,0,[1],"02"),p=Fr.getVbyList(l,0,[2],"02"),g=Fr.getVbyList(l,0,[3],"02"),y=Fr.getVbyList(l,0,[4],"02"),v=Fr.getVbyList(l,0,[5],"02"),r=new KJUR.crypto.DSA;return r.setPrivate(new o(d,16),new o(p,16),new o(g,16),new o(y,16),new o(v,16)),r}if(-1!=t.indexOf("-END ENCRYPTED PRIVATE KEY-"))return Cr.getKeyFromEncryptedPKCS8PEM(t,e);throw"not supported argument"},Cr.generateKeypair=function(t,e){if("RSA"==t){var n=e,r=new ve;r.generate(n,"10001"),r.isPrivate=!0,r.isPublic=!0;var i=new ve,s=r.n.toString(16),o=r.e.toString(16);i.setPublic(s,o),i.isPrivate=!1,i.isPublic=!0;var a={};return a.prvKeyObj=r,a.pubKeyObj=i,a}if("EC"==t){var u=e,c=new KJUR.crypto.ECDSA({curve:u}),f=c.generateKeyPairHex(),r=new KJUR.crypto.ECDSA({curve:u});r.setPrivateKeyHex(f.ecprvhex),r.isPrivate=!0,r.isPublic=!1;var i=new KJUR.crypto.ECDSA({curve:u});i.setPublicKeyHex(f.ecpubhex),i.isPrivate=!1,i.isPublic=!0;var a={};return a.prvKeyObj=r,a.pubKeyObj=i,a}throw"unknown algorithm: "+t},Cr.getPEM=function(t,e,n,r,i){function s(t){var e=KJUR.asn1.ASN1Util.newObject({seq:[{"int":0},{"int":{bigint:t.n}},{"int":t.e},{"int":{bigint:t.d}},{"int":{bigint:t.p}},{"int":{bigint:t.q}},{"int":{bigint:t.dmp1}},{"int":{bigint:t.dmq1}},{"int":{bigint:t.coeff}}]});return e}function o(t){var e=KJUR.asn1.ASN1Util.newObject({seq:[{"int":1},{octstr:{hex:t.prvKeyHex}},{tag:["a0",!0,{oid:{name:t.curveName}}]},{tag:["a1",!0,{bitstr:{hex:"00"+t.pubKeyHex}}]}]});return e}function a(t){var e=KJUR.asn1.ASN1Util.newObject({seq:[{"int":0},{"int":{bigint:t.p}},{"int":{bigint:t.q}},{"int":{bigint:t.g}},{"int":{bigint:t.y}},{"int":{bigint:t.x}}]});return e}var u=KJUR.asn1,c=KJUR.crypto;if(("undefined"!=typeof ve&&t instanceof ve||"undefined"!=typeof c.DSA&&t instanceof c.DSA||"undefined"!=typeof c.ECDSA&&t instanceof c.ECDSA)&&1==t.isPublic&&(void 0===e||"PKCS8PUB"==e)){var f=new KJUR.asn1.x509.SubjectPublicKeyInfo(t),h=f.getEncodedHex();return u.ASN1Util.getPEMStringFromHex(h,"PUBLIC KEY")}if("PKCS1PRV"==e&&"undefined"!=typeof ve&&t instanceof ve&&(void 0===n||null==n)&&1==t.isPrivate){var f=s(t),h=f.getEncodedHex();return u.ASN1Util.getPEMStringFromHex(h,"RSA PRIVATE KEY")}if("PKCS1PRV"==e&&"undefined"!=typeof ve&&t instanceof KJUR.crypto.ECDSA&&(void 0===n||null==n)&&1==t.isPrivate){var l=new KJUR.asn1.DERObjectIdentifier({name:t.curveName}),d=l.getEncodedHex(),p=o(t),g=p.getEncodedHex(),y="";return y+=u.ASN1Util.getPEMStringFromHex(d,"EC PARAMETERS"),y+=u.ASN1Util.getPEMStringFromHex(g,"EC PRIVATE KEY")}if("PKCS1PRV"==e&&"undefined"!=typeof KJUR.crypto.DSA&&t instanceof KJUR.crypto.DSA&&(void 0===n||null==n)&&1==t.isPrivate){var f=a(t),h=f.getEncodedHex();return u.ASN1Util.getPEMStringFromHex(h,"DSA PRIVATE KEY")}if("PKCS5PRV"==e&&"undefined"!=typeof ve&&t instanceof ve&&void 0!==n&&null!=n&&1==t.isPrivate){var f=s(t),h=f.getEncodedHex();return void 0===r&&(r="DES-EDE3-CBC"),this.getEncryptedPKCS5PEMFromPrvKeyHex("RSA",h,n,r)}if("PKCS5PRV"==e&&"undefined"!=typeof KJUR.crypto.ECDSA&&t instanceof KJUR.crypto.ECDSA&&void 0!==n&&null!=n&&1==t.isPrivate){var f=o(t),h=f.getEncodedHex();return void 0===r&&(r="DES-EDE3-CBC"),this.getEncryptedPKCS5PEMFromPrvKeyHex("EC",h,n,r)}if("PKCS5PRV"==e&&"undefined"!=typeof KJUR.crypto.DSA&&t instanceof KJUR.crypto.DSA&&void 0!==n&&null!=n&&1==t.isPrivate){var f=a(t),h=f.getEncodedHex();return void 0===r&&(r="DES-EDE3-CBC"),this.getEncryptedPKCS5PEMFromPrvKeyHex("DSA",h,n,r)}var v=function(t,e){var n=m(t,e),r=new KJUR.asn1.ASN1Util.newObject({seq:[{seq:[{oid:{name:"pkcs5PBES2"}},{seq:[{seq:[{oid:{name:"pkcs5PBKDF2"}},{seq:[{octstr:{hex:n.pbkdf2Salt}},{"int":n.pbkdf2Iter}]}]},{seq:[{oid:{name:"des-EDE3-CBC"}},{octstr:{hex:n.encryptionSchemeIV}}]}]}]},{octstr:{hex:n.ciphertext}}]});return r.getEncodedHex()},m=function(t,e){var n=100,r=sr.lib.WordArray.random(8),i="DES-EDE3-CBC",s=sr.lib.WordArray.random(8),o=sr.PBKDF2(e,r,{keySize:6,iterations:n}),a=sr.enc.Hex.parse(t),u=sr.TripleDES.encrypt(a,o,{iv:s})+"",c={};return c.ciphertext=u,c.pbkdf2Salt=sr.enc.Hex.stringify(r),c.pbkdf2Iter=n,c.encryptionSchemeAlg=i,c.encryptionSchemeIV=sr.enc.Hex.stringify(s),c};if("PKCS8PRV"==e&&"undefined"!=typeof ve&&t instanceof ve&&1==t.isPrivate){var S=s(t),b=S.getEncodedHex(),f=KJUR.asn1.ASN1Util.newObject({seq:[{"int":0},{seq:[{oid:{name:"rsaEncryption"}},{"null":!0}]},{octstr:{hex:b}}]}),h=f.getEncodedHex();if(void 0===n||null==n)return u.ASN1Util.getPEMStringFromHex(h,"PRIVATE KEY");
var g=v(h,n);return u.ASN1Util.getPEMStringFromHex(g,"ENCRYPTED PRIVATE KEY")}if("PKCS8PRV"==e&&"undefined"!=typeof KJUR.crypto.ECDSA&&t instanceof KJUR.crypto.ECDSA&&1==t.isPrivate){var S=new KJUR.asn1.ASN1Util.newObject({seq:[{"int":1},{octstr:{hex:t.prvKeyHex}},{tag:["a1",!0,{bitstr:{hex:"00"+t.pubKeyHex}}]}]}),b=S.getEncodedHex(),f=KJUR.asn1.ASN1Util.newObject({seq:[{"int":0},{seq:[{oid:{name:"ecPublicKey"}},{oid:{name:t.curveName}}]},{octstr:{hex:b}}]}),h=f.getEncodedHex();if(void 0===n||null==n)return u.ASN1Util.getPEMStringFromHex(h,"PRIVATE KEY");var g=v(h,n);return u.ASN1Util.getPEMStringFromHex(g,"ENCRYPTED PRIVATE KEY")}if("PKCS8PRV"==e&&"undefined"!=typeof KJUR.crypto.DSA&&t instanceof KJUR.crypto.DSA&&1==t.isPrivate){var S=new KJUR.asn1.DERInteger({bigint:t.x}),b=S.getEncodedHex(),f=KJUR.asn1.ASN1Util.newObject({seq:[{"int":0},{seq:[{oid:{name:"dsa"}},{seq:[{"int":{bigint:t.p}},{"int":{bigint:t.q}},{"int":{bigint:t.g}}]}]},{octstr:{hex:b}}]}),h=f.getEncodedHex();if(void 0===n||null==n)return u.ASN1Util.getPEMStringFromHex(h,"PRIVATE KEY");var g=v(h,n);return u.ASN1Util.getPEMStringFromHex(g,"ENCRYPTED PRIVATE KEY")}throw"unsupported object nor format"},Cr.getKeyFromCSRPEM=function(t){var e=Cr.getHexFromPEM(t,"CERTIFICATE REQUEST"),n=Cr.getKeyFromCSRHex(e);return n},Cr.getKeyFromCSRHex=function(t){var e=Cr.parseCSRHex(t),n=Cr.getKey(e.p8pubkeyhex,null,"pkcs8pub");return n},Cr.parseCSRHex=function(t){var e={},n=t;if("30"!=n.substr(0,2))throw"malformed CSR(code:001)";var r=Fr.getPosArrayOfChildren_AtObj(n,0);if(r.length<1)throw"malformed CSR(code:002)";if("30"!=n.substr(r[0],2))throw"malformed CSR(code:003)";var i=Fr.getPosArrayOfChildren_AtObj(n,r[0]);if(i.length<3)throw"malformed CSR(code:004)";return e.p8pubkeyhex=Fr.getHexOfTLV_AtObj(n,i[2]),e},ve.prototype.readPrivateKeyFromPEMString=Cn,ve.prototype.readPrivateKeyFromASN1HexString=On;/*! rsasign-1.2.7.js (c) 2012 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
var Ir=new RegExp("");Ir.compile("[^0-9a-f]","gi"),ve.prototype.signWithMessageHash=Tn,ve.prototype.signString=jn,ve.prototype.signStringWithSHA1=Dn,ve.prototype.signStringWithSHA256=Jn,ve.prototype.sign=jn,ve.prototype.signWithSHA1=Dn,ve.prototype.signWithSHA256=Jn,ve.prototype.signWithMessageHashPSS=kn,ve.prototype.signStringPSS=Bn,ve.prototype.signPSS=Bn,ve.SALT_LEN_HLEN=-1,ve.SALT_LEN_MAX=-2,ve.prototype.verifyWithMessageHash=zn,ve.prototype.verifyString=Wn,ve.prototype.verifyHexSignatureForMessage=qn,ve.prototype.verify=Wn,ve.prototype.verifyHexSignatureForByteArrayMessage=qn,ve.prototype.verifyWithMessageHashPSS=Gn,ve.prototype.verifyStringPSS=Yn,ve.prototype.verifyPSS=Yn,ve.SALT_LEN_RECOVER=-2,Xn.pemToBase64=function(t){var e=t;return e=e.replace("-----BEGIN CERTIFICATE-----",""),e=e.replace("-----END CERTIFICATE-----",""),e=e.replace(/[ \n]+/g,"")},Xn.pemToHex=function(t){var e=Xn.pemToBase64(t),n=i(e);return n},Xn.getSubjectPublicKeyPosFromCertHex=function(t){var e=Xn.getSubjectPublicKeyInfoPosFromCertHex(t);if(-1==e)return-1;var n=Fr.getPosArrayOfChildren_AtObj(t,e);if(2!=n.length)return-1;var r=n[1];if("03"!=t.substring(r,r+2))return-1;var i=Fr.getStartPosOfV_AtObj(t,r);return"00"!=t.substring(i,i+2)?-1:i+2},Xn.getSubjectPublicKeyInfoPosFromCertHex=function(t){var e=Fr.getStartPosOfV_AtObj(t,0),n=Fr.getPosArrayOfChildren_AtObj(t,e);return n.length<1?-1:"a003020102"==t.substring(n[0],n[0]+10)?n.length<6?-1:n[6]:n.length<5?-1:n[5]},Xn.getPublicKeyHexArrayFromCertHex=function(t){var e=Xn.getSubjectPublicKeyPosFromCertHex(t),n=Fr.getPosArrayOfChildren_AtObj(t,e);if(2!=n.length)return[];var r=Fr.getHexOfV_AtObj(t,n[0]),i=Fr.getHexOfV_AtObj(t,n[1]);return null!=r&&null!=i?[r,i]:[]},Xn.getHexTbsCertificateFromCert=function(t){var e=Fr.getStartPosOfV_AtObj(t,0);return e},Xn.getPublicKeyHexArrayFromCertPEM=function(t){var e=Xn.pemToHex(t),n=Xn.getPublicKeyHexArrayFromCertHex(e);return n},Xn.hex2dn=function(t){for(var e="",n=Fr.getPosArrayOfChildren_AtObj(t,0),r=0;r<n.length;r++){var i=Fr.getHexOfTLV_AtObj(t,n[r]);e=e+"/"+Xn.hex2rdn(i)}return e},Xn.hex2rdn=function(t){var e=Fr.getDecendantHexTLVByNthList(t,0,[0,0]),n=Fr.getDecendantHexVByNthList(t,0,[0,1]),r="";try{r=Xn.DN_ATTRHEX[e]}catch(i){r=e}n=n.replace(/(..)/g,"%$1");var s=decodeURIComponent(n);return r+"="+s},Xn.DN_ATTRHEX={"0603550406":"C","060355040a":"O","060355040b":"OU","0603550403":"CN","0603550405":"SN","0603550408":"ST","0603550407":"L","0603550409":"streetAddress","060355040f":"businessCategory","0603550411":"postalCode","060b2b0601040182373c020102":"jurisdictionOfIncorporationSP","060b2b0601040182373c020103":"jurisdictionOfIncorporationC"},Xn.getPublicKeyFromCertPEM=function(t){var e=Xn.getPublicKeyInfoPropOfCertPEM(t);if("2a864886f70d010101"==e.algoid){var n=Cr.parsePublicRawRSAKeyHex(e.keyhex),r=new ve;return r.setPublic(n.n,n.e),r}if("2a8648ce3d0201"==e.algoid){var i=KJUR.crypto.OID.oidhex2name[e.algparam],r=new KJUR.crypto.ECDSA({curve:i,info:e.keyhex});return r.setPublicKeyHex(e.keyhex),r}if("2a8648ce380401"==e.algoid){var s=Fr.getVbyList(e.algparam,0,[0],"02"),a=Fr.getVbyList(e.algparam,0,[1],"02"),u=Fr.getVbyList(e.algparam,0,[2],"02"),c=Fr.getHexOfV_AtObj(e.keyhex,0);c=c.substr(2);var r=new KJUR.crypto.DSA;return r.setPublic(new o(s,16),new o(a,16),new o(u,16),new o(c,16)),r}throw"unsupported key"},Xn.getPublicKeyInfoPropOfCertPEM=function(t){var e={};e.algparam=null;var n=Xn.pemToHex(t),r=Fr.getPosArrayOfChildren_AtObj(n,0);if(3!=r.length)throw"malformed X.509 certificate PEM (code:001)";if("30"!=n.substr(r[0],2))throw"malformed X.509 certificate PEM (code:002)";var i=Fr.getPosArrayOfChildren_AtObj(n,r[0]),s=6;if("a0"!==n.substr(i[0],2)&&(s=5),i.length<s+1)throw"malformed X.509 certificate PEM (code:003)";var o=Fr.getPosArrayOfChildren_AtObj(n,i[s]);if(2!=o.length)throw"malformed X.509 certificate PEM (code:004)";var a=Fr.getPosArrayOfChildren_AtObj(n,o[0]);if(2!=a.length)throw"malformed X.509 certificate PEM (code:005)";if(e.algoid=Fr.getHexOfV_AtObj(n,a[0]),"06"==n.substr(a[1],2)?e.algparam=Fr.getHexOfV_AtObj(n,a[1]):"30"==n.substr(a[1],2)&&(e.algparam=Fr.getHexOfTLV_AtObj(n,a[1])),"03"!=n.substr(o[1],2))throw"malformed X.509 certificate PEM (code:006)";var u=Fr.getHexOfV_AtObj(n,o[1]);return e.keyhex=u.substr(2),e},Xn.getPublicKeyInfoPosOfCertHEX=function(t){var e=Fr.getPosArrayOfChildren_AtObj(t,0);if(3!=e.length)throw"malformed X.509 certificate PEM (code:001)";if("30"!=t.substr(e[0],2))throw"malformed X.509 certificate PEM (code:002)";var n=Fr.getPosArrayOfChildren_AtObj(t,e[0]);if(n.length<7)throw"malformed X.509 certificate PEM (code:003)";return n[6]},Xn.getV3ExtInfoListOfCertHex=function(t){var e=Fr.getPosArrayOfChildren_AtObj(t,0);if(3!=e.length)throw"malformed X.509 certificate PEM (code:001)";if("30"!=t.substr(e[0],2))throw"malformed X.509 certificate PEM (code:002)";var n=Fr.getPosArrayOfChildren_AtObj(t,e[0]);if(n.length<8)throw"malformed X.509 certificate PEM (code:003)";if("a3"!=t.substr(n[7],2))throw"malformed X.509 certificate PEM (code:004)";var r=Fr.getPosArrayOfChildren_AtObj(t,n[7]);if(1!=r.length)throw"malformed X.509 certificate PEM (code:005)";if("30"!=t.substr(r[0],2))throw"malformed X.509 certificate PEM (code:006)";for(var i=Fr.getPosArrayOfChildren_AtObj(t,r[0]),s=i.length,o=new Array(s),a=0;s>a;a++)o[a]=Xn.getV3ExtItemInfo_AtObj(t,i[a]);return o},Xn.getV3ExtItemInfo_AtObj=function(t,e){var n={};n.posTLV=e;var r=Fr.getPosArrayOfChildren_AtObj(t,e);if(2!=r.length&&3!=r.length)throw"malformed X.509v3 Ext (code:001)";if("06"!=t.substr(r[0],2))throw"malformed X.509v3 Ext (code:002)";var i=Fr.getHexOfV_AtObj(t,r[0]);n.oid=Fr.hextooidstr(i),n.critical=!1,3==r.length&&(n.critical=!0);var s=r[r.length-1];if("04"!=t.substr(s,2))throw"malformed X.509v3 Ext (code:003)";return n.posV=Fr.getStartPosOfV_AtObj(t,s),n},Xn.getHexOfTLV_V3ExtValue=function(t,e){var n=Xn.getPosOfTLV_V3ExtValue(t,e);return-1==n?null:Fr.getHexOfTLV_AtObj(t,n)},Xn.getHexOfV_V3ExtValue=function(t,e){var n=Xn.getPosOfTLV_V3ExtValue(t,e);return-1==n?null:Fr.getHexOfV_AtObj(t,n)},Xn.getPosOfTLV_V3ExtValue=function(t,e){var n=e;if(e.match(/^[0-9.]+$/)||(n=KJUR.asn1.x509.OID.name2oid(e)),""==n)return-1;for(var r=Xn.getV3ExtInfoListOfCertHex(t),i=0;i<r.length;i++){var s=r[i];if(s.oid==n)return s.posV}return-1},Xn.getExtBasicConstraints=function(t){var e=Xn.getHexOfV_V3ExtValue(t,"basicConstraints");if(null===e)return null;if(""===e)return{};if("0101ff"===e)return{cA:!0};if("0101ff02"===e.substr(0,8)){var n=Fr.getHexOfV_AtObj(e,6),r=parseInt(n,16);return{cA:!0,pathLen:r}}throw"unknown error"},Xn.KEYUSAGE_NAME=["digitalSignature","nonRepudiation","keyEncipherment","dataEncipherment","keyAgreement","keyCertSign","cRLSign","encipherOnly","decipherOnly"],Xn.getExtKeyUsageBin=function(t){var e=Xn.getHexOfV_V3ExtValue(t,"keyUsage");if(""==e)return"";if(e.length%2!=0||e.length<=2)throw"malformed key usage value";var n=parseInt(e.substr(0,2)),r=parseInt(e.substr(2),16).toString(2);return r.substr(0,r.length-n)},Xn.getExtKeyUsageString=function(t){for(var e=Xn.getExtKeyUsageBin(t),n=new Array,r=0;r<e.length;r++)"1"==e.substr(r,1)&&n.push(Xn.KEYUSAGE_NAME[r]);return n.join(",")},Xn.getExtSubjectKeyIdentifier=function(t){var e=Xn.getHexOfV_V3ExtValue(t,"subjectKeyIdentifier");return e},Xn.getExtAuthorityKeyIdentifier=function(t){var e={},n=Xn.getHexOfTLV_V3ExtValue(t,"authorityKeyIdentifier");if(null===n)return null;for(var r=Fr.getPosArrayOfChildren_AtObj(n,0),i=0;i<r.length;i++)"80"===n.substr(r[i],2)&&(e.kid=Fr.getHexOfV_AtObj(n,r[i]));return e},Xn.getExtExtKeyUsageName=function(t){var e=new Array,n=Xn.getHexOfTLV_V3ExtValue(t,"extKeyUsage");if(null===n)return null;for(var r=Fr.getPosArrayOfChildren_AtObj(n,0),i=0;i<r.length;i++){var s=Fr.getHexOfV_AtObj(n,r[i]),o=KJUR.asn1.ASN1Util.oidHexToInt(s),a=KJUR.asn1.x509.OID.oid2name(o);e.push(a)}return e},Xn.getExtSubjectAltName=function(t){for(var e=new Array,n=Xn.getHexOfTLV_V3ExtValue(t,"subjectAltName"),r=Fr.getPosArrayOfChildren_AtObj(n,0),i=0;i<r.length;i++)if("82"===n.substr(r[i],2)){var s=Sn(Fr.getHexOfV_AtObj(n,r[i]));e.push(s)}return e},Xn.getExtCRLDistributionPointsURI=function(t){for(var e=new Array,n=Xn.getHexOfTLV_V3ExtValue(t,"cRLDistributionPoints"),r=Fr.getPosArrayOfChildren_AtObj(n,0),i=0;i<r.length;i++)for(var s=Fr.getHexOfTLV_AtObj(n,r[i]),o=Fr.getPosArrayOfChildren_AtObj(s,0),a=0;a<o.length;a++)if("a0"===s.substr(o[a],2)){var u=Fr.getHexOfV_AtObj(s,o[a]);if("a0"===u.substr(0,2)){var c=Fr.getHexOfV_AtObj(u,0);if("86"===c.substr(0,2)){var f=Fr.getHexOfV_AtObj(c,0),h=Sn(f);e.push(h)}}}return e},Xn.getExtAIAInfo=function(t){var e={};e.ocsp=[],e.caissuer=[];var n=Xn.getPosOfTLV_V3ExtValue(t,"authorityInfoAccess");if(-1==n)return null;if("30"!=t.substr(n,2))throw"malformed AIA Extn Value";for(var r=Fr.getPosArrayOfChildren_AtObj(t,n),i=0;i<r.length;i++){var s=r[i],o=Fr.getPosArrayOfChildren_AtObj(t,s);if(2!=o.length)throw"malformed AccessDescription of AIA Extn";var a=o[0],u=o[1];"2b06010505073001"==Fr.getHexOfV_AtObj(t,a)&&"86"==t.substr(u,2)&&e.ocsp.push(Sn(Fr.getHexOfV_AtObj(t,u))),"2b06010505073002"==Fr.getHexOfV_AtObj(t,a)&&"86"==t.substr(u,2)&&e.caissuer.push(Sn(Fr.getHexOfV_AtObj(t,u)))}return e},Xn.getSignatureAlgorithmName=function(t){var e=Fr.getDecendantHexVByNthList(t,0,[1,0]),n=KJUR.asn1.ASN1Util.oidHexToInt(e),r=KJUR.asn1.x509.OID.oid2name(n);return r},Xn.getSignatureValueHex=function(t){var e=Fr.getDecendantHexVByNthList(t,0,[2]);if("00"!==e.substr(0,2))throw"can't get signature value";return e.substr(2)},Xn.getSerialNumberHex=function(t){return Fr.getDecendantHexVByNthList(t,0,[0,1])},/*! jws-3.3.4 (c) 2013-2016 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
"undefined"!=typeof KJUR&&KJUR||(KJUR={}),"undefined"!=typeof KJUR.jws&&KJUR.jws||(KJUR.jws={}),KJUR.jws.JWS=function(){var t=KJUR.jws.JWS;this.parseJWS=function(e,n){if(void 0===this.parsedJWS||!n&&void 0===this.parsedJWS.sigvalH){if(null==e.match(/^([^.]+)\.([^.]+)\.([^.]+)$/))throw"JWS signature is not a form of 'Head.Payload.SigValue'.";var r=RegExp.$1,i=RegExp.$2,s=RegExp.$3,o=r+"."+i;if(this.parsedJWS={},this.parsedJWS.headB64U=r,this.parsedJWS.payloadB64U=i,this.parsedJWS.sigvalB64U=s,this.parsedJWS.si=o,!n){var a=gn(s),u=de(a,16);this.parsedJWS.sigvalH=a,this.parsedJWS.sigvalBI=u}var c=Pr(r),f=Pr(i);if(this.parsedJWS.headS=c,this.parsedJWS.payloadS=f,!t.isSafeJSONString(c,this.parsedJWS,"headP"))throw"malformed JSON string for JWS Head: "+c}}},KJUR.jws.JWS.sign=function(t,e,n,r,i){var s,o,a,u=KJUR.jws.JWS;if("string"!=typeof e&&"object"!=typeof e)throw"spHeader must be JSON string or object: "+e;if("object"==typeof e&&(o=e,s=JSON.stringify(o)),"string"==typeof e){if(s=e,!u.isSafeJSONString(s))throw"JWS Head is not safe JSON string: "+s;o=u.readSafeJSONString(s)}if(a=n,"object"==typeof n&&(a=JSON.stringify(n)),""!=t&&null!=t||void 0===o.alg||(t=o.alg),""!=t&&null!=t&&void 0===o.alg&&(o.alg=t,s=JSON.stringify(o)),t!==o.alg)throw"alg and sHeader.alg doesn't match: "+t+"!="+o.alg;var c=null;if(void 0===u.jwsalg2sigalg[t])throw"unsupported alg name: "+t;c=u.jwsalg2sigalg[t];var f=Kr(s),h=Kr(a),l=f+"."+h,d="";if("Hmac"==c.substr(0,4)){if(void 0===r)throw"mac key shall be specified for HS* alg";var p=new KJUR.crypto.Mac({alg:c,prov:"cryptojs",pass:r});p.updateString(l),d=p.doFinal()}else if(-1!=c.indexOf("withECDSA")){var g=new KJUR.crypto.Signature({alg:c});g.init(r,i),g.updateString(l),hASN1Sig=g.sign(),d=KJUR.crypto.ECDSA.asn1SigToConcatSig(hASN1Sig)}else if("none"!=c){var g=new KJUR.crypto.Signature({alg:c});g.init(r,i),g.updateString(l),d=g.sign()}var y=pn(d);return l+"."+y},KJUR.jws.JWS.verify=function(t,e,n){var r=KJUR.jws.JWS,i=t.split("."),s=i[0],o=i[1],a=s+"."+o,u=gn(i[2]),c=r.readSafeJSONString(Pr(i[0])),f=null,h=null;if(void 0===c.alg)throw"algorithm not specified in header";if(f=c.alg,h=f.substr(0,2),null!=n&&"[object Array]"===Object.prototype.toString.call(n)&&n.length>0){var l=":"+n.join(":")+":";if(-1==l.indexOf(":"+f+":"))throw"algorithm '"+f+"' not accepted in the list"}if("none"!=f&&null===e)throw"key shall be specified to verify.";if("string"==typeof e&&-1!=e.indexOf("-----BEGIN ")&&(e=Cr.getKey(e)),!("RS"!=h&&"PS"!=h||e instanceof ve))throw"key shall be a RSAKey obj for RS* and PS* algs";if("ES"==h&&!(e instanceof KJUR.crypto.ECDSA))throw"key shall be a ECDSA obj for ES* algs";var d=null;if(void 0===r.jwsalg2sigalg[c.alg])throw"unsupported alg name: "+f;if(d=r.jwsalg2sigalg[f],"none"==d)throw"not supported";if("Hmac"==d.substr(0,4)){var p=null;if(void 0===e)throw"hexadecimal key shall be specified for HMAC";var g=new KJUR.crypto.Mac({alg:d,pass:e});return g.updateString(a),p=g.doFinal(),u==p}if(-1!=d.indexOf("withECDSA")){var y=null;try{y=KJUR.crypto.ECDSA.concatSigToASN1Sig(u)}catch(v){return!1}var m=new KJUR.crypto.Signature({alg:d});return m.init(e),m.updateString(a),m.verify(y)}var m=new KJUR.crypto.Signature({alg:d});return m.init(e),m.updateString(a),m.verify(u)},KJUR.jws.JWS.parse=function(t){var e,n,r,i=t.split("."),s={};if(2!=i.length&&3!=i.length)throw"malformed sJWS: wrong number of '.' splitted elements";return e=i[0],n=i[1],3==i.length&&(r=i[2]),s.headerObj=KJUR.jws.JWS.readSafeJSONString(Pr(e)),s.payloadObj=KJUR.jws.JWS.readSafeJSONString(Pr(n)),s.headerPP=JSON.stringify(s.headerObj,null,"  "),null==s.payloadObj?s.payloadPP=Pr(n):s.payloadPP=JSON.stringify(s.payloadObj,null,"  "),void 0!==r&&(s.sigHex=gn(r)),s},KJUR.jws.JWS.verifyJWT=function(t,e,n){var r=KJUR.jws.JWS,i=t.split("."),s=i[0],o=i[1],a=(gn(i[2]),r.readSafeJSONString(Pr(s))),u=r.readSafeJSONString(Pr(o));if(void 0===a.alg)return!1;if(void 0===n.alg)throw"acceptField.alg shall be specified";if(!r.inArray(a.alg,n.alg))return!1;if(void 0!==u.iss&&"object"==typeof n.iss&&!r.inArray(u.iss,n.iss))return!1;if(void 0!==u.sub&&"object"==typeof n.sub&&!r.inArray(u.sub,n.sub))return!1;if(void 0!==u.aud&&"object"==typeof n.aud)if("string"==typeof u.aud){if(!r.inArray(u.aud,n.aud))return!1}else if("object"==typeof u.aud&&!r.includedArray(u.aud,n.aud))return!1;var c=KJUR.jws.IntDate.getNow();return void 0!==n.verifyAt&&"number"==typeof n.verifyAt&&(c=n.verifyAt),void 0!==n.gracePeriod&&"number"==typeof n.gracePeriod||(n.gracePeriod=0),void 0!==u.exp&&"number"==typeof u.exp&&u.exp+n.gracePeriod<c?!1:void 0!==u.nbf&&"number"==typeof u.nbf&&c<u.nbf-n.gracePeriod?!1:void 0!==u.iat&&"number"==typeof u.iat&&c<u.iat-n.gracePeriod?!1:void 0!==u.jti&&void 0!==n.jti&&u.jti!==n.jti?!1:!!KJUR.jws.JWS.verify(t,e,n.alg)},KJUR.jws.JWS.includedArray=function(t,e){var n=KJUR.jws.JWS.inArray;if(null===t)return!1;if("object"!=typeof t)return!1;if("number"!=typeof t.length)return!1;for(var r=0;r<t.length;r++)if(!n(t[r],e))return!1;return!0},KJUR.jws.JWS.inArray=function(t,e){if(null===e)return!1;if("object"!=typeof e)return!1;if("number"!=typeof e.length)return!1;for(var n=0;n<e.length;n++)if(e[n]==t)return!0;return!1},KJUR.jws.JWS.jwsalg2sigalg={HS256:"HmacSHA256",HS384:"HmacSHA384",HS512:"HmacSHA512",RS256:"SHA256withRSA",RS384:"SHA384withRSA",RS512:"SHA512withRSA",ES256:"SHA256withECDSA",ES384:"SHA384withECDSA",PS256:"SHA256withRSAandMGF1",PS384:"SHA384withRSAandMGF1",PS512:"SHA512withRSAandMGF1",none:"none"},KJUR.jws.JWS.isSafeJSONString=function(t,e,n){var r=null;try{return r=Ar(t),"object"!=typeof r?0:r.constructor===Array?0:(e&&(e[n]=r),1)}catch(i){return 0}},KJUR.jws.JWS.readSafeJSONString=function(t){var e=null;try{return e=Ar(t),"object"!=typeof e?null:e.constructor===Array?null:e}catch(n){return null}},KJUR.jws.JWS.getEncodedSignatureValueFromJWS=function(t){if(null==t.match(/^[^.]+\.[^.]+\.([^.]+)$/))throw"JWS signature is not a form of 'Head.Payload.SigValue'.";return RegExp.$1},KJUR.jws.JWS.getJWKthumbprint=function(t){if("RSA"!==t.kty&&"EC"!==t.kty&&"oct"!==t.kty)throw"unsupported algorithm for JWK Thumprint";var e="{";if("RSA"===t.kty){if("string"!=typeof t.n||"string"!=typeof t.e)throw"wrong n and e value for RSA key";e+='"e":"'+t.e+'",',e+='"kty":"'+t.kty+'",',e+='"n":"'+t.n+'"}'}else if("EC"===t.kty){if("string"!=typeof t.crv||"string"!=typeof t.x||"string"!=typeof t.y)throw"wrong crv, x and y value for EC key";e+='"crv":"'+t.crv+'",',e+='"kty":"'+t.kty+'",',e+='"x":"'+t.x+'",',e+='"y":"'+t.y+'"}'}else if("oct"===t.kty){if("string"!=typeof t.k)throw"wrong k value for oct(symmetric) key";e+='"kty":"'+t.kty+'",',e+='"k":"'+t.k+'"}'}var n=wn(e),r=KJUR.crypto.Util.hashHex(n,"sha256"),i=pn(r);return i},KJUR.jws.IntDate={},KJUR.jws.IntDate.get=function(t){if("now"==t)return KJUR.jws.IntDate.getNow();if("now + 1hour"==t)return KJUR.jws.IntDate.getNow()+3600;if("now + 1day"==t)return KJUR.jws.IntDate.getNow()+86400;if("now + 1month"==t)return KJUR.jws.IntDate.getNow()+2592e3;if("now + 1year"==t)return KJUR.jws.IntDate.getNow()+31536e3;if(t.match(/Z$/))return KJUR.jws.IntDate.getZulu(t);if(t.match(/^[0-9]+$/))return parseInt(t);throw"unsupported format: "+t},KJUR.jws.IntDate.getZulu=function(t){var e;if(e=t.match(/(\d+)(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)Z/)){var n=RegExp.$1,r=parseInt(n);if(4==n.length);else{if(2!=n.length)throw"malformed year string";if(r>=50&&100>r)r=1900+r;else{if(!(r>=0&&50>r))throw"malformed year string for UTCTime";r=2e3+r}}var i=parseInt(RegExp.$2)-1,s=parseInt(RegExp.$3),o=parseInt(RegExp.$4),a=parseInt(RegExp.$5),u=parseInt(RegExp.$6),c=new Date(Date.UTC(r,i,s,o,a,u));return~~(c/1e3)}throw"unsupported format: "+t},KJUR.jws.IntDate.getNow=function(){var t=~~(new Date/1e3);return t},KJUR.jws.IntDate.intDate2UTCString=function(t){var e=new Date(1e3*t);return e.toUTCString()},KJUR.jws.IntDate.intDate2Zulu=function(t){var e=new Date(1e3*t),n=("0000"+e.getUTCFullYear()).slice(-4),r=("00"+(e.getUTCMonth()+1)).slice(-2),i=("00"+e.getUTCDate()).slice(-2),s=("00"+e.getUTCHours()).slice(-2),o=("00"+e.getUTCMinutes()).slice(-2),a=("00"+e.getUTCSeconds()).slice(-2);return n+r+i+s+o+a+"Z"},/*! jwsjs-2.0.1 (c) 2010-2015 Kenji Urushima | kjur.github.com/jsjws/license
	 */
"undefined"!=typeof KJUR&&KJUR||(KJUR={}),"undefined"!=typeof KJUR.jws&&KJUR.jws||(KJUR.jws={}),KJUR.jws.JWSJS=function(){var t=KJUR.jws.JWS;this.aHeader=[],this.sPayload="",this.aSignature=[],this.init=function(){this.aHeader=[],this.sPayload="",this.aSignature=[]},this.initWithJWS=function(t){this.init();var e=new KJUR.jws.JWS;e.parseJWS(t),this.aHeader.push(e.parsedJWS.headB64U),this.sPayload=e.parsedJWS.payloadB64U,this.aSignature.push(e.parsedJWS.sigvalB64U)},this.addSignatureByHeaderKey=function(t,e){var n=Pr(this.sPayload),r=new KJUR.jws.JWS;r.generateJWSByP1PrvKey(t,n,e);this.aHeader.push(r.parsedJWS.headB64U),this.aSignature.push(r.parsedJWS.sigvalB64U)},this.addSignatureByHeaderPayloadKey=function(t,e,n){var r=new KJUR.jws.JWS;r.generateJWSByP1PrvKey(t,e,n);this.aHeader.push(r.parsedJWS.headB64U),this.sPayload=r.parsedJWS.payloadB64U,this.aSignature.push(r.parsedJWS.sigvalB64U)},this.verifyWithCerts=function(t){if(this.aHeader.length!=t.length)throw"num headers does not match with num certs";if(this.aSignature.length!=t.length)throw"num signatures does not match with num certs";for(var e=this.sPayload,n="",r=0;r<t.length;r++){var i=t[r],s=this.aHeader[r],o=this.aSignature[r],a=s+"."+e+"."+o,u=new KJUR.jws.JWS;try{var c=u.verifyJWSByPemX509Cert(a,i);1!=c&&(n+=r+1+"th signature unmatch. ")}catch(f){n+=r+1+"th signature fail("+f+"). "}}if(""==n)return 1;throw n},this.readJWSJS=function(e){var n=t.readSafeJSONString(e);if(null==n)throw"argument is not JSON string: "+e;this.aHeader=n.headers,this.sPayload=n.payload,this.aSignature=n.signatures},this.getJSON=function(){return{headers:this.aHeader,payload:this.sPayload,signatures:this.aSignature}},this.isEmpty=function(){return 0==this.aHeader.length?1:0}},e.SecureRandom=le,e.rng_seed_time=ce,e.BigInteger=o,e.RSAKey=ve,e.ECDSA=KJUR.crypto.ECDSA,e.DSA=KJUR.crypto.DSA,e.Signature=KJUR.crypto.Signature,e.MessageDigest=KJUR.crypto.MessageDigest,e.Mac=KJUR.crypto.Mac,e.KEYUTIL=Cr,e.ASN1HEX=Fr,e.X509=Xn,e.CryptoJS=sr,e.b64tohex=i,e.b64toBA=s,e.stoBA=sn,e.BAtos=on,e.BAtohex=an,e.stohex=un,e.stob64=cn,e.stob64u=fn,e.b64utos=hn,e.b64tob64u=ln,e.b64utob64=dn,e.hex2b64=r,e.hextob64u=pn,e.b64utohex=gn,e.b64tohex=i,e.utf8tob64u=Kr,e.b64utoutf8=Pr,e.utf8tob64=yn,e.b64toutf8=vn,e.utf8tohex=mn,e.hextoutf8=Sn,e.hextorstr=bn,e.rstrtohex=wn,e.newline_toUnix=Rn,e.newline_toDos=An,e.intarystrtohex=Fn,e.strdiffidx=Ur,e.crypto=KJUR.crypto,e.asn1=KJUR.asn1,e.jws=KJUR.jws,e.readFileUTF8=$n,e.readFileHexByBin=Zn,e.readFile=Qn,e.saveFile=tr,e.saveFileBinByHex=er}).call(e,n(312).Buffer)},function(t,e,n){(function(t,r){/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
"use strict";function i(){function t(){}try{var e=new Uint8Array(1);return e.foo=function(){return 42},e.constructor=t,42===e.foo()&&e.constructor===t&&"function"==typeof e.subarray&&0===e.subarray(1,1).byteLength}catch(n){return!1}}function s(){return t.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function t(e){return this instanceof t?(t.TYPED_ARRAY_SUPPORT||(this.length=0,this.parent=void 0),"number"==typeof e?o(this,e):"string"==typeof e?a(this,e,arguments.length>1?arguments[1]:"utf8"):u(this,e)):arguments.length>1?new t(e,arguments[1]):new t(e)}function o(e,n){if(e=g(e,0>n?0:0|y(n)),!t.TYPED_ARRAY_SUPPORT)for(var r=0;n>r;r++)e[r]=0;return e}function a(t,e,n){"string"==typeof n&&""!==n||(n="utf8");var r=0|m(e,n);return t=g(t,r),t.write(e,n),t}function u(e,n){if(t.isBuffer(n))return c(e,n);if(X(n))return f(e,n);if(null==n)throw new TypeError("must start with number, buffer, array or string");if("undefined"!=typeof ArrayBuffer){if(n.buffer instanceof ArrayBuffer)return h(e,n);if(n instanceof ArrayBuffer)return l(e,n)}return n.length?d(e,n):p(e,n)}function c(t,e){var n=0|y(e.length);return t=g(t,n),e.copy(t,0,0,n),t}function f(t,e){var n=0|y(e.length);t=g(t,n);for(var r=0;n>r;r+=1)t[r]=255&e[r];return t}function h(t,e){var n=0|y(e.length);t=g(t,n);for(var r=0;n>r;r+=1)t[r]=255&e[r];return t}function l(e,n){return t.TYPED_ARRAY_SUPPORT?(n.byteLength,e=t._augment(new Uint8Array(n))):e=h(e,new Uint8Array(n)),e}function d(t,e){var n=0|y(e.length);t=g(t,n);for(var r=0;n>r;r+=1)t[r]=255&e[r];return t}function p(t,e){var n,r=0;"Buffer"===e.type&&X(e.data)&&(n=e.data,r=0|y(n.length)),t=g(t,r);for(var i=0;r>i;i+=1)t[i]=255&n[i];return t}function g(e,n){t.TYPED_ARRAY_SUPPORT?(e=t._augment(new Uint8Array(n)),e.__proto__=t.prototype):(e.length=n,e._isBuffer=!0);var r=0!==n&&n<=t.poolSize>>>1;return r&&(e.parent=$),e}function y(t){if(t>=s())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+s().toString(16)+" bytes");return 0|t}function v(e,n){if(!(this instanceof v))return new v(e,n);var r=new t(e,n);return delete r.parent,r}function m(t,e){"string"!=typeof t&&(t=""+t);var n=t.length;if(0===n)return 0;for(var r=!1;;)switch(e){case"ascii":case"binary":case"raw":case"raws":return n;case"utf8":case"utf-8":return V(t).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*n;case"hex":return n>>>1;case"base64":return W(t).length;default:if(r)return V(t).length;e=(""+e).toLowerCase(),r=!0}}function S(t,e,n){var r=!1;if(e=0|e,n=void 0===n||n===1/0?this.length:0|n,t||(t="utf8"),0>e&&(e=0),n>this.length&&(n=this.length),e>=n)return"";for(;;)switch(t){case"hex":return O(this,e,n);case"utf8":case"utf-8":return F(this,e,n);case"ascii":return P(this,e,n);case"binary":return U(this,e,n);case"base64":return A(this,e,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return C(this,e,n);default:if(r)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),r=!0}}function b(t,e,n,r){n=Number(n)||0;var i=t.length-n;r?(r=Number(r),r>i&&(r=i)):r=i;var s=e.length;if(s%2!==0)throw new Error("Invalid hex string");r>s/2&&(r=s/2);for(var o=0;r>o;o++){var a=parseInt(e.substr(2*o,2),16);if(isNaN(a))throw new Error("Invalid hex string");t[n+o]=a}return o}function w(t,e,n,r){return z(V(e,t.length-n),t,n,r)}function E(t,e,n,r){return z(L(e),t,n,r)}function x(t,e,n,r){return E(t,e,n,r)}function _(t,e,n,r){return z(W(e),t,n,r)}function R(t,e,n,r){return z(q(e,t.length-n),t,n,r)}function A(t,e,n){return 0===e&&n===t.length?Y.fromByteArray(t):Y.fromByteArray(t.slice(e,n))}function F(t,e,n){n=Math.min(t.length,n);for(var r=[],i=e;n>i;){var s=t[i],o=null,a=s>239?4:s>223?3:s>191?2:1;if(n>=i+a){var u,c,f,h;switch(a){case 1:128>s&&(o=s);break;case 2:u=t[i+1],128===(192&u)&&(h=(31&s)<<6|63&u,h>127&&(o=h));break;case 3:u=t[i+1],c=t[i+2],128===(192&u)&&128===(192&c)&&(h=(15&s)<<12|(63&u)<<6|63&c,h>2047&&(55296>h||h>57343)&&(o=h));break;case 4:u=t[i+1],c=t[i+2],f=t[i+3],128===(192&u)&&128===(192&c)&&128===(192&f)&&(h=(15&s)<<18|(63&u)<<12|(63&c)<<6|63&f,h>65535&&1114112>h&&(o=h))}}null===o?(o=65533,a=1):o>65535&&(o-=65536,r.push(o>>>10&1023|55296),o=56320|1023&o),r.push(o),i+=a}return K(r)}function K(t){var e=t.length;if(Z>=e)return String.fromCharCode.apply(String,t);for(var n="",r=0;e>r;)n+=String.fromCharCode.apply(String,t.slice(r,r+=Z));return n}function P(t,e,n){var r="";n=Math.min(t.length,n);for(var i=e;n>i;i++)r+=String.fromCharCode(127&t[i]);return r}function U(t,e,n){var r="";n=Math.min(t.length,n);for(var i=e;n>i;i++)r+=String.fromCharCode(t[i]);return r}function O(t,e,n){var r=t.length;(!e||0>e)&&(e=0),(!n||0>n||n>r)&&(n=r);for(var i="",s=e;n>s;s++)i+=M(t[s]);return i}function C(t,e,n){for(var r=t.slice(e,n),i="",s=0;s<r.length;s+=2)i+=String.fromCharCode(r[s]+256*r[s+1]);return i}function I(t,e,n){if(t%1!==0||0>t)throw new RangeError("offset is not uint");if(t+e>n)throw new RangeError("Trying to access beyond buffer length")}function j(e,n,r,i,s,o){if(!t.isBuffer(e))throw new TypeError("buffer must be a Buffer instance");if(n>s||o>n)throw new RangeError("value is out of bounds");if(r+i>e.length)throw new RangeError("index out of range")}function T(t,e,n,r){0>e&&(e=65535+e+1);for(var i=0,s=Math.min(t.length-n,2);s>i;i++)t[n+i]=(e&255<<8*(r?i:1-i))>>>8*(r?i:1-i)}function D(t,e,n,r){0>e&&(e=4294967295+e+1);for(var i=0,s=Math.min(t.length-n,4);s>i;i++)t[n+i]=e>>>8*(r?i:3-i)&255}function J(t,e,n,r,i,s){if(e>i||s>e)throw new RangeError("value is out of bounds");if(n+r>t.length)throw new RangeError("index out of range");if(0>n)throw new RangeError("index out of range")}function H(t,e,n,r,i){return i||J(t,e,n,4,3.4028234663852886e38,-3.4028234663852886e38),G.write(t,e,n,r,23,4),n+4}function B(t,e,n,r,i){return i||J(t,e,n,8,1.7976931348623157e308,-1.7976931348623157e308),G.write(t,e,n,r,52,8),n+8}function k(t){if(t=N(t).replace(tt,""),t.length<2)return"";for(;t.length%4!==0;)t+="=";return t}function N(t){return t.trim?t.trim():t.replace(/^\s+|\s+$/g,"")}function M(t){return 16>t?"0"+t.toString(16):t.toString(16)}function V(t,e){e=e||1/0;for(var n,r=t.length,i=null,s=[],o=0;r>o;o++){if(n=t.charCodeAt(o),n>55295&&57344>n){if(!i){if(n>56319){(e-=3)>-1&&s.push(239,191,189);continue}if(o+1===r){(e-=3)>-1&&s.push(239,191,189);continue}i=n;continue}if(56320>n){(e-=3)>-1&&s.push(239,191,189),i=n;continue}n=(i-55296<<10|n-56320)+65536}else i&&(e-=3)>-1&&s.push(239,191,189);if(i=null,128>n){if((e-=1)<0)break;s.push(n)}else if(2048>n){if((e-=2)<0)break;s.push(n>>6|192,63&n|128)}else if(65536>n){if((e-=3)<0)break;s.push(n>>12|224,n>>6&63|128,63&n|128)}else{if(!(1114112>n))throw new Error("Invalid code point");if((e-=4)<0)break;s.push(n>>18|240,n>>12&63|128,n>>6&63|128,63&n|128)}}return s}function L(t){for(var e=[],n=0;n<t.length;n++)e.push(255&t.charCodeAt(n));return e}function q(t,e){for(var n,r,i,s=[],o=0;o<t.length&&!((e-=2)<0);o++)n=t.charCodeAt(o),r=n>>8,i=n%256,s.push(i),s.push(r);return s}function W(t){return Y.toByteArray(k(t))}function z(t,e,n,r){for(var i=0;r>i&&!(i+n>=e.length||i>=t.length);i++)e[i+n]=t[i];return i}var Y=n(313),G=n(314),X=n(315);e.Buffer=t,e.SlowBuffer=v,e.INSPECT_MAX_BYTES=50,t.poolSize=8192;var $={};t.TYPED_ARRAY_SUPPORT=void 0!==r.TYPED_ARRAY_SUPPORT?r.TYPED_ARRAY_SUPPORT:i(),t.TYPED_ARRAY_SUPPORT?(t.prototype.__proto__=Uint8Array.prototype,t.__proto__=Uint8Array):(t.prototype.length=void 0,t.prototype.parent=void 0),t.isBuffer=function(t){return!(null==t||!t._isBuffer)},t.compare=function(e,n){if(!t.isBuffer(e)||!t.isBuffer(n))throw new TypeError("Arguments must be Buffers");if(e===n)return 0;for(var r=e.length,i=n.length,s=0,o=Math.min(r,i);o>s&&e[s]===n[s];)++s;return s!==o&&(r=e[s],i=n[s]),i>r?-1:r>i?1:0},t.isEncoding=function(t){switch(String(t).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"raw":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},t.concat=function(e,n){if(!X(e))throw new TypeError("list argument must be an Array of Buffers.");if(0===e.length)return new t(0);var r;if(void 0===n)for(n=0,r=0;r<e.length;r++)n+=e[r].length;var i=new t(n),s=0;for(r=0;r<e.length;r++){var o=e[r];o.copy(i,s),s+=o.length}return i},t.byteLength=m,t.prototype.toString=function(){var t=0|this.length;return 0===t?"":0===arguments.length?F(this,0,t):S.apply(this,arguments)},t.prototype.equals=function(e){if(!t.isBuffer(e))throw new TypeError("Argument must be a Buffer");return this===e?!0:0===t.compare(this,e)},t.prototype.inspect=function(){var t="",n=e.INSPECT_MAX_BYTES;return this.length>0&&(t=this.toString("hex",0,n).match(/.{2}/g).join(" "),this.length>n&&(t+=" ... ")),"<Buffer "+t+">"},t.prototype.compare=function(e){if(!t.isBuffer(e))throw new TypeError("Argument must be a Buffer");return this===e?0:t.compare(this,e)},t.prototype.indexOf=function(e,n){function r(t,e,n){for(var r=-1,i=0;n+i<t.length;i++)if(t[n+i]===e[-1===r?0:i-r]){if(-1===r&&(r=i),i-r+1===e.length)return n+r}else r=-1;return-1}if(n>2147483647?n=2147483647:-2147483648>n&&(n=-2147483648),n>>=0,0===this.length)return-1;if(n>=this.length)return-1;if(0>n&&(n=Math.max(this.length+n,0)),"string"==typeof e)return 0===e.length?-1:String.prototype.indexOf.call(this,e,n);if(t.isBuffer(e))return r(this,e,n);if("number"==typeof e)return t.TYPED_ARRAY_SUPPORT&&"function"===Uint8Array.prototype.indexOf?Uint8Array.prototype.indexOf.call(this,e,n):r(this,[e],n);throw new TypeError("val must be string, number or Buffer")},t.prototype.get=function(t){return console.log(".get() is deprecated. Access using array indexes instead."),this.readUInt8(t)},t.prototype.set=function(t,e){return console.log(".set() is deprecated. Access using array indexes instead."),this.writeUInt8(t,e)},t.prototype.write=function(t,e,n,r){if(void 0===e)r="utf8",n=this.length,e=0;else if(void 0===n&&"string"==typeof e)r=e,n=this.length,e=0;else if(isFinite(e))e=0|e,isFinite(n)?(n=0|n,void 0===r&&(r="utf8")):(r=n,n=void 0);else{var i=r;r=e,e=0|n,n=i}var s=this.length-e;if((void 0===n||n>s)&&(n=s),t.length>0&&(0>n||0>e)||e>this.length)throw new RangeError("attempt to write outside buffer bounds");r||(r="utf8");for(var o=!1;;)switch(r){case"hex":return b(this,t,e,n);case"utf8":case"utf-8":return w(this,t,e,n);case"ascii":return E(this,t,e,n);case"binary":return x(this,t,e,n);case"base64":return _(this,t,e,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return R(this,t,e,n);default:if(o)throw new TypeError("Unknown encoding: "+r);r=(""+r).toLowerCase(),o=!0}},t.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var Z=4096;t.prototype.slice=function(e,n){var r=this.length;e=~~e,n=void 0===n?r:~~n,0>e?(e+=r,0>e&&(e=0)):e>r&&(e=r),0>n?(n+=r,0>n&&(n=0)):n>r&&(n=r),e>n&&(n=e);var i;if(t.TYPED_ARRAY_SUPPORT)i=t._augment(this.subarray(e,n));else{var s=n-e;i=new t(s,void 0);for(var o=0;s>o;o++)i[o]=this[o+e]}return i.length&&(i.parent=this.parent||this),i},t.prototype.readUIntLE=function(t,e,n){t=0|t,e=0|e,n||I(t,e,this.length);for(var r=this[t],i=1,s=0;++s<e&&(i*=256);)r+=this[t+s]*i;return r},t.prototype.readUIntBE=function(t,e,n){t=0|t,e=0|e,n||I(t,e,this.length);for(var r=this[t+--e],i=1;e>0&&(i*=256);)r+=this[t+--e]*i;return r},t.prototype.readUInt8=function(t,e){return e||I(t,1,this.length),this[t]},t.prototype.readUInt16LE=function(t,e){return e||I(t,2,this.length),this[t]|this[t+1]<<8},t.prototype.readUInt16BE=function(t,e){return e||I(t,2,this.length),this[t]<<8|this[t+1]},t.prototype.readUInt32LE=function(t,e){return e||I(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},t.prototype.readUInt32BE=function(t,e){return e||I(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},t.prototype.readIntLE=function(t,e,n){t=0|t,e=0|e,n||I(t,e,this.length);for(var r=this[t],i=1,s=0;++s<e&&(i*=256);)r+=this[t+s]*i;return i*=128,r>=i&&(r-=Math.pow(2,8*e)),r},t.prototype.readIntBE=function(t,e,n){t=0|t,e=0|e,n||I(t,e,this.length);for(var r=e,i=1,s=this[t+--r];r>0&&(i*=256);)s+=this[t+--r]*i;return i*=128,s>=i&&(s-=Math.pow(2,8*e)),s},t.prototype.readInt8=function(t,e){return e||I(t,1,this.length),128&this[t]?-1*(255-this[t]+1):this[t]},t.prototype.readInt16LE=function(t,e){e||I(t,2,this.length);var n=this[t]|this[t+1]<<8;return 32768&n?4294901760|n:n},t.prototype.readInt16BE=function(t,e){e||I(t,2,this.length);var n=this[t+1]|this[t]<<8;return 32768&n?4294901760|n:n},t.prototype.readInt32LE=function(t,e){return e||I(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},t.prototype.readInt32BE=function(t,e){return e||I(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},t.prototype.readFloatLE=function(t,e){return e||I(t,4,this.length),G.read(this,t,!0,23,4)},t.prototype.readFloatBE=function(t,e){return e||I(t,4,this.length),G.read(this,t,!1,23,4)},t.prototype.readDoubleLE=function(t,e){return e||I(t,8,this.length),G.read(this,t,!0,52,8)},t.prototype.readDoubleBE=function(t,e){return e||I(t,8,this.length),G.read(this,t,!1,52,8)},t.prototype.writeUIntLE=function(t,e,n,r){t=+t,e=0|e,n=0|n,r||j(this,t,e,n,Math.pow(2,8*n),0);var i=1,s=0;for(this[e]=255&t;++s<n&&(i*=256);)this[e+s]=t/i&255;return e+n},t.prototype.writeUIntBE=function(t,e,n,r){t=+t,e=0|e,n=0|n,r||j(this,t,e,n,Math.pow(2,8*n),0);var i=n-1,s=1;for(this[e+i]=255&t;--i>=0&&(s*=256);)this[e+i]=t/s&255;return e+n},t.prototype.writeUInt8=function(e,n,r){return e=+e,n=0|n,r||j(this,e,n,1,255,0),t.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),this[n]=255&e,n+1},t.prototype.writeUInt16LE=function(e,n,r){return e=+e,n=0|n,r||j(this,e,n,2,65535,0),t.TYPED_ARRAY_SUPPORT?(this[n]=255&e,this[n+1]=e>>>8):T(this,e,n,!0),n+2},t.prototype.writeUInt16BE=function(e,n,r){return e=+e,n=0|n,r||j(this,e,n,2,65535,0),t.TYPED_ARRAY_SUPPORT?(this[n]=e>>>8,this[n+1]=255&e):T(this,e,n,!1),n+2},t.prototype.writeUInt32LE=function(e,n,r){return e=+e,n=0|n,r||j(this,e,n,4,4294967295,0),t.TYPED_ARRAY_SUPPORT?(this[n+3]=e>>>24,this[n+2]=e>>>16,this[n+1]=e>>>8,this[n]=255&e):D(this,e,n,!0),n+4},t.prototype.writeUInt32BE=function(e,n,r){return e=+e,n=0|n,r||j(this,e,n,4,4294967295,0),t.TYPED_ARRAY_SUPPORT?(this[n]=e>>>24,this[n+1]=e>>>16,this[n+2]=e>>>8,this[n+3]=255&e):D(this,e,n,!1),n+4},t.prototype.writeIntLE=function(t,e,n,r){if(t=+t,e=0|e,!r){var i=Math.pow(2,8*n-1);j(this,t,e,n,i-1,-i)}var s=0,o=1,a=0>t?1:0;for(this[e]=255&t;++s<n&&(o*=256);)this[e+s]=(t/o>>0)-a&255;return e+n},t.prototype.writeIntBE=function(t,e,n,r){if(t=+t,e=0|e,!r){var i=Math.pow(2,8*n-1);j(this,t,e,n,i-1,-i)}var s=n-1,o=1,a=0>t?1:0;for(this[e+s]=255&t;--s>=0&&(o*=256);)this[e+s]=(t/o>>0)-a&255;return e+n},t.prototype.writeInt8=function(e,n,r){return e=+e,n=0|n,r||j(this,e,n,1,127,-128),t.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),0>e&&(e=255+e+1),this[n]=255&e,n+1},t.prototype.writeInt16LE=function(e,n,r){return e=+e,n=0|n,r||j(this,e,n,2,32767,-32768),t.TYPED_ARRAY_SUPPORT?(this[n]=255&e,this[n+1]=e>>>8):T(this,e,n,!0),n+2},t.prototype.writeInt16BE=function(e,n,r){return e=+e,n=0|n,r||j(this,e,n,2,32767,-32768),t.TYPED_ARRAY_SUPPORT?(this[n]=e>>>8,this[n+1]=255&e):T(this,e,n,!1),n+2},t.prototype.writeInt32LE=function(e,n,r){return e=+e,n=0|n,r||j(this,e,n,4,2147483647,-2147483648),t.TYPED_ARRAY_SUPPORT?(this[n]=255&e,this[n+1]=e>>>8,this[n+2]=e>>>16,this[n+3]=e>>>24):D(this,e,n,!0),n+4},t.prototype.writeInt32BE=function(e,n,r){return e=+e,n=0|n,r||j(this,e,n,4,2147483647,-2147483648),0>e&&(e=4294967295+e+1),t.TYPED_ARRAY_SUPPORT?(this[n]=e>>>24,this[n+1]=e>>>16,this[n+2]=e>>>8,this[n+3]=255&e):D(this,e,n,!1),n+4},t.prototype.writeFloatLE=function(t,e,n){return H(this,t,e,!0,n)},t.prototype.writeFloatBE=function(t,e,n){return H(this,t,e,!1,n)},t.prototype.writeDoubleLE=function(t,e,n){return B(this,t,e,!0,n)},t.prototype.writeDoubleBE=function(t,e,n){return B(this,t,e,!1,n)},t.prototype.copy=function(e,n,r,i){if(r||(r=0),i||0===i||(i=this.length),n>=e.length&&(n=e.length),n||(n=0),i>0&&r>i&&(i=r),i===r)return 0;if(0===e.length||0===this.length)return 0;if(0>n)throw new RangeError("targetStart out of bounds");if(0>r||r>=this.length)throw new RangeError("sourceStart out of bounds");if(0>i)throw new RangeError("sourceEnd out of bounds");i>this.length&&(i=this.length),e.length-n<i-r&&(i=e.length-n+r);var s,o=i-r;if(this===e&&n>r&&i>n)for(s=o-1;s>=0;s--)e[s+n]=this[s+r];else if(1e3>o||!t.TYPED_ARRAY_SUPPORT)for(s=0;o>s;s++)e[s+n]=this[s+r];else e._set(this.subarray(r,r+o),n);return o},t.prototype.fill=function(t,e,n){if(t||(t=0),e||(e=0),n||(n=this.length),e>n)throw new RangeError("end < start");if(n!==e&&0!==this.length){if(0>e||e>=this.length)throw new RangeError("start out of bounds");if(0>n||n>this.length)throw new RangeError("end out of bounds");var r;if("number"==typeof t)for(r=e;n>r;r++)this[r]=t;else{var i=V(t.toString()),s=i.length;for(r=e;n>r;r++)this[r]=i[r%s]}return this}},t.prototype.toArrayBuffer=function(){if("undefined"!=typeof Uint8Array){if(t.TYPED_ARRAY_SUPPORT)return new t(this).buffer;for(var e=new Uint8Array(this.length),n=0,r=e.length;r>n;n+=1)e[n]=this[n];return e.buffer}throw new TypeError("Buffer.toArrayBuffer not supported in this browser")};var Q=t.prototype;t._augment=function(e){return e.constructor=t,e._isBuffer=!0,e._set=e.set,e.get=Q.get,e.set=Q.set,e.write=Q.write,e.toString=Q.toString,e.toLocaleString=Q.toString,e.toJSON=Q.toJSON,e.equals=Q.equals,e.compare=Q.compare,e.indexOf=Q.indexOf,e.copy=Q.copy,e.slice=Q.slice,e.readUIntLE=Q.readUIntLE,e.readUIntBE=Q.readUIntBE,e.readUInt8=Q.readUInt8,e.readUInt16LE=Q.readUInt16LE,e.readUInt16BE=Q.readUInt16BE,e.readUInt32LE=Q.readUInt32LE,e.readUInt32BE=Q.readUInt32BE,e.readIntLE=Q.readIntLE,e.readIntBE=Q.readIntBE,e.readInt8=Q.readInt8,e.readInt16LE=Q.readInt16LE,e.readInt16BE=Q.readInt16BE,e.readInt32LE=Q.readInt32LE,e.readInt32BE=Q.readInt32BE,e.readFloatLE=Q.readFloatLE,e.readFloatBE=Q.readFloatBE,e.readDoubleLE=Q.readDoubleLE,e.readDoubleBE=Q.readDoubleBE,e.writeUInt8=Q.writeUInt8,e.writeUIntLE=Q.writeUIntLE,e.writeUIntBE=Q.writeUIntBE,e.writeUInt16LE=Q.writeUInt16LE,e.writeUInt16BE=Q.writeUInt16BE,e.writeUInt32LE=Q.writeUInt32LE,e.writeUInt32BE=Q.writeUInt32BE,e.writeIntLE=Q.writeIntLE,e.writeIntBE=Q.writeIntBE,e.writeInt8=Q.writeInt8,e.writeInt16LE=Q.writeInt16LE,e.writeInt16BE=Q.writeInt16BE,e.writeInt32LE=Q.writeInt32LE,e.writeInt32BE=Q.writeInt32BE,e.writeFloatLE=Q.writeFloatLE,e.writeFloatBE=Q.writeFloatBE,e.writeDoubleLE=Q.writeDoubleLE,e.writeDoubleBE=Q.writeDoubleBE,e.fill=Q.fill,e.inspect=Q.inspect,e.toArrayBuffer=Q.toArrayBuffer,e};var tt=/[^+\/0-9A-Za-z-_]/g}).call(e,n(312).Buffer,function(){return this}())},function(t,e,n){var r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";!function(t){"use strict";function e(t){var e=t.charCodeAt(0);return e===o||e===h?62:e===a||e===l?63:u>e?-1:u+10>e?e-u+26+26:f+26>e?e-f:c+26>e?e-c+26:void 0}function n(t){function n(t){c[h++]=t}var r,i,o,a,u,c;if(t.length%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var f=t.length;u="="===t.charAt(f-2)?2:"="===t.charAt(f-1)?1:0,c=new s(3*t.length/4-u),o=u>0?t.length-4:t.length;var h=0;for(r=0,i=0;o>r;r+=4,i+=3)a=e(t.charAt(r))<<18|e(t.charAt(r+1))<<12|e(t.charAt(r+2))<<6|e(t.charAt(r+3)),n((16711680&a)>>16),n((65280&a)>>8),n(255&a);return 2===u?(a=e(t.charAt(r))<<2|e(t.charAt(r+1))>>4,n(255&a)):1===u&&(a=e(t.charAt(r))<<10|e(t.charAt(r+1))<<4|e(t.charAt(r+2))>>2,n(a>>8&255),n(255&a)),c}function i(t){function e(t){return r.charAt(t)}function n(t){return e(t>>18&63)+e(t>>12&63)+e(t>>6&63)+e(63&t)}var i,s,o,a=t.length%3,u="";for(i=0,o=t.length-a;o>i;i+=3)s=(t[i]<<16)+(t[i+1]<<8)+t[i+2],u+=n(s);switch(a){case 1:s=t[t.length-1],u+=e(s>>2),u+=e(s<<4&63),u+="==";break;case 2:s=(t[t.length-2]<<8)+t[t.length-1],u+=e(s>>10),u+=e(s>>4&63),u+=e(s<<2&63),u+="="}return u}var s="undefined"!=typeof Uint8Array?Uint8Array:Array,o="+".charCodeAt(0),a="/".charCodeAt(0),u="0".charCodeAt(0),c="a".charCodeAt(0),f="A".charCodeAt(0),h="-".charCodeAt(0),l="_".charCodeAt(0);t.toByteArray=n,t.fromByteArray=i}(e)},function(t,e){e.read=function(t,e,n,r,i){var s,o,a=8*i-r-1,u=(1<<a)-1,c=u>>1,f=-7,h=n?i-1:0,l=n?-1:1,d=t[e+h];for(h+=l,s=d&(1<<-f)-1,d>>=-f,f+=a;f>0;s=256*s+t[e+h],h+=l,f-=8);for(o=s&(1<<-f)-1,s>>=-f,f+=r;f>0;o=256*o+t[e+h],h+=l,f-=8);if(0===s)s=1-c;else{if(s===u)return o?NaN:(d?-1:1)*(1/0);o+=Math.pow(2,r),s-=c}return(d?-1:1)*o*Math.pow(2,s-r)},e.write=function(t,e,n,r,i,s){var o,a,u,c=8*s-i-1,f=(1<<c)-1,h=f>>1,l=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,d=r?0:s-1,p=r?1:-1,g=0>e||0===e&&0>1/e?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(a=isNaN(e)?1:0,o=f):(o=Math.floor(Math.log(e)/Math.LN2),e*(u=Math.pow(2,-o))<1&&(o--,u*=2),e+=o+h>=1?l/u:l*Math.pow(2,1-h),e*u>=2&&(o++,u/=2),o+h>=f?(a=0,o=f):o+h>=1?(a=(e*u-1)*Math.pow(2,i),o+=h):(a=e*Math.pow(2,h-1)*Math.pow(2,i),o=0));i>=8;t[n+d]=255&a,d+=p,a/=256,i-=8);for(o=o<<i|a,c+=i;c>0;t[n+d]=255&o,d+=p,o/=256,c-=8);t[n+d-p]|=128*g}},function(t,e){var n={}.toString;t.exports=Array.isArray||function(t){return"[object Array]"==n.call(t)}},function(t,e){},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(300),o=r(s),a=n(318),u=r(a),c=n(319),f=r(c),h=function(){function t(e){var n=e.url,r=e.client_id,s=e.redirect_uri,a=e.response_type,c=e.scope,h=e.authority,l=e.data,d=e.prompt,p=e.display,g=e.max_age,y=e.ui_locales,v=e.id_token_hint,m=e.login_hint,S=e.acr_values;if(i(this,t),!n)throw o.default.error("No url passed to SigninRequest"),new Error("url");if(!r)throw o.default.error("No client_id passed to SigninRequest"),new Error("client_id");if(!s)throw o.default.error("No redirect_uri passed to SigninRequest"),new Error("redirect_uri");if(!a)throw o.default.error("No response_type passed to SigninRequest"),new Error("response_type");if(!c)throw o.default.error("No scope passed to SigninRequest"),new Error("scope");if(!h)throw o.default.error("No authority passed to SigninRequest"),new Error("authority");var b=t.isOidc(a);this.state=new f.default({nonce:b,data:l,client_id:r,authority:h}),n=u.default.addQueryParam(n,"client_id",r),n=u.default.addQueryParam(n,"redirect_uri",s),n=u.default.addQueryParam(n,"response_type",a),n=u.default.addQueryParam(n,"scope",c),n=u.default.addQueryParam(n,"state",this.state.id),b&&(n=u.default.addQueryParam(n,"nonce",this.state.nonce));var w={prompt:d,display:p,max_age:g,ui_locales:y,id_token_hint:v,login_hint:m,acr_values:S};for(var E in w)w[E]&&(n=u.default.addQueryParam(n,E,w[E]));this.url=n}return t.isOidc=function(t){var e=t.split(/\s+/g).filter(function(t){return"id_token"===t});return!!e[0]},t.isOAuth=function(t){var e=t.split(/\s+/g).filter(function(t){return"token"===t});return!!e[0]},t}();e.default=h,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(300),o=r(s),a=n(304),u=r(a),c=function(){function t(){i(this,t)}return t.addQueryParam=function(t,e,n){return t.indexOf("?")<0&&(t+="?"),"?"!==t[t.length-1]&&(t+="&"),t+=encodeURIComponent(e),t+="=",t+=encodeURIComponent(n)},t.parseUrlFragment=function(t){var e=arguments.length<=1||void 0===arguments[1]?"#":arguments[1],n=arguments.length<=2||void 0===arguments[2]?u.default:arguments[2];o.default.info("UrlUtility.parseUrlFragment"),"string"!=typeof t&&(t=n.location.href);var r=t.lastIndexOf(e);r>=0&&(t=t.substr(r+1));for(var i,s={},a=/([^&=]+)=([^&]*)/g,c=0;i=a.exec(t);)if(s[decodeURIComponent(i[1])]=decodeURIComponent(i[2]),c++>50)return o.default.error("response exceeded expected number of parameters",t),{error:"Response exceeded expected number of parameters"};for(var f in s)return s;return{}},t}();e.default=c,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(300),c=r(u),f=n(320),h=r(f),l=n(321),d=r(l),p=function(t){function e(){var n=arguments.length<=0||void 0===arguments[0]?{}:arguments[0],r=n.nonce,o=n.authority,a=n.client_id;i(this,e);var u=s(this,t.call(this,arguments[0]));return r===!0?u._nonce=(0,d.default)():r&&(u._nonce=r),u._authority=o,u._client_id=a,u}return o(e,t),e.prototype.toStorageString=function(){return c.default.info("SigninState.toStorageString"),JSON.stringify({id:this.id,data:this.data,created:this.created,nonce:this.nonce,authority:this.authority,client_id:this.client_id})},e.fromStorageString=function(t){c.default.info("SigninState.fromStorageString");var n=JSON.parse(t);return new e(n)},a(e,[{key:"nonce",get:function(){return this._nonce}},{key:"authority",get:function(){return this._authority}},{key:"client_id",get:function(){return this._client_id}}]),e}(h.default);e.default=p,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(300),a=r(o),u=n(321),c=r(u),f=function(){function t(){var e=arguments.length<=0||void 0===arguments[0]?{}:arguments[0],n=e.id,r=e.data,s=e.created;i(this,t),this._id=n||(0,c.default)(),this._data=r,"number"==typeof s&&s>0?this._created=s:this._created=parseInt(Date.now()/1e3)}return t.prototype.toStorageString=function(){return a.default.info("State.toStorageString"),JSON.stringify({id:this.id,data:this.data,created:this.created})},t.fromStorageString=function(e){return a.default.info("State.fromStorageString"),new t(JSON.parse(e))},t.clearStaleState=function(e,n){a.default.info("State.clearStaleState");var r=Date.now()/1e3-n;return e.getAllKeys().then(function(n){a.default.info("got keys",n);var i=[],s=!0,o=!1,u=void 0;try{for(var c,f=function(){var n=c.value;l=e.get(n).then(function(i){var s=!1;if(i)try{var o=t.fromStorageString(i);a.default.info("got item from key: ",n,o.created),o.created<=r&&(s=!0)}catch(u){a.default.error("Error parsing state for key",n,u.message),s=!0}else a.default.info("no item in storage for key: ",n),s=!0;return s?(a.default.info("removed item for key: ",n),e.remove(n)):void 0}),i.push(l)},h=n[Symbol.iterator]();!(s=(c=h.next()).done);s=!0){var l;f()}}catch(d){o=!0,u=d}finally{try{!s&&h.return&&h.return()}finally{if(o)throw u}}return a.default.info("waiting on promise count:",i.length),Promise.all(i)})},s(t,[{key:"id",get:function(){return this._id}},{key:"data",get:function(){return this._data}},{key:"created",get:function(){return this._created}}]),t}();e.default=f,t.exports=e.default},function(t,e){"use strict";
// @preserve Copyright (c) Microsoft Open Technologies, Inc.
function n(){for(var t="xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx",e="0123456789abcdef",n=0,r="",i=0;i<t.length;i++)"-"!==t[i]&&"4"!==t[i]&&(n=16*Math.random()|0),"x"===t[i]?r+=e[n]:"y"===t[i]?(n&=3,n|=8,r+=e[n]):r+=t[i];return r}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(318),a=r(o),u="openid",c=function(){function t(e){i(this,t);var n=a.default.parseUrlFragment(e,"#");this.error=n.error,this.error_description=n.error_description,this.error_uri=n.error_uri,this.state=n.state,this.id_token=n.id_token,this.session_state=n.session_state,this.access_token=n.access_token,this.token_type=n.token_type,this.scope=n.scope,this.profile=void 0;var r=parseInt(n.expires_in);if("number"==typeof r&&r>0){var s=parseInt(Date.now()/1e3);this.expires_at=s+r}}return s(t,[{key:"expires_in",get:function(){if(this.expires_at){var t=parseInt(Date.now()/1e3);return this.expires_at-t}}},{key:"expired",get:function(){var t=this.expires_in;return void 0!==t?0>=t:void 0}},{key:"scopes",get:function(){return(this.scope||"").split(" ")}},{key:"isOpenIdConnect",get:function(){return this.scopes.indexOf(u)>=0}}]),t}();e.default=c,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(300),o=r(s),a=n(318),u=r(a),c=n(320),f=r(c),h=function l(t){var e=t.url,n=t.id_token_hint,r=t.post_logout_redirect_uri,s=t.data;if(i(this,l),!e)throw o.default.error("No url passed to SignoutRequest"),new Error("url");n&&(e=u.default.addQueryParam(e,"id_token_hint",n),r&&(e=u.default.addQueryParam(e,"post_logout_redirect_uri",r),s&&(this.state=new f.default({data:s}),e=u.default.addQueryParam(e,"state",this.state.id)))),this.url=e};e.default=h,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(318),o=r(s),a=function u(t){i(this,u);var e=o.default.parseUrlFragment(t,"?");this.error=e.error,this.error_description=e.error_description,this.error_uri=e.error_uri,this.state=e.state};e.default=a,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(300),a=r(o),u=function(){function t(){i(this,t),this._data={}}return t.prototype.getItem=function(t){return a.default.info("InMemoryWebStorage.getItem",t),this._data[t]},t.prototype.setItem=function(t,e){a.default.info("InMemoryWebStorage.setItem",t),this._data[t]=e},t.prototype.removeItem=function(t){a.default.info("InMemoryWebStorage.removeItem",t),delete this._data[t]},t.prototype.key=function(t){return Object.getOwnPropertyNames(this._data)[t]},s(t,[{key:"length",get:function(){return Object.getOwnPropertyNames(this._data).length}}]),t}();e.default=u,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(300),c=r(u),f=n(301),h=r(f),l=n(327),d=r(l),p=n(333),g=r(p),y=n(334),v=r(y),m=n(338),S=r(m),b=n(339),w=r(b),E=function(t){function e(){var n=arguments.length<=0||void 0===arguments[0]?{}:arguments[0],r=arguments.length<=1||void 0===arguments[1]?S.default:arguments[1],o=arguments.length<=2||void 0===arguments[2]?w.default:arguments[2];i(this,e),n instanceof d.default||(n=new d.default(n));var a=s(this,t.call(this,n));return a._events=new v.default(n),a.settings.automaticSilentRenew&&(c.default.info("automaticSilentRenew is configured, setting up silent renew"),a._silentRenewService=new r(a)),a.settings.monitorSession&&(c.default.info("monitorSession is configured, setting up session monitor"),a._sessionMonitor=new o(a)),a}return o(e,t),e.prototype.getUser=function(){var t=this;return c.default.info("UserManager.getUser"),this._loadUser().then(function(e){return e?(c.default.info("user loaded"),t._events.load(e,!1),e):(c.default.info("user not found in storage"),null)})},e.prototype.removeUser=function(){var t=this;return c.default.info("UserManager.removeUser"),this._storeUser(null).then(function(){c.default.info("user removed from storage"),t._events.unload()})},e.prototype.signinPopup=function(){var t=arguments.length<=0||void 0===arguments[0]?{}:arguments[0];c.default.info("UserManager.signinPopup");var e=t.redirect_uri||this.settings.popup_redirect_uri||this.settings.redirect_uri;return e?(t.redirect_uri=e,t.display="popup",this._signin(t,this._popupNavigator,{startUrl:e,popupWindowFeatures:t.popupWindowFeatures||this.settings.popupWindowFeatures,popupWindowTarget:t.popupWindowTarget||this.settings.popupWindowTarget})):(c.default.error("No popup_redirect_uri or redirect_uri configured"),Promise.reject(new Error("No popup_redirect_uri or redirect_uri configured")))},e.prototype.signinPopupCallback=function(t){return c.default.info("UserManager.signinPopupCallback"),this._signinCallback(t,this._popupNavigator)},e.prototype.signinSilent=function(){var t=arguments.length<=0||void 0===arguments[0]?{}:arguments[0];c.default.info("UserManager.signinSilent");var e=t.redirect_uri||this.settings.silent_redirect_uri;return e?(t.redirect_uri=e,t.prompt="none",this._signin(t,this._iframeNavigator,{startUrl:e,silentRequestTimeout:t.silentRequestTimeout||this.settings.silentRequestTimeout})):(c.default.error("No silent_redirect_uri configured"),Promise.reject(new Error("No silent_redirect_uri configured")))},e.prototype.signinSilentCallback=function(t){return c.default.info("UserManager.signinSilentCallback"),this._signinCallback(t,this._iframeNavigator)},e.prototype.querySessionStatus=function(){var t=this,e=arguments.length<=0||void 0===arguments[0]?{}:arguments[0];c.default.info("UserManager.querySessionStatus");var n=e.redirect_uri||this.settings.silent_redirect_uri;return n?(e.redirect_uri=n,e.prompt="none",e.response_type="id_token",e.scope="openid",this._signinStart(e,this._iframeNavigator,{startUrl:n,silentRequestTimeout:e.silentRequestTimeout||this.settings.silentRequestTimeout}).then(function(e){return t.processSigninResponse(e.url).then(function(t){return c.default.info("got signin response"),t.session_state&&t.profile.sub?{session_state:t.session_state,sub:t.profile.sub}:void 0})})):(c.default.error("No silent_redirect_uri configured"),Promise.reject(new Error("No silent_redirect_uri configured")))},e.prototype._signin=function(t,e){var n=this,r=arguments.length<=2||void 0===arguments[2]?{}:arguments[2];return c.default.info("_signin"),this._signinStart(t,e,r).then(function(t){return n._signinEnd(t.url)})},e.prototype._signinCallback=function(t,e){return c.default.info("_signinCallback"),e.callback(t)},e.prototype._signout=function(t,e){var n=this,r=arguments.length<=2||void 0===arguments[2]?{}:arguments[2];return c.default.info("_signout"),this._signoutStart(t,e,r).then(function(t){return n._signoutEnd(t.url)})},e.prototype._signoutCallback=function(t,e){return c.default.info("_signoutCallback"),e.callback(t)},e.prototype.signinRedirect=function(t){return c.default.info("UserManager.signinRedirect"),this._signinStart(t,this._redirectNavigator)},e.prototype.signinRedirectCallback=function(t){return c.default.info("UserManager.signinRedirectCallback"),this._signinEnd(t||this._redirectNavigator.url)},e.prototype.signoutRedirect=function(t){return c.default.info("UserManager.signoutRedirect"),this._signoutStart(t,this._redirectNavigator)},e.prototype.signoutPopup=function(){var t=arguments.length<=0||void 0===arguments[0]?{}:arguments[0];c.default.info("UserManager.signoutPopup");var e=t.redirect_uri||this.settings.popup_redirect_uri||this.settings.redirect_uri;return e?this._signout(t,this._popupNavigator,{startUrl:e,popupWindowFeatures:t.popupWindowFeatures||this.settings.popupWindowFeatures,popupWindowTarget:t.popupWindowTarget||this.settings.popupWindowTarget}):(c.default.error("No popup_redirect_uri or redirect_uri configured"),Promise.reject(new Error("No popup_redirect_uri or redirect_uri configured")))},e.prototype.signoutRedirectCallback=function(t){return c.default.info("UserManager.signoutRedirectCallback"),this._signoutEnd(t||this._redirectNavigator.url)},e.prototype._signinStart=function(t,e){var n=this,r=arguments.length<=2||void 0===arguments[2]?{}:arguments[2];return c.default.info("_signinStart"),e.prepare(r).then(function(e){return c.default.info("got navigator window handle"),n.createSigninRequest(t).then(function(t){return c.default.info("got signin request"),r.url=t.url,e.navigate(r)})})},e.prototype._signinEnd=function(t){var e=this;return c.default.info("_signinEnd"),this.processSigninResponse(t).then(function(t){c.default.info("got signin response");var n=new g.default(t);return e._storeUser(n).then(function(){return c.default.info("user stored"),e._events.load(n),n})})},e.prototype._signoutStart=function(){var t=arguments.length<=0||void 0===arguments[0]?{}:arguments[0],e=this,n=arguments[1],r=arguments.length<=2||void 0===arguments[2]?{}:arguments[2];return c.default.info("_signoutStart"),n.prepare(r).then(function(n){return c.default.info("got navigator window handle"),e.getUser().then(function(i){c.default.info("loaded current user from storage");var s=t.id_token_hint||i&&i.id_token;return s&&(c.default.info("Setting id_token into signout request"),t.id_token_hint=s),e.removeUser().then(function(){return c.default.info("user removed, creating signout request"),e.createSignoutRequest(t).then(function(t){return c.default.info("got signout request"),r.url=t.url,n.navigate(r)})})})})},e.prototype._signoutEnd=function(t){return c.default.info("_signoutEnd"),this.processSignoutResponse(t).then(function(t){return c.default.info("got signout response"),t})},e.prototype._loadUser=function(){return c.default.info("_loadUser"),this._userStore.get(this._userStoreKey).then(function(t){return t?(c.default.info("user storageString loaded"),g.default.fromStorageString(t)):(c.default.info("no user storageString"),null)})},e.prototype._storeUser=function(t){if(t){c.default.info("_storeUser storing user");var e=t.toStorageString();return this._userStore.set(this._userStoreKey,e)}return c.default.info("_storeUser removing user storage"),this._userStore.remove(this._userStoreKey)},a(e,[{key:"_redirectNavigator",get:function(){return this.settings.redirectNavigator}},{key:"_popupNavigator",get:function(){return this.settings.popupNavigator}},{key:"_iframeNavigator",get:function(){return this.settings.iframeNavigator}},{key:"_userStore",get:function(){return this.settings.userStore}},{key:"events",get:function(){return this._events}},{key:"_userStoreKey",get:function(){return"user:"+this.settings.authority+":"+this.settings.client_id}}]),e}(h.default);e.default=E,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(300),c=(r(u),n(302)),f=r(c),h=n(328),l=r(h),d=n(329),p=r(d),g=n(331),y=r(g),v=n(303),m=r(v),S=n(304),b=r(S),w=60,E=function(t){function e(){var n=arguments.length<=0||void 0===arguments[0]?{}:arguments[0],r=n.popup_redirect_uri,o=n.popupWindowFeatures,a=n.popupWindowTarget,u=n.silent_redirect_uri,c=n.silentRequestTimeout,f=n.automaticSilentRenew,h=void 0===f?!1:f,d=n.monitorSession,g=void 0===d?!0:d,v=n.accessTokenExpiringNotificationTime,S=void 0===v?w:v,E=n.redirectNavigator,x=void 0===E?new l.default:E,_=n.popupNavigator,R=void 0===_?new p.default:_,A=n.iframeNavigator,F=void 0===A?new y.default:A,K=n.userStore,P=void 0===K?new m.default({store:b.default.sessionStorage}):K;i(this,e);var U=s(this,t.call(this,arguments[0]));return U._popup_redirect_uri=r,U._popupWindowFeatures=o,U._popupWindowTarget=a,U._silent_redirect_uri=u,U._silentRequestTimeout=c,U._automaticSilentRenew=!!h,U._accessTokenExpiringNotificationTime=S,U._monitorSession=g,U._redirectNavigator=x,U._popupNavigator=R,U._iframeNavigator=F,U._userStore=P,U}return o(e,t),a(e,[{key:"popup_redirect_uri",get:function(){return this._popup_redirect_uri}},{key:"popupWindowFeatures",get:function(){return this._popupWindowFeatures}},{key:"popupWindowTarget",get:function(){return this._popupWindowTarget}},{key:"silent_redirect_uri",get:function(){return this._silent_redirect_uri}},{key:"silentRequestTimeout",get:function(){return this._silentRequestTimeout}},{key:"automaticSilentRenew",get:function(){return!(!this.silent_redirect_uri||!this._automaticSilentRenew)}},{key:"accessTokenExpiringNotificationTime",get:function(){return this._accessTokenExpiringNotificationTime}},{key:"monitorSession",get:function(){return this._monitorSession}},{key:"redirectNavigator",get:function(){return this._redirectNavigator}},{key:"popupNavigator",get:function(){return this._popupNavigator}},{key:"iframeNavigator",get:function(){return this._iframeNavigator}},{key:"userStore",get:function(){return this._userStore}}]),e}(f.default);e.default=E,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(300),a=r(o),u=function(){function t(){i(this,t)}return t.prototype.prepare=function(){return Promise.resolve(this)},t.prototype.navigate=function(t){return a.default.info("RedirectNavigator.navigate"),t&&t.url?(window.location=t.url,Promise.resolve()):(a.default.error("No url provided"),Promise.reject(new Error("No url provided")))},s(t,[{key:"url",get:function(){return a.default.info("RedirectNavigator.url"),window.location.href}}]),t}();e.default=u,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(300),o=r(s),a=n(330),u=r(a),c=function(){function t(){i(this,t)}return t.prototype.prepare=function(t){var e=new u.default(t);return Promise.resolve(e)},t.prototype.callback=function(t){o.default.info("PopupNavigator.callback");try{return u.default.notifyOpener(t),Promise.resolve()}catch(e){return Promise.reject(e)}},t}();e.default=c,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(300),a=r(o),u=500,c="location=no,toolbar=no,width=500,height=500,left=100,top=100",f="_blank",h=function(){function t(e){var n=this;i(this,t),a.default.info("PopupWindow.ctor"),this._promise=new Promise(function(t,e){n._resolve=t,n._reject=e}),this._boundMessageEvent=this._message.bind(this),window.addEventListener("message",this._boundMessageEvent,!1);var r=e.popupWindowFeatures||c,s=e.popupWindowTarget||f;this._popup=window.open("",s,r),this._popup&&(a.default.info("popup successfully created"),this._checkForPopupClosedTimer=window.setInterval(this._checkForPopupClosed.bind(this),u))}return t.prototype.navigate=function(t){return a.default.info("PopupWindow.navigate"),this._popup?t&&t.url?(a.default.info("Setting URL in popup"),this._popup.focus(),this._popup.window.location=t.url):this._error("No url provided"):this._error("Error opening popup window"),this.promise},t.prototype._success=function(t){this._cleanup(),a.default.info("Successful response from popup window"),this._resolve(t)},t.prototype._error=function(t){this._cleanup(),a.default.error(t),this._reject(new Error(t))},t.prototype._cleanup=function(){a.default.info("PopupWindow._cleanup"),window.removeEventListener("message",this._boundMessageEvent,!1),window.clearInterval(this._checkForPopupClosedTimer),this._checkForPopupClosedTimer=null,this._boundMessageEventssage=null,this._popup&&this._popup.close(),this._popup=null},t.prototype._checkForPopupClosed=function(){a.default.info("PopupWindow._checkForPopupClosed"),this._popup&&!this._popup.closed||this._error("Popup window closed")},t.prototype._message=function(t){if(a.default.info("PopupWindow._message"),t.origin===this._origin&&t.source===this._popup.window){a.default.info("processing message");var e=t.data||t.source.location.href;this._cleanup(),e?this._success({url:e}):this._error("Invalid response from popup")}},t.notifyOpener=function(t){a.default.info("PopupWindow.notifyOpener"),window.opener&&(t=t||window.location.href,t&&(a.default.info("posting url message to opener"),window.opener.postMessage(t,location.protocol+"//"+location.host)))},s(t,[{key:"promise",get:function(){return this._promise}},{key:"_origin",get:function(){return location.protocol+"//"+location.host}}]),t}();e.default=h,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(300),o=r(s),a=n(332),u=r(a),c=function(){function t(){i(this,t)}return t.prototype.prepare=function(t){var e=new u.default(t);return Promise.resolve(e)},t.prototype.callback=function(t){o.default.info("IFrameNavigator.callback");try{return u.default.notifyParent(t),Promise.resolve()}catch(e){return Promise.reject(e)}},t}();e.default=c,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(300),a=r(o),u=5e3,c=function(){function t(e){var n=this;i(this,t),a.default.info("IFrameWindow.ctor"),this._promise=new Promise(function(t,e){n._resolve=t,n._reject=e}),this._boundMessageEvent=this._message.bind(this),window.addEventListener("message",this._boundMessageEvent,!1),this._frame=window.document.createElement("iframe"),this._frame.style.display="none",window.document.body.appendChild(this._frame)}return t.prototype.navigate=function(t){if(a.default.info("IFrameWindow.navigate"),t&&t.url){var e=t.silentRequestTimeout||u;a.default.info("Using timeout of:",e),this._timer=window.setTimeout(this._timeout.bind(this),e),this._frame.src=t.url}else this._error("No url provided");return this.promise},t.prototype._success=function(t){this._cleanup(),a.default.info("Successful response from frame window"),this._resolve(t)},t.prototype._error=function(t){this._cleanup(),a.default.error(t),this._reject(new Error(t))},t.prototype._cleanup=function(){a.default.info("IFrameWindow._cleanup"),window.removeEventListener("message",this._boundMessageEvent,!1),window.clearTimeout(this._timer),window.document.body.removeChild(this._frame),this._timer=null,this._frame=null,this._boundMessageEvent=null},t.prototype._timeout=function(){a.default.info("IFrameWindow._timeout"),this._error("Frame window timed out")},t.prototype._message=function(t){if(a.default.info("IFrameWindow._message"),this._timer&&t.origin===this._origin&&t.source===this._frame.contentWindow){var e=t.data;e?this._success({url:e}):this._error("Invalid response from frame")}},t.notifyParent=function(t){a.default.info("IFrameWindow.notifyParent"),window.parent&&window!==window.parent&&(t=t||window.location.href,t&&(a.default.info("posting url message to parent"),window.parent.postMessage(t,location.protocol+"//"+location.host)))},s(t,[{key:"promise",get:function(){return this._promise}},{key:"_origin",get:function(){return location.protocol+"//"+location.host}}]),t}();e.default=c,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(300),a=r(o),u=function(){function t(e){var n=e.id_token,r=e.session_state,s=e.access_token,o=e.token_type,a=e.scope,u=e.profile,c=e.expires_at,f=e.state;i(this,t),this.id_token=n,this.session_state=r,this.access_token=s,this.token_type=o,this.scope=a,this.profile=u,this.expires_at=c,this.state=f}return t.prototype.toStorageString=function(){return a.default.info("User.toStorageString"),JSON.stringify({id_token:this.id_token,session_state:this.session_state,access_token:this.access_token,token_type:this.token_type,scope:this.scope,profile:this.profile,expires_at:this.expires_at})},t.fromStorageString=function(e){return a.default.info("User.fromStorageString"),new t(JSON.parse(e))},s(t,[{key:"expires_in",get:function(){if(this.expires_at){var t=parseInt(Date.now()/1e3);return this.expires_at-t}}},{key:"expired",get:function(){var t=this.expires_in;return void 0!==t?0>=t:void 0}},{key:"scopes",get:function(){return(this.scope||"").split(" ")}}]),t}();e.default=u,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=n(300),u=r(a),c=n(335),f=r(c),h=n(337),l=r(h),d=function(t){function e(n){i(this,e);var r=s(this,t.call(this,n));return r._userLoaded=new l.default("User loaded"),r._userUnloaded=new l.default("User unloaded"),r._silentRenewError=new l.default("Silent renew error"),r._userSignedOut=new l.default("User signed out"),r}return o(e,t),e.prototype.load=function(e){var n=arguments.length<=1||void 0===arguments[1]?!0:arguments[1];u.default.info("UserManagerEvents.load"),t.prototype.load.call(this,e),n&&this._userLoaded.raise(e)},e.prototype.unload=function(){u.default.info("UserManagerEvents.unload"),t.prototype.unload.call(this),this._userUnloaded.raise()},e.prototype.addUserLoaded=function(t){this._userLoaded.addHandler(t)},e.prototype.removeUserLoaded=function(t){this._userLoaded.removeHandler(t)},e.prototype.addUserUnloaded=function(t){this._userUnloaded.addHandler(t)},e.prototype.removeUserUnloaded=function(t){this._userUnloaded.removeHandler(t)},e.prototype.addSilentRenewError=function(t){this._silentRenewError.addHandler(t)},e.prototype.removeSilentRenewError=function(t){this._silentRenewError.removeHandler(t)},e.prototype._raiseSilentRenewError=function(t){u.default.info("UserManagerEvents._raiseSilentRenewError",t.message),this._silentRenewError.raise(t)},e.prototype.addUserSignedOut=function(t){this._userSignedOut.addHandler(t)},e.prototype.removeUserSignedOut=function(t){this._userSignedOut.removeHandler(t)},e.prototype._raiseUserSignedOut=function(t){u.default.info("UserManagerEvents._raiseUserSignedOut"),this._userSignedOut.raise(t)},e}(f.default);e.default=d,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(300),o=r(s),a=n(336),u=r(a),c=60,f=function(){function t(){var e=arguments.length<=0||void 0===arguments[0]?{}:arguments[0],n=e.accessTokenExpiringNotificationTime,r=void 0===n?c:n,s=e.accessTokenExpiringTimer,o=void 0===s?new u.default("Access token expiring"):s,a=e.accessTokenExpiredTimer,f=void 0===a?new u.default("Access token expired"):a;i(this,t),this._accessTokenExpiringNotificationTime=r,this._accessTokenExpiring=o,this._accessTokenExpired=f}return t.prototype.load=function(t){if(o.default.info("AccessTokenEvents.load"),this._cancelTimers(),t.access_token){var e=t.expires_in;if(o.default.info("access token present, remaining duration:",e),e>0){var n=e-this._accessTokenExpiringNotificationTime;0>=n&&(n=1),o.default.info("registering expiring timer in:",n),this._accessTokenExpiring.init(n)}var r=e+1;o.default.info("registering expired timer in:",r),this._accessTokenExpired.init(r)}},t.prototype.unload=function(){o.default.info("AccessTokenEvents.unload"),this._cancelTimers()},t.prototype._cancelTimers=function(){o.default.info("canceling existing access token timers"),this._accessTokenExpiring.cancel(),this._accessTokenExpired.cancel()},t.prototype.addAccessTokenExpiring=function(t){this._accessTokenExpiring.addHandler(t)},t.prototype.removeAccessTokenExpiring=function(t){this._accessTokenExpiring.removeHandler(t)},t.prototype.addAccessTokenExpired=function(t){this._accessTokenExpired.addHandler(t)},t.prototype.removeAccessTokenExpired=function(t){this._accessTokenExpired.removeHandler(t)},t}();e.default=f,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=n(300),u=(r(a),n(304)),c=r(u),f=n(337),h=r(f),l=function(t){function e(n){var r=arguments.length<=1||void 0===arguments[1]?c.default.timer:arguments[1];i(this,e);var o=s(this,t.call(this,n));return o._timer=r,o}return o(e,t),e.prototype.init=function(t){this.cancel(),0>=t&&(t=1),this._timerHandle=this._timer.setTimeout(this._callback.bind(this),1e3*t)},e.prototype.cancel=function(){this._timerHandle&&(this._timer.clearTimeout(this._timerHandle),this._timerHandle=null)},e.prototype._callback=function(){this._timerHandle=null,t.prototype.raise.call(this)},e}(h.default);e.default=l,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(300),o=r(s),a=function(){function t(e){i(this,t),this._name=e,this._callbacks=[]}return t.prototype.addHandler=function(t){this._callbacks.push(t)},t.prototype.removeHandler=function(t){var e=this._callbacks.findIndex(function(e){return e===t});e>=0&&this._callbacks.splice(e,1)},t.prototype.raise=function(){o.default.info("Raising event: "+this._name);var t=!0,e=!1,n=void 0;try{for(var r,i=this._callbacks[Symbol.iterator]();!(t=(r=i.next()).done);t=!0){var s=r.value;s.apply(void 0,arguments)}}catch(a){e=!0,n=a}finally{try{!t&&i.return&&i.return()}finally{if(e)throw n}}},t}();e.default=a,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(300),o=r(s),a=function(){function t(e){i(this,t),this._userManager=e,this._userManager.events.addAccessTokenExpiring(this._tokenExpiring.bind(this)),this._userManager.getUser().then(function(t){}).catch(function(t){o.default.error("Error from getUser:",t.message)})}return t.prototype._tokenExpiring=function(){var t=this;o.default.info("SilentRenewService automatically renewing access token"),this._userManager.signinSilent().then(function(t){o.default.info("Silent token renewal successful")},function(e){o.default.error("Error from signinSilent:",e.message),t._userManager.events._raiseSilentRenewError(e)})},t}();e.default=a,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(300),a=r(o),u=n(340),c=r(u),f=function(){
function t(e){var n=this,r=arguments.length<=1||void 0===arguments[1]?c.default:arguments[1];if(i(this,t),!e)throw a.default.error("No user manager passed to SessionMonitor"),new Error("userManager");this._userManager=e,this._CheckSessionIFrameCtor=r,this._userManager.events.addUserLoaded(this._start.bind(this)),this._userManager.events.addUserUnloaded(this._stop.bind(this)),this._userManager.getUser().then(function(t){t&&n._start(t)}).catch(function(t){a.default.error("SessionMonitor ctor; error from getUser:",t.message)})}return t.prototype._start=function(t){var e=this,n=t.session_state;n&&(this._sub=t.profile.sub,a.default.info("SessionMonitor._start; session_state:",n,", sub:",this._sub),this._checkSessionIFrame?this._checkSessionIFrame.start(n):this._metadataService.getCheckSessionIframe().then(function(t){if(t){a.default.info("Initializing check session iframe");var r=e._client_id,i=e._checkSessionInterval;e._checkSessionIFrame=new e._CheckSessionIFrameCtor(e._callback.bind(e),r,t,i),e._checkSessionIFrame.start(n)}else a.default.warn("No check session iframe found in the metadata")}).catch(function(t){a.default.error("Error from getCheckSessionIframe:",t.message)}))},t.prototype._stop=function(){a.default.info("SessionMonitor._stop"),this._sub=null,this._checkSessionIFrame&&this._checkSessionIFrame.stop()},t.prototype._callback=function(){var t=this;a.default.info("SessionMonitor._callback"),this._userManager.querySessionStatus().then(function(e){var n=!0;e?e.sub===t._sub?(a.default.info("Same sub still logged in at OP, restarting check session iframe; session_state:",e.session_state),t._checkSessionIFrame.start(e.session_state),n=!1):e&&a.default.info("Different subject signed into OP:",e.sub):a.default.info("Subject no longer signed into OP"),n&&(a.default.info("SessionMonitor._callback; raising signed out event"),t._userManager.events._raiseUserSignedOut())}).catch(function(e){a.default.info("Error calling queryCurrentSigninSession; raising signed out event",e.message),t._userManager.events._raiseUserSignedOut()})},s(t,[{key:"_settings",get:function(){return this._userManager.settings}},{key:"_metadataService",get:function(){return this._userManager.metadataService}},{key:"_client_id",get:function(){return this._settings.client_id}},{key:"_checkSessionInterval",get:function(){return this._settings.checkSessionInterval}}]),t}();e.default=f,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(300),o=r(s),a=2e3,u=function(){function t(e,n,r,s){i(this,t),this._callback=e,this._client_id=n,this._url=r,this._interval=s||a;var o=r.indexOf("/",r.indexOf("//")+2);this._frame_origin=r.substr(0,o),this._frame=window.document.createElement("iframe"),this._frame.style.display="none",this._frame.src=r,window.document.body.appendChild(this._frame),this._boundMessageEvent=this._message.bind(this),window.addEventListener("message",this._boundMessageEvent,!1)}return t.prototype._message=function(t){t.origin===this._frame_origin&&t.source===this._frame.contentWindow&&("error"===t.data?(o.default.error("error message from check session op iframe"),this.stop()):"changed"===t.data?(o.default.info("changed message from check session op iframe"),this.stop(),this._callback()):o.default.info(t.data+" message from check session op iframe"))},t.prototype.start=function(t){var e=this;this._session_state!==t&&(o.default.info("CheckSessionIFrame.start"),this.stop(),this._session_state=t,this._timer=window.setInterval(function(){e._frame.contentWindow.postMessage(e._client_id+" "+e._session_state,e._frame_origin)},this._interval))},t.prototype.stop=function(){o.default.info("CheckSessionIFrame.stop"),this._session_state=null,this._timer&&(window.clearInterval(this._timer),this._timer=null)},t}();e.default=u,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(300),o=(r(s),n(342)),a=r(o),u=function(){function t(){i(this,t)}return t.prototype.prepare=function(t){var e=new a.default(t);return Promise.resolve(e)},t}();e.default=u,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(300),a=r(o),u="location=no,toolbar=no,zoom=no",c="_blank",f=function(){function t(e){var n=this;i(this,t),a.default.info("CordovaPopupWindow.ctor"),this._promise=new Promise(function(t,e){n._resolve=t,n._reject=e}),this.features=e.popupWindowFeatures||u,this.target=e.popupWindowTarget||c,this.redirect_uri=e.startUrl,a.default.info("redirect_uri: "+this.redirect_uri)}return t.prototype._isInAppBrowserInstalled=function(t){return["cordova-plugin-inappbrowser","cordova-plugin-inappbrowser.inappbrowser","org.apache.cordova.inappbrowser"].some(function(e){return t.hasOwnProperty(e)})},t.prototype.navigate=function(t){if(a.default.info("CordovaPopupWindow.navigate"),t&&t.url){if(!window.cordova)return this._error("cordova is undefined");var e=window.cordova.require("cordova/plugin_list").metadata;if(this._isInAppBrowserInstalled(e)===!1)return this._error("InAppBrowser plugin not found");this._popup=cordova.InAppBrowser.open(t.url,this.target,this.features),this._popup?(a.default.info("popup successfully created"),this._exitCallbackEvent=this._exitCallback.bind(this),this._loadStartCallbackEvent=this._loadStartCallback.bind(this),this._popup.addEventListener("exit",this._exitCallbackEvent,!1),this._popup.addEventListener("loadstart",this._loadStartCallbackEvent,!1)):this._error("Error opening popup window")}else this._error("No url provided");return this.promise},t.prototype._loadStartCallback=function(t){0===t.url.indexOf(this.redirect_uri)&&this._success({url:t.url})},t.prototype._exitCallback=function(t){this._error(t)},t.prototype._success=function(t){this._cleanup(),a.default.info("Successful response from cordova popup window"),this._resolve(t)},t.prototype._error=function(t){this._cleanup(),a.default.error(t),this._reject(new Error(t))},t.prototype._cleanup=function(){a.default.info("CordovaPopupWindow._cleanup"),this._popup&&(this._popup.removeEventListener("exit",this._exitCallbackEvent,!1),this._popup.removeEventListener("loadstart",this._loadStartCallbackEvent,!1),this._popup.close()),this._popup=null},s(t,[{key:"promise",get:function(){return this._promise}}]),t}();e.default=f,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(300),o=(r(s),n(342)),a=r(o),u=function(){function t(){i(this,t)}return t.prototype.prepare=function(t){t.popupWindowFeatures="hidden=yes";var e=new a.default(t);return Promise.resolve(e)},t}();e.default=u,t.exports=e.default}]);
angular.module(appName)
    .factory("oidcManager", function () {
        //https://github.com/IdentityServer/IdentityServer3.SAccount Codeamples/blob/master/source/Clients/JavaScriptImplicitClient/app.js
        var settings = {
            client_id:  window.isEntegra ? "beagleEntegra" : "beagle",
            redirect_uri: window.location.protocol + "//" + window.location.host + "/callback.cshtml",
            //response_type: "id_token",
            response_type: "token",
            scope: window.isEntegra ? "beagleEntegra" : "beagle",
            authority: window.urls ? window.urls.stsUrl : null,
            extraQueryParams: { 'company': window.isEntegra ? "entegra" : "psl" },
            // silent renew will get a new access_token via an iframe 
            // just prior to the old access_token expiring (60 seconds prior)
            silent_redirect_uri: window.location.protocol + "//" + window.location.host + "/silent_renew.html",
            automaticSilentRenew: false,

            // will raise events for when user has performed a logout at IdentityServer
            monitorSession: true,

            // this will allow all the OIDC protocol claims to vbe visible in the window. normally a client app 
            // wouldn't care about them or want them taking up space
            filterProtocolClaims: true,

            // this will use the user info endpoint if it's an OIDC request and there's an access_token
            loadUserInfo: true
        };


        var mgr = new Oidc.UserManager(settings);

        return {
            UserManager: function () {
                return mgr;
            }
        }
});
angular.module(appName)
  .factory('basketContextResource', [
    '$resource',
    'siteUrl',
    function ($resource,
              siteUrl) {
      var api = siteUrl() + 'api/BasketContext';
      return $resource(api, {}, {
        get: {
          method: 'GET',
          url: api,
          params: {
            basketId: '@basketId'
          }
        }
      });
    }
  ])

angular.module(appName)
    .factory('countryResource', [
        '$resource', 'siteUrl', function ($resource, siteUrl) {
            var api = siteUrl() + 'api/Country';
            return $resource(api, {},
                {
                    get: {
                        method: 'GET',
                        url: api + '/Get',
                        isArray: true
                    },
                    getCountriesWithOrgCountry: {
                      method: 'GET',
                      url: api + '/countries-with-org',
                      isArray: false,
                      params: { orgId: '@orgId' }
                    }
                });
        }
    ]);
'use strict';

angular.module(appName)
    .factory('organisationContactFactory', [
        '$resource', 'siteUrl', function($resource, siteUrl) {

            return $resource(siteUrl() + 'api/OrganisationContact', {},{});
        }
    ]);
angular.module(appName)
    .factory('quotePriceFactory', [
        '$resource', 'siteUrl', function ($resource, siteUrl) {

            return $resource(siteUrl() + 'api/QuotePrice', {}, {

                getPotentialSkusToSwap: {
                    method: 'GET',
                    url: siteUrl() + 'api/QuotePrice/GetPotentialSkusToSwap',
                    isArray: true
                },
                retrieveSkuMatchesForQuotePrice : {
                    method: 'GET',
                    url: siteUrl() + 'api/QuotePrice/RetrieveSkuMatchesForQuotePrice',
                    isArray: true,
                    params: {quotePriceId: '@quotePriceId'}
                },
                retrieveSkuMatchesForQuoteSheet: {
                    method: 'GET',
                    url: siteUrl() + 'api/QuotePrice/RetrieveSkuMatchesForQuoteSheet',
                    params: { quoteSheetId: '@quoteSheetId' }
                },
                handlePartiallyMatchedSKUs : {
                    method: 'POST',
                    url: siteUrl() + 'api/QuotePrice/HandlePartiallyMatchedSKUs',
                    params: { quoteSheetId: '@quoteSheetId' }
                },
                submitMidPeriodPartialMatchTasksForQuoteSheet : {
                    method: 'POST',
                    url: siteUrl() + 'api/QuotePrice/SubmitMidPeriodPartialMatchTasksForQuoteSheet',
                    params: { quoteSheetId: '@quoteSheetId' }
                }
            });
        }
    ]);

'use strict';

angular.module(appName)
    .factory('timezoneResource', [
        '$resource', 'siteUrl', function ($resource, siteUrl) {
            return $resource(siteUrl() + 'api/Timezone', {}, {
                getAllTimezones: {
                    method: 'GET',
                    isArray: true,
                    url: siteUrl() + 'api/Timezone/GetAllTimezones'
                }
            });
        }
    ]);
angular.module(appName)
	.factory('translateResource', [
		'$resource', 'siteUrl', function ($resource, siteUrl) {
		    var api = siteUrl() + 'api/Translate/';
		    return $resource(api, {}, {
		        get: {
		            method: 'GET',
		            url: api + 'Get',
		            params: {
		                lang: '@lang' 
		            }
		        }
		    });
		}
	]);
angular.module(appName)
	.factory("accessService",
		[
			"$q", "applicationModuleFactory",
			function($q, applicationModuleFactory) {
				var getApplicationModuleIdsWithAccess = function(applicationId, organisationId) {
					return $q(function(resolve) {
						applicationModuleFactory
							.getModulesForOrganisation({
								applicationId: applicationId,
								organisationId: organisationId
							}).$promise.then(function(organisationModuleData) {
								var moduleIdsWithAccess = _
									.pluck(organisationModuleData, "id");
								resolve(moduleIdsWithAccess);
							});
					});
				};
				var getApplicationModules = function(applicationId, organisationId) {
					return applicationModuleFactory
						.getModulesForOrganisation({
							applicationId: applicationId,
							organisationId: organisationId
						}).$promise;
				};
				return {
					getApplicationModuleIdsWithAccess: getApplicationModuleIdsWithAccess,
					getApplicationModules: getApplicationModules
				};
			}
		]);
angular.module(appName)
	.factory('allergenService', [
		'$http', 'siteUrl', function ($http, siteUrl) {

			var endpointUrl = siteUrl() + 'api/';

			var service = {
				getSkuIngredientAllergenStatus: function(skuId) {
					var url = endpointUrl + 'sku/' + skuId + "/ingredient-allergen-status";
					return $http.get(url);
				},
				getProductIngredientAllergenStatus: function(productId) {
					var url = endpointUrl + 'product/' + productId + "/ingredient-allergen-status";
					return $http.get(url);
				},
				getSubRecipeIngredientAllergenStatus: function(recipeId) {
					var url = endpointUrl + 'recipe/' + recipeId + "/ingredient-allergen-status";
					return $http.get(url);
				},
				getSuggestedAllergensForIngredient: function(id, entityType, owningClientUnitId) {
					var url = endpointUrl + 'Ingredient/GetSuggestedAllergensForPotentialIngredient';
					var params = {
						entityType: entityType,
						entityId: id,
						owningClientUnitId: owningClientUnitId
					}
					return $http.get(url, { params: params });
				},
				getAll: function() {
					var url = endpointUrl + "allergens";
					return $http.get(url);
				}
		}

			return service;
		}
	]);

angular.module(appName)
  .factory('basketContextService', [
    'basketContextResource',
    function (basketContextResource) {
      var get = function (id) {
        return basketContextResource.get({id: id});
      }

      return {
        get: get
      }
    }
  ])

    angular.module(appName)
  .factory("userService", [
    "$http", "siteUrl", "$q", "organisationContextService", "_",
    function ($http, siteUrl, $q, organisationContextService, _) {
        var self = this;
        self.currentUser = null;
        var currentOrganisationId = null;
        var _fetchingCurrentUserPromise;
        var _getCurrentUser = function () {
          
            var context = organisationContextService.getContext();
            if (context) {
                var id = context.currentSubscriptionUnit.organisation.id;
                return $q(function (resolve) {
                    if (currentOrganisationId !== id || !self.currentUser) {
                        currentOrganisationId = id;
                        if (!_fetchingCurrentUserPromise) {
                            var url = siteUrl() + "api/user/current?organisationId=" + id + "&groupOrganisationId=" + context.organisation.id;
                            _fetchingCurrentUserPromise = $http.get(url);
                        }
			_fetchingCurrentUserPromise.then(function (response) {
							self.currentUser = response.data;
                            resolve(self.currentUser);
                        });
                    } else {
                        resolve(self.currentUser);
                    }
                });
            } else {
                return $q(function(resolve) {
                    resolve();
                });
            }
        };
        return {
            getCurrentUser: _getCurrentUser,
            hasPermission: function (permission) {
                return $q(function (resolve, reject) {
                    if (!permission) {
                        if (resolve)
                            resolve();
                        return;
                    }
					_getCurrentUser().then(function (user) {
                        var result = _.contains(user.permissions, permission);
                        if (result)
                            resolve();
                        else {
                            if (reject)
                                reject();
                        }
                    });
                });
			},
            doesNotHavePermission: function (permission) {
	            return $q(function (resolve, reject) {
		            if (!permission) {
			            if (resolve)
				            resolve();
			            return;
		            }
		            _getCurrentUser().then(function (user) {
			            var result = _.contains(user.permissions, permission);
			            if (!result)
				            resolve();
			            else {
				            if (reject)
					            reject();
			            }
		            });
	            });
            },
            hasAnyPermission: function(permissions) {
                return $q(function(resolve, reject) {
                    _getCurrentUser().then(function(user) {
                        var result = _.intersection(user.permissions, permissions).length > 0;
                        if (result) {
                            resolve();
                        } else if (reject) {
                            reject();
                        }
                    });
                });
            },
            hasAllPermissions: function (permissions) {
                return $q(function (resolve, reject) {
                    _getCurrentUser().then(function (user) {
                        var result = _.intersection(user.permissions, permissions).length === permissions.length;
                        if (result)
                            resolve();
                        else {
                            if (reject)
                                reject();
                        }
                    });
                });
            },
            getUserTimezone: function () {
                var url = siteUrl() + "/api/Users/GetUserTimezone";
                return $http.get(url);
            }
        };
    }
  ])

angular.module(appName)
  .factory('cachedEntityService', [
    'enums',
    'localStorageService',
    function (
      enums,
      localStorageService
    ) {
      return {
        /**
         * Validates a cached entity with the timeout provided.
         *
         * Cached entity format:
         * {
         *   'entityGuid': DateTime,
         *   'entityGuid': DateTime
         * }
         * @param entityId Id of the entity to validate cache against.
         * @param timeout The timeout of the cache.
         * @returns `true` if the cached entity has expired or does not exist. `false` if the entity exists, and has not expired.
         */
        cachedEntityHasExpired: function (entityId, timeout) {
          var entity = localStorageService.getItem(enums.localStorage.entityTimeoutCache);
          var timeout = new Date();
          timeout.setMinutes(timeout.getMinutes() - window.appSettings.basketsUpdatePricesCacheTimeout);

          return entity === null || !entity.hasOwnProperty(entityId) ||
            (entity.hasOwnProperty(entityId) && new Date(entity[entityId]) < timeout);
        },

        cacheEntity: function(entityId) {
          var cache = localStorageService.getItem(enums.localStorage.entityTimeoutCache);
          if (cache === null) {
            cache = {};
          }
          cache[entityId] = new Date();
          localStorageService.setItem(enums.localStorage.entityTimeoutCache, cache);
        }
      }
    }
  ]);

angular.module(appName)
    .factory('dateService', [
        'moment',
        function(moment) {
            var self = this;
            var getDate = function (format) {
                if (!format) {
                    format = 'L';
                }
                return moment().format(format);
            }

            return {
                getDate: getDate
            }
        }
    ]);
angular.module(appName)
    .factory('fileDownloadService',
        [
            "$http", "$q", "$translate",
            function ($http, $q, $translate) {
                var service = {
                    downloadFile: function (url, fileName, fileExtension) {
                        var deferred = $q.defer();
                        var blobType;
                        var responseType = 'arraybuffer';
                        if (fileExtension === "xlsx") {
                            blobType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                        } else if (fileExtension === "xlsx") {
                            blobType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                        } else if (fileExtension === "xlsm") {
                            blobType = 'application/vnd.ms-excel.sheet.macroEnabled.12';
                        } else if (fileExtension === "csv") {
                            blobType = 'text/csv';
                        } else if (fileExtension === "pdf") {
                            blobType = "application/pdf";
                        } else if (fileExtension === "xls") {
                            blobType = "application/vnd.ms-excel";
                        } else if (fileExtension === "txt") {
                            blobType = "test/plain";
                        } else if (fileExtension === "csv") {
                            blobType = 'text/csv';
                        } else {
                            $translate('error_file_extension_not_allowed', { ext: fileExtension }).then(function (translateKey1) {
                                toastr.error(translateKey1);
                                return deferred.promise;
                            });
                        }
                        var accessToken = localStorage.getItem('access_token');
                        var headers = {};
                        headers.Authorization = 'Bearer ' + accessToken;

                        $http.get(
                            url,
                            {
                                responseType: responseType,
                                headers: headers
                            })
                            .then(
                                //success
                                function (result) {
                                    result.data.type = responseType;
                                    var blob = new Blob([result.data], { type: blobType });
                                    // IE Doesn't support the generic objectUrl method. This uses IE's API for downloading a blob if it exists.
                                    if (window.navigator.msSaveBlob) {
                                        window.navigator.msSaveBlob(blob, fileName + "." + fileExtension);
                                    } else {
                                        var objectUrl = window.URL.createObjectURL(blob);
                                        var a = document.createElement("a");
                                        document.body.appendChild(a);
                                        a.style = "display: none";
                                        a.href = objectUrl;
                                        a.download = fileName + "." + fileExtension;
                                        a.click();
                                        a.parentNode.removeChild(a);
                                        deferred.resolve(result.data);
                                    }
                                },
                                //error
                                function (data, status) {
                                    console.log("Request failed with status: " + status);
                                    deferred.reject(status);
                                });

                        return deferred.promise;
                    }
                }

                return service;
            }
        ]);
angular.module(appName)
    .service('hrefs', function () {
        productSearch = {
            root: '/ProductSearch',
            search: function (procurementBasketId, discriminator, segmentId) {
                return this.root + '/' + procurementBasketId + '/' + discriminator + '/' + segmentId;
            }
        };

        return {
            productSearch: productSearch
        }
    });
angular.module(appName)
	.factory('organisationContext', ['localStorageService', 'enums',

		function (localStorageService, enums) {
          return localStorageService.getItem(enums.localStorage.organisationContext);
        }
    ])

angular.module(appName)
    .factory("paginationService",
    [
        function () {
            var service = {};

            service.GetPager = GetPager;

            return service;

            // service implementation
            function GetPager(totalItems, currentPage, pageSize) {
                // default to first page
                currentPage = currentPage || 1;

                // default page size is 10
                pageSize = pageSize || 10;

                // calculate total pages
                var totalPages = Math.ceil(totalItems / pageSize);

                var startPage, endPage;
                if (totalPages <= 10) {
                    // less than 10 total pages so show all
                    startPage = 1;
                    endPage = totalPages;
                } else {
                    // more than 10 total pages so calculate start and end pages
                    if (currentPage <= 6) {
                        startPage = 1;
                        endPage = 10;
                    } else if (currentPage + 4 >= totalPages) {
                        startPage = totalPages - 9;
                        endPage = totalPages;
                    } else {
                        startPage = currentPage - 5;
                        endPage = currentPage + 4;
                    }
                }

                // calculate start and end item indexes
                var startIndex = (currentPage - 1) * pageSize;
                var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

                // create an array of pages to ng-repeat in the pager control
                var pages = _.range(startPage, endPage + 1);

                // return object with all pager properties required by the view
                return {
                    totalItems: totalItems,
                    currentPage: currentPage,
                    pageSize: pageSize,
                    totalPages: totalPages,
                    startPage: startPage,
                    endPage: endPage,
                    startIndex: startIndex,
                    endIndex: endIndex,
                    pages: pages
                };
            }
        }
    ]);
angular.module(appName)
    .factory("toastService", [
        "toastr", "$injector",
        function (toastr, $injector) {
            var $translate;
            var setTranslate = function () {
                $translate = $translate || $injector.get('$translate');
            };
            var service = {
                success: function (message, callback) {
                    setTranslate();
                    toastr.success(message, callback);
                },
                error: function (message, callback) {
                    setTranslate();
                    console.log('error', message);
                    toastr.error(message, callback);
                },
                warning: function (message, callback) {
                    setTranslate();
                    toastr.warning(message, callback);
                },
                throwSuccessfulToast: function (func, callback) {
                    setTranslate();
                    $translate.onReady().then(function() {
                        var msg = $translate.instant('success_action_successful_generic', { func: func });
                        toastr.success(msg);


                        if (angular.isDefined(callback))
                            callback();
                    });
                },
                throwDuplicateItemToast: function (func, item, callback) {
                    setTranslate();
                    $translate.onReady().then(function() {
                        var msg;
                        if (item) {
                            msg = $translate.instant('error_duplicate_item_simple', { func: func });
                        } else {
                            msg = $translate.instant('error_duplicate_item_advanced', { func: func, item: item });
                        }

                        toastr.error(msg);

                        if (angular.isDefined(callback))
                            callback();
                    });
                },
                throwItemInUseToast: function (func, item, inUseOn, callback) {
                    setTranslate();
                    $translate.onReady().then(function() {
                        var msg;
                        if (!inUseOn) {
                            msg = $translate.instant('error_item_in_use_simple', { func: func, item: item });
                        } else {
                            msg = $translate.instant('error_item_in_use_advanced',
                                { func: func, item: item, inUseOn: inUseOn });
                        }

                        toastr.error(msg);

                        if (angular.isDefined(callback))
                            callback();
                    });
                },
                throwDeleteSuccessToast: function (item, callback) {
                    setTranslate();
                    $translate.onReady().then(function() {
                        var msg = $translate.instant('success_deleted_successfully_simple', { item: item });
                        toastr.success(msg);

                        if (angular.isDefined(callback))
                            callback();
                    });
                },
                throwUnexpectedErrorToast: function (rejection) {
                    setTranslate();
                    $translate.onReady().then(function() {
                        if (rejection && rejection.exceptionType === "PSL.API.BusinessRuleException") {
                            toastr.error(rejection.exceptionMessage);
                        } else {
                            toastr.error($translate.instant('error_unexpected_error'));
                        }

                        console.log("Rejected: ", rejection);
                    });
                },
                throwInsufficientPermissionsToast: function (rejection) {
                    setTranslate();
                    $translate.onReady().then(function() {

                        //"Sorry, You do not have permission to carry out that action."
                        toastr.error($translate.instant('error_insufficient_permissions'));
                        console.log("Rejected: ", rejection);
                    });
                },
                throwBadRequestToast: function (rejection) {
                    setTranslate();
                    $translate.onReady().then(function() {
                        toastr.error(rejection.data);
                        console.log("Rejected: ", rejection);
                    });
                },
                throwNotImplementedToast: function (item) {
                    setTranslate();
                    $translate.onReady().then(function() {
                        var defaultMsg = $translate.instant('warn_not_yet_implemented');

                        toastr.warning(msg, defaultMsg);
                    });
                },
                throwEndpointNotFoundToast: function () {
                    setTranslate();
                    $translate.onReady().then(function() {
                        var msg = $translate.instant('error_endpoint_not_found');
                        toastr.error(msg);
                    });
                }
            };

            return service;
        }
    ]);
angular.module(appName)
    .factory('translateService', [
        '$translate', '$q', 'localStorageService', 'translateResource',
        function ($translate, $q, localStorageService, translateResource) {
            var deferred;
            var pushTranslationToArray = function (translationArray, translation, maxLength) {
                translationArray.push(translation);
                if (translationArray.length == maxLength) {
                    deferred.resolve(translationArray);
                }
            }

            return {
                setLanguage: function (language) {
                    translateResource.get({ lang: language }).$promise.then(function (data) {
                        $translate.use(language);
                    });
                },
                translateString: function (key) {
                    return $translate(key).then(function (translation) {
                        return translation.value;
                    });
                },
                translateArray: function (array, callback) {
                    deferred = $q.defer();
                    var translations = [];
                    //while (translations.length < array.length) {
                        for (var i = 0; i < array.length; i++) {
                            if (_.isString(array[i])) {
                                $translate(array[i]).then(function(translation) {
                                    pushTranslationToArray(translations, translation, array.length);
                                });
                            } else if (_.isObject(array[i])) {
                                if (_.has(array[i], 'key')) {
                                    $translate(array[i].key).then(function(translation) {
                                        pushTranslationToArray(translations, translation, array.length);
                                    });
                                }
                            }
                        }
                    //}

                    return deferred.promise;
                }
            }
        }
    ]);


angular.module(appName)
	.factory("wimdPriceService",
		[
			function() {
				var getPerQuantityPrice = function(unitPrice, quantity, itemYield, factor) {
                    if (unitPrice <= 0 || quantity <= 0 || itemYield <= 0 || factor <= 0) return;

                    return (unitPrice / (itemYield * 0.01) * factor).toFixed(2);
				};
				return {
                    getPerQuantityPrice: getPerQuantityPrice
				};
			}
		]);

angular.module(appName)
    .factory('windowService', [
        '$location', '$window',
        function ($location, $window) {
            var self = this;
            self.baskets = {
                root: '/baskets/',
                view: '/baskets/view/'
            };
            self.reportingGroups = {
                root: '/ReportingGroups/',
                view: '/ReportingGroups/View/'
            };
            self.reporting = {
                groupReport: '/GroupReports/GroupFoodFlashReport/',
                unitReport: '/UnitReports/UnitFlashReport/'
            }
            self.suppliers = {
                groupSuppliers: {
                    view: '/GroupSuppliers',
                    addEditSupplier: '/GroupSuppliers/AddEdit/'
                },
                unitSuppliers: {
                    view: '/ManageSuppliers',
                    assignUnitSupplier: '/ManageSuppliers/Assign/'
                }
            }
            self.purchaseOrders = {
                search: '/PurchaseOrders/Search/'
            }

            // This is so that if we ever need to do something on navigate,
            // we have one place to update.
            self.navigate = function (url, newTab) {
                newTab == true
                    ? window.open(url, '_blank')
                        : $location.path(url);
            }

            return {
                // Baskets Routes
                baskets: function () {
                    var url = self.baskets.root;
                    self.navigate(url);
                },
                viewBasket: function (basketId) {
					var url = self.baskets.view;
                    if (basketId)
                        url += basketId;

                    self.navigate(url);
                },

                // Reporting Groups Routes
                reportingGroups: function () {
                    var url = self.reportingGroups.root;
                    self.navigate(url);
                },
                viewReportingGroups: function (id) {
                    var url = self.reportingGroups.view;
                    if (id)
                        url += id;
                    self.navigate(url);
                },

                // Purchase Orders
                searchPurchaseOrders: function() {
                    var url = self.purchaseOrders.search;
                    self.navigate(url);
                },

                // Reporting
                unitReport: function (unitId, reportingPeriodId, reportDateTo) {
                    console.log("unitid", unitId);
                    console.log("reportingPeriodId", reportingPeriodId);
                    console.log("reportDateTo", reportDateTo);
                    var url = self.reporting.unitReport;
                    if(unitId)
                        url += unitId;
                    if (reportingPeriodId) {
                        url += '/' + reportingPeriodId;
                        if (reportDateTo) {
                            var safeDateForUrl = reportDateTo.replace(/\//g, "_");
                            console.log("safeDateForUrl", safeDateForUrl);
                            url += '/' + safeDateForUrl;
                        }
                          
                    }
                    console.log("url",url);
                    self.navigate(url, false);
                },

                // Suppliers
                groupSuppliers: function() {
                    var url = self.suppliers.groupSuppliers.view;
                    self.navigate(url, false);
                },
                addEditSupplier: function (subscriptionSupplierId) {
                    var url = self.suppliers.groupSuppliers.addEditSupplier;
                    if (subscriptionSupplierId)
                        url += subscriptionSupplierId;
                    self.navigate(url, false);
                },
                unitSuppliers: function() {
                    var url = self.suppliers.unitSuppliers.view;
                    self.navigate(url, false);
                },
                assignUnitSupplier: function (subscriptionSupplierId) {
                    var url = self.suppliers.unitSuppliers.assignUnitSupplier;
                    if (subscriptionSupplierId)
                        url += subscriptionSupplierId;
                    self.navigate(url, false);
                }
            }
        }
    ]);